var _regeneratorRuntime = require("/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/regenerator");

module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 611);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(3);

  var core = __webpack_require__(32);

  var hide = __webpack_require__(20);

  var redefine = __webpack_require__(21);

  var ctx = __webpack_require__(28);

  var PROTOTYPE = 'prototype';

  var $export = function $export(type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
    var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
    var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;

    for (key in source) {
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

      out = (own ? target : source)[key]; // bind timers to global for call from export context

      exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // extend global

      if (target) redefine(target, key, out, type & $export.U); // export

      if (exports[key] != out) hide(exports, key, exp);
      if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
  };

  global.core = core; // type bitmap

  $export.F = 1; // forced

  $export.G = 2; // global

  $export.S = 4; // static

  $export.P = 8; // proto

  $export.B = 16; // bind

  $export.W = 32; // wrap

  $export.U = 64; // safe

  $export.R = 128; // real proto method for `library`

  module.exports = $export;
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (global) {
    /*!
    * The buffer module from node.js, for the browser.
    *
    * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
    * @license  MIT
    */

    /* eslint-disable no-proto */
    var base64 = __webpack_require__(464);

    var ieee754 = __webpack_require__(495);

    var isArray = __webpack_require__(201);

    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    /**
     * If `Buffer.TYPED_ARRAY_SUPPORT`:
     *   === true    Use Uint8Array implementation (fastest)
     *   === false   Use Object implementation (most compatible, even IE6)
     *
     * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
     * Opera 11.6+, iOS 4.2+.
     *
     * Due to various browser bugs, sometimes the Object implementation will be used even
     * when the browser supports typed arrays.
     *
     * Note:
     *
     *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
     *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
     *
     *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
     *
     *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
     *     incorrect length in some situations.
    
     * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
     * get the Object implementation, which is slower but behaves correctly.
     */

    Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
    /*
     * Export kMaxLength after typed array support is determined.
     */

    exports.kMaxLength = kMaxLength();

    function typedArraySupport() {
      try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
          __proto__: Uint8Array.prototype,
          foo: function foo() {
            return 42;
          }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
      } catch (e) {
        return false;
      }
    }

    function kMaxLength() {
      return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
    }

    function createBuffer(that, length) {
      if (kMaxLength() < length) {
        throw new RangeError('Invalid typed array length');
      }

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
      } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) {
          that = new Buffer(length);
        }

        that.length = length;
      }

      return that;
    }
    /**
     * The Buffer constructor returns instances of `Uint8Array` that have their
     * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
     * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
     * and the `Uint8Array` methods. Square bracket notation works as expected -- it
     * returns a single octet.
     *
     * The `Uint8Array` prototype remains unmodified.
     */


    function Buffer(arg, encodingOrOffset, length) {
      if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
        return new Buffer(arg, encodingOrOffset, length);
      } // Common case.


      if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') {
          throw new Error('If encoding is specified then the first argument must be a string');
        }

        return allocUnsafe(this, arg);
      }

      return from(this, arg, encodingOrOffset, length);
    }

    Buffer.poolSize = 8192; // not used by this implementation
    // TODO: Legacy, not needed anymore. Remove in next major version.

    Buffer._augment = function (arr) {
      arr.__proto__ = Buffer.prototype;
      return arr;
    };

    function from(that, value, encodingOrOffset, length) {
      if (typeof value === 'number') {
        throw new TypeError('"value" argument must not be a number');
      }

      if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
        return fromArrayBuffer(that, value, encodingOrOffset, length);
      }

      if (typeof value === 'string') {
        return fromString(that, value, encodingOrOffset);
      }

      return fromObject(that, value);
    }
    /**
     * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
     * if value is a number.
     * Buffer.from(str[, encoding])
     * Buffer.from(array)
     * Buffer.from(buffer)
     * Buffer.from(arrayBuffer[, byteOffset[, length]])
     **/


    Buffer.from = function (value, encodingOrOffset, length) {
      return from(null, value, encodingOrOffset, length);
    };

    if (Buffer.TYPED_ARRAY_SUPPORT) {
      Buffer.prototype.__proto__ = Uint8Array.prototype;
      Buffer.__proto__ = Uint8Array;

      if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
        // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
        Object.defineProperty(Buffer, Symbol.species, {
          value: null,
          configurable: true
        });
      }
    }

    function assertSize(size) {
      if (typeof size !== 'number') {
        throw new TypeError('"size" argument must be a number');
      } else if (size < 0) {
        throw new RangeError('"size" argument must not be negative');
      }
    }

    function alloc(that, size, fill, encoding) {
      assertSize(size);

      if (size <= 0) {
        return createBuffer(that, size);
      }

      if (fill !== undefined) {
        // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpretted as a start offset.
        return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
      }

      return createBuffer(that, size);
    }
    /**
     * Creates a new filled Buffer instance.
     * alloc(size[, fill[, encoding]])
     **/


    Buffer.alloc = function (size, fill, encoding) {
      return alloc(null, size, fill, encoding);
    };

    function allocUnsafe(that, size) {
      assertSize(size);
      that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);

      if (!Buffer.TYPED_ARRAY_SUPPORT) {
        for (var i = 0; i < size; ++i) {
          that[i] = 0;
        }
      }

      return that;
    }
    /**
     * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
     * */


    Buffer.allocUnsafe = function (size) {
      return allocUnsafe(null, size);
    };
    /**
     * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
     */


    Buffer.allocUnsafeSlow = function (size) {
      return allocUnsafe(null, size);
    };

    function fromString(that, string, encoding) {
      if (typeof encoding !== 'string' || encoding === '') {
        encoding = 'utf8';
      }

      if (!Buffer.isEncoding(encoding)) {
        throw new TypeError('"encoding" must be a valid string encoding');
      }

      var length = byteLength(string, encoding) | 0;
      that = createBuffer(that, length);
      var actual = that.write(string, encoding);

      if (actual !== length) {
        // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        that = that.slice(0, actual);
      }

      return that;
    }

    function fromArrayLike(that, array) {
      var length = array.length < 0 ? 0 : checked(array.length) | 0;
      that = createBuffer(that, length);

      for (var i = 0; i < length; i += 1) {
        that[i] = array[i] & 255;
      }

      return that;
    }

    function fromArrayBuffer(that, array, byteOffset, length) {
      array.byteLength; // this throws if `array` is not a valid ArrayBuffer

      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('\'offset\' is out of bounds');
      }

      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('\'length\' is out of bounds');
      }

      if (byteOffset === undefined && length === undefined) {
        array = new Uint8Array(array);
      } else if (length === undefined) {
        array = new Uint8Array(array, byteOffset);
      } else {
        array = new Uint8Array(array, byteOffset, length);
      }

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
      } else {
        // Fallback: Return an object instance of the Buffer class
        that = fromArrayLike(that, array);
      }

      return that;
    }

    function fromObject(that, obj) {
      if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);

        if (that.length === 0) {
          return that;
        }

        obj.copy(that, 0, 0, len);
        return that;
      }

      if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
          if (typeof obj.length !== 'number' || isnan(obj.length)) {
            return createBuffer(that, 0);
          }

          return fromArrayLike(that, obj);
        }

        if (obj.type === 'Buffer' && isArray(obj.data)) {
          return fromArrayLike(that, obj.data);
        }
      }

      throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
    }

    function checked(length) {
      // Note: cannot use `length < kMaxLength()` here because that fails when
      // length is NaN (which is otherwise coerced to zero.)
      if (length >= kMaxLength()) {
        throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
      }

      return length | 0;
    }

    function SlowBuffer(length) {
      if (+length != length) {
        // eslint-disable-line eqeqeq
        length = 0;
      }

      return Buffer.alloc(+length);
    }

    Buffer.isBuffer = function isBuffer(b) {
      return !!(b != null && b._isBuffer);
    };

    Buffer.compare = function compare(a, b) {
      if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
        throw new TypeError('Arguments must be Buffers');
      }

      if (a === b) return 0;
      var x = a.length;
      var y = b.length;

      for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }

      if (x < y) return -1;
      if (y < x) return 1;
      return 0;
    };

    Buffer.isEncoding = function isEncoding(encoding) {
      switch (String(encoding).toLowerCase()) {
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return true;

        default:
          return false;
      }
    };

    Buffer.concat = function concat(list, length) {
      if (!isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }

      if (list.length === 0) {
        return Buffer.alloc(0);
      }

      var i;

      if (length === undefined) {
        length = 0;

        for (i = 0; i < list.length; ++i) {
          length += list[i].length;
        }
      }

      var buffer = Buffer.allocUnsafe(length);
      var pos = 0;

      for (i = 0; i < list.length; ++i) {
        var buf = list[i];

        if (!Buffer.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        }

        buf.copy(buffer, pos);
        pos += buf.length;
      }

      return buffer;
    };

    function byteLength(string, encoding) {
      if (Buffer.isBuffer(string)) {
        return string.length;
      }

      if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
        return string.byteLength;
      }

      if (typeof string !== 'string') {
        string = '' + string;
      }

      var len = string.length;
      if (len === 0) return 0; // Use a for loop to avoid recursion

      var loweredCase = false;

      for (;;) {
        switch (encoding) {
          case 'ascii':
          case 'latin1':
          case 'binary':
            return len;

          case 'utf8':
          case 'utf-8':
          case undefined:
            return utf8ToBytes(string).length;

          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return len * 2;

          case 'hex':
            return len >>> 1;

          case 'base64':
            return base64ToBytes(string).length;

          default:
            if (loweredCase) return utf8ToBytes(string).length; // assume utf8

            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }

    Buffer.byteLength = byteLength;

    function slowToString(encoding, start, end) {
      var loweredCase = false; // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
      // property of a typed array.
      // This behaves neither like String nor Uint8Array in that we set start/end
      // to their upper/lower bounds if the value passed is out of range.
      // undefined is handled specially as per ECMA-262 6th Edition,
      // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.

      if (start === undefined || start < 0) {
        start = 0;
      } // Return early if start > this.length. Done here to prevent potential uint32
      // coercion fail below.


      if (start > this.length) {
        return '';
      }

      if (end === undefined || end > this.length) {
        end = this.length;
      }

      if (end <= 0) {
        return '';
      } // Force coersion to uint32. This will also coerce falsey/NaN values to 0.


      end >>>= 0;
      start >>>= 0;

      if (end <= start) {
        return '';
      }

      if (!encoding) encoding = 'utf8';

      while (true) {
        switch (encoding) {
          case 'hex':
            return hexSlice(this, start, end);

          case 'utf8':
          case 'utf-8':
            return utf8Slice(this, start, end);

          case 'ascii':
            return asciiSlice(this, start, end);

          case 'latin1':
          case 'binary':
            return latin1Slice(this, start, end);

          case 'base64':
            return base64Slice(this, start, end);

          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return utf16leSlice(this, start, end);

          default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
        }
      }
    } // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
    // Buffer instances.


    Buffer.prototype._isBuffer = true;

    function swap(b, n, m) {
      var i = b[n];
      b[n] = b[m];
      b[m] = i;
    }

    Buffer.prototype.swap16 = function swap16() {
      var len = this.length;

      if (len % 2 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 16-bits');
      }

      for (var i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
      }

      return this;
    };

    Buffer.prototype.swap32 = function swap32() {
      var len = this.length;

      if (len % 4 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 32-bits');
      }

      for (var i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
      }

      return this;
    };

    Buffer.prototype.swap64 = function swap64() {
      var len = this.length;

      if (len % 8 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 64-bits');
      }

      for (var i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
      }

      return this;
    };

    Buffer.prototype.toString = function toString() {
      var length = this.length | 0;
      if (length === 0) return '';
      if (arguments.length === 0) return utf8Slice(this, 0, length);
      return slowToString.apply(this, arguments);
    };

    Buffer.prototype.equals = function equals(b) {
      if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
      if (this === b) return true;
      return Buffer.compare(this, b) === 0;
    };

    Buffer.prototype.inspect = function inspect() {
      var str = '';
      var max = exports.INSPECT_MAX_BYTES;

      if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
      }

      return '<Buffer ' + str + '>';
    };

    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
      if (!Buffer.isBuffer(target)) {
        throw new TypeError('Argument must be a Buffer');
      }

      if (start === undefined) {
        start = 0;
      }

      if (end === undefined) {
        end = target ? target.length : 0;
      }

      if (thisStart === undefined) {
        thisStart = 0;
      }

      if (thisEnd === undefined) {
        thisEnd = this.length;
      }

      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError('out of range index');
      }

      if (thisStart >= thisEnd && start >= end) {
        return 0;
      }

      if (thisStart >= thisEnd) {
        return -1;
      }

      if (start >= end) {
        return 1;
      }

      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target) return 0;
      var x = thisEnd - thisStart;
      var y = end - start;
      var len = Math.min(x, y);
      var thisCopy = this.slice(thisStart, thisEnd);
      var targetCopy = target.slice(start, end);

      for (var i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break;
        }
      }

      if (x < y) return -1;
      if (y < x) return 1;
      return 0;
    }; // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf


    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
      // Empty buffer means no match
      if (buffer.length === 0) return -1; // Normalize byteOffset

      if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 0x7fffffff) {
        byteOffset = 0x7fffffff;
      } else if (byteOffset < -0x80000000) {
        byteOffset = -0x80000000;
      }

      byteOffset = +byteOffset; // Coerce to Number.

      if (isNaN(byteOffset)) {
        // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
      } // Normalize byteOffset: negative offsets start from the end of the buffer


      if (byteOffset < 0) byteOffset = buffer.length + byteOffset;

      if (byteOffset >= buffer.length) {
        if (dir) return -1;else byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;else return -1;
      } // Normalize val


      if (typeof val === 'string') {
        val = Buffer.from(val, encoding);
      } // Finally, search either indexOf (if dir is true) or lastIndexOf


      if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) {
          return -1;
        }

        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
      } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]

        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
          }
        }

        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
      }

      throw new TypeError('val must be string, number or Buffer');
    }

    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
      var indexSize = 1;
      var arrLength = arr.length;
      var valLength = val.length;

      if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();

        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
          if (arr.length < 2 || val.length < 2) {
            return -1;
          }

          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }

      function read(buf, i) {
        if (indexSize === 1) {
          return buf[i];
        } else {
          return buf.readUInt16BE(i * indexSize);
        }
      }

      var i;

      if (dir) {
        var foundIndex = -1;

        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;

        for (i = byteOffset; i >= 0; i--) {
          var found = true;

          for (var j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false;
              break;
            }
          }

          if (found) return i;
        }
      }

      return -1;
    }

    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1;
    };

    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };

    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };

    function hexWrite(buf, string, offset, length) {
      offset = Number(offset) || 0;
      var remaining = buf.length - offset;

      if (!length) {
        length = remaining;
      } else {
        length = Number(length);

        if (length > remaining) {
          length = remaining;
        }
      } // must be an even number of digits


      var strLen = string.length;
      if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');

      if (length > strLen / 2) {
        length = strLen / 2;
      }

      for (var i = 0; i < length; ++i) {
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
      }

      return i;
    }

    function utf8Write(buf, string, offset, length) {
      return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }

    function asciiWrite(buf, string, offset, length) {
      return blitBuffer(asciiToBytes(string), buf, offset, length);
    }

    function latin1Write(buf, string, offset, length) {
      return asciiWrite(buf, string, offset, length);
    }

    function base64Write(buf, string, offset, length) {
      return blitBuffer(base64ToBytes(string), buf, offset, length);
    }

    function ucs2Write(buf, string, offset, length) {
      return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }

    Buffer.prototype.write = function write(string, offset, length, encoding) {
      // Buffer#write(string)
      if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0; // Buffer#write(string, encoding)
      } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0; // Buffer#write(string, offset[, length][, encoding])
      } else if (isFinite(offset)) {
        offset = offset | 0;

        if (isFinite(length)) {
          length = length | 0;
          if (encoding === undefined) encoding = 'utf8';
        } else {
          encoding = length;
          length = undefined;
        } // legacy write(string, encoding, offset, length) - remove in v0.13

      } else {
        throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
      }

      var remaining = this.length - offset;
      if (length === undefined || length > remaining) length = remaining;

      if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
        throw new RangeError('Attempt to write outside buffer bounds');
      }

      if (!encoding) encoding = 'utf8';
      var loweredCase = false;

      for (;;) {
        switch (encoding) {
          case 'hex':
            return hexWrite(this, string, offset, length);

          case 'utf8':
          case 'utf-8':
            return utf8Write(this, string, offset, length);

          case 'ascii':
            return asciiWrite(this, string, offset, length);

          case 'latin1':
          case 'binary':
            return latin1Write(this, string, offset, length);

          case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);

          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return ucs2Write(this, string, offset, length);

          default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };

    Buffer.prototype.toJSON = function toJSON() {
      return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };

    function base64Slice(buf, start, end) {
      if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start, end));
      }
    }

    function utf8Slice(buf, start, end) {
      end = Math.min(buf.length, end);
      var res = [];
      var i = start;

      while (i < end) {
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

        if (i + bytesPerSequence <= end) {
          var secondByte, thirdByte, fourthByte, tempCodePoint;

          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 0x80) {
                codePoint = firstByte;
              }

              break;

            case 2:
              secondByte = buf[i + 1];

              if ((secondByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;

                if (tempCodePoint > 0x7F) {
                  codePoint = tempCodePoint;
                }
              }

              break;

            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];

              if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;

                if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                  codePoint = tempCodePoint;
                }
              }

              break;

            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];

              if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;

                if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                  codePoint = tempCodePoint;
                }
              }

          }
        }

        if (codePoint === null) {
          // we did not generate a valid codePoint so insert a
          // replacement char (U+FFFD) and advance only 1 byte
          codePoint = 0xFFFD;
          bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
          // encode to utf16 (surrogate pair dance)
          codePoint -= 0x10000;
          res.push(codePoint >>> 10 & 0x3FF | 0xD800);
          codePoint = 0xDC00 | codePoint & 0x3FF;
        }

        res.push(codePoint);
        i += bytesPerSequence;
      }

      return decodeCodePointsArray(res);
    } // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety


    var MAX_ARGUMENTS_LENGTH = 0x1000;

    function decodeCodePointsArray(codePoints) {
      var len = codePoints.length;

      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
      } // Decode in chunks to avoid "call stack size exceeded".


      var res = '';
      var i = 0;

      while (i < len) {
        res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
      }

      return res;
    }

    function asciiSlice(buf, start, end) {
      var ret = '';
      end = Math.min(buf.length, end);

      for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 0x7F);
      }

      return ret;
    }

    function latin1Slice(buf, start, end) {
      var ret = '';
      end = Math.min(buf.length, end);

      for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
      }

      return ret;
    }

    function hexSlice(buf, start, end) {
      var len = buf.length;
      if (!start || start < 0) start = 0;
      if (!end || end < 0 || end > len) end = len;
      var out = '';

      for (var i = start; i < end; ++i) {
        out += toHex(buf[i]);
      }

      return out;
    }

    function utf16leSlice(buf, start, end) {
      var bytes = buf.slice(start, end);
      var res = '';

      for (var i = 0; i < bytes.length; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }

      return res;
    }

    Buffer.prototype.slice = function slice(start, end) {
      var len = this.length;
      start = ~~start;
      end = end === undefined ? len : ~~end;

      if (start < 0) {
        start += len;
        if (start < 0) start = 0;
      } else if (start > len) {
        start = len;
      }

      if (end < 0) {
        end += len;
        if (end < 0) end = 0;
      } else if (end > len) {
        end = len;
      }

      if (end < start) end = start;
      var newBuf;

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
      } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);

        for (var i = 0; i < sliceLen; ++i) {
          newBuf[i] = this[i + start];
        }
      }

      return newBuf;
    };
    /*
     * Need to make sure that buffer isn't trying to write out of bounds.
     */


    function checkOffset(offset, ext, length) {
      if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
      if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
    }

    Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);
      var val = this[offset];
      var mul = 1;
      var i = 0;

      while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul;
      }

      return val;
    };

    Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;

      if (!noAssert) {
        checkOffset(offset, byteLength, this.length);
      }

      var val = this[offset + --byteLength];
      var mul = 1;

      while (byteLength > 0 && (mul *= 0x100)) {
        val += this[offset + --byteLength] * mul;
      }

      return val;
    };

    Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 1, this.length);
      return this[offset];
    };

    Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      return this[offset] | this[offset + 1] << 8;
    };

    Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      return this[offset] << 8 | this[offset + 1];
    };

    Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };

    Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };

    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);
      var val = this[offset];
      var mul = 1;
      var i = 0;

      while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul;
      }

      mul *= 0x80;
      if (val >= mul) val -= Math.pow(2, 8 * byteLength);
      return val;
    };

    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);
      var i = byteLength;
      var mul = 1;
      var val = this[offset + --i];

      while (i > 0 && (mul *= 0x100)) {
        val += this[offset + --i] * mul;
      }

      mul *= 0x80;
      if (val >= mul) val -= Math.pow(2, 8 * byteLength);
      return val;
    };

    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 1, this.length);
      if (!(this[offset] & 0x80)) return this[offset];
      return (0xff - this[offset] + 1) * -1;
    };

    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      var val = this[offset] | this[offset + 1] << 8;
      return val & 0x8000 ? val | 0xFFFF0000 : val;
    };

    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      var val = this[offset + 1] | this[offset] << 8;
      return val & 0x8000 ? val | 0xFFFF0000 : val;
    };

    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };

    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };

    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, true, 23, 4);
    };

    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, false, 23, 4);
    };

    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, true, 52, 8);
    };

    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, false, 52, 8);
    };

    function checkInt(buf, value, offset, ext, max, min) {
      if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
      if (offset + ext > buf.length) throw new RangeError('Index out of range');
    }

    Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      byteLength = byteLength | 0;

      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
      }

      var mul = 1;
      var i = 0;
      this[offset] = value & 0xFF;

      while (++i < byteLength && (mul *= 0x100)) {
        this[offset + i] = value / mul & 0xFF;
      }

      return offset + byteLength;
    };

    Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      byteLength = byteLength | 0;

      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
      }

      var i = byteLength - 1;
      var mul = 1;
      this[offset + i] = value & 0xFF;

      while (--i >= 0 && (mul *= 0x100)) {
        this[offset + i] = value / mul & 0xFF;
      }

      return offset + byteLength;
    };

    Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
      if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
      this[offset] = value & 0xff;
      return offset + 1;
    };

    function objectWriteUInt16(buf, value, offset, littleEndian) {
      if (value < 0) value = 0xffff + value + 1;

      for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
        buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
      }
    }

    Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
      } else {
        objectWriteUInt16(this, value, offset, true);
      }

      return offset + 2;
    };

    Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
      } else {
        objectWriteUInt16(this, value, offset, false);
      }

      return offset + 2;
    };

    function objectWriteUInt32(buf, value, offset, littleEndian) {
      if (value < 0) value = 0xffffffff + value + 1;

      for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
        buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
      }
    }

    Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
      } else {
        objectWriteUInt32(this, value, offset, true);
      }

      return offset + 4;
    };

    Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
      } else {
        objectWriteUInt32(this, value, offset, false);
      }

      return offset + 4;
    };

    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;

      if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
      }

      var i = 0;
      var mul = 1;
      var sub = 0;
      this[offset] = value & 0xFF;

      while (++i < byteLength && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
          sub = 1;
        }

        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
      }

      return offset + byteLength;
    };

    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;

      if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
      }

      var i = byteLength - 1;
      var mul = 1;
      var sub = 0;
      this[offset + i] = value & 0xFF;

      while (--i >= 0 && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
          sub = 1;
        }

        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
      }

      return offset + byteLength;
    };

    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
      if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
      if (value < 0) value = 0xff + value + 1;
      this[offset] = value & 0xff;
      return offset + 1;
    };

    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
      } else {
        objectWriteUInt16(this, value, offset, true);
      }

      return offset + 2;
    };

    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
      } else {
        objectWriteUInt16(this, value, offset, false);
      }

      return offset + 2;
    };

    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
      } else {
        objectWriteUInt32(this, value, offset, true);
      }

      return offset + 4;
    };

    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
      if (value < 0) value = 0xffffffff + value + 1;

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
      } else {
        objectWriteUInt32(this, value, offset, false);
      }

      return offset + 4;
    };

    function checkIEEE754(buf, value, offset, ext, max, min) {
      if (offset + ext > buf.length) throw new RangeError('Index out of range');
      if (offset < 0) throw new RangeError('Index out of range');
    }

    function writeFloat(buf, value, offset, littleEndian, noAssert) {
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
      }

      ieee754.write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4;
    }

    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert);
    };

    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert);
    };

    function writeDouble(buf, value, offset, littleEndian, noAssert) {
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
      }

      ieee754.write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8;
    }

    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert);
    };

    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert);
    }; // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)


    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
      if (!start) start = 0;
      if (!end && end !== 0) end = this.length;
      if (targetStart >= target.length) targetStart = target.length;
      if (!targetStart) targetStart = 0;
      if (end > 0 && end < start) end = start; // Copy 0 bytes; we're done

      if (end === start) return 0;
      if (target.length === 0 || this.length === 0) return 0; // Fatal error conditions

      if (targetStart < 0) {
        throw new RangeError('targetStart out of bounds');
      }

      if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
      if (end < 0) throw new RangeError('sourceEnd out of bounds'); // Are we oob?

      if (end > this.length) end = this.length;

      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }

      var len = end - start;
      var i;

      if (this === target && start < targetStart && targetStart < end) {
        // descending copy from end
        for (i = len - 1; i >= 0; --i) {
          target[i + targetStart] = this[i + start];
        }
      } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
        // ascending copy from start
        for (i = 0; i < len; ++i) {
          target[i + targetStart] = this[i + start];
        }
      } else {
        Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
      }

      return len;
    }; // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])


    Buffer.prototype.fill = function fill(val, start, end, encoding) {
      // Handle string cases:
      if (typeof val === 'string') {
        if (typeof start === 'string') {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === 'string') {
          encoding = end;
          end = this.length;
        }

        if (val.length === 1) {
          var code = val.charCodeAt(0);

          if (code < 256) {
            val = code;
          }
        }

        if (encoding !== undefined && typeof encoding !== 'string') {
          throw new TypeError('encoding must be a string');
        }

        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
          throw new TypeError('Unknown encoding: ' + encoding);
        }
      } else if (typeof val === 'number') {
        val = val & 255;
      } // Invalid ranges are not set to a default, so can range check early.


      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError('Out of range index');
      }

      if (end <= start) {
        return this;
      }

      start = start >>> 0;
      end = end === undefined ? this.length : end >>> 0;
      if (!val) val = 0;
      var i;

      if (typeof val === 'number') {
        for (i = start; i < end; ++i) {
          this[i] = val;
        }
      } else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;

        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len];
        }
      }

      return this;
    }; // HELPER FUNCTIONS
    // ================


    var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

    function base64clean(str) {
      // Node strips out invalid characters like \n and \t from the string, base64-js does not
      str = stringtrim(str).replace(INVALID_BASE64_RE, ''); // Node converts strings with length < 2 to ''

      if (str.length < 2) return ''; // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not

      while (str.length % 4 !== 0) {
        str = str + '=';
      }

      return str;
    }

    function stringtrim(str) {
      if (str.trim) return str.trim();
      return str.replace(/^\s+|\s+$/g, '');
    }

    function toHex(n) {
      if (n < 16) return '0' + n.toString(16);
      return n.toString(16);
    }

    function utf8ToBytes(string, units) {
      units = units || Infinity;
      var codePoint;
      var length = string.length;
      var leadSurrogate = null;
      var bytes = [];

      for (var i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i); // is surrogate component

        if (codePoint > 0xD7FF && codePoint < 0xE000) {
          // last char was a lead
          if (!leadSurrogate) {
            // no lead yet
            if (codePoint > 0xDBFF) {
              // unexpected trail
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              continue;
            } else if (i + 1 === length) {
              // unpaired lead
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              continue;
            } // valid lead


            leadSurrogate = codePoint;
            continue;
          } // 2 leads in a row


          if (codePoint < 0xDC00) {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            leadSurrogate = codePoint;
            continue;
          } // valid surrogate pair


          codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) {
          // valid bmp char, but last char was a lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }

        leadSurrogate = null; // encode utf8

        if (codePoint < 0x80) {
          if ((units -= 1) < 0) break;
          bytes.push(codePoint);
        } else if (codePoint < 0x800) {
          if ((units -= 2) < 0) break;
          bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
          if ((units -= 3) < 0) break;
          bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
          if ((units -= 4) < 0) break;
          bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else {
          throw new Error('Invalid code point');
        }
      }

      return bytes;
    }

    function asciiToBytes(str) {
      var byteArray = [];

      for (var i = 0; i < str.length; ++i) {
        // Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
      }

      return byteArray;
    }

    function utf16leToBytes(str, units) {
      var c, hi, lo;
      var byteArray = [];

      for (var i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }

      return byteArray;
    }

    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }

    function blitBuffer(src, dst, offset, length) {
      for (var i = 0; i < length; ++i) {
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
      }

      return i;
    }

    function isnan(val) {
      return val !== val; // eslint-disable-line no-self-compare
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(10));
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(7);

  module.exports = function (it) {
    if (!isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
  };
  /***/

},
/* 3 */

/***/
function (module, exports) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
  : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory();
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define([], factory);
    } else {
      // Global (browser)
      root.CryptoJS = factory();
    }
  })(this, function () {
    /**
     * CryptoJS core components.
     */
    var CryptoJS = CryptoJS || function (Math, undefined) {
      /**
       * CryptoJS namespace.
       */
      var C = {};
      /**
       * Library namespace.
       */

      var C_lib = C.lib = {};
      /**
       * Base object for prototypal inheritance.
       */

      var Base = C_lib.Base = function () {
        function F() {}

        return {
          /**
           * Creates a new object that inherits from this object.
           *
           * @param {Object} overrides Properties to copy into the new object.
           *
           * @return {Object} The new object.
           *
           * @static
           *
           * @example
           *
           *     var MyType = CryptoJS.lib.Base.extend({
           *         field: 'value',
           *
           *         method: function () {
           *         }
           *     });
           */
          extend: function extend(overrides) {
            // Spawn
            F.prototype = this;
            var subtype = new F(); // Augment

            if (overrides) {
              subtype.mixIn(overrides);
            } // Create default initializer


            if (!subtype.hasOwnProperty('init')) {
              subtype.init = function () {
                subtype.$super.init.apply(this, arguments);
              };
            } // Initializer's prototype is the subtype object


            subtype.init.prototype = subtype; // Reference supertype

            subtype.$super = this;
            return subtype;
          },

          /**
           * Extends this object and runs the init method.
           * Arguments to create() will be passed to init().
           *
           * @return {Object} The new object.
           *
           * @static
           *
           * @example
           *
           *     var instance = MyType.create();
           */
          create: function create() {
            var instance = this.extend();
            instance.init.apply(instance, arguments);
            return instance;
          },

          /**
           * Initializes a newly created object.
           * Override this method to add some logic when your objects are created.
           *
           * @example
           *
           *     var MyType = CryptoJS.lib.Base.extend({
           *         init: function () {
           *             // ...
           *         }
           *     });
           */
          init: function init() {},

          /**
           * Copies properties into this object.
           *
           * @param {Object} properties The properties to mix in.
           *
           * @example
           *
           *     MyType.mixIn({
           *         field: 'value'
           *     });
           */
          mixIn: function mixIn(properties) {
            for (var propertyName in properties) {
              if (properties.hasOwnProperty(propertyName)) {
                this[propertyName] = properties[propertyName];
              }
            } // IE won't copy toString using the loop above


            if (properties.hasOwnProperty('toString')) {
              this.toString = properties.toString;
            }
          },

          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = instance.clone();
           */
          clone: function clone() {
            return this.init.prototype.extend(this);
          }
        };
      }();
      /**
       * An array of 32-bit words.
       *
       * @property {Array} words The array of 32-bit words.
       * @property {number} sigBytes The number of significant bytes in this word array.
       */


      var WordArray = C_lib.WordArray = Base.extend({
        /**
         * Initializes a newly created word array.
         *
         * @param {Array} words (Optional) An array of 32-bit words.
         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.create();
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
         */
        init: function init(words, sigBytes) {
          words = this.words = words || [];

          if (sigBytes != undefined) {
            this.sigBytes = sigBytes;
          } else {
            this.sigBytes = words.length * 4;
          }
        },

        /**
         * Converts this word array to a string.
         *
         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
         *
         * @return {string} The stringified word array.
         *
         * @example
         *
         *     var string = wordArray + '';
         *     var string = wordArray.toString();
         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
         */
        toString: function toString(encoder) {
          return (encoder || Hex).stringify(this);
        },

        /**
         * Concatenates a word array to this word array.
         *
         * @param {WordArray} wordArray The word array to append.
         *
         * @return {WordArray} This word array.
         *
         * @example
         *
         *     wordArray1.concat(wordArray2);
         */
        concat: function concat(wordArray) {
          // Shortcuts
          var thisWords = this.words;
          var thatWords = wordArray.words;
          var thisSigBytes = this.sigBytes;
          var thatSigBytes = wordArray.sigBytes; // Clamp excess bits

          this.clamp(); // Concat

          if (thisSigBytes % 4) {
            // Copy one byte at a time
            for (var i = 0; i < thatSigBytes; i++) {
              var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
              thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
            }
          } else {
            // Copy one word at a time
            for (var i = 0; i < thatSigBytes; i += 4) {
              thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
            }
          }

          this.sigBytes += thatSigBytes; // Chainable

          return this;
        },

        /**
         * Removes insignificant bits.
         *
         * @example
         *
         *     wordArray.clamp();
         */
        clamp: function clamp() {
          // Shortcuts
          var words = this.words;
          var sigBytes = this.sigBytes; // Clamp

          words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
          words.length = Math.ceil(sigBytes / 4);
        },

        /**
         * Creates a copy of this word array.
         *
         * @return {WordArray} The clone.
         *
         * @example
         *
         *     var clone = wordArray.clone();
         */
        clone: function clone() {
          var clone = Base.clone.call(this);
          clone.words = this.words.slice(0);
          return clone;
        },

        /**
         * Creates a word array filled with random bytes.
         *
         * @param {number} nBytes The number of random bytes to generate.
         *
         * @return {WordArray} The random word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.random(16);
         */
        random: function random(nBytes) {
          var words = [];

          var r = function r(m_w) {
            var m_w = m_w;
            var m_z = 0x3ade68b1;
            var mask = 0xffffffff;
            return function () {
              m_z = 0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10) & mask;
              m_w = 0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10) & mask;
              var result = (m_z << 0x10) + m_w & mask;
              result /= 0x100000000;
              result += 0.5;
              return result * (Math.random() > .5 ? 1 : -1);
            };
          };

          for (var i = 0, rcache; i < nBytes; i += 4) {
            var _r = r((rcache || Math.random()) * 0x100000000);

            rcache = _r() * 0x3ade67b7;
            words.push(_r() * 0x100000000 | 0);
          }

          return new WordArray.init(words, nBytes);
        }
      });
      /**
       * Encoder namespace.
       */

      var C_enc = C.enc = {};
      /**
       * Hex encoding strategy.
       */

      var Hex = C_enc.Hex = {
        /**
         * Converts a word array to a hex string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The hex string.
         *
         * @static
         *
         * @example
         *
         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
          // Shortcuts
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes; // Convert

          var hexChars = [];

          for (var i = 0; i < sigBytes; i++) {
            var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
            hexChars.push((bite >>> 4).toString(16));
            hexChars.push((bite & 0x0f).toString(16));
          }

          return hexChars.join('');
        },

        /**
         * Converts a hex string to a word array.
         *
         * @param {string} hexStr The hex string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
         */
        parse: function parse(hexStr) {
          // Shortcut
          var hexStrLength = hexStr.length; // Convert

          var words = [];

          for (var i = 0; i < hexStrLength; i += 2) {
            words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
          }

          return new WordArray.init(words, hexStrLength / 2);
        }
      };
      /**
       * Latin1 encoding strategy.
       */

      var Latin1 = C_enc.Latin1 = {
        /**
         * Converts a word array to a Latin1 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Latin1 string.
         *
         * @static
         *
         * @example
         *
         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
          // Shortcuts
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes; // Convert

          var latin1Chars = [];

          for (var i = 0; i < sigBytes; i++) {
            var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
            latin1Chars.push(String.fromCharCode(bite));
          }

          return latin1Chars.join('');
        },

        /**
         * Converts a Latin1 string to a word array.
         *
         * @param {string} latin1Str The Latin1 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
         */
        parse: function parse(latin1Str) {
          // Shortcut
          var latin1StrLength = latin1Str.length; // Convert

          var words = [];

          for (var i = 0; i < latin1StrLength; i++) {
            words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
          }

          return new WordArray.init(words, latin1StrLength);
        }
      };
      /**
       * UTF-8 encoding strategy.
       */

      var Utf8 = C_enc.Utf8 = {
        /**
         * Converts a word array to a UTF-8 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-8 string.
         *
         * @static
         *
         * @example
         *
         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
          try {
            return decodeURIComponent(escape(Latin1.stringify(wordArray)));
          } catch (e) {
            throw new Error('Malformed UTF-8 data');
          }
        },

        /**
         * Converts a UTF-8 string to a word array.
         *
         * @param {string} utf8Str The UTF-8 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
         */
        parse: function parse(utf8Str) {
          return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
        }
      };
      /**
       * Abstract buffered block algorithm template.
       *
       * The property blockSize must be implemented in a concrete subtype.
       *
       * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
       */

      var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
        /**
         * Resets this block algorithm's data buffer to its initial state.
         *
         * @example
         *
         *     bufferedBlockAlgorithm.reset();
         */
        reset: function reset() {
          // Initial values
          this._data = new WordArray.init();
          this._nDataBytes = 0;
        },

        /**
         * Adds new data to this block algorithm's buffer.
         *
         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
         *
         * @example
         *
         *     bufferedBlockAlgorithm._append('data');
         *     bufferedBlockAlgorithm._append(wordArray);
         */
        _append: function _append(data) {
          // Convert string to WordArray, else assume WordArray already
          if (typeof data == 'string') {
            data = Utf8.parse(data);
          } // Append


          this._data.concat(data);

          this._nDataBytes += data.sigBytes;
        },

        /**
         * Processes available data blocks.
         *
         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
         *
         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
         *
         * @return {WordArray} The processed data.
         *
         * @example
         *
         *     var processedData = bufferedBlockAlgorithm._process();
         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
         */
        _process: function _process(doFlush) {
          // Shortcuts
          var data = this._data;
          var dataWords = data.words;
          var dataSigBytes = data.sigBytes;
          var blockSize = this.blockSize;
          var blockSizeBytes = blockSize * 4; // Count blocks ready

          var nBlocksReady = dataSigBytes / blockSizeBytes;

          if (doFlush) {
            // Round up to include partial blocks
            nBlocksReady = Math.ceil(nBlocksReady);
          } else {
            // Round down to include only full blocks,
            // less the number of blocks that must remain in the buffer
            nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
          } // Count words ready


          var nWordsReady = nBlocksReady * blockSize; // Count bytes ready

          var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes); // Process blocks

          if (nWordsReady) {
            for (var offset = 0; offset < nWordsReady; offset += blockSize) {
              // Perform concrete-algorithm logic
              this._doProcessBlock(dataWords, offset);
            } // Remove processed words


            var processedWords = dataWords.splice(0, nWordsReady);
            data.sigBytes -= nBytesReady;
          } // Return processed words


          return new WordArray.init(processedWords, nBytesReady);
        },

        /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = bufferedBlockAlgorithm.clone();
         */
        clone: function clone() {
          var clone = Base.clone.call(this);
          clone._data = this._data.clone();
          return clone;
        },
        _minBufferSize: 0
      });
      /**
       * Abstract hasher template.
       *
       * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
       */

      var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
        /**
         * Configuration options.
         */
        cfg: Base.extend(),

        /**
         * Initializes a newly created hasher.
         *
         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
         *
         * @example
         *
         *     var hasher = CryptoJS.algo.SHA256.create();
         */
        init: function init(cfg) {
          // Apply config defaults
          this.cfg = this.cfg.extend(cfg); // Set initial values

          this.reset();
        },

        /**
         * Resets this hasher to its initial state.
         *
         * @example
         *
         *     hasher.reset();
         */
        reset: function reset() {
          // Reset data buffer
          BufferedBlockAlgorithm.reset.call(this); // Perform concrete-hasher logic

          this._doReset();
        },

        /**
         * Updates this hasher with a message.
         *
         * @param {WordArray|string} messageUpdate The message to append.
         *
         * @return {Hasher} This hasher.
         *
         * @example
         *
         *     hasher.update('message');
         *     hasher.update(wordArray);
         */
        update: function update(messageUpdate) {
          // Append
          this._append(messageUpdate); // Update the hash


          this._process(); // Chainable


          return this;
        },

        /**
         * Finalizes the hash computation.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} messageUpdate (Optional) A final message update.
         *
         * @return {WordArray} The hash.
         *
         * @example
         *
         *     var hash = hasher.finalize();
         *     var hash = hasher.finalize('message');
         *     var hash = hasher.finalize(wordArray);
         */
        finalize: function finalize(messageUpdate) {
          // Final message update
          if (messageUpdate) {
            this._append(messageUpdate);
          } // Perform concrete-hasher logic


          var hash = this._doFinalize();

          return hash;
        },
        blockSize: 512 / 32,

        /**
         * Creates a shortcut function to a hasher's object interface.
         *
         * @param {Hasher} hasher The hasher to create a helper for.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
         */
        _createHelper: function _createHelper(hasher) {
          return function (message, cfg) {
            return new hasher.init(cfg).finalize(message);
          };
        },

        /**
         * Creates a shortcut function to the HMAC's object interface.
         *
         * @param {Hasher} hasher The hasher to use in this HMAC helper.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
         */
        _createHmacHelper: function _createHmacHelper(hasher) {
          return function (message, key) {
            return new C_algo.HMAC.init(hasher, key).finalize(message);
          };
        }
      });
      /**
       * Algorithm namespace.
       */

      var C_algo = C.algo = {};
      return C;
    }(Math);

    return CryptoJS;
  });
  /***/

},
/* 5 */

/***/
function (module, exports) {
  module.exports = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };
  /***/

},
/* 6 */

/***/
function (module, exports) {
  /**
   * Node.js module for Forge.
   *
   * @author Dave Longley
   *
   * Copyright 2011-2016 Digital Bazaar, Inc.
   */
  module.exports = {
    // default options
    options: {
      usePureJavaScript: false
    }
  };
  /***/
},
/* 7 */

/***/
function (module, exports) {
  module.exports = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };
  /***/

},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process, setImmediate, Buffer) {
    /**
    * Utility functions for web applications.
    *
    * @author Dave Longley
    *
    * Copyright (c) 2010-2018 Digital Bazaar, Inc.
    */
    var forge = __webpack_require__(6);

    var baseN = __webpack_require__(539);
    /* Utilities API */


    var util = module.exports = forge.util = forge.util || {}; // define setImmediate and nextTick

    (function () {
      // use native nextTick (unless we're in webpack)
      // webpack (or better node-libs-browser polyfill) sets process.browser.
      // this way we can detect webpack properly
      if (typeof process !== 'undefined' && process.nextTick && !process.browser) {
        util.nextTick = process.nextTick;

        if (typeof setImmediate === 'function') {
          util.setImmediate = setImmediate;
        } else {
          // polyfill setImmediate with nextTick, older versions of node
          // (those w/o setImmediate) won't totally starve IO
          util.setImmediate = util.nextTick;
        }

        return;
      } // polyfill nextTick with native setImmediate


      if (typeof setImmediate === 'function') {
        util.setImmediate = function () {
          return setImmediate.apply(undefined, arguments);
        };

        util.nextTick = function (callback) {
          return setImmediate(callback);
        };

        return;
      }
      /* Note: A polyfill upgrade pattern is used here to allow combining
      polyfills. For example, MutationObserver is fast, but blocks UI updates,
      so it needs to allow UI updates periodically, so it falls back on
      postMessage or setTimeout. */
      // polyfill with setTimeout


      util.setImmediate = function (callback) {
        setTimeout(callback, 0);
      }; // upgrade polyfill to use postMessage


      if (typeof window !== 'undefined' && typeof window.postMessage === 'function') {
        var handler = function handler(event) {
          if (event.source === window && event.data === msg) {
            event.stopPropagation();
            var copy = callbacks.slice();
            callbacks.length = 0;
            copy.forEach(function (callback) {
              callback();
            });
          }
        };

        var msg = 'forge.setImmediate';
        var callbacks = [];

        util.setImmediate = function (callback) {
          callbacks.push(callback); // only send message when one hasn't been sent in
          // the current turn of the event loop

          if (callbacks.length === 1) {
            window.postMessage(msg, '*');
          }
        };

        window.addEventListener('message', handler, true);
      } // upgrade polyfill to use MutationObserver


      if (typeof MutationObserver !== 'undefined') {
        // polyfill with MutationObserver
        var now = Date.now();
        var attr = true;
        var div = document.createElement('div');
        var callbacks = [];
        new MutationObserver(function () {
          var copy = callbacks.slice();
          callbacks.length = 0;
          copy.forEach(function (callback) {
            callback();
          });
        }).observe(div, {
          attributes: true
        });
        var oldSetImmediate = util.setImmediate;

        util.setImmediate = function (callback) {
          if (Date.now() - now > 15) {
            now = Date.now();
            oldSetImmediate(callback);
          } else {
            callbacks.push(callback); // only trigger observer when it hasn't been triggered in
            // the current turn of the event loop

            if (callbacks.length === 1) {
              div.setAttribute('a', attr = !attr);
            }
          }
        };
      }

      util.nextTick = util.setImmediate;
    })(); // check if running under Node.js


    util.isNodejs = typeof process !== 'undefined' && process.versions && process.versions.node; // define isArray

    util.isArray = Array.isArray || function (x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    }; // define isArrayBuffer


    util.isArrayBuffer = function (x) {
      return typeof ArrayBuffer !== 'undefined' && x instanceof ArrayBuffer;
    }; // define isArrayBufferView


    util.isArrayBufferView = function (x) {
      return x && util.isArrayBuffer(x.buffer) && x.byteLength !== undefined;
    };
    /**
     * Ensure a bits param is 8, 16, 24, or 32. Used to validate input for
     * algorithms where bit manipulation, JavaScript limitations, and/or algorithm
     * design only allow for byte operations of a limited size.
     *
     * @param n number of bits.
     *
     * Throw Error if n invalid.
     */


    function _checkBitsParam(n) {
      if (!(n === 8 || n === 16 || n === 24 || n === 32)) {
        throw new Error('Only 8, 16, 24, or 32 bits supported: ' + n);
      }
    } // TODO: set ByteBuffer to best available backing


    util.ByteBuffer = ByteStringBuffer;
    /** Buffer w/BinaryString backing */

    /**
     * Constructor for a binary string backed byte buffer.
     *
     * @param [b] the bytes to wrap (either encoded as string, one byte per
     *          character, or as an ArrayBuffer or Typed Array).
     */

    function ByteStringBuffer(b) {
      // TODO: update to match DataBuffer API
      // the data in this buffer
      this.data = ''; // the pointer for reading from this buffer

      this.read = 0;

      if (typeof b === 'string') {
        this.data = b;
      } else if (util.isArrayBuffer(b) || util.isArrayBufferView(b)) {
        if (typeof Buffer !== 'undefined' && b instanceof Buffer) {
          this.data = b.toString('binary');
        } else {
          // convert native buffer to forge buffer
          // FIXME: support native buffers internally instead
          var arr = new Uint8Array(b);

          try {
            this.data = String.fromCharCode.apply(null, arr);
          } catch (e) {
            for (var i = 0; i < arr.length; ++i) {
              this.putByte(arr[i]);
            }
          }
        }
      } else if (b instanceof ByteStringBuffer || typeof b === 'object' && typeof b.data === 'string' && typeof b.read === 'number') {
        // copy existing buffer
        this.data = b.data;
        this.read = b.read;
      } // used for v8 optimization


      this._constructedStringLength = 0;
    }

    util.ByteStringBuffer = ByteStringBuffer;
    /* Note: This is an optimization for V8-based browsers. When V8 concatenates
      a string, the strings are only joined logically using a "cons string" or
      "constructed/concatenated string". These containers keep references to one
      another and can result in very large memory usage. For example, if a 2MB
      string is constructed by concatenating 4 bytes together at a time, the
      memory usage will be ~44MB; so ~22x increase. The strings are only joined
      together when an operation requiring their joining takes place, such as
      substr(). This function is called when adding data to this buffer to ensure
      these types of strings are periodically joined to reduce the memory
      footprint. */

    var _MAX_CONSTRUCTED_STRING_LENGTH = 4096;

    util.ByteStringBuffer.prototype._optimizeConstructedString = function (x) {
      this._constructedStringLength += x;

      if (this._constructedStringLength > _MAX_CONSTRUCTED_STRING_LENGTH) {
        // this substr() should cause the constructed string to join
        this.data.substr(0, 1);
        this._constructedStringLength = 0;
      }
    };
    /**
     * Gets the number of bytes in this buffer.
     *
     * @return the number of bytes in this buffer.
     */


    util.ByteStringBuffer.prototype.length = function () {
      return this.data.length - this.read;
    };
    /**
     * Gets whether or not this buffer is empty.
     *
     * @return true if this buffer is empty, false if not.
     */


    util.ByteStringBuffer.prototype.isEmpty = function () {
      return this.length() <= 0;
    };
    /**
     * Puts a byte in this buffer.
     *
     * @param b the byte to put.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putByte = function (b) {
      return this.putBytes(String.fromCharCode(b));
    };
    /**
     * Puts a byte in this buffer N times.
     *
     * @param b the byte to put.
     * @param n the number of bytes of value b to put.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.fillWithByte = function (b, n) {
      b = String.fromCharCode(b);
      var d = this.data;

      while (n > 0) {
        if (n & 1) {
          d += b;
        }

        n >>>= 1;

        if (n > 0) {
          b += b;
        }
      }

      this.data = d;

      this._optimizeConstructedString(n);

      return this;
    };
    /**
     * Puts bytes in this buffer.
     *
     * @param bytes the bytes (as a UTF-8 encoded string) to put.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putBytes = function (bytes) {
      this.data += bytes;

      this._optimizeConstructedString(bytes.length);

      return this;
    };
    /**
     * Puts a UTF-16 encoded string into this buffer.
     *
     * @param str the string to put.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putString = function (str) {
      return this.putBytes(util.encodeUtf8(str));
    };
    /**
     * Puts a 16-bit integer in this buffer in big-endian order.
     *
     * @param i the 16-bit integer.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putInt16 = function (i) {
      return this.putBytes(String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
    };
    /**
     * Puts a 24-bit integer in this buffer in big-endian order.
     *
     * @param i the 24-bit integer.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putInt24 = function (i) {
      return this.putBytes(String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
    };
    /**
     * Puts a 32-bit integer in this buffer in big-endian order.
     *
     * @param i the 32-bit integer.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putInt32 = function (i) {
      return this.putBytes(String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
    };
    /**
     * Puts a 16-bit integer in this buffer in little-endian order.
     *
     * @param i the 16-bit integer.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putInt16Le = function (i) {
      return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF));
    };
    /**
     * Puts a 24-bit integer in this buffer in little-endian order.
     *
     * @param i the 24-bit integer.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putInt24Le = function (i) {
      return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF));
    };
    /**
     * Puts a 32-bit integer in this buffer in little-endian order.
     *
     * @param i the 32-bit integer.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putInt32Le = function (i) {
      return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 24 & 0xFF));
    };
    /**
     * Puts an n-bit integer in this buffer in big-endian order.
     *
     * @param i the n-bit integer.
     * @param n the number of bits in the integer (8, 16, 24, or 32).
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putInt = function (i, n) {
      _checkBitsParam(n);

      var bytes = '';

      do {
        n -= 8;
        bytes += String.fromCharCode(i >> n & 0xFF);
      } while (n > 0);

      return this.putBytes(bytes);
    };
    /**
     * Puts a signed n-bit integer in this buffer in big-endian order. Two's
     * complement representation is used.
     *
     * @param i the n-bit integer.
     * @param n the number of bits in the integer (8, 16, 24, or 32).
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putSignedInt = function (i, n) {
      // putInt checks n
      if (i < 0) {
        i += 2 << n - 1;
      }

      return this.putInt(i, n);
    };
    /**
     * Puts the given buffer into this buffer.
     *
     * @param buffer the buffer to put into this one.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.putBuffer = function (buffer) {
      return this.putBytes(buffer.getBytes());
    };
    /**
     * Gets a byte from this buffer and advances the read pointer by 1.
     *
     * @return the byte.
     */


    util.ByteStringBuffer.prototype.getByte = function () {
      return this.data.charCodeAt(this.read++);
    };
    /**
     * Gets a uint16 from this buffer in big-endian order and advances the read
     * pointer by 2.
     *
     * @return the uint16.
     */


    util.ByteStringBuffer.prototype.getInt16 = function () {
      var rval = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
      this.read += 2;
      return rval;
    };
    /**
     * Gets a uint24 from this buffer in big-endian order and advances the read
     * pointer by 3.
     *
     * @return the uint24.
     */


    util.ByteStringBuffer.prototype.getInt24 = function () {
      var rval = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
      this.read += 3;
      return rval;
    };
    /**
     * Gets a uint32 from this buffer in big-endian order and advances the read
     * pointer by 4.
     *
     * @return the word.
     */


    util.ByteStringBuffer.prototype.getInt32 = function () {
      var rval = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
      this.read += 4;
      return rval;
    };
    /**
     * Gets a uint16 from this buffer in little-endian order and advances the read
     * pointer by 2.
     *
     * @return the uint16.
     */


    util.ByteStringBuffer.prototype.getInt16Le = function () {
      var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
      this.read += 2;
      return rval;
    };
    /**
     * Gets a uint24 from this buffer in little-endian order and advances the read
     * pointer by 3.
     *
     * @return the uint24.
     */


    util.ByteStringBuffer.prototype.getInt24Le = function () {
      var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
      this.read += 3;
      return rval;
    };
    /**
     * Gets a uint32 from this buffer in little-endian order and advances the read
     * pointer by 4.
     *
     * @return the word.
     */


    util.ByteStringBuffer.prototype.getInt32Le = function () {
      var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
      this.read += 4;
      return rval;
    };
    /**
     * Gets an n-bit integer from this buffer in big-endian order and advances the
     * read pointer by ceil(n/8).
     *
     * @param n the number of bits in the integer (8, 16, 24, or 32).
     *
     * @return the integer.
     */


    util.ByteStringBuffer.prototype.getInt = function (n) {
      _checkBitsParam(n);

      var rval = 0;

      do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.charCodeAt(this.read++);
        n -= 8;
      } while (n > 0);

      return rval;
    };
    /**
     * Gets a signed n-bit integer from this buffer in big-endian order, using
     * two's complement, and advances the read pointer by n/8.
     *
     * @param n the number of bits in the integer (8, 16, 24, or 32).
     *
     * @return the integer.
     */


    util.ByteStringBuffer.prototype.getSignedInt = function (n) {
      // getInt checks n
      var x = this.getInt(n);
      var max = 2 << n - 2;

      if (x >= max) {
        x -= max << 1;
      }

      return x;
    };
    /**
     * Reads bytes out into a UTF-8 string and clears them from the buffer.
     *
     * @param count the number of bytes to read, undefined or null for all.
     *
     * @return a UTF-8 string of bytes.
     */


    util.ByteStringBuffer.prototype.getBytes = function (count) {
      var rval;

      if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
      } else if (count === 0) {
        rval = '';
      } else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
      }

      return rval;
    };
    /**
     * Gets a UTF-8 encoded string of the bytes from this buffer without modifying
     * the read pointer.
     *
     * @param count the number of bytes to get, omit to get all.
     *
     * @return a string full of UTF-8 encoded characters.
     */


    util.ByteStringBuffer.prototype.bytes = function (count) {
      return typeof count === 'undefined' ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
    };
    /**
     * Gets a byte at the given index without modifying the read pointer.
     *
     * @param i the byte index.
     *
     * @return the byte.
     */


    util.ByteStringBuffer.prototype.at = function (i) {
      return this.data.charCodeAt(this.read + i);
    };
    /**
     * Puts a byte at the given index without modifying the read pointer.
     *
     * @param i the byte index.
     * @param b the byte to put.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.setAt = function (i, b) {
      this.data = this.data.substr(0, this.read + i) + String.fromCharCode(b) + this.data.substr(this.read + i + 1);
      return this;
    };
    /**
     * Gets the last byte without modifying the read pointer.
     *
     * @return the last byte.
     */


    util.ByteStringBuffer.prototype.last = function () {
      return this.data.charCodeAt(this.data.length - 1);
    };
    /**
     * Creates a copy of this buffer.
     *
     * @return the copy.
     */


    util.ByteStringBuffer.prototype.copy = function () {
      var c = util.createBuffer(this.data);
      c.read = this.read;
      return c;
    };
    /**
     * Compacts this buffer.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.compact = function () {
      if (this.read > 0) {
        this.data = this.data.slice(this.read);
        this.read = 0;
      }

      return this;
    };
    /**
     * Clears this buffer.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.clear = function () {
      this.data = '';
      this.read = 0;
      return this;
    };
    /**
     * Shortens this buffer by triming bytes off of the end of this buffer.
     *
     * @param count the number of bytes to trim off.
     *
     * @return this buffer.
     */


    util.ByteStringBuffer.prototype.truncate = function (count) {
      var len = Math.max(0, this.length() - count);
      this.data = this.data.substr(this.read, len);
      this.read = 0;
      return this;
    };
    /**
     * Converts this buffer to a hexadecimal string.
     *
     * @return a hexadecimal string.
     */


    util.ByteStringBuffer.prototype.toHex = function () {
      var rval = '';

      for (var i = this.read; i < this.data.length; ++i) {
        var b = this.data.charCodeAt(i);

        if (b < 16) {
          rval += '0';
        }

        rval += b.toString(16);
      }

      return rval;
    };
    /**
     * Converts this buffer to a UTF-16 string (standard JavaScript string).
     *
     * @return a UTF-16 string.
     */


    util.ByteStringBuffer.prototype.toString = function () {
      return util.decodeUtf8(this.bytes());
    };
    /** End Buffer w/BinaryString backing */

    /** Buffer w/UInt8Array backing */

    /**
     * FIXME: Experimental. Do not use yet.
     *
     * Constructor for an ArrayBuffer-backed byte buffer.
     *
     * The buffer may be constructed from a string, an ArrayBuffer, DataView, or a
     * TypedArray.
     *
     * If a string is given, its encoding should be provided as an option,
     * otherwise it will default to 'binary'. A 'binary' string is encoded such
     * that each character is one byte in length and size.
     *
     * If an ArrayBuffer, DataView, or TypedArray is given, it will be used
     * *directly* without any copying. Note that, if a write to the buffer requires
     * more space, the buffer will allocate a new backing ArrayBuffer to
     * accommodate. The starting read and write offsets for the buffer may be
     * given as options.
     *
     * @param [b] the initial bytes for this buffer.
     * @param options the options to use:
     *          [readOffset] the starting read offset to use (default: 0).
     *          [writeOffset] the starting write offset to use (default: the
     *            length of the first parameter).
     *          [growSize] the minimum amount, in bytes, to grow the buffer by to
     *            accommodate writes (default: 1024).
     *          [encoding] the encoding ('binary', 'utf8', 'utf16', 'hex') for the
     *            first parameter, if it is a string (default: 'binary').
     */


    function DataBuffer(b, options) {
      // default options
      options = options || {}; // pointers for read from/write to buffer

      this.read = options.readOffset || 0;
      this.growSize = options.growSize || 1024;
      var isArrayBuffer = util.isArrayBuffer(b);
      var isArrayBufferView = util.isArrayBufferView(b);

      if (isArrayBuffer || isArrayBufferView) {
        // use ArrayBuffer directly
        if (isArrayBuffer) {
          this.data = new DataView(b);
        } else {
          // TODO: adjust read/write offset based on the type of view
          // or specify that this must be done in the options ... that the
          // offsets are byte-based
          this.data = new DataView(b.buffer, b.byteOffset, b.byteLength);
        }

        this.write = 'writeOffset' in options ? options.writeOffset : this.data.byteLength;
        return;
      } // initialize to empty array buffer and add any given bytes using putBytes


      this.data = new DataView(new ArrayBuffer(0));
      this.write = 0;

      if (b !== null && b !== undefined) {
        this.putBytes(b);
      }

      if ('writeOffset' in options) {
        this.write = options.writeOffset;
      }
    }

    util.DataBuffer = DataBuffer;
    /**
     * Gets the number of bytes in this buffer.
     *
     * @return the number of bytes in this buffer.
     */

    util.DataBuffer.prototype.length = function () {
      return this.write - this.read;
    };
    /**
     * Gets whether or not this buffer is empty.
     *
     * @return true if this buffer is empty, false if not.
     */


    util.DataBuffer.prototype.isEmpty = function () {
      return this.length() <= 0;
    };
    /**
     * Ensures this buffer has enough empty space to accommodate the given number
     * of bytes. An optional parameter may be given that indicates a minimum
     * amount to grow the buffer if necessary. If the parameter is not given,
     * the buffer will be grown by some previously-specified default amount
     * or heuristic.
     *
     * @param amount the number of bytes to accommodate.
     * @param [growSize] the minimum amount, in bytes, to grow the buffer by if
     *          necessary.
     */


    util.DataBuffer.prototype.accommodate = function (amount, growSize) {
      if (this.length() >= amount) {
        return this;
      }

      growSize = Math.max(growSize || this.growSize, amount); // grow buffer

      var src = new Uint8Array(this.data.buffer, this.data.byteOffset, this.data.byteLength);
      var dst = new Uint8Array(this.length() + growSize);
      dst.set(src);
      this.data = new DataView(dst.buffer);
      return this;
    };
    /**
     * Puts a byte in this buffer.
     *
     * @param b the byte to put.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putByte = function (b) {
      this.accommodate(1);
      this.data.setUint8(this.write++, b);
      return this;
    };
    /**
     * Puts a byte in this buffer N times.
     *
     * @param b the byte to put.
     * @param n the number of bytes of value b to put.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.fillWithByte = function (b, n) {
      this.accommodate(n);

      for (var i = 0; i < n; ++i) {
        this.data.setUint8(b);
      }

      return this;
    };
    /**
     * Puts bytes in this buffer. The bytes may be given as a string, an
     * ArrayBuffer, a DataView, or a TypedArray.
     *
     * @param bytes the bytes to put.
     * @param [encoding] the encoding for the first parameter ('binary', 'utf8',
     *          'utf16', 'hex'), if it is a string (default: 'binary').
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putBytes = function (bytes, encoding) {
      if (util.isArrayBufferView(bytes)) {
        var src = new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        var len = src.byteLength - src.byteOffset;
        this.accommodate(len);
        var dst = new Uint8Array(this.data.buffer, this.write);
        dst.set(src);
        this.write += len;
        return this;
      }

      if (util.isArrayBuffer(bytes)) {
        var src = new Uint8Array(bytes);
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(this.data.buffer);
        dst.set(src, this.write);
        this.write += src.byteLength;
        return this;
      } // bytes is a util.DataBuffer or equivalent


      if (bytes instanceof util.DataBuffer || typeof bytes === 'object' && typeof bytes.read === 'number' && typeof bytes.write === 'number' && util.isArrayBufferView(bytes.data)) {
        var src = new Uint8Array(bytes.data.byteLength, bytes.read, bytes.length());
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(bytes.data.byteLength, this.write);
        dst.set(src);
        this.write += src.byteLength;
        return this;
      }

      if (bytes instanceof util.ByteStringBuffer) {
        // copy binary string and process as the same as a string parameter below
        bytes = bytes.data;
        encoding = 'binary';
      } // string conversion


      encoding = encoding || 'binary';

      if (typeof bytes === 'string') {
        var view; // decode from string

        if (encoding === 'hex') {
          this.accommodate(Math.ceil(bytes.length / 2));
          view = new Uint8Array(this.data.buffer, this.write);
          this.write += util.binary.hex.decode(bytes, view, this.write);
          return this;
        }

        if (encoding === 'base64') {
          this.accommodate(Math.ceil(bytes.length / 4) * 3);
          view = new Uint8Array(this.data.buffer, this.write);
          this.write += util.binary.base64.decode(bytes, view, this.write);
          return this;
        } // encode text as UTF-8 bytes


        if (encoding === 'utf8') {
          // encode as UTF-8 then decode string as raw binary
          bytes = util.encodeUtf8(bytes);
          encoding = 'binary';
        } // decode string as raw binary


        if (encoding === 'binary' || encoding === 'raw') {
          // one byte per character
          this.accommodate(bytes.length);
          view = new Uint8Array(this.data.buffer, this.write);
          this.write += util.binary.raw.decode(view);
          return this;
        } // encode text as UTF-16 bytes


        if (encoding === 'utf16') {
          // two bytes per character
          this.accommodate(bytes.length * 2);
          view = new Uint16Array(this.data.buffer, this.write);
          this.write += util.text.utf16.encode(view);
          return this;
        }

        throw new Error('Invalid encoding: ' + encoding);
      }

      throw Error('Invalid parameter: ' + bytes);
    };
    /**
     * Puts the given buffer into this buffer.
     *
     * @param buffer the buffer to put into this one.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putBuffer = function (buffer) {
      this.putBytes(buffer);
      buffer.clear();
      return this;
    };
    /**
     * Puts a string into this buffer.
     *
     * @param str the string to put.
     * @param [encoding] the encoding for the string (default: 'utf16').
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putString = function (str) {
      return this.putBytes(str, 'utf16');
    };
    /**
     * Puts a 16-bit integer in this buffer in big-endian order.
     *
     * @param i the 16-bit integer.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putInt16 = function (i) {
      this.accommodate(2);
      this.data.setInt16(this.write, i);
      this.write += 2;
      return this;
    };
    /**
     * Puts a 24-bit integer in this buffer in big-endian order.
     *
     * @param i the 24-bit integer.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putInt24 = function (i) {
      this.accommodate(3);
      this.data.setInt16(this.write, i >> 8 & 0xFFFF);
      this.data.setInt8(this.write, i >> 16 & 0xFF);
      this.write += 3;
      return this;
    };
    /**
     * Puts a 32-bit integer in this buffer in big-endian order.
     *
     * @param i the 32-bit integer.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putInt32 = function (i) {
      this.accommodate(4);
      this.data.setInt32(this.write, i);
      this.write += 4;
      return this;
    };
    /**
     * Puts a 16-bit integer in this buffer in little-endian order.
     *
     * @param i the 16-bit integer.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putInt16Le = function (i) {
      this.accommodate(2);
      this.data.setInt16(this.write, i, true);
      this.write += 2;
      return this;
    };
    /**
     * Puts a 24-bit integer in this buffer in little-endian order.
     *
     * @param i the 24-bit integer.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putInt24Le = function (i) {
      this.accommodate(3);
      this.data.setInt8(this.write, i >> 16 & 0xFF);
      this.data.setInt16(this.write, i >> 8 & 0xFFFF, true);
      this.write += 3;
      return this;
    };
    /**
     * Puts a 32-bit integer in this buffer in little-endian order.
     *
     * @param i the 32-bit integer.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putInt32Le = function (i) {
      this.accommodate(4);
      this.data.setInt32(this.write, i, true);
      this.write += 4;
      return this;
    };
    /**
     * Puts an n-bit integer in this buffer in big-endian order.
     *
     * @param i the n-bit integer.
     * @param n the number of bits in the integer (8, 16, 24, or 32).
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putInt = function (i, n) {
      _checkBitsParam(n);

      this.accommodate(n / 8);

      do {
        n -= 8;
        this.data.setInt8(this.write++, i >> n & 0xFF);
      } while (n > 0);

      return this;
    };
    /**
     * Puts a signed n-bit integer in this buffer in big-endian order. Two's
     * complement representation is used.
     *
     * @param i the n-bit integer.
     * @param n the number of bits in the integer.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.putSignedInt = function (i, n) {
      _checkBitsParam(n);

      this.accommodate(n / 8);

      if (i < 0) {
        i += 2 << n - 1;
      }

      return this.putInt(i, n);
    };
    /**
     * Gets a byte from this buffer and advances the read pointer by 1.
     *
     * @return the byte.
     */


    util.DataBuffer.prototype.getByte = function () {
      return this.data.getInt8(this.read++);
    };
    /**
     * Gets a uint16 from this buffer in big-endian order and advances the read
     * pointer by 2.
     *
     * @return the uint16.
     */


    util.DataBuffer.prototype.getInt16 = function () {
      var rval = this.data.getInt16(this.read);
      this.read += 2;
      return rval;
    };
    /**
     * Gets a uint24 from this buffer in big-endian order and advances the read
     * pointer by 3.
     *
     * @return the uint24.
     */


    util.DataBuffer.prototype.getInt24 = function () {
      var rval = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
      this.read += 3;
      return rval;
    };
    /**
     * Gets a uint32 from this buffer in big-endian order and advances the read
     * pointer by 4.
     *
     * @return the word.
     */


    util.DataBuffer.prototype.getInt32 = function () {
      var rval = this.data.getInt32(this.read);
      this.read += 4;
      return rval;
    };
    /**
     * Gets a uint16 from this buffer in little-endian order and advances the read
     * pointer by 2.
     *
     * @return the uint16.
     */


    util.DataBuffer.prototype.getInt16Le = function () {
      var rval = this.data.getInt16(this.read, true);
      this.read += 2;
      return rval;
    };
    /**
     * Gets a uint24 from this buffer in little-endian order and advances the read
     * pointer by 3.
     *
     * @return the uint24.
     */


    util.DataBuffer.prototype.getInt24Le = function () {
      var rval = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, true) << 8;
      this.read += 3;
      return rval;
    };
    /**
     * Gets a uint32 from this buffer in little-endian order and advances the read
     * pointer by 4.
     *
     * @return the word.
     */


    util.DataBuffer.prototype.getInt32Le = function () {
      var rval = this.data.getInt32(this.read, true);
      this.read += 4;
      return rval;
    };
    /**
     * Gets an n-bit integer from this buffer in big-endian order and advances the
     * read pointer by n/8.
     *
     * @param n the number of bits in the integer (8, 16, 24, or 32).
     *
     * @return the integer.
     */


    util.DataBuffer.prototype.getInt = function (n) {
      _checkBitsParam(n);

      var rval = 0;

      do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.getInt8(this.read++);
        n -= 8;
      } while (n > 0);

      return rval;
    };
    /**
     * Gets a signed n-bit integer from this buffer in big-endian order, using
     * two's complement, and advances the read pointer by n/8.
     *
     * @param n the number of bits in the integer (8, 16, 24, or 32).
     *
     * @return the integer.
     */


    util.DataBuffer.prototype.getSignedInt = function (n) {
      // getInt checks n
      var x = this.getInt(n);
      var max = 2 << n - 2;

      if (x >= max) {
        x -= max << 1;
      }

      return x;
    };
    /**
     * Reads bytes out into a UTF-8 string and clears them from the buffer.
     *
     * @param count the number of bytes to read, undefined or null for all.
     *
     * @return a UTF-8 string of bytes.
     */


    util.DataBuffer.prototype.getBytes = function (count) {
      // TODO: deprecate this method, it is poorly named and
      // this.toString('binary') replaces it
      // add a toTypedArray()/toArrayBuffer() function
      var rval;

      if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
      } else if (count === 0) {
        rval = '';
      } else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
      }

      return rval;
    };
    /**
     * Gets a UTF-8 encoded string of the bytes from this buffer without modifying
     * the read pointer.
     *
     * @param count the number of bytes to get, omit to get all.
     *
     * @return a string full of UTF-8 encoded characters.
     */


    util.DataBuffer.prototype.bytes = function (count) {
      // TODO: deprecate this method, it is poorly named, add "getString()"
      return typeof count === 'undefined' ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
    };
    /**
     * Gets a byte at the given index without modifying the read pointer.
     *
     * @param i the byte index.
     *
     * @return the byte.
     */


    util.DataBuffer.prototype.at = function (i) {
      return this.data.getUint8(this.read + i);
    };
    /**
     * Puts a byte at the given index without modifying the read pointer.
     *
     * @param i the byte index.
     * @param b the byte to put.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.setAt = function (i, b) {
      this.data.setUint8(i, b);
      return this;
    };
    /**
     * Gets the last byte without modifying the read pointer.
     *
     * @return the last byte.
     */


    util.DataBuffer.prototype.last = function () {
      return this.data.getUint8(this.write - 1);
    };
    /**
     * Creates a copy of this buffer.
     *
     * @return the copy.
     */


    util.DataBuffer.prototype.copy = function () {
      return new util.DataBuffer(this);
    };
    /**
     * Compacts this buffer.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.compact = function () {
      if (this.read > 0) {
        var src = new Uint8Array(this.data.buffer, this.read);
        var dst = new Uint8Array(src.byteLength);
        dst.set(src);
        this.data = new DataView(dst);
        this.write -= this.read;
        this.read = 0;
      }

      return this;
    };
    /**
     * Clears this buffer.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.clear = function () {
      this.data = new DataView(new ArrayBuffer(0));
      this.read = this.write = 0;
      return this;
    };
    /**
     * Shortens this buffer by triming bytes off of the end of this buffer.
     *
     * @param count the number of bytes to trim off.
     *
     * @return this buffer.
     */


    util.DataBuffer.prototype.truncate = function (count) {
      this.write = Math.max(0, this.length() - count);
      this.read = Math.min(this.read, this.write);
      return this;
    };
    /**
     * Converts this buffer to a hexadecimal string.
     *
     * @return a hexadecimal string.
     */


    util.DataBuffer.prototype.toHex = function () {
      var rval = '';

      for (var i = this.read; i < this.data.byteLength; ++i) {
        var b = this.data.getUint8(i);

        if (b < 16) {
          rval += '0';
        }

        rval += b.toString(16);
      }

      return rval;
    };
    /**
     * Converts this buffer to a string, using the given encoding. If no
     * encoding is given, 'utf8' (UTF-8) is used.
     *
     * @param [encoding] the encoding to use: 'binary', 'utf8', 'utf16', 'hex',
     *          'base64' (default: 'utf8').
     *
     * @return a string representation of the bytes in this buffer.
     */


    util.DataBuffer.prototype.toString = function (encoding) {
      var view = new Uint8Array(this.data, this.read, this.length());
      encoding = encoding || 'utf8'; // encode to string

      if (encoding === 'binary' || encoding === 'raw') {
        return util.binary.raw.encode(view);
      }

      if (encoding === 'hex') {
        return util.binary.hex.encode(view);
      }

      if (encoding === 'base64') {
        return util.binary.base64.encode(view);
      } // decode to text


      if (encoding === 'utf8') {
        return util.text.utf8.decode(view);
      }

      if (encoding === 'utf16') {
        return util.text.utf16.decode(view);
      }

      throw new Error('Invalid encoding: ' + encoding);
    };
    /** End Buffer w/UInt8Array backing */

    /**
     * Creates a buffer that stores bytes. A value may be given to put into the
     * buffer that is either a string of bytes or a UTF-16 string that will
     * be encoded using UTF-8 (to do the latter, specify 'utf8' as the encoding).
     *
     * @param [input] the bytes to wrap (as a string) or a UTF-16 string to encode
     *          as UTF-8.
     * @param [encoding] (default: 'raw', other: 'utf8').
     */


    util.createBuffer = function (input, encoding) {
      // TODO: deprecate, use new ByteBuffer() instead
      encoding = encoding || 'raw';

      if (input !== undefined && encoding === 'utf8') {
        input = util.encodeUtf8(input);
      }

      return new util.ByteBuffer(input);
    };
    /**
     * Fills a string with a particular value. If you want the string to be a byte
     * string, pass in String.fromCharCode(theByte).
     *
     * @param c the character to fill the string with, use String.fromCharCode
     *          to fill the string with a byte value.
     * @param n the number of characters of value c to fill with.
     *
     * @return the filled string.
     */


    util.fillString = function (c, n) {
      var s = '';

      while (n > 0) {
        if (n & 1) {
          s += c;
        }

        n >>>= 1;

        if (n > 0) {
          c += c;
        }
      }

      return s;
    };
    /**
     * Performs a per byte XOR between two byte strings and returns the result as a
     * string of bytes.
     *
     * @param s1 first string of bytes.
     * @param s2 second string of bytes.
     * @param n the number of bytes to XOR.
     *
     * @return the XOR'd result.
     */


    util.xorBytes = function (s1, s2, n) {
      var s3 = '';
      var b = '';
      var t = '';
      var i = 0;
      var c = 0;

      for (; n > 0; --n, ++i) {
        b = s1.charCodeAt(i) ^ s2.charCodeAt(i);

        if (c >= 10) {
          s3 += t;
          t = '';
          c = 0;
        }

        t += String.fromCharCode(b);
        ++c;
      }

      s3 += t;
      return s3;
    };
    /**
     * Converts a hex string into a 'binary' encoded string of bytes.
     *
     * @param hex the hexadecimal string to convert.
     *
     * @return the binary-encoded string of bytes.
     */


    util.hexToBytes = function (hex) {
      // TODO: deprecate: "Deprecated. Use util.binary.hex.decode instead."
      var rval = '';
      var i = 0;

      if (hex.length & 1 == 1) {
        // odd number of characters, convert first character alone
        i = 1;
        rval += String.fromCharCode(parseInt(hex[0], 16));
      } // convert 2 characters (1 byte) at a time


      for (; i < hex.length; i += 2) {
        rval += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
      }

      return rval;
    };
    /**
     * Converts a 'binary' encoded string of bytes to hex.
     *
     * @param bytes the byte string to convert.
     *
     * @return the string of hexadecimal characters.
     */


    util.bytesToHex = function (bytes) {
      // TODO: deprecate: "Deprecated. Use util.binary.hex.encode instead."
      return util.createBuffer(bytes).toHex();
    };
    /**
     * Converts an 32-bit integer to 4-big-endian byte string.
     *
     * @param i the integer.
     *
     * @return the byte string.
     */


    util.int32ToBytes = function (i) {
      return String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF);
    }; // base64 characters, reverse mapping


    var _base64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var _base64Idx = [
    /*43 -43 = 0*/

    /*'+',  1,  2,  3,'/' */
    62, -1, -1, -1, 63,
    /*'0','1','2','3','4','5','6','7','8','9' */
    52, 53, 54, 55, 56, 57, 58, 59, 60, 61,
    /*15, 16, 17,'=', 19, 20, 21 */
    -1, -1, -1, 64, -1, -1, -1,
    /*65 - 43 = 22*/

    /*'A','B','C','D','E','F','G','H','I','J','K','L','M', */
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
    /*'N','O','P','Q','R','S','T','U','V','W','X','Y','Z' */
    13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
    /*91 - 43 = 48 */

    /*48, 49, 50, 51, 52, 53 */
    -1, -1, -1, -1, -1, -1,
    /*97 - 43 = 54*/

    /*'a','b','c','d','e','f','g','h','i','j','k','l','m' */
    26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
    /*'n','o','p','q','r','s','t','u','v','w','x','y','z' */
    39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51]; // base58 characters (Bitcoin alphabet)

    var _base58 = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
    /**
     * Base64 encodes a 'binary' encoded string of bytes.
     *
     * @param input the binary encoded string of bytes to base64-encode.
     * @param maxline the maximum number of encoded characters per line to use,
     *          defaults to none.
     *
     * @return the base64-encoded output.
     */

    util.encode64 = function (input, maxline) {
      // TODO: deprecate: "Deprecated. Use util.binary.base64.encode instead."
      var line = '';
      var output = '';
      var chr1, chr2, chr3;
      var i = 0;

      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++); // encode 4 character group

        line += _base64.charAt(chr1 >> 2);
        line += _base64.charAt((chr1 & 3) << 4 | chr2 >> 4);

        if (isNaN(chr2)) {
          line += '==';
        } else {
          line += _base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
          line += isNaN(chr3) ? '=' : _base64.charAt(chr3 & 63);
        }

        if (maxline && line.length > maxline) {
          output += line.substr(0, maxline) + '\r\n';
          line = line.substr(maxline);
        }
      }

      output += line;
      return output;
    };
    /**
     * Base64 decodes a string into a 'binary' encoded string of bytes.
     *
     * @param input the base64-encoded input.
     *
     * @return the binary encoded string.
     */


    util.decode64 = function (input) {
      // TODO: deprecate: "Deprecated. Use util.binary.base64.decode instead."
      // remove all non-base64 characters
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
      var output = '';
      var enc1, enc2, enc3, enc4;
      var i = 0;

      while (i < input.length) {
        enc1 = _base64Idx[input.charCodeAt(i++) - 43];
        enc2 = _base64Idx[input.charCodeAt(i++) - 43];
        enc3 = _base64Idx[input.charCodeAt(i++) - 43];
        enc4 = _base64Idx[input.charCodeAt(i++) - 43];
        output += String.fromCharCode(enc1 << 2 | enc2 >> 4);

        if (enc3 !== 64) {
          // decoded at least 2 bytes
          output += String.fromCharCode((enc2 & 15) << 4 | enc3 >> 2);

          if (enc4 !== 64) {
            // decoded 3 bytes
            output += String.fromCharCode((enc3 & 3) << 6 | enc4);
          }
        }
      }

      return output;
    };
    /**
     * UTF-8 encodes the given UTF-16 encoded string (a standard JavaScript
     * string). Non-ASCII characters will be encoded as multiple bytes according
     * to UTF-8.
     *
     * @param str the string to encode.
     *
     * @return the UTF-8 encoded string.
     */


    util.encodeUtf8 = function (str) {
      return unescape(encodeURIComponent(str));
    };
    /**
     * Decodes a UTF-8 encoded string into a UTF-16 string.
     *
     * @param str the string to decode.
     *
     * @return the UTF-16 encoded string (standard JavaScript string).
     */


    util.decodeUtf8 = function (str) {
      return decodeURIComponent(escape(str));
    }; // binary encoding/decoding tools
    // FIXME: Experimental. Do not use yet.


    util.binary = {
      raw: {},
      hex: {},
      base64: {},
      base58: {},
      baseN: {
        encode: baseN.encode,
        decode: baseN.decode
      }
    };
    /**
     * Encodes a Uint8Array as a binary-encoded string. This encoding uses
     * a value between 0 and 255 for each character.
     *
     * @param bytes the Uint8Array to encode.
     *
     * @return the binary-encoded string.
     */

    util.binary.raw.encode = function (bytes) {
      return String.fromCharCode.apply(null, bytes);
    };
    /**
     * Decodes a binary-encoded string to a Uint8Array. This encoding uses
     * a value between 0 and 255 for each character.
     *
     * @param str the binary-encoded string to decode.
     * @param [output] an optional Uint8Array to write the output to; if it
     *          is too small, an exception will be thrown.
     * @param [offset] the start offset for writing to the output (default: 0).
     *
     * @return the Uint8Array or the number of bytes written if output was given.
     */


    util.binary.raw.decode = function (str, output, offset) {
      var out = output;

      if (!out) {
        out = new Uint8Array(str.length);
      }

      offset = offset || 0;
      var j = offset;

      for (var i = 0; i < str.length; ++i) {
        out[j++] = str.charCodeAt(i);
      }

      return output ? j - offset : out;
    };
    /**
     * Encodes a 'binary' string, ArrayBuffer, DataView, TypedArray, or
     * ByteBuffer as a string of hexadecimal characters.
     *
     * @param bytes the bytes to convert.
     *
     * @return the string of hexadecimal characters.
     */


    util.binary.hex.encode = util.bytesToHex;
    /**
     * Decodes a hex-encoded string to a Uint8Array.
     *
     * @param hex the hexadecimal string to convert.
     * @param [output] an optional Uint8Array to write the output to; if it
     *          is too small, an exception will be thrown.
     * @param [offset] the start offset for writing to the output (default: 0).
     *
     * @return the Uint8Array or the number of bytes written if output was given.
     */

    util.binary.hex.decode = function (hex, output, offset) {
      var out = output;

      if (!out) {
        out = new Uint8Array(Math.ceil(hex.length / 2));
      }

      offset = offset || 0;
      var i = 0,
          j = offset;

      if (hex.length & 1) {
        // odd number of characters, convert first character alone
        i = 1;
        out[j++] = parseInt(hex[0], 16);
      } // convert 2 characters (1 byte) at a time


      for (; i < hex.length; i += 2) {
        out[j++] = parseInt(hex.substr(i, 2), 16);
      }

      return output ? j - offset : out;
    };
    /**
     * Base64-encodes a Uint8Array.
     *
     * @param input the Uint8Array to encode.
     * @param maxline the maximum number of encoded characters per line to use,
     *          defaults to none.
     *
     * @return the base64-encoded output string.
     */


    util.binary.base64.encode = function (input, maxline) {
      var line = '';
      var output = '';
      var chr1, chr2, chr3;
      var i = 0;

      while (i < input.byteLength) {
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++]; // encode 4 character group

        line += _base64.charAt(chr1 >> 2);
        line += _base64.charAt((chr1 & 3) << 4 | chr2 >> 4);

        if (isNaN(chr2)) {
          line += '==';
        } else {
          line += _base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
          line += isNaN(chr3) ? '=' : _base64.charAt(chr3 & 63);
        }

        if (maxline && line.length > maxline) {
          output += line.substr(0, maxline) + '\r\n';
          line = line.substr(maxline);
        }
      }

      output += line;
      return output;
    };
    /**
     * Decodes a base64-encoded string to a Uint8Array.
     *
     * @param input the base64-encoded input string.
     * @param [output] an optional Uint8Array to write the output to; if it
     *          is too small, an exception will be thrown.
     * @param [offset] the start offset for writing to the output (default: 0).
     *
     * @return the Uint8Array or the number of bytes written if output was given.
     */


    util.binary.base64.decode = function (input, output, offset) {
      var out = output;

      if (!out) {
        out = new Uint8Array(Math.ceil(input.length / 4) * 3);
      } // remove all non-base64 characters


      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
      offset = offset || 0;
      var enc1, enc2, enc3, enc4;
      var i = 0,
          j = offset;

      while (i < input.length) {
        enc1 = _base64Idx[input.charCodeAt(i++) - 43];
        enc2 = _base64Idx[input.charCodeAt(i++) - 43];
        enc3 = _base64Idx[input.charCodeAt(i++) - 43];
        enc4 = _base64Idx[input.charCodeAt(i++) - 43];
        out[j++] = enc1 << 2 | enc2 >> 4;

        if (enc3 !== 64) {
          // decoded at least 2 bytes
          out[j++] = (enc2 & 15) << 4 | enc3 >> 2;

          if (enc4 !== 64) {
            // decoded 3 bytes
            out[j++] = (enc3 & 3) << 6 | enc4;
          }
        }
      } // make sure result is the exact decoded length


      return output ? j - offset : out.subarray(0, j);
    }; // add support for base58 encoding/decoding with Bitcoin alphabet


    util.binary.base58.encode = function (input, maxline) {
      return util.binary.baseN.encode(input, _base58, maxline);
    };

    util.binary.base58.decode = function (input, maxline) {
      return util.binary.baseN.decode(input, _base58, maxline);
    }; // text encoding/decoding tools
    // FIXME: Experimental. Do not use yet.


    util.text = {
      utf8: {},
      utf16: {}
    };
    /**
     * Encodes the given string as UTF-8 in a Uint8Array.
     *
     * @param str the string to encode.
     * @param [output] an optional Uint8Array to write the output to; if it
     *          is too small, an exception will be thrown.
     * @param [offset] the start offset for writing to the output (default: 0).
     *
     * @return the Uint8Array or the number of bytes written if output was given.
     */

    util.text.utf8.encode = function (str, output, offset) {
      str = util.encodeUtf8(str);
      var out = output;

      if (!out) {
        out = new Uint8Array(str.length);
      }

      offset = offset || 0;
      var j = offset;

      for (var i = 0; i < str.length; ++i) {
        out[j++] = str.charCodeAt(i);
      }

      return output ? j - offset : out;
    };
    /**
     * Decodes the UTF-8 contents from a Uint8Array.
     *
     * @param bytes the Uint8Array to decode.
     *
     * @return the resulting string.
     */


    util.text.utf8.decode = function (bytes) {
      return util.decodeUtf8(String.fromCharCode.apply(null, bytes));
    };
    /**
     * Encodes the given string as UTF-16 in a Uint8Array.
     *
     * @param str the string to encode.
     * @param [output] an optional Uint8Array to write the output to; if it
     *          is too small, an exception will be thrown.
     * @param [offset] the start offset for writing to the output (default: 0).
     *
     * @return the Uint8Array or the number of bytes written if output was given.
     */


    util.text.utf16.encode = function (str, output, offset) {
      var out = output;

      if (!out) {
        out = new Uint8Array(str.length * 2);
      }

      var view = new Uint16Array(out.buffer);
      offset = offset || 0;
      var j = offset;
      var k = offset;

      for (var i = 0; i < str.length; ++i) {
        view[k++] = str.charCodeAt(i);
        j += 2;
      }

      return output ? j - offset : out;
    };
    /**
     * Decodes the UTF-16 contents from a Uint8Array.
     *
     * @param bytes the Uint8Array to decode.
     *
     * @return the resulting string.
     */


    util.text.utf16.decode = function (bytes) {
      return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
    };
    /**
     * Deflates the given data using a flash interface.
     *
     * @param api the flash interface.
     * @param bytes the data.
     * @param raw true to return only raw deflate data, false to include zlib
     *          header and trailer.
     *
     * @return the deflated data as a string.
     */


    util.deflate = function (api, bytes, raw) {
      bytes = util.decode64(api.deflate(util.encode64(bytes)).rval); // strip zlib header and trailer if necessary

      if (raw) {
        // zlib header is 2 bytes (CMF,FLG) where FLG indicates that
        // there is a 4-byte DICT (alder-32) block before the data if
        // its 5th bit is set
        var start = 2;
        var flg = bytes.charCodeAt(1);

        if (flg & 0x20) {
          start = 6;
        } // zlib trailer is 4 bytes of adler-32


        bytes = bytes.substring(start, bytes.length - 4);
      }

      return bytes;
    };
    /**
     * Inflates the given data using a flash interface.
     *
     * @param api the flash interface.
     * @param bytes the data.
     * @param raw true if the incoming data has no zlib header or trailer and is
     *          raw DEFLATE data.
     *
     * @return the inflated data as a string, null on error.
     */


    util.inflate = function (api, bytes, raw) {
      // TODO: add zlib header and trailer if necessary/possible
      var rval = api.inflate(util.encode64(bytes)).rval;
      return rval === null ? null : util.decode64(rval);
    };
    /**
     * Sets a storage object.
     *
     * @param api the storage interface.
     * @param id the storage ID to use.
     * @param obj the storage object, null to remove.
     */


    var _setStorageObject = function _setStorageObject(api, id, obj) {
      if (!api) {
        throw new Error('WebStorage not available.');
      }

      var rval;

      if (obj === null) {
        rval = api.removeItem(id);
      } else {
        // json-encode and base64-encode object
        obj = util.encode64(JSON.stringify(obj));
        rval = api.setItem(id, obj);
      } // handle potential flash error


      if (typeof rval !== 'undefined' && rval.rval !== true) {
        var error = new Error(rval.error.message);
        error.id = rval.error.id;
        error.name = rval.error.name;
        throw error;
      }
    };
    /**
     * Gets a storage object.
     *
     * @param api the storage interface.
     * @param id the storage ID to use.
     *
     * @return the storage object entry or null if none exists.
     */


    var _getStorageObject = function _getStorageObject(api, id) {
      if (!api) {
        throw new Error('WebStorage not available.');
      } // get the existing entry


      var rval = api.getItem(id);
      /* Note: We check api.init because we can't do (api == localStorage)
        on IE because of "Class doesn't support Automation" exception. Only
        the flash api has an init method so this works too, but we need a
        better solution in the future. */
      // flash returns item wrapped in an object, handle special case

      if (api.init) {
        if (rval.rval === null) {
          if (rval.error) {
            var error = new Error(rval.error.message);
            error.id = rval.error.id;
            error.name = rval.error.name;
            throw error;
          } // no error, but also no item


          rval = null;
        } else {
          rval = rval.rval;
        }
      } // handle decoding


      if (rval !== null) {
        // base64-decode and json-decode data
        rval = JSON.parse(util.decode64(rval));
      }

      return rval;
    };
    /**
     * Stores an item in local storage.
     *
     * @param api the storage interface.
     * @param id the storage ID to use.
     * @param key the key for the item.
     * @param data the data for the item (any javascript object/primitive).
     */


    var _setItem = function _setItem(api, id, key, data) {
      // get storage object
      var obj = _getStorageObject(api, id);

      if (obj === null) {
        // create a new storage object
        obj = {};
      } // update key


      obj[key] = data; // set storage object

      _setStorageObject(api, id, obj);
    };
    /**
     * Gets an item from local storage.
     *
     * @param api the storage interface.
     * @param id the storage ID to use.
     * @param key the key for the item.
     *
     * @return the item.
     */


    var _getItem = function _getItem(api, id, key) {
      // get storage object
      var rval = _getStorageObject(api, id);

      if (rval !== null) {
        // return data at key
        rval = key in rval ? rval[key] : null;
      }

      return rval;
    };
    /**
     * Removes an item from local storage.
     *
     * @param api the storage interface.
     * @param id the storage ID to use.
     * @param key the key for the item.
     */


    var _removeItem = function _removeItem(api, id, key) {
      // get storage object
      var obj = _getStorageObject(api, id);

      if (obj !== null && key in obj) {
        // remove key
        delete obj[key]; // see if entry has no keys remaining

        var empty = true;

        for (var prop in obj) {
          empty = false;
          break;
        }

        if (empty) {
          // remove entry entirely if no keys are left
          obj = null;
        } // set storage object


        _setStorageObject(api, id, obj);
      }
    };
    /**
     * Clears the local disk storage identified by the given ID.
     *
     * @param api the storage interface.
     * @param id the storage ID to use.
     */


    var _clearItems = function _clearItems(api, id) {
      _setStorageObject(api, id, null);
    };
    /**
     * Calls a storage function.
     *
     * @param func the function to call.
     * @param args the arguments for the function.
     * @param location the location argument.
     *
     * @return the return value from the function.
     */


    var _callStorageFunction = function _callStorageFunction(func, args, location) {
      var rval = null; // default storage types

      if (typeof location === 'undefined') {
        location = ['web', 'flash'];
      } // apply storage types in order of preference


      var type;
      var done = false;
      var exception = null;

      for (var idx in location) {
        type = location[idx];

        try {
          if (type === 'flash' || type === 'both') {
            if (args[0] === null) {
              throw new Error('Flash local storage not available.');
            }

            rval = func.apply(this, args);
            done = type === 'flash';
          }

          if (type === 'web' || type === 'both') {
            args[0] = localStorage;
            rval = func.apply(this, args);
            done = true;
          }
        } catch (ex) {
          exception = ex;
        }

        if (done) {
          break;
        }
      }

      if (!done) {
        throw exception;
      }

      return rval;
    };
    /**
     * Stores an item on local disk.
     *
     * The available types of local storage include 'flash', 'web', and 'both'.
     *
     * The type 'flash' refers to flash local storage (SharedObject). In order
     * to use flash local storage, the 'api' parameter must be valid. The type
     * 'web' refers to WebStorage, if supported by the browser. The type 'both'
     * refers to storing using both 'flash' and 'web', not just one or the
     * other.
     *
     * The location array should list the storage types to use in order of
     * preference:
     *
     * ['flash']: flash only storage
     * ['web']: web only storage
     * ['both']: try to store in both
     * ['flash','web']: store in flash first, but if not available, 'web'
     * ['web','flash']: store in web first, but if not available, 'flash'
     *
     * The location array defaults to: ['web', 'flash']
     *
     * @param api the flash interface, null to use only WebStorage.
     * @param id the storage ID to use.
     * @param key the key for the item.
     * @param data the data for the item (any javascript object/primitive).
     * @param location an array with the preferred types of storage to use.
     */


    util.setItem = function (api, id, key, data, location) {
      _callStorageFunction(_setItem, arguments, location);
    };
    /**
     * Gets an item on local disk.
     *
     * Set setItem() for details on storage types.
     *
     * @param api the flash interface, null to use only WebStorage.
     * @param id the storage ID to use.
     * @param key the key for the item.
     * @param location an array with the preferred types of storage to use.
     *
     * @return the item.
     */


    util.getItem = function (api, id, key, location) {
      return _callStorageFunction(_getItem, arguments, location);
    };
    /**
     * Removes an item on local disk.
     *
     * Set setItem() for details on storage types.
     *
     * @param api the flash interface.
     * @param id the storage ID to use.
     * @param key the key for the item.
     * @param location an array with the preferred types of storage to use.
     */


    util.removeItem = function (api, id, key, location) {
      _callStorageFunction(_removeItem, arguments, location);
    };
    /**
     * Clears the local disk storage identified by the given ID.
     *
     * Set setItem() for details on storage types.
     *
     * @param api the flash interface if flash is available.
     * @param id the storage ID to use.
     * @param location an array with the preferred types of storage to use.
     */


    util.clearItems = function (api, id, location) {
      _callStorageFunction(_clearItems, arguments, location);
    };
    /**
     * Parses the scheme, host, and port from an http(s) url.
     *
     * @param str the url string.
     *
     * @return the parsed url object or null if the url is invalid.
     */


    util.parseUrl = function (str) {
      // FIXME: this regex looks a bit broken
      var regex = /^(https?):\/\/([^:&^\/]*):?(\d*)(.*)$/g;
      regex.lastIndex = 0;
      var m = regex.exec(str);
      var url = m === null ? null : {
        full: str,
        scheme: m[1],
        host: m[2],
        port: m[3],
        path: m[4]
      };

      if (url) {
        url.fullHost = url.host;

        if (url.port) {
          if (url.port !== 80 && url.scheme === 'http') {
            url.fullHost += ':' + url.port;
          } else if (url.port !== 443 && url.scheme === 'https') {
            url.fullHost += ':' + url.port;
          }
        } else if (url.scheme === 'http') {
          url.port = 80;
        } else if (url.scheme === 'https') {
          url.port = 443;
        }

        url.full = url.scheme + '://' + url.fullHost;
      }

      return url;
    };
    /* Storage for query variables */


    var _queryVariables = null;
    /**
     * Returns the window location query variables. Query is parsed on the first
     * call and the same object is returned on subsequent calls. The mapping
     * is from keys to an array of values. Parameters without values will have
     * an object key set but no value added to the value array. Values are
     * unescaped.
     *
     * ...?k1=v1&k2=v2:
     * {
     *   "k1": ["v1"],
     *   "k2": ["v2"]
     * }
     *
     * ...?k1=v1&k1=v2:
     * {
     *   "k1": ["v1", "v2"]
     * }
     *
     * ...?k1=v1&k2:
     * {
     *   "k1": ["v1"],
     *   "k2": []
     * }
     *
     * ...?k1=v1&k1:
     * {
     *   "k1": ["v1"]
     * }
     *
     * ...?k1&k1:
     * {
     *   "k1": []
     * }
     *
     * @param query the query string to parse (optional, default to cached
     *          results from parsing window location search query).
     *
     * @return object mapping keys to variables.
     */

    util.getQueryVariables = function (query) {
      var parse = function parse(q) {
        var rval = {};
        var kvpairs = q.split('&');

        for (var i = 0; i < kvpairs.length; i++) {
          var pos = kvpairs[i].indexOf('=');
          var key;
          var val;

          if (pos > 0) {
            key = kvpairs[i].substring(0, pos);
            val = kvpairs[i].substring(pos + 1);
          } else {
            key = kvpairs[i];
            val = null;
          }

          if (!(key in rval)) {
            rval[key] = [];
          } // disallow overriding object prototype keys


          if (!(key in Object.prototype) && val !== null) {
            rval[key].push(unescape(val));
          }
        }

        return rval;
      };

      var rval;

      if (typeof query === 'undefined') {
        // set cached variables if needed
        if (_queryVariables === null) {
          if (typeof window !== 'undefined' && window.location && window.location.search) {
            // parse window search query
            _queryVariables = parse(window.location.search.substring(1));
          } else {
            // no query variables available
            _queryVariables = {};
          }
        }

        rval = _queryVariables;
      } else {
        // parse given query
        rval = parse(query);
      }

      return rval;
    };
    /**
     * Parses a fragment into a path and query. This method will take a URI
     * fragment and break it up as if it were the main URI. For example:
     *    /bar/baz?a=1&b=2
     * results in:
     *    {
     *       path: ["bar", "baz"],
     *       query: {"k1": ["v1"], "k2": ["v2"]}
     *    }
     *
     * @return object with a path array and query object.
     */


    util.parseFragment = function (fragment) {
      // default to whole fragment
      var fp = fragment;
      var fq = ''; // split into path and query if possible at the first '?'

      var pos = fragment.indexOf('?');

      if (pos > 0) {
        fp = fragment.substring(0, pos);
        fq = fragment.substring(pos + 1);
      } // split path based on '/' and ignore first element if empty


      var path = fp.split('/');

      if (path.length > 0 && path[0] === '') {
        path.shift();
      } // convert query into object


      var query = fq === '' ? {} : util.getQueryVariables(fq);
      return {
        pathString: fp,
        queryString: fq,
        path: path,
        query: query
      };
    };
    /**
     * Makes a request out of a URI-like request string. This is intended to
     * be used where a fragment id (after a URI '#') is parsed as a URI with
     * path and query parts. The string should have a path beginning and
     * delimited by '/' and optional query parameters following a '?'. The
     * query should be a standard URL set of key value pairs delimited by
     * '&'. For backwards compatibility the initial '/' on the path is not
     * required. The request object has the following API, (fully described
     * in the method code):
     *    {
     *       path: <the path string part>.
     *       query: <the query string part>,
     *       getPath(i): get part or all of the split path array,
     *       getQuery(k, i): get part or all of a query key array,
     *       getQueryLast(k, _default): get last element of a query key array.
     *    }
     *
     * @return object with request parameters.
     */


    util.makeRequest = function (reqString) {
      var frag = util.parseFragment(reqString);
      var req = {
        // full path string
        path: frag.pathString,
        // full query string
        query: frag.queryString,

        /**
         * Get path or element in path.
         *
         * @param i optional path index.
         *
         * @return path or part of path if i provided.
         */
        getPath: function getPath(i) {
          return typeof i === 'undefined' ? frag.path : frag.path[i];
        },

        /**
         * Get query, values for a key, or value for a key index.
         *
         * @param k optional query key.
         * @param i optional query key index.
         *
         * @return query, values for a key, or value for a key index.
         */
        getQuery: function getQuery(k, i) {
          var rval;

          if (typeof k === 'undefined') {
            rval = frag.query;
          } else {
            rval = frag.query[k];

            if (rval && typeof i !== 'undefined') {
              rval = rval[i];
            }
          }

          return rval;
        },
        getQueryLast: function getQueryLast(k, _default) {
          var rval;
          var vals = req.getQuery(k);

          if (vals) {
            rval = vals[vals.length - 1];
          } else {
            rval = _default;
          }

          return rval;
        }
      };
      return req;
    };
    /**
     * Makes a URI out of a path, an object with query parameters, and a
     * fragment. Uses jQuery.param() internally for query string creation.
     * If the path is an array, it will be joined with '/'.
     *
     * @param path string path or array of strings.
     * @param query object with query parameters. (optional)
     * @param fragment fragment string. (optional)
     *
     * @return string object with request parameters.
     */


    util.makeLink = function (path, query, fragment) {
      // join path parts if needed
      path = jQuery.isArray(path) ? path.join('/') : path;
      var qstr = jQuery.param(query || {});
      fragment = fragment || '';
      return path + (qstr.length > 0 ? '?' + qstr : '') + (fragment.length > 0 ? '#' + fragment : '');
    };
    /**
     * Follows a path of keys deep into an object hierarchy and set a value.
     * If a key does not exist or it's value is not an object, create an
     * object in it's place. This can be destructive to a object tree if
     * leaf nodes are given as non-final path keys.
     * Used to avoid exceptions from missing parts of the path.
     *
     * @param object the starting object.
     * @param keys an array of string keys.
     * @param value the value to set.
     */


    util.setPath = function (object, keys, value) {
      // need to start at an object
      if (typeof object === 'object' && object !== null) {
        var i = 0;
        var len = keys.length;

        while (i < len) {
          var next = keys[i++];

          if (i == len) {
            // last
            object[next] = value;
          } else {
            // more
            var hasNext = next in object;

            if (!hasNext || hasNext && typeof object[next] !== 'object' || hasNext && object[next] === null) {
              object[next] = {};
            }

            object = object[next];
          }
        }
      }
    };
    /**
     * Follows a path of keys deep into an object hierarchy and return a value.
     * If a key does not exist, create an object in it's place.
     * Used to avoid exceptions from missing parts of the path.
     *
     * @param object the starting object.
     * @param keys an array of string keys.
     * @param _default value to return if path not found.
     *
     * @return the value at the path if found, else default if given, else
     *         undefined.
     */


    util.getPath = function (object, keys, _default) {
      var i = 0;
      var len = keys.length;
      var hasNext = true;

      while (hasNext && i < len && typeof object === 'object' && object !== null) {
        var next = keys[i++];
        hasNext = next in object;

        if (hasNext) {
          object = object[next];
        }
      }

      return hasNext ? object : _default;
    };
    /**
     * Follow a path of keys deep into an object hierarchy and delete the
     * last one. If a key does not exist, do nothing.
     * Used to avoid exceptions from missing parts of the path.
     *
     * @param object the starting object.
     * @param keys an array of string keys.
     */


    util.deletePath = function (object, keys) {
      // need to start at an object
      if (typeof object === 'object' && object !== null) {
        var i = 0;
        var len = keys.length;

        while (i < len) {
          var next = keys[i++];

          if (i == len) {
            // last
            delete object[next];
          } else {
            // more
            if (!(next in object) || typeof object[next] !== 'object' || object[next] === null) {
              break;
            }

            object = object[next];
          }
        }
      }
    };
    /**
     * Check if an object is empty.
     *
     * Taken from:
     * http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object-from-json/679937#679937
     *
     * @param object the object to check.
     */


    util.isEmpty = function (obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false;
        }
      }

      return true;
    };
    /**
     * Format with simple printf-style interpolation.
     *
     * %%: literal '%'
     * %s,%o: convert next argument into a string.
     *
     * @param format the string to format.
     * @param ... arguments to interpolate into the format string.
     */


    util.format = function (format) {
      var re = /%./g; // current match

      var match; // current part

      var part; // current arg index

      var argi = 0; // collected parts to recombine later

      var parts = []; // last index found

      var last = 0; // loop while matches remain

      while (match = re.exec(format)) {
        part = format.substring(last, re.lastIndex - 2); // don't add empty strings (ie, parts between %s%s)

        if (part.length > 0) {
          parts.push(part);
        }

        last = re.lastIndex; // switch on % code

        var code = match[0][1];

        switch (code) {
          case 's':
          case 'o':
            // check if enough arguments were given
            if (argi < arguments.length) {
              parts.push(arguments[argi++ + 1]);
            } else {
              parts.push('<?>');
            }

            break;
          // FIXME: do proper formating for numbers, etc
          //case 'f':
          //case 'd':

          case '%':
            parts.push('%');
            break;

          default:
            parts.push('<%' + code + '?>');
        }
      } // add trailing part of format string


      parts.push(format.substring(last));
      return parts.join('');
    };
    /**
     * Formats a number.
     *
     * http://snipplr.com/view/5945/javascript-numberformat--ported-from-php/
     */


    util.formatNumber = function (number, decimals, dec_point, thousands_sep) {
      // http://kevin.vanzonneveld.net
      // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
      // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // +     bugfix by: Michael White (http://crestidg.com)
      // +     bugfix by: Benjamin Lupton
      // +     bugfix by: Allan Jensen (http://www.winternet.no)
      // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
      // *     example 1: number_format(1234.5678, 2, '.', '');
      // *     returns 1: 1234.57
      var n = number,
          c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
      var d = dec_point === undefined ? ',' : dec_point;
      var t = thousands_sep === undefined ? '.' : thousands_sep,
          s = n < 0 ? '-' : '';
      var i = parseInt(n = Math.abs(+n || 0).toFixed(c), 10) + '';
      var j = i.length > 3 ? i.length % 3 : 0;
      return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
    };
    /**
     * Formats a byte size.
     *
     * http://snipplr.com/view/5949/format-humanize-file-byte-size-presentation-in-javascript/
     */


    util.formatSize = function (size) {
      if (size >= 1073741824) {
        size = util.formatNumber(size / 1073741824, 2, '.', '') + ' GiB';
      } else if (size >= 1048576) {
        size = util.formatNumber(size / 1048576, 2, '.', '') + ' MiB';
      } else if (size >= 1024) {
        size = util.formatNumber(size / 1024, 0) + ' KiB';
      } else {
        size = util.formatNumber(size, 0) + ' bytes';
      }

      return size;
    };
    /**
     * Converts an IPv4 or IPv6 string representation into bytes (in network order).
     *
     * @param ip the IPv4 or IPv6 address to convert.
     *
     * @return the 4-byte IPv6 or 16-byte IPv6 address or null if the address can't
     *         be parsed.
     */


    util.bytesFromIP = function (ip) {
      if (ip.indexOf('.') !== -1) {
        return util.bytesFromIPv4(ip);
      }

      if (ip.indexOf(':') !== -1) {
        return util.bytesFromIPv6(ip);
      }

      return null;
    };
    /**
     * Converts an IPv4 string representation into bytes (in network order).
     *
     * @param ip the IPv4 address to convert.
     *
     * @return the 4-byte address or null if the address can't be parsed.
     */


    util.bytesFromIPv4 = function (ip) {
      ip = ip.split('.');

      if (ip.length !== 4) {
        return null;
      }

      var b = util.createBuffer();

      for (var i = 0; i < ip.length; ++i) {
        var num = parseInt(ip[i], 10);

        if (isNaN(num)) {
          return null;
        }

        b.putByte(num);
      }

      return b.getBytes();
    };
    /**
     * Converts an IPv6 string representation into bytes (in network order).
     *
     * @param ip the IPv6 address to convert.
     *
     * @return the 16-byte address or null if the address can't be parsed.
     */


    util.bytesFromIPv6 = function (ip) {
      var blanks = 0;
      ip = ip.split(':').filter(function (e) {
        if (e.length === 0) ++blanks;
        return true;
      });
      var zeros = (8 - ip.length + blanks) * 2;
      var b = util.createBuffer();

      for (var i = 0; i < 8; ++i) {
        if (!ip[i] || ip[i].length === 0) {
          b.fillWithByte(0, zeros);
          zeros = 0;
          continue;
        }

        var bytes = util.hexToBytes(ip[i]);

        if (bytes.length < 2) {
          b.putByte(0);
        }

        b.putBytes(bytes);
      }

      return b.getBytes();
    };
    /**
     * Converts 4-bytes into an IPv4 string representation or 16-bytes into
     * an IPv6 string representation. The bytes must be in network order.
     *
     * @param bytes the bytes to convert.
     *
     * @return the IPv4 or IPv6 string representation if 4 or 16 bytes,
     *         respectively, are given, otherwise null.
     */


    util.bytesToIP = function (bytes) {
      if (bytes.length === 4) {
        return util.bytesToIPv4(bytes);
      }

      if (bytes.length === 16) {
        return util.bytesToIPv6(bytes);
      }

      return null;
    };
    /**
     * Converts 4-bytes into an IPv4 string representation. The bytes must be
     * in network order.
     *
     * @param bytes the bytes to convert.
     *
     * @return the IPv4 string representation or null for an invalid # of bytes.
     */


    util.bytesToIPv4 = function (bytes) {
      if (bytes.length !== 4) {
        return null;
      }

      var ip = [];

      for (var i = 0; i < bytes.length; ++i) {
        ip.push(bytes.charCodeAt(i));
      }

      return ip.join('.');
    };
    /**
     * Converts 16-bytes into an IPv16 string representation. The bytes must be
     * in network order.
     *
     * @param bytes the bytes to convert.
     *
     * @return the IPv16 string representation or null for an invalid # of bytes.
     */


    util.bytesToIPv6 = function (bytes) {
      if (bytes.length !== 16) {
        return null;
      }

      var ip = [];
      var zeroGroups = [];
      var zeroMaxGroup = 0;

      for (var i = 0; i < bytes.length; i += 2) {
        var hex = util.bytesToHex(bytes[i] + bytes[i + 1]); // canonicalize zero representation

        while (hex[0] === '0' && hex !== '0') {
          hex = hex.substr(1);
        }

        if (hex === '0') {
          var last = zeroGroups[zeroGroups.length - 1];
          var idx = ip.length;

          if (!last || idx !== last.end + 1) {
            zeroGroups.push({
              start: idx,
              end: idx
            });
          } else {
            last.end = idx;

            if (last.end - last.start > zeroGroups[zeroMaxGroup].end - zeroGroups[zeroMaxGroup].start) {
              zeroMaxGroup = zeroGroups.length - 1;
            }
          }
        }

        ip.push(hex);
      }

      if (zeroGroups.length > 0) {
        var group = zeroGroups[zeroMaxGroup]; // only shorten group of length > 0

        if (group.end - group.start > 0) {
          ip.splice(group.start, group.end - group.start + 1, '');

          if (group.start === 0) {
            ip.unshift('');
          }

          if (group.end === 7) {
            ip.push('');
          }
        }
      }

      return ip.join(':');
    };
    /**
     * Estimates the number of processes that can be run concurrently. If
     * creating Web Workers, keep in mind that the main JavaScript process needs
     * its own core.
     *
     * @param options the options to use:
     *          update true to force an update (not use the cached value).
     * @param callback(err, max) called once the operation completes.
     */


    util.estimateCores = function (options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      options = options || {};

      if ('cores' in util && !options.update) {
        return callback(null, util.cores);
      }

      if (typeof navigator !== 'undefined' && 'hardwareConcurrency' in navigator && navigator.hardwareConcurrency > 0) {
        util.cores = navigator.hardwareConcurrency;
        return callback(null, util.cores);
      }

      if (typeof Worker === 'undefined') {
        // workers not available
        util.cores = 1;
        return callback(null, util.cores);
      }

      if (typeof Blob === 'undefined') {
        // can't estimate, default to 2
        util.cores = 2;
        return callback(null, util.cores);
      } // create worker concurrency estimation code as blob


      var blobUrl = URL.createObjectURL(new Blob(['(', function () {
        self.addEventListener('message', function (e) {
          // run worker for 4 ms
          var st = Date.now();
          var et = st + 4;

          while (Date.now() < et) {
            ;
          }

          self.postMessage({
            st: st,
            et: et
          });
        });
      }.toString(), ')()'], {
        type: 'application/javascript'
      })); // take 5 samples using 16 workers

      sample([], 5, 16);

      function sample(max, samples, numWorkers) {
        if (samples === 0) {
          // get overlap average
          var avg = Math.floor(max.reduce(function (avg, x) {
            return avg + x;
          }, 0) / max.length);
          util.cores = Math.max(1, avg);
          URL.revokeObjectURL(blobUrl);
          return callback(null, util.cores);
        }

        map(numWorkers, function (err, results) {
          max.push(reduce(numWorkers, results));
          sample(max, samples - 1, numWorkers);
        });
      }

      function map(numWorkers, callback) {
        var workers = [];
        var results = [];

        for (var i = 0; i < numWorkers; ++i) {
          var worker = new Worker(blobUrl);
          worker.addEventListener('message', function (e) {
            results.push(e.data);

            if (results.length === numWorkers) {
              for (var i = 0; i < numWorkers; ++i) {
                workers[i].terminate();
              }

              callback(null, results);
            }
          });
          workers.push(worker);
        }

        for (var i = 0; i < numWorkers; ++i) {
          workers[i].postMessage(i);
        }
      }

      function reduce(numWorkers, results) {
        // find overlapping time windows
        var overlaps = [];

        for (var n = 0; n < numWorkers; ++n) {
          var r1 = results[n];
          var overlap = overlaps[n] = [];

          for (var i = 0; i < numWorkers; ++i) {
            if (n === i) {
              continue;
            }

            var r2 = results[i];

            if (r1.st > r2.st && r1.st < r2.et || r2.st > r1.st && r2.st < r1.et) {
              overlap.push(i);
            }
          }
        } // get maximum overlaps ... don't include overlapping worker itself
        // as the main JS process was also being scheduled during the work and
        // would have to be subtracted from the estimate anyway


        return overlaps.reduce(function (max, overlap) {
          return Math.max(max, overlap.length);
        }, 0);
      }
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(16), __webpack_require__(247).setImmediate, __webpack_require__(1).Buffer);
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  var store = __webpack_require__(97)('wks');

  var uid = __webpack_require__(59);

  var Symbol = __webpack_require__(3).Symbol;

  var USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
  };

  $exports.store = store;
  /***/
},
/* 10 */

/***/
function (module, exports) {
  var g; // This works in non-strict mode

  g = function () {
    return this;
  }();

  try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
  } catch (e) {
    // This works if the window reference is available
    if (typeof window === "object") g = window;
  } // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}


  module.exports = g;
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  // Thank's IE8 for his funny defineProperty
  module.exports = !__webpack_require__(5)(function () {
    return Object.defineProperty({}, 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  /***/
},
/* 12 */

/***/
function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(2);

  var IE8_DOM_DEFINE = __webpack_require__(172);

  var toPrimitive = __webpack_require__(36);

  var dP = Object.defineProperty;
  exports.f = __webpack_require__(11) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
      return dP(O, P, Attributes);
    } catch (e) {
      /* empty */
    }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };
  /***/
},
/* 13 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.15 ToLength
  var toInteger = __webpack_require__(35);

  var min = Math.min;

  module.exports = function (it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };
  /***/

},
/* 14 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * deps/forge.js - Forge Package Customization
   *
   * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
   */

  var forge = __webpack_require__(6);

  __webpack_require__(79);

  __webpack_require__(46);

  __webpack_require__(143);

  __webpack_require__(145);

  __webpack_require__(224);

  __webpack_require__(146);

  __webpack_require__(80);

  __webpack_require__(226);

  __webpack_require__(542);

  __webpack_require__(543);

  __webpack_require__(228);

  __webpack_require__(229);

  __webpack_require__(147);

  __webpack_require__(47);

  __webpack_require__(148);

  __webpack_require__(230);

  __webpack_require__(545);

  __webpack_require__(8); // Define AES "raw" cipher mode


  function modeRaw(options) {
    options = options || {};
    this.name = "";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._blocks = this.blockSize / 4;
    this._inBlock = new Array(this._blocks);
    this._outBlock = new Array(this._blocks);
  }

  modeRaw.prototype.start = function () {};

  modeRaw.prototype.encrypt = function (input, output, finish) {
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) {
      return true;
    }

    var i; // get next block

    for (i = 0; i < this._blocks; ++i) {
      this._inBlock[i] = input.getInt32();
    } // encrypt block


    this.cipher.encrypt(this._inBlock, this._outBlock); // write output

    for (i = 0; i < this._blocks; ++i) {
      output.putInt32(this._outBlock[i]);
    }
  };

  modeRaw.prototype.decrypt = function (input, output, finish) {
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) {
      return true;
    }

    var i; // get next block

    for (i = 0; i < this._blocks; ++i) {
      this._inBlock[i] = input.getInt32();
    } // decrypt block


    this.cipher.decrypt(this._inBlock, this._outBlock); // write output

    for (i = 0; i < this._blocks; ++i) {
      output.putInt32(this._outBlock[i]);
    }
  };

  (function () {
    var name = "AES",
        mode = modeRaw,
        factory;

    factory = function factory() {
      return new forge.aes.Algorithm(name, mode);
    };

    forge.cipher.registerAlgorithm(name, factory);
  })();

  module.exports = forge;
  /***/
},
/* 15 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.13 ToObject(argument)
  var defined = __webpack_require__(33);

  module.exports = function (it) {
    return Object(defined(it));
  };
  /***/

},
/* 16 */

/***/
function (module, exports) {
  // shim for using process in browser
  var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.

  var cachedSetTimeout;
  var cachedClearTimeout;

  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }

  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }

  (function () {
    try {
      if (typeof setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      } else {
        cachedSetTimeout = defaultSetTimout;
      }
    } catch (e) {
      cachedSetTimeout = defaultSetTimout;
    }

    try {
      if (typeof clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      } else {
        cachedClearTimeout = defaultClearTimeout;
      }
    } catch (e) {
      cachedClearTimeout = defaultClearTimeout;
    }
  })();

  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    } // if setTimeout wasn't available but was latter defined


    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }

  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    } // if clearTimeout wasn't available but was latter defined


    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }

  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }

    draining = false;

    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }

    if (queue.length) {
      drainQueue();
    }
  }

  function drainQueue() {
    if (draining) {
      return;
    }

    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;

    while (len) {
      currentQueue = queue;
      queue = [];

      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }

      queueIndex = -1;
      len = queue.length;
    }

    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }

  process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);

    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }

    queue.push(new Item(fun, args));

    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  }; // v8 likes predictible objects


  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }

  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues

  process.versions = {};

  function noop() {}

  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;

  process.listeners = function (name) {
    return [];
  };

  process.binding = function (name) {
    throw new Error('process.binding is not supported');
  };

  process.cwd = function () {
    return '/';
  };

  process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
  };

  process.umask = function () {
    return 0;
  };
  /***/

},
/* 17 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /**
     * Cipher core components.
     */
    CryptoJS.lib.Cipher || function (undefined) {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var Base = C_lib.Base;
      var WordArray = C_lib.WordArray;
      var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
      var C_enc = C.enc;
      var Utf8 = C_enc.Utf8;
      var Base64 = C_enc.Base64;
      var C_algo = C.algo;
      var EvpKDF = C_algo.EvpKDF;
      /**
       * Abstract base cipher template.
       *
       * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
       * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
       * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
       * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
       */

      var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
        /**
         * Configuration options.
         *
         * @property {WordArray} iv The IV to use for this operation.
         */
        cfg: Base.extend(),

        /**
         * Creates this cipher in encryption mode.
         *
         * @param {WordArray} key The key.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {Cipher} A cipher instance.
         *
         * @static
         *
         * @example
         *
         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
         */
        createEncryptor: function createEncryptor(key, cfg) {
          return this.create(this._ENC_XFORM_MODE, key, cfg);
        },

        /**
         * Creates this cipher in decryption mode.
         *
         * @param {WordArray} key The key.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {Cipher} A cipher instance.
         *
         * @static
         *
         * @example
         *
         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
         */
        createDecryptor: function createDecryptor(key, cfg) {
          return this.create(this._DEC_XFORM_MODE, key, cfg);
        },

        /**
         * Initializes a newly created cipher.
         *
         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
         * @param {WordArray} key The key.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @example
         *
         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
         */
        init: function init(xformMode, key, cfg) {
          // Apply config defaults
          this.cfg = this.cfg.extend(cfg); // Store transform mode and key

          this._xformMode = xformMode;
          this._key = key; // Set initial values

          this.reset();
        },

        /**
         * Resets this cipher to its initial state.
         *
         * @example
         *
         *     cipher.reset();
         */
        reset: function reset() {
          // Reset data buffer
          BufferedBlockAlgorithm.reset.call(this); // Perform concrete-cipher logic

          this._doReset();
        },

        /**
         * Adds data to be encrypted or decrypted.
         *
         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
         *
         * @return {WordArray} The data after processing.
         *
         * @example
         *
         *     var encrypted = cipher.process('data');
         *     var encrypted = cipher.process(wordArray);
         */
        process: function process(dataUpdate) {
          // Append
          this._append(dataUpdate); // Process available blocks


          return this._process();
        },

        /**
         * Finalizes the encryption or decryption process.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
         *
         * @return {WordArray} The data after final processing.
         *
         * @example
         *
         *     var encrypted = cipher.finalize();
         *     var encrypted = cipher.finalize('data');
         *     var encrypted = cipher.finalize(wordArray);
         */
        finalize: function finalize(dataUpdate) {
          // Final data update
          if (dataUpdate) {
            this._append(dataUpdate);
          } // Perform concrete-cipher logic


          var finalProcessedData = this._doFinalize();

          return finalProcessedData;
        },
        keySize: 128 / 32,
        ivSize: 128 / 32,
        _ENC_XFORM_MODE: 1,
        _DEC_XFORM_MODE: 2,

        /**
         * Creates shortcut functions to a cipher's object interface.
         *
         * @param {Cipher} cipher The cipher to create a helper for.
         *
         * @return {Object} An object with encrypt and decrypt shortcut functions.
         *
         * @static
         *
         * @example
         *
         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
         */
        _createHelper: function () {
          function selectCipherStrategy(key) {
            if (typeof key == 'string') {
              return PasswordBasedCipher;
            } else {
              return SerializableCipher;
            }
          }

          return function (cipher) {
            return {
              encrypt: function encrypt(message, key, cfg) {
                return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
              },
              decrypt: function decrypt(ciphertext, key, cfg) {
                return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
              }
            };
          };
        }()
      });
      /**
       * Abstract base stream cipher template.
       *
       * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
       */

      var StreamCipher = C_lib.StreamCipher = Cipher.extend({
        _doFinalize: function _doFinalize() {
          // Process partial blocks
          var finalProcessedBlocks = this._process(!!'flush');

          return finalProcessedBlocks;
        },
        blockSize: 1
      });
      /**
       * Mode namespace.
       */

      var C_mode = C.mode = {};
      /**
       * Abstract base block cipher mode template.
       */

      var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
        /**
         * Creates this mode for encryption.
         *
         * @param {Cipher} cipher A block cipher instance.
         * @param {Array} iv The IV words.
         *
         * @static
         *
         * @example
         *
         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
         */
        createEncryptor: function createEncryptor(cipher, iv) {
          return this.Encryptor.create(cipher, iv);
        },

        /**
         * Creates this mode for decryption.
         *
         * @param {Cipher} cipher A block cipher instance.
         * @param {Array} iv The IV words.
         *
         * @static
         *
         * @example
         *
         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
         */
        createDecryptor: function createDecryptor(cipher, iv) {
          return this.Decryptor.create(cipher, iv);
        },

        /**
         * Initializes a newly created mode.
         *
         * @param {Cipher} cipher A block cipher instance.
         * @param {Array} iv The IV words.
         *
         * @example
         *
         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
         */
        init: function init(cipher, iv) {
          this._cipher = cipher;
          this._iv = iv;
        }
      });
      /**
       * Cipher Block Chaining mode.
       */

      var CBC = C_mode.CBC = function () {
        /**
         * Abstract base CBC mode.
         */
        var CBC = BlockCipherMode.extend();
        /**
         * CBC encryptor.
         */

        CBC.Encryptor = CBC.extend({
          /**
           * Processes the data block at offset.
           *
           * @param {Array} words The data words to operate on.
           * @param {number} offset The offset where the block starts.
           *
           * @example
           *
           *     mode.processBlock(data.words, offset);
           */
          processBlock: function processBlock(words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize; // XOR and encrypt

            xorBlock.call(this, words, offset, blockSize);
            cipher.encryptBlock(words, offset); // Remember this block to use with next block

            this._prevBlock = words.slice(offset, offset + blockSize);
          }
        });
        /**
         * CBC decryptor.
         */

        CBC.Decryptor = CBC.extend({
          /**
           * Processes the data block at offset.
           *
           * @param {Array} words The data words to operate on.
           * @param {number} offset The offset where the block starts.
           *
           * @example
           *
           *     mode.processBlock(data.words, offset);
           */
          processBlock: function processBlock(words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize; // Remember this block to use with next block

            var thisBlock = words.slice(offset, offset + blockSize); // Decrypt and XOR

            cipher.decryptBlock(words, offset);
            xorBlock.call(this, words, offset, blockSize); // This block becomes the previous block

            this._prevBlock = thisBlock;
          }
        });

        function xorBlock(words, offset, blockSize) {
          // Shortcut
          var iv = this._iv; // Choose mixing block

          if (iv) {
            var block = iv; // Remove IV for subsequent blocks

            this._iv = undefined;
          } else {
            var block = this._prevBlock;
          } // XOR blocks


          for (var i = 0; i < blockSize; i++) {
            words[offset + i] ^= block[i];
          }
        }

        return CBC;
      }();
      /**
       * Padding namespace.
       */


      var C_pad = C.pad = {};
      /**
       * PKCS #5/7 padding strategy.
       */

      var Pkcs7 = C_pad.Pkcs7 = {
        /**
         * Pads data using the algorithm defined in PKCS #5/7.
         *
         * @param {WordArray} data The data to pad.
         * @param {number} blockSize The multiple that the data should be padded to.
         *
         * @static
         *
         * @example
         *
         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
         */
        pad: function pad(data, blockSize) {
          // Shortcut
          var blockSizeBytes = blockSize * 4; // Count padding bytes

          var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes; // Create padding word

          var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes; // Create padding

          var paddingWords = [];

          for (var i = 0; i < nPaddingBytes; i += 4) {
            paddingWords.push(paddingWord);
          }

          var padding = WordArray.create(paddingWords, nPaddingBytes); // Add padding

          data.concat(padding);
        },

        /**
         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
         *
         * @param {WordArray} data The data to unpad.
         *
         * @static
         *
         * @example
         *
         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
         */
        unpad: function unpad(data) {
          // Get number of padding bytes from last byte
          var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff; // Remove padding

          data.sigBytes -= nPaddingBytes;
        }
      };
      /**
       * Abstract base block cipher template.
       *
       * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
       */

      var BlockCipher = C_lib.BlockCipher = Cipher.extend({
        /**
         * Configuration options.
         *
         * @property {Mode} mode The block mode to use. Default: CBC
         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
         */
        cfg: Cipher.cfg.extend({
          mode: CBC,
          padding: Pkcs7
        }),
        reset: function reset() {
          // Reset cipher
          Cipher.reset.call(this); // Shortcuts

          var cfg = this.cfg;
          var iv = cfg.iv;
          var mode = cfg.mode; // Reset block mode

          if (this._xformMode == this._ENC_XFORM_MODE) {
            var modeCreator = mode.createEncryptor;
          } else
            /* if (this._xformMode == this._DEC_XFORM_MODE) */
            {
              var modeCreator = mode.createDecryptor; // Keep at least one block in the buffer for unpadding

              this._minBufferSize = 1;
            }

          this._mode = modeCreator.call(mode, this, iv && iv.words);
        },
        _doProcessBlock: function _doProcessBlock(words, offset) {
          this._mode.processBlock(words, offset);
        },
        _doFinalize: function _doFinalize() {
          // Shortcut
          var padding = this.cfg.padding; // Finalize

          if (this._xformMode == this._ENC_XFORM_MODE) {
            // Pad data
            padding.pad(this._data, this.blockSize); // Process final blocks

            var finalProcessedBlocks = this._process(!!'flush');
          } else
            /* if (this._xformMode == this._DEC_XFORM_MODE) */
            {
              // Process final blocks
              var finalProcessedBlocks = this._process(!!'flush'); // Unpad data


              padding.unpad(finalProcessedBlocks);
            }

          return finalProcessedBlocks;
        },
        blockSize: 128 / 32
      });
      /**
       * A collection of cipher parameters.
       *
       * @property {WordArray} ciphertext The raw ciphertext.
       * @property {WordArray} key The key to this ciphertext.
       * @property {WordArray} iv The IV used in the ciphering operation.
       * @property {WordArray} salt The salt used with a key derivation function.
       * @property {Cipher} algorithm The cipher algorithm.
       * @property {Mode} mode The block mode used in the ciphering operation.
       * @property {Padding} padding The padding scheme used in the ciphering operation.
       * @property {number} blockSize The block size of the cipher.
       * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
       */

      var CipherParams = C_lib.CipherParams = Base.extend({
        /**
         * Initializes a newly created cipher params object.
         *
         * @param {Object} cipherParams An object with any of the possible cipher parameters.
         *
         * @example
         *
         *     var cipherParams = CryptoJS.lib.CipherParams.create({
         *         ciphertext: ciphertextWordArray,
         *         key: keyWordArray,
         *         iv: ivWordArray,
         *         salt: saltWordArray,
         *         algorithm: CryptoJS.algo.AES,
         *         mode: CryptoJS.mode.CBC,
         *         padding: CryptoJS.pad.PKCS7,
         *         blockSize: 4,
         *         formatter: CryptoJS.format.OpenSSL
         *     });
         */
        init: function init(cipherParams) {
          this.mixIn(cipherParams);
        },

        /**
         * Converts this cipher params object to a string.
         *
         * @param {Format} formatter (Optional) The formatting strategy to use.
         *
         * @return {string} The stringified cipher params.
         *
         * @throws Error If neither the formatter nor the default formatter is set.
         *
         * @example
         *
         *     var string = cipherParams + '';
         *     var string = cipherParams.toString();
         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
         */
        toString: function toString(formatter) {
          return (formatter || this.formatter).stringify(this);
        }
      });
      /**
       * Format namespace.
       */

      var C_format = C.format = {};
      /**
       * OpenSSL formatting strategy.
       */

      var OpenSSLFormatter = C_format.OpenSSL = {
        /**
         * Converts a cipher params object to an OpenSSL-compatible string.
         *
         * @param {CipherParams} cipherParams The cipher params object.
         *
         * @return {string} The OpenSSL-compatible string.
         *
         * @static
         *
         * @example
         *
         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
         */
        stringify: function stringify(cipherParams) {
          // Shortcuts
          var ciphertext = cipherParams.ciphertext;
          var salt = cipherParams.salt; // Format

          if (salt) {
            var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
          } else {
            var wordArray = ciphertext;
          }

          return wordArray.toString(Base64);
        },

        /**
         * Converts an OpenSSL-compatible string to a cipher params object.
         *
         * @param {string} openSSLStr The OpenSSL-compatible string.
         *
         * @return {CipherParams} The cipher params object.
         *
         * @static
         *
         * @example
         *
         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
         */
        parse: function parse(openSSLStr) {
          // Parse base64
          var ciphertext = Base64.parse(openSSLStr); // Shortcut

          var ciphertextWords = ciphertext.words; // Test for salt

          if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
            // Extract salt
            var salt = WordArray.create(ciphertextWords.slice(2, 4)); // Remove salt from ciphertext

            ciphertextWords.splice(0, 4);
            ciphertext.sigBytes -= 16;
          }

          return CipherParams.create({
            ciphertext: ciphertext,
            salt: salt
          });
        }
      };
      /**
       * A cipher wrapper that returns ciphertext as a serializable cipher params object.
       */

      var SerializableCipher = C_lib.SerializableCipher = Base.extend({
        /**
         * Configuration options.
         *
         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
         */
        cfg: Base.extend({
          format: OpenSSLFormatter
        }),

        /**
         * Encrypts a message.
         *
         * @param {Cipher} cipher The cipher algorithm to use.
         * @param {WordArray|string} message The message to encrypt.
         * @param {WordArray} key The key.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {CipherParams} A cipher params object.
         *
         * @static
         *
         * @example
         *
         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
         */
        encrypt: function encrypt(cipher, message, key, cfg) {
          // Apply config defaults
          cfg = this.cfg.extend(cfg); // Encrypt

          var encryptor = cipher.createEncryptor(key, cfg);
          var ciphertext = encryptor.finalize(message); // Shortcut

          var cipherCfg = encryptor.cfg; // Create and return serializable cipher params

          return CipherParams.create({
            ciphertext: ciphertext,
            key: key,
            iv: cipherCfg.iv,
            algorithm: cipher,
            mode: cipherCfg.mode,
            padding: cipherCfg.padding,
            blockSize: cipher.blockSize,
            formatter: cfg.format
          });
        },

        /**
         * Decrypts serialized ciphertext.
         *
         * @param {Cipher} cipher The cipher algorithm to use.
         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
         * @param {WordArray} key The key.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {WordArray} The plaintext.
         *
         * @static
         *
         * @example
         *
         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
         */
        decrypt: function decrypt(cipher, ciphertext, key, cfg) {
          // Apply config defaults
          cfg = this.cfg.extend(cfg); // Convert string to CipherParams

          ciphertext = this._parse(ciphertext, cfg.format); // Decrypt

          var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
          return plaintext;
        },

        /**
         * Converts serialized ciphertext to CipherParams,
         * else assumed CipherParams already and returns ciphertext unchanged.
         *
         * @param {CipherParams|string} ciphertext The ciphertext.
         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
         *
         * @return {CipherParams} The unserialized ciphertext.
         *
         * @static
         *
         * @example
         *
         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
         */
        _parse: function _parse(ciphertext, format) {
          if (typeof ciphertext == 'string') {
            return format.parse(ciphertext, this);
          } else {
            return ciphertext;
          }
        }
      });
      /**
       * Key derivation function namespace.
       */

      var C_kdf = C.kdf = {};
      /**
       * OpenSSL key derivation function.
       */

      var OpenSSLKdf = C_kdf.OpenSSL = {
        /**
         * Derives a key and IV from a password.
         *
         * @param {string} password The password to derive from.
         * @param {number} keySize The size in words of the key to generate.
         * @param {number} ivSize The size in words of the IV to generate.
         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
         *
         * @return {CipherParams} A cipher params object with the key, IV, and salt.
         *
         * @static
         *
         * @example
         *
         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
         */
        execute: function execute(password, keySize, ivSize, salt) {
          // Generate random salt
          if (!salt) {
            salt = WordArray.random(64 / 8);
          } // Derive key and IV


          var key = EvpKDF.create({
            keySize: keySize + ivSize
          }).compute(password, salt); // Separate key and IV

          var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
          key.sigBytes = keySize * 4; // Return params

          return CipherParams.create({
            key: key,
            iv: iv,
            salt: salt
          });
        }
      };
      /**
       * A serializable cipher wrapper that derives the key from a password,
       * and returns ciphertext as a serializable cipher params object.
       */

      var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
        /**
         * Configuration options.
         *
         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
         */
        cfg: SerializableCipher.cfg.extend({
          kdf: OpenSSLKdf
        }),

        /**
         * Encrypts a message using a password.
         *
         * @param {Cipher} cipher The cipher algorithm to use.
         * @param {WordArray|string} message The message to encrypt.
         * @param {string} password The password.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {CipherParams} A cipher params object.
         *
         * @static
         *
         * @example
         *
         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
         */
        encrypt: function encrypt(cipher, message, password, cfg) {
          // Apply config defaults
          cfg = this.cfg.extend(cfg); // Derive key and other params

          var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize); // Add IV to config

          cfg.iv = derivedParams.iv; // Encrypt

          var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg); // Mix in derived params

          ciphertext.mixIn(derivedParams);
          return ciphertext;
        },

        /**
         * Decrypts serialized ciphertext using a password.
         *
         * @param {Cipher} cipher The cipher algorithm to use.
         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
         * @param {string} password The password.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {WordArray} The plaintext.
         *
         * @static
         *
         * @example
         *
         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
         */
        decrypt: function decrypt(cipher, ciphertext, password, cfg) {
          // Apply config defaults
          cfg = this.cfg.extend(cfg); // Convert string to CipherParams

          ciphertext = this._parse(ciphertext, cfg.format); // Derive key and other params

          var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt); // Add IV to config

          cfg.iv = derivedParams.iv; // Decrypt

          var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
          return plaintext;
        }
      });
    }();
  });
  /***/

},
/* 18 */

/***/
function (module, exports) {
  module.exports = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };
  /***/

},
/* 19 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * util/index.js - Utilities Entry Point
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var forge = __webpack_require__(14);

    var util;

    function asBuffer(input, encoding) {
      if (Buffer.isBuffer(input)) {
        return input;
      }

      if ("string" === typeof input) {
        encoding = encoding || "binary";

        if ("base64url" === encoding) {
          return util.base64url.decode(input);
        }

        return Buffer.from(input, encoding);
      } // assume input is an Array, ArrayBuffer, or ArrayBufferView


      if (forge.util.isArrayBufferView(input)) {
        input = input instanceof Uint8Array ? input : new Uint8Array(input.buffer, input.byteOffset, input.byteOffset + input.byteLength);
      } else if (forge.util.isArrayBuffer(input)) {
        input = new Uint8Array(input);
      }

      var output;
      output = Buffer.from(input);
      return output;
    }

    function randomBytes(len) {
      return Buffer.from(forge.random.getBytes(len), "binary");
    }

    util = {
      base64url: __webpack_require__(106),
      utf8: __webpack_require__(572),
      asBuffer: asBuffer,
      randomBytes: randomBytes
    };
    module.exports = util;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(12);

  var createDesc = __webpack_require__(55);

  module.exports = __webpack_require__(11) ? function (object, key, value) {
    return dP.f(object, key, createDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };
  /***/
},
/* 21 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(3);

  var hide = __webpack_require__(20);

  var has = __webpack_require__(23);

  var SRC = __webpack_require__(59)('src');

  var TO_STRING = 'toString';
  var $toString = Function[TO_STRING];
  var TPL = ('' + $toString).split(TO_STRING);

  __webpack_require__(32).inspectSource = function (it) {
    return $toString.call(it);
  };

  (module.exports = function (O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) has(val, 'name') || hide(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

    if (O === global) {
      O[key] = val;
    } else if (!safe) {
      delete O[key];
      hide(O, key, val);
    } else if (O[key]) {
      O[key] = val;
    } else {
      hide(O, key, val);
    } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

  })(Function.prototype, TO_STRING, function toString() {
    return typeof this == 'function' && this[SRC] || $toString.call(this);
  });
  /***/
},
/* 22 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var fails = __webpack_require__(5);

  var defined = __webpack_require__(33);

  var quot = /"/g; // B.2.3.2.1 CreateHTML(string, tag, attribute, value)

  var createHTML = function createHTML(string, tag, attribute, value) {
    var S = String(defined(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
  };

  module.exports = function (NAME, exec) {
    var O = {};
    O[NAME] = exec(createHTML);
    $export($export.P + $export.F * fails(function () {
      var test = ''[NAME]('"');
      return test !== test.toLowerCase() || test.split('"').length > 3;
    }), 'String', O);
  };
  /***/

},
/* 23 */

/***/
function (module, exports) {
  var hasOwnProperty = {}.hasOwnProperty;

  module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
  };
  /***/

},
/* 24 */

/***/
function (module, exports, __webpack_require__) {
  var pIE = __webpack_require__(77);

  var createDesc = __webpack_require__(55);

  var toIObject = __webpack_require__(26);

  var toPrimitive = __webpack_require__(36);

  var has = __webpack_require__(23);

  var IE8_DOM_DEFINE = __webpack_require__(172);

  var gOPD = Object.getOwnPropertyDescriptor;
  exports.f = __webpack_require__(11) ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = toIObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE) try {
      return gOPD(O, P);
    } catch (e) {
      /* empty */
    }
    if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
  };
  /***/
},
/* 25 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
  var has = __webpack_require__(23);

  var toObject = __webpack_require__(15);

  var IE_PROTO = __webpack_require__(125)('IE_PROTO');

  var ObjectProto = Object.prototype;

  module.exports = Object.getPrototypeOf || function (O) {
    O = toObject(O);
    if (has(O, IE_PROTO)) return O[IE_PROTO];

    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
      return O.constructor.prototype;
    }

    return O instanceof Object ? ObjectProto : null;
  };
  /***/

},
/* 26 */

/***/
function (module, exports, __webpack_require__) {
  // to indexed object, toObject with fallback for non-array-like ES3 strings
  var IObject = __webpack_require__(76);

  var defined = __webpack_require__(33);

  module.exports = function (it) {
    return IObject(defined(it));
  };
  /***/

},
/* 27 */

/***/
function (module, exports) {
  var toString = {}.toString;

  module.exports = function (it) {
    return toString.call(it).slice(8, -1);
  };
  /***/

},
/* 28 */

/***/
function (module, exports, __webpack_require__) {
  // optional / simple context binding
  var aFunction = __webpack_require__(18);

  module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;

    switch (length) {
      case 1:
        return function (a) {
          return fn.call(that, a);
        };

      case 2:
        return function (a, b) {
          return fn.call(that, a, b);
        };

      case 3:
        return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
    }

    return function ()
    /* ...args */
    {
      return fn.apply(that, arguments);
    };
  };
  /***/

},
/* 29 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var fails = __webpack_require__(5);

  module.exports = function (method, arg) {
    return !!method && fails(function () {
      // eslint-disable-next-line no-useless-call
      arg ? method.call(null, function () {
        /* empty */
      }, 1) : method.call(null);
    });
  };
  /***/

},
/* 30 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/helpers.js - Internal functions and fields used in Cryptographic
    * Algorithms
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    if (typeof Promise === "undefined") {
      __webpack_require__(138).polyfill();
    } // ###


    exports.int32ToBuffer = function (v, b) {
      b = b || Buffer.alloc(4);
      b[0] = v >>> 24 & 0xff;
      b[1] = v >>> 16 & 0xff;
      b[2] = v >>> 8 & 0xff;
      b[3] = v & 0xff;
      return b;
    };

    var MAX_INT32 = Math.pow(2, 32);

    exports.int64ToBuffer = function (v, b) {
      b = b || Buffer.alloc(8);
      var hi = Math.floor(v / MAX_INT32),
          lo = v % MAX_INT32;
      hi = exports.int32ToBuffer(hi);
      lo = exports.int32ToBuffer(lo);
      b = Buffer.concat([hi, lo]);
      return b;
    }; // ### crypto and DOMException in browsers ###

    /* global crypto:false, DOMException:false */


    function getCryptoSubtle() {
      if ("undefined" !== typeof crypto) {
        if ("undefined" !== typeof crypto.subtle) {
          return crypto.subtle;
        }
      }

      return undefined;
    }

    function getCryptoNodeJS() {
      var crypto;

      try {
        crypto = __webpack_require__(608);
      } catch (err) {
        return undefined;
      }

      if (!Object.keys(crypto).length) {
        // treat empty the same as missing
        return undefined;
      }

      return crypto;
    }

    var supported = {};
    Object.defineProperty(exports, "subtleCrypto", {
      get: function get() {
        var result;

        if ("subtleCrypto" in supported) {
          result = supported.subtleCrypto;
        } else {
          result = supported.subtleCrypto = getCryptoSubtle();
        }

        return result;
      },
      enumerable: true
    });
    Object.defineProperty(exports, "nodeCrypto", {
      get: function get() {
        var result;

        if ("nodeCrypto" in supported) {
          result = supported.nodeCrypto;
        } else {
          result = supported.nodeCrypto = getCryptoNodeJS();
        }

        return result;
      },
      enumerable: true
    });

    exports.setupFallback = function (nodejs, webcrypto, fallback) {
      var impl;

      if (nodejs && exports.nodeCrypto) {
        impl = function main() {
          var args = arguments,
              promise;

          function check(err) {
            if (0 === err.message.indexOf("unsupported algorithm:")) {
              impl = fallback;
              return impl.apply(null, args);
            }

            return Promise.reject(err);
          }

          try {
            promise = Promise.resolve(nodejs.apply(null, args));
          } catch (err) {
            promise = check(err);
          }

          return promise;
        };
      } else if (webcrypto && exports.subtleCrypto) {
        impl = function main() {
          var args = arguments,
              promise;

          function check(err) {
            if (err.code === DOMException.NOT_SUPPORTED_ERR || // Firefox rejects some operations erroneously complaining about inputs
            err.message === "Only ArrayBuffer and ArrayBufferView objects can be passed as CryptoOperationData" || // MS Edge rejects with not an Error
            !(err instanceof Error)) {
              // not actually supported -- always use fallback
              impl = fallback;
              return impl.apply(null, args);
            }

            return Promise.reject(err);
          }

          try {
            promise = webcrypto.apply(null, args);
            promise = promise.catch(check);
          } catch (err) {
            promise = check(err);
          }

          return promise;
        };
      } else {
        impl = fallback;
      }

      return impl;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 31 */

/***/
function (module, exports, __webpack_require__) {
  // 0 -> Array#forEach
  // 1 -> Array#map
  // 2 -> Array#filter
  // 3 -> Array#some
  // 4 -> Array#every
  // 5 -> Array#find
  // 6 -> Array#findIndex
  var ctx = __webpack_require__(28);

  var IObject = __webpack_require__(76);

  var toObject = __webpack_require__(15);

  var toLength = __webpack_require__(13);

  var asc = __webpack_require__(110);

  module.exports = function (TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || asc;
    return function ($this, callbackfn, that) {
      var O = toObject($this);
      var self = IObject(O);
      var f = ctx(callbackfn, that, 3);
      var length = toLength(self.length);
      var index = 0;
      var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
      var val, res;

      for (; length > index; index++) {
        if (NO_HOLES || index in self) {
          val = self[index];
          res = f(val, index, O);

          if (TYPE) {
            if (IS_MAP) result[index] = res; // map
            else if (res) switch (TYPE) {
                case 3:
                  return true;
                // some

                case 5:
                  return val;
                // find

                case 6:
                  return index;
                // findIndex

                case 2:
                  result.push(val);
                // filter
              } else if (IS_EVERY) return false; // every
          }
        }
      }

      return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
  };
  /***/

},
/* 32 */

/***/
function (module, exports) {
  var core = module.exports = {
    version: '2.5.5'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

  /***/
},
/* 33 */

/***/
function (module, exports) {
  // 7.2.1 RequireObjectCoercible(argument)
  module.exports = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };
  /***/

},
/* 34 */

/***/
function (module, exports, __webpack_require__) {
  // most Object methods by ES6 should accept primitives
  var $export = __webpack_require__(0);

  var core = __webpack_require__(32);

  var fails = __webpack_require__(5);

  module.exports = function (KEY, exec) {
    var fn = (core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $export($export.S + $export.F * fails(function () {
      fn(1);
    }), 'Object', exp);
  };
  /***/

},
/* 35 */

/***/
function (module, exports) {
  // 7.1.4 ToInteger
  var ceil = Math.ceil;
  var floor = Math.floor;

  module.exports = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };
  /***/

},
/* 36 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.1 ToPrimitive(input [, PreferredType])
  var isObject = __webpack_require__(7); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string


  module.exports = function (it, S) {
    if (!isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };
  /***/

},
/* 37 */

/***/
function (module, exports) {
  if (typeof Object.create === 'function') {
    // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;

      var TempCtor = function TempCtor() {};

      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }
  /***/

},
/* 38 */

/***/
function (module, exports, __webpack_require__) {
  /* eslint-disable node/no-deprecated-api */
  var buffer = __webpack_require__(1);

  var Buffer = buffer.Buffer; // alternative to using Object.keys for old browsers

  function copyProps(src, dst) {
    for (var key in src) {
      dst[key] = src[key];
    }
  }

  if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
    module.exports = buffer;
  } else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
  }

  function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
  } // Copy static methods from Buffer


  copyProps(Buffer, SafeBuffer);

  SafeBuffer.from = function (arg, encodingOrOffset, length) {
    if (typeof arg === 'number') {
      throw new TypeError('Argument must not be a number');
    }

    return Buffer(arg, encodingOrOffset, length);
  };

  SafeBuffer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('Argument must be a number');
    }

    var buf = Buffer(size);

    if (fill !== undefined) {
      if (typeof encoding === 'string') {
        buf.fill(fill, encoding);
      } else {
        buf.fill(fill);
      }
    } else {
      buf.fill(0);
    }

    return buf;
  };

  SafeBuffer.allocUnsafe = function (size) {
    if (typeof size !== 'number') {
      throw new TypeError('Argument must be a number');
    }

    return Buffer(size);
  };

  SafeBuffer.allocUnsafeSlow = function (size) {
    if (typeof size !== 'number') {
      throw new TypeError('Argument must be a number');
    }

    return buffer.SlowBuffer(size);
  };
  /***/

},
/* 39 */

/***/
function (module, exports, __webpack_require__) {
  var Map = __webpack_require__(193);

  var $export = __webpack_require__(0);

  var shared = __webpack_require__(97)('metadata');

  var store = shared.store || (shared.store = new (__webpack_require__(196))());

  var getOrCreateMetadataMap = function getOrCreateMetadataMap(target, targetKey, create) {
    var targetMetadata = store.get(target);

    if (!targetMetadata) {
      if (!create) return undefined;
      store.set(target, targetMetadata = new Map());
    }

    var keyMetadata = targetMetadata.get(targetKey);

    if (!keyMetadata) {
      if (!create) return undefined;
      targetMetadata.set(targetKey, keyMetadata = new Map());
    }

    return keyMetadata;
  };

  var ordinaryHasOwnMetadata = function ordinaryHasOwnMetadata(MetadataKey, O, P) {
    var metadataMap = getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
  };

  var ordinaryGetOwnMetadata = function ordinaryGetOwnMetadata(MetadataKey, O, P) {
    var metadataMap = getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
  };

  var ordinaryDefineOwnMetadata = function ordinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
    getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
  };

  var ordinaryOwnMetadataKeys = function ordinaryOwnMetadataKeys(target, targetKey) {
    var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
    var keys = [];
    if (metadataMap) metadataMap.forEach(function (_, key) {
      keys.push(key);
    });
    return keys;
  };

  var toMetaKey = function toMetaKey(it) {
    return it === undefined || typeof it == 'symbol' ? it : String(it);
  };

  var exp = function exp(O) {
    $export($export.S, 'Reflect', O);
  };

  module.exports = {
    store: store,
    map: getOrCreateMetadataMap,
    has: ordinaryHasOwnMetadata,
    get: ordinaryGetOwnMetadata,
    set: ordinaryDefineOwnMetadata,
    keys: ordinaryOwnMetadataKeys,
    key: toMetaKey,
    exp: exp
  };
  /***/
},
/* 40 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  if (__webpack_require__(11)) {
    var LIBRARY = __webpack_require__(51);

    var global = __webpack_require__(3);

    var fails = __webpack_require__(5);

    var $export = __webpack_require__(0);

    var $typed = __webpack_require__(99);

    var $buffer = __webpack_require__(131);

    var ctx = __webpack_require__(28);

    var anInstance = __webpack_require__(49);

    var propertyDesc = __webpack_require__(55);

    var hide = __webpack_require__(20);

    var redefineAll = __webpack_require__(56);

    var toInteger = __webpack_require__(35);

    var toLength = __webpack_require__(13);

    var toIndex = __webpack_require__(191);

    var toAbsoluteIndex = __webpack_require__(58);

    var toPrimitive = __webpack_require__(36);

    var has = __webpack_require__(23);

    var classof = __webpack_require__(75);

    var isObject = __webpack_require__(7);

    var toObject = __webpack_require__(15);

    var isArrayIter = __webpack_require__(117);

    var create = __webpack_require__(52);

    var getPrototypeOf = __webpack_require__(25);

    var gOPN = __webpack_require__(53).f;

    var getIterFn = __webpack_require__(134);

    var uid = __webpack_require__(59);

    var wks = __webpack_require__(9);

    var createArrayMethod = __webpack_require__(31);

    var createArrayIncludes = __webpack_require__(86);

    var speciesConstructor = __webpack_require__(98);

    var ArrayIterators = __webpack_require__(135);

    var Iterators = __webpack_require__(64);

    var $iterDetect = __webpack_require__(92);

    var setSpecies = __webpack_require__(57);

    var arrayFill = __webpack_require__(109);

    var arrayCopyWithin = __webpack_require__(164);

    var $DP = __webpack_require__(12);

    var $GOPD = __webpack_require__(24);

    var dP = $DP.f;
    var gOPD = $GOPD.f;
    var RangeError = global.RangeError;
    var TypeError = global.TypeError;
    var Uint8Array = global.Uint8Array;
    var ARRAY_BUFFER = 'ArrayBuffer';
    var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
    var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
    var PROTOTYPE = 'prototype';
    var ArrayProto = Array[PROTOTYPE];
    var $ArrayBuffer = $buffer.ArrayBuffer;
    var $DataView = $buffer.DataView;
    var arrayForEach = createArrayMethod(0);
    var arrayFilter = createArrayMethod(2);
    var arraySome = createArrayMethod(3);
    var arrayEvery = createArrayMethod(4);
    var arrayFind = createArrayMethod(5);
    var arrayFindIndex = createArrayMethod(6);
    var arrayIncludes = createArrayIncludes(true);
    var arrayIndexOf = createArrayIncludes(false);
    var arrayValues = ArrayIterators.values;
    var arrayKeys = ArrayIterators.keys;
    var arrayEntries = ArrayIterators.entries;
    var arrayLastIndexOf = ArrayProto.lastIndexOf;
    var arrayReduce = ArrayProto.reduce;
    var arrayReduceRight = ArrayProto.reduceRight;
    var arrayJoin = ArrayProto.join;
    var arraySort = ArrayProto.sort;
    var arraySlice = ArrayProto.slice;
    var arrayToString = ArrayProto.toString;
    var arrayToLocaleString = ArrayProto.toLocaleString;
    var ITERATOR = wks('iterator');
    var TAG = wks('toStringTag');
    var TYPED_CONSTRUCTOR = uid('typed_constructor');
    var DEF_CONSTRUCTOR = uid('def_constructor');
    var ALL_CONSTRUCTORS = $typed.CONSTR;
    var TYPED_ARRAY = $typed.TYPED;
    var VIEW = $typed.VIEW;
    var WRONG_LENGTH = 'Wrong length!';
    var $map = createArrayMethod(1, function (O, length) {
      return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
    });
    var LITTLE_ENDIAN = fails(function () {
      // eslint-disable-next-line no-undef
      return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
    });
    var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
      new Uint8Array(1).set({});
    });

    var toOffset = function toOffset(it, BYTES) {
      var offset = toInteger(it);
      if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
      return offset;
    };

    var validate = function validate(it) {
      if (isObject(it) && TYPED_ARRAY in it) return it;
      throw TypeError(it + ' is not a typed array!');
    };

    var allocate = function allocate(C, length) {
      if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
        throw TypeError('It is not a typed array constructor!');
      }

      return new C(length);
    };

    var speciesFromList = function speciesFromList(O, list) {
      return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
    };

    var fromList = function fromList(C, list) {
      var index = 0;
      var length = list.length;
      var result = allocate(C, length);

      while (length > index) {
        result[index] = list[index++];
      }

      return result;
    };

    var addGetter = function addGetter(it, key, internal) {
      dP(it, key, {
        get: function get() {
          return this._d[internal];
        }
      });
    };

    var $from = function from(source
    /* , mapfn, thisArg */
    ) {
      var O = toObject(source);
      var aLen = arguments.length;
      var mapfn = aLen > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var iterFn = getIterFn(O);
      var i, length, values, result, step, iterator;

      if (iterFn != undefined && !isArrayIter(iterFn)) {
        for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
          values.push(step.value);
        }

        O = values;
      }

      if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);

      for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
        result[i] = mapping ? mapfn(O[i], i) : O[i];
      }

      return result;
    };

    var $of = function of()
    /* ...items */
    {
      var index = 0;
      var length = arguments.length;
      var result = allocate(this, length);

      while (length > index) {
        result[index] = arguments[index++];
      }

      return result;
    }; // iOS Safari 6.x fails here


    var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
      arrayToLocaleString.call(new Uint8Array(1));
    });

    var $toLocaleString = function toLocaleString() {
      return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
    };

    var proto = {
      copyWithin: function copyWithin(target, start
      /* , end */
      ) {
        return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
      },
      every: function every(callbackfn
      /* , thisArg */
      ) {
        return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      fill: function fill(value
      /* , start, end */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayFill.apply(validate(this), arguments);
      },
      filter: function filter(callbackfn
      /* , thisArg */
      ) {
        return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
      },
      find: function find(predicate
      /* , thisArg */
      ) {
        return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
      },
      findIndex: function findIndex(predicate
      /* , thisArg */
      ) {
        return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
      },
      forEach: function forEach(callbackfn
      /* , thisArg */
      ) {
        arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      indexOf: function indexOf(searchElement
      /* , fromIndex */
      ) {
        return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
      },
      includes: function includes(searchElement
      /* , fromIndex */
      ) {
        return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
      },
      join: function join(separator) {
        // eslint-disable-line no-unused-vars
        return arrayJoin.apply(validate(this), arguments);
      },
      lastIndexOf: function lastIndexOf(searchElement
      /* , fromIndex */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayLastIndexOf.apply(validate(this), arguments);
      },
      map: function map(mapfn
      /* , thisArg */
      ) {
        return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      reduce: function reduce(callbackfn
      /* , initialValue */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayReduce.apply(validate(this), arguments);
      },
      reduceRight: function reduceRight(callbackfn
      /* , initialValue */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayReduceRight.apply(validate(this), arguments);
      },
      reverse: function reverse() {
        var that = this;
        var length = validate(that).length;
        var middle = Math.floor(length / 2);
        var index = 0;
        var value;

        while (index < middle) {
          value = that[index];
          that[index++] = that[--length];
          that[length] = value;
        }

        return that;
      },
      some: function some(callbackfn
      /* , thisArg */
      ) {
        return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      sort: function sort(comparefn) {
        return arraySort.call(validate(this), comparefn);
      },
      subarray: function subarray(begin, end) {
        var O = validate(this);
        var length = O.length;
        var $begin = toAbsoluteIndex(begin, length);
        return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
      }
    };

    var $slice = function slice(start, end) {
      return speciesFromList(this, arraySlice.call(validate(this), start, end));
    };

    var $set = function set(arrayLike
    /* , offset */
    ) {
      validate(this);
      var offset = toOffset(arguments[1], 1);
      var length = this.length;
      var src = toObject(arrayLike);
      var len = toLength(src.length);
      var index = 0;
      if (len + offset > length) throw RangeError(WRONG_LENGTH);

      while (index < len) {
        this[offset + index] = src[index++];
      }
    };

    var $iterators = {
      entries: function entries() {
        return arrayEntries.call(validate(this));
      },
      keys: function keys() {
        return arrayKeys.call(validate(this));
      },
      values: function values() {
        return arrayValues.call(validate(this));
      }
    };

    var isTAIndex = function isTAIndex(target, key) {
      return isObject(target) && target[TYPED_ARRAY] && typeof key != 'symbol' && key in target && String(+key) == String(key);
    };

    var $getDesc = function getOwnPropertyDescriptor(target, key) {
      return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
    };

    var $setDesc = function defineProperty(target, key, desc) {
      if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set') // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
        target[key] = desc.value;
        return target;
      }

      return dP(target, key, desc);
    };

    if (!ALL_CONSTRUCTORS) {
      $GOPD.f = $getDesc;
      $DP.f = $setDesc;
    }

    $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
      getOwnPropertyDescriptor: $getDesc,
      defineProperty: $setDesc
    });

    if (fails(function () {
      arrayToString.call({});
    })) {
      arrayToString = arrayToLocaleString = function toString() {
        return arrayJoin.call(this);
      };
    }

    var $TypedArrayPrototype$ = redefineAll({}, proto);
    redefineAll($TypedArrayPrototype$, $iterators);
    hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
    redefineAll($TypedArrayPrototype$, {
      slice: $slice,
      set: $set,
      constructor: function constructor() {
        /* noop */
      },
      toString: arrayToString,
      toLocaleString: $toLocaleString
    });
    addGetter($TypedArrayPrototype$, 'buffer', 'b');
    addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
    addGetter($TypedArrayPrototype$, 'byteLength', 'l');
    addGetter($TypedArrayPrototype$, 'length', 'e');
    dP($TypedArrayPrototype$, TAG, {
      get: function get() {
        return this[TYPED_ARRAY];
      }
    }); // eslint-disable-next-line max-statements

    module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
      CLAMPED = !!CLAMPED;
      var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
      var GETTER = 'get' + KEY;
      var SETTER = 'set' + KEY;
      var TypedArray = global[NAME];
      var Base = TypedArray || {};
      var TAC = TypedArray && getPrototypeOf(TypedArray);
      var FORCED = !TypedArray || !$typed.ABV;
      var O = {};
      var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];

      var getter = function getter(that, index) {
        var data = that._d;
        return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
      };

      var setter = function setter(that, index, value) {
        var data = that._d;
        if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
        data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
      };

      var addElement = function addElement(that, index) {
        dP(that, index, {
          get: function get() {
            return getter(this, index);
          },
          set: function set(value) {
            return setter(this, index, value);
          },
          enumerable: true
        });
      };

      if (FORCED) {
        TypedArray = wrapper(function (that, data, $offset, $length) {
          anInstance(that, TypedArray, NAME, '_d');
          var index = 0;
          var offset = 0;
          var buffer, byteLength, length, klass;

          if (!isObject(data)) {
            length = toIndex(data);
            byteLength = length * BYTES;
            buffer = new $ArrayBuffer(byteLength);
          } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
            buffer = data;
            offset = toOffset($offset, BYTES);
            var $len = data.byteLength;

            if ($length === undefined) {
              if ($len % BYTES) throw RangeError(WRONG_LENGTH);
              byteLength = $len - offset;
              if (byteLength < 0) throw RangeError(WRONG_LENGTH);
            } else {
              byteLength = toLength($length) * BYTES;
              if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
            }

            length = byteLength / BYTES;
          } else if (TYPED_ARRAY in data) {
            return fromList(TypedArray, data);
          } else {
            return $from.call(TypedArray, data);
          }

          hide(that, '_d', {
            b: buffer,
            o: offset,
            l: byteLength,
            e: length,
            v: new $DataView(buffer)
          });

          while (index < length) {
            addElement(that, index++);
          }
        });
        TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
        hide(TypedArrayPrototype, 'constructor', TypedArray);
      } else if (!fails(function () {
        TypedArray(1);
      }) || !fails(function () {
        new TypedArray(-1); // eslint-disable-line no-new
      }) || !$iterDetect(function (iter) {
        new TypedArray(); // eslint-disable-line no-new

        new TypedArray(null); // eslint-disable-line no-new

        new TypedArray(1.5); // eslint-disable-line no-new

        new TypedArray(iter); // eslint-disable-line no-new
      }, true)) {
        TypedArray = wrapper(function (that, data, $offset, $length) {
          anInstance(that, TypedArray, NAME);
          var klass; // `ws` module bug, temporarily remove validation length for Uint8Array
          // https://github.com/websockets/ws/pull/645

          if (!isObject(data)) return new Base(toIndex(data));

          if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
            return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
          }

          if (TYPED_ARRAY in data) return fromList(TypedArray, data);
          return $from.call(TypedArray, data);
        });
        arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
          if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
        });
        TypedArray[PROTOTYPE] = TypedArrayPrototype;
        if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
      }

      var $nativeIterator = TypedArrayPrototype[ITERATOR];
      var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
      var $iterator = $iterators.values;
      hide(TypedArray, TYPED_CONSTRUCTOR, true);
      hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
      hide(TypedArrayPrototype, VIEW, true);
      hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

      if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
        dP(TypedArrayPrototype, TAG, {
          get: function get() {
            return NAME;
          }
        });
      }

      O[NAME] = TypedArray;
      $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
      $export($export.S, NAME, {
        BYTES_PER_ELEMENT: BYTES
      });
      $export($export.S + $export.F * fails(function () {
        Base.of.call(TypedArray, 1);
      }), NAME, {
        from: $from,
        of: $of
      });
      if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
      $export($export.P, NAME, proto);
      setSpecies(NAME);
      $export($export.P + $export.F * FORCED_SET, NAME, {
        set: $set
      });
      $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
      if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
      $export($export.P + $export.F * fails(function () {
        new TypedArray(1).slice();
      }), NAME, {
        slice: $slice
      });
      $export($export.P + $export.F * (fails(function () {
        return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
      }) || !fails(function () {
        TypedArrayPrototype.toLocaleString.call([1, 2]);
      })), NAME, {
        toLocaleString: $toLocaleString
      });
      Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
      if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
    };
  } else module.exports = function () {
    /* empty */
  };
  /***/

},
/* 41 */

/***/
function (module, exports) {
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  function EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
  }

  module.exports = EventEmitter; // Backwards-compat with node 0.10.x

  EventEmitter.EventEmitter = EventEmitter;
  EventEmitter.prototype._events = undefined;
  EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
  // added to it. This is a useful default which helps finding memory leaks.

  EventEmitter.defaultMaxListeners = 10; // Obviously not all Emitters should be limited to 10. This function allows
  // that to be increased. Set to zero for unlimited.

  EventEmitter.prototype.setMaxListeners = function (n) {
    if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
  };

  EventEmitter.prototype.emit = function (type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {}; // If there is no 'error' event listener then throw.

    if (type === 'error') {
      if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
        er = arguments[1];

        if (er instanceof Error) {
          throw er; // Unhandled 'error' event
        } else {
          // At least give some kind of context to the user
          var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
          err.context = er;
          throw err;
        }
      }
    }

    handler = this._events[type];
    if (isUndefined(handler)) return false;

    if (isFunction(handler)) {
      switch (arguments.length) {
        // fast cases
        case 1:
          handler.call(this);
          break;

        case 2:
          handler.call(this, arguments[1]);
          break;

        case 3:
          handler.call(this, arguments[1], arguments[2]);
          break;
        // slower

        default:
          args = Array.prototype.slice.call(arguments, 1);
          handler.apply(this, args);
      }
    } else if (isObject(handler)) {
      args = Array.prototype.slice.call(arguments, 1);
      listeners = handler.slice();
      len = listeners.length;

      for (i = 0; i < len; i++) {
        listeners[i].apply(this, args);
      }
    }

    return true;
  };

  EventEmitter.prototype.addListener = function (type, listener) {
    var m;
    if (!isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {}; // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".

    if (this._events.newListener) this.emit('newListener', type, isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
      this._events[type] = listener;else if (isObject(this._events[type])) // If we've already got an array, just append.
      this._events[type].push(listener);else // Adding the second element, need to change to array.
      this._events[type] = [this._events[type], listener]; // Check for listener leak

    if (isObject(this._events[type]) && !this._events[type].warned) {
      if (!isUndefined(this._maxListeners)) {
        m = this._maxListeners;
      } else {
        m = EventEmitter.defaultMaxListeners;
      }

      if (m && m > 0 && this._events[type].length > m) {
        this._events[type].warned = true;
        console.error('(node) warning: possible EventEmitter memory ' + 'leak detected. %d listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.', this._events[type].length);

        if (typeof console.trace === 'function') {
          // not supported in IE 10
          console.trace();
        }
      }
    }

    return this;
  };

  EventEmitter.prototype.on = EventEmitter.prototype.addListener;

  EventEmitter.prototype.once = function (type, listener) {
    if (!isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;

    function g() {
      this.removeListener(type, g);

      if (!fired) {
        fired = true;
        listener.apply(this, arguments);
      }
    }

    g.listener = listener;
    this.on(type, g);
    return this;
  }; // emits a 'removeListener' event iff the listener was removed


  EventEmitter.prototype.removeListener = function (type, listener) {
    var list, position, length, i;
    if (!isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;

    if (list === listener || isFunction(list.listener) && list.listener === listener) {
      delete this._events[type];
      if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if (isObject(list)) {
      for (i = length; i-- > 0;) {
        if (list[i] === listener || list[i].listener && list[i].listener === listener) {
          position = i;
          break;
        }
      }

      if (position < 0) return this;

      if (list.length === 1) {
        list.length = 0;
        delete this._events[type];
      } else {
        list.splice(position, 1);
      }

      if (this._events.removeListener) this.emit('removeListener', type, listener);
    }

    return this;
  };

  EventEmitter.prototype.removeAllListeners = function (type) {
    var key, listeners;
    if (!this._events) return this; // not listening for removeListener, no need to emit

    if (!this._events.removeListener) {
      if (arguments.length === 0) this._events = {};else if (this._events[type]) delete this._events[type];
      return this;
    } // emit removeListener for all listeners on all events


    if (arguments.length === 0) {
      for (key in this._events) {
        if (key === 'removeListener') continue;
        this.removeAllListeners(key);
      }

      this.removeAllListeners('removeListener');
      this._events = {};
      return this;
    }

    listeners = this._events[type];

    if (isFunction(listeners)) {
      this.removeListener(type, listeners);
    } else if (listeners) {
      // LIFO order
      while (listeners.length) {
        this.removeListener(type, listeners[listeners.length - 1]);
      }
    }

    delete this._events[type];
    return this;
  };

  EventEmitter.prototype.listeners = function (type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];else if (isFunction(this._events[type])) ret = [this._events[type]];else ret = this._events[type].slice();
    return ret;
  };

  EventEmitter.prototype.listenerCount = function (type) {
    if (this._events) {
      var evlistener = this._events[type];
      if (isFunction(evlistener)) return 1;else if (evlistener) return evlistener.length;
    }

    return 0;
  };

  EventEmitter.listenerCount = function (emitter, type) {
    return emitter.listenerCount(type);
  };

  function isFunction(arg) {
    return typeof arg === 'function';
  }

  function isNumber(arg) {
    return typeof arg === 'number';
  }

  function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  }

  function isUndefined(arg) {
    return arg === void 0;
  }
  /***/

},
/* 42 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global, module) {
    /**
    * lodash (Custom Build) <https://lodash.com/>
    * Build: `lodash modularize exports="npm" -o ./`
    * Copyright jQuery Foundation and other contributors <https://jquery.org/>
    * Released under MIT license <https://lodash.com/license>
    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    */

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;
    /** Used to stand-in for `undefined` hash values. */

    var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as references for various `Number` constants. */

    var MAX_SAFE_INTEGER = 9007199254740991;
    /** `Object#toString` result references. */

    var argsTag = '[object Arguments]',
        arrayTag = '[object Array]',
        boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        errorTag = '[object Error]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        objectTag = '[object Object]',
        promiseTag = '[object Promise]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        symbolTag = '[object Symbol]',
        weakMapTag = '[object WeakMap]';
    var arrayBufferTag = '[object ArrayBuffer]',
        dataViewTag = '[object DataView]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';
    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */

    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to match `RegExp` flags from their coerced string values. */

    var reFlags = /\w*$/;
    /** Used to detect host constructors (Safari). */

    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect unsigned integer values. */

    var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to identify `toStringTag` values supported by `_.clone`. */

    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Detect free variable `global` from Node.js. */

    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */

    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */

    var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */

    var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */

    var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */

    var moduleExports = freeModule && freeModule.exports === freeExports;
    /**
     * Adds the key-value `pair` to `map`.
     *
     * @private
     * @param {Object} map The map to modify.
     * @param {Array} pair The key-value pair to add.
     * @returns {Object} Returns `map`.
     */

    function addMapEntry(map, pair) {
      // Don't return `map.set` because it's not chainable in IE 11.
      map.set(pair[0], pair[1]);
      return map;
    }
    /**
     * Adds `value` to `set`.
     *
     * @private
     * @param {Object} set The set to modify.
     * @param {*} value The value to add.
     * @returns {Object} Returns `set`.
     */


    function addSetEntry(set, value) {
      // Don't return `set.add` because it's not chainable in IE 11.
      set.add(value);
      return set;
    }
    /**
     * A specialized version of `_.forEach` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */


    function arrayEach(array, iteratee) {
      var index = -1,
          length = array ? array.length : 0;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }

      return array;
    }
    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */


    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }

      return array;
    }
    /**
     * A specialized version of `_.reduce` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the first element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */


    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1,
          length = array ? array.length : 0;

      if (initAccum && length) {
        accumulator = array[++index];
      }

      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }

      return accumulator;
    }
    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */


    function baseTimes(n, iteratee) {
      var index = -1,
          result = Array(n);

      while (++index < n) {
        result[index] = iteratee(index);
      }

      return result;
    }
    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */


    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }
    /**
     * Checks if `value` is a host object in IE < 9.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
     */


    function isHostObject(value) {
      // Many host objects are `Object` objects that can coerce to strings
      // despite having improperly defined `toString` methods.
      var result = false;

      if (value != null && typeof value.toString != 'function') {
        try {
          result = !!(value + '');
        } catch (e) {}
      }

      return result;
    }
    /**
     * Converts `map` to its key-value pairs.
     *
     * @private
     * @param {Object} map The map to convert.
     * @returns {Array} Returns the key-value pairs.
     */


    function mapToArray(map) {
      var index = -1,
          result = Array(map.size);
      map.forEach(function (value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */


    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }
    /**
     * Converts `set` to an array of its values.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the values.
     */


    function setToArray(set) {
      var index = -1,
          result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = value;
      });
      return result;
    }
    /** Used for built-in method references. */


    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;
    /** Used to detect overreaching core-js shims. */

    var coreJsData = root['__core-js_shared__'];
    /** Used to detect methods masquerading as native. */

    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();
    /** Used to resolve the decompiled source of functions. */


    var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */

    var hasOwnProperty = objectProto.hasOwnProperty;
    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */

    var objectToString = objectProto.toString;
    /** Used to detect if a method is native. */

    var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    /** Built-in value references. */

    var Buffer = moduleExports ? root.Buffer : undefined,
        Symbol = root.Symbol,
        Uint8Array = root.Uint8Array,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice;
    /* Built-in method references for those with the same name as other `lodash` methods. */

    var nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeKeys = overArg(Object.keys, Object);
    /* Built-in method references that are verified to be native. */

    var DataView = getNative(root, 'DataView'),
        Map = getNative(root, 'Map'),
        Promise = getNative(root, 'Promise'),
        Set = getNative(root, 'Set'),
        WeakMap = getNative(root, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');
    /** Used to detect maps, sets, and weakmaps. */

    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);
    /** Used to convert symbols to primitives and strings. */

    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function Hash(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */


    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function hashDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }
    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function hashGet(key) {
      var data = this.__data__;

      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }

      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */


    function hashSet(key, value) {
      var data = this.__data__;
      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
      return this;
    } // Add methods to `Hash`.


    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function ListCache(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */


    function listCacheClear() {
      this.__data__ = [];
    }
    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }

      var lastIndex = data.length - 1;

      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }

      return true;
    }
    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);
      return index < 0 ? undefined : data[index][1];
    }
    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */


    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }

      return this;
    } // Add methods to `ListCache`.


    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function MapCache(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */


    function mapCacheClear() {
      this.__data__ = {
        'hash': new Hash(),
        'map': new (Map || ListCache)(),
        'string': new Hash()
      };
    }
    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function mapCacheDelete(key) {
      return getMapData(this, key)['delete'](key);
    }
    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */


    function mapCacheSet(key, value) {
      getMapData(this, key).set(key, value);
      return this;
    } // Add methods to `MapCache`.


    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function Stack(entries) {
      this.__data__ = new ListCache(entries);
    }
    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */


    function stackClear() {
      this.__data__ = new ListCache();
    }
    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function stackDelete(key) {
      return this.__data__['delete'](key);
    }
    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function stackGet(key) {
      return this.__data__.get(key);
    }
    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function stackHas(key) {
      return this.__data__.has(key);
    }
    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */


    function stackSet(key, value) {
      var cache = this.__data__;

      if (cache instanceof ListCache) {
        var pairs = cache.__data__;

        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          return this;
        }

        cache = this.__data__ = new MapCache(pairs);
      }

      cache.set(key, value);
      return this;
    } // Add methods to `Stack`.


    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */

    function arrayLikeKeys(value, inherited) {
      // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
      // Safari 9 makes `arguments.length` enumerable in strict mode.
      var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
      var length = result.length,
          skipIndexes = !!length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
          result.push(key);
        }
      }

      return result;
    }
    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */


    function assignValue(object, key, value) {
      var objValue = object[key];

      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
        object[key] = value;
      }
    }
    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function assocIndexOf(array, key) {
      var length = array.length;

      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */


    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }
    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {boolean} [isFull] Specify a clone including symbols.
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */


    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
      var result;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }

      if (result !== undefined) {
        return result;
      }

      if (!isObject(value)) {
        return value;
      }

      var isArr = isArray(value);

      if (isArr) {
        result = initCloneArray(value);

        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }

        if (tag == objectTag || tag == argsTag || isFunc && !object) {
          if (isHostObject(value)) {
            return object ? value : {};
          }

          result = initCloneObject(isFunc ? {} : value);

          if (!isDeep) {
            return copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }

          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      } // Check for circular references and return its corresponding clone.


      stack || (stack = new Stack());
      var stacked = stack.get(value);

      if (stacked) {
        return stacked;
      }

      stack.set(value, result);

      if (!isArr) {
        var props = isFull ? getAllKeys(value) : keys(value);
      }

      arrayEach(props || value, function (subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        } // Recursively populate clone (susceptible to call stack limits).


        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
      });
      return result;
    }
    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */


    function baseCreate(proto) {
      return isObject(proto) ? objectCreate(proto) : {};
    }
    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */


    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    /**
     * The base implementation of `getTag`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */


    function baseGetTag(value) {
      return objectToString.call(value);
    }
    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */


    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }

      var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */


    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }

      var result = [];

      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }

      return result;
    }
    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */


    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }

      var result = new buffer.constructor(buffer.length);
      buffer.copy(result);
      return result;
    }
    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */


    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }
    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */


    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }
    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */


    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor());
    }
    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */


    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }
    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */


    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor());
    }
    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */


    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }
    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */


    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */


    function copyArray(source, array) {
      var index = -1,
          length = source.length;
      array || (array = Array(length));

      while (++index < length) {
        array[index] = source[index];
      }

      return array;
    }
    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */


    function copyObject(source, props, object, customizer) {
      object || (object = {});
      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
      }

      return object;
    }
    /**
     * Copies own symbol properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */


    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }
    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */


    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }
    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */


    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */


    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }
    /**
     * Creates an array of the own enumerable symbol properties of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */


    var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */

    var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11,
    // for data views in Edge < 14, and promises in Node.js.

    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
      getTag = function getTag(value) {
        var result = objectToString.call(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : undefined;

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;

            case mapCtorString:
              return mapTag;

            case promiseCtorString:
              return promiseTag;

            case setCtorString:
              return setTag;

            case weakMapCtorString:
              return weakMapTag;
          }
        }

        return result;
      };
    }
    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */


    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length); // Add properties assigned by `RegExp#exec`.

      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }

      return result;
    }
    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */


    function initCloneObject(object) {
      return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }
    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */


    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;

      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }
    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */


    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */


    function isKeyable(value) {
      var type = typeof value;
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */


    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */


    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
      return value === proto;
    }
    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to process.
     * @returns {string} Returns the source code.
     */


    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}

        try {
          return func + '';
        } catch (e) {}
      }

      return '';
    }
    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */


    function clone(value) {
      return baseClone(value, false, true);
    }
    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */


    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */


    function isArguments(value) {
      // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
    }
    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */


    var isArray = Array.isArray;
    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */

    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */


    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */


    var isBuffer = nativeIsBuffer || stubFalse;
    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */

    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8-9 which returns 'object' for typed array and other constructors.
      var tag = isObject(value) ? objectToString.call(value) : '';
      return tag == funcTag || tag == genTag;
    }
    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */


    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */


    function isObject(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */


    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }
    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */


    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */


    function stubArray() {
      return [];
    }
    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */


    function stubFalse() {
      return false;
    }

    module.exports = clone;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10), __webpack_require__(84)(module));
  /***/
},
/* 43 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * algorithms/constants.js - Constants used in Cryptographic Algorithms
   *
   * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
   */

  module.exports = {
    CHUNK_SIZE: 1024,
    HASHLENGTH: {
      "SHA-1": 160,
      "SHA-256": 256,
      "SHA-384": 384,
      "SHA-512": 512
    },
    ENCLENGTH: {
      "AES-128-CBC": 128,
      "AES-192-CBC": 192,
      "AES-256-CBC": 256,
      "AES-128-KW": 128,
      "AES-192-KW": 192,
      "AES-256-KW": 256
    },
    KEYLENGTH: {
      "A128CBC-HS256": 256,
      "A192CBC-HS384": 384,
      "A256CBC-HS512": 512,
      "A128CBC+HS256": 256,
      "A192CBC+HS384": 384,
      "A256CBC+HS512": 512,
      "A128GCM": 128,
      "A192GCM": 192,
      "A256GCM": 256,
      "A128KW": 128,
      "A192KW": 192,
      "A256KW": 256,
      "ECDH-ES+A128KW": 128,
      "ECDH-ES+A192KW": 192,
      "ECDH-ES+A256KW": 256
    },
    NONCELENGTH: {
      "A128CBC-HS256": 128,
      "A192CBC-HS384": 128,
      "A256CBC-HS512": 128,
      "A128CBC+HS256": 128,
      "A192CBC+HS384": 128,
      "A256CBC+HS512": 128,
      "A128GCM": 96,
      "A192GCM": 96,
      "A256GCM": 96
    }
  };
  /***/
},
/* 44 */

/***/
function (module, exports, __webpack_require__) {
  // 22.1.3.31 Array.prototype[@@unscopables]
  var UNSCOPABLES = __webpack_require__(9)('unscopables');

  var ArrayProto = Array.prototype;
  if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(20)(ArrayProto, UNSCOPABLES, {});

  module.exports = function (key) {
    ArrayProto[UNSCOPABLES][key] = true;
  };
  /***/

},
/* 45 */

/***/
function (module, exports, __webpack_require__) {
  var META = __webpack_require__(59)('meta');

  var isObject = __webpack_require__(7);

  var has = __webpack_require__(23);

  var setDesc = __webpack_require__(12).f;

  var id = 0;

  var isExtensible = Object.isExtensible || function () {
    return true;
  };

  var FREEZE = !__webpack_require__(5)(function () {
    return isExtensible(Object.preventExtensions({}));
  });

  var setMeta = function setMeta(it) {
    setDesc(it, META, {
      value: {
        i: 'O' + ++id,
        // object ID
        w: {} // weak collections IDs

      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return primitive with prefix
    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMeta(it); // return object ID
    }

    return it[META].i;
  };

  var getWeak = function getWeak(it, create) {
    if (!has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMeta(it); // return hash weak collections IDs
    }

    return it[META].w;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function onFreeze(it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
    return it;
  };

  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };
  /***/
},
/* 46 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Javascript implementation of Abstract Syntax Notation Number One.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2015 Digital Bazaar, Inc.
   *
   * An API for storing data using the Abstract Syntax Notation Number One
   * format using DER (Distinguished Encoding Rules) encoding. This encoding is
   * commonly used to store data for PKI, i.e. X.509 Certificates, and this
   * implementation exists for that purpose.
   *
   * Abstract Syntax Notation Number One (ASN.1) is used to define the abstract
   * syntax of information without restricting the way the information is encoded
   * for transmission. It provides a standard that allows for open systems
   * communication. ASN.1 defines the syntax of information data and a number of
   * simple data types as well as a notation for describing them and specifying
   * values for them.
   *
   * The RSA algorithm creates public and private keys that are often stored in
   * X.509 or PKCS#X formats -- which use ASN.1 (encoded in DER format). This
   * class provides the most basic functionality required to store and load DSA
   * keys that are encoded according to ASN.1.
   *
   * The most common binary encodings for ASN.1 are BER (Basic Encoding Rules)
   * and DER (Distinguished Encoding Rules). DER is just a subset of BER that
   * has stricter requirements for how data must be encoded.
   *
   * Each ASN.1 structure has a tag (a byte identifying the ASN.1 structure type)
   * and a byte array for the value of this ASN1 structure which may be data or a
   * list of ASN.1 structures.
   *
   * Each ASN.1 structure using BER is (Tag-Length-Value):
   *
   * | byte 0 | bytes X | bytes Y |
   * |--------|---------|----------
   * |  tag   | length  |  value  |
   *
   * ASN.1 allows for tags to be of "High-tag-number form" which allows a tag to
   * be two or more octets, but that is not supported by this class. A tag is
   * only 1 byte. Bits 1-5 give the tag number (ie the data type within a
   * particular 'class'), 6 indicates whether or not the ASN.1 value is
   * constructed from other ASN.1 values, and bits 7 and 8 give the 'class'. If
   * bits 7 and 8 are both zero, the class is UNIVERSAL. If only bit 7 is set,
   * then the class is APPLICATION. If only bit 8 is set, then the class is
   * CONTEXT_SPECIFIC. If both bits 7 and 8 are set, then the class is PRIVATE.
   * The tag numbers for the data types for the class UNIVERSAL are listed below:
   *
   * UNIVERSAL 0 Reserved for use by the encoding rules
   * UNIVERSAL 1 Boolean type
   * UNIVERSAL 2 Integer type
   * UNIVERSAL 3 Bitstring type
   * UNIVERSAL 4 Octetstring type
   * UNIVERSAL 5 Null type
   * UNIVERSAL 6 Object identifier type
   * UNIVERSAL 7 Object descriptor type
   * UNIVERSAL 8 External type and Instance-of type
   * UNIVERSAL 9 Real type
   * UNIVERSAL 10 Enumerated type
   * UNIVERSAL 11 Embedded-pdv type
   * UNIVERSAL 12 UTF8String type
   * UNIVERSAL 13 Relative object identifier type
   * UNIVERSAL 14-15 Reserved for future editions
   * UNIVERSAL 16 Sequence and Sequence-of types
   * UNIVERSAL 17 Set and Set-of types
   * UNIVERSAL 18-22, 25-30 Character string types
   * UNIVERSAL 23-24 Time types
   *
   * The length of an ASN.1 structure is specified after the tag identifier.
   * There is a definite form and an indefinite form. The indefinite form may
   * be used if the encoding is constructed and not all immediately available.
   * The indefinite form is encoded using a length byte with only the 8th bit
   * set. The end of the constructed object is marked using end-of-contents
   * octets (two zero bytes).
   *
   * The definite form looks like this:
   *
   * The length may take up 1 or more bytes, it depends on the length of the
   * value of the ASN.1 structure. DER encoding requires that if the ASN.1
   * structure has a value that has a length greater than 127, more than 1 byte
   * will be used to store its length, otherwise just one byte will be used.
   * This is strict.
   *
   * In the case that the length of the ASN.1 value is less than 127, 1 octet
   * (byte) is used to store the "short form" length. The 8th bit has a value of
   * 0 indicating the length is "short form" and not "long form" and bits 7-1
   * give the length of the data. (The 8th bit is the left-most, most significant
   * bit: also known as big endian or network format).
   *
   * In the case that the length of the ASN.1 value is greater than 127, 2 to
   * 127 octets (bytes) are used to store the "long form" length. The first
   * byte's 8th bit is set to 1 to indicate the length is "long form." Bits 7-1
   * give the number of additional octets. All following octets are in base 256
   * with the most significant digit first (typical big-endian binary unsigned
   * integer storage). So, for instance, if the length of a value was 257, the
   * first byte would be set to:
   *
   * 10000010 = 130 = 0x82.
   *
   * This indicates there are 2 octets (base 256) for the length. The second and
   * third bytes (the octets just mentioned) would store the length in base 256:
   *
   * octet 2: 00000001 = 1 * 256^1 = 256
   * octet 3: 00000001 = 1 * 256^0 = 1
   * total = 257
   *
   * The algorithm for converting a js integer value of 257 to base-256 is:
   *
   * var value = 257;
   * var bytes = [];
   * bytes[0] = (value >>> 8) & 0xFF; // most significant byte first
   * bytes[1] = value & 0xFF;        // least significant byte last
   *
   * On the ASN.1 UNIVERSAL Object Identifier (OID) type:
   *
   * An OID can be written like: "value1.value2.value3...valueN"
   *
   * The DER encoding rules:
   *
   * The first byte has the value 40 * value1 + value2.
   * The following bytes, if any, encode the remaining values. Each value is
   * encoded in base 128, most significant digit first (big endian), with as
   * few digits as possible, and the most significant bit of each byte set
   * to 1 except the last in each value's encoding. For example: Given the
   * OID "1.2.840.113549", its DER encoding is (remember each byte except the
   * last one in each encoding is OR'd with 0x80):
   *
   * byte 1: 40 * 1 + 2 = 42 = 0x2A.
   * bytes 2-3: 128 * 6 + 72 = 840 = 6 72 = 6 72 = 0x0648 = 0x8648
   * bytes 4-6: 16384 * 6 + 128 * 119 + 13 = 6 119 13 = 0x06770D = 0x86F70D
   *
   * The final value is: 0x2A864886F70D.
   * The full OID (including ASN.1 tag and length of 6 bytes) is:
   * 0x06062A864886F70D
   */
  var forge = __webpack_require__(6);

  __webpack_require__(8);

  __webpack_require__(61);
  /* ASN.1 API */


  var asn1 = module.exports = forge.asn1 = forge.asn1 || {};
  /**
   * ASN.1 classes.
   */

  asn1.Class = {
    UNIVERSAL: 0x00,
    APPLICATION: 0x40,
    CONTEXT_SPECIFIC: 0x80,
    PRIVATE: 0xC0
  };
  /**
   * ASN.1 types. Not all types are supported by this implementation, only
   * those necessary to implement a simple PKI are implemented.
   */

  asn1.Type = {
    NONE: 0,
    BOOLEAN: 1,
    INTEGER: 2,
    BITSTRING: 3,
    OCTETSTRING: 4,
    NULL: 5,
    OID: 6,
    ODESC: 7,
    EXTERNAL: 8,
    REAL: 9,
    ENUMERATED: 10,
    EMBEDDED: 11,
    UTF8: 12,
    ROID: 13,
    SEQUENCE: 16,
    SET: 17,
    PRINTABLESTRING: 19,
    IA5STRING: 22,
    UTCTIME: 23,
    GENERALIZEDTIME: 24,
    BMPSTRING: 30
  };
  /**
   * Creates a new asn1 object.
   *
   * @param tagClass the tag class for the object.
   * @param type the data type (tag number) for the object.
   * @param constructed true if the asn1 object is in constructed form.
   * @param value the value for the object, if it is not constructed.
   * @param [options] the options to use:
   *          [bitStringContents] the plain BIT STRING content including padding
   *            byte.
   *
   * @return the asn1 object.
   */

  asn1.create = function (tagClass, type, constructed, value, options) {
    /* An asn1 object has a tagClass, a type, a constructed flag, and a
      value. The value's type depends on the constructed flag. If
      constructed, it will contain a list of other asn1 objects. If not,
      it will contain the ASN.1 value as an array of bytes formatted
      according to the ASN.1 data type. */
    // remove undefined values
    if (forge.util.isArray(value)) {
      var tmp = [];

      for (var i = 0; i < value.length; ++i) {
        if (value[i] !== undefined) {
          tmp.push(value[i]);
        }
      }

      value = tmp;
    }

    var obj = {
      tagClass: tagClass,
      type: type,
      constructed: constructed,
      composed: constructed || forge.util.isArray(value),
      value: value
    };

    if (options && 'bitStringContents' in options) {
      // TODO: copy byte buffer if it's a buffer not a string
      obj.bitStringContents = options.bitStringContents; // TODO: add readonly flag to avoid this overhead
      // save copy to detect changes

      obj.original = asn1.copy(obj);
    }

    return obj;
  };
  /**
   * Copies an asn1 object.
   *
   * @param obj the asn1 object.
   * @param [options] copy options:
   *          [excludeBitStringContents] true to not copy bitStringContents
   *
   * @return the a copy of the asn1 object.
   */


  asn1.copy = function (obj, options) {
    var copy;

    if (forge.util.isArray(obj)) {
      copy = [];

      for (var i = 0; i < obj.length; ++i) {
        copy.push(asn1.copy(obj[i], options));
      }

      return copy;
    }

    if (typeof obj === 'string') {
      // TODO: copy byte buffer if it's a buffer not a string
      return obj;
    }

    copy = {
      tagClass: obj.tagClass,
      type: obj.type,
      constructed: obj.constructed,
      composed: obj.composed,
      value: asn1.copy(obj.value, options)
    };

    if (options && !options.excludeBitStringContents) {
      // TODO: copy byte buffer if it's a buffer not a string
      copy.bitStringContents = obj.bitStringContents;
    }

    return copy;
  };
  /**
   * Compares asn1 objects for equality.
   *
   * Note this function does not run in constant time.
   *
   * @param obj1 the first asn1 object.
   * @param obj2 the second asn1 object.
   * @param [options] compare options:
   *          [includeBitStringContents] true to compare bitStringContents
   *
   * @return true if the asn1 objects are equal.
   */


  asn1.equals = function (obj1, obj2, options) {
    if (forge.util.isArray(obj1)) {
      if (!forge.util.isArray(obj2)) {
        return false;
      }

      if (obj1.length !== obj2.length) {
        return false;
      }

      for (var i = 0; i < obj1.length; ++i) {
        if (!asn1.equals(obj1[i], obj2[i])) {
          return false;
        }
      }

      return true;
    }

    if (typeof obj1 !== typeof obj2) {
      return false;
    }

    if (typeof obj1 === 'string') {
      return obj1 === obj2;
    }

    var equal = obj1.tagClass === obj2.tagClass && obj1.type === obj2.type && obj1.constructed === obj2.constructed && obj1.composed === obj2.composed && asn1.equals(obj1.value, obj2.value);

    if (options && options.includeBitStringContents) {
      equal = equal && obj1.bitStringContents === obj2.bitStringContents;
    }

    return equal;
  };
  /**
   * Gets the length of a BER-encoded ASN.1 value.
   *
   * In case the length is not specified, undefined is returned.
   *
   * @param b the BER-encoded ASN.1 byte buffer, starting with the first
   *          length byte.
   *
   * @return the length of the BER-encoded ASN.1 value or undefined.
   */


  asn1.getBerValueLength = function (b) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    var b2 = b.getByte();

    if (b2 === 0x80) {
      return undefined;
    } // see if the length is "short form" or "long form" (bit 8 set)


    var length;
    var longForm = b2 & 0x80;

    if (!longForm) {
      // length is just the first byte
      length = b2;
    } else {
      // the number of bytes the length is specified in bits 7 through 1
      // and each length byte is in big-endian base-256
      length = b.getInt((b2 & 0x7F) << 3);
    }

    return length;
  };
  /**
   * Check if the byte buffer has enough bytes. Throws an Error if not.
   *
   * @param bytes the byte buffer to parse from.
   * @param remaining the bytes remaining in the current parsing state.
   * @param n the number of bytes the buffer must have.
   */


  function _checkBufferLength(bytes, remaining, n) {
    if (n > remaining) {
      var error = new Error('Too few bytes to parse DER.');
      error.available = bytes.length();
      error.remaining = remaining;
      error.requested = n;
      throw error;
    }
  }
  /**
   * Gets the length of a BER-encoded ASN.1 value.
   *
   * In case the length is not specified, undefined is returned.
   *
   * @param bytes the byte buffer to parse from.
   * @param remaining the bytes remaining in the current parsing state.
   *
   * @return the length of the BER-encoded ASN.1 value or undefined.
   */


  var _getValueLength = function _getValueLength(bytes, remaining) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    // fromDer already checked that this byte exists
    var b2 = bytes.getByte();
    remaining--;

    if (b2 === 0x80) {
      return undefined;
    } // see if the length is "short form" or "long form" (bit 8 set)


    var length;
    var longForm = b2 & 0x80;

    if (!longForm) {
      // length is just the first byte
      length = b2;
    } else {
      // the number of bytes the length is specified in bits 7 through 1
      // and each length byte is in big-endian base-256
      var longFormBytes = b2 & 0x7F;

      _checkBufferLength(bytes, remaining, longFormBytes);

      length = bytes.getInt(longFormBytes << 3);
    } // FIXME: this will only happen for 32 bit getInt with high bit set


    if (length < 0) {
      throw new Error('Negative length: ' + length);
    }

    return length;
  };
  /**
   * Parses an asn1 object from a byte buffer in DER format.
   *
   * @param bytes the byte buffer to parse from.
   * @param [strict] true to be strict when checking value lengths, false to
   *          allow truncated values (default: true).
   * @param [options] object with options or boolean strict flag
   *          [strict] true to be strict when checking value lengths, false to
   *            allow truncated values (default: true).
   *          [decodeBitStrings] true to attempt to decode the content of
   *            BIT STRINGs (not OCTET STRINGs) using strict mode. Note that
   *            without schema support to understand the data context this can
   *            erroneously decode values that happen to be valid ASN.1. This
   *            flag will be deprecated or removed as soon as schema support is
   *            available. (default: true)
   *
   * @return the parsed asn1 object.
   */


  asn1.fromDer = function (bytes, options) {
    if (options === undefined) {
      options = {
        strict: true,
        decodeBitStrings: true
      };
    }

    if (typeof options === 'boolean') {
      options = {
        strict: options,
        decodeBitStrings: true
      };
    }

    if (!('strict' in options)) {
      options.strict = true;
    }

    if (!('decodeBitStrings' in options)) {
      options.decodeBitStrings = true;
    } // wrap in buffer if needed


    if (typeof bytes === 'string') {
      bytes = forge.util.createBuffer(bytes);
    }

    return _fromDer(bytes, bytes.length(), 0, options);
  };
  /**
   * Internal function to parse an asn1 object from a byte buffer in DER format.
   *
   * @param bytes the byte buffer to parse from.
   * @param remaining the number of bytes remaining for this chunk.
   * @param depth the current parsing depth.
   * @param options object with same options as fromDer().
   *
   * @return the parsed asn1 object.
   */


  function _fromDer(bytes, remaining, depth, options) {
    // temporary storage for consumption calculations
    var start; // minimum length for ASN.1 DER structure is 2

    _checkBufferLength(bytes, remaining, 2); // get the first byte


    var b1 = bytes.getByte(); // consumed one byte

    remaining--; // get the tag class

    var tagClass = b1 & 0xC0; // get the type (bits 1-5)

    var type = b1 & 0x1F; // get the variable value length and adjust remaining bytes

    start = bytes.length();

    var length = _getValueLength(bytes, remaining);

    remaining -= start - bytes.length(); // ensure there are enough bytes to get the value

    if (length !== undefined && length > remaining) {
      if (options.strict) {
        var error = new Error('Too few bytes to read ASN.1 value.');
        error.available = bytes.length();
        error.remaining = remaining;
        error.requested = length;
        throw error;
      } // Note: be lenient with truncated values and use remaining state bytes


      length = remaining;
    } // value storage


    var value; // possible BIT STRING contents storage

    var bitStringContents; // constructed flag is bit 6 (32 = 0x20) of the first byte

    var constructed = (b1 & 0x20) === 0x20;

    if (constructed) {
      // parse child asn1 objects from the value
      value = [];

      if (length === undefined) {
        // asn1 object of indefinite length, read until end tag
        for (;;) {
          _checkBufferLength(bytes, remaining, 2);

          if (bytes.bytes(2) === String.fromCharCode(0, 0)) {
            bytes.getBytes(2);
            remaining -= 2;
            break;
          }

          start = bytes.length();
          value.push(_fromDer(bytes, remaining, depth + 1, options));
          remaining -= start - bytes.length();
        }
      } else {
        // parsing asn1 object of definite length
        while (length > 0) {
          start = bytes.length();
          value.push(_fromDer(bytes, length, depth + 1, options));
          remaining -= start - bytes.length();
          length -= start - bytes.length();
        }
      }
    } // if a BIT STRING, save the contents including padding


    if (value === undefined && tagClass === asn1.Class.UNIVERSAL && type === asn1.Type.BITSTRING) {
      bitStringContents = bytes.bytes(length);
    } // determine if a non-constructed value should be decoded as a composed
    // value that contains other ASN.1 objects. BIT STRINGs (and OCTET STRINGs)
    // can be used this way.


    if (value === undefined && options.decodeBitStrings && tagClass === asn1.Class.UNIVERSAL && // FIXME: OCTET STRINGs not yet supported here
    // .. other parts of forge expect to decode OCTET STRINGs manually
    type === asn1.Type.BITSTRING
    /*|| type === asn1.Type.OCTETSTRING*/
    && length > 1) {
      // save read position
      var savedRead = bytes.read;
      var savedRemaining = remaining;
      var unused = 0;

      if (type === asn1.Type.BITSTRING) {
        /* The first octet gives the number of bits by which the length of the
          bit string is less than the next multiple of eight (this is called
          the "number of unused bits").
           The second and following octets give the value of the bit string
          converted to an octet string. */
        _checkBufferLength(bytes, remaining, 1);

        unused = bytes.getByte();
        remaining--;
      } // if all bits are used, maybe the BIT/OCTET STRING holds ASN.1 objs


      if (unused === 0) {
        try {
          // attempt to parse child asn1 object from the value
          // (stored in array to signal composed value)
          start = bytes.length();
          var subOptions = {
            // enforce strict mode to avoid parsing ASN.1 from plain data
            verbose: options.verbose,
            strict: true,
            decodeBitStrings: true
          };

          var composed = _fromDer(bytes, remaining, depth + 1, subOptions);

          var used = start - bytes.length();
          remaining -= used;

          if (type == asn1.Type.BITSTRING) {
            used++;
          } // if the data all decoded and the class indicates UNIVERSAL or
          // CONTEXT_SPECIFIC then assume we've got an encapsulated ASN.1 object


          var tc = composed.tagClass;

          if (used === length && (tc === asn1.Class.UNIVERSAL || tc === asn1.Class.CONTEXT_SPECIFIC)) {
            value = [composed];
          }
        } catch (ex) {}
      }

      if (value === undefined) {
        // restore read position
        bytes.read = savedRead;
        remaining = savedRemaining;
      }
    }

    if (value === undefined) {
      // asn1 not constructed or composed, get raw value
      // TODO: do DER to OID conversion and vice-versa in .toDer?
      if (length === undefined) {
        if (options.strict) {
          throw new Error('Non-constructed ASN.1 object of indefinite length.');
        } // be lenient and use remaining state bytes


        length = remaining;
      }

      if (type === asn1.Type.BMPSTRING) {
        value = '';

        for (; length > 0; length -= 2) {
          _checkBufferLength(bytes, remaining, 2);

          value += String.fromCharCode(bytes.getInt16());
          remaining -= 2;
        }
      } else {
        value = bytes.getBytes(length);
      }
    } // add BIT STRING contents if available


    var asn1Options = bitStringContents === undefined ? null : {
      bitStringContents: bitStringContents
    }; // create and return asn1 object

    return asn1.create(tagClass, type, constructed, value, asn1Options);
  }
  /**
   * Converts the given asn1 object to a buffer of bytes in DER format.
   *
   * @param asn1 the asn1 object to convert to bytes.
   *
   * @return the buffer of bytes.
   */


  asn1.toDer = function (obj) {
    var bytes = forge.util.createBuffer(); // build the first byte

    var b1 = obj.tagClass | obj.type; // for storing the ASN.1 value

    var value = forge.util.createBuffer(); // use BIT STRING contents if available and data not changed

    var useBitStringContents = false;

    if ('bitStringContents' in obj) {
      useBitStringContents = true;

      if (obj.original) {
        useBitStringContents = asn1.equals(obj, obj.original);
      }
    }

    if (useBitStringContents) {
      value.putBytes(obj.bitStringContents);
    } else if (obj.composed) {
      // if composed, use each child asn1 object's DER bytes as value
      // turn on 6th bit (0x20 = 32) to indicate asn1 is constructed
      // from other asn1 objects
      if (obj.constructed) {
        b1 |= 0x20;
      } else {
        // type is a bit string, add unused bits of 0x00
        value.putByte(0x00);
      } // add all of the child DER bytes together


      for (var i = 0; i < obj.value.length; ++i) {
        if (obj.value[i] !== undefined) {
          value.putBuffer(asn1.toDer(obj.value[i]));
        }
      }
    } else {
      // use asn1.value directly
      if (obj.type === asn1.Type.BMPSTRING) {
        for (var i = 0; i < obj.value.length; ++i) {
          value.putInt16(obj.value.charCodeAt(i));
        }
      } else {
        // ensure integer is minimally-encoded
        // TODO: should all leading bytes be stripped vs just one?
        // .. ex '00 00 01' => '01'?
        if (obj.type === asn1.Type.INTEGER && obj.value.length > 1 && ( // leading 0x00 for positive integer
        obj.value.charCodeAt(0) === 0 && (obj.value.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
        obj.value.charCodeAt(0) === 0xFF && (obj.value.charCodeAt(1) & 0x80) === 0x80)) {
          value.putBytes(obj.value.substr(1));
        } else {
          value.putBytes(obj.value);
        }
      }
    } // add tag byte


    bytes.putByte(b1); // use "short form" encoding

    if (value.length() <= 127) {
      // one byte describes the length
      // bit 8 = 0 and bits 7-1 = length
      bytes.putByte(value.length() & 0x7F);
    } else {
      // use "long form" encoding
      // 2 to 127 bytes describe the length
      // first byte: bit 8 = 1 and bits 7-1 = # of additional bytes
      // other bytes: length in base 256, big-endian
      var len = value.length();
      var lenBytes = '';

      do {
        lenBytes += String.fromCharCode(len & 0xFF);
        len = len >>> 8;
      } while (len > 0); // set first byte to # bytes used to store the length and turn on
      // bit 8 to indicate long-form length is used


      bytes.putByte(lenBytes.length | 0x80); // concatenate length bytes in reverse since they were generated
      // little endian and we need big endian

      for (var i = lenBytes.length - 1; i >= 0; --i) {
        bytes.putByte(lenBytes.charCodeAt(i));
      }
    } // concatenate value bytes


    bytes.putBuffer(value);
    return bytes;
  };
  /**
   * Converts an OID dot-separated string to a byte buffer. The byte buffer
   * contains only the DER-encoded value, not any tag or length bytes.
   *
   * @param oid the OID dot-separated string.
   *
   * @return the byte buffer.
   */


  asn1.oidToDer = function (oid) {
    // split OID into individual values
    var values = oid.split('.');
    var bytes = forge.util.createBuffer(); // first byte is 40 * value1 + value2

    bytes.putByte(40 * parseInt(values[0], 10) + parseInt(values[1], 10)); // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value

    var last, valueBytes, value, b;

    for (var i = 2; i < values.length; ++i) {
      // produce value bytes in reverse because we don't know how many
      // bytes it will take to store the value
      last = true;
      valueBytes = [];
      value = parseInt(values[i], 10);

      do {
        b = value & 0x7F;
        value = value >>> 7; // if value is not last, then turn on 8th bit

        if (!last) {
          b |= 0x80;
        }

        valueBytes.push(b);
        last = false;
      } while (value > 0); // add value bytes in reverse (needs to be in big endian)


      for (var n = valueBytes.length - 1; n >= 0; --n) {
        bytes.putByte(valueBytes[n]);
      }
    }

    return bytes;
  };
  /**
   * Converts a DER-encoded byte buffer to an OID dot-separated string. The
   * byte buffer should contain only the DER-encoded value, not any tag or
   * length bytes.
   *
   * @param bytes the byte buffer.
   *
   * @return the OID dot-separated string.
   */


  asn1.derToOid = function (bytes) {
    var oid; // wrap in buffer if needed

    if (typeof bytes === 'string') {
      bytes = forge.util.createBuffer(bytes);
    } // first byte is 40 * value1 + value2


    var b = bytes.getByte();
    oid = Math.floor(b / 40) + '.' + b % 40; // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value

    var value = 0;

    while (bytes.length() > 0) {
      b = bytes.getByte();
      value = value << 7; // not the last byte for the value

      if (b & 0x80) {
        value += b & 0x7F;
      } else {
        // last byte
        oid += '.' + (value + b);
        value = 0;
      }
    }

    return oid;
  };
  /**
   * Converts a UTCTime value to a date.
   *
   * Note: GeneralizedTime has 4 digits for the year and is used for X.509
   * dates past 2049. Parsing that structure hasn't been implemented yet.
   *
   * @param utc the UTCTime value to convert.
   *
   * @return the date.
   */


  asn1.utcTimeToDate = function (utc) {
    /* The following formats can be used:
       YYMMDDhhmmZ
      YYMMDDhhmm+hh'mm'
      YYMMDDhhmm-hh'mm'
      YYMMDDhhmmssZ
      YYMMDDhhmmss+hh'mm'
      YYMMDDhhmmss-hh'mm'
       Where:
       YY is the least significant two digits of the year
      MM is the month (01 to 12)
      DD is the day (01 to 31)
      hh is the hour (00 to 23)
      mm are the minutes (00 to 59)
      ss are the seconds (00 to 59)
      Z indicates that local time is GMT, + indicates that local time is
      later than GMT, and - indicates that local time is earlier than GMT
      hh' is the absolute value of the offset from GMT in hours
      mm' is the absolute value of the offset from GMT in minutes */
    var date = new Date(); // if YY >= 50 use 19xx, if YY < 50 use 20xx

    var year = parseInt(utc.substr(0, 2), 10);
    year = year >= 50 ? 1900 + year : 2000 + year;
    var MM = parseInt(utc.substr(2, 2), 10) - 1; // use 0-11 for month

    var DD = parseInt(utc.substr(4, 2), 10);
    var hh = parseInt(utc.substr(6, 2), 10);
    var mm = parseInt(utc.substr(8, 2), 10);
    var ss = 0; // not just YYMMDDhhmmZ

    if (utc.length > 11) {
      // get character after minutes
      var c = utc.charAt(10);
      var end = 10; // see if seconds are present

      if (c !== '+' && c !== '-') {
        // get seconds
        ss = parseInt(utc.substr(10, 2), 10);
        end += 2;
      }
    } // update date


    date.setUTCFullYear(year, MM, DD);
    date.setUTCHours(hh, mm, ss, 0);

    if (end) {
      // get +/- after end of time
      c = utc.charAt(end);

      if (c === '+' || c === '-') {
        // get hours+minutes offset
        var hhoffset = parseInt(utc.substr(end + 1, 2), 10);
        var mmoffset = parseInt(utc.substr(end + 4, 2), 10); // calculate offset in milliseconds

        var offset = hhoffset * 60 + mmoffset;
        offset *= 60000; // apply offset

        if (c === '+') {
          date.setTime(+date - offset);
        } else {
          date.setTime(+date + offset);
        }
      }
    }

    return date;
  };
  /**
   * Converts a GeneralizedTime value to a date.
   *
   * @param gentime the GeneralizedTime value to convert.
   *
   * @return the date.
   */


  asn1.generalizedTimeToDate = function (gentime) {
    /* The following formats can be used:
       YYYYMMDDHHMMSS
      YYYYMMDDHHMMSS.fff
      YYYYMMDDHHMMSSZ
      YYYYMMDDHHMMSS.fffZ
      YYYYMMDDHHMMSS+hh'mm'
      YYYYMMDDHHMMSS.fff+hh'mm'
      YYYYMMDDHHMMSS-hh'mm'
      YYYYMMDDHHMMSS.fff-hh'mm'
       Where:
       YYYY is the year
      MM is the month (01 to 12)
      DD is the day (01 to 31)
      hh is the hour (00 to 23)
      mm are the minutes (00 to 59)
      ss are the seconds (00 to 59)
      .fff is the second fraction, accurate to three decimal places
      Z indicates that local time is GMT, + indicates that local time is
      later than GMT, and - indicates that local time is earlier than GMT
      hh' is the absolute value of the offset from GMT in hours
      mm' is the absolute value of the offset from GMT in minutes */
    var date = new Date();
    var YYYY = parseInt(gentime.substr(0, 4), 10);
    var MM = parseInt(gentime.substr(4, 2), 10) - 1; // use 0-11 for month

    var DD = parseInt(gentime.substr(6, 2), 10);
    var hh = parseInt(gentime.substr(8, 2), 10);
    var mm = parseInt(gentime.substr(10, 2), 10);
    var ss = parseInt(gentime.substr(12, 2), 10);
    var fff = 0;
    var offset = 0;
    var isUTC = false;

    if (gentime.charAt(gentime.length - 1) === 'Z') {
      isUTC = true;
    }

    var end = gentime.length - 5,
        c = gentime.charAt(end);

    if (c === '+' || c === '-') {
      // get hours+minutes offset
      var hhoffset = parseInt(gentime.substr(end + 1, 2), 10);
      var mmoffset = parseInt(gentime.substr(end + 4, 2), 10); // calculate offset in milliseconds

      offset = hhoffset * 60 + mmoffset;
      offset *= 60000; // apply offset

      if (c === '+') {
        offset *= -1;
      }

      isUTC = true;
    } // check for second fraction


    if (gentime.charAt(14) === '.') {
      fff = parseFloat(gentime.substr(14), 10) * 1000;
    }

    if (isUTC) {
      date.setUTCFullYear(YYYY, MM, DD);
      date.setUTCHours(hh, mm, ss, fff); // apply offset

      date.setTime(+date + offset);
    } else {
      date.setFullYear(YYYY, MM, DD);
      date.setHours(hh, mm, ss, fff);
    }

    return date;
  };
  /**
   * Converts a date to a UTCTime value.
   *
   * Note: GeneralizedTime has 4 digits for the year and is used for X.509
   * dates past 2049. Converting to a GeneralizedTime hasn't been
   * implemented yet.
   *
   * @param date the date to convert.
   *
   * @return the UTCTime value.
   */


  asn1.dateToUtcTime = function (date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === 'string') {
      return date;
    }

    var rval = ''; // create format YYMMDDhhmmssZ

    var format = [];
    format.push(('' + date.getUTCFullYear()).substr(2));
    format.push('' + (date.getUTCMonth() + 1));
    format.push('' + date.getUTCDate());
    format.push('' + date.getUTCHours());
    format.push('' + date.getUTCMinutes());
    format.push('' + date.getUTCSeconds()); // ensure 2 digits are used for each format entry

    for (var i = 0; i < format.length; ++i) {
      if (format[i].length < 2) {
        rval += '0';
      }

      rval += format[i];
    }

    rval += 'Z';
    return rval;
  };
  /**
   * Converts a date to a GeneralizedTime value.
   *
   * @param date the date to convert.
   *
   * @return the GeneralizedTime value as a string.
   */


  asn1.dateToGeneralizedTime = function (date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === 'string') {
      return date;
    }

    var rval = ''; // create format YYYYMMDDHHMMSSZ

    var format = [];
    format.push('' + date.getUTCFullYear());
    format.push('' + (date.getUTCMonth() + 1));
    format.push('' + date.getUTCDate());
    format.push('' + date.getUTCHours());
    format.push('' + date.getUTCMinutes());
    format.push('' + date.getUTCSeconds()); // ensure 2 digits are used for each format entry

    for (var i = 0; i < format.length; ++i) {
      if (format[i].length < 2) {
        rval += '0';
      }

      rval += format[i];
    }

    rval += 'Z';
    return rval;
  };
  /**
   * Converts a javascript integer to a DER-encoded byte buffer to be used
   * as the value for an INTEGER type.
   *
   * @param x the integer.
   *
   * @return the byte buffer.
   */


  asn1.integerToDer = function (x) {
    var rval = forge.util.createBuffer();

    if (x >= -0x80 && x < 0x80) {
      return rval.putSignedInt(x, 8);
    }

    if (x >= -0x8000 && x < 0x8000) {
      return rval.putSignedInt(x, 16);
    }

    if (x >= -0x800000 && x < 0x800000) {
      return rval.putSignedInt(x, 24);
    }

    if (x >= -0x80000000 && x < 0x80000000) {
      return rval.putSignedInt(x, 32);
    }

    var error = new Error('Integer too large; max is 32-bits.');
    error.integer = x;
    throw error;
  };
  /**
   * Converts a DER-encoded byte buffer to a javascript integer. This is
   * typically used to decode the value of an INTEGER type.
   *
   * @param bytes the byte buffer.
   *
   * @return the integer.
   */


  asn1.derToInteger = function (bytes) {
    // wrap in buffer if needed
    if (typeof bytes === 'string') {
      bytes = forge.util.createBuffer(bytes);
    }

    var n = bytes.length() * 8;

    if (n > 32) {
      throw new Error('Integer too large; max is 32-bits.');
    }

    return bytes.getSignedInt(n);
  };
  /**
   * Validates that the given ASN.1 object is at least a super set of the
   * given ASN.1 structure. Only tag classes and types are checked. An
   * optional map may also be provided to capture ASN.1 values while the
   * structure is checked.
   *
   * To capture an ASN.1 value, set an object in the validator's 'capture'
   * parameter to the key to use in the capture map. To capture the full
   * ASN.1 object, specify 'captureAsn1'. To capture BIT STRING bytes, including
   * the leading unused bits counter byte, specify 'captureBitStringContents'.
   * To capture BIT STRING bytes, without the leading unused bits counter byte,
   * specify 'captureBitStringValue'.
   *
   * Objects in the validator may set a field 'optional' to true to indicate
   * that it isn't necessary to pass validation.
   *
   * @param obj the ASN.1 object to validate.
   * @param v the ASN.1 structure validator.
   * @param capture an optional map to capture values in.
   * @param errors an optional array for storing validation errors.
   *
   * @return true on success, false on failure.
   */


  asn1.validate = function (obj, v, capture, errors) {
    var rval = false; // ensure tag class and type are the same if specified

    if ((obj.tagClass === v.tagClass || typeof v.tagClass === 'undefined') && (obj.type === v.type || typeof v.type === 'undefined')) {
      // ensure constructed flag is the same if specified
      if (obj.constructed === v.constructed || typeof v.constructed === 'undefined') {
        rval = true; // handle sub values

        if (v.value && forge.util.isArray(v.value)) {
          var j = 0;

          for (var i = 0; rval && i < v.value.length; ++i) {
            rval = v.value[i].optional || false;

            if (obj.value[j]) {
              rval = asn1.validate(obj.value[j], v.value[i], capture, errors);

              if (rval) {
                ++j;
              } else if (v.value[i].optional) {
                rval = true;
              }
            }

            if (!rval && errors) {
              errors.push('[' + v.name + '] ' + 'Tag class "' + v.tagClass + '", type "' + v.type + '" expected value length "' + v.value.length + '", got "' + obj.value.length + '"');
            }
          }
        }

        if (rval && capture) {
          if (v.capture) {
            capture[v.capture] = obj.value;
          }

          if (v.captureAsn1) {
            capture[v.captureAsn1] = obj;
          }

          if (v.captureBitStringContents && 'bitStringContents' in obj) {
            capture[v.captureBitStringContents] = obj.bitStringContents;
          }

          if (v.captureBitStringValue && 'bitStringContents' in obj) {
            var value;

            if (obj.bitStringContents.length < 2) {
              capture[v.captureBitStringValue] = '';
            } else {
              // FIXME: support unused bits with data shifting
              var unused = obj.bitStringContents.charCodeAt(0);

              if (unused !== 0) {
                throw new Error('captureBitStringValue only supported for zero unused bits');
              }

              capture[v.captureBitStringValue] = obj.bitStringContents.slice(1);
            }
          }
        }
      } else if (errors) {
        errors.push('[' + v.name + '] ' + 'Expected constructed "' + v.constructed + '", got "' + obj.constructed + '"');
      }
    } else if (errors) {
      if (obj.tagClass !== v.tagClass) {
        errors.push('[' + v.name + '] ' + 'Expected tag class "' + v.tagClass + '", got "' + obj.tagClass + '"');
      }

      if (obj.type !== v.type) {
        errors.push('[' + v.name + '] ' + 'Expected type "' + v.type + '", got "' + obj.type + '"');
      }
    }

    return rval;
  }; // regex for testing for non-latin characters


  var _nonLatinRegex = /[^\\u0000-\\u00ff]/;
  /**
   * Pretty prints an ASN.1 object to a string.
   *
   * @param obj the object to write out.
   * @param level the level in the tree.
   * @param indentation the indentation to use.
   *
   * @return the string.
   */

  asn1.prettyPrint = function (obj, level, indentation) {
    var rval = ''; // set default level and indentation

    level = level || 0;
    indentation = indentation || 2; // start new line for deep levels

    if (level > 0) {
      rval += '\n';
    } // create indent


    var indent = '';

    for (var i = 0; i < level * indentation; ++i) {
      indent += ' ';
    } // print class:type


    rval += indent + 'Tag: ';

    switch (obj.tagClass) {
      case asn1.Class.UNIVERSAL:
        rval += 'Universal:';
        break;

      case asn1.Class.APPLICATION:
        rval += 'Application:';
        break;

      case asn1.Class.CONTEXT_SPECIFIC:
        rval += 'Context-Specific:';
        break;

      case asn1.Class.PRIVATE:
        rval += 'Private:';
        break;
    }

    if (obj.tagClass === asn1.Class.UNIVERSAL) {
      rval += obj.type; // known types

      switch (obj.type) {
        case asn1.Type.NONE:
          rval += ' (None)';
          break;

        case asn1.Type.BOOLEAN:
          rval += ' (Boolean)';
          break;

        case asn1.Type.INTEGER:
          rval += ' (Integer)';
          break;

        case asn1.Type.BITSTRING:
          rval += ' (Bit string)';
          break;

        case asn1.Type.OCTETSTRING:
          rval += ' (Octet string)';
          break;

        case asn1.Type.NULL:
          rval += ' (Null)';
          break;

        case asn1.Type.OID:
          rval += ' (Object Identifier)';
          break;

        case asn1.Type.ODESC:
          rval += ' (Object Descriptor)';
          break;

        case asn1.Type.EXTERNAL:
          rval += ' (External or Instance of)';
          break;

        case asn1.Type.REAL:
          rval += ' (Real)';
          break;

        case asn1.Type.ENUMERATED:
          rval += ' (Enumerated)';
          break;

        case asn1.Type.EMBEDDED:
          rval += ' (Embedded PDV)';
          break;

        case asn1.Type.UTF8:
          rval += ' (UTF8)';
          break;

        case asn1.Type.ROID:
          rval += ' (Relative Object Identifier)';
          break;

        case asn1.Type.SEQUENCE:
          rval += ' (Sequence)';
          break;

        case asn1.Type.SET:
          rval += ' (Set)';
          break;

        case asn1.Type.PRINTABLESTRING:
          rval += ' (Printable String)';
          break;

        case asn1.Type.IA5String:
          rval += ' (IA5String (ASCII))';
          break;

        case asn1.Type.UTCTIME:
          rval += ' (UTC time)';
          break;

        case asn1.Type.GENERALIZEDTIME:
          rval += ' (Generalized time)';
          break;

        case asn1.Type.BMPSTRING:
          rval += ' (BMP String)';
          break;
      }
    } else {
      rval += obj.type;
    }

    rval += '\n';
    rval += indent + 'Constructed: ' + obj.constructed + '\n';

    if (obj.composed) {
      var subvalues = 0;
      var sub = '';

      for (var i = 0; i < obj.value.length; ++i) {
        if (obj.value[i] !== undefined) {
          subvalues += 1;
          sub += asn1.prettyPrint(obj.value[i], level + 1, indentation);

          if (i + 1 < obj.value.length) {
            sub += ',';
          }
        }
      }

      rval += indent + 'Sub values: ' + subvalues + sub;
    } else {
      rval += indent + 'Value: ';

      if (obj.type === asn1.Type.OID) {
        var oid = asn1.derToOid(obj.value);
        rval += oid;

        if (forge.pki && forge.pki.oids) {
          if (oid in forge.pki.oids) {
            rval += ' (' + forge.pki.oids[oid] + ') ';
          }
        }
      }

      if (obj.type === asn1.Type.INTEGER) {
        try {
          rval += asn1.derToInteger(obj.value);
        } catch (ex) {
          rval += '0x' + forge.util.bytesToHex(obj.value);
        }
      } else if (obj.type === asn1.Type.BITSTRING) {
        // TODO: shift bits as needed to display without padding
        if (obj.value.length > 1) {
          // remove unused bits field
          rval += '0x' + forge.util.bytesToHex(obj.value.slice(1));
        } else {
          rval += '(none)';
        } // show unused bit count


        if (obj.value.length > 0) {
          var unused = obj.value.charCodeAt(0);

          if (unused == 1) {
            rval += ' (1 unused bit shown)';
          } else if (unused > 1) {
            rval += ' (' + unused + ' unused bits shown)';
          }
        }
      } else if (obj.type === asn1.Type.OCTETSTRING) {
        if (!_nonLatinRegex.test(obj.value)) {
          rval += '(' + obj.value + ') ';
        }

        rval += '0x' + forge.util.bytesToHex(obj.value);
      } else if (obj.type === asn1.Type.UTF8) {
        rval += forge.util.decodeUtf8(obj.value);
      } else if (obj.type === asn1.Type.PRINTABLESTRING || obj.type === asn1.Type.IA5String) {
        rval += obj.value;
      } else if (_nonLatinRegex.test(obj.value)) {
        rval += '0x' + forge.util.bytesToHex(obj.value);
      } else if (obj.value.length === 0) {
        rval += '[null]';
      } else {
        rval += obj.value;
      }
    }

    return rval;
  };
  /***/

},
/* 47 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * An API for getting cryptographically-secure random bytes. The bytes are
   * generated using the Fortuna algorithm devised by Bruce Schneier and
   * Niels Ferguson.
   *
   * Getting strong random bytes is not yet easy to do in javascript. The only
   * truish random entropy that can be collected is from the mouse, keyboard, or
   * from timing with respect to page loads, etc. This generator makes a poor
   * attempt at providing random bytes when those sources haven't yet provided
   * enough entropy to initially seed or to reseed the PRNG.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2009-2014 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(79);

  __webpack_require__(230);

  __webpack_require__(229);

  __webpack_require__(8);

  (function () {
    // forge.random already defined
    if (forge.random && forge.random.getBytes) {
      module.exports = forge.random;
      return;
    }

    (function (jQuery) {
      // the default prng plugin, uses AES-128
      var prng_aes = {};

      var _prng_aes_output = new Array(4);

      var _prng_aes_buffer = forge.util.createBuffer();

      prng_aes.formatKey = function (key) {
        // convert the key into 32-bit integers
        var tmp = forge.util.createBuffer(key);
        key = new Array(4);
        key[0] = tmp.getInt32();
        key[1] = tmp.getInt32();
        key[2] = tmp.getInt32();
        key[3] = tmp.getInt32(); // return the expanded key

        return forge.aes._expandKey(key, false);
      };

      prng_aes.formatSeed = function (seed) {
        // convert seed into 32-bit integers
        var tmp = forge.util.createBuffer(seed);
        seed = new Array(4);
        seed[0] = tmp.getInt32();
        seed[1] = tmp.getInt32();
        seed[2] = tmp.getInt32();
        seed[3] = tmp.getInt32();
        return seed;
      };

      prng_aes.cipher = function (key, seed) {
        forge.aes._updateBlock(key, seed, _prng_aes_output, false);

        _prng_aes_buffer.putInt32(_prng_aes_output[0]);

        _prng_aes_buffer.putInt32(_prng_aes_output[1]);

        _prng_aes_buffer.putInt32(_prng_aes_output[2]);

        _prng_aes_buffer.putInt32(_prng_aes_output[3]);

        return _prng_aes_buffer.getBytes();
      };

      prng_aes.increment = function (seed) {
        // FIXME: do we care about carry or signed issues?
        ++seed[3];
        return seed;
      };

      prng_aes.md = forge.md.sha256;
      /**
       * Creates a new PRNG.
       */

      function spawnPrng() {
        var ctx = forge.prng.create(prng_aes);
        /**
         * Gets random bytes. If a native secure crypto API is unavailable, this
         * method tries to make the bytes more unpredictable by drawing from data that
         * can be collected from the user of the browser, eg: mouse movement.
         *
         * If a callback is given, this method will be called asynchronously.
         *
         * @param count the number of random bytes to get.
         * @param [callback(err, bytes)] called once the operation completes.
         *
         * @return the random bytes in a string.
         */

        ctx.getBytes = function (count, callback) {
          return ctx.generate(count, callback);
        };
        /**
         * Gets random bytes asynchronously. If a native secure crypto API is
         * unavailable, this method tries to make the bytes more unpredictable by
         * drawing from data that can be collected from the user of the browser,
         * eg: mouse movement.
         *
         * @param count the number of random bytes to get.
         *
         * @return the random bytes in a string.
         */


        ctx.getBytesSync = function (count) {
          return ctx.generate(count);
        };

        return ctx;
      } // create default prng context


      var _ctx = spawnPrng(); // add other sources of entropy only if window.crypto.getRandomValues is not
      // available -- otherwise this source will be automatically used by the prng


      var getRandomValues = null;

      if (typeof window !== 'undefined') {
        var _crypto = window.crypto || window.msCrypto;

        if (_crypto && _crypto.getRandomValues) {
          getRandomValues = function getRandomValues(arr) {
            return _crypto.getRandomValues(arr);
          };
        }
      }

      if (forge.options.usePureJavaScript || !forge.util.isNodejs && !getRandomValues) {
        // if this is a web worker, do not use weak entropy, instead register to
        // receive strong entropy asynchronously from the main thread
        if (typeof window === 'undefined' || window.document === undefined) {} // FIXME:
        // get load time entropy


        _ctx.collectInt(+new Date(), 32); // add some entropy from navigator object


        if (typeof navigator !== 'undefined') {
          var _navBytes = '';

          for (var key in navigator) {
            try {
              if (typeof navigator[key] == 'string') {
                _navBytes += navigator[key];
              }
            } catch (e) {
              /* Some navigator keys might not be accessible, e.g. the geolocation
                attribute throws an exception if touched in Mozilla chrome://
                context.
                 Silently ignore this and just don't use this as a source of
                entropy. */
            }
          }

          _ctx.collect(_navBytes);

          _navBytes = null;
        } // add mouse and keyboard collectors if jquery is available


        if (jQuery) {
          // set up mouse entropy capture
          jQuery().mousemove(function (e) {
            // add mouse coords
            _ctx.collectInt(e.clientX, 16);

            _ctx.collectInt(e.clientY, 16);
          }); // set up keyboard entropy capture

          jQuery().keypress(function (e) {
            _ctx.collectInt(e.charCode, 8);
          });
        }
      }
      /* Random API */


      if (!forge.random) {
        forge.random = _ctx;
      } else {
        // extend forge.random with _ctx
        for (var key in _ctx) {
          forge.random[key] = _ctx[key];
        }
      } // expose spawn PRNG


      forge.random.createInstance = spawnPrng;
      module.exports = forge.random;
    })(typeof jQuery !== 'undefined' ? jQuery : null);
  })();
  /***/

},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * util/utf8.js - Implementation of UTF-8 Encoder/Decoder
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var partialRight = __webpack_require__(500),
        merge = __webpack_require__(499);

    var typedArrayCtors = function () {
      var ctors = [];

      if ("undefined" !== typeof Uint8ClampedArray) {
        ctors.push(Uint8ClampedArray);
      }

      if ("undefined" !== typeof Uint8Array) {
        ctors.push(Uint8Array);
      }

      if ("undefined" !== typeof Uint16Array) {
        ctors.push(Uint16Array);
      }

      if ("undefined" !== typeof Uint32Array) {
        ctors.push(Uint32Array);
      }

      if ("undefined" !== typeof Float32Array) {
        ctors.push(Float32Array);
      }

      if ("undefined" !== typeof Float64Array) {
        ctors.push(Float64Array);
      }

      return ctors;
    }();

    function findTypedArrayFor(ta) {
      var ctor;

      for (var idx = 0; !ctor && typedArrayCtors.length > idx; idx++) {
        if (ta instanceof typedArrayCtors[idx]) {
          ctor = typedArrayCtors[idx];
        }
      }

      return ctor;
    }

    function mergeBuffer(a, b) {
      // TODO: should this be a copy, or the reference itself?
      if (Buffer.isBuffer(b)) {
        b = Buffer.from(b);
      } else {
        var Ctor = findTypedArrayFor(b);
        b = Ctor ? new Ctor(b, b.byteOffset, b.byteLength) : undefined;
      } // TODO: QUESTION: create a merged <whatever-a-is>??
      // for now, a is b


      a = b;
      return b;
    }

    module.exports = partialRight(merge, mergeBuffer);
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 49 */

/***/
function (module, exports) {
  module.exports = function (it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
      throw TypeError(name + ': incorrect invocation!');
    }

    return it;
  };
  /***/

},
/* 50 */

/***/
function (module, exports, __webpack_require__) {
  var ctx = __webpack_require__(28);

  var call = __webpack_require__(175);

  var isArrayIter = __webpack_require__(117);

  var anObject = __webpack_require__(2);

  var toLength = __webpack_require__(13);

  var getIterFn = __webpack_require__(134);

  var BREAK = {};
  var RETURN = {};

  var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function () {
      return iterable;
    } : getIterFn(iterable);
    var f = ctx(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!'); // fast case for arrays with default iterator

    if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
      result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
      if (result === BREAK || result === RETURN) return result;
    } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
      result = call(iterator, f, step.value, entries);
      if (result === BREAK || result === RETURN) return result;
    }
  };

  exports.BREAK = BREAK;
  exports.RETURN = RETURN;
  /***/
},
/* 51 */

/***/
function (module, exports) {
  module.exports = false;
  /***/
},
/* 52 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  var anObject = __webpack_require__(2);

  var dPs = __webpack_require__(181);

  var enumBugKeys = __webpack_require__(113);

  var IE_PROTO = __webpack_require__(125)('IE_PROTO');

  var Empty = function Empty() {
    /* empty */
  };

  var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

  var _createDict = function createDict() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = __webpack_require__(112)('iframe');

    var i = enumBugKeys.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';

    __webpack_require__(115).appendChild(iframe);

    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);

    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    _createDict = iframeDocument.F;

    while (i--) {
      delete _createDict[PROTOTYPE][enumBugKeys[i]];
    }

    return _createDict();
  };

  module.exports = Object.create || function create(O, Properties) {
    var result;

    if (O !== null) {
      Empty[PROTOTYPE] = anObject(O);
      result = new Empty();
      Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

      result[IE_PROTO] = O;
    } else result = _createDict();

    return Properties === undefined ? result : dPs(result, Properties);
  };
  /***/

},
/* 53 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
  var $keys = __webpack_require__(183);

  var hiddenKeys = __webpack_require__(113).concat('length', 'prototype');

  exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $keys(O, hiddenKeys);
  };
  /***/

},
/* 54 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
  var $keys = __webpack_require__(183);

  var enumBugKeys = __webpack_require__(113);

  module.exports = Object.keys || function keys(O) {
    return $keys(O, enumBugKeys);
  };
  /***/

},
/* 55 */

/***/
function (module, exports) {
  module.exports = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };
  /***/

},
/* 56 */

/***/
function (module, exports, __webpack_require__) {
  var redefine = __webpack_require__(21);

  module.exports = function (target, src, safe) {
    for (var key in src) {
      redefine(target, key, src[key], safe);
    }

    return target;
  };
  /***/

},
/* 57 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(3);

  var dP = __webpack_require__(12);

  var DESCRIPTORS = __webpack_require__(11);

  var SPECIES = __webpack_require__(9)('species');

  module.exports = function (KEY) {
    var C = global[KEY];
    if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
      configurable: true,
      get: function get() {
        return this;
      }
    });
  };
  /***/

},
/* 58 */

/***/
function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(35);

  var max = Math.max;
  var min = Math.min;

  module.exports = function (index, length) {
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
  };
  /***/

},
/* 59 */

/***/
function (module, exports) {
  var id = 0;
  var px = Math.random();

  module.exports = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };
  /***/

},
/* 60 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Node.js module for Forge message digests.
   *
   * @author Dave Longley
   *
   * Copyright 2011-2017 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  module.exports = forge.md = forge.md || {};
  forge.md.algorithms = forge.md.algorithms || {};
  /***/
},
/* 61 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Object IDs for ASN.1.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2013 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  forge.pki = forge.pki || {};
  var oids = module.exports = forge.pki.oids = forge.oids = forge.oids || {}; // set id to name mapping and name to id mapping

  function _IN(id, name) {
    oids[id] = name;
    oids[name] = id;
  } // set id to name mapping only


  function _I_(id, name) {
    oids[id] = name;
  } // algorithm OIDs


  _IN('1.2.840.113549.1.1.1', 'rsaEncryption'); // Note: md2 & md4 not implemented
  //_IN('1.2.840.113549.1.1.2', 'md2WithRSAEncryption');
  //_IN('1.2.840.113549.1.1.3', 'md4WithRSAEncryption');


  _IN('1.2.840.113549.1.1.4', 'md5WithRSAEncryption');

  _IN('1.2.840.113549.1.1.5', 'sha1WithRSAEncryption');

  _IN('1.2.840.113549.1.1.7', 'RSAES-OAEP');

  _IN('1.2.840.113549.1.1.8', 'mgf1');

  _IN('1.2.840.113549.1.1.9', 'pSpecified');

  _IN('1.2.840.113549.1.1.10', 'RSASSA-PSS');

  _IN('1.2.840.113549.1.1.11', 'sha256WithRSAEncryption');

  _IN('1.2.840.113549.1.1.12', 'sha384WithRSAEncryption');

  _IN('1.2.840.113549.1.1.13', 'sha512WithRSAEncryption');

  _IN('1.2.840.10040.4.3', 'dsa-with-sha1');

  _IN('1.3.14.3.2.7', 'desCBC');

  _IN('1.3.14.3.2.26', 'sha1');

  _IN('2.16.840.1.101.3.4.2.1', 'sha256');

  _IN('2.16.840.1.101.3.4.2.2', 'sha384');

  _IN('2.16.840.1.101.3.4.2.3', 'sha512');

  _IN('1.2.840.113549.2.5', 'md5'); // pkcs#7 content types


  _IN('1.2.840.113549.1.7.1', 'data');

  _IN('1.2.840.113549.1.7.2', 'signedData');

  _IN('1.2.840.113549.1.7.3', 'envelopedData');

  _IN('1.2.840.113549.1.7.4', 'signedAndEnvelopedData');

  _IN('1.2.840.113549.1.7.5', 'digestedData');

  _IN('1.2.840.113549.1.7.6', 'encryptedData'); // pkcs#9 oids


  _IN('1.2.840.113549.1.9.1', 'emailAddress');

  _IN('1.2.840.113549.1.9.2', 'unstructuredName');

  _IN('1.2.840.113549.1.9.3', 'contentType');

  _IN('1.2.840.113549.1.9.4', 'messageDigest');

  _IN('1.2.840.113549.1.9.5', 'signingTime');

  _IN('1.2.840.113549.1.9.6', 'counterSignature');

  _IN('1.2.840.113549.1.9.7', 'challengePassword');

  _IN('1.2.840.113549.1.9.8', 'unstructuredAddress');

  _IN('1.2.840.113549.1.9.14', 'extensionRequest');

  _IN('1.2.840.113549.1.9.20', 'friendlyName');

  _IN('1.2.840.113549.1.9.21', 'localKeyId');

  _IN('1.2.840.113549.1.9.22.1', 'x509Certificate'); // pkcs#12 safe bags


  _IN('1.2.840.113549.1.12.10.1.1', 'keyBag');

  _IN('1.2.840.113549.1.12.10.1.2', 'pkcs8ShroudedKeyBag');

  _IN('1.2.840.113549.1.12.10.1.3', 'certBag');

  _IN('1.2.840.113549.1.12.10.1.4', 'crlBag');

  _IN('1.2.840.113549.1.12.10.1.5', 'secretBag');

  _IN('1.2.840.113549.1.12.10.1.6', 'safeContentsBag'); // password-based-encryption for pkcs#12


  _IN('1.2.840.113549.1.5.13', 'pkcs5PBES2');

  _IN('1.2.840.113549.1.5.12', 'pkcs5PBKDF2');

  _IN('1.2.840.113549.1.12.1.1', 'pbeWithSHAAnd128BitRC4');

  _IN('1.2.840.113549.1.12.1.2', 'pbeWithSHAAnd40BitRC4');

  _IN('1.2.840.113549.1.12.1.3', 'pbeWithSHAAnd3-KeyTripleDES-CBC');

  _IN('1.2.840.113549.1.12.1.4', 'pbeWithSHAAnd2-KeyTripleDES-CBC');

  _IN('1.2.840.113549.1.12.1.5', 'pbeWithSHAAnd128BitRC2-CBC');

  _IN('1.2.840.113549.1.12.1.6', 'pbewithSHAAnd40BitRC2-CBC'); // hmac OIDs


  _IN('1.2.840.113549.2.7', 'hmacWithSHA1');

  _IN('1.2.840.113549.2.8', 'hmacWithSHA224');

  _IN('1.2.840.113549.2.9', 'hmacWithSHA256');

  _IN('1.2.840.113549.2.10', 'hmacWithSHA384');

  _IN('1.2.840.113549.2.11', 'hmacWithSHA512'); // symmetric key algorithm oids


  _IN('1.2.840.113549.3.7', 'des-EDE3-CBC');

  _IN('2.16.840.1.101.3.4.1.2', 'aes128-CBC');

  _IN('2.16.840.1.101.3.4.1.22', 'aes192-CBC');

  _IN('2.16.840.1.101.3.4.1.42', 'aes256-CBC'); // certificate issuer/subject OIDs


  _IN('2.5.4.3', 'commonName');

  _IN('2.5.4.5', 'serialName');

  _IN('2.5.4.6', 'countryName');

  _IN('2.5.4.7', 'localityName');

  _IN('2.5.4.8', 'stateOrProvinceName');

  _IN('2.5.4.10', 'organizationName');

  _IN('2.5.4.11', 'organizationalUnitName'); // X.509 extension OIDs


  _IN('2.16.840.1.113730.1.1', 'nsCertType');

  _I_('2.5.29.1', 'authorityKeyIdentifier'); // deprecated, use .35


  _I_('2.5.29.2', 'keyAttributes'); // obsolete use .37 or .15


  _I_('2.5.29.3', 'certificatePolicies'); // deprecated, use .32


  _I_('2.5.29.4', 'keyUsageRestriction'); // obsolete use .37 or .15


  _I_('2.5.29.5', 'policyMapping'); // deprecated use .33


  _I_('2.5.29.6', 'subtreesConstraint'); // obsolete use .30


  _I_('2.5.29.7', 'subjectAltName'); // deprecated use .17


  _I_('2.5.29.8', 'issuerAltName'); // deprecated use .18


  _I_('2.5.29.9', 'subjectDirectoryAttributes');

  _I_('2.5.29.10', 'basicConstraints'); // deprecated use .19


  _I_('2.5.29.11', 'nameConstraints'); // deprecated use .30


  _I_('2.5.29.12', 'policyConstraints'); // deprecated use .36


  _I_('2.5.29.13', 'basicConstraints'); // deprecated use .19


  _IN('2.5.29.14', 'subjectKeyIdentifier');

  _IN('2.5.29.15', 'keyUsage');

  _I_('2.5.29.16', 'privateKeyUsagePeriod');

  _IN('2.5.29.17', 'subjectAltName');

  _IN('2.5.29.18', 'issuerAltName');

  _IN('2.5.29.19', 'basicConstraints');

  _I_('2.5.29.20', 'cRLNumber');

  _I_('2.5.29.21', 'cRLReason');

  _I_('2.5.29.22', 'expirationDate');

  _I_('2.5.29.23', 'instructionCode');

  _I_('2.5.29.24', 'invalidityDate');

  _I_('2.5.29.25', 'cRLDistributionPoints'); // deprecated use .31


  _I_('2.5.29.26', 'issuingDistributionPoint'); // deprecated use .28


  _I_('2.5.29.27', 'deltaCRLIndicator');

  _I_('2.5.29.28', 'issuingDistributionPoint');

  _I_('2.5.29.29', 'certificateIssuer');

  _I_('2.5.29.30', 'nameConstraints');

  _IN('2.5.29.31', 'cRLDistributionPoints');

  _IN('2.5.29.32', 'certificatePolicies');

  _I_('2.5.29.33', 'policyMappings');

  _I_('2.5.29.34', 'policyConstraints'); // deprecated use .36


  _IN('2.5.29.35', 'authorityKeyIdentifier');

  _I_('2.5.29.36', 'policyConstraints');

  _IN('2.5.29.37', 'extKeyUsage');

  _I_('2.5.29.46', 'freshestCRL');

  _I_('2.5.29.54', 'inhibitAnyPolicy'); // extKeyUsage purposes


  _IN('1.3.6.1.4.1.11129.2.4.2', 'timestampList');

  _IN('1.3.6.1.5.5.7.1.1', 'authorityInfoAccess');

  _IN('1.3.6.1.5.5.7.3.1', 'serverAuth');

  _IN('1.3.6.1.5.5.7.3.2', 'clientAuth');

  _IN('1.3.6.1.5.5.7.3.3', 'codeSigning');

  _IN('1.3.6.1.5.5.7.3.4', 'emailProtection');

  _IN('1.3.6.1.5.5.7.3.8', 'timeStamping');
  /***/

},
/* 62 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  // a duplex stream is just a stream that is both readable and writable.
  // Since JS doesn't have multiple prototypal inheritance, this class
  // prototypally inherits from Readable, and then parasitically from
  // Writable.

  /*<replacement>*/

  var pna = __webpack_require__(83);
  /*</replacement>*/

  /*<replacement>*/


  var objectKeys = Object.keys || function (obj) {
    var keys = [];

    for (var key in obj) {
      keys.push(key);
    }

    return keys;
  };
  /*</replacement>*/


  module.exports = Duplex;
  /*<replacement>*/

  var util = __webpack_require__(78);

  util.inherits = __webpack_require__(37);
  /*</replacement>*/

  var Readable = __webpack_require__(242);

  var Writable = __webpack_require__(158);

  util.inherits(Duplex, Readable);
  {
    // avoid scope creep, the keys array can then be collected
    var keys = objectKeys(Writable.prototype);

    for (var v = 0; v < keys.length; v++) {
      var method = keys[v];
      if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
    }
  }

  function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', onend);
  }

  Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._writableState.highWaterMark;
    }
  }); // the no-half-open enforcer

  function onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.

    pna.nextTick(onEndNT, this);
  }

  function onEndNT(self) {
    self.end();
  }

  Object.defineProperty(Duplex.prototype, 'destroyed', {
    get: function get() {
      if (this._readableState === undefined || this._writableState === undefined) {
        return false;
      }

      return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
      // we ignore the value if the stream
      // has not been initialized yet
      if (this._readableState === undefined || this._writableState === undefined) {
        return;
      } // backward compatibility, the user is explicitly
      // managing destroyed


      this._readableState.destroyed = value;
      this._writableState.destroyed = value;
    }
  });

  Duplex.prototype._destroy = function (err, cb) {
    this.push(null);
    this.end();
    pna.nextTick(cb, err);
  };
  /***/

},
/* 63 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(242);
  exports.Stream = exports;
  exports.Readable = exports;
  exports.Writable = __webpack_require__(158);
  exports.Duplex = __webpack_require__(62);
  exports.Transform = __webpack_require__(243);
  exports.PassThrough = __webpack_require__(588);
  /***/
},
/* 64 */

/***/
function (module, exports) {
  module.exports = {};
  /***/
},
/* 65 */

/***/
function (module, exports, __webpack_require__) {
  var def = __webpack_require__(12).f;

  var has = __webpack_require__(23);

  var TAG = __webpack_require__(9)('toStringTag');

  module.exports = function (it, tag, stat) {
    if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
      configurable: true,
      value: tag
    });
  };
  /***/

},
/* 66 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var defined = __webpack_require__(33);

  var fails = __webpack_require__(5);

  var spaces = __webpack_require__(129);

  var space = '[' + spaces + ']';
  var non = "\u200B\x85";
  var ltrim = RegExp('^' + space + space + '*');
  var rtrim = RegExp(space + space + '*$');

  var exporter = function exporter(KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = fails(function () {
      return !!spaces[KEY]() || non[KEY]() != non;
    });
    var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    $export($export.P + $export.F * FORCE, 'String', exp);
  }; // 1 -> String#trimLeft
  // 2 -> String#trimRight
  // 3 -> String#trim


  var trim = exporter.trim = function (string, TYPE) {
    string = String(defined(string));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };

  module.exports = exporter;
  /***/
},
/* 67 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(7);

  module.exports = function (it, TYPE) {
    if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
  };
  /***/

},
/* 68 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var C_enc = C.enc;
      /**
       * Base64 encoding strategy.
       */

      var Base64 = C_enc.Base64 = {
        /**
         * Converts a word array to a Base64 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Base64 string.
         *
         * @static
         *
         * @example
         *
         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
          // Shortcuts
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var map = this._map; // Clamp excess bits

          wordArray.clamp(); // Convert

          var base64Chars = [];

          for (var i = 0; i < sigBytes; i += 3) {
            var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
            var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
            var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
            var triplet = byte1 << 16 | byte2 << 8 | byte3;

            for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
              base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
            }
          } // Add padding


          var paddingChar = map.charAt(64);

          if (paddingChar) {
            while (base64Chars.length % 4) {
              base64Chars.push(paddingChar);
            }
          }

          return base64Chars.join('');
        },

        /**
         * Converts a Base64 string to a word array.
         *
         * @param {string} base64Str The Base64 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
         */
        parse: function parse(base64Str) {
          // Shortcuts
          var base64StrLength = base64Str.length;
          var map = this._map; // Ignore padding

          var paddingChar = map.charAt(64);

          if (paddingChar) {
            var paddingIndex = base64Str.indexOf(paddingChar);

            if (paddingIndex != -1) {
              base64StrLength = paddingIndex;
            }
          } // Convert


          var words = [];
          var nBytes = 0;

          for (var i = 0; i < base64StrLength; i++) {
            if (i % 4) {
              var bits1 = map.indexOf(base64Str.charAt(i - 1)) << i % 4 * 2;
              var bits2 = map.indexOf(base64Str.charAt(i)) >>> 6 - i % 4 * 2;
              var bitsCombined = bits1 | bits2;
              words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
              nBytes++;
            }
          }

          return WordArray.create(words, nBytes);
        },
        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
      };
    })();

    return CryptoJS.enc.Base64;
  });
  /***/

},
/* 69 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(137), __webpack_require__(136));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./sha1", "./hmac"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var Base = C_lib.Base;
      var WordArray = C_lib.WordArray;
      var C_algo = C.algo;
      var MD5 = C_algo.MD5;
      /**
       * This key derivation function is meant to conform with EVP_BytesToKey.
       * www.openssl.org/docs/crypto/EVP_BytesToKey.html
       */

      var EvpKDF = C_algo.EvpKDF = Base.extend({
        /**
         * Configuration options.
         *
         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
         * @property {number} iterations The number of iterations to perform. Default: 1
         */
        cfg: Base.extend({
          keySize: 128 / 32,
          hasher: MD5,
          iterations: 1
        }),

        /**
         * Initializes a newly created key derivation function.
         *
         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
         *
         * @example
         *
         *     var kdf = CryptoJS.algo.EvpKDF.create();
         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
         */
        init: function init(cfg) {
          this.cfg = this.cfg.extend(cfg);
        },

        /**
         * Derives a key from a password.
         *
         * @param {WordArray|string} password The password.
         * @param {WordArray|string} salt A salt.
         *
         * @return {WordArray} The derived key.
         *
         * @example
         *
         *     var key = kdf.compute(password, salt);
         */
        compute: function compute(password, salt) {
          // Shortcut
          var cfg = this.cfg; // Init hasher

          var hasher = cfg.hasher.create(); // Initial values

          var derivedKey = WordArray.create(); // Shortcuts

          var derivedKeyWords = derivedKey.words;
          var keySize = cfg.keySize;
          var iterations = cfg.iterations; // Generate key

          while (derivedKeyWords.length < keySize) {
            if (block) {
              hasher.update(block);
            }

            var block = hasher.update(password).finalize(salt);
            hasher.reset(); // Iterations

            for (var i = 1; i < iterations; i++) {
              block = hasher.finalize(block);
              hasher.reset();
            }

            derivedKey.concat(block);
          }

          derivedKey.sigBytes = keySize * 4;
          return derivedKey;
        }
      });
      /**
       * Derives a key from a password.
       *
       * @param {WordArray|string} password The password.
       * @param {WordArray|string} salt A salt.
       * @param {Object} cfg (Optional) The configuration options to use for this computation.
       *
       * @return {WordArray} The derived key.
       *
       * @static
       *
       * @example
       *
       *     var key = CryptoJS.EvpKDF(password, salt);
       *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
       *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
       */

      C.EvpKDF = function (password, salt, cfg) {
        return EvpKDF.create(cfg).compute(password, salt);
      };
    })();

    return CryptoJS.EvpKDF;
  });
  /***/

},
/* 70 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function (Math) {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var Hasher = C_lib.Hasher;
      var C_algo = C.algo; // Constants table

      var T = []; // Compute constants

      (function () {
        for (var i = 0; i < 64; i++) {
          T[i] = Math.abs(Math.sin(i + 1)) * 0x100000000 | 0;
        }
      })();
      /**
       * MD5 hash algorithm.
       */


      var MD5 = C_algo.MD5 = Hasher.extend({
        _doReset: function _doReset() {
          this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476]);
        },
        _doProcessBlock: function _doProcessBlock(M, offset) {
          // Swap endian
          for (var i = 0; i < 16; i++) {
            // Shortcuts
            var offset_i = offset + i;
            var M_offset_i = M[offset_i];
            M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
          } // Shortcuts


          var H = this._hash.words;
          var M_offset_0 = M[offset + 0];
          var M_offset_1 = M[offset + 1];
          var M_offset_2 = M[offset + 2];
          var M_offset_3 = M[offset + 3];
          var M_offset_4 = M[offset + 4];
          var M_offset_5 = M[offset + 5];
          var M_offset_6 = M[offset + 6];
          var M_offset_7 = M[offset + 7];
          var M_offset_8 = M[offset + 8];
          var M_offset_9 = M[offset + 9];
          var M_offset_10 = M[offset + 10];
          var M_offset_11 = M[offset + 11];
          var M_offset_12 = M[offset + 12];
          var M_offset_13 = M[offset + 13];
          var M_offset_14 = M[offset + 14];
          var M_offset_15 = M[offset + 15]; // Working varialbes

          var a = H[0];
          var b = H[1];
          var c = H[2];
          var d = H[3]; // Computation

          a = FF(a, b, c, d, M_offset_0, 7, T[0]);
          d = FF(d, a, b, c, M_offset_1, 12, T[1]);
          c = FF(c, d, a, b, M_offset_2, 17, T[2]);
          b = FF(b, c, d, a, M_offset_3, 22, T[3]);
          a = FF(a, b, c, d, M_offset_4, 7, T[4]);
          d = FF(d, a, b, c, M_offset_5, 12, T[5]);
          c = FF(c, d, a, b, M_offset_6, 17, T[6]);
          b = FF(b, c, d, a, M_offset_7, 22, T[7]);
          a = FF(a, b, c, d, M_offset_8, 7, T[8]);
          d = FF(d, a, b, c, M_offset_9, 12, T[9]);
          c = FF(c, d, a, b, M_offset_10, 17, T[10]);
          b = FF(b, c, d, a, M_offset_11, 22, T[11]);
          a = FF(a, b, c, d, M_offset_12, 7, T[12]);
          d = FF(d, a, b, c, M_offset_13, 12, T[13]);
          c = FF(c, d, a, b, M_offset_14, 17, T[14]);
          b = FF(b, c, d, a, M_offset_15, 22, T[15]);
          a = GG(a, b, c, d, M_offset_1, 5, T[16]);
          d = GG(d, a, b, c, M_offset_6, 9, T[17]);
          c = GG(c, d, a, b, M_offset_11, 14, T[18]);
          b = GG(b, c, d, a, M_offset_0, 20, T[19]);
          a = GG(a, b, c, d, M_offset_5, 5, T[20]);
          d = GG(d, a, b, c, M_offset_10, 9, T[21]);
          c = GG(c, d, a, b, M_offset_15, 14, T[22]);
          b = GG(b, c, d, a, M_offset_4, 20, T[23]);
          a = GG(a, b, c, d, M_offset_9, 5, T[24]);
          d = GG(d, a, b, c, M_offset_14, 9, T[25]);
          c = GG(c, d, a, b, M_offset_3, 14, T[26]);
          b = GG(b, c, d, a, M_offset_8, 20, T[27]);
          a = GG(a, b, c, d, M_offset_13, 5, T[28]);
          d = GG(d, a, b, c, M_offset_2, 9, T[29]);
          c = GG(c, d, a, b, M_offset_7, 14, T[30]);
          b = GG(b, c, d, a, M_offset_12, 20, T[31]);
          a = HH(a, b, c, d, M_offset_5, 4, T[32]);
          d = HH(d, a, b, c, M_offset_8, 11, T[33]);
          c = HH(c, d, a, b, M_offset_11, 16, T[34]);
          b = HH(b, c, d, a, M_offset_14, 23, T[35]);
          a = HH(a, b, c, d, M_offset_1, 4, T[36]);
          d = HH(d, a, b, c, M_offset_4, 11, T[37]);
          c = HH(c, d, a, b, M_offset_7, 16, T[38]);
          b = HH(b, c, d, a, M_offset_10, 23, T[39]);
          a = HH(a, b, c, d, M_offset_13, 4, T[40]);
          d = HH(d, a, b, c, M_offset_0, 11, T[41]);
          c = HH(c, d, a, b, M_offset_3, 16, T[42]);
          b = HH(b, c, d, a, M_offset_6, 23, T[43]);
          a = HH(a, b, c, d, M_offset_9, 4, T[44]);
          d = HH(d, a, b, c, M_offset_12, 11, T[45]);
          c = HH(c, d, a, b, M_offset_15, 16, T[46]);
          b = HH(b, c, d, a, M_offset_2, 23, T[47]);
          a = II(a, b, c, d, M_offset_0, 6, T[48]);
          d = II(d, a, b, c, M_offset_7, 10, T[49]);
          c = II(c, d, a, b, M_offset_14, 15, T[50]);
          b = II(b, c, d, a, M_offset_5, 21, T[51]);
          a = II(a, b, c, d, M_offset_12, 6, T[52]);
          d = II(d, a, b, c, M_offset_3, 10, T[53]);
          c = II(c, d, a, b, M_offset_10, 15, T[54]);
          b = II(b, c, d, a, M_offset_1, 21, T[55]);
          a = II(a, b, c, d, M_offset_8, 6, T[56]);
          d = II(d, a, b, c, M_offset_15, 10, T[57]);
          c = II(c, d, a, b, M_offset_6, 15, T[58]);
          b = II(b, c, d, a, M_offset_13, 21, T[59]);
          a = II(a, b, c, d, M_offset_4, 6, T[60]);
          d = II(d, a, b, c, M_offset_11, 10, T[61]);
          c = II(c, d, a, b, M_offset_2, 15, T[62]);
          b = II(b, c, d, a, M_offset_9, 21, T[63]); // Intermediate hash value

          H[0] = H[0] + a | 0;
          H[1] = H[1] + b | 0;
          H[2] = H[2] + c | 0;
          H[3] = H[3] + d | 0;
        },
        _doFinalize: function _doFinalize() {
          // Shortcuts
          var data = this._data;
          var dataWords = data.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data.sigBytes * 8; // Add padding

          dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
          var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
          var nBitsTotalL = nBitsTotal;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
          data.sigBytes = (dataWords.length + 1) * 4; // Hash final blocks

          this._process(); // Shortcuts


          var hash = this._hash;
          var H = hash.words; // Swap endian

          for (var i = 0; i < 4; i++) {
            // Shortcut
            var H_i = H[i];
            H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
          } // Return final computed hash


          return hash;
        },
        clone: function clone() {
          var clone = Hasher.clone.call(this);
          clone._hash = this._hash.clone();
          return clone;
        }
      });

      function FF(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + x + t;
        return (n << s | n >>> 32 - s) + b;
      }

      function GG(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + x + t;
        return (n << s | n >>> 32 - s) + b;
      }

      function HH(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + x + t;
        return (n << s | n >>> 32 - s) + b;
      }

      function II(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + x + t;
        return (n << s | n >>> 32 - s) + b;
      }
      /**
       * Shortcut function to the hasher's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       *
       * @return {WordArray} The hash.
       *
       * @static
       *
       * @example
       *
       *     var hash = CryptoJS.MD5('message');
       *     var hash = CryptoJS.MD5(wordArray);
       */


      C.MD5 = Hasher._createHelper(MD5);
      /**
       * Shortcut function to the HMAC's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       * @param {WordArray|string} key The secret key.
       *
       * @return {WordArray} The HMAC.
       *
       * @static
       *
       * @example
       *
       *     var hmac = CryptoJS.HmacMD5(message, key);
       */

      C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);

    return CryptoJS.MD5;
  });
  /***/

},
/* 71 */

/***/
function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(139),
      getRawTag = __webpack_require__(511),
      objectToString = __webpack_require__(515);
  /** `Object#toString` result references. */


  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';
  /** Built-in value references. */

  var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  module.exports = baseGetTag;
  /***/
},
/* 72 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }

  module.exports = isObjectLike;
  /***/
},
/* 73 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * jwk/index.js - JSON Web Key (JWK) Entry Point
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  var JWKStore = __webpack_require__(105); // Public API -- Key and KeyStore methods


  Object.keys(JWKStore.KeyStore).forEach(function (name) {
    exports[name] = JWKStore.KeyStore[name];
  }); // Public API -- constants

  var CONSTANTS = __webpack_require__(237);

  Object.keys(CONSTANTS).forEach(function (name) {
    exports[name] = CONSTANTS[name];
  }); // Registered Key Types

  __webpack_require__(563);

  __webpack_require__(564);

  __webpack_require__(562);
  /***/

},
/* 74 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global, process) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    var formatRegExp = /%[sdj%]/g;

    exports.format = function (f) {
      if (!isString(f)) {
        var objects = [];

        for (var i = 0; i < arguments.length; i++) {
          objects.push(inspect(arguments[i]));
        }

        return objects.join(' ');
      }

      var i = 1;
      var args = arguments;
      var len = args.length;
      var str = String(f).replace(formatRegExp, function (x) {
        if (x === '%%') return '%';
        if (i >= len) return x;

        switch (x) {
          case '%s':
            return String(args[i++]);

          case '%d':
            return Number(args[i++]);

          case '%j':
            try {
              return JSON.stringify(args[i++]);
            } catch (_) {
              return '[Circular]';
            }

          default:
            return x;
        }
      });

      for (var x = args[i]; i < len; x = args[++i]) {
        if (isNull(x) || !isObject(x)) {
          str += ' ' + x;
        } else {
          str += ' ' + inspect(x);
        }
      }

      return str;
    }; // Mark that a method should not be used.
    // Returns a modified function which warns once by default.
    // If --no-deprecation is set, then it is a no-op.


    exports.deprecate = function (fn, msg) {
      // Allow for deprecating things in the process of starting up.
      if (isUndefined(global.process)) {
        return function () {
          return exports.deprecate(fn, msg).apply(this, arguments);
        };
      }

      if (process.noDeprecation === true) {
        return fn;
      }

      var warned = false;

      function deprecated() {
        if (!warned) {
          if (process.throwDeprecation) {
            throw new Error(msg);
          } else if (process.traceDeprecation) {
            console.trace(msg);
          } else {
            console.error(msg);
          }

          warned = true;
        }

        return fn.apply(this, arguments);
      }

      return deprecated;
    };

    var debugs = {};
    var debugEnviron;

    exports.debuglog = function (set) {
      if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
      set = set.toUpperCase();

      if (!debugs[set]) {
        if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
          var pid = process.pid;

          debugs[set] = function () {
            var msg = exports.format.apply(exports, arguments);
            console.error('%s %d: %s', set, pid, msg);
          };
        } else {
          debugs[set] = function () {};
        }
      }

      return debugs[set];
    };
    /**
     * Echos the value of a value. Trys to print the value out
     * in the best way possible given the different types.
     *
     * @param {Object} obj The object to print out.
     * @param {Object} opts Optional options object that alters the output.
     */

    /* legacy: obj, showHidden, depth, colors*/


    function inspect(obj, opts) {
      // default options
      var ctx = {
        seen: [],
        stylize: stylizeNoColor
      }; // legacy...

      if (arguments.length >= 3) ctx.depth = arguments[2];
      if (arguments.length >= 4) ctx.colors = arguments[3];

      if (isBoolean(opts)) {
        // legacy...
        ctx.showHidden = opts;
      } else if (opts) {
        // got an "options" object
        exports._extend(ctx, opts);
      } // set default options


      if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
      if (isUndefined(ctx.depth)) ctx.depth = 2;
      if (isUndefined(ctx.colors)) ctx.colors = false;
      if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
      if (ctx.colors) ctx.stylize = stylizeWithColor;
      return formatValue(ctx, obj, ctx.depth);
    }

    exports.inspect = inspect; // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics

    inspect.colors = {
      'bold': [1, 22],
      'italic': [3, 23],
      'underline': [4, 24],
      'inverse': [7, 27],
      'white': [37, 39],
      'grey': [90, 39],
      'black': [30, 39],
      'blue': [34, 39],
      'cyan': [36, 39],
      'green': [32, 39],
      'magenta': [35, 39],
      'red': [31, 39],
      'yellow': [33, 39]
    }; // Don't use 'blue' not visible on cmd.exe

    inspect.styles = {
      'special': 'cyan',
      'number': 'yellow',
      'boolean': 'yellow',
      'undefined': 'grey',
      'null': 'bold',
      'string': 'green',
      'date': 'magenta',
      // "name": intentionally not styling
      'regexp': 'red'
    };

    function stylizeWithColor(str, styleType) {
      var style = inspect.styles[styleType];

      if (style) {
        return "\x1B[" + inspect.colors[style][0] + 'm' + str + "\x1B[" + inspect.colors[style][1] + 'm';
      } else {
        return str;
      }
    }

    function stylizeNoColor(str, styleType) {
      return str;
    }

    function arrayToHash(array) {
      var hash = {};
      array.forEach(function (val, idx) {
        hash[val] = true;
      });
      return hash;
    }

    function formatValue(ctx, value, recurseTimes) {
      // Provide a hook for user-specified inspect functions.
      // Check that value is an object with an inspect function on it
      if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);

        if (!isString(ret)) {
          ret = formatValue(ctx, ret, recurseTimes);
        }

        return ret;
      } // Primitive types cannot have properties


      var primitive = formatPrimitive(ctx, value);

      if (primitive) {
        return primitive;
      } // Look up the keys of the object.


      var keys = Object.keys(value);
      var visibleKeys = arrayToHash(keys);

      if (ctx.showHidden) {
        keys = Object.getOwnPropertyNames(value);
      } // IE doesn't make error fields non-enumerable
      // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx


      if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
        return formatError(value);
      } // Some type of object without properties can be shortcutted.


      if (keys.length === 0) {
        if (isFunction(value)) {
          var name = value.name ? ': ' + value.name : '';
          return ctx.stylize('[Function' + name + ']', 'special');
        }

        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        }

        if (isDate(value)) {
          return ctx.stylize(Date.prototype.toString.call(value), 'date');
        }

        if (isError(value)) {
          return formatError(value);
        }
      }

      var base = '',
          array = false,
          braces = ['{', '}']; // Make Array say that they are Array

      if (isArray(value)) {
        array = true;
        braces = ['[', ']'];
      } // Make functions say that they are functions


      if (isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
      } // Make RegExps say that they are RegExps


      if (isRegExp(value)) {
        base = ' ' + RegExp.prototype.toString.call(value);
      } // Make dates with properties first say the date


      if (isDate(value)) {
        base = ' ' + Date.prototype.toUTCString.call(value);
      } // Make error with message first say the error


      if (isError(value)) {
        base = ' ' + formatError(value);
      }

      if (keys.length === 0 && (!array || value.length == 0)) {
        return braces[0] + base + braces[1];
      }

      if (recurseTimes < 0) {
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        } else {
          return ctx.stylize('[Object]', 'special');
        }
      }

      ctx.seen.push(value);
      var output;

      if (array) {
        output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
      } else {
        output = keys.map(function (key) {
          return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
      }

      ctx.seen.pop();
      return reduceToSingleString(output, base, braces);
    }

    function formatPrimitive(ctx, value) {
      if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');

      if (isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
      }

      if (isNumber(value)) return ctx.stylize('' + value, 'number');
      if (isBoolean(value)) return ctx.stylize('' + value, 'boolean'); // For some reason typeof null is "object", so special case here.

      if (isNull(value)) return ctx.stylize('null', 'null');
    }

    function formatError(value) {
      return '[' + Error.prototype.toString.call(value) + ']';
    }

    function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
      var output = [];

      for (var i = 0, l = value.length; i < l; ++i) {
        if (hasOwnProperty(value, String(i))) {
          output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
        } else {
          output.push('');
        }
      }

      keys.forEach(function (key) {
        if (!key.match(/^\d+$/)) {
          output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
        }
      });
      return output;
    }

    function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
      var name, str, desc;
      desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
      };

      if (desc.get) {
        if (desc.set) {
          str = ctx.stylize('[Getter/Setter]', 'special');
        } else {
          str = ctx.stylize('[Getter]', 'special');
        }
      } else {
        if (desc.set) {
          str = ctx.stylize('[Setter]', 'special');
        }
      }

      if (!hasOwnProperty(visibleKeys, key)) {
        name = '[' + key + ']';
      }

      if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
          if (isNull(recurseTimes)) {
            str = formatValue(ctx, desc.value, null);
          } else {
            str = formatValue(ctx, desc.value, recurseTimes - 1);
          }

          if (str.indexOf('\n') > -1) {
            if (array) {
              str = str.split('\n').map(function (line) {
                return '  ' + line;
              }).join('\n').substr(2);
            } else {
              str = '\n' + str.split('\n').map(function (line) {
                return '   ' + line;
              }).join('\n');
            }
          }
        } else {
          str = ctx.stylize('[Circular]', 'special');
        }
      }

      if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) {
          return str;
        }

        name = JSON.stringify('' + key);

        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
          name = name.substr(1, name.length - 2);
          name = ctx.stylize(name, 'name');
        } else {
          name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
          name = ctx.stylize(name, 'string');
        }
      }

      return name + ': ' + str;
    }

    function reduceToSingleString(output, base, braces) {
      var numLinesEst = 0;
      var length = output.reduce(function (prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
      }, 0);

      if (length > 60) {
        return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
      }

      return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
    } // NOTE: These type checking functions intentionally don't use `instanceof`
    // because it is fragile and can be easily faked with `Object.create()`.


    function isArray(ar) {
      return Array.isArray(ar);
    }

    exports.isArray = isArray;

    function isBoolean(arg) {
      return typeof arg === 'boolean';
    }

    exports.isBoolean = isBoolean;

    function isNull(arg) {
      return arg === null;
    }

    exports.isNull = isNull;

    function isNullOrUndefined(arg) {
      return arg == null;
    }

    exports.isNullOrUndefined = isNullOrUndefined;

    function isNumber(arg) {
      return typeof arg === 'number';
    }

    exports.isNumber = isNumber;

    function isString(arg) {
      return typeof arg === 'string';
    }

    exports.isString = isString;

    function isSymbol(arg) {
      return typeof arg === 'symbol';
    }

    exports.isSymbol = isSymbol;

    function isUndefined(arg) {
      return arg === void 0;
    }

    exports.isUndefined = isUndefined;

    function isRegExp(re) {
      return isObject(re) && objectToString(re) === '[object RegExp]';
    }

    exports.isRegExp = isRegExp;

    function isObject(arg) {
      return typeof arg === 'object' && arg !== null;
    }

    exports.isObject = isObject;

    function isDate(d) {
      return isObject(d) && objectToString(d) === '[object Date]';
    }

    exports.isDate = isDate;

    function isError(e) {
      return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
    }

    exports.isError = isError;

    function isFunction(arg) {
      return typeof arg === 'function';
    }

    exports.isFunction = isFunction;

    function isPrimitive(arg) {
      return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
      typeof arg === 'undefined';
    }

    exports.isPrimitive = isPrimitive;
    exports.isBuffer = __webpack_require__(600);

    function objectToString(o) {
      return Object.prototype.toString.call(o);
    }

    function pad(n) {
      return n < 10 ? '0' + n.toString(10) : n.toString(10);
    }

    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']; // 26 Feb 16:19:34

    function timestamp() {
      var d = new Date();
      var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
      return [d.getDate(), months[d.getMonth()], time].join(' ');
    } // log is just a thin wrapper to console.log that prepends a timestamp


    exports.log = function () {
      console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
    };
    /**
     * Inherit the prototype methods from one constructor into another.
     *
     * The Function.prototype.inherits from lang.js rewritten as a standalone
     * function (not on Function.prototype). NOTE: If this file is to be loaded
     * during bootstrapping this function needs to be rewritten using some native
     * functions as prototype setup using normal JavaScript does not work as
     * expected during bootstrapping (see mirror.js in r114903).
     *
     * @param {function} ctor Constructor function which needs to inherit the
     *     prototype.
     * @param {function} superCtor Constructor function to inherit prototype from.
     */


    exports.inherits = __webpack_require__(599);

    exports._extend = function (origin, add) {
      // Don't do anything if add isn't an object
      if (!add || !isObject(add)) return origin;
      var keys = Object.keys(add);
      var i = keys.length;

      while (i--) {
        origin[keys[i]] = add[keys[i]];
      }

      return origin;
    };

    function hasOwnProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(10), __webpack_require__(16));
  /***/
},
/* 75 */

/***/
function (module, exports, __webpack_require__) {
  // getting tag from 19.1.3.6 Object.prototype.toString()
  var cof = __webpack_require__(27);

  var TAG = __webpack_require__(9)('toStringTag'); // ES3 wrong here


  var ARG = cof(function () {
    return arguments;
  }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

  var tryGet = function tryGet(it, key) {
    try {
      return it[key];
    } catch (e) {
      /* empty */
    }
  };

  module.exports = function (it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
    : ARG ? cof(O) // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
  };
  /***/

},
/* 76 */

/***/
function (module, exports, __webpack_require__) {
  // fallback for non-array-like ES3 and non-enumerable old V8 strings
  var cof = __webpack_require__(27); // eslint-disable-next-line no-prototype-builtins


  module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
  };
  /***/
},
/* 77 */

/***/
function (module, exports) {
  exports.f = {}.propertyIsEnumerable;
  /***/
},
/* 78 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (Buffer) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    // NOTE: These type checking functions intentionally don't use `instanceof`
    // because it is fragile and can be easily faked with `Object.create()`.
    function isArray(arg) {
      if (Array.isArray) {
        return Array.isArray(arg);
      }

      return objectToString(arg) === '[object Array]';
    }

    exports.isArray = isArray;

    function isBoolean(arg) {
      return typeof arg === 'boolean';
    }

    exports.isBoolean = isBoolean;

    function isNull(arg) {
      return arg === null;
    }

    exports.isNull = isNull;

    function isNullOrUndefined(arg) {
      return arg == null;
    }

    exports.isNullOrUndefined = isNullOrUndefined;

    function isNumber(arg) {
      return typeof arg === 'number';
    }

    exports.isNumber = isNumber;

    function isString(arg) {
      return typeof arg === 'string';
    }

    exports.isString = isString;

    function isSymbol(arg) {
      return typeof arg === 'symbol';
    }

    exports.isSymbol = isSymbol;

    function isUndefined(arg) {
      return arg === void 0;
    }

    exports.isUndefined = isUndefined;

    function isRegExp(re) {
      return objectToString(re) === '[object RegExp]';
    }

    exports.isRegExp = isRegExp;

    function isObject(arg) {
      return typeof arg === 'object' && arg !== null;
    }

    exports.isObject = isObject;

    function isDate(d) {
      return objectToString(d) === '[object Date]';
    }

    exports.isDate = isDate;

    function isError(e) {
      return objectToString(e) === '[object Error]' || e instanceof Error;
    }

    exports.isError = isError;

    function isFunction(arg) {
      return typeof arg === 'function';
    }

    exports.isFunction = isFunction;

    function isPrimitive(arg) {
      return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
      typeof arg === 'undefined';
    }

    exports.isPrimitive = isPrimitive;
    exports.isBuffer = Buffer.isBuffer;

    function objectToString(o) {
      return Object.prototype.toString.call(o);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 79 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Advanced Encryption Standard (AES) implementation.
   *
   * This implementation is based on the public domain library 'jscrypto' which
   * was written by:
   *
   * Emily Stark (estark@stanford.edu)
   * Mike Hamburg (mhamburg@stanford.edu)
   * Dan Boneh (dabo@cs.stanford.edu)
   *
   * Parts of this code are based on the OpenSSL implementation of AES:
   * http://www.openssl.org
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2014 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(143);

  __webpack_require__(222);

  __webpack_require__(8);
  /* AES API */


  module.exports = forge.aes = forge.aes || {};
  /**
   * Deprecated. Instead, use:
   *
   * var cipher = forge.cipher.createCipher('AES-<mode>', key);
   * cipher.start({iv: iv});
   *
   * Creates an AES cipher object to encrypt data using the given symmetric key.
   * The output will be stored in the 'output' member of the returned cipher.
   *
   * The key and iv may be given as a string of bytes, an array of bytes,
   * a byte buffer, or an array of 32-bit words.
   *
   * @param key the symmetric key to use.
   * @param iv the initialization vector to use.
   * @param output the buffer to write to, null to create one.
   * @param mode the cipher mode to use (default: 'CBC').
   *
   * @return the cipher.
   */

  forge.aes.startEncrypting = function (key, iv, output, mode) {
    var cipher = _createCipher({
      key: key,
      output: output,
      decrypt: false,
      mode: mode
    });

    cipher.start(iv);
    return cipher;
  };
  /**
   * Deprecated. Instead, use:
   *
   * var cipher = forge.cipher.createCipher('AES-<mode>', key);
   *
   * Creates an AES cipher object to encrypt data using the given symmetric key.
   *
   * The key may be given as a string of bytes, an array of bytes, a
   * byte buffer, or an array of 32-bit words.
   *
   * @param key the symmetric key to use.
   * @param mode the cipher mode to use (default: 'CBC').
   *
   * @return the cipher.
   */


  forge.aes.createEncryptionCipher = function (key, mode) {
    return _createCipher({
      key: key,
      output: null,
      decrypt: false,
      mode: mode
    });
  };
  /**
   * Deprecated. Instead, use:
   *
   * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
   * decipher.start({iv: iv});
   *
   * Creates an AES cipher object to decrypt data using the given symmetric key.
   * The output will be stored in the 'output' member of the returned cipher.
   *
   * The key and iv may be given as a string of bytes, an array of bytes,
   * a byte buffer, or an array of 32-bit words.
   *
   * @param key the symmetric key to use.
   * @param iv the initialization vector to use.
   * @param output the buffer to write to, null to create one.
   * @param mode the cipher mode to use (default: 'CBC').
   *
   * @return the cipher.
   */


  forge.aes.startDecrypting = function (key, iv, output, mode) {
    var cipher = _createCipher({
      key: key,
      output: output,
      decrypt: true,
      mode: mode
    });

    cipher.start(iv);
    return cipher;
  };
  /**
   * Deprecated. Instead, use:
   *
   * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
   *
   * Creates an AES cipher object to decrypt data using the given symmetric key.
   *
   * The key may be given as a string of bytes, an array of bytes, a
   * byte buffer, or an array of 32-bit words.
   *
   * @param key the symmetric key to use.
   * @param mode the cipher mode to use (default: 'CBC').
   *
   * @return the cipher.
   */


  forge.aes.createDecryptionCipher = function (key, mode) {
    return _createCipher({
      key: key,
      output: null,
      decrypt: true,
      mode: mode
    });
  };
  /**
   * Creates a new AES cipher algorithm object.
   *
   * @param name the name of the algorithm.
   * @param mode the mode factory function.
   *
   * @return the AES algorithm object.
   */


  forge.aes.Algorithm = function (name, mode) {
    if (!init) {
      initialize();
    }

    var self = this;
    self.name = name;
    self.mode = new mode({
      blockSize: 16,
      cipher: {
        encrypt: function encrypt(inBlock, outBlock) {
          return _updateBlock(self._w, inBlock, outBlock, false);
        },
        decrypt: function decrypt(inBlock, outBlock) {
          return _updateBlock(self._w, inBlock, outBlock, true);
        }
      }
    });
    self._init = false;
  };
  /**
   * Initializes this AES algorithm by expanding its key.
   *
   * @param options the options to use.
   *          key the key to use with this algorithm.
   *          decrypt true if the algorithm should be initialized for decryption,
   *            false for encryption.
   */


  forge.aes.Algorithm.prototype.initialize = function (options) {
    if (this._init) {
      return;
    }

    var key = options.key;
    var tmp;
    /* Note: The key may be a string of bytes, an array of bytes, a byte
      buffer, or an array of 32-bit integers. If the key is in bytes, then
      it must be 16, 24, or 32 bytes in length. If it is in 32-bit
      integers, it must be 4, 6, or 8 integers long. */

    if (typeof key === 'string' && (key.length === 16 || key.length === 24 || key.length === 32)) {
      // convert key string into byte buffer
      key = forge.util.createBuffer(key);
    } else if (forge.util.isArray(key) && (key.length === 16 || key.length === 24 || key.length === 32)) {
      // convert key integer array into byte buffer
      tmp = key;
      key = forge.util.createBuffer();

      for (var i = 0; i < tmp.length; ++i) {
        key.putByte(tmp[i]);
      }
    } // convert key byte buffer into 32-bit integer array


    if (!forge.util.isArray(key)) {
      tmp = key;
      key = []; // key lengths of 16, 24, 32 bytes allowed

      var len = tmp.length();

      if (len === 16 || len === 24 || len === 32) {
        len = len >>> 2;

        for (var i = 0; i < len; ++i) {
          key.push(tmp.getInt32());
        }
      }
    } // key must be an array of 32-bit integers by now


    if (!forge.util.isArray(key) || !(key.length === 4 || key.length === 6 || key.length === 8)) {
      throw new Error('Invalid key parameter.');
    } // encryption operation is always used for these modes


    var mode = this.mode.name;
    var encryptOp = ['CFB', 'OFB', 'CTR', 'GCM'].indexOf(mode) !== -1; // do key expansion

    this._w = _expandKey(key, options.decrypt && !encryptOp);
    this._init = true;
  };
  /**
   * Expands a key. Typically only used for testing.
   *
   * @param key the symmetric key to expand, as an array of 32-bit words.
   * @param decrypt true to expand for decryption, false for encryption.
   *
   * @return the expanded key.
   */


  forge.aes._expandKey = function (key, decrypt) {
    if (!init) {
      initialize();
    }

    return _expandKey(key, decrypt);
  };
  /**
   * Updates a single block. Typically only used for testing.
   *
   * @param w the expanded key to use.
   * @param input an array of block-size 32-bit words.
   * @param output an array of block-size 32-bit words.
   * @param decrypt true to decrypt, false to encrypt.
   */


  forge.aes._updateBlock = _updateBlock;
  /** Register AES algorithms **/

  registerAlgorithm('AES-ECB', forge.cipher.modes.ecb);
  registerAlgorithm('AES-CBC', forge.cipher.modes.cbc);
  registerAlgorithm('AES-CFB', forge.cipher.modes.cfb);
  registerAlgorithm('AES-OFB', forge.cipher.modes.ofb);
  registerAlgorithm('AES-CTR', forge.cipher.modes.ctr);
  registerAlgorithm('AES-GCM', forge.cipher.modes.gcm);

  function registerAlgorithm(name, mode) {
    var factory = function factory() {
      return new forge.aes.Algorithm(name, mode);
    };

    forge.cipher.registerAlgorithm(name, factory);
  }
  /** AES implementation **/


  var init = false; // not yet initialized

  var Nb = 4; // number of words comprising the state (AES = 4)

  var sbox; // non-linear substitution table used in key expansion

  var isbox; // inversion of sbox

  var rcon; // round constant word array

  var mix; // mix-columns table

  var imix; // inverse mix-columns table

  /**
   * Performs initialization, ie: precomputes tables to optimize for speed.
   *
   * One way to understand how AES works is to imagine that 'addition' and
   * 'multiplication' are interfaces that require certain mathematical
   * properties to hold true (ie: they are associative) but they might have
   * different implementations and produce different kinds of results ...
   * provided that their mathematical properties remain true. AES defines
   * its own methods of addition and multiplication but keeps some important
   * properties the same, ie: associativity and distributivity. The
   * explanation below tries to shed some light on how AES defines addition
   * and multiplication of bytes and 32-bit words in order to perform its
   * encryption and decryption algorithms.
   *
   * The basics:
   *
   * The AES algorithm views bytes as binary representations of polynomials
   * that have either 1 or 0 as the coefficients. It defines the addition
   * or subtraction of two bytes as the XOR operation. It also defines the
   * multiplication of two bytes as a finite field referred to as GF(2^8)
   * (Note: 'GF' means "Galois Field" which is a field that contains a finite
   * number of elements so GF(2^8) has 256 elements).
   *
   * This means that any two bytes can be represented as binary polynomials;
   * when they multiplied together and modularly reduced by an irreducible
   * polynomial of the 8th degree, the results are the field GF(2^8). The
   * specific irreducible polynomial that AES uses in hexadecimal is 0x11b.
   * This multiplication is associative with 0x01 as the identity:
   *
   * (b * 0x01 = GF(b, 0x01) = b).
   *
   * The operation GF(b, 0x02) can be performed at the byte level by left
   * shifting b once and then XOR'ing it (to perform the modular reduction)
   * with 0x11b if b is >= 128. Repeated application of the multiplication
   * of 0x02 can be used to implement the multiplication of any two bytes.
   *
   * For instance, multiplying 0x57 and 0x13, denoted as GF(0x57, 0x13), can
   * be performed by factoring 0x13 into 0x01, 0x02, and 0x10. Then these
   * factors can each be multiplied by 0x57 and then added together. To do
   * the multiplication, values for 0x57 multiplied by each of these 3 factors
   * can be precomputed and stored in a table. To add them, the values from
   * the table are XOR'd together.
   *
   * AES also defines addition and multiplication of words, that is 4-byte
   * numbers represented as polynomials of 3 degrees where the coefficients
   * are the values of the bytes.
   *
   * The word [a0, a1, a2, a3] is a polynomial a3x^3 + a2x^2 + a1x + a0.
   *
   * Addition is performed by XOR'ing like powers of x. Multiplication
   * is performed in two steps, the first is an algebriac expansion as
   * you would do normally (where addition is XOR). But the result is
   * a polynomial larger than 3 degrees and thus it cannot fit in a word. So
   * next the result is modularly reduced by an AES-specific polynomial of
   * degree 4 which will always produce a polynomial of less than 4 degrees
   * such that it will fit in a word. In AES, this polynomial is x^4 + 1.
   *
   * The modular product of two polynomials 'a' and 'b' is thus:
   *
   * d(x) = d3x^3 + d2x^2 + d1x + d0
   * with
   * d0 = GF(a0, b0) ^ GF(a3, b1) ^ GF(a2, b2) ^ GF(a1, b3)
   * d1 = GF(a1, b0) ^ GF(a0, b1) ^ GF(a3, b2) ^ GF(a2, b3)
   * d2 = GF(a2, b0) ^ GF(a1, b1) ^ GF(a0, b2) ^ GF(a3, b3)
   * d3 = GF(a3, b0) ^ GF(a2, b1) ^ GF(a1, b2) ^ GF(a0, b3)
   *
   * As a matrix:
   *
   * [d0] = [a0 a3 a2 a1][b0]
   * [d1]   [a1 a0 a3 a2][b1]
   * [d2]   [a2 a1 a0 a3][b2]
   * [d3]   [a3 a2 a1 a0][b3]
   *
   * Special polynomials defined by AES (0x02 == {02}):
   * a(x)    = {03}x^3 + {01}x^2 + {01}x + {02}
   * a^-1(x) = {0b}x^3 + {0d}x^2 + {09}x + {0e}.
   *
   * These polynomials are used in the MixColumns() and InverseMixColumns()
   * operations, respectively, to cause each element in the state to affect
   * the output (referred to as diffusing).
   *
   * RotWord() uses: a0 = a1 = a2 = {00} and a3 = {01}, which is the
   * polynomial x3.
   *
   * The ShiftRows() method modifies the last 3 rows in the state (where
   * the state is 4 words with 4 bytes per word) by shifting bytes cyclically.
   * The 1st byte in the second row is moved to the end of the row. The 1st
   * and 2nd bytes in the third row are moved to the end of the row. The 1st,
   * 2nd, and 3rd bytes are moved in the fourth row.
   *
   * More details on how AES arithmetic works:
   *
   * In the polynomial representation of binary numbers, XOR performs addition
   * and subtraction and multiplication in GF(2^8) denoted as GF(a, b)
   * corresponds with the multiplication of polynomials modulo an irreducible
   * polynomial of degree 8. In other words, for AES, GF(a, b) will multiply
   * polynomial 'a' with polynomial 'b' and then do a modular reduction by
   * an AES-specific irreducible polynomial of degree 8.
   *
   * A polynomial is irreducible if its only divisors are one and itself. For
   * the AES algorithm, this irreducible polynomial is:
   *
   * m(x) = x^8 + x^4 + x^3 + x + 1,
   *
   * or {01}{1b} in hexadecimal notation, where each coefficient is a bit:
   * 100011011 = 283 = 0x11b.
   *
   * For example, GF(0x57, 0x83) = 0xc1 because
   *
   * 0x57 = 87  = 01010111 = x^6 + x^4 + x^2 + x + 1
   * 0x85 = 131 = 10000101 = x^7 + x + 1
   *
   * (x^6 + x^4 + x^2 + x + 1) * (x^7 + x + 1)
   * =  x^13 + x^11 + x^9 + x^8 + x^7 +
   *    x^7 + x^5 + x^3 + x^2 + x +
   *    x^6 + x^4 + x^2 + x + 1
   * =  x^13 + x^11 + x^9 + x^8 + x^6 + x^5 + x^4 + x^3 + 1 = y
   *    y modulo (x^8 + x^4 + x^3 + x + 1)
   * =  x^7 + x^6 + 1.
   *
   * The modular reduction by m(x) guarantees the result will be a binary
   * polynomial of less than degree 8, so that it can fit in a byte.
   *
   * The operation to multiply a binary polynomial b with x (the polynomial
   * x in binary representation is 00000010) is:
   *
   * b_7x^8 + b_6x^7 + b_5x^6 + b_4x^5 + b_3x^4 + b_2x^3 + b_1x^2 + b_0x^1
   *
   * To get GF(b, x) we must reduce that by m(x). If b_7 is 0 (that is the
   * most significant bit is 0 in b) then the result is already reduced. If
   * it is 1, then we can reduce it by subtracting m(x) via an XOR.
   *
   * It follows that multiplication by x (00000010 or 0x02) can be implemented
   * by performing a left shift followed by a conditional bitwise XOR with
   * 0x1b. This operation on bytes is denoted by xtime(). Multiplication by
   * higher powers of x can be implemented by repeated application of xtime().
   *
   * By adding intermediate results, multiplication by any constant can be
   * implemented. For instance:
   *
   * GF(0x57, 0x13) = 0xfe because:
   *
   * xtime(b) = (b & 128) ? (b << 1 ^ 0x11b) : (b << 1)
   *
   * Note: We XOR with 0x11b instead of 0x1b because in javascript our
   * datatype for b can be larger than 1 byte, so a left shift will not
   * automatically eliminate bits that overflow a byte ... by XOR'ing the
   * overflow bit with 1 (the extra one from 0x11b) we zero it out.
   *
   * GF(0x57, 0x02) = xtime(0x57) = 0xae
   * GF(0x57, 0x04) = xtime(0xae) = 0x47
   * GF(0x57, 0x08) = xtime(0x47) = 0x8e
   * GF(0x57, 0x10) = xtime(0x8e) = 0x07
   *
   * GF(0x57, 0x13) = GF(0x57, (0x01 ^ 0x02 ^ 0x10))
   *
   * And by the distributive property (since XOR is addition and GF() is
   * multiplication):
   *
   * = GF(0x57, 0x01) ^ GF(0x57, 0x02) ^ GF(0x57, 0x10)
   * = 0x57 ^ 0xae ^ 0x07
   * = 0xfe.
   */

  function initialize() {
    init = true;
    /* Populate the Rcon table. These are the values given by
      [x^(i-1),{00},{00},{00}] where x^(i-1) are powers of x (and x = 0x02)
      in the field of GF(2^8), where i starts at 1.
       rcon[0] = [0x00, 0x00, 0x00, 0x00]
      rcon[1] = [0x01, 0x00, 0x00, 0x00] 2^(1-1) = 2^0 = 1
      rcon[2] = [0x02, 0x00, 0x00, 0x00] 2^(2-1) = 2^1 = 2
      ...
      rcon[9]  = [0x1B, 0x00, 0x00, 0x00] 2^(9-1)  = 2^8 = 0x1B
      rcon[10] = [0x36, 0x00, 0x00, 0x00] 2^(10-1) = 2^9 = 0x36
       We only store the first byte because it is the only one used.
    */

    rcon = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1B, 0x36]; // compute xtime table which maps i onto GF(i, 0x02)

    var xtime = new Array(256);

    for (var i = 0; i < 128; ++i) {
      xtime[i] = i << 1;
      xtime[i + 128] = i + 128 << 1 ^ 0x11B;
    } // compute all other tables


    sbox = new Array(256);
    isbox = new Array(256);
    mix = new Array(4);
    imix = new Array(4);

    for (var i = 0; i < 4; ++i) {
      mix[i] = new Array(256);
      imix[i] = new Array(256);
    }

    var e = 0,
        ei = 0,
        e2,
        e4,
        e8,
        sx,
        sx2,
        me,
        ime;

    for (var i = 0; i < 256; ++i) {
      /* We need to generate the SubBytes() sbox and isbox tables so that
        we can perform byte substitutions. This requires us to traverse
        all of the elements in GF, find their multiplicative inverses,
        and apply to each the following affine transformation:
         bi' = bi ^ b(i + 4) mod 8 ^ b(i + 5) mod 8 ^ b(i + 6) mod 8 ^
              b(i + 7) mod 8 ^ ci
        for 0 <= i < 8, where bi is the ith bit of the byte, and ci is the
        ith bit of a byte c with the value {63} or {01100011}.
         It is possible to traverse every possible value in a Galois field
        using what is referred to as a 'generator'. There are many
        generators (128 out of 256): 3,5,6,9,11,82 to name a few. To fully
        traverse GF we iterate 255 times, multiplying by our generator
        each time.
         On each iteration we can determine the multiplicative inverse for
        the current element.
         Suppose there is an element in GF 'e'. For a given generator 'g',
        e = g^x. The multiplicative inverse of e is g^(255 - x). It turns
        out that if use the inverse of a generator as another generator
        it will produce all of the corresponding multiplicative inverses
        at the same time. For this reason, we choose 5 as our inverse
        generator because it only requires 2 multiplies and 1 add and its
        inverse, 82, requires relatively few operations as well.
         In order to apply the affine transformation, the multiplicative
        inverse 'ei' of 'e' can be repeatedly XOR'd (4 times) with a
        bit-cycling of 'ei'. To do this 'ei' is first stored in 's' and
        'x'. Then 's' is left shifted and the high bit of 's' is made the
        low bit. The resulting value is stored in 's'. Then 'x' is XOR'd
        with 's' and stored in 'x'. On each subsequent iteration the same
        operation is performed. When 4 iterations are complete, 'x' is
        XOR'd with 'c' (0x63) and the transformed value is stored in 'x'.
        For example:
         s = 01000001
        x = 01000001
         iteration 1: s = 10000010, x ^= s
        iteration 2: s = 00000101, x ^= s
        iteration 3: s = 00001010, x ^= s
        iteration 4: s = 00010100, x ^= s
        x ^= 0x63
         This can be done with a loop where s = (s << 1) | (s >> 7). However,
        it can also be done by using a single 16-bit (in this case 32-bit)
        number 'sx'. Since XOR is an associative operation, we can set 'sx'
        to 'ei' and then XOR it with 'sx' left-shifted 1,2,3, and 4 times.
        The most significant bits will flow into the high 8 bit positions
        and be correctly XOR'd with one another. All that remains will be
        to cycle the high 8 bits by XOR'ing them all with the lower 8 bits
        afterwards.
         At the same time we're populating sbox and isbox we can precompute
        the multiplication we'll need to do to do MixColumns() later.
      */
      // apply affine transformation
      sx = ei ^ ei << 1 ^ ei << 2 ^ ei << 3 ^ ei << 4;
      sx = sx >> 8 ^ sx & 255 ^ 0x63; // update tables

      sbox[e] = sx;
      isbox[sx] = e;
      /* Mixing columns is done using matrix multiplication. The columns
        that are to be mixed are each a single word in the current state.
        The state has Nb columns (4 columns). Therefore each column is a
        4 byte word. So to mix the columns in a single column 'c' where
        its rows are r0, r1, r2, and r3, we use the following matrix
        multiplication:
         [2 3 1 1]*[r0,c]=[r'0,c]
        [1 2 3 1] [r1,c] [r'1,c]
        [1 1 2 3] [r2,c] [r'2,c]
        [3 1 1 2] [r3,c] [r'3,c]
         r0, r1, r2, and r3 are each 1 byte of one of the words in the
        state (a column). To do matrix multiplication for each mixed
        column c' we multiply the corresponding row from the left matrix
        with the corresponding column from the right matrix. In total, we
        get 4 equations:
         r0,c' = 2*r0,c + 3*r1,c + 1*r2,c + 1*r3,c
        r1,c' = 1*r0,c + 2*r1,c + 3*r2,c + 1*r3,c
        r2,c' = 1*r0,c + 1*r1,c + 2*r2,c + 3*r3,c
        r3,c' = 3*r0,c + 1*r1,c + 1*r2,c + 2*r3,c
         As usual, the multiplication is as previously defined and the
        addition is XOR. In order to optimize mixing columns we can store
        the multiplication results in tables. If you think of the whole
        column as a word (it might help to visualize by mentally rotating
        the equations above by counterclockwise 90 degrees) then you can
        see that it would be useful to map the multiplications performed on
        each byte (r0, r1, r2, r3) onto a word as well. For instance, we
        could map 2*r0,1*r0,1*r0,3*r0 onto a word by storing 2*r0 in the
        highest 8 bits and 3*r0 in the lowest 8 bits (with the other two
        respectively in the middle). This means that a table can be
        constructed that uses r0 as an index to the word. We can do the
        same with r1, r2, and r3, creating a total of 4 tables.
         To construct a full c', we can just look up each byte of c in
        their respective tables and XOR the results together.
         Also, to build each table we only have to calculate the word
        for 2,1,1,3 for every byte ... which we can do on each iteration
        of this loop since we will iterate over every byte. After we have
        calculated 2,1,1,3 we can get the results for the other tables
        by cycling the byte at the end to the beginning. For instance
        we can take the result of table 2,1,1,3 and produce table 3,2,1,1
        by moving the right most byte to the left most position just like
        how you can imagine the 3 moved out of 2,1,1,3 and to the front
        to produce 3,2,1,1.
         There is another optimization in that the same multiples of
        the current element we need in order to advance our generator
        to the next iteration can be reused in performing the 2,1,1,3
        calculation. We also calculate the inverse mix column tables,
        with e,9,d,b being the inverse of 2,1,1,3.
         When we're done, and we need to actually mix columns, the first
        byte of each state word should be put through mix[0] (2,1,1,3),
        the second through mix[1] (3,2,1,1) and so forth. Then they should
        be XOR'd together to produce the fully mixed column.
      */
      // calculate mix and imix table values

      sx2 = xtime[sx];
      e2 = xtime[e];
      e4 = xtime[e2];
      e8 = xtime[e4];
      me = sx2 << 24 ^ // 2
      sx << 16 ^ // 1
      sx << 8 ^ ( // 1
      sx ^ sx2); // 3

      ime = (e2 ^ e4 ^ e8) << 24 ^ // E (14)
      (e ^ e8) << 16 ^ // 9
      (e ^ e4 ^ e8) << 8 ^ ( // D (13)
      e ^ e2 ^ e8); // B (11)
      // produce each of the mix tables by rotating the 2,1,1,3 value

      for (var n = 0; n < 4; ++n) {
        mix[n][e] = me;
        imix[n][sx] = ime; // cycle the right most byte to the left most position
        // ie: 2,1,1,3 becomes 3,2,1,1

        me = me << 24 | me >>> 8;
        ime = ime << 24 | ime >>> 8;
      } // get next element and inverse


      if (e === 0) {
        // 1 is the inverse of 1
        e = ei = 1;
      } else {
        // e = 2e + 2*2*2*(10e)) = multiply e by 82 (chosen generator)
        // ei = ei + 2*2*ei = multiply ei by 5 (inverse generator)
        e = e2 ^ xtime[xtime[xtime[e2 ^ e8]]];
        ei ^= xtime[xtime[ei]];
      }
    }
  }
  /**
   * Generates a key schedule using the AES key expansion algorithm.
   *
   * The AES algorithm takes the Cipher Key, K, and performs a Key Expansion
   * routine to generate a key schedule. The Key Expansion generates a total
   * of Nb*(Nr + 1) words: the algorithm requires an initial set of Nb words,
   * and each of the Nr rounds requires Nb words of key data. The resulting
   * key schedule consists of a linear array of 4-byte words, denoted [wi ],
   * with i in the range 0 ≤ i < Nb(Nr + 1).
   *
   * KeyExpansion(byte key[4*Nk], word w[Nb*(Nr+1)], Nk)
   * AES-128 (Nb=4, Nk=4, Nr=10)
   * AES-192 (Nb=4, Nk=6, Nr=12)
   * AES-256 (Nb=4, Nk=8, Nr=14)
   * Note: Nr=Nk+6.
   *
   * Nb is the number of columns (32-bit words) comprising the State (or
   * number of bytes in a block). For AES, Nb=4.
   *
   * @param key the key to schedule (as an array of 32-bit words).
   * @param decrypt true to modify the key schedule to decrypt, false not to.
   *
   * @return the generated key schedule.
   */


  function _expandKey(key, decrypt) {
    // copy the key's words to initialize the key schedule
    var w = key.slice(0);
    /* RotWord() will rotate a word, moving the first byte to the last
      byte's position (shifting the other bytes left).
       We will be getting the value of Rcon at i / Nk. 'i' will iterate
      from Nk to (Nb * Nr+1). Nk = 4 (4 byte key), Nb = 4 (4 words in
      a block), Nr = Nk + 6 (10). Therefore 'i' will iterate from
      4 to 44 (exclusive). Each time we iterate 4 times, i / Nk will
      increase by 1. We use a counter iNk to keep track of this.
     */
    // go through the rounds expanding the key

    var temp,
        iNk = 1;
    var Nk = w.length;
    var Nr1 = Nk + 6 + 1;
    var end = Nb * Nr1;

    for (var i = Nk; i < end; ++i) {
      temp = w[i - 1];

      if (i % Nk === 0) {
        // temp = SubWord(RotWord(temp)) ^ Rcon[i / Nk]
        temp = sbox[temp >>> 16 & 255] << 24 ^ sbox[temp >>> 8 & 255] << 16 ^ sbox[temp & 255] << 8 ^ sbox[temp >>> 24] ^ rcon[iNk] << 24;
        iNk++;
      } else if (Nk > 6 && i % Nk === 4) {
        // temp = SubWord(temp)
        temp = sbox[temp >>> 24] << 24 ^ sbox[temp >>> 16 & 255] << 16 ^ sbox[temp >>> 8 & 255] << 8 ^ sbox[temp & 255];
      }

      w[i] = w[i - Nk] ^ temp;
    }
    /* When we are updating a cipher block we always use the code path for
      encryption whether we are decrypting or not (to shorten code and
      simplify the generation of look up tables). However, because there
      are differences in the decryption algorithm, other than just swapping
      in different look up tables, we must transform our key schedule to
      account for these changes:
       1. The decryption algorithm gets its key rounds in reverse order.
      2. The decryption algorithm adds the round key before mixing columns
        instead of afterwards.
       We don't need to modify our key schedule to handle the first case,
      we can just traverse the key schedule in reverse order when decrypting.
       The second case requires a little work.
       The tables we built for performing rounds will take an input and then
      perform SubBytes() and MixColumns() or, for the decrypt version,
      InvSubBytes() and InvMixColumns(). But the decrypt algorithm requires
      us to AddRoundKey() before InvMixColumns(). This means we'll need to
      apply some transformations to the round key to inverse-mix its columns
      so they'll be correct for moving AddRoundKey() to after the state has
      had its columns inverse-mixed.
       To inverse-mix the columns of the state when we're decrypting we use a
      lookup table that will apply InvSubBytes() and InvMixColumns() at the
      same time. However, the round key's bytes are not inverse-substituted
      in the decryption algorithm. To get around this problem, we can first
      substitute the bytes in the round key so that when we apply the
      transformation via the InvSubBytes()+InvMixColumns() table, it will
      undo our substitution leaving us with the original value that we
      want -- and then inverse-mix that value.
       This change will correctly alter our key schedule so that we can XOR
      each round key with our already transformed decryption state. This
      allows us to use the same code path as the encryption algorithm.
       We make one more change to the decryption key. Since the decryption
      algorithm runs in reverse from the encryption algorithm, we reverse
      the order of the round keys to avoid having to iterate over the key
      schedule backwards when running the encryption algorithm later in
      decryption mode. In addition to reversing the order of the round keys,
      we also swap each round key's 2nd and 4th rows. See the comments
      section where rounds are performed for more details about why this is
      done. These changes are done inline with the other substitution
      described above.
    */


    if (decrypt) {
      var tmp;
      var m0 = imix[0];
      var m1 = imix[1];
      var m2 = imix[2];
      var m3 = imix[3];
      var wnew = w.slice(0);
      end = w.length;

      for (var i = 0, wi = end - Nb; i < end; i += Nb, wi -= Nb) {
        // do not sub the first or last round key (round keys are Nb
        // words) as no column mixing is performed before they are added,
        // but do change the key order
        if (i === 0 || i === end - Nb) {
          wnew[i] = w[wi];
          wnew[i + 1] = w[wi + 3];
          wnew[i + 2] = w[wi + 2];
          wnew[i + 3] = w[wi + 1];
        } else {
          // substitute each round key byte because the inverse-mix
          // table will inverse-substitute it (effectively cancel the
          // substitution because round key bytes aren't sub'd in
          // decryption mode) and swap indexes 3 and 1
          for (var n = 0; n < Nb; ++n) {
            tmp = w[wi + n];
            wnew[i + (3 & -n)] = m0[sbox[tmp >>> 24]] ^ m1[sbox[tmp >>> 16 & 255]] ^ m2[sbox[tmp >>> 8 & 255]] ^ m3[sbox[tmp & 255]];
          }
        }
      }

      w = wnew;
    }

    return w;
  }
  /**
   * Updates a single block (16 bytes) using AES. The update will either
   * encrypt or decrypt the block.
   *
   * @param w the key schedule.
   * @param input the input block (an array of 32-bit words).
   * @param output the updated output block.
   * @param decrypt true to decrypt the block, false to encrypt it.
   */


  function _updateBlock(w, input, output, decrypt) {
    /*
    Cipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
    begin
      byte state[4,Nb]
      state = in
      AddRoundKey(state, w[0, Nb-1])
      for round = 1 step 1 to Nr–1
        SubBytes(state)
        ShiftRows(state)
        MixColumns(state)
        AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
      end for
      SubBytes(state)
      ShiftRows(state)
      AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
      out = state
    end
     InvCipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
    begin
      byte state[4,Nb]
      state = in
      AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
      for round = Nr-1 step -1 downto 1
        InvShiftRows(state)
        InvSubBytes(state)
        AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
        InvMixColumns(state)
      end for
      InvShiftRows(state)
      InvSubBytes(state)
      AddRoundKey(state, w[0, Nb-1])
      out = state
    end
    */
    // Encrypt: AddRoundKey(state, w[0, Nb-1])
    // Decrypt: AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    var Nr = w.length / 4 - 1;
    var m0, m1, m2, m3, sub;

    if (decrypt) {
      m0 = imix[0];
      m1 = imix[1];
      m2 = imix[2];
      m3 = imix[3];
      sub = isbox;
    } else {
      m0 = mix[0];
      m1 = mix[1];
      m2 = mix[2];
      m3 = mix[3];
      sub = sbox;
    }

    var a, b, c, d, a2, b2, c2;
    a = input[0] ^ w[0];
    b = input[decrypt ? 3 : 1] ^ w[1];
    c = input[2] ^ w[2];
    d = input[decrypt ? 1 : 3] ^ w[3];
    var i = 3;
    /* In order to share code we follow the encryption algorithm when both
      encrypting and decrypting. To account for the changes required in the
      decryption algorithm, we use different lookup tables when decrypting
      and use a modified key schedule to account for the difference in the
      order of transformations applied when performing rounds. We also get
      key rounds in reverse order (relative to encryption). */

    for (var round = 1; round < Nr; ++round) {
      /* As described above, we'll be using table lookups to perform the
        column mixing. Each column is stored as a word in the state (the
        array 'input' has one column as a word at each index). In order to
        mix a column, we perform these transformations on each row in c,
        which is 1 byte in each word. The new column for c0 is c'0:
                  m0      m1      m2      m3
        r0,c'0 = 2*r0,c0 + 3*r1,c0 + 1*r2,c0 + 1*r3,c0
        r1,c'0 = 1*r0,c0 + 2*r1,c0 + 3*r2,c0 + 1*r3,c0
        r2,c'0 = 1*r0,c0 + 1*r1,c0 + 2*r2,c0 + 3*r3,c0
        r3,c'0 = 3*r0,c0 + 1*r1,c0 + 1*r2,c0 + 2*r3,c0
         So using mix tables where c0 is a word with r0 being its upper
        8 bits and r3 being its lower 8 bits:
         m0[c0 >> 24] will yield this word: [2*r0,1*r0,1*r0,3*r0]
        ...
        m3[c0 & 255] will yield this word: [1*r3,1*r3,3*r3,2*r3]
         Therefore to mix the columns in each word in the state we
        do the following (& 255 omitted for brevity):
        c'0,r0 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
        c'0,r1 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
        c'0,r2 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
        c'0,r3 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
         However, before mixing, the algorithm requires us to perform
        ShiftRows(). The ShiftRows() transformation cyclically shifts the
        last 3 rows of the state over different offsets. The first row
        (r = 0) is not shifted.
         s'_r,c = s_r,(c + shift(r, Nb) mod Nb
        for 0 < r < 4 and 0 <= c < Nb and
        shift(1, 4) = 1
        shift(2, 4) = 2
        shift(3, 4) = 3.
         This causes the first byte in r = 1 to be moved to the end of
        the row, the first 2 bytes in r = 2 to be moved to the end of
        the row, the first 3 bytes in r = 3 to be moved to the end of
        the row:
         r1: [c0 c1 c2 c3] => [c1 c2 c3 c0]
        r2: [c0 c1 c2 c3]    [c2 c3 c0 c1]
        r3: [c0 c1 c2 c3]    [c3 c0 c1 c2]
         We can make these substitutions inline with our column mixing to
        generate an updated set of equations to produce each word in the
        state (note the columns have changed positions):
         c0 c1 c2 c3 => c0 c1 c2 c3
        c0 c1 c2 c3    c1 c2 c3 c0  (cycled 1 byte)
        c0 c1 c2 c3    c2 c3 c0 c1  (cycled 2 bytes)
        c0 c1 c2 c3    c3 c0 c1 c2  (cycled 3 bytes)
         Therefore:
         c'0 = 2*r0,c0 + 3*r1,c1 + 1*r2,c2 + 1*r3,c3
        c'0 = 1*r0,c0 + 2*r1,c1 + 3*r2,c2 + 1*r3,c3
        c'0 = 1*r0,c0 + 1*r1,c1 + 2*r2,c2 + 3*r3,c3
        c'0 = 3*r0,c0 + 1*r1,c1 + 1*r2,c2 + 2*r3,c3
         c'1 = 2*r0,c1 + 3*r1,c2 + 1*r2,c3 + 1*r3,c0
        c'1 = 1*r0,c1 + 2*r1,c2 + 3*r2,c3 + 1*r3,c0
        c'1 = 1*r0,c1 + 1*r1,c2 + 2*r2,c3 + 3*r3,c0
        c'1 = 3*r0,c1 + 1*r1,c2 + 1*r2,c3 + 2*r3,c0
         ... and so forth for c'2 and c'3. The important distinction is
        that the columns are cycling, with c0 being used with the m0
        map when calculating c0, but c1 being used with the m0 map when
        calculating c1 ... and so forth.
         When performing the inverse we transform the mirror image and
        skip the bottom row, instead of the top one, and move upwards:
         c3 c2 c1 c0 => c0 c3 c2 c1  (cycled 3 bytes) *same as encryption
        c3 c2 c1 c0    c1 c0 c3 c2  (cycled 2 bytes)
        c3 c2 c1 c0    c2 c1 c0 c3  (cycled 1 byte)  *same as encryption
        c3 c2 c1 c0    c3 c2 c1 c0
         If you compare the resulting matrices for ShiftRows()+MixColumns()
        and for InvShiftRows()+InvMixColumns() the 2nd and 4th columns are
        different (in encrypt mode vs. decrypt mode). So in order to use
        the same code to handle both encryption and decryption, we will
        need to do some mapping.
         If in encryption mode we let a=c0, b=c1, c=c2, d=c3, and r<N> be
        a row number in the state, then the resulting matrix in encryption
        mode for applying the above transformations would be:
         r1: a b c d
        r2: b c d a
        r3: c d a b
        r4: d a b c
         If we did the same in decryption mode we would get:
         r1: a d c b
        r2: b a d c
        r3: c b a d
        r4: d c b a
         If instead we swap d and b (set b=c3 and d=c1), then we get:
         r1: a b c d
        r2: d a b c
        r3: c d a b
        r4: b c d a
         Now the 1st and 3rd rows are the same as the encryption matrix. All
        we need to do then to make the mapping exactly the same is to swap
        the 2nd and 4th rows when in decryption mode. To do this without
        having to do it on each iteration, we swapped the 2nd and 4th rows
        in the decryption key schedule. We also have to do the swap above
        when we first pull in the input and when we set the final output. */
      a2 = m0[a >>> 24] ^ m1[b >>> 16 & 255] ^ m2[c >>> 8 & 255] ^ m3[d & 255] ^ w[++i];
      b2 = m0[b >>> 24] ^ m1[c >>> 16 & 255] ^ m2[d >>> 8 & 255] ^ m3[a & 255] ^ w[++i];
      c2 = m0[c >>> 24] ^ m1[d >>> 16 & 255] ^ m2[a >>> 8 & 255] ^ m3[b & 255] ^ w[++i];
      d = m0[d >>> 24] ^ m1[a >>> 16 & 255] ^ m2[b >>> 8 & 255] ^ m3[c & 255] ^ w[++i];
      a = a2;
      b = b2;
      c = c2;
    }
    /*
      Encrypt:
      SubBytes(state)
      ShiftRows(state)
      AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
       Decrypt:
      InvShiftRows(state)
      InvSubBytes(state)
      AddRoundKey(state, w[0, Nb-1])
     */
    // Note: rows are shifted inline


    output[0] = sub[a >>> 24] << 24 ^ sub[b >>> 16 & 255] << 16 ^ sub[c >>> 8 & 255] << 8 ^ sub[d & 255] ^ w[++i];
    output[decrypt ? 3 : 1] = sub[b >>> 24] << 24 ^ sub[c >>> 16 & 255] << 16 ^ sub[d >>> 8 & 255] << 8 ^ sub[a & 255] ^ w[++i];
    output[2] = sub[c >>> 24] << 24 ^ sub[d >>> 16 & 255] << 16 ^ sub[a >>> 8 & 255] << 8 ^ sub[b & 255] ^ w[++i];
    output[decrypt ? 1 : 3] = sub[d >>> 24] << 24 ^ sub[a >>> 16 & 255] << 16 ^ sub[b >>> 8 & 255] << 8 ^ sub[c & 255] ^ w[++i];
  }
  /**
   * Deprecated. Instead, use:
   *
   * forge.cipher.createCipher('AES-<mode>', key);
   * forge.cipher.createDecipher('AES-<mode>', key);
   *
   * Creates a deprecated AES cipher object. This object's mode will default to
   * CBC (cipher-block-chaining).
   *
   * The key and iv may be given as a string of bytes, an array of bytes, a
   * byte buffer, or an array of 32-bit words.
   *
   * @param options the options to use.
   *          key the symmetric key to use.
   *          output the buffer to write to.
   *          decrypt true for decryption, false for encryption.
   *          mode the cipher mode to use (default: 'CBC').
   *
   * @return the cipher.
   */


  function _createCipher(options) {
    options = options || {};
    var mode = (options.mode || 'CBC').toUpperCase();
    var algorithm = 'AES-' + mode;
    var cipher;

    if (options.decrypt) {
      cipher = forge.cipher.createDecipher(algorithm, options.key);
    } else {
      cipher = forge.cipher.createCipher(algorithm, options.key);
    } // backwards compatible start API


    var start = cipher.start;

    cipher.start = function (iv, options) {
      // backwards compatibility: support second arg as output buffer
      var output = null;

      if (options instanceof forge.util.ByteBuffer) {
        output = options;
        options = {};
      }

      options = options || {};
      options.output = output;
      options.iv = iv;
      start.call(cipher, options);
    };

    return cipher;
  }
  /***/

},
/* 80 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Javascript implementation of basic PEM (Privacy Enhanced Mail) algorithms.
   *
   * See: RFC 1421.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2013-2014 Digital Bazaar, Inc.
   *
   * A Forge PEM object has the following fields:
   *
   * type: identifies the type of message (eg: "RSA PRIVATE KEY").
   *
   * procType: identifies the type of processing performed on the message,
   *   it has two subfields: version and type, eg: 4,ENCRYPTED.
   *
   * contentDomain: identifies the type of content in the message, typically
   *   only uses the value: "RFC822".
   *
   * dekInfo: identifies the message encryption algorithm and mode and includes
   *   any parameters for the algorithm, it has two subfields: algorithm and
   *   parameters, eg: DES-CBC,F8143EDE5960C597.
   *
   * headers: contains all other PEM encapsulated headers -- where order is
   *   significant (for pairing data like recipient ID + key info).
   *
   * body: the binary-encoded body.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(8); // shortcut for pem API


  var pem = module.exports = forge.pem = forge.pem || {};
  /**
   * Encodes (serializes) the given PEM object.
   *
   * @param msg the PEM message object to encode.
   * @param options the options to use:
   *          maxline the maximum characters per line for the body, (default: 64).
   *
   * @return the PEM-formatted string.
   */

  pem.encode = function (msg, options) {
    options = options || {};
    var rval = '-----BEGIN ' + msg.type + '-----\r\n'; // encode special headers

    var header;

    if (msg.procType) {
      header = {
        name: 'Proc-Type',
        values: [String(msg.procType.version), msg.procType.type]
      };
      rval += foldHeader(header);
    }

    if (msg.contentDomain) {
      header = {
        name: 'Content-Domain',
        values: [msg.contentDomain]
      };
      rval += foldHeader(header);
    }

    if (msg.dekInfo) {
      header = {
        name: 'DEK-Info',
        values: [msg.dekInfo.algorithm]
      };

      if (msg.dekInfo.parameters) {
        header.values.push(msg.dekInfo.parameters);
      }

      rval += foldHeader(header);
    }

    if (msg.headers) {
      // encode all other headers
      for (var i = 0; i < msg.headers.length; ++i) {
        rval += foldHeader(msg.headers[i]);
      }
    } // terminate header


    if (msg.procType) {
      rval += '\r\n';
    } // add body


    rval += forge.util.encode64(msg.body, options.maxline || 64) + '\r\n';
    rval += '-----END ' + msg.type + '-----\r\n';
    return rval;
  };
  /**
   * Decodes (deserializes) all PEM messages found in the given string.
   *
   * @param str the PEM-formatted string to decode.
   *
   * @return the PEM message objects in an array.
   */


  pem.decode = function (str) {
    var rval = []; // split string into PEM messages (be lenient w/EOF on BEGIN line)

    var rMessage = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g;
    var rHeader = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/;
    var rCRLF = /\r?\n/;
    var match;

    while (true) {
      match = rMessage.exec(str);

      if (!match) {
        break;
      }

      var msg = {
        type: match[1],
        procType: null,
        contentDomain: null,
        dekInfo: null,
        headers: [],
        body: forge.util.decode64(match[3])
      };
      rval.push(msg); // no headers

      if (!match[2]) {
        continue;
      } // parse headers


      var lines = match[2].split(rCRLF);
      var li = 0;

      while (match && li < lines.length) {
        // get line, trim any rhs whitespace
        var line = lines[li].replace(/\s+$/, ''); // RFC2822 unfold any following folded lines

        for (var nl = li + 1; nl < lines.length; ++nl) {
          var next = lines[nl];

          if (!/\s/.test(next[0])) {
            break;
          }

          line += next;
          li = nl;
        } // parse header


        match = line.match(rHeader);

        if (match) {
          var header = {
            name: match[1],
            values: []
          };
          var values = match[2].split(',');

          for (var vi = 0; vi < values.length; ++vi) {
            header.values.push(ltrim(values[vi]));
          } // Proc-Type must be the first header


          if (!msg.procType) {
            if (header.name !== 'Proc-Type') {
              throw new Error('Invalid PEM formatted message. The first ' + 'encapsulated header must be "Proc-Type".');
            } else if (header.values.length !== 2) {
              throw new Error('Invalid PEM formatted message. The "Proc-Type" ' + 'header must have two subfields.');
            }

            msg.procType = {
              version: values[0],
              type: values[1]
            };
          } else if (!msg.contentDomain && header.name === 'Content-Domain') {
            // special-case Content-Domain
            msg.contentDomain = values[0] || '';
          } else if (!msg.dekInfo && header.name === 'DEK-Info') {
            // special-case DEK-Info
            if (header.values.length === 0) {
              throw new Error('Invalid PEM formatted message. The "DEK-Info" ' + 'header must have at least one subfield.');
            }

            msg.dekInfo = {
              algorithm: values[0],
              parameters: values[1] || null
            };
          } else {
            msg.headers.push(header);
          }
        }

        ++li;
      }

      if (msg.procType === 'ENCRYPTED' && !msg.dekInfo) {
        throw new Error('Invalid PEM formatted message. The "DEK-Info" ' + 'header must be present if "Proc-Type" is "ENCRYPTED".');
      }
    }

    if (rval.length === 0) {
      throw new Error('Invalid PEM formatted message.');
    }

    return rval;
  };

  function foldHeader(header) {
    var rval = header.name + ': '; // ensure values with CRLF are folded

    var values = [];

    var insertSpace = function insertSpace(match, $1) {
      return ' ' + $1;
    };

    for (var i = 0; i < header.values.length; ++i) {
      values.push(header.values[i].replace(/^(\S+\r\n)/, insertSpace));
    }

    rval += values.join(',') + '\r\n'; // do folding

    var length = 0;
    var candidate = -1;

    for (var i = 0; i < rval.length; ++i, ++length) {
      if (length > 65 && candidate !== -1) {
        var insert = rval[candidate];

        if (insert === ',') {
          ++candidate;
          rval = rval.substr(0, candidate) + '\r\n ' + rval.substr(candidate);
        } else {
          rval = rval.substr(0, candidate) + '\r\n' + insert + rval.substr(candidate + 1);
        }

        length = i - candidate - 1;
        candidate = -1;
        ++i;
      } else if (rval[i] === ' ' || rval[i] === '\t' || rval[i] === ',') {
        candidate = i;
      }
    }

    return rval;
  }

  function ltrim(str) {
    return str.replace(/^\s+/, '');
  }
  /***/

},
/* 81 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * jwk/helpers.js - JWK Internal Helper Functions and Constants
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var clone = __webpack_require__(42),
        util = __webpack_require__(19),
        forge = __webpack_require__(14);

    var ALGORITHMS = __webpack_require__(153); // ### ASN.1 Validators
    // Adapted from digitalbazaar/node-forge/js/asn1.js
    // PrivateKeyInfo


    var privateKeyValidator = {
      name: "PrivateKeyInfo",
      tagClass: forge.asn1.Class.UNIVERSAL,
      type: forge.asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        // Version (INTEGER)
        name: "PrivateKeyInfo.version",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.INTEGER,
        constructed: false,
        capture: "keyVersion"
      }, {
        name: "PrivateKeyInfo.privateKeyAlgorithm",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.SEQUENCE,
        constructed: true,
        value: [{
          name: "AlgorithmIdentifier.algorithm",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.OID,
          constructed: false,
          capture: "keyOid"
        }, {
          name: "AlgorithmIdentifier.parameters",
          captureAsn1: "keyParams"
        }]
      }, {
        name: "PrivateKeyInfo",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.OCTETSTRING,
        constructed: false,
        capture: "keyValue"
      }]
    }; // Adapted from digitalbazaar/node-forge/x509.js

    var publicKeyValidator = {
      name: "SubjectPublicKeyInfo",
      tagClass: forge.asn1.Class.UNIVERSAL,
      type: forge.asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.SEQUENCE,
        constructed: true,
        value: [{
          name: "AlgorithmIdentifier.algorithm",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.OID,
          constructed: false,
          capture: "keyOid"
        }, {
          name: "AlgorithmIdentifier.parameters",
          captureAsn1: "keyParams"
        }]
      }, {
        name: "SubjectPublicKeyInfo.subjectPublicKey",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.BITSTRING,
        constructed: false,
        capture: "keyValue"
      }]
    }; // Adapted from digitalbazaar/node-forge/x509.js

    var X509CertificateValidator = {
      name: "Certificate",
      tagClass: forge.asn1.Class.UNIVERSAL,
      type: forge.asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: "Certificate.TBSCertificate",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.SEQUENCE,
        constructed: true,
        captureAsn1: "certificate",
        value: [{
          name: "Certificate.TBSCertificate.version",
          tagClass: forge.asn1.Class.CONTEXT_SPECIFIC,
          type: 0,
          constructed: true,
          optional: true,
          value: [{
            name: "Certificate.TBSCertificate.version.integer",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.INTEGER,
            constructed: false,
            capture: "certVersion"
          }]
        }, {
          name: "Certificate.TBSCertificate.serialNumber",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "certSerialNumber"
        }, {
          name: "Certificate.TBSCertificate.signature",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.SEQUENCE,
          constructed: true,
          value: [{
            name: "Certificate.TBSCertificate.signature.algorithm",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.OID,
            constructed: false,
            capture: "certSignatureOid"
          }, {
            name: "Certificate.TBSCertificate.signature.parameters",
            tagClass: forge.asn1.Class.UNIVERSAL,
            optional: true,
            captureAsn1: "certSignatureParams"
          }]
        }, {
          name: "Certificate.TBSCertificate.issuer",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.SEQUENCE,
          constructed: true,
          captureAsn1: "certIssuer"
        }, {
          name: "Certificate.TBSCertificate.validity",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.SEQUENCE,
          constructed: true,
          // Note: UTC and generalized times may both appear so the capture
          // names are based on their detected order, the names used below
          // are only for the common case, which validity time really means
          // "notBefore" and which means "notAfter" will be determined by order
          value: [{
            // notBefore (Time) (UTC time case)
            name: "Certificate.TBSCertificate.validity.notBefore (utc)",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.UTCTIME,
            constructed: false,
            optional: true,
            capture: "certValidity1UTCTime"
          }, {
            // notBefore (Time) (generalized time case)
            name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.GENERALIZEDTIME,
            constructed: false,
            optional: true,
            capture: "certValidity2GeneralizedTime"
          }, {
            // notAfter (Time) (only UTC time is supported)
            name: "Certificate.TBSCertificate.validity.notAfter (utc)",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.UTCTIME,
            constructed: false,
            optional: true,
            capture: "certValidity3UTCTime"
          }, {
            // notAfter (Time) (only UTC time is supported)
            name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.GENERALIZEDTIME,
            constructed: false,
            optional: true,
            capture: "certValidity4GeneralizedTime"
          }]
        }, {
          // Name (subject) (RDNSequence)
          name: "Certificate.TBSCertificate.subject",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.SEQUENCE,
          constructed: true,
          captureAsn1: "certSubject"
        }, // SubjectPublicKeyInfo
        publicKeyValidator, {
          // issuerUniqueID (optional)
          name: "Certificate.TBSCertificate.issuerUniqueID",
          tagClass: forge.asn1.Class.CONTEXT_SPECIFIC,
          type: 1,
          constructed: true,
          optional: true,
          value: [{
            name: "Certificate.TBSCertificate.issuerUniqueID.id",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.BITSTRING,
            constructed: false,
            capture: "certIssuerUniqueId"
          }]
        }, {
          // subjectUniqueID (optional)
          name: "Certificate.TBSCertificate.subjectUniqueID",
          tagClass: forge.asn1.Class.CONTEXT_SPECIFIC,
          type: 2,
          constructed: true,
          optional: true,
          value: [{
            name: "Certificate.TBSCertificate.subjectUniqueID.id",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.BITSTRING,
            constructed: false,
            capture: "certSubjectUniqueId"
          }]
        }, {
          // Extensions (optional)
          name: "Certificate.TBSCertificate.extensions",
          tagClass: forge.asn1.Class.CONTEXT_SPECIFIC,
          type: 3,
          constructed: true,
          captureAsn1: "certExtensions",
          optional: true
        }]
      }, {
        // AlgorithmIdentifier (signature algorithm)
        name: "Certificate.signatureAlgorithm",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.SEQUENCE,
        constructed: true,
        value: [{
          // algorithm
          name: "Certificate.signatureAlgorithm.algorithm",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.OID,
          constructed: false,
          capture: "certSignatureOid"
        }, {
          name: "Certificate.TBSCertificate.signature.parameters",
          tagClass: forge.asn1.Class.UNIVERSAL,
          optional: true,
          captureAsn1: "certSignatureParams"
        }]
      }, {
        // SignatureValue
        name: "Certificate.signatureValue",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.BITSTRING,
        constructed: false,
        capture: "certSignature"
      }]
    };
    var INTERNALS = {
      THUMBPRINT_KEY: "internal\0thumbprint",
      THUMBPRINT_HASH: "SHA-256"
    };
    module.exports = {
      validators: {
        privateKey: privateKeyValidator,
        publicKey: publicKeyValidator,
        certificate: X509CertificateValidator
      },
      thumbprint: function thumbprint(cfg, json, hash) {
        if ("function" !== typeof cfg.thumbprint) {
          return Promise.reject(new Error("thumbprint not supported"));
        }

        hash = (hash || INTERNALS.THUMBPRINT_HASH).toUpperCase();
        var fields = cfg.thumbprint(json);
        var input = Object.keys(fields).sort().map(function (k) {
          var v = fields[k];

          if (Buffer.isBuffer(v)) {
            v = util.base64url.encode(v);
          }

          return JSON.stringify(k) + ":" + JSON.stringify(v);
        });
        input = "{" + input.join(",") + "}";

        try {
          return ALGORITHMS.digest(hash, Buffer.from(input, "utf8"));
        } catch (err) {
          return Promise.reject(err);
        }
      },
      unpackProps: function unpackProps(props, allowed) {
        var output; // apply all of the existing values

        allowed.forEach(function (cfg) {
          if (!(cfg.name in props)) {
            return;
          }

          output = output || {};
          var value = props[cfg.name];

          switch (cfg.type) {
            case "binary":
              if (Buffer.isBuffer(value)) {
                props[cfg.name] = util.base64url.encode(value);
              } else {
                value = util.base64url.decode(value);
              }

              break;

            case "string":
            case "number":
            case "boolean":
              break;

            case "array":
              value = [].concat(value);
              break;

            case "object":
              value = clone(value);
              break;

            default:
              // TODO: deep clone?
              break;
          }

          output[cfg.name] = value;
        }); // remove any from json that didn't apply

        var check = output || {};
        Object.keys(props).forEach(function (n) {
          if (n in check) {
            return;
          }

          delete props[n];
        });
        return output;
      },
      COMMON_PROPS: [{
        name: "kty",
        type: "string"
      }, {
        name: "kid",
        type: "string"
      }, {
        name: "use",
        type: "string"
      }, {
        name: "alg",
        type: "string"
      }, {
        name: "x5c",
        type: "array"
      }, {
        name: "x5t",
        type: "binary"
      }, {
        name: "x5u",
        type: "string"
      }, {
        name: "key_ops",
        type: "array"
      }],
      INTERNALS: INTERNALS
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 82 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * util/databuffer.js - Forge-compatible Buffer based on Node.js Buffers
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var forge = __webpack_require__(14),
        base64url = __webpack_require__(106);
    /**
     *
     */


    function DataBuffer(b, options) {
      options = options || {}; // treat (views of) (Array)Buffers special
      // NOTE: default implementation creates copies, but efficiently
      //       wherever possible

      if (Buffer.isBuffer(b)) {
        this.data = b;
      } else if (forge.util.isArrayBuffer(b)) {
        b = new Uint8Array(b);
        this.data = Buffer.from(b);
      } else if (forge.util.isArrayBufferView(b)) {
        b = new Uint8Array(b.buffer, b.byteOffset, b.byteLength);
        this.data = Buffer.from(b);
      }

      if (this.data) {
        this.write = this.data.length;
        b = undefined;
      } // setup growth rate


      this.growSize = options.growSize || DataBuffer.DEFAULT_GROW_SIZE; // initialize pointers and data

      this.write = this.write || 0;
      this.read = this.read || 0;

      if (b) {
        this.putBytes(b);
      } else if (!this.data) {
        this.accommodate(0);
      } // massage read/write pointers


      options.readOffset = "readOffset" in options ? options.readOffset : this.read;
      this.write = "writeOffset" in options ? options.writeOffset : this.write;
      this.read = Math.min(options.readOffset, this.write);
    }

    DataBuffer.DEFAULT_GROW_SIZE = 16;

    DataBuffer.prototype.length = function () {
      return this.write - this.read;
    };

    DataBuffer.prototype.available = function () {
      return this.data.length - this.write;
    };

    DataBuffer.prototype.isEmpty = function () {
      return this.length() <= 0;
    };

    DataBuffer.prototype.accommodate = function (length) {
      if (!this.data) {
        // initializes a new buffer
        length = Math.max(this.write + length, this.growSize);
        this.data = Buffer.alloc(length);
      } else if (this.available() < length) {
        length = Math.max(length, this.growSize); // create a new empty buffer, and copy current one into it

        var src = this.data;
        var dst = Buffer.alloc(src.length + length);
        src.copy(dst, 0); // set data as the new buffer

        this.data = dst;
      } // ensure the rest is 0


      this.data.fill(0, this.write);
      return this;
    };

    DataBuffer.prototype.clear = function () {
      this.read = this.write = 0;
      this.data = Buffer.alloc(0);
      return this;
    };

    DataBuffer.prototype.truncate = function (count) {
      // chop off <count> bytes from the end
      this.write = this.read + Math.max(0, this.length() - count); // ensure the remainder is 0

      this.data.fill(0, this.write);
      return this;
    };

    DataBuffer.prototype.compact = function () {
      if (this.read > 0) {
        if (this.write === this.read) {
          this.read = this.write = 0;
        } else {
          this.data.copy(this.data, 0, this.read, this.write);
          this.write = this.write - this.read;
          this.read = 0;
        } // ensure remainder is 0


        this.data.fill(0, this.write);
      }

      return this;
    };

    DataBuffer.prototype.copy = function () {
      return new DataBuffer(this, {
        readOffset: this.read,
        writeOffset: this.write,
        growSize: this.growSize
      });
    };

    DataBuffer.prototype.equals = function (test) {
      if (!DataBuffer.isBuffer(test)) {
        return false;
      }

      if (test.length() !== this.length()) {
        return false;
      }

      var rval = true,
          delta = this.read - test.read; // constant time

      for (var idx = test.read; test.write > idx; idx++) {
        rval = rval && this.data[idx + delta] === test.data[idx];
      }

      return rval;
    };

    DataBuffer.prototype.at = function (idx) {
      return this.data[this.read + idx];
    };

    DataBuffer.prototype.setAt = function (idx, b) {
      this.data[this.read + idx] = b;
      return this;
    };

    DataBuffer.prototype.last = function () {
      return this.data[this.write - 1];
    };

    DataBuffer.prototype.bytes = function (count) {
      var rval;

      if (undefined === count) {
        count = this.length();
      } else if (count) {
        count = Math.min(count, this.length());
      }

      if (0 === count) {
        rval = "";
      } else {
        var begin = this.read,
            end = begin + count,
            data = this.data.slice(begin, end);
        rval = String.fromCharCode.apply(null, data);
      }

      return rval;
    };

    DataBuffer.prototype.buffer = function (count) {
      var rval;

      if (undefined === count) {
        count = this.length();
      } else if (count) {
        count = Math.min(count, this.length());
      }

      if (0 === count) {
        rval = new ArrayBuffer(0);
      } else {
        var begin = this.read,
            end = begin + count,
            data = this.data.slice(begin, end);
        rval = new Uint8Array(end - begin);
        rval.set(data);
      }

      return rval;
    };

    DataBuffer.prototype.native = function (count) {
      var rval;

      if ("undefined" === typeof count) {
        count = this.length();
      } else if (count) {
        count = Math.min(count, this.length());
      }

      if (0 === count) {
        rval = Buffer.alloc(0);
      } else {
        var begin = this.read,
            end = begin + count;
        rval = this.data.slice(begin, end);
      }

      return rval;
    };

    DataBuffer.prototype.toHex = function () {
      return this.toString("hex");
    };

    DataBuffer.prototype.toString = function (encoding) {
      // short circuit empty string
      if (0 === this.length()) {
        return "";
      }

      var view = this.data.slice(this.read, this.write);
      encoding = encoding || "utf8"; // special cases, then built-in support

      switch (encoding) {
        case "raw":
          return view.toString("binary");

        case "base64url":
          return base64url.encode(view);

        case "utf16":
          return view.toString("ucs2");

        default:
          return view.toString(encoding);
      }
    };

    DataBuffer.prototype.fillWithByte = function (b, n) {
      if (!n) {
        n = this.available();
      }

      this.accommodate(n);
      this.data.fill(b, this.write, this.write + n);
      this.write += n;
      return this;
    };

    DataBuffer.prototype.getBuffer = function (count) {
      var rval = this.buffer(count);
      this.read += rval.byteLength;
      return rval;
    };

    DataBuffer.prototype.putBuffer = function (bytes) {
      return this.putBytes(bytes);
    };

    DataBuffer.prototype.getBytes = function (count) {
      var rval = this.bytes(count);
      this.read += rval.length;
      return rval;
    };

    DataBuffer.prototype.putBytes = function (bytes, encoding) {
      if ("string" === typeof bytes) {
        // fixup encoding
        encoding = encoding || "binary";

        switch (encoding) {
          case "utf16":
            // treat as UCS-2/UTF-16BE
            encoding = "ucs-2";
            break;

          case "raw":
            encoding = "binary";
            break;

          case "base64url":
            // NOTE: this returns a Buffer
            bytes = base64url.decode(bytes);
            break;
        } // replace bytes with decoded Buffer (if not already)


        if (!Buffer.isBuffer(bytes)) {
          bytes = Buffer.from(bytes, encoding);
        }
      }

      var src, dst;

      if (bytes instanceof DataBuffer) {
        // be slightly more efficient
        var orig = bytes;
        bytes = orig.data.slice(orig.read, orig.write);
        orig.read = orig.write;
      } else if (bytes instanceof forge.util.ByteStringBuffer) {
        bytes = bytes.getBytes();
      } // process array


      if (Buffer.isBuffer(bytes)) {
        src = bytes;
      } else if (Array.isArray(bytes)) {
        src = Buffer.from(bytes);
      } else if (forge.util.isArrayBuffer(bytes)) {
        src = new Uint8Array(bytes);
        src = Buffer.from(src);
      } else if (forge.util.isArrayBufferView(bytes)) {
        src = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        src = Buffer.from(src);
      } else {
        throw new TypeError("invalid source type");
      }

      this.accommodate(src.length);
      dst = this.data;
      src.copy(dst, this.write);
      this.write += src.length;
      return this;
    };

    DataBuffer.prototype.getNative = function (count) {
      var rval = this.native(count);
      this.read += rval.length;
      return rval;
    };

    DataBuffer.prototype.putNative = DataBuffer.prototype.putBuffer;

    DataBuffer.prototype.getByte = function () {
      var b = this.data[this.read];
      this.read = Math.min(this.read + 1, this.write);
      return b;
    };

    DataBuffer.prototype.putByte = function (b) {
      this.accommodate(1);
      this.data[this.write] = b & 0xff;
      this.write++;
      return this;
    };

    DataBuffer.prototype.getInt16 = function () {
      var n = this.data[this.read] << 8 ^ this.data[this.read + 1];
      this.read = Math.min(this.read + 2, this.write);
      return n;
    };

    DataBuffer.prototype.putInt16 = function (n) {
      this.accommodate(2);
      this.data[this.write] = n >>> 8 & 0xff;
      this.data[this.write + 1] = n & 0xff;
      this.write += 2;
      return this;
    };

    DataBuffer.prototype.getInt24 = function () {
      var n = this.data[this.read] << 16 ^ this.data[this.read + 1] << 8 ^ this.data[this.read + 2];
      this.read = Math.min(this.read + 3, this.write);
      return n;
    };

    DataBuffer.prototype.putInt24 = function (n) {
      this.accommodate(3);
      this.data[this.write] = n >>> 16 & 0xff;
      this.data[this.write + 1] = n >>> 8 & 0xff;
      this.data[this.write + 2] = n & 0xff;
      this.write += 3;
      return this;
    };

    DataBuffer.prototype.getInt32 = function () {
      var n = this.data[this.read] << 24 ^ this.data[this.read + 1] << 16 ^ this.data[this.read + 2] << 8 ^ this.data[this.read + 3];
      this.read = Math.min(this.read + 4, this.write);
      return n;
    };

    DataBuffer.prototype.putInt32 = function (n) {
      this.accommodate(4);
      this.data[this.write] = n >>> 24 & 0xff;
      this.data[this.write + 1] = n >>> 16 & 0xff;
      this.data[this.write + 2] = n >>> 8 & 0xff;
      this.data[this.write + 3] = n & 0xff;
      this.write += 4;
      return this;
    };

    DataBuffer.prototype.getInt16Le = function () {
      var n = this.data[this.read + 1] << 8 ^ this.data[this.read];
      this.read = Math.min(this.read + 2, this.write);
      return n;
    };

    DataBuffer.prototype.putInt16Le = function (n) {
      this.accommodate(2);
      this.data[this.write + 1] = n >>> 8 & 0xff;
      this.data[this.write] = n & 0xff;
      this.write += 2;
      return this;
    };

    DataBuffer.prototype.getInt24Le = function () {
      var n = this.data[this.read + 2] << 16 ^ this.data[this.read + 1] << 8 ^ this.data[this.read];
      this.read = Math.min(this.read + 3, this.write);
      return n;
    };

    DataBuffer.prototype.putInt24Le = function (n) {
      this.accommodate(3);
      this.data[this.write + 2] = n >>> 16 & 0xff;
      this.data[this.write + 1] = n >>> 8 & 0xff;
      this.data[this.write] = n & 0xff;
      this.write += 3;
      return this;
    };

    DataBuffer.prototype.getInt32Le = function () {
      var n = this.data[this.read + 3] << 24 ^ this.data[this.read + 2] << 16 ^ this.data[this.read + 1] << 8 ^ this.data[this.read];
      this.read = Math.min(this.read + 4, this.write);
      return n;
    };

    DataBuffer.prototype.putInt32Le = function (n) {
      this.accommodate(4);
      this.data[this.write + 3] = n >>> 24 & 0xff;
      this.data[this.write + 2] = n >>> 16 & 0xff;
      this.data[this.write + 1] = n >>> 8 & 0xff;
      this.data[this.write] = n & 0xff;
      this.write += 4;
      return this;
    };

    DataBuffer.prototype.getInt = function (bits) {
      var rval = 0;

      do {
        rval = rval << 8 | this.getByte();
        bits -= 8;
      } while (bits > 0);

      return rval;
    };

    DataBuffer.prototype.putInt = function (n, bits) {
      this.accommodate(Math.ceil(bits / 8));

      do {
        bits -= 8;
        this.putByte(n >> bits & 0xff);
      } while (bits > 0);

      return this;
    };

    DataBuffer.prototype.putSignedInt = function (n, bits) {
      if (n < 0) {
        n += 2 << bits - 1;
      }

      return this.putInt(n, bits);
    };

    DataBuffer.prototype.putString = function (str) {
      return this.putBytes(str, "utf16");
    };

    DataBuffer.isBuffer = function (test) {
      return test instanceof DataBuffer;
    };

    DataBuffer.asBuffer = function (orig) {
      return DataBuffer.isBuffer(orig) ? orig : orig ? new DataBuffer(orig) : new DataBuffer();
    };

    module.exports = forge.util.ByteBuffer = DataBuffer;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 83 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    if (!process.version || process.version.indexOf('v0.') === 0 || process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
      module.exports = {
        nextTick: nextTick
      };
    } else {
      module.exports = process;
    }

    function nextTick(fn, arg1, arg2, arg3) {
      if (typeof fn !== 'function') {
        throw new TypeError('"callback" argument must be a function');
      }

      var len = arguments.length;
      var args, i;

      switch (len) {
        case 0:
        case 1:
          return process.nextTick(fn);

        case 2:
          return process.nextTick(function afterTickOne() {
            fn.call(null, arg1);
          });

        case 3:
          return process.nextTick(function afterTickTwo() {
            fn.call(null, arg1, arg2);
          });

        case 4:
          return process.nextTick(function afterTickThree() {
            fn.call(null, arg1, arg2, arg3);
          });

        default:
          args = new Array(len - 1);
          i = 0;

          while (i < args.length) {
            args[i++] = arguments[i];
          }

          return process.nextTick(function afterTick() {
            fn.apply(null, args);
          });
      }
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(16));
  /***/
},
/* 84 */

/***/
function (module, exports) {
  module.exports = function (module) {
    if (!module.webpackPolyfill) {
      module.deprecate = function () {};

      module.paths = []; // module.parent = undefined by default

      if (!module.children) module.children = [];
      Object.defineProperty(module, "loaded", {
        enumerable: true,
        get: function get() {
          return module.l;
        }
      });
      Object.defineProperty(module, "id", {
        enumerable: true,
        get: function get() {
          return module.i;
        }
      });
      module.webpackPolyfill = 1;
    }

    return module;
  };
  /***/

},
/* 85 */

/***/
function (module, exports) {
  /*
   * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
   *
   * Licensed under the Apache License, Version 2.0 (the "License").
   * You may not use this file except in compliance with the License.
   * A copy of the License is located at
   *
   *  http://aws.amazon.com/apache2.0
   *
   * or in the "license" file accompanying this file. This file is distributed
   * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
   * express or implied. See the License for the specific language governing
   * permissions and limitations under the License.
   */
  //node.js deps
  //npm deps
  //app deps
  //begin module

  /**
   * This is the exposed module.
   * This method determines if an object is undefined.
   *
   * @param {Object} value
   * @access public
   */
  module.exports = function (value) {
    return typeof value === 'undefined' || value === null;
  };
  /***/

},
/* 86 */

/***/
function (module, exports, __webpack_require__) {
  // false -> Array#indexOf
  // true  -> Array#includes
  var toIObject = __webpack_require__(26);

  var toLength = __webpack_require__(13);

  var toAbsoluteIndex = __webpack_require__(58);

  module.exports = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = toIObject($this);
      var length = toLength(O.length);
      var index = toAbsoluteIndex(fromIndex, length);
      var value; // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare

      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++]; // eslint-disable-next-line no-self-compare

        if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
      } else for (; length > index; index++) {
        if (IS_INCLUDES || index in O) {
          if (O[index] === el) return IS_INCLUDES || index || 0;
        }
      }
      return !IS_INCLUDES && -1;
    };
  };
  /***/

},
/* 87 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(3);

  var $export = __webpack_require__(0);

  var redefine = __webpack_require__(21);

  var redefineAll = __webpack_require__(56);

  var meta = __webpack_require__(45);

  var forOf = __webpack_require__(50);

  var anInstance = __webpack_require__(49);

  var isObject = __webpack_require__(7);

  var fails = __webpack_require__(5);

  var $iterDetect = __webpack_require__(92);

  var setToStringTag = __webpack_require__(65);

  var inheritIfRequired = __webpack_require__(116);

  module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = global[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};

    var fixMethod = function fixMethod(KEY) {
      var fn = proto[KEY];
      redefine(proto, KEY, KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) {
        fn.call(this, a === 0 ? 0 : a);
        return this;
      } : function set(a, b) {
        fn.call(this, a === 0 ? 0 : a, b);
        return this;
      });
    };

    if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
      new C().entries().next();
    }))) {
      // create collection constructor
      C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
      redefineAll(C.prototype, methods);
      meta.NEED = true;
    } else {
      var instance = new C(); // early implementations not supports chaining

      var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance; // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false

      var THROWS_ON_PRIMITIVES = fails(function () {
        instance.has(1);
      }); // most early implementations doesn't supports iterables, most modern - not close it correctly

      var ACCEPT_ITERABLES = $iterDetect(function (iter) {
        new C(iter);
      }); // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same

      var BUGGY_ZERO = !IS_WEAK && fails(function () {
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new C();
        var index = 5;

        while (index--) {
          $instance[ADDER](index, index);
        }

        return !$instance.has(-0);
      });

      if (!ACCEPT_ITERABLES) {
        C = wrapper(function (target, iterable) {
          anInstance(target, C, NAME);
          var that = inheritIfRequired(new Base(), target, C);
          if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
          return that;
        });
        C.prototype = proto;
        proto.constructor = C;
      }

      if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
        fixMethod('delete');
        fixMethod('has');
        IS_MAP && fixMethod('get');
      }

      if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER); // weak collections should not contains .clear method

      if (IS_WEAK && proto.clear) delete proto.clear;
    }

    setToStringTag(C, NAME);
    O[NAME] = C;
    $export($export.G + $export.W + $export.F * (C != Base), O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
  };
  /***/

},
/* 88 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var hide = __webpack_require__(20);

  var redefine = __webpack_require__(21);

  var fails = __webpack_require__(5);

  var defined = __webpack_require__(33);

  var wks = __webpack_require__(9);

  module.exports = function (KEY, length, exec) {
    var SYMBOL = wks(KEY);
    var fns = exec(defined, SYMBOL, ''[KEY]);
    var strfn = fns[0];
    var rxfn = fns[1];

    if (fails(function () {
      var O = {};

      O[SYMBOL] = function () {
        return 7;
      };

      return ''[KEY](O) != 7;
    })) {
      redefine(String.prototype, KEY, strfn);
      hide(RegExp.prototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) {
        return rxfn.call(string, this, arg);
      } // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) {
        return rxfn.call(string, this);
      });
    }
  };
  /***/

},
/* 89 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 21.2.5.3 get RegExp.prototype.flags

  var anObject = __webpack_require__(2);

  module.exports = function () {
    var that = anObject(this);
    var result = '';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.unicode) result += 'u';
    if (that.sticky) result += 'y';
    return result;
  };
  /***/

},
/* 90 */

/***/
function (module, exports, __webpack_require__) {
  // 7.2.2 IsArray(argument)
  var cof = __webpack_require__(27);

  module.exports = Array.isArray || function isArray(arg) {
    return cof(arg) == 'Array';
  };
  /***/

},
/* 91 */

/***/
function (module, exports, __webpack_require__) {
  // 7.2.8 IsRegExp(argument)
  var isObject = __webpack_require__(7);

  var cof = __webpack_require__(27);

  var MATCH = __webpack_require__(9)('match');

  module.exports = function (it) {
    var isRegExp;
    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
  };
  /***/

},
/* 92 */

/***/
function (module, exports, __webpack_require__) {
  var ITERATOR = __webpack_require__(9)('iterator');

  var SAFE_CLOSING = false;

  try {
    var riter = [7][ITERATOR]();

    riter['return'] = function () {
      SAFE_CLOSING = true;
    }; // eslint-disable-next-line no-throw-literal


    Array.from(riter, function () {
      throw 2;
    });
  } catch (e) {
    /* empty */
  }

  module.exports = function (exec, skipClosing) {
    if (!skipClosing && !SAFE_CLOSING) return false;
    var safe = false;

    try {
      var arr = [7];
      var iter = arr[ITERATOR]();

      iter.next = function () {
        return {
          done: safe = true
        };
      };

      arr[ITERATOR] = function () {
        return iter;
      };

      exec(arr);
    } catch (e) {
      /* empty */
    }

    return safe;
  };
  /***/

},
/* 93 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Forced replacement prototype accessors methods

  module.exports = __webpack_require__(51) || !__webpack_require__(5)(function () {
    var K = Math.random(); // In FF throws only define methods
    // eslint-disable-next-line no-undef, no-useless-call

    __defineSetter__.call(null, K, function () {
      /* empty */
    });

    delete __webpack_require__(3)[K];
  });
  /***/
},
/* 94 */

/***/
function (module, exports) {
  exports.f = Object.getOwnPropertySymbols;
  /***/
},
/* 95 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/proposal-setmap-offrom/

  var $export = __webpack_require__(0);

  var aFunction = __webpack_require__(18);

  var ctx = __webpack_require__(28);

  var forOf = __webpack_require__(50);

  module.exports = function (COLLECTION) {
    $export($export.S, COLLECTION, {
      from: function from(source
      /* , mapFn, thisArg */
      ) {
        var mapFn = arguments[1];
        var mapping, A, n, cb;
        aFunction(this);
        mapping = mapFn !== undefined;
        if (mapping) aFunction(mapFn);
        if (source == undefined) return new this();
        A = [];

        if (mapping) {
          n = 0;
          cb = ctx(mapFn, arguments[2], 2);
          forOf(source, false, function (nextItem) {
            A.push(cb(nextItem, n++));
          });
        } else {
          forOf(source, false, A.push, A);
        }

        return new this(A);
      }
    });
  };
  /***/

},
/* 96 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/proposal-setmap-offrom/

  var $export = __webpack_require__(0);

  module.exports = function (COLLECTION) {
    $export($export.S, COLLECTION, {
      of: function of() {
        var length = arguments.length;
        var A = new Array(length);

        while (length--) {
          A[length] = arguments[length];
        }

        return new this(A);
      }
    });
  };
  /***/

},
/* 97 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(3);

  var SHARED = '__core-js_shared__';
  var store = global[SHARED] || (global[SHARED] = {});

  module.exports = function (key) {
    return store[key] || (store[key] = {});
  };
  /***/

},
/* 98 */

/***/
function (module, exports, __webpack_require__) {
  // 7.3.20 SpeciesConstructor(O, defaultConstructor)
  var anObject = __webpack_require__(2);

  var aFunction = __webpack_require__(18);

  var SPECIES = __webpack_require__(9)('species');

  module.exports = function (O, D) {
    var C = anObject(O).constructor;
    var S;
    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
  };
  /***/

},
/* 99 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(3);

  var hide = __webpack_require__(20);

  var uid = __webpack_require__(59);

  var TYPED = uid('typed_array');
  var VIEW = uid('view');
  var ABV = !!(global.ArrayBuffer && global.DataView);
  var CONSTR = ABV;
  var i = 0;
  var l = 9;
  var Typed;
  var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');

  while (i < l) {
    if (Typed = global[TypedArrayConstructors[i++]]) {
      hide(Typed.prototype, TYPED, true);
      hide(Typed.prototype, VIEW, true);
    } else CONSTR = false;
  }

  module.exports = {
    ABV: ABV,
    CONSTR: CONSTR,
    TYPED: TYPED,
    VIEW: VIEW
  };
  /***/
},
/* 100 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function (undefined) {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var Base = C_lib.Base;
      var X32WordArray = C_lib.WordArray;
      /**
       * x64 namespace.
       */

      var C_x64 = C.x64 = {};
      /**
       * A 64-bit word.
       */

      var X64Word = C_x64.Word = Base.extend({
        /**
         * Initializes a newly created 64-bit word.
         *
         * @param {number} high The high 32 bits.
         * @param {number} low The low 32 bits.
         *
         * @example
         *
         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
         */
        init: function init(high, low) {
          this.high = high;
          this.low = low;
        }
        /**
         * Bitwise NOTs this word.
         *
         * @return {X64Word} A new x64-Word object after negating.
         *
         * @example
         *
         *     var negated = x64Word.not();
         */
        // not: function () {
        // var high = ~this.high;
        // var low = ~this.low;
        // return X64Word.create(high, low);
        // },

        /**
         * Bitwise ANDs this word with the passed word.
         *
         * @param {X64Word} word The x64-Word to AND with this word.
         *
         * @return {X64Word} A new x64-Word object after ANDing.
         *
         * @example
         *
         *     var anded = x64Word.and(anotherX64Word);
         */
        // and: function (word) {
        // var high = this.high & word.high;
        // var low = this.low & word.low;
        // return X64Word.create(high, low);
        // },

        /**
         * Bitwise ORs this word with the passed word.
         *
         * @param {X64Word} word The x64-Word to OR with this word.
         *
         * @return {X64Word} A new x64-Word object after ORing.
         *
         * @example
         *
         *     var ored = x64Word.or(anotherX64Word);
         */
        // or: function (word) {
        // var high = this.high | word.high;
        // var low = this.low | word.low;
        // return X64Word.create(high, low);
        // },

        /**
         * Bitwise XORs this word with the passed word.
         *
         * @param {X64Word} word The x64-Word to XOR with this word.
         *
         * @return {X64Word} A new x64-Word object after XORing.
         *
         * @example
         *
         *     var xored = x64Word.xor(anotherX64Word);
         */
        // xor: function (word) {
        // var high = this.high ^ word.high;
        // var low = this.low ^ word.low;
        // return X64Word.create(high, low);
        // },

        /**
         * Shifts this word n bits to the left.
         *
         * @param {number} n The number of bits to shift.
         *
         * @return {X64Word} A new x64-Word object after shifting.
         *
         * @example
         *
         *     var shifted = x64Word.shiftL(25);
         */
        // shiftL: function (n) {
        // if (n < 32) {
        // var high = (this.high << n) | (this.low >>> (32 - n));
        // var low = this.low << n;
        // } else {
        // var high = this.low << (n - 32);
        // var low = 0;
        // }
        // return X64Word.create(high, low);
        // },

        /**
         * Shifts this word n bits to the right.
         *
         * @param {number} n The number of bits to shift.
         *
         * @return {X64Word} A new x64-Word object after shifting.
         *
         * @example
         *
         *     var shifted = x64Word.shiftR(7);
         */
        // shiftR: function (n) {
        // if (n < 32) {
        // var low = (this.low >>> n) | (this.high << (32 - n));
        // var high = this.high >>> n;
        // } else {
        // var low = this.high >>> (n - 32);
        // var high = 0;
        // }
        // return X64Word.create(high, low);
        // },

        /**
         * Rotates this word n bits to the left.
         *
         * @param {number} n The number of bits to rotate.
         *
         * @return {X64Word} A new x64-Word object after rotating.
         *
         * @example
         *
         *     var rotated = x64Word.rotL(25);
         */
        // rotL: function (n) {
        // return this.shiftL(n).or(this.shiftR(64 - n));
        // },

        /**
         * Rotates this word n bits to the right.
         *
         * @param {number} n The number of bits to rotate.
         *
         * @return {X64Word} A new x64-Word object after rotating.
         *
         * @example
         *
         *     var rotated = x64Word.rotR(7);
         */
        // rotR: function (n) {
        // return this.shiftR(n).or(this.shiftL(64 - n));
        // },

        /**
         * Adds this word with the passed word.
         *
         * @param {X64Word} word The x64-Word to add with this word.
         *
         * @return {X64Word} A new x64-Word object after adding.
         *
         * @example
         *
         *     var added = x64Word.add(anotherX64Word);
         */
        // add: function (word) {
        // var low = (this.low + word.low) | 0;
        // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
        // var high = (this.high + word.high + carry) | 0;
        // return X64Word.create(high, low);
        // }

      });
      /**
       * An array of 64-bit words.
       *
       * @property {Array} words The array of CryptoJS.x64.Word objects.
       * @property {number} sigBytes The number of significant bytes in this word array.
       */

      var X64WordArray = C_x64.WordArray = Base.extend({
        /**
         * Initializes a newly created word array.
         *
         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
         *
         * @example
         *
         *     var wordArray = CryptoJS.x64.WordArray.create();
         *
         *     var wordArray = CryptoJS.x64.WordArray.create([
         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
         *     ]);
         *
         *     var wordArray = CryptoJS.x64.WordArray.create([
         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
         *     ], 10);
         */
        init: function init(words, sigBytes) {
          words = this.words = words || [];

          if (sigBytes != undefined) {
            this.sigBytes = sigBytes;
          } else {
            this.sigBytes = words.length * 8;
          }
        },

        /**
         * Converts this 64-bit word array to a 32-bit word array.
         *
         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
         *
         * @example
         *
         *     var x32WordArray = x64WordArray.toX32();
         */
        toX32: function toX32() {
          // Shortcuts
          var x64Words = this.words;
          var x64WordsLength = x64Words.length; // Convert

          var x32Words = [];

          for (var i = 0; i < x64WordsLength; i++) {
            var x64Word = x64Words[i];
            x32Words.push(x64Word.high);
            x32Words.push(x64Word.low);
          }

          return X32WordArray.create(x32Words, this.sigBytes);
        },

        /**
         * Creates a copy of this word array.
         *
         * @return {X64WordArray} The clone.
         *
         * @example
         *
         *     var clone = x64WordArray.clone();
         */
        clone: function clone() {
          var clone = Base.clone.call(this); // Clone "words" array

          var words = clone.words = this.words.slice(0); // Clone each X64Word object

          var wordsLength = words.length;

          for (var i = 0; i < wordsLength; i++) {
            words[i] = words[i].clone();
          }

          return clone;
        }
      });
    })();

    return CryptoJS;
  });
  /***/

},
/* 101 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Javascript implementation of basic RSA algorithms.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2014 Digital Bazaar, Inc.
   *
   * The only algorithm currently supported for PKI is RSA.
   *
   * An RSA key is often stored in ASN.1 DER format. The SubjectPublicKeyInfo
   * ASN.1 structure is composed of an algorithm of type AlgorithmIdentifier
   * and a subjectPublicKey of type bit string.
   *
   * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
   * for the algorithm, if any. In the case of RSA, there aren't any.
   *
   * SubjectPublicKeyInfo ::= SEQUENCE {
   *   algorithm AlgorithmIdentifier,
   *   subjectPublicKey BIT STRING
   * }
   *
   * AlgorithmIdentifer ::= SEQUENCE {
   *   algorithm OBJECT IDENTIFIER,
   *   parameters ANY DEFINED BY algorithm OPTIONAL
   * }
   *
   * For an RSA public key, the subjectPublicKey is:
   *
   * RSAPublicKey ::= SEQUENCE {
   *   modulus            INTEGER,    -- n
   *   publicExponent     INTEGER     -- e
   * }
   *
   * PrivateKeyInfo ::= SEQUENCE {
   *   version                   Version,
   *   privateKeyAlgorithm       PrivateKeyAlgorithmIdentifier,
   *   privateKey                PrivateKey,
   *   attributes           [0]  IMPLICIT Attributes OPTIONAL
   * }
   *
   * Version ::= INTEGER
   * PrivateKeyAlgorithmIdentifier ::= AlgorithmIdentifier
   * PrivateKey ::= OCTET STRING
   * Attributes ::= SET OF Attribute
   *
   * An RSA private key as the following structure:
   *
   * RSAPrivateKey ::= SEQUENCE {
   *   version Version,
   *   modulus INTEGER, -- n
   *   publicExponent INTEGER, -- e
   *   privateExponent INTEGER, -- d
   *   prime1 INTEGER, -- p
   *   prime2 INTEGER, -- q
   *   exponent1 INTEGER, -- d mod (p-1)
   *   exponent2 INTEGER, -- d mod (q-1)
   *   coefficient INTEGER -- (inverse of q) mod p
   * }
   *
   * Version ::= INTEGER
   *
   * The OID for the RSA key algorithm is: 1.2.840.113549.1.1.1
   */
  var forge = __webpack_require__(6);

  __webpack_require__(46);

  __webpack_require__(223);

  __webpack_require__(61);

  __webpack_require__(226);

  __webpack_require__(228);

  __webpack_require__(47);

  __webpack_require__(8);

  if (typeof BigInteger === 'undefined') {
    var BigInteger = forge.jsbn.BigInteger;
  } // shortcut for asn.1 API


  var asn1 = forge.asn1;
  /*
   * RSA encryption and decryption, see RFC 2313.
   */

  forge.pki = forge.pki || {};
  module.exports = forge.pki.rsa = forge.rsa = forge.rsa || {};
  var pki = forge.pki; // for finding primes, which are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29

  var GCD_30_DELTA = [6, 4, 2, 4, 2, 4, 6, 2]; // validator for a PrivateKeyInfo structure

  var privateKeyValidator = {
    // PrivateKeyInfo
    name: 'PrivateKeyInfo',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      // Version (INTEGER)
      name: 'PrivateKeyInfo.version',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'privateKeyVersion'
    }, {
      // privateKeyAlgorithm
      name: 'PrivateKeyInfo.privateKeyAlgorithm',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: 'AlgorithmIdentifier.algorithm',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OID,
        constructed: false,
        capture: 'privateKeyOid'
      }]
    }, {
      // PrivateKey
      name: 'PrivateKeyInfo',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OCTETSTRING,
      constructed: false,
      capture: 'privateKey'
    }]
  }; // validator for an RSA private key

  var rsaPrivateKeyValidator = {
    // RSAPrivateKey
    name: 'RSAPrivateKey',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      // Version (INTEGER)
      name: 'RSAPrivateKey.version',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'privateKeyVersion'
    }, {
      // modulus (n)
      name: 'RSAPrivateKey.modulus',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'privateKeyModulus'
    }, {
      // publicExponent (e)
      name: 'RSAPrivateKey.publicExponent',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'privateKeyPublicExponent'
    }, {
      // privateExponent (d)
      name: 'RSAPrivateKey.privateExponent',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'privateKeyPrivateExponent'
    }, {
      // prime1 (p)
      name: 'RSAPrivateKey.prime1',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'privateKeyPrime1'
    }, {
      // prime2 (q)
      name: 'RSAPrivateKey.prime2',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'privateKeyPrime2'
    }, {
      // exponent1 (d mod (p-1))
      name: 'RSAPrivateKey.exponent1',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'privateKeyExponent1'
    }, {
      // exponent2 (d mod (q-1))
      name: 'RSAPrivateKey.exponent2',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'privateKeyExponent2'
    }, {
      // coefficient ((inverse of q) mod p)
      name: 'RSAPrivateKey.coefficient',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'privateKeyCoefficient'
    }]
  }; // validator for an RSA public key

  var rsaPublicKeyValidator = {
    // RSAPublicKey
    name: 'RSAPublicKey',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      // modulus (n)
      name: 'RSAPublicKey.modulus',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'publicKeyModulus'
    }, {
      // publicExponent (e)
      name: 'RSAPublicKey.exponent',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'publicKeyExponent'
    }]
  }; // validator for an SubjectPublicKeyInfo structure
  // Note: Currently only works with an RSA public key

  var publicKeyValidator = forge.pki.rsa.publicKeyValidator = {
    name: 'SubjectPublicKeyInfo',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: 'subjectPublicKeyInfo',
    value: [{
      name: 'SubjectPublicKeyInfo.AlgorithmIdentifier',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: 'AlgorithmIdentifier.algorithm',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OID,
        constructed: false,
        capture: 'publicKeyOid'
      }]
    }, {
      // subjectPublicKey
      name: 'SubjectPublicKeyInfo.subjectPublicKey',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.BITSTRING,
      constructed: false,
      value: [{
        // RSAPublicKey
        name: 'SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        optional: true,
        captureAsn1: 'rsaPublicKey'
      }]
    }]
  };
  /**
   * Wrap digest in DigestInfo object.
   *
   * This function implements EMSA-PKCS1-v1_5-ENCODE as per RFC 3447.
   *
   * DigestInfo ::= SEQUENCE {
   *   digestAlgorithm DigestAlgorithmIdentifier,
   *   digest Digest
   * }
   *
   * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
   * Digest ::= OCTET STRING
   *
   * @param md the message digest object with the hash to sign.
   *
   * @return the encoded message (ready for RSA encrytion)
   */

  var emsaPkcs1v15encode = function emsaPkcs1v15encode(md) {
    // get the oid for the algorithm
    var oid;

    if (md.algorithm in pki.oids) {
      oid = pki.oids[md.algorithm];
    } else {
      var error = new Error('Unknown message digest algorithm.');
      error.algorithm = md.algorithm;
      throw error;
    }

    var oidBytes = asn1.oidToDer(oid).getBytes(); // create the digest info

    var digestInfo = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []);
    var digestAlgorithm = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []);
    digestAlgorithm.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, oidBytes));
    digestAlgorithm.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, ''));
    var digest = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, md.digest().getBytes());
    digestInfo.value.push(digestAlgorithm);
    digestInfo.value.push(digest); // encode digest info

    return asn1.toDer(digestInfo).getBytes();
  };
  /**
   * Performs x^c mod n (RSA encryption or decryption operation).
   *
   * @param x the number to raise and mod.
   * @param key the key to use.
   * @param pub true if the key is public, false if private.
   *
   * @return the result of x^c mod n.
   */


  var _modPow = function _modPow(x, key, pub) {
    if (pub) {
      return x.modPow(key.e, key.n);
    }

    if (!key.p || !key.q) {
      // allow calculation without CRT params (slow)
      return x.modPow(key.d, key.n);
    } // pre-compute dP, dQ, and qInv if necessary


    if (!key.dP) {
      key.dP = key.d.mod(key.p.subtract(BigInteger.ONE));
    }

    if (!key.dQ) {
      key.dQ = key.d.mod(key.q.subtract(BigInteger.ONE));
    }

    if (!key.qInv) {
      key.qInv = key.q.modInverse(key.p);
    }
    /* Chinese remainder theorem (CRT) states:
       Suppose n1, n2, ..., nk are positive integers which are pairwise
      coprime (n1 and n2 have no common factors other than 1). For any
      integers x1, x2, ..., xk there exists an integer x solving the
      system of simultaneous congruences (where ~= means modularly
      congruent so a ~= b mod n means a mod n = b mod n):
       x ~= x1 mod n1
      x ~= x2 mod n2
      ...
      x ~= xk mod nk
       This system of congruences has a single simultaneous solution x
      between 0 and n - 1. Furthermore, each xk solution and x itself
      is congruent modulo the product n = n1*n2*...*nk.
      So x1 mod n = x2 mod n = xk mod n = x mod n.
       The single simultaneous solution x can be solved with the following
      equation:
       x = sum(xi*ri*si) mod n where ri = n/ni and si = ri^-1 mod ni.
       Where x is less than n, xi = x mod ni.
       For RSA we are only concerned with k = 2. The modulus n = pq, where
      p and q are coprime. The RSA decryption algorithm is:
       y = x^d mod n
       Given the above:
       x1 = x^d mod p
      r1 = n/p = q
      s1 = q^-1 mod p
      x2 = x^d mod q
      r2 = n/q = p
      s2 = p^-1 mod q
       So y = (x1r1s1 + x2r2s2) mod n
           = ((x^d mod p)q(q^-1 mod p) + (x^d mod q)p(p^-1 mod q)) mod n
       According to Fermat's Little Theorem, if the modulus P is prime,
      for any integer A not evenly divisible by P, A^(P-1) ~= 1 mod P.
      Since A is not divisible by P it follows that if:
      N ~= M mod (P - 1), then A^N mod P = A^M mod P. Therefore:
       A^N mod P = A^(M mod (P - 1)) mod P. (The latter takes less effort
      to calculate). In order to calculate x^d mod p more quickly the
      exponent d mod (p - 1) is stored in the RSA private key (the same
      is done for x^d mod q). These values are referred to as dP and dQ
      respectively. Therefore we now have:
       y = ((x^dP mod p)q(q^-1 mod p) + (x^dQ mod q)p(p^-1 mod q)) mod n
       Since we'll be reducing x^dP by modulo p (same for q) we can also
      reduce x by p (and q respectively) before hand. Therefore, let
       xp = ((x mod p)^dP mod p), and
      xq = ((x mod q)^dQ mod q), yielding:
       y = (xp*q*(q^-1 mod p) + xq*p*(p^-1 mod q)) mod n
       This can be further reduced to a simple algorithm that only
      requires 1 inverse (the q inverse is used) to be used and stored.
      The algorithm is called Garner's algorithm. If qInv is the
      inverse of q, we simply calculate:
       y = (qInv*(xp - xq) mod p) * q + xq
       However, there are two further complications. First, we need to
      ensure that xp > xq to prevent signed BigIntegers from being used
      so we add p until this is true (since we will be mod'ing with
      p anyway). Then, there is a known timing attack on algorithms
      using the CRT. To mitigate this risk, "cryptographic blinding"
      should be used. This requires simply generating a random number r
      between 0 and n-1 and its inverse and multiplying x by r^e before
      calculating y and then multiplying y by r^-1 afterwards. Note that
      r must be coprime with n (gcd(r, n) === 1) in order to have an
      inverse.
    */
    // cryptographic blinding


    var r;

    do {
      r = new BigInteger(forge.util.bytesToHex(forge.random.getBytes(key.n.bitLength() / 8)), 16);
    } while (r.compareTo(key.n) >= 0 || !r.gcd(key.n).equals(BigInteger.ONE));

    x = x.multiply(r.modPow(key.e, key.n)).mod(key.n); // calculate xp and xq

    var xp = x.mod(key.p).modPow(key.dP, key.p);
    var xq = x.mod(key.q).modPow(key.dQ, key.q); // xp must be larger than xq to avoid signed bit usage

    while (xp.compareTo(xq) < 0) {
      xp = xp.add(key.p);
    } // do last step


    var y = xp.subtract(xq).multiply(key.qInv).mod(key.p).multiply(key.q).add(xq); // remove effect of random for cryptographic blinding

    y = y.multiply(r.modInverse(key.n)).mod(key.n);
    return y;
  };
  /**
   * NOTE: THIS METHOD IS DEPRECATED, use 'sign' on a private key object or
   * 'encrypt' on a public key object instead.
   *
   * Performs RSA encryption.
   *
   * The parameter bt controls whether to put padding bytes before the
   * message passed in. Set bt to either true or false to disable padding
   * completely (in order to handle e.g. EMSA-PSS encoding seperately before),
   * signaling whether the encryption operation is a public key operation
   * (i.e. encrypting data) or not, i.e. private key operation (data signing).
   *
   * For PKCS#1 v1.5 padding pass in the block type to use, i.e. either 0x01
   * (for signing) or 0x02 (for encryption). The key operation mode (private
   * or public) is derived from this flag in that case).
   *
   * @param m the message to encrypt as a byte string.
   * @param key the RSA key to use.
   * @param bt for PKCS#1 v1.5 padding, the block type to use
   *   (0x01 for private key, 0x02 for public),
   *   to disable padding: true = public key, false = private key.
   *
   * @return the encrypted bytes as a string.
   */


  pki.rsa.encrypt = function (m, key, bt) {
    var pub = bt;
    var eb; // get the length of the modulus in bytes

    var k = Math.ceil(key.n.bitLength() / 8);

    if (bt !== false && bt !== true) {
      // legacy, default to PKCS#1 v1.5 padding
      pub = bt === 0x02;
      eb = _encodePkcs1_v1_5(m, key, bt);
    } else {
      eb = forge.util.createBuffer();
      eb.putBytes(m);
    } // load encryption block as big integer 'x'
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings


    var x = new BigInteger(eb.toHex(), 16); // do RSA encryption

    var y = _modPow(x, key, pub); // convert y into the encrypted data byte string, if y is shorter in
    // bytes than k, then prepend zero bytes to fill up ed
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings


    var yhex = y.toString(16);
    var ed = forge.util.createBuffer();
    var zeros = k - Math.ceil(yhex.length / 2);

    while (zeros > 0) {
      ed.putByte(0x00);
      --zeros;
    }

    ed.putBytes(forge.util.hexToBytes(yhex));
    return ed.getBytes();
  };
  /**
   * NOTE: THIS METHOD IS DEPRECATED, use 'decrypt' on a private key object or
   * 'verify' on a public key object instead.
   *
   * Performs RSA decryption.
   *
   * The parameter ml controls whether to apply PKCS#1 v1.5 padding
   * or not.  Set ml = false to disable padding removal completely
   * (in order to handle e.g. EMSA-PSS later on) and simply pass back
   * the RSA encryption block.
   *
   * @param ed the encrypted data to decrypt in as a byte string.
   * @param key the RSA key to use.
   * @param pub true for a public key operation, false for private.
   * @param ml the message length, if known, false to disable padding.
   *
   * @return the decrypted message as a byte string.
   */


  pki.rsa.decrypt = function (ed, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8); // error if the length of the encrypted data ED is not k

    if (ed.length !== k) {
      var error = new Error('Encrypted message length is invalid.');
      error.length = ed.length;
      error.expected = k;
      throw error;
    } // convert encrypted data into a big integer
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings


    var y = new BigInteger(forge.util.createBuffer(ed).toHex(), 16); // y must be less than the modulus or it wasn't the result of
    // a previous mod operation (encryption) using that modulus

    if (y.compareTo(key.n) >= 0) {
      throw new Error('Encrypted message is invalid.');
    } // do RSA decryption


    var x = _modPow(y, key, pub); // create the encryption block, if x is shorter in bytes than k, then
    // prepend zero bytes to fill up eb
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings


    var xhex = x.toString(16);
    var eb = forge.util.createBuffer();
    var zeros = k - Math.ceil(xhex.length / 2);

    while (zeros > 0) {
      eb.putByte(0x00);
      --zeros;
    }

    eb.putBytes(forge.util.hexToBytes(xhex));

    if (ml !== false) {
      // legacy, default to PKCS#1 v1.5 padding
      return _decodePkcs1_v1_5(eb.getBytes(), key, pub);
    } // return message


    return eb.getBytes();
  };
  /**
   * Creates an RSA key-pair generation state object. It is used to allow
   * key-generation to be performed in steps. It also allows for a UI to
   * display progress updates.
   *
   * @param bits the size for the private key in bits, defaults to 2048.
   * @param e the public exponent to use, defaults to 65537 (0x10001).
   * @param [options] the options to use.
   *          prng a custom crypto-secure pseudo-random number generator to use,
   *            that must define "getBytesSync".
   *          algorithm the algorithm to use (default: 'PRIMEINC').
   *
   * @return the state object to use to generate the key-pair.
   */


  pki.rsa.createKeyPairGenerationState = function (bits, e, options) {
    // TODO: migrate step-based prime generation code to forge.prime
    // set default bits
    if (typeof bits === 'string') {
      bits = parseInt(bits, 10);
    }

    bits = bits || 2048; // create prng with api that matches BigInteger secure random

    options = options || {};
    var prng = options.prng || forge.random;
    var rng = {
      // x is an array to fill with bytes
      nextBytes: function nextBytes(x) {
        var b = prng.getBytesSync(x.length);

        for (var i = 0; i < x.length; ++i) {
          x[i] = b.charCodeAt(i);
        }
      }
    };
    var algorithm = options.algorithm || 'PRIMEINC'; // create PRIMEINC algorithm state

    var rval;

    if (algorithm === 'PRIMEINC') {
      rval = {
        algorithm: algorithm,
        state: 0,
        bits: bits,
        rng: rng,
        eInt: e || 65537,
        e: new BigInteger(null),
        p: null,
        q: null,
        qBits: bits >> 1,
        pBits: bits - (bits >> 1),
        pqState: 0,
        num: null,
        keys: null
      };
      rval.e.fromInt(rval.eInt);
    } else {
      throw new Error('Invalid key generation algorithm: ' + algorithm);
    }

    return rval;
  };
  /**
   * Attempts to runs the key-generation algorithm for at most n seconds
   * (approximately) using the given state. When key-generation has completed,
   * the keys will be stored in state.keys.
   *
   * To use this function to update a UI while generating a key or to prevent
   * causing browser lockups/warnings, set "n" to a value other than 0. A
   * simple pattern for generating a key and showing a progress indicator is:
   *
   * var state = pki.rsa.createKeyPairGenerationState(2048);
   * var step = function() {
   *   // step key-generation, run algorithm for 100 ms, repeat
   *   if(!forge.pki.rsa.stepKeyPairGenerationState(state, 100)) {
   *     setTimeout(step, 1);
   *   } else {
   *     // key-generation complete
   *     // TODO: turn off progress indicator here
   *     // TODO: use the generated key-pair in "state.keys"
   *   }
   * };
   * // TODO: turn on progress indicator here
   * setTimeout(step, 0);
   *
   * @param state the state to use.
   * @param n the maximum number of milliseconds to run the algorithm for, 0
   *          to run the algorithm to completion.
   *
   * @return true if the key-generation completed, false if not.
   */


  pki.rsa.stepKeyPairGenerationState = function (state, n) {
    // set default algorithm if not set
    if (!('algorithm' in state)) {
      state.algorithm = 'PRIMEINC';
    } // TODO: migrate step-based prime generation code to forge.prime
    // TODO: abstract as PRIMEINC algorithm
    // do key generation (based on Tom Wu's rsa.js, see jsbn.js license)
    // with some minor optimizations and designed to run in steps
    // local state vars


    var THIRTY = new BigInteger(null);
    THIRTY.fromInt(30);
    var deltaIdx = 0;

    var op_or = function op_or(x, y) {
      return x | y;
    }; // keep stepping until time limit is reached or done


    var t1 = +new Date();
    var t2;
    var total = 0;

    while (state.keys === null && (n <= 0 || total < n)) {
      // generate p or q
      if (state.state === 0) {
        /* Note: All primes are of the form:
           30k+i, for i < 30 and gcd(30, i)=1, where there are 8 values for i
           When we generate a random number, we always align it at 30k + 1. Each
          time the number is determined not to be prime we add to get to the
          next 'i', eg: if the number was at 30k + 1 we add 6. */
        var bits = state.p === null ? state.pBits : state.qBits;
        var bits1 = bits - 1; // get a random number

        if (state.pqState === 0) {
          state.num = new BigInteger(bits, state.rng); // force MSB set

          if (!state.num.testBit(bits1)) {
            state.num.bitwiseTo(BigInteger.ONE.shiftLeft(bits1), op_or, state.num);
          } // align number on 30k+1 boundary


          state.num.dAddOffset(31 - state.num.mod(THIRTY).byteValue(), 0);
          deltaIdx = 0;
          ++state.pqState;
        } else if (state.pqState === 1) {
          // try to make the number a prime
          if (state.num.bitLength() > bits) {
            // overflow, try again
            state.pqState = 0; // do primality test
          } else if (state.num.isProbablePrime(_getMillerRabinTests(state.num.bitLength()))) {
            ++state.pqState;
          } else {
            // get next potential prime
            state.num.dAddOffset(GCD_30_DELTA[deltaIdx++ % 8], 0);
          }
        } else if (state.pqState === 2) {
          // ensure number is coprime with e
          state.pqState = state.num.subtract(BigInteger.ONE).gcd(state.e).compareTo(BigInteger.ONE) === 0 ? 3 : 0;
        } else if (state.pqState === 3) {
          // store p or q
          state.pqState = 0;

          if (state.p === null) {
            state.p = state.num;
          } else {
            state.q = state.num;
          } // advance state if both p and q are ready


          if (state.p !== null && state.q !== null) {
            ++state.state;
          }

          state.num = null;
        }
      } else if (state.state === 1) {
        // ensure p is larger than q (swap them if not)
        if (state.p.compareTo(state.q) < 0) {
          state.num = state.p;
          state.p = state.q;
          state.q = state.num;
        }

        ++state.state;
      } else if (state.state === 2) {
        // compute phi: (p - 1)(q - 1) (Euler's totient function)
        state.p1 = state.p.subtract(BigInteger.ONE);
        state.q1 = state.q.subtract(BigInteger.ONE);
        state.phi = state.p1.multiply(state.q1);
        ++state.state;
      } else if (state.state === 3) {
        // ensure e and phi are coprime
        if (state.phi.gcd(state.e).compareTo(BigInteger.ONE) === 0) {
          // phi and e are coprime, advance
          ++state.state;
        } else {
          // phi and e aren't coprime, so generate a new p and q
          state.p = null;
          state.q = null;
          state.state = 0;
        }
      } else if (state.state === 4) {
        // create n, ensure n is has the right number of bits
        state.n = state.p.multiply(state.q); // ensure n is right number of bits

        if (state.n.bitLength() === state.bits) {
          // success, advance
          ++state.state;
        } else {
          // failed, get new q
          state.q = null;
          state.state = 0;
        }
      } else if (state.state === 5) {
        // set keys
        var d = state.e.modInverse(state.phi);
        state.keys = {
          privateKey: pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
          publicKey: pki.rsa.setPublicKey(state.n, state.e)
        };
      } // update timing


      t2 = +new Date();
      total += t2 - t1;
      t1 = t2;
    }

    return state.keys !== null;
  };
  /**
   * Generates an RSA public-private key pair in a single call.
   *
   * To generate a key-pair in steps (to allow for progress updates and to
   * prevent blocking or warnings in slow browsers) then use the key-pair
   * generation state functions.
   *
   * To generate a key-pair asynchronously (either through web-workers, if
   * available, or by breaking up the work on the main thread), pass a
   * callback function.
   *
   * @param [bits] the size for the private key in bits, defaults to 2048.
   * @param [e] the public exponent to use, defaults to 65537.
   * @param [options] options for key-pair generation, if given then 'bits'
   *          and 'e' must *not* be given:
   *          bits the size for the private key in bits, (default: 2048).
   *          e the public exponent to use, (default: 65537 (0x10001)).
   *          workerScript the worker script URL.
   *          workers the number of web workers (if supported) to use,
   *            (default: 2).
   *          workLoad the size of the work load, ie: number of possible prime
   *            numbers for each web worker to check per work assignment,
   *            (default: 100).
   *          prng a custom crypto-secure pseudo-random number generator to use,
   *            that must define "getBytesSync".
   *          algorithm the algorithm to use (default: 'PRIMEINC').
   * @param [callback(err, keypair)] called once the operation completes.
   *
   * @return an object with privateKey and publicKey properties.
   */


  pki.rsa.generateKeyPair = function (bits, e, options, callback) {
    // (bits), (options), (callback)
    if (arguments.length === 1) {
      if (typeof bits === 'object') {
        options = bits;
        bits = undefined;
      } else if (typeof bits === 'function') {
        callback = bits;
        bits = undefined;
      }
    } else if (arguments.length === 2) {
      // (bits, e), (bits, options), (bits, callback), (options, callback)
      if (typeof bits === 'number') {
        if (typeof e === 'function') {
          callback = e;
          e = undefined;
        } else if (typeof e !== 'number') {
          options = e;
          e = undefined;
        }
      } else {
        options = bits;
        callback = e;
        bits = undefined;
        e = undefined;
      }
    } else if (arguments.length === 3) {
      // (bits, e, options), (bits, e, callback), (bits, options, callback)
      if (typeof e === 'number') {
        if (typeof options === 'function') {
          callback = options;
          options = undefined;
        }
      } else {
        callback = options;
        options = e;
        e = undefined;
      }
    }

    options = options || {};

    if (bits === undefined) {
      bits = options.bits || 2048;
    }

    if (e === undefined) {
      e = options.e || 0x10001;
    } // if native code is permitted and a callback is given, use native
    // key generation code if available and if parameters are acceptable


    if (!forge.options.usePureJavaScript && callback && bits >= 256 && bits <= 16384 && (e === 0x10001 || e === 3)) {
      if (_detectSubtleCrypto('generateKey') && _detectSubtleCrypto('exportKey')) {
        // use standard native generateKey
        return window.crypto.subtle.generateKey({
          name: 'RSASSA-PKCS1-v1_5',
          modulusLength: bits,
          publicExponent: _intToUint8Array(e),
          hash: {
            name: 'SHA-256'
          }
        }, true
        /* key can be exported*/
        , ['sign', 'verify']).then(function (pair) {
          return window.crypto.subtle.exportKey('pkcs8', pair.privateKey); // avoiding catch(function(err) {...}) to support IE <= 8
        }).then(undefined, function (err) {
          callback(err);
        }).then(function (pkcs8) {
          if (pkcs8) {
            var privateKey = pki.privateKeyFromAsn1(asn1.fromDer(forge.util.createBuffer(pkcs8)));
            callback(null, {
              privateKey: privateKey,
              publicKey: pki.setRsaPublicKey(privateKey.n, privateKey.e)
            });
          }
        });
      }

      if (_detectSubtleMsCrypto('generateKey') && _detectSubtleMsCrypto('exportKey')) {
        var genOp = window.msCrypto.subtle.generateKey({
          name: 'RSASSA-PKCS1-v1_5',
          modulusLength: bits,
          publicExponent: _intToUint8Array(e),
          hash: {
            name: 'SHA-256'
          }
        }, true
        /* key can be exported*/
        , ['sign', 'verify']);

        genOp.oncomplete = function (e) {
          var pair = e.target.result;
          var exportOp = window.msCrypto.subtle.exportKey('pkcs8', pair.privateKey);

          exportOp.oncomplete = function (e) {
            var pkcs8 = e.target.result;
            var privateKey = pki.privateKeyFromAsn1(asn1.fromDer(forge.util.createBuffer(pkcs8)));
            callback(null, {
              privateKey: privateKey,
              publicKey: pki.setRsaPublicKey(privateKey.n, privateKey.e)
            });
          };

          exportOp.onerror = function (err) {
            callback(err);
          };
        };

        genOp.onerror = function (err) {
          callback(err);
        };

        return;
      }
    } // use JavaScript implementation


    var state = pki.rsa.createKeyPairGenerationState(bits, e, options);

    if (!callback) {
      pki.rsa.stepKeyPairGenerationState(state, 0);
      return state.keys;
    }

    _generateKeyPair(state, options, callback);
  };
  /**
   * Sets an RSA public key from BigIntegers modulus and exponent.
   *
   * @param n the modulus.
   * @param e the exponent.
   *
   * @return the public key.
   */


  pki.setRsaPublicKey = pki.rsa.setPublicKey = function (n, e) {
    var key = {
      n: n,
      e: e
    };
    /**
     * Encrypts the given data with this public key. Newer applications
     * should use the 'RSA-OAEP' decryption scheme, 'RSAES-PKCS1-V1_5' is for
     * legacy applications.
     *
     * @param data the byte string to encrypt.
     * @param scheme the encryption scheme to use:
     *          'RSAES-PKCS1-V1_5' (default),
     *          'RSA-OAEP',
     *          'RAW', 'NONE', or null to perform raw RSA encryption,
     *          an object with an 'encode' property set to a function
     *          with the signature 'function(data, key)' that returns
     *          a binary-encoded string representing the encoded data.
     * @param schemeOptions any scheme-specific options.
     *
     * @return the encrypted byte string.
     */

    key.encrypt = function (data, scheme, schemeOptions) {
      if (typeof scheme === 'string') {
        scheme = scheme.toUpperCase();
      } else if (scheme === undefined) {
        scheme = 'RSAES-PKCS1-V1_5';
      }

      if (scheme === 'RSAES-PKCS1-V1_5') {
        scheme = {
          encode: function encode(m, key, pub) {
            return _encodePkcs1_v1_5(m, key, 0x02).getBytes();
          }
        };
      } else if (scheme === 'RSA-OAEP' || scheme === 'RSAES-OAEP') {
        scheme = {
          encode: function encode(m, key) {
            return forge.pkcs1.encode_rsa_oaep(key, m, schemeOptions);
          }
        };
      } else if (['RAW', 'NONE', 'NULL', null].indexOf(scheme) !== -1) {
        scheme = {
          encode: function encode(e) {
            return e;
          }
        };
      } else if (typeof scheme === 'string') {
        throw new Error('Unsupported encryption scheme: "' + scheme + '".');
      } // do scheme-based encoding then rsa encryption


      var e = scheme.encode(data, key, true);
      return pki.rsa.encrypt(e, key, true);
    };
    /**
     * Verifies the given signature against the given digest.
     *
     * PKCS#1 supports multiple (currently two) signature schemes:
     * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
     *
     * By default this implementation uses the "old scheme", i.e.
     * RSASSA-PKCS1-V1_5, in which case once RSA-decrypted, the
     * signature is an OCTET STRING that holds a DigestInfo.
     *
     * DigestInfo ::= SEQUENCE {
     *   digestAlgorithm DigestAlgorithmIdentifier,
     *   digest Digest
     * }
     * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
     * Digest ::= OCTET STRING
     *
     * To perform PSS signature verification, provide an instance
     * of Forge PSS object as the scheme parameter.
     *
     * @param digest the message digest hash to compare against the signature,
     *          as a binary-encoded string.
     * @param signature the signature to verify, as a binary-encoded string.
     * @param scheme signature verification scheme to use:
     *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
     *          a Forge PSS object for RSASSA-PSS,
     *          'NONE' or null for none, DigestInfo will not be expected, but
     *            PKCS#1 v1.5 padding will still be used.
     *
     * @return true if the signature was verified, false if not.
     */


    key.verify = function (digest, signature, scheme) {
      if (typeof scheme === 'string') {
        scheme = scheme.toUpperCase();
      } else if (scheme === undefined) {
        scheme = 'RSASSA-PKCS1-V1_5';
      }

      if (scheme === 'RSASSA-PKCS1-V1_5') {
        scheme = {
          verify: function verify(digest, d) {
            // remove padding
            d = _decodePkcs1_v1_5(d, key, true); // d is ASN.1 BER-encoded DigestInfo

            var obj = asn1.fromDer(d); // compare the given digest to the decrypted one

            return digest === obj.value[1].value;
          }
        };
      } else if (scheme === 'NONE' || scheme === 'NULL' || scheme === null) {
        scheme = {
          verify: function verify(digest, d) {
            // remove padding
            d = _decodePkcs1_v1_5(d, key, true);
            return digest === d;
          }
        };
      } // do rsa decryption w/o any decoding, then verify -- which does decoding


      var d = pki.rsa.decrypt(signature, key, true, false);
      return scheme.verify(digest, d, key.n.bitLength());
    };

    return key;
  };
  /**
   * Sets an RSA private key from BigIntegers modulus, exponent, primes,
   * prime exponents, and modular multiplicative inverse.
   *
   * @param n the modulus.
   * @param e the public exponent.
   * @param d the private exponent ((inverse of e) mod n).
   * @param p the first prime.
   * @param q the second prime.
   * @param dP exponent1 (d mod (p-1)).
   * @param dQ exponent2 (d mod (q-1)).
   * @param qInv ((inverse of q) mod p)
   *
   * @return the private key.
   */


  pki.setRsaPrivateKey = pki.rsa.setPrivateKey = function (n, e, d, p, q, dP, dQ, qInv) {
    var key = {
      n: n,
      e: e,
      d: d,
      p: p,
      q: q,
      dP: dP,
      dQ: dQ,
      qInv: qInv
    };
    /**
     * Decrypts the given data with this private key. The decryption scheme
     * must match the one used to encrypt the data.
     *
     * @param data the byte string to decrypt.
     * @param scheme the decryption scheme to use:
     *          'RSAES-PKCS1-V1_5' (default),
     *          'RSA-OAEP',
     *          'RAW', 'NONE', or null to perform raw RSA decryption.
     * @param schemeOptions any scheme-specific options.
     *
     * @return the decrypted byte string.
     */

    key.decrypt = function (data, scheme, schemeOptions) {
      if (typeof scheme === 'string') {
        scheme = scheme.toUpperCase();
      } else if (scheme === undefined) {
        scheme = 'RSAES-PKCS1-V1_5';
      } // do rsa decryption w/o any decoding


      var d = pki.rsa.decrypt(data, key, false, false);

      if (scheme === 'RSAES-PKCS1-V1_5') {
        scheme = {
          decode: _decodePkcs1_v1_5
        };
      } else if (scheme === 'RSA-OAEP' || scheme === 'RSAES-OAEP') {
        scheme = {
          decode: function decode(d, key) {
            return forge.pkcs1.decode_rsa_oaep(key, d, schemeOptions);
          }
        };
      } else if (['RAW', 'NONE', 'NULL', null].indexOf(scheme) !== -1) {
        scheme = {
          decode: function decode(d) {
            return d;
          }
        };
      } else {
        throw new Error('Unsupported encryption scheme: "' + scheme + '".');
      } // decode according to scheme


      return scheme.decode(d, key, false);
    };
    /**
     * Signs the given digest, producing a signature.
     *
     * PKCS#1 supports multiple (currently two) signature schemes:
     * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
     *
     * By default this implementation uses the "old scheme", i.e.
     * RSASSA-PKCS1-V1_5. In order to generate a PSS signature, provide
     * an instance of Forge PSS object as the scheme parameter.
     *
     * @param md the message digest object with the hash to sign.
     * @param scheme the signature scheme to use:
     *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
     *          a Forge PSS object for RSASSA-PSS,
     *          'NONE' or null for none, DigestInfo will not be used but
     *            PKCS#1 v1.5 padding will still be used.
     *
     * @return the signature as a byte string.
     */


    key.sign = function (md, scheme) {
      /* Note: The internal implementation of RSA operations is being
        transitioned away from a PKCS#1 v1.5 hard-coded scheme. Some legacy
        code like the use of an encoding block identifier 'bt' will eventually
        be removed. */
      // private key operation
      var bt = false;

      if (typeof scheme === 'string') {
        scheme = scheme.toUpperCase();
      }

      if (scheme === undefined || scheme === 'RSASSA-PKCS1-V1_5') {
        scheme = {
          encode: emsaPkcs1v15encode
        };
        bt = 0x01;
      } else if (scheme === 'NONE' || scheme === 'NULL' || scheme === null) {
        scheme = {
          encode: function encode() {
            return md;
          }
        };
        bt = 0x01;
      } // encode and then encrypt


      var d = scheme.encode(md, key.n.bitLength());
      return pki.rsa.encrypt(d, key, bt);
    };

    return key;
  };
  /**
   * Wraps an RSAPrivateKey ASN.1 object in an ASN.1 PrivateKeyInfo object.
   *
   * @param rsaKey the ASN.1 RSAPrivateKey.
   *
   * @return the ASN.1 PrivateKeyInfo.
   */


  pki.wrapRsaPrivateKey = function (rsaKey) {
    // PrivateKeyInfo
    return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// version (0)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(0).getBytes()), // privateKeyAlgorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(pki.oids.rsaEncryption).getBytes()), asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '')]), // PrivateKey
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, asn1.toDer(rsaKey).getBytes())]);
  };
  /**
   * Converts a private key from an ASN.1 object.
   *
   * @param obj the ASN.1 representation of a PrivateKeyInfo containing an
   *          RSAPrivateKey or an RSAPrivateKey.
   *
   * @return the private key.
   */


  pki.privateKeyFromAsn1 = function (obj) {
    // get PrivateKeyInfo
    var capture = {};
    var errors = [];

    if (asn1.validate(obj, privateKeyValidator, capture, errors)) {
      obj = asn1.fromDer(forge.util.createBuffer(capture.privateKey));
    } // get RSAPrivateKey


    capture = {};
    errors = [];

    if (!asn1.validate(obj, rsaPrivateKeyValidator, capture, errors)) {
      var error = new Error('Cannot read private key. ' + 'ASN.1 object does not contain an RSAPrivateKey.');
      error.errors = errors;
      throw error;
    } // Note: Version is currently ignored.
    // capture.privateKeyVersion
    // FIXME: inefficient, get a BigInteger that uses byte strings


    var n, e, d, p, q, dP, dQ, qInv;
    n = forge.util.createBuffer(capture.privateKeyModulus).toHex();
    e = forge.util.createBuffer(capture.privateKeyPublicExponent).toHex();
    d = forge.util.createBuffer(capture.privateKeyPrivateExponent).toHex();
    p = forge.util.createBuffer(capture.privateKeyPrime1).toHex();
    q = forge.util.createBuffer(capture.privateKeyPrime2).toHex();
    dP = forge.util.createBuffer(capture.privateKeyExponent1).toHex();
    dQ = forge.util.createBuffer(capture.privateKeyExponent2).toHex();
    qInv = forge.util.createBuffer(capture.privateKeyCoefficient).toHex(); // set private key

    return pki.setRsaPrivateKey(new BigInteger(n, 16), new BigInteger(e, 16), new BigInteger(d, 16), new BigInteger(p, 16), new BigInteger(q, 16), new BigInteger(dP, 16), new BigInteger(dQ, 16), new BigInteger(qInv, 16));
  };
  /**
   * Converts a private key to an ASN.1 RSAPrivateKey.
   *
   * @param key the private key.
   *
   * @return the ASN.1 representation of an RSAPrivateKey.
   */


  pki.privateKeyToAsn1 = pki.privateKeyToRSAPrivateKey = function (key) {
    // RSAPrivateKey
    return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// version (0 = only 2 primes, 1 multiple primes)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(0).getBytes()), // modulus (n)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, _bnToBytes(key.n)), // publicExponent (e)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, _bnToBytes(key.e)), // privateExponent (d)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, _bnToBytes(key.d)), // privateKeyPrime1 (p)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, _bnToBytes(key.p)), // privateKeyPrime2 (q)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, _bnToBytes(key.q)), // privateKeyExponent1 (dP)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, _bnToBytes(key.dP)), // privateKeyExponent2 (dQ)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, _bnToBytes(key.dQ)), // coefficient (qInv)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, _bnToBytes(key.qInv))]);
  };
  /**
   * Converts a public key from an ASN.1 SubjectPublicKeyInfo or RSAPublicKey.
   *
   * @param obj the asn1 representation of a SubjectPublicKeyInfo or RSAPublicKey.
   *
   * @return the public key.
   */


  pki.publicKeyFromAsn1 = function (obj) {
    // get SubjectPublicKeyInfo
    var capture = {};
    var errors = [];

    if (asn1.validate(obj, publicKeyValidator, capture, errors)) {
      // get oid
      var oid = asn1.derToOid(capture.publicKeyOid);

      if (oid !== pki.oids.rsaEncryption) {
        var error = new Error('Cannot read public key. Unknown OID.');
        error.oid = oid;
        throw error;
      }

      obj = capture.rsaPublicKey;
    } // get RSA params


    errors = [];

    if (!asn1.validate(obj, rsaPublicKeyValidator, capture, errors)) {
      var error = new Error('Cannot read public key. ' + 'ASN.1 object does not contain an RSAPublicKey.');
      error.errors = errors;
      throw error;
    } // FIXME: inefficient, get a BigInteger that uses byte strings


    var n = forge.util.createBuffer(capture.publicKeyModulus).toHex();
    var e = forge.util.createBuffer(capture.publicKeyExponent).toHex(); // set public key

    return pki.setRsaPublicKey(new BigInteger(n, 16), new BigInteger(e, 16));
  };
  /**
   * Converts a public key to an ASN.1 SubjectPublicKeyInfo.
   *
   * @param key the public key.
   *
   * @return the asn1 representation of a SubjectPublicKeyInfo.
   */


  pki.publicKeyToAsn1 = pki.publicKeyToSubjectPublicKeyInfo = function (key) {
    // SubjectPublicKeyInfo
    return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// AlgorithmIdentifier
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// algorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(pki.oids.rsaEncryption).getBytes()), // parameters (null)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '')]), // subjectPublicKey
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.BITSTRING, false, [pki.publicKeyToRSAPublicKey(key)])]);
  };
  /**
   * Converts a public key to an ASN.1 RSAPublicKey.
   *
   * @param key the public key.
   *
   * @return the asn1 representation of a RSAPublicKey.
   */


  pki.publicKeyToRSAPublicKey = function (key) {
    // RSAPublicKey
    return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// modulus (n)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, _bnToBytes(key.n)), // publicExponent (e)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, _bnToBytes(key.e))]);
  };
  /**
   * Encodes a message using PKCS#1 v1.5 padding.
   *
   * @param m the message to encode.
   * @param key the RSA key to use.
   * @param bt the block type to use, i.e. either 0x01 (for signing) or 0x02
   *          (for encryption).
   *
   * @return the padded byte buffer.
   */


  function _encodePkcs1_v1_5(m, key, bt) {
    var eb = forge.util.createBuffer(); // get the length of the modulus in bytes

    var k = Math.ceil(key.n.bitLength() / 8);
    /* use PKCS#1 v1.5 padding */

    if (m.length > k - 11) {
      var error = new Error('Message is too long for PKCS#1 v1.5 padding.');
      error.length = m.length;
      error.max = k - 11;
      throw error;
    }
    /* A block type BT, a padding string PS, and the data D shall be
      formatted into an octet string EB, the encryption block:
       EB = 00 || BT || PS || 00 || D
       The block type BT shall be a single octet indicating the structure of
      the encryption block. For this version of the document it shall have
      value 00, 01, or 02. For a private-key operation, the block type
      shall be 00 or 01. For a public-key operation, it shall be 02.
       The padding string PS shall consist of k-3-||D|| octets. For block
      type 00, the octets shall have value 00; for block type 01, they
      shall have value FF; and for block type 02, they shall be
      pseudorandomly generated and nonzero. This makes the length of the
      encryption block EB equal to k. */
    // build the encryption block


    eb.putByte(0x00);
    eb.putByte(bt); // create the padding

    var padNum = k - 3 - m.length;
    var padByte; // private key op

    if (bt === 0x00 || bt === 0x01) {
      padByte = bt === 0x00 ? 0x00 : 0xFF;

      for (var i = 0; i < padNum; ++i) {
        eb.putByte(padByte);
      }
    } else {
      // public key op
      // pad with random non-zero values
      while (padNum > 0) {
        var numZeros = 0;
        var padBytes = forge.random.getBytes(padNum);

        for (var i = 0; i < padNum; ++i) {
          padByte = padBytes.charCodeAt(i);

          if (padByte === 0) {
            ++numZeros;
          } else {
            eb.putByte(padByte);
          }
        }

        padNum = numZeros;
      }
    } // zero followed by message


    eb.putByte(0x00);
    eb.putBytes(m);
    return eb;
  }
  /**
   * Decodes a message using PKCS#1 v1.5 padding.
   *
   * @param em the message to decode.
   * @param key the RSA key to use.
   * @param pub true if the key is a public key, false if it is private.
   * @param ml the message length, if specified.
   *
   * @return the decoded bytes.
   */


  function _decodePkcs1_v1_5(em, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* It is an error if any of the following conditions occurs:
       1. The encryption block EB cannot be parsed unambiguously.
      2. The padding string PS consists of fewer than eight octets
        or is inconsisent with the block type BT.
      3. The decryption process is a public-key operation and the block
        type BT is not 00 or 01, or the decryption process is a
        private-key operation and the block type is not 02.
     */
    // parse the encryption block

    var eb = forge.util.createBuffer(em);
    var first = eb.getByte();
    var bt = eb.getByte();

    if (first !== 0x00 || pub && bt !== 0x00 && bt !== 0x01 || !pub && bt != 0x02 || pub && bt === 0x00 && typeof ml === 'undefined') {
      throw new Error('Encryption block is invalid.');
    }

    var padNum = 0;

    if (bt === 0x00) {
      // check all padding bytes for 0x00
      padNum = k - 3 - ml;

      for (var i = 0; i < padNum; ++i) {
        if (eb.getByte() !== 0x00) {
          throw new Error('Encryption block is invalid.');
        }
      }
    } else if (bt === 0x01) {
      // find the first byte that isn't 0xFF, should be after all padding
      padNum = 0;

      while (eb.length() > 1) {
        if (eb.getByte() !== 0xFF) {
          --eb.read;
          break;
        }

        ++padNum;
      }
    } else if (bt === 0x02) {
      // look for 0x00 byte
      padNum = 0;

      while (eb.length() > 1) {
        if (eb.getByte() === 0x00) {
          --eb.read;
          break;
        }

        ++padNum;
      }
    } // zero must be 0x00 and padNum must be (k - 3 - message length)


    var zero = eb.getByte();

    if (zero !== 0x00 || padNum !== k - 3 - eb.length()) {
      throw new Error('Encryption block is invalid.');
    }

    return eb.getBytes();
  }
  /**
   * Runs the key-generation algorithm asynchronously, either in the background
   * via Web Workers, or using the main thread and setImmediate.
   *
   * @param state the key-pair generation state.
   * @param [options] options for key-pair generation:
   *          workerScript the worker script URL.
   *          workers the number of web workers (if supported) to use,
   *            (default: 2, -1 to use estimated cores minus one).
   *          workLoad the size of the work load, ie: number of possible prime
   *            numbers for each web worker to check per work assignment,
   *            (default: 100).
   * @param callback(err, keypair) called once the operation completes.
   */


  function _generateKeyPair(state, options, callback) {
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    options = options || {};
    var opts = {
      algorithm: {
        name: options.algorithm || 'PRIMEINC',
        options: {
          workers: options.workers || 2,
          workLoad: options.workLoad || 100,
          workerScript: options.workerScript
        }
      }
    };

    if ('prng' in options) {
      opts.prng = options.prng;
    }

    generate();

    function generate() {
      // find p and then q (done in series to simplify)
      getPrime(state.pBits, function (err, num) {
        if (err) {
          return callback(err);
        }

        state.p = num;

        if (state.q !== null) {
          return finish(err, state.q);
        }

        getPrime(state.qBits, finish);
      });
    }

    function getPrime(bits, callback) {
      forge.prime.generateProbablePrime(bits, opts, callback);
    }

    function finish(err, num) {
      if (err) {
        return callback(err);
      } // set q


      state.q = num; // ensure p is larger than q (swap them if not)

      if (state.p.compareTo(state.q) < 0) {
        var tmp = state.p;
        state.p = state.q;
        state.q = tmp;
      } // ensure p is coprime with e


      if (state.p.subtract(BigInteger.ONE).gcd(state.e).compareTo(BigInteger.ONE) !== 0) {
        state.p = null;
        generate();
        return;
      } // ensure q is coprime with e


      if (state.q.subtract(BigInteger.ONE).gcd(state.e).compareTo(BigInteger.ONE) !== 0) {
        state.q = null;
        getPrime(state.qBits, finish);
        return;
      } // compute phi: (p - 1)(q - 1) (Euler's totient function)


      state.p1 = state.p.subtract(BigInteger.ONE);
      state.q1 = state.q.subtract(BigInteger.ONE);
      state.phi = state.p1.multiply(state.q1); // ensure e and phi are coprime

      if (state.phi.gcd(state.e).compareTo(BigInteger.ONE) !== 0) {
        // phi and e aren't coprime, so generate a new p and q
        state.p = state.q = null;
        generate();
        return;
      } // create n, ensure n is has the right number of bits


      state.n = state.p.multiply(state.q);

      if (state.n.bitLength() !== state.bits) {
        // failed, get new q
        state.q = null;
        getPrime(state.qBits, finish);
        return;
      } // set keys


      var d = state.e.modInverse(state.phi);
      state.keys = {
        privateKey: pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
        publicKey: pki.rsa.setPublicKey(state.n, state.e)
      };
      callback(null, state.keys);
    }
  }
  /**
   * Converts a positive BigInteger into 2's-complement big-endian bytes.
   *
   * @param b the big integer to convert.
   *
   * @return the bytes.
   */


  function _bnToBytes(b) {
    // prepend 0x00 if first byte >= 0x80
    var hex = b.toString(16);

    if (hex[0] >= '8') {
      hex = '00' + hex;
    }

    var bytes = forge.util.hexToBytes(hex); // ensure integer is minimally-encoded

    if (bytes.length > 1 && ( // leading 0x00 for positive integer
    bytes.charCodeAt(0) === 0 && (bytes.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
    bytes.charCodeAt(0) === 0xFF && (bytes.charCodeAt(1) & 0x80) === 0x80)) {
      return bytes.substr(1);
    }

    return bytes;
  }
  /**
   * Returns the required number of Miller-Rabin tests to generate a
   * prime with an error probability of (1/2)^80.
   *
   * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
   *
   * @param bits the bit size.
   *
   * @return the required number of iterations.
   */


  function _getMillerRabinTests(bits) {
    if (bits <= 100) return 27;
    if (bits <= 150) return 18;
    if (bits <= 200) return 15;
    if (bits <= 250) return 12;
    if (bits <= 300) return 9;
    if (bits <= 350) return 8;
    if (bits <= 400) return 7;
    if (bits <= 500) return 6;
    if (bits <= 600) return 5;
    if (bits <= 800) return 4;
    if (bits <= 1250) return 3;
    return 2;
  }
  /**
   * Performs feature detection on the SubtleCrypto interface.
   *
   * @param fn the feature (function) to detect.
   *
   * @return true if detected, false if not.
   */


  function _detectSubtleCrypto(fn) {
    return typeof window !== 'undefined' && typeof window.crypto === 'object' && typeof window.crypto.subtle === 'object' && typeof window.crypto.subtle[fn] === 'function';
  }
  /**
   * Performs feature detection on the deprecated Microsoft Internet Explorer
   * outdated SubtleCrypto interface. This function should only be used after
   * checking for the modern, standard SubtleCrypto interface.
   *
   * @param fn the feature (function) to detect.
   *
   * @return true if detected, false if not.
   */


  function _detectSubtleMsCrypto(fn) {
    return typeof window !== 'undefined' && typeof window.msCrypto === 'object' && typeof window.msCrypto.subtle === 'object' && typeof window.msCrypto.subtle[fn] === 'function';
  }

  function _intToUint8Array(x) {
    var bytes = forge.util.hexToBytes(x.toString(16));
    var buffer = new Uint8Array(bytes.length);

    for (var i = 0; i < bytes.length; ++i) {
      buffer[i] = bytes.charCodeAt(i);
    }

    return buffer;
  }

  function _privateKeyFromJwk(jwk) {
    if (jwk.kty !== 'RSA') {
      throw new Error('Unsupported key algorithm "' + jwk.kty + '"; algorithm must be "RSA".');
    }

    return pki.setRsaPrivateKey(_base64ToBigInt(jwk.n), _base64ToBigInt(jwk.e), _base64ToBigInt(jwk.d), _base64ToBigInt(jwk.p), _base64ToBigInt(jwk.q), _base64ToBigInt(jwk.dp), _base64ToBigInt(jwk.dq), _base64ToBigInt(jwk.qi));
  }

  function _publicKeyFromJwk(jwk) {
    if (jwk.kty !== 'RSA') {
      throw new Error('Key algorithm must be "RSA".');
    }

    return pki.setRsaPublicKey(_base64ToBigInt(jwk.n), _base64ToBigInt(jwk.e));
  }

  function _base64ToBigInt(b64) {
    return new BigInteger(forge.util.bytesToHex(forge.util.decode64(b64)), 16);
  }
  /***/

},
/* 102 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/sha.js - Cryptographic Secure Hash Algorithms, versions 1 and 2
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var forge = __webpack_require__(14),
        helpers = __webpack_require__(30);

    function hashDigestFN(hash) {
      var md = hash.replace("SHA-", "SHA").toLowerCase();
      var alg = {
        name: hash
      }; // ### Fallback Implementation -- uses forge

      var fallback = function fallback(pdata
      /* props */
      ) {
        var digest = forge.md[md].create();
        digest.update(pdata);
        digest = digest.digest().native();
        return Promise.resolve(digest);
      }; // ### WebCryptoAPI Implementation


      var webcrypto = function webcrypto(pdata
      /* props */
      ) {
        var promise;
        promise = helpers.subtleCrypto.digest(alg, pdata);
        promise = promise.then(function (result) {
          result = Buffer.from(result);
          return result;
        });
        return promise;
      }; // ### nodejs Implementation


      var nodejs = function nodejs(pdata
      /* props */
      ) {
        var digest = helpers.nodeCrypto.createHash(md);
        digest.update(pdata);
        return digest.digest();
      };

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    } // Public API
    // * [name].digest


    var sha = {};
    ["SHA-1", "SHA-256", "SHA-384", "SHA-512"].forEach(function (name) {
      sha[name] = {
        digest: hashDigestFN(name)
      };
    });
    module.exports = sha;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 103 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * deps/ciphermodes/pack.js - Pack/Unpack Functions
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var Long = __webpack_require__(141);

    var pack = module.exports = {
      intToBigEndian: function intToBigEndian(n, bs, off) {
        if (typeof n === "number") {
          switch (arguments.length) {
            case 1:
              bs = Buffer.alloc(4);
              pack.intToBigEndian(n, bs, 0);
              break;

            case 3:
              bs[off] = 0xff & n >>> 24;
              bs[++off] = 0xff & n >>> 16;
              bs[++off] = 0xff & n >>> 8;
              bs[++off] = 0xff & n;
              break;

            default:
              throw new TypeError("Expected 1 or 3 arguments.");
          }
        } else {
          switch (arguments.length) {
            case 1:
              bs = Buffer.alloc(4 * n.length);
              pack.intToBigEndian(n, bs, 0);
              break;

            case 3:
              for (var i = 0; i < n.length; ++i) {
                pack.intToBigEndian(n[i], bs, off);
                off += 4;
              }

              break;

            default:
              throw new TypeError("Expected 1 or 3 arguments.");
          }
        }

        return bs;
      },
      longToBigEndian: function longToBigEndian(n, bs, off) {
        if (!Array.isArray(n)) {
          // Single
          switch (arguments.length) {
            case 1:
              bs = Buffer.alloc(8);
              pack.longToBigEndian(n, bs, 0);
              break;

            case 3:
              var lo = n.low,
                  hi = n.high;
              pack.intToBigEndian(hi, bs, off);
              pack.intToBigEndian(lo, bs, off + 4);
              break;

            default:
              throw new TypeError("Expected 1 or 3 arguments.");
          }
        } else {
          // Array
          switch (arguments.length) {
            case 1:
              bs = Buffer.alloc(8 * n.length);
              pack.longToBigEndian(n, bs, 0);
              break;

            case 3:
              for (var i = 0; i < n.length; ++i) {
                pack.longToBigEndian(n[i], bs, off);
                off += 8;
              }

              break;

            default:
              throw new TypeError("Expected 1 or 3 arguments.");
          }
        }

        return bs;
      },
      bigEndianToInt: function bigEndianToInt(bs, off, ns) {
        switch (arguments.length) {
          case 2:
            var n = bs[off] << 24;
            n |= (bs[++off] & 0xff) << 16;
            n |= (bs[++off] & 0xff) << 8;
            n |= bs[++off] & 0xff;
            return n;

          case 3:
            for (var i = 0; i < ns.length; ++i) {
              ns[i] = pack.bigEndianToInt(bs, off);
              off += 4;
            }

            break;

          default:
            throw new TypeError("Expected 2 or 3 arguments.");
        }
      },
      bigEndianToLong: function bigEndianToLong(bs, off, ns) {
        switch (arguments.length) {
          case 2:
            var hi = pack.bigEndianToInt(bs, off);
            var lo = pack.bigEndianToInt(bs, off + 4);
            var num = new Long(lo, hi);
            return num;

          case 3:
            for (var i = 0; i < ns.length; ++i) {
              ns[i] = pack.bigEndianToLong(bs, off);
              off += 8;
            }

            break;

          default:
            throw new TypeError("Expected 2 or 3 arguments.");
        }
      }
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 104 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * jwk/basekey.js - JWK Key Base Class Implementation
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var assign = __webpack_require__(202),
        clone = __webpack_require__(42),
        flatten = __webpack_require__(497),
        intersection = __webpack_require__(498),
        merge = __webpack_require__(48),
        omit = __webpack_require__(203),
        pick = __webpack_require__(204),
        uniq = __webpack_require__(205),
        uuid = __webpack_require__(601);

    var ALGORITHMS = __webpack_require__(153),
        CONSTANTS = __webpack_require__(237),
        HELPERS = __webpack_require__(81),
        UTIL = __webpack_require__(19);
    /**
     * @class JWK.Key
     * @classdesc
     * Represents a JSON Web Key instance.
     *
     * @description
     * **NOTE:** This class cannot be instantiated directly. Instead call
     * {@link JWK.asKey}, {@link JWK.KeyStore#add}, or
     * {@link JWK.KeyStore#generate}.
     */


    var JWKBaseKeyObject = function JWKBaseKeyObject(kty, ks, props, cfg) {
      // ### validate/coerce arguments ###
      if (!kty) {
        throw new Error("kty cannot be null");
      }

      if (!ks) {
        throw new Error("keystore cannot be null");
      }

      if (!props) {
        throw new Error("props cannot be null");
      } else if ("string" === typeof props) {
        props = JSON.parse(props);
      }

      if (!cfg) {
        throw new Error("cfg cannot be null");
      }

      var excluded = [];
      var keys = {},
          json = {},
          prints,
          kid;
      props = clone(props); // strip thumbprints if present

      prints = assign({}, props[HELPERS.INTERNALS.THUMBPRINT_KEY] || {});
      delete props[HELPERS.INTERNALS.THUMBPRINT_KEY];
      Object.keys(prints).forEach(function (a) {
        var h = prints[a];

        if (!kid) {
          kid = h;

          if (Buffer.isBuffer(kid)) {
            kid = UTIL.base64url.encode(kid);
          }
        }

        if (!Buffer.isBuffer(h)) {
          h = UTIL.base64url.decode(h);
          prints[a] = h;
        }
      }); // force certain values

      props.kty = kty;
      props.kid = props.kid || kid || uuid(); // setup base info

      var included = Object.keys(HELPERS.COMMON_PROPS).map(function (p) {
        return HELPERS.COMMON_PROPS[p].name;
      });
      json.base = pick(props, included);
      excluded = excluded.concat(Object.keys(json.base)); // setup public information

      json.public = clone(props);
      keys.public = cfg.publicKey(json.public);

      if (keys.public) {
        // exclude public values from extra
        excluded = excluded.concat(Object.keys(json.public));
      } // setup private information


      json.private = clone(props);
      keys.private = cfg.privateKey(json.private);

      if (keys.private) {
        // exclude private values from extra
        excluded = excluded.concat(Object.keys(json.private));
      } // setup extra information


      json.extra = omit(props, excluded); // TODO: validate 'alg' against supported algorithms
      // setup calculated values

      var keyLen;

      if (keys.public && "length" in keys.public) {
        keyLen = keys.public.length;
      } else if (keys.private && "length" in keys.private) {
        keyLen = keys.private.length;
      } else {
        keyLen = NaN;
      } // ### Public Properties ###

      /**
       * @member {JWK.KeyStore} JWK.Key#keystore
       * @description
       * The owning keystore.
       */


      Object.defineProperty(this, "keystore", {
        value: ks,
        enumerable: true
      });
      /**
       * @member {Number} JWK.Key#length
       * @description
       * The size of this Key, in bits.
       */

      Object.defineProperty(this, "length", {
        value: keyLen,
        enumerable: true
      });
      /**
       * @member {String} JWK.Key#kty
       * @description
       * The type of Key.
       */

      Object.defineProperty(this, "kty", {
        value: kty,
        enumerable: true
      });
      /**
       * @member {String} JWK.Key#kid
       * @description
       * The identifier for this Key.
       */

      Object.defineProperty(this, "kid", {
        value: json.base.kid,
        enumerable: true
      });
      /**
       * @member {String} JWK.Key#use
       * @description
       * The usage for this Key.
       */

      Object.defineProperty(this, "use", {
        value: json.base.use || "",
        enumerable: true
      });
      /**
       * @member {String} JWK.Key#alg
       * @description
       * The sole algorithm this key can be used for.
       */

      Object.defineProperty(this, "alg", {
        value: json.base.alg || "",
        enumerable: true
      }); // ### Public Methods ###

      /**
       * Generates the thumbprint of this Key.
       *
       * @param {String} [] The hash algorithm to use
       * @returns {Promise} The promise for the thumbprint generation.
       */

      Object.defineProperty(this, "thumbprint", {
        value: function value(hash) {
          hash = (hash || HELPERS.INTERNALS.THUMBPRINT_HASH).toUpperCase();

          if (prints[hash]) {
            // return cached value
            return Promise.resolve(prints[hash]);
          }

          var p = HELPERS.thumbprint(cfg, json, hash);
          p = p.then(function (result) {
            if (result) {
              prints[hash] = result;
            }

            return result;
          });
          return p;
        }
      });
      /**
       * @method JWK.Key#algorithms
       * @description
       * The possible algorithms this Key can be used for. The returned
       * list is not any particular order, but is filtered based on the
       * Key's intended usage.
       *
       * @param {String} mode The operation mode
       * @returns {String[]} The list of supported algorithms
       * @see JWK.Key#supports
       */

      Object.defineProperty(this, "algorithms", {
        value: function value(mode) {
          var modes = [];

          if (!this.use || this.use === "sig") {
            if (!mode || CONSTANTS.MODE_SIGN === mode) {
              modes.push(CONSTANTS.MODE_SIGN);
            }

            if (!mode || CONSTANTS.MODE_VERIFY === mode) {
              modes.push(CONSTANTS.MODE_VERIFY);
            }
          }

          if (!this.use || this.use === "enc") {
            if (!mode || CONSTANTS.MODE_ENCRYPT === mode) {
              modes.push(CONSTANTS.MODE_ENCRYPT);
            }

            if (!mode || CONSTANTS.MODE_DECRYPT === mode) {
              modes.push(CONSTANTS.MODE_DECRYPT);
            }

            if (!mode || CONSTANTS.MODE_WRAP === mode) {
              modes.push(CONSTANTS.MODE_WRAP);
            }

            if (!mode || CONSTANTS.MODE_UNWRAP === mode) {
              modes.push(CONSTANTS.MODE_UNWRAP);
            }
          }

          var self = this;
          var algs = modes.map(function (m) {
            return cfg.algorithms.call(self, keys, m);
          });
          algs = flatten(algs);
          algs = uniq(algs);

          if (this.alg) {
            // TODO: fix this correctly
            var valid;

            if ("oct" === kty) {
              valid = [this.alg, "dir"];
            } else {
              valid = [this.alg];
            }

            algs = intersection(algs, valid);
          }

          return algs;
        }
      });
      /**
       * @method JWK.Key#supports
       * @description
       * Determines if the given algorithm is supported.
       *
       * @param {String} alg The algorithm in question
       * @param {String} [mode] The operation mode
       * @returns {Boolean} `true` if {alg} is supported, and `false` otherwise.
       * @see JWK.Key#algorithms
       */

      Object.defineProperty(this, "supports", {
        value: function value(alg, mode) {
          return this.algorithms(mode).indexOf(alg) !== -1;
        }
      });
      /**
       * @method JWK.Key#has
       * @description
       * Determines if this Key contains the given parameter.
       *
       * @param {String} name The name of the parameter
       * @param {Boolean} [isPrivate=false] `true` if private parameters should be
       *        checked.
       * @returns {Boolean} `true` if the given parameter is present; `false`
       *          otherwise.
       */

      Object.defineProperty(this, "has", {
        value: function value(name, isPrivate) {
          var contains = false;
          contains = contains || !!(json.base && name in json.base);
          contains = contains || !!(keys.public && name in keys.public);
          contains = contains || !!(json.extra && name in json.extra);
          contains = contains || !!(isPrivate && keys.private && name in keys.private); // TODO: check for export restrictions

          return contains;
        }
      });
      /**
       * @method JWK.Key#get
       * @description
       * Retrieves the value of the given parameter. The value returned by this
       * method is in its natural format, which might not exactly match its
       * JSON encoding (e.g., a binary string rather than a base64url-encoded
       * string).
       *
       * **NOTE:** This method can return `false`. Call
       * {@link JWK.Key#has} to determine if the parameter is present.
       *
       * @param {String} name The name of the parameter
       * @param {Boolean} [isPrivate=false] `true` if private parameters should
       *        be checked.
       * @returns {any} The value of the named parameter, or undefined if
       *          it is not present.
       */

      Object.defineProperty(this, "get", {
        value: function value(name, isPrivate) {
          var src;

          if (json.base && name in json.base) {
            src = json.base;
          } else if (keys.public && name in keys.public) {
            src = keys.public;
          } else if (json.extra && name in json.extra) {
            src = json.extra;
          } else if (isPrivate && keys.private && name in keys.private) {
            // TODO: check for export restrictions
            src = keys.private;
          }

          return src && src[name] || null;
        }
      });
      /**
       * @method JWK.Key#toJSON
       * @description
       * Returns the JSON representation of this Key.  All properties of the
       * returned JSON object are properly encoded (e.g., base64url encoding for
       * any binary strings).
       *
       * @param {Boolean} [isPrivate=false] `true` if private parameters should be
       *        included.
       * @param {String[]} [excluded] The list of parameters to exclude from
       *        the returned JSON.
       * @returns {Object} The plain JSON object
       */

      Object.defineProperty(this, "toJSON", {
        value: function value(isPrivate, excluded) {
          // coerce arguments
          if (Array.isArray(isPrivate)) {
            excluded = isPrivate;
            isPrivate = false;
          }

          var result = {}; // TODO: check for export restrictions

          result = merge(result, json.base, json.public, "boolean" === typeof isPrivate && isPrivate ? json.private : {}, json.extra);
          result = omit(result, excluded || []);
          return result;
        }
      });
      /**
       * @method JWK.Key#toPEM
       * @description
       * Returns the PEM representation of this Key as a string.
       *
       * @param {Boolean} [isPrivate=false] `true` if private parameters should be
       *        included.
       * @returns {string} The PEM-encoded string
       */

      Object.defineProperty(this, "toPEM", {
        value: function value(isPrivate) {
          if (isPrivate === null) {
            isPrivate = false;
          }

          if (!cfg.convertToPEM) {
            throw new Error("Unsupported key type for PEM encoding");
          }

          var k = isPrivate ? keys.private : keys.public;

          if (!k) {
            throw new Error("Invalid key");
          }

          return cfg.convertToPEM.call(this, k, isPrivate);
        }
      });
      /**
       * @method JWK.Key#toObject
       * @description
       * Returns the plain object representing this Key.  All properties of the
       * returned object are in their natural encoding (e.g., binary strings
       * instead of base64url encoded).
       *
       * @param {Boolean} [isPrivate=false] `true` if private parameters should be
       *        included.
       * @param {String[]} [excluded] The list of parameters to exclude from
       *        the returned object.
       * @returns {Object} The plain Object.
       */

      Object.defineProperty(this, "toObject", {
        value: function value(isPrivate, excluded) {
          // coerce arguments
          if (Array.isArray(isPrivate)) {
            excluded = isPrivate;
            isPrivate = false;
          }

          var result = {}; // TODO: check for export restrictions

          result = merge(result, json.base, keys.public, "boolean" === typeof isPrivate && isPrivate ? keys.private : {}, json.extra);
          result = omit(result, (excluded || []).concat("length"));
          return result;
        }
      });
      /**
       * @method JWK.Key#sign
       * @description
       * Sign the given data using the specified algorithm.
       *
       * **NOTE:** This is the primitive signing operation; the output is
       * _**NOT**_ a JSON Web Signature (JWS) object.
       *
       * The Promise, when fulfilled, returns an Object with the following
       * properties:
       *
       * + **data**: The data that was signed (and should be equal to {data}).
       * + **mac**: The signature or message authentication code (MAC).
       *
       * @param {String} alg The signing algorithm
       * @param {String|Buffer} data The data to sign
       * @param {Object} [props] Additional properties for the signing
       *        algorithm.
       * @returns {Promise} The promise for the signing operation.
       * @throws {Error} If {alg} is not appropriate for this Key; or if
       *         this Key does not contain the appropriate parameters.
       */

      Object.defineProperty(this, "sign", {
        value: function value(alg, data, props) {
          // validate appropriateness
          if (this.algorithms("sign").indexOf(alg) === -1) {
            return Promise.reject(new Error("unsupported algorithm"));
          }

          var k = cfg.signKey.call(this, alg, keys);

          if (!k) {
            return Promise.reject(new Error("improper key"));
          } // prepare properties (if any)


          props = props ? clone(props) : {};

          if (cfg.signProps) {
            props = merge(props, cfg.signProps.call(this, alg, props));
          }

          return ALGORITHMS.sign(alg, k, data, props);
        }
      });
      /**
       * @method JWK.Key#verify
       * @description
       * Verify the given data and signature using the specified algorithm.
       *
       * **NOTE:** This is the primitive verification operation; the input is
       * _**NOT**_ a JSON Web Signature.</p>
       *
       * The Promise, when fulfilled, returns an Object with the following
       * properties:
       *
       * + **data**: The data that was verified (and should be equal to
       *   {data}).
       * + **mac**: The signature or MAC that was verified (and should be equal
       *   to {mac}).
       * + **valid**: `true` if {mac} is valid for {data}.
       *
       * @param {String} alg The verification algorithm
       * @param {String|Buffer} data The data to verify
       * @param {String|Buffer} mac The signature or MAC to verify
       * @param {Object} [props] Additional properties for the verification
       *        algorithm.
       * @returns {Promise} The promise for the verification operation.
       * @throws {Error} If {alg} is not appropriate for this Key; or if
       *         the Key does not contain the appropriate properties.
       */

      Object.defineProperty(this, "verify", {
        value: function value(alg, data, mac, props) {
          // validate appropriateness
          if (this.algorithms("verify").indexOf(alg) === -1) {
            return Promise.reject(new Error("unsupported algorithm"));
          }

          var k = cfg.verifyKey.call(this, alg, keys);

          if (!k) {
            return Promise.reject(new Error("improper key"));
          } // prepare properties (if any)


          props = props ? clone(props) : {};

          if (cfg.verifyProps) {
            props = merge(props, cfg.verifyProps.call(this, alg, props));
          }

          return ALGORITHMS.verify(alg, k, data, mac, props);
        }
      });
      /**
       * @method JWK.Key#encrypt
       * @description
       * Encrypts the given data using the specified algorithm.
       *
       * **NOTE:** This is the primitive encryption operation; the output is
       * _**NOT**_ a JSON Web Encryption (JWE) object.
       *
       * **NOTE:** This operation is treated as distinct from {@link
       * JWK.Key#wrap}, as different algorithms and properties are often
       * used for wrapping a key versues encrypting arbitrary data.
       *
       * The Promise, when fulfilled, returns an object with the following
       * properties:
       *
       * + **data**: The ciphertext data
       * + **mac**: The associated message authentication code (MAC).
       *
       * @param {String} alg The encryption algorithm
       * @param {Buffer|String} data The data to encrypt
       * @param {Object} [props] Additional properties for the encryption
       *        algorithm.
       * @returns {Promise} The promise for the encryption operation.
       * @throws {Error} If {alg} is not appropriate for this Key; or if
       *         this Key does not contain the appropriate parameters.
       */

      Object.defineProperty(this, "encrypt", {
        value: function value(alg, data, props) {
          // validate appropriateness
          if (this.algorithms("encrypt").indexOf(alg) === -1) {
            return Promise.reject(new Error("unsupported algorithm"));
          }

          var k = cfg.encryptKey.call(this, alg, keys);

          if (!k) {
            return Promise.reject(new Error("improper key"));
          } // prepare properties (if any)


          props = props ? clone(props) : {};

          if (cfg.encryptProps) {
            props = merge(props, cfg.encryptProps.call(this, alg, props));
          }

          return ALGORITHMS.encrypt(alg, k, data, props);
        }
      });
      /**
       * @method JWK.Key#decrypt
       * @description
       * Decrypts the given data using the specified algorithm.
       *
       * **NOTE:** This is the primitive decryption operation; the input is
       * _**NOT**_ a JSON Web Encryption (JWE) object.
       *
       * **NOTE:** This operation is treated as distinct from {@link
       * JWK.Key#unwrap}, as different algorithms and properties are often used
       * for unwrapping a key versues decrypting arbitrary data.
       *
       * The Promise, when fulfilled, returns the plaintext data.
       *
       * @param {String} alg The decryption algorithm.
       * @param {Buffer|String} data The data to decypt.
       * @param {Object} [props] Additional data for the decryption operation.
       * @returns {Promise} The promise for the decryption operation.
       * @throws {Error} If {alg} is not appropriate for this Key; or if
       *         the Key does not contain the appropriate properties.
       */

      Object.defineProperty(this, "decrypt", {
        value: function value(alg, data, props) {
          // validate appropriateness
          if (this.algorithms("decrypt").indexOf(alg) === -1) {
            return Promise.reject(new Error("unsupported algorithm"));
          }

          var k = cfg.decryptKey.call(this, alg, keys);

          if (!k) {
            return Promise.reject(new Error("improper key"));
          } // prepare properties (if any)


          props = props ? clone(props) : {};

          if (cfg.decryptProps) {
            props = merge(props, cfg.decryptProps.call(this, alg, props));
          }

          return ALGORITHMS.decrypt(alg, k, data, props);
        }
      });
      /**
       * @method JWK.Key#wrap
       * @description
       * Wraps the given key using the specified algorithm.
       *
       * **NOTE:** This is the primitive encryption operation; the output is
       * _**NOT**_ a JSON Web Encryption (JWE) object.
       *
       * **NOTE:** This operation is treated as distinct from {@link
       * JWK.Key#encrypt}, as different algorithms and properties are
       * often used for wrapping a key versues encrypting arbitrary data.
       *
       * The Promise, when fulfilled, returns an object with the following
       * properties:
       *
       * + **data**: The ciphertext data
       * + **headers**: The additional header parameters to apply to a JWE.
       *
       * @param {String} alg The encryption algorithm
       * @param {Buffer|String} data The data to encrypt
       * @param {Object} [props] Additional properties for the encryption
       *        algorithm.
       * @returns {Promise} The promise for the encryption operation.
       * @throws {Error} If {alg} is not appropriate for this Key; or if
       *         this Key does not contain the appropriate parameters.
       */

      Object.defineProperty(this, "wrap", {
        value: function value(alg, data, props) {
          // validate appropriateness
          if (this.algorithms("wrap").indexOf(alg) === -1) {
            return Promise.reject(new Error("unsupported algorithm"));
          }

          var k = cfg.wrapKey.call(this, alg, keys);

          if (!k) {
            return Promise.reject(new Error("improper key"));
          } // prepare properties (if any)


          props = props ? clone(props) : {};

          if (cfg.wrapProps) {
            props = merge(props, cfg.wrapProps.call(this, alg, props));
          }

          return ALGORITHMS.encrypt(alg, k, data, props);
        }
      });
      /**
       * @method JWK.Key#unwrap
       * @description
       * Unwraps the given key using the specified algorithm.
       *
       * **NOTE:** This is the primitive unwrap operation; the input is
       * _**NOT**_ a JSON Web Encryption (JWE) object.
       *
       * **NOTE:** This operation is treated as distinct from {@link
       * JWK.Key#decrypt}, as different algorithms and properties are often used
       * for unwrapping a key versues decrypting arbitrary data.
       *
       * The Promise, when fulfilled, returns the unwrapped key.
       *
       * @param {String} alg The unwrap algorithm.
       * @param {Buffer|String} data The data to unwrap.
       * @param {Object} [props] Additional data for the unwrap operation.
       * @returns {Promise} The promise for the unwrap operation.
       * @throws {Error} If {alg} is not appropriate for this Key; or if
       *         the Key does not contain the appropriate properties.
       */

      Object.defineProperty(this, "unwrap", {
        value: function value(alg, data, props) {
          // validate appropriateness
          if (this.algorithms("unwrap").indexOf(alg) === -1) {
            return Promise.reject(new Error("unsupported algorithm"));
          }

          var k = cfg.unwrapKey.call(this, alg, keys);

          if (!k) {
            return Promise.reject(new Error("improper key"));
          } // prepare properties (if any)


          props = props ? clone(props) : {};

          if (cfg.unwrapProps) {
            props = merge(props, cfg.unwrapProps.call(this, alg, props));
          }

          return ALGORITHMS.decrypt(alg, k, data, props);
        }
      });
    };

    module.exports = JWKBaseKeyObject;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 105 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * jwk/keystore.js - JWK KeyStore Implementation
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var clone = __webpack_require__(42),
        merge = __webpack_require__(48),
        forge = __webpack_require__(14),
        util = __webpack_require__(19);

    var JWK = {
      BaseKey: __webpack_require__(104),
      helpers: __webpack_require__(81)
    };
    /**
     * @class JWK.KeyStoreRegistry
     * @classdesc
     * A registry of JWK.Key types that can be used.
     *
     * @description
     * **NOTE:** This constructor cannot be called directly. Instead use the
     * global {JWK.registry}
     */

    var JWKRegistry = function JWKRegistry() {
      var types = {};
      Object.defineProperty(this, "register", {
        value: function value(factory) {
          if (!factory || "string" !== typeof factory.kty || !factory.kty) {
            throw new Error("invalid Key factory");
          }

          var kty = factory.kty;
          types[kty] = factory;
          return this;
        }
      });
      Object.defineProperty(this, "unregister", {
        value: function value(factory) {
          if (!factory || "string" !== typeof factory.kty || !factory.kty) {
            throw new Error("invalid Key factory");
          }

          var kty = factory.kty;

          if (factory === types[kty]) {
            delete types[kty];
          }

          return this;
        }
      });
      Object.defineProperty(this, "get", {
        value: function value(kty) {
          return types[kty || ""] || undefined;
        }
      });
      Object.defineProperty(this, "all", {
        value: function value() {
          return Object.keys(types).map(function (t) {
            return types[t];
          });
        }
      });
    }; // Globals


    var GLOBAL_REGISTRY = new JWKRegistry(); // importer

    function processCert(input) {
      // convert certIssuer to readable attributes
      ["certIssuer", "certSubject"].forEach(function (field) {
        /* eslint new-cap: [0] */
        var attrs = forge.pki.RDNAttributesAsArray(input[field]);
        var result = input[field] = {};
        attrs.forEach(function (a) {
          result[a.name || a.type] = a.value;
        });
      });
      return input;
    }

    function fromPEM(input) {
      var result = {};
      var pems = forge.pem.decode(input);
      var found = pems.some(function (p) {
        switch (p.type) {
          case "CERTIFICATE":
            result.form = "pkix";
            break;

          case "PUBLIC KEY":
            result.form = "spki";
            break;

          case "PRIVATE KEY":
            result.form = "pkcs8";
            break;

          case "EC PRIVATE KEY":
          /* eslint no-fallthrough: [0] */

          case "RSA PRIVATE KEY":
            result.form = "private";
            break;

          default:
            return false;
        }

        result.body = p.body;
        return true;
      });

      if (!found) {
        throw new Error("supported PEM type not found");
      }

      return result;
    }

    function importFrom(registry, input) {
      // form can be one of:
      //  'private' | 'pkcs8' | 'public' | 'spki' | 'pkix' | 'x509'
      var capture = {},
          errors = [],
          result; // conver from DER to ASN1

      var form = input.form,
          der = input.body,
          thumbprint = null;
      input = forge.asn1.fromDer(der);

      switch (form) {
        case "private":
          registry.all().some(function (factory) {
            if (result) {
              return false;
            }

            if (!factory.validators) {
              return false;
            }

            var oid = factory.validators.oid,
                validator = factory.validators.privateKey;

            if (!validator) {
              return false;
            }

            capture = {};
            errors = [];
            result = forge.asn1.validate(input, validator, capture, errors);

            if (result) {
              capture.keyOid = forge.asn1.oidToDer(oid);
              capture.parsed = true;
            }

            return result;
          });
          capture.type = "private";
          break;

        case "pkcs8":
          result = forge.asn1.validate(input, JWK.helpers.validators.privateKey, capture, errors);
          capture.type = "private";
          break;

        case "public": // eslint no-fallthrough: [0] */

        case "spki":
          result = forge.asn1.validate(input, JWK.helpers.validators.publicKey, capture, errors);
          capture.type = "public";
          break;

        case "pkix":
        /* eslint no-fallthrough: [0] */

        case "x509":
          result = forge.asn1.validate(input, JWK.helpers.validators.certificate, capture, errors);

          if (result) {
            capture = processCert(capture);
            var md = forge.md.sha1.create();
            md.update(der);
            thumbprint = util.base64url.encode(Buffer.from(md.digest().toHex(), "hex"));
          }

          capture.type = "public";
          break;
      }

      if (!result) {
        return null;
      } // convert oids


      if (capture.keyOid) {
        capture.keyOid = forge.asn1.derToOid(capture.keyOid);
      } // find and invoke the importer


      result = null;
      GLOBAL_REGISTRY.all().forEach(function (factory) {
        if (result) {
          return;
        }

        if (!factory) {
          return;
        }

        if ("function" !== typeof factory.import) {
          return;
        }

        result = factory.import(capture);
      });

      if (result && capture.certSubject && capture.certSubject.commonName) {
        result.kid = capture.certSubject.commonName;
      }

      if (result && thumbprint) {
        result.x5t = thumbprint;
      }

      return result;
    }
    /**
     * @class JWK.KeyStore
     * @classdesc
     * Represents a collection of Keys.
     *
     * @description
     * **NOTE:** This constructor cannot be called directly. Instead call {@link
     * JWK.createKeyStore}.
     */


    var JWKStore = function JWKStore(registry, parent) {
      var keysets = {};
      /**
       * @method JWK.KeyStore#generate
       * @description
       * Generates a new random Key into this KeyStore.
       *
       * The type of {size} depends on the value of {kty}:
       *
       * + **`EC`**: String naming the curve to use, which can be one of:
       *   `"P-256"`, `"P-384"`, or `"P-521"` (default is **`"P-256"`**).
       * + **`RSA`**: Number describing the size of the key, in bits (default is
       *   **`2048`**).
       * + **`oct`**: Number describing the size of the key, in bits (default is
       *   **`256`**).
       *
       * Any properties in {props} are applied before the key is generated,
       * and are expected to be data types acceptable in JSON.  This allows the
       * generated key to have a specific key identifier, or to specify its
       * acceptable usage.
       *
       * The returned Promise, when fulfilled, returns the generated Key.
       *
       * @param {String} kty The type of generated key
       * @param {String|Number} [size] The size of the generated key
       * @param {Object} [props] Additional properties to apply to the generated
       *        key.
       * @returns {Promise} The promise for the generated Key
       * @throws {Error} If {kty} is not supported
       */

      Object.defineProperty(this, "generate", {
        value: function value(kty, size, props) {
          var keytype = registry.get(kty);

          if (!keytype) {
            return Promise.reject(new Error("unsupported key type"));
          }

          props = clone(props || {});
          props.kty = kty;
          var self = this,
              promise = keytype.generate(size);
          return promise.then(function (jwk) {
            jwk = merge(props, jwk, {
              kty: kty
            });
            return self.add(jwk);
          });
        }
      });
      /**
       * @method JWK.KeyStore#add
       * @description
       * Adds a Key to this KeyStore. If {jwk} is a string, it is first
       * parsed into a plain JSON object. If {jwk} is already an instance
       * of JWK.Key, its (public) JSON representation is first obtained
       * then applied to a new JWK.Key object within this KeyStore.
       *
       * @param {String|Object} jwk The JSON Web Key (JWK)
       * @param {String} [form] The format of a String key to expect
       * @param {Object} [extras] extra jwk fields inserted when importing from a non json string (eg "pem")
       * @returns {Promise} The promise for the added key
       */

      Object.defineProperty(this, "add", {
        value: function value(jwk, form, extras) {
          extras = extras || {};
          var factors;

          if (Buffer.isBuffer(jwk) || typeof jwk === "string") {
            // form can be 'json', 'pkcs8', 'spki', 'pkix', 'x509', 'pem'
            form = (form || "json").toLowerCase();

            if ("json" === form) {
              jwk = JSON.parse(jwk.toString("utf8"));
            } else {
              try {
                if ("pem" === form) {
                  // convert *first* PEM -> DER
                  factors = fromPEM(jwk);
                } else {
                  factors = {
                    body: jwk.toString("binary"),
                    form: form
                  };
                }

                jwk = importFrom(registry, factors);

                if (!jwk) {
                  throw new Error("no importer for key");
                }

                Object.keys(extras).forEach(function (field) {
                  jwk[field] = extras[field];
                });
              } catch (err) {
                return Promise.reject(err);
              }
            }
          } else if (JWKStore.isKey(jwk)) {
            // assume a complete duplicate is desired
            jwk = jwk.toJSON(true);
          } else {
            jwk = clone(jwk);
          }

          var keytype = registry.get(jwk.kty);

          if (!keytype) {
            return Promise.reject(new Error("unsupported key type"));
          }

          var self = this,
              promise = keytype.prepare(jwk);
          return promise.then(function (cfg) {
            return new JWK.BaseKey(jwk.kty, self, jwk, cfg);
          }).then(function (jwk) {
            var kid = jwk.kid || "";
            var keys = keysets[kid] = keysets[kid] || [];
            keys.push(jwk);
            return jwk;
          });
        }
      });
      /**
       * @method JWK.KeyStore#remove
       * @description
       * Removes a Key from this KeyStore.
       *
       * **NOTE:** The removed Key's {keystore} property is not changed.
       *
       * @param {JWK.Key} jwk The key to remove.
       */

      Object.defineProperty(this, "remove", {
        value: function value(jwk) {
          if (!jwk) {
            return;
          }

          var keys = keysets[jwk.kid];

          if (!keys) {
            return;
          }

          var pos = keys.indexOf(jwk);

          if (pos === -1) {
            return;
          }

          keys.splice(pos, 1);

          if (!keys.length) {
            delete keysets[jwk.kid];
          }
        }
      });
      /**
       * @method JWK.KeyStore#all
       * @description
       * Retrieves all of the contained Keys that optinally match all of the
       * given properties.
       *
       * If {props} are specified, this method only returns Keys which exactly
       * match the given properties. The properties can be any of the
       * following:
       *
       * + **alg**: The algorithm for the Key.
       * + **use**: The usage for the Key.
       * + **kid**: The identifier for the Key.
       *
       * If no properties are given, this method returns all of the Keys for this
       * KeyStore.
       *
       * @param {Object} [props] The properties to match against
       * @param {Boolean} [local = false] `true` if only the Keys
       *        directly contained by this KeyStore should be returned, or
       *        `false` if it should return all Keys of this KeyStore and
       *        its ancestors.
       * @returns {JWK.Key[]} The list of matching Keys, or an empty array if no
       *          matches are found.
       */

      Object.defineProperty(this, "all", {
        value: function value(props, local) {
          props = props || {}; // workaround for issues/109

          if (props.kid !== undefined && props.kid !== null && typeof props.kid !== "string") {
            props.kid = String(props.kid);
          }

          var candidates = [];

          var matches = function matches(key) {
            // match on 'kty'
            if (props.kty && key.kty && props.kty !== key.kty) {
              return false;
            } // match on 'use'


            if (props.use && key.use && props.use !== key.use) {
              return false;
            } // match on 'alg'


            if (props.alg) {
              if (props.alg !== "dir" && key.alg && props.alg !== key.alg) {
                return false;
              }

              return key.supports(props.alg);
            } //TODO: match on 'key_ops'


            return true;
          };

          Object.keys(keysets).forEach(function (id) {
            if (props.kid && props.kid !== id) {
              return;
            }

            var keys = keysets[id].filter(matches);

            if (keys.length) {
              candidates = candidates.concat(keys);
            }
          });

          if (!local && parent) {
            candidates = candidates.concat(parent.all(props));
          }

          return candidates;
        }
      });
      /**
       * @method JWK.KeyStore#get
       * @description
       * Retrieves the contained Key matching the given {kid}, and optionally
       * all of the given properties.  This method equivalent to calling
       * {@link JWK.Store#all}, then returning the first Key whose
       * "kid" is {kid}. If {kid} is undefined, then the first Key that
       * is returned from `all()` is returned.
       *
       * @param {String} [kid] The key identifier to match against.
       * @param {Object} [props] The properties to match against.
       * @param {Boolean} [local = false] `true` if only the Keys
       *        directly contained by this KeyStore should be returned, or
       *        `false` if it should return all Keys of this KeyStore and
       *        its ancestors.
       * @returns {JWK.Key} The Key matching {kid} and {props}, or `null`
       *          if no match is found.
       */

      Object.defineProperty(this, "get", {
        value: function value(kid, props, local) {
          // reconcile arguments
          if (typeof kid === "boolean") {
            local = kid;
            props = kid = null;
          } else if (typeof kid === "object") {
            local = props;
            props = kid;
            kid = null;
          } // fixup props


          props = props || {};

          if (kid) {
            props.kid = kid;
          } // workaround for issues/109


          if (props.kid !== undefined && props.kid !== null && typeof props.kid !== "string") {
            props.kid = String(props.kid);
          }

          var candidates = this.all(props, true);

          if (!candidates.length && parent && !local) {
            candidates = parent.get(props, local);
          }

          return candidates[0] || null;
        }
      });
      /**
       * @method JWK.KeyStore#temp
       * @description
       * Creates a temporary KeyStore based on this KeyStore.
       *
       * @returns {JWK.KeyStore} The temporary KeyStore.
       */

      Object.defineProperty(this, "temp", {
        value: function value() {
          return new JWKStore(registry, this);
        }
      });
      /**
       * @method JWK.KeyStore#toJSON
       * @description
       * Generates a JSON representation of this KeyStore, which conforms
       * to a JWK Set from {I-D.ietf-jose-json-web-key}.
       *
       * @param {Boolean} [isPrivate = false] `true` if the private fields
       *        of stored keys are to be included.
       * @returns {Object} The JSON representation of this KeyStore.
       */

      Object.defineProperty(this, "toJSON", {
        value: function value(isPrivate) {
          var keys = [];
          Object.keys(keysets).forEach(function (kid) {
            var items = keysets[kid].map(function (k) {
              return k.toJSON(isPrivate);
            });
            keys = keys.concat(items);
          });
          return {
            keys: keys
          };
        }
      });
    };
    /**
     * Determines if the given object is an instance of JWK.KeyStore.
     *
     * @param {Object} obj The object to test
     * @returns {Boolean} `true` if {obj} is an instance of JWK.KeyStore,
     *          and `false` otherwise.
     */


    JWKStore.isKeyStore = function (obj) {
      if (!obj) {
        return false;
      }

      if ("object" !== typeof obj) {
        return false;
      }

      if ("function" !== typeof obj.get || "function" !== typeof obj.all || "function" !== typeof obj.generate || "function" !== typeof obj.add || "function" !== typeof obj.remove) {
        return false;
      }

      return true;
    };
    /**
     * Creates a new empty KeyStore.
     *
     * @returns {JWK.KeyStore} The empty KeyStore.
     */


    JWKStore.createKeyStore = function () {
      return new JWKStore(GLOBAL_REGISTRY);
    };
    /**
     * Coerces the given object into a KeyStore. This method uses the following
     * algorithm to coerce {ks}:
     *
     * 1. if {ks} is an instance of JWK.KeyStore, it is returned directly
     * 2. if {ks} is a string, it is parsed into a JSON value
     * 3. if {ks} is an array, it creates a new JWK.KeyStore and calls {@link
     *    JWK.KeyStore#add} for each element in the {ks} array.
     * 4. if {ks} is a JSON object, it creates a new JWK.KeyStore and calls {@link
     *    JWK.KeyStore#add} for each element in the "keys" property.
     *
     * @param {Object|String} ks The value to coerce into a
     *        KeyStore
     * @returns {Promise(JWK.KeyStore)} A promise for the coerced KeyStore.
     */


    JWKStore.asKeyStore = function (ks) {
      if (JWKStore.isKeyStore(ks)) {
        return Promise.resolve(ks);
      }

      var store = JWKStore.createKeyStore(),
          keys;

      if (typeof ks === "string") {
        ks = JSON.parse(ks);
      }

      if (Array.isArray(ks)) {
        keys = ks;
      } else if ("keys" in ks) {
        keys = ks.keys;
      } else {
        return Promise.reject(new Error("invalid keystore"));
      }

      keys = keys.map(function (k) {
        return store.add(k);
      });
      var promise = Promise.all(keys);
      promise = promise.then(function () {
        return store;
      });
      return promise;
    };
    /**
     * Determines if the given object is a JWK.Key instance.
     *
     * @param {Object} obj The object to test
     * @returns `true` if {obj} is a JWK.Key
     */


    JWKStore.isKey = function (obj) {
      if (!obj) {
        return false;
      }

      if ("object" !== typeof obj) {
        return false;
      }

      if (!JWKStore.isKeyStore(obj.keystore)) {
        return false;
      }

      if ("string" !== typeof obj.kty || "number" !== typeof obj.length || "function" !== typeof obj.algorithms || "function" !== typeof obj.supports || "function" !== typeof obj.encrypt || "function" !== typeof obj.decrypt || "function" !== typeof obj.wrap || "function" !== typeof obj.unwrap || "function" !== typeof obj.sign || "function" !== typeof obj.verify) {
        return false;
      }

      return true;
    };
    /**
     * Creates a new key with the given properties.  This method is a convenience
     * to calling `JWK.createKeyStore()` then `generate()` on the returned keystore.
     *
     * @param {String} kty The type of generated key
     * @param {String|Number} [size] The size of the generated key
     * @param {Object} [props] Additional properties to apply to the generated
     *        key.
     * @returns {Promise} The promise for the generated Key
     * @throws {Error} If {kty} is not supported
     * @see JWKStore#generate
     */


    JWKStore.createKey = function (kty, size, props) {
      var ks = JWKStore.createKeyStore();
      return ks.generate(kty, size, props);
    };
    /**
     * Coerces the given object into a Key. If {key} is an instance of JWK.Key,
     * it is returned directly. Otherwise, this method first creates a new
     * JWK.KeyStore and calls {@link JWK.KeyStore#add} on this new KeyStore.
     *
     * @param {Object|String} key The value to coerce into a Key
     * @param {String} [form] The format of a String Key to expect
     * @param {Object} [extras] extra jwk fields inserted when importing from a non json string (eg "pem")
     * @returns {Promise(JWK.Key)} A promise for the coerced Key.
     */


    JWKStore.asKey = function (key, form, extras) {
      if (JWKStore.isKey(key)) {
        return Promise.resolve(key);
      }

      var ks = JWKStore.createKeyStore();
      key = ks.add(key, form, extras);
      return key;
    };

    module.exports = {
      KeyRegistry: JWKRegistry,
      KeyStore: JWKStore,
      registry: GLOBAL_REGISTRY
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 106 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * util/base64url.js - Implementation of web-safe Base64 Encoder/Decoder
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var impl = __webpack_require__(467);
    /**
     * @namespace base64url
     * @description
     * Provides methods to encode and decode data according to the
     * base64url alphabet.
     */


    var base64url = {
      /**
       * @function
       * Encodes the input to base64url.
       *
       * If {input} is a Buffer, then {encoding} is ignored. Otherwise,
       * {encoding} can be one of "binary", "base64", "hex", "utf8".
       *
       * @param {Buffer|String} input The data to encode.
       * @param {String} [encoding = binary] The input encoding format.
       * @returns {String} the base64url encoding of {input}.
       */
      encode: function encode(buffer, encoding) {
        if (buffer instanceof ArrayBuffer) {
          buffer = new Uint8Array(buffer);
        }

        if (!Buffer.isBuffer(buffer)) {
          buffer = Buffer.from(buffer, encoding);
        }

        return impl.encode(buffer);
      },

      /**
       * @function
       * Decodes the input from base64url.
       *
       * @param {String} input The data to decode.
       * @returns {Buffer|String} the base64url decoding of {input}.
       */
      decode: impl.toBuffer
    };
    module.exports = base64url;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 107 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';

  function _has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  exports.assign = function (obj
  /*from1, from2, from3, ...*/
  ) {
    var sources = Array.prototype.slice.call(arguments, 1);

    while (sources.length) {
      var source = sources.shift();

      if (!source) {
        continue;
      }

      if (typeof source !== 'object') {
        throw new TypeError(source + 'must be non-object');
      }

      for (var p in source) {
        if (_has(source, p)) {
          obj[p] = source[p];
        }
      }
    }

    return obj;
  }; // reduce buffer size, avoiding mem copy


  exports.shrinkBuf = function (buf, size) {
    if (buf.length === size) {
      return buf;
    }

    if (buf.subarray) {
      return buf.subarray(0, size);
    }

    buf.length = size;
    return buf;
  };

  var fnTyped = {
    arraySet: function arraySet(dest, src, src_offs, len, dest_offs) {
      if (src.subarray && dest.subarray) {
        dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
        return;
      } // Fallback to ordinary array


      for (var i = 0; i < len; i++) {
        dest[dest_offs + i] = src[src_offs + i];
      }
    },
    // Join array of chunks to single array.
    flattenChunks: function flattenChunks(chunks) {
      var i, l, len, pos, chunk, result; // calculate data length

      len = 0;

      for (i = 0, l = chunks.length; i < l; i++) {
        len += chunks[i].length;
      } // join chunks


      result = new Uint8Array(len);
      pos = 0;

      for (i = 0, l = chunks.length; i < l; i++) {
        chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
      }

      return result;
    }
  };
  var fnUntyped = {
    arraySet: function arraySet(dest, src, src_offs, len, dest_offs) {
      for (var i = 0; i < len; i++) {
        dest[dest_offs + i] = src[src_offs + i];
      }
    },
    // Join array of chunks to single array.
    flattenChunks: function flattenChunks(chunks) {
      return [].concat.apply([], chunks);
    }
  }; // Enable/Disable typed arrays use, for testing
  //

  exports.setTyped = function (on) {
    if (on) {
      exports.Buf8 = Uint8Array;
      exports.Buf16 = Uint16Array;
      exports.Buf32 = Int32Array;
      exports.assign(exports, fnTyped);
    } else {
      exports.Buf8 = Array;
      exports.Buf16 = Array;
      exports.Buf32 = Array;
      exports.assign(exports, fnUntyped);
    }
  };

  exports.setTyped(TYPED_OK);
  /***/
},
/* 108 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /*
    * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
    *
    * Licensed under the Apache License, Version 2.0 (the "License").
    * You may not use this file except in compliance with the License.
    * A copy of the License is located at
    *
    *  http://aws.amazon.com/apache2.0
    *
    * or in the "license" file accompanying this file. This file is distributed
    * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
    * express or implied. See the License for the specific language governing
    * permissions and limitations under the License.
    */
    //node.js deps
    var events = __webpack_require__(41);

    var inherits = __webpack_require__(74).inherits; //npm deps


    var mqtt = __webpack_require__(537);

    var crypto = __webpack_require__(473); //app deps


    var exceptions = __webpack_require__(256);

    var isUndefined = __webpack_require__(85);

    var tlsReader = __webpack_require__(255);

    var path = __webpack_require__(582);

    var fs = __webpack_require__(157); //begin module


    function makeTwoDigits(n) {
      if (n > 9) {
        return n;
      } else {
        return '0' + n;
      }
    }

    function getDateTimeString() {
      var d = new Date(); //
      // The additional ''s are used to force JavaScript to interpret the
      // '+' operator as string concatenation rather than arithmetic.
      //

      return d.getUTCFullYear() + '' + makeTwoDigits(d.getUTCMonth() + 1) + '' + makeTwoDigits(d.getUTCDate()) + 'T' + '' + makeTwoDigits(d.getUTCHours()) + '' + makeTwoDigits(d.getUTCMinutes()) + '' + makeTwoDigits(d.getUTCSeconds()) + 'Z';
    }

    function getDateString(dateTimeString) {
      return dateTimeString.substring(0, dateTimeString.indexOf('T'));
    }

    function getSignatureKey(key, dateStamp, regionName, serviceName) {
      var kDate = crypto.HmacSHA256(dateStamp, 'AWS4' + key, {
        asBytes: true
      });
      var kRegion = crypto.HmacSHA256(regionName, kDate, {
        asBytes: true
      });
      var kService = crypto.HmacSHA256(serviceName, kRegion, {
        asBytes: true
      });
      var kSigning = crypto.HmacSHA256('aws4_request', kService, {
        asBytes: true
      });
      return kSigning;
    }

    function signUrl(method, scheme, hostname, path, queryParams, accessId, secretKey, region, serviceName, payload, today, now, debug, awsSTSToken) {
      var signedHeaders = 'host';
      var canonicalHeaders = 'host:' + hostname.toLowerCase() + '\n';
      var canonicalRequest = method + '\n' + // method
      path + '\n' + // path
      queryParams + '\n' + // query params
      canonicalHeaders + // headers
      '\n' + // required
      signedHeaders + '\n' + // signed header list
      crypto.SHA256(payload, {
        asBytes: true
      }); // hash of payload (empty string)

      if (debug === true) {
        console.log('canonical request: ' + canonicalRequest + '\n');
      }

      var hashedCanonicalRequest = crypto.SHA256(canonicalRequest, {
        asBytes: true
      });

      if (debug === true) {
        console.log('hashed canonical request: ' + hashedCanonicalRequest + '\n');
      }

      var stringToSign = 'AWS4-HMAC-SHA256\n' + now + '\n' + today + '/' + region + '/' + serviceName + '/aws4_request\n' + hashedCanonicalRequest;

      if (debug === true) {
        console.log('string to sign: ' + stringToSign + '\n');
      }

      var signingKey = getSignatureKey(secretKey, today, region, serviceName);

      if (debug === true) {
        console.log('signing key: ' + signingKey + '\n');
      }

      var signature = crypto.HmacSHA256(stringToSign, signingKey, {
        asBytes: true
      });

      if (debug === true) {
        console.log('signature: ' + signature + '\n');
      }

      var finalParams = queryParams + '&X-Amz-Signature=' + signature;

      if (!isUndefined(awsSTSToken)) {
        finalParams += '&X-Amz-Security-Token=' + encodeURIComponent(awsSTSToken);
      }

      var url = scheme + hostname + path + '?' + finalParams;

      if (debug === true) {
        console.log('url: ' + url + '\n');
      }

      return url;
    }

    function prepareWebSocketUrl(options, awsAccessId, awsSecretKey, awsSTSToken) {
      var now = getDateTimeString();
      var today = getDateString(now);
      var path = '/mqtt';
      var awsServiceName = 'iotdevicegateway';
      var queryParams = 'X-Amz-Algorithm=AWS4-HMAC-SHA256' + '&X-Amz-Credential=' + awsAccessId + '%2F' + today + '%2F' + options.region + '%2F' + awsServiceName + '%2Faws4_request' + '&X-Amz-Date=' + now + '&X-Amz-SignedHeaders=host';
      var hostName = options.host; // Include the port number in the hostname if it's not 
      // the standard wss port (443).
      //

      if (!isUndefined(options.port) && options.port !== 443) {
        hostName = options.host + ':' + options.port;
      }

      return signUrl('GET', 'wss://', hostName, path, queryParams, awsAccessId, awsSecretKey, options.region, awsServiceName, '', today, now, options.debug, awsSTSToken);
    }

    function prepareWebSocketCustomAuthUrl(options) {
      var path = '/mqtt';
      var hostName = options.host; // Include the port number in the hostname if it's not 
      // the standard wss port (443).
      //

      if (!isUndefined(options.port) && options.port !== 443) {
        hostName = options.host + ':' + options.port;
      }

      return 'wss://' + hostName + path;
    }

    function arrayEach(array, iterFunction) {
      for (var idx in array) {
        if (Object.prototype.hasOwnProperty.call(array, idx)) {
          iterFunction.call(this, array[idx], parseInt(idx, 10));
        }
      }
    }

    function getCredentials(ini) {
      //Get shared credential function from AWS SDK.
      var map = {};
      var currentSection = {};
      arrayEach(ini.split(/\r?\n/), function (line) {
        line = line.split(/(^|\s)[;#]/)[0]; // remove comments

        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);

        if (section) {
          currentSection = section[1];
        } else if (currentSection) {
          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);

          if (item) {
            map[currentSection] = map[currentSection] || {};
            map[currentSection][item[1]] = item[2];
          }
        }
      });
      return map;
    } //
    // This method is the exposed module; it validates the mqtt options,
    // creates a secure mqtt connection via TLS, and returns the mqtt
    // connection instance.
    //


    function DeviceClient(options) {
      //
      // Force instantiation using the 'new' operator; this will cause inherited
      // constructors (e.g. the 'events' class) to be called.
      //
      if (!(this instanceof DeviceClient)) {
        return new DeviceClient(options);
      } //
      // A copy of 'this' for use inside of closures
      //


      var that = this; //
      // Offline Operation
      //
      // The connection to AWS IoT can be in one of three states:
      //
      //   1) Inactive
      //   2) Established
      //   3) Stable
      //
      // During state 1), publish operations are placed in a queue
      // ("filling")
      //
      // During states 2) and 3), any operations present in the queue
      // are sent to the mqtt client for completion ("draining").
      //
      // In all states, subscriptions are tracked in a cache
      //
      // A "draining interval" is used to specify the rate at which
      // which operations are drained from the queue.
      //
      //    +- - - - - - - - - - - - - - - - - - - - - - - - +
      //    |                                                |
      //                                                      
      //    |                    FILLING                     |         
      //                                                      
      //    |                                                |
      //              +-----------------------------+         
      //    |         |                             |        |
      //              |                             |         
      //    |         v                             |        |
      //    +- - Established                     Inactive - -+
      //    |         |                             ^        |
      //              |                             |         
      //    |         |                             |        |
      //              +----------> Stable ----------+        
      //    |                                                |
      //                                                      
      //    |                     DRAINING                   |         
      //                                                      
      //    |                                                |
      //    +- - - - - - - - - - - - - - - - - - - - - - - - +
      //
      //
      // Draining Operation
      //
      // During draining, existing subscriptions are re-sent,
      // followed by any publishes which occurred while offline.
      //    
      //
      // Publish cache used during filling
      //

      var offlinePublishQueue = [];
      var offlineQueueing = true;
      var offlineQueueMaxSize = 0;
      var offlineQueueDropBehavior = 'oldest'; // oldest or newest

      offlinePublishQueue.length = 0; //
      // Subscription queue for subscribe/unsubscribe requests received when offline
      // We do not want an unbounded queue so for now limit to current max subs in AWS IoT
      //

      var offlineSubscriptionQueue = [];
      var offlineSubscriptionQueueMaxSize = 50;
      offlineSubscriptionQueue.length = 0; //
      // Subscription cache; active if autoResubscribe === true
      //

      var activeSubscriptions = [];
      var autoResubscribe = true;
      activeSubscriptions.length = 0; //
      // Cloned subscription cache; active during initial draining.
      //

      var clonedSubscriptions = [];
      clonedSubscriptions.length = 0; //
      // Contains the operational state of the connection
      //

      var connectionState = 'inactive'; //
      // Used to time draining operations; active during draining.
      //

      var drainingTimer = null;
      var drainTimeMs = 250; //Default keep alive time interval in seconds.

      var defaultKeepalive = 300; //
      // These properties control the reconnect behavior of the MQTT Client.  If 
      // the MQTT client becomes disconnected, it will attempt to reconnect after 
      // a quiet period; this quiet period doubles with each reconnection attempt,
      // e.g. 1 seconds, 2 seconds, 2, 8, 16, 32, etc... up until a maximum 
      // reconnection time is reached.
      //
      // If a connection is active for the minimum connection time, the quiet 
      // period is reset to the initial value.
      //
      // baseReconnectTime: the time in seconds to wait before the first 
      //     reconnect attempt
      //
      // minimumConnectionTime: the time in seconds that a connection must be 
      //     active before resetting the current reconnection time to the base 
      //     reconnection time
      //
      // maximumReconnectTime: the maximum time in seconds to wait between 
      //     reconnect attempts
      //
      // The defaults for these values are:
      //
      // baseReconnectTime: 1 seconds
      // minimumConnectionTime: 20 seconds
      // maximumReconnectTime: 128 seconds
      //

      var baseReconnectTimeMs = 1000;
      var minimumConnectionTimeMs = 20000;
      var maximumReconnectTimeMs = 128000;
      var currentReconnectTimeMs; //
      // Used to measure the length of time the connection has been active to
      // know if it's stable or not.  Active beginning from receipt of a 'connect'
      // event (e.g. received CONNACK) until 'minimumConnectionTimeMs' has elapsed.
      //

      var connectionTimer = null; //
      // Credentials when authenticating via WebSocket/SigV4
      //

      var awsAccessId;
      var awsSecretKey;
      var awsSTSToken; //
      // Validate options, set default reconnect period if not specified.
      //

      var metricPrefix = "?SDK=JavaScript&Version=";

      var pjson = __webpack_require__(261);

      var sdkVersion = pjson.version;
      var defaultUsername = metricPrefix + sdkVersion;

      if (isUndefined(options) || Object.keys(options).length === 0) {
        throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
      }

      if (isUndefined(options.keepalive)) {
        options.keepalive = defaultKeepalive;
      } //
      // Metrics will be enabled by default unless the user explicitly disables it
      //


      if (isUndefined(options.enableMetrics) || options.enableMetrics === true) {
        if (isUndefined(options.username)) {
          options.username = defaultUsername;
        } else {
          options.username += defaultUsername;
        }
      }

      if (!isUndefined(options.baseReconnectTimeMs)) {
        baseReconnectTimeMs = options.baseReconnectTimeMs;
      }

      if (!isUndefined(options.minimumConnectionTimeMs)) {
        minimumConnectionTimeMs = options.minimumConnectionTimeMs;
      }

      if (!isUndefined(options.maximumReconnectTimeMs)) {
        maximumReconnectTimeMs = options.maximumReconnectTimeMs;
      }

      if (!isUndefined(options.drainTimeMs)) {
        drainTimeMs = options.drainTimeMs;
      }

      if (!isUndefined(options.autoResubscribe)) {
        autoResubscribe = options.autoResubscribe;
      }

      if (!isUndefined(options.offlineQueueing)) {
        offlineQueueing = options.offlineQueueing;
      }

      if (!isUndefined(options.offlineQueueMaxSize)) {
        offlineQueueMaxSize = options.offlineQueueMaxSize;
      }

      if (!isUndefined(options.offlineQueueDropBehavior)) {
        offlineQueueDropBehavior = options.offlineQueueDropBehavior;
      }

      currentReconnectTimeMs = baseReconnectTimeMs;
      options.reconnectPeriod = currentReconnectTimeMs;
      options.fastDisconnectDetection = true; //
      //SDK has its own logic to deal with auto resubscribe
      //

      options.resubscribe = false; //
      // Verify that the reconnection timing parameters make sense.
      //

      if (options.baseReconnectTimeMs <= 0) {
        throw new Error(exceptions.INVALID_RECONNECT_TIMING);
      }

      if (maximumReconnectTimeMs < baseReconnectTimeMs) {
        throw new Error(exceptions.INVALID_RECONNECT_TIMING);
      }

      if (minimumConnectionTimeMs < baseReconnectTimeMs) {
        throw new Error(exceptions.INVALID_RECONNECT_TIMING);
      } //
      // Verify that the other optional parameters make sense.
      //


      if (offlineQueueDropBehavior !== 'newest' && offlineQueueDropBehavior !== 'oldest') {
        throw new Error(exceptions.INVALID_OFFLINE_QUEUEING_PARAMETERS);
      }

      if (offlineQueueMaxSize < 0) {
        throw new Error(exceptions.INVALID_OFFLINE_QUEUEING_PARAMETERS);
      } // set protocol, do not override existing definitions if available


      if (isUndefined(options.protocol)) {
        options.protocol = 'mqtts';
      }

      if (isUndefined(options.host)) {
        throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
      }

      if (options.protocol === 'mqtts') {
        // set port, do not override existing definitions if available
        if (isUndefined(options.port)) {
          options.port = 8883;
        } //read and map certificates


        tlsReader(options);
      } else if (options.protocol === 'wss' || options.protocol === 'wss-custom-auth') {
        if (options.protocol === 'wss') {
          //
          // AWS access id and secret key 
          // It first check Input options and Environment variables 
          // If that not available, it will try to load credentials from default credential file
          if (!isUndefined(options.accessKeyId)) {
            awsAccessId = options.accessKeyId;
          } else {
            awsAccessId = process.env.AWS_ACCESS_KEY_ID;
          }

          if (!isUndefined(options.secretKey)) {
            awsSecretKey = options.secretKey;
          } else {
            awsSecretKey = process.env.AWS_SECRET_ACCESS_KEY;
          }

          if (!isUndefined(options.sessionToken)) {
            awsSTSToken = options.sessionToken;
          } else {
            awsSTSToken = process.env.AWS_SESSION_TOKEN;
          }

          if (isUndefined(awsAccessId) || isUndefined(awsSecretKey)) {
            var filename;

            try {
              if (!isUndefined(options.filename)) {
                filename = options.filename;
              } else {
                filename = _loadDefaultFilename();
              }

              var user_profile = options.profile || process.env.AWS_PROFILE || 'default';
              var creds = getCredentials(fs.readFileSync(filename, 'utf-8'));
              var profile = creds[user_profile];
              awsAccessId = profile.aws_access_key_id;
              awsSecretKey = profile.aws_secret_access_key;
              awsSTSToken = profile.aws_session_token;
            } catch (e) {
              console.log(e);
              console.log('Failed to read credentials from ' + filename);
            }
          } // AWS Access Key ID and AWS Secret Key must be defined


          if (isUndefined(awsAccessId) || isUndefined(awsSecretKey)) {
            console.log('To connect via WebSocket/SigV4, AWS Access Key ID and AWS Secret Key must be passed either in options or as environment variables; see README.md');
            throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
          }
        } else {
          if (isUndefined(options.customAuthHeaders)) {
            console.log('To authenticate with a custom authorizer, you must provide the required HTTP headers; see README.md');
            throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
          }
        }

        if (!isUndefined(options.host) && isUndefined(options.region)) {
          var pattern = /[a-zA-Z0-9]+\.iot\.([a-z]+-[a-z]+-[0-9]+)\.amazonaws\..+/;
          var region = pattern.exec(options.host);

          if (region === null) {
            console.log('Host endpoint is not valid');
            throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
          } else {
            options.region = region[1];
          }
        } // set port, do not override existing definitions if available


        if (isUndefined(options.port)) {
          options.port = 443;
        } // check websocketOptions and ensure that the protocol is defined


        if (isUndefined(options.websocketOptions)) {
          options.websocketOptions = {
            protocol: 'mqttv3.1'
          };
        } else {
          options.websocketOptions.protocol = 'mqttv3.1';
        }

        if (options.protocol === 'wss-custom-auth') {
          options.websocketOptions.headers = options.customAuthHeaders;
        }
      }

      if (!isUndefined(options) && options.debug === true) {
        console.log(options);
        console.log('attempting new mqtt connection...');
      } //connect and return the client instance to map all mqttjs apis


      var protocols = {};
      protocols.mqtts = __webpack_require__(257);
      protocols.wss = __webpack_require__(258);

      function _loadDefaultFilename() {
        var home = process.env.HOME || process.env.USERPROFILE || (process.env.HOMEPATH ? (process.env.HOMEDRIVE || 'C:/') + process.env.HOMEPATH : null);
        return path.join(home, '.aws', 'credentials');
      }

      function _addToSubscriptionCache(topic, options) {
        var matches = activeSubscriptions.filter(function (element) {
          return element.topic === topic;
        }); //
        // Add the element only if it doesn't already exist.
        //

        if (matches.length === 0) {
          activeSubscriptions.push({
            topic: topic,
            options: options
          });
        }
      }

      function _deleteFromSubscriptionCache(topic, options) {
        var remaining = activeSubscriptions.filter(function (element) {
          return element.topic !== topic;
        });
        activeSubscriptions = remaining;
      }

      function _updateSubscriptionCache(operation, topics, options) {
        var opFunc = null; //
        // Don't cache subscriptions if auto-resubscribe is disabled
        // 

        if (autoResubscribe === false) {
          return;
        }

        if (operation === 'subscribe') {
          opFunc = _addToSubscriptionCache;
        } else if (operation === 'unsubscribe') {
          opFunc = _deleteFromSubscriptionCache;
        } //
        // Test to see if 'topics' is an array and if so, iterate.
        //


        if (Object.prototype.toString.call(topics) === '[object Array]') {
          topics.forEach(function (item, index, array) {
            opFunc(item, options);
          });
        } else {
          opFunc(topics, options);
        }
      } //
      // Return true if the connection is currently in a 'filling' 
      // state
      //


      function _filling() {
        return connectionState === 'inactive';
      }

      function _wrapper(client) {
        var protocol = options.protocol;

        if (protocol === 'wss') {
          var url; //
          // If the access id and secret key are available, prepare the URL. 
          // Otherwise, set the url to an invalid value.
          //

          if (awsAccessId === '' || awsSecretKey === '') {
            url = 'wss://no-credentials-available';
          } else {
            url = prepareWebSocketUrl(options, awsAccessId, awsSecretKey, awsSTSToken);
          }

          if (options.debug === true) {
            console.log('using websockets, will connect to \'' + url + '\'...');
          }

          options.url = url;
        } else if (protocol === 'wss-custom-auth') {
          options.url = prepareWebSocketCustomAuthUrl(options);

          if (options.debug === true) {
            console.log('using websockets custom auth, will connect to \'' + options.url + '\'...');
          } // Treat the request as a standard websocket request from here onwards


          protocol = 'wss';
        }

        return protocols[protocol](client, options);
      }

      var device = new mqtt.MqttClient(_wrapper, options); //handle events from the mqtt client
      //
      // Timeout expiry function for the connection timer; once a connection
      // is stable, reset the current reconnection time to the base value. 
      //

      function _markConnectionStable() {
        currentReconnectTimeMs = baseReconnectTimeMs;
        device.options.reconnectPeriod = currentReconnectTimeMs; //
        // Mark this timeout as expired
        //

        connectionTimer = null;
        connectionState = 'stable';
      } //
      // Trim the offline queue if required; returns true if another
      // element can be placed in the queue
      //


      function _trimOfflinePublishQueueIfNecessary() {
        var rc = true;

        if (offlineQueueMaxSize > 0 && offlinePublishQueue.length >= offlineQueueMaxSize) {
          //
          // The queue has reached its maximum size, trim it
          // according to the defined drop behavior.
          //
          if (offlineQueueDropBehavior === 'oldest') {
            offlinePublishQueue.shift();
          } else {
            rc = false;
          }
        }

        return rc;
      } //
      // Timeout expiry function for the drain timer; once a connection
      // has been established, begin draining cached transactions.
      //


      function _drainOperationQueue() {
        //
        // Handle our active subscriptions first, using a cloned
        // copy of the array.  We shift them out one-by-one until
        // all have been processed, leaving the official record
        // of active subscriptions untouched.
        // 
        var subscription = clonedSubscriptions.shift();

        if (!isUndefined(subscription)) {
          //
          // If the 3rd argument (namely callback) is not present, we will
          // use two-argument form to call mqtt.Client#subscribe(), which
          // supports both subscribe(topics, options) and subscribe(topics, callback).
          //
          if (!isUndefined(subscription.callback)) {
            device.subscribe(subscription.topic, subscription.options, subscription.callback);
          } else {
            device.subscribe(subscription.topic, subscription.options);
          }
        } else {
          //
          // If no remaining active subscriptions to process,
          // then handle subscription requests queued while offline.
          //
          var req = offlineSubscriptionQueue.shift();

          if (!isUndefined(req)) {
            _updateSubscriptionCache(req.type, req.topics, req.options);

            if (req.type === 'subscribe') {
              if (!isUndefined(req.callback)) {
                device.subscribe(req.topics, req.options, req.callback);
              } else {
                device.subscribe(req.topics, req.options);
              }
            } else if (req.type === 'unsubscribe') {
              device.unsubscribe(req.topics, req.callback);
            }
          } else {
            //
            // If no active or queued subscriptions remaining to process,
            // then handle queued publish operations.
            //
            var offlinePublishMessage = offlinePublishQueue.shift();

            if (!isUndefined(offlinePublishMessage)) {
              device.publish(offlinePublishMessage.topic, offlinePublishMessage.message, offlinePublishMessage.options, offlinePublishMessage.callback);
            }

            if (offlinePublishQueue.length === 0) {
              //
              // The subscription and offlinePublishQueue queues are fully drained,
              // cancel the draining timer.
              //
              clearInterval(drainingTimer);
              drainingTimer = null;
            }
          }
        }
      } //
      // Event handling - *all* events generated by the mqtt.js client must be
      // handled here, *and* propagated upwards.
      //


      device.on('connect', function (connack) {
        //
        // If not already running, start the connection timer.
        //
        if (connectionTimer === null) {
          connectionTimer = setTimeout(_markConnectionStable, minimumConnectionTimeMs);
        }

        connectionState = 'established'; //
        // If not already running, start the draining timer and 
        // clone the active subscriptions.
        //

        if (drainingTimer === null) {
          clonedSubscriptions = activeSubscriptions.slice(0);
          drainingTimer = setInterval(_drainOperationQueue, drainTimeMs);
        }

        that.emit('connect', connack);
      });
      device.on('close', function (err) {
        if (!isUndefined(err)) {
          that.emit('error', err);
        }

        if (!isUndefined(options) && options.debug === true) {
          console.log('connection lost - will attempt reconnection in ' + device.options.reconnectPeriod / 1000 + ' seconds...');
        } //
        // Clear the connection and drain timers
        //


        clearTimeout(connectionTimer);
        connectionTimer = null;
        clearInterval(drainingTimer);
        drainingTimer = null; //
        // Mark the connection state as inactive
        //

        connectionState = 'inactive';
        that.emit('close');
      });
      device.on('reconnect', function () {
        //
        // Update the current reconnect timeout; this will be the
        // next timeout value used if this connect attempt fails.
        // 
        currentReconnectTimeMs = currentReconnectTimeMs * 2;
        currentReconnectTimeMs = Math.min(maximumReconnectTimeMs, currentReconnectTimeMs);
        device.options.reconnectPeriod = currentReconnectTimeMs;
        that.emit('reconnect');
      });
      device.on('offline', function () {
        that.emit('offline');
      });
      device.on('error', function (error) {
        that.emit('error', error);
      });
      device.on('packetsend', function (packet) {
        that.emit('packetsend', packet);
      });
      device.on('packetreceive', function (packet) {
        that.emit('packetreceive', packet);
      });
      device.on('message', function (topic, message, packet) {
        that.emit('message', topic, message, packet);
      }); //
      // The signatures of these methods *must* match those of the mqtt.js
      // client.
      //

      this.publish = function (topic, message, options, callback) {
        //
        // If filling or still draining, push this publish operation 
        // into the offline operations queue; otherwise, perform it
        // immediately.
        //
        if (offlineQueueing === true && (_filling() || drainingTimer !== null)) {
          if (_trimOfflinePublishQueueIfNecessary()) {
            offlinePublishQueue.push({
              topic: topic,
              message: message,
              options: options,
              callback: callback
            });
          }
        } else {
          if (offlineQueueing === true || !_filling()) {
            device.publish(topic, message, options, callback);
          }
        }
      };

      this.subscribe = function (topics, options, callback) {
        if (!_filling() || autoResubscribe === false) {
          _updateSubscriptionCache('subscribe', topics, options); // we do not store callback in active cache
          //
          // If the 3rd argument (namely callback) is not present, we will
          // use two-argument form to call mqtt.Client#subscribe(), which
          // supports both subscribe(topics, options) and subscribe(topics, callback).
          //


          if (!isUndefined(callback)) {
            device.subscribe(topics, options, callback);
          } else {
            device.subscribe(topics, options);
          }
        } else {
          // we're offline - queue this subscription request
          if (offlineSubscriptionQueue.length < offlineSubscriptionQueueMaxSize) {
            offlineSubscriptionQueue.push({
              type: 'subscribe',
              topics: topics,
              options: options,
              callback: callback
            });
          } else {
            that.emit('error', new Error('Maximum queued offline subscription reached'));
          }
        }
      };

      this.unsubscribe = function (topics, callback) {
        if (!_filling() || autoResubscribe === false) {
          _updateSubscriptionCache('unsubscribe', topics);

          device.unsubscribe(topics, callback);
        } else {
          // we're offline - queue this unsubscribe request
          if (offlineSubscriptionQueue.length < offlineSubscriptionQueueMaxSize) {
            offlineSubscriptionQueue.push({
              type: 'unsubscribe',
              topics: topics,
              options: options,
              callback: callback
            });
          }
        }
      };

      this.end = function (force, callback) {
        device.end(force, callback);
      };

      this.handleMessage = device.handleMessage.bind(device);

      device.handleMessage = function (packet, callback) {
        that.handleMessage(packet, callback);
      };

      this.updateWebSocketCredentials = function (accessKeyId, secretKey, sessionToken, expiration) {
        awsAccessId = accessKeyId;
        awsSecretKey = secretKey;
        awsSTSToken = sessionToken;
      };

      this.getWebsocketHeaders = function () {
        return options.websocketOptions.headers;
      }; //
      // Call this function to update the custom auth headers
      //


      this.updateCustomAuthHeaders = function (newHeaders) {
        options.websocketOptions.headers = newHeaders;
      }; //
      // Used for integration testing only
      //


      this.simulateNetworkFailure = function () {
        device.stream.emit('error', new Error('simulated connection error'));
        device.stream.end();
      };
    } //
    // Allow instances to listen in on events that we produce for them
    //


    inherits(DeviceClient, events.EventEmitter);
    module.exports = DeviceClient;
    module.exports.DeviceClient = DeviceClient; //
    // Exported for unit testing only
    //

    module.exports.prepareWebSocketUrl = prepareWebSocketUrl;
    module.exports.prepareWebSocketCustomAuthUrl = prepareWebSocketCustomAuthUrl;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(16));
  /***/
},
/* 109 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

  var toObject = __webpack_require__(15);

  var toAbsoluteIndex = __webpack_require__(58);

  var toLength = __webpack_require__(13);

  module.exports = function fill(value
  /* , start = 0, end = @length */
  ) {
    var O = toObject(this);
    var length = toLength(O.length);
    var aLen = arguments.length;
    var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
    var end = aLen > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : toAbsoluteIndex(end, length);

    while (endPos > index) {
      O[index++] = value;
    }

    return O;
  };
  /***/

},
/* 110 */

/***/
function (module, exports, __webpack_require__) {
  // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
  var speciesConstructor = __webpack_require__(264);

  module.exports = function (original, length) {
    return new (speciesConstructor(original))(length);
  };
  /***/

},
/* 111 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $defineProperty = __webpack_require__(12);

  var createDesc = __webpack_require__(55);

  module.exports = function (object, index, value) {
    if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
  };
  /***/

},
/* 112 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(7);

  var document = __webpack_require__(3).document; // typeof document.createElement is 'object' in old IE


  var is = isObject(document) && isObject(document.createElement);

  module.exports = function (it) {
    return is ? document.createElement(it) : {};
  };
  /***/

},
/* 113 */

/***/
function (module, exports) {
  // IE 8- don't enum bug keys
  module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
  /***/
},
/* 114 */

/***/
function (module, exports, __webpack_require__) {
  var MATCH = __webpack_require__(9)('match');

  module.exports = function (KEY) {
    var re = /./;

    try {
      '/./'[KEY](re);
    } catch (e) {
      try {
        re[MATCH] = false;
        return !'/./'[KEY](re);
      } catch (f) {
        /* empty */
      }
    }

    return true;
  };
  /***/

},
/* 115 */

/***/
function (module, exports, __webpack_require__) {
  var document = __webpack_require__(3).document;

  module.exports = document && document.documentElement;
  /***/
},
/* 116 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(7);

  var setPrototypeOf = __webpack_require__(124).set;

  module.exports = function (that, target, C) {
    var S = target.constructor;
    var P;

    if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
      setPrototypeOf(that, P);
    }

    return that;
  };
  /***/

},
/* 117 */

/***/
function (module, exports, __webpack_require__) {
  // check on default Array iterator
  var Iterators = __webpack_require__(64);

  var ITERATOR = __webpack_require__(9)('iterator');

  var ArrayProto = Array.prototype;

  module.exports = function (it) {
    return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
  };
  /***/

},
/* 118 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var create = __webpack_require__(52);

  var descriptor = __webpack_require__(55);

  var setToStringTag = __webpack_require__(65);

  var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

  __webpack_require__(20)(IteratorPrototype, __webpack_require__(9)('iterator'), function () {
    return this;
  });

  module.exports = function (Constructor, NAME, next) {
    Constructor.prototype = create(IteratorPrototype, {
      next: descriptor(1, next)
    });
    setToStringTag(Constructor, NAME + ' Iterator');
  };
  /***/

},
/* 119 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var LIBRARY = __webpack_require__(51);

  var $export = __webpack_require__(0);

  var redefine = __webpack_require__(21);

  var hide = __webpack_require__(20);

  var Iterators = __webpack_require__(64);

  var $iterCreate = __webpack_require__(118);

  var setToStringTag = __webpack_require__(65);

  var getPrototypeOf = __webpack_require__(25);

  var ITERATOR = __webpack_require__(9)('iterator');

  var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

  var FF_ITERATOR = '@@iterator';
  var KEYS = 'keys';
  var VALUES = 'values';

  var returnThis = function returnThis() {
    return this;
  };

  module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $iterCreate(Constructor, NAME, next);

    var getMethod = function getMethod(kind) {
      if (!BUGGY && kind in proto) return proto[kind];

      switch (kind) {
        case KEYS:
          return function keys() {
            return new Constructor(this, kind);
          };

        case VALUES:
          return function values() {
            return new Constructor(this, kind);
          };
      }

      return function entries() {
        return new Constructor(this, kind);
      };
    };

    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype; // Fix native

    if ($anyNative) {
      IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

      if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
        // Set @@toStringTag to native iterators
        setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

        if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
      }
    } // fix Array#{values, @@iterator}.name in V8 / FF


    if (DEF_VALUES && $native && $native.name !== VALUES) {
      VALUES_BUG = true;

      $default = function values() {
        return $native.call(this);
      };
    } // Define iterator


    if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
      hide(proto, ITERATOR, $default);
    } // Plug for library


    Iterators[NAME] = $default;
    Iterators[TAG] = returnThis;

    if (DEFAULT) {
      methods = {
        values: DEF_VALUES ? $default : getMethod(VALUES),
        keys: IS_SET ? $default : getMethod(KEYS),
        entries: $entries
      };
      if (FORCED) for (key in methods) {
        if (!(key in proto)) redefine(proto, key, methods[key]);
      } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }

    return methods;
  };
  /***/

},
/* 120 */

/***/
function (module, exports) {
  // 20.2.2.14 Math.expm1(x)
  var $expm1 = Math.expm1;
  module.exports = !$expm1 // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168 // Tor Browser bug
  || $expm1(-2e-17) != -2e-17 ? function expm1(x) {
    return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
  } : $expm1;
  /***/
},
/* 121 */

/***/
function (module, exports) {
  // 20.2.2.28 Math.sign(x)
  module.exports = Math.sign || function sign(x) {
    // eslint-disable-next-line no-self-compare
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
  };
  /***/

},
/* 122 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(3);

  var macrotask = __webpack_require__(130).set;

  var Observer = global.MutationObserver || global.WebKitMutationObserver;
  var process = global.process;
  var Promise = global.Promise;
  var isNode = __webpack_require__(27)(process) == 'process';

  module.exports = function () {
    var head, last, notify;

    var flush = function flush() {
      var parent, fn;
      if (isNode && (parent = process.domain)) parent.exit();

      while (head) {
        fn = head.fn;
        head = head.next;

        try {
          fn();
        } catch (e) {
          if (head) notify();else last = undefined;
          throw e;
        }
      }

      last = undefined;
      if (parent) parent.enter();
    }; // Node.js


    if (isNode) {
      notify = function notify() {
        process.nextTick(flush);
      }; // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339

    } else if (Observer && !(global.navigator && global.navigator.standalone)) {
      var toggle = true;
      var node = document.createTextNode('');
      new Observer(flush).observe(node, {
        characterData: true
      }); // eslint-disable-line no-new

      notify = function notify() {
        node.data = toggle = !toggle;
      }; // environments with maybe non-completely correct, but existent Promise

    } else if (Promise && Promise.resolve) {
      var promise = Promise.resolve();

      notify = function notify() {
        promise.then(flush);
      }; // for other environments - macrotask based on:
      // - setImmediate
      // - MessageChannel
      // - window.postMessag
      // - onreadystatechange
      // - setTimeout

    } else {
      notify = function notify() {
        // strange IE + webpack dev server bug - use .call(global)
        macrotask.call(global, flush);
      };
    }

    return function (fn) {
      var task = {
        fn: fn,
        next: undefined
      };
      if (last) last.next = task;

      if (!head) {
        head = task;
        notify();
      }

      last = task;
    };
  };
  /***/

},
/* 123 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 25.4.1.5 NewPromiseCapability(C)

  var aFunction = __webpack_require__(18);

  function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function ($$resolve, $$reject) {
      if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
      resolve = $$resolve;
      reject = $$reject;
    });
    this.resolve = aFunction(resolve);
    this.reject = aFunction(reject);
  }

  module.exports.f = function (C) {
    return new PromiseCapability(C);
  };
  /***/

},
/* 124 */

/***/
function (module, exports, __webpack_require__) {
  // Works with __proto__ only. Old v8 can't work with null proto objects.

  /* eslint-disable no-proto */
  var isObject = __webpack_require__(7);

  var anObject = __webpack_require__(2);

  var check = function check(O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
  };

  module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(28)(Function.call, __webpack_require__(24).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) {
        buggy = true;
      }

      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
    check: check
  };
  /***/
},
/* 125 */

/***/
function (module, exports, __webpack_require__) {
  var shared = __webpack_require__(97)('keys');

  var uid = __webpack_require__(59);

  module.exports = function (key) {
    return shared[key] || (shared[key] = uid(key));
  };
  /***/

},
/* 126 */

/***/
function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(35);

  var defined = __webpack_require__(33); // true  -> String#at
  // false -> String#codePointAt


  module.exports = function (TO_STRING) {
    return function (that, pos) {
      var s = String(defined(that));
      var i = toInteger(pos);
      var l = s.length;
      var a, b;
      if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };
  /***/

},
/* 127 */

/***/
function (module, exports, __webpack_require__) {
  // helper for String#{startsWith, endsWith, includes}
  var isRegExp = __webpack_require__(91);

  var defined = __webpack_require__(33);

  module.exports = function (that, searchString, NAME) {
    if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
    return String(defined(that));
  };
  /***/

},
/* 128 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var toInteger = __webpack_require__(35);

  var defined = __webpack_require__(33);

  module.exports = function repeat(count) {
    var str = String(defined(this));
    var res = '';
    var n = toInteger(count);
    if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");

    for (; n > 0; (n >>>= 1) && (str += str)) {
      if (n & 1) res += str;
    }

    return res;
  };
  /***/

},
/* 129 */

/***/
function (module, exports) {
  module.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003" + "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  /***/
},
/* 130 */

/***/
function (module, exports, __webpack_require__) {
  var ctx = __webpack_require__(28);

  var invoke = __webpack_require__(173);

  var html = __webpack_require__(115);

  var cel = __webpack_require__(112);

  var global = __webpack_require__(3);

  var process = global.process;
  var setTask = global.setImmediate;
  var clearTask = global.clearImmediate;
  var MessageChannel = global.MessageChannel;
  var Dispatch = global.Dispatch;
  var counter = 0;
  var queue = {};
  var ONREADYSTATECHANGE = 'onreadystatechange';
  var defer, channel, port;

  var run = function run() {
    var id = +this; // eslint-disable-next-line no-prototype-builtins

    if (queue.hasOwnProperty(id)) {
      var fn = queue[id];
      delete queue[id];
      fn();
    }
  };

  var listener = function listener(event) {
    run.call(event.data);
  }; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


  if (!setTask || !clearTask) {
    setTask = function setImmediate(fn) {
      var args = [];
      var i = 1;

      while (arguments.length > i) {
        args.push(arguments[i++]);
      }

      queue[++counter] = function () {
        // eslint-disable-next-line no-new-func
        invoke(typeof fn == 'function' ? fn : Function(fn), args);
      };

      defer(counter);
      return counter;
    };

    clearTask = function clearImmediate(id) {
      delete queue[id];
    }; // Node.js 0.8-


    if (__webpack_require__(27)(process) == 'process') {
      defer = function defer(id) {
        process.nextTick(ctx(run, id, 1));
      }; // Sphere (JS game engine) Dispatch API

    } else if (Dispatch && Dispatch.now) {
      defer = function defer(id) {
        Dispatch.now(ctx(run, id, 1));
      }; // Browsers with MessageChannel, includes WebWorkers

    } else if (MessageChannel) {
      channel = new MessageChannel();
      port = channel.port2;
      channel.port1.onmessage = listener;
      defer = ctx(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
      // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
      defer = function defer(id) {
        global.postMessage(id + '', '*');
      };

      global.addEventListener('message', listener, false); // IE8-
    } else if (ONREADYSTATECHANGE in cel('script')) {
      defer = function defer(id) {
        html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
          html.removeChild(this);
          run.call(id);
        };
      }; // Rest old browsers

    } else {
      defer = function defer(id) {
        setTimeout(ctx(run, id, 1), 0);
      };
    }
  }

  module.exports = {
    set: setTask,
    clear: clearTask
  };
  /***/
},
/* 131 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(3);

  var DESCRIPTORS = __webpack_require__(11);

  var LIBRARY = __webpack_require__(51);

  var $typed = __webpack_require__(99);

  var hide = __webpack_require__(20);

  var redefineAll = __webpack_require__(56);

  var fails = __webpack_require__(5);

  var anInstance = __webpack_require__(49);

  var toInteger = __webpack_require__(35);

  var toLength = __webpack_require__(13);

  var toIndex = __webpack_require__(191);

  var gOPN = __webpack_require__(53).f;

  var dP = __webpack_require__(12).f;

  var arrayFill = __webpack_require__(109);

  var setToStringTag = __webpack_require__(65);

  var ARRAY_BUFFER = 'ArrayBuffer';
  var DATA_VIEW = 'DataView';
  var PROTOTYPE = 'prototype';
  var WRONG_LENGTH = 'Wrong length!';
  var WRONG_INDEX = 'Wrong index!';
  var $ArrayBuffer = global[ARRAY_BUFFER];
  var $DataView = global[DATA_VIEW];
  var Math = global.Math;
  var RangeError = global.RangeError; // eslint-disable-next-line no-shadow-restricted-names

  var Infinity = global.Infinity;
  var BaseBuffer = $ArrayBuffer;
  var abs = Math.abs;
  var pow = Math.pow;
  var floor = Math.floor;
  var log = Math.log;
  var LN2 = Math.LN2;
  var BUFFER = 'buffer';
  var BYTE_LENGTH = 'byteLength';
  var BYTE_OFFSET = 'byteOffset';
  var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
  var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
  var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET; // IEEE754 conversions based on https://github.com/feross/ieee754

  function packIEEE754(value, mLen, nBytes) {
    var buffer = new Array(nBytes);
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
    var i = 0;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    var e, m, c;
    value = abs(value); // eslint-disable-next-line no-self-compare

    if (value != value || value === Infinity) {
      // eslint-disable-next-line no-self-compare
      m = value != value ? 1 : 0;
      e = eMax;
    } else {
      e = floor(log(value) / LN2);

      if (value * (c = pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }

      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * pow(2, 1 - eBias);
      }

      if (value * c >= 2) {
        e++;
        c /= 2;
      }

      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * pow(2, eBias - 1) * pow(2, mLen);
        e = 0;
      }
    }

    for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {
      ;
    }

    e = e << mLen | m;
    eLen += mLen;

    for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {
      ;
    }

    buffer[--i] |= s * 128;
    return buffer;
  }

  function unpackIEEE754(buffer, mLen, nBytes) {
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = eLen - 7;
    var i = nBytes - 1;
    var s = buffer[i--];
    var e = s & 127;
    var m;
    s >>= 7;

    for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {
      ;
    }

    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;

    for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {
      ;
    }

    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : s ? -Infinity : Infinity;
    } else {
      m = m + pow(2, mLen);
      e = e - eBias;
    }

    return (s ? -1 : 1) * m * pow(2, e - mLen);
  }

  function unpackI32(bytes) {
    return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
  }

  function packI8(it) {
    return [it & 0xff];
  }

  function packI16(it) {
    return [it & 0xff, it >> 8 & 0xff];
  }

  function packI32(it) {
    return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
  }

  function packF64(it) {
    return packIEEE754(it, 52, 8);
  }

  function packF32(it) {
    return packIEEE754(it, 23, 4);
  }

  function addGetter(C, key, internal) {
    dP(C[PROTOTYPE], key, {
      get: function get() {
        return this[internal];
      }
    });
  }

  function get(view, bytes, index, isLittleEndian) {
    var numIndex = +index;
    var intIndex = toIndex(numIndex);
    if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
    var store = view[$BUFFER]._b;
    var start = intIndex + view[$OFFSET];
    var pack = store.slice(start, start + bytes);
    return isLittleEndian ? pack : pack.reverse();
  }

  function set(view, bytes, index, conversion, value, isLittleEndian) {
    var numIndex = +index;
    var intIndex = toIndex(numIndex);
    if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
    var store = view[$BUFFER]._b;
    var start = intIndex + view[$OFFSET];
    var pack = conversion(+value);

    for (var i = 0; i < bytes; i++) {
      store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
    }
  }

  if (!$typed.ABV) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
      var byteLength = toIndex(length);
      this._b = arrayFill.call(new Array(byteLength), 0);
      this[$LENGTH] = byteLength;
    };

    $DataView = function DataView(buffer, byteOffset, byteLength) {
      anInstance(this, $DataView, DATA_VIEW);
      anInstance(buffer, $ArrayBuffer, DATA_VIEW);
      var bufferLength = buffer[$LENGTH];
      var offset = toInteger(byteOffset);
      if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
      byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
      if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
      this[$BUFFER] = buffer;
      this[$OFFSET] = offset;
      this[$LENGTH] = byteLength;
    };

    if (DESCRIPTORS) {
      addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
      addGetter($DataView, BUFFER, '_b');
      addGetter($DataView, BYTE_LENGTH, '_l');
      addGetter($DataView, BYTE_OFFSET, '_o');
    }

    redefineAll($DataView[PROTOTYPE], {
      getInt8: function getInt8(byteOffset) {
        return get(this, 1, byteOffset)[0] << 24 >> 24;
      },
      getUint8: function getUint8(byteOffset) {
        return get(this, 1, byteOffset)[0];
      },
      getInt16: function getInt16(byteOffset
      /* , littleEndian */
      ) {
        var bytes = get(this, 2, byteOffset, arguments[1]);
        return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
      },
      getUint16: function getUint16(byteOffset
      /* , littleEndian */
      ) {
        var bytes = get(this, 2, byteOffset, arguments[1]);
        return bytes[1] << 8 | bytes[0];
      },
      getInt32: function getInt32(byteOffset
      /* , littleEndian */
      ) {
        return unpackI32(get(this, 4, byteOffset, arguments[1]));
      },
      getUint32: function getUint32(byteOffset
      /* , littleEndian */
      ) {
        return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
      },
      getFloat32: function getFloat32(byteOffset
      /* , littleEndian */
      ) {
        return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
      },
      getFloat64: function getFloat64(byteOffset
      /* , littleEndian */
      ) {
        return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
      },
      setInt8: function setInt8(byteOffset, value) {
        set(this, 1, byteOffset, packI8, value);
      },
      setUint8: function setUint8(byteOffset, value) {
        set(this, 1, byteOffset, packI8, value);
      },
      setInt16: function setInt16(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 2, byteOffset, packI16, value, arguments[2]);
      },
      setUint16: function setUint16(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 2, byteOffset, packI16, value, arguments[2]);
      },
      setInt32: function setInt32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packI32, value, arguments[2]);
      },
      setUint32: function setUint32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packI32, value, arguments[2]);
      },
      setFloat32: function setFloat32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packF32, value, arguments[2]);
      },
      setFloat64: function setFloat64(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 8, byteOffset, packF64, value, arguments[2]);
      }
    });
  } else {
    if (!fails(function () {
      $ArrayBuffer(1);
    }) || !fails(function () {
      new $ArrayBuffer(-1); // eslint-disable-line no-new
    }) || fails(function () {
      new $ArrayBuffer(); // eslint-disable-line no-new

      new $ArrayBuffer(1.5); // eslint-disable-line no-new

      new $ArrayBuffer(NaN); // eslint-disable-line no-new

      return $ArrayBuffer.name != ARRAY_BUFFER;
    })) {
      $ArrayBuffer = function ArrayBuffer(length) {
        anInstance(this, $ArrayBuffer);
        return new BaseBuffer(toIndex(length));
      };

      var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];

      for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
        if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
      }

      if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
    } // iOS Safari 7.x bug


    var view = new $DataView(new $ArrayBuffer(2));
    var $setInt8 = $DataView[PROTOTYPE].setInt8;
    view.setInt8(0, 2147483648);
    view.setInt8(1, 2147483649);
    if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
      setInt8: function setInt8(byteOffset, value) {
        $setInt8.call(this, byteOffset, value << 24 >> 24);
      },
      setUint8: function setUint8(byteOffset, value) {
        $setInt8.call(this, byteOffset, value << 24 >> 24);
      }
    }, true);
  }

  setToStringTag($ArrayBuffer, ARRAY_BUFFER);
  setToStringTag($DataView, DATA_VIEW);
  hide($DataView[PROTOTYPE], $typed.VIEW, true);
  exports[ARRAY_BUFFER] = $ArrayBuffer;
  exports[DATA_VIEW] = $DataView;
  /***/
},
/* 132 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(3);

  var navigator = global.navigator;
  module.exports = navigator && navigator.userAgent || '';
  /***/
},
/* 133 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(3);

  var core = __webpack_require__(32);

  var LIBRARY = __webpack_require__(51);

  var wksExt = __webpack_require__(192);

  var defineProperty = __webpack_require__(12).f;

  module.exports = function (name) {
    var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
      value: wksExt.f(name)
    });
  };
  /***/

},
/* 134 */

/***/
function (module, exports, __webpack_require__) {
  var classof = __webpack_require__(75);

  var ITERATOR = __webpack_require__(9)('iterator');

  var Iterators = __webpack_require__(64);

  module.exports = __webpack_require__(32).getIteratorMethod = function (it) {
    if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
  };
  /***/

},
/* 135 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var addToUnscopables = __webpack_require__(44);

  var step = __webpack_require__(176);

  var Iterators = __webpack_require__(64);

  var toIObject = __webpack_require__(26); // 22.1.3.4 Array.prototype.entries()
  // 22.1.3.13 Array.prototype.keys()
  // 22.1.3.29 Array.prototype.values()
  // 22.1.3.30 Array.prototype[@@iterator]()


  module.exports = __webpack_require__(119)(Array, 'Array', function (iterated, kind) {
    this._t = toIObject(iterated); // target

    this._i = 0; // next index

    this._k = kind; // kind
    // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;

    if (!O || index >= O.length) {
      this._t = undefined;
      return step(1);
    }

    if (kind == 'keys') return step(0, index);
    if (kind == 'values') return step(0, O[index]);
    return step(0, [index, O[index]]);
  }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

  Iterators.Arguments = Iterators.Array;
  addToUnscopables('keys');
  addToUnscopables('values');
  addToUnscopables('entries');
  /***/
},
/* 136 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var Base = C_lib.Base;
      var C_enc = C.enc;
      var Utf8 = C_enc.Utf8;
      var C_algo = C.algo;
      /**
       * HMAC algorithm.
       */

      var HMAC = C_algo.HMAC = Base.extend({
        /**
         * Initializes a newly created HMAC.
         *
         * @param {Hasher} hasher The hash algorithm to use.
         * @param {WordArray|string} key The secret key.
         *
         * @example
         *
         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
         */
        init: function init(hasher, key) {
          // Init hasher
          hasher = this._hasher = new hasher.init(); // Convert string to WordArray, else assume WordArray already

          if (typeof key == 'string') {
            key = Utf8.parse(key);
          } // Shortcuts


          var hasherBlockSize = hasher.blockSize;
          var hasherBlockSizeBytes = hasherBlockSize * 4; // Allow arbitrary length keys

          if (key.sigBytes > hasherBlockSizeBytes) {
            key = hasher.finalize(key);
          } // Clamp excess bits


          key.clamp(); // Clone key for inner and outer pads

          var oKey = this._oKey = key.clone();
          var iKey = this._iKey = key.clone(); // Shortcuts

          var oKeyWords = oKey.words;
          var iKeyWords = iKey.words; // XOR keys with pad constants

          for (var i = 0; i < hasherBlockSize; i++) {
            oKeyWords[i] ^= 0x5c5c5c5c;
            iKeyWords[i] ^= 0x36363636;
          }

          oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes; // Set initial values

          this.reset();
        },

        /**
         * Resets this HMAC to its initial state.
         *
         * @example
         *
         *     hmacHasher.reset();
         */
        reset: function reset() {
          // Shortcut
          var hasher = this._hasher; // Reset

          hasher.reset();
          hasher.update(this._iKey);
        },

        /**
         * Updates this HMAC with a message.
         *
         * @param {WordArray|string} messageUpdate The message to append.
         *
         * @return {HMAC} This HMAC instance.
         *
         * @example
         *
         *     hmacHasher.update('message');
         *     hmacHasher.update(wordArray);
         */
        update: function update(messageUpdate) {
          this._hasher.update(messageUpdate); // Chainable


          return this;
        },

        /**
         * Finalizes the HMAC computation.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} messageUpdate (Optional) A final message update.
         *
         * @return {WordArray} The HMAC.
         *
         * @example
         *
         *     var hmac = hmacHasher.finalize();
         *     var hmac = hmacHasher.finalize('message');
         *     var hmac = hmacHasher.finalize(wordArray);
         */
        finalize: function finalize(messageUpdate) {
          // Shortcut
          var hasher = this._hasher; // Compute HMAC

          var innerHash = hasher.finalize(messageUpdate);
          hasher.reset();
          var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
          return hmac;
        }
      });
    })();
  });
  /***/

},
/* 137 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var Hasher = C_lib.Hasher;
      var C_algo = C.algo; // Reusable object

      var W = [];
      /**
       * SHA-1 hash algorithm.
       */

      var SHA1 = C_algo.SHA1 = Hasher.extend({
        _doReset: function _doReset() {
          this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0]);
        },
        _doProcessBlock: function _doProcessBlock(M, offset) {
          // Shortcut
          var H = this._hash.words; // Working variables

          var a = H[0];
          var b = H[1];
          var c = H[2];
          var d = H[3];
          var e = H[4]; // Computation

          for (var i = 0; i < 80; i++) {
            if (i < 16) {
              W[i] = M[offset + i] | 0;
            } else {
              var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
              W[i] = n << 1 | n >>> 31;
            }

            var t = (a << 5 | a >>> 27) + e + W[i];

            if (i < 20) {
              t += (b & c | ~b & d) + 0x5a827999;
            } else if (i < 40) {
              t += (b ^ c ^ d) + 0x6ed9eba1;
            } else if (i < 60) {
              t += (b & c | b & d | c & d) - 0x70e44324;
            } else
              /* if (i < 80) */
              {
                t += (b ^ c ^ d) - 0x359d3e2a;
              }

            e = d;
            d = c;
            c = b << 30 | b >>> 2;
            b = a;
            a = t;
          } // Intermediate hash value


          H[0] = H[0] + a | 0;
          H[1] = H[1] + b | 0;
          H[2] = H[2] + c | 0;
          H[3] = H[3] + d | 0;
          H[4] = H[4] + e | 0;
        },
        _doFinalize: function _doFinalize() {
          // Shortcuts
          var data = this._data;
          var dataWords = data.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data.sigBytes * 8; // Add padding

          dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
          data.sigBytes = dataWords.length * 4; // Hash final blocks

          this._process(); // Return final computed hash


          return this._hash;
        },
        clone: function clone() {
          var clone = Hasher.clone.call(this);
          clone._hash = this._hash.clone();
          return clone;
        }
      });
      /**
       * Shortcut function to the hasher's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       *
       * @return {WordArray} The hash.
       *
       * @static
       *
       * @example
       *
       *     var hash = CryptoJS.SHA1('message');
       *     var hash = CryptoJS.SHA1(wordArray);
       */

      C.SHA1 = Hasher._createHelper(SHA1);
      /**
       * Shortcut function to the HMAC's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       * @param {WordArray|string} key The secret key.
       *
       * @return {WordArray} The HMAC.
       *
       * @static
       *
       * @example
       *
       *     var hmac = CryptoJS.HmacSHA1(message, key);
       */

      C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();

    return CryptoJS.SHA1;
  });
  /***/

},
/* 138 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process, global) {
    /*!
    * @overview es6-promise - a tiny implementation of Promises/A+.
    * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
    * @license   Licensed under MIT license
    *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
    * @version   v4.2.5+7f2b526d
    */
    (function (global, factory) {
      true ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.ES6Promise = factory();
    })(this, function () {
      'use strict';

      function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === 'object' || type === 'function');
      }

      function isFunction(x) {
        return typeof x === 'function';
      }

      var _isArray = void 0;

      if (Array.isArray) {
        _isArray = Array.isArray;
      } else {
        _isArray = function _isArray(x) {
          return Object.prototype.toString.call(x) === '[object Array]';
        };
      }

      var isArray = _isArray;
      var len = 0;
      var vertxNext = void 0;
      var customSchedulerFn = void 0;

      var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;

        if (len === 2) {
          // If len is 2, that means that we need to schedule an async flush.
          // If additional callbacks are queued before the queue is flushed, they
          // will be processed by this flush that we are scheduling.
          if (customSchedulerFn) {
            customSchedulerFn(flush);
          } else {
            scheduleFlush();
          }
        }
      };

      function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
      }

      function setAsap(asapFn) {
        asap = asapFn;
      }

      var browserWindow = typeof window !== 'undefined' ? window : undefined;
      var browserGlobal = browserWindow || {};
      var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
      var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]'; // test for web worker but not in IE10

      var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined'; // node

      function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function () {
          return process.nextTick(flush);
        };
      } // vertx


      function useVertxTimer() {
        if (typeof vertxNext !== 'undefined') {
          return function () {
            vertxNext(flush);
          };
        }

        return useSetTimeout();
      }

      function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode('');
        observer.observe(node, {
          characterData: true
        });
        return function () {
          node.data = iterations = ++iterations % 2;
        };
      } // web worker


      function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function () {
          return channel.port2.postMessage(0);
        };
      }

      function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function () {
          return globalSetTimeout(flush, 1);
        };
      }

      var queue = new Array(1000);

      function flush() {
        for (var i = 0; i < len; i += 2) {
          var callback = queue[i];
          var arg = queue[i + 1];
          callback(arg);
          queue[i] = undefined;
          queue[i + 1] = undefined;
        }

        len = 0;
      }

      function attemptVertx() {
        try {
          var vertx = Function('return this')().require('vertx');

          vertxNext = vertx.runOnLoop || vertx.runOnContext;
          return useVertxTimer();
        } catch (e) {
          return useSetTimeout();
        }
      }

      var scheduleFlush = void 0; // Decide what async method to use to triggering processing of queued callbacks:

      if (isNode) {
        scheduleFlush = useNextTick();
      } else if (BrowserMutationObserver) {
        scheduleFlush = useMutationObserver();
      } else if (isWorker) {
        scheduleFlush = useMessageChannel();
      } else if (browserWindow === undefined && "function" === 'function') {
        scheduleFlush = attemptVertx();
      } else {
        scheduleFlush = useSetTimeout();
      }

      function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);

        if (child[PROMISE_ID] === undefined) {
          makePromise(child);
        }

        var _state = parent._state;

        if (_state) {
          var callback = arguments[_state - 1];
          asap(function () {
            return invokeCallback(_state, child, callback, parent._result);
          });
        } else {
          subscribe(parent, child, onFulfillment, onRejection);
        }

        return child;
      }
      /**
        `Promise.resolve` returns a promise that will become resolved with the
        passed `value`. It is shorthand for the following:
      
        ```javascript
        let promise = new Promise(function(resolve, reject){
          resolve(1);
        });
      
        promise.then(function(value){
          // value === 1
        });
        ```
      
        Instead of writing the above, your code now simply becomes the following:
      
        ```javascript
        let promise = Promise.resolve(1);
      
        promise.then(function(value){
          // value === 1
        });
        ```
      
        @method resolve
        @static
        @param {Any} value value that the returned promise will be resolved with
        Useful for tooling.
        @return {Promise} a promise that will become fulfilled with the given
        `value`
      */


      function resolve$1(object) {
        /*jshint validthis:true */
        var Constructor = this;

        if (object && typeof object === 'object' && object.constructor === Constructor) {
          return object;
        }

        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
      }

      var PROMISE_ID = Math.random().toString(36).substring(2);

      function noop() {}

      var PENDING = void 0;
      var FULFILLED = 1;
      var REJECTED = 2;
      var TRY_CATCH_ERROR = {
        error: null
      };

      function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
      }

      function cannotReturnOwn() {
        return new TypeError('A promises callback cannot return that same promise.');
      }

      function getThen(promise) {
        try {
          return promise.then;
        } catch (error) {
          TRY_CATCH_ERROR.error = error;
          return TRY_CATCH_ERROR;
        }
      }

      function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
          then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
          return e;
        }
      }

      function handleForeignThenable(promise, thenable, then$$1) {
        asap(function (promise) {
          var sealed = false;
          var error = tryThen(then$$1, thenable, function (value) {
            if (sealed) {
              return;
            }

            sealed = true;

            if (thenable !== value) {
              resolve(promise, value);
            } else {
              fulfill(promise, value);
            }
          }, function (reason) {
            if (sealed) {
              return;
            }

            sealed = true;
            reject(promise, reason);
          }, 'Settle: ' + (promise._label || ' unknown promise'));

          if (!sealed && error) {
            sealed = true;
            reject(promise, error);
          }
        }, promise);
      }

      function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) {
          fulfill(promise, thenable._result);
        } else if (thenable._state === REJECTED) {
          reject(promise, thenable._result);
        } else {
          subscribe(thenable, undefined, function (value) {
            return resolve(promise, value);
          }, function (reason) {
            return reject(promise, reason);
          });
        }
      }

      function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
          handleOwnThenable(promise, maybeThenable);
        } else {
          if (then$$1 === TRY_CATCH_ERROR) {
            reject(promise, TRY_CATCH_ERROR.error);
            TRY_CATCH_ERROR.error = null;
          } else if (then$$1 === undefined) {
            fulfill(promise, maybeThenable);
          } else if (isFunction(then$$1)) {
            handleForeignThenable(promise, maybeThenable, then$$1);
          } else {
            fulfill(promise, maybeThenable);
          }
        }
      }

      function resolve(promise, value) {
        if (promise === value) {
          reject(promise, selfFulfillment());
        } else if (objectOrFunction(value)) {
          handleMaybeThenable(promise, value, getThen(value));
        } else {
          fulfill(promise, value);
        }
      }

      function publishRejection(promise) {
        if (promise._onerror) {
          promise._onerror(promise._result);
        }

        publish(promise);
      }

      function fulfill(promise, value) {
        if (promise._state !== PENDING) {
          return;
        }

        promise._result = value;
        promise._state = FULFILLED;

        if (promise._subscribers.length !== 0) {
          asap(publish, promise);
        }
      }

      function reject(promise, reason) {
        if (promise._state !== PENDING) {
          return;
        }

        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
      }

      function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;

        if (length === 0 && parent._state) {
          asap(publish, parent);
        }
      }

      function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;

        if (subscribers.length === 0) {
          return;
        }

        var child = void 0,
            callback = void 0,
            detail = promise._result;

        for (var i = 0; i < subscribers.length; i += 3) {
          child = subscribers[i];
          callback = subscribers[i + settled];

          if (child) {
            invokeCallback(settled, child, callback, detail);
          } else {
            callback(detail);
          }
        }

        promise._subscribers.length = 0;
      }

      function tryCatch(callback, detail) {
        try {
          return callback(detail);
        } catch (e) {
          TRY_CATCH_ERROR.error = e;
          return TRY_CATCH_ERROR;
        }
      }

      function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback),
            value = void 0,
            error = void 0,
            succeeded = void 0,
            failed = void 0;

        if (hasCallback) {
          value = tryCatch(callback, detail);

          if (value === TRY_CATCH_ERROR) {
            failed = true;
            error = value.error;
            value.error = null;
          } else {
            succeeded = true;
          }

          if (promise === value) {
            reject(promise, cannotReturnOwn());
            return;
          }
        } else {
          value = detail;
          succeeded = true;
        }

        if (promise._state !== PENDING) {// noop
        } else if (hasCallback && succeeded) {
          resolve(promise, value);
        } else if (failed) {
          reject(promise, error);
        } else if (settled === FULFILLED) {
          fulfill(promise, value);
        } else if (settled === REJECTED) {
          reject(promise, value);
        }
      }

      function initializePromise(promise, resolver) {
        try {
          resolver(function resolvePromise(value) {
            resolve(promise, value);
          }, function rejectPromise(reason) {
            reject(promise, reason);
          });
        } catch (e) {
          reject(promise, e);
        }
      }

      var id = 0;

      function nextId() {
        return id++;
      }

      function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
      }

      function validationError() {
        return new Error('Array Methods must be provided an Array');
      }

      var Enumerator = function () {
        function Enumerator(Constructor, input) {
          this._instanceConstructor = Constructor;
          this.promise = new Constructor(noop);

          if (!this.promise[PROMISE_ID]) {
            makePromise(this.promise);
          }

          if (isArray(input)) {
            this.length = input.length;
            this._remaining = input.length;
            this._result = new Array(this.length);

            if (this.length === 0) {
              fulfill(this.promise, this._result);
            } else {
              this.length = this.length || 0;

              this._enumerate(input);

              if (this._remaining === 0) {
                fulfill(this.promise, this._result);
              }
            }
          } else {
            reject(this.promise, validationError());
          }
        }

        Enumerator.prototype._enumerate = function _enumerate(input) {
          for (var i = 0; this._state === PENDING && i < input.length; i++) {
            this._eachEntry(input[i], i);
          }
        };

        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
          var c = this._instanceConstructor;
          var resolve$$1 = c.resolve;

          if (resolve$$1 === resolve$1) {
            var _then = getThen(entry);

            if (_then === then && entry._state !== PENDING) {
              this._settledAt(entry._state, i, entry._result);
            } else if (typeof _then !== 'function') {
              this._remaining--;
              this._result[i] = entry;
            } else if (c === Promise$1) {
              var promise = new c(noop);
              handleMaybeThenable(promise, entry, _then);

              this._willSettleAt(promise, i);
            } else {
              this._willSettleAt(new c(function (resolve$$1) {
                return resolve$$1(entry);
              }), i);
            }
          } else {
            this._willSettleAt(resolve$$1(entry), i);
          }
        };

        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
          var promise = this.promise;

          if (promise._state === PENDING) {
            this._remaining--;

            if (state === REJECTED) {
              reject(promise, value);
            } else {
              this._result[i] = value;
            }
          }

          if (this._remaining === 0) {
            fulfill(promise, this._result);
          }
        };

        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
          var enumerator = this;
          subscribe(promise, undefined, function (value) {
            return enumerator._settledAt(FULFILLED, i, value);
          }, function (reason) {
            return enumerator._settledAt(REJECTED, i, reason);
          });
        };

        return Enumerator;
      }();
      /**
        `Promise.all` accepts an array of promises, and returns a new promise which
        is fulfilled with an array of fulfillment values for the passed promises, or
        rejected with the reason of the first passed promise to be rejected. It casts all
        elements of the passed iterable to promises as it runs this algorithm.
      
        Example:
      
        ```javascript
        let promise1 = resolve(1);
        let promise2 = resolve(2);
        let promise3 = resolve(3);
        let promises = [ promise1, promise2, promise3 ];
      
        Promise.all(promises).then(function(array){
          // The array here would be [ 1, 2, 3 ];
        });
        ```
      
        If any of the `promises` given to `all` are rejected, the first promise
        that is rejected will be given as an argument to the returned promises's
        rejection handler. For example:
      
        Example:
      
        ```javascript
        let promise1 = resolve(1);
        let promise2 = reject(new Error("2"));
        let promise3 = reject(new Error("3"));
        let promises = [ promise1, promise2, promise3 ];
      
        Promise.all(promises).then(function(array){
          // Code here never runs because there are rejected promises!
        }, function(error) {
          // error.message === "2"
        });
        ```
      
        @method all
        @static
        @param {Array} entries array of promises
        @param {String} label optional string for labeling the promise.
        Useful for tooling.
        @return {Promise} promise that is fulfilled when all `promises` have been
        fulfilled, or rejected if any of them become rejected.
        @static
      */


      function all(entries) {
        return new Enumerator(this, entries).promise;
      }
      /**
        `Promise.race` returns a new promise which is settled in the same way as the
        first passed promise to settle.
      
        Example:
      
        ```javascript
        let promise1 = new Promise(function(resolve, reject){
          setTimeout(function(){
            resolve('promise 1');
          }, 200);
        });
      
        let promise2 = new Promise(function(resolve, reject){
          setTimeout(function(){
            resolve('promise 2');
          }, 100);
        });
      
        Promise.race([promise1, promise2]).then(function(result){
          // result === 'promise 2' because it was resolved before promise1
          // was resolved.
        });
        ```
      
        `Promise.race` is deterministic in that only the state of the first
        settled promise matters. For example, even if other promises given to the
        `promises` array argument are resolved, but the first settled promise has
        become rejected before the other promises became fulfilled, the returned
        promise will become rejected:
      
        ```javascript
        let promise1 = new Promise(function(resolve, reject){
          setTimeout(function(){
            resolve('promise 1');
          }, 200);
        });
      
        let promise2 = new Promise(function(resolve, reject){
          setTimeout(function(){
            reject(new Error('promise 2'));
          }, 100);
        });
      
        Promise.race([promise1, promise2]).then(function(result){
          // Code here never runs
        }, function(reason){
          // reason.message === 'promise 2' because promise 2 became rejected before
          // promise 1 became fulfilled
        });
        ```
      
        An example real-world use case is implementing timeouts:
      
        ```javascript
        Promise.race([ajax('foo.json'), timeout(5000)])
        ```
      
        @method race
        @static
        @param {Array} promises array of promises to observe
        Useful for tooling.
        @return {Promise} a promise which settles in the same way as the first passed
        promise to settle.
      */


      function race(entries) {
        /*jshint validthis:true */
        var Constructor = this;

        if (!isArray(entries)) {
          return new Constructor(function (_, reject) {
            return reject(new TypeError('You must pass an array to race.'));
          });
        } else {
          return new Constructor(function (resolve, reject) {
            var length = entries.length;

            for (var i = 0; i < length; i++) {
              Constructor.resolve(entries[i]).then(resolve, reject);
            }
          });
        }
      }
      /**
        `Promise.reject` returns a promise rejected with the passed `reason`.
        It is shorthand for the following:
      
        ```javascript
        let promise = new Promise(function(resolve, reject){
          reject(new Error('WHOOPS'));
        });
      
        promise.then(function(value){
          // Code here doesn't run because the promise is rejected!
        }, function(reason){
          // reason.message === 'WHOOPS'
        });
        ```
      
        Instead of writing the above, your code now simply becomes the following:
      
        ```javascript
        let promise = Promise.reject(new Error('WHOOPS'));
      
        promise.then(function(value){
          // Code here doesn't run because the promise is rejected!
        }, function(reason){
          // reason.message === 'WHOOPS'
        });
        ```
      
        @method reject
        @static
        @param {Any} reason value that the returned promise will be rejected with.
        Useful for tooling.
        @return {Promise} a promise rejected with the given `reason`.
      */


      function reject$1(reason) {
        /*jshint validthis:true */
        var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
      }

      function needsResolver() {
        throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
      }

      function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
      }
      /**
        Promise objects represent the eventual result of an asynchronous operation. The
        primary way of interacting with a promise is through its `then` method, which
        registers callbacks to receive either a promise's eventual value or the reason
        why the promise cannot be fulfilled.
      
        Terminology
        -----------
      
        - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
        - `thenable` is an object or function that defines a `then` method.
        - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
        - `exception` is a value that is thrown using the throw statement.
        - `reason` is a value that indicates why a promise was rejected.
        - `settled` the final resting state of a promise, fulfilled or rejected.
      
        A promise can be in one of three states: pending, fulfilled, or rejected.
      
        Promises that are fulfilled have a fulfillment value and are in the fulfilled
        state.  Promises that are rejected have a rejection reason and are in the
        rejected state.  A fulfillment value is never a thenable.
      
        Promises can also be said to *resolve* a value.  If this value is also a
        promise, then the original promise's settled state will match the value's
        settled state.  So a promise that *resolves* a promise that rejects will
        itself reject, and a promise that *resolves* a promise that fulfills will
        itself fulfill.
      
      
        Basic Usage:
        ------------
      
        ```js
        let promise = new Promise(function(resolve, reject) {
          // on success
          resolve(value);
      
          // on failure
          reject(reason);
        });
      
        promise.then(function(value) {
          // on fulfillment
        }, function(reason) {
          // on rejection
        });
        ```
      
        Advanced Usage:
        ---------------
      
        Promises shine when abstracting away asynchronous interactions such as
        `XMLHttpRequest`s.
      
        ```js
        function getJSON(url) {
          return new Promise(function(resolve, reject){
            let xhr = new XMLHttpRequest();
      
            xhr.open('GET', url);
            xhr.onreadystatechange = handler;
            xhr.responseType = 'json';
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.send();
      
            function handler() {
              if (this.readyState === this.DONE) {
                if (this.status === 200) {
                  resolve(this.response);
                } else {
                  reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
                }
              }
            };
          });
        }
      
        getJSON('/posts.json').then(function(json) {
          // on fulfillment
        }, function(reason) {
          // on rejection
        });
        ```
      
        Unlike callbacks, promises are great composable primitives.
      
        ```js
        Promise.all([
          getJSON('/posts'),
          getJSON('/comments')
        ]).then(function(values){
          values[0] // => postsJSON
          values[1] // => commentsJSON
      
          return values;
        });
        ```
      
        @class Promise
        @param {Function} resolver
        Useful for tooling.
        @constructor
      */


      var Promise$1 = function () {
        function Promise(resolver) {
          this[PROMISE_ID] = nextId();
          this._result = this._state = undefined;
          this._subscribers = [];

          if (noop !== resolver) {
            typeof resolver !== 'function' && needsResolver();
            this instanceof Promise ? initializePromise(this, resolver) : needsNew();
          }
        }
        /**
        The primary way of interacting with a promise is through its `then` method,
        which registers callbacks to receive either a promise's eventual value or the
        reason why the promise cannot be fulfilled.
         ```js
        findUser().then(function(user){
          // user is available
        }, function(reason){
          // user is unavailable, and you are given the reason why
        });
        ```
         Chaining
        --------
         The return value of `then` is itself a promise.  This second, 'downstream'
        promise is resolved with the return value of the first promise's fulfillment
        or rejection handler, or rejected if the handler throws an exception.
         ```js
        findUser().then(function (user) {
          return user.name;
        }, function (reason) {
          return 'default name';
        }).then(function (userName) {
          // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
          // will be `'default name'`
        });
         findUser().then(function (user) {
          throw new Error('Found user, but still unhappy');
        }, function (reason) {
          throw new Error('`findUser` rejected and we're unhappy');
        }).then(function (value) {
          // never reached
        }, function (reason) {
          // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
          // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
        });
        ```
        If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
         ```js
        findUser().then(function (user) {
          throw new PedagogicalException('Upstream error');
        }).then(function (value) {
          // never reached
        }).then(function (value) {
          // never reached
        }, function (reason) {
          // The `PedgagocialException` is propagated all the way down to here
        });
        ```
         Assimilation
        ------------
         Sometimes the value you want to propagate to a downstream promise can only be
        retrieved asynchronously. This can be achieved by returning a promise in the
        fulfillment or rejection handler. The downstream promise will then be pending
        until the returned promise is settled. This is called *assimilation*.
         ```js
        findUser().then(function (user) {
          return findCommentsByAuthor(user);
        }).then(function (comments) {
          // The user's comments are now available
        });
        ```
         If the assimliated promise rejects, then the downstream promise will also reject.
         ```js
        findUser().then(function (user) {
          return findCommentsByAuthor(user);
        }).then(function (comments) {
          // If `findCommentsByAuthor` fulfills, we'll have the value here
        }, function (reason) {
          // If `findCommentsByAuthor` rejects, we'll have the reason here
        });
        ```
         Simple Example
        --------------
         Synchronous Example
         ```javascript
        let result;
         try {
          result = findResult();
          // success
        } catch(reason) {
          // failure
        }
        ```
         Errback Example
         ```js
        findResult(function(result, err){
          if (err) {
            // failure
          } else {
            // success
          }
        });
        ```
         Promise Example;
         ```javascript
        findResult().then(function(result){
          // success
        }, function(reason){
          // failure
        });
        ```
         Advanced Example
        --------------
         Synchronous Example
         ```javascript
        let author, books;
         try {
          author = findAuthor();
          books  = findBooksByAuthor(author);
          // success
        } catch(reason) {
          // failure
        }
        ```
         Errback Example
         ```js
         function foundBooks(books) {
         }
         function failure(reason) {
         }
         findAuthor(function(author, err){
          if (err) {
            failure(err);
            // failure
          } else {
            try {
              findBoooksByAuthor(author, function(books, err) {
                if (err) {
                  failure(err);
                } else {
                  try {
                    foundBooks(books);
                  } catch(reason) {
                    failure(reason);
                  }
                }
              });
            } catch(error) {
              failure(err);
            }
            // success
          }
        });
        ```
         Promise Example;
         ```javascript
        findAuthor().
          then(findBooksByAuthor).
          then(function(books){
            // found books
        }).catch(function(reason){
          // something went wrong
        });
        ```
         @method then
        @param {Function} onFulfilled
        @param {Function} onRejected
        Useful for tooling.
        @return {Promise}
        */

        /**
        `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
        as the catch block of a try/catch statement.
        ```js
        function findAuthor(){
        throw new Error('couldn't find that author');
        }
        // synchronous
        try {
        findAuthor();
        } catch(reason) {
        // something went wrong
        }
        // async with promises
        findAuthor().catch(function(reason){
        // something went wrong
        });
        ```
        @method catch
        @param {Function} onRejection
        Useful for tooling.
        @return {Promise}
        */


        Promise.prototype.catch = function _catch(onRejection) {
          return this.then(null, onRejection);
        };
        /**
          `finally` will be invoked regardless of the promise's fate just as native
          try/catch/finally behaves
        
          Synchronous example:
        
          ```js
          findAuthor() {
            if (Math.random() > 0.5) {
              throw new Error();
            }
            return new Author();
          }
        
          try {
            return findAuthor(); // succeed or fail
          } catch(error) {
            return findOtherAuther();
          } finally {
            // always runs
            // doesn't affect the return value
          }
          ```
        
          Asynchronous example:
        
          ```js
          findAuthor().catch(function(reason){
            return findOtherAuther();
          }).finally(function(){
            // author was either found, or not
          });
          ```
        
          @method finally
          @param {Function} callback
          @return {Promise}
        */


        Promise.prototype.finally = function _finally(callback) {
          var promise = this;
          var constructor = promise.constructor;

          if (isFunction(callback)) {
            return promise.then(function (value) {
              return constructor.resolve(callback()).then(function () {
                return value;
              });
            }, function (reason) {
              return constructor.resolve(callback()).then(function () {
                throw reason;
              });
            });
          }

          return promise.then(callback, callback);
        };

        return Promise;
      }();

      Promise$1.prototype.then = then;
      Promise$1.all = all;
      Promise$1.race = race;
      Promise$1.resolve = resolve$1;
      Promise$1.reject = reject$1;
      Promise$1._setScheduler = setScheduler;
      Promise$1._setAsap = setAsap;
      Promise$1._asap = asap;
      /*global self*/

      function polyfill() {
        var local = void 0;

        if (typeof global !== 'undefined') {
          local = global;
        } else if (typeof self !== 'undefined') {
          local = self;
        } else {
          try {
            local = Function('return this')();
          } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
          }
        }

        var P = local.Promise;

        if (P) {
          var promiseToString = null;

          try {
            promiseToString = Object.prototype.toString.call(P.resolve());
          } catch (e) {// silently ignored
          }

          if (promiseToString === '[object Promise]' && !P.cast) {
            return;
          }
        }

        local.Promise = Promise$1;
      } // Strange compat..


      Promise$1.polyfill = polyfill;
      Promise$1.Promise = Promise$1;
      return Promise$1;
    });
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(16), __webpack_require__(10));
  /***/
},
/* 139 */

/***/
function (module, exports, __webpack_require__) {
  var root = __webpack_require__(212);
  /** Built-in value references. */


  var Symbol = root.Symbol;
  module.exports = Symbol;
  /***/
},
/* 140 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;
  module.exports = isArray;
  /***/
},
/* 141 */

/***/
function (module, exports) {
  module.exports = Long;
  /**
   * wasm optimizations, to do native i64 multiplication and divide
   */

  var wasm = null;

  try {
    wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11])), {}).exports;
  } catch (e) {} // no wasm support :(

  /**
   * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
   *  See the from* functions below for more convenient ways of constructing Longs.
   * @exports Long
   * @class A Long class for representing a 64 bit two's-complement integer value.
   * @param {number} low The low (signed) 32 bits of the long
   * @param {number} high The high (signed) 32 bits of the long
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @constructor
   */


  function Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */
    this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */

    this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */

    this.unsigned = !!unsigned;
  } // The internal representation of a long is the two given signed, 32-bit values.
  // We use 32-bit pieces because these are the size of integers on which
  // Javascript performs bit-operations.  For operations like addition and
  // multiplication, we split each number into 16 bit pieces, which can easily be
  // multiplied within Javascript's floating-point representation without overflow
  // or change in sign.
  //
  // In the algorithms below, we frequently reduce the negative case to the
  // positive case by negating the input(s) and then post-processing the result.
  // Note that we must ALWAYS check specially whether those values are MIN_VALUE
  // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
  // a positive number, it overflows back into a negative).  Not handling this
  // case would often result in infinite recursion.
  //
  // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
  // methods on which they depend.

  /**
   * An indicator used to reliably determine if an object is a Long or not.
   * @type {boolean}
   * @const
   * @private
   */


  Long.prototype.__isLong__;
  Object.defineProperty(Long.prototype, "__isLong__", {
    value: true
  });
  /**
   * @function
   * @param {*} obj Object
   * @returns {boolean}
   * @inner
   */

  function isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
  }
  /**
   * Tests if the specified object is a Long.
   * @function
   * @param {*} obj Object
   * @returns {boolean}
   */


  Long.isLong = isLong;
  /**
   * A cache of the Long representations of small integer values.
   * @type {!Object}
   * @inner
   */

  var INT_CACHE = {};
  /**
   * A cache of the Long representations of small unsigned integer values.
   * @type {!Object}
   * @inner
   */

  var UINT_CACHE = {};
  /**
   * @param {number} value
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */

  function fromInt(value, unsigned) {
    var obj, cachedObj, cache;

    if (unsigned) {
      value >>>= 0;

      if (cache = 0 <= value && value < 256) {
        cachedObj = UINT_CACHE[value];
        if (cachedObj) return cachedObj;
      }

      obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
      if (cache) UINT_CACHE[value] = obj;
      return obj;
    } else {
      value |= 0;

      if (cache = -128 <= value && value < 128) {
        cachedObj = INT_CACHE[value];
        if (cachedObj) return cachedObj;
      }

      obj = fromBits(value, value < 0 ? -1 : 0, false);
      if (cache) INT_CACHE[value] = obj;
      return obj;
    }
  }
  /**
   * Returns a Long representing the given 32 bit integer value.
   * @function
   * @param {number} value The 32 bit integer in question
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */


  Long.fromInt = fromInt;
  /**
   * @param {number} value
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */

  function fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? UZERO : ZERO;

    if (unsigned) {
      if (value < 0) return UZERO;
      if (value >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
    } else {
      if (value <= -TWO_PWR_63_DBL) return MIN_VALUE;
      if (value + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
    }

    if (value < 0) return fromNumber(-value, unsigned).neg();
    return fromBits(value % TWO_PWR_32_DBL | 0, value / TWO_PWR_32_DBL | 0, unsigned);
  }
  /**
   * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
   * @function
   * @param {number} value The number in question
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */


  Long.fromNumber = fromNumber;
  /**
   * @param {number} lowBits
   * @param {number} highBits
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */

  function fromBits(lowBits, highBits, unsigned) {
    return new Long(lowBits, highBits, unsigned);
  }
  /**
   * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
   *  assumed to use 32 bits.
   * @function
   * @param {number} lowBits The low 32 bits
   * @param {number} highBits The high 32 bits
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */


  Long.fromBits = fromBits;
  /**
   * @function
   * @param {number} base
   * @param {number} exponent
   * @returns {number}
   * @inner
   */

  var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)

  /**
   * @param {string} str
   * @param {(boolean|number)=} unsigned
   * @param {number=} radix
   * @returns {!Long}
   * @inner
   */

  function fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return ZERO;

    if (typeof unsigned === 'number') {
      // For goog.math.long compatibility
      radix = unsigned, unsigned = false;
    } else {
      unsigned = !!unsigned;
    }

    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    var p;
    if ((p = str.indexOf('-')) > 0) throw Error('interior hyphen');else if (p === 0) {
      return fromString(str.substring(1), unsigned, radix).neg();
    } // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.

    var radixToPower = fromNumber(pow_dbl(radix, 8));
    var result = ZERO;

    for (var i = 0; i < str.length; i += 8) {
      var size = Math.min(8, str.length - i),
          value = parseInt(str.substring(i, i + size), radix);

      if (size < 8) {
        var power = fromNumber(pow_dbl(radix, size));
        result = result.mul(power).add(fromNumber(value));
      } else {
        result = result.mul(radixToPower);
        result = result.add(fromNumber(value));
      }
    }

    result.unsigned = unsigned;
    return result;
  }
  /**
   * Returns a Long representation of the given string, written using the specified radix.
   * @function
   * @param {string} str The textual representation of the Long
   * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
   * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
   * @returns {!Long} The corresponding Long value
   */


  Long.fromString = fromString;
  /**
   * @function
   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */

  function fromValue(val, unsigned) {
    if (typeof val === 'number') return fromNumber(val, unsigned);
    if (typeof val === 'string') return fromString(val, unsigned); // Throws for non-objects, converts non-instanceof Long:

    return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
  }
  /**
   * Converts the specified value to a Long using the appropriate from* function for its type.
   * @function
   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long}
   */


  Long.fromValue = fromValue; // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
  // no runtime penalty for these.

  /**
   * @type {number}
   * @const
   * @inner
   */

  var TWO_PWR_16_DBL = 1 << 16;
  /**
   * @type {number}
   * @const
   * @inner
   */

  var TWO_PWR_24_DBL = 1 << 24;
  /**
   * @type {number}
   * @const
   * @inner
   */

  var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
  /**
   * @type {number}
   * @const
   * @inner
   */

  var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
  /**
   * @type {number}
   * @const
   * @inner
   */

  var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
  /**
   * @type {!Long}
   * @const
   * @inner
   */

  var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
  /**
   * @type {!Long}
   * @inner
   */

  var ZERO = fromInt(0);
  /**
   * Signed zero.
   * @type {!Long}
   */

  Long.ZERO = ZERO;
  /**
   * @type {!Long}
   * @inner
   */

  var UZERO = fromInt(0, true);
  /**
   * Unsigned zero.
   * @type {!Long}
   */

  Long.UZERO = UZERO;
  /**
   * @type {!Long}
   * @inner
   */

  var ONE = fromInt(1);
  /**
   * Signed one.
   * @type {!Long}
   */

  Long.ONE = ONE;
  /**
   * @type {!Long}
   * @inner
   */

  var UONE = fromInt(1, true);
  /**
   * Unsigned one.
   * @type {!Long}
   */

  Long.UONE = UONE;
  /**
   * @type {!Long}
   * @inner
   */

  var NEG_ONE = fromInt(-1);
  /**
   * Signed negative one.
   * @type {!Long}
   */

  Long.NEG_ONE = NEG_ONE;
  /**
   * @type {!Long}
   * @inner
   */

  var MAX_VALUE = fromBits(0xFFFFFFFF | 0, 0x7FFFFFFF | 0, false);
  /**
   * Maximum signed value.
   * @type {!Long}
   */

  Long.MAX_VALUE = MAX_VALUE;
  /**
   * @type {!Long}
   * @inner
   */

  var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF | 0, 0xFFFFFFFF | 0, true);
  /**
   * Maximum unsigned value.
   * @type {!Long}
   */

  Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
  /**
   * @type {!Long}
   * @inner
   */

  var MIN_VALUE = fromBits(0, 0x80000000 | 0, false);
  /**
   * Minimum signed value.
   * @type {!Long}
   */

  Long.MIN_VALUE = MIN_VALUE;
  /**
   * @alias Long.prototype
   * @inner
   */

  var LongPrototype = Long.prototype;
  /**
   * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
   * @returns {number}
   */

  LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
  };
  /**
   * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
   * @returns {number}
   */


  LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
  };
  /**
   * Converts the Long to a string written in the specified radix.
   * @param {number=} radix Radix (2-36), defaults to 10
   * @returns {string}
   * @override
   * @throws {RangeError} If `radix` is out of range
   */


  LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    if (this.isZero()) return '0';

    if (this.isNegative()) {
      // Unsigned Longs are never negative
      if (this.eq(MIN_VALUE)) {
        // We need to change the Long value before it can be negated, so we remove
        // the bottom-most digit in this base and then recurse to do the rest.
        var radixLong = fromNumber(radix),
            div = this.div(radixLong),
            rem1 = div.mul(radixLong).sub(this);
        return div.toString(radix) + rem1.toInt().toString(radix);
      } else return '-' + this.neg().toString(radix);
    } // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.


    var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
        rem = this;
    var result = '';

    while (true) {
      var remDiv = rem.div(radixToPower),
          intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
          digits = intval.toString(radix);
      rem = remDiv;
      if (rem.isZero()) return digits + result;else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }

        result = '' + digits + result;
      }
    }
  };
  /**
   * Gets the high 32 bits as a signed integer.
   * @returns {number} Signed high bits
   */


  LongPrototype.getHighBits = function getHighBits() {
    return this.high;
  };
  /**
   * Gets the high 32 bits as an unsigned integer.
   * @returns {number} Unsigned high bits
   */


  LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
  };
  /**
   * Gets the low 32 bits as a signed integer.
   * @returns {number} Signed low bits
   */


  LongPrototype.getLowBits = function getLowBits() {
    return this.low;
  };
  /**
   * Gets the low 32 bits as an unsigned integer.
   * @returns {number} Unsigned low bits
   */


  LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
  };
  /**
   * Gets the number of bits needed to represent the absolute value of this Long.
   * @returns {number}
   */


  LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) // Unsigned Longs are never negative
      return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;

    for (var bit = 31; bit > 0; bit--) {
      if ((val & 1 << bit) != 0) break;
    }

    return this.high != 0 ? bit + 33 : bit + 1;
  };
  /**
   * Tests if this Long's value equals zero.
   * @returns {boolean}
   */


  LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
  };
  /**
   * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
   * @returns {boolean}
   */


  LongPrototype.eqz = LongPrototype.isZero;
  /**
   * Tests if this Long's value is negative.
   * @returns {boolean}
   */

  LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
  };
  /**
   * Tests if this Long's value is positive.
   * @returns {boolean}
   */


  LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
  };
  /**
   * Tests if this Long's value is odd.
   * @returns {boolean}
   */


  LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
  };
  /**
   * Tests if this Long's value is even.
   * @returns {boolean}
   */


  LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
  };
  /**
   * Tests if this Long's value equals the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */


  LongPrototype.equals = function equals(other) {
    if (!isLong(other)) other = fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
  };
  /**
   * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */


  LongPrototype.eq = LongPrototype.equals;
  /**
   * Tests if this Long's value differs from the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */

  LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(
    /* validates */
    other);
  };
  /**
   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */


  LongPrototype.neq = LongPrototype.notEquals;
  /**
   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */

  LongPrototype.ne = LongPrototype.notEquals;
  /**
   * Tests if this Long's value is less than the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */

  LongPrototype.lessThan = function lessThan(other) {
    return this.comp(
    /* validates */
    other) < 0;
  };
  /**
   * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */


  LongPrototype.lt = LongPrototype.lessThan;
  /**
   * Tests if this Long's value is less than or equal the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */

  LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(
    /* validates */
    other) <= 0;
  };
  /**
   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */


  LongPrototype.lte = LongPrototype.lessThanOrEqual;
  /**
   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */

  LongPrototype.le = LongPrototype.lessThanOrEqual;
  /**
   * Tests if this Long's value is greater than the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */

  LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(
    /* validates */
    other) > 0;
  };
  /**
   * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */


  LongPrototype.gt = LongPrototype.greaterThan;
  /**
   * Tests if this Long's value is greater than or equal the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */

  LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(
    /* validates */
    other) >= 0;
  };
  /**
   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */


  LongPrototype.gte = LongPrototype.greaterThanOrEqual;
  /**
   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */

  LongPrototype.ge = LongPrototype.greaterThanOrEqual;
  /**
   * Compares this Long's value with the specified's.
   * @param {!Long|number|string} other Other value
   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
   *  if the given one is greater
   */

  LongPrototype.compare = function compare(other) {
    if (!isLong(other)) other = fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(),
        otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1; // At this point the sign bits are the same

    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1; // Both are positive if at least one is unsigned

    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
  };
  /**
   * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
   *  if the given one is greater
   */


  LongPrototype.comp = LongPrototype.compare;
  /**
   * Negates this Long's value.
   * @returns {!Long} Negated Long
   */

  LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq(MIN_VALUE)) return MIN_VALUE;
    return this.not().add(ONE);
  };
  /**
   * Negates this Long's value. This is an alias of {@link Long#negate}.
   * @function
   * @returns {!Long} Negated Long
   */


  LongPrototype.neg = LongPrototype.negate;
  /**
   * Returns the sum of this and the specified Long.
   * @param {!Long|number|string} addend Addend
   * @returns {!Long} Sum
   */

  LongPrototype.add = function add(addend) {
    if (!isLong(addend)) addend = fromValue(addend); // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0,
        c32 = 0,
        c16 = 0,
        c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
  };
  /**
   * Returns the difference of this and the specified Long.
   * @param {!Long|number|string} subtrahend Subtrahend
   * @returns {!Long} Difference
   */


  LongPrototype.subtract = function subtract(subtrahend) {
    if (!isLong(subtrahend)) subtrahend = fromValue(subtrahend);
    return this.add(subtrahend.neg());
  };
  /**
   * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
   * @function
   * @param {!Long|number|string} subtrahend Subtrahend
   * @returns {!Long} Difference
   */


  LongPrototype.sub = LongPrototype.subtract;
  /**
   * Returns the product of this and the specified Long.
   * @param {!Long|number|string} multiplier Multiplier
   * @returns {!Long} Product
   */

  LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return ZERO;
    if (!isLong(multiplier)) multiplier = fromValue(multiplier); // use wasm support if present

    if (wasm) {
      var low = wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
      return fromBits(low, wasm.get_high(), this.unsigned);
    }

    if (multiplier.isZero()) return ZERO;
    if (this.eq(MIN_VALUE)) return multiplier.isOdd() ? MIN_VALUE : ZERO;
    if (multiplier.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;

    if (this.isNegative()) {
      if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg(); // If both longs are small, use float multiplication


    if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24)) return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned); // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.

    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0,
        c32 = 0,
        c16 = 0,
        c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
  };
  /**
   * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
   * @function
   * @param {!Long|number|string} multiplier Multiplier
   * @returns {!Long} Product
   */


  LongPrototype.mul = LongPrototype.multiply;
  /**
   * Returns this Long divided by the specified. The result is signed if this Long is signed or
   *  unsigned if this Long is unsigned.
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Quotient
   */

  LongPrototype.divide = function divide(divisor) {
    if (!isLong(divisor)) divisor = fromValue(divisor);
    if (divisor.isZero()) throw Error('division by zero'); // use wasm support if present

    if (wasm) {
      // guard against signed division overflow: the largest
      // negative number / -1 would be 1 larger than the largest
      // positive number, due to two's complement.
      if (!this.unsigned && this.high === -0x80000000 && divisor.low === -1 && divisor.high === -1) {
        // be consistent with non-wasm code path
        return this;
      }

      var low = (this.unsigned ? wasm.div_u : wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
      return fromBits(low, wasm.get_high(), this.unsigned);
    }

    if (this.isZero()) return this.unsigned ? UZERO : ZERO;
    var approx, rem, res;

    if (!this.unsigned) {
      // This section is only relevant for signed longs and is derived from the
      // closure library as a whole.
      if (this.eq(MIN_VALUE)) {
        if (divisor.eq(ONE) || divisor.eq(NEG_ONE)) return MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
        else if (divisor.eq(MIN_VALUE)) return ONE;else {
            // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
            var halfThis = this.shr(1);
            approx = halfThis.div(divisor).shl(1);

            if (approx.eq(ZERO)) {
              return divisor.isNegative() ? ONE : NEG_ONE;
            } else {
              rem = this.sub(divisor.mul(approx));
              res = approx.add(rem.div(divisor));
              return res;
            }
          }
      } else if (divisor.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;

      if (this.isNegative()) {
        if (divisor.isNegative()) return this.neg().div(divisor.neg());
        return this.neg().div(divisor).neg();
      } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();

      res = ZERO;
    } else {
      // The algorithm below has not been made for unsigned longs. It's therefore
      // required to take special care of the MSB prior to running it.
      if (!divisor.unsigned) divisor = divisor.toUnsigned();
      if (divisor.gt(this)) return UZERO;
      if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
        return UONE;
      res = UZERO;
    } // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.


    rem = this;

    while (rem.gte(divisor)) {
      // Approximate the result of division. This may be a little greater or
      // smaller than the actual value.
      approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber())); // We will tweak the approximate result by changing it in the 48-th digit or
      // the smallest non-fractional digit, whichever is larger.

      var log2 = Math.ceil(Math.log(approx) / Math.LN2),
          delta = log2 <= 48 ? 1 : pow_dbl(2, log2 - 48),
          // Decrease the approximation until it is smaller than the remainder.  Note
      // that if it is too large, the product overflows and is negative.
      approxRes = fromNumber(approx),
          approxRem = approxRes.mul(divisor);

      while (approxRem.isNegative() || approxRem.gt(rem)) {
        approx -= delta;
        approxRes = fromNumber(approx, this.unsigned);
        approxRem = approxRes.mul(divisor);
      } // We know the answer can't be zero... and actually, zero would cause
      // infinite recursion since we would make no progress.


      if (approxRes.isZero()) approxRes = ONE;
      res = res.add(approxRes);
      rem = rem.sub(approxRem);
    }

    return res;
  };
  /**
   * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Quotient
   */


  LongPrototype.div = LongPrototype.divide;
  /**
   * Returns this Long modulo the specified.
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */

  LongPrototype.modulo = function modulo(divisor) {
    if (!isLong(divisor)) divisor = fromValue(divisor); // use wasm support if present

    if (wasm) {
      var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
      return fromBits(low, wasm.get_high(), this.unsigned);
    }

    return this.sub(this.div(divisor).mul(divisor));
  };
  /**
   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */


  LongPrototype.mod = LongPrototype.modulo;
  /**
   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */

  LongPrototype.rem = LongPrototype.modulo;
  /**
   * Returns the bitwise NOT of this Long.
   * @returns {!Long}
   */

  LongPrototype.not = function not() {
    return fromBits(~this.low, ~this.high, this.unsigned);
  };
  /**
   * Returns the bitwise AND of this Long and the specified.
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */


  LongPrototype.and = function and(other) {
    if (!isLong(other)) other = fromValue(other);
    return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
  };
  /**
   * Returns the bitwise OR of this Long and the specified.
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */


  LongPrototype.or = function or(other) {
    if (!isLong(other)) other = fromValue(other);
    return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
  };
  /**
   * Returns the bitwise XOR of this Long and the given one.
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */


  LongPrototype.xor = function xor(other) {
    if (!isLong(other)) other = fromValue(other);
    return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
  };
  /**
   * Returns this Long with bits shifted to the left by the given amount.
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */


  LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if (isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;else if (numBits < 32) return fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);else return fromBits(0, this.low << numBits - 32, this.unsigned);
  };
  /**
   * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */


  LongPrototype.shl = LongPrototype.shiftLeft;
  /**
   * Returns this Long with bits arithmetically shifted to the right by the given amount.
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */

  LongPrototype.shiftRight = function shiftRight(numBits) {
    if (isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;else if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);else return fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
  };
  /**
   * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */


  LongPrototype.shr = LongPrototype.shiftRight;
  /**
   * Returns this Long with bits logically shifted to the right by the given amount.
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */

  LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if (isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;else {
      var high = this.high;

      if (numBits < 32) {
        var low = this.low;
        return fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
      } else if (numBits === 32) return fromBits(high, 0, this.unsigned);else return fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
  };
  /**
   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */


  LongPrototype.shru = LongPrototype.shiftRightUnsigned;
  /**
   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */

  LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
  /**
   * Converts this Long to signed.
   * @returns {!Long} Signed long
   */

  LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return fromBits(this.low, this.high, false);
  };
  /**
   * Converts this Long to unsigned.
   * @returns {!Long} Unsigned long
   */


  LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return fromBits(this.low, this.high, true);
  };
  /**
   * Converts this Long to its byte representation.
   * @param {boolean=} le Whether little or big endian, defaults to big endian
   * @returns {!Array.<number>} Byte representation
   */


  LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
  };
  /**
   * Converts this Long to its little endian byte representation.
   * @returns {!Array.<number>} Little endian byte representation
   */


  LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high,
        lo = this.low;
    return [lo & 0xff, lo >>> 8 & 0xff, lo >>> 16 & 0xff, lo >>> 24, hi & 0xff, hi >>> 8 & 0xff, hi >>> 16 & 0xff, hi >>> 24];
  };
  /**
   * Converts this Long to its big endian byte representation.
   * @returns {!Array.<number>} Big endian byte representation
   */


  LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high,
        lo = this.low;
    return [hi >>> 24, hi >>> 16 & 0xff, hi >>> 8 & 0xff, hi & 0xff, lo >>> 24, lo >>> 16 & 0xff, lo >>> 8 & 0xff, lo & 0xff];
  };
  /**
   * Creates a Long from its byte representation.
   * @param {!Array.<number>} bytes Byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @param {boolean=} le Whether little or big endian, defaults to big endian
   * @returns {Long} The corresponding Long value
   */


  Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
  };
  /**
   * Creates a Long from its little endian byte representation.
   * @param {!Array.<number>} bytes Little endian byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {Long} The corresponding Long value
   */


  Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
  };
  /**
   * Creates a Long from its big endian byte representation.
   * @param {!Array.<number>} bytes Big endian byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {Long} The corresponding Long value
   */


  Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
  };
  /***/

},
/* 142 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var tls = __webpack_require__(607);

  function buildBuilder(mqttClient, opts) {
    var connection;
    opts.port = opts.port || 8883;
    opts.host = opts.hostname || opts.host || 'localhost';
    opts.rejectUnauthorized = opts.rejectUnauthorized !== false;
    delete opts.path;
    connection = tls.connect(opts);
    /* eslint no-use-before-define: [2, "nofunc"] */

    connection.on('secureConnect', function () {
      if (opts.rejectUnauthorized && !connection.authorized) {
        connection.emit('error', new Error('TLS not authorized'));
      } else {
        connection.removeListener('error', handleTLSerrors);
      }
    });

    function handleTLSerrors(err) {
      // How can I get verify this error is a tls error?
      if (opts.rejectUnauthorized) {
        mqttClient.emit('error', err);
      } // close this connection to match the behaviour of net
      // otherwise all we get is an error from the connection
      // and close event doesn't fire. This is a work around
      // to enable the reconnect code to work the same as with
      // net.createConnection


      connection.end();
    }

    connection.on('error', handleTLSerrors);
    return connection;
  }

  module.exports = buildBuilder;
  /***/
},
/* 143 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Cipher base API.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2014 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(8);

  module.exports = forge.cipher = forge.cipher || {}; // registered algorithms

  forge.cipher.algorithms = forge.cipher.algorithms || {};
  /**
   * Creates a cipher object that can be used to encrypt data using the given
   * algorithm and key. The algorithm may be provided as a string value for a
   * previously registered algorithm or it may be given as a cipher algorithm
   * API object.
   *
   * @param algorithm the algorithm to use, either a string or an algorithm API
   *          object.
   * @param key the key to use, as a binary-encoded string of bytes or a
   *          byte buffer.
   *
   * @return the cipher.
   */

  forge.cipher.createCipher = function (algorithm, key) {
    var api = algorithm;

    if (typeof api === 'string') {
      api = forge.cipher.getAlgorithm(api);

      if (api) {
        api = api();
      }
    }

    if (!api) {
      throw new Error('Unsupported algorithm: ' + algorithm);
    } // assume block cipher


    return new forge.cipher.BlockCipher({
      algorithm: api,
      key: key,
      decrypt: false
    });
  };
  /**
   * Creates a decipher object that can be used to decrypt data using the given
   * algorithm and key. The algorithm may be provided as a string value for a
   * previously registered algorithm or it may be given as a cipher algorithm
   * API object.
   *
   * @param algorithm the algorithm to use, either a string or an algorithm API
   *          object.
   * @param key the key to use, as a binary-encoded string of bytes or a
   *          byte buffer.
   *
   * @return the cipher.
   */


  forge.cipher.createDecipher = function (algorithm, key) {
    var api = algorithm;

    if (typeof api === 'string') {
      api = forge.cipher.getAlgorithm(api);

      if (api) {
        api = api();
      }
    }

    if (!api) {
      throw new Error('Unsupported algorithm: ' + algorithm);
    } // assume block cipher


    return new forge.cipher.BlockCipher({
      algorithm: api,
      key: key,
      decrypt: true
    });
  };
  /**
   * Registers an algorithm by name. If the name was already registered, the
   * algorithm API object will be overwritten.
   *
   * @param name the name of the algorithm.
   * @param algorithm the algorithm API object.
   */


  forge.cipher.registerAlgorithm = function (name, algorithm) {
    name = name.toUpperCase();
    forge.cipher.algorithms[name] = algorithm;
  };
  /**
   * Gets a registered algorithm by name.
   *
   * @param name the name of the algorithm.
   *
   * @return the algorithm, if found, null if not.
   */


  forge.cipher.getAlgorithm = function (name) {
    name = name.toUpperCase();

    if (name in forge.cipher.algorithms) {
      return forge.cipher.algorithms[name];
    }

    return null;
  };

  var BlockCipher = forge.cipher.BlockCipher = function (options) {
    this.algorithm = options.algorithm;
    this.mode = this.algorithm.mode;
    this.blockSize = this.mode.blockSize;
    this._finish = false;
    this._input = null;
    this.output = null;
    this._op = options.decrypt ? this.mode.decrypt : this.mode.encrypt;
    this._decrypt = options.decrypt;
    this.algorithm.initialize(options);
  };
  /**
   * Starts or restarts the encryption or decryption process, whichever
   * was previously configured.
   *
   * For non-GCM mode, the IV may be a binary-encoded string of bytes, an array
   * of bytes, a byte buffer, or an array of 32-bit integers. If the IV is in
   * bytes, then it must be Nb (16) bytes in length. If the IV is given in as
   * 32-bit integers, then it must be 4 integers long.
   *
   * Note: an IV is not required or used in ECB mode.
   *
   * For GCM-mode, the IV must be given as a binary-encoded string of bytes or
   * a byte buffer. The number of bytes should be 12 (96 bits) as recommended
   * by NIST SP-800-38D but another length may be given.
   *
   * @param options the options to use:
   *          iv the initialization vector to use as a binary-encoded string of
   *            bytes, null to reuse the last ciphered block from a previous
   *            update() (this "residue" method is for legacy support only).
   *          additionalData additional authentication data as a binary-encoded
   *            string of bytes, for 'GCM' mode, (default: none).
   *          tagLength desired length of authentication tag, in bits, for
   *            'GCM' mode (0-128, default: 128).
   *          tag the authentication tag to check if decrypting, as a
   *             binary-encoded string of bytes.
   *          output the output the buffer to write to, null to create one.
   */


  BlockCipher.prototype.start = function (options) {
    options = options || {};
    var opts = {};

    for (var key in options) {
      opts[key] = options[key];
    }

    opts.decrypt = this._decrypt;
    this._finish = false;
    this._input = forge.util.createBuffer();
    this.output = options.output || forge.util.createBuffer();
    this.mode.start(opts);
  };
  /**
   * Updates the next block according to the cipher mode.
   *
   * @param input the buffer to read from.
   */


  BlockCipher.prototype.update = function (input) {
    if (input) {
      // input given, so empty it into the input buffer
      this._input.putBuffer(input);
    } // do cipher operation until it needs more input and not finished


    while (!this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish) {} // free consumed memory from input buffer


    this._input.compact();
  };
  /**
   * Finishes encrypting or decrypting.
   *
   * @param pad a padding function to use in CBC mode, null for default,
   *          signature(blockSize, buffer, decrypt).
   *
   * @return true if successful, false on error.
   */


  BlockCipher.prototype.finish = function (pad) {
    // backwards-compatibility w/deprecated padding API
    // Note: will overwrite padding functions even after another start() call
    if (pad && (this.mode.name === 'ECB' || this.mode.name === 'CBC')) {
      this.mode.pad = function (input) {
        return pad(this.blockSize, input, false);
      };

      this.mode.unpad = function (output) {
        return pad(this.blockSize, output, true);
      };
    } // build options for padding and afterFinish functions


    var options = {};
    options.decrypt = this._decrypt; // get # of bytes that won't fill a block

    options.overflow = this._input.length() % this.blockSize;

    if (!this._decrypt && this.mode.pad) {
      if (!this.mode.pad(this._input, options)) {
        return false;
      }
    } // do final update


    this._finish = true;
    this.update();

    if (this._decrypt && this.mode.unpad) {
      if (!this.mode.unpad(this.output, options)) {
        return false;
      }
    }

    if (this.mode.afterFinish) {
      if (!this.mode.afterFinish(this.output, options)) {
        return false;
      }
    }

    return true;
  };
  /***/

},
/* 144 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * DES (Data Encryption Standard) implementation.
   *
   * This implementation supports DES as well as 3DES-EDE in ECB and CBC mode.
   * It is based on the BSD-licensed implementation by Paul Tero:
   *
   * Paul Tero, July 2001
   * http://www.tero.co.uk/des/
   *
   * Optimised for performance with large blocks by Michael Hayworth, November 2001
   * http://www.netdealing.com
   *
   * THIS SOFTWARE IS PROVIDED "AS IS" AND
   * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
   * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
   * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
   * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
   * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
   * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
   * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
   * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
   * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
   * SUCH DAMAGE.
   *
   * @author Stefan Siegl
   * @author Dave Longley
   *
   * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
   * Copyright (c) 2012-2014 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(143);

  __webpack_require__(222);

  __webpack_require__(8);
  /* DES API */


  module.exports = forge.des = forge.des || {};
  /**
   * Deprecated. Instead, use:
   *
   * var cipher = forge.cipher.createCipher('DES-<mode>', key);
   * cipher.start({iv: iv});
   *
   * Creates an DES cipher object to encrypt data using the given symmetric key.
   * The output will be stored in the 'output' member of the returned cipher.
   *
   * The key and iv may be given as binary-encoded strings of bytes or
   * byte buffers.
   *
   * @param key the symmetric key to use (64 or 192 bits).
   * @param iv the initialization vector to use.
   * @param output the buffer to write to, null to create one.
   * @param mode the cipher mode to use (default: 'CBC' if IV is
   *          given, 'ECB' if null).
   *
   * @return the cipher.
   */

  forge.des.startEncrypting = function (key, iv, output, mode) {
    var cipher = _createCipher({
      key: key,
      output: output,
      decrypt: false,
      mode: mode || (iv === null ? 'ECB' : 'CBC')
    });

    cipher.start(iv);
    return cipher;
  };
  /**
   * Deprecated. Instead, use:
   *
   * var cipher = forge.cipher.createCipher('DES-<mode>', key);
   *
   * Creates an DES cipher object to encrypt data using the given symmetric key.
   *
   * The key may be given as a binary-encoded string of bytes or a byte buffer.
   *
   * @param key the symmetric key to use (64 or 192 bits).
   * @param mode the cipher mode to use (default: 'CBC').
   *
   * @return the cipher.
   */


  forge.des.createEncryptionCipher = function (key, mode) {
    return _createCipher({
      key: key,
      output: null,
      decrypt: false,
      mode: mode
    });
  };
  /**
   * Deprecated. Instead, use:
   *
   * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
   * decipher.start({iv: iv});
   *
   * Creates an DES cipher object to decrypt data using the given symmetric key.
   * The output will be stored in the 'output' member of the returned cipher.
   *
   * The key and iv may be given as binary-encoded strings of bytes or
   * byte buffers.
   *
   * @param key the symmetric key to use (64 or 192 bits).
   * @param iv the initialization vector to use.
   * @param output the buffer to write to, null to create one.
   * @param mode the cipher mode to use (default: 'CBC' if IV is
   *          given, 'ECB' if null).
   *
   * @return the cipher.
   */


  forge.des.startDecrypting = function (key, iv, output, mode) {
    var cipher = _createCipher({
      key: key,
      output: output,
      decrypt: true,
      mode: mode || (iv === null ? 'ECB' : 'CBC')
    });

    cipher.start(iv);
    return cipher;
  };
  /**
   * Deprecated. Instead, use:
   *
   * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
   *
   * Creates an DES cipher object to decrypt data using the given symmetric key.
   *
   * The key may be given as a binary-encoded string of bytes or a byte buffer.
   *
   * @param key the symmetric key to use (64 or 192 bits).
   * @param mode the cipher mode to use (default: 'CBC').
   *
   * @return the cipher.
   */


  forge.des.createDecryptionCipher = function (key, mode) {
    return _createCipher({
      key: key,
      output: null,
      decrypt: true,
      mode: mode
    });
  };
  /**
   * Creates a new DES cipher algorithm object.
   *
   * @param name the name of the algorithm.
   * @param mode the mode factory function.
   *
   * @return the DES algorithm object.
   */


  forge.des.Algorithm = function (name, mode) {
    var self = this;
    self.name = name;
    self.mode = new mode({
      blockSize: 8,
      cipher: {
        encrypt: function encrypt(inBlock, outBlock) {
          return _updateBlock(self._keys, inBlock, outBlock, false);
        },
        decrypt: function decrypt(inBlock, outBlock) {
          return _updateBlock(self._keys, inBlock, outBlock, true);
        }
      }
    });
    self._init = false;
  };
  /**
   * Initializes this DES algorithm by expanding its key.
   *
   * @param options the options to use.
   *          key the key to use with this algorithm.
   *          decrypt true if the algorithm should be initialized for decryption,
   *            false for encryption.
   */


  forge.des.Algorithm.prototype.initialize = function (options) {
    if (this._init) {
      return;
    }

    var key = forge.util.createBuffer(options.key);

    if (this.name.indexOf('3DES') === 0) {
      if (key.length() !== 24) {
        throw new Error('Invalid Triple-DES key size: ' + key.length() * 8);
      }
    } // do key expansion to 16 or 48 subkeys (single or triple DES)


    this._keys = _createKeys(key);
    this._init = true;
  };
  /** Register DES algorithms **/


  registerAlgorithm('DES-ECB', forge.cipher.modes.ecb);
  registerAlgorithm('DES-CBC', forge.cipher.modes.cbc);
  registerAlgorithm('DES-CFB', forge.cipher.modes.cfb);
  registerAlgorithm('DES-OFB', forge.cipher.modes.ofb);
  registerAlgorithm('DES-CTR', forge.cipher.modes.ctr);
  registerAlgorithm('3DES-ECB', forge.cipher.modes.ecb);
  registerAlgorithm('3DES-CBC', forge.cipher.modes.cbc);
  registerAlgorithm('3DES-CFB', forge.cipher.modes.cfb);
  registerAlgorithm('3DES-OFB', forge.cipher.modes.ofb);
  registerAlgorithm('3DES-CTR', forge.cipher.modes.ctr);

  function registerAlgorithm(name, mode) {
    var factory = function factory() {
      return new forge.des.Algorithm(name, mode);
    };

    forge.cipher.registerAlgorithm(name, factory);
  }
  /** DES implementation **/


  var spfunction1 = [0x1010400, 0, 0x10000, 0x1010404, 0x1010004, 0x10404, 0x4, 0x10000, 0x400, 0x1010400, 0x1010404, 0x400, 0x1000404, 0x1010004, 0x1000000, 0x4, 0x404, 0x1000400, 0x1000400, 0x10400, 0x10400, 0x1010000, 0x1010000, 0x1000404, 0x10004, 0x1000004, 0x1000004, 0x10004, 0, 0x404, 0x10404, 0x1000000, 0x10000, 0x1010404, 0x4, 0x1010000, 0x1010400, 0x1000000, 0x1000000, 0x400, 0x1010004, 0x10000, 0x10400, 0x1000004, 0x400, 0x4, 0x1000404, 0x10404, 0x1010404, 0x10004, 0x1010000, 0x1000404, 0x1000004, 0x404, 0x10404, 0x1010400, 0x404, 0x1000400, 0x1000400, 0, 0x10004, 0x10400, 0, 0x1010004];
  var spfunction2 = [-0x7fef7fe0, -0x7fff8000, 0x8000, 0x108020, 0x100000, 0x20, -0x7fefffe0, -0x7fff7fe0, -0x7fffffe0, -0x7fef7fe0, -0x7fef8000, -0x80000000, -0x7fff8000, 0x100000, 0x20, -0x7fefffe0, 0x108000, 0x100020, -0x7fff7fe0, 0, -0x80000000, 0x8000, 0x108020, -0x7ff00000, 0x100020, -0x7fffffe0, 0, 0x108000, 0x8020, -0x7fef8000, -0x7ff00000, 0x8020, 0, 0x108020, -0x7fefffe0, 0x100000, -0x7fff7fe0, -0x7ff00000, -0x7fef8000, 0x8000, -0x7ff00000, -0x7fff8000, 0x20, -0x7fef7fe0, 0x108020, 0x20, 0x8000, -0x80000000, 0x8020, -0x7fef8000, 0x100000, -0x7fffffe0, 0x100020, -0x7fff7fe0, -0x7fffffe0, 0x100020, 0x108000, 0, -0x7fff8000, 0x8020, -0x80000000, -0x7fefffe0, -0x7fef7fe0, 0x108000];
  var spfunction3 = [0x208, 0x8020200, 0, 0x8020008, 0x8000200, 0, 0x20208, 0x8000200, 0x20008, 0x8000008, 0x8000008, 0x20000, 0x8020208, 0x20008, 0x8020000, 0x208, 0x8000000, 0x8, 0x8020200, 0x200, 0x20200, 0x8020000, 0x8020008, 0x20208, 0x8000208, 0x20200, 0x20000, 0x8000208, 0x8, 0x8020208, 0x200, 0x8000000, 0x8020200, 0x8000000, 0x20008, 0x208, 0x20000, 0x8020200, 0x8000200, 0, 0x200, 0x20008, 0x8020208, 0x8000200, 0x8000008, 0x200, 0, 0x8020008, 0x8000208, 0x20000, 0x8000000, 0x8020208, 0x8, 0x20208, 0x20200, 0x8000008, 0x8020000, 0x8000208, 0x208, 0x8020000, 0x20208, 0x8, 0x8020008, 0x20200];
  var spfunction4 = [0x802001, 0x2081, 0x2081, 0x80, 0x802080, 0x800081, 0x800001, 0x2001, 0, 0x802000, 0x802000, 0x802081, 0x81, 0, 0x800080, 0x800001, 0x1, 0x2000, 0x800000, 0x802001, 0x80, 0x800000, 0x2001, 0x2080, 0x800081, 0x1, 0x2080, 0x800080, 0x2000, 0x802080, 0x802081, 0x81, 0x800080, 0x800001, 0x802000, 0x802081, 0x81, 0, 0, 0x802000, 0x2080, 0x800080, 0x800081, 0x1, 0x802001, 0x2081, 0x2081, 0x80, 0x802081, 0x81, 0x1, 0x2000, 0x800001, 0x2001, 0x802080, 0x800081, 0x2001, 0x2080, 0x800000, 0x802001, 0x80, 0x800000, 0x2000, 0x802080];
  var spfunction5 = [0x100, 0x2080100, 0x2080000, 0x42000100, 0x80000, 0x100, 0x40000000, 0x2080000, 0x40080100, 0x80000, 0x2000100, 0x40080100, 0x42000100, 0x42080000, 0x80100, 0x40000000, 0x2000000, 0x40080000, 0x40080000, 0, 0x40000100, 0x42080100, 0x42080100, 0x2000100, 0x42080000, 0x40000100, 0, 0x42000000, 0x2080100, 0x2000000, 0x42000000, 0x80100, 0x80000, 0x42000100, 0x100, 0x2000000, 0x40000000, 0x2080000, 0x42000100, 0x40080100, 0x2000100, 0x40000000, 0x42080000, 0x2080100, 0x40080100, 0x100, 0x2000000, 0x42080000, 0x42080100, 0x80100, 0x42000000, 0x42080100, 0x2080000, 0, 0x40080000, 0x42000000, 0x80100, 0x2000100, 0x40000100, 0x80000, 0, 0x40080000, 0x2080100, 0x40000100];
  var spfunction6 = [0x20000010, 0x20400000, 0x4000, 0x20404010, 0x20400000, 0x10, 0x20404010, 0x400000, 0x20004000, 0x404010, 0x400000, 0x20000010, 0x400010, 0x20004000, 0x20000000, 0x4010, 0, 0x400010, 0x20004010, 0x4000, 0x404000, 0x20004010, 0x10, 0x20400010, 0x20400010, 0, 0x404010, 0x20404000, 0x4010, 0x404000, 0x20404000, 0x20000000, 0x20004000, 0x10, 0x20400010, 0x404000, 0x20404010, 0x400000, 0x4010, 0x20000010, 0x400000, 0x20004000, 0x20000000, 0x4010, 0x20000010, 0x20404010, 0x404000, 0x20400000, 0x404010, 0x20404000, 0, 0x20400010, 0x10, 0x4000, 0x20400000, 0x404010, 0x4000, 0x400010, 0x20004010, 0, 0x20404000, 0x20000000, 0x400010, 0x20004010];
  var spfunction7 = [0x200000, 0x4200002, 0x4000802, 0, 0x800, 0x4000802, 0x200802, 0x4200800, 0x4200802, 0x200000, 0, 0x4000002, 0x2, 0x4000000, 0x4200002, 0x802, 0x4000800, 0x200802, 0x200002, 0x4000800, 0x4000002, 0x4200000, 0x4200800, 0x200002, 0x4200000, 0x800, 0x802, 0x4200802, 0x200800, 0x2, 0x4000000, 0x200800, 0x4000000, 0x200800, 0x200000, 0x4000802, 0x4000802, 0x4200002, 0x4200002, 0x2, 0x200002, 0x4000000, 0x4000800, 0x200000, 0x4200800, 0x802, 0x200802, 0x4200800, 0x802, 0x4000002, 0x4200802, 0x4200000, 0x200800, 0, 0x2, 0x4200802, 0, 0x200802, 0x4200000, 0x800, 0x4000002, 0x4000800, 0x800, 0x200002];
  var spfunction8 = [0x10001040, 0x1000, 0x40000, 0x10041040, 0x10000000, 0x10001040, 0x40, 0x10000000, 0x40040, 0x10040000, 0x10041040, 0x41000, 0x10041000, 0x41040, 0x1000, 0x40, 0x10040000, 0x10000040, 0x10001000, 0x1040, 0x41000, 0x40040, 0x10040040, 0x10041000, 0x1040, 0, 0, 0x10040040, 0x10000040, 0x10001000, 0x41040, 0x40000, 0x41040, 0x40000, 0x10041000, 0x1000, 0x40, 0x10040040, 0x1000, 0x41040, 0x10001000, 0x40, 0x10000040, 0x10040000, 0x10040040, 0x10000000, 0x40000, 0x10001040, 0, 0x10041040, 0x40040, 0x10000040, 0x10040000, 0x10001000, 0x10001040, 0, 0x10041040, 0x41000, 0x41000, 0x1040, 0x1040, 0x40040, 0x10000000, 0x10041000];
  /**
   * Create necessary sub keys.
   *
   * @param key the 64-bit or 192-bit key.
   *
   * @return the expanded keys.
   */

  function _createKeys(key) {
    var pc2bytes0 = [0, 0x4, 0x20000000, 0x20000004, 0x10000, 0x10004, 0x20010000, 0x20010004, 0x200, 0x204, 0x20000200, 0x20000204, 0x10200, 0x10204, 0x20010200, 0x20010204],
        pc2bytes1 = [0, 0x1, 0x100000, 0x100001, 0x4000000, 0x4000001, 0x4100000, 0x4100001, 0x100, 0x101, 0x100100, 0x100101, 0x4000100, 0x4000101, 0x4100100, 0x4100101],
        pc2bytes2 = [0, 0x8, 0x800, 0x808, 0x1000000, 0x1000008, 0x1000800, 0x1000808, 0, 0x8, 0x800, 0x808, 0x1000000, 0x1000008, 0x1000800, 0x1000808],
        pc2bytes3 = [0, 0x200000, 0x8000000, 0x8200000, 0x2000, 0x202000, 0x8002000, 0x8202000, 0x20000, 0x220000, 0x8020000, 0x8220000, 0x22000, 0x222000, 0x8022000, 0x8222000],
        pc2bytes4 = [0, 0x40000, 0x10, 0x40010, 0, 0x40000, 0x10, 0x40010, 0x1000, 0x41000, 0x1010, 0x41010, 0x1000, 0x41000, 0x1010, 0x41010],
        pc2bytes5 = [0, 0x400, 0x20, 0x420, 0, 0x400, 0x20, 0x420, 0x2000000, 0x2000400, 0x2000020, 0x2000420, 0x2000000, 0x2000400, 0x2000020, 0x2000420],
        pc2bytes6 = [0, 0x10000000, 0x80000, 0x10080000, 0x2, 0x10000002, 0x80002, 0x10080002, 0, 0x10000000, 0x80000, 0x10080000, 0x2, 0x10000002, 0x80002, 0x10080002],
        pc2bytes7 = [0, 0x10000, 0x800, 0x10800, 0x20000000, 0x20010000, 0x20000800, 0x20010800, 0x20000, 0x30000, 0x20800, 0x30800, 0x20020000, 0x20030000, 0x20020800, 0x20030800],
        pc2bytes8 = [0, 0x40000, 0, 0x40000, 0x2, 0x40002, 0x2, 0x40002, 0x2000000, 0x2040000, 0x2000000, 0x2040000, 0x2000002, 0x2040002, 0x2000002, 0x2040002],
        pc2bytes9 = [0, 0x10000000, 0x8, 0x10000008, 0, 0x10000000, 0x8, 0x10000008, 0x400, 0x10000400, 0x408, 0x10000408, 0x400, 0x10000400, 0x408, 0x10000408],
        pc2bytes10 = [0, 0x20, 0, 0x20, 0x100000, 0x100020, 0x100000, 0x100020, 0x2000, 0x2020, 0x2000, 0x2020, 0x102000, 0x102020, 0x102000, 0x102020],
        pc2bytes11 = [0, 0x1000000, 0x200, 0x1000200, 0x200000, 0x1200000, 0x200200, 0x1200200, 0x4000000, 0x5000000, 0x4000200, 0x5000200, 0x4200000, 0x5200000, 0x4200200, 0x5200200],
        pc2bytes12 = [0, 0x1000, 0x8000000, 0x8001000, 0x80000, 0x81000, 0x8080000, 0x8081000, 0x10, 0x1010, 0x8000010, 0x8001010, 0x80010, 0x81010, 0x8080010, 0x8081010],
        pc2bytes13 = [0, 0x4, 0x100, 0x104, 0, 0x4, 0x100, 0x104, 0x1, 0x5, 0x101, 0x105, 0x1, 0x5, 0x101, 0x105]; // how many iterations (1 for des, 3 for triple des)
    // changed by Paul 16/6/2007 to use Triple DES for 9+ byte keys

    var iterations = key.length() > 8 ? 3 : 1; // stores the return keys

    var keys = []; // now define the left shifts which need to be done

    var shifts = [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0];
    var n = 0,
        tmp;

    for (var j = 0; j < iterations; j++) {
      var left = key.getInt32();
      var right = key.getInt32();
      tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
      right ^= tmp;
      left ^= tmp << 4;
      tmp = (right >>> -16 ^ left) & 0x0000ffff;
      left ^= tmp;
      right ^= tmp << -16;
      tmp = (left >>> 2 ^ right) & 0x33333333;
      right ^= tmp;
      left ^= tmp << 2;
      tmp = (right >>> -16 ^ left) & 0x0000ffff;
      left ^= tmp;
      right ^= tmp << -16;
      tmp = (left >>> 1 ^ right) & 0x55555555;
      right ^= tmp;
      left ^= tmp << 1;
      tmp = (right >>> 8 ^ left) & 0x00ff00ff;
      left ^= tmp;
      right ^= tmp << 8;
      tmp = (left >>> 1 ^ right) & 0x55555555;
      right ^= tmp;
      left ^= tmp << 1; // right needs to be shifted and OR'd with last four bits of left

      tmp = left << 8 | right >>> 20 & 0x000000f0; // left needs to be put upside down

      left = right << 24 | right << 8 & 0xff0000 | right >>> 8 & 0xff00 | right >>> 24 & 0xf0;
      right = tmp; // now go through and perform these shifts on the left and right keys

      for (var i = 0; i < shifts.length; ++i) {
        //shift the keys either one or two bits to the left
        if (shifts[i]) {
          left = left << 2 | left >>> 26;
          right = right << 2 | right >>> 26;
        } else {
          left = left << 1 | left >>> 27;
          right = right << 1 | right >>> 27;
        }

        left &= -0xf;
        right &= -0xf; // now apply PC-2, in such a way that E is easier when encrypting or
        // decrypting this conversion will look like PC-2 except only the last 6
        // bits of each byte are used rather than 48 consecutive bits and the
        // order of lines will be according to how the S selection functions will
        // be applied: S2, S4, S6, S8, S1, S3, S5, S7

        var lefttmp = pc2bytes0[left >>> 28] | pc2bytes1[left >>> 24 & 0xf] | pc2bytes2[left >>> 20 & 0xf] | pc2bytes3[left >>> 16 & 0xf] | pc2bytes4[left >>> 12 & 0xf] | pc2bytes5[left >>> 8 & 0xf] | pc2bytes6[left >>> 4 & 0xf];
        var righttmp = pc2bytes7[right >>> 28] | pc2bytes8[right >>> 24 & 0xf] | pc2bytes9[right >>> 20 & 0xf] | pc2bytes10[right >>> 16 & 0xf] | pc2bytes11[right >>> 12 & 0xf] | pc2bytes12[right >>> 8 & 0xf] | pc2bytes13[right >>> 4 & 0xf];
        tmp = (righttmp >>> 16 ^ lefttmp) & 0x0000ffff;
        keys[n++] = lefttmp ^ tmp;
        keys[n++] = righttmp ^ tmp << 16;
      }
    }

    return keys;
  }
  /**
   * Updates a single block (1 byte) using DES. The update will either
   * encrypt or decrypt the block.
   *
   * @param keys the expanded keys.
   * @param input the input block (an array of 32-bit words).
   * @param output the updated output block.
   * @param decrypt true to decrypt the block, false to encrypt it.
   */


  function _updateBlock(keys, input, output, decrypt) {
    // set up loops for single or triple DES
    var iterations = keys.length === 32 ? 3 : 9;
    var looping;

    if (iterations === 3) {
      looping = decrypt ? [30, -2, -2] : [0, 32, 2];
    } else {
      looping = decrypt ? [94, 62, -2, 32, 64, 2, 30, -2, -2] : [0, 32, 2, 62, 30, -2, 64, 96, 2];
    }

    var tmp;
    var left = input[0];
    var right = input[1]; // first each 64 bit chunk of the message must be permuted according to IP

    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1; // rotate left 1 bit

    left = left << 1 | left >>> 31;
    right = right << 1 | right >>> 31;

    for (var j = 0; j < iterations; j += 3) {
      var endloop = looping[j + 1];
      var loopinc = looping[j + 2]; // now go through and perform the encryption or decryption

      for (var i = looping[j]; i != endloop; i += loopinc) {
        var right1 = right ^ keys[i];
        var right2 = (right >>> 4 | right << 28) ^ keys[i + 1]; // passing these bytes through the S selection functions

        tmp = left;
        left = right;
        right = tmp ^ (spfunction2[right1 >>> 24 & 0x3f] | spfunction4[right1 >>> 16 & 0x3f] | spfunction6[right1 >>> 8 & 0x3f] | spfunction8[right1 & 0x3f] | spfunction1[right2 >>> 24 & 0x3f] | spfunction3[right2 >>> 16 & 0x3f] | spfunction5[right2 >>> 8 & 0x3f] | spfunction7[right2 & 0x3f]);
      } // unreverse left and right


      tmp = left;
      left = right;
      right = tmp;
    } // rotate right 1 bit


    left = left >>> 1 | left << 31;
    right = right >>> 1 | right << 31; // now perform IP-1, which is IP in the opposite direction

    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    output[0] = left;
    output[1] = right;
  }
  /**
   * Deprecated. Instead, use:
   *
   * forge.cipher.createCipher('DES-<mode>', key);
   * forge.cipher.createDecipher('DES-<mode>', key);
   *
   * Creates a deprecated DES cipher object. This object's mode will default to
   * CBC (cipher-block-chaining).
   *
   * The key may be given as a binary-encoded string of bytes or a byte buffer.
   *
   * @param options the options to use.
   *          key the symmetric key to use (64 or 192 bits).
   *          output the buffer to write to.
   *          decrypt true for decryption, false for encryption.
   *          mode the cipher mode to use (default: 'CBC').
   *
   * @return the cipher.
   */


  function _createCipher(options) {
    options = options || {};
    var mode = (options.mode || 'CBC').toUpperCase();
    var algorithm = 'DES-' + mode;
    var cipher;

    if (options.decrypt) {
      cipher = forge.cipher.createDecipher(algorithm, options.key);
    } else {
      cipher = forge.cipher.createCipher(algorithm, options.key);
    } // backwards compatible start API


    var start = cipher.start;

    cipher.start = function (iv, options) {
      // backwards compatibility: support second arg as output buffer
      var output = null;

      if (options instanceof forge.util.ByteBuffer) {
        output = options;
        options = {};
      }

      options = options || {};
      options.output = output;
      options.iv = iv;
      start.call(cipher, options);
    };

    return cipher;
  }
  /***/

},
/* 145 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Hash-based Message Authentication Code implementation. Requires a message
   * digest object that can be obtained, for example, from forge.md.sha1 or
   * forge.md.md5.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2012 Digital Bazaar, Inc. All rights reserved.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(60);

  __webpack_require__(8);
  /* HMAC API */


  var hmac = module.exports = forge.hmac = forge.hmac || {};
  /**
   * Creates an HMAC object that uses the given message digest object.
   *
   * @return an HMAC object.
   */

  hmac.create = function () {
    // the hmac key to use
    var _key = null; // the message digest to use

    var _md = null; // the inner padding

    var _ipadding = null; // the outer padding

    var _opadding = null; // hmac context

    var ctx = {};
    /**
     * Starts or restarts the HMAC with the given key and message digest.
     *
     * @param md the message digest to use, null to reuse the previous one,
     *           a string to use builtin 'sha1', 'md5', 'sha256'.
     * @param key the key to use as a string, array of bytes, byte buffer,
     *           or null to reuse the previous key.
     */

    ctx.start = function (md, key) {
      if (md !== null) {
        if (typeof md === 'string') {
          // create builtin message digest
          md = md.toLowerCase();

          if (md in forge.md.algorithms) {
            _md = forge.md.algorithms[md].create();
          } else {
            throw new Error('Unknown hash algorithm "' + md + '"');
          }
        } else {
          // store message digest
          _md = md;
        }
      }

      if (key === null) {
        // reuse previous key
        key = _key;
      } else {
        if (typeof key === 'string') {
          // convert string into byte buffer
          key = forge.util.createBuffer(key);
        } else if (forge.util.isArray(key)) {
          // convert byte array into byte buffer
          var tmp = key;
          key = forge.util.createBuffer();

          for (var i = 0; i < tmp.length; ++i) {
            key.putByte(tmp[i]);
          }
        } // if key is longer than blocksize, hash it


        var keylen = key.length();

        if (keylen > _md.blockLength) {
          _md.start();

          _md.update(key.bytes());

          key = _md.digest();
        } // mix key into inner and outer padding
        // ipadding = [0x36 * blocksize] ^ key
        // opadding = [0x5C * blocksize] ^ key


        _ipadding = forge.util.createBuffer();
        _opadding = forge.util.createBuffer();
        keylen = key.length();

        for (var i = 0; i < keylen; ++i) {
          var tmp = key.at(i);

          _ipadding.putByte(0x36 ^ tmp);

          _opadding.putByte(0x5C ^ tmp);
        } // if key is shorter than blocksize, add additional padding


        if (keylen < _md.blockLength) {
          var tmp = _md.blockLength - keylen;

          for (var i = 0; i < tmp; ++i) {
            _ipadding.putByte(0x36);

            _opadding.putByte(0x5C);
          }
        }

        _key = key;
        _ipadding = _ipadding.bytes();
        _opadding = _opadding.bytes();
      } // digest is done like so: hash(opadding | hash(ipadding | message))
      // prepare to do inner hash
      // hash(ipadding | message)


      _md.start();

      _md.update(_ipadding);
    };
    /**
     * Updates the HMAC with the given message bytes.
     *
     * @param bytes the bytes to update with.
     */


    ctx.update = function (bytes) {
      _md.update(bytes);
    };
    /**
     * Produces the Message Authentication Code (MAC).
     *
     * @return a byte buffer containing the digest value.
     */


    ctx.getMac = function () {
      // digest is done like so: hash(opadding | hash(ipadding | message))
      // here we do the outer hashing
      var inner = _md.digest().bytes();

      _md.start();

      _md.update(_opadding);

      _md.update(inner);

      return _md.digest();
    }; // alias for getMac


    ctx.digest = ctx.getMac;
    return ctx;
  };
  /***/

},
/* 146 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (Buffer) {
    /**
    * Password-Based Key-Derivation Function #2 implementation.
    *
    * See RFC 2898 for details.
    *
    * @author Dave Longley
    *
    * Copyright (c) 2010-2013 Digital Bazaar, Inc.
    */
    var forge = __webpack_require__(6);

    __webpack_require__(145);

    __webpack_require__(60);

    __webpack_require__(8);

    var pkcs5 = forge.pkcs5 = forge.pkcs5 || {};
    var crypto;

    if (forge.util.isNodejs && !forge.options.usePureJavaScript) {
      crypto = __webpack_require__(251);
    }
    /**
     * Derives a key from a password.
     *
     * @param p the password as a binary-encoded string of bytes.
     * @param s the salt as a binary-encoded string of bytes.
     * @param c the iteration count, a positive integer.
     * @param dkLen the intended length, in bytes, of the derived key,
     *          (max: 2^32 - 1) * hash length of the PRF.
     * @param [md] the message digest (or algorithm identifier as a string) to use
     *          in the PRF, defaults to SHA-1.
     * @param [callback(err, key)] presence triggers asynchronous version, called
     *          once the operation completes.
     *
     * @return the derived key, as a binary-encoded string of bytes, for the
     *           synchronous version (if no callback is specified).
     */


    module.exports = forge.pbkdf2 = pkcs5.pbkdf2 = function (p, s, c, dkLen, md, callback) {
      if (typeof md === 'function') {
        callback = md;
        md = null;
      } // use native implementation if possible and not disabled, note that
      // some node versions only support SHA-1, others allow digest to be changed


      if (forge.util.isNodejs && !forge.options.usePureJavaScript && crypto.pbkdf2 && (md === null || typeof md !== 'object') && (crypto.pbkdf2Sync.length > 4 || !md || md === 'sha1')) {
        if (typeof md !== 'string') {
          // default prf to SHA-1
          md = 'sha1';
        }

        p = new Buffer(p, 'binary');
        s = new Buffer(s, 'binary');

        if (!callback) {
          if (crypto.pbkdf2Sync.length === 4) {
            return crypto.pbkdf2Sync(p, s, c, dkLen).toString('binary');
          }

          return crypto.pbkdf2Sync(p, s, c, dkLen, md).toString('binary');
        }

        if (crypto.pbkdf2Sync.length === 4) {
          return crypto.pbkdf2(p, s, c, dkLen, function (err, key) {
            if (err) {
              return callback(err);
            }

            callback(null, key.toString('binary'));
          });
        }

        return crypto.pbkdf2(p, s, c, dkLen, md, function (err, key) {
          if (err) {
            return callback(err);
          }

          callback(null, key.toString('binary'));
        });
      }

      if (typeof md === 'undefined' || md === null) {
        // default prf to SHA-1
        md = 'sha1';
      }

      if (typeof md === 'string') {
        if (!(md in forge.md.algorithms)) {
          throw new Error('Unknown hash algorithm: ' + md);
        }

        md = forge.md[md].create();
      }

      var hLen = md.digestLength;
      /* 1. If dkLen > (2^32 - 1) * hLen, output "derived key too long" and
        stop. */

      if (dkLen > 0xFFFFFFFF * hLen) {
        var err = new Error('Derived key is too long.');

        if (callback) {
          return callback(err);
        }

        throw err;
      }
      /* 2. Let len be the number of hLen-octet blocks in the derived key,
        rounding up, and let r be the number of octets in the last
        block:
         len = CEIL(dkLen / hLen),
        r = dkLen - (len - 1) * hLen. */


      var len = Math.ceil(dkLen / hLen);
      var r = dkLen - (len - 1) * hLen;
      /* 3. For each block of the derived key apply the function F defined
        below to the password P, the salt S, the iteration count c, and
        the block index to compute the block:
         T_1 = F(P, S, c, 1),
        T_2 = F(P, S, c, 2),
        ...
        T_len = F(P, S, c, len),
         where the function F is defined as the exclusive-or sum of the
        first c iterates of the underlying pseudorandom function PRF
        applied to the password P and the concatenation of the salt S
        and the block index i:
         F(P, S, c, i) = u_1 XOR u_2 XOR ... XOR u_c
         where
         u_1 = PRF(P, S || INT(i)),
        u_2 = PRF(P, u_1),
        ...
        u_c = PRF(P, u_{c-1}).
         Here, INT(i) is a four-octet encoding of the integer i, most
        significant octet first. */

      var prf = forge.hmac.create();
      prf.start(md, p);
      var dk = '';
      var xor, u_c, u_c1; // sync version

      if (!callback) {
        for (var i = 1; i <= len; ++i) {
          // PRF(P, S || INT(i)) (first iteration)
          prf.start(null, null);
          prf.update(s);
          prf.update(forge.util.int32ToBytes(i));
          xor = u_c1 = prf.digest().getBytes(); // PRF(P, u_{c-1}) (other iterations)

          for (var j = 2; j <= c; ++j) {
            prf.start(null, null);
            prf.update(u_c1);
            u_c = prf.digest().getBytes(); // F(p, s, c, i)

            xor = forge.util.xorBytes(xor, u_c, hLen);
            u_c1 = u_c;
          }
          /* 4. Concatenate the blocks and extract the first dkLen octets to
            produce a derived key DK:
             DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */


          dk += i < len ? xor : xor.substr(0, r);
        }
        /* 5. Output the derived key DK. */


        return dk;
      } // async version


      var i = 1,
          j;

      function outer() {
        if (i > len) {
          // done
          return callback(null, dk);
        } // PRF(P, S || INT(i)) (first iteration)


        prf.start(null, null);
        prf.update(s);
        prf.update(forge.util.int32ToBytes(i));
        xor = u_c1 = prf.digest().getBytes(); // PRF(P, u_{c-1}) (other iterations)

        j = 2;
        inner();
      }

      function inner() {
        if (j <= c) {
          prf.start(null, null);
          prf.update(u_c1);
          u_c = prf.digest().getBytes(); // F(p, s, c, i)

          xor = forge.util.xorBytes(xor, u_c, hLen);
          u_c1 = u_c;
          ++j;
          return forge.util.setImmediate(inner);
        }
        /* 4. Concatenate the blocks and extract the first dkLen octets to
          produce a derived key DK:
           DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */


        dk += i < len ? xor : xor.substr(0, r);
        ++i;
        outer();
      }

      outer();
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 147 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Javascript implementation of PKCS#1 PSS signature padding.
   *
   * @author Stefan Siegl
   *
   * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
   */
  var forge = __webpack_require__(6);

  __webpack_require__(47);

  __webpack_require__(8); // shortcut for PSS API


  var pss = module.exports = forge.pss = forge.pss || {};
  /**
   * Creates a PSS signature scheme object.
   *
   * There are several ways to provide a salt for encoding:
   *
   * 1. Specify the saltLength only and the built-in PRNG will generate it.
   * 2. Specify the saltLength and a custom PRNG with 'getBytesSync' defined that
   *   will be used.
   * 3. Specify the salt itself as a forge.util.ByteBuffer.
   *
   * @param options the options to use:
   *          md the message digest object to use, a forge md instance.
   *          mgf the mask generation function to use, a forge mgf instance.
   *          [saltLength] the length of the salt in octets.
   *          [prng] the pseudo-random number generator to use to produce a salt.
   *          [salt] the salt to use when encoding.
   *
   * @return a signature scheme object.
   */

  pss.create = function (options) {
    // backwards compatibility w/legacy args: hash, mgf, sLen
    if (arguments.length === 3) {
      options = {
        md: arguments[0],
        mgf: arguments[1],
        saltLength: arguments[2]
      };
    }

    var hash = options.md;
    var mgf = options.mgf;
    var hLen = hash.digestLength;
    var salt_ = options.salt || null;

    if (typeof salt_ === 'string') {
      // assume binary-encoded string
      salt_ = forge.util.createBuffer(salt_);
    }

    var sLen;

    if ('saltLength' in options) {
      sLen = options.saltLength;
    } else if (salt_ !== null) {
      sLen = salt_.length();
    } else {
      throw new Error('Salt length not specified or specific salt not given.');
    }

    if (salt_ !== null && salt_.length() !== sLen) {
      throw new Error('Given salt length does not match length of given salt.');
    }

    var prng = options.prng || forge.random;
    var pssobj = {};
    /**
     * Encodes a PSS signature.
     *
     * This function implements EMSA-PSS-ENCODE as per RFC 3447, section 9.1.1.
     *
     * @param md the message digest object with the hash to sign.
     * @param modsBits the length of the RSA modulus in bits.
     *
     * @return the encoded message as a binary-encoded string of length
     *           ceil((modBits - 1) / 8).
     */

    pssobj.encode = function (md, modBits) {
      var i;
      var emBits = modBits - 1;
      var emLen = Math.ceil(emBits / 8);
      /* 2. Let mHash = Hash(M), an octet string of length hLen. */

      var mHash = md.digest().getBytes();
      /* 3. If emLen < hLen + sLen + 2, output "encoding error" and stop. */

      if (emLen < hLen + sLen + 2) {
        throw new Error('Message is too long to encrypt.');
      }
      /* 4. Generate a random octet string salt of length sLen; if sLen = 0,
       *    then salt is the empty string. */


      var salt;

      if (salt_ === null) {
        salt = prng.getBytesSync(sLen);
      } else {
        salt = salt_.bytes();
      }
      /* 5. Let M' = (0x)00 00 00 00 00 00 00 00 || mHash || salt; */


      var m_ = new forge.util.ByteBuffer();
      m_.fillWithByte(0, 8);
      m_.putBytes(mHash);
      m_.putBytes(salt);
      /* 6. Let H = Hash(M'), an octet string of length hLen. */

      hash.start();
      hash.update(m_.getBytes());
      var h = hash.digest().getBytes();
      /* 7. Generate an octet string PS consisting of emLen - sLen - hLen - 2
       *    zero octets.  The length of PS may be 0. */

      var ps = new forge.util.ByteBuffer();
      ps.fillWithByte(0, emLen - sLen - hLen - 2);
      /* 8. Let DB = PS || 0x01 || salt; DB is an octet string of length
       *    emLen - hLen - 1. */

      ps.putByte(0x01);
      ps.putBytes(salt);
      var db = ps.getBytes();
      /* 9. Let dbMask = MGF(H, emLen - hLen - 1). */

      var maskLen = emLen - hLen - 1;
      var dbMask = mgf.generate(h, maskLen);
      /* 10. Let maskedDB = DB \xor dbMask. */

      var maskedDB = '';

      for (i = 0; i < maskLen; i++) {
        maskedDB += String.fromCharCode(db.charCodeAt(i) ^ dbMask.charCodeAt(i));
      }
      /* 11. Set the leftmost 8emLen - emBits bits of the leftmost octet in
       *     maskedDB to zero. */


      var mask = 0xFF00 >> 8 * emLen - emBits & 0xFF;
      maskedDB = String.fromCharCode(maskedDB.charCodeAt(0) & ~mask) + maskedDB.substr(1);
      /* 12. Let EM = maskedDB || H || 0xbc.
       * 13. Output EM. */

      return maskedDB + h + String.fromCharCode(0xbc);
    };
    /**
     * Verifies a PSS signature.
     *
     * This function implements EMSA-PSS-VERIFY as per RFC 3447, section 9.1.2.
     *
     * @param mHash the message digest hash, as a binary-encoded string, to
     *         compare against the signature.
     * @param em the encoded message, as a binary-encoded string
     *          (RSA decryption result).
     * @param modsBits the length of the RSA modulus in bits.
     *
     * @return true if the signature was verified, false if not.
     */


    pssobj.verify = function (mHash, em, modBits) {
      var i;
      var emBits = modBits - 1;
      var emLen = Math.ceil(emBits / 8);
      /* c. Convert the message representative m to an encoded message EM
       *    of length emLen = ceil((modBits - 1) / 8) octets, where modBits
       *    is the length in bits of the RSA modulus n */

      em = em.substr(-emLen);
      /* 3. If emLen < hLen + sLen + 2, output "inconsistent" and stop. */

      if (emLen < hLen + sLen + 2) {
        throw new Error('Inconsistent parameters to PSS signature verification.');
      }
      /* 4. If the rightmost octet of EM does not have hexadecimal value
       *    0xbc, output "inconsistent" and stop. */


      if (em.charCodeAt(emLen - 1) !== 0xbc) {
        throw new Error('Encoded message does not end in 0xBC.');
      }
      /* 5. Let maskedDB be the leftmost emLen - hLen - 1 octets of EM, and
       *    let H be the next hLen octets. */


      var maskLen = emLen - hLen - 1;
      var maskedDB = em.substr(0, maskLen);
      var h = em.substr(maskLen, hLen);
      /* 6. If the leftmost 8emLen - emBits bits of the leftmost octet in
       *    maskedDB are not all equal to zero, output "inconsistent" and stop. */

      var mask = 0xFF00 >> 8 * emLen - emBits & 0xFF;

      if ((maskedDB.charCodeAt(0) & mask) !== 0) {
        throw new Error('Bits beyond keysize not zero as expected.');
      }
      /* 7. Let dbMask = MGF(H, emLen - hLen - 1). */


      var dbMask = mgf.generate(h, maskLen);
      /* 8. Let DB = maskedDB \xor dbMask. */

      var db = '';

      for (i = 0; i < maskLen; i++) {
        db += String.fromCharCode(maskedDB.charCodeAt(i) ^ dbMask.charCodeAt(i));
      }
      /* 9. Set the leftmost 8emLen - emBits bits of the leftmost octet
       * in DB to zero. */


      db = String.fromCharCode(db.charCodeAt(0) & ~mask) + db.substr(1);
      /* 10. If the emLen - hLen - sLen - 2 leftmost octets of DB are not zero
       * or if the octet at position emLen - hLen - sLen - 1 (the leftmost
       * position is "position 1") does not have hexadecimal value 0x01,
       * output "inconsistent" and stop. */

      var checkLen = emLen - hLen - sLen - 2;

      for (i = 0; i < checkLen; i++) {
        if (db.charCodeAt(i) !== 0x00) {
          throw new Error('Leftmost octets not zero as expected');
        }
      }

      if (db.charCodeAt(checkLen) !== 0x01) {
        throw new Error('Inconsistent PSS signature, 0x01 marker not found');
      }
      /* 11. Let salt be the last sLen octets of DB. */


      var salt = db.substr(-sLen);
      /* 12.  Let M' = (0x)00 00 00 00 00 00 00 00 || mHash || salt */

      var m_ = new forge.util.ByteBuffer();
      m_.fillWithByte(0, 8);
      m_.putBytes(mHash);
      m_.putBytes(salt);
      /* 13. Let H' = Hash(M'), an octet string of length hLen. */

      hash.start();
      hash.update(m_.getBytes());
      var h_ = hash.digest().getBytes();
      /* 14. If H = H', output "consistent." Otherwise, output "inconsistent." */

      return h === h_;
    };

    return pssobj;
  };
  /***/

},
/* 148 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Secure Hash Algorithm with 160-bit digest (SHA-1) implementation.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2015 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(60);

  __webpack_require__(8);

  var sha1 = module.exports = forge.sha1 = forge.sha1 || {};
  forge.md.sha1 = forge.md.algorithms.sha1 = sha1;
  /**
   * Creates a SHA-1 message digest object.
   *
   * @return a message digest object.
   */

  sha1.create = function () {
    // do initialization as necessary
    if (!_initialized) {
      _init();
    } // SHA-1 state contains five 32-bit integers


    var _state = null; // input buffer

    var _input = forge.util.createBuffer(); // used for word storage


    var _w = new Array(80); // message digest object


    var md = {
      algorithm: 'sha1',
      blockLength: 64,
      digestLength: 20,
      // 56-bit length of message so far (does not including padding)
      messageLength: 0,
      // true message length
      fullMessageLength: null,
      // size of message length in bytes
      messageLengthSize: 8
    };
    /**
     * Starts the digest.
     *
     * @return this digest object.
     */

    md.start = function () {
      // up to 56-bit message length for convenience
      md.messageLength = 0; // full message length (set md.messageLength64 for backwards-compatibility)

      md.fullMessageLength = md.messageLength64 = [];
      var int32s = md.messageLengthSize / 4;

      for (var i = 0; i < int32s; ++i) {
        md.fullMessageLength.push(0);
      }

      _input = forge.util.createBuffer();
      _state = {
        h0: 0x67452301,
        h1: 0xEFCDAB89,
        h2: 0x98BADCFE,
        h3: 0x10325476,
        h4: 0xC3D2E1F0
      };
      return md;
    }; // start digest automatically for first time


    md.start();
    /**
     * Updates the digest with the given message input. The given input can
     * treated as raw input (no encoding will be applied) or an encoding of
     * 'utf8' maybe given to encode the input using UTF-8.
     *
     * @param msg the message input to update with.
     * @param encoding the encoding to use (default: 'raw', other: 'utf8').
     *
     * @return this digest object.
     */

    md.update = function (msg, encoding) {
      if (encoding === 'utf8') {
        msg = forge.util.encodeUtf8(msg);
      } // update message length


      var len = msg.length;
      md.messageLength += len;
      len = [len / 0x100000000 >>> 0, len >>> 0];

      for (var i = md.fullMessageLength.length - 1; i >= 0; --i) {
        md.fullMessageLength[i] += len[1];
        len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
        md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
        len[0] = len[1] / 0x100000000 >>> 0;
      } // add bytes to input buffer


      _input.putBytes(msg); // process bytes


      _update(_state, _w, _input); // compact input buffer every 2K or if empty


      if (_input.read > 2048 || _input.length() === 0) {
        _input.compact();
      }

      return md;
    };
    /**
     * Produces the digest.
     *
     * @return a byte buffer containing the digest value.
     */


    md.digest = function () {
      /* Note: Here we copy the remaining bytes in the input buffer and
      add the appropriate SHA-1 padding. Then we do the final update
      on a copy of the state so that if the user wants to get
      intermediate digests they can do so. */

      /* Determine the number of bytes that must be added to the message
      to ensure its length is congruent to 448 mod 512. In other words,
      the data to be digested must be a multiple of 512 bits (or 128 bytes).
      This data includes the message, some padding, and the length of the
      message. Since the length of the message will be encoded as 8 bytes (64
      bits), that means that the last segment of the data must have 56 bytes
      (448 bits) of message and padding. Therefore, the length of the message
      plus the padding must be congruent to 448 mod 512 because
      512 - 128 = 448.
       In order to fill up the message length it must be filled with
      padding that begins with 1 bit followed by all 0 bits. Padding
      must *always* be present, so if the message length is already
      congruent to 448 mod 512, then 512 padding bits must be added. */
      var finalBlock = forge.util.createBuffer();
      finalBlock.putBytes(_input.bytes()); // compute remaining size to be digested (include message length size)

      var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize; // add padding for overflow blockSize - overflow
      // _padding starts with 1 byte with first bit is set (byte value 128), then
      // there may be up to (blockSize - 1) other pad bytes

      var overflow = remaining & md.blockLength - 1;
      finalBlock.putBytes(_padding.substr(0, md.blockLength - overflow)); // serialize message length in bits in big-endian order; since length
      // is stored in bytes we multiply by 8 and add carry from next int

      var next, carry;
      var bits = md.fullMessageLength[0] * 8;

      for (var i = 0; i < md.fullMessageLength.length - 1; ++i) {
        next = md.fullMessageLength[i + 1] * 8;
        carry = next / 0x100000000 >>> 0;
        bits += carry;
        finalBlock.putInt32(bits >>> 0);
        bits = next >>> 0;
      }

      finalBlock.putInt32(bits);
      var s2 = {
        h0: _state.h0,
        h1: _state.h1,
        h2: _state.h2,
        h3: _state.h3,
        h4: _state.h4
      };

      _update(s2, _w, finalBlock);

      var rval = forge.util.createBuffer();
      rval.putInt32(s2.h0);
      rval.putInt32(s2.h1);
      rval.putInt32(s2.h2);
      rval.putInt32(s2.h3);
      rval.putInt32(s2.h4);
      return rval;
    };

    return md;
  }; // sha-1 padding bytes not initialized yet


  var _padding = null;
  var _initialized = false;
  /**
   * Initializes the constant tables.
   */

  function _init() {
    // create padding
    _padding = String.fromCharCode(128);
    _padding += forge.util.fillString(String.fromCharCode(0x00), 64); // now initialized

    _initialized = true;
  }
  /**
   * Updates a SHA-1 state with the given byte buffer.
   *
   * @param s the SHA-1 state to update.
   * @param w the array to use to store words.
   * @param bytes the byte buffer to update with.
   */


  function _update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t, a, b, c, d, e, f, i;
    var len = bytes.length();

    while (len >= 64) {
      // the w array will be populated with sixteen 32-bit big-endian words
      // and then extended into 80 32-bit words according to SHA-1 algorithm
      // and for 32-79 using Max Locktyukhin's optimization
      // initialize hash value for this chunk
      a = s.h0;
      b = s.h1;
      c = s.h2;
      d = s.h3;
      e = s.h4; // round 1

      for (i = 0; i < 16; ++i) {
        t = bytes.getInt32();
        w[i] = t;
        f = d ^ b & (c ^ d);
        t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
        e = d;
        d = c; // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug

        c = (b << 30 | b >>> 2) >>> 0;
        b = a;
        a = t;
      }

      for (; i < 20; ++i) {
        t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
        t = t << 1 | t >>> 31;
        w[i] = t;
        f = d ^ b & (c ^ d);
        t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
        e = d;
        d = c; // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug

        c = (b << 30 | b >>> 2) >>> 0;
        b = a;
        a = t;
      } // round 2


      for (; i < 32; ++i) {
        t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
        t = t << 1 | t >>> 31;
        w[i] = t;
        f = b ^ c ^ d;
        t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
        e = d;
        d = c; // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug

        c = (b << 30 | b >>> 2) >>> 0;
        b = a;
        a = t;
      }

      for (; i < 40; ++i) {
        t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
        t = t << 2 | t >>> 30;
        w[i] = t;
        f = b ^ c ^ d;
        t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
        e = d;
        d = c; // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug

        c = (b << 30 | b >>> 2) >>> 0;
        b = a;
        a = t;
      } // round 3


      for (; i < 60; ++i) {
        t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
        t = t << 2 | t >>> 30;
        w[i] = t;
        f = b & c | d & (b ^ c);
        t = (a << 5 | a >>> 27) + f + e + 0x8F1BBCDC + t;
        e = d;
        d = c; // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug

        c = (b << 30 | b >>> 2) >>> 0;
        b = a;
        a = t;
      } // round 4


      for (; i < 80; ++i) {
        t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
        t = t << 2 | t >>> 30;
        w[i] = t;
        f = b ^ c ^ d;
        t = (a << 5 | a >>> 27) + f + e + 0xCA62C1D6 + t;
        e = d;
        d = c; // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug

        c = (b << 30 | b >>> 2) >>> 0;
        b = a;
        a = t;
      } // update hash state


      s.h0 = s.h0 + a | 0;
      s.h1 = s.h1 + b | 0;
      s.h2 = s.h2 + c | 0;
      s.h3 = s.h3 + d | 0;
      s.h4 = s.h4 + e | 0;
      len -= 64;
    }
  }
  /***/

},
/* 149 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Javascript implementation of X.509 and related components (such as
   * Certification Signing Requests) of a Public Key Infrastructure.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2014 Digital Bazaar, Inc.
   *
   * The ASN.1 representation of an X.509v3 certificate is as follows
   * (see RFC 2459):
   *
   * Certificate ::= SEQUENCE {
   *   tbsCertificate       TBSCertificate,
   *   signatureAlgorithm   AlgorithmIdentifier,
   *   signatureValue       BIT STRING
   * }
   *
   * TBSCertificate ::= SEQUENCE {
   *   version         [0]  EXPLICIT Version DEFAULT v1,
   *   serialNumber         CertificateSerialNumber,
   *   signature            AlgorithmIdentifier,
   *   issuer               Name,
   *   validity             Validity,
   *   subject              Name,
   *   subjectPublicKeyInfo SubjectPublicKeyInfo,
   *   issuerUniqueID  [1]  IMPLICIT UniqueIdentifier OPTIONAL,
   *                        -- If present, version shall be v2 or v3
   *   subjectUniqueID [2]  IMPLICIT UniqueIdentifier OPTIONAL,
   *                        -- If present, version shall be v2 or v3
   *   extensions      [3]  EXPLICIT Extensions OPTIONAL
   *                        -- If present, version shall be v3
   * }
   *
   * Version ::= INTEGER  { v1(0), v2(1), v3(2) }
   *
   * CertificateSerialNumber ::= INTEGER
   *
   * Name ::= CHOICE {
   *   // only one possible choice for now
   *   RDNSequence
   * }
   *
   * RDNSequence ::= SEQUENCE OF RelativeDistinguishedName
   *
   * RelativeDistinguishedName ::= SET OF AttributeTypeAndValue
   *
   * AttributeTypeAndValue ::= SEQUENCE {
   *   type     AttributeType,
   *   value    AttributeValue
   * }
   * AttributeType ::= OBJECT IDENTIFIER
   * AttributeValue ::= ANY DEFINED BY AttributeType
   *
   * Validity ::= SEQUENCE {
   *   notBefore      Time,
   *   notAfter       Time
   * }
   *
   * Time ::= CHOICE {
   *   utcTime        UTCTime,
   *   generalTime    GeneralizedTime
   * }
   *
   * UniqueIdentifier ::= BIT STRING
   *
   * SubjectPublicKeyInfo ::= SEQUENCE {
   *   algorithm            AlgorithmIdentifier,
   *   subjectPublicKey     BIT STRING
   * }
   *
   * Extensions ::= SEQUENCE SIZE (1..MAX) OF Extension
   *
   * Extension ::= SEQUENCE {
   *   extnID      OBJECT IDENTIFIER,
   *   critical    BOOLEAN DEFAULT FALSE,
   *   extnValue   OCTET STRING
   * }
   *
   * The only key algorithm currently supported for PKI is RSA.
   *
   * RSASSA-PSS signatures are described in RFC 3447 and RFC 4055.
   *
   * PKCS#10 v1.7 describes certificate signing requests:
   *
   * CertificationRequestInfo:
   *
   * CertificationRequestInfo ::= SEQUENCE {
   *   version       INTEGER { v1(0) } (v1,...),
   *   subject       Name,
   *   subjectPKInfo SubjectPublicKeyInfo{{ PKInfoAlgorithms }},
   *   attributes    [0] Attributes{{ CRIAttributes }}
   * }
   *
   * Attributes { ATTRIBUTE:IOSet } ::= SET OF Attribute{{ IOSet }}
   *
   * CRIAttributes  ATTRIBUTE  ::= {
   *   ... -- add any locally defined attributes here -- }
   *
   * Attribute { ATTRIBUTE:IOSet } ::= SEQUENCE {
   *   type   ATTRIBUTE.&id({IOSet}),
   *   values SET SIZE(1..MAX) OF ATTRIBUTE.&Type({IOSet}{@type})
   * }
   *
   * CertificationRequest ::= SEQUENCE {
   *   certificationRequestInfo CertificationRequestInfo,
   *   signatureAlgorithm AlgorithmIdentifier{{ SignatureAlgorithms }},
   *   signature          BIT STRING
   * }
   */
  var forge = __webpack_require__(6);

  __webpack_require__(79);

  __webpack_require__(46);

  __webpack_require__(144);

  __webpack_require__(60);

  __webpack_require__(540);

  __webpack_require__(61);

  __webpack_require__(80);

  __webpack_require__(147);

  __webpack_require__(101);

  __webpack_require__(8); // shortcut for asn.1 API


  var asn1 = forge.asn1;
  /* Public Key Infrastructure (PKI) implementation. */

  var pki = module.exports = forge.pki = forge.pki || {};
  var oids = pki.oids; // short name OID mappings

  var _shortNames = {};
  _shortNames['CN'] = oids['commonName'];
  _shortNames['commonName'] = 'CN';
  _shortNames['C'] = oids['countryName'];
  _shortNames['countryName'] = 'C';
  _shortNames['L'] = oids['localityName'];
  _shortNames['localityName'] = 'L';
  _shortNames['ST'] = oids['stateOrProvinceName'];
  _shortNames['stateOrProvinceName'] = 'ST';
  _shortNames['O'] = oids['organizationName'];
  _shortNames['organizationName'] = 'O';
  _shortNames['OU'] = oids['organizationalUnitName'];
  _shortNames['organizationalUnitName'] = 'OU';
  _shortNames['E'] = oids['emailAddress'];
  _shortNames['emailAddress'] = 'E'; // validator for an SubjectPublicKeyInfo structure
  // Note: Currently only works with an RSA public key

  var publicKeyValidator = forge.pki.rsa.publicKeyValidator; // validator for an X.509v3 certificate

  var x509CertificateValidator = {
    name: 'Certificate',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'Certificate.TBSCertificate',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      captureAsn1: 'tbsCertificate',
      value: [{
        name: 'Certificate.TBSCertificate.version',
        tagClass: asn1.Class.CONTEXT_SPECIFIC,
        type: 0,
        constructed: true,
        optional: true,
        value: [{
          name: 'Certificate.TBSCertificate.version.integer',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.INTEGER,
          constructed: false,
          capture: 'certVersion'
        }]
      }, {
        name: 'Certificate.TBSCertificate.serialNumber',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.INTEGER,
        constructed: false,
        capture: 'certSerialNumber'
      }, {
        name: 'Certificate.TBSCertificate.signature',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        value: [{
          name: 'Certificate.TBSCertificate.signature.algorithm',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.OID,
          constructed: false,
          capture: 'certinfoSignatureOid'
        }, {
          name: 'Certificate.TBSCertificate.signature.parameters',
          tagClass: asn1.Class.UNIVERSAL,
          optional: true,
          captureAsn1: 'certinfoSignatureParams'
        }]
      }, {
        name: 'Certificate.TBSCertificate.issuer',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        captureAsn1: 'certIssuer'
      }, {
        name: 'Certificate.TBSCertificate.validity',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        // Note: UTC and generalized times may both appear so the capture
        // names are based on their detected order, the names used below
        // are only for the common case, which validity time really means
        // "notBefore" and which means "notAfter" will be determined by order
        value: [{
          // notBefore (Time) (UTC time case)
          name: 'Certificate.TBSCertificate.validity.notBefore (utc)',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.UTCTIME,
          constructed: false,
          optional: true,
          capture: 'certValidity1UTCTime'
        }, {
          // notBefore (Time) (generalized time case)
          name: 'Certificate.TBSCertificate.validity.notBefore (generalized)',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.GENERALIZEDTIME,
          constructed: false,
          optional: true,
          capture: 'certValidity2GeneralizedTime'
        }, {
          // notAfter (Time) (only UTC time is supported)
          name: 'Certificate.TBSCertificate.validity.notAfter (utc)',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.UTCTIME,
          constructed: false,
          optional: true,
          capture: 'certValidity3UTCTime'
        }, {
          // notAfter (Time) (only UTC time is supported)
          name: 'Certificate.TBSCertificate.validity.notAfter (generalized)',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.GENERALIZEDTIME,
          constructed: false,
          optional: true,
          capture: 'certValidity4GeneralizedTime'
        }]
      }, {
        // Name (subject) (RDNSequence)
        name: 'Certificate.TBSCertificate.subject',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        captureAsn1: 'certSubject'
      }, // SubjectPublicKeyInfo
      publicKeyValidator, {
        // issuerUniqueID (optional)
        name: 'Certificate.TBSCertificate.issuerUniqueID',
        tagClass: asn1.Class.CONTEXT_SPECIFIC,
        type: 1,
        constructed: true,
        optional: true,
        value: [{
          name: 'Certificate.TBSCertificate.issuerUniqueID.id',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.BITSTRING,
          constructed: false,
          // TODO: support arbitrary bit length ids
          captureBitStringValue: 'certIssuerUniqueId'
        }]
      }, {
        // subjectUniqueID (optional)
        name: 'Certificate.TBSCertificate.subjectUniqueID',
        tagClass: asn1.Class.CONTEXT_SPECIFIC,
        type: 2,
        constructed: true,
        optional: true,
        value: [{
          name: 'Certificate.TBSCertificate.subjectUniqueID.id',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.BITSTRING,
          constructed: false,
          // TODO: support arbitrary bit length ids
          captureBitStringValue: 'certSubjectUniqueId'
        }]
      }, {
        // Extensions (optional)
        name: 'Certificate.TBSCertificate.extensions',
        tagClass: asn1.Class.CONTEXT_SPECIFIC,
        type: 3,
        constructed: true,
        captureAsn1: 'certExtensions',
        optional: true
      }]
    }, {
      // AlgorithmIdentifier (signature algorithm)
      name: 'Certificate.signatureAlgorithm',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        // algorithm
        name: 'Certificate.signatureAlgorithm.algorithm',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OID,
        constructed: false,
        capture: 'certSignatureOid'
      }, {
        name: 'Certificate.TBSCertificate.signature.parameters',
        tagClass: asn1.Class.UNIVERSAL,
        optional: true,
        captureAsn1: 'certSignatureParams'
      }]
    }, {
      // SignatureValue
      name: 'Certificate.signatureValue',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.BITSTRING,
      constructed: false,
      captureBitStringValue: 'certSignature'
    }]
  };
  var rsassaPssParameterValidator = {
    name: 'rsapss',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'rsapss.hashAlgorithm',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 0,
      constructed: true,
      value: [{
        name: 'rsapss.hashAlgorithm.AlgorithmIdentifier',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Class.SEQUENCE,
        constructed: true,
        optional: true,
        value: [{
          name: 'rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.OID,
          constructed: false,
          capture: 'hashOid'
          /* parameter block omitted, for SHA1 NULL anyhow. */

        }]
      }]
    }, {
      name: 'rsapss.maskGenAlgorithm',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 1,
      constructed: true,
      value: [{
        name: 'rsapss.maskGenAlgorithm.AlgorithmIdentifier',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Class.SEQUENCE,
        constructed: true,
        optional: true,
        value: [{
          name: 'rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.OID,
          constructed: false,
          capture: 'maskGenOid'
        }, {
          name: 'rsapss.maskGenAlgorithm.AlgorithmIdentifier.params',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.SEQUENCE,
          constructed: true,
          value: [{
            name: 'rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm',
            tagClass: asn1.Class.UNIVERSAL,
            type: asn1.Type.OID,
            constructed: false,
            capture: 'maskGenHashOid'
            /* parameter block omitted, for SHA1 NULL anyhow. */

          }]
        }]
      }]
    }, {
      name: 'rsapss.saltLength',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 2,
      optional: true,
      value: [{
        name: 'rsapss.saltLength.saltLength',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Class.INTEGER,
        constructed: false,
        capture: 'saltLength'
      }]
    }, {
      name: 'rsapss.trailerField',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 3,
      optional: true,
      value: [{
        name: 'rsapss.trailer.trailer',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Class.INTEGER,
        constructed: false,
        capture: 'trailer'
      }]
    }]
  }; // validator for a CertificationRequestInfo structure

  var certificationRequestInfoValidator = {
    name: 'CertificationRequestInfo',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: 'certificationRequestInfo',
    value: [{
      name: 'CertificationRequestInfo.integer',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'certificationRequestInfoVersion'
    }, {
      // Name (subject) (RDNSequence)
      name: 'CertificationRequestInfo.subject',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      captureAsn1: 'certificationRequestInfoSubject'
    }, // SubjectPublicKeyInfo
    publicKeyValidator, {
      name: 'CertificationRequestInfo.attributes',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 0,
      constructed: true,
      optional: true,
      capture: 'certificationRequestInfoAttributes',
      value: [{
        name: 'CertificationRequestInfo.attributes',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        value: [{
          name: 'CertificationRequestInfo.attributes.type',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.OID,
          constructed: false
        }, {
          name: 'CertificationRequestInfo.attributes.value',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.SET,
          constructed: true
        }]
      }]
    }]
  }; // validator for a CertificationRequest structure

  var certificationRequestValidator = {
    name: 'CertificationRequest',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: 'csr',
    value: [certificationRequestInfoValidator, {
      // AlgorithmIdentifier (signature algorithm)
      name: 'CertificationRequest.signatureAlgorithm',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        // algorithm
        name: 'CertificationRequest.signatureAlgorithm.algorithm',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OID,
        constructed: false,
        capture: 'csrSignatureOid'
      }, {
        name: 'CertificationRequest.signatureAlgorithm.parameters',
        tagClass: asn1.Class.UNIVERSAL,
        optional: true,
        captureAsn1: 'csrSignatureParams'
      }]
    }, {
      // signature
      name: 'CertificationRequest.signature',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.BITSTRING,
      constructed: false,
      captureBitStringValue: 'csrSignature'
    }]
  };
  /**
   * Converts an RDNSequence of ASN.1 DER-encoded RelativeDistinguishedName
   * sets into an array with objects that have type and value properties.
   *
   * @param rdn the RDNSequence to convert.
   * @param md a message digest to append type and value to if provided.
   */

  pki.RDNAttributesAsArray = function (rdn, md) {
    var rval = []; // each value in 'rdn' in is a SET of RelativeDistinguishedName

    var set, attr, obj;

    for (var si = 0; si < rdn.value.length; ++si) {
      // get the RelativeDistinguishedName set
      set = rdn.value[si]; // each value in the SET is an AttributeTypeAndValue sequence
      // containing first a type (an OID) and second a value (defined by
      // the OID)

      for (var i = 0; i < set.value.length; ++i) {
        obj = {};
        attr = set.value[i];
        obj.type = asn1.derToOid(attr.value[0].value);
        obj.value = attr.value[1].value;
        obj.valueTagClass = attr.value[1].type; // if the OID is known, get its name and short name

        if (obj.type in oids) {
          obj.name = oids[obj.type];

          if (obj.name in _shortNames) {
            obj.shortName = _shortNames[obj.name];
          }
        }

        if (md) {
          md.update(obj.type);
          md.update(obj.value);
        }

        rval.push(obj);
      }
    }

    return rval;
  };
  /**
   * Converts ASN.1 CRIAttributes into an array with objects that have type and
   * value properties.
   *
   * @param attributes the CRIAttributes to convert.
   */


  pki.CRIAttributesAsArray = function (attributes) {
    var rval = []; // each value in 'attributes' in is a SEQUENCE with an OID and a SET

    for (var si = 0; si < attributes.length; ++si) {
      // get the attribute sequence
      var seq = attributes[si]; // each value in the SEQUENCE containing first a type (an OID) and
      // second a set of values (defined by the OID)

      var type = asn1.derToOid(seq.value[0].value);
      var values = seq.value[1].value;

      for (var vi = 0; vi < values.length; ++vi) {
        var obj = {};
        obj.type = type;
        obj.value = values[vi].value;
        obj.valueTagClass = values[vi].type; // if the OID is known, get its name and short name

        if (obj.type in oids) {
          obj.name = oids[obj.type];

          if (obj.name in _shortNames) {
            obj.shortName = _shortNames[obj.name];
          }
        } // parse extensions


        if (obj.type === oids.extensionRequest) {
          obj.extensions = [];

          for (var ei = 0; ei < obj.value.length; ++ei) {
            obj.extensions.push(pki.certificateExtensionFromAsn1(obj.value[ei]));
          }
        }

        rval.push(obj);
      }
    }

    return rval;
  };
  /**
   * Gets an issuer or subject attribute from its name, type, or short name.
   *
   * @param obj the issuer or subject object.
   * @param options a short name string or an object with:
   *          shortName the short name for the attribute.
   *          name the name for the attribute.
   *          type the type for the attribute.
   *
   * @return the attribute.
   */


  function _getAttribute(obj, options) {
    if (typeof options === 'string') {
      options = {
        shortName: options
      };
    }

    var rval = null;
    var attr;

    for (var i = 0; rval === null && i < obj.attributes.length; ++i) {
      attr = obj.attributes[i];

      if (options.type && options.type === attr.type) {
        rval = attr;
      } else if (options.name && options.name === attr.name) {
        rval = attr;
      } else if (options.shortName && options.shortName === attr.shortName) {
        rval = attr;
      }
    }

    return rval;
  }
  /**
   * Converts signature parameters from ASN.1 structure.
   *
   * Currently only RSASSA-PSS supported.  The PKCS#1 v1.5 signature scheme had
   * no parameters.
   *
   * RSASSA-PSS-params  ::=  SEQUENCE  {
   *   hashAlgorithm      [0] HashAlgorithm DEFAULT
   *                             sha1Identifier,
   *   maskGenAlgorithm   [1] MaskGenAlgorithm DEFAULT
   *                             mgf1SHA1Identifier,
   *   saltLength         [2] INTEGER DEFAULT 20,
   *   trailerField       [3] INTEGER DEFAULT 1
   * }
   *
   * HashAlgorithm  ::=  AlgorithmIdentifier
   *
   * MaskGenAlgorithm  ::=  AlgorithmIdentifier
   *
   * AlgorithmIdentifer ::= SEQUENCE {
   *   algorithm OBJECT IDENTIFIER,
   *   parameters ANY DEFINED BY algorithm OPTIONAL
   * }
   *
   * @param oid The OID specifying the signature algorithm
   * @param obj The ASN.1 structure holding the parameters
   * @param fillDefaults Whether to use return default values where omitted
   * @return signature parameter object
   */


  var _readSignatureParameters = function _readSignatureParameters(oid, obj, fillDefaults) {
    var params = {};

    if (oid !== oids['RSASSA-PSS']) {
      return params;
    }

    if (fillDefaults) {
      params = {
        hash: {
          algorithmOid: oids['sha1']
        },
        mgf: {
          algorithmOid: oids['mgf1'],
          hash: {
            algorithmOid: oids['sha1']
          }
        },
        saltLength: 20
      };
    }

    var capture = {};
    var errors = [];

    if (!asn1.validate(obj, rsassaPssParameterValidator, capture, errors)) {
      var error = new Error('Cannot read RSASSA-PSS parameter block.');
      error.errors = errors;
      throw error;
    }

    if (capture.hashOid !== undefined) {
      params.hash = params.hash || {};
      params.hash.algorithmOid = asn1.derToOid(capture.hashOid);
    }

    if (capture.maskGenOid !== undefined) {
      params.mgf = params.mgf || {};
      params.mgf.algorithmOid = asn1.derToOid(capture.maskGenOid);
      params.mgf.hash = params.mgf.hash || {};
      params.mgf.hash.algorithmOid = asn1.derToOid(capture.maskGenHashOid);
    }

    if (capture.saltLength !== undefined) {
      params.saltLength = capture.saltLength.charCodeAt(0);
    }

    return params;
  };
  /**
   * Converts an X.509 certificate from PEM format.
   *
   * Note: If the certificate is to be verified then compute hash should
   * be set to true. This will scan the TBSCertificate part of the ASN.1
   * object while it is converted so it doesn't need to be converted back
   * to ASN.1-DER-encoding later.
   *
   * @param pem the PEM-formatted certificate.
   * @param computeHash true to compute the hash for verification.
   * @param strict true to be strict when checking ASN.1 value lengths, false to
   *          allow truncated values (default: true).
   *
   * @return the certificate.
   */


  pki.certificateFromPem = function (pem, computeHash, strict) {
    var msg = forge.pem.decode(pem)[0];

    if (msg.type !== 'CERTIFICATE' && msg.type !== 'X509 CERTIFICATE' && msg.type !== 'TRUSTED CERTIFICATE') {
      var error = new Error('Could not convert certificate from PEM; PEM header type ' + 'is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
      error.headerType = msg.type;
      throw error;
    }

    if (msg.procType && msg.procType.type === 'ENCRYPTED') {
      throw new Error('Could not convert certificate from PEM; PEM is encrypted.');
    } // convert DER to ASN.1 object


    var obj = asn1.fromDer(msg.body, strict);
    return pki.certificateFromAsn1(obj, computeHash);
  };
  /**
   * Converts an X.509 certificate to PEM format.
   *
   * @param cert the certificate.
   * @param maxline the maximum characters per line, defaults to 64.
   *
   * @return the PEM-formatted certificate.
   */


  pki.certificateToPem = function (cert, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
      type: 'CERTIFICATE',
      body: asn1.toDer(pki.certificateToAsn1(cert)).getBytes()
    };
    return forge.pem.encode(msg, {
      maxline: maxline
    });
  };
  /**
   * Converts an RSA public key from PEM format.
   *
   * @param pem the PEM-formatted public key.
   *
   * @return the public key.
   */


  pki.publicKeyFromPem = function (pem) {
    var msg = forge.pem.decode(pem)[0];

    if (msg.type !== 'PUBLIC KEY' && msg.type !== 'RSA PUBLIC KEY') {
      var error = new Error('Could not convert public key from PEM; PEM header ' + 'type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
      error.headerType = msg.type;
      throw error;
    }

    if (msg.procType && msg.procType.type === 'ENCRYPTED') {
      throw new Error('Could not convert public key from PEM; PEM is encrypted.');
    } // convert DER to ASN.1 object


    var obj = asn1.fromDer(msg.body);
    return pki.publicKeyFromAsn1(obj);
  };
  /**
   * Converts an RSA public key to PEM format (using a SubjectPublicKeyInfo).
   *
   * @param key the public key.
   * @param maxline the maximum characters per line, defaults to 64.
   *
   * @return the PEM-formatted public key.
   */


  pki.publicKeyToPem = function (key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
      type: 'PUBLIC KEY',
      body: asn1.toDer(pki.publicKeyToAsn1(key)).getBytes()
    };
    return forge.pem.encode(msg, {
      maxline: maxline
    });
  };
  /**
   * Converts an RSA public key to PEM format (using an RSAPublicKey).
   *
   * @param key the public key.
   * @param maxline the maximum characters per line, defaults to 64.
   *
   * @return the PEM-formatted public key.
   */


  pki.publicKeyToRSAPublicKeyPem = function (key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
      type: 'RSA PUBLIC KEY',
      body: asn1.toDer(pki.publicKeyToRSAPublicKey(key)).getBytes()
    };
    return forge.pem.encode(msg, {
      maxline: maxline
    });
  };
  /**
   * Gets a fingerprint for the given public key.
   *
   * @param options the options to use.
   *          [md] the message digest object to use (defaults to forge.md.sha1).
   *          [type] the type of fingerprint, such as 'RSAPublicKey',
   *            'SubjectPublicKeyInfo' (defaults to 'RSAPublicKey').
   *          [encoding] an alternative output encoding, such as 'hex'
   *            (defaults to none, outputs a byte buffer).
   *          [delimiter] the delimiter to use between bytes for 'hex' encoded
   *            output, eg: ':' (defaults to none).
   *
   * @return the fingerprint as a byte buffer or other encoding based on options.
   */


  pki.getPublicKeyFingerprint = function (key, options) {
    options = options || {};
    var md = options.md || forge.md.sha1.create();
    var type = options.type || 'RSAPublicKey';
    var bytes;

    switch (type) {
      case 'RSAPublicKey':
        bytes = asn1.toDer(pki.publicKeyToRSAPublicKey(key)).getBytes();
        break;

      case 'SubjectPublicKeyInfo':
        bytes = asn1.toDer(pki.publicKeyToAsn1(key)).getBytes();
        break;

      default:
        throw new Error('Unknown fingerprint type "' + options.type + '".');
    } // hash public key bytes


    md.start();
    md.update(bytes);
    var digest = md.digest();

    if (options.encoding === 'hex') {
      var hex = digest.toHex();

      if (options.delimiter) {
        return hex.match(/.{2}/g).join(options.delimiter);
      }

      return hex;
    } else if (options.encoding === 'binary') {
      return digest.getBytes();
    } else if (options.encoding) {
      throw new Error('Unknown encoding "' + options.encoding + '".');
    }

    return digest;
  };
  /**
   * Converts a PKCS#10 certification request (CSR) from PEM format.
   *
   * Note: If the certification request is to be verified then compute hash
   * should be set to true. This will scan the CertificationRequestInfo part of
   * the ASN.1 object while it is converted so it doesn't need to be converted
   * back to ASN.1-DER-encoding later.
   *
   * @param pem the PEM-formatted certificate.
   * @param computeHash true to compute the hash for verification.
   * @param strict true to be strict when checking ASN.1 value lengths, false to
   *          allow truncated values (default: true).
   *
   * @return the certification request (CSR).
   */


  pki.certificationRequestFromPem = function (pem, computeHash, strict) {
    var msg = forge.pem.decode(pem)[0];

    if (msg.type !== 'CERTIFICATE REQUEST') {
      var error = new Error('Could not convert certification request from PEM; ' + 'PEM header type is not "CERTIFICATE REQUEST".');
      error.headerType = msg.type;
      throw error;
    }

    if (msg.procType && msg.procType.type === 'ENCRYPTED') {
      throw new Error('Could not convert certification request from PEM; ' + 'PEM is encrypted.');
    } // convert DER to ASN.1 object


    var obj = asn1.fromDer(msg.body, strict);
    return pki.certificationRequestFromAsn1(obj, computeHash);
  };
  /**
   * Converts a PKCS#10 certification request (CSR) to PEM format.
   *
   * @param csr the certification request.
   * @param maxline the maximum characters per line, defaults to 64.
   *
   * @return the PEM-formatted certification request.
   */


  pki.certificationRequestToPem = function (csr, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
      type: 'CERTIFICATE REQUEST',
      body: asn1.toDer(pki.certificationRequestToAsn1(csr)).getBytes()
    };
    return forge.pem.encode(msg, {
      maxline: maxline
    });
  };
  /**
   * Creates an empty X.509v3 RSA certificate.
   *
   * @return the certificate.
   */


  pki.createCertificate = function () {
    var cert = {};
    cert.version = 0x02;
    cert.serialNumber = '00';
    cert.signatureOid = null;
    cert.signature = null;
    cert.siginfo = {};
    cert.siginfo.algorithmOid = null;
    cert.validity = {};
    cert.validity.notBefore = new Date();
    cert.validity.notAfter = new Date();
    cert.issuer = {};

    cert.issuer.getField = function (sn) {
      return _getAttribute(cert.issuer, sn);
    };

    cert.issuer.addField = function (attr) {
      _fillMissingFields([attr]);

      cert.issuer.attributes.push(attr);
    };

    cert.issuer.attributes = [];
    cert.issuer.hash = null;
    cert.subject = {};

    cert.subject.getField = function (sn) {
      return _getAttribute(cert.subject, sn);
    };

    cert.subject.addField = function (attr) {
      _fillMissingFields([attr]);

      cert.subject.attributes.push(attr);
    };

    cert.subject.attributes = [];
    cert.subject.hash = null;
    cert.extensions = [];
    cert.publicKey = null;
    cert.md = null;
    /**
     * Sets the subject of this certificate.
     *
     * @param attrs the array of subject attributes to use.
     * @param uniqueId an optional a unique ID to use.
     */

    cert.setSubject = function (attrs, uniqueId) {
      // set new attributes, clear hash
      _fillMissingFields(attrs);

      cert.subject.attributes = attrs;
      delete cert.subject.uniqueId;

      if (uniqueId) {
        // TODO: support arbitrary bit length ids
        cert.subject.uniqueId = uniqueId;
      }

      cert.subject.hash = null;
    };
    /**
     * Sets the issuer of this certificate.
     *
     * @param attrs the array of issuer attributes to use.
     * @param uniqueId an optional a unique ID to use.
     */


    cert.setIssuer = function (attrs, uniqueId) {
      // set new attributes, clear hash
      _fillMissingFields(attrs);

      cert.issuer.attributes = attrs;
      delete cert.issuer.uniqueId;

      if (uniqueId) {
        // TODO: support arbitrary bit length ids
        cert.issuer.uniqueId = uniqueId;
      }

      cert.issuer.hash = null;
    };
    /**
     * Sets the extensions of this certificate.
     *
     * @param exts the array of extensions to use.
     */


    cert.setExtensions = function (exts) {
      for (var i = 0; i < exts.length; ++i) {
        _fillMissingExtensionFields(exts[i], {
          cert: cert
        });
      } // set new extensions


      cert.extensions = exts;
    };
    /**
     * Gets an extension by its name or id.
     *
     * @param options the name to use or an object with:
     *          name the name to use.
     *          id the id to use.
     *
     * @return the extension or null if not found.
     */


    cert.getExtension = function (options) {
      if (typeof options === 'string') {
        options = {
          name: options
        };
      }

      var rval = null;
      var ext;

      for (var i = 0; rval === null && i < cert.extensions.length; ++i) {
        ext = cert.extensions[i];

        if (options.id && ext.id === options.id) {
          rval = ext;
        } else if (options.name && ext.name === options.name) {
          rval = ext;
        }
      }

      return rval;
    };
    /**
     * Signs this certificate using the given private key.
     *
     * @param key the private key to sign with.
     * @param md the message digest object to use (defaults to forge.md.sha1).
     */


    cert.sign = function (key, md) {
      // TODO: get signature OID from private key
      cert.md = md || forge.md.sha1.create();
      var algorithmOid = oids[cert.md.algorithm + 'WithRSAEncryption'];

      if (!algorithmOid) {
        var error = new Error('Could not compute certificate digest. ' + 'Unknown message digest algorithm OID.');
        error.algorithm = cert.md.algorithm;
        throw error;
      }

      cert.signatureOid = cert.siginfo.algorithmOid = algorithmOid; // get TBSCertificate, convert to DER

      cert.tbsCertificate = pki.getTBSCertificate(cert);
      var bytes = asn1.toDer(cert.tbsCertificate); // digest and sign

      cert.md.update(bytes.getBytes());
      cert.signature = key.sign(cert.md);
    };
    /**
     * Attempts verify the signature on the passed certificate using this
     * certificate's public key.
     *
     * @param child the certificate to verify.
     *
     * @return true if verified, false if not.
     */


    cert.verify = function (child) {
      var rval = false;

      if (!cert.issued(child)) {
        var issuer = child.issuer;
        var subject = cert.subject;
        var error = new Error('The parent certificate did not issue the given child ' + 'certificate; the child certificate\'s issuer does not match the ' + 'parent\'s subject.');
        error.expectedIssuer = issuer.attributes;
        error.actualIssuer = subject.attributes;
        throw error;
      }

      var md = child.md;

      if (md === null) {
        // check signature OID for supported signature types
        if (child.signatureOid in oids) {
          var oid = oids[child.signatureOid];

          switch (oid) {
            case 'sha1WithRSAEncryption':
              md = forge.md.sha1.create();
              break;

            case 'md5WithRSAEncryption':
              md = forge.md.md5.create();
              break;

            case 'sha256WithRSAEncryption':
              md = forge.md.sha256.create();
              break;

            case 'sha384WithRSAEncryption':
              md = forge.md.sha384.create();
              break;

            case 'sha512WithRSAEncryption':
              md = forge.md.sha512.create();
              break;

            case 'RSASSA-PSS':
              md = forge.md.sha256.create();
              break;
          }
        }

        if (md === null) {
          var error = new Error('Could not compute certificate digest. ' + 'Unknown signature OID.');
          error.signatureOid = child.signatureOid;
          throw error;
        } // produce DER formatted TBSCertificate and digest it


        var tbsCertificate = child.tbsCertificate || pki.getTBSCertificate(child);
        var bytes = asn1.toDer(tbsCertificate);
        md.update(bytes.getBytes());
      }

      if (md !== null) {
        var scheme;

        switch (child.signatureOid) {
          case oids.sha1WithRSAEncryption:
            scheme = undefined;
            /* use PKCS#1 v1.5 padding scheme */

            break;

          case oids['RSASSA-PSS']:
            var hash, mgf;
            /* initialize mgf */

            hash = oids[child.signatureParameters.mgf.hash.algorithmOid];

            if (hash === undefined || forge.md[hash] === undefined) {
              var error = new Error('Unsupported MGF hash function.');
              error.oid = child.signatureParameters.mgf.hash.algorithmOid;
              error.name = hash;
              throw error;
            }

            mgf = oids[child.signatureParameters.mgf.algorithmOid];

            if (mgf === undefined || forge.mgf[mgf] === undefined) {
              var error = new Error('Unsupported MGF function.');
              error.oid = child.signatureParameters.mgf.algorithmOid;
              error.name = mgf;
              throw error;
            }

            mgf = forge.mgf[mgf].create(forge.md[hash].create());
            /* initialize hash function */

            hash = oids[child.signatureParameters.hash.algorithmOid];

            if (hash === undefined || forge.md[hash] === undefined) {
              throw {
                message: 'Unsupported RSASSA-PSS hash function.',
                oid: child.signatureParameters.hash.algorithmOid,
                name: hash
              };
            }

            scheme = forge.pss.create(forge.md[hash].create(), mgf, child.signatureParameters.saltLength);
            break;
        } // verify signature on cert using public key


        rval = cert.publicKey.verify(md.digest().getBytes(), child.signature, scheme);
      }

      return rval;
    };
    /**
     * Returns true if this certificate's issuer matches the passed
     * certificate's subject. Note that no signature check is performed.
     *
     * @param parent the certificate to check.
     *
     * @return true if this certificate's issuer matches the passed certificate's
     *         subject.
     */


    cert.isIssuer = function (parent) {
      var rval = false;
      var i = cert.issuer;
      var s = parent.subject; // compare hashes if present

      if (i.hash && s.hash) {
        rval = i.hash === s.hash;
      } else if (i.attributes.length === s.attributes.length) {
        // all attributes are the same so issuer matches subject
        rval = true;
        var iattr, sattr;

        for (var n = 0; rval && n < i.attributes.length; ++n) {
          iattr = i.attributes[n];
          sattr = s.attributes[n];

          if (iattr.type !== sattr.type || iattr.value !== sattr.value) {
            // attribute mismatch
            rval = false;
          }
        }
      }

      return rval;
    };
    /**
     * Returns true if this certificate's subject matches the issuer of the
     * given certificate). Note that not signature check is performed.
     *
     * @param child the certificate to check.
     *
     * @return true if this certificate's subject matches the passed
     *         certificate's issuer.
     */


    cert.issued = function (child) {
      return child.isIssuer(cert);
    };
    /**
     * Generates the subjectKeyIdentifier for this certificate as byte buffer.
     *
     * @return the subjectKeyIdentifier for this certificate as byte buffer.
     */


    cert.generateSubjectKeyIdentifier = function () {
      /* See: 4.2.1.2 section of the the RFC3280, keyIdentifier is either:
         (1) The keyIdentifier is composed of the 160-bit SHA-1 hash of the
          value of the BIT STRING subjectPublicKey (excluding the tag,
          length, and number of unused bits).
         (2) The keyIdentifier is composed of a four bit type field with
          the value 0100 followed by the least significant 60 bits of the
          SHA-1 hash of the value of the BIT STRING subjectPublicKey
          (excluding the tag, length, and number of unused bit string bits).
      */
      // skipping the tag, length, and number of unused bits is the same
      // as just using the RSAPublicKey (for RSA keys, which are the
      // only ones supported)
      return pki.getPublicKeyFingerprint(cert.publicKey, {
        type: 'RSAPublicKey'
      });
    };
    /**
     * Verifies the subjectKeyIdentifier extension value for this certificate
     * against its public key. If no extension is found, false will be
     * returned.
     *
     * @return true if verified, false if not.
     */


    cert.verifySubjectKeyIdentifier = function () {
      var oid = oids['subjectKeyIdentifier'];

      for (var i = 0; i < cert.extensions.length; ++i) {
        var ext = cert.extensions[i];

        if (ext.id === oid) {
          var ski = cert.generateSubjectKeyIdentifier().getBytes();
          return forge.util.hexToBytes(ext.subjectKeyIdentifier) === ski;
        }
      }

      return false;
    };

    return cert;
  };
  /**
   * Converts an X.509v3 RSA certificate from an ASN.1 object.
   *
   * Note: If the certificate is to be verified then compute hash should
   * be set to true. There is currently no implementation for converting
   * a certificate back to ASN.1 so the TBSCertificate part of the ASN.1
   * object needs to be scanned before the cert object is created.
   *
   * @param obj the asn1 representation of an X.509v3 RSA certificate.
   * @param computeHash true to compute the hash for verification.
   *
   * @return the certificate.
   */


  pki.certificateFromAsn1 = function (obj, computeHash) {
    // validate certificate and capture data
    var capture = {};
    var errors = [];

    if (!asn1.validate(obj, x509CertificateValidator, capture, errors)) {
      var error = new Error('Cannot read X.509 certificate. ' + 'ASN.1 object is not an X509v3 Certificate.');
      error.errors = errors;
      throw error;
    } // get oid


    var oid = asn1.derToOid(capture.publicKeyOid);

    if (oid !== pki.oids.rsaEncryption) {
      throw new Error('Cannot read public key. OID is not RSA.');
    } // create certificate


    var cert = pki.createCertificate();
    cert.version = capture.certVersion ? capture.certVersion.charCodeAt(0) : 0;
    var serial = forge.util.createBuffer(capture.certSerialNumber);
    cert.serialNumber = serial.toHex();
    cert.signatureOid = forge.asn1.derToOid(capture.certSignatureOid);
    cert.signatureParameters = _readSignatureParameters(cert.signatureOid, capture.certSignatureParams, true);
    cert.siginfo.algorithmOid = forge.asn1.derToOid(capture.certinfoSignatureOid);
    cert.siginfo.parameters = _readSignatureParameters(cert.siginfo.algorithmOid, capture.certinfoSignatureParams, false);
    cert.signature = capture.certSignature;
    var validity = [];

    if (capture.certValidity1UTCTime !== undefined) {
      validity.push(asn1.utcTimeToDate(capture.certValidity1UTCTime));
    }

    if (capture.certValidity2GeneralizedTime !== undefined) {
      validity.push(asn1.generalizedTimeToDate(capture.certValidity2GeneralizedTime));
    }

    if (capture.certValidity3UTCTime !== undefined) {
      validity.push(asn1.utcTimeToDate(capture.certValidity3UTCTime));
    }

    if (capture.certValidity4GeneralizedTime !== undefined) {
      validity.push(asn1.generalizedTimeToDate(capture.certValidity4GeneralizedTime));
    }

    if (validity.length > 2) {
      throw new Error('Cannot read notBefore/notAfter validity times; more ' + 'than two times were provided in the certificate.');
    }

    if (validity.length < 2) {
      throw new Error('Cannot read notBefore/notAfter validity times; they ' + 'were not provided as either UTCTime or GeneralizedTime.');
    }

    cert.validity.notBefore = validity[0];
    cert.validity.notAfter = validity[1]; // keep TBSCertificate to preserve signature when exporting

    cert.tbsCertificate = capture.tbsCertificate;

    if (computeHash) {
      // check signature OID for supported signature types
      cert.md = null;

      if (cert.signatureOid in oids) {
        var oid = oids[cert.signatureOid];

        switch (oid) {
          case 'sha1WithRSAEncryption':
            cert.md = forge.md.sha1.create();
            break;

          case 'md5WithRSAEncryption':
            cert.md = forge.md.md5.create();
            break;

          case 'sha256WithRSAEncryption':
            cert.md = forge.md.sha256.create();
            break;

          case 'sha384WithRSAEncryption':
            cert.md = forge.md.sha384.create();
            break;

          case 'sha512WithRSAEncryption':
            cert.md = forge.md.sha512.create();
            break;

          case 'RSASSA-PSS':
            cert.md = forge.md.sha256.create();
            break;
        }
      }

      if (cert.md === null) {
        var error = new Error('Could not compute certificate digest. ' + 'Unknown signature OID.');
        error.signatureOid = cert.signatureOid;
        throw error;
      } // produce DER formatted TBSCertificate and digest it


      var bytes = asn1.toDer(cert.tbsCertificate);
      cert.md.update(bytes.getBytes());
    } // handle issuer, build issuer message digest


    var imd = forge.md.sha1.create();

    cert.issuer.getField = function (sn) {
      return _getAttribute(cert.issuer, sn);
    };

    cert.issuer.addField = function (attr) {
      _fillMissingFields([attr]);

      cert.issuer.attributes.push(attr);
    };

    cert.issuer.attributes = pki.RDNAttributesAsArray(capture.certIssuer, imd);

    if (capture.certIssuerUniqueId) {
      cert.issuer.uniqueId = capture.certIssuerUniqueId;
    }

    cert.issuer.hash = imd.digest().toHex(); // handle subject, build subject message digest

    var smd = forge.md.sha1.create();

    cert.subject.getField = function (sn) {
      return _getAttribute(cert.subject, sn);
    };

    cert.subject.addField = function (attr) {
      _fillMissingFields([attr]);

      cert.subject.attributes.push(attr);
    };

    cert.subject.attributes = pki.RDNAttributesAsArray(capture.certSubject, smd);

    if (capture.certSubjectUniqueId) {
      cert.subject.uniqueId = capture.certSubjectUniqueId;
    }

    cert.subject.hash = smd.digest().toHex(); // handle extensions

    if (capture.certExtensions) {
      cert.extensions = pki.certificateExtensionsFromAsn1(capture.certExtensions);
    } else {
      cert.extensions = [];
    } // convert RSA public key from ASN.1


    cert.publicKey = pki.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
    return cert;
  };
  /**
   * Converts an ASN.1 extensions object (with extension sequences as its
   * values) into an array of extension objects with types and values.
   *
   * Supported extensions:
   *
   * id-ce-keyUsage OBJECT IDENTIFIER ::=  { id-ce 15 }
   * KeyUsage ::= BIT STRING {
   *   digitalSignature        (0),
   *   nonRepudiation          (1),
   *   keyEncipherment         (2),
   *   dataEncipherment        (3),
   *   keyAgreement            (4),
   *   keyCertSign             (5),
   *   cRLSign                 (6),
   *   encipherOnly            (7),
   *   decipherOnly            (8)
   * }
   *
   * id-ce-basicConstraints OBJECT IDENTIFIER ::=  { id-ce 19 }
   * BasicConstraints ::= SEQUENCE {
   *   cA                      BOOLEAN DEFAULT FALSE,
   *   pathLenConstraint       INTEGER (0..MAX) OPTIONAL
   * }
   *
   * subjectAltName EXTENSION ::= {
   *   SYNTAX GeneralNames
   *   IDENTIFIED BY id-ce-subjectAltName
   * }
   *
   * GeneralNames ::= SEQUENCE SIZE (1..MAX) OF GeneralName
   *
   * GeneralName ::= CHOICE {
   *   otherName      [0] INSTANCE OF OTHER-NAME,
   *   rfc822Name     [1] IA5String,
   *   dNSName        [2] IA5String,
   *   x400Address    [3] ORAddress,
   *   directoryName  [4] Name,
   *   ediPartyName   [5] EDIPartyName,
   *   uniformResourceIdentifier [6] IA5String,
   *   IPAddress      [7] OCTET STRING,
   *   registeredID   [8] OBJECT IDENTIFIER
   * }
   *
   * OTHER-NAME ::= TYPE-IDENTIFIER
   *
   * EDIPartyName ::= SEQUENCE {
   *   nameAssigner [0] DirectoryString {ub-name} OPTIONAL,
   *   partyName    [1] DirectoryString {ub-name}
   * }
   *
   * @param exts the extensions ASN.1 with extension sequences to parse.
   *
   * @return the array.
   */


  pki.certificateExtensionsFromAsn1 = function (exts) {
    var rval = [];

    for (var i = 0; i < exts.value.length; ++i) {
      // get extension sequence
      var extseq = exts.value[i];

      for (var ei = 0; ei < extseq.value.length; ++ei) {
        rval.push(pki.certificateExtensionFromAsn1(extseq.value[ei]));
      }
    }

    return rval;
  };
  /**
   * Parses a single certificate extension from ASN.1.
   *
   * @param ext the extension in ASN.1 format.
   *
   * @return the parsed extension as an object.
   */


  pki.certificateExtensionFromAsn1 = function (ext) {
    // an extension has:
    // [0] extnID      OBJECT IDENTIFIER
    // [1] critical    BOOLEAN DEFAULT FALSE
    // [2] extnValue   OCTET STRING
    var e = {};
    e.id = asn1.derToOid(ext.value[0].value);
    e.critical = false;

    if (ext.value[1].type === asn1.Type.BOOLEAN) {
      e.critical = ext.value[1].value.charCodeAt(0) !== 0x00;
      e.value = ext.value[2].value;
    } else {
      e.value = ext.value[1].value;
    } // if the oid is known, get its name


    if (e.id in oids) {
      e.name = oids[e.id]; // handle key usage

      if (e.name === 'keyUsage') {
        // get value as BIT STRING
        var ev = asn1.fromDer(e.value);
        var b2 = 0x00;
        var b3 = 0x00;

        if (ev.value.length > 1) {
          // skip first byte, just indicates unused bits which
          // will be padded with 0s anyway
          // get bytes with flag bits
          b2 = ev.value.charCodeAt(1);
          b3 = ev.value.length > 2 ? ev.value.charCodeAt(2) : 0;
        } // set flags


        e.digitalSignature = (b2 & 0x80) === 0x80;
        e.nonRepudiation = (b2 & 0x40) === 0x40;
        e.keyEncipherment = (b2 & 0x20) === 0x20;
        e.dataEncipherment = (b2 & 0x10) === 0x10;
        e.keyAgreement = (b2 & 0x08) === 0x08;
        e.keyCertSign = (b2 & 0x04) === 0x04;
        e.cRLSign = (b2 & 0x02) === 0x02;
        e.encipherOnly = (b2 & 0x01) === 0x01;
        e.decipherOnly = (b3 & 0x80) === 0x80;
      } else if (e.name === 'basicConstraints') {
        // handle basic constraints
        // get value as SEQUENCE
        var ev = asn1.fromDer(e.value); // get cA BOOLEAN flag (defaults to false)

        if (ev.value.length > 0 && ev.value[0].type === asn1.Type.BOOLEAN) {
          e.cA = ev.value[0].value.charCodeAt(0) !== 0x00;
        } else {
          e.cA = false;
        } // get path length constraint


        var value = null;

        if (ev.value.length > 0 && ev.value[0].type === asn1.Type.INTEGER) {
          value = ev.value[0].value;
        } else if (ev.value.length > 1) {
          value = ev.value[1].value;
        }

        if (value !== null) {
          e.pathLenConstraint = asn1.derToInteger(value);
        }
      } else if (e.name === 'extKeyUsage') {
        // handle extKeyUsage
        // value is a SEQUENCE of OIDs
        var ev = asn1.fromDer(e.value);

        for (var vi = 0; vi < ev.value.length; ++vi) {
          var oid = asn1.derToOid(ev.value[vi].value);

          if (oid in oids) {
            e[oids[oid]] = true;
          } else {
            e[oid] = true;
          }
        }
      } else if (e.name === 'nsCertType') {
        // handle nsCertType
        // get value as BIT STRING
        var ev = asn1.fromDer(e.value);
        var b2 = 0x00;

        if (ev.value.length > 1) {
          // skip first byte, just indicates unused bits which
          // will be padded with 0s anyway
          // get bytes with flag bits
          b2 = ev.value.charCodeAt(1);
        } // set flags


        e.client = (b2 & 0x80) === 0x80;
        e.server = (b2 & 0x40) === 0x40;
        e.email = (b2 & 0x20) === 0x20;
        e.objsign = (b2 & 0x10) === 0x10;
        e.reserved = (b2 & 0x08) === 0x08;
        e.sslCA = (b2 & 0x04) === 0x04;
        e.emailCA = (b2 & 0x02) === 0x02;
        e.objCA = (b2 & 0x01) === 0x01;
      } else if (e.name === 'subjectAltName' || e.name === 'issuerAltName') {
        // handle subjectAltName/issuerAltName
        e.altNames = []; // ev is a SYNTAX SEQUENCE

        var gn;
        var ev = asn1.fromDer(e.value);

        for (var n = 0; n < ev.value.length; ++n) {
          // get GeneralName
          gn = ev.value[n];
          var altName = {
            type: gn.type,
            value: gn.value
          };
          e.altNames.push(altName); // Note: Support for types 1,2,6,7,8

          switch (gn.type) {
            // rfc822Name
            case 1: // dNSName

            case 2: // uniformResourceIdentifier (URI)

            case 6:
              break;
            // IPAddress

            case 7:
              // convert to IPv4/IPv6 string representation
              altName.ip = forge.util.bytesToIP(gn.value);
              break;
            // registeredID

            case 8:
              altName.oid = asn1.derToOid(gn.value);
              break;

            default: // unsupported

          }
        }
      } else if (e.name === 'subjectKeyIdentifier') {
        // value is an OCTETSTRING w/the hash of the key-type specific
        // public key structure (eg: RSAPublicKey)
        var ev = asn1.fromDer(e.value);
        e.subjectKeyIdentifier = forge.util.bytesToHex(ev.value);
      }
    }

    return e;
  };
  /**
   * Converts a PKCS#10 certification request (CSR) from an ASN.1 object.
   *
   * Note: If the certification request is to be verified then compute hash
   * should be set to true. There is currently no implementation for converting
   * a certificate back to ASN.1 so the CertificationRequestInfo part of the
   * ASN.1 object needs to be scanned before the csr object is created.
   *
   * @param obj the asn1 representation of a PKCS#10 certification request (CSR).
   * @param computeHash true to compute the hash for verification.
   *
   * @return the certification request (CSR).
   */


  pki.certificationRequestFromAsn1 = function (obj, computeHash) {
    // validate certification request and capture data
    var capture = {};
    var errors = [];

    if (!asn1.validate(obj, certificationRequestValidator, capture, errors)) {
      var error = new Error('Cannot read PKCS#10 certificate request. ' + 'ASN.1 object is not a PKCS#10 CertificationRequest.');
      error.errors = errors;
      throw error;
    } // get oid


    var oid = asn1.derToOid(capture.publicKeyOid);

    if (oid !== pki.oids.rsaEncryption) {
      throw new Error('Cannot read public key. OID is not RSA.');
    } // create certification request


    var csr = pki.createCertificationRequest();
    csr.version = capture.csrVersion ? capture.csrVersion.charCodeAt(0) : 0;
    csr.signatureOid = forge.asn1.derToOid(capture.csrSignatureOid);
    csr.signatureParameters = _readSignatureParameters(csr.signatureOid, capture.csrSignatureParams, true);
    csr.siginfo.algorithmOid = forge.asn1.derToOid(capture.csrSignatureOid);
    csr.siginfo.parameters = _readSignatureParameters(csr.siginfo.algorithmOid, capture.csrSignatureParams, false);
    csr.signature = capture.csrSignature; // keep CertificationRequestInfo to preserve signature when exporting

    csr.certificationRequestInfo = capture.certificationRequestInfo;

    if (computeHash) {
      // check signature OID for supported signature types
      csr.md = null;

      if (csr.signatureOid in oids) {
        var oid = oids[csr.signatureOid];

        switch (oid) {
          case 'sha1WithRSAEncryption':
            csr.md = forge.md.sha1.create();
            break;

          case 'md5WithRSAEncryption':
            csr.md = forge.md.md5.create();
            break;

          case 'sha256WithRSAEncryption':
            csr.md = forge.md.sha256.create();
            break;

          case 'sha384WithRSAEncryption':
            csr.md = forge.md.sha384.create();
            break;

          case 'sha512WithRSAEncryption':
            csr.md = forge.md.sha512.create();
            break;

          case 'RSASSA-PSS':
            csr.md = forge.md.sha256.create();
            break;
        }
      }

      if (csr.md === null) {
        var error = new Error('Could not compute certification request digest. ' + 'Unknown signature OID.');
        error.signatureOid = csr.signatureOid;
        throw error;
      } // produce DER formatted CertificationRequestInfo and digest it


      var bytes = asn1.toDer(csr.certificationRequestInfo);
      csr.md.update(bytes.getBytes());
    } // handle subject, build subject message digest


    var smd = forge.md.sha1.create();

    csr.subject.getField = function (sn) {
      return _getAttribute(csr.subject, sn);
    };

    csr.subject.addField = function (attr) {
      _fillMissingFields([attr]);

      csr.subject.attributes.push(attr);
    };

    csr.subject.attributes = pki.RDNAttributesAsArray(capture.certificationRequestInfoSubject, smd);
    csr.subject.hash = smd.digest().toHex(); // convert RSA public key from ASN.1

    csr.publicKey = pki.publicKeyFromAsn1(capture.subjectPublicKeyInfo); // convert attributes from ASN.1

    csr.getAttribute = function (sn) {
      return _getAttribute(csr, sn);
    };

    csr.addAttribute = function (attr) {
      _fillMissingFields([attr]);

      csr.attributes.push(attr);
    };

    csr.attributes = pki.CRIAttributesAsArray(capture.certificationRequestInfoAttributes || []);
    return csr;
  };
  /**
   * Creates an empty certification request (a CSR or certificate signing
   * request). Once created, its public key and attributes can be set and then
   * it can be signed.
   *
   * @return the empty certification request.
   */


  pki.createCertificationRequest = function () {
    var csr = {};
    csr.version = 0x00;
    csr.signatureOid = null;
    csr.signature = null;
    csr.siginfo = {};
    csr.siginfo.algorithmOid = null;
    csr.subject = {};

    csr.subject.getField = function (sn) {
      return _getAttribute(csr.subject, sn);
    };

    csr.subject.addField = function (attr) {
      _fillMissingFields([attr]);

      csr.subject.attributes.push(attr);
    };

    csr.subject.attributes = [];
    csr.subject.hash = null;
    csr.publicKey = null;
    csr.attributes = [];

    csr.getAttribute = function (sn) {
      return _getAttribute(csr, sn);
    };

    csr.addAttribute = function (attr) {
      _fillMissingFields([attr]);

      csr.attributes.push(attr);
    };

    csr.md = null;
    /**
     * Sets the subject of this certification request.
     *
     * @param attrs the array of subject attributes to use.
     */

    csr.setSubject = function (attrs) {
      // set new attributes
      _fillMissingFields(attrs);

      csr.subject.attributes = attrs;
      csr.subject.hash = null;
    };
    /**
     * Sets the attributes of this certification request.
     *
     * @param attrs the array of attributes to use.
     */


    csr.setAttributes = function (attrs) {
      // set new attributes
      _fillMissingFields(attrs);

      csr.attributes = attrs;
    };
    /**
     * Signs this certification request using the given private key.
     *
     * @param key the private key to sign with.
     * @param md the message digest object to use (defaults to forge.md.sha1).
     */


    csr.sign = function (key, md) {
      // TODO: get signature OID from private key
      csr.md = md || forge.md.sha1.create();
      var algorithmOid = oids[csr.md.algorithm + 'WithRSAEncryption'];

      if (!algorithmOid) {
        var error = new Error('Could not compute certification request digest. ' + 'Unknown message digest algorithm OID.');
        error.algorithm = csr.md.algorithm;
        throw error;
      }

      csr.signatureOid = csr.siginfo.algorithmOid = algorithmOid; // get CertificationRequestInfo, convert to DER

      csr.certificationRequestInfo = pki.getCertificationRequestInfo(csr);
      var bytes = asn1.toDer(csr.certificationRequestInfo); // digest and sign

      csr.md.update(bytes.getBytes());
      csr.signature = key.sign(csr.md);
    };
    /**
     * Attempts verify the signature on the passed certification request using
     * its public key.
     *
     * A CSR that has been exported to a file in PEM format can be verified using
     * OpenSSL using this command:
     *
     * openssl req -in <the-csr-pem-file> -verify -noout -text
     *
     * @return true if verified, false if not.
     */


    csr.verify = function () {
      var rval = false;
      var md = csr.md;

      if (md === null) {
        // check signature OID for supported signature types
        if (csr.signatureOid in oids) {
          // TODO: create DRY `OID to md` function
          var oid = oids[csr.signatureOid];

          switch (oid) {
            case 'sha1WithRSAEncryption':
              md = forge.md.sha1.create();
              break;

            case 'md5WithRSAEncryption':
              md = forge.md.md5.create();
              break;

            case 'sha256WithRSAEncryption':
              md = forge.md.sha256.create();
              break;

            case 'sha384WithRSAEncryption':
              md = forge.md.sha384.create();
              break;

            case 'sha512WithRSAEncryption':
              md = forge.md.sha512.create();
              break;

            case 'RSASSA-PSS':
              md = forge.md.sha256.create();
              break;
          }
        }

        if (md === null) {
          var error = new Error('Could not compute certification request digest. ' + 'Unknown signature OID.');
          error.signatureOid = csr.signatureOid;
          throw error;
        } // produce DER formatted CertificationRequestInfo and digest it


        var cri = csr.certificationRequestInfo || pki.getCertificationRequestInfo(csr);
        var bytes = asn1.toDer(cri);
        md.update(bytes.getBytes());
      }

      if (md !== null) {
        var scheme;

        switch (csr.signatureOid) {
          case oids.sha1WithRSAEncryption:
            /* use PKCS#1 v1.5 padding scheme */
            break;

          case oids['RSASSA-PSS']:
            var hash, mgf;
            /* initialize mgf */

            hash = oids[csr.signatureParameters.mgf.hash.algorithmOid];

            if (hash === undefined || forge.md[hash] === undefined) {
              var error = new Error('Unsupported MGF hash function.');
              error.oid = csr.signatureParameters.mgf.hash.algorithmOid;
              error.name = hash;
              throw error;
            }

            mgf = oids[csr.signatureParameters.mgf.algorithmOid];

            if (mgf === undefined || forge.mgf[mgf] === undefined) {
              var error = new Error('Unsupported MGF function.');
              error.oid = csr.signatureParameters.mgf.algorithmOid;
              error.name = mgf;
              throw error;
            }

            mgf = forge.mgf[mgf].create(forge.md[hash].create());
            /* initialize hash function */

            hash = oids[csr.signatureParameters.hash.algorithmOid];

            if (hash === undefined || forge.md[hash] === undefined) {
              var error = new Error('Unsupported RSASSA-PSS hash function.');
              error.oid = csr.signatureParameters.hash.algorithmOid;
              error.name = hash;
              throw error;
            }

            scheme = forge.pss.create(forge.md[hash].create(), mgf, csr.signatureParameters.saltLength);
            break;
        } // verify signature on csr using its public key


        rval = csr.publicKey.verify(md.digest().getBytes(), csr.signature, scheme);
      }

      return rval;
    };

    return csr;
  };
  /**
   * Converts an X.509 subject or issuer to an ASN.1 RDNSequence.
   *
   * @param obj the subject or issuer (distinguished name).
   *
   * @return the ASN.1 RDNSequence.
   */


  function _dnToAsn1(obj) {
    // create an empty RDNSequence
    var rval = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []); // iterate over attributes

    var attr, set;
    var attrs = obj.attributes;

    for (var i = 0; i < attrs.length; ++i) {
      attr = attrs[i];
      var value = attr.value; // reuse tag class for attribute value if available

      var valueTagClass = asn1.Type.PRINTABLESTRING;

      if ('valueTagClass' in attr) {
        valueTagClass = attr.valueTagClass;

        if (valueTagClass === asn1.Type.UTF8) {
          value = forge.util.encodeUtf8(value);
        } // FIXME: handle more encodings

      } // create a RelativeDistinguishedName set
      // each value in the set is an AttributeTypeAndValue first
      // containing the type (an OID) and second the value


      set = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// AttributeType
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(attr.type).getBytes()), // AttributeValue
      asn1.create(asn1.Class.UNIVERSAL, valueTagClass, false, value)])]);
      rval.value.push(set);
    }

    return rval;
  }
  /**
   * Gets all printable attributes (typically of an issuer or subject) in a
   * simplified JSON format for display.
   *
   * @param attrs the attributes.
   *
   * @return the JSON for display.
   */


  function _getAttributesAsJson(attrs) {
    var rval = {};

    for (var i = 0; i < attrs.length; ++i) {
      var attr = attrs[i];

      if (attr.shortName && (attr.valueTagClass === asn1.Type.UTF8 || attr.valueTagClass === asn1.Type.PRINTABLESTRING || attr.valueTagClass === asn1.Type.IA5STRING)) {
        var value = attr.value;

        if (attr.valueTagClass === asn1.Type.UTF8) {
          value = forge.util.encodeUtf8(attr.value);
        }

        if (!(attr.shortName in rval)) {
          rval[attr.shortName] = value;
        } else if (forge.util.isArray(rval[attr.shortName])) {
          rval[attr.shortName].push(value);
        } else {
          rval[attr.shortName] = [rval[attr.shortName], value];
        }
      }
    }

    return rval;
  }
  /**
   * Fills in missing fields in attributes.
   *
   * @param attrs the attributes to fill missing fields in.
   */


  function _fillMissingFields(attrs) {
    var attr;

    for (var i = 0; i < attrs.length; ++i) {
      attr = attrs[i]; // populate missing name

      if (typeof attr.name === 'undefined') {
        if (attr.type && attr.type in pki.oids) {
          attr.name = pki.oids[attr.type];
        } else if (attr.shortName && attr.shortName in _shortNames) {
          attr.name = pki.oids[_shortNames[attr.shortName]];
        }
      } // populate missing type (OID)


      if (typeof attr.type === 'undefined') {
        if (attr.name && attr.name in pki.oids) {
          attr.type = pki.oids[attr.name];
        } else {
          var error = new Error('Attribute type not specified.');
          error.attribute = attr;
          throw error;
        }
      } // populate missing shortname


      if (typeof attr.shortName === 'undefined') {
        if (attr.name && attr.name in _shortNames) {
          attr.shortName = _shortNames[attr.name];
        }
      } // convert extensions to value


      if (attr.type === oids.extensionRequest) {
        attr.valueConstructed = true;
        attr.valueTagClass = asn1.Type.SEQUENCE;

        if (!attr.value && attr.extensions) {
          attr.value = [];

          for (var ei = 0; ei < attr.extensions.length; ++ei) {
            attr.value.push(pki.certificateExtensionToAsn1(_fillMissingExtensionFields(attr.extensions[ei])));
          }
        }
      }

      if (typeof attr.value === 'undefined') {
        var error = new Error('Attribute value not specified.');
        error.attribute = attr;
        throw error;
      }
    }
  }
  /**
   * Fills in missing fields in certificate extensions.
   *
   * @param e the extension.
   * @param [options] the options to use.
   *          [cert] the certificate the extensions are for.
   *
   * @return the extension.
   */


  function _fillMissingExtensionFields(e, options) {
    options = options || {}; // populate missing name

    if (typeof e.name === 'undefined') {
      if (e.id && e.id in pki.oids) {
        e.name = pki.oids[e.id];
      }
    } // populate missing id


    if (typeof e.id === 'undefined') {
      if (e.name && e.name in pki.oids) {
        e.id = pki.oids[e.name];
      } else {
        var error = new Error('Extension ID not specified.');
        error.extension = e;
        throw error;
      }
    }

    if (typeof e.value !== 'undefined') {
      return e;
    } // handle missing value:
    // value is a BIT STRING


    if (e.name === 'keyUsage') {
      // build flags
      var unused = 0;
      var b2 = 0x00;
      var b3 = 0x00;

      if (e.digitalSignature) {
        b2 |= 0x80;
        unused = 7;
      }

      if (e.nonRepudiation) {
        b2 |= 0x40;
        unused = 6;
      }

      if (e.keyEncipherment) {
        b2 |= 0x20;
        unused = 5;
      }

      if (e.dataEncipherment) {
        b2 |= 0x10;
        unused = 4;
      }

      if (e.keyAgreement) {
        b2 |= 0x08;
        unused = 3;
      }

      if (e.keyCertSign) {
        b2 |= 0x04;
        unused = 2;
      }

      if (e.cRLSign) {
        b2 |= 0x02;
        unused = 1;
      }

      if (e.encipherOnly) {
        b2 |= 0x01;
        unused = 0;
      }

      if (e.decipherOnly) {
        b3 |= 0x80;
        unused = 7;
      } // create bit string


      var value = String.fromCharCode(unused);

      if (b3 !== 0) {
        value += String.fromCharCode(b2) + String.fromCharCode(b3);
      } else if (b2 !== 0) {
        value += String.fromCharCode(b2);
      }

      e.value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.BITSTRING, false, value);
    } else if (e.name === 'basicConstraints') {
      // basicConstraints is a SEQUENCE
      e.value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []); // cA BOOLEAN flag defaults to false

      if (e.cA) {
        e.value.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.BOOLEAN, false, String.fromCharCode(0xFF)));
      }

      if ('pathLenConstraint' in e) {
        e.value.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(e.pathLenConstraint).getBytes()));
      }
    } else if (e.name === 'extKeyUsage') {
      // extKeyUsage is a SEQUENCE of OIDs
      e.value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []);
      var seq = e.value.value;

      for (var key in e) {
        if (e[key] !== true) {
          continue;
        } // key is name in OID map


        if (key in oids) {
          seq.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(oids[key]).getBytes()));
        } else if (key.indexOf('.') !== -1) {
          // assume key is an OID
          seq.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(key).getBytes()));
        }
      }
    } else if (e.name === 'nsCertType') {
      // nsCertType is a BIT STRING
      // build flags
      var unused = 0;
      var b2 = 0x00;

      if (e.client) {
        b2 |= 0x80;
        unused = 7;
      }

      if (e.server) {
        b2 |= 0x40;
        unused = 6;
      }

      if (e.email) {
        b2 |= 0x20;
        unused = 5;
      }

      if (e.objsign) {
        b2 |= 0x10;
        unused = 4;
      }

      if (e.reserved) {
        b2 |= 0x08;
        unused = 3;
      }

      if (e.sslCA) {
        b2 |= 0x04;
        unused = 2;
      }

      if (e.emailCA) {
        b2 |= 0x02;
        unused = 1;
      }

      if (e.objCA) {
        b2 |= 0x01;
        unused = 0;
      } // create bit string


      var value = String.fromCharCode(unused);

      if (b2 !== 0) {
        value += String.fromCharCode(b2);
      }

      e.value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.BITSTRING, false, value);
    } else if (e.name === 'subjectAltName' || e.name === 'issuerAltName') {
      // SYNTAX SEQUENCE
      e.value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []);
      var altName;

      for (var n = 0; n < e.altNames.length; ++n) {
        altName = e.altNames[n];
        var value = altName.value; // handle IP

        if (altName.type === 7 && altName.ip) {
          value = forge.util.bytesFromIP(altName.ip);

          if (value === null) {
            var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
            error.extension = e;
            throw error;
          }
        } else if (altName.type === 8) {
          // handle OID
          if (altName.oid) {
            value = asn1.oidToDer(asn1.oidToDer(altName.oid));
          } else {
            // deprecated ... convert value to OID
            value = asn1.oidToDer(value);
          }
        }

        e.value.value.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, altName.type, false, value));
      }
    } else if (e.name === 'subjectKeyIdentifier' && options.cert) {
      var ski = options.cert.generateSubjectKeyIdentifier();
      e.subjectKeyIdentifier = ski.toHex(); // OCTETSTRING w/digest

      e.value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, ski.getBytes());
    } else if (e.name === 'authorityKeyIdentifier' && options.cert) {
      // SYNTAX SEQUENCE
      e.value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []);
      var seq = e.value.value;

      if (e.keyIdentifier) {
        var keyIdentifier = e.keyIdentifier === true ? options.cert.generateSubjectKeyIdentifier().getBytes() : e.keyIdentifier;
        seq.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, false, keyIdentifier));
      }

      if (e.authorityCertIssuer) {
        var authorityCertIssuer = [asn1.create(asn1.Class.CONTEXT_SPECIFIC, 4, true, [_dnToAsn1(e.authorityCertIssuer === true ? options.cert.issuer : e.authorityCertIssuer)])];
        seq.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 1, true, authorityCertIssuer));
      }

      if (e.serialNumber) {
        var serialNumber = forge.util.hexToBytes(e.serialNumber === true ? options.cert.serialNumber : e.serialNumber);
        seq.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 2, false, serialNumber));
      }
    } else if (e.name === 'cRLDistributionPoints') {
      e.value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []);
      var seq = e.value.value; // Create sub SEQUENCE of DistributionPointName

      var subSeq = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []); // Create fullName CHOICE

      var fullNameGeneralNames = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
      var altName;

      for (var n = 0; n < e.altNames.length; ++n) {
        altName = e.altNames[n];
        var value = altName.value; // handle IP

        if (altName.type === 7 && altName.ip) {
          value = forge.util.bytesFromIP(altName.ip);

          if (value === null) {
            var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
            error.extension = e;
            throw error;
          }
        } else if (altName.type === 8) {
          // handle OID
          if (altName.oid) {
            value = asn1.oidToDer(asn1.oidToDer(altName.oid));
          } else {
            // deprecated ... convert value to OID
            value = asn1.oidToDer(value);
          }
        }

        fullNameGeneralNames.value.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, altName.type, false, value));
      } // Add to the parent SEQUENCE


      subSeq.value.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [fullNameGeneralNames]));
      seq.push(subSeq);
    } // ensure value has been defined by now


    if (typeof e.value === 'undefined') {
      var error = new Error('Extension value not specified.');
      error.extension = e;
      throw error;
    }

    return e;
  }
  /**
   * Convert signature parameters object to ASN.1
   *
   * @param {String} oid Signature algorithm OID
   * @param params The signature parametrs object
   * @return ASN.1 object representing signature parameters
   */


  function _signatureParametersToAsn1(oid, params) {
    switch (oid) {
      case oids['RSASSA-PSS']:
        var parts = [];

        if (params.hash.algorithmOid !== undefined) {
          parts.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(params.hash.algorithmOid).getBytes()), asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '')])]));
        }

        if (params.mgf.algorithmOid !== undefined) {
          parts.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 1, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(params.mgf.algorithmOid).getBytes()), asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(params.mgf.hash.algorithmOid).getBytes()), asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '')])])]));
        }

        if (params.saltLength !== undefined) {
          parts.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 2, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(params.saltLength).getBytes())]));
        }

        return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, parts);

      default:
        return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '');
    }
  }
  /**
   * Converts a certification request's attributes to an ASN.1 set of
   * CRIAttributes.
   *
   * @param csr certification request.
   *
   * @return the ASN.1 set of CRIAttributes.
   */


  function _CRIAttributesToAsn1(csr) {
    // create an empty context-specific container
    var rval = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, []); // no attributes, return empty container

    if (csr.attributes.length === 0) {
      return rval;
    } // each attribute has a sequence with a type and a set of values


    var attrs = csr.attributes;

    for (var i = 0; i < attrs.length; ++i) {
      var attr = attrs[i];
      var value = attr.value; // reuse tag class for attribute value if available

      var valueTagClass = asn1.Type.UTF8;

      if ('valueTagClass' in attr) {
        valueTagClass = attr.valueTagClass;
      }

      if (valueTagClass === asn1.Type.UTF8) {
        value = forge.util.encodeUtf8(value);
      }

      var valueConstructed = false;

      if ('valueConstructed' in attr) {
        valueConstructed = attr.valueConstructed;
      } // FIXME: handle more encodings
      // create a RelativeDistinguishedName set
      // each value in the set is an AttributeTypeAndValue first
      // containing the type (an OID) and second the value


      var seq = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// AttributeType
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(attr.type).getBytes()), asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, [// AttributeValue
      asn1.create(asn1.Class.UNIVERSAL, valueTagClass, valueConstructed, value)])]);
      rval.value.push(seq);
    }

    return rval;
  }
  /**
   * Gets the ASN.1 TBSCertificate part of an X.509v3 certificate.
   *
   * @param cert the certificate.
   *
   * @return the asn1 TBSCertificate.
   */


  pki.getTBSCertificate = function (cert) {
    // TBSCertificate
    var tbs = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// version
    asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [// integer
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(cert.version).getBytes())]), // serialNumber
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, forge.util.hexToBytes(cert.serialNumber)), // signature
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// algorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(cert.siginfo.algorithmOid).getBytes()), // parameters
    _signatureParametersToAsn1(cert.siginfo.algorithmOid, cert.siginfo.parameters)]), // issuer
    _dnToAsn1(cert.issuer), // validity
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// notBefore
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.UTCTIME, false, asn1.dateToUtcTime(cert.validity.notBefore)), // notAfter
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.UTCTIME, false, asn1.dateToUtcTime(cert.validity.notAfter))]), // subject
    _dnToAsn1(cert.subject), // SubjectPublicKeyInfo
    pki.publicKeyToAsn1(cert.publicKey)]);

    if (cert.issuer.uniqueId) {
      // issuerUniqueID (optional)
      tbs.value.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 1, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.BITSTRING, false, // TODO: support arbitrary bit length ids
      String.fromCharCode(0x00) + cert.issuer.uniqueId)]));
    }

    if (cert.subject.uniqueId) {
      // subjectUniqueID (optional)
      tbs.value.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 2, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.BITSTRING, false, // TODO: support arbitrary bit length ids
      String.fromCharCode(0x00) + cert.subject.uniqueId)]));
    }

    if (cert.extensions.length > 0) {
      // extensions (optional)
      tbs.value.push(pki.certificateExtensionsToAsn1(cert.extensions));
    }

    return tbs;
  };
  /**
   * Gets the ASN.1 CertificationRequestInfo part of a
   * PKCS#10 CertificationRequest.
   *
   * @param csr the certification request.
   *
   * @return the asn1 CertificationRequestInfo.
   */


  pki.getCertificationRequestInfo = function (csr) {
    // CertificationRequestInfo
    var cri = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// version
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(csr.version).getBytes()), // subject
    _dnToAsn1(csr.subject), // SubjectPublicKeyInfo
    pki.publicKeyToAsn1(csr.publicKey), // attributes
    _CRIAttributesToAsn1(csr)]);
    return cri;
  };
  /**
   * Converts a DistinguishedName (subject or issuer) to an ASN.1 object.
   *
   * @param dn the DistinguishedName.
   *
   * @return the asn1 representation of a DistinguishedName.
   */


  pki.distinguishedNameToAsn1 = function (dn) {
    return _dnToAsn1(dn);
  };
  /**
   * Converts an X.509v3 RSA certificate to an ASN.1 object.
   *
   * @param cert the certificate.
   *
   * @return the asn1 representation of an X.509v3 RSA certificate.
   */


  pki.certificateToAsn1 = function (cert) {
    // prefer cached TBSCertificate over generating one
    var tbsCertificate = cert.tbsCertificate || pki.getTBSCertificate(cert); // Certificate

    return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// TBSCertificate
    tbsCertificate, // AlgorithmIdentifier (signature algorithm)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// algorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(cert.signatureOid).getBytes()), // parameters
    _signatureParametersToAsn1(cert.signatureOid, cert.signatureParameters)]), // SignatureValue
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.BITSTRING, false, String.fromCharCode(0x00) + cert.signature)]);
  };
  /**
   * Converts X.509v3 certificate extensions to ASN.1.
   *
   * @param exts the extensions to convert.
   *
   * @return the extensions in ASN.1 format.
   */


  pki.certificateExtensionsToAsn1 = function (exts) {
    // create top-level extension container
    var rval = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 3, true, []); // create extension sequence (stores a sequence for each extension)

    var seq = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []);
    rval.value.push(seq);

    for (var i = 0; i < exts.length; ++i) {
      seq.value.push(pki.certificateExtensionToAsn1(exts[i]));
    }

    return rval;
  };
  /**
   * Converts a single certificate extension to ASN.1.
   *
   * @param ext the extension to convert.
   *
   * @return the extension in ASN.1 format.
   */


  pki.certificateExtensionToAsn1 = function (ext) {
    // create a sequence for each extension
    var extseq = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, []); // extnID (OID)

    extseq.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(ext.id).getBytes())); // critical defaults to false

    if (ext.critical) {
      // critical BOOLEAN DEFAULT FALSE
      extseq.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.BOOLEAN, false, String.fromCharCode(0xFF)));
    }

    var value = ext.value;

    if (typeof ext.value !== 'string') {
      // value is asn.1
      value = asn1.toDer(value).getBytes();
    } // extnValue (OCTET STRING)


    extseq.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, value));
    return extseq;
  };
  /**
   * Converts a PKCS#10 certification request to an ASN.1 object.
   *
   * @param csr the certification request.
   *
   * @return the asn1 representation of a certification request.
   */


  pki.certificationRequestToAsn1 = function (csr) {
    // prefer cached CertificationRequestInfo over generating one
    var cri = csr.certificationRequestInfo || pki.getCertificationRequestInfo(csr); // Certificate

    return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// CertificationRequestInfo
    cri, // AlgorithmIdentifier (signature algorithm)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// algorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(csr.signatureOid).getBytes()), // parameters
    _signatureParametersToAsn1(csr.signatureOid, csr.signatureParameters)]), // signature
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.BITSTRING, false, String.fromCharCode(0x00) + csr.signature)]);
  };
  /**
   * Creates a CA store.
   *
   * @param certs an optional array of certificate objects or PEM-formatted
   *          certificate strings to add to the CA store.
   *
   * @return the CA store.
   */


  pki.createCaStore = function (certs) {
    // create CA store
    var caStore = {
      // stored certificates
      certs: {}
    };
    /**
     * Gets the certificate that issued the passed certificate or its
     * 'parent'.
     *
     * @param cert the certificate to get the parent for.
     *
     * @return the parent certificate or null if none was found.
     */

    caStore.getIssuer = function (cert) {
      var rval = getBySubject(cert.issuer); // see if there are multiple matches

      /*if(forge.util.isArray(rval)) {
        // TODO: resolve multiple matches by checking
        // authorityKey/subjectKey/issuerUniqueID/other identifiers, etc.
        // FIXME: or alternatively do authority key mapping
        // if possible (X.509v1 certs can't work?)
        throw new Error('Resolving multiple issuer matches not implemented yet.');
      }*/

      return rval;
    };
    /**
     * Adds a trusted certificate to the store.
     *
     * @param cert the certificate to add as a trusted certificate (either a
     *          pki.certificate object or a PEM-formatted certificate).
     */


    caStore.addCertificate = function (cert) {
      // convert from pem if necessary
      if (typeof cert === 'string') {
        cert = forge.pki.certificateFromPem(cert);
      }

      ensureSubjectHasHash(cert.subject);

      if (!caStore.hasCertificate(cert)) {
        // avoid duplicate certificates in store
        if (cert.subject.hash in caStore.certs) {
          // subject hash already exists, append to array
          var tmp = caStore.certs[cert.subject.hash];

          if (!forge.util.isArray(tmp)) {
            tmp = [tmp];
          }

          tmp.push(cert);
          caStore.certs[cert.subject.hash] = tmp;
        } else {
          caStore.certs[cert.subject.hash] = cert;
        }
      }
    };
    /**
     * Checks to see if the given certificate is in the store.
     *
     * @param cert the certificate to check (either a pki.certificate or a
     *          PEM-formatted certificate).
     *
     * @return true if the certificate is in the store, false if not.
     */


    caStore.hasCertificate = function (cert) {
      // convert from pem if necessary
      if (typeof cert === 'string') {
        cert = forge.pki.certificateFromPem(cert);
      }

      var match = getBySubject(cert.subject);

      if (!match) {
        return false;
      }

      if (!forge.util.isArray(match)) {
        match = [match];
      } // compare DER-encoding of certificates


      var der1 = asn1.toDer(pki.certificateToAsn1(cert)).getBytes();

      for (var i = 0; i < match.length; ++i) {
        var der2 = asn1.toDer(pki.certificateToAsn1(match[i])).getBytes();

        if (der1 === der2) {
          return true;
        }
      }

      return false;
    };
    /**
     * Lists all of the certificates kept in the store.
     *
     * @return an array of all of the pki.certificate objects in the store.
     */


    caStore.listAllCertificates = function () {
      var certList = [];

      for (var hash in caStore.certs) {
        if (caStore.certs.hasOwnProperty(hash)) {
          var value = caStore.certs[hash];

          if (!forge.util.isArray(value)) {
            certList.push(value);
          } else {
            for (var i = 0; i < value.length; ++i) {
              certList.push(value[i]);
            }
          }
        }
      }

      return certList;
    };
    /**
     * Removes a certificate from the store.
     *
     * @param cert the certificate to remove (either a pki.certificate or a
     *          PEM-formatted certificate).
     *
     * @return the certificate that was removed or null if the certificate
     *           wasn't in store.
     */


    caStore.removeCertificate = function (cert) {
      var result; // convert from pem if necessary

      if (typeof cert === 'string') {
        cert = forge.pki.certificateFromPem(cert);
      }

      ensureSubjectHasHash(cert.subject);

      if (!caStore.hasCertificate(cert)) {
        return null;
      }

      var match = getBySubject(cert.subject);

      if (!forge.util.isArray(match)) {
        result = caStore.certs[cert.subject.hash];
        delete caStore.certs[cert.subject.hash];
        return result;
      } // compare DER-encoding of certificates


      var der1 = asn1.toDer(pki.certificateToAsn1(cert)).getBytes();

      for (var i = 0; i < match.length; ++i) {
        var der2 = asn1.toDer(pki.certificateToAsn1(match[i])).getBytes();

        if (der1 === der2) {
          result = match[i];
          match.splice(i, 1);
        }
      }

      if (match.length === 0) {
        delete caStore.certs[cert.subject.hash];
      }

      return result;
    };

    function getBySubject(subject) {
      ensureSubjectHasHash(subject);
      return caStore.certs[subject.hash] || null;
    }

    function ensureSubjectHasHash(subject) {
      // produce subject hash if it doesn't exist
      if (!subject.hash) {
        var md = forge.md.sha1.create();
        subject.attributes = pki.RDNAttributesAsArray(_dnToAsn1(subject), md);
        subject.hash = md.digest().toHex();
      }
    } // auto-add passed in certs


    if (certs) {
      // parse PEM-formatted certificates as necessary
      for (var i = 0; i < certs.length; ++i) {
        var cert = certs[i];
        caStore.addCertificate(cert);
      }
    }

    return caStore;
  };
  /**
   * Certificate verification errors, based on TLS.
   */


  pki.certificateError = {
    bad_certificate: 'forge.pki.BadCertificate',
    unsupported_certificate: 'forge.pki.UnsupportedCertificate',
    certificate_revoked: 'forge.pki.CertificateRevoked',
    certificate_expired: 'forge.pki.CertificateExpired',
    certificate_unknown: 'forge.pki.CertificateUnknown',
    unknown_ca: 'forge.pki.UnknownCertificateAuthority'
  };
  /**
   * Verifies a certificate chain against the given Certificate Authority store
   * with an optional custom verify callback.
   *
   * @param caStore a certificate store to verify against.
   * @param chain the certificate chain to verify, with the root or highest
   *          authority at the end (an array of certificates).
   * @param verify called for every certificate in the chain.
   *
   * The verify callback has the following signature:
   *
   * verified - Set to true if certificate was verified, otherwise the
   *   pki.certificateError for why the certificate failed.
   * depth - The current index in the chain, where 0 is the end point's cert.
   * certs - The certificate chain, *NOTE* an empty chain indicates an anonymous
   *   end point.
   *
   * The function returns true on success and on failure either the appropriate
   * pki.certificateError or an object with 'error' set to the appropriate
   * pki.certificateError and 'message' set to a custom error message.
   *
   * @return true if successful, error thrown if not.
   */

  pki.verifyCertificateChain = function (caStore, chain, verify) {
    /* From: RFC3280 - Internet X.509 Public Key Infrastructure Certificate
      Section 6: Certification Path Validation
      See inline parentheticals related to this particular implementation.
       The primary goal of path validation is to verify the binding between
      a subject distinguished name or a subject alternative name and subject
      public key, as represented in the end entity certificate, based on the
      public key of the trust anchor. This requires obtaining a sequence of
      certificates that support that binding. That sequence should be provided
      in the passed 'chain'. The trust anchor should be in the given CA
      store. The 'end entity' certificate is the certificate provided by the
      end point (typically a server) and is the first in the chain.
       To meet this goal, the path validation process verifies, among other
      things, that a prospective certification path (a sequence of n
      certificates or a 'chain') satisfies the following conditions:
       (a) for all x in {1, ..., n-1}, the subject of certificate x is
            the issuer of certificate x+1;
       (b) certificate 1 is issued by the trust anchor;
       (c) certificate n is the certificate to be validated; and
       (d) for all x in {1, ..., n}, the certificate was valid at the
            time in question.
       Note that here 'n' is index 0 in the chain and 1 is the last certificate
      in the chain and it must be signed by a certificate in the connection's
      CA store.
       The path validation process also determines the set of certificate
      policies that are valid for this path, based on the certificate policies
      extension, policy mapping extension, policy constraints extension, and
      inhibit any-policy extension.
       Note: Policy mapping extension not supported (Not Required).
       Note: If the certificate has an unsupported critical extension, then it
      must be rejected.
       Note: A certificate is self-issued if the DNs that appear in the subject
      and issuer fields are identical and are not empty.
       The path validation algorithm assumes the following seven inputs are
      provided to the path processing logic. What this specific implementation
      will use is provided parenthetically:
       (a) a prospective certification path of length n (the 'chain')
      (b) the current date/time: ('now').
      (c) user-initial-policy-set: A set of certificate policy identifiers
            naming the policies that are acceptable to the certificate user.
            The user-initial-policy-set contains the special value any-policy
            if the user is not concerned about certificate policy
            (Not implemented. Any policy is accepted).
      (d) trust anchor information, describing a CA that serves as a trust
            anchor for the certification path. The trust anchor information
            includes:
         (1)  the trusted issuer name,
        (2)  the trusted public key algorithm,
        (3)  the trusted public key, and
        (4)  optionally, the trusted public key parameters associated
               with the public key.
         (Trust anchors are provided via certificates in the CA store).
         The trust anchor information may be provided to the path processing
        procedure in the form of a self-signed certificate. The trusted anchor
        information is trusted because it was delivered to the path processing
        procedure by some trustworthy out-of-band procedure. If the trusted
        public key algorithm requires parameters, then the parameters are
        provided along with the trusted public key (No parameters used in this
        implementation).
       (e) initial-policy-mapping-inhibit, which indicates if policy mapping is
            allowed in the certification path.
            (Not implemented, no policy checking)
       (f) initial-explicit-policy, which indicates if the path must be valid
            for at least one of the certificate policies in the user-initial-
            policy-set.
            (Not implemented, no policy checking)
       (g) initial-any-policy-inhibit, which indicates whether the
            anyPolicy OID should be processed if it is included in a
            certificate.
            (Not implemented, so any policy is valid provided that it is
            not marked as critical) */

    /* Basic Path Processing:
       For each certificate in the 'chain', the following is checked:
       1. The certificate validity period includes the current time.
      2. The certificate was signed by its parent (where the parent is either
         the next in the chain or from the CA store). Allow processing to
         continue to the next step if no parent is found but the certificate is
         in the CA store.
      3. TODO: The certificate has not been revoked.
      4. The certificate issuer name matches the parent's subject name.
      5. TODO: If the certificate is self-issued and not the final certificate
         in the chain, skip this step, otherwise verify that the subject name
         is within one of the permitted subtrees of X.500 distinguished names
         and that each of the alternative names in the subjectAltName extension
         (critical or non-critical) is within one of the permitted subtrees for
         that name type.
      6. TODO: If the certificate is self-issued and not the final certificate
         in the chain, skip this step, otherwise verify that the subject name
         is not within one of the excluded subtrees for X.500 distinguished
         names and none of the subjectAltName extension names are excluded for
         that name type.
      7. The other steps in the algorithm for basic path processing involve
         handling the policy extension which is not presently supported in this
         implementation. Instead, if a critical policy extension is found, the
         certificate is rejected as not supported.
      8. If the certificate is not the first or if its the only certificate in
         the chain (having no parent from the CA store or is self-signed) and it
         has a critical key usage extension, verify that the keyCertSign bit is
         set. If the key usage extension exists, verify that the basic
         constraints extension exists. If the basic constraints extension exists,
         verify that the cA flag is set. If pathLenConstraint is set, ensure that
         the number of certificates that precede in the chain (come earlier
         in the chain as implemented below), excluding the very first in the
         chain (typically the end-entity one), isn't greater than the
         pathLenConstraint. This constraint limits the number of intermediate
         CAs that may appear below a CA before only end-entity certificates
         may be issued. */
    // copy cert chain references to another array to protect against changes
    // in verify callback
    chain = chain.slice(0);
    var certs = chain.slice(0); // get current date

    var now = new Date(); // verify each cert in the chain using its parent, where the parent
    // is either the next in the chain or from the CA store

    var first = true;
    var error = null;
    var depth = 0;

    do {
      var cert = chain.shift();
      var parent = null;
      var selfSigned = false; // 1. check valid time

      if (now < cert.validity.notBefore || now > cert.validity.notAfter) {
        error = {
          message: 'Certificate is not valid yet or has expired.',
          error: pki.certificateError.certificate_expired,
          notBefore: cert.validity.notBefore,
          notAfter: cert.validity.notAfter,
          now: now
        };
      } // 2. verify with parent from chain or CA store


      if (error === null) {
        parent = chain[0] || caStore.getIssuer(cert);

        if (parent === null) {
          // check for self-signed cert
          if (cert.isIssuer(cert)) {
            selfSigned = true;
            parent = cert;
          }
        }

        if (parent) {
          // FIXME: current CA store implementation might have multiple
          // certificates where the issuer can't be determined from the
          // certificate (happens rarely with, eg: old certificates) so normalize
          // by always putting parents into an array
          // TODO: there's may be an extreme degenerate case currently uncovered
          // where an old intermediate certificate seems to have a matching parent
          // but none of the parents actually verify ... but the intermediate
          // is in the CA and it should pass this check; needs investigation
          var parents = parent;

          if (!forge.util.isArray(parents)) {
            parents = [parents];
          } // try to verify with each possible parent (typically only one)


          var verified = false;

          while (!verified && parents.length > 0) {
            parent = parents.shift();

            try {
              verified = parent.verify(cert);
            } catch (ex) {// failure to verify, don't care why, try next one
            }
          }

          if (!verified) {
            error = {
              message: 'Certificate signature is invalid.',
              error: pki.certificateError.bad_certificate
            };
          }
        }

        if (error === null && (!parent || selfSigned) && !caStore.hasCertificate(cert)) {
          // no parent issuer and certificate itself is not trusted
          error = {
            message: 'Certificate is not trusted.',
            error: pki.certificateError.unknown_ca
          };
        }
      } // TODO: 3. check revoked
      // 4. check for matching issuer/subject


      if (error === null && parent && !cert.isIssuer(parent)) {
        // parent is not issuer
        error = {
          message: 'Certificate issuer is invalid.',
          error: pki.certificateError.bad_certificate
        };
      } // 5. TODO: check names with permitted names tree
      // 6. TODO: check names against excluded names tree
      // 7. check for unsupported critical extensions


      if (error === null) {
        // supported extensions
        var se = {
          keyUsage: true,
          basicConstraints: true
        };

        for (var i = 0; error === null && i < cert.extensions.length; ++i) {
          var ext = cert.extensions[i];

          if (ext.critical && !(ext.name in se)) {
            error = {
              message: 'Certificate has an unsupported critical extension.',
              error: pki.certificateError.unsupported_certificate
            };
          }
        }
      } // 8. check for CA if cert is not first or is the only certificate
      // remaining in chain with no parent or is self-signed


      if (error === null && (!first || chain.length === 0 && (!parent || selfSigned))) {
        // first check keyUsage extension and then basic constraints
        var bcExt = cert.getExtension('basicConstraints');
        var keyUsageExt = cert.getExtension('keyUsage');

        if (keyUsageExt !== null) {
          // keyCertSign must be true and there must be a basic
          // constraints extension
          if (!keyUsageExt.keyCertSign || bcExt === null) {
            // bad certificate
            error = {
              message: 'Certificate keyUsage or basicConstraints conflict ' + 'or indicate that the certificate is not a CA. ' + 'If the certificate is the only one in the chain or ' + 'isn\'t the first then the certificate must be a ' + 'valid CA.',
              error: pki.certificateError.bad_certificate
            };
          }
        } // basic constraints cA flag must be set


        if (error === null && bcExt !== null && !bcExt.cA) {
          // bad certificate
          error = {
            message: 'Certificate basicConstraints indicates the certificate ' + 'is not a CA.',
            error: pki.certificateError.bad_certificate
          };
        } // if error is not null and keyUsage is available, then we know it
        // has keyCertSign and there is a basic constraints extension too,
        // which means we can check pathLenConstraint (if it exists)


        if (error === null && keyUsageExt !== null && 'pathLenConstraint' in bcExt) {
          // pathLen is the maximum # of intermediate CA certs that can be
          // found between the current certificate and the end-entity (depth 0)
          // certificate; this number does not include the end-entity (depth 0,
          // last in the chain) even if it happens to be a CA certificate itself
          var pathLen = depth - 1;

          if (pathLen > bcExt.pathLenConstraint) {
            // pathLenConstraint violated, bad certificate
            error = {
              message: 'Certificate basicConstraints pathLenConstraint violated.',
              error: pki.certificateError.bad_certificate
            };
          }
        }
      } // call application callback


      var vfd = error === null ? true : error.error;
      var ret = verify ? verify(vfd, depth, certs) : vfd;

      if (ret === true) {
        // clear any set error
        error = null;
      } else {
        // if passed basic tests, set default message and alert
        if (vfd === true) {
          error = {
            message: 'The application rejected the certificate.',
            error: pki.certificateError.bad_certificate
          };
        } // check for custom error info


        if (ret || ret === 0) {
          // set custom message and error
          if (typeof ret === 'object' && !forge.util.isArray(ret)) {
            if (ret.message) {
              error.message = ret.message;
            }

            if (ret.error) {
              error.error = ret.error;
            }
          } else if (typeof ret === 'string') {
            // set custom error
            error.error = ret;
          }
        } // throw error


        throw error;
      } // no longer first cert in chain


      first = false;
      ++depth;
    } while (chain.length > 0);

    return true;
  };
  /***/

},
/* 150 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/aes-kw.js - AES-KW Key-Wrapping
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var helpers = __webpack_require__(30),
        forge = __webpack_require__(14),
        DataBuffer = __webpack_require__(82);

    var A0 = Buffer.from("a6a6a6a6a6a6a6a6", "hex"); // ### helpers

    function xor(a, b) {
      var len = Math.max(a.length, b.length);
      var result = Buffer.alloc(len);

      for (var idx = 0; len > idx; idx++) {
        result[idx] = (a[idx] || 0) ^ (b[idx] || 0);
      }

      return result;
    }

    function split(input, size) {
      var output = [];

      for (var idx = 0; input.length > idx; idx += size) {
        output.push(input.slice(idx, idx + size));
      }

      return output;
    }

    function longToBigEndian(input) {
      var hi = Math.floor(input / 4294967296),
          lo = input % 4294967296;
      var output = Buffer.alloc(8);
      output[0] = 0xff & hi >>> 24;
      output[1] = 0xff & hi >>> 16;
      output[2] = 0xff & hi >>> 8;
      output[3] = 0xff & hi >>> 0;
      output[4] = 0xff & lo >>> 24;
      output[5] = 0xff & lo >>> 16;
      output[6] = 0xff & lo >>> 8;
      output[7] = 0xff & lo >>> 0;
      return output;
    }

    function kwEncryptFN(size) {
      function commonChecks(key, data) {
        if (size !== key.length << 3) {
          throw new Error("invalid key size");
        }

        if (0 < data.length && 0 !== data.length % 8) {
          throw new Error("invalid data length");
        }
      } // ### 'fallback' implementation -- uses forge


      var fallback = function fallback(key, pdata) {
        try {
          commonChecks(key, pdata);
        } catch (err) {
          return Promise.reject(err);
        } // setup cipher


        var cipher = forge.cipher.createCipher("AES", new DataBuffer(key)); // split input into chunks

        var R = split(pdata, 8);
        var A, B, count;
        A = A0;

        for (var jdx = 0; 6 > jdx; jdx++) {
          for (var idx = 0; R.length > idx; idx++) {
            count = R.length * jdx + idx + 1;
            B = Buffer.concat([A, R[idx]]);
            cipher.start();
            cipher.update(new DataBuffer(B));
            cipher.finish();
            B = cipher.output.native();
            A = xor(B.slice(0, 8), longToBigEndian(count));
            R[idx] = B.slice(8, 16);
          }
        }

        R = [A].concat(R);
        var cdata = Buffer.concat(R);
        return Promise.resolve({
          data: cdata
        });
      }; // ### WebCryptoAPI implementation


      var webcrypto = function webcrypto(key, pdata) {
        try {
          commonChecks(key, pdata);
        } catch (err) {
          return Promise.reject(err);
        }

        var alg = {
          name: "AES-KW"
        };
        var promise = [helpers.subtleCrypto.importKey("raw", pdata, {
          name: "HMAC",
          hash: "SHA-256"
        }, true, ["sign"]), helpers.subtleCrypto.importKey("raw", key, alg, true, ["wrapKey"])];
        promise = Promise.all(promise);
        promise = promise.then(function (keys) {
          return helpers.subtleCrypto.wrapKey("raw", keys[0], // key
          keys[1], // wrappingKey
          alg);
        });
        promise = promise.then(function (result) {
          result = Buffer.from(result);
          return {
            data: result
          };
        });
        return promise;
      };

      var node = function node(key, pdata) {
        try {
          commonChecks(key, pdata);
        } catch (err) {
          return Promise.reject(err);
        } // split input into chunks


        var R = split(pdata, 8),
            iv = Buffer.alloc(16);
        var A, B, count;
        A = A0;

        for (var jdx = 0; 6 > jdx; jdx++) {
          for (var idx = 0; R.length > idx; idx++) {
            count = R.length * jdx + idx + 1;
            B = Buffer.concat([A, R[idx]]);
            var cipher = helpers.nodeCrypto.createCipheriv("AES" + size, key, iv);
            B = cipher.update(B);
            A = xor(B.slice(0, 8), longToBigEndian(count));
            R[idx] = B.slice(8, 16);
          }
        }

        R = [A].concat(R);
        var cdata = Buffer.concat(R);
        return Promise.resolve({
          data: cdata
        });
      };

      return helpers.setupFallback(node, webcrypto, fallback);
    }

    function kwDecryptFN(size) {
      function commonChecks(key, data) {
        if (size !== key.length << 3) {
          throw new Error("invalid key size");
        }

        if (0 < data.length - 8 && 0 !== data.length % 8) {
          throw new Error("invalid data length");
        }
      } // ### 'fallback' implementation -- uses forge


      var fallback = function fallback(key, cdata) {
        try {
          commonChecks(key, cdata);
        } catch (err) {
          return Promise.reject(err);
        } // setup cipher


        var cipher = forge.cipher.createDecipher("AES", new DataBuffer(key)); // prepare inputs

        var R = split(cdata, 8),
            A,
            B,
            count;
        A = R[0];
        R = R.slice(1);

        for (var jdx = 5; 0 <= jdx; --jdx) {
          for (var idx = R.length - 1; 0 <= idx; --idx) {
            count = R.length * jdx + idx + 1;
            B = xor(A, longToBigEndian(count));
            B = Buffer.concat([B, R[idx]]);
            cipher.start();
            cipher.update(new DataBuffer(B));
            cipher.finish();
            B = cipher.output.native();
            A = B.slice(0, 8);
            R[idx] = B.slice(8, 16);
          }
        }

        if (A.toString() !== A0.toString()) {
          return Promise.reject(new Error("decryption failed"));
        }

        var pdata = Buffer.concat(R);
        return Promise.resolve(pdata);
      }; // ### WebCryptoAPI implementation


      var webcrypto = function webcrypto(key, cdata) {
        try {
          commonChecks(key, cdata);
        } catch (err) {
          return Promise.reject(err);
        }

        var alg = {
          name: "AES-KW"
        };
        var promise = helpers.subtleCrypto.importKey("raw", key, alg, true, ["unwrapKey"]);
        promise = promise.then(function (key) {
          return helpers.subtleCrypto.unwrapKey("raw", cdata, key, alg, {
            name: "HMAC",
            hash: "SHA-256"
          }, true, ["sign"]);
        });
        promise = promise.then(function (result) {
          // unwrapped CryptoKey -- extract raw
          return helpers.subtleCrypto.exportKey("raw", result);
        });
        promise = promise.then(function (result) {
          result = Buffer.from(result);
          return result;
        });
        return promise;
      };

      var node = function node(key, cdata) {
        try {
          commonChecks(key, cdata);
        } catch (err) {
          return Promise.reject(err);
        } // prepare inputs


        var R = split(cdata, 8),
            iv = Buffer.alloc(16),
            A,
            B,
            count;
        A = R[0];
        R = R.slice(1);

        for (var jdx = 5; 0 <= jdx; --jdx) {
          for (var idx = R.length - 1; 0 <= idx; --idx) {
            count = R.length * jdx + idx + 1;
            B = xor(A, longToBigEndian(count));
            B = Buffer.concat([B, R[idx], iv]);
            var cipher = helpers.nodeCrypto.createDecipheriv("AES" + size, key, iv);
            B = cipher.update(B);
            A = B.slice(0, 8);
            R[idx] = B.slice(8, 16);
          }
        }

        if (A.toString() !== A0.toString()) {
          return Promise.reject(new Error("decryption failed"));
        }

        var pdata = Buffer.concat(R);
        return Promise.resolve(pdata);
      };

      return helpers.setupFallback(node, webcrypto, fallback);
    } // ### Public API
    // * [name].encrypt
    // * [name].decrypt


    var aesKw = {};
    ["A128KW", "A192KW", "A256KW"].forEach(function (alg) {
      var size = parseInt(/A(\d+)KW/g.exec(alg)[1]);
      aesKw[alg] = {
        encrypt: kwEncryptFN(size),
        decrypt: kwDecryptFN(size)
      };
    });
    module.exports = aesKw;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 151 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/ec-util.js - Elliptic Curve Utility Functions
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var clone = __webpack_require__(42),
        ecc = __webpack_require__(234),
        forge = __webpack_require__(14),
        util = __webpack_require__(19);

    var EC_KEYSIZES = {
      "P-256": 256,
      "P-384": 384,
      "P-521": 521
    };

    function convertToForge(key, isPublic) {
      var parts = isPublic ? ["x", "y"] : ["d"];
      parts = parts.map(function (f) {
        return new forge.jsbn.BigInteger(key[f].toString("hex"), 16);
      }); // prefix with curve

      parts = [key.crv].concat(parts);
      var fn = isPublic ? ecc.asPublicKey : ecc.asPrivateKey;
      return fn.apply(ecc, parts);
    }

    function convertToJWK(key, isPublic) {
      var result = clone(key);
      var parts = isPublic ? ["x", "y"] : ["x", "y", "d"];
      parts.forEach(function (f) {
        result[f] = util.base64url.encode(result[f]);
      }); // remove potentially troublesome properties

      delete result.key_ops;
      delete result.use;
      delete result.alg;

      if (isPublic) {
        delete result.d;
      }

      return result;
    }

    function convertToObj(key, isPublic) {
      var result = clone(key);
      var parts = isPublic ? ["x", "y"] : ["d"];
      parts.forEach(function (f) {
        // assume string if base64url-encoded
        result[f] = util.asBuffer(result[f], "base64url");
      });
      return result;
    }

    var UNCOMPRESSED = Buffer.from([0x04]);

    function convertToBuffer(key, isPublic) {
      key = convertToObj(key, isPublic);
      var result = isPublic ? Buffer.concat([UNCOMPRESSED, key.x, key.y]) : key.d;
      return result;
    }

    function curveSize(crv) {
      return EC_KEYSIZES[crv || ""] || NaN;
    }

    function curveNameToOid(crv) {
      switch (crv) {
        case "P-256":
          return "1.2.840.10045.3.1.7";

        case "P-384":
          return "1.3.132.0.34";

        case "P-521":
          return "1.3.132.0.35";

        default:
          return null;
      }
    }

    var EC_OID = "1.2.840.10045.2.1";

    function convertToPEM(key, isPrivate) {
      // curveName to OID
      var oid = key.crv;
      oid = curveNameToOid(oid);
      oid = forge.asn1.oidToDer(oid); // key as bytes

      var type, pub, asn1;

      if (isPrivate) {
        type = "EC PRIVATE KEY";
        pub = Buffer.concat([Buffer.from([0x00, 0x04]), key.x, key.y]).toString("binary");
        key = key.d.toString("binary");
        asn1 = forge.asn1.create(forge.asn1.Class.UNIVERSAL, forge.asn1.Type.SEQUENCE, true, [forge.asn1.create(forge.asn1.Class.UNIVERSAL, forge.asn1.Type.INTEGER, false, "\x01"), forge.asn1.create(forge.asn1.Class.UNIVERSAL, forge.asn1.Type.OCTETSTRING, false, key), forge.asn1.create(forge.asn1.Class.CONTEXT_SPECIFIC, 0, true, [forge.asn1.create(forge.asn1.Class.UNIVERSAL, forge.asn1.Type.OID, false, oid.bytes())]), forge.asn1.create(forge.asn1.Class.CONTEXT_SPECIFIC, 1, true, [forge.asn1.create(forge.asn1.Class.UNIVERSAL, forge.asn1.Type.BITSTRING, false, pub)])]);
      } else {
        type = "PUBLIC KEY";
        key = Buffer.concat([Buffer.from([0x00, 0x04]), key.x, key.y]).toString("binary");
        asn1 = forge.asn1.create(forge.asn1.Class.UNIVERSAL, forge.asn1.Type.SEQUENCE, true, [forge.asn1.create(forge.asn1.Class.UNIVERSAL, forge.asn1.Type.SEQUENCE, true, [forge.asn1.create(forge.asn1.Class.UNIVERSAL, forge.asn1.Type.OID, false, forge.asn1.oidToDer(EC_OID).bytes()), forge.asn1.create(forge.asn1.Class.UNIVERSAL, forge.asn1.Type.OID, false, oid.bytes())]), forge.asn1.create(forge.asn1.Class.UNIVERSAL, forge.asn1.Type.BITSTRING, false, key)]);
      }

      asn1 = forge.asn1.toDer(asn1).bytes();
      var pem = forge.pem.encode({
        type: type,
        body: asn1
      });
      return pem;
    } // Inspired by teifip/node-webtokens/blob/master/lib/ecdsa.js


    var ERR_MSG = 'Could not extract parameters from DER signature';

    function derToConcat(signature, size) {
      var offset = 0;

      if (signature[offset++] !== 0x30) {
        throw new Error(ERR_MSG);
      }

      var seqLength = signature[offset++];

      if (seqLength === 0x81) {
        seqLength = signature[offset++];
      }

      if (seqLength > signature.length - offset) {
        throw new Error(ERR_MSG);
      }

      if (signature[offset++] !== 0x02) {
        throw new Error(ERR_MSG);
      }

      var rLength = signature[offset++];

      if (rLength > signature.length - offset - 2) {
        throw new Error(ERR_MSG);
      }

      if (rLength > size + 1) {
        throw new Error(ERR_MSG);
      }

      var rOffset = offset;
      offset += rLength;

      if (signature[offset++] !== 0x02) {
        throw new Error(ERR_MSG);
      }

      var sLength = signature[offset++];

      if (sLength !== signature.length - offset) {
        throw new Error(ERR_MSG);
      }

      if (sLength > size + 1) {
        throw new Error(ERR_MSG);
      }

      var sOffset = offset;
      offset += sLength;

      if (offset !== signature.length) {
        throw new Error(ERR_MSG);
      }

      var rPadding = size - rLength;
      var sPadding = size - sLength;
      var dst = Buffer.alloc(rPadding + rLength + sPadding + sLength);

      for (offset = 0; offset < rPadding; ++offset) {
        dst[offset] = 0;
      }

      var rPad = Math.max(-rPadding, 0);
      signature.copy(dst, offset, rOffset + rPad, rOffset + rLength);
      offset = size;

      for (var o = offset; offset < o + sPadding; ++offset) {
        dst[offset] = 0;
      }

      var sPad = Math.max(-sPadding, 0);
      signature.copy(dst, offset, sOffset + sPad, sOffset + sLength);
      return dst;
    }

    function countPadding(buf, start, stop) {
      var padding = 0;

      while (start + padding < stop && buf[start + padding] === 0) {
        ++padding;
      }

      var needsSign = buf[start + padding] >= 0x80;

      if (needsSign) {
        --padding;
      }

      return padding;
    }

    function concatToDer(signature, size) {
      var rPadding = countPadding(signature, 0, size);
      var sPadding = countPadding(signature, size, signature.length);
      var rLength = size - rPadding;
      var sLength = size - sPadding;
      var rsBytes = rLength + sLength + 4;
      var shortLength = rsBytes < 0x80;
      var dst = Buffer.alloc((shortLength ? 2 : 3) + rsBytes);
      var offset = 0;
      dst[offset++] = 0x30;

      if (shortLength) {
        dst[offset++] = rsBytes;
      } else {
        dst[offset++] = 0x81;
        dst[offset++] = rsBytes & 0xFF;
      }

      dst[offset++] = 0x02;
      dst[offset++] = rLength;

      if (rPadding < 0) {
        dst[offset++] = 0;
        offset += signature.copy(dst, offset, 0, size);
      } else {
        offset += signature.copy(dst, offset, rPadding, size);
      }

      dst[offset++] = 0x02;
      dst[offset++] = sLength;

      if (sPadding < 0) {
        dst[offset++] = 0;
        signature.copy(dst, offset, size);
      } else {
        signature.copy(dst, offset, size + sPadding);
      }

      return dst;
    }

    module.exports = {
      convertToForge: convertToForge,
      convertToJWK: convertToJWK,
      convertToObj: convertToObj,
      convertToBuffer: convertToBuffer,
      curveSize: curveSize,
      derToConcat: derToConcat,
      concatToDer: concatToDer,
      convertToPEM: convertToPEM,
      EC_OID: EC_OID
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 152 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/hmac.js - HMAC-based "signatures"
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var CONSTANTS = __webpack_require__(43),
        forge = __webpack_require__(14),
        DataBuffer = __webpack_require__(82),
        helpers = __webpack_require__(30);

    function hmacSignFN(name) {
      var md = name.replace("HS", "SHA").toLowerCase(),
          hash = name.replace("HS", "SHA-");

      function checkKeyLength(len, key) {
        len = (len || CONSTANTS.HASHLENGTH[hash]) / 8;

        if (len > key.length) {
          return Promise.reject(new Error("invalid key length"));
        }

        return Promise.resolve(key);
      } // ### Fallback Implementation -- uses forge


      var fallback = function fallback(key, pdata, props) {
        props = props || {};
        var promise;
        promise = checkKeyLength(props.length, key);
        promise = promise.then(function () {
          var sig = forge.hmac.create();
          sig.start(md, key.toString("binary"));
          sig.update(pdata);
          sig = sig.digest().native();
          return {
            data: pdata,
            mac: sig
          };
        });
        return promise;
      }; // ### WebCryptoAPI Implementation


      var webcrypto = function webcrypto(key, pdata, props) {
        props = props || {};
        var alg = {
          name: "HMAC",
          hash: {
            name: hash
          }
        };
        var promise;
        promise = checkKeyLength(props.length, key);
        promise = promise.then(function () {
          return helpers.subtleCrypto.importKey("raw", key, alg, true, ["sign"]);
        });
        promise = promise.then(function (key) {
          return helpers.subtleCrypto.sign(alg, key, pdata);
        });
        promise = promise.then(function (result) {
          var sig = Buffer.from(result);
          return {
            data: pdata,
            mac: sig
          };
        });
        return promise;
      }; // ### NodeJS implementation


      var nodejs = function nodejs(key, pdata, props) {
        props = props || {};
        var promise;
        promise = checkKeyLength(props.length, key);
        promise = promise.then(function () {
          var hmac = helpers.nodeCrypto.createHmac(md, key);
          hmac.update(pdata);
          var sig = hmac.digest();
          return {
            data: pdata,
            mac: sig
          };
        });
        return promise;
      };

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    }

    function hmacVerifyFN(name) {
      var md = name.replace("HS", "SHA").toLowerCase(),
          hash = name.replace("HS", "SHA-");

      function compare(len, expected, actual) {
        len = (len || CONSTANTS.HASHLENGTH[hash]) / 8;
        var valid = true;

        for (var idx = 0; len > idx; idx++) {
          valid = valid && expected[idx] === actual[idx];
        }

        return valid;
      } // ### Fallback Implementation -- uses forge


      var fallback = function fallback(key, pdata, mac, props) {
        props = props || {};
        var vrfy = forge.hmac.create();
        vrfy.start(md, new DataBuffer(key));
        vrfy.update(pdata);
        vrfy = vrfy.digest().native();

        if (compare(props.length, mac, vrfy)) {
          return Promise.resolve({
            data: pdata,
            mac: mac,
            valid: true
          });
        } else {
          return Promise.reject(new Error("verification failed"));
        }
      };

      var webcrypto = function webcrypto(key, pdata, mac, props) {
        props = props || {};
        var alg = {
          name: "HMAC",
          hash: {
            name: hash
          }
        };
        var promise;

        if (props.length) {
          promise = helpers.subtleCrypto.importKey("raw", key, alg, true, ["sign"]);
          promise = promise.then(function (key) {
            return helpers.subtleCrypto.sign(alg, key, pdata);
          });
          promise = promise.then(function (result) {
            var sig = Buffer.from(result);
            return compare(props.length, mac, sig);
          });
        } else {
          promise = helpers.subtleCrypto.importKey("raw", key, alg, true, ["verify"]);
          promise = promise.then(function (key) {
            return helpers.subtleCrypto.verify(alg, key, mac, pdata);
          });
        }

        promise = promise.then(function (result) {
          if (!result) {
            return Promise.reject(new Error("verifaction failed"));
          }

          return {
            data: pdata,
            mac: mac,
            valid: true
          };
        });
        return promise;
      };

      var nodejs = function nodejs(key, pdata, mac, props) {
        props = props || {};
        var hmac = helpers.nodeCrypto.createHmac(md, key);
        hmac.update(pdata);
        var sig = hmac.digest();

        if (!compare(props.length, mac, sig)) {
          throw new Error("verification failed");
        }

        return {
          data: pdata,
          mac: sig,
          valid: true
        };
      };

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    } // ### Public API
    // * [name].sign
    // * [name].verify


    var hmac = {};
    ["HS1", "HS256", "HS384", "HS512"].forEach(function (alg) {
      hmac[alg] = {
        sign: hmacSignFN(alg),
        verify: hmacVerifyFN(alg)
      };
    });
    module.exports = hmac;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 153 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * algorithms/index.js - Cryptographic Algorithms Entry Point
   *
   * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
   */
  // setup implementations

  var implementations = [__webpack_require__(546), __webpack_require__(547), __webpack_require__(150), __webpack_require__(231), __webpack_require__(548), __webpack_require__(549), __webpack_require__(550), __webpack_require__(232), __webpack_require__(152), __webpack_require__(551), __webpack_require__(552), __webpack_require__(553), __webpack_require__(102)];
  var ALGS_DIGEST = {};
  var ALGS_DERIVE = {};
  var ALGS_SIGN = {},
      ALGS_VRFY = {};
  var ALGS_ENC = {},
      ALGS_DEC = {};
  implementations.forEach(function (mod) {
    Object.keys(mod).forEach(function (alg) {
      var op = mod[alg];

      if ("function" === typeof op.encrypt) {
        ALGS_ENC[alg] = op.encrypt;
      }

      if ("function" === typeof op.decrypt) {
        ALGS_DEC[alg] = op.decrypt;
      }

      if ("function" === typeof op.sign) {
        ALGS_SIGN[alg] = op.sign;
      }

      if ("function" === typeof op.verify) {
        ALGS_VRFY[alg] = op.verify;
      }

      if ("function" === typeof op.digest) {
        ALGS_DIGEST[alg] = op.digest;
      }

      if ("function" === typeof op.derive) {
        ALGS_DERIVE[alg] = op.derive;
      }
    });
  }); // public API

  exports.digest = function (alg, data, props) {
    var op = ALGS_DIGEST[alg];

    if (!op) {
      return Promise.reject(new Error("unsupported algorithm: " + alg));
    }

    return op(data, props);
  };

  exports.derive = function (alg, key, props) {
    var op = ALGS_DERIVE[alg];

    if (!op) {
      return Promise.reject(new Error("unsupported algorithm: " + alg));
    }

    return op(key, props);
  };

  exports.sign = function (alg, key, pdata, props) {
    var op = ALGS_SIGN[alg];

    if (!op) {
      return Promise.reject(new Error("unsupported algorithm: " + alg));
    }

    return op(key, pdata, props || {});
  };

  exports.verify = function (alg, key, pdata, mac, props) {
    var op = ALGS_VRFY[alg];

    if (!op) {
      return Promise.reject(new Error("unsupported algorithm: " + alg));
    }

    return op(key, pdata, mac, props || {});
  };

  exports.encrypt = function (alg, key, pdata, props) {
    var op = ALGS_ENC[alg];

    if (!op) {
      return Promise.reject(new Error("unsupported algorithm: " + alg));
    }

    return op(key, pdata, props || {});
  };

  exports.decrypt = function (alg, key, cdata, props) {
    var op = ALGS_DEC[alg];

    if (!op) {
      return Promise.reject(new Error("unsupported algorithm: " + alg));
    }

    return op(key, cdata, props || {});
  };
  /***/

},
/* 154 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * algorithms/rsa-util.js - RSA Utility Functions
   *
   * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
   */

  var clone = __webpack_require__(42),
      forge = __webpack_require__(14),
      util = __webpack_require__(19); // ### RSA-specific Helpers


  function convertToForge(key, isPublic) {
    var parts = isPublic ? ["n", "e"] : ["n", "e", "d", "p", "q", "dp", "dq", "qi"];
    parts = parts.map(function (f) {
      return new forge.jsbn.BigInteger(key[f].toString("hex"), 16);
    });
    var fn = isPublic ? forge.pki.rsa.setPublicKey : forge.pki.rsa.setPrivateKey;
    return fn.apply(forge.pki.rsa, parts);
  }

  function convertToJWK(key, isPublic) {
    var result = clone(key);
    var parts = isPublic ? ["n", "e"] : ["n", "e", "d", "p", "q", "dp", "dq", "qi"];
    parts.forEach(function (f) {
      result[f] = util.base64url.encode(result[f]);
    }); // remove potentially troublesome properties

    delete result.key_ops;
    delete result.use;
    delete result.alg;

    if (isPublic) {
      delete result.d;
      delete result.p;
      delete result.q;
      delete result.dp;
      delete result.dq;
      delete result.qi;
    }

    return result;
  }

  function convertToPem(key, isPublic) {
    var cacheKey = isPublic ? "__cachedPublicPem" : "__cachedPrivatePem";

    if (key[cacheKey]) {
      return key[cacheKey];
    }

    var value;

    if (isPublic) {
      value = forge.pki.publicKeyToPem(convertToForge(key, isPublic));
    } else {
      value = forge.pki.privateKeyToPem(convertToForge(key, isPublic));
    }

    Object.defineProperty(key, cacheKey, {
      value: value
    });
    return value;
  }

  module.exports = {
    convertToForge: convertToForge,
    convertToJWK: convertToJWK,
    convertToPem: convertToPem
  };
  /***/
},
/* 155 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * jwe/index.js - JSON Web Encryption (JWE) Entry Point
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  var JWE = {
    createEncrypt: __webpack_require__(561).createEncrypt,
    createDecrypt: __webpack_require__(559).createDecrypt
  };
  module.exports = JWE;
  /***/
},
/* 156 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * jws/index.js - JSON Web Signature (JWS) Entry Point
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  var JWS = {
    createSign: __webpack_require__(567).createSign,
    createVerify: __webpack_require__(568).createVerify
  };
  module.exports = JWS;
  /***/
},
/* 157 */

/***/
function (module, exports) {
  /***/
},
/* 158 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process, setImmediate, global) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    // A bit simpler than readable streams.
    // Implement an async ._write(chunk, encoding, cb), and it'll handle all
    // the drain event emission and buffering.

    /*<replacement>*/
    var pna = __webpack_require__(83);
    /*</replacement>*/


    module.exports = Writable;
    /* <replacement> */

    function WriteReq(chunk, encoding, cb) {
      this.chunk = chunk;
      this.encoding = encoding;
      this.callback = cb;
      this.next = null;
    } // It seems a linked list but it is not
    // there will be only 2 of these for each stream


    function CorkedRequest(state) {
      var _this = this;

      this.next = null;
      this.entry = null;

      this.finish = function () {
        onCorkedFinish(_this, state);
      };
    }
    /* </replacement> */

    /*<replacement>*/


    var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
    /*</replacement>*/

    /*<replacement>*/

    var Duplex;
    /*</replacement>*/

    Writable.WritableState = WritableState;
    /*<replacement>*/

    var util = __webpack_require__(78);

    util.inherits = __webpack_require__(37);
    /*</replacement>*/

    /*<replacement>*/

    var internalUtil = {
      deprecate: __webpack_require__(598)
    };
    /*</replacement>*/

    /*<replacement>*/

    var Stream = __webpack_require__(245);
    /*</replacement>*/

    /*<replacement>*/


    var Buffer = __webpack_require__(38).Buffer;

    var OurUint8Array = global.Uint8Array || function () {};

    function _uint8ArrayToBuffer(chunk) {
      return Buffer.from(chunk);
    }

    function _isUint8Array(obj) {
      return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
    }
    /*</replacement>*/


    var destroyImpl = __webpack_require__(244);

    util.inherits(Writable, Stream);

    function nop() {}

    function WritableState(options, stream) {
      Duplex = Duplex || __webpack_require__(62);
      options = options || {}; // Duplex streams are both readable and writable, but share
      // the same options object.
      // However, some cases require setting options to different
      // values for the readable and the writable sides of the duplex stream.
      // These options can be provided separately as readableXXX and writableXXX.

      var isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
      // contains buffers or objects.

      this.objectMode = !!options.objectMode;
      if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
      // Note: 0 is a valid value, means that we always return false if
      // the entire buffer is not flushed immediately on write()

      var hwm = options.highWaterMark;
      var writableHwm = options.writableHighWaterMark;
      var defaultHwm = this.objectMode ? 16 : 16 * 1024;
      if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm; // cast to ints.

      this.highWaterMark = Math.floor(this.highWaterMark); // if _final has been called

      this.finalCalled = false; // drain event flag.

      this.needDrain = false; // at the start of calling end()

      this.ending = false; // when end() has been called, and returned

      this.ended = false; // when 'finish' is emitted

      this.finished = false; // has it been destroyed

      this.destroyed = false; // should we decode strings into buffers before passing to _write?
      // this is here so that some node-core streams can optimize string
      // handling at a lower level.

      var noDecode = options.decodeStrings === false;
      this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
      // encoding is 'binary' so we have to make this configurable.
      // Everything else in the universe uses 'utf8', though.

      this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
      // of how much we're waiting to get pushed to some underlying
      // socket or file.

      this.length = 0; // a flag to see when we're in the middle of a write.

      this.writing = false; // when true all writes will be buffered until .uncork() call

      this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
      // or on a later tick.  We set this to true at first, because any
      // actions that shouldn't happen until "later" should generally also
      // not happen before the first write call.

      this.sync = true; // a flag to know if we're processing previously buffered items, which
      // may call the _write() callback in the same tick, so that we don't
      // end up in an overlapped onwrite situation.

      this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

      this.onwrite = function (er) {
        onwrite(stream, er);
      }; // the callback that the user supplies to write(chunk,encoding,cb)


      this.writecb = null; // the amount that is being written when _write is called.

      this.writelen = 0;
      this.bufferedRequest = null;
      this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
      // this must be 0 before 'finish' can be emitted

      this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
      // This is relevant for synchronous Transform streams

      this.prefinished = false; // True if the error was already emitted and should not be thrown again

      this.errorEmitted = false; // count buffered requests

      this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
      // one allocated and free to use, and we maintain at most two

      this.corkedRequestsFree = new CorkedRequest(this);
    }

    WritableState.prototype.getBuffer = function getBuffer() {
      var current = this.bufferedRequest;
      var out = [];

      while (current) {
        out.push(current);
        current = current.next;
      }

      return out;
    };

    (function () {
      try {
        Object.defineProperty(WritableState.prototype, 'buffer', {
          get: internalUtil.deprecate(function () {
            return this.getBuffer();
          }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
        });
      } catch (_) {}
    })(); // Test _writableState for inheritance to account for Duplex streams,
    // whose prototype chain only points to Readable.


    var realHasInstance;

    if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
      realHasInstance = Function.prototype[Symbol.hasInstance];
      Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
          if (realHasInstance.call(this, object)) return true;
          if (this !== Writable) return false;
          return object && object._writableState instanceof WritableState;
        }
      });
    } else {
      realHasInstance = function realHasInstance(object) {
        return object instanceof this;
      };
    }

    function Writable(options) {
      Duplex = Duplex || __webpack_require__(62); // Writable ctor is applied to Duplexes, too.
      // `realHasInstance` is necessary because using plain `instanceof`
      // would return false, as no `_writableState` property is attached.
      // Trying to use the custom `instanceof` for Writable here will also break the
      // Node.js LazyTransform implementation, which has a non-trivial getter for
      // `_writableState` that would lead to infinite recursion.

      if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
        return new Writable(options);
      }

      this._writableState = new WritableState(options, this); // legacy.

      this.writable = true;

      if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
      }

      Stream.call(this);
    } // Otherwise people can pipe Writable streams, which is just wrong.


    Writable.prototype.pipe = function () {
      this.emit('error', new Error('Cannot pipe, not readable'));
    };

    function writeAfterEnd(stream, cb) {
      var er = new Error('write after end'); // TODO: defer error events consistently everywhere, not just the cb

      stream.emit('error', er);
      pna.nextTick(cb, er);
    } // Checks that a user-supplied chunk is valid, especially for the particular
    // mode the stream is in. Currently this means that `null` is never accepted
    // and undefined/non-string values are only allowed in object mode.


    function validChunk(stream, state, chunk, cb) {
      var valid = true;
      var er = false;

      if (chunk === null) {
        er = new TypeError('May not write null values to stream');
      } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
        er = new TypeError('Invalid non-string/buffer chunk');
      }

      if (er) {
        stream.emit('error', er);
        pna.nextTick(cb, er);
        valid = false;
      }

      return valid;
    }

    Writable.prototype.write = function (chunk, encoding, cb) {
      var state = this._writableState;
      var ret = false;

      var isBuf = !state.objectMode && _isUint8Array(chunk);

      if (isBuf && !Buffer.isBuffer(chunk)) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
      }

      if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
      if (typeof cb !== 'function') cb = nop;
      if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
      }
      return ret;
    };

    Writable.prototype.cork = function () {
      var state = this._writableState;
      state.corked++;
    };

    Writable.prototype.uncork = function () {
      var state = this._writableState;

      if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
      }
    };

    Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
      // node::ParseEncoding() requires lower case.
      if (typeof encoding === 'string') encoding = encoding.toLowerCase();
      if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
      this._writableState.defaultEncoding = encoding;
      return this;
    };

    function decodeChunk(state, chunk, encoding) {
      if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
        chunk = Buffer.from(chunk, encoding);
      }

      return chunk;
    }

    Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: false,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    }); // if we're already writing something, then just put this
    // in the queue, and wait our turn.  Otherwise, call _write
    // If we return false, then we need a drain event, so set that flag.

    function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
      if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);

        if (chunk !== newChunk) {
          isBuf = true;
          encoding = 'buffer';
          chunk = newChunk;
        }
      }

      var len = state.objectMode ? 1 : chunk.length;
      state.length += len;
      var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

      if (!ret) state.needDrain = true;

      if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
          chunk: chunk,
          encoding: encoding,
          isBuf: isBuf,
          callback: cb,
          next: null
        };

        if (last) {
          last.next = state.lastBufferedRequest;
        } else {
          state.bufferedRequest = state.lastBufferedRequest;
        }

        state.bufferedRequestCount += 1;
      } else {
        doWrite(stream, state, false, len, chunk, encoding, cb);
      }

      return ret;
    }

    function doWrite(stream, state, writev, len, chunk, encoding, cb) {
      state.writelen = len;
      state.writecb = cb;
      state.writing = true;
      state.sync = true;
      if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
      state.sync = false;
    }

    function onwriteError(stream, state, sync, er, cb) {
      --state.pendingcb;

      if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        pna.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error

        pna.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
      } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er); // this can emit finish, but finish must
        // always follow error

        finishMaybe(stream, state);
      }
    }

    function onwriteStateUpdate(state) {
      state.writing = false;
      state.writecb = null;
      state.length -= state.writelen;
      state.writelen = 0;
    }

    function onwrite(stream, er) {
      var state = stream._writableState;
      var sync = state.sync;
      var cb = state.writecb;
      onwriteStateUpdate(state);
      if (er) onwriteError(stream, state, sync, er, cb);else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state);

        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
          clearBuffer(stream, state);
        }

        if (sync) {
          /*<replacement>*/
          asyncWrite(afterWrite, stream, state, finished, cb);
          /*</replacement>*/
        } else {
          afterWrite(stream, state, finished, cb);
        }
      }
    }

    function afterWrite(stream, state, finished, cb) {
      if (!finished) onwriteDrain(stream, state);
      state.pendingcb--;
      cb();
      finishMaybe(stream, state);
    } // Must force callback to be called on nextTick, so that we don't
    // emit 'drain' before the write() consumer gets the 'false' return
    // value, and has a chance to attach a 'drain' listener.


    function onwriteDrain(stream, state) {
      if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
      }
    } // if there's something in the buffer waiting, then process it


    function clearBuffer(stream, state) {
      state.bufferProcessing = true;
      var entry = state.bufferedRequest;

      if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;

        while (entry) {
          buffer[count] = entry;
          if (!entry.isBuf) allBuffers = false;
          entry = entry.next;
          count += 1;
        }

        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite

        state.pendingcb++;
        state.lastBufferedRequest = null;

        if (holder.next) {
          state.corkedRequestsFree = holder.next;
          holder.next = null;
        } else {
          state.corkedRequestsFree = new CorkedRequest(state);
        }

        state.bufferedRequestCount = 0;
      } else {
        // Slow case, write chunks one-by-one
        while (entry) {
          var chunk = entry.chunk;
          var encoding = entry.encoding;
          var cb = entry.callback;
          var len = state.objectMode ? 1 : chunk.length;
          doWrite(stream, state, false, len, chunk, encoding, cb);
          entry = entry.next;
          state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
          // it means that we need to wait until it does.
          // also, that means that the chunk and cb are currently
          // being processed, so move the buffer counter past them.

          if (state.writing) {
            break;
          }
        }

        if (entry === null) state.lastBufferedRequest = null;
      }

      state.bufferedRequest = entry;
      state.bufferProcessing = false;
    }

    Writable.prototype._write = function (chunk, encoding, cb) {
      cb(new Error('_write() is not implemented'));
    };

    Writable.prototype._writev = null;

    Writable.prototype.end = function (chunk, encoding, cb) {
      var state = this._writableState;

      if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
      } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
      }

      if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

      if (state.corked) {
        state.corked = 1;
        this.uncork();
      } // ignore unnecessary end() calls.


      if (!state.ending && !state.finished) endWritable(this, state, cb);
    };

    function needFinish(state) {
      return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
    }

    function callFinal(stream, state) {
      stream._final(function (err) {
        state.pendingcb--;

        if (err) {
          stream.emit('error', err);
        }

        state.prefinished = true;
        stream.emit('prefinish');
        finishMaybe(stream, state);
      });
    }

    function prefinish(stream, state) {
      if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
          state.pendingcb++;
          state.finalCalled = true;
          pna.nextTick(callFinal, stream, state);
        } else {
          state.prefinished = true;
          stream.emit('prefinish');
        }
      }
    }

    function finishMaybe(stream, state) {
      var need = needFinish(state);

      if (need) {
        prefinish(stream, state);

        if (state.pendingcb === 0) {
          state.finished = true;
          stream.emit('finish');
        }
      }

      return need;
    }

    function endWritable(stream, state, cb) {
      state.ending = true;
      finishMaybe(stream, state);

      if (cb) {
        if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
      }

      state.ended = true;
      stream.writable = false;
    }

    function onCorkedFinish(corkReq, state, err) {
      var entry = corkReq.entry;
      corkReq.entry = null;

      while (entry) {
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
      }

      if (state.corkedRequestsFree) {
        state.corkedRequestsFree.next = corkReq;
      } else {
        state.corkedRequestsFree = corkReq;
      }
    }

    Object.defineProperty(Writable.prototype, 'destroyed', {
      get: function get() {
        if (this._writableState === undefined) {
          return false;
        }

        return this._writableState.destroyed;
      },
      set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) {
          return;
        } // backward compatibility, the user is explicitly
        // managing destroyed


        this._writableState.destroyed = value;
      }
    });
    Writable.prototype.destroy = destroyImpl.destroy;
    Writable.prototype._undestroy = destroyImpl.undestroy;

    Writable.prototype._destroy = function (err, cb) {
      this.end();
      cb(err);
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(16), __webpack_require__(247).setImmediate, __webpack_require__(10));
  /***/
},
/* 159 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.

  var punycode = __webpack_require__(583);

  var util = __webpack_require__(597);

  exports.parse = urlParse;
  exports.resolve = urlResolve;
  exports.resolveObject = urlResolveObject;
  exports.format = urlFormat;
  exports.Url = Url;

  function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
  } // Reference: RFC 3986, RFC 1808, RFC 2396
  // define these here so at least they only have to be
  // compiled once on the first module load.


  var protocolPattern = /^([a-z0-9.+-]+:)/i,
      portPattern = /:[0-9]*$/,
      // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
      // RFC 2396: characters reserved for delimiting URLs.
  // We actually just auto-escape these.
  delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
      // RFC 2396: characters not allowed for various reasons.
  unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
      // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
      // Characters that are never ever allowed in a hostname.
  // Note that any invalid chars are also handled, but these
  // are the ones that are *expected* to be seen, so we fast-path
  // them.
  nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
      hostEndingChars = ['/', '?', '#'],
      hostnameMaxLen = 255,
      hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
      hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
      // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    'javascript': true,
    'javascript:': true
  },
      // protocols that never have a hostname.
  hostlessProtocol = {
    'javascript': true,
    'javascript:': true
  },
      // protocols that always contain a // bit.
  slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
      querystring = __webpack_require__(586);

  function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && util.isObject(url) && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
  }

  Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
    if (!util.isString(url)) {
      throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    } // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916


    var queryIndex = url.indexOf('?'),
        splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
        uSplit = url.split(splitter),
        slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url; // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"

    rest = rest.trim();

    if (!slashesDenoteHost && url.split('#').length === 1) {
      // Try fast path regexp
      var simplePath = simplePathPattern.exec(rest);

      if (simplePath) {
        this.path = rest;
        this.href = rest;
        this.pathname = simplePath[1];

        if (simplePath[2]) {
          this.search = simplePath[2];

          if (parseQueryString) {
            this.query = querystring.parse(this.search.substr(1));
          } else {
            this.query = this.search.substr(1);
          }
        } else if (parseQueryString) {
          this.search = '';
          this.query = {};
        }

        return this;
      }
    }

    var proto = protocolPattern.exec(rest);

    if (proto) {
      proto = proto[0];
      var lowerProto = proto.toLowerCase();
      this.protocol = lowerProto;
      rest = rest.substr(proto.length);
    } // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.


    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
      var slashes = rest.substr(0, 2) === '//';

      if (slashes && !(proto && hostlessProtocol[proto])) {
        rest = rest.substr(2);
        this.slashes = true;
      }
    }

    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
      // there's a hostname.
      // the first instance of /, ?, ;, or # ends the host.
      //
      // If there is an @ in the hostname, then non-host chars *are* allowed
      // to the left of the last @ sign, unless some host-ending character
      // comes *before* the @-sign.
      // URLs are obnoxious.
      //
      // ex:
      // http://a@b@c/ => user:a@b host:c
      // http://a@b?@c => user:a host:c path:/?@c
      // v0.12 TODO(isaacs): This is not quite how Chrome does things.
      // Review our test case against browsers more comprehensively.
      // find the first instance of any hostEndingChars
      var hostEnd = -1;

      for (var i = 0; i < hostEndingChars.length; i++) {
        var hec = rest.indexOf(hostEndingChars[i]);
        if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
      } // at this point, either we have an explicit point where the
      // auth portion cannot go past, or the last @ char is the decider.


      var auth, atSign;

      if (hostEnd === -1) {
        // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
      } else {
        // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
      } // Now we have a portion which is definitely the auth.
      // Pull that off.


      if (atSign !== -1) {
        auth = rest.slice(0, atSign);
        rest = rest.slice(atSign + 1);
        this.auth = decodeURIComponent(auth);
      } // the host is the remaining to the left of the first non-host char


      hostEnd = -1;

      for (var i = 0; i < nonHostChars.length; i++) {
        var hec = rest.indexOf(nonHostChars[i]);
        if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
      } // if we still have not hit it, then the entire thing is a host.


      if (hostEnd === -1) hostEnd = rest.length;
      this.host = rest.slice(0, hostEnd);
      rest = rest.slice(hostEnd); // pull out port.

      this.parseHost(); // we've indicated that there is a hostname,
      // so even if it's empty, it has to be present.

      this.hostname = this.hostname || ''; // if hostname begins with [ and ends with ]
      // assume that it's an IPv6 address.

      var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']'; // validate a little.

      if (!ipv6Hostname) {
        var hostparts = this.hostname.split(/\./);

        for (var i = 0, l = hostparts.length; i < l; i++) {
          var part = hostparts[i];
          if (!part) continue;

          if (!part.match(hostnamePartPattern)) {
            var newpart = '';

            for (var j = 0, k = part.length; j < k; j++) {
              if (part.charCodeAt(j) > 127) {
                // we replace non-ASCII char with a temporary placeholder
                // we need this to make sure size of hostname is not
                // broken by replacing non-ASCII by nothing
                newpart += 'x';
              } else {
                newpart += part[j];
              }
            } // we test again with ASCII char only


            if (!newpart.match(hostnamePartPattern)) {
              var validParts = hostparts.slice(0, i);
              var notHost = hostparts.slice(i + 1);
              var bit = part.match(hostnamePartStart);

              if (bit) {
                validParts.push(bit[1]);
                notHost.unshift(bit[2]);
              }

              if (notHost.length) {
                rest = '/' + notHost.join('.') + rest;
              }

              this.hostname = validParts.join('.');
              break;
            }
          }
        }
      }

      if (this.hostname.length > hostnameMaxLen) {
        this.hostname = '';
      } else {
        // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
      }

      if (!ipv6Hostname) {
        // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = punycode.toASCII(this.hostname);
      }

      var p = this.port ? ':' + this.port : '';
      var h = this.hostname || '';
      this.host = h + p;
      this.href += this.host; // strip [ and ] from the hostname
      // the host field still retains them, though

      if (ipv6Hostname) {
        this.hostname = this.hostname.substr(1, this.hostname.length - 2);

        if (rest[0] !== '/') {
          rest = '/' + rest;
        }
      }
    } // now rest is set to the post-host stuff.
    // chop off any delim chars.


    if (!unsafeProtocol[lowerProto]) {
      // First, make 100% sure that any "autoEscape" chars get
      // escaped, even if encodeURIComponent doesn't think they
      // need to be.
      for (var i = 0, l = autoEscape.length; i < l; i++) {
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);

        if (esc === ae) {
          esc = escape(ae);
        }

        rest = rest.split(ae).join(esc);
      }
    } // chop off from the tail first.


    var hash = rest.indexOf('#');

    if (hash !== -1) {
      // got a fragment string.
      this.hash = rest.substr(hash);
      rest = rest.slice(0, hash);
    }

    var qm = rest.indexOf('?');

    if (qm !== -1) {
      this.search = rest.substr(qm);
      this.query = rest.substr(qm + 1);

      if (parseQueryString) {
        this.query = querystring.parse(this.query);
      }

      rest = rest.slice(0, qm);
    } else if (parseQueryString) {
      // no query string, but parseQueryString still requested
      this.search = '';
      this.query = {};
    }

    if (rest) this.pathname = rest;

    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
      this.pathname = '/';
    } //to support http.request


    if (this.pathname || this.search) {
      var p = this.pathname || '';
      var s = this.search || '';
      this.path = p + s;
    } // finally, reconstruct the href based on what has been validated.


    this.href = this.format();
    return this;
  }; // format a parsed object into a url string


  function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if (util.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
  }

  Url.prototype.format = function () {
    var auth = this.auth || '';

    if (auth) {
      auth = encodeURIComponent(auth);
      auth = auth.replace(/%3A/i, ':');
      auth += '@';
    }

    var protocol = this.protocol || '',
        pathname = this.pathname || '',
        hash = this.hash || '',
        host = false,
        query = '';

    if (this.host) {
      host = auth + this.host;
    } else if (this.hostname) {
      host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');

      if (this.port) {
        host += ':' + this.port;
      }
    }

    if (this.query && util.isObject(this.query) && Object.keys(this.query).length) {
      query = querystring.stringify(this.query);
    }

    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':'; // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.

    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
      host = '//' + (host || '');
      if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) {
      host = '';
    }

    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function (match) {
      return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
  };

  function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
  }

  Url.prototype.resolve = function (relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
  };

  function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
  }

  Url.prototype.resolveObject = function (relative) {
    if (util.isString(relative)) {
      var rel = new Url();
      rel.parse(relative, false, true);
      relative = rel;
    }

    var result = new Url();
    var tkeys = Object.keys(this);

    for (var tk = 0; tk < tkeys.length; tk++) {
      var tkey = tkeys[tk];
      result[tkey] = this[tkey];
    } // hash is always overridden, no matter what.
    // even href="" will remove it.


    result.hash = relative.hash; // if the relative url is empty, then there's nothing left to do here.

    if (relative.href === '') {
      result.href = result.format();
      return result;
    } // hrefs like //foo/bar always cut to the protocol.


    if (relative.slashes && !relative.protocol) {
      // take everything except the protocol from relative
      var rkeys = Object.keys(relative);

      for (var rk = 0; rk < rkeys.length; rk++) {
        var rkey = rkeys[rk];
        if (rkey !== 'protocol') result[rkey] = relative[rkey];
      } //urlParse appends trailing / to urls like http://www.example.com


      if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
        result.path = result.pathname = '/';
      }

      result.href = result.format();
      return result;
    }

    if (relative.protocol && relative.protocol !== result.protocol) {
      // if it's a known url protocol, then changing
      // the protocol does weird things
      // first, if it's not file:, then we MUST have a host,
      // and if there was a path
      // to begin with, then we MUST have a path.
      // if it is file:, then the host is dropped,
      // because that's known to be hostless.
      // anything else is assumed to be absolute.
      if (!slashedProtocol[relative.protocol]) {
        var keys = Object.keys(relative);

        for (var v = 0; v < keys.length; v++) {
          var k = keys[v];
          result[k] = relative[k];
        }

        result.href = result.format();
        return result;
      }

      result.protocol = relative.protocol;

      if (!relative.host && !hostlessProtocol[relative.protocol]) {
        var relPath = (relative.pathname || '').split('/');

        while (relPath.length && !(relative.host = relPath.shift())) {
          ;
        }

        if (!relative.host) relative.host = '';
        if (!relative.hostname) relative.hostname = '';
        if (relPath[0] !== '') relPath.unshift('');
        if (relPath.length < 2) relPath.unshift('');
        result.pathname = relPath.join('/');
      } else {
        result.pathname = relative.pathname;
      }

      result.search = relative.search;
      result.query = relative.query;
      result.host = relative.host || '';
      result.auth = relative.auth;
      result.hostname = relative.hostname || relative.host;
      result.port = relative.port; // to support http.request

      if (result.pathname || result.search) {
        var p = result.pathname || '';
        var s = result.search || '';
        result.path = p + s;
      }

      result.slashes = result.slashes || relative.slashes;
      result.href = result.format();
      return result;
    }

    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
        isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
        mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname,
        removeAllDots = mustEndAbs,
        srcPath = result.pathname && result.pathname.split('/') || [],
        relPath = relative.pathname && relative.pathname.split('/') || [],
        psychotic = result.protocol && !slashedProtocol[result.protocol]; // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.

    if (psychotic) {
      result.hostname = '';
      result.port = null;

      if (result.host) {
        if (srcPath[0] === '') srcPath[0] = result.host;else srcPath.unshift(result.host);
      }

      result.host = '';

      if (relative.protocol) {
        relative.hostname = null;
        relative.port = null;

        if (relative.host) {
          if (relPath[0] === '') relPath[0] = relative.host;else relPath.unshift(relative.host);
        }

        relative.host = null;
      }

      mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }

    if (isRelAbs) {
      // it's absolute.
      result.host = relative.host || relative.host === '' ? relative.host : result.host;
      result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
      result.search = relative.search;
      result.query = relative.query;
      srcPath = relPath; // fall through to the dot-handling below.
    } else if (relPath.length) {
      // it's relative
      // throw away the existing file, and take the new path instead.
      if (!srcPath) srcPath = [];
      srcPath.pop();
      srcPath = srcPath.concat(relPath);
      result.search = relative.search;
      result.query = relative.query;
    } else if (!util.isNullOrUndefined(relative.search)) {
      // just pull out the search.
      // like href='?foo'.
      // Put this after the other two cases because it simplifies the booleans
      if (psychotic) {
        result.hostname = result.host = srcPath.shift(); //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')

        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;

        if (authInHost) {
          result.auth = authInHost.shift();
          result.host = result.hostname = authInHost.shift();
        }
      }

      result.search = relative.search;
      result.query = relative.query; //to support http.request

      if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
        result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
      }

      result.href = result.format();
      return result;
    }

    if (!srcPath.length) {
      // no path at all.  easy.
      // we've already handled the other stuff above.
      result.pathname = null; //to support http.request

      if (result.search) {
        result.path = '/' + result.search;
      } else {
        result.path = null;
      }

      result.href = result.format();
      return result;
    } // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.


    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === ''; // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0

    var up = 0;

    for (var i = srcPath.length; i >= 0; i--) {
      last = srcPath[i];

      if (last === '.') {
        srcPath.splice(i, 1);
      } else if (last === '..') {
        srcPath.splice(i, 1);
        up++;
      } else if (up) {
        srcPath.splice(i, 1);
        up--;
      }
    } // if the path is allowed to go above the root, restore leading ..s


    if (!mustEndAbs && !removeAllDots) {
      for (; up--; up) {
        srcPath.unshift('..');
      }
    }

    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
      srcPath.unshift('');
    }

    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') {
      srcPath.push('');
    }

    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/'; // put the host back

    if (psychotic) {
      result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : ''; //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')

      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;

      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }

    mustEndAbs = mustEndAbs || result.host && srcPath.length;

    if (mustEndAbs && !isAbsolute) {
      srcPath.unshift('');
    }

    if (!srcPath.length) {
      result.pathname = null;
      result.path = null;
    } else {
      result.pathname = srcPath.join('/');
    } //to support request.http


    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }

    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  };

  Url.prototype.parseHost = function () {
    var host = this.host;
    var port = portPattern.exec(host);

    if (port) {
      port = port[0];

      if (port !== ':') {
        this.port = port.substr(1);
      }

      host = host.substr(0, host.length - port.length);
    }

    if (host) this.hostname = host;
  };
  /***/

},
/* 160 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process, global) {
    var Transform = __webpack_require__(63).Transform;

    var duplexify = __webpack_require__(494);

    var WS = __webpack_require__(604);

    var Buffer = __webpack_require__(38).Buffer;

    module.exports = WebSocketStream;

    function buildProxy(options, socketWrite, socketEnd) {
      var proxy = new Transform({
        objectMode: options.objectMode
      });
      proxy._write = socketWrite;
      proxy._flush = socketEnd;
      return proxy;
    }

    function WebSocketStream(target, protocols, options) {
      var stream, socket;
      var isBrowser = process.title === 'browser';
      var isNative = !!global.WebSocket;
      var socketWrite = isBrowser ? socketWriteBrowser : socketWriteNode;

      if (protocols && !Array.isArray(protocols) && 'object' === typeof protocols) {
        // accept the "options" Object as the 2nd argument
        options = protocols;
        protocols = null;

        if (typeof options.protocol === 'string' || Array.isArray(options.protocol)) {
          protocols = options.protocol;
        }
      }

      if (!options) options = {};

      if (options.objectMode === undefined) {
        options.objectMode = !(options.binary === true || options.binary === undefined);
      }

      var proxy = buildProxy(options, socketWrite, socketEnd);

      if (!options.objectMode) {
        proxy._writev = writev;
      } // browser only: sets the maximum socket buffer size before throttling


      var bufferSize = options.browserBufferSize || 1024 * 512; // browser only: how long to wait when throttling

      var bufferTimeout = options.browserBufferTimeout || 1000; // use existing WebSocket object that was passed in

      if (typeof target === 'object') {
        socket = target; // otherwise make a new one
      } else {
        // special constructor treatment for native websockets in browsers, see
        // https://github.com/maxogden/websocket-stream/issues/82
        if (isNative && isBrowser) {
          socket = new WS(target, protocols);
        } else {
          socket = new WS(target, protocols, options);
        }

        socket.binaryType = 'arraybuffer';
      } // was already open when passed in


      if (socket.readyState === socket.OPEN) {
        stream = proxy;
      } else {
        stream = duplexify.obj();
        socket.onopen = onopen;
      }

      stream.socket = socket;
      socket.onclose = onclose;
      socket.onerror = onerror;
      socket.onmessage = onmessage;
      proxy.on('close', destroy);
      var coerceToBuffer = !options.objectMode;

      function socketWriteNode(chunk, enc, next) {
        // avoid errors, this never happens unless
        // destroy() is called
        if (socket.readyState !== socket.OPEN) {
          next();
          return;
        }

        if (coerceToBuffer && typeof chunk === 'string') {
          chunk = Buffer.from(chunk, 'utf8');
        }

        socket.send(chunk, next);
      }

      function socketWriteBrowser(chunk, enc, next) {
        if (socket.bufferedAmount > bufferSize) {
          setTimeout(socketWriteBrowser, bufferTimeout, chunk, enc, next);
          return;
        }

        if (coerceToBuffer && typeof chunk === 'string') {
          chunk = Buffer.from(chunk, 'utf8');
        }

        try {
          socket.send(chunk);
        } catch (err) {
          return next(err);
        }

        next();
      }

      function socketEnd(done) {
        socket.close();
        done();
      }

      function onopen() {
        stream.setReadable(proxy);
        stream.setWritable(proxy);
        stream.emit('connect');
      }

      function onclose() {
        stream.end();
        stream.destroy();
      }

      function onerror(err) {
        stream.destroy(err);
      }

      function onmessage(event) {
        var data = event.data;
        if (data instanceof ArrayBuffer) data = Buffer.from(data);else data = Buffer.from(data, 'utf8');
        proxy.push(data);
      }

      function destroy() {
        socket.close();
      } // this is to be enabled only if objectMode is false


      function writev(chunks, cb) {
        var buffers = new Array(chunks.length);

        for (var i = 0; i < chunks.length; i++) {
          if (typeof chunks[i].chunk === 'string') {
            buffers[i] = Buffer.from(chunks[i], 'utf8');
          } else {
            buffers[i] = chunks[i].chunk;
          }
        }

        this._write(Buffer.concat(buffers), 'binary', cb);
      }

      return stream;
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(16), __webpack_require__(10));
  /***/
},
/* 161 */

/***/
function (module, exports) {
  module.exports = extend;
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  function extend() {
    var target = {};

    for (var i = 0; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }
  /***/

},
/* 162 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (global) {
    // compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
    // original notice:

    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
     * @license  MIT
     */
    function compare(a, b) {
      if (a === b) {
        return 0;
      }

      var x = a.length;
      var y = b.length;

      for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }

      if (x < y) {
        return -1;
      }

      if (y < x) {
        return 1;
      }

      return 0;
    }

    function isBuffer(b) {
      if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
        return global.Buffer.isBuffer(b);
      }

      return !!(b != null && b._isBuffer);
    } // based on node assert, original notice:
    // http://wiki.commonjs.org/wiki/Unit_Testing/1.0
    //
    // THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
    //
    // Originally from narwhal.js (http://narwhaljs.org)
    // Copyright (c) 2009 Thomas Robinson <280north.com>
    //
    // Permission is hereby granted, free of charge, to any person obtaining a copy
    // of this software and associated documentation files (the 'Software'), to
    // deal in the Software without restriction, including without limitation the
    // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
    // sell copies of the Software, and to permit persons to whom the Software is
    // furnished to do so, subject to the following conditions:
    //
    // The above copyright notice and this permission notice shall be included in
    // all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    // AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
    // ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
    // WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


    var util = __webpack_require__(74);

    var hasOwn = Object.prototype.hasOwnProperty;
    var pSlice = Array.prototype.slice;

    var functionsHaveNames = function () {
      return function foo() {}.name === 'foo';
    }();

    function pToString(obj) {
      return Object.prototype.toString.call(obj);
    }

    function isView(arrbuf) {
      if (isBuffer(arrbuf)) {
        return false;
      }

      if (typeof global.ArrayBuffer !== 'function') {
        return false;
      }

      if (typeof ArrayBuffer.isView === 'function') {
        return ArrayBuffer.isView(arrbuf);
      }

      if (!arrbuf) {
        return false;
      }

      if (arrbuf instanceof DataView) {
        return true;
      }

      if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
        return true;
      }

      return false;
    } // 1. The assert module provides functions that throw
    // AssertionError's when particular conditions are not met. The
    // assert module must conform to the following interface.


    var assert = module.exports = ok; // 2. The AssertionError is defined in assert.
    // new assert.AssertionError({ message: message,
    //                             actual: actual,
    //                             expected: expected })

    var regex = /\s*function\s+([^\(\s]*)\s*/; // based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js

    function getName(func) {
      if (!util.isFunction(func)) {
        return;
      }

      if (functionsHaveNames) {
        return func.name;
      }

      var str = func.toString();
      var match = str.match(regex);
      return match && match[1];
    }

    assert.AssertionError = function AssertionError(options) {
      this.name = 'AssertionError';
      this.actual = options.actual;
      this.expected = options.expected;
      this.operator = options.operator;

      if (options.message) {
        this.message = options.message;
        this.generatedMessage = false;
      } else {
        this.message = getMessage(this);
        this.generatedMessage = true;
      }

      var stackStartFunction = options.stackStartFunction || fail;

      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, stackStartFunction);
      } else {
        // non v8 browsers so we can have a stacktrace
        var err = new Error();

        if (err.stack) {
          var out = err.stack; // try to strip useless frames

          var fn_name = getName(stackStartFunction);
          var idx = out.indexOf('\n' + fn_name);

          if (idx >= 0) {
            // once we have located the function frame
            // we need to strip out everything before it (and its line)
            var next_line = out.indexOf('\n', idx + 1);
            out = out.substring(next_line + 1);
          }

          this.stack = out;
        }
      }
    }; // assert.AssertionError instanceof Error


    util.inherits(assert.AssertionError, Error);

    function truncate(s, n) {
      if (typeof s === 'string') {
        return s.length < n ? s : s.slice(0, n);
      } else {
        return s;
      }
    }

    function inspect(something) {
      if (functionsHaveNames || !util.isFunction(something)) {
        return util.inspect(something);
      }

      var rawname = getName(something);
      var name = rawname ? ': ' + rawname : '';
      return '[Function' + name + ']';
    }

    function getMessage(self) {
      return truncate(inspect(self.actual), 128) + ' ' + self.operator + ' ' + truncate(inspect(self.expected), 128);
    } // At present only the three keys mentioned above are used and
    // understood by the spec. Implementations or sub modules can pass
    // other keys to the AssertionError's constructor - they will be
    // ignored.
    // 3. All of the following functions must throw an AssertionError
    // when a corresponding condition is not met, with a message that
    // may be undefined if not provided.  All assertion methods provide
    // both the actual and expected values to the assertion error for
    // display purposes.


    function fail(actual, expected, message, operator, stackStartFunction) {
      throw new assert.AssertionError({
        message: message,
        actual: actual,
        expected: expected,
        operator: operator,
        stackStartFunction: stackStartFunction
      });
    } // EXTENSION! allows for well behaved errors defined elsewhere.


    assert.fail = fail; // 4. Pure assertion tests whether a value is truthy, as determined
    // by !!guard.
    // assert.ok(guard, message_opt);
    // This statement is equivalent to assert.equal(true, !!guard,
    // message_opt);. To test strictly for the value true, use
    // assert.strictEqual(true, guard, message_opt);.

    function ok(value, message) {
      if (!value) fail(value, true, message, '==', assert.ok);
    }

    assert.ok = ok; // 5. The equality assertion tests shallow, coercive equality with
    // ==.
    // assert.equal(actual, expected, message_opt);

    assert.equal = function equal(actual, expected, message) {
      if (actual != expected) fail(actual, expected, message, '==', assert.equal);
    }; // 6. The non-equality assertion tests for whether two objects are not equal
    // with != assert.notEqual(actual, expected, message_opt);


    assert.notEqual = function notEqual(actual, expected, message) {
      if (actual == expected) {
        fail(actual, expected, message, '!=', assert.notEqual);
      }
    }; // 7. The equivalence assertion tests a deep equality relation.
    // assert.deepEqual(actual, expected, message_opt);


    assert.deepEqual = function deepEqual(actual, expected, message) {
      if (!_deepEqual(actual, expected, false)) {
        fail(actual, expected, message, 'deepEqual', assert.deepEqual);
      }
    };

    assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
      if (!_deepEqual(actual, expected, true)) {
        fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
      }
    };

    function _deepEqual(actual, expected, strict, memos) {
      // 7.1. All identical values are equivalent, as determined by ===.
      if (actual === expected) {
        return true;
      } else if (isBuffer(actual) && isBuffer(expected)) {
        return compare(actual, expected) === 0; // 7.2. If the expected value is a Date object, the actual value is
        // equivalent if it is also a Date object that refers to the same time.
      } else if (util.isDate(actual) && util.isDate(expected)) {
        return actual.getTime() === expected.getTime(); // 7.3 If the expected value is a RegExp object, the actual value is
        // equivalent if it is also a RegExp object with the same source and
        // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
      } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
        return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase; // 7.4. Other pairs that do not both pass typeof value == 'object',
        // equivalence is determined by ==.
      } else if ((actual === null || typeof actual !== 'object') && (expected === null || typeof expected !== 'object')) {
        return strict ? actual === expected : actual == expected; // If both values are instances of typed arrays, wrap their underlying
        // ArrayBuffers in a Buffer each to increase performance
        // This optimization requires the arrays to have the same type as checked by
        // Object.prototype.toString (aka pToString). Never perform binary
        // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
        // bit patterns are not identical.
      } else if (isView(actual) && isView(expected) && pToString(actual) === pToString(expected) && !(actual instanceof Float32Array || actual instanceof Float64Array)) {
        return compare(new Uint8Array(actual.buffer), new Uint8Array(expected.buffer)) === 0; // 7.5 For all other Object pairs, including Array objects, equivalence is
        // determined by having the same number of owned properties (as verified
        // with Object.prototype.hasOwnProperty.call), the same set of keys
        // (although not necessarily the same order), equivalent values for every
        // corresponding key, and an identical 'prototype' property. Note: this
        // accounts for both named and indexed properties on Arrays.
      } else if (isBuffer(actual) !== isBuffer(expected)) {
        return false;
      } else {
        memos = memos || {
          actual: [],
          expected: []
        };
        var actualIndex = memos.actual.indexOf(actual);

        if (actualIndex !== -1) {
          if (actualIndex === memos.expected.indexOf(expected)) {
            return true;
          }
        }

        memos.actual.push(actual);
        memos.expected.push(expected);
        return objEquiv(actual, expected, strict, memos);
      }
    }

    function isArguments(object) {
      return Object.prototype.toString.call(object) == '[object Arguments]';
    }

    function objEquiv(a, b, strict, actualVisitedObjects) {
      if (a === null || a === undefined || b === null || b === undefined) return false; // if one is a primitive, the other must be same

      if (util.isPrimitive(a) || util.isPrimitive(b)) return a === b;
      if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
      var aIsArgs = isArguments(a);
      var bIsArgs = isArguments(b);
      if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;

      if (aIsArgs) {
        a = pSlice.call(a);
        b = pSlice.call(b);
        return _deepEqual(a, b, strict);
      }

      var ka = objectKeys(a);
      var kb = objectKeys(b);
      var key, i; // having the same number of owned properties (keys incorporates
      // hasOwnProperty)

      if (ka.length !== kb.length) return false; //the same set of keys (although not necessarily the same order),

      ka.sort();
      kb.sort(); //~~~cheap key test

      for (i = ka.length - 1; i >= 0; i--) {
        if (ka[i] !== kb[i]) return false;
      } //equivalent values for every corresponding key, and
      //~~~possibly expensive deep test


      for (i = ka.length - 1; i >= 0; i--) {
        key = ka[i];
        if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects)) return false;
      }

      return true;
    } // 8. The non-equivalence assertion tests for any deep inequality.
    // assert.notDeepEqual(actual, expected, message_opt);


    assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
      if (_deepEqual(actual, expected, false)) {
        fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
      }
    };

    assert.notDeepStrictEqual = notDeepStrictEqual;

    function notDeepStrictEqual(actual, expected, message) {
      if (_deepEqual(actual, expected, true)) {
        fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
      }
    } // 9. The strict equality assertion tests strict equality, as determined by ===.
    // assert.strictEqual(actual, expected, message_opt);


    assert.strictEqual = function strictEqual(actual, expected, message) {
      if (actual !== expected) {
        fail(actual, expected, message, '===', assert.strictEqual);
      }
    }; // 10. The strict non-equality assertion tests for strict inequality, as
    // determined by !==.  assert.notStrictEqual(actual, expected, message_opt);


    assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
      if (actual === expected) {
        fail(actual, expected, message, '!==', assert.notStrictEqual);
      }
    };

    function expectedException(actual, expected) {
      if (!actual || !expected) {
        return false;
      }

      if (Object.prototype.toString.call(expected) == '[object RegExp]') {
        return expected.test(actual);
      }

      try {
        if (actual instanceof expected) {
          return true;
        }
      } catch (e) {// Ignore.  The instanceof check doesn't work for arrow functions.
      }

      if (Error.isPrototypeOf(expected)) {
        return false;
      }

      return expected.call({}, actual) === true;
    }

    function _tryBlock(block) {
      var error;

      try {
        block();
      } catch (e) {
        error = e;
      }

      return error;
    }

    function _throws(shouldThrow, block, expected, message) {
      var actual;

      if (typeof block !== 'function') {
        throw new TypeError('"block" argument must be a function');
      }

      if (typeof expected === 'string') {
        message = expected;
        expected = null;
      }

      actual = _tryBlock(block);
      message = (expected && expected.name ? ' (' + expected.name + ').' : '.') + (message ? ' ' + message : '.');

      if (shouldThrow && !actual) {
        fail(actual, expected, 'Missing expected exception' + message);
      }

      var userProvidedMessage = typeof message === 'string';
      var isUnwantedException = !shouldThrow && util.isError(actual);
      var isUnexpectedException = !shouldThrow && actual && !expected;

      if (isUnwantedException && userProvidedMessage && expectedException(actual, expected) || isUnexpectedException) {
        fail(actual, expected, 'Got unwanted exception' + message);
      }

      if (shouldThrow && actual && expected && !expectedException(actual, expected) || !shouldThrow && actual) {
        throw actual;
      }
    } // 11. Expected to throw an error:
    // assert.throws(block, Error_opt, message_opt);


    assert.throws = function (block,
    /*optional*/
    error,
    /*optional*/
    message) {
      _throws(true, block, error, message);
    }; // EXTENSION! This is annoying to write outside this module.


    assert.doesNotThrow = function (block,
    /*optional*/
    error,
    /*optional*/
    message) {
      _throws(false, block, error, message);
    };

    assert.ifError = function (err) {
      if (err) throw err;
    };

    var objectKeys = Object.keys || function (obj) {
      var keys = [];

      for (var key in obj) {
        if (hasOwn.call(obj, key)) keys.push(key);
      }

      return keys;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(10));
  /***/
},
/* 163 */

/***/
function (module, exports, __webpack_require__) {
  var cof = __webpack_require__(27);

  module.exports = function (it, msg) {
    if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
    return +it;
  };
  /***/

},
/* 164 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

  var toObject = __webpack_require__(15);

  var toAbsoluteIndex = __webpack_require__(58);

  var toLength = __webpack_require__(13);

  module.exports = [].copyWithin || function copyWithin(target
  /* = 0 */
  , start
  /* = 0, end = @length */
  ) {
    var O = toObject(this);
    var len = toLength(O.length);
    var to = toAbsoluteIndex(target, len);
    var from = toAbsoluteIndex(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
    var inc = 1;

    if (from < to && to < from + count) {
      inc = -1;
      from += count - 1;
      to += count - 1;
    }

    while (count-- > 0) {
      if (from in O) O[to] = O[from];else delete O[to];
      to += inc;
      from += inc;
    }

    return O;
  };
  /***/

},
/* 165 */

/***/
function (module, exports, __webpack_require__) {
  var forOf = __webpack_require__(50);

  module.exports = function (iter, ITERATOR) {
    var result = [];
    forOf(iter, false, result.push, result, ITERATOR);
    return result;
  };
  /***/

},
/* 166 */

/***/
function (module, exports, __webpack_require__) {
  var aFunction = __webpack_require__(18);

  var toObject = __webpack_require__(15);

  var IObject = __webpack_require__(76);

  var toLength = __webpack_require__(13);

  module.exports = function (that, callbackfn, aLen, memo, isRight) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IObject(O);
    var length = toLength(O.length);
    var index = isRight ? length - 1 : 0;
    var i = isRight ? -1 : 1;
    if (aLen < 2) for (;;) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }

      index += i;

      if (isRight ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }

    for (; isRight ? index >= 0 : length > index; index += i) {
      if (index in self) {
        memo = callbackfn(memo, self[index], index, O);
      }
    }

    return memo;
  };
  /***/

},
/* 167 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var aFunction = __webpack_require__(18);

  var isObject = __webpack_require__(7);

  var invoke = __webpack_require__(173);

  var arraySlice = [].slice;
  var factories = {};

  var construct = function construct(F, len, args) {
    if (!(len in factories)) {
      for (var n = [], i = 0; i < len; i++) {
        n[i] = 'a[' + i + ']';
      } // eslint-disable-next-line no-new-func


      factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
    }

    return factories[len](F, args);
  };

  module.exports = Function.bind || function bind(that
  /* , ...args */
  ) {
    var fn = aFunction(this);
    var partArgs = arraySlice.call(arguments, 1);

    var bound = function bound()
    /* args... */
    {
      var args = partArgs.concat(arraySlice.call(arguments));
      return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
    };

    if (isObject(fn.prototype)) bound.prototype = fn.prototype;
    return bound;
  };
  /***/

},
/* 168 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var dP = __webpack_require__(12).f;

  var create = __webpack_require__(52);

  var redefineAll = __webpack_require__(56);

  var ctx = __webpack_require__(28);

  var anInstance = __webpack_require__(49);

  var forOf = __webpack_require__(50);

  var $iterDefine = __webpack_require__(119);

  var step = __webpack_require__(176);

  var setSpecies = __webpack_require__(57);

  var DESCRIPTORS = __webpack_require__(11);

  var fastKey = __webpack_require__(45).fastKey;

  var validate = __webpack_require__(67);

  var SIZE = DESCRIPTORS ? '_s' : 'size';

  var getEntry = function getEntry(that, key) {
    // fast case
    var index = fastKey(key);
    var entry;
    if (index !== 'F') return that._i[index]; // frozen object case

    for (entry = that._f; entry; entry = entry.n) {
      if (entry.k == key) return entry;
    }
  };

  module.exports = {
    getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
      var C = wrapper(function (that, iterable) {
        anInstance(that, C, NAME, '_i');
        that._t = NAME; // collection type

        that._i = create(null); // index

        that._f = undefined; // first entry

        that._l = undefined; // last entry

        that[SIZE] = 0; // size

        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
      });
      redefineAll(C.prototype, {
        // 23.1.3.1 Map.prototype.clear()
        // 23.2.3.2 Set.prototype.clear()
        clear: function clear() {
          for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
            entry.r = true;
            if (entry.p) entry.p = entry.p.n = undefined;
            delete data[entry.i];
          }

          that._f = that._l = undefined;
          that[SIZE] = 0;
        },
        // 23.1.3.3 Map.prototype.delete(key)
        // 23.2.3.4 Set.prototype.delete(value)
        'delete': function _delete(key) {
          var that = validate(this, NAME);
          var entry = getEntry(that, key);

          if (entry) {
            var next = entry.n;
            var prev = entry.p;
            delete that._i[entry.i];
            entry.r = true;
            if (prev) prev.n = next;
            if (next) next.p = prev;
            if (that._f == entry) that._f = next;
            if (that._l == entry) that._l = prev;
            that[SIZE]--;
          }

          return !!entry;
        },
        // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
        // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
        forEach: function forEach(callbackfn
        /* , that = undefined */
        ) {
          validate(this, NAME);
          var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
          var entry;

          while (entry = entry ? entry.n : this._f) {
            f(entry.v, entry.k, this); // revert to the last existing entry

            while (entry && entry.r) {
              entry = entry.p;
            }
          }
        },
        // 23.1.3.7 Map.prototype.has(key)
        // 23.2.3.7 Set.prototype.has(value)
        has: function has(key) {
          return !!getEntry(validate(this, NAME), key);
        }
      });
      if (DESCRIPTORS) dP(C.prototype, 'size', {
        get: function get() {
          return validate(this, NAME)[SIZE];
        }
      });
      return C;
    },
    def: function def(that, key, value) {
      var entry = getEntry(that, key);
      var prev, index; // change existing entry

      if (entry) {
        entry.v = value; // create new entry
      } else {
        that._l = entry = {
          i: index = fastKey(key, true),
          // <- index
          k: key,
          // <- key
          v: value,
          // <- value
          p: prev = that._l,
          // <- previous entry
          n: undefined,
          // <- next entry
          r: false // <- removed

        };
        if (!that._f) that._f = entry;
        if (prev) prev.n = entry;
        that[SIZE]++; // add to index

        if (index !== 'F') that._i[index] = entry;
      }

      return that;
    },
    getEntry: getEntry,
    setStrong: function setStrong(C, NAME, IS_MAP) {
      // add .keys, .values, .entries, [@@iterator]
      // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
      $iterDefine(C, NAME, function (iterated, kind) {
        this._t = validate(iterated, NAME); // target

        this._k = kind; // kind

        this._l = undefined; // previous
      }, function () {
        var that = this;
        var kind = that._k;
        var entry = that._l; // revert to the last existing entry

        while (entry && entry.r) {
          entry = entry.p;
        } // get next entry


        if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
          // or finish the iteration
          that._t = undefined;
          return step(1);
        } // return step by kind


        if (kind == 'keys') return step(0, entry.k);
        if (kind == 'values') return step(0, entry.v);
        return step(0, [entry.k, entry.v]);
      }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // add [@@species], 23.1.2.2, 23.2.2.2

      setSpecies(NAME);
    }
  };
  /***/
},
/* 169 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/DavidBruant/Map-Set.prototype.toJSON
  var classof = __webpack_require__(75);

  var from = __webpack_require__(165);

  module.exports = function (NAME) {
    return function toJSON() {
      if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
      return from(this);
    };
  };
  /***/

},
/* 170 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var redefineAll = __webpack_require__(56);

  var getWeak = __webpack_require__(45).getWeak;

  var anObject = __webpack_require__(2);

  var isObject = __webpack_require__(7);

  var anInstance = __webpack_require__(49);

  var forOf = __webpack_require__(50);

  var createArrayMethod = __webpack_require__(31);

  var $has = __webpack_require__(23);

  var validate = __webpack_require__(67);

  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var id = 0; // fallback for uncaught frozen keys

  var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
    return that._l || (that._l = new UncaughtFrozenStore());
  };

  var UncaughtFrozenStore = function UncaughtFrozenStore() {
    this.a = [];
  };

  var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
    return arrayFind(store.a, function (it) {
      return it[0] === key;
    });
  };

  UncaughtFrozenStore.prototype = {
    get: function get(key) {
      var entry = findUncaughtFrozen(this, key);
      if (entry) return entry[1];
    },
    has: function has(key) {
      return !!findUncaughtFrozen(this, key);
    },
    set: function set(key, value) {
      var entry = findUncaughtFrozen(this, key);
      if (entry) entry[1] = value;else this.a.push([key, value]);
    },
    'delete': function _delete(key) {
      var index = arrayFindIndex(this.a, function (it) {
        return it[0] === key;
      });
      if (~index) this.a.splice(index, 1);
      return !!~index;
    }
  };
  module.exports = {
    getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
      var C = wrapper(function (that, iterable) {
        anInstance(that, C, NAME, '_i');
        that._t = NAME; // collection type

        that._i = id++; // collection id

        that._l = undefined; // leak store for uncaught frozen objects

        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
      });
      redefineAll(C.prototype, {
        // 23.3.3.2 WeakMap.prototype.delete(key)
        // 23.4.3.3 WeakSet.prototype.delete(value)
        'delete': function _delete(key) {
          if (!isObject(key)) return false;
          var data = getWeak(key);
          if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
          return data && $has(data, this._i) && delete data[this._i];
        },
        // 23.3.3.4 WeakMap.prototype.has(key)
        // 23.4.3.4 WeakSet.prototype.has(value)
        has: function has(key) {
          if (!isObject(key)) return false;
          var data = getWeak(key);
          if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
          return data && $has(data, this._i);
        }
      });
      return C;
    },
    def: function def(that, key, value) {
      var data = getWeak(anObject(key), true);
      if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
      return that;
    },
    ufstore: uncaughtFrozenStore
  };
  /***/
},
/* 171 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray

  var isArray = __webpack_require__(90);

  var isObject = __webpack_require__(7);

  var toLength = __webpack_require__(13);

  var ctx = __webpack_require__(28);

  var IS_CONCAT_SPREADABLE = __webpack_require__(9)('isConcatSpreadable');

  function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
    var element, spreadable;

    while (sourceIndex < sourceLen) {
      if (sourceIndex in source) {
        element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
        spreadable = false;

        if (isObject(element)) {
          spreadable = element[IS_CONCAT_SPREADABLE];
          spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
        }

        if (spreadable && depth > 0) {
          targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
        } else {
          if (targetIndex >= 0x1fffffffffffff) throw TypeError();
          target[targetIndex] = element;
        }

        targetIndex++;
      }

      sourceIndex++;
    }

    return targetIndex;
  }

  module.exports = flattenIntoArray;
  /***/
},
/* 172 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = !__webpack_require__(11) && !__webpack_require__(5)(function () {
    return Object.defineProperty(__webpack_require__(112)('div'), 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  /***/
},
/* 173 */

/***/
function (module, exports) {
  // fast apply, http://jsperf.lnkit.com/fast-apply/5
  module.exports = function (fn, args, that) {
    var un = that === undefined;

    switch (args.length) {
      case 0:
        return un ? fn() : fn.call(that);

      case 1:
        return un ? fn(args[0]) : fn.call(that, args[0]);

      case 2:
        return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

      case 3:
        return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

      case 4:
        return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }

    return fn.apply(that, args);
  };
  /***/

},
/* 174 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.3 Number.isInteger(number)
  var isObject = __webpack_require__(7);

  var floor = Math.floor;

  module.exports = function isInteger(it) {
    return !isObject(it) && isFinite(it) && floor(it) === it;
  };
  /***/

},
/* 175 */

/***/
function (module, exports, __webpack_require__) {
  // call something on iterator step with safe closing on error
  var anObject = __webpack_require__(2);

  module.exports = function (iterator, fn, value, entries) {
    try {
      return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
      var ret = iterator['return'];
      if (ret !== undefined) anObject(ret.call(iterator));
      throw e;
    }
  };
  /***/

},
/* 176 */

/***/
function (module, exports) {
  module.exports = function (done, value) {
    return {
      value: value,
      done: !!done
    };
  };
  /***/

},
/* 177 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.16 Math.fround(x)
  var sign = __webpack_require__(121);

  var pow = Math.pow;
  var EPSILON = pow(2, -52);
  var EPSILON32 = pow(2, -23);
  var MAX32 = pow(2, 127) * (2 - EPSILON32);
  var MIN32 = pow(2, -126);

  var roundTiesToEven = function roundTiesToEven(n) {
    return n + 1 / EPSILON - 1 / EPSILON;
  };

  module.exports = Math.fround || function fround(x) {
    var $abs = Math.abs(x);
    var $sign = sign(x);
    var a, result;
    if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs); // eslint-disable-next-line no-self-compare

    if (result > MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
  };
  /***/

},
/* 178 */

/***/
function (module, exports) {
  // 20.2.2.20 Math.log1p(x)
  module.exports = Math.log1p || function log1p(x) {
    return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
  };
  /***/

},
/* 179 */

/***/
function (module, exports) {
  // https://rwaldron.github.io/proposal-math-extensions/
  module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
    if (arguments.length === 0 // eslint-disable-next-line no-self-compare
    || x != x // eslint-disable-next-line no-self-compare
    || inLow != inLow // eslint-disable-next-line no-self-compare
    || inHigh != inHigh // eslint-disable-next-line no-self-compare
    || outLow != outLow // eslint-disable-next-line no-self-compare
    || outHigh != outHigh) return NaN;
    if (x === Infinity || x === -Infinity) return x;
    return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
  };
  /***/

},
/* 180 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 19.1.2.1 Object.assign(target, source, ...)

  var getKeys = __webpack_require__(54);

  var gOPS = __webpack_require__(94);

  var pIE = __webpack_require__(77);

  var toObject = __webpack_require__(15);

  var IObject = __webpack_require__(76);

  var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

  module.exports = !$assign || __webpack_require__(5)(function () {
    var A = {};
    var B = {}; // eslint-disable-next-line no-undef

    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) {
      B[k] = k;
    });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
  }) ? function assign(target, source) {
    // eslint-disable-line no-unused-vars
    var T = toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = gOPS.f;
    var isEnum = pIE.f;

    while (aLen > index) {
      var S = IObject(arguments[index++]);
      var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
      var length = keys.length;
      var j = 0;
      var key;

      while (length > j) {
        if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
      }
    }

    return T;
  } : $assign;
  /***/
},
/* 181 */

/***/
function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(12);

  var anObject = __webpack_require__(2);

  var getKeys = __webpack_require__(54);

  module.exports = __webpack_require__(11) ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = getKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;

    while (length > i) {
      dP.f(O, P = keys[i++], Properties[P]);
    }

    return O;
  };
  /***/
},
/* 182 */

/***/
function (module, exports, __webpack_require__) {
  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
  var toIObject = __webpack_require__(26);

  var gOPN = __webpack_require__(53).f;

  var toString = {}.toString;
  var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function getWindowNames(it) {
    try {
      return gOPN(it);
    } catch (e) {
      return windowNames.slice();
    }
  };

  module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
  };
  /***/

},
/* 183 */

/***/
function (module, exports, __webpack_require__) {
  var has = __webpack_require__(23);

  var toIObject = __webpack_require__(26);

  var arrayIndexOf = __webpack_require__(86)(false);

  var IE_PROTO = __webpack_require__(125)('IE_PROTO');

  module.exports = function (object, names) {
    var O = toIObject(object);
    var i = 0;
    var result = [];
    var key;

    for (key in O) {
      if (key != IE_PROTO) has(O, key) && result.push(key);
    } // Don't enum bug & hidden keys


    while (names.length > i) {
      if (has(O, key = names[i++])) {
        ~arrayIndexOf(result, key) || result.push(key);
      }
    }

    return result;
  };
  /***/

},
/* 184 */

/***/
function (module, exports, __webpack_require__) {
  var getKeys = __webpack_require__(54);

  var toIObject = __webpack_require__(26);

  var isEnum = __webpack_require__(77).f;

  module.exports = function (isEntries) {
    return function (it) {
      var O = toIObject(it);
      var keys = getKeys(O);
      var length = keys.length;
      var i = 0;
      var result = [];
      var key;

      while (length > i) {
        if (isEnum.call(O, key = keys[i++])) {
          result.push(isEntries ? [key, O[key]] : O[key]);
        }
      }

      return result;
    };
  };
  /***/

},
/* 185 */

/***/
function (module, exports, __webpack_require__) {
  // all object keys, includes non-enumerable and symbols
  var gOPN = __webpack_require__(53);

  var gOPS = __webpack_require__(94);

  var anObject = __webpack_require__(2);

  var Reflect = __webpack_require__(3).Reflect;

  module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
    var keys = gOPN.f(anObject(it));
    var getSymbols = gOPS.f;
    return getSymbols ? keys.concat(getSymbols(it)) : keys;
  };
  /***/

},
/* 186 */

/***/
function (module, exports, __webpack_require__) {
  var $parseFloat = __webpack_require__(3).parseFloat;

  var $trim = __webpack_require__(66).trim;

  module.exports = 1 / $parseFloat(__webpack_require__(129) + '-0') !== -Infinity ? function parseFloat(str) {
    var string = $trim(String(str), 3);
    var result = $parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
  } : $parseFloat;
  /***/
},
/* 187 */

/***/
function (module, exports, __webpack_require__) {
  var $parseInt = __webpack_require__(3).parseInt;

  var $trim = __webpack_require__(66).trim;

  var ws = __webpack_require__(129);

  var hex = /^[-+]?0[xX]/;
  module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
    var string = $trim(String(str), 3);
    return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
  } : $parseInt;
  /***/
},
/* 188 */

/***/
function (module, exports) {
  module.exports = function (exec) {
    try {
      return {
        e: false,
        v: exec()
      };
    } catch (e) {
      return {
        e: true,
        v: e
      };
    }
  };
  /***/

},
/* 189 */

/***/
function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(2);

  var isObject = __webpack_require__(7);

  var newPromiseCapability = __webpack_require__(123);

  module.exports = function (C, x) {
    anObject(C);
    if (isObject(x) && x.constructor === C) return x;
    var promiseCapability = newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
  };
  /***/

},
/* 190 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-string-pad-start-end
  var toLength = __webpack_require__(13);

  var repeat = __webpack_require__(128);

  var defined = __webpack_require__(33);

  module.exports = function (that, maxLength, fillString, left) {
    var S = String(defined(that));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = toLength(maxLength);
    if (intMaxLength <= stringLength || fillStr == '') return S;
    var fillLen = intMaxLength - stringLength;
    var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return left ? stringFiller + S : S + stringFiller;
  };
  /***/

},
/* 191 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/ecma262/#sec-toindex
  var toInteger = __webpack_require__(35);

  var toLength = __webpack_require__(13);

  module.exports = function (it) {
    if (it === undefined) return 0;
    var number = toInteger(it);
    var length = toLength(number);
    if (number !== length) throw RangeError('Wrong length!');
    return length;
  };
  /***/

},
/* 192 */

/***/
function (module, exports, __webpack_require__) {
  exports.f = __webpack_require__(9);
  /***/
},
/* 193 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var strong = __webpack_require__(168);

  var validate = __webpack_require__(67);

  var MAP = 'Map'; // 23.1 Map Objects

  module.exports = __webpack_require__(87)(MAP, function (get) {
    return function Map() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  }, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key) {
      var entry = strong.getEntry(validate(this, MAP), key);
      return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value) {
      return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
    }
  }, strong, true);
  /***/
},
/* 194 */

/***/
function (module, exports, __webpack_require__) {
  // 21.2.5.3 get RegExp.prototype.flags()
  if (__webpack_require__(11) && /./g.flags != 'g') __webpack_require__(12).f(RegExp.prototype, 'flags', {
    configurable: true,
    get: __webpack_require__(89)
  });
  /***/
},
/* 195 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var strong = __webpack_require__(168);

  var validate = __webpack_require__(67);

  var SET = 'Set'; // 23.2 Set Objects

  module.exports = __webpack_require__(87)(SET, function (get) {
    return function Set() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  }, {
    // 23.2.3.1 Set.prototype.add(value)
    add: function add(value) {
      return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
    }
  }, strong);
  /***/
},
/* 196 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var each = __webpack_require__(31)(0);

  var redefine = __webpack_require__(21);

  var meta = __webpack_require__(45);

  var assign = __webpack_require__(180);

  var weak = __webpack_require__(170);

  var isObject = __webpack_require__(7);

  var fails = __webpack_require__(5);

  var validate = __webpack_require__(67);

  var WEAK_MAP = 'WeakMap';
  var getWeak = meta.getWeak;
  var isExtensible = Object.isExtensible;
  var uncaughtFrozenStore = weak.ufstore;
  var tmp = {};
  var InternalMap;

  var wrapper = function wrapper(get) {
    return function WeakMap() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  };

  var methods = {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key) {
      if (isObject(key)) {
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
        return data ? data[this._i] : undefined;
      }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value) {
      return weak.def(validate(this, WEAK_MAP), key, value);
    }
  }; // 23.3 WeakMap Objects

  var $WeakMap = module.exports = __webpack_require__(87)(WEAK_MAP, wrapper, methods, weak, true, true); // IE11 WeakMap frozen keys fix


  if (fails(function () {
    return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
  })) {
    InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
    assign(InternalMap.prototype, methods);
    meta.NEED = true;
    each(['delete', 'has', 'get', 'set'], function (key) {
      var proto = $WeakMap.prototype;
      var method = proto[key];
      redefine(proto, key, function (a, b) {
        // store frozen objects on internal weakmap shim
        if (isObject(a) && !isExtensible(a)) {
          if (!this._f) this._f = new InternalMap();

          var result = this._f[key](a, b);

          return key == 'set' ? this : result; // store all the rest on native weakmap
        }

        return method.call(this, a, b);
      });
    });
  }
  /***/

},
/* 197 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    var Buffer = __webpack_require__(1).Buffer;

    var Transform = __webpack_require__(595).Transform;

    var binding = __webpack_require__(469);

    var util = __webpack_require__(74);

    var assert = __webpack_require__(162).ok;

    var kMaxLength = __webpack_require__(1).kMaxLength;

    var kRangeErrorMessage = 'Cannot create final Buffer. It would be larger ' + 'than 0x' + kMaxLength.toString(16) + ' bytes'; // zlib doesn't provide these, so kludge them in following the same
    // const naming scheme zlib uses.

    binding.Z_MIN_WINDOWBITS = 8;
    binding.Z_MAX_WINDOWBITS = 15;
    binding.Z_DEFAULT_WINDOWBITS = 15; // fewer than 64 bytes per chunk is stupid.
    // technically it could work with as few as 8, but even 64 bytes
    // is absurdly low.  Usually a MB or more is best.

    binding.Z_MIN_CHUNK = 64;
    binding.Z_MAX_CHUNK = Infinity;
    binding.Z_DEFAULT_CHUNK = 16 * 1024;
    binding.Z_MIN_MEMLEVEL = 1;
    binding.Z_MAX_MEMLEVEL = 9;
    binding.Z_DEFAULT_MEMLEVEL = 8;
    binding.Z_MIN_LEVEL = -1;
    binding.Z_MAX_LEVEL = 9;
    binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION; // expose all the zlib constants

    var bkeys = Object.keys(binding);

    for (var bk = 0; bk < bkeys.length; bk++) {
      var bkey = bkeys[bk];

      if (bkey.match(/^Z/)) {
        Object.defineProperty(exports, bkey, {
          enumerable: true,
          value: binding[bkey],
          writable: false
        });
      }
    } // translation table for return codes.


    var codes = {
      Z_OK: binding.Z_OK,
      Z_STREAM_END: binding.Z_STREAM_END,
      Z_NEED_DICT: binding.Z_NEED_DICT,
      Z_ERRNO: binding.Z_ERRNO,
      Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
      Z_DATA_ERROR: binding.Z_DATA_ERROR,
      Z_MEM_ERROR: binding.Z_MEM_ERROR,
      Z_BUF_ERROR: binding.Z_BUF_ERROR,
      Z_VERSION_ERROR: binding.Z_VERSION_ERROR
    };
    var ckeys = Object.keys(codes);

    for (var ck = 0; ck < ckeys.length; ck++) {
      var ckey = ckeys[ck];
      codes[codes[ckey]] = ckey;
    }

    Object.defineProperty(exports, 'codes', {
      enumerable: true,
      value: Object.freeze(codes),
      writable: false
    });
    exports.Deflate = Deflate;
    exports.Inflate = Inflate;
    exports.Gzip = Gzip;
    exports.Gunzip = Gunzip;
    exports.DeflateRaw = DeflateRaw;
    exports.InflateRaw = InflateRaw;
    exports.Unzip = Unzip;

    exports.createDeflate = function (o) {
      return new Deflate(o);
    };

    exports.createInflate = function (o) {
      return new Inflate(o);
    };

    exports.createDeflateRaw = function (o) {
      return new DeflateRaw(o);
    };

    exports.createInflateRaw = function (o) {
      return new InflateRaw(o);
    };

    exports.createGzip = function (o) {
      return new Gzip(o);
    };

    exports.createGunzip = function (o) {
      return new Gunzip(o);
    };

    exports.createUnzip = function (o) {
      return new Unzip(o);
    }; // Convenience methods.
    // compress/decompress a string or buffer in one step.


    exports.deflate = function (buffer, opts, callback) {
      if (typeof opts === 'function') {
        callback = opts;
        opts = {};
      }

      return zlibBuffer(new Deflate(opts), buffer, callback);
    };

    exports.deflateSync = function (buffer, opts) {
      return zlibBufferSync(new Deflate(opts), buffer);
    };

    exports.gzip = function (buffer, opts, callback) {
      if (typeof opts === 'function') {
        callback = opts;
        opts = {};
      }

      return zlibBuffer(new Gzip(opts), buffer, callback);
    };

    exports.gzipSync = function (buffer, opts) {
      return zlibBufferSync(new Gzip(opts), buffer);
    };

    exports.deflateRaw = function (buffer, opts, callback) {
      if (typeof opts === 'function') {
        callback = opts;
        opts = {};
      }

      return zlibBuffer(new DeflateRaw(opts), buffer, callback);
    };

    exports.deflateRawSync = function (buffer, opts) {
      return zlibBufferSync(new DeflateRaw(opts), buffer);
    };

    exports.unzip = function (buffer, opts, callback) {
      if (typeof opts === 'function') {
        callback = opts;
        opts = {};
      }

      return zlibBuffer(new Unzip(opts), buffer, callback);
    };

    exports.unzipSync = function (buffer, opts) {
      return zlibBufferSync(new Unzip(opts), buffer);
    };

    exports.inflate = function (buffer, opts, callback) {
      if (typeof opts === 'function') {
        callback = opts;
        opts = {};
      }

      return zlibBuffer(new Inflate(opts), buffer, callback);
    };

    exports.inflateSync = function (buffer, opts) {
      return zlibBufferSync(new Inflate(opts), buffer);
    };

    exports.gunzip = function (buffer, opts, callback) {
      if (typeof opts === 'function') {
        callback = opts;
        opts = {};
      }

      return zlibBuffer(new Gunzip(opts), buffer, callback);
    };

    exports.gunzipSync = function (buffer, opts) {
      return zlibBufferSync(new Gunzip(opts), buffer);
    };

    exports.inflateRaw = function (buffer, opts, callback) {
      if (typeof opts === 'function') {
        callback = opts;
        opts = {};
      }

      return zlibBuffer(new InflateRaw(opts), buffer, callback);
    };

    exports.inflateRawSync = function (buffer, opts) {
      return zlibBufferSync(new InflateRaw(opts), buffer);
    };

    function zlibBuffer(engine, buffer, callback) {
      var buffers = [];
      var nread = 0;
      engine.on('error', onError);
      engine.on('end', onEnd);
      engine.end(buffer);
      flow();

      function flow() {
        var chunk;

        while (null !== (chunk = engine.read())) {
          buffers.push(chunk);
          nread += chunk.length;
        }

        engine.once('readable', flow);
      }

      function onError(err) {
        engine.removeListener('end', onEnd);
        engine.removeListener('readable', flow);
        callback(err);
      }

      function onEnd() {
        var buf;
        var err = null;

        if (nread >= kMaxLength) {
          err = new RangeError(kRangeErrorMessage);
        } else {
          buf = Buffer.concat(buffers, nread);
        }

        buffers = [];
        engine.close();
        callback(err, buf);
      }
    }

    function zlibBufferSync(engine, buffer) {
      if (typeof buffer === 'string') buffer = Buffer.from(buffer);
      if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');
      var flushFlag = engine._finishFlushFlag;
      return engine._processChunk(buffer, flushFlag);
    } // generic zlib
    // minimal 2-byte header


    function Deflate(opts) {
      if (!(this instanceof Deflate)) return new Deflate(opts);
      Zlib.call(this, opts, binding.DEFLATE);
    }

    function Inflate(opts) {
      if (!(this instanceof Inflate)) return new Inflate(opts);
      Zlib.call(this, opts, binding.INFLATE);
    } // gzip - bigger header, same deflate compression


    function Gzip(opts) {
      if (!(this instanceof Gzip)) return new Gzip(opts);
      Zlib.call(this, opts, binding.GZIP);
    }

    function Gunzip(opts) {
      if (!(this instanceof Gunzip)) return new Gunzip(opts);
      Zlib.call(this, opts, binding.GUNZIP);
    } // raw - no header


    function DeflateRaw(opts) {
      if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
      Zlib.call(this, opts, binding.DEFLATERAW);
    }

    function InflateRaw(opts) {
      if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
      Zlib.call(this, opts, binding.INFLATERAW);
    } // auto-detect header.


    function Unzip(opts) {
      if (!(this instanceof Unzip)) return new Unzip(opts);
      Zlib.call(this, opts, binding.UNZIP);
    }

    function isValidFlushFlag(flag) {
      return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
    } // the Zlib class they all inherit from
    // This thing manages the queue of requests, and returns
    // true or false if there is anything in the queue when
    // you call the .write() method.


    function Zlib(opts, mode) {
      var _this = this;

      this._opts = opts = opts || {};
      this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
      Transform.call(this, opts);

      if (opts.flush && !isValidFlushFlag(opts.flush)) {
        throw new Error('Invalid flush flag: ' + opts.flush);
      }

      if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) {
        throw new Error('Invalid flush flag: ' + opts.finishFlush);
      }

      this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
      this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;

      if (opts.chunkSize) {
        if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) {
          throw new Error('Invalid chunk size: ' + opts.chunkSize);
        }
      }

      if (opts.windowBits) {
        if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) {
          throw new Error('Invalid windowBits: ' + opts.windowBits);
        }
      }

      if (opts.level) {
        if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) {
          throw new Error('Invalid compression level: ' + opts.level);
        }
      }

      if (opts.memLevel) {
        if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) {
          throw new Error('Invalid memLevel: ' + opts.memLevel);
        }
      }

      if (opts.strategy) {
        if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) {
          throw new Error('Invalid strategy: ' + opts.strategy);
        }
      }

      if (opts.dictionary) {
        if (!Buffer.isBuffer(opts.dictionary)) {
          throw new Error('Invalid dictionary: it should be a Buffer instance');
        }
      }

      this._handle = new binding.Zlib(mode);
      var self = this;
      this._hadError = false;

      this._handle.onerror = function (message, errno) {
        // there is no way to cleanly recover.
        // continuing only obscures problems.
        _close(self);

        self._hadError = true;
        var error = new Error(message);
        error.errno = errno;
        error.code = exports.codes[errno];
        self.emit('error', error);
      };

      var level = exports.Z_DEFAULT_COMPRESSION;
      if (typeof opts.level === 'number') level = opts.level;
      var strategy = exports.Z_DEFAULT_STRATEGY;
      if (typeof opts.strategy === 'number') strategy = opts.strategy;

      this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);

      this._buffer = Buffer.allocUnsafe(this._chunkSize);
      this._offset = 0;
      this._level = level;
      this._strategy = strategy;
      this.once('end', this.close);
      Object.defineProperty(this, '_closed', {
        get: function get() {
          return !_this._handle;
        },
        configurable: true,
        enumerable: true
      });
    }

    util.inherits(Zlib, Transform);

    Zlib.prototype.params = function (level, strategy, callback) {
      if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) {
        throw new RangeError('Invalid compression level: ' + level);
      }

      if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) {
        throw new TypeError('Invalid strategy: ' + strategy);
      }

      if (this._level !== level || this._strategy !== strategy) {
        var self = this;
        this.flush(binding.Z_SYNC_FLUSH, function () {
          assert(self._handle, 'zlib binding closed');

          self._handle.params(level, strategy);

          if (!self._hadError) {
            self._level = level;
            self._strategy = strategy;
            if (callback) callback();
          }
        });
      } else {
        process.nextTick(callback);
      }
    };

    Zlib.prototype.reset = function () {
      assert(this._handle, 'zlib binding closed');
      return this._handle.reset();
    }; // This is the _flush function called by the transform class,
    // internally, when the last chunk has been written.


    Zlib.prototype._flush = function (callback) {
      this._transform(Buffer.alloc(0), '', callback);
    };

    Zlib.prototype.flush = function (kind, callback) {
      var _this2 = this;

      var ws = this._writableState;

      if (typeof kind === 'function' || kind === undefined && !callback) {
        callback = kind;
        kind = binding.Z_FULL_FLUSH;
      }

      if (ws.ended) {
        if (callback) process.nextTick(callback);
      } else if (ws.ending) {
        if (callback) this.once('end', callback);
      } else if (ws.needDrain) {
        if (callback) {
          this.once('drain', function () {
            return _this2.flush(kind, callback);
          });
        }
      } else {
        this._flushFlag = kind;
        this.write(Buffer.alloc(0), '', callback);
      }
    };

    Zlib.prototype.close = function (callback) {
      _close(this, callback);

      process.nextTick(emitCloseNT, this);
    };

    function _close(engine, callback) {
      if (callback) process.nextTick(callback); // Caller may invoke .close after a zlib error (which will null _handle).

      if (!engine._handle) return;

      engine._handle.close();

      engine._handle = null;
    }

    function emitCloseNT(self) {
      self.emit('close');
    }

    Zlib.prototype._transform = function (chunk, encoding, cb) {
      var flushFlag;
      var ws = this._writableState;
      var ending = ws.ending || ws.ended;
      var last = ending && (!chunk || ws.length === chunk.length);
      if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));
      if (!this._handle) return cb(new Error('zlib binding closed')); // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
      // (or whatever flag was provided using opts.finishFlush).
      // If it's explicitly flushing at some other time, then we use
      // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
      // goodness.

      if (last) flushFlag = this._finishFlushFlag;else {
        flushFlag = this._flushFlag; // once we've flushed the last of the queue, stop flushing and
        // go back to the normal behavior.

        if (chunk.length >= ws.length) {
          this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
        }
      }

      this._processChunk(chunk, flushFlag, cb);
    };

    Zlib.prototype._processChunk = function (chunk, flushFlag, cb) {
      var availInBefore = chunk && chunk.length;
      var availOutBefore = this._chunkSize - this._offset;
      var inOff = 0;
      var self = this;
      var async = typeof cb === 'function';

      if (!async) {
        var buffers = [];
        var nread = 0;
        var error;
        this.on('error', function (er) {
          error = er;
        });
        assert(this._handle, 'zlib binding closed');

        do {
          var res = this._handle.writeSync(flushFlag, chunk, // in
          inOff, // in_off
          availInBefore, // in_len
          this._buffer, // out
          this._offset, //out_off
          availOutBefore); // out_len

        } while (!this._hadError && callback(res[0], res[1]));

        if (this._hadError) {
          throw error;
        }

        if (nread >= kMaxLength) {
          _close(this);

          throw new RangeError(kRangeErrorMessage);
        }

        var buf = Buffer.concat(buffers, nread);

        _close(this);

        return buf;
      }

      assert(this._handle, 'zlib binding closed');

      var req = this._handle.write(flushFlag, chunk, // in
      inOff, // in_off
      availInBefore, // in_len
      this._buffer, // out
      this._offset, //out_off
      availOutBefore); // out_len


      req.buffer = chunk;
      req.callback = callback;

      function callback(availInAfter, availOutAfter) {
        // When the callback is used in an async write, the callback's
        // context is the `req` object that was created. The req object
        // is === this._handle, and that's why it's important to null
        // out the values after they are done being used. `this._handle`
        // can stay in memory longer than the callback and buffer are needed.
        if (this) {
          this.buffer = null;
          this.callback = null;
        }

        if (self._hadError) return;
        var have = availOutBefore - availOutAfter;
        assert(have >= 0, 'have should not go down');

        if (have > 0) {
          var out = self._buffer.slice(self._offset, self._offset + have);

          self._offset += have; // serve some output to the consumer.

          if (async) {
            self.push(out);
          } else {
            buffers.push(out);
            nread += out.length;
          }
        } // exhausted the output buffer, or used all the input create a new one.


        if (availOutAfter === 0 || self._offset >= self._chunkSize) {
          availOutBefore = self._chunkSize;
          self._offset = 0;
          self._buffer = Buffer.allocUnsafe(self._chunkSize);
        }

        if (availOutAfter === 0) {
          // Not actually done.  Need to reprocess.
          // Also, update the availInBefore to the availInAfter value,
          // so that if we have to hit it a third (fourth, etc.) time,
          // it'll have the correct byte counts.
          inOff += availInBefore - availInAfter;
          availInBefore = availInAfter;
          if (!async) return true;

          var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);

          newReq.callback = callback; // this same function

          newReq.buffer = chunk;
          return;
        }

        if (!async) return false; // finished with the chunk.

        cb();
      }
    };

    util.inherits(Deflate, Zlib);
    util.inherits(Inflate, Zlib);
    util.inherits(Gzip, Zlib);
    util.inherits(Gunzip, Zlib);
    util.inherits(DeflateRaw, Zlib);
    util.inherits(InflateRaw, Zlib);
    util.inherits(Unzip, Zlib);
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(16));
  /***/
},
/* 198 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function (Math) {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var Hasher = C_lib.Hasher;
      var C_algo = C.algo; // Initialization and round constants tables

      var H = [];
      var K = []; // Compute constants

      (function () {
        function isPrime(n) {
          var sqrtN = Math.sqrt(n);

          for (var factor = 2; factor <= sqrtN; factor++) {
            if (!(n % factor)) {
              return false;
            }
          }

          return true;
        }

        function getFractionalBits(n) {
          return (n - (n | 0)) * 0x100000000 | 0;
        }

        var n = 2;
        var nPrime = 0;

        while (nPrime < 64) {
          if (isPrime(n)) {
            if (nPrime < 8) {
              H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
            }

            K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
            nPrime++;
          }

          n++;
        }
      })(); // Reusable object


      var W = [];
      /**
       * SHA-256 hash algorithm.
       */

      var SHA256 = C_algo.SHA256 = Hasher.extend({
        _doReset: function _doReset() {
          this._hash = new WordArray.init(H.slice(0));
        },
        _doProcessBlock: function _doProcessBlock(M, offset) {
          // Shortcut
          var H = this._hash.words; // Working variables

          var a = H[0];
          var b = H[1];
          var c = H[2];
          var d = H[3];
          var e = H[4];
          var f = H[5];
          var g = H[6];
          var h = H[7]; // Computation

          for (var i = 0; i < 64; i++) {
            if (i < 16) {
              W[i] = M[offset + i] | 0;
            } else {
              var gamma0x = W[i - 15];
              var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
              var gamma1x = W[i - 2];
              var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
              W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
            }

            var ch = e & f ^ ~e & g;
            var maj = a & b ^ a & c ^ b & c;
            var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
            var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
            var t1 = h + sigma1 + ch + K[i] + W[i];
            var t2 = sigma0 + maj;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
          } // Intermediate hash value


          H[0] = H[0] + a | 0;
          H[1] = H[1] + b | 0;
          H[2] = H[2] + c | 0;
          H[3] = H[3] + d | 0;
          H[4] = H[4] + e | 0;
          H[5] = H[5] + f | 0;
          H[6] = H[6] + g | 0;
          H[7] = H[7] + h | 0;
        },
        _doFinalize: function _doFinalize() {
          // Shortcuts
          var data = this._data;
          var dataWords = data.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data.sigBytes * 8; // Add padding

          dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
          data.sigBytes = dataWords.length * 4; // Hash final blocks

          this._process(); // Return final computed hash


          return this._hash;
        },
        clone: function clone() {
          var clone = Hasher.clone.call(this);
          clone._hash = this._hash.clone();
          return clone;
        }
      });
      /**
       * Shortcut function to the hasher's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       *
       * @return {WordArray} The hash.
       *
       * @static
       *
       * @example
       *
       *     var hash = CryptoJS.SHA256('message');
       *     var hash = CryptoJS.SHA256(wordArray);
       */

      C.SHA256 = Hasher._createHelper(SHA256);
      /**
       * Shortcut function to the HMAC's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       * @param {WordArray|string} key The secret key.
       *
       * @return {WordArray} The HMAC.
       *
       * @static
       *
       * @example
       *
       *     var hmac = CryptoJS.HmacSHA256(message, key);
       */

      C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);

    return CryptoJS.SHA256;
  });
  /***/

},
/* 199 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(100));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./x64-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var Hasher = C_lib.Hasher;
      var C_x64 = C.x64;
      var X64Word = C_x64.Word;
      var X64WordArray = C_x64.WordArray;
      var C_algo = C.algo;

      function X64Word_create() {
        return X64Word.create.apply(X64Word, arguments);
      } // Constants


      var K = [X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd), X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc), X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019), X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118), X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe), X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2), X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1), X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694), X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3), X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65), X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483), X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5), X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210), X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4), X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725), X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70), X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926), X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df), X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8), X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b), X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001), X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30), X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910), X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8), X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53), X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8), X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb), X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3), X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60), X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec), X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9), X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b), X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207), X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178), X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6), X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b), X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493), X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c), X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a), X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)]; // Reusable objects

      var W = [];

      (function () {
        for (var i = 0; i < 80; i++) {
          W[i] = X64Word_create();
        }
      })();
      /**
       * SHA-512 hash algorithm.
       */


      var SHA512 = C_algo.SHA512 = Hasher.extend({
        _doReset: function _doReset() {
          this._hash = new X64WordArray.init([new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b), new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1), new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f), new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)]);
        },
        _doProcessBlock: function _doProcessBlock(M, offset) {
          // Shortcuts
          var H = this._hash.words;
          var H0 = H[0];
          var H1 = H[1];
          var H2 = H[2];
          var H3 = H[3];
          var H4 = H[4];
          var H5 = H[5];
          var H6 = H[6];
          var H7 = H[7];
          var H0h = H0.high;
          var H0l = H0.low;
          var H1h = H1.high;
          var H1l = H1.low;
          var H2h = H2.high;
          var H2l = H2.low;
          var H3h = H3.high;
          var H3l = H3.low;
          var H4h = H4.high;
          var H4l = H4.low;
          var H5h = H5.high;
          var H5l = H5.low;
          var H6h = H6.high;
          var H6l = H6.low;
          var H7h = H7.high;
          var H7l = H7.low; // Working variables

          var ah = H0h;
          var al = H0l;
          var bh = H1h;
          var bl = H1l;
          var ch = H2h;
          var cl = H2l;
          var dh = H3h;
          var dl = H3l;
          var eh = H4h;
          var el = H4l;
          var fh = H5h;
          var fl = H5l;
          var gh = H6h;
          var gl = H6l;
          var hh = H7h;
          var hl = H7l; // Rounds

          for (var i = 0; i < 80; i++) {
            // Shortcut
            var Wi = W[i]; // Extend message

            if (i < 16) {
              var Wih = Wi.high = M[offset + i * 2] | 0;
              var Wil = Wi.low = M[offset + i * 2 + 1] | 0;
            } else {
              // Gamma0
              var gamma0x = W[i - 15];
              var gamma0xh = gamma0x.high;
              var gamma0xl = gamma0x.low;
              var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
              var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25); // Gamma1

              var gamma1x = W[i - 2];
              var gamma1xh = gamma1x.high;
              var gamma1xl = gamma1x.low;
              var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
              var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26); // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]

              var Wi7 = W[i - 7];
              var Wi7h = Wi7.high;
              var Wi7l = Wi7.low;
              var Wi16 = W[i - 16];
              var Wi16h = Wi16.high;
              var Wi16l = Wi16.low;
              var Wil = gamma0l + Wi7l;
              var Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
              var Wil = Wil + gamma1l;
              var Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
              var Wil = Wil + Wi16l;
              var Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
              Wi.high = Wih;
              Wi.low = Wil;
            }

            var chh = eh & fh ^ ~eh & gh;
            var chl = el & fl ^ ~el & gl;
            var majh = ah & bh ^ ah & ch ^ bh & ch;
            var majl = al & bl ^ al & cl ^ bl & cl;
            var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
            var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
            var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
            var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9); // t1 = h + sigma1 + ch + K[i] + W[i]

            var Ki = K[i];
            var Kih = Ki.high;
            var Kil = Ki.low;
            var t1l = hl + sigma1l;
            var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
            var t1l = t1l + chl;
            var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
            var t1l = t1l + Kil;
            var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
            var t1l = t1l + Wil;
            var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0); // t2 = sigma0 + maj

            var t2l = sigma0l + majl;
            var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0); // Update working variables

            hh = gh;
            hl = gl;
            gh = fh;
            gl = fl;
            fh = eh;
            fl = el;
            el = dl + t1l | 0;
            eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
            dh = ch;
            dl = cl;
            ch = bh;
            cl = bl;
            bh = ah;
            bl = al;
            al = t1l + t2l | 0;
            ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
          } // Intermediate hash value


          H0l = H0.low = H0l + al;
          H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
          H1l = H1.low = H1l + bl;
          H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
          H2l = H2.low = H2l + cl;
          H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
          H3l = H3.low = H3l + dl;
          H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
          H4l = H4.low = H4l + el;
          H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
          H5l = H5.low = H5l + fl;
          H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
          H6l = H6.low = H6l + gl;
          H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
          H7l = H7.low = H7l + hl;
          H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
        },
        _doFinalize: function _doFinalize() {
          // Shortcuts
          var data = this._data;
          var dataWords = data.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data.sigBytes * 8; // Add padding

          dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
          dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
          dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
          data.sigBytes = dataWords.length * 4; // Hash final blocks

          this._process(); // Convert hash to 32-bit word array before returning


          var hash = this._hash.toX32(); // Return final computed hash


          return hash;
        },
        clone: function clone() {
          var clone = Hasher.clone.call(this);
          clone._hash = this._hash.clone();
          return clone;
        },
        blockSize: 1024 / 32
      });
      /**
       * Shortcut function to the hasher's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       *
       * @return {WordArray} The hash.
       *
       * @static
       *
       * @example
       *
       *     var hash = CryptoJS.SHA512('message');
       *     var hash = CryptoJS.SHA512(wordArray);
       */

      C.SHA512 = Hasher._createHelper(SHA512);
      /**
       * Shortcut function to the HMAC's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       * @param {WordArray|string} key The secret key.
       *
       * @return {WordArray} The HMAC.
       *
       * @static
       *
       * @example
       *
       *     var hmac = CryptoJS.HmacSHA512(message, key);
       */

      C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();

    return CryptoJS.SHA512;
  });
  /***/

},
/* 200 */

/***/
function (module, exports, __webpack_require__) {
  var once = __webpack_require__(573);

  var noop = function noop() {};

  var isRequest = function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
  };

  var isChildProcess = function isChildProcess(stream) {
    return stream.stdio && Array.isArray(stream.stdio) && stream.stdio.length === 3;
  };

  var eos = function eos(stream, opts, callback) {
    if (typeof opts === 'function') return eos(stream, null, opts);
    if (!opts) opts = {};
    callback = once(callback || noop);
    var ws = stream._writableState;
    var rs = stream._readableState;
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;

    var onlegacyfinish = function onlegacyfinish() {
      if (!stream.writable) onfinish();
    };

    var onfinish = function onfinish() {
      writable = false;
      if (!readable) callback.call(stream);
    };

    var onend = function onend() {
      readable = false;
      if (!writable) callback.call(stream);
    };

    var onexit = function onexit(exitCode) {
      callback.call(stream, exitCode ? new Error('exited with error code: ' + exitCode) : null);
    };

    var onerror = function onerror(err) {
      callback.call(stream, err);
    };

    var onclose = function onclose() {
      if (readable && !(rs && rs.ended)) return callback.call(stream, new Error('premature close'));
      if (writable && !(ws && ws.ended)) return callback.call(stream, new Error('premature close'));
    };

    var onrequest = function onrequest() {
      stream.req.on('finish', onfinish);
    };

    if (isRequest(stream)) {
      stream.on('complete', onfinish);
      stream.on('abort', onclose);
      if (stream.req) onrequest();else stream.on('request', onrequest);
    } else if (writable && !ws) {
      // legacy streams
      stream.on('end', onlegacyfinish);
      stream.on('close', onlegacyfinish);
    }

    if (isChildProcess(stream)) stream.on('exit', onexit);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function () {
      stream.removeListener('complete', onfinish);
      stream.removeListener('abort', onclose);
      stream.removeListener('request', onrequest);
      if (stream.req) stream.req.removeListener('finish', onfinish);
      stream.removeListener('end', onlegacyfinish);
      stream.removeListener('close', onlegacyfinish);
      stream.removeListener('finish', onfinish);
      stream.removeListener('exit', onexit);
      stream.removeListener('end', onend);
      stream.removeListener('error', onerror);
      stream.removeListener('close', onclose);
    };
  };

  module.exports = eos;
  /***/
},
/* 201 */

/***/
function (module, exports) {
  var toString = {}.toString;

  module.exports = Array.isArray || function (arr) {
    return toString.call(arr) == '[object Array]';
  };
  /***/

},
/* 202 */

/***/
function (module, exports) {
  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]';
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */

  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);

      case 1:
        return func.call(thisArg, args[0]);

      case 2:
        return func.call(thisArg, args[0], args[1]);

      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }

    return func.apply(thisArg, args);
  }
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */


  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */


  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var objectToString = objectProto.toString;
  /** Built-in value references. */

  var propertyIsEnumerable = objectProto.propertyIsEnumerable;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeKeys = overArg(Object.keys, Object),
      nativeMax = Math.max;
  /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */

  var nonEnumShadows = !propertyIsEnumerable.call({
    'valueOf': 1
  }, 'valueOf');
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length,
        skipIndexes = !!length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */


  function assignValue(object, key, value) {
    var objValue = object[key];

    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
      object[key] = value;
    }
  }
  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }

    var result = [];

    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */


  function baseRest(func, start) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function () {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }

      index = -1;
      var otherArgs = Array(start + 1);

      while (++index < start) {
        otherArgs[index] = args[index];
      }

      otherArgs[start] = array;
      return apply(func, this, otherArgs);
    };
  }
  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */


  function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
      assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }

    return object;
  }
  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */


  function createAssigner(assigner) {
    return baseRest(function (object, sources) {
      var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;
      customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? undefined : customizer;
        length = 1;
      }

      object = Object(object);

      while (++index < length) {
        var source = sources[index];

        if (source) {
          assigner(object, source, index, customizer);
        }
      }

      return object;
    });
  }
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */


  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */


  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }

    var type = typeof index;

    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
      return eq(object[index], value);
    }

    return false;
  }
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */


  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */


  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */


  function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
  }
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */


  var isArray = Array.isArray;
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */


  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */


  function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
  }
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */


  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }
  /**
   * Assigns own enumerable string keyed properties of source objects to the
   * destination object. Source objects are applied from left to right.
   * Subsequent sources overwrite property assignments of previous sources.
   *
   * **Note:** This method mutates `object` and is loosely based on
   * [`Object.assign`](https://mdn.io/Object/assign).
   *
   * @static
   * @memberOf _
   * @since 0.10.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @see _.assignIn
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * function Bar() {
   *   this.c = 3;
   * }
   *
   * Foo.prototype.b = 2;
   * Bar.prototype.d = 4;
   *
   * _.assign({ 'a': 0 }, new Foo, new Bar);
   * // => { 'a': 1, 'c': 3 }
   */


  var assign = createAssigner(function (object, source) {
    if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
      copyObject(source, keys(source), object);
      return;
    }

    for (var key in source) {
      if (hasOwnProperty.call(source, key)) {
        assignValue(object, key, source[key]);
      }
    }
  });
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */

  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }

  module.exports = assign;
  /***/
},
/* 203 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
    * lodash (Custom Build) <https://lodash.com/>
    * Build: `lodash modularize exports="npm" -o ./`
    * Copyright jQuery Foundation and other contributors <https://jquery.org/>
    * Released under MIT license <https://lodash.com/license>
    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    */

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;
    /** Used to stand-in for `undefined` hash values. */

    var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as references for various `Number` constants. */

    var INFINITY = 1 / 0,
        MAX_SAFE_INTEGER = 9007199254740991;
    /** `Object#toString` result references. */

    var argsTag = '[object Arguments]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        symbolTag = '[object Symbol]';
    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */

    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to detect host constructors (Safari). */

    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect unsigned integer values. */

    var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Detect free variable `global` from Node.js. */

    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */

    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */

    var root = freeGlobal || freeSelf || Function('return this')();
    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */

    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);

        case 1:
          return func.call(thisArg, args[0]);

        case 2:
          return func.call(thisArg, args[0], args[1]);

        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }

      return func.apply(thisArg, args);
    }
    /**
     * A specialized version of `_.includes` for arrays without support for
     * specifying an index to search from.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */


    function arrayIncludes(array, value) {
      var length = array ? array.length : 0;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
     * This function is like `arrayIncludes` except that it accepts a comparator.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */


    function arrayIncludesWith(array, value, comparator) {
      var index = -1,
          length = array ? array.length : 0;

      while (++index < length) {
        if (comparator(value, array[index])) {
          return true;
        }
      }

      return false;
    }
    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */


    function arrayMap(array, iteratee) {
      var index = -1,
          length = array ? array.length : 0,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }

      return result;
    }
    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */


    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }

      return array;
    }
    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
          index = fromIndex + (fromRight ? 1 : -1);

      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function baseIndexOf(array, value, fromIndex) {
      if (value !== value) {
        return baseFindIndex(array, baseIsNaN, fromIndex);
      }

      var index = fromIndex - 1,
          length = array.length;

      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */


    function baseIsNaN(value) {
      return value !== value;
    }
    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */


    function baseTimes(n, iteratee) {
      var index = -1,
          result = Array(n);

      while (++index < n) {
        result[index] = iteratee(index);
      }

      return result;
    }
    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */


    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }
    /**
     * Checks if a cache value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function cacheHas(cache, key) {
      return cache.has(key);
    }
    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */


    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }
    /**
     * Checks if `value` is a host object in IE < 9.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
     */


    function isHostObject(value) {
      // Many host objects are `Object` objects that can coerce to strings
      // despite having improperly defined `toString` methods.
      var result = false;

      if (value != null && typeof value.toString != 'function') {
        try {
          result = !!(value + '');
        } catch (e) {}
      }

      return result;
    }
    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */


    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }
    /** Used for built-in method references. */


    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;
    /** Used to detect overreaching core-js shims. */

    var coreJsData = root['__core-js_shared__'];
    /** Used to detect methods masquerading as native. */

    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();
    /** Used to resolve the decompiled source of functions. */


    var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */

    var hasOwnProperty = objectProto.hasOwnProperty;
    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */

    var objectToString = objectProto.toString;
    /** Used to detect if a method is native. */

    var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    /** Built-in value references. */

    var Symbol = root.Symbol,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
    /* Built-in method references for those with the same name as other `lodash` methods. */

    var nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeMax = Math.max;
    /* Built-in method references that are verified to be native. */

    var Map = getNative(root, 'Map'),
        nativeCreate = getNative(Object, 'create');
    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function Hash(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */


    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function hashDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }
    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function hashGet(key) {
      var data = this.__data__;

      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }

      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */


    function hashSet(key, value) {
      var data = this.__data__;
      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
      return this;
    } // Add methods to `Hash`.


    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function ListCache(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */


    function listCacheClear() {
      this.__data__ = [];
    }
    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }

      var lastIndex = data.length - 1;

      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }

      return true;
    }
    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);
      return index < 0 ? undefined : data[index][1];
    }
    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */


    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }

      return this;
    } // Add methods to `ListCache`.


    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function MapCache(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */


    function mapCacheClear() {
      this.__data__ = {
        'hash': new Hash(),
        'map': new (Map || ListCache)(),
        'string': new Hash()
      };
    }
    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function mapCacheDelete(key) {
      return getMapData(this, key)['delete'](key);
    }
    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */


    function mapCacheSet(key, value) {
      getMapData(this, key).set(key, value);
      return this;
    } // Add methods to `MapCache`.


    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */

    function SetCache(values) {
      var index = -1,
          length = values ? values.length : 0;
      this.__data__ = new MapCache();

      while (++index < length) {
        this.add(values[index]);
      }
    }
    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */


    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);

      return this;
    }
    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */


    function setCacheHas(value) {
      return this.__data__.has(value);
    } // Add methods to `SetCache`.


    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */

    function arrayLikeKeys(value, inherited) {
      // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
      // Safari 9 makes `arguments.length` enumerable in strict mode.
      var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
      var length = result.length,
          skipIndexes = !!length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
          result.push(key);
        }
      }

      return result;
    }
    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function assocIndexOf(array, key) {
      var length = array.length;

      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }

      return -1;
    }
    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */


    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }

      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }

      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      } else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }

      outer: while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;

        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;

          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }

          result.push(value);
        } else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }

      return result;
    }
    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */


    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;
      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];

        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }

      return result;
    }
    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */


    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */


    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }

      var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */


    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }

      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }

      return result;
    }
    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property identifiers to pick.
     * @returns {Object} Returns the new object.
     */


    function basePick(object, props) {
      object = Object(object);
      return basePickBy(object, props, function (value, key) {
        return key in object;
      });
    }
    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property identifiers to pick from.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */


    function basePickBy(object, props, predicate) {
      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (predicate(value, key)) {
          result[key] = value;
        }
      }

      return result;
    }
    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */


    function baseRest(func, start) {
      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
      return function () {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }

        index = -1;
        var otherArgs = Array(start + 1);

        while (++index < start) {
          otherArgs[index] = args[index];
        }

        otherArgs[start] = array;
        return apply(func, this, otherArgs);
      };
    }
    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */


    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }
    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */


    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */


    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }
    /**
     * Creates an array of the own enumerable symbol properties of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */


    var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
    /**
     * Creates an array of the own and inherited enumerable symbol properties
     * of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */

    var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
      var result = [];

      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }

      return result;
    };
    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */

    function isFlattenable(value) {
      return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
    }
    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */


    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */


    function isKeyable(value) {
      var type = typeof value;
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */


    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */


    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
      return value === proto;
    }
    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */


    function nativeKeysIn(object) {
      var result = [];

      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }

      return result;
    }
    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */


    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }

      var result = value + '';
      return result == '0' && 1 / value == -INFINITY ? '-0' : result;
    }
    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to process.
     * @returns {string} Returns the source code.
     */


    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}

        try {
          return func + '';
        } catch (e) {}
      }

      return '';
    }
    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */


    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */


    function isArguments(value) {
      // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
    }
    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */


    var isArray = Array.isArray;
    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */

    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */


    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */


    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8-9 which returns 'object' for typed array and other constructors.
      var tag = isObject(value) ? objectToString.call(value) : '';
      return tag == funcTag || tag == genTag;
    }
    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */


    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */


    function isObject(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */


    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }
    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */


    function isSymbol(value) {
      return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */


    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }
    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable string keyed properties of `object` that are
     * not omitted.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [props] The property identifiers to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */


    var omit = baseRest(function (object, props) {
      if (object == null) {
        return {};
      }

      props = arrayMap(baseFlatten(props, 1), toKey);
      return basePick(object, baseDifference(getAllKeysIn(object), props));
    });
    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */

    function stubArray() {
      return [];
    }

    module.exports = omit;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10));
  /***/
},
/* 204 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
    * lodash (Custom Build) <https://lodash.com/>
    * Build: `lodash modularize exports="npm" -o ./`
    * Copyright jQuery Foundation and other contributors <https://jquery.org/>
    * Released under MIT license <https://lodash.com/license>
    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    */

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0,
        MAX_SAFE_INTEGER = 9007199254740991;
    /** `Object#toString` result references. */

    var argsTag = '[object Arguments]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        symbolTag = '[object Symbol]';
    /** Detect free variable `global` from Node.js. */

    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */

    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */

    var root = freeGlobal || freeSelf || Function('return this')();
    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */

    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);

        case 1:
          return func.call(thisArg, args[0]);

        case 2:
          return func.call(thisArg, args[0], args[1]);

        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }

      return func.apply(thisArg, args);
    }
    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */


    function arrayMap(array, iteratee) {
      var index = -1,
          length = array ? array.length : 0,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }

      return result;
    }
    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */


    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }

      return array;
    }
    /** Used for built-in method references. */


    var objectProto = Object.prototype;
    /** Used to check objects for own properties. */

    var hasOwnProperty = objectProto.hasOwnProperty;
    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */

    var objectToString = objectProto.toString;
    /** Built-in value references. */

    var Symbol = root.Symbol,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
    /* Built-in method references for those with the same name as other `lodash` methods. */

    var nativeMax = Math.max;
    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */

    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;
      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];

        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }

      return result;
    }
    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property identifiers to pick.
     * @returns {Object} Returns the new object.
     */


    function basePick(object, props) {
      object = Object(object);
      return basePickBy(object, props, function (value, key) {
        return key in object;
      });
    }
    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property identifiers to pick from.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */


    function basePickBy(object, props, predicate) {
      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (predicate(value, key)) {
          result[key] = value;
        }
      }

      return result;
    }
    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */


    function baseRest(func, start) {
      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
      return function () {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }

        index = -1;
        var otherArgs = Array(start + 1);

        while (++index < start) {
          otherArgs[index] = args[index];
        }

        otherArgs[start] = array;
        return apply(func, this, otherArgs);
      };
    }
    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */


    function isFlattenable(value) {
      return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
    }
    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */


    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }

      var result = value + '';
      return result == '0' && 1 / value == -INFINITY ? '-0' : result;
    }
    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */


    function isArguments(value) {
      // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
    }
    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */


    var isArray = Array.isArray;
    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */

    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */


    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */


    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8-9 which returns 'object' for typed array and other constructors.
      var tag = isObject(value) ? objectToString.call(value) : '';
      return tag == funcTag || tag == genTag;
    }
    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */


    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */


    function isObject(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */


    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }
    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */


    function isSymbol(value) {
      return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [props] The property identifiers to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */


    var pick = baseRest(function (object, props) {
      return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
    });
    module.exports = pick;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10));
  /***/
},
/* 205 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
    * lodash (Custom Build) <https://lodash.com/>
    * Build: `lodash modularize exports="npm" -o ./`
    * Copyright jQuery Foundation and other contributors <https://jquery.org/>
    * Released under MIT license <https://lodash.com/license>
    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    */

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;
    /** Used to stand-in for `undefined` hash values. */

    var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as references for various `Number` constants. */

    var INFINITY = 1 / 0;
    /** `Object#toString` result references. */

    var funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]';
    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */

    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to detect host constructors (Safari). */

    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Detect free variable `global` from Node.js. */

    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */

    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */

    var root = freeGlobal || freeSelf || Function('return this')();
    /**
     * A specialized version of `_.includes` for arrays without support for
     * specifying an index to search from.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */

    function arrayIncludes(array, value) {
      var length = array ? array.length : 0;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
     * This function is like `arrayIncludes` except that it accepts a comparator.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */


    function arrayIncludesWith(array, value, comparator) {
      var index = -1,
          length = array ? array.length : 0;

      while (++index < length) {
        if (comparator(value, array[index])) {
          return true;
        }
      }

      return false;
    }
    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
          index = fromIndex + (fromRight ? 1 : -1);

      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function baseIndexOf(array, value, fromIndex) {
      if (value !== value) {
        return baseFindIndex(array, baseIsNaN, fromIndex);
      }

      var index = fromIndex - 1,
          length = array.length;

      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */


    function baseIsNaN(value) {
      return value !== value;
    }
    /**
     * Checks if a cache value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function cacheHas(cache, key) {
      return cache.has(key);
    }
    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */


    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }
    /**
     * Checks if `value` is a host object in IE < 9.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
     */


    function isHostObject(value) {
      // Many host objects are `Object` objects that can coerce to strings
      // despite having improperly defined `toString` methods.
      var result = false;

      if (value != null && typeof value.toString != 'function') {
        try {
          result = !!(value + '');
        } catch (e) {}
      }

      return result;
    }
    /**
     * Converts `set` to an array of its values.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the values.
     */


    function setToArray(set) {
      var index = -1,
          result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = value;
      });
      return result;
    }
    /** Used for built-in method references. */


    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;
    /** Used to detect overreaching core-js shims. */

    var coreJsData = root['__core-js_shared__'];
    /** Used to detect methods masquerading as native. */

    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();
    /** Used to resolve the decompiled source of functions. */


    var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */

    var hasOwnProperty = objectProto.hasOwnProperty;
    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */

    var objectToString = objectProto.toString;
    /** Used to detect if a method is native. */

    var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    /** Built-in value references. */

    var splice = arrayProto.splice;
    /* Built-in method references that are verified to be native. */

    var Map = getNative(root, 'Map'),
        Set = getNative(root, 'Set'),
        nativeCreate = getNative(Object, 'create');
    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function Hash(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */


    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function hashDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }
    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function hashGet(key) {
      var data = this.__data__;

      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }

      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */


    function hashSet(key, value) {
      var data = this.__data__;
      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
      return this;
    } // Add methods to `Hash`.


    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function ListCache(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */


    function listCacheClear() {
      this.__data__ = [];
    }
    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }

      var lastIndex = data.length - 1;

      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }

      return true;
    }
    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);
      return index < 0 ? undefined : data[index][1];
    }
    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */


    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }

      return this;
    } // Add methods to `ListCache`.


    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function MapCache(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */


    function mapCacheClear() {
      this.__data__ = {
        'hash': new Hash(),
        'map': new (Map || ListCache)(),
        'string': new Hash()
      };
    }
    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function mapCacheDelete(key) {
      return getMapData(this, key)['delete'](key);
    }
    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */


    function mapCacheSet(key, value) {
      getMapData(this, key).set(key, value);
      return this;
    } // Add methods to `MapCache`.


    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */

    function SetCache(values) {
      var index = -1,
          length = values ? values.length : 0;
      this.__data__ = new MapCache();

      while (++index < length) {
        this.add(values[index]);
      }
    }
    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */


    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);

      return this;
    }
    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */


    function setCacheHas(value) {
      return this.__data__.has(value);
    } // Add methods to `SetCache`.


    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */

    function assocIndexOf(array, key) {
      var length = array.length;

      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */


    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }

      var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */


    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);

        if (set) {
          return setToArray(set);
        }

        isCommon = false;
        includes = cacheHas;
        seen = new SetCache();
      } else {
        seen = iteratee ? [] : result;
      }

      outer: while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;

        if (isCommon && computed === computed) {
          var seenIndex = seen.length;

          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }

          if (iteratee) {
            seen.push(computed);
          }

          result.push(value);
        } else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }

          result.push(value);
        }
      }

      return result;
    }
    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */


    var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
      return new Set(values);
    };
    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */

    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */


    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }
    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */


    function isKeyable(value) {
      var type = typeof value;
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */


    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to process.
     * @returns {string} Returns the source code.
     */


    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}

        try {
          return func + '';
        } catch (e) {}
      }

      return '';
    }
    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each
     * element is kept.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */


    function uniq(array) {
      return array && array.length ? baseUniq(array) : [];
    }
    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */


    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */


    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8-9 which returns 'object' for typed array and other constructors.
      var tag = isObject(value) ? objectToString.call(value) : '';
      return tag == funcTag || tag == genTag;
    }
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */


    function isObject(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }
    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */


    function noop() {// No operation performed.
    }

    module.exports = uniq;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10));
  /***/
},
/* 206 */

/***/
function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(139),
      arrayMap = __webpack_require__(502),
      isArray = __webpack_require__(140),
      isSymbol = __webpack_require__(525);
  /** Used as references for various `Number` constants. */


  var INFINITY = 1 / 0;
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;
  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */

  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }

    if (isArray(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }

    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }

    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }

  module.exports = baseToString;
  /***/
},
/* 207 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  module.exports = baseUnary;
  /***/
},
/* 208 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /** Detect free variable `global` from Node.js. */
    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    module.exports = freeGlobal;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10));
  /***/
},
/* 209 */

/***/
function (module, exports) {
  /** Used to compose unicode character classes. */
  var rsAstralRange = "\\ud800-\\udfff",
      rsComboMarksRange = "\\u0300-\\u036f",
      reComboHalfMarksRange = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange = "\\u20d0-\\u20ff",
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsVarRange = "\\ufe0e\\ufe0f";
  /** Used to compose unicode capture groups. */

  var rsZWJ = "\\u200d";
  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */

  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  module.exports = hasUnicode;
  /***/
},
/* 210 */

/***/
function (module, exports) {
  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */

  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }

  module.exports = isIndex;
  /***/
},
/* 211 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (module) {
    var freeGlobal = __webpack_require__(208);
    /** Detect free variable `exports`. */


    var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */

    var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */

    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */

    var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */

    var nodeUtil = function () {
      try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;

        if (types) {
          return types;
        } // Legacy `process.binding('util')` for Node.js < 10.


        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();

    module.exports = nodeUtil;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(84)(module));
  /***/
},
/* 212 */

/***/
function (module, exports, __webpack_require__) {
  var freeGlobal = __webpack_require__(208);
  /** Detect free variable `self`. */


  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  module.exports = root;
  /***/
},
/* 213 */

/***/
function (module, exports, __webpack_require__) {
  var isFunction = __webpack_require__(522),
      isLength = __webpack_require__(214);
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */


  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  module.exports = isArrayLike;
  /***/
},
/* 214 */

/***/
function (module, exports) {
  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */

  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  module.exports = isLength;
  /***/
},
/* 215 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }

  module.exports = isObject;
  /***/
},
/* 216 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var Buffer = __webpack_require__(38).Buffer;
  /* Protocol - protocol constants */


  var protocol = module.exports;
  /* Command code => mnemonic */

  protocol.types = {
    0: 'reserved',
    1: 'connect',
    2: 'connack',
    3: 'publish',
    4: 'puback',
    5: 'pubrec',
    6: 'pubrel',
    7: 'pubcomp',
    8: 'subscribe',
    9: 'suback',
    10: 'unsubscribe',
    11: 'unsuback',
    12: 'pingreq',
    13: 'pingresp',
    14: 'disconnect',
    15: 'reserved'
    /* Mnemonic => Command code */

  };
  protocol.codes = {};

  for (var k in protocol.types) {
    var v = protocol.types[k];
    protocol.codes[v] = k;
  }
  /* Header */


  protocol.CMD_SHIFT = 4;
  protocol.CMD_MASK = 0xF0;
  protocol.DUP_MASK = 0x08;
  protocol.QOS_MASK = 0x03;
  protocol.QOS_SHIFT = 1;
  protocol.RETAIN_MASK = 0x01;
  /* Length */

  protocol.LENGTH_MASK = 0x7F;
  protocol.LENGTH_FIN_MASK = 0x80;
  /* Connack */

  protocol.SESSIONPRESENT_MASK = 0x01;
  protocol.SESSIONPRESENT_HEADER = Buffer.from([protocol.SESSIONPRESENT_MASK]);
  protocol.CONNACK_HEADER = Buffer.from([protocol.codes['connack'] << protocol.CMD_SHIFT]);
  /* Connect */

  protocol.USERNAME_MASK = 0x80;
  protocol.PASSWORD_MASK = 0x40;
  protocol.WILL_RETAIN_MASK = 0x20;
  protocol.WILL_QOS_MASK = 0x18;
  protocol.WILL_QOS_SHIFT = 3;
  protocol.WILL_FLAG_MASK = 0x04;
  protocol.CLEAN_SESSION_MASK = 0x02;
  protocol.CONNECT_HEADER = Buffer.from([protocol.codes['connect'] << protocol.CMD_SHIFT]);

  function genHeader(type) {
    return [0, 1, 2].map(function (qos) {
      return [0, 1].map(function (dup) {
        return [0, 1].map(function (retain) {
          var buf = new Buffer(1);
          buf.writeUInt8(protocol.codes[type] << protocol.CMD_SHIFT | (dup ? protocol.DUP_MASK : 0) | qos << protocol.QOS_SHIFT | retain, 0, true);
          return buf;
        });
      });
    });
  }
  /* Publish */


  protocol.PUBLISH_HEADER = genHeader('publish');
  /* Subscribe */

  protocol.SUBSCRIBE_HEADER = genHeader('subscribe');
  /* Unsubscribe */

  protocol.UNSUBSCRIBE_HEADER = genHeader('unsubscribe');
  /* Confirmations */

  protocol.ACKS = {
    unsuback: genHeader('unsuback'),
    puback: genHeader('puback'),
    pubcomp: genHeader('pubcomp'),
    pubrel: genHeader('pubrel'),
    pubrec: genHeader('pubrec')
  };
  protocol.SUBACK_HEADER = Buffer.from([protocol.codes['suback'] << protocol.CMD_SHIFT]);
  /* Protocol versions */

  protocol.VERSION3 = Buffer.from([3]);
  protocol.VERSION4 = Buffer.from([4]);
  /* QoS */

  protocol.QOS = [0, 1, 2].map(function (qos) {
    return Buffer.from([qos]);
  });
  /* Empty packets */

  protocol.EMPTY = {
    pingreq: Buffer.from([protocol.codes['pingreq'] << 4, 0]),
    pingresp: Buffer.from([protocol.codes['pingresp'] << 4, 0]),
    disconnect: Buffer.from([protocol.codes['disconnect'] << 4, 0])
    /***/

  };
},
/* 217 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var protocol = __webpack_require__(216);

  var Buffer = __webpack_require__(38).Buffer;

  var empty = Buffer.allocUnsafe(0);
  var zeroBuf = Buffer.from([0]);

  var numbers = __webpack_require__(533);

  var nextTick = __webpack_require__(83).nextTick;

  var numCache = numbers.cache;
  var generateNumber = numbers.generateNumber;
  var generateCache = numbers.generateCache;
  var writeNumber = writeNumberCached;
  var toGenerate = true;

  function generate(packet, stream) {
    if (stream.cork) {
      stream.cork();
      nextTick(uncork, stream);
    }

    if (toGenerate) {
      toGenerate = false;
      generateCache();
    }

    switch (packet.cmd) {
      case 'connect':
        return connect(packet, stream);

      case 'connack':
        return connack(packet, stream);

      case 'publish':
        return publish(packet, stream);

      case 'puback':
      case 'pubrec':
      case 'pubrel':
      case 'pubcomp':
      case 'unsuback':
        return confirmation(packet, stream);

      case 'subscribe':
        return subscribe(packet, stream);

      case 'suback':
        return suback(packet, stream);

      case 'unsubscribe':
        return unsubscribe(packet, stream);

      case 'pingreq':
      case 'pingresp':
      case 'disconnect':
        return emptyPacket(packet, stream);

      default:
        stream.emit('error', new Error('Unknown command'));
        return false;
    }
  }
  /**
   * Controls numbers cache.
   * Set to "false" to allocate buffers on-the-flight instead of pre-generated cache
   */


  Object.defineProperty(generate, 'cacheNumbers', {
    get: function get() {
      return writeNumber === writeNumberCached;
    },
    set: function set(value) {
      if (value) {
        if (!numCache || Object.keys(numCache).length === 0) toGenerate = true;
        writeNumber = writeNumberCached;
      } else {
        toGenerate = false;
        writeNumber = writeNumberGenerated;
      }
    }
  });

  function uncork(stream) {
    stream.uncork();
  }

  function connect(opts, stream) {
    var settings = opts || {};
    var protocolId = settings.protocolId || 'MQTT';
    var protocolVersion = settings.protocolVersion || 4;
    var will = settings.will;
    var clean = settings.clean;
    var keepalive = settings.keepalive || 0;
    var clientId = settings.clientId || '';
    var username = settings.username;
    var password = settings.password;
    if (clean === undefined) clean = true;
    var length = 0; // Must be a string and non-falsy

    if (!protocolId || typeof protocolId !== 'string' && !Buffer.isBuffer(protocolId)) {
      stream.emit('error', new Error('Invalid protocolId'));
      return false;
    } else length += protocolId.length + 2; // Must be 3 or 4


    if (protocolVersion !== 3 && protocolVersion !== 4) {
      stream.emit('error', new Error('Invalid protocol version'));
      return false;
    } else length += 1; // ClientId might be omitted in 3.1.1, but only if cleanSession is set to 1


    if ((typeof clientId === 'string' || Buffer.isBuffer(clientId)) && (clientId || protocolVersion === 4) && (clientId || clean)) {
      length += clientId.length + 2;
    } else {
      if (protocolVersion < 4) {
        stream.emit('error', new Error('clientId must be supplied before 3.1.1'));
        return false;
      }

      if (clean * 1 === 0) {
        stream.emit('error', new Error('clientId must be given if cleanSession set to 0'));
        return false;
      }
    } // Must be a two byte number


    if (typeof keepalive !== 'number' || keepalive < 0 || keepalive > 65535 || keepalive % 1 !== 0) {
      stream.emit('error', new Error('Invalid keepalive'));
      return false;
    } else length += 2; // Connect flags


    length += 1; // If will exists...

    if (will) {
      // It must be an object
      if (typeof will !== 'object') {
        stream.emit('error', new Error('Invalid will'));
        return false;
      } // It must have topic typeof string


      if (!will.topic || typeof will.topic !== 'string') {
        stream.emit('error', new Error('Invalid will topic'));
        return false;
      } else {
        length += Buffer.byteLength(will.topic) + 2;
      } // Payload


      if (will.payload && will.payload) {
        if (will.payload.length >= 0) {
          if (typeof will.payload === 'string') {
            length += Buffer.byteLength(will.payload) + 2;
          } else {
            length += will.payload.length + 2;
          }
        } else {
          stream.emit('error', new Error('Invalid will payload'));
          return false;
        }
      } else {
        length += 2;
      }
    } // Username


    var providedUsername = false;

    if (username != null) {
      if (isStringOrBuffer(username)) {
        providedUsername = true;
        length += Buffer.byteLength(username) + 2;
      } else {
        stream.emit('error', new Error('Invalid username'));
        return false;
      }
    } // Password


    if (password != null) {
      if (!providedUsername) {
        stream.emit('error', new Error('Username is required to use password'));
        return false;
      }

      if (isStringOrBuffer(password)) {
        length += byteLength(password) + 2;
      } else {
        stream.emit('error', new Error('Invalid password'));
        return false;
      }
    } // Generate header


    stream.write(protocol.CONNECT_HEADER); // Generate length

    writeLength(stream, length); // Generate protocol ID

    writeStringOrBuffer(stream, protocolId);
    stream.write(protocolVersion === 4 ? protocol.VERSION4 : protocol.VERSION3); // Connect flags

    var flags = 0;
    flags |= username != null ? protocol.USERNAME_MASK : 0;
    flags |= password != null ? protocol.PASSWORD_MASK : 0;
    flags |= will && will.retain ? protocol.WILL_RETAIN_MASK : 0;
    flags |= will && will.qos ? will.qos << protocol.WILL_QOS_SHIFT : 0;
    flags |= will ? protocol.WILL_FLAG_MASK : 0;
    flags |= clean ? protocol.CLEAN_SESSION_MASK : 0;
    stream.write(Buffer.from([flags])); // Keepalive

    writeNumber(stream, keepalive); // Client ID

    writeStringOrBuffer(stream, clientId); // Will

    if (will) {
      writeString(stream, will.topic);
      writeStringOrBuffer(stream, will.payload);
    } // Username and password


    if (username != null) {
      writeStringOrBuffer(stream, username);
    }

    if (password != null) {
      writeStringOrBuffer(stream, password);
    } // This is a small packet that happens only once on a stream
    // We assume the stream is always free to receive more data after this


    return true;
  }

  function connack(opts, stream) {
    var settings = opts || {};
    var rc = settings.returnCode; // Check return code

    if (typeof rc !== 'number') {
      stream.emit('error', new Error('Invalid return code'));
      return false;
    }

    stream.write(protocol.CONNACK_HEADER);
    writeLength(stream, 2);
    stream.write(opts.sessionPresent ? protocol.SESSIONPRESENT_HEADER : zeroBuf);
    return stream.write(Buffer.from([rc]));
  }

  function publish(opts, stream) {
    var settings = opts || {};
    var qos = settings.qos || 0;
    var retain = settings.retain ? protocol.RETAIN_MASK : 0;
    var topic = settings.topic;
    var payload = settings.payload || empty;
    var id = settings.messageId;
    var length = 0; // Topic must be a non-empty string or Buffer

    if (typeof topic === 'string') length += Buffer.byteLength(topic) + 2;else if (Buffer.isBuffer(topic)) length += topic.length + 2;else {
      stream.emit('error', new Error('Invalid topic'));
      return false;
    } // Get the payload length

    if (!Buffer.isBuffer(payload)) length += Buffer.byteLength(payload);else length += payload.length; // Message ID must a number if qos > 0

    if (qos && typeof id !== 'number') {
      stream.emit('error', new Error('Invalid messageId'));
      return false;
    } else if (qos) length += 2; // Header


    stream.write(protocol.PUBLISH_HEADER[qos][opts.dup ? 1 : 0][retain ? 1 : 0]); // Remaining length

    writeLength(stream, length); // Topic

    writeNumber(stream, byteLength(topic));
    stream.write(topic); // Message ID

    if (qos > 0) writeNumber(stream, id); // Payload

    return stream.write(payload);
  }
  /* Puback, pubrec, pubrel and pubcomp */


  function confirmation(opts, stream) {
    var settings = opts || {};
    var type = settings.cmd || 'puback';
    var id = settings.messageId;
    var dup = settings.dup && type === 'pubrel' ? protocol.DUP_MASK : 0;
    var qos = 0;
    if (type === 'pubrel') qos = 1; // Check message ID

    if (typeof id !== 'number') {
      stream.emit('error', new Error('Invalid messageId'));
      return false;
    } // Header


    stream.write(protocol.ACKS[type][qos][dup][0]); // Length

    writeLength(stream, 2); // Message ID

    return writeNumber(stream, id);
  }

  function subscribe(opts, stream) {
    var settings = opts || {};
    var dup = settings.dup ? protocol.DUP_MASK : 0;
    var id = settings.messageId;
    var subs = settings.subscriptions;
    var length = 0; // Check message ID

    if (typeof id !== 'number') {
      stream.emit('error', new Error('Invalid messageId'));
      return false;
    } else length += 2; // Check subscriptions


    if (typeof subs === 'object' && subs.length) {
      for (var i = 0; i < subs.length; i += 1) {
        var itopic = subs[i].topic;
        var iqos = subs[i].qos;

        if (typeof itopic !== 'string') {
          stream.emit('error', new Error('Invalid subscriptions - invalid topic'));
          return false;
        }

        if (typeof iqos !== 'number') {
          stream.emit('error', new Error('Invalid subscriptions - invalid qos'));
          return false;
        }

        length += Buffer.byteLength(itopic) + 2 + 1;
      }
    } else {
      stream.emit('error', new Error('Invalid subscriptions'));
      return false;
    } // Generate header


    stream.write(protocol.SUBSCRIBE_HEADER[1][dup ? 1 : 0][0]); // Generate length

    writeLength(stream, length); // Generate message ID

    writeNumber(stream, id);
    var result = true; // Generate subs

    for (var j = 0; j < subs.length; j++) {
      var sub = subs[j];
      var jtopic = sub.topic;
      var jqos = sub.qos; // Write topic string

      writeString(stream, jtopic); // Write qos

      result = stream.write(protocol.QOS[jqos]);
    }

    return result;
  }

  function suback(opts, stream) {
    var settings = opts || {};
    var id = settings.messageId;
    var granted = settings.granted;
    var length = 0; // Check message ID

    if (typeof id !== 'number') {
      stream.emit('error', new Error('Invalid messageId'));
      return false;
    } else length += 2; // Check granted qos vector


    if (typeof granted === 'object' && granted.length) {
      for (var i = 0; i < granted.length; i += 1) {
        if (typeof granted[i] !== 'number') {
          stream.emit('error', new Error('Invalid qos vector'));
          return false;
        }

        length += 1;
      }
    } else {
      stream.emit('error', new Error('Invalid qos vector'));
      return false;
    } // header


    stream.write(protocol.SUBACK_HEADER); // Length

    writeLength(stream, length); // Message ID

    writeNumber(stream, id);
    return stream.write(Buffer.from(granted));
  }

  function unsubscribe(opts, stream) {
    var settings = opts || {};
    var id = settings.messageId;
    var dup = settings.dup ? protocol.DUP_MASK : 0;
    var unsubs = settings.unsubscriptions;
    var length = 0; // Check message ID

    if (typeof id !== 'number') {
      stream.emit('error', new Error('Invalid messageId'));
      return false;
    } else {
      length += 2;
    } // Check unsubs


    if (typeof unsubs === 'object' && unsubs.length) {
      for (var i = 0; i < unsubs.length; i += 1) {
        if (typeof unsubs[i] !== 'string') {
          stream.emit('error', new Error('Invalid unsubscriptions'));
          return false;
        }

        length += Buffer.byteLength(unsubs[i]) + 2;
      }
    } else {
      stream.emit('error', new Error('Invalid unsubscriptions'));
      return false;
    } // Header


    stream.write(protocol.UNSUBSCRIBE_HEADER[1][dup ? 1 : 0][0]); // Length

    writeLength(stream, length); // Message ID

    writeNumber(stream, id); // Unsubs

    var result = true;

    for (var j = 0; j < unsubs.length; j++) {
      result = writeString(stream, unsubs[j]);
    }

    return result;
  }

  function emptyPacket(opts, stream) {
    return stream.write(protocol.EMPTY[opts.cmd]);
  }
  /**
   * calcLengthLength - calculate the length of the remaining
   * length field
   *
   * @api private
   */


  function calcLengthLength(length) {
    if (length >= 0 && length < 128) return 1;else if (length >= 128 && length < 16384) return 2;else if (length >= 16384 && length < 2097152) return 3;else if (length >= 2097152 && length < 268435456) return 4;else return 0;
  }

  function genBufLength(length) {
    var digit = 0;
    var pos = 0;
    var buffer = Buffer.allocUnsafe(calcLengthLength(length));

    do {
      digit = length % 128 | 0;
      length = length / 128 | 0;
      if (length > 0) digit = digit | 0x80;
      buffer.writeUInt8(digit, pos++, true);
    } while (length > 0);

    return buffer;
  }
  /**
   * writeLength - write an MQTT style length field to the buffer
   *
   * @param <Buffer> buffer - destination
   * @param <Number> pos - offset
   * @param <Number> length - length (>0)
   * @returns <Number> number of bytes written
   *
   * @api private
   */


  var lengthCache = {};

  function writeLength(stream, length) {
    var buffer = lengthCache[length];

    if (!buffer) {
      buffer = genBufLength(length);
      if (length < 16384) lengthCache[length] = buffer;
    }

    stream.write(buffer);
  }
  /**
   * writeString - write a utf8 string to the buffer
   *
   * @param <Buffer> buffer - destination
   * @param <Number> pos - offset
   * @param <String> string - string to write
   * @return <Number> number of bytes written
   *
   * @api private
   */


  function writeString(stream, string) {
    var strlen = Buffer.byteLength(string);
    writeNumber(stream, strlen);
    stream.write(string, 'utf8');
  }
  /**
   * writeNumber - write a two byte number to the buffer
   *
   * @param <Buffer> buffer - destination
   * @param <Number> pos - offset
   * @param <String> number - number to write
   * @return <Number> number of bytes written
   *
   * @api private
   */


  function writeNumberCached(stream, number) {
    return stream.write(numCache[number]);
  }

  function writeNumberGenerated(stream, number) {
    return stream.write(generateNumber(number));
  }
  /**
   * writeStringOrBuffer - write a String or Buffer with the its length prefix
   *
   * @param <Buffer> buffer - destination
   * @param <Number> pos - offset
   * @param <String> toWrite - String or Buffer
   * @return <Number> number of bytes written
   */


  function writeStringOrBuffer(stream, toWrite) {
    if (typeof toWrite === 'string') {
      writeString(stream, toWrite);
    } else if (toWrite) {
      writeNumber(stream, toWrite.length);
      stream.write(toWrite);
    } else writeNumber(stream, 0);
  }

  function byteLength(bufOrString) {
    if (!bufOrString) return 0;else if (bufOrString instanceof Buffer) return bufOrString.length;else return Buffer.byteLength(bufOrString);
  }

  function isStringOrBuffer(field) {
    return typeof field === 'string' || field instanceof Buffer;
  }

  module.exports = generate;
  /***/
},
/* 218 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var net = __webpack_require__(606);
  /*
    variables port and host can be removed since
    you have all required information in opts object
  */


  function buildBuilder(client, opts) {
    var port, host;
    opts.port = opts.port || 1883;
    opts.hostname = opts.hostname || opts.host || 'localhost';
    port = opts.port;
    host = opts.hostname;
    return net.createConnection(port, host);
  }

  module.exports = buildBuilder;
  /***/
},
/* 219 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    var websocket = __webpack_require__(160);

    var urlModule = __webpack_require__(159);

    var WSS_OPTIONS = ['rejectUnauthorized', 'ca', 'cert', 'key', 'pfx', 'passphrase'];
    var IS_BROWSER = process.title === 'browser';

    function buildUrl(opts, client) {
      var url = opts.protocol + '://' + opts.hostname + ':' + opts.port + opts.path;

      if (typeof opts.transformWsUrl === 'function') {
        url = opts.transformWsUrl(url, opts, client);
      }

      return url;
    }

    function setDefaultOpts(opts) {
      if (!opts.hostname) {
        opts.hostname = 'localhost';
      }

      if (!opts.port) {
        if (opts.protocol === 'wss') {
          opts.port = 443;
        } else {
          opts.port = 80;
        }
      }

      if (!opts.path) {
        opts.path = '/';
      }

      if (!opts.wsOptions) {
        opts.wsOptions = {};
      }

      if (!IS_BROWSER && opts.protocol === 'wss') {
        // Add cert/key/ca etc options
        WSS_OPTIONS.forEach(function (prop) {
          if (opts.hasOwnProperty(prop) && !opts.wsOptions.hasOwnProperty(prop)) {
            opts.wsOptions[prop] = opts[prop];
          }
        });
      }
    }

    function createWebSocket(client, opts) {
      var websocketSubProtocol = opts.protocolId === 'MQIsdp' && opts.protocolVersion === 3 ? 'mqttv3.1' : 'mqtt';
      setDefaultOpts(opts);
      var url = buildUrl(opts, client);
      return websocket(url, [websocketSubProtocol], opts.wsOptions);
    }

    function buildBuilder(client, opts) {
      return createWebSocket(client, opts);
    }

    function buildBuilderBrowser(client, opts) {
      if (!opts.hostname) {
        opts.hostname = opts.host;
      }

      if (!opts.hostname) {
        // Throwing an error in a Web Worker if no `hostname` is given, because we
        // can not determine the `hostname` automatically.  If connecting to
        // localhost, please supply the `hostname` as an argument.
        if (typeof document === 'undefined') {
          throw new Error('Could not determine host. Specify host manually.');
        }

        var parsed = urlModule.parse(document.URL);
        opts.hostname = parsed.hostname;

        if (!opts.port) {
          opts.port = parsed.port;
        }
      }

      return createWebSocket(client, opts);
    }

    if (IS_BROWSER) {
      module.exports = buildBuilderBrowser;
    } else {
      module.exports = buildBuilder;
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(16));
  /***/
},
/* 220 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* global wx */

  var socketOpen = false;
  var socketMsgQueue = [];

  function sendSocketMessage(msg) {
    if (socketOpen) {
      wx.sendSocketMessage({
        data: msg
      });
    } else {
      socketMsgQueue.push(msg);
    }
  }

  function WebSocket(url, protocols) {
    var ws = {
      OPEN: 1,
      CLOSING: 2,
      CLOSED: 3,
      readyState: socketOpen ? 1 : 0,
      send: sendSocketMessage,
      close: wx.closeSocket,
      onopen: null,
      onmessage: null,
      onclose: null,
      onerror: null
    };
    wx.connectSocket({
      url: url,
      protocols: protocols
    });
    wx.onSocketOpen(function (res) {
      ws.readyState = ws.OPEN;
      socketOpen = true;

      for (var i = 0; i < socketMsgQueue.length; i++) {
        sendSocketMessage(socketMsgQueue[i]);
      }

      socketMsgQueue = [];
      ws.onopen && ws.onopen.apply(ws, arguments);
    });
    wx.onSocketMessage(function (res) {
      ws.onmessage && ws.onmessage.apply(ws, arguments);
    });
    wx.onSocketClose(function () {
      ws.onclose && ws.onclose.apply(ws, arguments);
      ws.readyState = ws.CLOSED;
      socketOpen = false;
    });
    wx.onSocketError(function () {
      ws.onerror && ws.onerror.apply(ws, arguments);
      ws.readyState = ws.CLOSED;
      socketOpen = false;
    });
    return ws;
  }

  var websocket = __webpack_require__(160);

  var urlModule = __webpack_require__(159);

  function buildUrl(opts, client) {
    var protocol = opts.protocol === 'wxs' ? 'wss' : 'ws';
    var url = protocol + '://' + opts.hostname + ':' + opts.port + opts.path;

    if (typeof opts.transformWsUrl === 'function') {
      url = opts.transformWsUrl(url, opts, client);
    }

    return url;
  }

  function setDefaultOpts(opts) {
    if (!opts.hostname) {
      opts.hostname = 'localhost';
    }

    if (!opts.port) {
      if (opts.protocol === 'wss') {
        opts.port = 443;
      } else {
        opts.port = 80;
      }
    }

    if (!opts.path) {
      opts.path = '/';
    }

    if (!opts.wsOptions) {
      opts.wsOptions = {};
    }
  }

  function createWebSocket(client, opts) {
    var websocketSubProtocol = opts.protocolId === 'MQIsdp' && opts.protocolVersion === 3 ? 'mqttv3.1' : 'mqtt';
    setDefaultOpts(opts);
    var url = buildUrl(opts, client);
    return websocket(WebSocket(url, [websocketSubProtocol]));
  }

  function buildBuilder(client, opts) {
    if (!opts.hostname) {
      opts.hostname = opts.host;
    }

    if (!opts.hostname) {
      // Throwing an error in a Web Worker if no `hostname` is given, because we
      // can not determine the `hostname` automatically.  If connecting to
      // localhost, please supply the `hostname` as an argument.
      if (typeof document === 'undefined') {
        throw new Error('Could not determine host. Specify host manually.');
      }

      var parsed = urlModule.parse(document.URL);
      opts.hostname = parsed.hostname;

      if (!opts.port) {
        opts.port = parsed.port;
      }
    }

    return createWebSocket(client, opts);
  }

  module.exports = buildBuilder;
  /***/
},
/* 221 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
     * Module dependencies
     */
    var xtend = __webpack_require__(161);

    var Readable = __webpack_require__(63).Readable;

    var streamsOpts = {
      objectMode: true
    };
    var defaultStoreOptions = {
      clean: true
      /**
       * In-memory implementation of the message store
       * This can actually be saved into files.
       *
       * @param {Object} [options] - store options
       */

    };

    function Store(options) {
      if (!(this instanceof Store)) {
        return new Store(options);
      }

      this.options = options || {}; // Defaults

      this.options = xtend(defaultStoreOptions, options);
      this._inflights = {};
    }
    /**
     * Adds a packet to the store, a packet is
     * anything that has a messageId property.
     *
     */


    Store.prototype.put = function (packet, cb) {
      this._inflights[packet.messageId] = packet;

      if (cb) {
        cb();
      }

      return this;
    };
    /**
     * Creates a stream with all the packets in the store
     *
     */


    Store.prototype.createStream = function () {
      var stream = new Readable(streamsOpts);
      var inflights = this._inflights;
      var ids = Object.keys(this._inflights);
      var destroyed = false;
      var i = 0;

      stream._read = function () {
        if (!destroyed && i < ids.length) {
          this.push(inflights[ids[i++]]);
        } else {
          this.push(null);
        }
      };

      stream.destroy = function () {
        if (destroyed) {
          return;
        }

        var self = this;
        destroyed = true;
        process.nextTick(function () {
          self.emit('close');
        });
      };

      return stream;
    };
    /**
     * deletes a packet from the store.
     */


    Store.prototype.del = function (packet, cb) {
      packet = this._inflights[packet.messageId];

      if (packet) {
        delete this._inflights[packet.messageId];
        cb(null, packet);
      } else if (cb) {
        cb(new Error('missing packet'));
      }

      return this;
    };
    /**
     * get a packet from the store.
     */


    Store.prototype.get = function (packet, cb) {
      packet = this._inflights[packet.messageId];

      if (packet) {
        cb(null, packet);
      } else if (cb) {
        cb(new Error('missing packet'));
      }

      return this;
    };
    /**
     * Close the store
     */


    Store.prototype.close = function (cb) {
      if (this.options.clean) {
        this._inflights = null;
      }

      if (cb) {
        cb();
      }
    };

    module.exports = Store;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(16));
  /***/
},
/* 222 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Supported cipher modes.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2014 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(8);

  forge.cipher = forge.cipher || {}; // supported cipher modes

  var modes = module.exports = forge.cipher.modes = forge.cipher.modes || {};
  /** Electronic codebook (ECB) (Don't use this; it's not secure) **/

  modes.ecb = function (options) {
    options = options || {};
    this.name = 'ECB';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
  };

  modes.ecb.prototype.start = function (options) {};

  modes.ecb.prototype.encrypt = function (input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) {
      return true;
    } // get next block


    for (var i = 0; i < this._ints; ++i) {
      this._inBlock[i] = input.getInt32();
    } // encrypt block


    this.cipher.encrypt(this._inBlock, this._outBlock); // write output

    for (var i = 0; i < this._ints; ++i) {
      output.putInt32(this._outBlock[i]);
    }
  };

  modes.ecb.prototype.decrypt = function (input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) {
      return true;
    } // get next block


    for (var i = 0; i < this._ints; ++i) {
      this._inBlock[i] = input.getInt32();
    } // decrypt block


    this.cipher.decrypt(this._inBlock, this._outBlock); // write output

    for (var i = 0; i < this._ints; ++i) {
      output.putInt32(this._outBlock[i]);
    }
  };

  modes.ecb.prototype.pad = function (input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
  };

  modes.ecb.prototype.unpad = function (output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) {
      return false;
    } // ensure padding byte count is valid


    var len = output.length();
    var count = output.at(len - 1);

    if (count > this.blockSize << 2) {
      return false;
    } // trim off padding bytes


    output.truncate(count);
    return true;
  };
  /** Cipher-block Chaining (CBC) **/


  modes.cbc = function (options) {
    options = options || {};
    this.name = 'CBC';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
  };

  modes.cbc.prototype.start = function (options) {
    // Note: legacy support for using IV residue (has security flaws)
    // if IV is null, reuse block from previous processing
    if (options.iv === null) {
      // must have a previous block
      if (!this._prev) {
        throw new Error('Invalid IV parameter.');
      }

      this._iv = this._prev.slice(0);
    } else if (!('iv' in options)) {
      throw new Error('Invalid IV parameter.');
    } else {
      // save IV as "previous" block
      this._iv = transformIV(options.iv);
      this._prev = this._iv.slice(0);
    }
  };

  modes.cbc.prototype.encrypt = function (input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) {
      return true;
    } // get next block
    // CBC XOR's IV (or previous block) with plaintext


    for (var i = 0; i < this._ints; ++i) {
      this._inBlock[i] = this._prev[i] ^ input.getInt32();
    } // encrypt block


    this.cipher.encrypt(this._inBlock, this._outBlock); // write output, save previous block

    for (var i = 0; i < this._ints; ++i) {
      output.putInt32(this._outBlock[i]);
    }

    this._prev = this._outBlock;
  };

  modes.cbc.prototype.decrypt = function (input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) {
      return true;
    } // get next block


    for (var i = 0; i < this._ints; ++i) {
      this._inBlock[i] = input.getInt32();
    } // decrypt block


    this.cipher.decrypt(this._inBlock, this._outBlock); // write output, save previous ciphered block
    // CBC XOR's IV (or previous block) with ciphertext

    for (var i = 0; i < this._ints; ++i) {
      output.putInt32(this._prev[i] ^ this._outBlock[i]);
    }

    this._prev = this._inBlock.slice(0);
  };

  modes.cbc.prototype.pad = function (input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
  };

  modes.cbc.prototype.unpad = function (output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) {
      return false;
    } // ensure padding byte count is valid


    var len = output.length();
    var count = output.at(len - 1);

    if (count > this.blockSize << 2) {
      return false;
    } // trim off padding bytes


    output.truncate(count);
    return true;
  };
  /** Cipher feedback (CFB) **/


  modes.cfb = function (options) {
    options = options || {};
    this.name = 'CFB';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialBlock = new Array(this._ints);
    this._partialOutput = forge.util.createBuffer();
    this._partialBytes = 0;
  };

  modes.cfb.prototype.start = function (options) {
    if (!('iv' in options)) {
      throw new Error('Invalid IV parameter.');
    } // use IV as first input


    this._iv = transformIV(options.iv);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
  };

  modes.cfb.prototype.encrypt = function (input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();

    if (inputLength === 0) {
      return true;
    } // encrypt block


    this.cipher.encrypt(this._inBlock, this._outBlock); // handle full block

    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
      // XOR input with output, write input as output
      for (var i = 0; i < this._ints; ++i) {
        this._inBlock[i] = input.getInt32() ^ this._outBlock[i];
        output.putInt32(this._inBlock[i]);
      }

      return;
    } // handle partial block


    var partialBytes = (this.blockSize - inputLength) % this.blockSize;

    if (partialBytes > 0) {
      partialBytes = this.blockSize - partialBytes;
    } // XOR input with output, write input as partial output


    this._partialOutput.clear();

    for (var i = 0; i < this._ints; ++i) {
      this._partialBlock[i] = input.getInt32() ^ this._outBlock[i];

      this._partialOutput.putInt32(this._partialBlock[i]);
    }

    if (partialBytes > 0) {
      // block still incomplete, restore input buffer
      input.read -= this.blockSize;
    } else {
      // block complete, update input block
      for (var i = 0; i < this._ints; ++i) {
        this._inBlock[i] = this._partialBlock[i];
      }
    } // skip any previous partial bytes


    if (this._partialBytes > 0) {
      this._partialOutput.getBytes(this._partialBytes);
    }

    if (partialBytes > 0 && !finish) {
      output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
      this._partialBytes = partialBytes;
      return true;
    }

    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
  };

  modes.cfb.prototype.decrypt = function (input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();

    if (inputLength === 0) {
      return true;
    } // encrypt block (CFB always uses encryption mode)


    this.cipher.encrypt(this._inBlock, this._outBlock); // handle full block

    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
      // XOR input with output, write input as output
      for (var i = 0; i < this._ints; ++i) {
        this._inBlock[i] = input.getInt32();
        output.putInt32(this._inBlock[i] ^ this._outBlock[i]);
      }

      return;
    } // handle partial block


    var partialBytes = (this.blockSize - inputLength) % this.blockSize;

    if (partialBytes > 0) {
      partialBytes = this.blockSize - partialBytes;
    } // XOR input with output, write input as partial output


    this._partialOutput.clear();

    for (var i = 0; i < this._ints; ++i) {
      this._partialBlock[i] = input.getInt32();

      this._partialOutput.putInt32(this._partialBlock[i] ^ this._outBlock[i]);
    }

    if (partialBytes > 0) {
      // block still incomplete, restore input buffer
      input.read -= this.blockSize;
    } else {
      // block complete, update input block
      for (var i = 0; i < this._ints; ++i) {
        this._inBlock[i] = this._partialBlock[i];
      }
    } // skip any previous partial bytes


    if (this._partialBytes > 0) {
      this._partialOutput.getBytes(this._partialBytes);
    }

    if (partialBytes > 0 && !finish) {
      output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
      this._partialBytes = partialBytes;
      return true;
    }

    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
  };
  /** Output feedback (OFB) **/


  modes.ofb = function (options) {
    options = options || {};
    this.name = 'OFB';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = forge.util.createBuffer();
    this._partialBytes = 0;
  };

  modes.ofb.prototype.start = function (options) {
    if (!('iv' in options)) {
      throw new Error('Invalid IV parameter.');
    } // use IV as first input


    this._iv = transformIV(options.iv);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
  };

  modes.ofb.prototype.encrypt = function (input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();

    if (input.length() === 0) {
      return true;
    } // encrypt block (OFB always uses encryption mode)


    this.cipher.encrypt(this._inBlock, this._outBlock); // handle full block

    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
      // XOR input with output and update next input
      for (var i = 0; i < this._ints; ++i) {
        output.putInt32(input.getInt32() ^ this._outBlock[i]);
        this._inBlock[i] = this._outBlock[i];
      }

      return;
    } // handle partial block


    var partialBytes = (this.blockSize - inputLength) % this.blockSize;

    if (partialBytes > 0) {
      partialBytes = this.blockSize - partialBytes;
    } // XOR input with output


    this._partialOutput.clear();

    for (var i = 0; i < this._ints; ++i) {
      this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
    }

    if (partialBytes > 0) {
      // block still incomplete, restore input buffer
      input.read -= this.blockSize;
    } else {
      // block complete, update input block
      for (var i = 0; i < this._ints; ++i) {
        this._inBlock[i] = this._outBlock[i];
      }
    } // skip any previous partial bytes


    if (this._partialBytes > 0) {
      this._partialOutput.getBytes(this._partialBytes);
    }

    if (partialBytes > 0 && !finish) {
      output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
      this._partialBytes = partialBytes;
      return true;
    }

    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
  };

  modes.ofb.prototype.decrypt = modes.ofb.prototype.encrypt;
  /** Counter (CTR) **/

  modes.ctr = function (options) {
    options = options || {};
    this.name = 'CTR';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = forge.util.createBuffer();
    this._partialBytes = 0;
  };

  modes.ctr.prototype.start = function (options) {
    if (!('iv' in options)) {
      throw new Error('Invalid IV parameter.');
    } // use IV as first input


    this._iv = transformIV(options.iv);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
  };

  modes.ctr.prototype.encrypt = function (input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();

    if (inputLength === 0) {
      return true;
    } // encrypt block (CTR always uses encryption mode)


    this.cipher.encrypt(this._inBlock, this._outBlock); // handle full block

    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
      // XOR input with output
      for (var i = 0; i < this._ints; ++i) {
        output.putInt32(input.getInt32() ^ this._outBlock[i]);
      }
    } else {
      // handle partial block
      var partialBytes = (this.blockSize - inputLength) % this.blockSize;

      if (partialBytes > 0) {
        partialBytes = this.blockSize - partialBytes;
      } // XOR input with output


      this._partialOutput.clear();

      for (var i = 0; i < this._ints; ++i) {
        this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
      }

      if (partialBytes > 0) {
        // block still incomplete, restore input buffer
        input.read -= this.blockSize;
      } // skip any previous partial bytes


      if (this._partialBytes > 0) {
        this._partialOutput.getBytes(this._partialBytes);
      }

      if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
      }

      output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
      this._partialBytes = 0;
    } // block complete, increment counter (input block)


    inc32(this._inBlock);
  };

  modes.ctr.prototype.decrypt = modes.ctr.prototype.encrypt;
  /** Galois/Counter Mode (GCM) **/

  modes.gcm = function (options) {
    options = options || {};
    this.name = 'GCM';
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
    this._partialOutput = forge.util.createBuffer();
    this._partialBytes = 0; // R is actually this value concatenated with 120 more zero bits, but
    // we only XOR against R so the other zeros have no effect -- we just
    // apply this value to the first integer in a block

    this._R = 0xE1000000;
  };

  modes.gcm.prototype.start = function (options) {
    if (!('iv' in options)) {
      throw new Error('Invalid IV parameter.');
    } // ensure IV is a byte buffer


    var iv = forge.util.createBuffer(options.iv); // no ciphered data processed yet

    this._cipherLength = 0; // default additional data is none

    var additionalData;

    if ('additionalData' in options) {
      additionalData = forge.util.createBuffer(options.additionalData);
    } else {
      additionalData = forge.util.createBuffer();
    } // default tag length is 128 bits


    if ('tagLength' in options) {
      this._tagLength = options.tagLength;
    } else {
      this._tagLength = 128;
    } // if tag is given, ensure tag matches tag length


    this._tag = null;

    if (options.decrypt) {
      // save tag to check later
      this._tag = forge.util.createBuffer(options.tag).getBytes();

      if (this._tag.length !== this._tagLength / 8) {
        throw new Error('Authentication tag does not match tag length.');
      }
    } // create tmp storage for hash calculation


    this._hashBlock = new Array(this._ints); // no tag generated yet

    this.tag = null; // generate hash subkey
    // (apply block cipher to "zero" block)

    this._hashSubkey = new Array(this._ints);
    this.cipher.encrypt([0, 0, 0, 0], this._hashSubkey); // generate table M
    // use 4-bit tables (32 component decomposition of a 16 byte value)
    // 8-bit tables take more space and are known to have security
    // vulnerabilities (in native implementations)

    this.componentBits = 4;
    this._m = this.generateHashTable(this._hashSubkey, this.componentBits); // Note: support IV length different from 96 bits? (only supporting
    // 96 bits is recommended by NIST SP-800-38D)
    // generate J_0

    var ivLength = iv.length();

    if (ivLength === 12) {
      // 96-bit IV
      this._j0 = [iv.getInt32(), iv.getInt32(), iv.getInt32(), 1];
    } else {
      // IV is NOT 96-bits
      this._j0 = [0, 0, 0, 0];

      while (iv.length() > 0) {
        this._j0 = this.ghash(this._hashSubkey, this._j0, [iv.getInt32(), iv.getInt32(), iv.getInt32(), iv.getInt32()]);
      }

      this._j0 = this.ghash(this._hashSubkey, this._j0, [0, 0].concat(from64To32(ivLength * 8)));
    } // generate ICB (initial counter block)


    this._inBlock = this._j0.slice(0);
    inc32(this._inBlock);
    this._partialBytes = 0; // consume authentication data

    additionalData = forge.util.createBuffer(additionalData); // save additional data length as a BE 64-bit number

    this._aDataLength = from64To32(additionalData.length() * 8); // pad additional data to 128 bit (16 byte) block size

    var overflow = additionalData.length() % this.blockSize;

    if (overflow) {
      additionalData.fillWithByte(0, this.blockSize - overflow);
    }

    this._s = [0, 0, 0, 0];

    while (additionalData.length() > 0) {
      this._s = this.ghash(this._hashSubkey, this._s, [additionalData.getInt32(), additionalData.getInt32(), additionalData.getInt32(), additionalData.getInt32()]);
    }
  };

  modes.gcm.prototype.encrypt = function (input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();

    if (inputLength === 0) {
      return true;
    } // encrypt block


    this.cipher.encrypt(this._inBlock, this._outBlock); // handle full block

    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
      // XOR input with output
      for (var i = 0; i < this._ints; ++i) {
        output.putInt32(this._outBlock[i] ^= input.getInt32());
      }

      this._cipherLength += this.blockSize;
    } else {
      // handle partial block
      var partialBytes = (this.blockSize - inputLength) % this.blockSize;

      if (partialBytes > 0) {
        partialBytes = this.blockSize - partialBytes;
      } // XOR input with output


      this._partialOutput.clear();

      for (var i = 0; i < this._ints; ++i) {
        this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
      }

      if (partialBytes === 0 || finish) {
        // handle overflow prior to hashing
        if (finish) {
          // get block overflow
          var overflow = inputLength % this.blockSize;
          this._cipherLength += overflow; // truncate for hash function

          this._partialOutput.truncate(this.blockSize - overflow);
        } else {
          this._cipherLength += this.blockSize;
        } // get output block for hashing


        for (var i = 0; i < this._ints; ++i) {
          this._outBlock[i] = this._partialOutput.getInt32();
        }

        this._partialOutput.read -= this.blockSize;
      } // skip any previous partial bytes


      if (this._partialBytes > 0) {
        this._partialOutput.getBytes(this._partialBytes);
      }

      if (partialBytes > 0 && !finish) {
        // block still incomplete, restore input buffer, get partial output,
        // and return early
        input.read -= this.blockSize;
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
      }

      output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
      this._partialBytes = 0;
    } // update hash block S


    this._s = this.ghash(this._hashSubkey, this._s, this._outBlock); // increment counter (input block)

    inc32(this._inBlock);
  };

  modes.gcm.prototype.decrypt = function (input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();

    if (inputLength < this.blockSize && !(finish && inputLength > 0)) {
      return true;
    } // encrypt block (GCM always uses encryption mode)


    this.cipher.encrypt(this._inBlock, this._outBlock); // increment counter (input block)

    inc32(this._inBlock); // update hash block S

    this._hashBlock[0] = input.getInt32();
    this._hashBlock[1] = input.getInt32();
    this._hashBlock[2] = input.getInt32();
    this._hashBlock[3] = input.getInt32();
    this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock); // XOR hash input with output

    for (var i = 0; i < this._ints; ++i) {
      output.putInt32(this._outBlock[i] ^ this._hashBlock[i]);
    } // increment cipher data length


    if (inputLength < this.blockSize) {
      this._cipherLength += inputLength % this.blockSize;
    } else {
      this._cipherLength += this.blockSize;
    }
  };

  modes.gcm.prototype.afterFinish = function (output, options) {
    var rval = true; // handle overflow

    if (options.decrypt && options.overflow) {
      output.truncate(this.blockSize - options.overflow);
    } // handle authentication tag


    this.tag = forge.util.createBuffer(); // concatenate additional data length with cipher length

    var lengths = this._aDataLength.concat(from64To32(this._cipherLength * 8)); // include lengths in hash


    this._s = this.ghash(this._hashSubkey, this._s, lengths); // do GCTR(J_0, S)

    var tag = [];
    this.cipher.encrypt(this._j0, tag);

    for (var i = 0; i < this._ints; ++i) {
      this.tag.putInt32(this._s[i] ^ tag[i]);
    } // trim tag to length


    this.tag.truncate(this.tag.length() % (this._tagLength / 8)); // check authentication tag

    if (options.decrypt && this.tag.bytes() !== this._tag) {
      rval = false;
    }

    return rval;
  };
  /**
   * See NIST SP-800-38D 6.3 (Algorithm 1). This function performs Galois
   * field multiplication. The field, GF(2^128), is defined by the polynomial:
   *
   * x^128 + x^7 + x^2 + x + 1
   *
   * Which is represented in little-endian binary form as: 11100001 (0xe1). When
   * the value of a coefficient is 1, a bit is set. The value R, is the
   * concatenation of this value and 120 zero bits, yielding a 128-bit value
   * which matches the block size.
   *
   * This function will multiply two elements (vectors of bytes), X and Y, in
   * the field GF(2^128). The result is initialized to zero. For each bit of
   * X (out of 128), x_i, if x_i is set, then the result is multiplied (XOR'd)
   * by the current value of Y. For each bit, the value of Y will be raised by
   * a power of x (multiplied by the polynomial x). This can be achieved by
   * shifting Y once to the right. If the current value of Y, prior to being
   * multiplied by x, has 0 as its LSB, then it is a 127th degree polynomial.
   * Otherwise, we must divide by R after shifting to find the remainder.
   *
   * @param x the first block to multiply by the second.
   * @param y the second block to multiply by the first.
   *
   * @return the block result of the multiplication.
   */


  modes.gcm.prototype.multiply = function (x, y) {
    var z_i = [0, 0, 0, 0];
    var v_i = y.slice(0); // calculate Z_128 (block has 128 bits)

    for (var i = 0; i < 128; ++i) {
      // if x_i is 0, Z_{i+1} = Z_i (unchanged)
      // else Z_{i+1} = Z_i ^ V_i
      // get x_i by finding 32-bit int position, then left shift 1 by remainder
      var x_i = x[i / 32 | 0] & 1 << 31 - i % 32;

      if (x_i) {
        z_i[0] ^= v_i[0];
        z_i[1] ^= v_i[1];
        z_i[2] ^= v_i[2];
        z_i[3] ^= v_i[3];
      } // if LSB(V_i) is 1, V_i = V_i >> 1
      // else V_i = (V_i >> 1) ^ R


      this.pow(v_i, v_i);
    }

    return z_i;
  };

  modes.gcm.prototype.pow = function (x, out) {
    // if LSB(x) is 1, x = x >>> 1
    // else x = (x >>> 1) ^ R
    var lsb = x[3] & 1; // always do x >>> 1:
    // starting with the rightmost integer, shift each integer to the right
    // one bit, pulling in the bit from the integer to the left as its top
    // most bit (do this for the last 3 integers)

    for (var i = 3; i > 0; --i) {
      out[i] = x[i] >>> 1 | (x[i - 1] & 1) << 31;
    } // shift the first integer normally


    out[0] = x[0] >>> 1; // if lsb was not set, then polynomial had a degree of 127 and doesn't
    // need to divided; otherwise, XOR with R to find the remainder; we only
    // need to XOR the first integer since R technically ends w/120 zero bits

    if (lsb) {
      out[0] ^= this._R;
    }
  };

  modes.gcm.prototype.tableMultiply = function (x) {
    // assumes 4-bit tables are used
    var z = [0, 0, 0, 0];

    for (var i = 0; i < 32; ++i) {
      var idx = i / 8 | 0;
      var x_i = x[idx] >>> (7 - i % 8) * 4 & 0xF;
      var ah = this._m[i][x_i];
      z[0] ^= ah[0];
      z[1] ^= ah[1];
      z[2] ^= ah[2];
      z[3] ^= ah[3];
    }

    return z;
  };
  /**
   * A continuing version of the GHASH algorithm that operates on a single
   * block. The hash block, last hash value (Ym) and the new block to hash
   * are given.
   *
   * @param h the hash block.
   * @param y the previous value for Ym, use [0, 0, 0, 0] for a new hash.
   * @param x the block to hash.
   *
   * @return the hashed value (Ym).
   */


  modes.gcm.prototype.ghash = function (h, y, x) {
    y[0] ^= x[0];
    y[1] ^= x[1];
    y[2] ^= x[2];
    y[3] ^= x[3];
    return this.tableMultiply(y); //return this.multiply(y, h);
  };
  /**
   * Precomputes a table for multiplying against the hash subkey. This
   * mechanism provides a substantial speed increase over multiplication
   * performed without a table. The table-based multiplication this table is
   * for solves X * H by multiplying each component of X by H and then
   * composing the results together using XOR.
   *
   * This function can be used to generate tables with different bit sizes
   * for the components, however, this implementation assumes there are
   * 32 components of X (which is a 16 byte vector), therefore each component
   * takes 4-bits (so the table is constructed with bits=4).
   *
   * @param h the hash subkey.
   * @param bits the bit size for a component.
   */


  modes.gcm.prototype.generateHashTable = function (h, bits) {
    // TODO: There are further optimizations that would use only the
    // first table M_0 (or some variant) along with a remainder table;
    // this can be explored in the future
    var multiplier = 8 / bits;
    var perInt = 4 * multiplier;
    var size = 16 * multiplier;
    var m = new Array(size);

    for (var i = 0; i < size; ++i) {
      var tmp = [0, 0, 0, 0];
      var idx = i / perInt | 0;
      var shft = (perInt - 1 - i % perInt) * bits;
      tmp[idx] = 1 << bits - 1 << shft;
      m[i] = this.generateSubHashTable(this.multiply(tmp, h), bits);
    }

    return m;
  };
  /**
   * Generates a table for multiplying against the hash subkey for one
   * particular component (out of all possible component values).
   *
   * @param mid the pre-multiplied value for the middle key of the table.
   * @param bits the bit size for a component.
   */


  modes.gcm.prototype.generateSubHashTable = function (mid, bits) {
    // compute the table quickly by minimizing the number of
    // POW operations -- they only need to be performed for powers of 2,
    // all other entries can be composed from those powers using XOR
    var size = 1 << bits;
    var half = size >>> 1;
    var m = new Array(size);
    m[half] = mid.slice(0);
    var i = half >>> 1;

    while (i > 0) {
      // raise m0[2 * i] and store in m0[i]
      this.pow(m[2 * i], m[i] = []);
      i >>= 1;
    }

    i = 2;

    while (i < half) {
      for (var j = 1; j < i; ++j) {
        var m_i = m[i];
        var m_j = m[j];
        m[i + j] = [m_i[0] ^ m_j[0], m_i[1] ^ m_j[1], m_i[2] ^ m_j[2], m_i[3] ^ m_j[3]];
      }

      i *= 2;
    }

    m[0] = [0, 0, 0, 0];
    /* Note: We could avoid storing these by doing composition during multiply
    calculate top half using composition by speed is preferred. */

    for (i = half + 1; i < size; ++i) {
      var c = m[i ^ half];
      m[i] = [mid[0] ^ c[0], mid[1] ^ c[1], mid[2] ^ c[2], mid[3] ^ c[3]];
    }

    return m;
  };
  /** Utility functions */


  function transformIV(iv) {
    if (typeof iv === 'string') {
      // convert iv string into byte buffer
      iv = forge.util.createBuffer(iv);
    }

    if (forge.util.isArray(iv) && iv.length > 4) {
      // convert iv byte array into byte buffer
      var tmp = iv;
      iv = forge.util.createBuffer();

      for (var i = 0; i < tmp.length; ++i) {
        iv.putByte(tmp[i]);
      }
    }

    if (!forge.util.isArray(iv)) {
      // convert iv byte buffer into 32-bit integer array
      iv = [iv.getInt32(), iv.getInt32(), iv.getInt32(), iv.getInt32()];
    }

    return iv;
  }

  function inc32(block) {
    // increment last 32 bits of block only
    block[block.length - 1] = block[block.length - 1] + 1 & 0xFFFFFFFF;
  }

  function from64To32(num) {
    // convert 64-bit number to two BE Int32s
    return [num / 0x100000000 | 0, num & 0xFFFFFFFF];
  }
  /***/

},
/* 223 */

/***/
function (module, exports, __webpack_require__) {
  // Copyright (c) 2005  Tom Wu
  // All Rights Reserved.
  // See "LICENSE" for details.
  // Basic JavaScript BN library - subset useful for RSA encryption.

  /*
  Licensing (LICENSE)
  -------------------
  
  This software is covered under the following copyright:
  */

  /*
   * Copyright (c) 2003-2005  Tom Wu
   * All Rights Reserved.
   *
   * Permission is hereby granted, free of charge, to any person obtaining
   * a copy of this software and associated documentation files (the
   * "Software"), to deal in the Software without restriction, including
   * without limitation the rights to use, copy, modify, merge, publish,
   * distribute, sublicense, and/or sell copies of the Software, and to
   * permit persons to whom the Software is furnished to do so, subject to
   * the following conditions:
   *
   * The above copyright notice and this permission notice shall be
   * included in all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
   * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
   * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
   *
   * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
   * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
   * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
   * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
   * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * In addition, the following condition applies:
   *
   * All redistributions must retain an intact copy of this copyright notice
   * and disclaimer.
   */

  /*
  Address all questions regarding this license to:
  
    Tom Wu
    tjw@cs.Stanford.EDU
  */
  var forge = __webpack_require__(6);

  module.exports = forge.jsbn = forge.jsbn || {}; // Bits per digit

  var dbits; // JavaScript engine analysis

  var canary = 0xdeadbeefcafe;
  var j_lm = (canary & 0xffffff) == 0xefcafe; // (public) Constructor

  function BigInteger(a, b, c) {
    this.data = [];
    if (a != null) if ("number" == typeof a) this.fromNumber(a, b, c);else if (b == null && "string" != typeof a) this.fromString(a, 256);else this.fromString(a, b);
  }

  forge.jsbn.BigInteger = BigInteger; // return new, unset BigInteger

  function nbi() {
    return new BigInteger(null);
  } // am: Compute w_j += (x*this_i), propagate carries,
  // c is initial carry, returns final carry.
  // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
  // We need to select the fastest one that works in this environment.
  // am1: use a single mult and divide to get the high bits,
  // max digit bits should be 26 because
  // max internal value = 2*dvalue^2-2*dvalue (< 2^53)


  function am1(i, x, w, j, c, n) {
    while (--n >= 0) {
      var v = x * this.data[i++] + w.data[j] + c;
      c = Math.floor(v / 0x4000000);
      w.data[j++] = v & 0x3ffffff;
    }

    return c;
  } // am2 avoids a big mult-and-extract completely.
  // Max digit bits should be <= 30 because we do bitwise ops
  // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)


  function am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff,
        xh = x >> 15;

    while (--n >= 0) {
      var l = this.data[i] & 0x7fff;
      var h = this.data[i++] >> 15;
      var m = xh * l + h * xl;
      l = xl * l + ((m & 0x7fff) << 15) + w.data[j] + (c & 0x3fffffff);
      c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
      w.data[j++] = l & 0x3fffffff;
    }

    return c;
  } // Alternately, set max digit bits to 28 since some
  // browsers slow down when dealing with 32-bit numbers.


  function am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff,
        xh = x >> 14;

    while (--n >= 0) {
      var l = this.data[i] & 0x3fff;
      var h = this.data[i++] >> 14;
      var m = xh * l + h * xl;
      l = xl * l + ((m & 0x3fff) << 14) + w.data[j] + c;
      c = (l >> 28) + (m >> 14) + xh * h;
      w.data[j++] = l & 0xfffffff;
    }

    return c;
  } // node.js (no browser)


  if (typeof navigator === 'undefined') {
    BigInteger.prototype.am = am3;
    dbits = 28;
  } else if (j_lm && navigator.appName == "Microsoft Internet Explorer") {
    BigInteger.prototype.am = am2;
    dbits = 30;
  } else if (j_lm && navigator.appName != "Netscape") {
    BigInteger.prototype.am = am1;
    dbits = 26;
  } else {
    // Mozilla/Netscape seems to prefer am3
    BigInteger.prototype.am = am3;
    dbits = 28;
  }

  BigInteger.prototype.DB = dbits;
  BigInteger.prototype.DM = (1 << dbits) - 1;
  BigInteger.prototype.DV = 1 << dbits;
  var BI_FP = 52;
  BigInteger.prototype.FV = Math.pow(2, BI_FP);
  BigInteger.prototype.F1 = BI_FP - dbits;
  BigInteger.prototype.F2 = 2 * dbits - BI_FP; // Digit conversions

  var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
  var BI_RC = new Array();
  var rr, vv;
  rr = "0".charCodeAt(0);

  for (vv = 0; vv <= 9; ++vv) {
    BI_RC[rr++] = vv;
  }

  rr = "a".charCodeAt(0);

  for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
  }

  rr = "A".charCodeAt(0);

  for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
  }

  function int2char(n) {
    return BI_RM.charAt(n);
  }

  function intAt(s, i) {
    var c = BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
  } // (protected) copy this to r


  function bnpCopyTo(r) {
    for (var i = this.t - 1; i >= 0; --i) {
      r.data[i] = this.data[i];
    }

    r.t = this.t;
    r.s = this.s;
  } // (protected) set from integer value x, -DV <= x < DV


  function bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this.data[0] = x;else if (x < -1) this.data[0] = x + this.DV;else this.t = 0;
  } // return bigint initialized to value


  function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
  } // (protected) set from string and radix


  function bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 256) k = 8; // byte array
    else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else {
        this.fromRadix(s, b);
        return;
      }
    this.t = 0;
    this.s = 0;
    var i = s.length,
        mi = false,
        sh = 0;

    while (--i >= 0) {
      var x = k == 8 ? s[i] & 0xff : intAt(s, i);

      if (x < 0) {
        if (s.charAt(i) == "-") mi = true;
        continue;
      }

      mi = false;
      if (sh == 0) this.data[this.t++] = x;else if (sh + k > this.DB) {
        this.data[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
        this.data[this.t++] = x >> this.DB - sh;
      } else this.data[this.t - 1] |= x << sh;
      sh += k;
      if (sh >= this.DB) sh -= this.DB;
    }

    if (k == 8 && (s[0] & 0x80) != 0) {
      this.s = -1;
      if (sh > 0) this.data[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
    }

    this.clamp();
    if (mi) BigInteger.ZERO.subTo(this, this);
  } // (protected) clamp off excess high words


  function bnpClamp() {
    var c = this.s & this.DM;

    while (this.t > 0 && this.data[this.t - 1] == c) {
      --this.t;
    }
  } // (public) return string representation in given radix


  function bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else return this.toRadix(b);
    var km = (1 << k) - 1,
        d,
        m = false,
        r = "",
        i = this.t;
    var p = this.DB - i * this.DB % k;

    if (i-- > 0) {
      if (p < this.DB && (d = this.data[i] >> p) > 0) {
        m = true;
        r = int2char(d);
      }

      while (i >= 0) {
        if (p < k) {
          d = (this.data[i] & (1 << p) - 1) << k - p;
          d |= this.data[--i] >> (p += this.DB - k);
        } else {
          d = this.data[i] >> (p -= k) & km;

          if (p <= 0) {
            p += this.DB;
            --i;
          }
        }

        if (d > 0) m = true;
        if (m) r += int2char(d);
      }
    }

    return m ? r : "0";
  } // (public) -this


  function bnNegate() {
    var r = nbi();
    BigInteger.ZERO.subTo(this, r);
    return r;
  } // (public) |this|


  function bnAbs() {
    return this.s < 0 ? this.negate() : this;
  } // (public) return + if this > a, - if this < a, 0 if equal


  function bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;

    while (--i >= 0) {
      if ((r = this.data[i] - a.data[i]) != 0) return r;
    }

    return 0;
  } // returns bit length of the integer x


  function nbits(x) {
    var r = 1,
        t;

    if ((t = x >>> 16) != 0) {
      x = t;
      r += 16;
    }

    if ((t = x >> 8) != 0) {
      x = t;
      r += 8;
    }

    if ((t = x >> 4) != 0) {
      x = t;
      r += 4;
    }

    if ((t = x >> 2) != 0) {
      x = t;
      r += 2;
    }

    if ((t = x >> 1) != 0) {
      x = t;
      r += 1;
    }

    return r;
  } // (public) return the number of bits in "this"


  function bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + nbits(this.data[this.t - 1] ^ this.s & this.DM);
  } // (protected) r = this << n*DB


  function bnpDLShiftTo(n, r) {
    var i;

    for (i = this.t - 1; i >= 0; --i) {
      r.data[i + n] = this.data[i];
    }

    for (i = n - 1; i >= 0; --i) {
      r.data[i] = 0;
    }

    r.t = this.t + n;
    r.s = this.s;
  } // (protected) r = this >> n*DB


  function bnpDRShiftTo(n, r) {
    for (var i = n; i < this.t; ++i) {
      r.data[i - n] = this.data[i];
    }

    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
  } // (protected) r = this << n


  function bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB),
        c = this.s << bs & this.DM,
        i;

    for (i = this.t - 1; i >= 0; --i) {
      r.data[i + ds + 1] = this.data[i] >> cbs | c;
      c = (this.data[i] & bm) << bs;
    }

    for (i = ds - 1; i >= 0; --i) {
      r.data[i] = 0;
    }

    r.data[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
  } // (protected) r = this >> n


  function bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);

    if (ds >= this.t) {
      r.t = 0;
      return;
    }

    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r.data[0] = this.data[ds] >> bs;

    for (var i = ds + 1; i < this.t; ++i) {
      r.data[i - ds - 1] |= (this.data[i] & bm) << cbs;
      r.data[i - ds] = this.data[i] >> bs;
    }

    if (bs > 0) r.data[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
  } // (protected) r = this - a


  function bnpSubTo(a, r) {
    var i = 0,
        c = 0,
        m = Math.min(a.t, this.t);

    while (i < m) {
      c += this.data[i] - a.data[i];
      r.data[i++] = c & this.DM;
      c >>= this.DB;
    }

    if (a.t < this.t) {
      c -= a.s;

      while (i < this.t) {
        c += this.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
      }

      c += this.s;
    } else {
      c += this.s;

      while (i < a.t) {
        c -= a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
      }

      c -= a.s;
    }

    r.s = c < 0 ? -1 : 0;
    if (c < -1) r.data[i++] = this.DV + c;else if (c > 0) r.data[i++] = c;
    r.t = i;
    r.clamp();
  } // (protected) r = this * a, r != this,a (HAC 14.12)
  // "this" should be the larger one if appropriate.


  function bnpMultiplyTo(a, r) {
    var x = this.abs(),
        y = a.abs();
    var i = x.t;
    r.t = i + y.t;

    while (--i >= 0) {
      r.data[i] = 0;
    }

    for (i = 0; i < y.t; ++i) {
      r.data[i + x.t] = x.am(0, y.data[i], r, i, 0, x.t);
    }

    r.s = 0;
    r.clamp();
    if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
  } // (protected) r = this^2, r != this (HAC 14.16)


  function bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;

    while (--i >= 0) {
      r.data[i] = 0;
    }

    for (i = 0; i < x.t - 1; ++i) {
      var c = x.am(i, x.data[i], r, 2 * i, 0, 1);

      if ((r.data[i + x.t] += x.am(i + 1, 2 * x.data[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
        r.data[i + x.t] -= x.DV;
        r.data[i + x.t + 1] = 1;
      }
    }

    if (r.t > 0) r.data[r.t - 1] += x.am(i, x.data[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
  } // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
  // r != q, this != m.  q or r may be null.


  function bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();

    if (pt.t < pm.t) {
      if (q != null) q.fromInt(0);
      if (r != null) this.copyTo(r);
      return;
    }

    if (r == null) r = nbi();
    var y = nbi(),
        ts = this.s,
        ms = m.s;
    var nsh = this.DB - nbits(pm.data[pm.t - 1]); // normalize modulus

    if (nsh > 0) {
      pm.lShiftTo(nsh, y);
      pt.lShiftTo(nsh, r);
    } else {
      pm.copyTo(y);
      pt.copyTo(r);
    }

    var ys = y.t;
    var y0 = y.data[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y.data[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt,
        d2 = (1 << this.F1) / yt,
        e = 1 << this.F2;
    var i = r.t,
        j = i - ys,
        t = q == null ? nbi() : q;
    y.dlShiftTo(j, t);

    if (r.compareTo(t) >= 0) {
      r.data[r.t++] = 1;
      r.subTo(t, r);
    }

    BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later

    while (y.t < ys) {
      y.data[y.t++] = 0;
    }

    while (--j >= 0) {
      // Estimate quotient digit
      var qd = r.data[--i] == y0 ? this.DM : Math.floor(r.data[i] * d1 + (r.data[i - 1] + e) * d2);

      if ((r.data[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
        // Try it out
        y.dlShiftTo(j, t);
        r.subTo(t, r);

        while (r.data[i] < --qd) {
          r.subTo(t, r);
        }
      }
    }

    if (q != null) {
      r.drShiftTo(ys, q);
      if (ts != ms) BigInteger.ZERO.subTo(q, q);
    }

    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder

    if (ts < 0) BigInteger.ZERO.subTo(r, r);
  } // (public) this mod a


  function bnMod(a) {
    var r = nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
  } // Modular reduction using "classic" algorithm


  function Classic(m) {
    this.m = m;
  }

  function cConvert(x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);else return x;
  }

  function cRevert(x) {
    return x;
  }

  function cReduce(x) {
    x.divRemTo(this.m, null, x);
  }

  function cMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
  }

  function cSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
  }

  Classic.prototype.convert = cConvert;
  Classic.prototype.revert = cRevert;
  Classic.prototype.reduce = cReduce;
  Classic.prototype.mulTo = cMulTo;
  Classic.prototype.sqrTo = cSqrTo; // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
  // justification:
  //         xy == 1 (mod m)
  //         xy =  1+km
  //   xy(2-xy) = (1+km)(1-km)
  // x[y(2-xy)] = 1-k^2m^2
  // x[y(2-xy)] == 1 (mod m^2)
  // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
  // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
  // JS multiply "overflows" differently from C/C++, so care is needed here.

  function bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this.data[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2

    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4

    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8

    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints

    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV

    return y > 0 ? this.DV - y : -y;
  } // Montgomery reduction


  function Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
  } // xR mod m


  function montConvert(x) {
    var r = nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
  } // x/R mod m


  function montRevert(x) {
    var r = nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
  } // x = x/R mod m (HAC 14.32)


  function montReduce(x) {
    while (x.t <= this.mt2) {
      // pad x so am has enough room later
      x.data[x.t++] = 0;
    }

    for (var i = 0; i < this.m.t; ++i) {
      // faster way of calculating u0 = x.data[i]*mp mod DV
      var j = x.data[i] & 0x7fff;
      var u0 = j * this.mpl + ((j * this.mph + (x.data[i] >> 15) * this.mpl & this.um) << 15) & x.DM; // use am to combine the multiply-shift-add into one call

      j = i + this.m.t;
      x.data[j] += this.m.am(0, u0, x, i, 0, this.m.t); // propagate carry

      while (x.data[j] >= x.DV) {
        x.data[j] -= x.DV;
        x.data[++j]++;
      }
    }

    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
  } // r = "x^2/R mod m"; x != r


  function montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
  } // r = "xy/R mod m"; x,y != r


  function montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
  }

  Montgomery.prototype.convert = montConvert;
  Montgomery.prototype.revert = montRevert;
  Montgomery.prototype.reduce = montReduce;
  Montgomery.prototype.mulTo = montMulTo;
  Montgomery.prototype.sqrTo = montSqrTo; // (protected) true iff this is even

  function bnpIsEven() {
    return (this.t > 0 ? this.data[0] & 1 : this.s) == 0;
  } // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)


  function bnpExp(e, z) {
    if (e > 0xffffffff || e < 1) return BigInteger.ONE;
    var r = nbi(),
        r2 = nbi(),
        g = z.convert(this),
        i = nbits(e) - 1;
    g.copyTo(r);

    while (--i >= 0) {
      z.sqrTo(r, r2);
      if ((e & 1 << i) > 0) z.mulTo(r2, g, r);else {
        var t = r;
        r = r2;
        r2 = t;
      }
    }

    return z.revert(r);
  } // (public) this^e % m, 0 <= e < 2^32


  function bnModPowInt(e, m) {
    var z;
    if (e < 256 || m.isEven()) z = new Classic(m);else z = new Montgomery(m);
    return this.exp(e, z);
  } // protected


  BigInteger.prototype.copyTo = bnpCopyTo;
  BigInteger.prototype.fromInt = bnpFromInt;
  BigInteger.prototype.fromString = bnpFromString;
  BigInteger.prototype.clamp = bnpClamp;
  BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
  BigInteger.prototype.drShiftTo = bnpDRShiftTo;
  BigInteger.prototype.lShiftTo = bnpLShiftTo;
  BigInteger.prototype.rShiftTo = bnpRShiftTo;
  BigInteger.prototype.subTo = bnpSubTo;
  BigInteger.prototype.multiplyTo = bnpMultiplyTo;
  BigInteger.prototype.squareTo = bnpSquareTo;
  BigInteger.prototype.divRemTo = bnpDivRemTo;
  BigInteger.prototype.invDigit = bnpInvDigit;
  BigInteger.prototype.isEven = bnpIsEven;
  BigInteger.prototype.exp = bnpExp; // public

  BigInteger.prototype.toString = bnToString;
  BigInteger.prototype.negate = bnNegate;
  BigInteger.prototype.abs = bnAbs;
  BigInteger.prototype.compareTo = bnCompareTo;
  BigInteger.prototype.bitLength = bnBitLength;
  BigInteger.prototype.mod = bnMod;
  BigInteger.prototype.modPowInt = bnModPowInt; // "constants"

  BigInteger.ZERO = nbv(0);
  BigInteger.ONE = nbv(1); // jsbn2 lib
  //Copyright (c) 2005-2009  Tom Wu
  //All Rights Reserved.
  //See "LICENSE" for details (See jsbn.js for LICENSE).
  //Extended JavaScript BN functions, required for RSA private ops.
  //Version 1.1: new BigInteger("0", 10) returns "proper" zero
  //(public)

  function bnClone() {
    var r = nbi();
    this.copyTo(r);
    return r;
  } //(public) return value as integer


  function bnIntValue() {
    if (this.s < 0) {
      if (this.t == 1) return this.data[0] - this.DV;else if (this.t == 0) return -1;
    } else if (this.t == 1) return this.data[0];else if (this.t == 0) return 0; // assumes 16 < DB < 32


    return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
  } //(public) return value as byte


  function bnByteValue() {
    return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
  } //(public) return value as short (assumes DB>=16)


  function bnShortValue() {
    return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
  } //(protected) return x s.t. r^x < DV


  function bnpChunkSize(r) {
    return Math.floor(Math.LN2 * this.DB / Math.log(r));
  } //(public) 0 if this == 0, 1 if this > 0


  function bnSigNum() {
    if (this.s < 0) return -1;else if (this.t <= 0 || this.t == 1 && this.data[0] <= 0) return 0;else return 1;
  } //(protected) convert to radix string


  function bnpToRadix(b) {
    if (b == null) b = 10;
    if (this.signum() == 0 || b < 2 || b > 36) return "0";
    var cs = this.chunkSize(b);
    var a = Math.pow(b, cs);
    var d = nbv(a),
        y = nbi(),
        z = nbi(),
        r = "";
    this.divRemTo(d, y, z);

    while (y.signum() > 0) {
      r = (a + z.intValue()).toString(b).substr(1) + r;
      y.divRemTo(d, y, z);
    }

    return z.intValue().toString(b) + r;
  } //(protected) convert from radix string


  function bnpFromRadix(s, b) {
    this.fromInt(0);
    if (b == null) b = 10;
    var cs = this.chunkSize(b);
    var d = Math.pow(b, cs),
        mi = false,
        j = 0,
        w = 0;

    for (var i = 0; i < s.length; ++i) {
      var x = intAt(s, i);

      if (x < 0) {
        if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
        continue;
      }

      w = b * w + x;

      if (++j >= cs) {
        this.dMultiply(d);
        this.dAddOffset(w, 0);
        j = 0;
        w = 0;
      }
    }

    if (j > 0) {
      this.dMultiply(Math.pow(b, j));
      this.dAddOffset(w, 0);
    }

    if (mi) BigInteger.ZERO.subTo(this, this);
  } //(protected) alternate constructor


  function bnpFromNumber(a, b, c) {
    if ("number" == typeof b) {
      // new BigInteger(int,int,RNG)
      if (a < 2) this.fromInt(1);else {
        this.fromNumber(a, c);
        if (!this.testBit(a - 1)) // force MSB set
          this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
        if (this.isEven()) this.dAddOffset(1, 0); // force odd

        while (!this.isProbablePrime(b)) {
          this.dAddOffset(2, 0);
          if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
        }
      }
    } else {
      // new BigInteger(int,RNG)
      var x = new Array(),
          t = a & 7;
      x.length = (a >> 3) + 1;
      b.nextBytes(x);
      if (t > 0) x[0] &= (1 << t) - 1;else x[0] = 0;
      this.fromString(x, 256);
    }
  } //(public) convert to bigendian byte array


  function bnToByteArray() {
    var i = this.t,
        r = new Array();
    r[0] = this.s;
    var p = this.DB - i * this.DB % 8,
        d,
        k = 0;

    if (i-- > 0) {
      if (p < this.DB && (d = this.data[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;

      while (i >= 0) {
        if (p < 8) {
          d = (this.data[i] & (1 << p) - 1) << 8 - p;
          d |= this.data[--i] >> (p += this.DB - 8);
        } else {
          d = this.data[i] >> (p -= 8) & 0xff;

          if (p <= 0) {
            p += this.DB;
            --i;
          }
        }

        if ((d & 0x80) != 0) d |= -256;
        if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
        if (k > 0 || d != this.s) r[k++] = d;
      }
    }

    return r;
  }

  function bnEquals(a) {
    return this.compareTo(a) == 0;
  }

  function bnMin(a) {
    return this.compareTo(a) < 0 ? this : a;
  }

  function bnMax(a) {
    return this.compareTo(a) > 0 ? this : a;
  } //(protected) r = this op a (bitwise)


  function bnpBitwiseTo(a, op, r) {
    var i,
        f,
        m = Math.min(a.t, this.t);

    for (i = 0; i < m; ++i) {
      r.data[i] = op(this.data[i], a.data[i]);
    }

    if (a.t < this.t) {
      f = a.s & this.DM;

      for (i = m; i < this.t; ++i) {
        r.data[i] = op(this.data[i], f);
      }

      r.t = this.t;
    } else {
      f = this.s & this.DM;

      for (i = m; i < a.t; ++i) {
        r.data[i] = op(f, a.data[i]);
      }

      r.t = a.t;
    }

    r.s = op(this.s, a.s);
    r.clamp();
  } //(public) this & a


  function op_and(x, y) {
    return x & y;
  }

  function bnAnd(a) {
    var r = nbi();
    this.bitwiseTo(a, op_and, r);
    return r;
  } //(public) this | a


  function op_or(x, y) {
    return x | y;
  }

  function bnOr(a) {
    var r = nbi();
    this.bitwiseTo(a, op_or, r);
    return r;
  } //(public) this ^ a


  function op_xor(x, y) {
    return x ^ y;
  }

  function bnXor(a) {
    var r = nbi();
    this.bitwiseTo(a, op_xor, r);
    return r;
  } //(public) this & ~a


  function op_andnot(x, y) {
    return x & ~y;
  }

  function bnAndNot(a) {
    var r = nbi();
    this.bitwiseTo(a, op_andnot, r);
    return r;
  } //(public) ~this


  function bnNot() {
    var r = nbi();

    for (var i = 0; i < this.t; ++i) {
      r.data[i] = this.DM & ~this.data[i];
    }

    r.t = this.t;
    r.s = ~this.s;
    return r;
  } //(public) this << n


  function bnShiftLeft(n) {
    var r = nbi();
    if (n < 0) this.rShiftTo(-n, r);else this.lShiftTo(n, r);
    return r;
  } //(public) this >> n


  function bnShiftRight(n) {
    var r = nbi();
    if (n < 0) this.lShiftTo(-n, r);else this.rShiftTo(n, r);
    return r;
  } //return index of lowest 1-bit in x, x < 2^31


  function lbit(x) {
    if (x == 0) return -1;
    var r = 0;

    if ((x & 0xffff) == 0) {
      x >>= 16;
      r += 16;
    }

    if ((x & 0xff) == 0) {
      x >>= 8;
      r += 8;
    }

    if ((x & 0xf) == 0) {
      x >>= 4;
      r += 4;
    }

    if ((x & 3) == 0) {
      x >>= 2;
      r += 2;
    }

    if ((x & 1) == 0) ++r;
    return r;
  } //(public) returns index of lowest 1-bit (or -1 if none)


  function bnGetLowestSetBit() {
    for (var i = 0; i < this.t; ++i) {
      if (this.data[i] != 0) return i * this.DB + lbit(this.data[i]);
    }

    if (this.s < 0) return this.t * this.DB;
    return -1;
  } //return number of 1 bits in x


  function cbit(x) {
    var r = 0;

    while (x != 0) {
      x &= x - 1;
      ++r;
    }

    return r;
  } //(public) return number of set bits


  function bnBitCount() {
    var r = 0,
        x = this.s & this.DM;

    for (var i = 0; i < this.t; ++i) {
      r += cbit(this.data[i] ^ x);
    }

    return r;
  } //(public) true iff nth bit is set


  function bnTestBit(n) {
    var j = Math.floor(n / this.DB);
    if (j >= this.t) return this.s != 0;
    return (this.data[j] & 1 << n % this.DB) != 0;
  } //(protected) this op (1<<n)


  function bnpChangeBit(n, op) {
    var r = BigInteger.ONE.shiftLeft(n);
    this.bitwiseTo(r, op, r);
    return r;
  } //(public) this | (1<<n)


  function bnSetBit(n) {
    return this.changeBit(n, op_or);
  } //(public) this & ~(1<<n)


  function bnClearBit(n) {
    return this.changeBit(n, op_andnot);
  } //(public) this ^ (1<<n)


  function bnFlipBit(n) {
    return this.changeBit(n, op_xor);
  } //(protected) r = this + a


  function bnpAddTo(a, r) {
    var i = 0,
        c = 0,
        m = Math.min(a.t, this.t);

    while (i < m) {
      c += this.data[i] + a.data[i];
      r.data[i++] = c & this.DM;
      c >>= this.DB;
    }

    if (a.t < this.t) {
      c += a.s;

      while (i < this.t) {
        c += this.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
      }

      c += this.s;
    } else {
      c += this.s;

      while (i < a.t) {
        c += a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
      }

      c += a.s;
    }

    r.s = c < 0 ? -1 : 0;
    if (c > 0) r.data[i++] = c;else if (c < -1) r.data[i++] = this.DV + c;
    r.t = i;
    r.clamp();
  } //(public) this + a


  function bnAdd(a) {
    var r = nbi();
    this.addTo(a, r);
    return r;
  } //(public) this - a


  function bnSubtract(a) {
    var r = nbi();
    this.subTo(a, r);
    return r;
  } //(public) this * a


  function bnMultiply(a) {
    var r = nbi();
    this.multiplyTo(a, r);
    return r;
  } //(public) this / a


  function bnDivide(a) {
    var r = nbi();
    this.divRemTo(a, r, null);
    return r;
  } //(public) this % a


  function bnRemainder(a) {
    var r = nbi();
    this.divRemTo(a, null, r);
    return r;
  } //(public) [this/a,this%a]


  function bnDivideAndRemainder(a) {
    var q = nbi(),
        r = nbi();
    this.divRemTo(a, q, r);
    return new Array(q, r);
  } //(protected) this *= n, this >= 0, 1 < n < DV


  function bnpDMultiply(n) {
    this.data[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
  } //(protected) this += n << w words, this >= 0


  function bnpDAddOffset(n, w) {
    if (n == 0) return;

    while (this.t <= w) {
      this.data[this.t++] = 0;
    }

    this.data[w] += n;

    while (this.data[w] >= this.DV) {
      this.data[w] -= this.DV;
      if (++w >= this.t) this.data[this.t++] = 0;
      ++this.data[w];
    }
  } //A "null" reducer


  function NullExp() {}

  function nNop(x) {
    return x;
  }

  function nMulTo(x, y, r) {
    x.multiplyTo(y, r);
  }

  function nSqrTo(x, r) {
    x.squareTo(r);
  }

  NullExp.prototype.convert = nNop;
  NullExp.prototype.revert = nNop;
  NullExp.prototype.mulTo = nMulTo;
  NullExp.prototype.sqrTo = nSqrTo; //(public) this^e

  function bnPow(e) {
    return this.exp(e, new NullExp());
  } //(protected) r = lower n words of "this * a", a.t <= n
  //"this" should be the larger one if appropriate.


  function bnpMultiplyLowerTo(a, n, r) {
    var i = Math.min(this.t + a.t, n);
    r.s = 0; // assumes a,this >= 0

    r.t = i;

    while (i > 0) {
      r.data[--i] = 0;
    }

    var j;

    for (j = r.t - this.t; i < j; ++i) {
      r.data[i + this.t] = this.am(0, a.data[i], r, i, 0, this.t);
    }

    for (j = Math.min(a.t, n); i < j; ++i) {
      this.am(0, a.data[i], r, i, 0, n - i);
    }

    r.clamp();
  } //(protected) r = "this * a" without lower n words, n > 0
  //"this" should be the larger one if appropriate.


  function bnpMultiplyUpperTo(a, n, r) {
    --n;
    var i = r.t = this.t + a.t - n;
    r.s = 0; // assumes a,this >= 0

    while (--i >= 0) {
      r.data[i] = 0;
    }

    for (i = Math.max(n - this.t, 0); i < a.t; ++i) {
      r.data[this.t + i - n] = this.am(n - i, a.data[i], r, 0, 0, this.t + i - n);
    }

    r.clamp();
    r.drShiftTo(1, r);
  } //Barrett modular reduction


  function Barrett(m) {
    // setup Barrett
    this.r2 = nbi();
    this.q3 = nbi();
    BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
    this.mu = this.r2.divide(m);
    this.m = m;
  }

  function barrettConvert(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);else if (x.compareTo(this.m) < 0) return x;else {
      var r = nbi();
      x.copyTo(r);
      this.reduce(r);
      return r;
    }
  }

  function barrettRevert(x) {
    return x;
  } //x = x mod m (HAC 14.42)


  function barrettReduce(x) {
    x.drShiftTo(this.m.t - 1, this.r2);

    if (x.t > this.m.t + 1) {
      x.t = this.m.t + 1;
      x.clamp();
    }

    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);

    while (x.compareTo(this.r2) < 0) {
      x.dAddOffset(1, this.m.t + 1);
    }

    x.subTo(this.r2, x);

    while (x.compareTo(this.m) >= 0) {
      x.subTo(this.m, x);
    }
  } //r = x^2 mod m; x != r


  function barrettSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
  } //r = x*y mod m; x,y != r


  function barrettMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
  }

  Barrett.prototype.convert = barrettConvert;
  Barrett.prototype.revert = barrettRevert;
  Barrett.prototype.reduce = barrettReduce;
  Barrett.prototype.mulTo = barrettMulTo;
  Barrett.prototype.sqrTo = barrettSqrTo; //(public) this^e % m (HAC 14.85)

  function bnModPow(e, m) {
    var i = e.bitLength(),
        k,
        r = nbv(1),
        z;
    if (i <= 0) return r;else if (i < 18) k = 1;else if (i < 48) k = 3;else if (i < 144) k = 4;else if (i < 768) k = 5;else k = 6;
    if (i < 8) z = new Classic(m);else if (m.isEven()) z = new Barrett(m);else z = new Montgomery(m); // precomputation

    var g = new Array(),
        n = 3,
        k1 = k - 1,
        km = (1 << k) - 1;
    g[1] = z.convert(this);

    if (k > 1) {
      var g2 = nbi();
      z.sqrTo(g[1], g2);

      while (n <= km) {
        g[n] = nbi();
        z.mulTo(g2, g[n - 2], g[n]);
        n += 2;
      }
    }

    var j = e.t - 1,
        w,
        is1 = true,
        r2 = nbi(),
        t;
    i = nbits(e.data[j]) - 1;

    while (j >= 0) {
      if (i >= k1) w = e.data[j] >> i - k1 & km;else {
        w = (e.data[j] & (1 << i + 1) - 1) << k1 - i;
        if (j > 0) w |= e.data[j - 1] >> this.DB + i - k1;
      }
      n = k;

      while ((w & 1) == 0) {
        w >>= 1;
        --n;
      }

      if ((i -= n) < 0) {
        i += this.DB;
        --j;
      }

      if (is1) {
        // ret == 1, don't bother squaring or multiplying it
        g[w].copyTo(r);
        is1 = false;
      } else {
        while (n > 1) {
          z.sqrTo(r, r2);
          z.sqrTo(r2, r);
          n -= 2;
        }

        if (n > 0) z.sqrTo(r, r2);else {
          t = r;
          r = r2;
          r2 = t;
        }
        z.mulTo(r2, g[w], r);
      }

      while (j >= 0 && (e.data[j] & 1 << i) == 0) {
        z.sqrTo(r, r2);
        t = r;
        r = r2;
        r2 = t;

        if (--i < 0) {
          i = this.DB - 1;
          --j;
        }
      }
    }

    return z.revert(r);
  } //(public) gcd(this,a) (HAC 14.54)


  function bnGCD(a) {
    var x = this.s < 0 ? this.negate() : this.clone();
    var y = a.s < 0 ? a.negate() : a.clone();

    if (x.compareTo(y) < 0) {
      var t = x;
      x = y;
      y = t;
    }

    var i = x.getLowestSetBit(),
        g = y.getLowestSetBit();
    if (g < 0) return x;
    if (i < g) g = i;

    if (g > 0) {
      x.rShiftTo(g, x);
      y.rShiftTo(g, y);
    }

    while (x.signum() > 0) {
      if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
      if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);

      if (x.compareTo(y) >= 0) {
        x.subTo(y, x);
        x.rShiftTo(1, x);
      } else {
        y.subTo(x, y);
        y.rShiftTo(1, y);
      }
    }

    if (g > 0) y.lShiftTo(g, y);
    return y;
  } //(protected) this % n, n < 2^26


  function bnpModInt(n) {
    if (n <= 0) return 0;
    var d = this.DV % n,
        r = this.s < 0 ? n - 1 : 0;
    if (this.t > 0) if (d == 0) r = this.data[0] % n;else for (var i = this.t - 1; i >= 0; --i) {
      r = (d * r + this.data[i]) % n;
    }
    return r;
  } //(public) 1/this % m (HAC 14.61)


  function bnModInverse(m) {
    var ac = m.isEven();
    if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
    var u = m.clone(),
        v = this.clone();
    var a = nbv(1),
        b = nbv(0),
        c = nbv(0),
        d = nbv(1);

    while (u.signum() != 0) {
      while (u.isEven()) {
        u.rShiftTo(1, u);

        if (ac) {
          if (!a.isEven() || !b.isEven()) {
            a.addTo(this, a);
            b.subTo(m, b);
          }

          a.rShiftTo(1, a);
        } else if (!b.isEven()) b.subTo(m, b);

        b.rShiftTo(1, b);
      }

      while (v.isEven()) {
        v.rShiftTo(1, v);

        if (ac) {
          if (!c.isEven() || !d.isEven()) {
            c.addTo(this, c);
            d.subTo(m, d);
          }

          c.rShiftTo(1, c);
        } else if (!d.isEven()) d.subTo(m, d);

        d.rShiftTo(1, d);
      }

      if (u.compareTo(v) >= 0) {
        u.subTo(v, u);
        if (ac) a.subTo(c, a);
        b.subTo(d, b);
      } else {
        v.subTo(u, v);
        if (ac) c.subTo(a, c);
        d.subTo(b, d);
      }
    }

    if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
    if (d.compareTo(m) >= 0) return d.subtract(m);
    if (d.signum() < 0) d.addTo(m, d);else return d;
    if (d.signum() < 0) return d.add(m);else return d;
  }

  var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509];
  var lplim = (1 << 26) / lowprimes[lowprimes.length - 1]; //(public) test primality with certainty >= 1-.5^t

  function bnIsProbablePrime(t) {
    var i,
        x = this.abs();

    if (x.t == 1 && x.data[0] <= lowprimes[lowprimes.length - 1]) {
      for (i = 0; i < lowprimes.length; ++i) {
        if (x.data[0] == lowprimes[i]) return true;
      }

      return false;
    }

    if (x.isEven()) return false;
    i = 1;

    while (i < lowprimes.length) {
      var m = lowprimes[i],
          j = i + 1;

      while (j < lowprimes.length && m < lplim) {
        m *= lowprimes[j++];
      }

      m = x.modInt(m);

      while (i < j) {
        if (m % lowprimes[i++] == 0) return false;
      }
    }

    return x.millerRabin(t);
  } //(protected) true if probably prime (HAC 4.24, Miller-Rabin)


  function bnpMillerRabin(t) {
    var n1 = this.subtract(BigInteger.ONE);
    var k = n1.getLowestSetBit();
    if (k <= 0) return false;
    var r = n1.shiftRight(k);
    var prng = bnGetPrng();
    var a;

    for (var i = 0; i < t; ++i) {
      // select witness 'a' at random from between 1 and n1
      do {
        a = new BigInteger(this.bitLength(), prng);
      } while (a.compareTo(BigInteger.ONE) <= 0 || a.compareTo(n1) >= 0);

      var y = a.modPow(r, this);

      if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
        var j = 1;

        while (j++ < k && y.compareTo(n1) != 0) {
          y = y.modPowInt(2, this);
          if (y.compareTo(BigInteger.ONE) == 0) return false;
        }

        if (y.compareTo(n1) != 0) return false;
      }
    }

    return true;
  } // get pseudo random number generator


  function bnGetPrng() {
    // create prng with api that matches BigInteger secure random
    return {
      // x is an array to fill with bytes
      nextBytes: function nextBytes(x) {
        for (var i = 0; i < x.length; ++i) {
          x[i] = Math.floor(Math.random() * 0x0100);
        }
      }
    };
  } //protected


  BigInteger.prototype.chunkSize = bnpChunkSize;
  BigInteger.prototype.toRadix = bnpToRadix;
  BigInteger.prototype.fromRadix = bnpFromRadix;
  BigInteger.prototype.fromNumber = bnpFromNumber;
  BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
  BigInteger.prototype.changeBit = bnpChangeBit;
  BigInteger.prototype.addTo = bnpAddTo;
  BigInteger.prototype.dMultiply = bnpDMultiply;
  BigInteger.prototype.dAddOffset = bnpDAddOffset;
  BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
  BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
  BigInteger.prototype.modInt = bnpModInt;
  BigInteger.prototype.millerRabin = bnpMillerRabin; //public

  BigInteger.prototype.clone = bnClone;
  BigInteger.prototype.intValue = bnIntValue;
  BigInteger.prototype.byteValue = bnByteValue;
  BigInteger.prototype.shortValue = bnShortValue;
  BigInteger.prototype.signum = bnSigNum;
  BigInteger.prototype.toByteArray = bnToByteArray;
  BigInteger.prototype.equals = bnEquals;
  BigInteger.prototype.min = bnMin;
  BigInteger.prototype.max = bnMax;
  BigInteger.prototype.and = bnAnd;
  BigInteger.prototype.or = bnOr;
  BigInteger.prototype.xor = bnXor;
  BigInteger.prototype.andNot = bnAndNot;
  BigInteger.prototype.not = bnNot;
  BigInteger.prototype.shiftLeft = bnShiftLeft;
  BigInteger.prototype.shiftRight = bnShiftRight;
  BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
  BigInteger.prototype.bitCount = bnBitCount;
  BigInteger.prototype.testBit = bnTestBit;
  BigInteger.prototype.setBit = bnSetBit;
  BigInteger.prototype.clearBit = bnClearBit;
  BigInteger.prototype.flipBit = bnFlipBit;
  BigInteger.prototype.add = bnAdd;
  BigInteger.prototype.subtract = bnSubtract;
  BigInteger.prototype.multiply = bnMultiply;
  BigInteger.prototype.divide = bnDivide;
  BigInteger.prototype.remainder = bnRemainder;
  BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
  BigInteger.prototype.modPow = bnModPow;
  BigInteger.prototype.modInverse = bnModInverse;
  BigInteger.prototype.pow = bnPow;
  BigInteger.prototype.gcd = bnGCD;
  BigInteger.prototype.isProbablePrime = bnIsProbablePrime; //BigInteger interfaces not implemented in jsbn:
  //BigInteger(int signum, byte[] magnitude)
  //double doubleValue()
  //float floatValue()
  //int hashCode()
  //long longValue()
  //static BigInteger valueOf(long val)

  /***/
},
/* 224 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Javascript implementation of mask generation function MGF1.
   *
   * @author Stefan Siegl
   * @author Dave Longley
   *
   * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
   * Copyright (c) 2014 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(8);

  forge.mgf = forge.mgf || {};
  var mgf1 = module.exports = forge.mgf.mgf1 = forge.mgf1 = forge.mgf1 || {};
  /**
   * Creates a MGF1 mask generation function object.
   *
   * @param md the message digest API to use (eg: forge.md.sha1.create()).
   *
   * @return a mask generation function object.
   */

  mgf1.create = function (md) {
    var mgf = {
      /**
       * Generate mask of specified length.
       *
       * @param {String} seed The seed for mask generation.
       * @param maskLen Number of bytes to generate.
       * @return {String} The generated mask.
       */
      generate: function generate(seed, maskLen) {
        /* 2. Let T be the empty octet string. */
        var t = new forge.util.ByteBuffer();
        /* 3. For counter from 0 to ceil(maskLen / hLen), do the following: */

        var len = Math.ceil(maskLen / md.digestLength);

        for (var i = 0; i < len; i++) {
          /* a. Convert counter to an octet string C of length 4 octets */
          var c = new forge.util.ByteBuffer();
          c.putInt32(i);
          /* b. Concatenate the hash of the seed mgfSeed and C to the octet
           * string T: */

          md.start();
          md.update(seed + c.getBytes());
          t.putBuffer(md.digest());
        }
        /* Output the leading maskLen octets of T as the octet string mask. */


        t.truncate(t.length() - maskLen);
        return t.getBytes();
      }
    };
    return mgf;
  };
  /***/

},
/* 225 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Password-based encryption functions.
   *
   * @author Dave Longley
   * @author Stefan Siegl <stesie@brokenpipe.de>
   *
   * Copyright (c) 2010-2013 Digital Bazaar, Inc.
   * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
   *
   * An EncryptedPrivateKeyInfo:
   *
   * EncryptedPrivateKeyInfo ::= SEQUENCE {
   *   encryptionAlgorithm  EncryptionAlgorithmIdentifier,
   *   encryptedData        EncryptedData }
   *
   * EncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
   *
   * EncryptedData ::= OCTET STRING
   */
  var forge = __webpack_require__(6);

  __webpack_require__(79);

  __webpack_require__(46);

  __webpack_require__(144);

  __webpack_require__(60);

  __webpack_require__(61);

  __webpack_require__(146);

  __webpack_require__(80);

  __webpack_require__(47);

  __webpack_require__(544);

  __webpack_require__(101);

  __webpack_require__(8);

  if (typeof BigInteger === 'undefined') {
    var BigInteger = forge.jsbn.BigInteger;
  } // shortcut for asn.1 API


  var asn1 = forge.asn1;
  /* Password-based encryption implementation. */

  var pki = forge.pki = forge.pki || {};
  module.exports = pki.pbe = forge.pbe = forge.pbe || {};
  var oids = pki.oids; // validator for an EncryptedPrivateKeyInfo structure
  // Note: Currently only works w/algorithm params

  var encryptedPrivateKeyValidator = {
    name: 'EncryptedPrivateKeyInfo',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'EncryptedPrivateKeyInfo.encryptionAlgorithm',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: 'AlgorithmIdentifier.algorithm',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OID,
        constructed: false,
        capture: 'encryptionOid'
      }, {
        name: 'AlgorithmIdentifier.parameters',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        captureAsn1: 'encryptionParams'
      }]
    }, {
      // encryptedData
      name: 'EncryptedPrivateKeyInfo.encryptedData',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OCTETSTRING,
      constructed: false,
      capture: 'encryptedData'
    }]
  }; // validator for a PBES2Algorithms structure
  // Note: Currently only works w/PBKDF2 + AES encryption schemes

  var PBES2AlgorithmsValidator = {
    name: 'PBES2Algorithms',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'PBES2Algorithms.keyDerivationFunc',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: 'PBES2Algorithms.keyDerivationFunc.oid',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OID,
        constructed: false,
        capture: 'kdfOid'
      }, {
        name: 'PBES2Algorithms.params',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        value: [{
          name: 'PBES2Algorithms.params.salt',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.OCTETSTRING,
          constructed: false,
          capture: 'kdfSalt'
        }, {
          name: 'PBES2Algorithms.params.iterationCount',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.INTEGER,
          constructed: false,
          capture: 'kdfIterationCount'
        }, {
          name: 'PBES2Algorithms.params.keyLength',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.INTEGER,
          constructed: false,
          optional: true,
          capture: 'keyLength'
        }, {
          // prf
          name: 'PBES2Algorithms.params.prf',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.SEQUENCE,
          constructed: true,
          optional: true,
          value: [{
            name: 'PBES2Algorithms.params.prf.algorithm',
            tagClass: asn1.Class.UNIVERSAL,
            type: asn1.Type.OID,
            constructed: false,
            capture: 'prfOid'
          }]
        }]
      }]
    }, {
      name: 'PBES2Algorithms.encryptionScheme',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: 'PBES2Algorithms.encryptionScheme.oid',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OID,
        constructed: false,
        capture: 'encOid'
      }, {
        name: 'PBES2Algorithms.encryptionScheme.iv',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OCTETSTRING,
        constructed: false,
        capture: 'encIv'
      }]
    }]
  };
  var pkcs12PbeParamsValidator = {
    name: 'pkcs-12PbeParams',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'pkcs-12PbeParams.salt',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OCTETSTRING,
      constructed: false,
      capture: 'salt'
    }, {
      name: 'pkcs-12PbeParams.iterations',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'iterations'
    }]
  };
  /**
   * Encrypts a ASN.1 PrivateKeyInfo object, producing an EncryptedPrivateKeyInfo.
   *
   * PBES2Algorithms ALGORITHM-IDENTIFIER ::=
   *   { {PBES2-params IDENTIFIED BY id-PBES2}, ...}
   *
   * id-PBES2 OBJECT IDENTIFIER ::= {pkcs-5 13}
   *
   * PBES2-params ::= SEQUENCE {
   *   keyDerivationFunc AlgorithmIdentifier {{PBES2-KDFs}},
   *   encryptionScheme AlgorithmIdentifier {{PBES2-Encs}}
   * }
   *
   * PBES2-KDFs ALGORITHM-IDENTIFIER ::=
   *   { {PBKDF2-params IDENTIFIED BY id-PBKDF2}, ... }
   *
   * PBES2-Encs ALGORITHM-IDENTIFIER ::= { ... }
   *
   * PBKDF2-params ::= SEQUENCE {
   *   salt CHOICE {
   *     specified OCTET STRING,
   *     otherSource AlgorithmIdentifier {{PBKDF2-SaltSources}}
   *   },
   *   iterationCount INTEGER (1..MAX),
   *   keyLength INTEGER (1..MAX) OPTIONAL,
   *   prf AlgorithmIdentifier {{PBKDF2-PRFs}} DEFAULT algid-hmacWithSHA1
   * }
   *
   * @param obj the ASN.1 PrivateKeyInfo object.
   * @param password the password to encrypt with.
   * @param options:
   *          algorithm the encryption algorithm to use
   *            ('aes128', 'aes192', 'aes256', '3des'), defaults to 'aes128'.
   *          count the iteration count to use.
   *          saltSize the salt size to use.
   *          prfAlgorithm the PRF message digest algorithm to use
   *            ('sha1', 'sha224', 'sha256', 'sha384', 'sha512')
   *
   * @return the ASN.1 EncryptedPrivateKeyInfo.
   */

  pki.encryptPrivateKeyInfo = function (obj, password, options) {
    // set default options
    options = options || {};
    options.saltSize = options.saltSize || 8;
    options.count = options.count || 2048;
    options.algorithm = options.algorithm || 'aes128';
    options.prfAlgorithm = options.prfAlgorithm || 'sha1'; // generate PBE params

    var salt = forge.random.getBytesSync(options.saltSize);
    var count = options.count;
    var countBytes = asn1.integerToDer(count);
    var dkLen;
    var encryptionAlgorithm;
    var encryptedData;

    if (options.algorithm.indexOf('aes') === 0 || options.algorithm === 'des') {
      // do PBES2
      var ivLen, encOid, cipherFn;

      switch (options.algorithm) {
        case 'aes128':
          dkLen = 16;
          ivLen = 16;
          encOid = oids['aes128-CBC'];
          cipherFn = forge.aes.createEncryptionCipher;
          break;

        case 'aes192':
          dkLen = 24;
          ivLen = 16;
          encOid = oids['aes192-CBC'];
          cipherFn = forge.aes.createEncryptionCipher;
          break;

        case 'aes256':
          dkLen = 32;
          ivLen = 16;
          encOid = oids['aes256-CBC'];
          cipherFn = forge.aes.createEncryptionCipher;
          break;

        case 'des':
          dkLen = 8;
          ivLen = 8;
          encOid = oids['desCBC'];
          cipherFn = forge.des.createEncryptionCipher;
          break;

        default:
          var error = new Error('Cannot encrypt private key. Unknown encryption algorithm.');
          error.algorithm = options.algorithm;
          throw error;
      } // get PRF message digest


      var prfAlgorithm = 'hmacWith' + options.prfAlgorithm.toUpperCase();
      var md = prfAlgorithmToMessageDigest(prfAlgorithm); // encrypt private key using pbe SHA-1 and AES/DES

      var dk = forge.pkcs5.pbkdf2(password, salt, count, dkLen, md);
      var iv = forge.random.getBytesSync(ivLen);
      var cipher = cipherFn(dk);
      cipher.start(iv);
      cipher.update(asn1.toDer(obj));
      cipher.finish();
      encryptedData = cipher.output.getBytes(); // get PBKDF2-params

      var params = createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm);
      encryptionAlgorithm = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(oids['pkcs5PBES2']).getBytes()), asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// keyDerivationFunc
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(oids['pkcs5PBKDF2']).getBytes()), // PBKDF2-params
      params]), // encryptionScheme
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(encOid).getBytes()), // iv
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, iv)])])]);
    } else if (options.algorithm === '3des') {
      // Do PKCS12 PBE
      dkLen = 24;
      var saltBytes = new forge.util.ByteBuffer(salt);
      var dk = pki.pbe.generatePkcs12Key(password, saltBytes, 1, count, dkLen);
      var iv = pki.pbe.generatePkcs12Key(password, saltBytes, 2, count, dkLen);
      var cipher = forge.des.createEncryptionCipher(dk);
      cipher.start(iv);
      cipher.update(asn1.toDer(obj));
      cipher.finish();
      encryptedData = cipher.output.getBytes();
      encryptionAlgorithm = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(oids['pbeWithSHAAnd3-KeyTripleDES-CBC']).getBytes()), // pkcs-12PbeParams
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// salt
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, salt), // iteration count
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, countBytes.getBytes())])]);
    } else {
      var error = new Error('Cannot encrypt private key. Unknown encryption algorithm.');
      error.algorithm = options.algorithm;
      throw error;
    } // EncryptedPrivateKeyInfo


    var rval = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// encryptionAlgorithm
    encryptionAlgorithm, // encryptedData
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, encryptedData)]);
    return rval;
  };
  /**
   * Decrypts a ASN.1 PrivateKeyInfo object.
   *
   * @param obj the ASN.1 EncryptedPrivateKeyInfo object.
   * @param password the password to decrypt with.
   *
   * @return the ASN.1 PrivateKeyInfo on success, null on failure.
   */


  pki.decryptPrivateKeyInfo = function (obj, password) {
    var rval = null; // get PBE params

    var capture = {};
    var errors = [];

    if (!asn1.validate(obj, encryptedPrivateKeyValidator, capture, errors)) {
      var error = new Error('Cannot read encrypted private key. ' + 'ASN.1 object is not a supported EncryptedPrivateKeyInfo.');
      error.errors = errors;
      throw error;
    } // get cipher


    var oid = asn1.derToOid(capture.encryptionOid);
    var cipher = pki.pbe.getCipher(oid, capture.encryptionParams, password); // get encrypted data

    var encrypted = forge.util.createBuffer(capture.encryptedData);
    cipher.update(encrypted);

    if (cipher.finish()) {
      rval = asn1.fromDer(cipher.output);
    }

    return rval;
  };
  /**
   * Converts a EncryptedPrivateKeyInfo to PEM format.
   *
   * @param epki the EncryptedPrivateKeyInfo.
   * @param maxline the maximum characters per line, defaults to 64.
   *
   * @return the PEM-formatted encrypted private key.
   */


  pki.encryptedPrivateKeyToPem = function (epki, maxline) {
    // convert to DER, then PEM-encode
    var msg = {
      type: 'ENCRYPTED PRIVATE KEY',
      body: asn1.toDer(epki).getBytes()
    };
    return forge.pem.encode(msg, {
      maxline: maxline
    });
  };
  /**
   * Converts a PEM-encoded EncryptedPrivateKeyInfo to ASN.1 format. Decryption
   * is not performed.
   *
   * @param pem the EncryptedPrivateKeyInfo in PEM-format.
   *
   * @return the ASN.1 EncryptedPrivateKeyInfo.
   */


  pki.encryptedPrivateKeyFromPem = function (pem) {
    var msg = forge.pem.decode(pem)[0];

    if (msg.type !== 'ENCRYPTED PRIVATE KEY') {
      var error = new Error('Could not convert encrypted private key from PEM; ' + 'PEM header type is "ENCRYPTED PRIVATE KEY".');
      error.headerType = msg.type;
      throw error;
    }

    if (msg.procType && msg.procType.type === 'ENCRYPTED') {
      throw new Error('Could not convert encrypted private key from PEM; ' + 'PEM is encrypted.');
    } // convert DER to ASN.1 object


    return asn1.fromDer(msg.body);
  };
  /**
   * Encrypts an RSA private key. By default, the key will be wrapped in
   * a PrivateKeyInfo and encrypted to produce a PKCS#8 EncryptedPrivateKeyInfo.
   * This is the standard, preferred way to encrypt a private key.
   *
   * To produce a non-standard PEM-encrypted private key that uses encapsulated
   * headers to indicate the encryption algorithm (old-style non-PKCS#8 OpenSSL
   * private key encryption), set the 'legacy' option to true. Note: Using this
   * option will cause the iteration count to be forced to 1.
   *
   * Note: The 'des' algorithm is supported, but it is not considered to be
   * secure because it only uses a single 56-bit key. If possible, it is highly
   * recommended that a different algorithm be used.
   *
   * @param rsaKey the RSA key to encrypt.
   * @param password the password to use.
   * @param options:
   *          algorithm: the encryption algorithm to use
   *            ('aes128', 'aes192', 'aes256', '3des', 'des').
   *          count: the iteration count to use.
   *          saltSize: the salt size to use.
   *          legacy: output an old non-PKCS#8 PEM-encrypted+encapsulated
   *            headers (DEK-Info) private key.
   *
   * @return the PEM-encoded ASN.1 EncryptedPrivateKeyInfo.
   */


  pki.encryptRsaPrivateKey = function (rsaKey, password, options) {
    // standard PKCS#8
    options = options || {};

    if (!options.legacy) {
      // encrypt PrivateKeyInfo
      var rval = pki.wrapRsaPrivateKey(pki.privateKeyToAsn1(rsaKey));
      rval = pki.encryptPrivateKeyInfo(rval, password, options);
      return pki.encryptedPrivateKeyToPem(rval);
    } // legacy non-PKCS#8


    var algorithm;
    var iv;
    var dkLen;
    var cipherFn;

    switch (options.algorithm) {
      case 'aes128':
        algorithm = 'AES-128-CBC';
        dkLen = 16;
        iv = forge.random.getBytesSync(16);
        cipherFn = forge.aes.createEncryptionCipher;
        break;

      case 'aes192':
        algorithm = 'AES-192-CBC';
        dkLen = 24;
        iv = forge.random.getBytesSync(16);
        cipherFn = forge.aes.createEncryptionCipher;
        break;

      case 'aes256':
        algorithm = 'AES-256-CBC';
        dkLen = 32;
        iv = forge.random.getBytesSync(16);
        cipherFn = forge.aes.createEncryptionCipher;
        break;

      case '3des':
        algorithm = 'DES-EDE3-CBC';
        dkLen = 24;
        iv = forge.random.getBytesSync(8);
        cipherFn = forge.des.createEncryptionCipher;
        break;

      case 'des':
        algorithm = 'DES-CBC';
        dkLen = 8;
        iv = forge.random.getBytesSync(8);
        cipherFn = forge.des.createEncryptionCipher;
        break;

      default:
        var error = new Error('Could not encrypt RSA private key; unsupported ' + 'encryption algorithm "' + options.algorithm + '".');
        error.algorithm = options.algorithm;
        throw error;
    } // encrypt private key using OpenSSL legacy key derivation


    var dk = forge.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
    var cipher = cipherFn(dk);
    cipher.start(iv);
    cipher.update(asn1.toDer(pki.privateKeyToAsn1(rsaKey)));
    cipher.finish();
    var msg = {
      type: 'RSA PRIVATE KEY',
      procType: {
        version: '4',
        type: 'ENCRYPTED'
      },
      dekInfo: {
        algorithm: algorithm,
        parameters: forge.util.bytesToHex(iv).toUpperCase()
      },
      body: cipher.output.getBytes()
    };
    return forge.pem.encode(msg);
  };
  /**
   * Decrypts an RSA private key.
   *
   * @param pem the PEM-formatted EncryptedPrivateKeyInfo to decrypt.
   * @param password the password to use.
   *
   * @return the RSA key on success, null on failure.
   */


  pki.decryptRsaPrivateKey = function (pem, password) {
    var rval = null;
    var msg = forge.pem.decode(pem)[0];

    if (msg.type !== 'ENCRYPTED PRIVATE KEY' && msg.type !== 'PRIVATE KEY' && msg.type !== 'RSA PRIVATE KEY') {
      var error = new Error('Could not convert private key from PEM; PEM header type ' + 'is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".');
      error.headerType = error;
      throw error;
    }

    if (msg.procType && msg.procType.type === 'ENCRYPTED') {
      var dkLen;
      var cipherFn;

      switch (msg.dekInfo.algorithm) {
        case 'DES-CBC':
          dkLen = 8;
          cipherFn = forge.des.createDecryptionCipher;
          break;

        case 'DES-EDE3-CBC':
          dkLen = 24;
          cipherFn = forge.des.createDecryptionCipher;
          break;

        case 'AES-128-CBC':
          dkLen = 16;
          cipherFn = forge.aes.createDecryptionCipher;
          break;

        case 'AES-192-CBC':
          dkLen = 24;
          cipherFn = forge.aes.createDecryptionCipher;
          break;

        case 'AES-256-CBC':
          dkLen = 32;
          cipherFn = forge.aes.createDecryptionCipher;
          break;

        case 'RC2-40-CBC':
          dkLen = 5;

          cipherFn = function cipherFn(key) {
            return forge.rc2.createDecryptionCipher(key, 40);
          };

          break;

        case 'RC2-64-CBC':
          dkLen = 8;

          cipherFn = function cipherFn(key) {
            return forge.rc2.createDecryptionCipher(key, 64);
          };

          break;

        case 'RC2-128-CBC':
          dkLen = 16;

          cipherFn = function cipherFn(key) {
            return forge.rc2.createDecryptionCipher(key, 128);
          };

          break;

        default:
          var error = new Error('Could not decrypt private key; unsupported ' + 'encryption algorithm "' + msg.dekInfo.algorithm + '".');
          error.algorithm = msg.dekInfo.algorithm;
          throw error;
      } // use OpenSSL legacy key derivation


      var iv = forge.util.hexToBytes(msg.dekInfo.parameters);
      var dk = forge.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
      var cipher = cipherFn(dk);
      cipher.start(iv);
      cipher.update(forge.util.createBuffer(msg.body));

      if (cipher.finish()) {
        rval = cipher.output.getBytes();
      } else {
        return rval;
      }
    } else {
      rval = msg.body;
    }

    if (msg.type === 'ENCRYPTED PRIVATE KEY') {
      rval = pki.decryptPrivateKeyInfo(asn1.fromDer(rval), password);
    } else {
      // decryption already performed above
      rval = asn1.fromDer(rval);
    }

    if (rval !== null) {
      rval = pki.privateKeyFromAsn1(rval);
    }

    return rval;
  };
  /**
   * Derives a PKCS#12 key.
   *
   * @param password the password to derive the key material from, null or
   *          undefined for none.
   * @param salt the salt, as a ByteBuffer, to use.
   * @param id the PKCS#12 ID byte (1 = key material, 2 = IV, 3 = MAC).
   * @param iter the iteration count.
   * @param n the number of bytes to derive from the password.
   * @param md the message digest to use, defaults to SHA-1.
   *
   * @return a ByteBuffer with the bytes derived from the password.
   */


  pki.pbe.generatePkcs12Key = function (password, salt, id, iter, n, md) {
    var j, l;

    if (typeof md === 'undefined' || md === null) {
      if (!('sha1' in forge.md)) {
        throw new Error('"sha1" hash algorithm unavailable.');
      }

      md = forge.md.sha1.create();
    }

    var u = md.digestLength;
    var v = md.blockLength;
    var result = new forge.util.ByteBuffer();
    /* Convert password to Unicode byte buffer + trailing 0-byte. */

    var passBuf = new forge.util.ByteBuffer();

    if (password !== null && password !== undefined) {
      for (l = 0; l < password.length; l++) {
        passBuf.putInt16(password.charCodeAt(l));
      }

      passBuf.putInt16(0);
    }
    /* Length of salt and password in BYTES. */


    var p = passBuf.length();
    var s = salt.length();
    /* 1. Construct a string, D (the "diversifier"), by concatenating
          v copies of ID. */

    var D = new forge.util.ByteBuffer();
    D.fillWithByte(id, v);
    /* 2. Concatenate copies of the salt together to create a string S of length
          v * ceil(s / v) bytes (the final copy of the salt may be trunacted
          to create S).
          Note that if the salt is the empty string, then so is S. */

    var Slen = v * Math.ceil(s / v);
    var S = new forge.util.ByteBuffer();

    for (l = 0; l < Slen; l++) {
      S.putByte(salt.at(l % s));
    }
    /* 3. Concatenate copies of the password together to create a string P of
          length v * ceil(p / v) bytes (the final copy of the password may be
          truncated to create P).
          Note that if the password is the empty string, then so is P. */


    var Plen = v * Math.ceil(p / v);
    var P = new forge.util.ByteBuffer();

    for (l = 0; l < Plen; l++) {
      P.putByte(passBuf.at(l % p));
    }
    /* 4. Set I=S||P to be the concatenation of S and P. */


    var I = S;
    I.putBuffer(P);
    /* 5. Set c=ceil(n / u). */

    var c = Math.ceil(n / u);
    /* 6. For i=1, 2, ..., c, do the following: */

    for (var i = 1; i <= c; i++) {
      /* a) Set Ai=H^r(D||I). (l.e. the rth hash of D||I, H(H(H(...H(D||I)))) */
      var buf = new forge.util.ByteBuffer();
      buf.putBytes(D.bytes());
      buf.putBytes(I.bytes());

      for (var round = 0; round < iter; round++) {
        md.start();
        md.update(buf.getBytes());
        buf = md.digest();
      }
      /* b) Concatenate copies of Ai to create a string B of length v bytes (the
            final copy of Ai may be truncated to create B). */


      var B = new forge.util.ByteBuffer();

      for (l = 0; l < v; l++) {
        B.putByte(buf.at(l % u));
      }
      /* c) Treating I as a concatenation I0, I1, ..., Ik-1 of v-byte blocks,
            where k=ceil(s / v) + ceil(p / v), modify I by setting
            Ij=(Ij+B+1) mod 2v for each j.  */


      var k = Math.ceil(s / v) + Math.ceil(p / v);
      var Inew = new forge.util.ByteBuffer();

      for (j = 0; j < k; j++) {
        var chunk = new forge.util.ByteBuffer(I.getBytes(v));
        var x = 0x1ff;

        for (l = B.length() - 1; l >= 0; l--) {
          x = x >> 8;
          x += B.at(l) + chunk.at(l);
          chunk.setAt(l, x & 0xff);
        }

        Inew.putBuffer(chunk);
      }

      I = Inew;
      /* Add Ai to A. */

      result.putBuffer(buf);
    }

    result.truncate(result.length() - n);
    return result;
  };
  /**
   * Get new Forge cipher object instance.
   *
   * @param oid the OID (in string notation).
   * @param params the ASN.1 params object.
   * @param password the password to decrypt with.
   *
   * @return new cipher object instance.
   */


  pki.pbe.getCipher = function (oid, params, password) {
    switch (oid) {
      case pki.oids['pkcs5PBES2']:
        return pki.pbe.getCipherForPBES2(oid, params, password);

      case pki.oids['pbeWithSHAAnd3-KeyTripleDES-CBC']:
      case pki.oids['pbewithSHAAnd40BitRC2-CBC']:
        return pki.pbe.getCipherForPKCS12PBE(oid, params, password);

      default:
        var error = new Error('Cannot read encrypted PBE data block. Unsupported OID.');
        error.oid = oid;
        error.supportedOids = ['pkcs5PBES2', 'pbeWithSHAAnd3-KeyTripleDES-CBC', 'pbewithSHAAnd40BitRC2-CBC'];
        throw error;
    }
  };
  /**
   * Get new Forge cipher object instance according to PBES2 params block.
   *
   * The returned cipher instance is already started using the IV
   * from PBES2 parameter block.
   *
   * @param oid the PKCS#5 PBKDF2 OID (in string notation).
   * @param params the ASN.1 PBES2-params object.
   * @param password the password to decrypt with.
   *
   * @return new cipher object instance.
   */


  pki.pbe.getCipherForPBES2 = function (oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];

    if (!asn1.validate(params, PBES2AlgorithmsValidator, capture, errors)) {
      var error = new Error('Cannot read password-based-encryption algorithm ' + 'parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.');
      error.errors = errors;
      throw error;
    } // check oids


    oid = asn1.derToOid(capture.kdfOid);

    if (oid !== pki.oids['pkcs5PBKDF2']) {
      var error = new Error('Cannot read encrypted private key. ' + 'Unsupported key derivation function OID.');
      error.oid = oid;
      error.supportedOids = ['pkcs5PBKDF2'];
      throw error;
    }

    oid = asn1.derToOid(capture.encOid);

    if (oid !== pki.oids['aes128-CBC'] && oid !== pki.oids['aes192-CBC'] && oid !== pki.oids['aes256-CBC'] && oid !== pki.oids['des-EDE3-CBC'] && oid !== pki.oids['desCBC']) {
      var error = new Error('Cannot read encrypted private key. ' + 'Unsupported encryption scheme OID.');
      error.oid = oid;
      error.supportedOids = ['aes128-CBC', 'aes192-CBC', 'aes256-CBC', 'des-EDE3-CBC', 'desCBC'];
      throw error;
    } // set PBE params


    var salt = capture.kdfSalt;
    var count = forge.util.createBuffer(capture.kdfIterationCount);
    count = count.getInt(count.length() << 3);
    var dkLen;
    var cipherFn;

    switch (pki.oids[oid]) {
      case 'aes128-CBC':
        dkLen = 16;
        cipherFn = forge.aes.createDecryptionCipher;
        break;

      case 'aes192-CBC':
        dkLen = 24;
        cipherFn = forge.aes.createDecryptionCipher;
        break;

      case 'aes256-CBC':
        dkLen = 32;
        cipherFn = forge.aes.createDecryptionCipher;
        break;

      case 'des-EDE3-CBC':
        dkLen = 24;
        cipherFn = forge.des.createDecryptionCipher;
        break;

      case 'desCBC':
        dkLen = 8;
        cipherFn = forge.des.createDecryptionCipher;
        break;
    } // get PRF message digest


    var md = prfOidToMessageDigest(capture.prfOid); // decrypt private key using pbe with chosen PRF and AES/DES

    var dk = forge.pkcs5.pbkdf2(password, salt, count, dkLen, md);
    var iv = capture.encIv;
    var cipher = cipherFn(dk);
    cipher.start(iv);
    return cipher;
  };
  /**
   * Get new Forge cipher object instance for PKCS#12 PBE.
   *
   * The returned cipher instance is already started using the key & IV
   * derived from the provided password and PKCS#12 PBE salt.
   *
   * @param oid The PKCS#12 PBE OID (in string notation).
   * @param params The ASN.1 PKCS#12 PBE-params object.
   * @param password The password to decrypt with.
   *
   * @return the new cipher object instance.
   */


  pki.pbe.getCipherForPKCS12PBE = function (oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];

    if (!asn1.validate(params, pkcs12PbeParamsValidator, capture, errors)) {
      var error = new Error('Cannot read password-based-encryption algorithm ' + 'parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.');
      error.errors = errors;
      throw error;
    }

    var salt = forge.util.createBuffer(capture.salt);
    var count = forge.util.createBuffer(capture.iterations);
    count = count.getInt(count.length() << 3);
    var dkLen, dIvLen, cipherFn;

    switch (oid) {
      case pki.oids['pbeWithSHAAnd3-KeyTripleDES-CBC']:
        dkLen = 24;
        dIvLen = 8;
        cipherFn = forge.des.startDecrypting;
        break;

      case pki.oids['pbewithSHAAnd40BitRC2-CBC']:
        dkLen = 5;
        dIvLen = 8;

        cipherFn = function cipherFn(key, iv) {
          var cipher = forge.rc2.createDecryptionCipher(key, 40);
          cipher.start(iv, null);
          return cipher;
        };

        break;

      default:
        var error = new Error('Cannot read PKCS #12 PBE data block. Unsupported OID.');
        error.oid = oid;
        throw error;
    } // get PRF message digest


    var md = prfOidToMessageDigest(capture.prfOid);
    var key = pki.pbe.generatePkcs12Key(password, salt, 1, count, dkLen, md);
    md.start();
    var iv = pki.pbe.generatePkcs12Key(password, salt, 2, count, dIvLen, md);
    return cipherFn(key, iv);
  };
  /**
   * OpenSSL's legacy key derivation function.
   *
   * See: http://www.openssl.org/docs/crypto/EVP_BytesToKey.html
   *
   * @param password the password to derive the key from.
   * @param salt the salt to use, null for none.
   * @param dkLen the number of bytes needed for the derived key.
   * @param [options] the options to use:
   *          [md] an optional message digest object to use.
   */


  pki.pbe.opensslDeriveBytes = function (password, salt, dkLen, md) {
    if (typeof md === 'undefined' || md === null) {
      if (!('md5' in forge.md)) {
        throw new Error('"md5" hash algorithm unavailable.');
      }

      md = forge.md.md5.create();
    }

    if (salt === null) {
      salt = '';
    }

    var digests = [hash(md, password + salt)];

    for (var length = 16, i = 1; length < dkLen; ++i, length += 16) {
      digests.push(hash(md, digests[i - 1] + password + salt));
    }

    return digests.join('').substr(0, dkLen);
  };

  function hash(md, bytes) {
    return md.start().update(bytes).digest().getBytes();
  }

  function prfOidToMessageDigest(prfOid) {
    // get PRF algorithm, default to SHA-1
    var prfAlgorithm;

    if (!prfOid) {
      prfAlgorithm = 'hmacWithSHA1';
    } else {
      prfAlgorithm = pki.oids[asn1.derToOid(prfOid)];

      if (!prfAlgorithm) {
        var error = new Error('Unsupported PRF OID.');
        error.oid = prfOid;
        error.supported = ['hmacWithSHA1', 'hmacWithSHA224', 'hmacWithSHA256', 'hmacWithSHA384', 'hmacWithSHA512'];
        throw error;
      }
    }

    return prfAlgorithmToMessageDigest(prfAlgorithm);
  }

  function prfAlgorithmToMessageDigest(prfAlgorithm) {
    var factory = forge.md;

    switch (prfAlgorithm) {
      case 'hmacWithSHA224':
        factory = forge.md.sha512;

      case 'hmacWithSHA1':
      case 'hmacWithSHA256':
      case 'hmacWithSHA384':
      case 'hmacWithSHA512':
        prfAlgorithm = prfAlgorithm.substr(8).toLowerCase();
        break;

      default:
        var error = new Error('Unsupported PRF algorithm.');
        error.algorithm = prfAlgorithm;
        error.supported = ['hmacWithSHA1', 'hmacWithSHA224', 'hmacWithSHA256', 'hmacWithSHA384', 'hmacWithSHA512'];
        throw error;
    }

    if (!factory || !(prfAlgorithm in factory)) {
      throw new Error('Unknown hash algorithm: ' + prfAlgorithm);
    }

    return factory[prfAlgorithm].create();
  }

  function createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm) {
    var params = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// salt
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, salt), // iteration count
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, countBytes.getBytes())]); // when PRF algorithm is not SHA-1 default, add key length and PRF algorithm

    if (prfAlgorithm !== 'hmacWithSHA1') {
      params.value.push( // key length
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, forge.util.hexToBytes(dkLen.toString(16))), // AlgorithmIdentifier
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// algorithm
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(pki.oids[prfAlgorithm]).getBytes()), // parameters (null)
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '')]));
    }

    return params;
  }
  /***/

},
/* 226 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Partial implementation of PKCS#1 v2.2: RSA-OEAP
   *
   * Modified but based on the following MIT and BSD licensed code:
   *
   * https://github.com/kjur/jsjws/blob/master/rsa.js:
   *
   * The 'jsjws'(JSON Web Signature JavaScript Library) License
   *
   * Copyright (c) 2012 Kenji Urushima
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in
   * all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   * THE SOFTWARE.
   *
   * http://webrsa.cvs.sourceforge.net/viewvc/webrsa/Client/RSAES-OAEP.js?content-type=text%2Fplain:
   *
   * RSAES-OAEP.js
   * $Id: RSAES-OAEP.js,v 1.1.1.1 2003/03/19 15:37:20 ellispritchard Exp $
   * JavaScript Implementation of PKCS #1 v2.1 RSA CRYPTOGRAPHY STANDARD (RSA Laboratories, June 14, 2002)
   * Copyright (C) Ellis Pritchard, Guardian Unlimited 2003.
   * Contact: ellis@nukinetics.com
   * Distributed under the BSD License.
   *
   * Official documentation: http://www.rsa.com/rsalabs/node.asp?id=2125
   *
   * @author Evan Jones (http://evanjones.ca/)
   * @author Dave Longley
   *
   * Copyright (c) 2013-2014 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(8);

  __webpack_require__(47);

  __webpack_require__(148); // shortcut for PKCS#1 API


  var pkcs1 = module.exports = forge.pkcs1 = forge.pkcs1 || {};
  /**
   * Encode the given RSAES-OAEP message (M) using key, with optional label (L)
   * and seed.
   *
   * This method does not perform RSA encryption, it only encodes the message
   * using RSAES-OAEP.
   *
   * @param key the RSA key to use.
   * @param message the message to encode.
   * @param options the options to use:
   *          label an optional label to use.
   *          seed the seed to use.
   *          md the message digest object to use, undefined for SHA-1.
   *          mgf1 optional mgf1 parameters:
   *            md the message digest object to use for MGF1.
   *
   * @return the encoded message bytes.
   */

  pkcs1.encode_rsa_oaep = function (key, message, options) {
    // parse arguments
    var label;
    var seed;
    var md;
    var mgf1Md; // legacy args (label, seed, md)

    if (typeof options === 'string') {
      label = options;
      seed = arguments[3] || undefined;
      md = arguments[4] || undefined;
    } else if (options) {
      label = options.label || undefined;
      seed = options.seed || undefined;
      md = options.md || undefined;

      if (options.mgf1 && options.mgf1.md) {
        mgf1Md = options.mgf1.md;
      }
    } // default OAEP to SHA-1 message digest


    if (!md) {
      md = forge.md.sha1.create();
    } else {
      md.start();
    } // default MGF-1 to same as OAEP


    if (!mgf1Md) {
      mgf1Md = md;
    } // compute length in bytes and check output


    var keyLength = Math.ceil(key.n.bitLength() / 8);
    var maxLength = keyLength - 2 * md.digestLength - 2;

    if (message.length > maxLength) {
      var error = new Error('RSAES-OAEP input message length is too long.');
      error.length = message.length;
      error.maxLength = maxLength;
      throw error;
    }

    if (!label) {
      label = '';
    }

    md.update(label, 'raw');
    var lHash = md.digest();
    var PS = '';
    var PS_length = maxLength - message.length;

    for (var i = 0; i < PS_length; i++) {
      PS += '\x00';
    }

    var DB = lHash.getBytes() + PS + '\x01' + message;

    if (!seed) {
      seed = forge.random.getBytes(md.digestLength);
    } else if (seed.length !== md.digestLength) {
      var error = new Error('Invalid RSAES-OAEP seed. The seed length must ' + 'match the digest length.');
      error.seedLength = seed.length;
      error.digestLength = md.digestLength;
      throw error;
    }

    var dbMask = rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var maskedDB = forge.util.xorBytes(DB, dbMask, DB.length);
    var seedMask = rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var maskedSeed = forge.util.xorBytes(seed, seedMask, seed.length); // return encoded message

    return '\x00' + maskedSeed + maskedDB;
  };
  /**
   * Decode the given RSAES-OAEP encoded message (EM) using key, with optional
   * label (L).
   *
   * This method does not perform RSA decryption, it only decodes the message
   * using RSAES-OAEP.
   *
   * @param key the RSA key to use.
   * @param em the encoded message to decode.
   * @param options the options to use:
   *          label an optional label to use.
   *          md the message digest object to use for OAEP, undefined for SHA-1.
   *          mgf1 optional mgf1 parameters:
   *            md the message digest object to use for MGF1.
   *
   * @return the decoded message bytes.
   */


  pkcs1.decode_rsa_oaep = function (key, em, options) {
    // parse args
    var label;
    var md;
    var mgf1Md; // legacy args

    if (typeof options === 'string') {
      label = options;
      md = arguments[3] || undefined;
    } else if (options) {
      label = options.label || undefined;
      md = options.md || undefined;

      if (options.mgf1 && options.mgf1.md) {
        mgf1Md = options.mgf1.md;
      }
    } // compute length in bytes


    var keyLength = Math.ceil(key.n.bitLength() / 8);

    if (em.length !== keyLength) {
      var error = new Error('RSAES-OAEP encoded message length is invalid.');
      error.length = em.length;
      error.expectedLength = keyLength;
      throw error;
    } // default OAEP to SHA-1 message digest


    if (md === undefined) {
      md = forge.md.sha1.create();
    } else {
      md.start();
    } // default MGF-1 to same as OAEP


    if (!mgf1Md) {
      mgf1Md = md;
    }

    if (keyLength < 2 * md.digestLength + 2) {
      throw new Error('RSAES-OAEP key is too short for the hash function.');
    }

    if (!label) {
      label = '';
    }

    md.update(label, 'raw');
    var lHash = md.digest().getBytes(); // split the message into its parts

    var y = em.charAt(0);
    var maskedSeed = em.substring(1, md.digestLength + 1);
    var maskedDB = em.substring(1 + md.digestLength);
    var seedMask = rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var seed = forge.util.xorBytes(maskedSeed, seedMask, maskedSeed.length);
    var dbMask = rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var db = forge.util.xorBytes(maskedDB, dbMask, maskedDB.length);
    var lHashPrime = db.substring(0, md.digestLength); // constant time check that all values match what is expected

    var error = y !== '\x00'; // constant time check lHash vs lHashPrime

    for (var i = 0; i < md.digestLength; ++i) {
      error |= lHash.charAt(i) !== lHashPrime.charAt(i);
    } // "constant time" find the 0x1 byte separating the padding (zeros) from the
    // message
    // TODO: It must be possible to do this in a better/smarter way?


    var in_ps = 1;
    var index = md.digestLength;

    for (var j = md.digestLength; j < db.length; j++) {
      var code = db.charCodeAt(j);
      var is_0 = code & 0x1 ^ 0x1; // non-zero if not 0 or 1 in the ps section

      var error_mask = in_ps ? 0xfffe : 0x0000;
      error |= code & error_mask; // latch in_ps to zero after we find 0x1

      in_ps = in_ps & is_0;
      index += in_ps;
    }

    if (error || db.charCodeAt(index) !== 0x1) {
      throw new Error('Invalid RSAES-OAEP padding.');
    }

    return db.substring(index + 1);
  };

  function rsa_mgf1(seed, maskLength, hash) {
    // default to SHA-1 message digest
    if (!hash) {
      hash = forge.md.sha1.create();
    }

    var t = '';
    var count = Math.ceil(maskLength / hash.digestLength);

    for (var i = 0; i < count; ++i) {
      var c = String.fromCharCode(i >> 24 & 0xFF, i >> 16 & 0xFF, i >> 8 & 0xFF, i & 0xFF);
      hash.start();
      hash.update(seed + c);
      t += hash.digest().getBytes();
    }

    return t.substring(0, maskLength);
  }
  /***/

},
/* 227 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Javascript implementation of ASN.1 validators for PKCS#7 v1.5.
   *
   * @author Dave Longley
   * @author Stefan Siegl
   *
   * Copyright (c) 2012-2015 Digital Bazaar, Inc.
   * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
   *
   * The ASN.1 representation of PKCS#7 is as follows
   * (see RFC #2315 for details, http://www.ietf.org/rfc/rfc2315.txt):
   *
   * A PKCS#7 message consists of a ContentInfo on root level, which may
   * contain any number of further ContentInfo nested into it.
   *
   * ContentInfo ::= SEQUENCE {
   *   contentType                ContentType,
   *   content               [0]  EXPLICIT ANY DEFINED BY contentType OPTIONAL
   * }
   *
   * ContentType ::= OBJECT IDENTIFIER
   *
   * EnvelopedData ::= SEQUENCE {
   *   version                    Version,
   *   recipientInfos             RecipientInfos,
   *   encryptedContentInfo       EncryptedContentInfo
   * }
   *
   * EncryptedData ::= SEQUENCE {
   *   version                    Version,
   *   encryptedContentInfo       EncryptedContentInfo
   * }
   *
   * id-signedData OBJECT IDENTIFIER ::= { iso(1) member-body(2)
   *   us(840) rsadsi(113549) pkcs(1) pkcs7(7) 2 }
   *
   * SignedData ::= SEQUENCE {
   *   version           INTEGER,
   *   digestAlgorithms  DigestAlgorithmIdentifiers,
   *   contentInfo       ContentInfo,
   *   certificates      [0] IMPLICIT Certificates OPTIONAL,
   *   crls              [1] IMPLICIT CertificateRevocationLists OPTIONAL,
   *   signerInfos       SignerInfos
   * }
   *
   * SignerInfos ::= SET OF SignerInfo
   *
   * SignerInfo ::= SEQUENCE {
   *   version                    Version,
   *   issuerAndSerialNumber      IssuerAndSerialNumber,
   *   digestAlgorithm            DigestAlgorithmIdentifier,
   *   authenticatedAttributes    [0] IMPLICIT Attributes OPTIONAL,
   *   digestEncryptionAlgorithm  DigestEncryptionAlgorithmIdentifier,
   *   encryptedDigest            EncryptedDigest,
   *   unauthenticatedAttributes  [1] IMPLICIT Attributes OPTIONAL
   * }
   *
   * EncryptedDigest ::= OCTET STRING
   *
   * Attributes ::= SET OF Attribute
   *
   * Attribute ::= SEQUENCE {
   *   attrType    OBJECT IDENTIFIER,
   *   attrValues  SET OF AttributeValue
   * }
   *
   * AttributeValue ::= ANY
   *
   * Version ::= INTEGER
   *
   * RecipientInfos ::= SET OF RecipientInfo
   *
   * EncryptedContentInfo ::= SEQUENCE {
   *   contentType                 ContentType,
   *   contentEncryptionAlgorithm  ContentEncryptionAlgorithmIdentifier,
   *   encryptedContent       [0]  IMPLICIT EncryptedContent OPTIONAL
   * }
   *
   * ContentEncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
   *
   * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
   * for the algorithm, if any. In the case of AES and DES3, there is only one,
   * the IV.
   *
   * AlgorithmIdentifer ::= SEQUENCE {
   *    algorithm OBJECT IDENTIFIER,
   *    parameters ANY DEFINED BY algorithm OPTIONAL
   * }
   *
   * EncryptedContent ::= OCTET STRING
   *
   * RecipientInfo ::= SEQUENCE {
   *   version                     Version,
   *   issuerAndSerialNumber       IssuerAndSerialNumber,
   *   keyEncryptionAlgorithm      KeyEncryptionAlgorithmIdentifier,
   *   encryptedKey                EncryptedKey
   * }
   *
   * IssuerAndSerialNumber ::= SEQUENCE {
   *   issuer                      Name,
   *   serialNumber                CertificateSerialNumber
   * }
   *
   * CertificateSerialNumber ::= INTEGER
   *
   * KeyEncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
   *
   * EncryptedKey ::= OCTET STRING
   */
  var forge = __webpack_require__(6);

  __webpack_require__(46);

  __webpack_require__(8); // shortcut for ASN.1 API


  var asn1 = forge.asn1; // shortcut for PKCS#7 API

  var p7v = module.exports = forge.pkcs7asn1 = forge.pkcs7asn1 || {};
  forge.pkcs7 = forge.pkcs7 || {};
  forge.pkcs7.asn1 = p7v;
  var contentInfoValidator = {
    name: 'ContentInfo',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'ContentInfo.ContentType',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OID,
      constructed: false,
      capture: 'contentType'
    }, {
      name: 'ContentInfo.content',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 0,
      constructed: true,
      optional: true,
      captureAsn1: 'content'
    }]
  };
  p7v.contentInfoValidator = contentInfoValidator;
  var encryptedContentInfoValidator = {
    name: 'EncryptedContentInfo',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'EncryptedContentInfo.contentType',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OID,
      constructed: false,
      capture: 'contentType'
    }, {
      name: 'EncryptedContentInfo.contentEncryptionAlgorithm',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: 'EncryptedContentInfo.contentEncryptionAlgorithm.algorithm',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OID,
        constructed: false,
        capture: 'encAlgorithm'
      }, {
        name: 'EncryptedContentInfo.contentEncryptionAlgorithm.parameter',
        tagClass: asn1.Class.UNIVERSAL,
        captureAsn1: 'encParameter'
      }]
    }, {
      name: 'EncryptedContentInfo.encryptedContent',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 0,

      /* The PKCS#7 structure output by OpenSSL somewhat differs from what
       * other implementations do generate.
       *
       * OpenSSL generates a structure like this:
       * SEQUENCE {
       *    ...
       *    [0]
       *       26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
       *       C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
       *       ...
       * }
       *
       * Whereas other implementations (and this PKCS#7 module) generate:
       * SEQUENCE {
       *    ...
       *    [0] {
       *       OCTET STRING
       *          26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
       *          C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
       *          ...
       *    }
       * }
       *
       * In order to support both, we just capture the context specific
       * field here.  The OCTET STRING bit is removed below.
       */
      capture: 'encryptedContent',
      captureAsn1: 'encryptedContentAsn1'
    }]
  };
  p7v.envelopedDataValidator = {
    name: 'EnvelopedData',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'EnvelopedData.Version',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'version'
    }, {
      name: 'EnvelopedData.RecipientInfos',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SET,
      constructed: true,
      captureAsn1: 'recipientInfos'
    }].concat(encryptedContentInfoValidator)
  };
  p7v.encryptedDataValidator = {
    name: 'EncryptedData',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'EncryptedData.Version',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'version'
    }].concat(encryptedContentInfoValidator)
  };
  var signerValidator = {
    name: 'SignerInfo',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'SignerInfo.version',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false
    }, {
      name: 'SignerInfo.issuerAndSerialNumber',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: 'SignerInfo.issuerAndSerialNumber.issuer',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        captureAsn1: 'issuer'
      }, {
        name: 'SignerInfo.issuerAndSerialNumber.serialNumber',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.INTEGER,
        constructed: false,
        capture: 'serial'
      }]
    }, {
      name: 'SignerInfo.digestAlgorithm',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: 'SignerInfo.digestAlgorithm.algorithm',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OID,
        constructed: false,
        capture: 'digestAlgorithm'
      }, {
        name: 'SignerInfo.digestAlgorithm.parameter',
        tagClass: asn1.Class.UNIVERSAL,
        constructed: false,
        captureAsn1: 'digestParameter',
        optional: true
      }]
    }, {
      name: 'SignerInfo.authenticatedAttributes',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 0,
      constructed: true,
      optional: true,
      capture: 'authenticatedAttributes'
    }, {
      name: 'SignerInfo.digestEncryptionAlgorithm',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      capture: 'signatureAlgorithm'
    }, {
      name: 'SignerInfo.encryptedDigest',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OCTETSTRING,
      constructed: false,
      capture: 'signature'
    }, {
      name: 'SignerInfo.unauthenticatedAttributes',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 1,
      constructed: true,
      optional: true,
      capture: 'unauthenticatedAttributes'
    }]
  };
  p7v.signedDataValidator = {
    name: 'SignedData',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'SignedData.Version',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'version'
    }, {
      name: 'SignedData.DigestAlgorithms',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SET,
      constructed: true,
      captureAsn1: 'digestAlgorithms'
    }, contentInfoValidator, {
      name: 'SignedData.Certificates',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 0,
      optional: true,
      captureAsn1: 'certificates'
    }, {
      name: 'SignedData.CertificateRevocationLists',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      type: 1,
      optional: true,
      captureAsn1: 'crls'
    }, {
      name: 'SignedData.SignerInfos',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SET,
      capture: 'signerInfos',
      optional: true,
      value: [signerValidator]
    }]
  };
  p7v.recipientInfoValidator = {
    name: 'RecipientInfo',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'RecipientInfo.version',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'version'
    }, {
      name: 'RecipientInfo.issuerAndSerial',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: 'RecipientInfo.issuerAndSerial.issuer',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        captureAsn1: 'issuer'
      }, {
        name: 'RecipientInfo.issuerAndSerial.serialNumber',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.INTEGER,
        constructed: false,
        capture: 'serial'
      }]
    }, {
      name: 'RecipientInfo.keyEncryptionAlgorithm',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: 'RecipientInfo.keyEncryptionAlgorithm.algorithm',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OID,
        constructed: false,
        capture: 'encAlgorithm'
      }, {
        name: 'RecipientInfo.keyEncryptionAlgorithm.parameter',
        tagClass: asn1.Class.UNIVERSAL,
        constructed: false,
        captureAsn1: 'encParameter'
      }]
    }, {
      name: 'RecipientInfo.encryptedKey',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OCTETSTRING,
      constructed: false,
      capture: 'encKey'
    }]
  };
  /***/
},
/* 228 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Prime number generation API.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2014 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(8);

  __webpack_require__(223);

  __webpack_require__(47);

  (function () {
    // forge.prime already defined
    if (forge.prime) {
      module.exports = forge.prime;
      return;
    }
    /* PRIME API */


    var prime = module.exports = forge.prime = forge.prime || {};
    var BigInteger = forge.jsbn.BigInteger; // primes are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29

    var GCD_30_DELTA = [6, 4, 2, 4, 2, 4, 6, 2];
    var THIRTY = new BigInteger(null);
    THIRTY.fromInt(30);

    var op_or = function op_or(x, y) {
      return x | y;
    };
    /**
     * Generates a random probable prime with the given number of bits.
     *
     * Alternative algorithms can be specified by name as a string or as an
     * object with custom options like so:
     *
     * {
     *   name: 'PRIMEINC',
     *   options: {
     *     maxBlockTime: <the maximum amount of time to block the main
     *       thread before allowing I/O other JS to run>,
     *     millerRabinTests: <the number of miller-rabin tests to run>,
     *     workerScript: <the worker script URL>,
     *     workers: <the number of web workers (if supported) to use,
     *       -1 to use estimated cores minus one>.
     *     workLoad: the size of the work load, ie: number of possible prime
     *       numbers for each web worker to check per work assignment,
     *       (default: 100).
     *   }
     * }
     *
     * @param bits the number of bits for the prime number.
     * @param options the options to use.
     *          [algorithm] the algorithm to use (default: 'PRIMEINC').
     *          [prng] a custom crypto-secure pseudo-random number generator to use,
     *            that must define "getBytesSync".
     *
     * @return callback(err, num) called once the operation completes.
     */


    prime.generateProbablePrime = function (bits, options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      options = options || {}; // default to PRIMEINC algorithm

      var algorithm = options.algorithm || 'PRIMEINC';

      if (typeof algorithm === 'string') {
        algorithm = {
          name: algorithm
        };
      }

      algorithm.options = algorithm.options || {}; // create prng with api that matches BigInteger secure random

      var prng = options.prng || forge.random;
      var rng = {
        // x is an array to fill with bytes
        nextBytes: function nextBytes(x) {
          var b = prng.getBytesSync(x.length);

          for (var i = 0; i < x.length; ++i) {
            x[i] = b.charCodeAt(i);
          }
        }
      };

      if (algorithm.name === 'PRIMEINC') {
        return primeincFindPrime(bits, rng, algorithm.options, callback);
      }

      throw new Error('Invalid prime generation algorithm: ' + algorithm.name);
    };

    function primeincFindPrime(bits, rng, options, callback) {
      if ('workers' in options) {
        return primeincFindPrimeWithWorkers(bits, rng, options, callback);
      }

      return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
    }

    function primeincFindPrimeWithoutWorkers(bits, rng, options, callback) {
      // initialize random number
      var num = generateRandom(bits, rng);
      /* Note: All primes are of the form 30k+i for i < 30 and gcd(30, i)=1. The
      number we are given is always aligned at 30k + 1. Each time the number is
      determined not to be prime we add to get to the next 'i', eg: if the number
      was at 30k + 1 we add 6. */

      var deltaIdx = 0; // get required number of MR tests

      var mrTests = getMillerRabinTests(num.bitLength());

      if ('millerRabinTests' in options) {
        mrTests = options.millerRabinTests;
      } // find prime nearest to 'num' for maxBlockTime ms
      // 10 ms gives 5ms of leeway for other calculations before dropping
      // below 60fps (1000/60 == 16.67), but in reality, the number will
      // likely be higher due to an 'atomic' big int modPow


      var maxBlockTime = 10;

      if ('maxBlockTime' in options) {
        maxBlockTime = options.maxBlockTime;
      }

      _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
    }

    function _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback) {
      var start = +new Date();

      do {
        // overflow, regenerate random number
        if (num.bitLength() > bits) {
          num = generateRandom(bits, rng);
        } // do primality test


        if (num.isProbablePrime(mrTests)) {
          return callback(null, num);
        } // get next potential prime


        num.dAddOffset(GCD_30_DELTA[deltaIdx++ % 8], 0);
      } while (maxBlockTime < 0 || +new Date() - start < maxBlockTime); // keep trying later


      forge.util.setImmediate(function () {
        _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
      });
    } // NOTE: This algorithm is indeterminate in nature because workers
    // run in parallel looking at different segments of numbers. Even if this
    // algorithm is run twice with the same input from a predictable RNG, it
    // may produce different outputs.


    function primeincFindPrimeWithWorkers(bits, rng, options, callback) {
      // web workers unavailable
      if (typeof Worker === 'undefined') {
        return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
      } // initialize random number


      var num = generateRandom(bits, rng); // use web workers to generate keys

      var numWorkers = options.workers;
      var workLoad = options.workLoad || 100;
      var range = workLoad * 30 / 8;
      var workerScript = options.workerScript || 'forge/prime.worker.js';

      if (numWorkers === -1) {
        return forge.util.estimateCores(function (err, cores) {
          if (err) {
            // default to 2
            cores = 2;
          }

          numWorkers = cores - 1;
          generate();
        });
      }

      generate();

      function generate() {
        // require at least 1 worker
        numWorkers = Math.max(1, numWorkers); // TODO: consider optimizing by starting workers outside getPrime() ...
        // note that in order to clean up they will have to be made internally
        // asynchronous which may actually be slower
        // start workers immediately

        var workers = [];

        for (var i = 0; i < numWorkers; ++i) {
          // FIXME: fix path or use blob URLs
          workers[i] = new Worker(workerScript);
        }

        var running = numWorkers; // listen for requests from workers and assign ranges to find prime

        for (var i = 0; i < numWorkers; ++i) {
          workers[i].addEventListener('message', workerMessage);
        }
        /* Note: The distribution of random numbers is unknown. Therefore, each
        web worker is continuously allocated a range of numbers to check for a
        random number until one is found.
         Every 30 numbers will be checked just 8 times, because prime numbers
        have the form:
         30k+i, for i < 30 and gcd(30, i)=1 (there are 8 values of i for this)
         Therefore, if we want a web worker to run N checks before asking for
        a new range of numbers, each range must contain N*30/8 numbers.
         For 100 checks (workLoad), this is a range of 375. */


        var found = false;

        function workerMessage(e) {
          // ignore message, prime already found
          if (found) {
            return;
          }

          --running;
          var data = e.data;

          if (data.found) {
            // terminate all workers
            for (var i = 0; i < workers.length; ++i) {
              workers[i].terminate();
            }

            found = true;
            return callback(null, new BigInteger(data.prime, 16));
          } // overflow, regenerate random number


          if (num.bitLength() > bits) {
            num = generateRandom(bits, rng);
          } // assign new range to check


          var hex = num.toString(16); // start prime search

          e.target.postMessage({
            hex: hex,
            workLoad: workLoad
          });
          num.dAddOffset(range, 0);
        }
      }
    }
    /**
     * Generates a random number using the given number of bits and RNG.
     *
     * @param bits the number of bits for the number.
     * @param rng the random number generator to use.
     *
     * @return the random number.
     */


    function generateRandom(bits, rng) {
      var num = new BigInteger(bits, rng); // force MSB set

      var bits1 = bits - 1;

      if (!num.testBit(bits1)) {
        num.bitwiseTo(BigInteger.ONE.shiftLeft(bits1), op_or, num);
      } // align number on 30k+1 boundary


      num.dAddOffset(31 - num.mod(THIRTY).byteValue(), 0);
      return num;
    }
    /**
     * Returns the required number of Miller-Rabin tests to generate a
     * prime with an error probability of (1/2)^80.
     *
     * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
     *
     * @param bits the bit size.
     *
     * @return the required number of iterations.
     */


    function getMillerRabinTests(bits) {
      if (bits <= 100) return 27;
      if (bits <= 150) return 18;
      if (bits <= 200) return 15;
      if (bits <= 250) return 12;
      if (bits <= 300) return 9;
      if (bits <= 350) return 8;
      if (bits <= 400) return 7;
      if (bits <= 500) return 6;
      if (bits <= 600) return 5;
      if (bits <= 800) return 4;
      if (bits <= 1250) return 3;
      return 2;
    }
  })();
  /***/

},
/* 229 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /**
    * A javascript implementation of a cryptographically-secure
    * Pseudo Random Number Generator (PRNG). The Fortuna algorithm is followed
    * here though the use of SHA-256 is not enforced; when generating an
    * a PRNG context, the hashing algorithm and block cipher used for
    * the generator are specified via a plugin.
    *
    * @author Dave Longley
    *
    * Copyright (c) 2010-2014 Digital Bazaar, Inc.
    */
    var forge = __webpack_require__(6);

    __webpack_require__(8);

    var _crypto = null;

    if (forge.util.isNodejs && !forge.options.usePureJavaScript && !process.versions['node-webkit']) {
      _crypto = __webpack_require__(251);
    }
    /* PRNG API */


    var prng = module.exports = forge.prng = forge.prng || {};
    /**
     * Creates a new PRNG context.
     *
     * A PRNG plugin must be passed in that will provide:
     *
     * 1. A function that initializes the key and seed of a PRNG context. It
     *   will be given a 16 byte key and a 16 byte seed. Any key expansion
     *   or transformation of the seed from a byte string into an array of
     *   integers (or similar) should be performed.
     * 2. The cryptographic function used by the generator. It takes a key and
     *   a seed.
     * 3. A seed increment function. It takes the seed and returns seed + 1.
     * 4. An api to create a message digest.
     *
     * For an example, see random.js.
     *
     * @param plugin the PRNG plugin to use.
     */

    prng.create = function (plugin) {
      var ctx = {
        plugin: plugin,
        key: null,
        seed: null,
        time: null,
        // number of reseeds so far
        reseeds: 0,
        // amount of data generated so far
        generated: 0,
        // no initial key bytes
        keyBytes: ''
      }; // create 32 entropy pools (each is a message digest)

      var md = plugin.md;
      var pools = new Array(32);

      for (var i = 0; i < 32; ++i) {
        pools[i] = md.create();
      }

      ctx.pools = pools; // entropy pools are written to cyclically, starting at index 0

      ctx.pool = 0;
      /**
       * Generates random bytes. The bytes may be generated synchronously or
       * asynchronously. Web workers must use the asynchronous interface or
       * else the behavior is undefined.
       *
       * @param count the number of random bytes to generate.
       * @param [callback(err, bytes)] called once the operation completes.
       *
       * @return count random bytes as a string.
       */

      ctx.generate = function (count, callback) {
        // do synchronously
        if (!callback) {
          return ctx.generateSync(count);
        } // simple generator using counter-based CBC


        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        var b = forge.util.createBuffer(); // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generate` call

        ctx.key = null;
        generate();

        function generate(err) {
          if (err) {
            return callback(err);
          } // sufficient bytes generated


          if (b.length() >= count) {
            return callback(null, b.getBytes(count));
          } // if amount of data generated is greater than 1 MiB, trigger reseed


          if (ctx.generated > 0xfffff) {
            ctx.key = null;
          }

          if (ctx.key === null) {
            // prevent stack overflow
            return forge.util.nextTick(function () {
              _reseed(generate);
            });
          } // generate the random bytes


          var bytes = cipher(ctx.key, ctx.seed);
          ctx.generated += bytes.length;
          b.putBytes(bytes); // generate bytes for a new key and seed

          ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
          ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
          forge.util.setImmediate(generate);
        }
      };
      /**
       * Generates random bytes synchronously.
       *
       * @param count the number of random bytes to generate.
       *
       * @return count random bytes as a string.
       */


      ctx.generateSync = function (count) {
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed; // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generateSync` call

        ctx.key = null;
        var b = forge.util.createBuffer();

        while (b.length() < count) {
          // if amount of data generated is greater than 1 MiB, trigger reseed
          if (ctx.generated > 0xfffff) {
            ctx.key = null;
          }

          if (ctx.key === null) {
            _reseedSync();
          } // generate the random bytes


          var bytes = cipher(ctx.key, ctx.seed);
          ctx.generated += bytes.length;
          b.putBytes(bytes); // generate bytes for a new key and seed

          ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
          ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
        }

        return b.getBytes(count);
      };
      /**
       * Private function that asynchronously reseeds a generator.
       *
       * @param callback(err) called once the operation completes.
       */


      function _reseed(callback) {
        if (ctx.pools[0].messageLength >= 32) {
          _seed();

          return callback();
        } // not enough seed data...


        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.seedFile(needed, function (err, bytes) {
          if (err) {
            return callback(err);
          }

          ctx.collect(bytes);

          _seed();

          callback();
        });
      }
      /**
       * Private function that synchronously reseeds a generator.
       */


      function _reseedSync() {
        if (ctx.pools[0].messageLength >= 32) {
          return _seed();
        } // not enough seed data...


        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.collect(ctx.seedFileSync(needed));

        _seed();
      }
      /**
       * Private function that seeds a generator once enough bytes are available.
       */


      function _seed() {
        // update reseed count
        ctx.reseeds = ctx.reseeds === 0xffffffff ? 0 : ctx.reseeds + 1; // goal is to update `key` via:
        // key = hash(key + s)
        //   where 's' is all collected entropy from selected pools, then...
        // create a plugin-based message digest

        var md = ctx.plugin.md.create(); // consume current key bytes

        md.update(ctx.keyBytes); // digest the entropy of pools whose index k meet the
        // condition 'n mod 2^k == 0' where n is the number of reseeds

        var _2powK = 1;

        for (var k = 0; k < 32; ++k) {
          if (ctx.reseeds % _2powK === 0) {
            md.update(ctx.pools[k].digest().getBytes());
            ctx.pools[k].start();
          }

          _2powK = _2powK << 1;
        } // get digest for key bytes


        ctx.keyBytes = md.digest().getBytes(); // paranoid deviation from Fortuna:
        // update `seed` via `seed = hash(key)`
        // instead of initializing to zero once and only
        // ever incrementing it

        md.start();
        md.update(ctx.keyBytes);
        var seedBytes = md.digest().getBytes(); // update state

        ctx.key = ctx.plugin.formatKey(ctx.keyBytes);
        ctx.seed = ctx.plugin.formatSeed(seedBytes);
        ctx.generated = 0;
      }
      /**
       * The built-in default seedFile. This seedFile is used when entropy
       * is needed immediately.
       *
       * @param needed the number of bytes that are needed.
       *
       * @return the random bytes.
       */


      function defaultSeedFile(needed) {
        // use window.crypto.getRandomValues strong source of entropy if available
        var getRandomValues = null;

        if (typeof window !== 'undefined') {
          var _crypto = window.crypto || window.msCrypto;

          if (_crypto && _crypto.getRandomValues) {
            getRandomValues = function getRandomValues(arr) {
              return _crypto.getRandomValues(arr);
            };
          }
        }

        var b = forge.util.createBuffer();

        if (getRandomValues) {
          while (b.length() < needed) {
            // max byte length is 65536 before QuotaExceededError is thrown
            // http://www.w3.org/TR/WebCryptoAPI/#RandomSource-method-getRandomValues
            var count = Math.max(1, Math.min(needed - b.length(), 65536) / 4);
            var entropy = new Uint32Array(Math.floor(count));

            try {
              getRandomValues(entropy);

              for (var i = 0; i < entropy.length; ++i) {
                b.putInt32(entropy[i]);
              }
            } catch (e) {
              /* only ignore QuotaExceededError */
              if (!(typeof QuotaExceededError !== 'undefined' && e instanceof QuotaExceededError)) {
                throw e;
              }
            }
          }
        } // be sad and add some weak random data


        if (b.length() < needed) {
          /* Draws from Park-Miller "minimal standard" 31 bit PRNG,
          implemented with David G. Carta's optimization: with 32 bit math
          and without division (Public Domain). */
          var hi, lo, next;
          var seed = Math.floor(Math.random() * 0x010000);

          while (b.length() < needed) {
            lo = 16807 * (seed & 0xFFFF);
            hi = 16807 * (seed >> 16);
            lo += (hi & 0x7FFF) << 16;
            lo += hi >> 15;
            lo = (lo & 0x7FFFFFFF) + (lo >> 31);
            seed = lo & 0xFFFFFFFF; // consume lower 3 bytes of seed

            for (var i = 0; i < 3; ++i) {
              // throw in more pseudo random
              next = seed >>> (i << 3);
              next ^= Math.floor(Math.random() * 0x0100);
              b.putByte(String.fromCharCode(next & 0xFF));
            }
          }
        }

        return b.getBytes(needed);
      } // initialize seed file APIs


      if (_crypto) {
        // use nodejs async API
        ctx.seedFile = function (needed, callback) {
          _crypto.randomBytes(needed, function (err, bytes) {
            if (err) {
              return callback(err);
            }

            callback(null, bytes.toString());
          });
        }; // use nodejs sync API


        ctx.seedFileSync = function (needed) {
          return _crypto.randomBytes(needed).toString();
        };
      } else {
        ctx.seedFile = function (needed, callback) {
          try {
            callback(null, defaultSeedFile(needed));
          } catch (e) {
            callback(e);
          }
        };

        ctx.seedFileSync = defaultSeedFile;
      }
      /**
       * Adds entropy to a prng ctx's accumulator.
       *
       * @param bytes the bytes of entropy as a string.
       */


      ctx.collect = function (bytes) {
        // iterate over pools distributing entropy cyclically
        var count = bytes.length;

        for (var i = 0; i < count; ++i) {
          ctx.pools[ctx.pool].update(bytes.substr(i, 1));
          ctx.pool = ctx.pool === 31 ? 0 : ctx.pool + 1;
        }
      };
      /**
       * Collects an integer of n bits.
       *
       * @param i the integer entropy.
       * @param n the number of bits in the integer.
       */


      ctx.collectInt = function (i, n) {
        var bytes = '';

        for (var x = 0; x < n; x += 8) {
          bytes += String.fromCharCode(i >> x & 0xFF);
        }

        ctx.collect(bytes);
      };
      /**
       * Registers a Web Worker to receive immediate entropy from the main thread.
       * This method is required until Web Workers can access the native crypto
       * API. This method should be called twice for each created worker, once in
       * the main thread, and once in the worker itself.
       *
       * @param worker the worker to register.
       */


      ctx.registerWorker = function (worker) {
        // worker receives random bytes
        if (worker === self) {
          ctx.seedFile = function (needed, callback) {
            function listener(e) {
              var data = e.data;

              if (data.forge && data.forge.prng) {
                self.removeEventListener('message', listener);
                callback(data.forge.prng.err, data.forge.prng.bytes);
              }
            }

            self.addEventListener('message', listener);
            self.postMessage({
              forge: {
                prng: {
                  needed: needed
                }
              }
            });
          };
        } else {
          // main thread sends random bytes upon request
          var listener = function listener(e) {
            var data = e.data;

            if (data.forge && data.forge.prng) {
              ctx.seedFile(data.forge.prng.needed, function (err, bytes) {
                worker.postMessage({
                  forge: {
                    prng: {
                      err: err,
                      bytes: bytes
                    }
                  }
                });
              });
            }
          }; // TODO: do we need to remove the event listener when the worker dies?


          worker.addEventListener('message', listener);
        }
      };

      return ctx;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(16));
  /***/
},
/* 230 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Secure Hash Algorithm with 256-bit digest (SHA-256) implementation.
   *
   * See FIPS 180-2 for details.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2015 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(60);

  __webpack_require__(8);

  var sha256 = module.exports = forge.sha256 = forge.sha256 || {};
  forge.md.sha256 = forge.md.algorithms.sha256 = sha256;
  /**
   * Creates a SHA-256 message digest object.
   *
   * @return a message digest object.
   */

  sha256.create = function () {
    // do initialization as necessary
    if (!_initialized) {
      _init();
    } // SHA-256 state contains eight 32-bit integers


    var _state = null; // input buffer

    var _input = forge.util.createBuffer(); // used for word storage


    var _w = new Array(64); // message digest object


    var md = {
      algorithm: 'sha256',
      blockLength: 64,
      digestLength: 32,
      // 56-bit length of message so far (does not including padding)
      messageLength: 0,
      // true message length
      fullMessageLength: null,
      // size of message length in bytes
      messageLengthSize: 8
    };
    /**
     * Starts the digest.
     *
     * @return this digest object.
     */

    md.start = function () {
      // up to 56-bit message length for convenience
      md.messageLength = 0; // full message length (set md.messageLength64 for backwards-compatibility)

      md.fullMessageLength = md.messageLength64 = [];
      var int32s = md.messageLengthSize / 4;

      for (var i = 0; i < int32s; ++i) {
        md.fullMessageLength.push(0);
      }

      _input = forge.util.createBuffer();
      _state = {
        h0: 0x6A09E667,
        h1: 0xBB67AE85,
        h2: 0x3C6EF372,
        h3: 0xA54FF53A,
        h4: 0x510E527F,
        h5: 0x9B05688C,
        h6: 0x1F83D9AB,
        h7: 0x5BE0CD19
      };
      return md;
    }; // start digest automatically for first time


    md.start();
    /**
     * Updates the digest with the given message input. The given input can
     * treated as raw input (no encoding will be applied) or an encoding of
     * 'utf8' maybe given to encode the input using UTF-8.
     *
     * @param msg the message input to update with.
     * @param encoding the encoding to use (default: 'raw', other: 'utf8').
     *
     * @return this digest object.
     */

    md.update = function (msg, encoding) {
      if (encoding === 'utf8') {
        msg = forge.util.encodeUtf8(msg);
      } // update message length


      var len = msg.length;
      md.messageLength += len;
      len = [len / 0x100000000 >>> 0, len >>> 0];

      for (var i = md.fullMessageLength.length - 1; i >= 0; --i) {
        md.fullMessageLength[i] += len[1];
        len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
        md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
        len[0] = len[1] / 0x100000000 >>> 0;
      } // add bytes to input buffer


      _input.putBytes(msg); // process bytes


      _update(_state, _w, _input); // compact input buffer every 2K or if empty


      if (_input.read > 2048 || _input.length() === 0) {
        _input.compact();
      }

      return md;
    };
    /**
     * Produces the digest.
     *
     * @return a byte buffer containing the digest value.
     */


    md.digest = function () {
      /* Note: Here we copy the remaining bytes in the input buffer and
      add the appropriate SHA-256 padding. Then we do the final update
      on a copy of the state so that if the user wants to get
      intermediate digests they can do so. */

      /* Determine the number of bytes that must be added to the message
      to ensure its length is congruent to 448 mod 512. In other words,
      the data to be digested must be a multiple of 512 bits (or 128 bytes).
      This data includes the message, some padding, and the length of the
      message. Since the length of the message will be encoded as 8 bytes (64
      bits), that means that the last segment of the data must have 56 bytes
      (448 bits) of message and padding. Therefore, the length of the message
      plus the padding must be congruent to 448 mod 512 because
      512 - 128 = 448.
       In order to fill up the message length it must be filled with
      padding that begins with 1 bit followed by all 0 bits. Padding
      must *always* be present, so if the message length is already
      congruent to 448 mod 512, then 512 padding bits must be added. */
      var finalBlock = forge.util.createBuffer();
      finalBlock.putBytes(_input.bytes()); // compute remaining size to be digested (include message length size)

      var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize; // add padding for overflow blockSize - overflow
      // _padding starts with 1 byte with first bit is set (byte value 128), then
      // there may be up to (blockSize - 1) other pad bytes

      var overflow = remaining & md.blockLength - 1;
      finalBlock.putBytes(_padding.substr(0, md.blockLength - overflow)); // serialize message length in bits in big-endian order; since length
      // is stored in bytes we multiply by 8 and add carry from next int

      var next, carry;
      var bits = md.fullMessageLength[0] * 8;

      for (var i = 0; i < md.fullMessageLength.length - 1; ++i) {
        next = md.fullMessageLength[i + 1] * 8;
        carry = next / 0x100000000 >>> 0;
        bits += carry;
        finalBlock.putInt32(bits >>> 0);
        bits = next >>> 0;
      }

      finalBlock.putInt32(bits);
      var s2 = {
        h0: _state.h0,
        h1: _state.h1,
        h2: _state.h2,
        h3: _state.h3,
        h4: _state.h4,
        h5: _state.h5,
        h6: _state.h6,
        h7: _state.h7
      };

      _update(s2, _w, finalBlock);

      var rval = forge.util.createBuffer();
      rval.putInt32(s2.h0);
      rval.putInt32(s2.h1);
      rval.putInt32(s2.h2);
      rval.putInt32(s2.h3);
      rval.putInt32(s2.h4);
      rval.putInt32(s2.h5);
      rval.putInt32(s2.h6);
      rval.putInt32(s2.h7);
      return rval;
    };

    return md;
  }; // sha-256 padding bytes not initialized yet


  var _padding = null;
  var _initialized = false; // table of constants

  var _k = null;
  /**
   * Initializes the constant tables.
   */

  function _init() {
    // create padding
    _padding = String.fromCharCode(128);
    _padding += forge.util.fillString(String.fromCharCode(0x00), 64); // create K table for SHA-256

    _k = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2]; // now initialized

    _initialized = true;
  }
  /**
   * Updates a SHA-256 state with the given byte buffer.
   *
   * @param s the SHA-256 state to update.
   * @param w the array to use to store words.
   * @param bytes the byte buffer to update with.
   */


  function _update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t1, t2, s0, s1, ch, maj, i, a, b, c, d, e, f, g, h;
    var len = bytes.length();

    while (len >= 64) {
      // the w array will be populated with sixteen 32-bit big-endian words
      // and then extended into 64 32-bit words according to SHA-256
      for (i = 0; i < 16; ++i) {
        w[i] = bytes.getInt32();
      }

      for (; i < 64; ++i) {
        // XOR word 2 words ago rot right 17, rot right 19, shft right 10
        t1 = w[i - 2];
        t1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10; // XOR word 15 words ago rot right 7, rot right 18, shft right 3

        t2 = w[i - 15];
        t2 = (t2 >>> 7 | t2 << 25) ^ (t2 >>> 18 | t2 << 14) ^ t2 >>> 3; // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^32

        w[i] = t1 + w[i - 7] + t2 + w[i - 16] | 0;
      } // initialize hash value for this chunk


      a = s.h0;
      b = s.h1;
      c = s.h2;
      d = s.h3;
      e = s.h4;
      f = s.h5;
      g = s.h6;
      h = s.h7; // round function

      for (i = 0; i < 64; ++i) {
        // Sum1(e)
        s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7); // Ch(e, f, g) (optimized the same way as SHA-1)

        ch = g ^ e & (f ^ g); // Sum0(a)

        s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10); // Maj(a, b, c) (optimized the same way as SHA-1)

        maj = a & b | c & (a ^ b); // main algorithm

        t1 = h + s1 + ch + _k[i] + w[i];
        t2 = s0 + maj;
        h = g;
        g = f;
        f = e; // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
        // can't truncate with `| 0`

        e = d + t1 >>> 0;
        d = c;
        c = b;
        b = a; // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
        // can't truncate with `| 0`

        a = t1 + t2 >>> 0;
      } // update hash state


      s.h0 = s.h0 + a | 0;
      s.h1 = s.h1 + b | 0;
      s.h2 = s.h2 + c | 0;
      s.h3 = s.h3 + d | 0;
      s.h4 = s.h4 + e | 0;
      s.h5 = s.h5 + f | 0;
      s.h6 = s.h6 + g | 0;
      s.h7 = s.h7 + h | 0;
      len -= 64;
    }
  }
  /***/

},
/* 231 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/concat.js - Concat Key Derivation
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var CONSTANTS = __webpack_require__(43),
        sha = __webpack_require__(102);

    function concatDeriveFn(name) {
      name = name.replace("CONCAT-", ""); // NOTE: no nodejs/webcrypto/fallback model, since ConcatKDF is
      //       implemented using the SHA algorithms

      var fn = function fn(key, props) {
        props = props || {};
        var keyLen = props.length,
            hashLen = CONSTANTS.HASHLENGTH[name];

        if (!keyLen) {
          return Promise.reject(new Error("invalid key length"));
        } // setup otherInfo


        if (!props.otherInfo) {
          return Promise.reject(new Error("invalid otherInfo"));
        }

        var otherInfo = props.otherInfo;
        var op = sha[name].digest;
        var N = Math.ceil(keyLen / hashLen),
            idx = 0,
            okm = [];

        function step() {
          if (N === idx++) {
            return Buffer.concat(okm).slice(0, keyLen);
          }

          var T = Buffer.alloc(4 + key.length + otherInfo.length);
          T.writeUInt32BE(idx, 0);
          key.copy(T, 4);
          otherInfo.copy(T, 4 + key.length);
          return op(T).then(function (result) {
            okm.push(result);
            return step();
          });
        }

        return step();
      };

      return fn;
    } // Public API
    // * [name].derive


    var concat = {};
    ["CONCAT-SHA-1", "CONCAT-SHA-256", "CONCAT-SHA-384", "CONCAT-SHA-512"].forEach(function (name) {
      concat[name] = {
        derive: concatDeriveFn(name)
      };
    });
    module.exports = concat;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 232 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/hkdf.js - HMAC-based Extract-and-Expand Key Derivation
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var CONSTANTS = __webpack_require__(43),
        hmac = __webpack_require__(152);

    function hkdfDeriveFn(name) {
      var hash = name.replace("HKDF-", ""),
          op = name.replace("HKDF-SHA-", "HS"); // NOTE: no nodejs/webcrypto/fallback model, since this HKDF is
      //       implemented using the HMAC algorithms

      var fn = function fn(key, props) {
        var hashLen = CONSTANTS.HASHLENGTH[hash] / 8;

        if ("string" === typeof op) {
          op = hmac[op].sign;
        } // prepare options


        props = props || {};
        var salt = props.salt;

        if (!salt || 0 === salt.length) {
          salt = Buffer.alloc(hashLen);
        }

        var info = props.info || Buffer.alloc(0);
        var keyLen = props.length || hashLen;
        var promise; // Setup Expansion

        var N = Math.ceil(keyLen / hashLen),
            okm = [],
            idx = 0;

        function expand(key, T) {
          if (N === idx++) {
            return Buffer.concat(okm).slice(0, keyLen);
          }

          if (!T) {
            T = Buffer.alloc(0);
          }

          T = Buffer.concat([T, info, Buffer.from([idx])]);
          T = op(key, T);
          T = T.then(function (result) {
            T = result.mac;
            okm.push(T);
            return expand(key, T);
          });
          return T;
        } // Step 1: Extract


        promise = op(salt, key, {
          length: salt.length * 8
        });
        promise = promise.then(function (result) {
          // Step 2: Expand
          return expand(result.mac);
        });
        return promise;
      };

      return fn;
    } // Public API
    // * [name].derive


    var hkdf = {};
    ["HKDF-SHA-1", "HKDF-SHA-256", "HKDF-SHA-384", "HKDF-SHA-512"].forEach(function (name) {
      hkdf[name] = {
        derive: hkdfDeriveFn(name)
      };
    });
    module.exports = hkdf;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 233 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * deps/ciphermodes/gcm/helpers.js - AES-GCM Helper Functions
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var Long = __webpack_require__(141),
        fill = __webpack_require__(496),
        pack = __webpack_require__(103);

    var E1 = 0xe1000000,
        E1B = 0xe1,
        E1L = new Long(E1 >> 8);

    function generateLookup() {
      var lookup = [];

      for (var c = 0; c < 256; ++c) {
        var v = 0;

        for (var i = 7; i >= 0; --i) {
          if ((c & 1 << i) !== 0) {
            v ^= E1 >>> 7 - i;
          }
        }

        lookup.push(v);
      }

      return lookup;
    }

    var helpers = module.exports = {
      // ### Constants
      E1: E1,
      E1B: E1B,
      E1L: E1L,
      LOOKUP: generateLookup(),
      // ### Array Helpers
      arrayCopy: function arrayCopy(src, srcPos, dest, destPos, length) {
        // Start by checking for negatives since arrays in JS auto-expand
        if (srcPos < 0 || destPos < 0 || length < 0) {
          throw new TypeError("Invalid input.");
        }

        if (dest instanceof Uint8Array) {
          // Check for overflow if dest is a typed-array
          if (destPos >= dest.length || destPos + length > dest.length) {
            throw new TypeError("Invalid input.");
          }

          if (srcPos !== 0 || length < src.length) {
            if (src instanceof Uint8Array) {
              src = src.subarray(srcPos, srcPos + length);
            } else {
              src = src.slice(srcPos, srcPos + length);
            }
          }

          dest.set(src, destPos);
        } else {
          for (var i = 0; i < length; ++i) {
            dest[destPos + i] = src[srcPos + i];
          }
        }
      },
      arrayEqual: function arrayEqual(a1, a2) {
        a1 = a1 || [];
        a2 = a2 || [];
        var len = Math.min(a1.length, a2.length),
            result = a1.length === a2.length;

        for (var idx = 0; idx < len; idx++) {
          result = result && "undefined" !== typeof a1[idx] && "undefined" !== typeof a2[idx] && a1[idx] === a2[idx];
        }

        return result;
      },
      // ### Conversions
      asBytes: function asBytes(x, z) {
        switch (arguments.length) {
          case 1:
            z = Buffer.alloc(16);
            pack.intToBigEndian(x, z, 0);
            return z;

          case 2:
            pack.intToBigEndian(x, z, 0);
            break;

          default:
            throw new TypeError("Expected 1 or 2 arguments.");
        }
      },
      asInts: function asInts(x, z) {
        switch (arguments.length) {
          case 1:
            z = [];
            fill(z, 0, 0, 4);
            pack.bigEndianToInt(x, 0, z);
            return z;

          case 2:
            pack.bigEndianToInt(x, 0, z);
            break;

          default:
            throw new TypeError("Expected 1 or 2 arguments.");
        }
      },
      oneAsInts: function oneAsInts() {
        var tmp = [];

        for (var c = 0; c < 4; ++c) {
          tmp.push(1 << 31);
        }

        return tmp;
      },
      // ## Bit-wise
      shiftRight: function shiftRight(x, z) {
        var b, c;

        switch (arguments.length) {
          case 1:
            b = x[0];
            x[0] = b >>> 1;
            c = b << 31;
            b = x[1];
            x[1] = b >>> 1 | c;
            c = b << 31;
            b = x[2];
            x[2] = b >>> 1 | c;
            c = b << 31;
            b = x[3];
            x[3] = b >>> 1 | c;
            return b << 31 & 0xffffffff;

          case 2:
            b = x[0];
            z[0] = b >>> 1;
            c = b << 31;
            b = x[1];
            z[1] = b >>> 1 | c;
            c = b << 31;
            b = x[2];
            z[2] = b >>> 1 | c;
            c = b << 31;
            b = x[3];
            z[3] = b >>> 1 | c;
            return b << 31 & 0xffffffff;

          default:
            throw new TypeError("Expected 1 or 2 arguments.");
        }
      },
      shiftRightN: function shiftRightN(x, n, z) {
        var nInv, b, c;

        switch (arguments.length) {
          case 2:
            b = x[0];
            nInv = 32 - n;
            x[0] = b >>> n;
            c = b << nInv;
            b = x[1];
            x[1] = b >>> n | c;
            c = b << nInv;
            b = x[2];
            x[2] = b >>> n | c;
            c = b << nInv;
            b = x[3];
            x[3] = b >>> n | c;
            return b << nInv;

          case 3:
            b = x[0];
            nInv = 32 - n;
            z[0] = b >>> n;
            c = b << nInv;
            b = x[1];
            z[1] = b >>> n | c;
            c = b << nInv;
            b = x[2];
            z[2] = b >>> n | c;
            c = b << nInv;
            b = x[3];
            z[3] = b >>> n | c;
            return b << nInv;

          default:
            throw new TypeError("Expected 2 or 3 arguments.");
        }
      },
      xor: function xor(x, y, z) {
        switch (arguments.length) {
          case 2:
            x[0] ^= y[0];
            x[1] ^= y[1];
            x[2] ^= y[2];
            x[3] ^= y[3];
            break;

          case 3:
            z[0] = x[0] ^ y[0];
            z[1] = x[1] ^ y[1];
            z[2] = x[2] ^ y[2];
            z[3] = x[3] ^ y[3];
            break;

          default:
            throw new TypeError("Expected 2 or 3 arguments.");
        }
      },
      multiply: function multiply(x, y) {
        var r0 = x.slice();
        var r1 = [];

        for (var i = 0; i < 4; ++i) {
          var bits = y[i];

          for (var j = 31; j >= 0; --j) {
            if ((bits & 1 << j) !== 0) {
              helpers.xor(r1, r0);
            }

            if (helpers.shiftRight(r0) !== 0) {
              r0[0] ^= helpers.E1;
            }
          }
        }

        helpers.arrayCopy(r1, 0, x, 0, 4);
      },
      multiplyP: function multiplyP(x, y) {
        switch (arguments.length) {
          case 1:
            if (helpers.shiftRight(x) !== 0) {
              x[0] ^= helpers.E1;
            }

            break;

          case 2:
            if (helpers.shiftRight(x, y) !== 0) {
              y[0] ^= helpers.E1;
            }

            break;

          default:
            throw new TypeError("Expected 1 or 2 arguments.");
        }
      },
      multiplyP8: function multiplyP8(x, y) {
        var c;

        switch (arguments.length) {
          case 1:
            c = helpers.shiftRightN(x, 8);
            x[0] ^= helpers.LOOKUP[c >>> 24];
            break;

          case 2:
            c = helpers.shiftRightN(x, 8, y);
            y[0] ^= helpers.LOOKUP[c >>> 24];
            break;

          default:
            throw new TypeError("Expected 1 or 2 arguments.");
        }
      }
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 234 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /**
    * deps/ecc/index.js - Elliptic Curve Entry Point
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var forge = __webpack_require__(14),
        BigInteger = forge.jsbn.BigInteger,
        ec = __webpack_require__(235),
        CURVES = __webpack_require__(557); // ### Helpers


    function hex2bn(s) {
      return new BigInteger(s, 16);
    }

    function bn2bin(bn, len) {
      if (!len) {
        len = Math.ceil(bn.bitLength() / 8);
      }

      len = len * 2;
      var hex = bn.toString(16); // truncate-left if too large

      hex = hex.substring(Math.max(hex.length - len, 0)); // pad-left if too small

      while (len > hex.length) {
        hex = "0" + hex;
      }

      return Buffer.from(hex, "hex");
    }

    function bin2bn(s) {
      if ("string" === typeof s) {
        s = Buffer.from(s, "binary");
      }

      return hex2bn(s.toString("hex"));
    }

    function keySizeBytes(params) {
      return Math.ceil(params.getN().bitLength() / 8);
    }

    function namedCurve(curve) {
      var params = CURVES[curve];

      if (!params) {
        throw new TypeError("unsupported named curve: " + curve);
      }

      return params;
    }

    function normalizeEcdsa(params, md) {
      var log2n = params.getN().bitLength(),
          mdLen = md.length * 8;
      var e = bin2bn(md);

      if (log2n < mdLen) {
        e = e.shiftRight(mdLen - log2n);
      }

      return e;
    } // ### EC Public Key

    /**
     *
     * @param {String} curve The named curve
     * @param {BigInteger} x The X coordinate
     * @param {BigInteger} y The Y coordinate
     */


    function ECPublicKey(curve, x, y) {
      var params = namedCurve(curve),
          c = params.getCurve();
      var key = new ec.ECPointFp(c, c.fromBigInteger(x), c.fromBigInteger(y));
      this.curve = curve;
      this.params = params;
      this.point = key;
      var size = keySizeBytes(params);
      this.x = bn2bin(x, size);
      this.y = bn2bin(y, size);
    } // basics


    ECPublicKey.prototype.isValid = function () {
      return this.params.curve.contains(this.point);
    }; // ECDSA


    ECPublicKey.prototype.verify = function (md, sig) {
      var N = this.params.getN(),
          G = this.params.getG(); // prepare and validate (r, s)

      var r = bin2bn(sig.r),
          s = bin2bn(sig.s);

      if (r.compareTo(BigInteger.ONE) < 0 || r.compareTo(N) >= 0) {
        return false;
      }

      if (s.compareTo(BigInteger.ONE) < 0 || r.compareTo(N) >= 0) {
        return false;
      } // normalize input


      var e = normalizeEcdsa(this.params, md); // verify (r, s)

      var w = s.modInverse(N),
          u1 = e.multiply(w).mod(N),
          u2 = r.multiply(w).mod(N);
      var v = G.multiplyTwo(u1, this.point, u2).getX().toBigInteger();
      v = v.mod(N);
      return v.equals(r);
    }; // ### EC Private Key

    /**
     * @param {String} curve The named curve
     * @param {Buffer} key The private key value
     */


    function ECPrivateKey(curve, key) {
      var params = namedCurve(curve);
      this.curve = curve;
      this.params = params;
      var size = keySizeBytes(params);
      this.d = bn2bin(key, size);
    }

    ECPrivateKey.prototype.toPublicKey = function () {
      var d = bin2bn(this.d);
      var P = this.params.getG().multiply(d);
      return new ECPublicKey(this.curve, P.getX().toBigInteger(), P.getY().toBigInteger());
    }; // ECDSA


    ECPrivateKey.prototype.sign = function (md) {
      var keysize = keySizeBytes(this.params),
          N = this.params.getN(),
          G = this.params.getG(),
          e = normalizeEcdsa(this.params, md),
          d = bin2bn(this.d);
      var r, s;
      var k, x1, z;

      do {
        do {
          // determine random nonce
          do {
            k = bin2bn(forge.random.getBytes(keysize));
          } while (k.equals(BigInteger.ZERO) || k.compareTo(N) >= 0); // (x1, y1) = k * G


          x1 = G.multiply(k).getX().toBigInteger(); // r = x1 mod N

          r = x1.mod(N);
        } while (r.equals(BigInteger.ZERO)); // s = (k^-1 * (e + r * d)) mod N


        z = d.multiply(r);
        z = e.add(z);
        s = k.modInverse(N).multiply(z).mod(N);
      } while (s.equals(BigInteger.ONE)); // convert (r, s) to bytes


      var len = keySizeBytes(this.params);
      r = bn2bin(r, len);
      s = bn2bin(s, len);
      return {
        r: r,
        s: s
      };
    }; // basics


    ECPrivateKey.prototype.isValid = function () {
      var d = bin2bn(this.d),
          n1 = this.params.getN().subtract(BigInteger.ONE);
      return d.compareTo(BigInteger.ONE) >= 0 && d.compareTo(n1) < 0;
    }; // ECDH


    ECPrivateKey.prototype.computeSecret = function (pubkey) {
      var d = bin2bn(this.d);
      var S = pubkey.point.multiply(d).getX().toBigInteger();
      S = bn2bin(S, keySizeBytes(this.params));
      return S;
    }; // ### Public API


    exports.generateKeyPair = function (curve) {
      var params = namedCurve(curve),
          n = params.getN(); // generate random within range [1, N-1)

      var r = forge.random.getBytes(keySizeBytes(params));
      r = bin2bn(r);
      var n1 = n.subtract(BigInteger.ONE);
      var d = r.mod(n1).add(BigInteger.ONE);
      var privkey = new ECPrivateKey(curve, d),
          pubkey = privkey.toPublicKey();
      return {
        "private": privkey,
        "public": pubkey
      };
    };

    exports.asPublicKey = function (curve, x, y) {
      if ("string" === typeof x) {
        x = hex2bn(x);
      } else if (Buffer.isBuffer(x)) {
        x = bin2bn(x);
      }

      if ("string" === typeof y) {
        y = hex2bn(y);
      } else if (Buffer.isBuffer(y)) {
        y = bin2bn(y);
      }

      var pubkey = new ECPublicKey(curve, x, y);
      return pubkey;
    };

    exports.asPrivateKey = function (curve, d) {
      // Elaborate way to get to a Buffer from a (String|Buffer|BigInteger)
      if ("string" === typeof d) {
        d = hex2bn(d);
      } else if (Buffer.isBuffer(d)) {
        d = bin2bn(d);
      }

      var privkey = new ECPrivateKey(curve, d);
      return privkey;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 235 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * deps/ecc/math.js - Elliptic Curve Math
   * Original Copyright (c) 2003-2005  Tom Wu.
   * Modifications Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
   *
   * Ported from Tom Wu, which is ported from BouncyCastle
   * Modified to reuse existing external NPM modules, restricted to the
   * NIST//SECG/X9.62 prime curves only, and formatted to match project
   * coding styles.
   */
  // Basic Javascript Elliptic Curve implementation
  // Ported loosely from BouncyCastle's Java EC code
  // Only Fp curves implemented for now

  var BigInteger = __webpack_require__(14).jsbn.BigInteger; // ----------------
  // Helpers


  function nbi() {
    return new BigInteger(null);
  } // ----------------
  // Barrett modular reduction
  // constructor


  function Barrett(m) {
    // setup Barrett
    this.r2 = nbi();
    this.q3 = nbi();
    BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
    this.mu = this.r2.divide(m);
    this.m = m;
  }

  function barrettConvert(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);else if (x.compareTo(this.m) < 0) return x;else {
      var r = nbi();
      x.copyTo(r);
      this.reduce(r);
      return r;
    }
  }

  function barrettRevert(x) {
    return x;
  } // x = x mod m (HAC 14.42)


  function barrettReduce(x) {
    x.drShiftTo(this.m.t - 1, this.r2);

    if (x.t > this.m.t + 1) {
      x.t = this.m.t + 1;
      x.clamp();
    }

    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);

    while (x.compareTo(this.r2) < 0) {
      x.dAddOffset(1, this.m.t + 1);
    }

    x.subTo(this.r2, x);

    while (x.compareTo(this.m) >= 0) {
      x.subTo(this.m, x);
    }
  } // r = x^2 mod m; x != r


  function barrettSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
  } // r = x*y mod m; x,y != r


  function barrettMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
  }

  Barrett.prototype.convert = barrettConvert;
  Barrett.prototype.revert = barrettRevert;
  Barrett.prototype.reduce = barrettReduce;
  Barrett.prototype.mulTo = barrettMulTo;
  Barrett.prototype.sqrTo = barrettSqrTo; // ----------------
  // ECFieldElementFp
  // constructor

  function ECFieldElementFp(q, x) {
    this.x = x; // TODO if(x.compareTo(q) >= 0) error

    this.p = q;
  }

  function feFpEquals(other) {
    if (other === this) {
      return true;
    }

    return this.p.equals(other.p) && this.x.equals(other.x);
  }

  function feFpToBigInteger() {
    return this.x;
  }

  function feFpNegate() {
    return new ECFieldElementFp(this.p, this.x.negate().mod(this.p));
  }

  function feFpAdd(b) {
    return new ECFieldElementFp(this.p, this.x.add(b.toBigInteger()).mod(this.p));
  }

  function feFpSubtract(b) {
    return new ECFieldElementFp(this.p, this.x.subtract(b.toBigInteger()).mod(this.p));
  }

  function feFpMultiply(b) {
    return new ECFieldElementFp(this.p, this.x.multiply(b.toBigInteger()).mod(this.p));
  }

  function feFpSquare() {
    return new ECFieldElementFp(this.p, this.x.pow(2).mod(this.p));
  }

  function feFpDivide(b) {
    return new ECFieldElementFp(this.p, this.x.multiply(b.toBigInteger().modInverse(this.p)).mod(this.p));
  }

  ECFieldElementFp.prototype.equals = feFpEquals;
  ECFieldElementFp.prototype.toBigInteger = feFpToBigInteger;
  ECFieldElementFp.prototype.negate = feFpNegate;
  ECFieldElementFp.prototype.add = feFpAdd;
  ECFieldElementFp.prototype.subtract = feFpSubtract;
  ECFieldElementFp.prototype.multiply = feFpMultiply;
  ECFieldElementFp.prototype.square = feFpSquare;
  ECFieldElementFp.prototype.divide = feFpDivide; // ----------------
  // ECPointFp
  // constructor

  function ECPointFp(curve, x, y, z) {
    this.curve = curve;
    this.x = x;
    this.y = y; // Projective coordinates: either zinv == null or z * zinv == 1
    // z and zinv are just BigIntegers, not fieldElements

    if (!z) {
      this.z = BigInteger.ONE;
    } else {
      this.z = z;
    }

    this.zinv = null; //TODO: compression flag
  }

  function pointFpGetX() {
    if (!this.zinv) {
      this.zinv = this.z.modInverse(this.curve.p);
    }

    var r = this.x.toBigInteger().multiply(this.zinv);
    this.curve.reduce(r);
    return this.curve.fromBigInteger(r);
  }

  function pointFpGetY() {
    if (!this.zinv) {
      this.zinv = this.z.modInverse(this.curve.p);
    }

    var r = this.y.toBigInteger().multiply(this.zinv);
    this.curve.reduce(r);
    return this.curve.fromBigInteger(r);
  }

  function pointFpEquals(other) {
    if (other === this) {
      return true;
    }

    if (this.isInfinity()) {
      return other.isInfinity();
    }

    if (other.isInfinity()) {
      return this.isInfinity();
    }

    var u, v; // u = Y2 * Z1 - Y1 * Z2

    u = other.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(other.z)).mod(this.curve.p);

    if (!u.equals(BigInteger.ZERO)) {
      return false;
    } // v = X2 * Z1 - X1 * Z2


    v = other.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(other.z)).mod(this.curve.p);
    return v.equals(BigInteger.ZERO);
  }

  function pointFpIsInfinity() {
    if (this.x == null && this.y == null) {
      return true;
    }

    return this.z.equals(BigInteger.ZERO) && !this.y.toBigInteger().equals(BigInteger.ZERO);
  }

  function pointFpNegate() {
    return new ECPointFp(this.curve, this.x, this.y.negate(), this.z);
  }

  function pointFpAdd(b) {
    if (this.isInfinity()) {
      return b;
    }

    if (b.isInfinity()) {
      return this;
    } // u = Y2 * Z1 - Y1 * Z2


    var u = b.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(b.z)).mod(this.curve.p); // v = X2 * Z1 - X1 * Z2

    var v = b.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(b.z)).mod(this.curve.p);

    if (BigInteger.ZERO.equals(v)) {
      if (BigInteger.ZERO.equals(u)) {
        return this.twice(); // this == b, so double
      }

      return this.curve.getInfinity(); // this = -b, so infinity
    }

    var THREE = new BigInteger("3");
    var x1 = this.x.toBigInteger();
    var y1 = this.y.toBigInteger();
    var v2 = v.pow(2);
    var v3 = v2.multiply(v);
    var x1v2 = x1.multiply(v2);
    var zu2 = u.pow(2).multiply(this.z); // x3 = v * (z2 * (z1 * u^2 - 2 * x1 * v^2) - v^3)

    var x3 = zu2.subtract(x1v2.shiftLeft(1)).multiply(b.z).subtract(v3).multiply(v).mod(this.curve.p); // y3 = z2 * (3 * x1 * u * v^2 - y1 * v^3 - z1 * u^3) + u * v^3

    var y3 = x1v2.multiply(THREE).multiply(u).subtract(y1.multiply(v3)).subtract(zu2.multiply(u)).multiply(b.z).add(u.multiply(v3)).mod(this.curve.p); // z3 = v^3 * z1 * z2

    var z3 = v3.multiply(this.z).multiply(b.z).mod(this.curve.p);
    return new ECPointFp(this.curve, this.curve.fromBigInteger(x3), this.curve.fromBigInteger(y3), z3);
  }

  function pointFpTwice() {
    if (this.isInfinity()) {
      return this;
    }

    if (this.y.toBigInteger().signum() === 0) {
      return this.curve.getInfinity();
    } // TODO: optimized handling of constants


    var THREE = new BigInteger("3");
    var x1 = this.x.toBigInteger();
    var y1 = this.y.toBigInteger();
    var y1z1 = y1.multiply(this.z);
    var y1sqz1 = y1z1.multiply(y1).mod(this.curve.p);
    var a = this.curve.a.toBigInteger(); // w = 3 * x1^2 + a * z1^2

    var w = x1.pow(2).multiply(THREE);

    if (!BigInteger.ZERO.equals(a)) {
      w = w.add(this.z.pow(2).multiply(a));
    }

    w = w.mod(this.curve.p); //this.curve.reduce(w);
    // x3 = 2 * y1 * z1 * (w^2 - 8 * x1 * y1^2 * z1)

    var x3 = w.pow(2).subtract(x1.shiftLeft(3).multiply(y1sqz1)).shiftLeft(1).multiply(y1z1).mod(this.curve.p); // y3 = 4 * y1^2 * z1 * (3 * w * x1 - 2 * y1^2 * z1) - w^3

    var y3 = w.multiply(THREE).multiply(x1).subtract(y1sqz1.shiftLeft(1)).shiftLeft(2).multiply(y1sqz1).subtract(w.pow(2).multiply(w)).mod(this.curve.p); // z3 = 8 * (y1 * z1)^3

    var z3 = y1z1.pow(2).multiply(y1z1).shiftLeft(3).mod(this.curve.p);
    return new ECPointFp(this.curve, this.curve.fromBigInteger(x3), this.curve.fromBigInteger(y3), z3);
  } // Simple NAF (Non-Adjacent Form) multiplication algorithm
  // TODO: modularize the multiplication algorithm


  function pointFpMultiply(k) {
    if (this.isInfinity()) {
      return this;
    }

    if (k.signum() === 0) {
      return this.curve.getInfinity();
    }

    var e = k;
    var h = e.multiply(new BigInteger("3"));
    var neg = this.negate();
    var R = this;
    var i;

    for (i = h.bitLength() - 2; i > 0; --i) {
      R = R.twice();
      var hBit = h.testBit(i);
      var eBit = e.testBit(i);

      if (hBit !== eBit) {
        R = R.add(hBit ? this : neg);
      }
    }

    return R;
  } // Compute this*j + x*k (simultaneous multiplication)


  function pointFpMultiplyTwo(j, x, k) {
    var i;

    if (j.bitLength() > k.bitLength()) {
      i = j.bitLength() - 1;
    } else {
      i = k.bitLength() - 1;
    }

    var R = this.curve.getInfinity();
    var both = this.add(x);

    while (i >= 0) {
      R = R.twice();

      if (j.testBit(i)) {
        if (k.testBit(i)) {
          R = R.add(both);
        } else {
          R = R.add(this);
        }
      } else {
        if (k.testBit(i)) {
          R = R.add(x);
        }
      }

      --i;
    }

    return R;
  }

  ECPointFp.prototype.getX = pointFpGetX;
  ECPointFp.prototype.getY = pointFpGetY;
  ECPointFp.prototype.equals = pointFpEquals;
  ECPointFp.prototype.isInfinity = pointFpIsInfinity;
  ECPointFp.prototype.negate = pointFpNegate;
  ECPointFp.prototype.add = pointFpAdd;
  ECPointFp.prototype.twice = pointFpTwice;
  ECPointFp.prototype.multiply = pointFpMultiply;
  ECPointFp.prototype.multiplyTwo = pointFpMultiplyTwo; // ----------------
  // ECCurveFp
  // constructor

  function ECCurveFp(p, a, b) {
    this.p = p;
    this.a = this.fromBigInteger(a);
    this.b = this.fromBigInteger(b);
    this.infinity = new ECPointFp(this, null, null);
    this.reducer = new Barrett(this.p);
  }

  function curveFpgetP() {
    return this.p;
  }

  function curveFpGetA() {
    return this.a;
  }

  function curveFpGetB() {
    return this.b;
  }

  function curveFpEquals(other) {
    if (other === this) {
      return true;
    }

    return this.p.equals(other.p) && this.a.equals(other.a) && this.b.equals(other.b);
  }

  function curveFpContains(pt) {
    // y^2 = x^3 + a*x + b mod p
    var x = pt.getX().toBigInteger(),
        y = pt.getY().toBigInteger(),
        a = this.a.toBigInteger(),
        b = this.b.toBigInteger(),
        p = this.p;
    var left = y.pow(2).mod(p),
        right = x.pow(3).add(a.multiply(x)).add(b).mod(p);
    return left.equals(right);
  }

  function curveFpGetInfinity() {
    return this.infinity;
  }

  function curveFpFromBigInteger(x) {
    return new ECFieldElementFp(this.p, x);
  }

  function curveReduce(x) {
    this.reducer.reduce(x);
  } // for now, work with hex strings because they're easier in JS


  function curveFpDecodePointHex(s) {
    switch (parseInt(s.substring(0, 2), 16)) {
      // first byte
      case 0:
        return this.infinity;

      case 2:
      case 3:
        // point compression not supported yet
        return null;

      case 4:
      case 6:
      case 7:
        var len = (s.length - 2) / 2;
        var xHex = s.substr(2, len);
        var yHex = s.substr(len + 2, len);
        return new ECPointFp(this, this.fromBigInteger(new BigInteger(xHex, 16)), this.fromBigInteger(new BigInteger(yHex, 16)));

      default:
        // unsupported
        return null;
    }
  }

  function curveFpEncodePointHex(p) {
    if (p.isInfinity()) {
      return "00";
    }

    var xHex = p.getX().toBigInteger().toString(16);
    var yHex = p.getY().toBigInteger().toString(16);
    var oLen = this.getP().toString(16).length;

    if (oLen % 2 !== 0) {
      oLen++;
    }

    while (xHex.length < oLen) {
      xHex = "0" + xHex;
    }

    while (yHex.length < oLen) {
      yHex = "0" + yHex;
    }

    return "04" + xHex + yHex;
  }

  ECCurveFp.prototype.getP = curveFpgetP;
  ECCurveFp.prototype.getA = curveFpGetA;
  ECCurveFp.prototype.getB = curveFpGetB;
  ECCurveFp.prototype.equals = curveFpEquals;
  ECCurveFp.prototype.contains = curveFpContains;
  ECCurveFp.prototype.getInfinity = curveFpGetInfinity;
  ECCurveFp.prototype.fromBigInteger = curveFpFromBigInteger;
  ECCurveFp.prototype.reduce = curveReduce;
  ECCurveFp.prototype.decodePointHex = curveFpDecodePointHex;
  ECCurveFp.prototype.encodePointHex = curveFpEncodePointHex; // Exports

  module.exports = {
    ECFieldElementFp: ECFieldElementFp,
    ECPointFp: ECPointFp,
    ECCurveFp: ECCurveFp
  };
  /***/
},
/* 236 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * jwe/helpers.js - JWE Internal Helper Functions
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  var CONSTANTS = __webpack_require__(43),
      JWK = __webpack_require__(73);

  module.exports = {
    slice: function slice(input, start) {
      return Array.prototype.slice.call(input, start || 0);
    },
    generateCEK: function generateCEK(enc) {
      var ks = JWK.createKeyStore();
      var len = CONSTANTS.KEYLENGTH[enc];

      if (len) {
        return ks.generate("oct", len);
      }

      throw new Error("unsupported encryption algorithm");
    }
  };
  /***/
},
/* 237 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * jwk/constants.js - Constants for JWKs
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  module.exports = {
    MODE_SIGN: "sign",
    MODE_VERIFY: "verify",
    MODE_ENCRYPT: "encrypt",
    MODE_DECRYPT: "decrypt",
    MODE_WRAP: "wrap",
    MODE_UNWRAP: "unwrap"
  };
  /***/
},
/* 238 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * util/algconfig.js - Functions for managing algorithm set options
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  function quoteRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
  }

  function makeRE(prefix, wildcard, suffix) {
    var parts = [];
    parts.push("^");

    if (prefix) {
      prefix = quoteRE(prefix);
      parts.push(prefix);
    }

    if (wildcard) {
      parts.push(prefix || suffix ? ".*" : ".+");
    }

    if (suffix) {
      suffix = quoteRE(suffix);
      parts.push(suffix);
    }

    parts.push("$");
    return parts.join("");
  }

  var AlgConfig = function AlgConfig(algspec) {
    if (!algspec) {
      algspec = [];
    } else if ("string" === typeof algspec) {
      algspec = algspec.split(" ");
    }

    var specAllowed = [],
        specDisallowed = [];
    var ptnAllowed = [],
        ptnDisallowed = [];
    var ptn = /^(!)?([^*]*)(\*?)([^*]*)$/,
        fmt;
    algspec.forEach(function (a) {
      if (!a) {
        return;
      }

      ptn.lastIndex = 0;
      var parts = ptn.exec(a);

      if (!parts) {
        return;
      }

      fmt = "(" + makeRE(parts[2], parts[3], parts[4]) + ")";

      if (!parts[1]) {
        // allowed pattern
        ptnAllowed.push(fmt);
        specAllowed.push(parts[0]);
      } else {
        // disallowed pattern
        ptnDisallowed.push(fmt);
        specDisallowed.push(parts[0]);
      }
    });
    ptnAllowed = ptnAllowed.length ? new RegExp(ptnAllowed.join("|")) : null;
    ptnDisallowed = ptnDisallowed.length ? new RegExp(ptnDisallowed.join("|")) : null;

    if (!specAllowed.length) {
      specAllowed = ["*"];
    }

    Object.defineProperty(this, "spec", {
      value: specAllowed.join(" ") + " " + specDisallowed.join(" "),
      enumerable: true
    });
    Object.defineProperty(this, "match", {
      value: function value(alg) {
        var result = Boolean(alg);

        if (result && ptnAllowed) {
          ptnAllowed.lastIndex = 0;
          result = ptnAllowed.test(alg);
        }

        if (result && ptnDisallowed) {
          ptnDisallowed.lastIndex = 0;
          result = !ptnDisallowed.test(alg);
        }

        return result;
      }
    });
  };

  module.exports = AlgConfig;
  /***/
},
/* 239 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Note: adler32 takes 12% for level 0 and 2% for level 6.
  // It isn't worth it to make additional optimizations as in original.
  // Small size is preferable.
  // (C) 1995-2013 Jean-loup Gailly and Mark Adler
  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
  //
  // This software is provided 'as-is', without any express or implied
  // warranty. In no event will the authors be held liable for any damages
  // arising from the use of this software.
  //
  // Permission is granted to anyone to use this software for any purpose,
  // including commercial applications, and to alter it and redistribute it
  // freely, subject to the following restrictions:
  //
  // 1. The origin of this software must not be misrepresented; you must not
  //   claim that you wrote the original software. If you use this software
  //   in a product, an acknowledgment in the product documentation would be
  //   appreciated but is not required.
  // 2. Altered source versions must be plainly marked as such, and must not be
  //   misrepresented as being the original software.
  // 3. This notice may not be removed or altered from any source distribution.

  function adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0,
        s2 = adler >>> 16 & 0xffff | 0,
        n = 0;

    while (len !== 0) {
      // Set limit ~ twice less than 5552, to keep
      // s2 in 31-bits, because we force signed ints.
      // in other case %= will fail.
      n = len > 2000 ? 2000 : len;
      len -= n;

      do {
        s1 = s1 + buf[pos++] | 0;
        s2 = s2 + s1 | 0;
      } while (--n);

      s1 %= 65521;
      s2 %= 65521;
    }

    return s1 | s2 << 16 | 0;
  }

  module.exports = adler32;
  /***/
},
/* 240 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Note: we can't get significant speed boost here.
  // So write code to minimize size - no pregenerated tables
  // and array tools dependencies.
  // (C) 1995-2013 Jean-loup Gailly and Mark Adler
  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
  //
  // This software is provided 'as-is', without any express or implied
  // warranty. In no event will the authors be held liable for any damages
  // arising from the use of this software.
  //
  // Permission is granted to anyone to use this software for any purpose,
  // including commercial applications, and to alter it and redistribute it
  // freely, subject to the following restrictions:
  //
  // 1. The origin of this software must not be misrepresented; you must not
  //   claim that you wrote the original software. If you use this software
  //   in a product, an acknowledgment in the product documentation would be
  //   appreciated but is not required.
  // 2. Altered source versions must be plainly marked as such, and must not be
  //   misrepresented as being the original software.
  // 3. This notice may not be removed or altered from any source distribution.
  // Use ordinary array, since untyped makes no boost here

  function makeTable() {
    var c,
        table = [];

    for (var n = 0; n < 256; n++) {
      c = n;

      for (var k = 0; k < 8; k++) {
        c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
      }

      table[n] = c;
    }

    return table;
  } // Create table on load. Just 255 signed longs. Not a problem.


  var crcTable = makeTable();

  function crc32(crc, buf, len, pos) {
    var t = crcTable,
        end = pos + len;
    crc ^= -1;

    for (var i = pos; i < end; i++) {
      crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    }

    return crc ^ -1; // >>> 0;
  }

  module.exports = crc32;
  /***/
},
/* 241 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(62);
  /***/
},
/* 242 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (global, process) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.

    /*<replacement>*/
    var pna = __webpack_require__(83);
    /*</replacement>*/


    module.exports = Readable;
    /*<replacement>*/

    var isArray = __webpack_require__(201);
    /*</replacement>*/

    /*<replacement>*/


    var Duplex;
    /*</replacement>*/

    Readable.ReadableState = ReadableState;
    /*<replacement>*/

    var EE = __webpack_require__(41).EventEmitter;

    var EElistenerCount = function EElistenerCount(emitter, type) {
      return emitter.listeners(type).length;
    };
    /*</replacement>*/

    /*<replacement>*/


    var Stream = __webpack_require__(245);
    /*</replacement>*/

    /*<replacement>*/


    var Buffer = __webpack_require__(38).Buffer;

    var OurUint8Array = global.Uint8Array || function () {};

    function _uint8ArrayToBuffer(chunk) {
      return Buffer.from(chunk);
    }

    function _isUint8Array(obj) {
      return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
    }
    /*</replacement>*/

    /*<replacement>*/


    var util = __webpack_require__(78);

    util.inherits = __webpack_require__(37);
    /*</replacement>*/

    /*<replacement>*/

    var debugUtil = __webpack_require__(609);

    var debug = void 0;

    if (debugUtil && debugUtil.debuglog) {
      debug = debugUtil.debuglog('stream');
    } else {
      debug = function debug() {};
    }
    /*</replacement>*/


    var BufferList = __webpack_require__(589);

    var destroyImpl = __webpack_require__(244);

    var StringDecoder;
    util.inherits(Readable, Stream);
    var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

    function prependListener(emitter, event, fn) {
      // Sadly this is not cacheable as some libraries bundle their own
      // event emitter implementation with them.
      if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
      // userland ones.  NEVER DO THIS. This is here only because this code needs
      // to continue to work with older versions of Node.js that do not include
      // the prependListener() method. The goal is to eventually remove this hack.

      if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
    }

    function ReadableState(options, stream) {
      Duplex = Duplex || __webpack_require__(62);
      options = options || {}; // Duplex streams are both readable and writable, but share
      // the same options object.
      // However, some cases require setting options to different
      // values for the readable and the writable sides of the duplex stream.
      // These options can be provided separately as readableXXX and writableXXX.

      var isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
      // make all the buffer merging and length checks go away

      this.objectMode = !!options.objectMode;
      if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
      // Note: 0 is a valid value, means "don't call _read preemptively ever"

      var hwm = options.highWaterMark;
      var readableHwm = options.readableHighWaterMark;
      var defaultHwm = this.objectMode ? 16 : 16 * 1024;
      if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm; // cast to ints.

      this.highWaterMark = Math.floor(this.highWaterMark); // A linked list is used to store data chunks instead of an array because the
      // linked list can remove elements from the beginning faster than
      // array.shift()

      this.buffer = new BufferList();
      this.length = 0;
      this.pipes = null;
      this.pipesCount = 0;
      this.flowing = null;
      this.ended = false;
      this.endEmitted = false;
      this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
      // immediately, or on a later tick.  We set this to true at first, because
      // any actions that shouldn't happen until "later" should generally also
      // not happen before the first read call.

      this.sync = true; // whenever we return null, then we set a flag to say
      // that we're awaiting a 'readable' event emission.

      this.needReadable = false;
      this.emittedReadable = false;
      this.readableListening = false;
      this.resumeScheduled = false; // has it been destroyed

      this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
      // encoding is 'binary' so we have to make this configurable.
      // Everything else in the universe uses 'utf8', though.

      this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s

      this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

      this.readingMore = false;
      this.decoder = null;
      this.encoding = null;

      if (options.encoding) {
        if (!StringDecoder) StringDecoder = __webpack_require__(246).StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
      }
    }

    function Readable(options) {
      Duplex = Duplex || __webpack_require__(62);
      if (!(this instanceof Readable)) return new Readable(options);
      this._readableState = new ReadableState(options, this); // legacy

      this.readable = true;

      if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
      }

      Stream.call(this);
    }

    Object.defineProperty(Readable.prototype, 'destroyed', {
      get: function get() {
        if (this._readableState === undefined) {
          return false;
        }

        return this._readableState.destroyed;
      },
      set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) {
          return;
        } // backward compatibility, the user is explicitly
        // managing destroyed


        this._readableState.destroyed = value;
      }
    });
    Readable.prototype.destroy = destroyImpl.destroy;
    Readable.prototype._undestroy = destroyImpl.undestroy;

    Readable.prototype._destroy = function (err, cb) {
      this.push(null);
      cb(err);
    }; // Manually shove something into the read() buffer.
    // This returns true if the highWaterMark has not been hit yet,
    // similar to how Writable.write() returns true if you should
    // write() some more.


    Readable.prototype.push = function (chunk, encoding) {
      var state = this._readableState;
      var skipChunkCheck;

      if (!state.objectMode) {
        if (typeof chunk === 'string') {
          encoding = encoding || state.defaultEncoding;

          if (encoding !== state.encoding) {
            chunk = Buffer.from(chunk, encoding);
            encoding = '';
          }

          skipChunkCheck = true;
        }
      } else {
        skipChunkCheck = true;
      }

      return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
    }; // Unshift should *always* be something directly out of read()


    Readable.prototype.unshift = function (chunk) {
      return readableAddChunk(this, chunk, null, true, false);
    };

    function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
      var state = stream._readableState;

      if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
      } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);

        if (er) {
          stream.emit('error', er);
        } else if (state.objectMode || chunk && chunk.length > 0) {
          if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
            chunk = _uint8ArrayToBuffer(chunk);
          }

          if (addToFront) {
            if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
          } else if (state.ended) {
            stream.emit('error', new Error('stream.push() after EOF'));
          } else {
            state.reading = false;

            if (state.decoder && !encoding) {
              chunk = state.decoder.write(chunk);
              if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
            } else {
              addChunk(stream, state, chunk, false);
            }
          }
        } else if (!addToFront) {
          state.reading = false;
        }
      }

      return needMoreData(state);
    }

    function addChunk(stream, state, chunk, addToFront) {
      if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
      } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
      }

      maybeReadMore(stream, state);
    }

    function chunkInvalid(state, chunk) {
      var er;

      if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
        er = new TypeError('Invalid non-string/buffer chunk');
      }

      return er;
    } // if it's past the high water mark, we can push in some more.
    // Also, if we have no data yet, we can stand some
    // more bytes.  This is to work around cases where hwm=0,
    // such as the repl.  Also, if the push() triggered a
    // readable event, and the user called read(largeNumber) such that
    // needReadable was set, then we ought to push more, so that another
    // 'readable' event will be triggered.


    function needMoreData(state) {
      return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
    }

    Readable.prototype.isPaused = function () {
      return this._readableState.flowing === false;
    }; // backwards compatibility.


    Readable.prototype.setEncoding = function (enc) {
      if (!StringDecoder) StringDecoder = __webpack_require__(246).StringDecoder;
      this._readableState.decoder = new StringDecoder(enc);
      this._readableState.encoding = enc;
      return this;
    }; // Don't raise the hwm > 8MB


    var MAX_HWM = 0x800000;

    function computeNewHighWaterMark(n) {
      if (n >= MAX_HWM) {
        n = MAX_HWM;
      } else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
      }

      return n;
    } // This function is designed to be inlinable, so please take care when making
    // changes to the function body.


    function howMuchToRead(n, state) {
      if (n <= 0 || state.length === 0 && state.ended) return 0;
      if (state.objectMode) return 1;

      if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
      } // If we're asking for more than the current hwm, then raise the hwm.


      if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
      if (n <= state.length) return n; // Don't have enough

      if (!state.ended) {
        state.needReadable = true;
        return 0;
      }

      return state.length;
    } // you can override either this method, or the async _read(n) below.


    Readable.prototype.read = function (n) {
      debug('read', n);
      n = parseInt(n, 10);
      var state = this._readableState;
      var nOrig = n;
      if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
      // already have a bunch of data in the buffer, then just trigger
      // the 'readable' event and move on.

      if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
        return null;
      }

      n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.

      if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
      } // All the actual chunk generation logic needs to be
      // *below* the call to _read.  The reason is that in certain
      // synthetic stream cases, such as passthrough streams, _read
      // may be a completely synchronous operation which may change
      // the state of the read buffer, providing enough data when
      // before there was *not* enough.
      //
      // So, the steps are:
      // 1. Figure out what the state of things will be after we do
      // a read from the buffer.
      //
      // 2. If that resulting state will trigger a _read, then call _read.
      // Note that this may be asynchronous, or synchronous.  Yes, it is
      // deeply ugly to write APIs this way, but that still doesn't mean
      // that the Readable class should behave improperly, as streams are
      // designed to be sync/async agnostic.
      // Take note if the _read call is sync or async (ie, if the read call
      // has returned yet), so that we know whether or not it's safe to emit
      // 'readable' etc.
      //
      // 3. Actually pull the requested chunks out of the buffer and return.
      // if we need a readable event, then we need to do some reading.


      var doRead = state.needReadable;
      debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

      if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug('length less than watermark', doRead);
      } // however, if we've ended, then there's no point, and if we're already
      // reading, then it's unnecessary.


      if (state.ended || state.reading) {
        doRead = false;
        debug('reading or ended', doRead);
      } else if (doRead) {
        debug('do read');
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.

        if (state.length === 0) state.needReadable = true; // call internal read method

        this._read(state.highWaterMark);

        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.

        if (!state.reading) n = howMuchToRead(nOrig, state);
      }

      var ret;
      if (n > 0) ret = fromList(n, state);else ret = null;

      if (ret === null) {
        state.needReadable = true;
        n = 0;
      } else {
        state.length -= n;
      }

      if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

        if (nOrig !== n && state.ended) endReadable(this);
      }

      if (ret !== null) this.emit('data', ret);
      return ret;
    };

    function onEofChunk(stream, state) {
      if (state.ended) return;

      if (state.decoder) {
        var chunk = state.decoder.end();

        if (chunk && chunk.length) {
          state.buffer.push(chunk);
          state.length += state.objectMode ? 1 : chunk.length;
        }
      }

      state.ended = true; // emit 'readable' now to make sure it gets picked up.

      emitReadable(stream);
    } // Don't emit readable right away in sync mode, because this can trigger
    // another read() call => stack overflow.  This way, it might trigger
    // a nextTick recursion warning, but that's not so bad.


    function emitReadable(stream) {
      var state = stream._readableState;
      state.needReadable = false;

      if (!state.emittedReadable) {
        debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
      }
    }

    function emitReadable_(stream) {
      debug('emit readable');
      stream.emit('readable');
      flow(stream);
    } // at this point, the user has presumably seen the 'readable' event,
    // and called read() to consume some data.  that may have triggered
    // in turn another _read(n) call, in which case reading = true if
    // it's in progress.
    // However, if we're not ended, or reading, and the length < hwm,
    // then go ahead and try to read some more preemptively.


    function maybeReadMore(stream, state) {
      if (!state.readingMore) {
        state.readingMore = true;
        pna.nextTick(maybeReadMore_, stream, state);
      }
    }

    function maybeReadMore_(stream, state) {
      var len = state.length;

      while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
        debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) // didn't get any data, stop spinning.
          break;else len = state.length;
      }

      state.readingMore = false;
    } // abstract method.  to be overridden in specific implementation classes.
    // call cb(er, data) where data is <= n in length.
    // for virtual (non-string, non-buffer) streams, "length" is somewhat
    // arbitrary, and perhaps not very meaningful.


    Readable.prototype._read = function (n) {
      this.emit('error', new Error('_read() is not implemented'));
    };

    Readable.prototype.pipe = function (dest, pipeOpts) {
      var src = this;
      var state = this._readableState;

      switch (state.pipesCount) {
        case 0:
          state.pipes = dest;
          break;

        case 1:
          state.pipes = [state.pipes, dest];
          break;

        default:
          state.pipes.push(dest);
          break;
      }

      state.pipesCount += 1;
      debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
      var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
      var endFn = doEnd ? onend : unpipe;
      if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
      dest.on('unpipe', onunpipe);

      function onunpipe(readable, unpipeInfo) {
        debug('onunpipe');

        if (readable === src) {
          if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
            unpipeInfo.hasUnpiped = true;
            cleanup();
          }
        }
      }

      function onend() {
        debug('onend');
        dest.end();
      } // when the dest drains, it reduces the awaitDrain counter
      // on the source.  This would be more elegant with a .once()
      // handler in flow(), but adding and removing repeatedly is
      // too slow.


      var ondrain = pipeOnDrain(src);
      dest.on('drain', ondrain);
      var cleanedUp = false;

      function cleanup() {
        debug('cleanup'); // cleanup event handlers once the pipe is broken

        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.

        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
      } // If the user pushes more data while we're writing to dest then we'll end up
      // in ondata again. However, we only want to increase awaitDrain once because
      // dest will only emit one 'drain' event for the multiple writes.
      // => Introduce a guard on increasing awaitDrain.


      var increasedAwaitDrain = false;
      src.on('data', ondata);

      function ondata(chunk) {
        debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);

        if (false === ret && !increasedAwaitDrain) {
          // If the user unpiped during `dest.write()`, it is possible
          // to get stuck in a permanently paused state if that write
          // also returned false.
          // => Check whether `dest` is still a piping destination.
          if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
            debug('false write response, pause', src._readableState.awaitDrain);
            src._readableState.awaitDrain++;
            increasedAwaitDrain = true;
          }

          src.pause();
        }
      } // if the dest has an error, then stop piping into it.
      // however, don't suppress the throwing behavior for this.


      function onerror(er) {
        debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
      } // Make sure our error handler is attached before userland ones.


      prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

      function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
      }

      dest.once('close', onclose);

      function onfinish() {
        debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
      }

      dest.once('finish', onfinish);

      function unpipe() {
        debug('unpipe');
        src.unpipe(dest);
      } // tell the dest that it's being piped to


      dest.emit('pipe', src); // start the flow if it hasn't been started already.

      if (!state.flowing) {
        debug('pipe resume');
        src.resume();
      }

      return dest;
    };

    function pipeOnDrain(src) {
      return function () {
        var state = src._readableState;
        debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;

        if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
          state.flowing = true;
          flow(src);
        }
      };
    }

    Readable.prototype.unpipe = function (dest) {
      var state = this._readableState;
      var unpipeInfo = {
        hasUnpiped: false
      }; // if we're not piping anywhere, then do nothing.

      if (state.pipesCount === 0) return this; // just one destination.  most common case.

      if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.

        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
      } // slow case. multiple pipe destinations.


      if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;

        for (var i = 0; i < len; i++) {
          dests[i].emit('unpipe', this, unpipeInfo);
        }

        return this;
      } // try to find the right one.


      var index = indexOf(state.pipes, dest);
      if (index === -1) return this;
      state.pipes.splice(index, 1);
      state.pipesCount -= 1;
      if (state.pipesCount === 1) state.pipes = state.pipes[0];
      dest.emit('unpipe', this, unpipeInfo);
      return this;
    }; // set up data events if they are asked for
    // Ensure readable listeners eventually get something


    Readable.prototype.on = function (ev, fn) {
      var res = Stream.prototype.on.call(this, ev, fn);

      if (ev === 'data') {
        // Start flowing on next tick if stream isn't explicitly paused
        if (this._readableState.flowing !== false) this.resume();
      } else if (ev === 'readable') {
        var state = this._readableState;

        if (!state.endEmitted && !state.readableListening) {
          state.readableListening = state.needReadable = true;
          state.emittedReadable = false;

          if (!state.reading) {
            pna.nextTick(nReadingNextTick, this);
          } else if (state.length) {
            emitReadable(this);
          }
        }
      }

      return res;
    };

    Readable.prototype.addListener = Readable.prototype.on;

    function nReadingNextTick(self) {
      debug('readable nexttick read 0');
      self.read(0);
    } // pause() and resume() are remnants of the legacy readable stream API
    // If the user uses them, then switch into old mode.


    Readable.prototype.resume = function () {
      var state = this._readableState;

      if (!state.flowing) {
        debug('resume');
        state.flowing = true;
        resume(this, state);
      }

      return this;
    };

    function resume(stream, state) {
      if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        pna.nextTick(resume_, stream, state);
      }
    }

    function resume_(stream, state) {
      if (!state.reading) {
        debug('resume read 0');
        stream.read(0);
      }

      state.resumeScheduled = false;
      state.awaitDrain = 0;
      stream.emit('resume');
      flow(stream);
      if (state.flowing && !state.reading) stream.read(0);
    }

    Readable.prototype.pause = function () {
      debug('call pause flowing=%j', this._readableState.flowing);

      if (false !== this._readableState.flowing) {
        debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
      }

      return this;
    };

    function flow(stream) {
      var state = stream._readableState;
      debug('flow', state.flowing);

      while (state.flowing && stream.read() !== null) {}
    } // wrap an old-style stream as the async data source.
    // This is *not* part of the readable stream interface.
    // It is an ugly unfortunate mess of history.


    Readable.prototype.wrap = function (stream) {
      var _this = this;

      var state = this._readableState;
      var paused = false;
      stream.on('end', function () {
        debug('wrapped end');

        if (state.decoder && !state.ended) {
          var chunk = state.decoder.end();
          if (chunk && chunk.length) _this.push(chunk);
        }

        _this.push(null);
      });
      stream.on('data', function (chunk) {
        debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

        if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

        var ret = _this.push(chunk);

        if (!ret) {
          paused = true;
          stream.pause();
        }
      }); // proxy all the other methods.
      // important when wrapping filters and duplexes.

      for (var i in stream) {
        if (this[i] === undefined && typeof stream[i] === 'function') {
          this[i] = function (method) {
            return function () {
              return stream[method].apply(stream, arguments);
            };
          }(i);
        }
      } // proxy certain important events.


      for (var n = 0; n < kProxyEvents.length; n++) {
        stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
      } // when we try to consume some more bytes, simply unpause the
      // underlying stream.


      this._read = function (n) {
        debug('wrapped _read', n);

        if (paused) {
          paused = false;
          stream.resume();
        }
      };

      return this;
    };

    Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: false,
      get: function get() {
        return this._readableState.highWaterMark;
      }
    }); // exposed for testing purposes only.

    Readable._fromList = fromList; // Pluck off n bytes from an array of buffers.
    // Length is the combined lengths of all the buffers in the list.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.

    function fromList(n, state) {
      // nothing buffered
      if (state.length === 0) return null;
      var ret;
      if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
        state.buffer.clear();
      } else {
        // read part of list
        ret = fromListPartial(n, state.buffer, state.decoder);
      }
      return ret;
    } // Extracts only enough buffered data to satisfy the amount requested.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.


    function fromListPartial(n, list, hasStrings) {
      var ret;

      if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
      } else if (n === list.head.data.length) {
        // first chunk is a perfect match
        ret = list.shift();
      } else {
        // result spans more than one buffer
        ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
      }

      return ret;
    } // Copies a specified amount of characters from the list of buffered data
    // chunks.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.


    function copyFromBufferString(n, list) {
      var p = list.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;

      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;

        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) list.head = p.next;else list.head = list.tail = null;
          } else {
            list.head = p;
            p.data = str.slice(nb);
          }

          break;
        }

        ++c;
      }

      list.length -= c;
      return ret;
    } // Copies a specified amount of bytes from the list of buffered data chunks.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.


    function copyFromBuffer(n, list) {
      var ret = Buffer.allocUnsafe(n);
      var p = list.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;

      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;

        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) list.head = p.next;else list.head = list.tail = null;
          } else {
            list.head = p;
            p.data = buf.slice(nb);
          }

          break;
        }

        ++c;
      }

      list.length -= c;
      return ret;
    }

    function endReadable(stream) {
      var state = stream._readableState; // If we get here before consuming all the bytes, then that is a
      // bug in node.  Should never happen.

      if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

      if (!state.endEmitted) {
        state.ended = true;
        pna.nextTick(endReadableNT, state, stream);
      }
    }

    function endReadableNT(state, stream) {
      // Check that we didn't get one last unshift.
      if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
      }
    }

    function indexOf(xs, x) {
      for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) return i;
      }

      return -1;
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(10), __webpack_require__(16));
  /***/
},
/* 243 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  // a transform stream is a readable/writable stream where you do
  // something with the data.  Sometimes it's called a "filter",
  // but that's not a great name for it, since that implies a thing where
  // some bits pass through, and others are simply ignored.  (That would
  // be a valid example of a transform, of course.)
  //
  // While the output is causally related to the input, it's not a
  // necessarily symmetric or synchronous transformation.  For example,
  // a zlib stream might take multiple plain-text writes(), and then
  // emit a single compressed chunk some time in the future.
  //
  // Here's how this works:
  //
  // The Transform stream has all the aspects of the readable and writable
  // stream classes.  When you write(chunk), that calls _write(chunk,cb)
  // internally, and returns false if there's a lot of pending writes
  // buffered up.  When you call read(), that calls _read(n) until
  // there's enough pending readable data buffered up.
  //
  // In a transform stream, the written data is placed in a buffer.  When
  // _read(n) is called, it transforms the queued up data, calling the
  // buffered _write cb's as it consumes chunks.  If consuming a single
  // written chunk would result in multiple output chunks, then the first
  // outputted bit calls the readcb, and subsequent chunks just go into
  // the read buffer, and will cause it to emit 'readable' if necessary.
  //
  // This way, back-pressure is actually determined by the reading side,
  // since _read has to be called to start processing a new chunk.  However,
  // a pathological inflate type of transform can cause excessive buffering
  // here.  For example, imagine a stream where every byte of input is
  // interpreted as an integer from 0-255, and then results in that many
  // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
  // 1kb of data being output.  In this case, you could write a very small
  // amount of input, and end up with a very large amount of output.  In
  // such a pathological inflating mechanism, there'd be no way to tell
  // the system to stop doing the transform.  A single 4MB write could
  // cause the system to run out of memory.
  //
  // However, even in such a pathological case, only a single written chunk
  // would be consumed, and then the rest would wait (un-transformed) until
  // the results of the previous transformed chunk were consumed.

  module.exports = Transform;

  var Duplex = __webpack_require__(62);
  /*<replacement>*/


  var util = __webpack_require__(78);

  util.inherits = __webpack_require__(37);
  /*</replacement>*/

  util.inherits(Transform, Duplex);

  function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;

    if (!cb) {
      return this.emit('error', new Error('write callback called multiple times'));
    }

    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
      this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;

    if (rs.needReadable || rs.length < rs.highWaterMark) {
      this._read(rs.highWaterMark);
    }
  }

  function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
      afterTransform: afterTransform.bind(this),
      needTransform: false,
      transforming: false,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }; // start out asking for a readable event once data is transformed.

    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.

    this._readableState.sync = false;

    if (options) {
      if (typeof options.transform === 'function') this._transform = options.transform;
      if (typeof options.flush === 'function') this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.


    this.on('prefinish', prefinish);
  }

  function prefinish() {
    var _this = this;

    if (typeof this._flush === 'function') {
      this._flush(function (er, data) {
        done(_this, er, data);
      });
    } else {
      done(this, null, null);
    }
  }

  Transform.prototype.push = function (chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
  }; // This is the part where you do stuff!
  // override this function in implementation classes.
  // 'chunk' is an input chunk.
  //
  // Call `push(newChunk)` to pass along transformed output
  // to the readable side.  You may call 'push' zero or more times.
  //
  // Call `cb(err)` when you are done with this chunk.  If you pass
  // an error, then that'll put the hurt on the whole operation.  If you
  // never call cb(), then you'll never get another chunk.


  Transform.prototype._transform = function (chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
  };

  Transform.prototype._write = function (chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;

    if (!ts.transforming) {
      var rs = this._readableState;
      if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
  }; // Doesn't matter what the args are here.
  // _transform does all the work.
  // That we got here means that the readable side wants more data.


  Transform.prototype._read = function (n) {
    var ts = this._transformState;

    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
      ts.transforming = true;

      this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else {
      // mark that we need a transform, so that any data that comes in
      // will get processed, now that we've asked for it.
      ts.needTransform = true;
    }
  };

  Transform.prototype._destroy = function (err, cb) {
    var _this2 = this;

    Duplex.prototype._destroy.call(this, err, function (err2) {
      cb(err2);

      _this2.emit('close');
    });
  };

  function done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
      stream.push(data); // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided

    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
  }
  /***/

},
/* 244 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*<replacement>*/

  var pna = __webpack_require__(83);
  /*</replacement>*/
  // undocumented cb() API, needed for core, not for public API


  function destroy(err, cb) {
    var _this = this;

    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;

    if (readableDestroyed || writableDestroyed) {
      if (cb) {
        cb(err);
      } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
        pna.nextTick(emitErrorNT, this, err);
      }

      return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks


    if (this._readableState) {
      this._readableState.destroyed = true;
    } // if this is a duplex stream mark the writable part as destroyed as well


    if (this._writableState) {
      this._writableState.destroyed = true;
    }

    this._destroy(err || null, function (err) {
      if (!cb && err) {
        pna.nextTick(emitErrorNT, _this, err);

        if (_this._writableState) {
          _this._writableState.errorEmitted = true;
        }
      } else if (cb) {
        cb(err);
      }
    });

    return this;
  }

  function undestroy() {
    if (this._readableState) {
      this._readableState.destroyed = false;
      this._readableState.reading = false;
      this._readableState.ended = false;
      this._readableState.endEmitted = false;
    }

    if (this._writableState) {
      this._writableState.destroyed = false;
      this._writableState.ended = false;
      this._writableState.ending = false;
      this._writableState.finished = false;
      this._writableState.errorEmitted = false;
    }
  }

  function emitErrorNT(self, err) {
    self.emit('error', err);
  }

  module.exports = {
    destroy: destroy,
    undestroy: undestroy
  };
  /***/
},
/* 245 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(41).EventEmitter;
  /***/
},
/* 246 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.

  /*<replacement>*/

  var Buffer = __webpack_require__(38).Buffer;
  /*</replacement>*/


  var isEncoding = Buffer.isEncoding || function (encoding) {
    encoding = '' + encoding;

    switch (encoding && encoding.toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
      case 'raw':
        return true;

      default:
        return false;
    }
  };

  function _normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;

    while (true) {
      switch (enc) {
        case 'utf8':
        case 'utf-8':
          return 'utf8';

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return 'utf16le';

        case 'latin1':
        case 'binary':
          return 'latin1';

        case 'base64':
        case 'ascii':
        case 'hex':
          return enc;

        default:
          if (retried) return; // undefined

          enc = ('' + enc).toLowerCase();
          retried = true;
      }
    }
  }

  ; // Do not cache `Buffer.isEncoding` when checking encoding names as some
  // modules monkey-patch it to support additional encodings

  function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);

    if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
  } // StringDecoder provides an interface for efficiently splitting a series of
  // buffers into a series of JS strings without breaking apart multi-byte
  // characters.


  exports.StringDecoder = StringDecoder;

  function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;

    switch (this.encoding) {
      case 'utf16le':
        this.text = utf16Text;
        this.end = utf16End;
        nb = 4;
        break;

      case 'utf8':
        this.fillLast = utf8FillLast;
        nb = 4;
        break;

      case 'base64':
        this.text = base64Text;
        this.end = base64End;
        nb = 3;
        break;

      default:
        this.write = simpleWrite;
        this.end = simpleEnd;
        return;
    }

    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
  }

  StringDecoder.prototype.write = function (buf) {
    if (buf.length === 0) return '';
    var r;
    var i;

    if (this.lastNeed) {
      r = this.fillLast(buf);
      if (r === undefined) return '';
      i = this.lastNeed;
      this.lastNeed = 0;
    } else {
      i = 0;
    }

    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
  };

  StringDecoder.prototype.end = utf8End; // Returns only complete characters in a Buffer

  StringDecoder.prototype.text = utf8Text; // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer

  StringDecoder.prototype.fillLast = function (buf) {
    if (this.lastNeed <= buf.length) {
      buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
      return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }

    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
  }; // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
  // continuation byte. If an invalid byte is detected, -2 is returned.


  function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
  } // Checks at most 3 bytes at the end of a Buffer in order to detect an
  // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
  // needed to complete the UTF-8 character (if applicable) are returned.


  function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);

    if (nb >= 0) {
      if (nb > 0) self.lastNeed = nb - 1;
      return nb;
    }

    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);

    if (nb >= 0) {
      if (nb > 0) self.lastNeed = nb - 2;
      return nb;
    }

    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);

    if (nb >= 0) {
      if (nb > 0) {
        if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
      }

      return nb;
    }

    return 0;
  } // Validates as many continuation bytes for a multi-byte UTF-8 character as
  // needed or are available. If we see a non-continuation byte where we expect
  // one, we "replace" the validated continuation bytes we've seen so far with
  // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
  // behavior. The continuation byte check is included three times in the case
  // where all of the continuation bytes for a character exist in the same buffer.
  // It is also done this way as a slight performance increase instead of using a
  // loop.


  function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
      self.lastNeed = 0;
      return "\uFFFD";
    }

    if (self.lastNeed > 1 && buf.length > 1) {
      if ((buf[1] & 0xC0) !== 0x80) {
        self.lastNeed = 1;
        return "\uFFFD";
      }

      if (self.lastNeed > 2 && buf.length > 2) {
        if ((buf[2] & 0xC0) !== 0x80) {
          self.lastNeed = 2;
          return "\uFFFD";
        }
      }
    }
  } // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.


  function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;

    if (this.lastNeed <= buf.length) {
      buf.copy(this.lastChar, p, 0, this.lastNeed);
      return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }

    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
  } // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
  // partial character, the character's bytes are buffered until the required
  // number of bytes are available.


  function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
  } // For UTF-8, a replacement character is added when ending on a partial
  // character.


  function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + "\uFFFD";
    return r;
  } // UTF-16LE typically needs two bytes per character, but even if we have an even
  // number of bytes available, we need to check if we end on a leading/high
  // surrogate. In that case, we need to wait for the next two bytes in order to
  // decode the last character properly.


  function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
      var r = buf.toString('utf16le', i);

      if (r) {
        var c = r.charCodeAt(r.length - 1);

        if (c >= 0xD800 && c <= 0xDBFF) {
          this.lastNeed = 2;
          this.lastTotal = 4;
          this.lastChar[0] = buf[buf.length - 2];
          this.lastChar[1] = buf[buf.length - 1];
          return r.slice(0, -1);
        }
      }

      return r;
    }

    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
  } // For UTF-16LE we do not explicitly append special replacement characters if we
  // end on a partial character, we simply let v8 handle that.


  function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';

    if (this.lastNeed) {
      var end = this.lastTotal - this.lastNeed;
      return r + this.lastChar.toString('utf16le', 0, end);
    }

    return r;
  }

  function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;

    if (n === 1) {
      this.lastChar[0] = buf[buf.length - 1];
    } else {
      this.lastChar[0] = buf[buf.length - 2];
      this.lastChar[1] = buf[buf.length - 1];
    }

    return buf.toString('base64', i, buf.length - n);
  }

  function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
  } // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)


  function simpleWrite(buf) {
    return buf.toString(this.encoding);
  }

  function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
  }
  /***/

},
/* 247 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
    var apply = Function.prototype.apply; // DOM APIs, for completeness

    exports.setTimeout = function () {
      return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
    };

    exports.setInterval = function () {
      return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
    };

    exports.clearTimeout = exports.clearInterval = function (timeout) {
      if (timeout) {
        timeout.close();
      }
    };

    function Timeout(id, clearFn) {
      this._id = id;
      this._clearFn = clearFn;
    }

    Timeout.prototype.unref = Timeout.prototype.ref = function () {};

    Timeout.prototype.close = function () {
      this._clearFn.call(scope, this._id);
    }; // Does not start the time, just sets up the members needed.


    exports.enroll = function (item, msecs) {
      clearTimeout(item._idleTimeoutId);
      item._idleTimeout = msecs;
    };

    exports.unenroll = function (item) {
      clearTimeout(item._idleTimeoutId);
      item._idleTimeout = -1;
    };

    exports._unrefActive = exports.active = function (item) {
      clearTimeout(item._idleTimeoutId);
      var msecs = item._idleTimeout;

      if (msecs >= 0) {
        item._idleTimeoutId = setTimeout(function onTimeout() {
          if (item._onTimeout) item._onTimeout();
        }, msecs);
      }
    }; // setimmediate attaches itself to the global object


    __webpack_require__(594); // On some exotic environments, it's not clear which object `setimmediate` was
    // able to install onto.  Search each possibility in the same order as the
    // `setimmediate` library.


    exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
    exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10));
  /***/
},
/* 248 */

/***/
function (module, exports) {
  /**
   * Convert array of 16 byte values to UUID string format of the form:
   * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
   */
  var byteToHex = [];

  for (var i = 0; i < 256; ++i) {
    byteToHex[i] = (i + 0x100).toString(16).substr(1);
  }

  function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

    return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
  }

  module.exports = bytesToUuid;
  /***/
},
/* 249 */

/***/
function (module, exports) {
  // Unique ID creation requires a high quality random # generator.  In the
  // browser this is a little complicated due to unknown quality of Math.random()
  // and inconsistent support for the `crypto` API.  We do the best we can via
  // feature-detection
  // getRandomValues needs to be invoked in a context where "this" is a Crypto
  // implementation. Also, find the complete implementation of crypto on IE11.
  var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);

  if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

    module.exports = function whatwgRNG() {
      getRandomValues(rnds8);
      return rnds8;
    };
  } else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);

    module.exports = function mathRNG() {
      for (var i = 0, r; i < 16; i++) {
        if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
        rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
      }

      return rnds;
    };
  }
  /***/

},
/* 250 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 251 */

/***/
function (module, exports) {
  /* (ignored) */

  /***/
},
/* 252 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ZougglaScan = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  exports.isMultiRecipientEncryptedFieldSet = isMultiRecipientEncryptedFieldSet;
  exports.isJWEJSON = isJWEJSON;

  var _react = __webpack_require__(250);

  var _react2 = _interopRequireDefault(_react);

  var _nodeJose = __webpack_require__(558);

  var jose = _interopRequireWildcard(_nodeJose);

  var _es6Promise = __webpack_require__(138);

  var _split = __webpack_require__(528);

  var _split2 = _interopRequireDefault(_split);

  var _keys = __webpack_require__(527);

  var _keys2 = _interopRequireDefault(_keys);

  var _isString = __webpack_require__(524);

  var _isString2 = _interopRequireDefault(_isString);

  var _reactDeviceDetect = __webpack_require__(587);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _asyncToGenerator(fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new _es6Promise.Promise(function (resolve, reject) {
        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            return _es6Promise.Promise.resolve(value).then(function (value) {
              step("next", value);
            }, function (err) {
              step("throw", err);
            });
          }
        }

        return step("next");
      });
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  } //import { BrowserRouter as Router, Route, Link } from "react-router-dom";
  //import QRCode from 'react-qr-code';


  var awsIot = __webpack_require__(259); //--------------------------------------------------------------------------------------


  var globalstage = 'prod';

  var devlog = function devlog(msg) {
    if (globalstage === 'dev') {
      console.log('[devlog] ' + msg);
    }
  }; //--------------------------------------------------------------------------------------


  var ZougglaScan = exports.ZougglaScan = function (_Component) {
    _inherits(ZougglaScan, _Component);

    function ZougglaScan(props) {
      _classCallCheck(this, ZougglaScan);

      var _this = _possibleConstructorReturn(this, (ZougglaScan.__proto__ || Object.getPrototypeOf(ZougglaScan)).call(this, props));

      _this.state = {
        showZoucan: _this.props.showZoucan || false,
        scannedCode: _this.props.scannedCode || false,
        showMessage: false,
        qrSize: _this.props.qrSize || '128',
        qrBgColor: _this.props.qrBgColor || '#ffffff',
        qrFgColor: _this.props.qrFgColor || '#000000',
        qrLevel: _this.props.qrLevel || 'L',
        stageLevel: _this.props.stageLevel || 'prod'
      };
      _this.showBird = _this.showBird.bind(_this);
      _this.onScannedCode = _this.onScannedCode.bind(_this);
      globalstage = _this.state.stageLevel;
      return _this;
    }

    _createClass(ZougglaScan, [{
      key: 'showBird',
      value: function showBird() {
        this.setState({
          showZoucan: true
        });
      }
    }, {
      key: 'onScannedCode',
      value: function onScannedCode() {
        if (this.props.onScannedCode && typeof this.props.onScannedCode === 'function') this.props.onScannedCode();
        this.setState({
          scannedCode: true,
          showMessage: true
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var divScannedBox = {
          backgroundColor: 'white',
          padding: '20px',
          color: 'black',
          fontFamily: '"Open Sans", sans-serif',
          fontSize: '12px',
          fontWeight: 'bold',
          fontStyle: 'normal',
          fontStretch: 'normal',
          lineHeight: 'normal',
          letterSpacing: 'normal',
          textAlign: 'center'
        };

        if (!this.props.toshow) {
          //} || this.state.scannedCode) {
          //console.log("not showing anything");
          return null;
        } else if (this.state.showZoucan) {
          return _react2.default.createElement('div', null, 'Thanks for using Zouggla\'s Zatabank');
        } else if (this.state.showMessage) {
          return _react2.default.createElement('div', {
            style: divScannedBox
          }, 'QR Code Scanned!', _react2.default.createElement('br', null), _react2.default.createElement('br', null), _react2.default.createElement('img', {
            src: 'https://zouggla.com/i/group.png'
          }), _react2.default.createElement('br', null), ' ', _react2.default.createElement('br', null), _react2.default.createElement('div', {
            style: {
              fontSize: '8px',
              fontWeight: 'normal'
            }
          }, 'Proceed with your Zouggla App.'));
        } else {
          devlog('apiKey:' + this.props.apiKey);
          return _react2.default.createElement('div', null, _react2.default.createElement(QRFromInvoice, {
            invoiceDetails: this.props.data,
            invoiceType: this.props.type,
            mainCallback: this.props.howtoreturn,
            qrSize: this.state.qrSize,
            qrBgColor: this.state.qrBgColor,
            qrFgColor: this.state.qrFgcolor,
            qrLevel: this.state.qrLevel,
            showBird: this.showBird,
            onScannedCode: this.onScannedCode,
            apiKey: this.props.apiKey,
            stageLevel: this.props.stageLevel
          }));
        }
      }
    }]);

    return ZougglaScan;
  }(_react.Component); //--------------------------------------------------------------------------------------
  //--------------------------------------------------------------------------------------


  var QRFromInvoice = function (_React$Component) {
    _inherits(QRFromInvoice, _React$Component);

    function QRFromInvoice(props) {
      _classCallCheck(this, QRFromInvoice);

      var _this2 = _possibleConstructorReturn(this, (QRFromInvoice.__proto__ || Object.getPrototypeOf(QRFromInvoice)).call(this, props));

      _this2.state = {
        uuid: null,
        hasLoaded: false,
        accessKey: null,
        iotEndpoint: null,
        region: null,
        secretKey: null,
        sessionToken: null
      };
      return _this2;
    } //-------------------------------------------------------


    _createClass(QRFromInvoice, [{
      key: 'getUUID',
      value: function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(stage, type, key, load) {
          var _this3 = this;

          var request, iotRequest, baseURL, urlSuffix, fetchURL;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  //-----------------------------------------------------
                  request = function () {
                    var _ref2 = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee(fetchURL, key, load, stage) {
                      var response, json, iotKeyURLbase, iotKeyURL, iotResp;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              //      console.log(fetchURL, key, JSON.stringify(load));
                              response = void 0;
                              json = void 0;

                              if (!(fetchURL === '')) {
                                _context.next = 6;
                                break;
                              }

                              json = {
                                status: true,
                                json: {
                                  uuid: load.uuid
                                }
                              };
                              _context.next = 12;
                              break;

                            case 6:
                              _context.next = 8;
                              return fetch(fetchURL, {
                                method: 'POST',
                                headers: {
                                  'Content-Type': 'application/json',
                                  'x-api-key': key
                                },
                                body: JSON.stringify(load)
                              });

                            case 8:
                              response = _context.sent;
                              _context.next = 11;
                              return response.json();

                            case 11:
                              json = _context.sent;

                            case 12:
                              if (!(typeof json.json.iotKeys === 'undefined')) {
                                _context.next = 22;
                                break;
                              } // console.log('not found in resp');


                              iotKeyURLbase = 'https://ipa.zouggla.com';

                              if (stage === 'dev') {
                                iotKeyURLbase = 'https://devipa.zouggla.com';
                              } //        let iotKeyURL = iotKeyURLbase + '/helper/iot/keys';


                              iotKeyURL = iotKeyURLbase + '/zdk/iot/keys';
                              _context.next = 18;
                              return iotRequest(iotKeyURL, key);

                            case 18:
                              iotResp = _context.sent; //const iotjson = await iotResp.json();

                              json.json.iotKeys = iotResp;
                              _context.next = 22;
                              break;

                            case 22:
                              return _context.abrupt('return', json);

                            case 23:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this3);
                    }));

                    return function request(_x5, _x6, _x7, _x8) {
                      return _ref2.apply(this, arguments);
                    };
                  }(); //-----------------------------------------------------


                  iotRequest = function () {
                    var _ref3 = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee2(iotURL, key) {
                      var response, json;
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.next = 2;
                              return fetch(iotURL, {
                                method: 'GET',
                                headers: {
                                  'x-api-key': key
                                }
                              });

                            case 2:
                              response = _context2.sent;
                              _context2.next = 5;
                              return response.json();

                            case 5:
                              json = _context2.sent;
                              return _context2.abrupt('return', json);

                            case 7:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this3);
                    }));

                    return function iotRequest(_x9, _x10) {
                      return _ref3.apply(this, arguments);
                    };
                  }(); //-----------------------------------------------------


                  if (!(type === 'uuid')) {
                    _context3.next = 8;
                    break;
                  }

                  _context3.next = 5;
                  return request('', key, load, stage);

                case 5:
                  return _context3.abrupt('return', _context3.sent);

                case 8:
                  baseURL = 'https://' + (stage === 'prod' ? //          ? 'ipa.zouggla.com/webkit/'
                  //         : 'devipa.zouggla.com/webkit/');
                  'ipa.zouggla.com/zdk/' : 'devipa.zouggla.com/zdk/');
                  urlSuffix = '';
                  _context3.t0 = type;
                  _context3.next = _context3.t0 === 'login' ? 13 : _context3.t0 === 'loginv2' ? 15 : 17;
                  break;

                case 13:
                  urlSuffix = 'datainvoice';
                  return _context3.abrupt('break', 18);

                case 15:
                  urlSuffix = 'logincontract';
                  return _context3.abrupt('break', 18);

                case 17:
                  urlSuffix = 'contract';

                case 18:
                  fetchURL = baseURL + urlSuffix;
                  _context3.next = 21;
                  return request(fetchURL, key, load, stage);

                case 21:
                  return _context3.abrupt('return', _context3.sent);

                case 22:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function getUUID(_x, _x2, _x3, _x4) {
          return _ref.apply(this, arguments);
        }

        return getUUID;
      }() //-------------------------------------------------------

    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this4 = this;

        var payload = this.props.invoiceDetails;
        var invoiceType = this.props.invoiceType;
        var theStage = 'prod';

        if (this.props.stageLevel && this.props.stageLevel === 'dev') {
          theStage = 'dev';
        }

        this.getUUID(theStage, invoiceType, this.props.apiKey, payload).then(function (response) {
          var uuid = response.json.uuid;

          _this4.setState({
            uuid: uuid
          }); //            console.log(data);
          //            this.setState({ accessKey: data.accessKey });
          //           this.setState({ iotEndpoint: data.iotEndpoint });
          //          this.setState({ region: data.region });
          //         this.setState({ secretKey: data.secretKey });
          //        this.setState({ sessionToken: data.sessionToken });

          /*
          // moved the following iotKey fetch code into getUUID() on Nov 30 2018, since that now is sometimes
          // returning the iotKeys itself
          let iotKeyURLbase = 'https://ipa.zouggla.com';
          if (theStage === 'dev') {
            iotKeyURLbase = 'https://devipa.zouggla.com';
          }
          let iotKeyURL = iotKeyURLbase + '/helper/iot/keys';
          return fetch(iotKeyURL, {
            method: 'GET',
            headers: {
              'x-api-key': this.props.apiKey
            }
          })
            .then(response => {
              //console.log(response);
              return response.json();
            })
            .then(data => {
          */


          _this4.setState({
            accessKey: response.json.iotKeys.accessKey
          });

          _this4.setState({
            iotEndpoint: response.json.iotKeys.iotEndpoint
          });

          _this4.setState({
            region: response.json.iotKeys.region
          });

          _this4.setState({
            secretKey: response.json.iotKeys.secretKey
          });

          _this4.setState({
            sessionToken: response.json.iotKeys.sessionToken
          });

          var iotTopic = '/zbox/txack/' + _this4.state.uuid; //this.props.uuid;
          //            console.log('topic is: ', iotTopic);
          //console.log("BEFOREIOT: ", this.props.mainCallback);

          IoT.connect(iotTopic, response.json.iotKeys.iotEndpoint, response.json.iotKeys.region, response.json.iotKeys.accessKey, response.json.iotKeys.secretKey, response.json.iotKeys.sessionToken, _this4.props.mainCallback, _this4.props.showBird, _this4.props.onScannedCode); //this.setState({ uuid: data.json.uuid });

          _this4.setState({
            hasLoaded: true
          }); //console.log("the UUID is: ", data.json.uuid);

        }); //}
        //);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement('div', {
          className: 'qr'
        }, _react2.default.createElement('h2', null, _react2.default.createElement(WaitQRCode, {
          hasLoaded: this.state.hasLoaded,
          uuid: this.state.uuid,
          qrSize: this.props.qrSize,
          qrBgColor: this.props.qrBgColor,
          qrFgColor: this.props.qrFgcolor,
          qrLevel: this.props.qrLevel,
          stageLevel: this.props.stageLevel
        })));
      }
    }]);

    return QRFromInvoice;
  }(_react2.default.Component); //--------------------------------------------------------------------------------------


  var WaitQRCode = function (_React$Component2) {
    _inherits(WaitQRCode, _React$Component2);

    function WaitQRCode() {
      _classCallCheck(this, WaitQRCode);

      return _possibleConstructorReturn(this, (WaitQRCode.__proto__ || Object.getPrototypeOf(WaitQRCode)).apply(this, arguments));
    }

    _createClass(WaitQRCode, [{
      key: 'render',
      value: function render() {
        if (this.props.hasLoaded) {
          return _react2.default.createElement('div', null, _react2.default.createElement(OurQRCode, {
            value: this.props.uuid,
            stageLevel: this.props.stageLevel
          }));
        } else {
          return _react2.default.createElement('div', null, 'Waiting');
        }
      }
    }]);

    return WaitQRCode;
  }(_react2.default.Component); //--------------------------------------------------------------------------------------


  var OurQRCode = function (_React$Component3) {
    _inherits(OurQRCode, _React$Component3);

    function OurQRCode() {
      _classCallCheck(this, OurQRCode);

      return _possibleConstructorReturn(this, (OurQRCode.__proto__ || Object.getPrototypeOf(OurQRCode)).apply(this, arguments));
    }

    _createClass(OurQRCode, [{
      key: 'render',
      value: function render() {
        // Original URL:  https://ryaevjj25e.execute-api.us-west-2.amazonaws.com/prod/%7Buuid%7D
        // https://devipa.zouggla.com/helper/qr/123e4567-e89b-12d3-a456-426655440000
        // https://ipa.zouggla.com/helper/qr/123e4567-e89b-12d3-a456-426655440000
        var qrURL = 'https://a.zouggla.com/a/' + this.props.value;
        var devqrURL = 'https://deva.zouggla.com/a/' + this.props.value;
        var encURL = encodeURIComponent(qrURL);
        var devencURL = encURL; //encodeURIComponent(devqrURL);
        //    const devencURL = encodeURIComponent(devqrURL);
        //    const devurl = 'https://devipa.zouggla.com/helper/qr/' + devencURL;
        //   const produrl = 'https://ipa.zouggla.com/helper/qr/' + encURL;

        var devurl = 'https://devipa.zouggla.com/zdk/qr/' + devencURL;
        var produrl = 'https://ipa.zouggla.com/zdk/qr/' + encURL;
        var prodclickUrl = 'https://a.zouggla.com/a/' + this.props.value + '?u=' + encodeURI(window.location.href); //  const devclickUrl = 'https://deva.zouggla.com/a/' + this.props.value;

        var devclickUrl = prodclickUrl;
        var imgUrl = this.props.stageLevel === 'dev' ? devurl : produrl;
        var clickUrl = this.props.stageLevel === 'dev' ? devclickUrl : prodclickUrl; //    if (this.props.stageLevel === 'dev') {

        return _react2.default.createElement('div', null, _react2.default.createElement('div', null, _react2.default.createElement(_reactDeviceDetect.BrowserView, null, _react2.default.createElement('img', {
          src: imgUrl
        }))), _react2.default.createElement('div', null, _react2.default.createElement(_reactDeviceDetect.MobileView, null, _react2.default.createElement('a', {
          href: clickUrl
        }, _react2.default.createElement('img', {
          src: imgUrl
        })))));
      }
    }]);

    return OurQRCode;
  }(_react2.default.Component); //--------------------------------------------------------------------------------------


  var client = void 0,
      iotTopic = void 0;
  var IoT = {
    connect: function connect(topic, iotEndpoint, region, accessKey, secretKey, sessionToken, callback, showBird, onScannedCode) {
      iotTopic = topic;
      client = awsIot.device({
        region: region,
        protocol: 'wss',
        accessKeyId: accessKey,
        secretKey: secretKey,
        sessionToken: sessionToken,
        port: 443,
        host: iotEndpoint
      });
      client.on('connect', onConnect);
      client.on('message', function (topic, message) {
        onMessage(topic, message, callback, showBird, onScannedCode);
      });
      client.on('error', onError);
      client.on('reconnect', onReconnect);
      client.on('offline', onOffline);
      client.on('close', onClose);
    },
    send: function send(message) {
      client.publish(iotTopic, message);
    },
    disconnect: function disconnect() {
      client.end();
    }
  }; //--------------------------------------------------------------------------------------

  var onConnect = function onConnect() {
    client.subscribe(iotTopic); //client.subscribe(topic);

    addLog('Connected to: ', iotTopic);
  }; //--------------------------------------------------------------------------------------


  var onMessage = function onMessage(topic, message, callback, showBird, onScannedCode) {
    var msgStr = message.toString('utf-8'); //console.log(msgStr);

    var msgJ = JSON.parse(msgStr); //const msg = msgJ.SNSMessage;

    var date = new Date().toTimeString().slice(0, 8); //  console.log(date, ':' + JSON.stringify(msgJ));

    var status = msgJ.status;

    if (status === 'COMPLETE') {
      var outputsByType = msgJ.outputsByType;
      Object.keys(outputsByType).forEach(function (k) {
        switch (k) {
          case 'id.person.snapshot':
          case 'LoginEvent':
          case 'paymentevent':
          case 'PaymentEvent':
          case 'Currency':
          case 'Coupon':
          case 'Credential':
          case 'AccessEvent':
            var dataItem = outputsByType[k]; //          console.log('[', date, '][', status, ']: ', k + ' - ' + dataItem);
            // we want to take this outputByType[k] and pass it along as the token.

            showBird(); // end the web socket connection before calling the callback

            IoT.disconnect();
            callback(dataItem);
            break;

          default: //          console.log('received a data type not on the list...  (', k, ')');

        }
      });
    } else if (msgJ.scannedCode) {
      //    console.log('received a message of scannedCode:true');
      onScannedCode();
    } else {//    console.log("received a status != 'COMPLETE'");
    }
  }; //--------------------------------------------------------------------------------------


  var onError = function onError() {}; //--------------------------------------------------------------------------------------


  var onReconnect = function onReconnect() {}; //--------------------------------------------------------------------------------------


  var onOffline = function onOffline() {}; //--------------------------------------------------------------------------------------


  var onClose = function onClose() {
    //  addLog('Connection closed');
    devlog('ws connection closed');
  }; //--------------------------------------------------------------------------------------


  var addLog = function addLog(msg) {
    var date = new Date().toTimeString().slice(0, 8);
    devlog('Raw form of message (' + msg + ') received at (' + date + ')'); //console.log("here we are again   (", msg, ") at this time (", date, ")");
    //$("#log").prepend(`<li>[${date}] ${msg}</li>`);
  }; //--------------------------------------------------------------------------------------


  exports.getPK = function (partnerID, apiKey) {
    var stage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'prod'; //  let baseurl = 'https://ipa.zouggla.com/helper/pk';

    var baseurl = 'https://ipa.zouggla.com/zdk/pk';

    if (stage === 'dev') {
      //    baseurl = 'https://devipa.zouggla.com/helper/pk';
      baseurl = 'https://devipa.zouggla.com/zdk/pk';
    }

    var fullurl = baseurl + '?partner=' + partnerID + '&apiKey=' + apiKey;
    devlog('fu:' + fullurl);
    return fetch(fullurl, {
      method: 'GET',
      headers: {
        'x-api-key': apiKey
      }
    }).then(function (response) {
      //console.log(response);
      return response.json();
    });
  }; //--------------------------------------------------------------------------------------


  exports.unpackDataItem = function (jwkset, jwt) {
    // TODO: get key and validate signatures
    var parts = (0, _split2.default)(jwt, '.');
    var stringified = jose.util.base64url.decode(parts[1]).toString('utf8');
    var data = JSON.parse(stringified);

    var result = _extends({}, data);

    var aedpromises = [];
    var promises = [];

    if (data.aed) {
      delete result.aed;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = data.aed.ciphertexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var ct = _step.value;
          aedpromises.push(decryptCipherText(jwkset, ct));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = (0, _keys2.default)(data)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var k = _step2.value;

        if (isMultiRecipientEncryptedFieldSet(data[k])) {
          var decrypted = decryptCipherText(jwkset, data[k].jwe);
          delete result[k];
          promises.push(decrypted);
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    var aedPromise = _es6Promise.Promise.all(aedpromises).then(function (decryptions) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = decryptions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var decrypted = _step3.value;
          var parsed = JSON.parse(decrypted);
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = (0, _keys2.default)(parsed)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _k = _step4.value;
              var v = parsed[_k];
              var i = v.indexOf('.');
              var _parts = [v.slice(0, i), v.slice(i + 1)];

              if (_parts[1] && _parts[1] !== 'undefined') {
                result[_k] = JSON.parse(_parts[1]);
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    });

    var plainPromise = _es6Promise.Promise.all(promises).then(function (decryptions) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = decryptions[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var decrypted = _step5.value;

          if (decrypted) {
            var parsed = JSON.parse(decrypted);
            result = _extends({}, result, parsed);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    });

    return _es6Promise.Promise.all([plainPromise, aedPromise]).then(function () {
      return result;
    });
  };

  function decryptCipherText(jwkset, ciphertext) {
    var parsed = (0, _isString2.default)(ciphertext) ? JSON.parse(ciphertext) : ciphertext;
    return jose.JWK.asKeyStore(jwkset).then(function (ks) {
      return jose.JWE.createDecrypt(ks).decrypt(parsed);
    }).then(function (decryptResult) {
      return decryptResult.plaintext.toString('utf8');
    });
  }

  function isMultiRecipientEncryptedFieldSet(obj) {
    return obj && obj.jwe && 'flatten' in obj && isJWEJSON(obj.jwe);
  }

  function isJWEJSON(jwe) {
    return !!jwe && !(0, _isString2.default)(jwe) && Boolean(jwe.ciphertext) && Boolean(jwe.recipients);
  }
  /***/

},
/* 253 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (global) {
    __webpack_require__(462);

    __webpack_require__(463);

    __webpack_require__(263);

    if (global._babelPolyfill) {
      throw new Error("only one instance of babel-polyfill is allowed");
    }

    global._babelPolyfill = true;
    var DEFINE_PROPERTY = "defineProperty";

    function define(O, key, value) {
      O[key] || Object[DEFINE_PROPERTY](O, key, {
        writable: true,
        configurable: true,
        value: value
      });
    }

    define(String.prototype, "padLeft", "".padStart);
    define(String.prototype, "padRight", "".padEnd);
    "pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
      [][key] && define(Array, key, Function.call.bind([][key]));
    });
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10));
  /***/
},
/* 254 */

/***/
function (module, exports) {
  /*
   * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
   *
   * Licensed under the Apache License, Version 2.0 (the "License").
   * You may not use this file except in compliance with the License.
   * A copy of the License is located at
   *
   *  http://aws.amazon.com/apache2.0
   *
   * or in the "license" file accompanying this file. This file is distributed
   * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
   * express or implied. See the License for the specific language governing
   * permissions and limitations under the License.
   */
  //node.js deps
  //npm deps
  //app deps
  //begin module
  module.exports = {
    NO_KEY_OPTION: 'No "keyPath" or "privateKey" option supplied.',
    NO_CERT_OPTION: 'No "certPath" or "clientCert" option supplied.',
    NO_CA_OPTION: 'No "caPath" or "caCert" option supplied.',
    INVALID_KEY_PATH_OPTION: 'Invalid "keyPath" option supplied.',
    INVALID_CERT_PATH_OPTION: 'Invalid "certPath" option supplied.',
    INVALID_CA_PATH_OPTION: 'Invalid "caPath" option supplied.',
    INVALID_CLIENT_CERT_OPTION: 'Invalid "clientCert" option supplied.',
    INVALID_PRIVATE_KEY_OPTION: 'Invalid "privateKey" option supplied.',
    INVALID_CA_CERT_OPTION: 'Invalid "caCert" option supplied.'
  };
  /***/
},
/* 255 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (Buffer) {
    /*
    * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
    *
    * Licensed under the Apache License, Version 2.0 (the "License").
    * You may not use this file except in compliance with the License.
    * A copy of the License is located at
    *
    *  http://aws.amazon.com/apache2.0
    *
    * or in the "license" file accompanying this file. This file is distributed
    * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
    * express or implied. See the License for the specific language governing
    * permissions and limitations under the License.
    */
    //node.js deps
    var filesys = __webpack_require__(157); //npm deps
    //app deps


    var isUndefined = __webpack_require__(85);

    var exceptions = __webpack_require__(254); //begin module

    /**
     * This method is the exposed module; it validates and prepares the tls
     * options as required for connection to the AWS IoT service.
     *
     * @param {Object} options
     * @access public
     */


    module.exports = function (options) {
      // verify certificate paths
      if (isUndefined(options.keyPath) && isUndefined(options.privateKey)) {
        throw new Error(exceptions.NO_KEY_OPTION);
      }

      if (isUndefined(options.certPath) && isUndefined(options.clientCert)) {
        throw new Error(exceptions.NO_CERT_OPTION);
      }

      if (isUndefined(options.caPath) && isUndefined(options.caCert)) {
        throw new Error(exceptions.NO_CA_OPTION);
      } //
      // Certificates and private keys may be passed in files using options
      // ending in 'Path', e.g. 'keyPath', 'certPath', and 'caPath'.  In addition,
      // they can also be passed in as buffers or files using the options
      // 'privateKey', 'clientCert', and 'caCert'.  This second set is the one
      // that the AWS Console generates a JSON configuration document for.
      //


      if (!isUndefined(options.caCert)) {
        if (Buffer.isBuffer(options.caCert)) {
          options.ca = options.caCert;
        } else {
          if (filesys.existsSync(options.caCert)) {
            options.ca = filesys.readFileSync(options.caCert);
          } else {
            throw new Error(exceptions.INVALID_CA_CERT_OPTION);
          }
        }
      }

      if (!isUndefined(options.privateKey)) {
        if (Buffer.isBuffer(options.privateKey)) {
          options.key = options.privateKey;
        } else {
          if (filesys.existsSync(options.privateKey)) {
            options.key = filesys.readFileSync(options.privateKey);
          } else {
            throw new Error(exceptions.INVALID_PRIVATE_KEY_OPTION);
          }
        }
      }

      if (!isUndefined(options.clientCert)) {
        if (Buffer.isBuffer(options.clientCert)) {
          options.cert = options.clientCert;
        } else {
          if (filesys.existsSync(options.clientCert)) {
            options.cert = filesys.readFileSync(options.clientCert);
          } else {
            throw new Error(exceptions.INVALID_CLIENT_CERT_OPTION);
          }
        }
      } // Parse PEM files.  Options ending in 'Path' must be files
      // and will override options which do not end in 'Path'.


      if (filesys.existsSync(options.keyPath)) {
        options.key = filesys.readFileSync(options.keyPath);
      } else if (!isUndefined(options.keyPath)) {
        throw new Error(exceptions.INVALID_KEY_PATH_OPTION);
      }

      if (filesys.existsSync(options.certPath)) {
        options.cert = filesys.readFileSync(options.certPath);
      } else if (!isUndefined(options.certPath)) {
        throw new Error(exceptions.INVALID_CERT_PATH_OPTION);
      }

      if (filesys.existsSync(options.caPath)) {
        options.ca = filesys.readFileSync(options.caPath);
      } else if (!isUndefined(options.caPath)) {
        throw new Error(exceptions.INVALID_CA_PATH_OPTION);
      } // request certificate from partner


      options.requestCert = true; // require certificate authentication

      options.rejectUnauthorized = true;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 256 */

/***/
function (module, exports) {
  /*
   * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
   *
   * Licensed under the Apache License, Version 2.0 (the "License").
   * You may not use this file except in compliance with the License.
   * A copy of the License is located at
   *
   *  http://aws.amazon.com/apache2.0
   *
   * or in the "license" file accompanying this file. This file is distributed
   * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
   * express or implied. See the License for the specific language governing
   * permissions and limitations under the License.
   */
  //node.js deps
  //npm deps
  //app deps
  //begin module
  module.exports = {
    INVALID_CONNECT_OPTIONS: 'Invalid connect options supplied.',
    INVALID_CLIENT_ID_OPTION: 'Invalid "clientId" (mqtt client id) option supplied.',
    INVALID_RECONNECT_TIMING: 'Invalid reconnect timing options supplied.',
    INVALID_OFFLINE_QUEUEING_PARAMETERS: 'Invalid offline queueing options supplied.'
  };
  /***/
},
/* 257 */

/***/
function (module, exports, __webpack_require__) {
  /*
   * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
   *
   * Licensed under the Apache License, Version 2.0 (the "License").
   * You may not use this file except in compliance with the License.
   * A copy of the License is located at
   *
   *  http://aws.amazon.com/apache2.0
   *
   * or in the "license" file accompanying this file. This file is distributed
   * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
   * express or implied. See the License for the specific language governing
   * permissions and limitations under the License.
   */
  //node.js deps
  var tls = __webpack_require__(157); //npm deps
  //app deps


  function buildBuilder(mqttClient, opts) {
    var connection;
    connection = tls.connect(opts);

    function handleTLSerrors(err) {
      mqttClient.emit('error', err);
      connection.end();
    }

    connection.on('secureConnect', function () {
      if (!connection.authorized) {
        connection.emit('error', new Error('TLS not authorized'));
      } else {
        connection.removeListener('error', handleTLSerrors);
      }
    });
    connection.on('error', handleTLSerrors);
    return connection;
  }

  module.exports = buildBuilder;
  /***/
},
/* 258 */

/***/
function (module, exports, __webpack_require__) {
  /*
   * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
   *
   * Licensed under the Apache License, Version 2.0 (the "License").
   * You may not use this file except in compliance with the License.
   * A copy of the License is located at
   *
   *  http://aws.amazon.com/apache2.0
   *
   * or in the "license" file accompanying this file. This file is distributed
   * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
   * express or implied. See the License for the specific language governing
   * permissions and limitations under the License.
   */
  //node.js deps
  //npm deps
  var websocket = __webpack_require__(160); //app deps


  function buildBuilder(client, opts) {
    return websocket(opts.url, ['mqttv3.1'], opts.websocketOptions);
  }

  module.exports = buildBuilder;
  /***/
},
/* 259 */

/***/
function (module, exports, __webpack_require__) {
  /*
   * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
   *
   * Licensed under the Apache License, Version 2.0 (the "License").
   * You may not use this file except in compliance with the License.
   * A copy of the License is located at
   *
   *  http://aws.amazon.com/apache2.0
   *
   * or in the "license" file accompanying this file. This file is distributed
   * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
   * express or implied. See the License for the specific language governing
   * permissions and limitations under the License.
   */

  /*
   * Expose AWS IoT Embedded Javascript SDK modules
   */
  module.exports.device = __webpack_require__(108);
  module.exports.thingShadow = __webpack_require__(262);
  module.exports.jobs = __webpack_require__(260);
  /***/
},
/* 260 */

/***/
function (module, exports, __webpack_require__) {
  /*
   * Copyright 2010-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
   *
   * Licensed under the Apache License, Version 2.0 (the "License").
   * You may not use this file except in compliance with the License.
   * A copy of the License is located at
   *
   *  http://aws.amazon.com/apache2.0
   *
   * or in the "license" file accompanying this file. This file is distributed
   * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
   * express or implied. See the License for the specific language governing
   * permissions and limitations under the License.
   */
  //node.js deps
  var events = __webpack_require__(41);

  var inherits = __webpack_require__(74).inherits; //npm deps
  //app deps


  var deviceModule = __webpack_require__(108);

  var isUndefined = __webpack_require__(85); //
  // private functions
  //


  function isJobTopic(topicTokens) {
    //
    // Job topics have the forms:
    //
    //      $aws/things/{thingName}/jobs/#
    //
    return topicTokens[0] === '$aws' && topicTokens[1] === 'things' && topicTokens[3] === 'jobs';
  }

  function buildJobTopic(thingName, jobId, operation) {
    var result = '$aws/things/' + thingName + '/jobs/'; // check for omitted jobId and fixup parameters

    if (isUndefined(operation)) {
      operation = jobId;
    } else {
      result += jobId.toString() + '/';
    }

    result += operation;
    return result;
  } //begin module


  function jobsClient(options) {
    //
    // Force instantiation using the 'new' operator; this will cause inherited
    // constructors (e.g. the 'events' class) to be called.
    //
    if (!(this instanceof jobsClient)) {
      return new jobsClient(options);
    } //
    // A copy of 'this' for use inside of closures
    //


    var that = this; //
    // Track job subscriptions
    //
    // [
    //    { 
    //       "thingName": "string",
    //       "operations": [
    //          { 
    //             "operationName": "string",  // if null then treat as default
    //             "currentJob": job,
    //             "callback": callback
    //          }
    //       ]
    //    }
    // ]
    //

    var jobSubscriptions = []; //
    // Instantiate the device
    //

    var device = deviceModule.DeviceClient(options); //
    // Private function to update job execution status for given thing
    //

    this._updateJobStatus = function (thingName, job, status, statusDetails, callback) {
      // Check for omitted statusDetails and update parameters
      if (typeof statusDetails === "function") {
        callback = statusDetails;
        statusDetails = undefined;
      }

      if (!isUndefined(options) && options.debug === true) {
        console.log('updateJobStatus:', {
          thingName: thingName,
          jobId: job.id,
          status: status,
          statusDetails: statusDetails
        });
      }

      device.publish(buildJobTopic(thingName, job.id, 'update'), JSON.stringify({
        status: status,
        statusDetails: statusDetails
      }), null, function (err) {
        if (isUndefined(err)) {
          job.status = {
            status: status,
            statusDetails: statusDetails
          };
        }

        if (!isUndefined(callback)) {
          callback(err);
        }
      });
    }; //
    // Private function to build job object for passing to callback supplied in subscribeToJobs
    //


    this._buildJobObject = function (thingName, jobExecution) {
      if (isUndefined(jobExecution) || isUndefined(jobExecution.jobId)) {
        return null;
      }

      var job = {};
      job.id = jobExecution.jobId;
      job.document = jobExecution.jobDocument;
      job.operation = job.document.operation;
      job.status = {
        status: jobExecution.status,
        statusDetails: jobExecution.statusDetails
      };

      job.inProgress = function (statusDetails, callback) {
        that._updateJobStatus(thingName, job, 'IN_PROGRESS', statusDetails, callback);
      };

      job.failed = function (statusDetails, callback) {
        that._updateJobStatus(thingName, job, 'FAILED', statusDetails, callback);
      };

      job.succeeded = function (statusDetails, callback) {
        that._updateJobStatus(thingName, job, 'SUCCEEDED', statusDetails, callback);
      };

      return job;
    }; //
    // Private function to handle job messages and process them accordingly
    //


    this._handleMessages = function (topic, payload) {
      var topicTokens = topic.split('/'); // If not a job topic emit to application and return

      if (!isJobTopic(topicTokens)) {
        that.emit('message', topic, payload);
        return;
      }

      var thingName = topicTokens[2];
      var thing = jobSubscriptions.find(function (elem) {
        return elem.thingName === thingName;
      }); // Do nothing if thing not found in job subscriptions 

      if (isUndefined(thing)) {
        return;
      }

      var jobExecutionData = {};

      try {
        jobExecutionData = JSON.parse(payload.toString());
      } catch (err) {
        if (options.debug === true) {
          console.error('failed parsing JSON \'' + payload.toString() + '\', ' + err);
        }

        return;
      }

      if (isUndefined(jobExecutionData.execution) || isUndefined(jobExecutionData.execution.jobId) || isUndefined(jobExecutionData.execution.jobDocument)) {
        return;
      }

      var operationName = jobExecutionData.execution.jobDocument.operation;
      var operation = thing.operations.find(function (elem) {
        return isUndefined(operationName) ? isUndefined(elem.operationName) : operationName === elem.operationName;
      }); // If operation subscription not found by operation name then look for default operation subscription

      if (isUndefined(operation)) {
        operation = thing.operations.find(function (elem) {
          return isUndefined(elem.operationName);
        });

        if (isUndefined(operation)) {
          return;
        }
      }

      operation.callback(null, that._buildJobObject(thingName, jobExecutionData.execution));
    };

    this.subscribeToJobs = function (thingName, operationName, callback) {
      // Check for omitted optional operationName and fixup parameters
      if (isUndefined(callback)) {
        callback = operationName;
        operationName = null;
      }

      if (!isUndefined(options) && options.debug === true) {
        console.log('subscribeToJobs:', {
          thingName: thingName,
          operationName: operationName
        });
      }

      var thing = jobSubscriptions.find(function (elem) {
        return elem.thingName === thingName;
      }); // Check for previously unseen thing and add to job subscriptions

      if (isUndefined(thing)) {
        thing = {
          thingName: thingName,
          operations: []
        };
        jobSubscriptions.push(thing);
        device.subscribe([buildJobTopic(thingName, '$next/get/accepted'), buildJobTopic(thingName, 'notify-next')], function (err, granted) {
          if (!isUndefined(err)) {
            callback(err);
          }
        });
      } // Find existing subscription for the given operationName


      var operation = thing.operations.find(function (elem) {
        return isUndefined(operationName) ? isUndefined(elem.operationName) : operationName === elem.operationName;
      }); // If existing subscription found then update callback, otherwise create new entry in the thing's operations array

      if (!isUndefined(operation)) {
        operation.callback = callback;
      } else {
        operation = {
          operationName: operationName,
          callback: callback
        };
        thing.operations.push(operation);
      }
    };

    this.unsubscribeFromJobs = function (thingName, operationName, callback) {
      // Check for omitted optional operationName and fixup parameters
      if (isUndefined(callback)) {
        callback = operationName;
        operationName = null;
      }

      if (!isUndefined(options) && options.debug === true) {
        console.log('unsubscribeFromJobs:', {
          thingName: thingName,
          operationName: operationName
        });
      }

      var iThing = jobSubscriptions.findIndex(function (elem) {
        return elem.thingName === thingName;
      });
      var notFoundError = new Error('subscription not found for given thing'); // Check for previously unseen thing and add to job subscriptions and publish to get to retrieve first job to be executed

      if (iThing < 0) {
        callback(notFoundError);
        return;
      }

      var iOperation = jobSubscriptions[iThing].operations.findIndex(function (elem) {
        return isUndefined(operationName) ? isUndefined(elem.operationName) : operationName === elem.operationName;
      });

      if (iOperation < 0) {
        callback(notFoundError);
        return;
      }

      jobSubscriptions[iThing].operations.splice(iOperation, 1);

      if (jobSubscriptions[iThing].operations.length === 0) {
        jobSubscriptions.splice(iThing, 1);
        device.unsubscribe([buildJobTopic(thingName, '$next/get/accepted'), buildJobTopic(thingName, 'notify-next')], callback);
        return;
      }

      callback();
    };

    this.startJobNotifications = function (thingName, callback) {
      if (!isUndefined(options) && options.debug === true) {
        console.log('startJobNotifications:', {
          thingName: thingName
        });
      }

      device.publish(buildJobTopic(thingName, '$next', 'get'), '{}', callback);
    };

    device.on('connect', function () {
      that.emit('connect');
    });
    device.on('close', function () {
      that.emit('close');
    });
    device.on('reconnect', function () {
      that.emit('reconnect');
    });
    device.on('offline', function () {
      that.emit('offline');
    });
    device.on('error', function (error) {
      that.emit('error', error);
    });
    device.on('message', that._handleMessages);
    this.publish = device.publish;
    this.subscribe = device.subscribe;
    this.unsubscribe = device.unsubscribe;
    this.end = device.end;
    this.handleMessage = device.handleMessage;
    this.updateWebSocketCredentials = device.updateWebSocketCredentials; //
    // Used for integration testing only
    //

    this.simulateNetworkFailure = device.simulateNetworkFailure;
  } //
  // Allow instances to listen in on events that we produce for them
  //


  inherits(jobsClient, events.EventEmitter);
  module.exports = jobsClient;
  /***/
},
/* 261 */

/***/
function (module, exports) {
  module.exports = {
    "_args": [["aws-iot-device-sdk@2.2.1", "/Users/mark/Zouggla/git/zouggla-sdk/web/react"]],
    "_from": "aws-iot-device-sdk@2.2.1",
    "_id": "aws-iot-device-sdk@2.2.1",
    "_inBundle": false,
    "_integrity": "sha1-Dff6i0xSBNJNil9yoSzkMwGwnFM=",
    "_location": "/aws-iot-device-sdk",
    "_phantomChildren": {},
    "_requested": {
      "type": "version",
      "registry": true,
      "raw": "aws-iot-device-sdk@2.2.1",
      "name": "aws-iot-device-sdk",
      "escapedName": "aws-iot-device-sdk",
      "rawSpec": "2.2.1",
      "saveSpec": null,
      "fetchSpec": "2.2.1"
    },
    "_requiredBy": ["/"],
    "_resolved": "https://registry.npmjs.org/aws-iot-device-sdk/-/aws-iot-device-sdk-2.2.1.tgz",
    "_spec": "2.2.1",
    "_where": "/Users/mark/Zouggla/git/zouggla-sdk/web/react",
    "author": {
      "name": "Amazon Web Services",
      "url": "http://aws.amazon.com"
    },
    "bugs": {
      "url": "http://github.com/aws/aws-iot-device-sdk-js/issues"
    },
    "dependencies": {
      "crypto-js": "3.1.6",
      "minimist": "1.2.0",
      "mqtt": "2.15.1",
      "websocket-stream": "^5.0.1"
    },
    "description": "AWS IoT Node.js SDK for Embedded Devices",
    "devDependencies": {
      "gulp": "^3.9.0",
      "gulp-beautify": "^2.0.0",
      "gulp-concat": "^2.6.0",
      "gulp-coverage": "^0.3.38",
      "gulp-jscs": "^4.0.0",
      "gulp-jshint": "^2.0.0",
      "gulp-mocha": "^3.0.1",
      "jshint": "^2.9.1",
      "jshint-stylish": "^2.2.1",
      "rewire": "^2.5.1",
      "sinon": "^1.17.3"
    },
    "engines": {
      "node": ">=4.0.0"
    },
    "homepage": "https://github.com/aws/aws-iot-device-sdk-js",
    "keywords": ["api", "amazon", "aws", "iot", "mqtt"],
    "license": "Apache-2.0",
    "main": "index.js",
    "name": "aws-iot-device-sdk",
    "repository": {
      "type": "git",
      "url": "git://github.com/aws/aws-iot-device-sdk-js.git"
    },
    "scripts": {
      "beautify": "node ./node_modules/gulp/bin/gulp.js beautify",
      "browserize": "./scripts/browserize.sh",
      "test": "node ./node_modules/gulp/bin/gulp.js test --verbose"
    },
    "version": "2.2.1"
    /***/

  };
},
/* 262 */

/***/
function (module, exports, __webpack_require__) {
  /*
   * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
   *
   * Licensed under the Apache License, Version 2.0 (the "License").
   * You may not use this file except in compliance with the License.
   * A copy of the License is located at
   *
   *  http://aws.amazon.com/apache2.0
   *
   * or in the "license" file accompanying this file. This file is distributed
   * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
   * express or implied. See the License for the specific language governing
   * permissions and limitations under the License.
   */
  //node.js deps
  var events = __webpack_require__(41);

  var inherits = __webpack_require__(74).inherits; //npm deps
  //app deps


  var deviceModule = __webpack_require__(108);

  var isUndefined = __webpack_require__(85); //
  // private functions
  //


  function buildThingShadowTopic(thingName, operation, type) {
    if (!isUndefined(type)) {
      return '$aws/things/' + thingName + '/shadow/' + operation + '/' + type;
    }

    return '$aws/things/' + thingName + '/shadow/' + operation;
  }

  function isReservedTopic(topic) {
    if (topic.substring(0, 12) === '$aws/things/') {
      return true;
    }

    return false;
  }

  function isThingShadowTopic(topicTokens, direction) {
    var rc = false;

    if (topicTokens[0] === '$aws') {
      //
      // Thing shadow topics have the form:
      //
      //      $aws/things/{thingName}/shadow/{Operation}/{Status}
      //
      // Where {Operation} === update|get|delete
      //   And    {Status} === accepted|rejected|delta
      //
      if (topicTokens[1] === 'things' && topicTokens[3] === 'shadow' && (topicTokens[4] === 'update' || topicTokens[4] === 'get' || topicTokens[4] === 'delete')) {
        //
        // Looks good so far; now check the direction and see if
        // still makes sense.
        //
        if (direction === 'subscribe') {
          if ((topicTokens[5] === 'accepted' || topicTokens[5] === 'rejected' || topicTokens[5] === 'delta') && topicTokens.length === 6) {
            rc = true;
          }
        } else // direction === 'publish'
          {
            if (topicTokens.length === 5) {
              rc = true;
            }
          }
      }
    }

    return rc;
  } //begin module


  function ThingShadowsClient(deviceOptions, thingShadowOptions) {
    //
    // Force instantiation using the 'new' operator; this will cause inherited
    // constructors (e.g. the 'events' class) to be called.
    //
    if (!(this instanceof ThingShadowsClient)) {
      return new ThingShadowsClient(deviceOptions, thingShadowOptions);
    } //
    // A copy of 'this' for use inside of closures
    //


    var that = this; //
    // Track Thing Shadow registrations in here.
    //

    var thingShadows = [{}]; //
    // Implements for every operation, used to construct clientToken.
    //

    var operationCount = 0; //
    // Operation timeout (milliseconds).  If no accepted or rejected response
    // to a thing operation is received within this time, subscriptions
    // to the accepted and rejected sub-topics for a thing are cancelled.
    //

    var operationTimeout = 10000;
    /* milliseconds */
    //
    // Variable used by the testing API setConnectionStatus() to simulate
    // network connectivity failures.
    //

    var connected = true; //
    // Instantiate the device.
    //

    var device = deviceModule.DeviceClient(deviceOptions);

    if (!isUndefined(thingShadowOptions)) {
      if (!isUndefined(thingShadowOptions.operationTimeout)) {
        operationTimeout = thingShadowOptions.operationTimeout;
      }
    } //
    // Private function to subscribe and unsubscribe from topics.
    //


    this._handleSubscriptions = function (thingName, topicSpecs, devFunction, callback) {
      var topics = []; //
      // Build an array of topic names.
      //

      for (var i = 0, topicsLen = topicSpecs.length; i < topicsLen; i++) {
        for (var j = 0, opsLen = topicSpecs[i].operations.length; j < opsLen; j++) {
          for (var k = 0, statLen = topicSpecs[i].statii.length; k < statLen; k++) {
            topics.push(buildThingShadowTopic(thingName, topicSpecs[i].operations[j], topicSpecs[i].statii[k]));
          }
        }
      }

      if (thingShadows[thingName].debug === true) {
        console.log(devFunction + ' on ' + topics);
      } //
      // Subscribe/unsubscribe from the topics and perform callback when complete.
      //


      var args = [];
      args.push(topics);

      if (devFunction === 'subscribe') {
        // QoS only applicable for subscribe
        args.push({
          qos: thingShadows[thingName].qos
        }); // add our callback to check the SUBACK response for granted subscriptions

        args.push(function (err, granted) {
          if (!isUndefined(callback)) {
            if (err) {
              callback(err);
              return;
            } //
            // Check to see if we got all topic subscriptions granted.
            //


            var failedTopics = [];

            for (var k = 0, grantedLen = granted.length; k < grantedLen; k++) {
              //
              // 128 is 0x80 - Failure from the MQTT lib.
              //
              if (granted[k].qos === 128) {
                failedTopics.push(granted[k]);
              }
            }

            if (failedTopics.length > 0) {
              callback('Not all subscriptions were granted', failedTopics);
              return;
            } // all subscriptions were granted


            callback();
          }
        });
      } else {
        if (!isUndefined(callback)) {
          args.push(callback);
        }
      }

      device[devFunction].apply(device, args);
    }; //
    // Private function to handle messages and dispatch them accordingly.
    //


    this._handleMessages = function (thingName, operation, operationStatus, payload) {
      var stateObject = {};

      try {
        stateObject = JSON.parse(payload.toString());
      } catch (err) {
        if (deviceOptions.debug === true) {
          console.error('failed parsing JSON \'' + payload.toString() + '\', ' + err);
        }

        return;
      }

      var clientToken = stateObject.clientToken;
      var version = stateObject.version; //
      // Remove the properties 'clientToken' and 'version' from the stateObject;
      // these properties are internal to this class.
      //

      delete stateObject.clientToken; //Expose shadow version from raw object
      //delete stateObject.version;
      //
      // Update the thing version on every accepted or delta message which 
      // contains it.
      //

      if (!isUndefined(version) && operationStatus !== 'rejected') {
        //
        // The thing shadow version is incremented by AWS IoT and should always
        // increase.  Do not update our local version if the received version is
        // less than our version.  
        //
        if (isUndefined(thingShadows[thingName].version) || version >= thingShadows[thingName].version) {
          thingShadows[thingName].version = version;
        } else {
          //
          // We've received a message from AWS IoT with a version number lower than
          // we would expect.  There are two things that can cause this:
          //
          //  1) The shadow has been deleted (version # reverts to 1 in this case.)
          //  2) The message has arrived out-of-order.
          //
          // For case 1) we can look at the operation to determine that this
          // is the case and notify the client if appropriate.  For case 2, 
          // we will not process it unless the client has specifically expressed
          // an interested in these messages by setting 'discardStale' to false.
          //
          if (operation !== 'delete' && thingShadows[thingName].discardStale === true) {
            if (deviceOptions.debug === true) {
              console.warn('out-of-date version \'' + version + '\' on \'' + thingName + '\' (local version \'' + thingShadows[thingName].version + '\')');
            }

            return;
          }
        }
      } //
      // If this is a 'delta' message, emit an event for it and return.
      //


      if (operationStatus === 'delta') {
        this.emit('delta', thingName, stateObject);
        return;
      } //
      // only accepted/rejected messages past this point
      // ===============================================
      // If this is an unkown clientToken (e.g., it doesn't have a corresponding
      // client token property, the shadow has been modified by another client.
      // If it's an update/accepted or delete/accepted, update the shadow and
      // notify the client.
      //


      if (isUndefined(thingShadows[thingName].clientToken) || thingShadows[thingName].clientToken !== clientToken) {
        if (operationStatus === 'accepted' && operation !== 'get') {
          //
          // This is a foreign update or delete accepted, update our
          // shadow with the latest state and send a notification.
          //
          this.emit('foreignStateChange', thingName, operation, stateObject);
        }

        return;
      } //
      // A response has been received, so cancel any outstanding timeout on this
      // thingName/clientToken, delete the timeout handle, and unsubscribe from
      // all sub-topics.
      //


      clearTimeout(thingShadows[thingName].timeout);
      delete thingShadows[thingName].timeout; //
      // Delete the operation's client token.
      //

      delete thingShadows[thingName].clientToken; //
      // Mark this operation as complete.
      //

      thingShadows[thingName].pending = false; //
      // Unsubscribe from the 'accepted' and 'rejected' sub-topics unless we are
      // persistently subscribed to this thing shadow.
      //

      if (thingShadows[thingName].persistentSubscribe === false) {
        this._handleSubscriptions(thingName, [{
          operations: [operation],
          statii: ['accepted', 'rejected']
        }], 'unsubscribe');
      } //
      // Emit an event detailing the operation status; the clientToken is included
      // as an argument so that the application can correlate status events to
      // the operations they are associated with.
      //


      this.emit('status', thingName, operationStatus, clientToken, stateObject);
    };

    device.on('connect', function () {
      that.emit('connect');
    });
    device.on('close', function () {
      that.emit('close');
    });
    device.on('reconnect', function () {
      that.emit('reconnect');
    });
    device.on('offline', function () {
      that.emit('offline');
    });
    device.on('error', function (error) {
      that.emit('error', error);
    });
    device.on('packetsend', function (packet) {
      that.emit('packetsend', packet);
    });
    device.on('packetreceive', function (packet) {
      that.emit('packetreceive', packet);
    });
    device.on('message', function (topic, payload) {
      if (connected === true) {
        //
        // Parse the topic to determine what to do with it.
        //
        var topicTokens = topic.split('/'); //
        // First, do a rough check to see if we should continue or not.
        //

        if (isThingShadowTopic(topicTokens, 'subscribe')) {
          //
          // This looks like a valid Thing topic, so see if the Thing is in the
          // registered Thing table.
          //
          if (thingShadows.hasOwnProperty(topicTokens[2])) {
            //
            // This is a registered Thing, so perform message handling on it.
            //
            that._handleMessages(topicTokens[2], // thingName
            topicTokens[4], // operation
            topicTokens[5], // status
            payload);
          } //
          // Any messages received for unregistered Things fall here and are ignored.
          //

        } else {
          //
          // This isn't a Thing topic, so pass it along to the instance if they have
          // indicated they want to handle it.
          //
          that.emit('message', topic, payload);
        }
      }
    });

    this._thingOperation = function (thingName, operation, stateObject) {
      var rc = null;

      if (thingShadows.hasOwnProperty(thingName)) {
        //
        // Don't allow a new operation if an existing one is still in process.
        //
        if (thingShadows[thingName].pending === false) {
          //
          // Starting a new operation
          //
          thingShadows[thingName].pending = true; //
          // If not provided, construct a clientToken from the clientId and a rolling 
          // operation count.  The clientToken is transmitted in any published stateObject 
          // and is returned to the caller for each operation.  Applications can use
          // clientToken values to correlate received responses or timeouts with
          // the original operations.
          //

          var clientToken;

          if (isUndefined(stateObject.clientToken)) {
            //
            // AWS IoT restricts client tokens to 64 bytes, so use only the last 48
            // characters of the client ID when constructing a client token.
            //
            var clientIdLength = deviceOptions.clientId.length;

            if (clientIdLength > 48) {
              clientToken = deviceOptions.clientId.substr(clientIdLength - 48) + '-' + operationCount++;
            } else {
              clientToken = deviceOptions.clientId + '-' + operationCount++;
            }
          } else {
            clientToken = stateObject.clientToken;
          } //
          // Remember the client token for this operation; it will be
          // deleted when the operation completes or times out.
          //


          thingShadows[thingName].clientToken = clientToken;
          var publishTopic = buildThingShadowTopic(thingName, operation); //
          // Subscribe to the 'accepted' and 'rejected' sub-topics for this get
          // operation and set a timeout beyond which they will be unsubscribed if 
          // no messages have been received for either of them.
          //

          thingShadows[thingName].timeout = setTimeout(function (thingName, clientToken) {
            //
            // Timed-out.  Unsubscribe from the 'accepted' and 'rejected' sub-topics unless
            // we are persistently subscribing to this thing shadow.
            //
            if (thingShadows[thingName].persistentSubscribe === false) {
              that._handleSubscriptions(thingName, [{
                operations: [operation],
                statii: ['accepted', 'rejected']
              }], 'unsubscribe');
            } //
            // Mark this operation as complete.
            //


            thingShadows[thingName].pending = false; //
            // Emit an event for the timeout; the clientToken is included as an argument
            // so that the application can correlate timeout events to the operations
            // they are associated with.
            //

            that.emit('timeout', thingName, clientToken); //
            // Delete the timeout handle and client token for this thingName.
            //

            delete thingShadows[thingName].timeout;
            delete thingShadows[thingName].clientToken;
          }, operationTimeout, thingName, clientToken); //
          // Subscribe to the 'accepted' and 'rejected' sub-topics unless we are
          // persistently subscribing, in which case we can publish to the topic immediately
          // since we are already subscribed to all applicable sub-topics.
          //

          if (thingShadows[thingName].persistentSubscribe === false) {
            this._handleSubscriptions(thingName, [{
              operations: [operation],
              statii: ['accepted', 'rejected']
            }], 'subscribe', function (err, failedTopics) {
              if (!isUndefined(err) || !isUndefined(failedTopics)) {
                console.warn('failed subscription to accepted/rejected topics');
                return;
              } //
              // If 'stateObject' is defined, publish it to the publish topic for this
              // thingName+operation.
              //


              if (!isUndefined(stateObject)) {
                //
                // Add the version # (if known and versioning is enabled) and 
                // 'clientToken' properties to the stateObject.
                //
                if (!isUndefined(thingShadows[thingName].version) && thingShadows[thingName].enableVersioning) {
                  stateObject.version = thingShadows[thingName].version;
                }

                stateObject.clientToken = clientToken;
                device.publish(publishTopic, JSON.stringify(stateObject), {
                  qos: thingShadows[thingName].qos
                });

                if (!isUndefined(thingShadows[thingName]) && thingShadows[thingName].debug === true) {
                  console.log('publishing \'' + JSON.stringify(stateObject) + ' on \'' + publishTopic + '\'');
                }
              }
            });
          } else {
            //
            // Add the version # (if known and versioning is enabled) and 
            // 'clientToken' properties to the stateObject.
            //
            if (!isUndefined(thingShadows[thingName].version) && thingShadows[thingName].enableVersioning) {
              stateObject.version = thingShadows[thingName].version;
            }

            stateObject.clientToken = clientToken;
            device.publish(publishTopic, JSON.stringify(stateObject), {
              qos: thingShadows[thingName].qos
            });

            if (thingShadows[thingName].debug === true) {
              console.log('publishing \'' + JSON.stringify(stateObject) + ' on \'' + publishTopic + '\'');
            }
          }

          rc = clientToken; // return the clientToken to the caller
        } else {
          if (deviceOptions.debug === true) {
            console.error(operation + ' still in progress on thing: ', thingName);
          }
        }
      } else {
        if (deviceOptions.debug === true) {
          console.error('attempting to ' + operation + ' unknown thing: ', thingName);
        }
      }

      return rc;
    };

    this.register = function (thingName, options, callback) {
      if (!thingShadows.hasOwnProperty(thingName)) {
        //
        // Initialize the registration entry for this thing; because the version # is 
        // not yet known, do not add the property for it yet. The version number 
        // property will be added after the first accepted update from AWS IoT.
        //
        var ignoreDeltas = false;
        var topicSpecs = [];
        thingShadows[thingName] = {
          persistentSubscribe: true,
          debug: false,
          discardStale: true,
          enableVersioning: true,
          qos: 0,
          pending: true
        };

        if (typeof options === 'function') {
          callback = options;
          options = null;
        }

        if (!isUndefined(options)) {
          if (!isUndefined(options.ignoreDeltas)) {
            ignoreDeltas = options.ignoreDeltas;
          }

          if (!isUndefined(options.persistentSubscribe)) {
            thingShadows[thingName].persistentSubscribe = options.persistentSubscribe;
          }

          if (!isUndefined(options.debug)) {
            thingShadows[thingName].debug = options.debug;
          }

          if (!isUndefined(options.discardStale)) {
            thingShadows[thingName].discardStale = options.discardStale;
          }

          if (!isUndefined(options.enableVersioning)) {
            thingShadows[thingName].enableVersioning = options.enableVersioning;
          }

          if (!isUndefined(options.qos)) {
            thingShadows[thingName].qos = options.qos;
          }
        } //
        // Always listen for deltas unless requested otherwise.
        //


        if (ignoreDeltas === false) {
          topicSpecs.push({
            operations: ['update'],
            statii: ['delta']
          });
        } //
        // If we are persistently subscribing, we subscribe to everything we could ever
        // possibly be interested in.  This will provide us the ability to publish
        // without waiting at the cost of potentially increased irrelevant traffic
        // which the application will need to filter out.
        //


        if (thingShadows[thingName].persistentSubscribe === true) {
          topicSpecs.push({
            operations: ['update', 'get', 'delete'],
            statii: ['accepted', 'rejected']
          });
        }

        if (topicSpecs.length > 0) {
          this._handleSubscriptions(thingName, topicSpecs, 'subscribe', function (err, failedTopics) {
            if (isUndefined(err) && isUndefined(failedTopics)) {
              thingShadows[thingName].pending = false;
            }

            if (!isUndefined(callback)) {
              callback(err, failedTopics);
            }
          });
        } else {
          thingShadows[thingName].pending = false;

          if (!isUndefined(callback)) {
            callback();
          }
        }
      } else {
        if (deviceOptions.debug === true) {
          console.error('thing already registered: ', thingName);
        }
      }
    };

    this.unregister = function (thingName) {
      if (thingShadows.hasOwnProperty(thingName)) {
        var topicSpecs = []; //
        // If an operation is outstanding, it will have a timeout set; when it
        // expires any accept/reject sub-topic subscriptions for the thing will be 
        // deleted.  If any messages arrive after the thing has been deleted, they
        // will simply be ignored as it no longer exists in the thing registrations.
        // The only sub-topic we need to unsubscribe from is the delta sub-topic,
        // which is always active.
        //

        topicSpecs.push({
          operations: ['update'],
          statii: ['delta']
        }); //
        // If we are persistently subscribing, we subscribe to everything we could ever
        // possibly be interested in; this means that when it's time to unregister
        // interest in a thing, we need to unsubscribe from all of these topics.
        //

        if (thingShadows[thingName].persistentSubscribe === true) {
          topicSpecs.push({
            operations: ['update', 'get', 'delete'],
            statii: ['accepted', 'rejected']
          });
        }

        this._handleSubscriptions(thingName, topicSpecs, 'unsubscribe'); //
        // Delete any pending timeout
        //


        if (!isUndefined(thingShadows[thingName].timeout)) {
          clearTimeout(thingShadows[thingName].timeout);
        } //
        // Delete the thing from the Thing registrations.
        //


        delete thingShadows[thingName];
      } else {
        if (deviceOptions.debug === true) {
          console.error('attempting to unregister unknown thing: ', thingName);
        }
      }
    }; //
    // Perform an update operation on the given thing shadow.
    //


    this.update = function (thingName, stateObject) {
      var rc = null; //
      // Verify that the message does not contain a property named 'version',
      // as these property is reserved for use within this class.
      //

      if (isUndefined(stateObject.version)) {
        rc = that._thingOperation(thingName, 'update', stateObject);
      } else {
        console.error('message can\'t contain \'version\' property');
      }

      return rc;
    }; //
    // Perform a get operation on the given thing shadow; allow the user
    // to specify their own client token if they don't want to use the
    // default.
    //


    this.get = function (thingName, clientToken) {
      var stateObject = {};

      if (!isUndefined(clientToken)) {
        stateObject.clientToken = clientToken;
      }

      return that._thingOperation(thingName, 'get', stateObject);
    }; //
    // Perform a delete operation on the given thing shadow.
    //


    this.delete = function (thingName, clientToken) {
      var stateObject = {};

      if (!isUndefined(clientToken)) {
        stateObject.clientToken = clientToken;
      }

      return that._thingOperation(thingName, 'delete', stateObject);
    }; //
    // Publish on non-thing topics.
    //


    this.publish = function (topic, message, options, callback) {
      if (!isReservedTopic(topic)) {
        device.publish(topic, message, options, callback);
      } else {
        throw 'cannot publish to reserved topic \'' + topic + '\'';
      }
    }; //
    // Subscribe to non-thing topics.
    //


    this.subscribe = function (topics, options, callback) {
      var topicsArray = [];

      if (typeof topics === 'string') {
        topicsArray.push(topics);
      } else if (typeof topics === 'object' && topics.length) {
        topicsArray = topics;
      }

      for (var i = 0; i < topicsArray.length; i++) {
        if (isReservedTopic(topicsArray[i])) {
          throw 'cannot subscribe to topic array since one of them is a reserved topic \'' + topicsArray[i] + '\'';
        }
      }

      device.subscribe(topicsArray, options, callback);
    }; //
    // Unsubscribe from non-thing topics.
    //


    this.unsubscribe = function (topics, callback) {
      var topicsArray = [];

      if (typeof topics === 'string') {
        topicsArray.push(topics);
      } else if (typeof topics === 'object' && topics.length) {
        topicsArray = topics;
      }

      for (var i = 0; i < topicsArray.length; i++) {
        if (isReservedTopic(topicsArray[i])) {
          throw 'cannot unsubscribe from topic array since one of them is a reserved topic \'' + topicsArray[i] + '\'';
        }
      }

      device.unsubscribe(topicsArray, callback);
    }; //
    // Close the device connection; this will be passed through to
    // the device class.
    //


    this.end = function (force, callback) {
      device.end(force, callback);
    }; //
    // Call this function to update the credentials used when
    // connecting via WebSocket/SigV4; this will be passed through
    // to the device class.
    //


    this.updateWebSocketCredentials = function (accessKeyId, secretKey, sessionToken, expiration) {
      device.updateWebSocketCredentials(accessKeyId, secretKey, sessionToken, expiration);
    }; //
    // Call this function to update the custom auth headers
    // This will be passed through to the device class
    //


    this.updateCustomAuthHeaders = function (newHeaders) {
      device.updateCustomAuthHeaders(newHeaders);
    }; //
    // This is an unpublished API used for testing.
    //


    this.setConnectionStatus = function (connectionStatus) {
      connected = connectionStatus;
    };

    events.EventEmitter.call(this);
  } //
  // Allow instances to listen in on events that we produce for them
  //


  inherits(ThingShadowsClient, events.EventEmitter);
  module.exports = ThingShadowsClient;
  /***/
},
/* 263 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(270);

  module.exports = __webpack_require__(32).RegExp.escape;
  /***/
},
/* 264 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(7);

  var isArray = __webpack_require__(90);

  var SPECIES = __webpack_require__(9)('species');

  module.exports = function (original) {
    var C;

    if (isArray(original)) {
      C = original.constructor; // cross-realm fallback

      if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;

      if (isObject(C)) {
        C = C[SPECIES];
        if (C === null) C = undefined;
      }
    }

    return C === undefined ? Array : C;
  };
  /***/

},
/* 265 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

  var fails = __webpack_require__(5);

  var getTime = Date.prototype.getTime;
  var $toISOString = Date.prototype.toISOString;

  var lz = function lz(num) {
    return num > 9 ? num : '0' + num;
  }; // PhantomJS / old WebKit has a broken implementations


  module.exports = fails(function () {
    return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
  }) || !fails(function () {
    $toISOString.call(new Date(NaN));
  }) ? function toISOString() {
    if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
    var d = this;
    var y = d.getUTCFullYear();
    var m = d.getUTCMilliseconds();
    var s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
  } : $toISOString;
  /***/
},
/* 266 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var anObject = __webpack_require__(2);

  var toPrimitive = __webpack_require__(36);

  var NUMBER = 'number';

  module.exports = function (hint) {
    if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
    return toPrimitive(anObject(this), hint != NUMBER);
  };
  /***/

},
/* 267 */

/***/
function (module, exports, __webpack_require__) {
  // all enumerable object keys, includes symbols
  var getKeys = __webpack_require__(54);

  var gOPS = __webpack_require__(94);

  var pIE = __webpack_require__(77);

  module.exports = function (it) {
    var result = getKeys(it);
    var getSymbols = gOPS.f;

    if (getSymbols) {
      var symbols = getSymbols(it);
      var isEnum = pIE.f;
      var i = 0;
      var key;

      while (symbols.length > i) {
        if (isEnum.call(it, key = symbols[i++])) result.push(key);
      }
    }

    return result;
  };
  /***/

},
/* 268 */

/***/
function (module, exports) {
  module.exports = function (regExp, replace) {
    var replacer = replace === Object(replace) ? function (part) {
      return replace[part];
    } : replace;
    return function (it) {
      return String(it).replace(regExp, replacer);
    };
  };
  /***/

},
/* 269 */

/***/
function (module, exports) {
  // 7.2.9 SameValue(x, y)
  module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
  };
  /***/

},
/* 270 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/benjamingr/RexExp.escape
  var $export = __webpack_require__(0);

  var $re = __webpack_require__(268)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

  $export($export.S, 'RegExp', {
    escape: function escape(it) {
      return $re(it);
    }
  });
  /***/
},
/* 271 */

/***/
function (module, exports, __webpack_require__) {
  // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
  var $export = __webpack_require__(0);

  $export($export.P, 'Array', {
    copyWithin: __webpack_require__(164)
  });

  __webpack_require__(44)('copyWithin');
  /***/

},
/* 272 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $every = __webpack_require__(31)(4);

  $export($export.P + $export.F * !__webpack_require__(29)([].every, true), 'Array', {
    // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
    every: function every(callbackfn
    /* , thisArg */
    ) {
      return $every(this, callbackfn, arguments[1]);
    }
  });
  /***/
},
/* 273 */

/***/
function (module, exports, __webpack_require__) {
  // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
  var $export = __webpack_require__(0);

  $export($export.P, 'Array', {
    fill: __webpack_require__(109)
  });

  __webpack_require__(44)('fill');
  /***/

},
/* 274 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $filter = __webpack_require__(31)(2);

  $export($export.P + $export.F * !__webpack_require__(29)([].filter, true), 'Array', {
    // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
    filter: function filter(callbackfn
    /* , thisArg */
    ) {
      return $filter(this, callbackfn, arguments[1]);
    }
  });
  /***/
},
/* 275 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

  var $export = __webpack_require__(0);

  var $find = __webpack_require__(31)(6);

  var KEY = 'findIndex';
  var forced = true; // Shouldn't skip holes

  if (KEY in []) Array(1)[KEY](function () {
    forced = false;
  });
  $export($export.P + $export.F * forced, 'Array', {
    findIndex: function findIndex(callbackfn
    /* , that = undefined */
    ) {
      return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  __webpack_require__(44)(KEY);
  /***/

},
/* 276 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

  var $export = __webpack_require__(0);

  var $find = __webpack_require__(31)(5);

  var KEY = 'find';
  var forced = true; // Shouldn't skip holes

  if (KEY in []) Array(1)[KEY](function () {
    forced = false;
  });
  $export($export.P + $export.F * forced, 'Array', {
    find: function find(callbackfn
    /* , that = undefined */
    ) {
      return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  __webpack_require__(44)(KEY);
  /***/

},
/* 277 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $forEach = __webpack_require__(31)(0);

  var STRICT = __webpack_require__(29)([].forEach, true);

  $export($export.P + $export.F * !STRICT, 'Array', {
    // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
    forEach: function forEach(callbackfn
    /* , thisArg */
    ) {
      return $forEach(this, callbackfn, arguments[1]);
    }
  });
  /***/
},
/* 278 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ctx = __webpack_require__(28);

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(15);

  var call = __webpack_require__(175);

  var isArrayIter = __webpack_require__(117);

  var toLength = __webpack_require__(13);

  var createProperty = __webpack_require__(111);

  var getIterFn = __webpack_require__(134);

  $export($export.S + $export.F * !__webpack_require__(92)(function (iter) {
    Array.from(iter);
  }), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike
    /* , mapfn = undefined, thisArg = undefined */
    ) {
      var O = toObject(arrayLike);
      var C = typeof this == 'function' ? this : Array;
      var aLen = arguments.length;
      var mapfn = aLen > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var index = 0;
      var iterFn = getIterFn(O);
      var length, result, step, iterator;
      if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

      if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
        for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
          createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
        }
      } else {
        length = toLength(O.length);

        for (result = new C(length); length > index; index++) {
          createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
      }

      result.length = index;
      return result;
    }
  });
  /***/
},
/* 279 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $indexOf = __webpack_require__(86)(false);

  var $native = [].indexOf;
  var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
  $export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(29)($native)), 'Array', {
    // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
    indexOf: function indexOf(searchElement
    /* , fromIndex = 0 */
    ) {
      return NEGATIVE_ZERO // convert -0 to +0
      ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
    }
  });
  /***/
},
/* 280 */

/***/
function (module, exports, __webpack_require__) {
  // 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
  var $export = __webpack_require__(0);

  $export($export.S, 'Array', {
    isArray: __webpack_require__(90)
  });
  /***/
},
/* 281 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 22.1.3.13 Array.prototype.join(separator)

  var $export = __webpack_require__(0);

  var toIObject = __webpack_require__(26);

  var arrayJoin = [].join; // fallback for not array-like strings

  $export($export.P + $export.F * (__webpack_require__(76) != Object || !__webpack_require__(29)(arrayJoin)), 'Array', {
    join: function join(separator) {
      return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
    }
  });
  /***/
},
/* 282 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toIObject = __webpack_require__(26);

  var toInteger = __webpack_require__(35);

  var toLength = __webpack_require__(13);

  var $native = [].lastIndexOf;
  var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
  $export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(29)($native)), 'Array', {
    // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
    lastIndexOf: function lastIndexOf(searchElement
    /* , fromIndex = @[*-1] */
    ) {
      // convert -0 to +0
      if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
      var O = toIObject(this);
      var length = toLength(O.length);
      var index = length - 1;
      if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
      if (index < 0) index = length + index;

      for (; index >= 0; index--) {
        if (index in O) if (O[index] === searchElement) return index || 0;
      }

      return -1;
    }
  });
  /***/
},
/* 283 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $map = __webpack_require__(31)(1);

  $export($export.P + $export.F * !__webpack_require__(29)([].map, true), 'Array', {
    // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
    map: function map(callbackfn
    /* , thisArg */
    ) {
      return $map(this, callbackfn, arguments[1]);
    }
  });
  /***/
},
/* 284 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var createProperty = __webpack_require__(111); // WebKit Array.of isn't generic


  $export($export.S + $export.F * __webpack_require__(5)(function () {
    function F() {
      /* empty */
    }

    return !(Array.of.call(F) instanceof F);
  }), 'Array', {
    // 22.1.2.3 Array.of( ...items)
    of: function of()
    /* ...args */
    {
      var index = 0;
      var aLen = arguments.length;
      var result = new (typeof this == 'function' ? this : Array)(aLen);

      while (aLen > index) {
        createProperty(result, index, arguments[index++]);
      }

      result.length = aLen;
      return result;
    }
  });
  /***/
},
/* 285 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $reduce = __webpack_require__(166);

  $export($export.P + $export.F * !__webpack_require__(29)([].reduceRight, true), 'Array', {
    // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
    reduceRight: function reduceRight(callbackfn
    /* , initialValue */
    ) {
      return $reduce(this, callbackfn, arguments.length, arguments[1], true);
    }
  });
  /***/
},
/* 286 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $reduce = __webpack_require__(166);

  $export($export.P + $export.F * !__webpack_require__(29)([].reduce, true), 'Array', {
    // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
    reduce: function reduce(callbackfn
    /* , initialValue */
    ) {
      return $reduce(this, callbackfn, arguments.length, arguments[1], false);
    }
  });
  /***/
},
/* 287 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var html = __webpack_require__(115);

  var cof = __webpack_require__(27);

  var toAbsoluteIndex = __webpack_require__(58);

  var toLength = __webpack_require__(13);

  var arraySlice = [].slice; // fallback for not array-like ES3 strings and DOM objects

  $export($export.P + $export.F * __webpack_require__(5)(function () {
    if (html) arraySlice.call(html);
  }), 'Array', {
    slice: function slice(begin, end) {
      var len = toLength(this.length);
      var klass = cof(this);
      end = end === undefined ? len : end;
      if (klass == 'Array') return arraySlice.call(this, begin, end);
      var start = toAbsoluteIndex(begin, len);
      var upTo = toAbsoluteIndex(end, len);
      var size = toLength(upTo - start);
      var cloned = new Array(size);
      var i = 0;

      for (; i < size; i++) {
        cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
      }

      return cloned;
    }
  });
  /***/
},
/* 288 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $some = __webpack_require__(31)(3);

  $export($export.P + $export.F * !__webpack_require__(29)([].some, true), 'Array', {
    // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
    some: function some(callbackfn
    /* , thisArg */
    ) {
      return $some(this, callbackfn, arguments[1]);
    }
  });
  /***/
},
/* 289 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var aFunction = __webpack_require__(18);

  var toObject = __webpack_require__(15);

  var fails = __webpack_require__(5);

  var $sort = [].sort;
  var test = [1, 2, 3];
  $export($export.P + $export.F * (fails(function () {
    // IE8-
    test.sort(undefined);
  }) || !fails(function () {
    // V8 bug
    test.sort(null); // Old WebKit
  }) || !__webpack_require__(29)($sort)), 'Array', {
    // 22.1.3.25 Array.prototype.sort(comparefn)
    sort: function sort(comparefn) {
      return comparefn === undefined ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
    }
  });
  /***/
},
/* 290 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(57)('Array');
  /***/

},
/* 291 */

/***/
function (module, exports, __webpack_require__) {
  // 20.3.3.1 / 15.9.4.4 Date.now()
  var $export = __webpack_require__(0);

  $export($export.S, 'Date', {
    now: function now() {
      return new Date().getTime();
    }
  });
  /***/
},
/* 292 */

/***/
function (module, exports, __webpack_require__) {
  // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
  var $export = __webpack_require__(0);

  var toISOString = __webpack_require__(265); // PhantomJS / old WebKit has a broken implementations


  $export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
    toISOString: toISOString
  });
  /***/
},
/* 293 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(15);

  var toPrimitive = __webpack_require__(36);

  $export($export.P + $export.F * __webpack_require__(5)(function () {
    return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
      toISOString: function toISOString() {
        return 1;
      }
    }) !== 1;
  }), 'Date', {
    // eslint-disable-next-line no-unused-vars
    toJSON: function toJSON(key) {
      var O = toObject(this);
      var pv = toPrimitive(O);
      return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
    }
  });
  /***/
},
/* 294 */

/***/
function (module, exports, __webpack_require__) {
  var TO_PRIMITIVE = __webpack_require__(9)('toPrimitive');

  var proto = Date.prototype;
  if (!(TO_PRIMITIVE in proto)) __webpack_require__(20)(proto, TO_PRIMITIVE, __webpack_require__(266));
  /***/
},
/* 295 */

/***/
function (module, exports, __webpack_require__) {
  var DateProto = Date.prototype;
  var INVALID_DATE = 'Invalid Date';
  var TO_STRING = 'toString';
  var $toString = DateProto[TO_STRING];
  var getTime = DateProto.getTime;

  if (new Date(NaN) + '' != INVALID_DATE) {
    __webpack_require__(21)(DateProto, TO_STRING, function toString() {
      var value = getTime.call(this); // eslint-disable-next-line no-self-compare

      return value === value ? $toString.call(this) : INVALID_DATE;
    });
  }
  /***/

},
/* 296 */

/***/
function (module, exports, __webpack_require__) {
  // 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
  var $export = __webpack_require__(0);

  $export($export.P, 'Function', {
    bind: __webpack_require__(167)
  });
  /***/
},
/* 297 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var isObject = __webpack_require__(7);

  var getPrototypeOf = __webpack_require__(25);

  var HAS_INSTANCE = __webpack_require__(9)('hasInstance');

  var FunctionProto = Function.prototype; // 19.2.3.6 Function.prototype[@@hasInstance](V)

  if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(12).f(FunctionProto, HAS_INSTANCE, {
    value: function value(O) {
      if (typeof this != 'function' || !isObject(O)) return false;
      if (!isObject(this.prototype)) return O instanceof this; // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:

      while (O = getPrototypeOf(O)) {
        if (this.prototype === O) return true;
      }

      return false;
    }
  });
  /***/
},
/* 298 */

/***/
function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(12).f;

  var FProto = Function.prototype;
  var nameRE = /^\s*function ([^ (]*)/;
  var NAME = 'name'; // 19.2.4.2 name

  NAME in FProto || __webpack_require__(11) && dP(FProto, NAME, {
    configurable: true,
    get: function get() {
      try {
        return ('' + this).match(nameRE)[1];
      } catch (e) {
        return '';
      }
    }
  });
  /***/
},
/* 299 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.3 Math.acosh(x)
  var $export = __webpack_require__(0);

  var log1p = __webpack_require__(178);

  var sqrt = Math.sqrt;
  var $acosh = Math.acosh;
  $export($export.S + $export.F * !($acosh // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710 // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity), 'Math', {
    acosh: function acosh(x) {
      return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
    }
  });
  /***/
},
/* 300 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.5 Math.asinh(x)
  var $export = __webpack_require__(0);

  var $asinh = Math.asinh;

  function asinh(x) {
    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
  } // Tor Browser bug: Math.asinh(0) -> -0


  $export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {
    asinh: asinh
  });
  /***/
},
/* 301 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.7 Math.atanh(x)
  var $export = __webpack_require__(0);

  var $atanh = Math.atanh; // Tor Browser bug: Math.atanh(-0) -> 0

  $export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
    atanh: function atanh(x) {
      return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
    }
  });
  /***/
},
/* 302 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.9 Math.cbrt(x)
  var $export = __webpack_require__(0);

  var sign = __webpack_require__(121);

  $export($export.S, 'Math', {
    cbrt: function cbrt(x) {
      return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
    }
  });
  /***/
},
/* 303 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.11 Math.clz32(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    clz32: function clz32(x) {
      return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
    }
  });
  /***/
},
/* 304 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.12 Math.cosh(x)
  var $export = __webpack_require__(0);

  var exp = Math.exp;
  $export($export.S, 'Math', {
    cosh: function cosh(x) {
      return (exp(x = +x) + exp(-x)) / 2;
    }
  });
  /***/
},
/* 305 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.14 Math.expm1(x)
  var $export = __webpack_require__(0);

  var $expm1 = __webpack_require__(120);

  $export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {
    expm1: $expm1
  });
  /***/
},
/* 306 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.16 Math.fround(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    fround: __webpack_require__(177)
  });
  /***/
},
/* 307 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
  var $export = __webpack_require__(0);

  var abs = Math.abs;
  $export($export.S, 'Math', {
    hypot: function hypot(value1, value2) {
      // eslint-disable-line no-unused-vars
      var sum = 0;
      var i = 0;
      var aLen = arguments.length;
      var larg = 0;
      var arg, div;

      while (i < aLen) {
        arg = abs(arguments[i++]);

        if (larg < arg) {
          div = larg / arg;
          sum = sum * div * div + 1;
          larg = arg;
        } else if (arg > 0) {
          div = arg / larg;
          sum += div * div;
        } else sum += arg;
      }

      return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
    }
  });
  /***/
},
/* 308 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.18 Math.imul(x, y)
  var $export = __webpack_require__(0);

  var $imul = Math.imul; // some WebKit versions fails with big numbers, some has wrong arity

  $export($export.S + $export.F * __webpack_require__(5)(function () {
    return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
  }), 'Math', {
    imul: function imul(x, y) {
      var UINT16 = 0xffff;
      var xn = +x;
      var yn = +y;
      var xl = UINT16 & xn;
      var yl = UINT16 & yn;
      return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
  });
  /***/
},
/* 309 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.21 Math.log10(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    log10: function log10(x) {
      return Math.log(x) * Math.LOG10E;
    }
  });
  /***/
},
/* 310 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.20 Math.log1p(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    log1p: __webpack_require__(178)
  });
  /***/
},
/* 311 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.22 Math.log2(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    log2: function log2(x) {
      return Math.log(x) / Math.LN2;
    }
  });
  /***/
},
/* 312 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.28 Math.sign(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    sign: __webpack_require__(121)
  });
  /***/
},
/* 313 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.30 Math.sinh(x)
  var $export = __webpack_require__(0);

  var expm1 = __webpack_require__(120);

  var exp = Math.exp; // V8 near Chromium 38 has a problem with very small numbers

  $export($export.S + $export.F * __webpack_require__(5)(function () {
    return !Math.sinh(-2e-17) != -2e-17;
  }), 'Math', {
    sinh: function sinh(x) {
      return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
    }
  });
  /***/
},
/* 314 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.33 Math.tanh(x)
  var $export = __webpack_require__(0);

  var expm1 = __webpack_require__(120);

  var exp = Math.exp;
  $export($export.S, 'Math', {
    tanh: function tanh(x) {
      var a = expm1(x = +x);
      var b = expm1(-x);
      return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
    }
  });
  /***/
},
/* 315 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.34 Math.trunc(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    trunc: function trunc(it) {
      return (it > 0 ? Math.floor : Math.ceil)(it);
    }
  });
  /***/
},
/* 316 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(3);

  var has = __webpack_require__(23);

  var cof = __webpack_require__(27);

  var inheritIfRequired = __webpack_require__(116);

  var toPrimitive = __webpack_require__(36);

  var fails = __webpack_require__(5);

  var gOPN = __webpack_require__(53).f;

  var gOPD = __webpack_require__(24).f;

  var dP = __webpack_require__(12).f;

  var $trim = __webpack_require__(66).trim;

  var NUMBER = 'Number';
  var $Number = global[NUMBER];
  var Base = $Number;
  var proto = $Number.prototype; // Opera ~12 has broken Object#toString

  var BROKEN_COF = cof(__webpack_require__(52)(proto)) == NUMBER;
  var TRIM = 'trim' in String.prototype; // 7.1.3 ToNumber(argument)

  var toNumber = function toNumber(argument) {
    var it = toPrimitive(argument, false);

    if (typeof it == 'string' && it.length > 2) {
      it = TRIM ? it.trim() : $trim(it, 3);
      var first = it.charCodeAt(0);
      var third, radix, maxCode;

      if (first === 43 || first === 45) {
        third = it.charCodeAt(2);
        if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
      } else if (first === 48) {
        switch (it.charCodeAt(1)) {
          case 66:
          case 98:
            radix = 2;
            maxCode = 49;
            break;
          // fast equal /^0b[01]+$/i

          case 79:
          case 111:
            radix = 8;
            maxCode = 55;
            break;
          // fast equal /^0o[0-7]+$/i

          default:
            return +it;
        }

        for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
          code = digits.charCodeAt(i); // parseInt parses a string to a first unavailable symbol
          // but ToNumber should return NaN if a string contains unavailable symbols

          if (code < 48 || code > maxCode) return NaN;
        }

        return parseInt(digits, radix);
      }
    }

    return +it;
  };

  if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
    $Number = function Number(value) {
      var it = arguments.length < 1 ? 0 : value;
      var that = this;
      return that instanceof $Number // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () {
        proto.valueOf.call(that);
      }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
    };

    for (var keys = __webpack_require__(11) ? gOPN(Base) : ( // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
      if (has(Base, key = keys[j]) && !has($Number, key)) {
        dP($Number, key, gOPD(Base, key));
      }
    }

    $Number.prototype = proto;
    proto.constructor = $Number;

    __webpack_require__(21)(global, NUMBER, $Number);
  }
  /***/

},
/* 317 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.1 Number.EPSILON
  var $export = __webpack_require__(0);

  $export($export.S, 'Number', {
    EPSILON: Math.pow(2, -52)
  });
  /***/
},
/* 318 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.2 Number.isFinite(number)
  var $export = __webpack_require__(0);

  var _isFinite = __webpack_require__(3).isFinite;

  $export($export.S, 'Number', {
    isFinite: function isFinite(it) {
      return typeof it == 'number' && _isFinite(it);
    }
  });
  /***/
},
/* 319 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.3 Number.isInteger(number)
  var $export = __webpack_require__(0);

  $export($export.S, 'Number', {
    isInteger: __webpack_require__(174)
  });
  /***/
},
/* 320 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.4 Number.isNaN(number)
  var $export = __webpack_require__(0);

  $export($export.S, 'Number', {
    isNaN: function isNaN(number) {
      // eslint-disable-next-line no-self-compare
      return number != number;
    }
  });
  /***/
},
/* 321 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.5 Number.isSafeInteger(number)
  var $export = __webpack_require__(0);

  var isInteger = __webpack_require__(174);

  var abs = Math.abs;
  $export($export.S, 'Number', {
    isSafeInteger: function isSafeInteger(number) {
      return isInteger(number) && abs(number) <= 0x1fffffffffffff;
    }
  });
  /***/
},
/* 322 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.6 Number.MAX_SAFE_INTEGER
  var $export = __webpack_require__(0);

  $export($export.S, 'Number', {
    MAX_SAFE_INTEGER: 0x1fffffffffffff
  });
  /***/
},
/* 323 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.10 Number.MIN_SAFE_INTEGER
  var $export = __webpack_require__(0);

  $export($export.S, 'Number', {
    MIN_SAFE_INTEGER: -0x1fffffffffffff
  });
  /***/
},
/* 324 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var $parseFloat = __webpack_require__(186); // 20.1.2.12 Number.parseFloat(string)


  $export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {
    parseFloat: $parseFloat
  });
  /***/
},
/* 325 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var $parseInt = __webpack_require__(187); // 20.1.2.13 Number.parseInt(string, radix)


  $export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {
    parseInt: $parseInt
  });
  /***/
},
/* 326 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toInteger = __webpack_require__(35);

  var aNumberValue = __webpack_require__(163);

  var repeat = __webpack_require__(128);

  var $toFixed = 1.0.toFixed;
  var floor = Math.floor;
  var data = [0, 0, 0, 0, 0, 0];
  var ERROR = 'Number.toFixed: incorrect invocation!';
  var ZERO = '0';

  var multiply = function multiply(n, c) {
    var i = -1;
    var c2 = c;

    while (++i < 6) {
      c2 += n * data[i];
      data[i] = c2 % 1e7;
      c2 = floor(c2 / 1e7);
    }
  };

  var divide = function divide(n) {
    var i = 6;
    var c = 0;

    while (--i >= 0) {
      c += data[i];
      data[i] = floor(c / n);
      c = c % n * 1e7;
    }
  };

  var numToString = function numToString() {
    var i = 6;
    var s = '';

    while (--i >= 0) {
      if (s !== '' || i === 0 || data[i] !== 0) {
        var t = String(data[i]);
        s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
      }
    }

    return s;
  };

  var pow = function pow(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
  };

  var log = function log(x) {
    var n = 0;
    var x2 = x;

    while (x2 >= 4096) {
      n += 12;
      x2 /= 4096;
    }

    while (x2 >= 2) {
      n += 1;
      x2 /= 2;
    }

    return n;
  };

  $export($export.P + $export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !__webpack_require__(5)(function () {
    // V8 ~ Android 4.3-
    $toFixed.call({});
  })), 'Number', {
    toFixed: function toFixed(fractionDigits) {
      var x = aNumberValue(this, ERROR);
      var f = toInteger(fractionDigits);
      var s = '';
      var m = ZERO;
      var e, z, j, k;
      if (f < 0 || f > 20) throw RangeError(ERROR); // eslint-disable-next-line no-self-compare

      if (x != x) return 'NaN';
      if (x <= -1e21 || x >= 1e21) return String(x);

      if (x < 0) {
        s = '-';
        x = -x;
      }

      if (x > 1e-21) {
        e = log(x * pow(2, 69, 1)) - 69;
        z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
        z *= 0x10000000000000;
        e = 52 - e;

        if (e > 0) {
          multiply(0, z);
          j = f;

          while (j >= 7) {
            multiply(1e7, 0);
            j -= 7;
          }

          multiply(pow(10, j, 1), 0);
          j = e - 1;

          while (j >= 23) {
            divide(1 << 23);
            j -= 23;
          }

          divide(1 << j);
          multiply(1, 1);
          divide(2);
          m = numToString();
        } else {
          multiply(0, z);
          multiply(1 << -e, 0);
          m = numToString() + repeat.call(ZERO, f);
        }
      }

      if (f > 0) {
        k = m.length;
        m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
      } else {
        m = s + m;
      }

      return m;
    }
  });
  /***/
},
/* 327 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $fails = __webpack_require__(5);

  var aNumberValue = __webpack_require__(163);

  var $toPrecision = 1.0.toPrecision;
  $export($export.P + $export.F * ($fails(function () {
    // IE7-
    return $toPrecision.call(1, undefined) !== '1';
  }) || !$fails(function () {
    // V8 ~ Android 4.3-
    $toPrecision.call({});
  })), 'Number', {
    toPrecision: function toPrecision(precision) {
      var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
      return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
    }
  });
  /***/
},
/* 328 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.3.1 Object.assign(target, source)
  var $export = __webpack_require__(0);

  $export($export.S + $export.F, 'Object', {
    assign: __webpack_require__(180)
  });
  /***/
},
/* 329 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


  $export($export.S, 'Object', {
    create: __webpack_require__(52)
  });
  /***/
},
/* 330 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0); // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)


  $export($export.S + $export.F * !__webpack_require__(11), 'Object', {
    defineProperties: __webpack_require__(181)
  });
  /***/
},
/* 331 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


  $export($export.S + $export.F * !__webpack_require__(11), 'Object', {
    defineProperty: __webpack_require__(12).f
  });
  /***/
},
/* 332 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.5 Object.freeze(O)
  var isObject = __webpack_require__(7);

  var meta = __webpack_require__(45).onFreeze;

  __webpack_require__(34)('freeze', function ($freeze) {
    return function freeze(it) {
      return $freeze && isObject(it) ? $freeze(meta(it)) : it;
    };
  });
  /***/

},
/* 333 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  var toIObject = __webpack_require__(26);

  var $getOwnPropertyDescriptor = __webpack_require__(24).f;

  __webpack_require__(34)('getOwnPropertyDescriptor', function () {
    return function getOwnPropertyDescriptor(it, key) {
      return $getOwnPropertyDescriptor(toIObject(it), key);
    };
  });
  /***/

},
/* 334 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  __webpack_require__(34)('getOwnPropertyNames', function () {
    return __webpack_require__(182).f;
  });
  /***/

},
/* 335 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.9 Object.getPrototypeOf(O)
  var toObject = __webpack_require__(15);

  var $getPrototypeOf = __webpack_require__(25);

  __webpack_require__(34)('getPrototypeOf', function () {
    return function getPrototypeOf(it) {
      return $getPrototypeOf(toObject(it));
    };
  });
  /***/

},
/* 336 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.11 Object.isExtensible(O)
  var isObject = __webpack_require__(7);

  __webpack_require__(34)('isExtensible', function ($isExtensible) {
    return function isExtensible(it) {
      return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
    };
  });
  /***/

},
/* 337 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.12 Object.isFrozen(O)
  var isObject = __webpack_require__(7);

  __webpack_require__(34)('isFrozen', function ($isFrozen) {
    return function isFrozen(it) {
      return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
    };
  });
  /***/

},
/* 338 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.13 Object.isSealed(O)
  var isObject = __webpack_require__(7);

  __webpack_require__(34)('isSealed', function ($isSealed) {
    return function isSealed(it) {
      return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
    };
  });
  /***/

},
/* 339 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.3.10 Object.is(value1, value2)
  var $export = __webpack_require__(0);

  $export($export.S, 'Object', {
    is: __webpack_require__(269)
  });
  /***/
},
/* 340 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.14 Object.keys(O)
  var toObject = __webpack_require__(15);

  var $keys = __webpack_require__(54);

  __webpack_require__(34)('keys', function () {
    return function keys(it) {
      return $keys(toObject(it));
    };
  });
  /***/

},
/* 341 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.15 Object.preventExtensions(O)
  var isObject = __webpack_require__(7);

  var meta = __webpack_require__(45).onFreeze;

  __webpack_require__(34)('preventExtensions', function ($preventExtensions) {
    return function preventExtensions(it) {
      return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
    };
  });
  /***/

},
/* 342 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.17 Object.seal(O)
  var isObject = __webpack_require__(7);

  var meta = __webpack_require__(45).onFreeze;

  __webpack_require__(34)('seal', function ($seal) {
    return function seal(it) {
      return $seal && isObject(it) ? $seal(meta(it)) : it;
    };
  });
  /***/

},
/* 343 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.3.19 Object.setPrototypeOf(O, proto)
  var $export = __webpack_require__(0);

  $export($export.S, 'Object', {
    setPrototypeOf: __webpack_require__(124).set
  });
  /***/
},
/* 344 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 19.1.3.6 Object.prototype.toString()

  var classof = __webpack_require__(75);

  var test = {};
  test[__webpack_require__(9)('toStringTag')] = 'z';

  if (test + '' != '[object z]') {
    __webpack_require__(21)(Object.prototype, 'toString', function toString() {
      return '[object ' + classof(this) + ']';
    }, true);
  }
  /***/

},
/* 345 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var $parseFloat = __webpack_require__(186); // 18.2.4 parseFloat(string)


  $export($export.G + $export.F * (parseFloat != $parseFloat), {
    parseFloat: $parseFloat
  });
  /***/
},
/* 346 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var $parseInt = __webpack_require__(187); // 18.2.5 parseInt(string, radix)


  $export($export.G + $export.F * (parseInt != $parseInt), {
    parseInt: $parseInt
  });
  /***/
},
/* 347 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var LIBRARY = __webpack_require__(51);

  var global = __webpack_require__(3);

  var ctx = __webpack_require__(28);

  var classof = __webpack_require__(75);

  var $export = __webpack_require__(0);

  var isObject = __webpack_require__(7);

  var aFunction = __webpack_require__(18);

  var anInstance = __webpack_require__(49);

  var forOf = __webpack_require__(50);

  var speciesConstructor = __webpack_require__(98);

  var task = __webpack_require__(130).set;

  var microtask = __webpack_require__(122)();

  var newPromiseCapabilityModule = __webpack_require__(123);

  var perform = __webpack_require__(188);

  var promiseResolve = __webpack_require__(189);

  var PROMISE = 'Promise';
  var TypeError = global.TypeError;
  var process = global.process;
  var $Promise = global[PROMISE];
  var isNode = classof(process) == 'process';

  var empty = function empty() {
    /* empty */
  };

  var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
  var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
  var USE_NATIVE = !!function () {
    try {
      // correct subclassing with @@species support
      var promise = $Promise.resolve(1);

      var FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function (exec) {
        exec(empty, empty);
      }; // unhandled rejections tracking support, NodeJS Promise without it fails @@species test


      return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
    } catch (e) {
      /* empty */
    }
  }(); // helpers

  var isThenable = function isThenable(it) {
    var then;
    return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
  };

  var notify = function notify(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    microtask(function () {
      var value = promise._v;
      var ok = promise._s == 1;
      var i = 0;

      var run = function run(reaction) {
        var handler = ok ? reaction.ok : reaction.fail;
        var resolve = reaction.resolve;
        var reject = reaction.reject;
        var domain = reaction.domain;
        var result, then, exited;

        try {
          if (handler) {
            if (!ok) {
              if (promise._h == 2) onHandleUnhandled(promise);
              promise._h = 1;
            }

            if (handler === true) result = value;else {
              if (domain) domain.enter();
              result = handler(value); // may throw

              if (domain) {
                domain.exit();
                exited = true;
              }
            }

            if (result === reaction.promise) {
              reject(TypeError('Promise-chain cycle'));
            } else if (then = isThenable(result)) {
              then.call(result, resolve, reject);
            } else resolve(result);
          } else reject(value);
        } catch (e) {
          if (domain && !exited) domain.exit();
          reject(e);
        }
      };

      while (chain.length > i) {
        run(chain[i++]);
      } // variable length - can't use forEach


      promise._c = [];
      promise._n = false;
      if (isReject && !promise._h) onUnhandled(promise);
    });
  };

  var onUnhandled = function onUnhandled(promise) {
    task.call(global, function () {
      var value = promise._v;
      var unhandled = isUnhandled(promise);
      var result, handler, console;

      if (unhandled) {
        result = perform(function () {
          if (isNode) {
            process.emit('unhandledRejection', value, promise);
          } else if (handler = global.onunhandledrejection) {
            handler({
              promise: promise,
              reason: value
            });
          } else if ((console = global.console) && console.error) {
            console.error('Unhandled promise rejection', value);
          }
        }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

        promise._h = isNode || isUnhandled(promise) ? 2 : 1;
      }

      promise._a = undefined;
      if (unhandled && result.e) throw result.v;
    });
  };

  var isUnhandled = function isUnhandled(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
  };

  var onHandleUnhandled = function onHandleUnhandled(promise) {
    task.call(global, function () {
      var handler;

      if (isNode) {
        process.emit('rejectionHandled', promise);
      } else if (handler = global.onrejectionhandled) {
        handler({
          promise: promise,
          reason: promise._v
        });
      }
    });
  };

  var $reject = function $reject(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap

    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    notify(promise, true);
  };

  var $resolve = function $resolve(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap

    try {
      if (promise === value) throw TypeError("Promise can't be resolved itself");

      if (then = isThenable(value)) {
        microtask(function () {
          var wrapper = {
            _w: promise,
            _d: false
          }; // wrap

          try {
            then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
          } catch (e) {
            $reject.call(wrapper, e);
          }
        });
      } else {
        promise._v = value;
        promise._s = 1;
        notify(promise, false);
      }
    } catch (e) {
      $reject.call({
        _w: promise,
        _d: false
      }, e); // wrap
    }
  }; // constructor polyfill


  if (!USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $Promise = function Promise(executor) {
      anInstance(this, $Promise, PROMISE, '_h');
      aFunction(executor);
      Internal.call(this);

      try {
        executor(ctx($resolve, this, 1), ctx($reject, this, 1));
      } catch (err) {
        $reject.call(this, err);
      }
    }; // eslint-disable-next-line no-unused-vars


    Internal = function Promise(executor) {
      this._c = []; // <- awaiting reactions

      this._a = undefined; // <- checked in isUnhandled reactions

      this._s = 0; // <- state

      this._d = false; // <- done

      this._v = undefined; // <- value

      this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled

      this._n = false; // <- notify
    };

    Internal.prototype = __webpack_require__(56)($Promise.prototype, {
      // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
      then: function then(onFulfilled, onRejected) {
        var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
        reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
        reaction.fail = typeof onRejected == 'function' && onRejected;
        reaction.domain = isNode ? process.domain : undefined;

        this._c.push(reaction);

        if (this._a) this._a.push(reaction);
        if (this._s) notify(this, false);
        return reaction.promise;
      },
      // 25.4.5.1 Promise.prototype.catch(onRejected)
      'catch': function _catch(onRejected) {
        return this.then(undefined, onRejected);
      }
    });

    OwnPromiseCapability = function OwnPromiseCapability() {
      var promise = new Internal();
      this.promise = promise;
      this.resolve = ctx($resolve, promise, 1);
      this.reject = ctx($reject, promise, 1);
    };

    newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
      return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
    };
  }

  $export($export.G + $export.W + $export.F * !USE_NATIVE, {
    Promise: $Promise
  });

  __webpack_require__(65)($Promise, PROMISE);

  __webpack_require__(57)(PROMISE);

  Wrapper = __webpack_require__(32)[PROMISE]; // statics

  $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
      var capability = newPromiseCapability(this);
      var $$reject = capability.reject;
      $$reject(r);
      return capability.promise;
    }
  });
  $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
      return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
    }
  });
  $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(92)(function (iter) {
    $Promise.all(iter)['catch'](empty);
  })), PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = perform(function () {
        var values = [];
        var index = 0;
        var remaining = 1;
        forOf(iterable, false, function (promise) {
          var $index = index++;
          var alreadyCalled = false;
          values.push(undefined);
          remaining++;
          C.resolve(promise).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[$index] = value;
            --remaining || resolve(values);
          }, reject);
        });
        --remaining || resolve(values);
      });
      if (result.e) reject(result.v);
      return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var reject = capability.reject;
      var result = perform(function () {
        forOf(iterable, false, function (promise) {
          C.resolve(promise).then(capability.resolve, reject);
        });
      });
      if (result.e) reject(result.v);
      return capability.promise;
    }
  });
  /***/
},
/* 348 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
  var $export = __webpack_require__(0);

  var aFunction = __webpack_require__(18);

  var anObject = __webpack_require__(2);

  var rApply = (__webpack_require__(3).Reflect || {}).apply;
  var fApply = Function.apply; // MS Edge argumentsList argument is optional

  $export($export.S + $export.F * !__webpack_require__(5)(function () {
    rApply(function () {
      /* empty */
    });
  }), 'Reflect', {
    apply: function apply(target, thisArgument, argumentsList) {
      var T = aFunction(target);
      var L = anObject(argumentsList);
      return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
    }
  });
  /***/
},
/* 349 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
  var $export = __webpack_require__(0);

  var create = __webpack_require__(52);

  var aFunction = __webpack_require__(18);

  var anObject = __webpack_require__(2);

  var isObject = __webpack_require__(7);

  var fails = __webpack_require__(5);

  var bind = __webpack_require__(167);

  var rConstruct = (__webpack_require__(3).Reflect || {}).construct; // MS Edge supports only 2 arguments and argumentsList argument is optional
  // FF Nightly sets third argument as `new.target`, but does not create `this` from it

  var NEW_TARGET_BUG = fails(function () {
    function F() {
      /* empty */
    }

    return !(rConstruct(function () {
      /* empty */
    }, [], F) instanceof F);
  });
  var ARGS_BUG = !fails(function () {
    rConstruct(function () {
      /* empty */
    });
  });
  $export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
    construct: function construct(Target, args
    /* , newTarget */
    ) {
      aFunction(Target);
      anObject(args);
      var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
      if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);

      if (Target == newTarget) {
        // w/o altered newTarget, optimization for 0-4 arguments
        switch (args.length) {
          case 0:
            return new Target();

          case 1:
            return new Target(args[0]);

          case 2:
            return new Target(args[0], args[1]);

          case 3:
            return new Target(args[0], args[1], args[2]);

          case 4:
            return new Target(args[0], args[1], args[2], args[3]);
        } // w/o altered newTarget, lot of arguments case


        var $args = [null];
        $args.push.apply($args, args);
        return new (bind.apply(Target, $args))();
      } // with altered newTarget, not support built-in constructors


      var proto = newTarget.prototype;
      var instance = create(isObject(proto) ? proto : Object.prototype);
      var result = Function.apply.call(Target, instance, args);
      return isObject(result) ? result : instance;
    }
  });
  /***/
},
/* 350 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
  var dP = __webpack_require__(12);

  var $export = __webpack_require__(0);

  var anObject = __webpack_require__(2);

  var toPrimitive = __webpack_require__(36); // MS Edge has broken Reflect.defineProperty - throwing instead of returning false


  $export($export.S + $export.F * __webpack_require__(5)(function () {
    // eslint-disable-next-line no-undef
    Reflect.defineProperty(dP.f({}, 1, {
      value: 1
    }), 1, {
      value: 2
    });
  }), 'Reflect', {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
      anObject(target);
      propertyKey = toPrimitive(propertyKey, true);
      anObject(attributes);

      try {
        dP.f(target, propertyKey, attributes);
        return true;
      } catch (e) {
        return false;
      }
    }
  });
  /***/
},
/* 351 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.4 Reflect.deleteProperty(target, propertyKey)
  var $export = __webpack_require__(0);

  var gOPD = __webpack_require__(24).f;

  var anObject = __webpack_require__(2);

  $export($export.S, 'Reflect', {
    deleteProperty: function deleteProperty(target, propertyKey) {
      var desc = gOPD(anObject(target), propertyKey);
      return desc && !desc.configurable ? false : delete target[propertyKey];
    }
  });
  /***/
},
/* 352 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 26.1.5 Reflect.enumerate(target)

  var $export = __webpack_require__(0);

  var anObject = __webpack_require__(2);

  var Enumerate = function Enumerate(iterated) {
    this._t = anObject(iterated); // target

    this._i = 0; // next index

    var keys = this._k = []; // keys

    var key;

    for (key in iterated) {
      keys.push(key);
    }
  };

  __webpack_require__(118)(Enumerate, 'Object', function () {
    var that = this;
    var keys = that._k;
    var key;

    do {
      if (that._i >= keys.length) return {
        value: undefined,
        done: true
      };
    } while (!((key = keys[that._i++]) in that._t));

    return {
      value: key,
      done: false
    };
  });

  $export($export.S, 'Reflect', {
    enumerate: function enumerate(target) {
      return new Enumerate(target);
    }
  });
  /***/
},
/* 353 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
  var gOPD = __webpack_require__(24);

  var $export = __webpack_require__(0);

  var anObject = __webpack_require__(2);

  $export($export.S, 'Reflect', {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
      return gOPD.f(anObject(target), propertyKey);
    }
  });
  /***/
},
/* 354 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.8 Reflect.getPrototypeOf(target)
  var $export = __webpack_require__(0);

  var getProto = __webpack_require__(25);

  var anObject = __webpack_require__(2);

  $export($export.S, 'Reflect', {
    getPrototypeOf: function getPrototypeOf(target) {
      return getProto(anObject(target));
    }
  });
  /***/
},
/* 355 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.6 Reflect.get(target, propertyKey [, receiver])
  var gOPD = __webpack_require__(24);

  var getPrototypeOf = __webpack_require__(25);

  var has = __webpack_require__(23);

  var $export = __webpack_require__(0);

  var isObject = __webpack_require__(7);

  var anObject = __webpack_require__(2);

  function get(target, propertyKey
  /* , receiver */
  ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var desc, proto;
    if (anObject(target) === receiver) return target[propertyKey];
    if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
    if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
  }

  $export($export.S, 'Reflect', {
    get: get
  });
  /***/
},
/* 356 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.9 Reflect.has(target, propertyKey)
  var $export = __webpack_require__(0);

  $export($export.S, 'Reflect', {
    has: function has(target, propertyKey) {
      return propertyKey in target;
    }
  });
  /***/
},
/* 357 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.10 Reflect.isExtensible(target)
  var $export = __webpack_require__(0);

  var anObject = __webpack_require__(2);

  var $isExtensible = Object.isExtensible;
  $export($export.S, 'Reflect', {
    isExtensible: function isExtensible(target) {
      anObject(target);
      return $isExtensible ? $isExtensible(target) : true;
    }
  });
  /***/
},
/* 358 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.11 Reflect.ownKeys(target)
  var $export = __webpack_require__(0);

  $export($export.S, 'Reflect', {
    ownKeys: __webpack_require__(185)
  });
  /***/
},
/* 359 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.12 Reflect.preventExtensions(target)
  var $export = __webpack_require__(0);

  var anObject = __webpack_require__(2);

  var $preventExtensions = Object.preventExtensions;
  $export($export.S, 'Reflect', {
    preventExtensions: function preventExtensions(target) {
      anObject(target);

      try {
        if ($preventExtensions) $preventExtensions(target);
        return true;
      } catch (e) {
        return false;
      }
    }
  });
  /***/
},
/* 360 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.14 Reflect.setPrototypeOf(target, proto)
  var $export = __webpack_require__(0);

  var setProto = __webpack_require__(124);

  if (setProto) $export($export.S, 'Reflect', {
    setPrototypeOf: function setPrototypeOf(target, proto) {
      setProto.check(target, proto);

      try {
        setProto.set(target, proto);
        return true;
      } catch (e) {
        return false;
      }
    }
  });
  /***/
},
/* 361 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
  var dP = __webpack_require__(12);

  var gOPD = __webpack_require__(24);

  var getPrototypeOf = __webpack_require__(25);

  var has = __webpack_require__(23);

  var $export = __webpack_require__(0);

  var createDesc = __webpack_require__(55);

  var anObject = __webpack_require__(2);

  var isObject = __webpack_require__(7);

  function set(target, propertyKey, V
  /* , receiver */
  ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDesc = gOPD.f(anObject(target), propertyKey);
    var existingDescriptor, proto;

    if (!ownDesc) {
      if (isObject(proto = getPrototypeOf(target))) {
        return set(proto, propertyKey, V, receiver);
      }

      ownDesc = createDesc(0);
    }

    if (has(ownDesc, 'value')) {
      if (ownDesc.writable === false || !isObject(receiver)) return false;

      if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
        if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
        existingDescriptor.value = V;
        dP.f(receiver, propertyKey, existingDescriptor);
      } else dP.f(receiver, propertyKey, createDesc(0, V));

      return true;
    }

    return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
  }

  $export($export.S, 'Reflect', {
    set: set
  });
  /***/
},
/* 362 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(3);

  var inheritIfRequired = __webpack_require__(116);

  var dP = __webpack_require__(12).f;

  var gOPN = __webpack_require__(53).f;

  var isRegExp = __webpack_require__(91);

  var $flags = __webpack_require__(89);

  var $RegExp = global.RegExp;
  var Base = $RegExp;
  var proto = $RegExp.prototype;
  var re1 = /a/g;
  var re2 = /a/g; // "new" creates a new object, old webkit buggy here

  var CORRECT_NEW = new $RegExp(re1) !== re1;

  if (__webpack_require__(11) && (!CORRECT_NEW || __webpack_require__(5)(function () {
    re2[__webpack_require__(9)('match')] = false; // RegExp constructor can alter flags and IsRegExp works correct with @@match

    return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
  }))) {
    $RegExp = function RegExp(p, f) {
      var tiRE = this instanceof $RegExp;
      var piRE = isRegExp(p);
      var fiU = f === undefined;
      return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
    };

    var proxy = function proxy(key) {
      key in $RegExp || dP($RegExp, key, {
        configurable: true,
        get: function get() {
          return Base[key];
        },
        set: function set(it) {
          Base[key] = it;
        }
      });
    };

    for (var keys = gOPN(Base), i = 0; keys.length > i;) {
      proxy(keys[i++]);
    }

    proto.constructor = $RegExp;
    $RegExp.prototype = proto;

    __webpack_require__(21)(global, 'RegExp', $RegExp);
  }

  __webpack_require__(57)('RegExp');
  /***/

},
/* 363 */

/***/
function (module, exports, __webpack_require__) {
  // @@match logic
  __webpack_require__(88)('match', 1, function (defined, MATCH, $match) {
    // 21.1.3.11 String.prototype.match(regexp)
    return [function match(regexp) {
      'use strict';

      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    }, $match];
  });
  /***/

},
/* 364 */

/***/
function (module, exports, __webpack_require__) {
  // @@replace logic
  __webpack_require__(88)('replace', 2, function (defined, REPLACE, $replace) {
    // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
    return [function replace(searchValue, replaceValue) {
      'use strict';

      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
    }, $replace];
  });
  /***/

},
/* 365 */

/***/
function (module, exports, __webpack_require__) {
  // @@search logic
  __webpack_require__(88)('search', 1, function (defined, SEARCH, $search) {
    // 21.1.3.15 String.prototype.search(regexp)
    return [function search(regexp) {
      'use strict';

      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    }, $search];
  });
  /***/

},
/* 366 */

/***/
function (module, exports, __webpack_require__) {
  // @@split logic
  __webpack_require__(88)('split', 2, function (defined, SPLIT, $split) {
    'use strict';

    var isRegExp = __webpack_require__(91);

    var _split = $split;
    var $push = [].push;
    var $SPLIT = 'split';
    var LENGTH = 'length';
    var LAST_INDEX = 'lastIndex';

    if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
      var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
      // based on es5-shim implementation, need to rework it

      $split = function $split(separator, limit) {
        var string = String(this);
        if (separator === undefined && limit === 0) return []; // If `separator` is not a regex, use native split

        if (!isRegExp(separator)) return _split.call(string, separator, limit);
        var output = [];
        var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
        var lastLastIndex = 0;
        var splitLimit = limit === undefined ? 4294967295 : limit >>> 0; // Make `global` and avoid `lastIndex` issues by working with a copy

        var separatorCopy = new RegExp(separator.source, flags + 'g');
        var separator2, match, lastIndex, lastLength, i; // Doesn't need flags gy, but they don't hurt

        if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);

        while (match = separatorCopy.exec(string)) {
          // `separatorCopy.lastIndex` is not reliable cross-browser
          lastIndex = match.index + match[0][LENGTH];

          if (lastIndex > lastLastIndex) {
            output.push(string.slice(lastLastIndex, match.index)); // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
            // eslint-disable-next-line no-loop-func

            if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
              for (i = 1; i < arguments[LENGTH] - 2; i++) {
                if (arguments[i] === undefined) match[i] = undefined;
              }
            });
            if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
            lastLength = match[0][LENGTH];
            lastLastIndex = lastIndex;
            if (output[LENGTH] >= splitLimit) break;
          }

          if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
        }

        if (lastLastIndex === string[LENGTH]) {
          if (lastLength || !separatorCopy.test('')) output.push('');
        } else output.push(string.slice(lastLastIndex));

        return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
      }; // Chakra, V8

    } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
      $split = function $split(separator, limit) {
        return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
      };
    } // 21.1.3.17 String.prototype.split(separator, limit)


    return [function split(separator, limit) {
      var O = defined(this);
      var fn = separator == undefined ? undefined : separator[SPLIT];
      return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
    }, $split];
  });
  /***/

},
/* 367 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  __webpack_require__(194);

  var anObject = __webpack_require__(2);

  var $flags = __webpack_require__(89);

  var DESCRIPTORS = __webpack_require__(11);

  var TO_STRING = 'toString';
  var $toString = /./[TO_STRING];

  var define = function define(fn) {
    __webpack_require__(21)(RegExp.prototype, TO_STRING, fn, true);
  }; // 21.2.5.14 RegExp.prototype.toString()


  if (__webpack_require__(5)(function () {
    return $toString.call({
      source: 'a',
      flags: 'b'
    }) != '/a/b';
  })) {
    define(function toString() {
      var R = anObject(this);
      return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
    }); // FF44- RegExp#toString has a wrong name
  } else if ($toString.name != TO_STRING) {
    define(function toString() {
      return $toString.call(this);
    });
  }
  /***/

},
/* 368 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.2 String.prototype.anchor(name)

  __webpack_require__(22)('anchor', function (createHTML) {
    return function anchor(name) {
      return createHTML(this, 'a', 'name', name);
    };
  });
  /***/

},
/* 369 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.3 String.prototype.big()

  __webpack_require__(22)('big', function (createHTML) {
    return function big() {
      return createHTML(this, 'big', '', '');
    };
  });
  /***/

},
/* 370 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.4 String.prototype.blink()

  __webpack_require__(22)('blink', function (createHTML) {
    return function blink() {
      return createHTML(this, 'blink', '', '');
    };
  });
  /***/

},
/* 371 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.5 String.prototype.bold()

  __webpack_require__(22)('bold', function (createHTML) {
    return function bold() {
      return createHTML(this, 'b', '', '');
    };
  });
  /***/

},
/* 372 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $at = __webpack_require__(126)(false);

  $export($export.P, 'String', {
    // 21.1.3.3 String.prototype.codePointAt(pos)
    codePointAt: function codePointAt(pos) {
      return $at(this, pos);
    }
  });
  /***/
},
/* 373 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

  var $export = __webpack_require__(0);

  var toLength = __webpack_require__(13);

  var context = __webpack_require__(127);

  var ENDS_WITH = 'endsWith';
  var $endsWith = ''[ENDS_WITH];
  $export($export.P + $export.F * __webpack_require__(114)(ENDS_WITH), 'String', {
    endsWith: function endsWith(searchString
    /* , endPosition = @length */
    ) {
      var that = context(this, searchString, ENDS_WITH);
      var endPosition = arguments.length > 1 ? arguments[1] : undefined;
      var len = toLength(that.length);
      var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
      var search = String(searchString);
      return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
    }
  });
  /***/
},
/* 374 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.6 String.prototype.fixed()

  __webpack_require__(22)('fixed', function (createHTML) {
    return function fixed() {
      return createHTML(this, 'tt', '', '');
    };
  });
  /***/

},
/* 375 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.7 String.prototype.fontcolor(color)

  __webpack_require__(22)('fontcolor', function (createHTML) {
    return function fontcolor(color) {
      return createHTML(this, 'font', 'color', color);
    };
  });
  /***/

},
/* 376 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.8 String.prototype.fontsize(size)

  __webpack_require__(22)('fontsize', function (createHTML) {
    return function fontsize(size) {
      return createHTML(this, 'font', 'size', size);
    };
  });
  /***/

},
/* 377 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var toAbsoluteIndex = __webpack_require__(58);

  var fromCharCode = String.fromCharCode;
  var $fromCodePoint = String.fromCodePoint; // length should be 1, old FF problem

  $export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
    // 21.1.2.2 String.fromCodePoint(...codePoints)
    fromCodePoint: function fromCodePoint(x) {
      // eslint-disable-line no-unused-vars
      var res = [];
      var aLen = arguments.length;
      var i = 0;
      var code;

      while (aLen > i) {
        code = +arguments[i++];
        if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
        res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
      }

      return res.join('');
    }
  });
  /***/
},
/* 378 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 21.1.3.7 String.prototype.includes(searchString, position = 0)

  var $export = __webpack_require__(0);

  var context = __webpack_require__(127);

  var INCLUDES = 'includes';
  $export($export.P + $export.F * __webpack_require__(114)(INCLUDES), 'String', {
    includes: function includes(searchString
    /* , position = 0 */
    ) {
      return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 379 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.9 String.prototype.italics()

  __webpack_require__(22)('italics', function (createHTML) {
    return function italics() {
      return createHTML(this, 'i', '', '');
    };
  });
  /***/

},
/* 380 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $at = __webpack_require__(126)(true); // 21.1.3.27 String.prototype[@@iterator]()


  __webpack_require__(119)(String, 'String', function (iterated) {
    this._t = String(iterated); // target

    this._i = 0; // next index
    // 21.1.5.2.1 %StringIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
      value: undefined,
      done: true
    };
    point = $at(O, index);
    this._i += point.length;
    return {
      value: point,
      done: false
    };
  });
  /***/

},
/* 381 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.10 String.prototype.link(url)

  __webpack_require__(22)('link', function (createHTML) {
    return function link(url) {
      return createHTML(this, 'a', 'href', url);
    };
  });
  /***/

},
/* 382 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var toIObject = __webpack_require__(26);

  var toLength = __webpack_require__(13);

  $export($export.S, 'String', {
    // 21.1.2.4 String.raw(callSite, ...substitutions)
    raw: function raw(callSite) {
      var tpl = toIObject(callSite.raw);
      var len = toLength(tpl.length);
      var aLen = arguments.length;
      var res = [];
      var i = 0;

      while (len > i) {
        res.push(String(tpl[i++]));
        if (i < aLen) res.push(String(arguments[i]));
      }

      return res.join('');
    }
  });
  /***/
},
/* 383 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  $export($export.P, 'String', {
    // 21.1.3.13 String.prototype.repeat(count)
    repeat: __webpack_require__(128)
  });
  /***/
},
/* 384 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.11 String.prototype.small()

  __webpack_require__(22)('small', function (createHTML) {
    return function small() {
      return createHTML(this, 'small', '', '');
    };
  });
  /***/

},
/* 385 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 21.1.3.18 String.prototype.startsWith(searchString [, position ])

  var $export = __webpack_require__(0);

  var toLength = __webpack_require__(13);

  var context = __webpack_require__(127);

  var STARTS_WITH = 'startsWith';
  var $startsWith = ''[STARTS_WITH];
  $export($export.P + $export.F * __webpack_require__(114)(STARTS_WITH), 'String', {
    startsWith: function startsWith(searchString
    /* , position = 0 */
    ) {
      var that = context(this, searchString, STARTS_WITH);
      var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
      var search = String(searchString);
      return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
    }
  });
  /***/
},
/* 386 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.12 String.prototype.strike()

  __webpack_require__(22)('strike', function (createHTML) {
    return function strike() {
      return createHTML(this, 'strike', '', '');
    };
  });
  /***/

},
/* 387 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.13 String.prototype.sub()

  __webpack_require__(22)('sub', function (createHTML) {
    return function sub() {
      return createHTML(this, 'sub', '', '');
    };
  });
  /***/

},
/* 388 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.14 String.prototype.sup()

  __webpack_require__(22)('sup', function (createHTML) {
    return function sup() {
      return createHTML(this, 'sup', '', '');
    };
  });
  /***/

},
/* 389 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 21.1.3.25 String.prototype.trim()

  __webpack_require__(66)('trim', function ($trim) {
    return function trim() {
      return $trim(this, 3);
    };
  });
  /***/

},
/* 390 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // ECMAScript 6 symbols shim

  var global = __webpack_require__(3);

  var has = __webpack_require__(23);

  var DESCRIPTORS = __webpack_require__(11);

  var $export = __webpack_require__(0);

  var redefine = __webpack_require__(21);

  var META = __webpack_require__(45).KEY;

  var $fails = __webpack_require__(5);

  var shared = __webpack_require__(97);

  var setToStringTag = __webpack_require__(65);

  var uid = __webpack_require__(59);

  var wks = __webpack_require__(9);

  var wksExt = __webpack_require__(192);

  var wksDefine = __webpack_require__(133);

  var enumKeys = __webpack_require__(267);

  var isArray = __webpack_require__(90);

  var anObject = __webpack_require__(2);

  var isObject = __webpack_require__(7);

  var toIObject = __webpack_require__(26);

  var toPrimitive = __webpack_require__(36);

  var createDesc = __webpack_require__(55);

  var _create = __webpack_require__(52);

  var gOPNExt = __webpack_require__(182);

  var $GOPD = __webpack_require__(24);

  var $DP = __webpack_require__(12);

  var $keys = __webpack_require__(54);

  var gOPD = $GOPD.f;
  var dP = $DP.f;
  var gOPN = gOPNExt.f;
  var $Symbol = global.Symbol;
  var $JSON = global.JSON;

  var _stringify = $JSON && $JSON.stringify;

  var PROTOTYPE = 'prototype';
  var HIDDEN = wks('_hidden');
  var TO_PRIMITIVE = wks('toPrimitive');
  var isEnum = {}.propertyIsEnumerable;
  var SymbolRegistry = shared('symbol-registry');
  var AllSymbols = shared('symbols');
  var OPSymbols = shared('op-symbols');
  var ObjectProto = Object[PROTOTYPE];
  var USE_NATIVE = typeof $Symbol == 'function';
  var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

  var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

  var setSymbolDesc = DESCRIPTORS && $fails(function () {
    return _create(dP({}, 'a', {
      get: function get() {
        return dP(this, 'a', {
          value: 7
        }).a;
      }
    })).a != 7;
  }) ? function (it, key, D) {
    var protoDesc = gOPD(ObjectProto, key);
    if (protoDesc) delete ObjectProto[key];
    dP(it, key, D);
    if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
  } : dP;

  var wrap = function wrap(tag) {
    var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

    sym._k = tag;
    return sym;
  };

  var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
    return typeof it == 'symbol';
  } : function (it) {
    return it instanceof $Symbol;
  };

  var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
    anObject(it);
    key = toPrimitive(key, true);
    anObject(D);

    if (has(AllSymbols, key)) {
      if (!D.enumerable) {
        if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
        D = _create(D, {
          enumerable: createDesc(0, false)
        });
      }

      return setSymbolDesc(it, key, D);
    }

    return dP(it, key, D);
  };

  var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIObject(P));
    var i = 0;
    var l = keys.length;
    var key;

    while (l > i) {
      $defineProperty(it, key = keys[i++], P[key]);
    }

    return it;
  };

  var $create = function create(it, P) {
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
  };

  var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = toPrimitive(key, true));
    if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };

  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = toIObject(it);
    key = toPrimitive(key, true);
    if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
    var D = gOPD(it, key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
  };

  var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN(toIObject(it));
    var result = [];
    var i = 0;
    var key;

    while (names.length > i) {
      if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
    }

    return result;
  };

  var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto;
    var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
    var result = [];
    var i = 0;
    var key;

    while (names.length > i) {
      if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
    }

    return result;
  }; // 19.4.1.1 Symbol([description])


  if (!USE_NATIVE) {
    $Symbol = function Symbol() {
      if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
      var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

      var $set = function $set(value) {
        if (this === ObjectProto) $set.call(OPSymbols, value);
        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, createDesc(1, value));
      };

      if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
        configurable: true,
        set: $set
      });
      return wrap(tag);
    };

    redefine($Symbol[PROTOTYPE], 'toString', function toString() {
      return this._k;
    });
    $GOPD.f = $getOwnPropertyDescriptor;
    $DP.f = $defineProperty;
    __webpack_require__(53).f = gOPNExt.f = $getOwnPropertyNames;
    __webpack_require__(77).f = $propertyIsEnumerable;
    __webpack_require__(94).f = $getOwnPropertySymbols;

    if (DESCRIPTORS && !__webpack_require__(51)) {
      redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }

    wksExt.f = function (name) {
      return wrap(wks(name));
    };
  }

  $export($export.G + $export.W + $export.F * !USE_NATIVE, {
    Symbol: $Symbol
  });

  for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
    wks(es6Symbols[j++]);
  }

  for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
    wksDefine(wellKnownSymbols[k++]);
  }

  $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function _for(key) {
      return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
      if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

      for (var key in SymbolRegistry) {
        if (SymbolRegistry[key] === sym) return key;
      }
    },
    useSetter: function useSetter() {
      setter = true;
    },
    useSimple: function useSimple() {
      setter = false;
    }
  });
  $export($export.S + $export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
  }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

  $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
    var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols

    return _stringify([S]) != '[null]' || _stringify({
      a: S
    }) != '{}' || _stringify(Object(S)) != '{}';
  })), 'JSON', {
    stringify: function stringify(it) {
      var args = [it];
      var i = 1;
      var replacer, $replacer;

      while (arguments.length > i) {
        args.push(arguments[i++]);
      }

      $replacer = replacer = args[1];
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

      if (!isArray(replacer)) replacer = function replacer(key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return _stringify.apply($JSON, args);
    }
  }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

  $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(20)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

  setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

  setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

  setToStringTag(global.JSON, 'JSON', true);
  /***/
},
/* 391 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $typed = __webpack_require__(99);

  var buffer = __webpack_require__(131);

  var anObject = __webpack_require__(2);

  var toAbsoluteIndex = __webpack_require__(58);

  var toLength = __webpack_require__(13);

  var isObject = __webpack_require__(7);

  var ArrayBuffer = __webpack_require__(3).ArrayBuffer;

  var speciesConstructor = __webpack_require__(98);

  var $ArrayBuffer = buffer.ArrayBuffer;
  var $DataView = buffer.DataView;
  var $isView = $typed.ABV && ArrayBuffer.isView;
  var $slice = $ArrayBuffer.prototype.slice;
  var VIEW = $typed.VIEW;
  var ARRAY_BUFFER = 'ArrayBuffer';
  $export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {
    ArrayBuffer: $ArrayBuffer
  });
  $export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
    // 24.1.3.1 ArrayBuffer.isView(arg)
    isView: function isView(it) {
      return $isView && $isView(it) || isObject(it) && VIEW in it;
    }
  });
  $export($export.P + $export.U + $export.F * __webpack_require__(5)(function () {
    return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
  }), ARRAY_BUFFER, {
    // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
    slice: function slice(start, end) {
      if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix

      var len = anObject(this).byteLength;
      var first = toAbsoluteIndex(start, len);
      var final = toAbsoluteIndex(end === undefined ? len : end, len);
      var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
      var viewS = new $DataView(this);
      var viewT = new $DataView(result);
      var index = 0;

      while (first < final) {
        viewT.setUint8(index++, viewS.getUint8(first++));
      }

      return result;
    }
  });

  __webpack_require__(57)(ARRAY_BUFFER);
  /***/

},
/* 392 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  $export($export.G + $export.W + $export.F * !__webpack_require__(99).ABV, {
    DataView: __webpack_require__(131).DataView
  });
  /***/
},
/* 393 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(40)('Float32', 4, function (init) {
    return function Float32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 394 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(40)('Float64', 8, function (init) {
    return function Float64Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 395 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(40)('Int16', 2, function (init) {
    return function Int16Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 396 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(40)('Int32', 4, function (init) {
    return function Int32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 397 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(40)('Int8', 1, function (init) {
    return function Int8Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 398 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(40)('Uint16', 2, function (init) {
    return function Uint16Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 399 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(40)('Uint32', 4, function (init) {
    return function Uint32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 400 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(40)('Uint8', 1, function (init) {
    return function Uint8Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 401 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(40)('Uint8', 1, function (init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  }, true);
  /***/

},
/* 402 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var weak = __webpack_require__(170);

  var validate = __webpack_require__(67);

  var WEAK_SET = 'WeakSet'; // 23.4 WeakSet Objects

  __webpack_require__(87)(WEAK_SET, function (get) {
    return function WeakSet() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  }, {
    // 23.4.3.1 WeakSet.prototype.add(value)
    add: function add(value) {
      return weak.def(validate(this, WEAK_SET), value, true);
    }
  }, weak, false, true);
  /***/

},
/* 403 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap

  var $export = __webpack_require__(0);

  var flattenIntoArray = __webpack_require__(171);

  var toObject = __webpack_require__(15);

  var toLength = __webpack_require__(13);

  var aFunction = __webpack_require__(18);

  var arraySpeciesCreate = __webpack_require__(110);

  $export($export.P, 'Array', {
    flatMap: function flatMap(callbackfn
    /* , thisArg */
    ) {
      var O = toObject(this);
      var sourceLen, A;
      aFunction(callbackfn);
      sourceLen = toLength(O.length);
      A = arraySpeciesCreate(O, 0);
      flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
      return A;
    }
  });

  __webpack_require__(44)('flatMap');
  /***/

},
/* 404 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten

  var $export = __webpack_require__(0);

  var flattenIntoArray = __webpack_require__(171);

  var toObject = __webpack_require__(15);

  var toLength = __webpack_require__(13);

  var toInteger = __webpack_require__(35);

  var arraySpeciesCreate = __webpack_require__(110);

  $export($export.P, 'Array', {
    flatten: function flatten()
    /* depthArg = 1 */
    {
      var depthArg = arguments[0];
      var O = toObject(this);
      var sourceLen = toLength(O.length);
      var A = arraySpeciesCreate(O, 0);
      flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
      return A;
    }
  });

  __webpack_require__(44)('flatten');
  /***/

},
/* 405 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/Array.prototype.includes

  var $export = __webpack_require__(0);

  var $includes = __webpack_require__(86)(true);

  $export($export.P, 'Array', {
    includes: function includes(el
    /* , fromIndex = 0 */
    ) {
      return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  __webpack_require__(44)('includes');
  /***/

},
/* 406 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
  var $export = __webpack_require__(0);

  var microtask = __webpack_require__(122)();

  var process = __webpack_require__(3).process;

  var isNode = __webpack_require__(27)(process) == 'process';
  $export($export.G, {
    asap: function asap(fn) {
      var domain = isNode && process.domain;
      microtask(domain ? domain.bind(fn) : fn);
    }
  });
  /***/
},
/* 407 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/ljharb/proposal-is-error
  var $export = __webpack_require__(0);

  var cof = __webpack_require__(27);

  $export($export.S, 'Error', {
    isError: function isError(it) {
      return cof(it) === 'Error';
    }
  });
  /***/
},
/* 408 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-global
  var $export = __webpack_require__(0);

  $export($export.G, {
    global: __webpack_require__(3)
  });
  /***/
},
/* 409 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
  __webpack_require__(95)('Map');
  /***/

},
/* 410 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
  __webpack_require__(96)('Map');
  /***/

},
/* 411 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/DavidBruant/Map-Set.prototype.toJSON
  var $export = __webpack_require__(0);

  $export($export.P + $export.R, 'Map', {
    toJSON: __webpack_require__(169)('Map')
  });
  /***/
},
/* 412 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    clamp: function clamp(x, lower, upper) {
      return Math.min(upper, Math.max(lower, x));
    }
  });
  /***/
},
/* 413 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    DEG_PER_RAD: Math.PI / 180
  });
  /***/
},
/* 414 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  var RAD_PER_DEG = 180 / Math.PI;
  $export($export.S, 'Math', {
    degrees: function degrees(radians) {
      return radians * RAD_PER_DEG;
    }
  });
  /***/
},
/* 415 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  var scale = __webpack_require__(179);

  var fround = __webpack_require__(177);

  $export($export.S, 'Math', {
    fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
      return fround(scale(x, inLow, inHigh, outLow, outHigh));
    }
  });
  /***/
},
/* 416 */

/***/
function (module, exports, __webpack_require__) {
  // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    iaddh: function iaddh(x0, x1, y0, y1) {
      var $x0 = x0 >>> 0;
      var $x1 = x1 >>> 0;
      var $y0 = y0 >>> 0;
      return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
    }
  });
  /***/
},
/* 417 */

/***/
function (module, exports, __webpack_require__) {
  // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    imulh: function imulh(u, v) {
      var UINT16 = 0xffff;
      var $u = +u;
      var $v = +v;
      var u0 = $u & UINT16;
      var v0 = $v & UINT16;
      var u1 = $u >> 16;
      var v1 = $v >> 16;
      var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
      return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
    }
  });
  /***/
},
/* 418 */

/***/
function (module, exports, __webpack_require__) {
  // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    isubh: function isubh(x0, x1, y0, y1) {
      var $x0 = x0 >>> 0;
      var $x1 = x1 >>> 0;
      var $y0 = y0 >>> 0;
      return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
    }
  });
  /***/
},
/* 419 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    RAD_PER_DEG: 180 / Math.PI
  });
  /***/
},
/* 420 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  var DEG_PER_RAD = Math.PI / 180;
  $export($export.S, 'Math', {
    radians: function radians(degrees) {
      return degrees * DEG_PER_RAD;
    }
  });
  /***/
},
/* 421 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    scale: __webpack_require__(179)
  });
  /***/
},
/* 422 */

/***/
function (module, exports, __webpack_require__) {
  // http://jfbastien.github.io/papers/Math.signbit.html
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    signbit: function signbit(x) {
      // eslint-disable-next-line no-self-compare
      return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
    }
  });
  /***/
},
/* 423 */

/***/
function (module, exports, __webpack_require__) {
  // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    umulh: function umulh(u, v) {
      var UINT16 = 0xffff;
      var $u = +u;
      var $v = +v;
      var u0 = $u & UINT16;
      var v0 = $v & UINT16;
      var u1 = $u >>> 16;
      var v1 = $v >>> 16;
      var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
      return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
    }
  });
  /***/
},
/* 424 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(15);

  var aFunction = __webpack_require__(18);

  var $defineProperty = __webpack_require__(12); // B.2.2.2 Object.prototype.__defineGetter__(P, getter)


  __webpack_require__(11) && $export($export.P + __webpack_require__(93), 'Object', {
    __defineGetter__: function __defineGetter__(P, getter) {
      $defineProperty.f(toObject(this), P, {
        get: aFunction(getter),
        enumerable: true,
        configurable: true
      });
    }
  });
  /***/
},
/* 425 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(15);

  var aFunction = __webpack_require__(18);

  var $defineProperty = __webpack_require__(12); // B.2.2.3 Object.prototype.__defineSetter__(P, setter)


  __webpack_require__(11) && $export($export.P + __webpack_require__(93), 'Object', {
    __defineSetter__: function __defineSetter__(P, setter) {
      $defineProperty.f(toObject(this), P, {
        set: aFunction(setter),
        enumerable: true,
        configurable: true
      });
    }
  });
  /***/
},
/* 426 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-object-values-entries
  var $export = __webpack_require__(0);

  var $entries = __webpack_require__(184)(true);

  $export($export.S, 'Object', {
    entries: function entries(it) {
      return $entries(it);
    }
  });
  /***/
},
/* 427 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-object-getownpropertydescriptors
  var $export = __webpack_require__(0);

  var ownKeys = __webpack_require__(185);

  var toIObject = __webpack_require__(26);

  var gOPD = __webpack_require__(24);

  var createProperty = __webpack_require__(111);

  $export($export.S, 'Object', {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
      var O = toIObject(object);
      var getDesc = gOPD.f;
      var keys = ownKeys(O);
      var result = {};
      var i = 0;
      var key, desc;

      while (keys.length > i) {
        desc = getDesc(O, key = keys[i++]);
        if (desc !== undefined) createProperty(result, key, desc);
      }

      return result;
    }
  });
  /***/
},
/* 428 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(15);

  var toPrimitive = __webpack_require__(36);

  var getPrototypeOf = __webpack_require__(25);

  var getOwnPropertyDescriptor = __webpack_require__(24).f; // B.2.2.4 Object.prototype.__lookupGetter__(P)


  __webpack_require__(11) && $export($export.P + __webpack_require__(93), 'Object', {
    __lookupGetter__: function __lookupGetter__(P) {
      var O = toObject(this);
      var K = toPrimitive(P, true);
      var D;

      do {
        if (D = getOwnPropertyDescriptor(O, K)) return D.get;
      } while (O = getPrototypeOf(O));
    }
  });
  /***/
},
/* 429 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(15);

  var toPrimitive = __webpack_require__(36);

  var getPrototypeOf = __webpack_require__(25);

  var getOwnPropertyDescriptor = __webpack_require__(24).f; // B.2.2.5 Object.prototype.__lookupSetter__(P)


  __webpack_require__(11) && $export($export.P + __webpack_require__(93), 'Object', {
    __lookupSetter__: function __lookupSetter__(P) {
      var O = toObject(this);
      var K = toPrimitive(P, true);
      var D;

      do {
        if (D = getOwnPropertyDescriptor(O, K)) return D.set;
      } while (O = getPrototypeOf(O));
    }
  });
  /***/
},
/* 430 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-object-values-entries
  var $export = __webpack_require__(0);

  var $values = __webpack_require__(184)(false);

  $export($export.S, 'Object', {
    values: function values(it) {
      return $values(it);
    }
  });
  /***/
},
/* 431 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/zenparsing/es-observable

  var $export = __webpack_require__(0);

  var global = __webpack_require__(3);

  var core = __webpack_require__(32);

  var microtask = __webpack_require__(122)();

  var OBSERVABLE = __webpack_require__(9)('observable');

  var aFunction = __webpack_require__(18);

  var anObject = __webpack_require__(2);

  var anInstance = __webpack_require__(49);

  var redefineAll = __webpack_require__(56);

  var hide = __webpack_require__(20);

  var forOf = __webpack_require__(50);

  var RETURN = forOf.RETURN;

  var getMethod = function getMethod(fn) {
    return fn == null ? undefined : aFunction(fn);
  };

  var cleanupSubscription = function cleanupSubscription(subscription) {
    var cleanup = subscription._c;

    if (cleanup) {
      subscription._c = undefined;
      cleanup();
    }
  };

  var subscriptionClosed = function subscriptionClosed(subscription) {
    return subscription._o === undefined;
  };

  var closeSubscription = function closeSubscription(subscription) {
    if (!subscriptionClosed(subscription)) {
      subscription._o = undefined;
      cleanupSubscription(subscription);
    }
  };

  var Subscription = function Subscription(observer, subscriber) {
    anObject(observer);
    this._c = undefined;
    this._o = observer;
    observer = new SubscriptionObserver(this);

    try {
      var cleanup = subscriber(observer);
      var subscription = cleanup;

      if (cleanup != null) {
        if (typeof cleanup.unsubscribe === 'function') cleanup = function cleanup() {
          subscription.unsubscribe();
        };else aFunction(cleanup);
        this._c = cleanup;
      }
    } catch (e) {
      observer.error(e);
      return;
    }

    if (subscriptionClosed(this)) cleanupSubscription(this);
  };

  Subscription.prototype = redefineAll({}, {
    unsubscribe: function unsubscribe() {
      closeSubscription(this);
    }
  });

  var SubscriptionObserver = function SubscriptionObserver(subscription) {
    this._s = subscription;
  };

  SubscriptionObserver.prototype = redefineAll({}, {
    next: function next(value) {
      var subscription = this._s;

      if (!subscriptionClosed(subscription)) {
        var observer = subscription._o;

        try {
          var m = getMethod(observer.next);
          if (m) return m.call(observer, value);
        } catch (e) {
          try {
            closeSubscription(subscription);
          } finally {
            throw e;
          }
        }
      }
    },
    error: function error(value) {
      var subscription = this._s;
      if (subscriptionClosed(subscription)) throw value;
      var observer = subscription._o;
      subscription._o = undefined;

      try {
        var m = getMethod(observer.error);
        if (!m) throw value;
        value = m.call(observer, value);
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      }

      cleanupSubscription(subscription);
      return value;
    },
    complete: function complete(value) {
      var subscription = this._s;

      if (!subscriptionClosed(subscription)) {
        var observer = subscription._o;
        subscription._o = undefined;

        try {
          var m = getMethod(observer.complete);
          value = m ? m.call(observer, value) : undefined;
        } catch (e) {
          try {
            cleanupSubscription(subscription);
          } finally {
            throw e;
          }
        }

        cleanupSubscription(subscription);
        return value;
      }
    }
  });

  var $Observable = function Observable(subscriber) {
    anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
  };

  redefineAll($Observable.prototype, {
    subscribe: function subscribe(observer) {
      return new Subscription(observer, this._f);
    },
    forEach: function forEach(fn) {
      var that = this;
      return new (core.Promise || global.Promise)(function (resolve, reject) {
        aFunction(fn);
        var subscription = that.subscribe({
          next: function next(value) {
            try {
              return fn(value);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },
          error: reject,
          complete: resolve
        });
      });
    }
  });
  redefineAll($Observable, {
    from: function from(x) {
      var C = typeof this === 'function' ? this : $Observable;
      var method = getMethod(anObject(x)[OBSERVABLE]);

      if (method) {
        var observable = anObject(method.call(x));
        return observable.constructor === C ? observable : new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      return new C(function (observer) {
        var done = false;
        microtask(function () {
          if (!done) {
            try {
              if (forOf(x, false, function (it) {
                observer.next(it);
                if (done) return RETURN;
              }) === RETURN) return;
            } catch (e) {
              if (done) throw e;
              observer.error(e);
              return;
            }

            observer.complete();
          }
        });
        return function () {
          done = true;
        };
      });
    },
    of: function of() {
      for (var i = 0, l = arguments.length, items = new Array(l); i < l;) {
        items[i] = arguments[i++];
      }

      return new (typeof this === 'function' ? this : $Observable)(function (observer) {
        var done = false;
        microtask(function () {
          if (!done) {
            for (var j = 0; j < items.length; ++j) {
              observer.next(items[j]);
              if (done) return;
            }

            observer.complete();
          }
        });
        return function () {
          done = true;
        };
      });
    }
  });
  hide($Observable.prototype, OBSERVABLE, function () {
    return this;
  });
  $export($export.G, {
    Observable: $Observable
  });

  __webpack_require__(57)('Observable');
  /***/

},
/* 432 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/proposal-promise-finally

  var $export = __webpack_require__(0);

  var core = __webpack_require__(32);

  var global = __webpack_require__(3);

  var speciesConstructor = __webpack_require__(98);

  var promiseResolve = __webpack_require__(189);

  $export($export.P + $export.R, 'Promise', {
    'finally': function _finally(onFinally) {
      var C = speciesConstructor(this, core.Promise || global.Promise);
      var isFunction = typeof onFinally == 'function';
      return this.then(isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () {
          return x;
        });
      } : onFinally, isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () {
          throw e;
        });
      } : onFinally);
    }
  });
  /***/
},
/* 433 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/proposal-promise-try

  var $export = __webpack_require__(0);

  var newPromiseCapability = __webpack_require__(123);

  var perform = __webpack_require__(188);

  $export($export.S, 'Promise', {
    'try': function _try(callbackfn) {
      var promiseCapability = newPromiseCapability.f(this);
      var result = perform(callbackfn);
      (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
      return promiseCapability.promise;
    }
  });
  /***/
},
/* 434 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(2);

  var toMetaKey = metadata.key;
  var ordinaryDefineOwnMetadata = metadata.set;
  metadata.exp({
    defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
      ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
    }
  });
  /***/
},
/* 435 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(2);

  var toMetaKey = metadata.key;
  var getOrCreateMetadataMap = metadata.map;
  var store = metadata.store;
  metadata.exp({
    deleteMetadata: function deleteMetadata(metadataKey, target
    /* , targetKey */
    ) {
      var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
      var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
      if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
      if (metadataMap.size) return true;
      var targetMetadata = store.get(target);
      targetMetadata['delete'](targetKey);
      return !!targetMetadata.size || store['delete'](target);
    }
  });
  /***/
},
/* 436 */

/***/
function (module, exports, __webpack_require__) {
  var Set = __webpack_require__(195);

  var from = __webpack_require__(165);

  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(2);

  var getPrototypeOf = __webpack_require__(25);

  var ordinaryOwnMetadataKeys = metadata.keys;
  var toMetaKey = metadata.key;

  var ordinaryMetadataKeys = function ordinaryMetadataKeys(O, P) {
    var oKeys = ordinaryOwnMetadataKeys(O, P);
    var parent = getPrototypeOf(O);
    if (parent === null) return oKeys;
    var pKeys = ordinaryMetadataKeys(parent, P);
    return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
  };

  metadata.exp({
    getMetadataKeys: function getMetadataKeys(target
    /* , targetKey */
    ) {
      return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
    }
  });
  /***/
},
/* 437 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(2);

  var getPrototypeOf = __webpack_require__(25);

  var ordinaryHasOwnMetadata = metadata.has;
  var ordinaryGetOwnMetadata = metadata.get;
  var toMetaKey = metadata.key;

  var ordinaryGetMetadata = function ordinaryGetMetadata(MetadataKey, O, P) {
    var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
    var parent = getPrototypeOf(O);
    return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
  };

  metadata.exp({
    getMetadata: function getMetadata(metadataKey, target
    /* , targetKey */
    ) {
      return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
    }
  });
  /***/
},
/* 438 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(2);

  var ordinaryOwnMetadataKeys = metadata.keys;
  var toMetaKey = metadata.key;
  metadata.exp({
    getOwnMetadataKeys: function getOwnMetadataKeys(target
    /* , targetKey */
    ) {
      return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
    }
  });
  /***/
},
/* 439 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(2);

  var ordinaryGetOwnMetadata = metadata.get;
  var toMetaKey = metadata.key;
  metadata.exp({
    getOwnMetadata: function getOwnMetadata(metadataKey, target
    /* , targetKey */
    ) {
      return ordinaryGetOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
    }
  });
  /***/
},
/* 440 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(2);

  var getPrototypeOf = __webpack_require__(25);

  var ordinaryHasOwnMetadata = metadata.has;
  var toMetaKey = metadata.key;

  var ordinaryHasMetadata = function ordinaryHasMetadata(MetadataKey, O, P) {
    var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return true;
    var parent = getPrototypeOf(O);
    return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
  };

  metadata.exp({
    hasMetadata: function hasMetadata(metadataKey, target
    /* , targetKey */
    ) {
      return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
    }
  });
  /***/
},
/* 441 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(2);

  var ordinaryHasOwnMetadata = metadata.has;
  var toMetaKey = metadata.key;
  metadata.exp({
    hasOwnMetadata: function hasOwnMetadata(metadataKey, target
    /* , targetKey */
    ) {
      return ordinaryHasOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
    }
  });
  /***/
},
/* 442 */

/***/
function (module, exports, __webpack_require__) {
  var $metadata = __webpack_require__(39);

  var anObject = __webpack_require__(2);

  var aFunction = __webpack_require__(18);

  var toMetaKey = $metadata.key;
  var ordinaryDefineOwnMetadata = $metadata.set;
  $metadata.exp({
    metadata: function metadata(metadataKey, metadataValue) {
      return function decorator(target, targetKey) {
        ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? anObject : aFunction)(target), toMetaKey(targetKey));
      };
    }
  });
  /***/
},
/* 443 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
  __webpack_require__(95)('Set');
  /***/

},
/* 444 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
  __webpack_require__(96)('Set');
  /***/

},
/* 445 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/DavidBruant/Map-Set.prototype.toJSON
  var $export = __webpack_require__(0);

  $export($export.P + $export.R, 'Set', {
    toJSON: __webpack_require__(169)('Set')
  });
  /***/
},
/* 446 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/mathiasbynens/String.prototype.at

  var $export = __webpack_require__(0);

  var $at = __webpack_require__(126)(true);

  $export($export.P, 'String', {
    at: function at(pos) {
      return $at(this, pos);
    }
  });
  /***/
},
/* 447 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/String.prototype.matchAll/

  var $export = __webpack_require__(0);

  var defined = __webpack_require__(33);

  var toLength = __webpack_require__(13);

  var isRegExp = __webpack_require__(91);

  var getFlags = __webpack_require__(89);

  var RegExpProto = RegExp.prototype;

  var $RegExpStringIterator = function $RegExpStringIterator(regexp, string) {
    this._r = regexp;
    this._s = string;
  };

  __webpack_require__(118)($RegExpStringIterator, 'RegExp String', function next() {
    var match = this._r.exec(this._s);

    return {
      value: match,
      done: match === null
    };
  });

  $export($export.P, 'String', {
    matchAll: function matchAll(regexp) {
      defined(this);
      if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
      var S = String(this);
      var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
      var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
      rx.lastIndex = toLength(regexp.lastIndex);
      return new $RegExpStringIterator(rx, S);
    }
  });
  /***/
},
/* 448 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/proposal-string-pad-start-end

  var $export = __webpack_require__(0);

  var $pad = __webpack_require__(190);

  var userAgent = __webpack_require__(132); // https://github.com/zloirock/core-js/issues/280


  $export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
    padEnd: function padEnd(maxLength
    /* , fillString = ' ' */
    ) {
      return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
    }
  });
  /***/
},
/* 449 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/proposal-string-pad-start-end

  var $export = __webpack_require__(0);

  var $pad = __webpack_require__(190);

  var userAgent = __webpack_require__(132); // https://github.com/zloirock/core-js/issues/280


  $export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
    padStart: function padStart(maxLength
    /* , fillString = ' ' */
    ) {
      return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
    }
  });
  /***/
},
/* 450 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/sebmarkbage/ecmascript-string-left-right-trim

  __webpack_require__(66)('trimLeft', function ($trim) {
    return function trimLeft() {
      return $trim(this, 1);
    };
  }, 'trimStart');
  /***/

},
/* 451 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/sebmarkbage/ecmascript-string-left-right-trim

  __webpack_require__(66)('trimRight', function ($trim) {
    return function trimRight() {
      return $trim(this, 2);
    };
  }, 'trimEnd');
  /***/

},
/* 452 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(133)('asyncIterator');
  /***/

},
/* 453 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(133)('observable');
  /***/

},
/* 454 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-global
  var $export = __webpack_require__(0);

  $export($export.S, 'System', {
    global: __webpack_require__(3)
  });
  /***/
},
/* 455 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
  __webpack_require__(95)('WeakMap');
  /***/

},
/* 456 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
  __webpack_require__(96)('WeakMap');
  /***/

},
/* 457 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
  __webpack_require__(95)('WeakSet');
  /***/

},
/* 458 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
  __webpack_require__(96)('WeakSet');
  /***/

},
/* 459 */

/***/
function (module, exports, __webpack_require__) {
  var $iterators = __webpack_require__(135);

  var getKeys = __webpack_require__(54);

  var redefine = __webpack_require__(21);

  var global = __webpack_require__(3);

  var hide = __webpack_require__(20);

  var Iterators = __webpack_require__(64);

  var wks = __webpack_require__(9);

  var ITERATOR = wks('iterator');
  var TO_STRING_TAG = wks('toStringTag');
  var ArrayValues = Iterators.Array;
  var DOMIterables = {
    CSSRuleList: true,
    // TODO: Not spec compliant, should be false.
    CSSStyleDeclaration: false,
    CSSValueList: false,
    ClientRectList: false,
    DOMRectList: false,
    DOMStringList: false,
    DOMTokenList: true,
    DataTransferItemList: false,
    FileList: false,
    HTMLAllCollection: false,
    HTMLCollection: false,
    HTMLFormElement: false,
    HTMLSelectElement: false,
    MediaList: true,
    // TODO: Not spec compliant, should be false.
    MimeTypeArray: false,
    NamedNodeMap: false,
    NodeList: true,
    PaintRequestList: false,
    Plugin: false,
    PluginArray: false,
    SVGLengthList: false,
    SVGNumberList: false,
    SVGPathSegList: false,
    SVGPointList: false,
    SVGStringList: false,
    SVGTransformList: false,
    SourceBufferList: false,
    StyleSheetList: true,
    // TODO: Not spec compliant, should be false.
    TextTrackCueList: false,
    TextTrackList: false,
    TouchList: false
  };

  for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
    var NAME = collections[i];
    var explicit = DOMIterables[NAME];
    var Collection = global[NAME];
    var proto = Collection && Collection.prototype;
    var key;

    if (proto) {
      if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
      if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
      Iterators[NAME] = ArrayValues;
      if (explicit) for (key in $iterators) {
        if (!proto[key]) redefine(proto, key, $iterators[key], true);
      }
    }
  }
  /***/

},
/* 460 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var $task = __webpack_require__(130);

  $export($export.G + $export.B, {
    setImmediate: $task.set,
    clearImmediate: $task.clear
  });
  /***/
},
/* 461 */

/***/
function (module, exports, __webpack_require__) {
  // ie9- setTimeout & setInterval additional parameters fix
  var global = __webpack_require__(3);

  var $export = __webpack_require__(0);

  var userAgent = __webpack_require__(132);

  var slice = [].slice;
  var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

  var wrap = function wrap(set) {
    return function (fn, time
    /* , ...args */
    ) {
      var boundArgs = arguments.length > 2;
      var args = boundArgs ? slice.call(arguments, 2) : false;
      return set(boundArgs ? function () {
        // eslint-disable-next-line no-new-func
        (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
      } : fn, time);
    };
  };

  $export($export.G + $export.B + $export.F * MSIE, {
    setTimeout: wrap(global.setTimeout),
    setInterval: wrap(global.setInterval)
  });
  /***/
},
/* 462 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(390);

  __webpack_require__(329);

  __webpack_require__(331);

  __webpack_require__(330);

  __webpack_require__(333);

  __webpack_require__(335);

  __webpack_require__(340);

  __webpack_require__(334);

  __webpack_require__(332);

  __webpack_require__(342);

  __webpack_require__(341);

  __webpack_require__(337);

  __webpack_require__(338);

  __webpack_require__(336);

  __webpack_require__(328);

  __webpack_require__(339);

  __webpack_require__(343);

  __webpack_require__(344);

  __webpack_require__(296);

  __webpack_require__(298);

  __webpack_require__(297);

  __webpack_require__(346);

  __webpack_require__(345);

  __webpack_require__(316);

  __webpack_require__(326);

  __webpack_require__(327);

  __webpack_require__(317);

  __webpack_require__(318);

  __webpack_require__(319);

  __webpack_require__(320);

  __webpack_require__(321);

  __webpack_require__(322);

  __webpack_require__(323);

  __webpack_require__(324);

  __webpack_require__(325);

  __webpack_require__(299);

  __webpack_require__(300);

  __webpack_require__(301);

  __webpack_require__(302);

  __webpack_require__(303);

  __webpack_require__(304);

  __webpack_require__(305);

  __webpack_require__(306);

  __webpack_require__(307);

  __webpack_require__(308);

  __webpack_require__(309);

  __webpack_require__(310);

  __webpack_require__(311);

  __webpack_require__(312);

  __webpack_require__(313);

  __webpack_require__(314);

  __webpack_require__(315);

  __webpack_require__(377);

  __webpack_require__(382);

  __webpack_require__(389);

  __webpack_require__(380);

  __webpack_require__(372);

  __webpack_require__(373);

  __webpack_require__(378);

  __webpack_require__(383);

  __webpack_require__(385);

  __webpack_require__(368);

  __webpack_require__(369);

  __webpack_require__(370);

  __webpack_require__(371);

  __webpack_require__(374);

  __webpack_require__(375);

  __webpack_require__(376);

  __webpack_require__(379);

  __webpack_require__(381);

  __webpack_require__(384);

  __webpack_require__(386);

  __webpack_require__(387);

  __webpack_require__(388);

  __webpack_require__(291);

  __webpack_require__(293);

  __webpack_require__(292);

  __webpack_require__(295);

  __webpack_require__(294);

  __webpack_require__(280);

  __webpack_require__(278);

  __webpack_require__(284);

  __webpack_require__(281);

  __webpack_require__(287);

  __webpack_require__(289);

  __webpack_require__(277);

  __webpack_require__(283);

  __webpack_require__(274);

  __webpack_require__(288);

  __webpack_require__(272);

  __webpack_require__(286);

  __webpack_require__(285);

  __webpack_require__(279);

  __webpack_require__(282);

  __webpack_require__(271);

  __webpack_require__(273);

  __webpack_require__(276);

  __webpack_require__(275);

  __webpack_require__(290);

  __webpack_require__(135);

  __webpack_require__(362);

  __webpack_require__(367);

  __webpack_require__(194);

  __webpack_require__(363);

  __webpack_require__(364);

  __webpack_require__(365);

  __webpack_require__(366);

  __webpack_require__(347);

  __webpack_require__(193);

  __webpack_require__(195);

  __webpack_require__(196);

  __webpack_require__(402);

  __webpack_require__(391);

  __webpack_require__(392);

  __webpack_require__(397);

  __webpack_require__(400);

  __webpack_require__(401);

  __webpack_require__(395);

  __webpack_require__(398);

  __webpack_require__(396);

  __webpack_require__(399);

  __webpack_require__(393);

  __webpack_require__(394);

  __webpack_require__(348);

  __webpack_require__(349);

  __webpack_require__(350);

  __webpack_require__(351);

  __webpack_require__(352);

  __webpack_require__(355);

  __webpack_require__(353);

  __webpack_require__(354);

  __webpack_require__(356);

  __webpack_require__(357);

  __webpack_require__(358);

  __webpack_require__(359);

  __webpack_require__(361);

  __webpack_require__(360);

  __webpack_require__(405);

  __webpack_require__(403);

  __webpack_require__(404);

  __webpack_require__(446);

  __webpack_require__(449);

  __webpack_require__(448);

  __webpack_require__(450);

  __webpack_require__(451);

  __webpack_require__(447);

  __webpack_require__(452);

  __webpack_require__(453);

  __webpack_require__(427);

  __webpack_require__(430);

  __webpack_require__(426);

  __webpack_require__(424);

  __webpack_require__(425);

  __webpack_require__(428);

  __webpack_require__(429);

  __webpack_require__(411);

  __webpack_require__(445);

  __webpack_require__(410);

  __webpack_require__(444);

  __webpack_require__(456);

  __webpack_require__(458);

  __webpack_require__(409);

  __webpack_require__(443);

  __webpack_require__(455);

  __webpack_require__(457);

  __webpack_require__(408);

  __webpack_require__(454);

  __webpack_require__(407);

  __webpack_require__(412);

  __webpack_require__(413);

  __webpack_require__(414);

  __webpack_require__(415);

  __webpack_require__(416);

  __webpack_require__(418);

  __webpack_require__(417);

  __webpack_require__(419);

  __webpack_require__(420);

  __webpack_require__(421);

  __webpack_require__(423);

  __webpack_require__(422);

  __webpack_require__(432);

  __webpack_require__(433);

  __webpack_require__(434);

  __webpack_require__(435);

  __webpack_require__(437);

  __webpack_require__(436);

  __webpack_require__(439);

  __webpack_require__(438);

  __webpack_require__(440);

  __webpack_require__(441);

  __webpack_require__(442);

  __webpack_require__(406);

  __webpack_require__(431);

  __webpack_require__(461);

  __webpack_require__(460);

  __webpack_require__(459);

  module.exports = __webpack_require__(32);
  /***/
},
/* 463 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
    * Copyright (c) 2014, Facebook, Inc.
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
    * additional grant of patent rights can be found in the PATENTS file in
    * the same directory.
    */
    !function (global) {
      "use strict";

      var Op = Object.prototype;
      var hasOwn = Op.hasOwnProperty;
      var undefined; // More compressible than void 0.

      var $Symbol = typeof Symbol === "function" ? Symbol : {};
      var iteratorSymbol = $Symbol.iterator || "@@iterator";
      var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
      var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
      var inModule = typeof module === "object";
      var runtime = global.regeneratorRuntime;

      if (runtime) {
        if (inModule) {
          // If regeneratorRuntime is defined globally and we're in a module,
          // make the exports object identical to regeneratorRuntime.
          module.exports = runtime;
        } // Don't bother evaluating the rest of this file if the runtime was
        // already defined globally.


        return;
      } // Define the runtime globally (as expected by generated code) as either
      // module.exports (if we're in a module) or a new, empty object.


      runtime = global.regeneratorRuntime = inModule ? module.exports : {};

      function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.

        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
      }

      runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
      // record like context.tryEntries[i].completion. This interface could
      // have been (and was previously) designed to take a closure to be
      // invoked without arguments, but in all the cases we care about we
      // already have an existing method we want to call, so there's no need
      // to create a new function object. We can even get away with assuming
      // the method takes exactly one argument, since that happens to be true
      // in every case, so we don't have to touch the arguments object. The
      // only additional allocation required is the completion record, which
      // has a stable shape and so hopefully should be cheap to allocate.

      function tryCatch(fn, obj, arg) {
        try {
          return {
            type: "normal",
            arg: fn.call(obj, arg)
          };
        } catch (err) {
          return {
            type: "throw",
            arg: err
          };
        }
      }

      var GenStateSuspendedStart = "suspendedStart";
      var GenStateSuspendedYield = "suspendedYield";
      var GenStateExecuting = "executing";
      var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
      // breaking out of the dispatch switch statement.

      var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
      // .constructor.prototype properties for functions that return Generator
      // objects. For full spec compliance, you may wish to configure your
      // minifier not to mangle the names of these two functions.

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
      // don't natively support it.


      var IteratorPrototype = {};

      IteratorPrototype[iteratorSymbol] = function () {
        return this;
      };

      var getProto = Object.getPrototypeOf;
      var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

      if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
        // This environment has a native %IteratorPrototype%; use it instead
        // of the polyfill.
        IteratorPrototype = NativeIteratorPrototype;
      }

      var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
      GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
      GeneratorFunctionPrototype.constructor = GeneratorFunction;
      GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
      // Iterator interface in terms of a single ._invoke method.

      function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
          prototype[method] = function (arg) {
            return this._invoke(method, arg);
          };
        });
      }

      runtime.isGeneratorFunction = function (genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
      };

      runtime.mark = function (genFun) {
        if (Object.setPrototypeOf) {
          Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        } else {
          genFun.__proto__ = GeneratorFunctionPrototype;

          if (!(toStringTagSymbol in genFun)) {
            genFun[toStringTagSymbol] = "GeneratorFunction";
          }
        }

        genFun.prototype = Object.create(Gp);
        return genFun;
      }; // Within the body of any async function, `await x` is transformed to
      // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
      // `hasOwn.call(value, "__await")` to determine if the yielded value is
      // meant to be awaited.


      runtime.awrap = function (arg) {
        return {
          __await: arg
        };
      };

      function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
          var record = tryCatch(generator[method], generator, arg);

          if (record.type === "throw") {
            reject(record.arg);
          } else {
            var result = record.arg;
            var value = result.value;

            if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
              return Promise.resolve(value.__await).then(function (value) {
                invoke("next", value, resolve, reject);
              }, function (err) {
                invoke("throw", err, resolve, reject);
              });
            }

            return Promise.resolve(value).then(function (unwrapped) {
              // When a yielded Promise is resolved, its final value becomes
              // the .value of the Promise<{value,done}> result for the
              // current iteration. If the Promise is rejected, however, the
              // result for this iteration will be rejected with the same
              // reason. Note that rejections of yielded Promises are not
              // thrown back into the generator function, as is the case
              // when an awaited Promise is rejected. This difference in
              // behavior between yield and await is important, because it
              // allows the consumer to decide what to do with the yielded
              // rejection (swallow it and continue, manually .throw it back
              // into the generator, abandon iteration, whatever). With
              // await, by contrast, there is no opportunity to examine the
              // rejection reason outside the generator function, so the
              // only option is to throw it from the await expression, and
              // let the generator function handle the exception.
              result.value = unwrapped;
              resolve(result);
            }, reject);
          }
        }

        if (typeof global.process === "object" && global.process.domain) {
          invoke = global.process.domain.bind(invoke);
        }

        var previousPromise;

        function enqueue(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new Promise(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }

          return previousPromise = // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        } // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).


        this._invoke = enqueue;
      }

      defineIteratorMethods(AsyncIterator.prototype);

      AsyncIterator.prototype[asyncIteratorSymbol] = function () {
        return this;
      };

      runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
      // AsyncIterator objects; they just return a Promise for the value of
      // the final result produced by the iterator.

      runtime.async = function (innerFn, outerFn, self, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
        return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function (result) {
          return result.done ? result.value : iter.next();
        });
      };

      function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
          if (state === GenStateExecuting) {
            throw new Error("Generator is already running");
          }

          if (state === GenStateCompleted) {
            if (method === "throw") {
              throw arg;
            } // Be forgiving, per 25.3.3.3.3 of the spec:
            // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


            return doneResult();
          }

          context.method = method;
          context.arg = arg;

          while (true) {
            var delegate = context.delegate;

            if (delegate) {
              var delegateResult = maybeInvokeDelegate(delegate, context);

              if (delegateResult) {
                if (delegateResult === ContinueSentinel) continue;
                return delegateResult;
              }
            }

            if (context.method === "next") {
              // Setting context._sent for legacy support of Babel's
              // function.sent implementation.
              context.sent = context._sent = context.arg;
            } else if (context.method === "throw") {
              if (state === GenStateSuspendedStart) {
                state = GenStateCompleted;
                throw context.arg;
              }

              context.dispatchException(context.arg);
            } else if (context.method === "return") {
              context.abrupt("return", context.arg);
            }

            state = GenStateExecuting;
            var record = tryCatch(innerFn, self, context);

            if (record.type === "normal") {
              // If an exception is thrown from innerFn, we leave state ===
              // GenStateExecuting and loop back for another invocation.
              state = context.done ? GenStateCompleted : GenStateSuspendedYield;

              if (record.arg === ContinueSentinel) {
                continue;
              }

              return {
                value: record.arg,
                done: context.done
              };
            } else if (record.type === "throw") {
              state = GenStateCompleted; // Dispatch the exception by looping back around to the
              // context.dispatchException(context.arg) call above.

              context.method = "throw";
              context.arg = record.arg;
            }
          }
        };
      } // Call delegate.iterator[context.method](context.arg) and handle the
      // result, either by returning a { value, done } result from the
      // delegate iterator, or by modifying context.method and context.arg,
      // setting context.delegate to null, and returning the ContinueSentinel.


      function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];

        if (method === undefined) {
          // A .throw or .return when the delegate iterator has no .throw
          // method always terminates the yield* loop.
          context.delegate = null;

          if (context.method === "throw") {
            if (delegate.iterator.return) {
              // If the delegate iterator has a return method, give it a
              // chance to clean up.
              context.method = "return";
              context.arg = undefined;
              maybeInvokeDelegate(delegate, context);

              if (context.method === "throw") {
                // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
              }
            }

            context.method = "throw";
            context.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return ContinueSentinel;
        }

        var record = tryCatch(method, delegate.iterator, context.arg);

        if (record.type === "throw") {
          context.method = "throw";
          context.arg = record.arg;
          context.delegate = null;
          return ContinueSentinel;
        }

        var info = record.arg;

        if (!info) {
          context.method = "throw";
          context.arg = new TypeError("iterator result is not an object");
          context.delegate = null;
          return ContinueSentinel;
        }

        if (info.done) {
          // Assign the result of the finished delegate to the temporary
          // variable specified by delegate.resultName (see delegateYield).
          context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

          context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
          // exception, let the outer generator proceed normally. If
          // context.method was "next", forget context.arg since it has been
          // "consumed" by the delegate iterator. If context.method was
          // "return", allow the original .return call to continue in the
          // outer generator.

          if (context.method !== "return") {
            context.method = "next";
            context.arg = undefined;
          }
        } else {
          // Re-yield the result returned by the delegate method.
          return info;
        } // The delegate iterator is finished, so forget it and continue with
        // the outer generator.


        context.delegate = null;
        return ContinueSentinel;
      } // Define Generator.prototype.{next,throw,return} in terms of the
      // unified ._invoke helper method.


      defineIteratorMethods(Gp);
      Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
      // @@iterator function is called on it. Some browsers' implementations of the
      // iterator prototype chain incorrectly implement this, causing the Generator
      // object to not be returned from this call. This ensures that doesn't happen.
      // See https://github.com/facebook/regenerator/issues/274 for more details.

      Gp[iteratorSymbol] = function () {
        return this;
      };

      Gp.toString = function () {
        return "[object Generator]";
      };

      function pushTryEntry(locs) {
        var entry = {
          tryLoc: locs[0]
        };

        if (1 in locs) {
          entry.catchLoc = locs[1];
        }

        if (2 in locs) {
          entry.finallyLoc = locs[2];
          entry.afterLoc = locs[3];
        }

        this.tryEntries.push(entry);
      }

      function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
      }

      function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [{
          tryLoc: "root"
        }];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
      }

      runtime.keys = function (object) {
        var keys = [];

        for (var key in object) {
          keys.push(key);
        }

        keys.reverse(); // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.

        return function next() {
          while (keys.length) {
            var key = keys.pop();

            if (key in object) {
              next.value = key;
              next.done = false;
              return next;
            }
          } // To avoid creating an additional object, we just hang the .value
          // and .done properties off the next function object itself. This
          // also ensures that the minifier will not anonymize the function.


          next.done = true;
          return next;
        };
      };

      function values(iterable) {
        if (iterable) {
          var iteratorMethod = iterable[iteratorSymbol];

          if (iteratorMethod) {
            return iteratorMethod.call(iterable);
          }

          if (typeof iterable.next === "function") {
            return iterable;
          }

          if (!isNaN(iterable.length)) {
            var i = -1,
                next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }

              next.value = undefined;
              next.done = true;
              return next;
            };

            return next.next = next;
          }
        } // Return an iterator with no values.


        return {
          next: doneResult
        };
      }

      runtime.values = values;

      function doneResult() {
        return {
          value: undefined,
          done: true
        };
      }

      Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
          this.prev = 0;
          this.next = 0; // Resetting context._sent for legacy support of Babel's
          // function.sent implementation.

          this.sent = this._sent = undefined;
          this.done = false;
          this.delegate = null;
          this.method = "next";
          this.arg = undefined;
          this.tryEntries.forEach(resetTryEntry);

          if (!skipTempReset) {
            for (var name in this) {
              // Not sure about the optimal order of these conditions:
              if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                this[name] = undefined;
              }
            }
          }
        },
        stop: function stop() {
          this.done = true;
          var rootEntry = this.tryEntries[0];
          var rootRecord = rootEntry.completion;

          if (rootRecord.type === "throw") {
            throw rootRecord.arg;
          }

          return this.rval;
        },
        dispatchException: function dispatchException(exception) {
          if (this.done) {
            throw exception;
          }

          var context = this;

          function handle(loc, caught) {
            record.type = "throw";
            record.arg = exception;
            context.next = loc;

            if (caught) {
              // If the dispatched exception was caught by a catch block,
              // then let that catch block handle the exception normally.
              context.method = "next";
              context.arg = undefined;
            }

            return !!caught;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            var record = entry.completion;

            if (entry.tryLoc === "root") {
              // Exception thrown outside of any try block that could handle
              // it, so set the completion value of the entire function to
              // throw the exception.
              return handle("end");
            }

            if (entry.tryLoc <= this.prev) {
              var hasCatch = hasOwn.call(entry, "catchLoc");
              var hasFinally = hasOwn.call(entry, "finallyLoc");

              if (hasCatch && hasFinally) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                } else if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else if (hasCatch) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                }
              } else if (hasFinally) {
                if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else {
                throw new Error("try statement without catch or finally");
              }
            }
          }
        },
        abrupt: function abrupt(type, arg) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
              var finallyEntry = entry;
              break;
            }
          }

          if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
            // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
          }

          var record = finallyEntry ? finallyEntry.completion : {};
          record.type = type;
          record.arg = arg;

          if (finallyEntry) {
            this.method = "next";
            this.next = finallyEntry.finallyLoc;
            return ContinueSentinel;
          }

          return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
          if (record.type === "throw") {
            throw record.arg;
          }

          if (record.type === "break" || record.type === "continue") {
            this.next = record.arg;
          } else if (record.type === "return") {
            this.rval = this.arg = record.arg;
            this.method = "return";
            this.next = "end";
          } else if (record.type === "normal" && afterLoc) {
            this.next = afterLoc;
          }

          return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.finallyLoc === finallyLoc) {
              this.complete(entry.completion, entry.afterLoc);
              resetTryEntry(entry);
              return ContinueSentinel;
            }
          }
        },
        "catch": function _catch(tryLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.tryLoc === tryLoc) {
              var record = entry.completion;

              if (record.type === "throw") {
                var thrown = record.arg;
                resetTryEntry(entry);
              }

              return thrown;
            }
          } // The context.catch method must only be called with a location
          // argument that corresponds to a known catch block.


          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
          this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc
          };

          if (this.method === "next") {
            // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
          }

          return ContinueSentinel;
        }
      };
    }( // Among the various tricks for obtaining a reference to the global
    // object, this seems to be the most reliable technique that does not
    // use indirect eval (which violates Content Security Policy).
    typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : this);
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10));
  /***/
},
/* 464 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.byteLength = byteLength;
  exports.toByteArray = toByteArray;
  exports.fromByteArray = fromByteArray;
  var lookup = [];
  var revLookup = [];
  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
  } // Support decoding URL-safe base64 strings, as Node.js does.
  // See: https://en.wikipedia.org/wiki/Base64#URL_applications


  revLookup['-'.charCodeAt(0)] = 62;
  revLookup['_'.charCodeAt(0)] = 63;

  function getLens(b64) {
    var len = b64.length;

    if (len % 4 > 0) {
      throw new Error('Invalid string. Length must be a multiple of 4');
    } // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42


    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [validLen, placeHoldersLen];
  } // base64 is 4/3 + up to two characters of the original data


  function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
  }

  function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
  }

  function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars

    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;

    for (var i = 0; i < len; i += 4) {
      tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
      arr[curByte++] = tmp >> 16 & 0xFF;
      arr[curByte++] = tmp >> 8 & 0xFF;
      arr[curByte++] = tmp & 0xFF;
    }

    if (placeHoldersLen === 2) {
      tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
      arr[curByte++] = tmp & 0xFF;
    }

    if (placeHoldersLen === 1) {
      tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
      arr[curByte++] = tmp >> 8 & 0xFF;
      arr[curByte++] = tmp & 0xFF;
    }

    return arr;
  }

  function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
  }

  function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];

    for (var i = start; i < end; i += 3) {
      tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
      output.push(tripletToBase64(tmp));
    }

    return output.join('');
  }

  function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes

    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later

    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
      parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    } // pad the end with zeros, but make sure to not forget the extra bytes


    if (extraBytes === 1) {
      tmp = uint8[len - 1];
      parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
      tmp = (uint8[len - 2] << 8) + uint8[len - 1];
      parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }

    return parts.join('');
  }
  /***/

},
/* 465 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var pad_string_1 = __webpack_require__(466);

    function encode(input) {
      var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "utf8";

      if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString("base64"));
      }

      return fromBase64(Buffer.from(input, encoding).toString("base64"));
    }

    ;

    function decode(base64url) {
      var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "utf8";
      return Buffer.from(toBase64(base64url), "base64").toString(encoding);
    }

    function toBase64(base64url) {
      base64url = base64url.toString();
      return pad_string_1.default(base64url).replace(/\-/g, "+").replace(/_/g, "/");
    }

    function fromBase64(base64) {
      return base64.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    }

    function toBuffer(base64url) {
      return Buffer.from(toBase64(base64url), "base64");
    }

    var base64url = encode;
    base64url.encode = encode;
    base64url.decode = decode;
    base64url.toBase64 = toBase64;
    base64url.fromBase64 = fromBase64;
    base64url.toBuffer = toBuffer;
    exports.default = base64url;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 466 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    function padString(input) {
      var segmentLength = 4;
      var stringLength = input.length;
      var diff = stringLength % segmentLength;

      if (!diff) {
        return input;
      }

      var position = stringLength;
      var padLength = segmentLength - diff;
      var paddedStringLength = stringLength + padLength;
      var buffer = Buffer.alloc(paddedStringLength);
      buffer.write(input);

      while (padLength--) {
        buffer.write("=", position++);
      }

      return buffer.toString();
    }

    exports.default = padString;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 467 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(465).default;
  module.exports.default = module.exports;
  /***/
},
/* 468 */

/***/
function (module, exports, __webpack_require__) {
  var DuplexStream = __webpack_require__(241),
      util = __webpack_require__(74),
      Buffer = __webpack_require__(38).Buffer;

  function BufferList(callback) {
    if (!(this instanceof BufferList)) return new BufferList(callback);
    this._bufs = [];
    this.length = 0;

    if (typeof callback == 'function') {
      this._callback = callback;

      var piper = function piper(err) {
        if (this._callback) {
          this._callback(err);

          this._callback = null;
        }
      }.bind(this);

      this.on('pipe', function onPipe(src) {
        src.on('error', piper);
      });
      this.on('unpipe', function onUnpipe(src) {
        src.removeListener('error', piper);
      });
    } else {
      this.append(callback);
    }

    DuplexStream.call(this);
  }

  util.inherits(BufferList, DuplexStream);

  BufferList.prototype._offset = function _offset(offset) {
    var tot = 0,
        i = 0,
        _t;

    if (offset === 0) return [0, 0];

    for (; i < this._bufs.length; i++) {
      _t = tot + this._bufs[i].length;
      if (offset < _t || i == this._bufs.length - 1) return [i, offset - tot];
      tot = _t;
    }
  };

  BufferList.prototype.append = function append(buf) {
    var i = 0;

    if (Buffer.isBuffer(buf)) {
      this._appendBuffer(buf);
    } else if (Array.isArray(buf)) {
      for (; i < buf.length; i++) {
        this.append(buf[i]);
      }
    } else if (buf instanceof BufferList) {
      // unwrap argument into individual BufferLists
      for (; i < buf._bufs.length; i++) {
        this.append(buf._bufs[i]);
      }
    } else if (buf != null) {
      // coerce number arguments to strings, since Buffer(number) does
      // uninitialized memory allocation
      if (typeof buf == 'number') buf = buf.toString();

      this._appendBuffer(Buffer.from(buf));
    }

    return this;
  };

  BufferList.prototype._appendBuffer = function appendBuffer(buf) {
    this._bufs.push(buf);

    this.length += buf.length;
  };

  BufferList.prototype._write = function _write(buf, encoding, callback) {
    this._appendBuffer(buf);

    if (typeof callback == 'function') callback();
  };

  BufferList.prototype._read = function _read(size) {
    if (!this.length) return this.push(null);
    size = Math.min(size, this.length);
    this.push(this.slice(0, size));
    this.consume(size);
  };

  BufferList.prototype.end = function end(chunk) {
    DuplexStream.prototype.end.call(this, chunk);

    if (this._callback) {
      this._callback(null, this.slice());

      this._callback = null;
    }
  };

  BufferList.prototype.get = function get(index) {
    return this.slice(index, index + 1)[0];
  };

  BufferList.prototype.slice = function slice(start, end) {
    if (typeof start == 'number' && start < 0) start += this.length;
    if (typeof end == 'number' && end < 0) end += this.length;
    return this.copy(null, 0, start, end);
  };

  BufferList.prototype.copy = function copy(dst, dstStart, srcStart, srcEnd) {
    if (typeof srcStart != 'number' || srcStart < 0) srcStart = 0;
    if (typeof srcEnd != 'number' || srcEnd > this.length) srcEnd = this.length;
    if (srcStart >= this.length) return dst || Buffer.alloc(0);
    if (srcEnd <= 0) return dst || Buffer.alloc(0);

    var copy = !!dst,
        off = this._offset(srcStart),
        len = srcEnd - srcStart,
        bytes = len,
        bufoff = copy && dstStart || 0,
        start = off[1],
        l,
        i; // copy/slice everything


    if (srcStart === 0 && srcEnd == this.length) {
      if (!copy) {
        // slice, but full concat if multiple buffers
        return this._bufs.length === 1 ? this._bufs[0] : Buffer.concat(this._bufs, this.length);
      } // copy, need to copy individual buffers


      for (i = 0; i < this._bufs.length; i++) {
        this._bufs[i].copy(dst, bufoff);

        bufoff += this._bufs[i].length;
      }

      return dst;
    } // easy, cheap case where it's a subset of one of the buffers


    if (bytes <= this._bufs[off[0]].length - start) {
      return copy ? this._bufs[off[0]].copy(dst, dstStart, start, start + bytes) : this._bufs[off[0]].slice(start, start + bytes);
    }

    if (!copy) // a slice, we need something to copy in to
      dst = Buffer.allocUnsafe(len);

    for (i = off[0]; i < this._bufs.length; i++) {
      l = this._bufs[i].length - start;

      if (bytes > l) {
        this._bufs[i].copy(dst, bufoff, start);
      } else {
        this._bufs[i].copy(dst, bufoff, start, start + bytes);

        break;
      }

      bufoff += l;
      bytes -= l;
      if (start) start = 0;
    }

    return dst;
  };

  BufferList.prototype.shallowSlice = function shallowSlice(start, end) {
    start = start || 0;
    end = end || this.length;
    if (start < 0) start += this.length;
    if (end < 0) end += this.length;

    var startOffset = this._offset(start),
        endOffset = this._offset(end),
        buffers = this._bufs.slice(startOffset[0], endOffset[0] + 1);

    if (endOffset[1] == 0) buffers.pop();else buffers[buffers.length - 1] = buffers[buffers.length - 1].slice(0, endOffset[1]);
    if (startOffset[1] != 0) buffers[0] = buffers[0].slice(startOffset[1]);
    return new BufferList(buffers);
  };

  BufferList.prototype.toString = function toString(encoding, start, end) {
    return this.slice(start, end).toString(encoding);
  };

  BufferList.prototype.consume = function consume(bytes) {
    while (this._bufs.length) {
      if (bytes >= this._bufs[0].length) {
        bytes -= this._bufs[0].length;
        this.length -= this._bufs[0].length;

        this._bufs.shift();
      } else {
        this._bufs[0] = this._bufs[0].slice(bytes);
        this.length -= bytes;
        break;
      }
    }

    return this;
  };

  BufferList.prototype.duplicate = function duplicate() {
    var i = 0,
        copy = new BufferList();

    for (; i < this._bufs.length; i++) {
      copy.append(this._bufs[i]);
    }

    return copy;
  };

  BufferList.prototype.destroy = function destroy() {
    this._bufs.length = 0;
    this.length = 0;
    this.push(null);
  };

  (function () {
    var methods = {
      'readDoubleBE': 8,
      'readDoubleLE': 8,
      'readFloatBE': 4,
      'readFloatLE': 4,
      'readInt32BE': 4,
      'readInt32LE': 4,
      'readUInt32BE': 4,
      'readUInt32LE': 4,
      'readInt16BE': 2,
      'readInt16LE': 2,
      'readUInt16BE': 2,
      'readUInt16LE': 2,
      'readInt8': 1,
      'readUInt8': 1
    };

    for (var m in methods) {
      (function (m) {
        BufferList.prototype[m] = function (offset) {
          return this.slice(offset, offset + methods[m])[m](0);
        };
      })(m);
    }
  })();

  module.exports = BufferList;
  /***/
},
/* 469 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer, process) {
    /* eslint camelcase: "off" */
    var assert = __webpack_require__(162);

    var Zstream = __webpack_require__(581);

    var zlib_deflate = __webpack_require__(575);

    var zlib_inflate = __webpack_require__(577);

    var constants = __webpack_require__(574);

    for (var key in constants) {
      exports[key] = constants[key];
    } // zlib modes


    exports.NONE = 0;
    exports.DEFLATE = 1;
    exports.INFLATE = 2;
    exports.GZIP = 3;
    exports.GUNZIP = 4;
    exports.DEFLATERAW = 5;
    exports.INFLATERAW = 6;
    exports.UNZIP = 7;
    var GZIP_HEADER_ID1 = 0x1f;
    var GZIP_HEADER_ID2 = 0x8b;
    /**
     * Emulate Node's zlib C++ layer for use by the JS layer in index.js
     */

    function Zlib(mode) {
      if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) {
        throw new TypeError('Bad argument');
      }

      this.dictionary = null;
      this.err = 0;
      this.flush = 0;
      this.init_done = false;
      this.level = 0;
      this.memLevel = 0;
      this.mode = mode;
      this.strategy = 0;
      this.windowBits = 0;
      this.write_in_progress = false;
      this.pending_close = false;
      this.gzip_id_bytes_read = 0;
    }

    Zlib.prototype.close = function () {
      if (this.write_in_progress) {
        this.pending_close = true;
        return;
      }

      this.pending_close = false;
      assert(this.init_done, 'close before init');
      assert(this.mode <= exports.UNZIP);

      if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
        zlib_deflate.deflateEnd(this.strm);
      } else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) {
        zlib_inflate.inflateEnd(this.strm);
      }

      this.mode = exports.NONE;
      this.dictionary = null;
    };

    Zlib.prototype.write = function (flush, input, in_off, in_len, out, out_off, out_len) {
      return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
    };

    Zlib.prototype.writeSync = function (flush, input, in_off, in_len, out, out_off, out_len) {
      return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
    };

    Zlib.prototype._write = function (async, flush, input, in_off, in_len, out, out_off, out_len) {
      assert.equal(arguments.length, 8);
      assert(this.init_done, 'write before init');
      assert(this.mode !== exports.NONE, 'already finalized');
      assert.equal(false, this.write_in_progress, 'write already in progress');
      assert.equal(false, this.pending_close, 'close is pending');
      this.write_in_progress = true;
      assert.equal(false, flush === undefined, 'must provide flush value');
      this.write_in_progress = true;

      if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) {
        throw new Error('Invalid flush value');
      }

      if (input == null) {
        input = Buffer.alloc(0);
        in_len = 0;
        in_off = 0;
      }

      this.strm.avail_in = in_len;
      this.strm.input = input;
      this.strm.next_in = in_off;
      this.strm.avail_out = out_len;
      this.strm.output = out;
      this.strm.next_out = out_off;
      this.flush = flush;

      if (!async) {
        // sync version
        this._process();

        if (this._checkError()) {
          return this._afterSync();
        }

        return;
      } // async version


      var self = this;
      process.nextTick(function () {
        self._process();

        self._after();
      });
      return this;
    };

    Zlib.prototype._afterSync = function () {
      var avail_out = this.strm.avail_out;
      var avail_in = this.strm.avail_in;
      this.write_in_progress = false;
      return [avail_in, avail_out];
    };

    Zlib.prototype._process = function () {
      var next_expected_header_byte = null; // If the avail_out is left at 0, then it means that it ran out
      // of room.  If there was avail_out left over, then it means
      // that all of the input was consumed.

      switch (this.mode) {
        case exports.DEFLATE:
        case exports.GZIP:
        case exports.DEFLATERAW:
          this.err = zlib_deflate.deflate(this.strm, this.flush);
          break;

        case exports.UNZIP:
          if (this.strm.avail_in > 0) {
            next_expected_header_byte = this.strm.next_in;
          }

          switch (this.gzip_id_bytes_read) {
            case 0:
              if (next_expected_header_byte === null) {
                break;
              }

              if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                this.gzip_id_bytes_read = 1;
                next_expected_header_byte++;

                if (this.strm.avail_in === 1) {
                  // The only available byte was already read.
                  break;
                }
              } else {
                this.mode = exports.INFLATE;
                break;
              }

            // fallthrough

            case 1:
              if (next_expected_header_byte === null) {
                break;
              }

              if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                this.gzip_id_bytes_read = 2;
                this.mode = exports.GUNZIP;
              } else {
                // There is no actual difference between INFLATE and INFLATERAW
                // (after initialization).
                this.mode = exports.INFLATE;
              }

              break;

            default:
              throw new Error('invalid number of gzip magic number bytes read');
          }

        // fallthrough

        case exports.INFLATE:
        case exports.GUNZIP:
        case exports.INFLATERAW:
          this.err = zlib_inflate.inflate(this.strm, this.flush // If data was encoded with dictionary
          );

          if (this.err === exports.Z_NEED_DICT && this.dictionary) {
            // Load it
            this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);

            if (this.err === exports.Z_OK) {
              // And try to decode again
              this.err = zlib_inflate.inflate(this.strm, this.flush);
            } else if (this.err === exports.Z_DATA_ERROR) {
              // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
              // Make it possible for After() to tell a bad dictionary from bad
              // input.
              this.err = exports.Z_NEED_DICT;
            }
          }

          while (this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00) {
            // Bytes remain in input buffer. Perhaps this is another compressed
            // member in the same archive, or just trailing garbage.
            // Trailing zero bytes are okay, though, since they are frequently
            // used for padding.
            this.reset();
            this.err = zlib_inflate.inflate(this.strm, this.flush);
          }

          break;

        default:
          throw new Error('Unknown mode ' + this.mode);
      }
    };

    Zlib.prototype._checkError = function () {
      // Acceptable error states depend on the type of zlib stream.
      switch (this.err) {
        case exports.Z_OK:
        case exports.Z_BUF_ERROR:
          if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
            this._error('unexpected end of file');

            return false;
          }

          break;

        case exports.Z_STREAM_END:
          // normal statuses, not fatal
          break;

        case exports.Z_NEED_DICT:
          if (this.dictionary == null) {
            this._error('Missing dictionary');
          } else {
            this._error('Bad dictionary');
          }

          return false;

        default:
          // something else.
          this._error('Zlib error');

          return false;
      }

      return true;
    };

    Zlib.prototype._after = function () {
      if (!this._checkError()) {
        return;
      }

      var avail_out = this.strm.avail_out;
      var avail_in = this.strm.avail_in;
      this.write_in_progress = false; // call the write() cb

      this.callback(avail_in, avail_out);

      if (this.pending_close) {
        this.close();
      }
    };

    Zlib.prototype._error = function (message) {
      if (this.strm.msg) {
        message = this.strm.msg;
      }

      this.onerror(message, this.err // no hope of rescue.
      );
      this.write_in_progress = false;

      if (this.pending_close) {
        this.close();
      }
    };

    Zlib.prototype.init = function (windowBits, level, memLevel, strategy, dictionary) {
      assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');
      assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
      assert(level >= -1 && level <= 9, 'invalid compression level');
      assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');
      assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');

      this._init(level, windowBits, memLevel, strategy, dictionary);

      this._setDictionary();
    };

    Zlib.prototype.params = function () {
      throw new Error('deflateParams Not supported');
    };

    Zlib.prototype.reset = function () {
      this._reset();

      this._setDictionary();
    };

    Zlib.prototype._init = function (level, windowBits, memLevel, strategy, dictionary) {
      this.level = level;
      this.windowBits = windowBits;
      this.memLevel = memLevel;
      this.strategy = strategy;
      this.flush = exports.Z_NO_FLUSH;
      this.err = exports.Z_OK;

      if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) {
        this.windowBits += 16;
      }

      if (this.mode === exports.UNZIP) {
        this.windowBits += 32;
      }

      if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) {
        this.windowBits = -1 * this.windowBits;
      }

      this.strm = new Zstream();

      switch (this.mode) {
        case exports.DEFLATE:
        case exports.GZIP:
        case exports.DEFLATERAW:
          this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
          break;

        case exports.INFLATE:
        case exports.GUNZIP:
        case exports.INFLATERAW:
        case exports.UNZIP:
          this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
          break;

        default:
          throw new Error('Unknown mode ' + this.mode);
      }

      if (this.err !== exports.Z_OK) {
        this._error('Init error');
      }

      this.dictionary = dictionary;
      this.write_in_progress = false;
      this.init_done = true;
    };

    Zlib.prototype._setDictionary = function () {
      if (this.dictionary == null) {
        return;
      }

      this.err = exports.Z_OK;

      switch (this.mode) {
        case exports.DEFLATE:
        case exports.DEFLATERAW:
          this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
          break;

        default:
          break;
      }

      if (this.err !== exports.Z_OK) {
        this._error('Failed to set dictionary');
      }
    };

    Zlib.prototype._reset = function () {
      this.err = exports.Z_OK;

      switch (this.mode) {
        case exports.DEFLATE:
        case exports.DEFLATERAW:
        case exports.GZIP:
          this.err = zlib_deflate.deflateReset(this.strm);
          break;

        case exports.INFLATE:
        case exports.INFLATERAW:
        case exports.GUNZIP:
          this.err = zlib_inflate.inflateReset(this.strm);
          break;

        default:
          break;
      }

      if (this.err !== exports.Z_OK) {
        this._error('Failed to reset stream');
      }
    };

    exports.Zlib = Zlib;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer, __webpack_require__(16));
  /***/
},
/* 470 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(68), __webpack_require__(70), __webpack_require__(69), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var BlockCipher = C_lib.BlockCipher;
      var C_algo = C.algo; // Lookup tables

      var SBOX = [];
      var INV_SBOX = [];
      var SUB_MIX_0 = [];
      var SUB_MIX_1 = [];
      var SUB_MIX_2 = [];
      var SUB_MIX_3 = [];
      var INV_SUB_MIX_0 = [];
      var INV_SUB_MIX_1 = [];
      var INV_SUB_MIX_2 = [];
      var INV_SUB_MIX_3 = []; // Compute lookup tables

      (function () {
        // Compute double table
        var d = [];

        for (var i = 0; i < 256; i++) {
          if (i < 128) {
            d[i] = i << 1;
          } else {
            d[i] = i << 1 ^ 0x11b;
          }
        } // Walk GF(2^8)


        var x = 0;
        var xi = 0;

        for (var i = 0; i < 256; i++) {
          // Compute sbox
          var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
          sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
          SBOX[x] = sx;
          INV_SBOX[sx] = x; // Compute multiplication

          var x2 = d[x];
          var x4 = d[x2];
          var x8 = d[x4]; // Compute sub bytes, mix columns tables

          var t = d[sx] * 0x101 ^ sx * 0x1010100;
          SUB_MIX_0[x] = t << 24 | t >>> 8;
          SUB_MIX_1[x] = t << 16 | t >>> 16;
          SUB_MIX_2[x] = t << 8 | t >>> 24;
          SUB_MIX_3[x] = t; // Compute inv sub bytes, inv mix columns tables

          var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
          INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
          INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
          INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
          INV_SUB_MIX_3[sx] = t; // Compute next counter

          if (!x) {
            x = xi = 1;
          } else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
          }
        }
      })(); // Precomputed Rcon lookup


      var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
      /**
       * AES block cipher algorithm.
       */

      var AES = C_algo.AES = BlockCipher.extend({
        _doReset: function _doReset() {
          // Shortcuts
          var key = this._key;
          var keyWords = key.words;
          var keySize = key.sigBytes / 4; // Compute number of rounds

          var nRounds = this._nRounds = keySize + 6; // Compute number of key schedule rows

          var ksRows = (nRounds + 1) * 4; // Compute key schedule

          var keySchedule = this._keySchedule = [];

          for (var ksRow = 0; ksRow < ksRows; ksRow++) {
            if (ksRow < keySize) {
              keySchedule[ksRow] = keyWords[ksRow];
            } else {
              var t = keySchedule[ksRow - 1];

              if (!(ksRow % keySize)) {
                // Rot word
                t = t << 8 | t >>> 24; // Sub word

                t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff]; // Mix Rcon

                t ^= RCON[ksRow / keySize | 0] << 24;
              } else if (keySize > 6 && ksRow % keySize == 4) {
                // Sub word
                t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
              }

              keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
            }
          } // Compute inv key schedule


          var invKeySchedule = this._invKeySchedule = [];

          for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
            var ksRow = ksRows - invKsRow;

            if (invKsRow % 4) {
              var t = keySchedule[ksRow];
            } else {
              var t = keySchedule[ksRow - 4];
            }

            if (invKsRow < 4 || ksRow <= 4) {
              invKeySchedule[invKsRow] = t;
            } else {
              invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
            }
          }
        },
        encryptBlock: function encryptBlock(M, offset) {
          this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
        },
        decryptBlock: function decryptBlock(M, offset) {
          // Swap 2nd and 4th rows
          var t = M[offset + 1];
          M[offset + 1] = M[offset + 3];
          M[offset + 3] = t;

          this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX); // Inv swap 2nd and 4th rows


          var t = M[offset + 1];
          M[offset + 1] = M[offset + 3];
          M[offset + 3] = t;
        },
        _doCryptBlock: function _doCryptBlock(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
          // Shortcut
          var nRounds = this._nRounds; // Get input, add round key

          var s0 = M[offset] ^ keySchedule[0];
          var s1 = M[offset + 1] ^ keySchedule[1];
          var s2 = M[offset + 2] ^ keySchedule[2];
          var s3 = M[offset + 3] ^ keySchedule[3]; // Key schedule row counter

          var ksRow = 4; // Rounds

          for (var round = 1; round < nRounds; round++) {
            // Shift rows, sub bytes, mix columns, add round key
            var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
            var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
            var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
            var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++]; // Update state

            s0 = t0;
            s1 = t1;
            s2 = t2;
            s3 = t3;
          } // Shift rows, sub bytes, add round key


          var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
          var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
          var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
          var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]; // Set output

          M[offset] = t0;
          M[offset + 1] = t1;
          M[offset + 2] = t2;
          M[offset + 3] = t3;
        },
        keySize: 256 / 32
      });
      /**
       * Shortcut functions to the cipher's object interface.
       *
       * @example
       *
       *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
       *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
       */

      C.AES = BlockCipher._createHelper(AES);
    })();

    return CryptoJS.AES;
  });
  /***/

},
/* 471 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var C_enc = C.enc;
      /**
       * UTF-16 BE encoding strategy.
       */

      var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
        /**
         * Converts a word array to a UTF-16 BE string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-16 BE string.
         *
         * @static
         *
         * @example
         *
         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
          // Shortcuts
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes; // Convert

          var utf16Chars = [];

          for (var i = 0; i < sigBytes; i += 2) {
            var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
            utf16Chars.push(String.fromCharCode(codePoint));
          }

          return utf16Chars.join('');
        },

        /**
         * Converts a UTF-16 BE string to a word array.
         *
         * @param {string} utf16Str The UTF-16 BE string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
         */
        parse: function parse(utf16Str) {
          // Shortcut
          var utf16StrLength = utf16Str.length; // Convert

          var words = [];

          for (var i = 0; i < utf16StrLength; i++) {
            words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
          }

          return WordArray.create(words, utf16StrLength * 2);
        }
      };
      /**
       * UTF-16 LE encoding strategy.
       */

      C_enc.Utf16LE = {
        /**
         * Converts a word array to a UTF-16 LE string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-16 LE string.
         *
         * @static
         *
         * @example
         *
         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
          // Shortcuts
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes; // Convert

          var utf16Chars = [];

          for (var i = 0; i < sigBytes; i += 2) {
            var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
            utf16Chars.push(String.fromCharCode(codePoint));
          }

          return utf16Chars.join('');
        },

        /**
         * Converts a UTF-16 LE string to a word array.
         *
         * @param {string} utf16Str The UTF-16 LE string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
         */
        parse: function parse(utf16Str) {
          // Shortcut
          var utf16StrLength = utf16Str.length; // Convert

          var words = [];

          for (var i = 0; i < utf16StrLength; i++) {
            words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
          }

          return WordArray.create(words, utf16StrLength * 2);
        }
      };

      function swapEndian(word) {
        return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
      }
    })();

    return CryptoJS.enc.Utf16;
  });
  /***/

},
/* 472 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function (undefined) {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var CipherParams = C_lib.CipherParams;
      var C_enc = C.enc;
      var Hex = C_enc.Hex;
      var C_format = C.format;
      var HexFormatter = C_format.Hex = {
        /**
         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
         *
         * @param {CipherParams} cipherParams The cipher params object.
         *
         * @return {string} The hexadecimally encoded string.
         *
         * @static
         *
         * @example
         *
         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
         */
        stringify: function stringify(cipherParams) {
          return cipherParams.ciphertext.toString(Hex);
        },

        /**
         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
         *
         * @param {string} input The hexadecimally encoded string.
         *
         * @return {CipherParams} The cipher params object.
         *
         * @static
         *
         * @example
         *
         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
         */
        parse: function parse(input) {
          var ciphertext = Hex.parse(input);
          return CipherParams.create({
            ciphertext: ciphertext
          });
        }
      };
    })();

    return CryptoJS.format.Hex;
  });
  /***/

},
/* 473 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(100), __webpack_require__(474), __webpack_require__(471), __webpack_require__(68), __webpack_require__(70), __webpack_require__(137), __webpack_require__(198), __webpack_require__(490), __webpack_require__(199), __webpack_require__(492), __webpack_require__(491), __webpack_require__(489), __webpack_require__(136), __webpack_require__(485), __webpack_require__(69), __webpack_require__(17), __webpack_require__(475), __webpack_require__(477), __webpack_require__(476), __webpack_require__(479), __webpack_require__(478), __webpack_require__(480), __webpack_require__(481), __webpack_require__(482), __webpack_require__(484), __webpack_require__(483), __webpack_require__(472), __webpack_require__(470), __webpack_require__(493), __webpack_require__(488), __webpack_require__(487), __webpack_require__(486));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
    } else {
      // Global (browser)
      root.CryptoJS = factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    return CryptoJS;
  });
  /***/

},
/* 474 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Check if typed arrays are supported
      if (typeof ArrayBuffer != 'function') {
        return;
      } // Shortcuts


      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray; // Reference original init

      var superInit = WordArray.init; // Augment WordArray.init to handle typed arrays

      var subInit = WordArray.init = function (typedArray) {
        // Convert buffers to uint8
        if (typedArray instanceof ArrayBuffer) {
          typedArray = new Uint8Array(typedArray);
        } // Convert other array views to uint8


        if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
          typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
        } // Handle Uint8Array


        if (typedArray instanceof Uint8Array) {
          // Shortcut
          var typedArrayByteLength = typedArray.byteLength; // Extract bytes

          var words = [];

          for (var i = 0; i < typedArrayByteLength; i++) {
            words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
          } // Initialize this word array


          superInit.call(this, words, typedArrayByteLength);
        } else {
          // Else call normal init
          superInit.apply(this, arguments);
        }
      };

      subInit.prototype = WordArray;
    })();

    return CryptoJS.lib.WordArray;
  });
  /***/

},
/* 475 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /**
     * Cipher Feedback block mode.
     */
    CryptoJS.mode.CFB = function () {
      var CFB = CryptoJS.lib.BlockCipherMode.extend();
      CFB.Encryptor = CFB.extend({
        processBlock: function processBlock(words, offset) {
          // Shortcuts
          var cipher = this._cipher;
          var blockSize = cipher.blockSize;
          generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher); // Remember this block to use with next block

          this._prevBlock = words.slice(offset, offset + blockSize);
        }
      });
      CFB.Decryptor = CFB.extend({
        processBlock: function processBlock(words, offset) {
          // Shortcuts
          var cipher = this._cipher;
          var blockSize = cipher.blockSize; // Remember this block to use with next block

          var thisBlock = words.slice(offset, offset + blockSize);
          generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher); // This block becomes the previous block

          this._prevBlock = thisBlock;
        }
      });

      function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
        // Shortcut
        var iv = this._iv; // Generate keystream

        if (iv) {
          var keystream = iv.slice(0); // Remove IV for subsequent blocks

          this._iv = undefined;
        } else {
          var keystream = this._prevBlock;
        }

        cipher.encryptBlock(keystream, 0); // Encrypt

        for (var i = 0; i < blockSize; i++) {
          words[offset + i] ^= keystream[i];
        }
      }

      return CFB;
    }();

    return CryptoJS.mode.CFB;
  });
  /***/

},
/* 476 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /** @preserve
     * Counter block mode compatible with  Dr Brian Gladman fileenc.c
     * derived from CryptoJS.mode.CTR
     * Jan Hruby jhruby.web@gmail.com
     */
    CryptoJS.mode.CTRGladman = function () {
      var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

      function incWord(word) {
        if ((word >> 24 & 0xff) === 0xff) {
          //overflow
          var b1 = word >> 16 & 0xff;
          var b2 = word >> 8 & 0xff;
          var b3 = word & 0xff;

          if (b1 === 0xff) // overflow b1
            {
              b1 = 0;

              if (b2 === 0xff) {
                b2 = 0;

                if (b3 === 0xff) {
                  b3 = 0;
                } else {
                  ++b3;
                }
              } else {
                ++b2;
              }
            } else {
            ++b1;
          }

          word = 0;
          word += b1 << 16;
          word += b2 << 8;
          word += b3;
        } else {
          word += 0x01 << 24;
        }

        return word;
      }

      function incCounter(counter) {
        if ((counter[0] = incWord(counter[0])) === 0) {
          // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
          counter[1] = incWord(counter[1]);
        }

        return counter;
      }

      var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
        processBlock: function processBlock(words, offset) {
          // Shortcuts
          var cipher = this._cipher;
          var blockSize = cipher.blockSize;
          var iv = this._iv;
          var counter = this._counter; // Generate keystream

          if (iv) {
            counter = this._counter = iv.slice(0); // Remove IV for subsequent blocks

            this._iv = undefined;
          }

          incCounter(counter);
          var keystream = counter.slice(0);
          cipher.encryptBlock(keystream, 0); // Encrypt

          for (var i = 0; i < blockSize; i++) {
            words[offset + i] ^= keystream[i];
          }
        }
      });
      CTRGladman.Decryptor = Encryptor;
      return CTRGladman;
    }();

    return CryptoJS.mode.CTRGladman;
  });
  /***/

},
/* 477 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /**
     * Counter block mode.
     */
    CryptoJS.mode.CTR = function () {
      var CTR = CryptoJS.lib.BlockCipherMode.extend();
      var Encryptor = CTR.Encryptor = CTR.extend({
        processBlock: function processBlock(words, offset) {
          // Shortcuts
          var cipher = this._cipher;
          var blockSize = cipher.blockSize;
          var iv = this._iv;
          var counter = this._counter; // Generate keystream

          if (iv) {
            counter = this._counter = iv.slice(0); // Remove IV for subsequent blocks

            this._iv = undefined;
          }

          var keystream = counter.slice(0);
          cipher.encryptBlock(keystream, 0); // Increment counter

          counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0; // Encrypt

          for (var i = 0; i < blockSize; i++) {
            words[offset + i] ^= keystream[i];
          }
        }
      });
      CTR.Decryptor = Encryptor;
      return CTR;
    }();

    return CryptoJS.mode.CTR;
  });
  /***/

},
/* 478 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /**
     * Electronic Codebook block mode.
     */
    CryptoJS.mode.ECB = function () {
      var ECB = CryptoJS.lib.BlockCipherMode.extend();
      ECB.Encryptor = ECB.extend({
        processBlock: function processBlock(words, offset) {
          this._cipher.encryptBlock(words, offset);
        }
      });
      ECB.Decryptor = ECB.extend({
        processBlock: function processBlock(words, offset) {
          this._cipher.decryptBlock(words, offset);
        }
      });
      return ECB;
    }();

    return CryptoJS.mode.ECB;
  });
  /***/

},
/* 479 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /**
     * Output Feedback block mode.
     */
    CryptoJS.mode.OFB = function () {
      var OFB = CryptoJS.lib.BlockCipherMode.extend();
      var Encryptor = OFB.Encryptor = OFB.extend({
        processBlock: function processBlock(words, offset) {
          // Shortcuts
          var cipher = this._cipher;
          var blockSize = cipher.blockSize;
          var iv = this._iv;
          var keystream = this._keystream; // Generate keystream

          if (iv) {
            keystream = this._keystream = iv.slice(0); // Remove IV for subsequent blocks

            this._iv = undefined;
          }

          cipher.encryptBlock(keystream, 0); // Encrypt

          for (var i = 0; i < blockSize; i++) {
            words[offset + i] ^= keystream[i];
          }
        }
      });
      OFB.Decryptor = Encryptor;
      return OFB;
    }();

    return CryptoJS.mode.OFB;
  });
  /***/

},
/* 480 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /**
     * ANSI X.923 padding strategy.
     */
    CryptoJS.pad.AnsiX923 = {
      pad: function pad(data, blockSize) {
        // Shortcuts
        var dataSigBytes = data.sigBytes;
        var blockSizeBytes = blockSize * 4; // Count padding bytes

        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes; // Compute last byte position

        var lastBytePos = dataSigBytes + nPaddingBytes - 1; // Pad

        data.clamp();
        data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
        data.sigBytes += nPaddingBytes;
      },
      unpad: function unpad(data) {
        // Get number of padding bytes from last byte
        var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff; // Remove padding

        data.sigBytes -= nPaddingBytes;
      }
    };
    return CryptoJS.pad.Ansix923;
  });
  /***/

},
/* 481 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /**
     * ISO 10126 padding strategy.
     */
    CryptoJS.pad.Iso10126 = {
      pad: function pad(data, blockSize) {
        // Shortcut
        var blockSizeBytes = blockSize * 4; // Count padding bytes

        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes; // Pad

        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
      },
      unpad: function unpad(data) {
        // Get number of padding bytes from last byte
        var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff; // Remove padding

        data.sigBytes -= nPaddingBytes;
      }
    };
    return CryptoJS.pad.Iso10126;
  });
  /***/

},
/* 482 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /**
     * ISO/IEC 9797-1 Padding Method 2.
     */
    CryptoJS.pad.Iso97971 = {
      pad: function pad(data, blockSize) {
        // Add 0x80 byte
        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1)); // Zero pad the rest

        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
      },
      unpad: function unpad(data) {
        // Remove zero padding
        CryptoJS.pad.ZeroPadding.unpad(data); // Remove one more byte -- the 0x80 byte

        data.sigBytes--;
      }
    };
    return CryptoJS.pad.Iso97971;
  });
  /***/

},
/* 483 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /**
     * A noop padding strategy.
     */
    CryptoJS.pad.NoPadding = {
      pad: function pad() {},
      unpad: function unpad() {}
    };
    return CryptoJS.pad.NoPadding;
  });
  /***/

},
/* 484 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /**
     * Zero padding strategy.
     */
    CryptoJS.pad.ZeroPadding = {
      pad: function pad(data, blockSize) {
        // Shortcut
        var blockSizeBytes = blockSize * 4; // Pad

        data.clamp();
        data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
      },
      unpad: function unpad(data) {
        // Shortcut
        var dataWords = data.words; // Unpad

        var i = data.sigBytes - 1;

        while (!(dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff)) {
          i--;
        }

        data.sigBytes = i + 1;
      }
    };
    return CryptoJS.pad.ZeroPadding;
  });
  /***/

},
/* 485 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(137), __webpack_require__(136));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./sha1", "./hmac"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var Base = C_lib.Base;
      var WordArray = C_lib.WordArray;
      var C_algo = C.algo;
      var SHA1 = C_algo.SHA1;
      var HMAC = C_algo.HMAC;
      /**
       * Password-Based Key Derivation Function 2 algorithm.
       */

      var PBKDF2 = C_algo.PBKDF2 = Base.extend({
        /**
         * Configuration options.
         *
         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
         * @property {Hasher} hasher The hasher to use. Default: SHA1
         * @property {number} iterations The number of iterations to perform. Default: 1
         */
        cfg: Base.extend({
          keySize: 128 / 32,
          hasher: SHA1,
          iterations: 1
        }),

        /**
         * Initializes a newly created key derivation function.
         *
         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
         *
         * @example
         *
         *     var kdf = CryptoJS.algo.PBKDF2.create();
         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
         */
        init: function init(cfg) {
          this.cfg = this.cfg.extend(cfg);
        },

        /**
         * Computes the Password-Based Key Derivation Function 2.
         *
         * @param {WordArray|string} password The password.
         * @param {WordArray|string} salt A salt.
         *
         * @return {WordArray} The derived key.
         *
         * @example
         *
         *     var key = kdf.compute(password, salt);
         */
        compute: function compute(password, salt) {
          // Shortcut
          var cfg = this.cfg; // Init HMAC

          var hmac = HMAC.create(cfg.hasher, password); // Initial values

          var derivedKey = WordArray.create();
          var blockIndex = WordArray.create([0x00000001]); // Shortcuts

          var derivedKeyWords = derivedKey.words;
          var blockIndexWords = blockIndex.words;
          var keySize = cfg.keySize;
          var iterations = cfg.iterations; // Generate key

          while (derivedKeyWords.length < keySize) {
            var block = hmac.update(salt).finalize(blockIndex);
            hmac.reset(); // Shortcuts

            var blockWords = block.words;
            var blockWordsLength = blockWords.length; // Iterations

            var intermediate = block;

            for (var i = 1; i < iterations; i++) {
              intermediate = hmac.finalize(intermediate);
              hmac.reset(); // Shortcut

              var intermediateWords = intermediate.words; // XOR intermediate with block

              for (var j = 0; j < blockWordsLength; j++) {
                blockWords[j] ^= intermediateWords[j];
              }
            }

            derivedKey.concat(block);
            blockIndexWords[0]++;
          }

          derivedKey.sigBytes = keySize * 4;
          return derivedKey;
        }
      });
      /**
       * Computes the Password-Based Key Derivation Function 2.
       *
       * @param {WordArray|string} password The password.
       * @param {WordArray|string} salt A salt.
       * @param {Object} cfg (Optional) The configuration options to use for this computation.
       *
       * @return {WordArray} The derived key.
       *
       * @static
       *
       * @example
       *
       *     var key = CryptoJS.PBKDF2(password, salt);
       *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
       *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
       */

      C.PBKDF2 = function (password, salt, cfg) {
        return PBKDF2.create(cfg).compute(password, salt);
      };
    })();

    return CryptoJS.PBKDF2;
  });
  /***/

},
/* 486 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(68), __webpack_require__(70), __webpack_require__(69), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var StreamCipher = C_lib.StreamCipher;
      var C_algo = C.algo; // Reusable objects

      var S = [];
      var C_ = [];
      var G = [];
      /**
       * Rabbit stream cipher algorithm.
       *
       * This is a legacy version that neglected to convert the key to little-endian.
       * This error doesn't affect the cipher's security,
       * but it does affect its compatibility with other implementations.
       */

      var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
        _doReset: function _doReset() {
          // Shortcuts
          var K = this._key.words;
          var iv = this.cfg.iv; // Generate initial state values

          var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16]; // Generate initial counter values

          var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff]; // Carry bit

          this._b = 0; // Iterate the system four times

          for (var i = 0; i < 4; i++) {
            nextState.call(this);
          } // Modify the counters


          for (var i = 0; i < 8; i++) {
            C[i] ^= X[i + 4 & 7];
          } // IV setup


          if (iv) {
            // Shortcuts
            var IV = iv.words;
            var IV_0 = IV[0];
            var IV_1 = IV[1]; // Generate four subvectors

            var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
            var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
            var i1 = i0 >>> 16 | i2 & 0xffff0000;
            var i3 = i2 << 16 | i0 & 0x0000ffff; // Modify counter values

            C[0] ^= i0;
            C[1] ^= i1;
            C[2] ^= i2;
            C[3] ^= i3;
            C[4] ^= i0;
            C[5] ^= i1;
            C[6] ^= i2;
            C[7] ^= i3; // Iterate the system four times

            for (var i = 0; i < 4; i++) {
              nextState.call(this);
            }
          }
        },
        _doProcessBlock: function _doProcessBlock(M, offset) {
          // Shortcut
          var X = this._X; // Iterate the system

          nextState.call(this); // Generate four keystream words

          S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
          S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
          S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
          S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;

          for (var i = 0; i < 4; i++) {
            // Swap endian
            S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00; // Encrypt

            M[offset + i] ^= S[i];
          }
        },
        blockSize: 128 / 32,
        ivSize: 64 / 32
      });

      function nextState() {
        // Shortcuts
        var X = this._X;
        var C = this._C; // Save old counter values

        for (var i = 0; i < 8; i++) {
          C_[i] = C[i];
        } // Calculate new counter values


        C[0] = C[0] + 0x4d34d34d + this._b | 0;
        C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
        C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
        C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
        C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
        C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
        C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
        C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
        this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0; // Calculate the g-values

        for (var i = 0; i < 8; i++) {
          var gx = X[i] + C[i]; // Construct high and low argument for squaring

          var ga = gx & 0xffff;
          var gb = gx >>> 16; // Calculate high and low result of squaring

          var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
          var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0); // High XOR low

          G[i] = gh ^ gl;
        } // Calculate new state values


        X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
        X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
        X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
        X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
        X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
        X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
        X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
        X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
      }
      /**
       * Shortcut functions to the cipher's object interface.
       *
       * @example
       *
       *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
       *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
       */


      C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();

    return CryptoJS.RabbitLegacy;
  });
  /***/

},
/* 487 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(68), __webpack_require__(70), __webpack_require__(69), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var StreamCipher = C_lib.StreamCipher;
      var C_algo = C.algo; // Reusable objects

      var S = [];
      var C_ = [];
      var G = [];
      /**
       * Rabbit stream cipher algorithm
       */

      var Rabbit = C_algo.Rabbit = StreamCipher.extend({
        _doReset: function _doReset() {
          // Shortcuts
          var K = this._key.words;
          var iv = this.cfg.iv; // Swap endian

          for (var i = 0; i < 4; i++) {
            K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
          } // Generate initial state values


          var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16]; // Generate initial counter values

          var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff]; // Carry bit

          this._b = 0; // Iterate the system four times

          for (var i = 0; i < 4; i++) {
            nextState.call(this);
          } // Modify the counters


          for (var i = 0; i < 8; i++) {
            C[i] ^= X[i + 4 & 7];
          } // IV setup


          if (iv) {
            // Shortcuts
            var IV = iv.words;
            var IV_0 = IV[0];
            var IV_1 = IV[1]; // Generate four subvectors

            var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
            var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
            var i1 = i0 >>> 16 | i2 & 0xffff0000;
            var i3 = i2 << 16 | i0 & 0x0000ffff; // Modify counter values

            C[0] ^= i0;
            C[1] ^= i1;
            C[2] ^= i2;
            C[3] ^= i3;
            C[4] ^= i0;
            C[5] ^= i1;
            C[6] ^= i2;
            C[7] ^= i3; // Iterate the system four times

            for (var i = 0; i < 4; i++) {
              nextState.call(this);
            }
          }
        },
        _doProcessBlock: function _doProcessBlock(M, offset) {
          // Shortcut
          var X = this._X; // Iterate the system

          nextState.call(this); // Generate four keystream words

          S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
          S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
          S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
          S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;

          for (var i = 0; i < 4; i++) {
            // Swap endian
            S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00; // Encrypt

            M[offset + i] ^= S[i];
          }
        },
        blockSize: 128 / 32,
        ivSize: 64 / 32
      });

      function nextState() {
        // Shortcuts
        var X = this._X;
        var C = this._C; // Save old counter values

        for (var i = 0; i < 8; i++) {
          C_[i] = C[i];
        } // Calculate new counter values


        C[0] = C[0] + 0x4d34d34d + this._b | 0;
        C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
        C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
        C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
        C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
        C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
        C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
        C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
        this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0; // Calculate the g-values

        for (var i = 0; i < 8; i++) {
          var gx = X[i] + C[i]; // Construct high and low argument for squaring

          var ga = gx & 0xffff;
          var gb = gx >>> 16; // Calculate high and low result of squaring

          var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
          var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0); // High XOR low

          G[i] = gh ^ gl;
        } // Calculate new state values


        X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
        X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
        X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
        X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
        X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
        X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
        X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
        X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
      }
      /**
       * Shortcut functions to the cipher's object interface.
       *
       * @example
       *
       *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
       *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
       */


      C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();

    return CryptoJS.Rabbit;
  });
  /***/

},
/* 488 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(68), __webpack_require__(70), __webpack_require__(69), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var StreamCipher = C_lib.StreamCipher;
      var C_algo = C.algo;
      /**
       * RC4 stream cipher algorithm.
       */

      var RC4 = C_algo.RC4 = StreamCipher.extend({
        _doReset: function _doReset() {
          // Shortcuts
          var key = this._key;
          var keyWords = key.words;
          var keySigBytes = key.sigBytes; // Init sbox

          var S = this._S = [];

          for (var i = 0; i < 256; i++) {
            S[i] = i;
          } // Key setup


          for (var i = 0, j = 0; i < 256; i++) {
            var keyByteIndex = i % keySigBytes;
            var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
            j = (j + S[i] + keyByte) % 256; // Swap

            var t = S[i];
            S[i] = S[j];
            S[j] = t;
          } // Counters


          this._i = this._j = 0;
        },
        _doProcessBlock: function _doProcessBlock(M, offset) {
          M[offset] ^= generateKeystreamWord.call(this);
        },
        keySize: 256 / 32,
        ivSize: 0
      });

      function generateKeystreamWord() {
        // Shortcuts
        var S = this._S;
        var i = this._i;
        var j = this._j; // Generate keystream word

        var keystreamWord = 0;

        for (var n = 0; n < 4; n++) {
          i = (i + 1) % 256;
          j = (j + S[i]) % 256; // Swap

          var t = S[i];
          S[i] = S[j];
          S[j] = t;
          keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
        } // Update counters


        this._i = i;
        this._j = j;
        return keystreamWord;
      }
      /**
       * Shortcut functions to the cipher's object interface.
       *
       * @example
       *
       *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
       *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
       */


      C.RC4 = StreamCipher._createHelper(RC4);
      /**
       * Modified RC4 stream cipher algorithm.
       */

      var RC4Drop = C_algo.RC4Drop = RC4.extend({
        /**
         * Configuration options.
         *
         * @property {number} drop The number of keystream words to drop. Default 192
         */
        cfg: RC4.cfg.extend({
          drop: 192
        }),
        _doReset: function _doReset() {
          RC4._doReset.call(this); // Drop


          for (var i = this.cfg.drop; i > 0; i--) {
            generateKeystreamWord.call(this);
          }
        }
      });
      /**
       * Shortcut functions to the cipher's object interface.
       *
       * @example
       *
       *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
       *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
       */

      C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();

    return CryptoJS.RC4;
  });
  /***/

},
/* 489 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    /** @preserve
    (c) 2012 by Cédric Mesnil. All rights reserved.
    	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
    	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
        - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
    	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
    */
    (function (Math) {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var Hasher = C_lib.Hasher;
      var C_algo = C.algo; // Constants table

      var _zl = WordArray.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]);

      var _zr = WordArray.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]);

      var _sl = WordArray.create([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]);

      var _sr = WordArray.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]);

      var _hl = WordArray.create([0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);

      var _hr = WordArray.create([0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
      /**
       * RIPEMD160 hash algorithm.
       */


      var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
        _doReset: function _doReset() {
          this._hash = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
        },
        _doProcessBlock: function _doProcessBlock(M, offset) {
          // Swap endian
          for (var i = 0; i < 16; i++) {
            // Shortcuts
            var offset_i = offset + i;
            var M_offset_i = M[offset_i]; // Swap

            M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
          } // Shortcut


          var H = this._hash.words;
          var hl = _hl.words;
          var hr = _hr.words;
          var zl = _zl.words;
          var zr = _zr.words;
          var sl = _sl.words;
          var sr = _sr.words; // Working variables

          var al, bl, cl, dl, el;
          var ar, br, cr, dr, er;
          ar = al = H[0];
          br = bl = H[1];
          cr = cl = H[2];
          dr = dl = H[3];
          er = el = H[4]; // Computation

          var t;

          for (var i = 0; i < 80; i += 1) {
            t = al + M[offset + zl[i]] | 0;

            if (i < 16) {
              t += f1(bl, cl, dl) + hl[0];
            } else if (i < 32) {
              t += f2(bl, cl, dl) + hl[1];
            } else if (i < 48) {
              t += f3(bl, cl, dl) + hl[2];
            } else if (i < 64) {
              t += f4(bl, cl, dl) + hl[3];
            } else {
              // if (i<80) {
              t += f5(bl, cl, dl) + hl[4];
            }

            t = t | 0;
            t = rotl(t, sl[i]);
            t = t + el | 0;
            al = el;
            el = dl;
            dl = rotl(cl, 10);
            cl = bl;
            bl = t;
            t = ar + M[offset + zr[i]] | 0;

            if (i < 16) {
              t += f5(br, cr, dr) + hr[0];
            } else if (i < 32) {
              t += f4(br, cr, dr) + hr[1];
            } else if (i < 48) {
              t += f3(br, cr, dr) + hr[2];
            } else if (i < 64) {
              t += f2(br, cr, dr) + hr[3];
            } else {
              // if (i<80) {
              t += f1(br, cr, dr) + hr[4];
            }

            t = t | 0;
            t = rotl(t, sr[i]);
            t = t + er | 0;
            ar = er;
            er = dr;
            dr = rotl(cr, 10);
            cr = br;
            br = t;
          } // Intermediate hash value


          t = H[1] + cl + dr | 0;
          H[1] = H[2] + dl + er | 0;
          H[2] = H[3] + el + ar | 0;
          H[3] = H[4] + al + br | 0;
          H[4] = H[0] + bl + cr | 0;
          H[0] = t;
        },
        _doFinalize: function _doFinalize() {
          // Shortcuts
          var data = this._data;
          var dataWords = data.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data.sigBytes * 8; // Add padding

          dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
          data.sigBytes = (dataWords.length + 1) * 4; // Hash final blocks

          this._process(); // Shortcuts


          var hash = this._hash;
          var H = hash.words; // Swap endian

          for (var i = 0; i < 5; i++) {
            // Shortcut
            var H_i = H[i]; // Swap

            H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
          } // Return final computed hash


          return hash;
        },
        clone: function clone() {
          var clone = Hasher.clone.call(this);
          clone._hash = this._hash.clone();
          return clone;
        }
      });

      function f1(x, y, z) {
        return x ^ y ^ z;
      }

      function f2(x, y, z) {
        return x & y | ~x & z;
      }

      function f3(x, y, z) {
        return (x | ~y) ^ z;
      }

      function f4(x, y, z) {
        return x & z | y & ~z;
      }

      function f5(x, y, z) {
        return x ^ (y | ~z);
      }

      function rotl(x, n) {
        return x << n | x >>> 32 - n;
      }
      /**
       * Shortcut function to the hasher's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       *
       * @return {WordArray} The hash.
       *
       * @static
       *
       * @example
       *
       *     var hash = CryptoJS.RIPEMD160('message');
       *     var hash = CryptoJS.RIPEMD160(wordArray);
       */


      C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
      /**
       * Shortcut function to the HMAC's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       * @param {WordArray|string} key The secret key.
       *
       * @return {WordArray} The HMAC.
       *
       * @static
       *
       * @example
       *
       *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
       */

      C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);

    return CryptoJS.RIPEMD160;
  });
  /***/

},
/* 490 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(198));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./sha256"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var C_algo = C.algo;
      var SHA256 = C_algo.SHA256;
      /**
       * SHA-224 hash algorithm.
       */

      var SHA224 = C_algo.SHA224 = SHA256.extend({
        _doReset: function _doReset() {
          this._hash = new WordArray.init([0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4]);
        },
        _doFinalize: function _doFinalize() {
          var hash = SHA256._doFinalize.call(this);

          hash.sigBytes -= 4;
          return hash;
        }
      });
      /**
       * Shortcut function to the hasher's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       *
       * @return {WordArray} The hash.
       *
       * @static
       *
       * @example
       *
       *     var hash = CryptoJS.SHA224('message');
       *     var hash = CryptoJS.SHA224(wordArray);
       */

      C.SHA224 = SHA256._createHelper(SHA224);
      /**
       * Shortcut function to the HMAC's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       * @param {WordArray|string} key The secret key.
       *
       * @return {WordArray} The HMAC.
       *
       * @static
       *
       * @example
       *
       *     var hmac = CryptoJS.HmacSHA224(message, key);
       */

      C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();

    return CryptoJS.SHA224;
  });
  /***/

},
/* 491 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(100));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./x64-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function (Math) {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var Hasher = C_lib.Hasher;
      var C_x64 = C.x64;
      var X64Word = C_x64.Word;
      var C_algo = C.algo; // Constants tables

      var RHO_OFFSETS = [];
      var PI_INDEXES = [];
      var ROUND_CONSTANTS = []; // Compute Constants

      (function () {
        // Compute rho offset constants
        var x = 1,
            y = 0;

        for (var t = 0; t < 24; t++) {
          RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
          var newX = y % 5;
          var newY = (2 * x + 3 * y) % 5;
          x = newX;
          y = newY;
        } // Compute pi index constants


        for (var x = 0; x < 5; x++) {
          for (var y = 0; y < 5; y++) {
            PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
          }
        } // Compute round constants


        var LFSR = 0x01;

        for (var i = 0; i < 24; i++) {
          var roundConstantMsw = 0;
          var roundConstantLsw = 0;

          for (var j = 0; j < 7; j++) {
            if (LFSR & 0x01) {
              var bitPosition = (1 << j) - 1;

              if (bitPosition < 32) {
                roundConstantLsw ^= 1 << bitPosition;
              } else
                /* if (bitPosition >= 32) */
                {
                  roundConstantMsw ^= 1 << bitPosition - 32;
                }
            } // Compute next LFSR


            if (LFSR & 0x80) {
              // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
              LFSR = LFSR << 1 ^ 0x71;
            } else {
              LFSR <<= 1;
            }
          }

          ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
        }
      })(); // Reusable objects for temporary values


      var T = [];

      (function () {
        for (var i = 0; i < 25; i++) {
          T[i] = X64Word.create();
        }
      })();
      /**
       * SHA-3 hash algorithm.
       */


      var SHA3 = C_algo.SHA3 = Hasher.extend({
        /**
         * Configuration options.
         *
         * @property {number} outputLength
         *   The desired number of bits in the output hash.
         *   Only values permitted are: 224, 256, 384, 512.
         *   Default: 512
         */
        cfg: Hasher.cfg.extend({
          outputLength: 512
        }),
        _doReset: function _doReset() {
          var state = this._state = [];

          for (var i = 0; i < 25; i++) {
            state[i] = new X64Word.init();
          }

          this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
        },
        _doProcessBlock: function _doProcessBlock(M, offset) {
          // Shortcuts
          var state = this._state;
          var nBlockSizeLanes = this.blockSize / 2; // Absorb

          for (var i = 0; i < nBlockSizeLanes; i++) {
            // Shortcuts
            var M2i = M[offset + 2 * i];
            var M2i1 = M[offset + 2 * i + 1]; // Swap endian

            M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
            M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00; // Absorb message into state

            var lane = state[i];
            lane.high ^= M2i1;
            lane.low ^= M2i;
          } // Rounds


          for (var round = 0; round < 24; round++) {
            // Theta
            for (var x = 0; x < 5; x++) {
              // Mix column lanes
              var tMsw = 0,
                  tLsw = 0;

              for (var y = 0; y < 5; y++) {
                var lane = state[x + 5 * y];
                tMsw ^= lane.high;
                tLsw ^= lane.low;
              } // Temporary values


              var Tx = T[x];
              Tx.high = tMsw;
              Tx.low = tLsw;
            }

            for (var x = 0; x < 5; x++) {
              // Shortcuts
              var Tx4 = T[(x + 4) % 5];
              var Tx1 = T[(x + 1) % 5];
              var Tx1Msw = Tx1.high;
              var Tx1Lsw = Tx1.low; // Mix surrounding columns

              var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
              var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);

              for (var y = 0; y < 5; y++) {
                var lane = state[x + 5 * y];
                lane.high ^= tMsw;
                lane.low ^= tLsw;
              }
            } // Rho Pi


            for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
              // Shortcuts
              var lane = state[laneIndex];
              var laneMsw = lane.high;
              var laneLsw = lane.low;
              var rhoOffset = RHO_OFFSETS[laneIndex]; // Rotate lanes

              if (rhoOffset < 32) {
                var tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                var tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
              } else
                /* if (rhoOffset >= 32) */
                {
                  var tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                  var tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                } // Transpose lanes


              var TPiLane = T[PI_INDEXES[laneIndex]];
              TPiLane.high = tMsw;
              TPiLane.low = tLsw;
            } // Rho pi at x = y = 0


            var T0 = T[0];
            var state0 = state[0];
            T0.high = state0.high;
            T0.low = state0.low; // Chi

            for (var x = 0; x < 5; x++) {
              for (var y = 0; y < 5; y++) {
                // Shortcuts
                var laneIndex = x + 5 * y;
                var lane = state[laneIndex];
                var TLane = T[laneIndex];
                var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                var Tx2Lane = T[(x + 2) % 5 + 5 * y]; // Mix rows

                lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
              }
            } // Iota


            var lane = state[0];
            var roundConstant = ROUND_CONSTANTS[round];
            lane.high ^= roundConstant.high;
            lane.low ^= roundConstant.low;
            ;
          }
        },
        _doFinalize: function _doFinalize() {
          // Shortcuts
          var data = this._data;
          var dataWords = data.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data.sigBytes * 8;
          var blockSizeBits = this.blockSize * 32; // Add padding

          dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
          dataWords[(Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
          data.sigBytes = dataWords.length * 4; // Hash final blocks

          this._process(); // Shortcuts


          var state = this._state;
          var outputLengthBytes = this.cfg.outputLength / 8;
          var outputLengthLanes = outputLengthBytes / 8; // Squeeze

          var hashWords = [];

          for (var i = 0; i < outputLengthLanes; i++) {
            // Shortcuts
            var lane = state[i];
            var laneMsw = lane.high;
            var laneLsw = lane.low; // Swap endian

            laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
            laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00; // Squeeze state to retrieve hash

            hashWords.push(laneLsw);
            hashWords.push(laneMsw);
          } // Return final computed hash


          return new WordArray.init(hashWords, outputLengthBytes);
        },
        clone: function clone() {
          var clone = Hasher.clone.call(this);

          var state = clone._state = this._state.slice(0);

          for (var i = 0; i < 25; i++) {
            state[i] = state[i].clone();
          }

          return clone;
        }
      });
      /**
       * Shortcut function to the hasher's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       *
       * @return {WordArray} The hash.
       *
       * @static
       *
       * @example
       *
       *     var hash = CryptoJS.SHA3('message');
       *     var hash = CryptoJS.SHA3(wordArray);
       */

      C.SHA3 = Hasher._createHelper(SHA3);
      /**
       * Shortcut function to the HMAC's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       * @param {WordArray|string} key The secret key.
       *
       * @return {WordArray} The HMAC.
       *
       * @static
       *
       * @example
       *
       *     var hmac = CryptoJS.HmacSHA3(message, key);
       */

      C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);

    return CryptoJS.SHA3;
  });
  /***/

},
/* 492 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(100), __webpack_require__(199));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./x64-core", "./sha512"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_x64 = C.x64;
      var X64Word = C_x64.Word;
      var X64WordArray = C_x64.WordArray;
      var C_algo = C.algo;
      var SHA512 = C_algo.SHA512;
      /**
       * SHA-384 hash algorithm.
       */

      var SHA384 = C_algo.SHA384 = SHA512.extend({
        _doReset: function _doReset() {
          this._hash = new X64WordArray.init([new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507), new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939), new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511), new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)]);
        },
        _doFinalize: function _doFinalize() {
          var hash = SHA512._doFinalize.call(this);

          hash.sigBytes -= 16;
          return hash;
        }
      });
      /**
       * Shortcut function to the hasher's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       *
       * @return {WordArray} The hash.
       *
       * @static
       *
       * @example
       *
       *     var hash = CryptoJS.SHA384('message');
       *     var hash = CryptoJS.SHA384(wordArray);
       */

      C.SHA384 = SHA512._createHelper(SHA384);
      /**
       * Shortcut function to the HMAC's object interface.
       *
       * @param {WordArray|string} message The message to hash.
       * @param {WordArray|string} key The secret key.
       *
       * @return {WordArray} The HMAC.
       *
       * @static
       *
       * @example
       *
       *     var hmac = CryptoJS.HmacSHA384(message, key);
       */

      C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();

    return CryptoJS.SHA384;
  });
  /***/

},
/* 493 */

/***/
function (module, exports, __webpack_require__) {
  ;

  (function (root, factory, undef) {
    if (true) {
      // CommonJS
      module.exports = exports = factory(__webpack_require__(4), __webpack_require__(68), __webpack_require__(70), __webpack_require__(69), __webpack_require__(17));
    } else if (typeof define === "function" && define.amd) {
      // AMD
      define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
    } else {
      // Global (browser)
      factory(root.CryptoJS);
    }
  })(this, function (CryptoJS) {
    (function () {
      // Shortcuts
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var BlockCipher = C_lib.BlockCipher;
      var C_algo = C.algo; // Permuted Choice 1 constants

      var PC1 = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4]; // Permuted Choice 2 constants

      var PC2 = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32]; // Cumulative bit shift constants

      var BIT_SHIFTS = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28]; // SBOXes and round permutation constants

      var SBOX_P = [{
        0x0: 0x808200,
        0x10000000: 0x8000,
        0x20000000: 0x808002,
        0x30000000: 0x2,
        0x40000000: 0x200,
        0x50000000: 0x808202,
        0x60000000: 0x800202,
        0x70000000: 0x800000,
        0x80000000: 0x202,
        0x90000000: 0x800200,
        0xa0000000: 0x8200,
        0xb0000000: 0x808000,
        0xc0000000: 0x8002,
        0xd0000000: 0x800002,
        0xe0000000: 0x0,
        0xf0000000: 0x8202,
        0x8000000: 0x0,
        0x18000000: 0x808202,
        0x28000000: 0x8202,
        0x38000000: 0x8000,
        0x48000000: 0x808200,
        0x58000000: 0x200,
        0x68000000: 0x808002,
        0x78000000: 0x2,
        0x88000000: 0x800200,
        0x98000000: 0x8200,
        0xa8000000: 0x808000,
        0xb8000000: 0x800202,
        0xc8000000: 0x800002,
        0xd8000000: 0x8002,
        0xe8000000: 0x202,
        0xf8000000: 0x800000,
        0x1: 0x8000,
        0x10000001: 0x2,
        0x20000001: 0x808200,
        0x30000001: 0x800000,
        0x40000001: 0x808002,
        0x50000001: 0x8200,
        0x60000001: 0x200,
        0x70000001: 0x800202,
        0x80000001: 0x808202,
        0x90000001: 0x808000,
        0xa0000001: 0x800002,
        0xb0000001: 0x8202,
        0xc0000001: 0x202,
        0xd0000001: 0x800200,
        0xe0000001: 0x8002,
        0xf0000001: 0x0,
        0x8000001: 0x808202,
        0x18000001: 0x808000,
        0x28000001: 0x800000,
        0x38000001: 0x200,
        0x48000001: 0x8000,
        0x58000001: 0x800002,
        0x68000001: 0x2,
        0x78000001: 0x8202,
        0x88000001: 0x8002,
        0x98000001: 0x800202,
        0xa8000001: 0x202,
        0xb8000001: 0x808200,
        0xc8000001: 0x800200,
        0xd8000001: 0x0,
        0xe8000001: 0x8200,
        0xf8000001: 0x808002
      }, {
        0x0: 0x40084010,
        0x1000000: 0x4000,
        0x2000000: 0x80000,
        0x3000000: 0x40080010,
        0x4000000: 0x40000010,
        0x5000000: 0x40084000,
        0x6000000: 0x40004000,
        0x7000000: 0x10,
        0x8000000: 0x84000,
        0x9000000: 0x40004010,
        0xa000000: 0x40000000,
        0xb000000: 0x84010,
        0xc000000: 0x80010,
        0xd000000: 0x0,
        0xe000000: 0x4010,
        0xf000000: 0x40080000,
        0x800000: 0x40004000,
        0x1800000: 0x84010,
        0x2800000: 0x10,
        0x3800000: 0x40004010,
        0x4800000: 0x40084010,
        0x5800000: 0x40000000,
        0x6800000: 0x80000,
        0x7800000: 0x40080010,
        0x8800000: 0x80010,
        0x9800000: 0x0,
        0xa800000: 0x4000,
        0xb800000: 0x40080000,
        0xc800000: 0x40000010,
        0xd800000: 0x84000,
        0xe800000: 0x40084000,
        0xf800000: 0x4010,
        0x10000000: 0x0,
        0x11000000: 0x40080010,
        0x12000000: 0x40004010,
        0x13000000: 0x40084000,
        0x14000000: 0x40080000,
        0x15000000: 0x10,
        0x16000000: 0x84010,
        0x17000000: 0x4000,
        0x18000000: 0x4010,
        0x19000000: 0x80000,
        0x1a000000: 0x80010,
        0x1b000000: 0x40000010,
        0x1c000000: 0x84000,
        0x1d000000: 0x40004000,
        0x1e000000: 0x40000000,
        0x1f000000: 0x40084010,
        0x10800000: 0x84010,
        0x11800000: 0x80000,
        0x12800000: 0x40080000,
        0x13800000: 0x4000,
        0x14800000: 0x40004000,
        0x15800000: 0x40084010,
        0x16800000: 0x10,
        0x17800000: 0x40000000,
        0x18800000: 0x40084000,
        0x19800000: 0x40000010,
        0x1a800000: 0x40004010,
        0x1b800000: 0x80010,
        0x1c800000: 0x0,
        0x1d800000: 0x4010,
        0x1e800000: 0x40080010,
        0x1f800000: 0x84000
      }, {
        0x0: 0x104,
        0x100000: 0x0,
        0x200000: 0x4000100,
        0x300000: 0x10104,
        0x400000: 0x10004,
        0x500000: 0x4000004,
        0x600000: 0x4010104,
        0x700000: 0x4010000,
        0x800000: 0x4000000,
        0x900000: 0x4010100,
        0xa00000: 0x10100,
        0xb00000: 0x4010004,
        0xc00000: 0x4000104,
        0xd00000: 0x10000,
        0xe00000: 0x4,
        0xf00000: 0x100,
        0x80000: 0x4010100,
        0x180000: 0x4010004,
        0x280000: 0x0,
        0x380000: 0x4000100,
        0x480000: 0x4000004,
        0x580000: 0x10000,
        0x680000: 0x10004,
        0x780000: 0x104,
        0x880000: 0x4,
        0x980000: 0x100,
        0xa80000: 0x4010000,
        0xb80000: 0x10104,
        0xc80000: 0x10100,
        0xd80000: 0x4000104,
        0xe80000: 0x4010104,
        0xf80000: 0x4000000,
        0x1000000: 0x4010100,
        0x1100000: 0x10004,
        0x1200000: 0x10000,
        0x1300000: 0x4000100,
        0x1400000: 0x100,
        0x1500000: 0x4010104,
        0x1600000: 0x4000004,
        0x1700000: 0x0,
        0x1800000: 0x4000104,
        0x1900000: 0x4000000,
        0x1a00000: 0x4,
        0x1b00000: 0x10100,
        0x1c00000: 0x4010000,
        0x1d00000: 0x104,
        0x1e00000: 0x10104,
        0x1f00000: 0x4010004,
        0x1080000: 0x4000000,
        0x1180000: 0x104,
        0x1280000: 0x4010100,
        0x1380000: 0x0,
        0x1480000: 0x10004,
        0x1580000: 0x4000100,
        0x1680000: 0x100,
        0x1780000: 0x4010004,
        0x1880000: 0x10000,
        0x1980000: 0x4010104,
        0x1a80000: 0x10104,
        0x1b80000: 0x4000004,
        0x1c80000: 0x4000104,
        0x1d80000: 0x4010000,
        0x1e80000: 0x4,
        0x1f80000: 0x10100
      }, {
        0x0: 0x80401000,
        0x10000: 0x80001040,
        0x20000: 0x401040,
        0x30000: 0x80400000,
        0x40000: 0x0,
        0x50000: 0x401000,
        0x60000: 0x80000040,
        0x70000: 0x400040,
        0x80000: 0x80000000,
        0x90000: 0x400000,
        0xa0000: 0x40,
        0xb0000: 0x80001000,
        0xc0000: 0x80400040,
        0xd0000: 0x1040,
        0xe0000: 0x1000,
        0xf0000: 0x80401040,
        0x8000: 0x80001040,
        0x18000: 0x40,
        0x28000: 0x80400040,
        0x38000: 0x80001000,
        0x48000: 0x401000,
        0x58000: 0x80401040,
        0x68000: 0x0,
        0x78000: 0x80400000,
        0x88000: 0x1000,
        0x98000: 0x80401000,
        0xa8000: 0x400000,
        0xb8000: 0x1040,
        0xc8000: 0x80000000,
        0xd8000: 0x400040,
        0xe8000: 0x401040,
        0xf8000: 0x80000040,
        0x100000: 0x400040,
        0x110000: 0x401000,
        0x120000: 0x80000040,
        0x130000: 0x0,
        0x140000: 0x1040,
        0x150000: 0x80400040,
        0x160000: 0x80401000,
        0x170000: 0x80001040,
        0x180000: 0x80401040,
        0x190000: 0x80000000,
        0x1a0000: 0x80400000,
        0x1b0000: 0x401040,
        0x1c0000: 0x80001000,
        0x1d0000: 0x400000,
        0x1e0000: 0x40,
        0x1f0000: 0x1000,
        0x108000: 0x80400000,
        0x118000: 0x80401040,
        0x128000: 0x0,
        0x138000: 0x401000,
        0x148000: 0x400040,
        0x158000: 0x80000000,
        0x168000: 0x80001040,
        0x178000: 0x40,
        0x188000: 0x80000040,
        0x198000: 0x1000,
        0x1a8000: 0x80001000,
        0x1b8000: 0x80400040,
        0x1c8000: 0x1040,
        0x1d8000: 0x80401000,
        0x1e8000: 0x400000,
        0x1f8000: 0x401040
      }, {
        0x0: 0x80,
        0x1000: 0x1040000,
        0x2000: 0x40000,
        0x3000: 0x20000000,
        0x4000: 0x20040080,
        0x5000: 0x1000080,
        0x6000: 0x21000080,
        0x7000: 0x40080,
        0x8000: 0x1000000,
        0x9000: 0x20040000,
        0xa000: 0x20000080,
        0xb000: 0x21040080,
        0xc000: 0x21040000,
        0xd000: 0x0,
        0xe000: 0x1040080,
        0xf000: 0x21000000,
        0x800: 0x1040080,
        0x1800: 0x21000080,
        0x2800: 0x80,
        0x3800: 0x1040000,
        0x4800: 0x40000,
        0x5800: 0x20040080,
        0x6800: 0x21040000,
        0x7800: 0x20000000,
        0x8800: 0x20040000,
        0x9800: 0x0,
        0xa800: 0x21040080,
        0xb800: 0x1000080,
        0xc800: 0x20000080,
        0xd800: 0x21000000,
        0xe800: 0x1000000,
        0xf800: 0x40080,
        0x10000: 0x40000,
        0x11000: 0x80,
        0x12000: 0x20000000,
        0x13000: 0x21000080,
        0x14000: 0x1000080,
        0x15000: 0x21040000,
        0x16000: 0x20040080,
        0x17000: 0x1000000,
        0x18000: 0x21040080,
        0x19000: 0x21000000,
        0x1a000: 0x1040000,
        0x1b000: 0x20040000,
        0x1c000: 0x40080,
        0x1d000: 0x20000080,
        0x1e000: 0x0,
        0x1f000: 0x1040080,
        0x10800: 0x21000080,
        0x11800: 0x1000000,
        0x12800: 0x1040000,
        0x13800: 0x20040080,
        0x14800: 0x20000000,
        0x15800: 0x1040080,
        0x16800: 0x80,
        0x17800: 0x21040000,
        0x18800: 0x40080,
        0x19800: 0x21040080,
        0x1a800: 0x0,
        0x1b800: 0x21000000,
        0x1c800: 0x1000080,
        0x1d800: 0x40000,
        0x1e800: 0x20040000,
        0x1f800: 0x20000080
      }, {
        0x0: 0x10000008,
        0x100: 0x2000,
        0x200: 0x10200000,
        0x300: 0x10202008,
        0x400: 0x10002000,
        0x500: 0x200000,
        0x600: 0x200008,
        0x700: 0x10000000,
        0x800: 0x0,
        0x900: 0x10002008,
        0xa00: 0x202000,
        0xb00: 0x8,
        0xc00: 0x10200008,
        0xd00: 0x202008,
        0xe00: 0x2008,
        0xf00: 0x10202000,
        0x80: 0x10200000,
        0x180: 0x10202008,
        0x280: 0x8,
        0x380: 0x200000,
        0x480: 0x202008,
        0x580: 0x10000008,
        0x680: 0x10002000,
        0x780: 0x2008,
        0x880: 0x200008,
        0x980: 0x2000,
        0xa80: 0x10002008,
        0xb80: 0x10200008,
        0xc80: 0x0,
        0xd80: 0x10202000,
        0xe80: 0x202000,
        0xf80: 0x10000000,
        0x1000: 0x10002000,
        0x1100: 0x10200008,
        0x1200: 0x10202008,
        0x1300: 0x2008,
        0x1400: 0x200000,
        0x1500: 0x10000000,
        0x1600: 0x10000008,
        0x1700: 0x202000,
        0x1800: 0x202008,
        0x1900: 0x0,
        0x1a00: 0x8,
        0x1b00: 0x10200000,
        0x1c00: 0x2000,
        0x1d00: 0x10002008,
        0x1e00: 0x10202000,
        0x1f00: 0x200008,
        0x1080: 0x8,
        0x1180: 0x202000,
        0x1280: 0x200000,
        0x1380: 0x10000008,
        0x1480: 0x10002000,
        0x1580: 0x2008,
        0x1680: 0x10202008,
        0x1780: 0x10200000,
        0x1880: 0x10202000,
        0x1980: 0x10200008,
        0x1a80: 0x2000,
        0x1b80: 0x202008,
        0x1c80: 0x200008,
        0x1d80: 0x0,
        0x1e80: 0x10000000,
        0x1f80: 0x10002008
      }, {
        0x0: 0x100000,
        0x10: 0x2000401,
        0x20: 0x400,
        0x30: 0x100401,
        0x40: 0x2100401,
        0x50: 0x0,
        0x60: 0x1,
        0x70: 0x2100001,
        0x80: 0x2000400,
        0x90: 0x100001,
        0xa0: 0x2000001,
        0xb0: 0x2100400,
        0xc0: 0x2100000,
        0xd0: 0x401,
        0xe0: 0x100400,
        0xf0: 0x2000000,
        0x8: 0x2100001,
        0x18: 0x0,
        0x28: 0x2000401,
        0x38: 0x2100400,
        0x48: 0x100000,
        0x58: 0x2000001,
        0x68: 0x2000000,
        0x78: 0x401,
        0x88: 0x100401,
        0x98: 0x2000400,
        0xa8: 0x2100000,
        0xb8: 0x100001,
        0xc8: 0x400,
        0xd8: 0x2100401,
        0xe8: 0x1,
        0xf8: 0x100400,
        0x100: 0x2000000,
        0x110: 0x100000,
        0x120: 0x2000401,
        0x130: 0x2100001,
        0x140: 0x100001,
        0x150: 0x2000400,
        0x160: 0x2100400,
        0x170: 0x100401,
        0x180: 0x401,
        0x190: 0x2100401,
        0x1a0: 0x100400,
        0x1b0: 0x1,
        0x1c0: 0x0,
        0x1d0: 0x2100000,
        0x1e0: 0x2000001,
        0x1f0: 0x400,
        0x108: 0x100400,
        0x118: 0x2000401,
        0x128: 0x2100001,
        0x138: 0x1,
        0x148: 0x2000000,
        0x158: 0x100000,
        0x168: 0x401,
        0x178: 0x2100400,
        0x188: 0x2000001,
        0x198: 0x2100000,
        0x1a8: 0x0,
        0x1b8: 0x2100401,
        0x1c8: 0x100401,
        0x1d8: 0x400,
        0x1e8: 0x2000400,
        0x1f8: 0x100001
      }, {
        0x0: 0x8000820,
        0x1: 0x20000,
        0x2: 0x8000000,
        0x3: 0x20,
        0x4: 0x20020,
        0x5: 0x8020820,
        0x6: 0x8020800,
        0x7: 0x800,
        0x8: 0x8020000,
        0x9: 0x8000800,
        0xa: 0x20800,
        0xb: 0x8020020,
        0xc: 0x820,
        0xd: 0x0,
        0xe: 0x8000020,
        0xf: 0x20820,
        0x80000000: 0x800,
        0x80000001: 0x8020820,
        0x80000002: 0x8000820,
        0x80000003: 0x8000000,
        0x80000004: 0x8020000,
        0x80000005: 0x20800,
        0x80000006: 0x20820,
        0x80000007: 0x20,
        0x80000008: 0x8000020,
        0x80000009: 0x820,
        0x8000000a: 0x20020,
        0x8000000b: 0x8020800,
        0x8000000c: 0x0,
        0x8000000d: 0x8020020,
        0x8000000e: 0x8000800,
        0x8000000f: 0x20000,
        0x10: 0x20820,
        0x11: 0x8020800,
        0x12: 0x20,
        0x13: 0x800,
        0x14: 0x8000800,
        0x15: 0x8000020,
        0x16: 0x8020020,
        0x17: 0x20000,
        0x18: 0x0,
        0x19: 0x20020,
        0x1a: 0x8020000,
        0x1b: 0x8000820,
        0x1c: 0x8020820,
        0x1d: 0x20800,
        0x1e: 0x820,
        0x1f: 0x8000000,
        0x80000010: 0x20000,
        0x80000011: 0x800,
        0x80000012: 0x8020020,
        0x80000013: 0x20820,
        0x80000014: 0x20,
        0x80000015: 0x8020000,
        0x80000016: 0x8000000,
        0x80000017: 0x8000820,
        0x80000018: 0x8020820,
        0x80000019: 0x8000020,
        0x8000001a: 0x8000800,
        0x8000001b: 0x0,
        0x8000001c: 0x20800,
        0x8000001d: 0x820,
        0x8000001e: 0x20020,
        0x8000001f: 0x8020800
      }]; // Masks that select the SBOX input

      var SBOX_MASK = [0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000, 0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f];
      /**
       * DES block cipher algorithm.
       */

      var DES = C_algo.DES = BlockCipher.extend({
        _doReset: function _doReset() {
          // Shortcuts
          var key = this._key;
          var keyWords = key.words; // Select 56 bits according to PC1

          var keyBits = [];

          for (var i = 0; i < 56; i++) {
            var keyBitPos = PC1[i] - 1;
            keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
          } // Assemble 16 subkeys


          var subKeys = this._subKeys = [];

          for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
            // Create subkey
            var subKey = subKeys[nSubKey] = []; // Shortcut

            var bitShift = BIT_SHIFTS[nSubKey]; // Select 48 bits according to PC2

            for (var i = 0; i < 24; i++) {
              // Select from the left 28 key bits
              subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6; // Select from the right 28 key bits

              subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
            } // Since each subkey is applied to an expanded 32-bit input,
            // the subkey can be broken into 8 values scaled to 32-bits,
            // which allows the key to be used without expansion


            subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;

            for (var i = 1; i < 7; i++) {
              subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
            }

            subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
          } // Compute inverse subkeys


          var invSubKeys = this._invSubKeys = [];

          for (var i = 0; i < 16; i++) {
            invSubKeys[i] = subKeys[15 - i];
          }
        },
        encryptBlock: function encryptBlock(M, offset) {
          this._doCryptBlock(M, offset, this._subKeys);
        },
        decryptBlock: function decryptBlock(M, offset) {
          this._doCryptBlock(M, offset, this._invSubKeys);
        },
        _doCryptBlock: function _doCryptBlock(M, offset, subKeys) {
          // Get input
          this._lBlock = M[offset];
          this._rBlock = M[offset + 1]; // Initial permutation

          exchangeLR.call(this, 4, 0x0f0f0f0f);
          exchangeLR.call(this, 16, 0x0000ffff);
          exchangeRL.call(this, 2, 0x33333333);
          exchangeRL.call(this, 8, 0x00ff00ff);
          exchangeLR.call(this, 1, 0x55555555); // Rounds

          for (var round = 0; round < 16; round++) {
            // Shortcuts
            var subKey = subKeys[round];
            var lBlock = this._lBlock;
            var rBlock = this._rBlock; // Feistel function

            var f = 0;

            for (var i = 0; i < 8; i++) {
              f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
            }

            this._lBlock = rBlock;
            this._rBlock = lBlock ^ f;
          } // Undo swap from last round


          var t = this._lBlock;
          this._lBlock = this._rBlock;
          this._rBlock = t; // Final permutation

          exchangeLR.call(this, 1, 0x55555555);
          exchangeRL.call(this, 8, 0x00ff00ff);
          exchangeRL.call(this, 2, 0x33333333);
          exchangeLR.call(this, 16, 0x0000ffff);
          exchangeLR.call(this, 4, 0x0f0f0f0f); // Set output

          M[offset] = this._lBlock;
          M[offset + 1] = this._rBlock;
        },
        keySize: 64 / 32,
        ivSize: 64 / 32,
        blockSize: 64 / 32
      }); // Swap bits across the left and right words

      function exchangeLR(offset, mask) {
        var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
        this._rBlock ^= t;
        this._lBlock ^= t << offset;
      }

      function exchangeRL(offset, mask) {
        var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
        this._lBlock ^= t;
        this._rBlock ^= t << offset;
      }
      /**
       * Shortcut functions to the cipher's object interface.
       *
       * @example
       *
       *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
       *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
       */


      C.DES = BlockCipher._createHelper(DES);
      /**
       * Triple-DES block cipher algorithm.
       */

      var TripleDES = C_algo.TripleDES = BlockCipher.extend({
        _doReset: function _doReset() {
          // Shortcuts
          var key = this._key;
          var keyWords = key.words; // Create DES instances

          this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
          this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
          this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
        },
        encryptBlock: function encryptBlock(M, offset) {
          this._des1.encryptBlock(M, offset);

          this._des2.decryptBlock(M, offset);

          this._des3.encryptBlock(M, offset);
        },
        decryptBlock: function decryptBlock(M, offset) {
          this._des3.decryptBlock(M, offset);

          this._des2.encryptBlock(M, offset);

          this._des1.decryptBlock(M, offset);
        },
        keySize: 192 / 32,
        ivSize: 64 / 32,
        blockSize: 64 / 32
      });
      /**
       * Shortcut functions to the cipher's object interface.
       *
       * @example
       *
       *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
       *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
       */

      C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();

    return CryptoJS.TripleDES;
  });
  /***/

},
/* 494 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (Buffer, process) {
    var stream = __webpack_require__(63);

    var eos = __webpack_require__(200);

    var inherits = __webpack_require__(37);

    var shift = __webpack_require__(596);

    var SIGNAL_FLUSH = Buffer.from && Buffer.from !== Uint8Array.from ? Buffer.from([0]) : new Buffer([0]);

    var onuncork = function onuncork(self, fn) {
      if (self._corked) self.once('uncork', fn);else fn();
    };

    var destroyer = function destroyer(self, end) {
      return function (err) {
        if (err) self._destroyInterval(err);else if (end && !self._ended) self.end();
      };
    };

    var end = function end(ws, fn) {
      if (!ws) return fn();
      if (ws._writableState && ws._writableState.finished) return fn();
      if (ws._writableState) return ws.end(fn);
      ws.end();
      fn();
    };

    var toStreams2 = function toStreams2(rs) {
      return new stream.Readable({
        objectMode: true,
        highWaterMark: 16
      }).wrap(rs);
    };

    var Duplexify = function Duplexify(writable, readable, opts) {
      if (!(this instanceof Duplexify)) return new Duplexify(writable, readable, opts);
      stream.Duplex.call(this, opts);
      this._writable = null;
      this._readable = null;
      this._readable2 = null;
      this._forwardDestroy = !opts || opts.destroy !== false;
      this._forwardEnd = !opts || opts.end !== false;
      this._corked = 1; // start corked

      this._ondrain = null;
      this._drained = false;
      this._forwarding = false;
      this._unwrite = null;
      this._unread = null;
      this._ended = false;
      this._error = null;
      this._preferError = false;
      this.destroyed = false;
      if (writable) this.setWritable(writable);
      if (readable) this.setReadable(readable);
    };

    inherits(Duplexify, stream.Duplex);

    Duplexify.obj = function (writable, readable, opts) {
      if (!opts) opts = {};
      opts.objectMode = true;
      opts.highWaterMark = 16;
      return new Duplexify(writable, readable, opts);
    };

    Duplexify.prototype.cork = function () {
      if (++this._corked === 1) this.emit('cork');
    };

    Duplexify.prototype.uncork = function () {
      if (this._corked && --this._corked === 0) this.emit('uncork');
    };

    Duplexify.prototype.setWritable = function (writable) {
      if (this._unwrite) this._unwrite();

      if (this.destroyed) {
        if (writable && writable.destroy) writable.destroy();
        return;
      }

      if (writable === null || writable === false) {
        this.end();
        return;
      }

      var self = this;
      var unend = eos(writable, {
        writable: true,
        readable: false
      }, destroyer(this, this._forwardEnd));

      var ondrain = function ondrain() {
        var ondrain = self._ondrain;
        self._ondrain = null;
        if (ondrain) ondrain();
      };

      var clear = function clear() {
        self._writable.removeListener('drain', ondrain);

        unend();
      };

      if (this._unwrite) process.nextTick(ondrain); // force a drain on stream reset to avoid livelocks

      this._writable = writable;

      this._writable.on('drain', ondrain);

      this._unwrite = clear;
      this.uncork(); // always uncork setWritable
    };

    Duplexify.prototype.setReadable = function (readable) {
      if (this._unread) this._unread();

      if (this.destroyed) {
        if (readable && readable.destroy) readable.destroy();
        return;
      }

      if (readable === null || readable === false) {
        this.push(null);
        this.resume();
        return;
      }

      var self = this;
      var unend = eos(readable, {
        writable: false,
        readable: true
      }, destroyer(this));

      var onreadable = function onreadable() {
        self._forward();
      };

      var onend = function onend() {
        self.push(null);
      };

      var clear = function clear() {
        self._readable2.removeListener('readable', onreadable);

        self._readable2.removeListener('end', onend);

        unend();
      };

      this._drained = true;
      this._readable = readable;
      this._readable2 = readable._readableState ? readable : toStreams2(readable);

      this._readable2.on('readable', onreadable);

      this._readable2.on('end', onend);

      this._unread = clear;

      this._forward();
    };

    Duplexify.prototype._read = function () {
      this._drained = true;

      this._forward();
    };

    Duplexify.prototype._forward = function () {
      if (this._forwarding || !this._readable2 || !this._drained) return;
      this._forwarding = true;
      var data;

      while (this._drained && (data = shift(this._readable2)) !== null) {
        if (this.destroyed) continue;
        this._drained = this.push(data);
      }

      this._forwarding = false;
    };

    Duplexify.prototype.destroy = function (err) {
      if (this._preferError && !this._error && err) this._error = err;
      if (this.destroyed) return;
      this.destroyed = true;
      var self = this;
      process.nextTick(function () {
        self._destroy(self._preferError ? self._error : err);
      });
    };

    Duplexify.prototype._destroyInterval = function (err) {
      if (this.destroyed) return;
      if (err.message !== 'premature close') return this.destroy(err);
      this._preferError = true;
      this.destroy(null);
    };

    Duplexify.prototype._destroy = function (err) {
      if (err) {
        var ondrain = this._ondrain;
        this._ondrain = null;
        if (ondrain) ondrain(err);else this.emit('error', err);
      }

      if (this._forwardDestroy) {
        if (this._readable && this._readable.destroy) this._readable.destroy();
        if (this._writable && this._writable.destroy) this._writable.destroy();
      }

      this.emit('close');
    };

    Duplexify.prototype._write = function (data, enc, cb) {
      if (this.destroyed) return cb();
      if (this._corked) return onuncork(this, this._write.bind(this, data, enc, cb));
      if (data === SIGNAL_FLUSH) return this._finish(cb);
      if (!this._writable) return cb();
      if (this._writable.write(data) === false) this._ondrain = cb;else cb();
    };

    Duplexify.prototype._finish = function (cb) {
      var self = this;
      this.emit('preend');
      onuncork(this, function () {
        end(self._forwardEnd && self._writable, function () {
          // haxx to not emit prefinish twice
          if (self._writableState.prefinished === false) self._writableState.prefinished = true;
          self.emit('prefinish');
          onuncork(self, cb);
        });
      });
    };

    Duplexify.prototype.end = function (data, enc, cb) {
      if (typeof data === 'function') return this.end(null, null, data);
      if (typeof enc === 'function') return this.end(data, null, enc);
      this._ended = true;
      if (data) this.write(data);
      if (!this._writableState.ending) this.write(SIGNAL_FLUSH);
      return stream.Writable.prototype.end.call(this, cb);
    };

    module.exports = Duplexify;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer, __webpack_require__(16));
  /***/
},
/* 495 */

/***/
function (module, exports) {
  exports.read = function (buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;

    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;

    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : (s ? -1 : 1) * Infinity;
    } else {
      m = m + Math.pow(2, mLen);
      e = e - eBias;
    }

    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
  };

  exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);

    if (isNaN(value) || value === Infinity) {
      m = isNaN(value) ? 1 : 0;
      e = eMax;
    } else {
      e = Math.floor(Math.log(value) / Math.LN2);

      if (value * (c = Math.pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }

      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * Math.pow(2, 1 - eBias);
      }

      if (value * c >= 2) {
        e++;
        c /= 2;
      }

      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * Math.pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
        e = 0;
      }
    }

    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

    e = e << mLen | m;
    eLen += mLen;

    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

    buffer[offset + i - d] |= s * 128;
  };
  /***/

},
/* 496 */

/***/
function (module, exports) {
  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;
  /** Used as references for the maximum length and index of an array. */

  var MAX_ARRAY_LENGTH = 4294967295;
  /** `Object#toString` result references. */

  var funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      symbolTag = '[object Symbol]';
  /** Used to match leading and trailing whitespace. */

  var reTrim = /^\s+|\s+$/g;
  /** Used to detect bad signed hexadecimal string values. */

  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  /** Used to detect binary string values. */

  var reIsBinary = /^0b[01]+$/i;
  /** Used to detect octal string values. */

  var reIsOctal = /^0o[0-7]+$/i;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /** Built-in method references without a dependency on `root`. */

  var freeParseInt = parseInt;
  /** Used for built-in method references. */

  var objectProto = Object.prototype;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var objectToString = objectProto.toString;
  /**
   * The base implementation of `_.clamp` which doesn't coerce arguments.
   *
   * @private
   * @param {number} number The number to clamp.
   * @param {number} [lower] The lower bound.
   * @param {number} upper The upper bound.
   * @returns {number} Returns the clamped number.
   */

  function baseClamp(number, lower, upper) {
    if (number === number) {
      if (upper !== undefined) {
        number = number <= upper ? number : upper;
      }

      if (lower !== undefined) {
        number = number >= lower ? number : lower;
      }
    }

    return number;
  }
  /**
   * The base implementation of `_.fill` without an iteratee call guard.
   *
   * @private
   * @param {Array} array The array to fill.
   * @param {*} value The value to fill `array` with.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns `array`.
   */


  function baseFill(array, value, start, end) {
    var length = array.length;
    start = toInteger(start);

    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }

    end = end === undefined || end > length ? length : toInteger(end);

    if (end < 0) {
      end += length;
    }

    end = start > end ? 0 : toLength(end);

    while (start < end) {
      array[start++] = value;
    }

    return array;
  }
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */


  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */


  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }

    var type = typeof index;

    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
      return eq(object[index], value);
    }

    return false;
  }
  /**
   * Fills elements of `array` with `value` from `start` up to, but not
   * including, `end`.
   *
   * **Note:** This method mutates `array`.
   *
   * @static
   * @memberOf _
   * @since 3.2.0
   * @category Array
   * @param {Array} array The array to fill.
   * @param {*} value The value to fill `array` with.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns `array`.
   * @example
   *
   * var array = [1, 2, 3];
   *
   * _.fill(array, 'a');
   * console.log(array);
   * // => ['a', 'a', 'a']
   *
   * _.fill(Array(3), 2);
   * // => [2, 2, 2]
   *
   * _.fill([4, 6, 8, 10], '*', 1, 3);
   * // => [4, '*', '*', 10]
   */


  function fill(array, value, start, end) {
    var length = array ? array.length : 0;

    if (!length) {
      return [];
    }

    if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
      start = 0;
      end = length;
    }

    return baseFill(array, value, start, end);
  }
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */


  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */


  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */


  function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
  }
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */


  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }
  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */


  function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
  }
  /**
   * Converts `value` to a finite number.
   *
   * @static
   * @memberOf _
   * @since 4.12.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted number.
   * @example
   *
   * _.toFinite(3.2);
   * // => 3.2
   *
   * _.toFinite(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toFinite(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toFinite('3.2');
   * // => 3.2
   */


  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }

    value = toNumber(value);

    if (value === INFINITY || value === -INFINITY) {
      var sign = value < 0 ? -1 : 1;
      return sign * MAX_INTEGER;
    }

    return value === value ? value : 0;
  }
  /**
   * Converts `value` to an integer.
   *
   * **Note:** This method is loosely based on
   * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted integer.
   * @example
   *
   * _.toInteger(3.2);
   * // => 3
   *
   * _.toInteger(Number.MIN_VALUE);
   * // => 0
   *
   * _.toInteger(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toInteger('3.2');
   * // => 3
   */


  function toInteger(value) {
    var result = toFinite(value),
        remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
  }
  /**
   * Converts `value` to an integer suitable for use as the length of an
   * array-like object.
   *
   * **Note:** This method is based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted integer.
   * @example
   *
   * _.toLength(3.2);
   * // => 3
   *
   * _.toLength(Number.MIN_VALUE);
   * // => 0
   *
   * _.toLength(Infinity);
   * // => 4294967295
   *
   * _.toLength('3.2');
   * // => 3
   */


  function toLength(value) {
    return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
  }
  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */


  function toNumber(value) {
    if (typeof value == 'number') {
      return value;
    }

    if (isSymbol(value)) {
      return NAN;
    }

    if (isObject(value)) {
      var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
      value = isObject(other) ? other + '' : other;
    }

    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }

    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }

  module.exports = fill;
  /***/
},
/* 497 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
    * lodash (Custom Build) <https://lodash.com/>
    * Build: `lodash modularize exports="npm" -o ./`
    * Copyright jQuery Foundation and other contributors <https://jquery.org/>
    * Released under MIT license <https://lodash.com/license>
    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    */

    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER = 9007199254740991;
    /** `Object#toString` result references. */

    var argsTag = '[object Arguments]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]';
    /** Detect free variable `global` from Node.js. */

    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */

    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */

    var root = freeGlobal || freeSelf || Function('return this')();
    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */

    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }

      return array;
    }
    /** Used for built-in method references. */


    var objectProto = Object.prototype;
    /** Used to check objects for own properties. */

    var hasOwnProperty = objectProto.hasOwnProperty;
    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */

    var objectToString = objectProto.toString;
    /** Built-in value references. */

    var Symbol = root.Symbol,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */

    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;
      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];

        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }

      return result;
    }
    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */


    function isFlattenable(value) {
      return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
    }
    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */


    function flatten(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, 1) : [];
    }
    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */


    function isArguments(value) {
      // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
    }
    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */


    var isArray = Array.isArray;
    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */

    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */


    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */


    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8-9 which returns 'object' for typed array and other constructors.
      var tag = isObject(value) ? objectToString.call(value) : '';
      return tag == funcTag || tag == genTag;
    }
    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */


    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */


    function isObject(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */


    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }

    module.exports = flatten;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10));
  /***/
},
/* 498 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
    * lodash (Custom Build) <https://lodash.com/>
    * Build: `lodash modularize exports="npm" -o ./`
    * Copyright jQuery Foundation and other contributors <https://jquery.org/>
    * Released under MIT license <https://lodash.com/license>
    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    */

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as references for various `Number` constants. */

    var MAX_SAFE_INTEGER = 9007199254740991;
    /** `Object#toString` result references. */

    var funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]';
    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */

    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to detect host constructors (Safari). */

    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Detect free variable `global` from Node.js. */

    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */

    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */

    var root = freeGlobal || freeSelf || Function('return this')();
    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */

    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);

        case 1:
          return func.call(thisArg, args[0]);

        case 2:
          return func.call(thisArg, args[0], args[1]);

        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }

      return func.apply(thisArg, args);
    }
    /**
     * A specialized version of `_.includes` for arrays without support for
     * specifying an index to search from.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */


    function arrayIncludes(array, value) {
      var length = array ? array.length : 0;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
     * This function is like `arrayIncludes` except that it accepts a comparator.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */


    function arrayIncludesWith(array, value, comparator) {
      var index = -1,
          length = array ? array.length : 0;

      while (++index < length) {
        if (comparator(value, array[index])) {
          return true;
        }
      }

      return false;
    }
    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */


    function arrayMap(array, iteratee) {
      var index = -1,
          length = array ? array.length : 0,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }

      return result;
    }
    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
          index = fromIndex + (fromRight ? 1 : -1);

      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function baseIndexOf(array, value, fromIndex) {
      if (value !== value) {
        return baseFindIndex(array, baseIsNaN, fromIndex);
      }

      var index = fromIndex - 1,
          length = array.length;

      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */


    function baseIsNaN(value) {
      return value !== value;
    }
    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */


    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }
    /**
     * Checks if a cache value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function cacheHas(cache, key) {
      return cache.has(key);
    }
    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */


    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }
    /**
     * Checks if `value` is a host object in IE < 9.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
     */


    function isHostObject(value) {
      // Many host objects are `Object` objects that can coerce to strings
      // despite having improperly defined `toString` methods.
      var result = false;

      if (value != null && typeof value.toString != 'function') {
        try {
          result = !!(value + '');
        } catch (e) {}
      }

      return result;
    }
    /** Used for built-in method references. */


    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;
    /** Used to detect overreaching core-js shims. */

    var coreJsData = root['__core-js_shared__'];
    /** Used to detect methods masquerading as native. */

    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();
    /** Used to resolve the decompiled source of functions. */


    var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */

    var hasOwnProperty = objectProto.hasOwnProperty;
    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */

    var objectToString = objectProto.toString;
    /** Used to detect if a method is native. */

    var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    /** Built-in value references. */

    var splice = arrayProto.splice;
    /* Built-in method references for those with the same name as other `lodash` methods. */

    var nativeMax = Math.max,
        nativeMin = Math.min;
    /* Built-in method references that are verified to be native. */

    var Map = getNative(root, 'Map'),
        nativeCreate = getNative(Object, 'create');
    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function Hash(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */


    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function hashDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }
    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function hashGet(key) {
      var data = this.__data__;

      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }

      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */


    function hashSet(key, value) {
      var data = this.__data__;
      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
      return this;
    } // Add methods to `Hash`.


    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function ListCache(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */


    function listCacheClear() {
      this.__data__ = [];
    }
    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }

      var lastIndex = data.length - 1;

      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }

      return true;
    }
    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);
      return index < 0 ? undefined : data[index][1];
    }
    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */


    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }

      return this;
    } // Add methods to `ListCache`.


    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function MapCache(entries) {
      var index = -1,
          length = entries ? entries.length : 0;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */


    function mapCacheClear() {
      this.__data__ = {
        'hash': new Hash(),
        'map': new (Map || ListCache)(),
        'string': new Hash()
      };
    }
    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function mapCacheDelete(key) {
      return getMapData(this, key)['delete'](key);
    }
    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */


    function mapCacheSet(key, value) {
      getMapData(this, key).set(key, value);
      return this;
    } // Add methods to `MapCache`.


    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */

    function SetCache(values) {
      var index = -1,
          length = values ? values.length : 0;
      this.__data__ = new MapCache();

      while (++index < length) {
        this.add(values[index]);
      }
    }
    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */


    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);

      return this;
    }
    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */


    function setCacheHas(value) {
      return this.__data__.has(value);
    } // Add methods to `SetCache`.


    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */

    function assocIndexOf(array, key) {
      var length = array.length;

      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }

      return -1;
    }
    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */


    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];

        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }

        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
      }

      array = arrays[0];
      var index = -1,
          seen = caches[0];

      outer: while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;

        if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
          othIndex = othLength;

          while (--othIndex) {
            var cache = caches[othIndex];

            if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
              continue outer;
            }
          }

          if (seen) {
            seen.push(computed);
          }

          result.push(value);
        }
      }

      return result;
    }
    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */


    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }

      var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */


    function baseRest(func, start) {
      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
      return function () {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }

        index = -1;
        var otherArgs = Array(start + 1);

        while (++index < start) {
          otherArgs[index] = args[index];
        }

        otherArgs[start] = array;
        return apply(func, this, otherArgs);
      };
    }
    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */


    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }
    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */


    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */


    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }
    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */


    function isKeyable(value) {
      var type = typeof value;
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */


    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to process.
     * @returns {string} Returns the source code.
     */


    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}

        try {
          return func + '';
        } catch (e) {}
      }

      return '';
    }
    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order of result values is determined by the
     * order they occur in the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */


    var intersection = baseRest(function (arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
    });
    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */

    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */


    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */


    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */


    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8-9 which returns 'object' for typed array and other constructors.
      var tag = isObject(value) ? objectToString.call(value) : '';
      return tag == funcTag || tag == genTag;
    }
    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */


    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */


    function isObject(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */


    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }

    module.exports = intersection;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10));
  /***/
},
/* 499 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global, module) {
    /**
    * Lodash (Custom Build) <https://lodash.com/>
    * Build: `lodash modularize exports="npm" -o ./`
    * Copyright JS Foundation and other contributors <https://js.foundation/>
    * Released under MIT license <https://lodash.com/license>
    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    */

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;
    /** Used to stand-in for `undefined` hash values. */

    var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */

    var HOT_COUNT = 800,
        HOT_SPAN = 16;
    /** Used as references for various `Number` constants. */

    var MAX_SAFE_INTEGER = 9007199254740991;
    /** `Object#toString` result references. */

    var argsTag = '[object Arguments]',
        arrayTag = '[object Array]',
        asyncTag = '[object AsyncFunction]',
        boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        errorTag = '[object Error]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        nullTag = '[object Null]',
        objectTag = '[object Object]',
        proxyTag = '[object Proxy]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        undefinedTag = '[object Undefined]',
        weakMapTag = '[object WeakMap]';
    var arrayBufferTag = '[object ArrayBuffer]',
        dataViewTag = '[object DataView]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';
    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */

    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to detect host constructors (Safari). */

    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect unsigned integer values. */

    var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to identify `toStringTag` values of typed arrays. */

    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Detect free variable `global` from Node.js. */

    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */

    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */

    var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */

    var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */

    var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */

    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */

    var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */

    var nodeUtil = function () {
      try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();
    /* Node.js helper references. */


    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */

    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);

        case 1:
          return func.call(thisArg, args[0]);

        case 2:
          return func.call(thisArg, args[0], args[1]);

        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }

      return func.apply(thisArg, args);
    }
    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */


    function baseTimes(n, iteratee) {
      var index = -1,
          result = Array(n);

      while (++index < n) {
        result[index] = iteratee(index);
      }

      return result;
    }
    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */


    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }
    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */


    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }
    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */


    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }
    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */


    function safeGet(object, key) {
      return key == '__proto__' ? undefined : object[key];
    }
    /** Used for built-in method references. */


    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;
    /** Used to detect overreaching core-js shims. */

    var coreJsData = root['__core-js_shared__'];
    /** Used to resolve the decompiled source of functions. */

    var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */

    var hasOwnProperty = objectProto.hasOwnProperty;
    /** Used to detect methods masquerading as native. */

    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();
    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */


    var nativeObjectToString = objectProto.toString;
    /** Used to infer the `Object` constructor. */

    var objectCtorString = funcToString.call(Object);
    /** Used to detect if a method is native. */

    var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    /** Built-in value references. */

    var Buffer = moduleExports ? root.Buffer : undefined,
        Symbol = root.Symbol,
        Uint8Array = root.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = function () {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }();
    /* Built-in method references for those with the same name as other `lodash` methods. */


    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeMax = Math.max,
        nativeNow = Date.now;
    /* Built-in method references that are verified to be native. */

    var Map = getNative(root, 'Map'),
        nativeCreate = getNative(Object, 'create');
    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */

    var baseCreate = function () {
      function object() {}

      return function (proto) {
        if (!isObject(proto)) {
          return {};
        }

        if (objectCreate) {
          return objectCreate(proto);
        }

        object.prototype = proto;
        var result = new object();
        object.prototype = undefined;
        return result;
      };
    }();
    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */


    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */


    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function hashGet(key) {
      var data = this.__data__;

      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }

      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */


    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
      return this;
    } // Add methods to `Hash`.


    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */


    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }

      var lastIndex = data.length - 1;

      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }

      --this.size;
      return true;
    }
    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);
      return index < 0 ? undefined : data[index][1];
    }
    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */


    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }

      return this;
    } // Add methods to `ListCache`.


    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;
      this.clear();

      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */


    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash(),
        'map': new (Map || ListCache)(),
        'string': new Hash()
      };
    }
    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */


    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    } // Add methods to `MapCache`.


    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */

    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */


    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */


    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);
      this.size = data.size;
      return result;
    }
    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */


    function stackGet(key) {
      return this.__data__.get(key);
    }
    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */


    function stackHas(key) {
      return this.__data__.has(key);
    }
    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */


    function stackSet(key, value) {
      var data = this.__data__;

      if (data instanceof ListCache) {
        var pairs = data.__data__;

        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }

        data = this.__data__ = new MapCache(pairs);
      }

      data.set(key, value);
      this.size = data.size;
      return this;
    } // Add methods to `Stack`.


    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */

    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
        key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }

      return result;
    }
    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */


    function assignMergeValue(object, key, value) {
      if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */


    function assignValue(object, key, value) {
      var objValue = object[key];

      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function assocIndexOf(array, key) {
      var length = array.length;

      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */


    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }
    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */


    var baseFor = createBaseFor();
    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */

    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }

      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */


    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */


    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }

      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */


    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */


    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }

      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }

      return result;
    }
    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */


    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }

      baseFor(source, function (srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack());
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        } else {
          var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }

          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }
    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */


    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }

      var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;

        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          } else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          } else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          } else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          } else {
            newValue = [];
          }
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;

          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          } else if (!isObject(objValue) || srcIndex && isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        } else {
          isCommon = false;
        }
      }

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }

      assignMergeValue(object, key, newValue);
    }
    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */


    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }
    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */


    var baseSetToString = !defineProperty ? identity : function (func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };
    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */

    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }

      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */


    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }
    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */


    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */


    function copyArray(source, array) {
      var index = -1,
          length = source.length;
      array || (array = Array(length));

      while (++index < length) {
        array[index] = source[index];
      }

      return array;
    }
    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */


    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }

        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }

      return object;
    }
    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */


    function createAssigner(assigner) {
      return baseRest(function (object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }

        object = Object(object);

        while (++index < length) {
          var source = sources[index];

          if (source) {
            assigner(object, source, index, customizer);
          }
        }

        return object;
      });
    }
    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */


    function createBaseFor(fromRight) {
      return function (object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];

          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }

        return object;
      };
    }
    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */


    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */


    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }
    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */


    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);

      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }

      return result;
    }
    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */


    function initCloneObject(object) {
      return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }
    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */


    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */


    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }

      var type = typeof index;

      if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
        return eq(object[index], value);
      }

      return false;
    }
    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */


    function isKeyable(value) {
      var type = typeof value;
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */


    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */


    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
      return value === proto;
    }
    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */


    function nativeKeysIn(object) {
      var result = [];

      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }

      return result;
    }
    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */


    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */


    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
      return function () {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }

        index = -1;
        var otherArgs = Array(start + 1);

        while (++index < start) {
          otherArgs[index] = args[index];
        }

        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */


    var setToString = shortOut(baseSetToString);
    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */

    function shortOut(func) {
      var count = 0,
          lastCalled = 0;
      return function () {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;

        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }

        return func.apply(undefined, arguments);
      };
    }
    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */


    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}

        try {
          return func + '';
        } catch (e) {}
      }

      return '';
    }
    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */


    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */


    var isArguments = baseIsArguments(function () {
      return arguments;
    }()) ? baseIsArguments : function (value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    };
    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */

    var isArray = Array.isArray;
    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */

    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */


    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */


    var isBuffer = nativeIsBuffer || stubFalse;
    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */

    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      } // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.


      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */


    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */


    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */


    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }
    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */


    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }

      var proto = getPrototype(value);

      if (proto === null) {
        return true;
      }

      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */


    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */

    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }
    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */


    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }
    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */


    var merge = createAssigner(function (object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });
    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */

    function constant(value) {
      return function () {
        return value;
      };
    }
    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */


    function identity(value) {
      return value;
    }
    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */


    function stubFalse() {
      return false;
    }

    module.exports = merge;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10), __webpack_require__(84)(module));
  /***/
},
/* 500 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
    * lodash (Custom Build) <https://lodash.com/>
    * Build: `lodash modularize exports="npm" -o ./`
    * Copyright jQuery Foundation and other contributors <https://jquery.org/>
    * Released under MIT license <https://lodash.com/license>
    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    */

    /** Used as the `TypeError` message for "Functions" methods. */
    var FUNC_ERROR_TEXT = 'Expected a function';
    /** Used as the internal argument placeholder. */

    var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for function metadata. */

    var BIND_FLAG = 1,
        BIND_KEY_FLAG = 2,
        CURRY_BOUND_FLAG = 4,
        CURRY_FLAG = 8,
        CURRY_RIGHT_FLAG = 16,
        PARTIAL_FLAG = 32,
        PARTIAL_RIGHT_FLAG = 64,
        ARY_FLAG = 128,
        REARG_FLAG = 256,
        FLIP_FLAG = 512;
    /** Used as references for various `Number` constants. */

    var INFINITY = 1 / 0,
        MAX_SAFE_INTEGER = 9007199254740991,
        MAX_INTEGER = 1.7976931348623157e+308,
        NAN = 0 / 0;
    /** Used to associate wrap methods with their bit flags. */

    var wrapFlags = [['ary', ARY_FLAG], ['bind', BIND_FLAG], ['bindKey', BIND_KEY_FLAG], ['curry', CURRY_FLAG], ['curryRight', CURRY_RIGHT_FLAG], ['flip', FLIP_FLAG], ['partial', PARTIAL_FLAG], ['partialRight', PARTIAL_RIGHT_FLAG], ['rearg', REARG_FLAG]];
    /** `Object#toString` result references. */

    var funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        symbolTag = '[object Symbol]';
    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */

    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to match leading and trailing whitespace. */

    var reTrim = /^\s+|\s+$/g;
    /** Used to match wrap detail comments. */

    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
        reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
        reSplitDetails = /,? & /;
    /** Used to detect bad signed hexadecimal string values. */

    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */

    var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */

    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */

    var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */

    var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Built-in method references without a dependency on `root`. */

    var freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */

    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */

    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */

    var root = freeGlobal || freeSelf || Function('return this')();
    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */

    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);

        case 1:
          return func.call(thisArg, args[0]);

        case 2:
          return func.call(thisArg, args[0], args[1]);

        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }

      return func.apply(thisArg, args);
    }
    /**
     * A specialized version of `_.forEach` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */


    function arrayEach(array, iteratee) {
      var index = -1,
          length = array ? array.length : 0;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }

      return array;
    }
    /**
     * A specialized version of `_.includes` for arrays without support for
     * specifying an index to search from.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */


    function arrayIncludes(array, value) {
      var length = array ? array.length : 0;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
          index = fromIndex + (fromRight ? 1 : -1);

      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */


    function baseIndexOf(array, value, fromIndex) {
      if (value !== value) {
        return baseFindIndex(array, baseIsNaN, fromIndex);
      }

      var index = fromIndex - 1,
          length = array.length;

      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }

      return -1;
    }
    /**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */


    function baseIsNaN(value) {
      return value !== value;
    }
    /**
     * Gets the number of `placeholder` occurrences in `array`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} placeholder The placeholder to search for.
     * @returns {number} Returns the placeholder count.
     */


    function countHolders(array, placeholder) {
      var length = array.length,
          result = 0;

      while (length--) {
        if (array[length] === placeholder) {
          result++;
        }
      }

      return result;
    }
    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */


    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }
    /**
     * Checks if `value` is a host object in IE < 9.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
     */


    function isHostObject(value) {
      // Many host objects are `Object` objects that can coerce to strings
      // despite having improperly defined `toString` methods.
      var result = false;

      if (value != null && typeof value.toString != 'function') {
        try {
          result = !!(value + '');
        } catch (e) {}
      }

      return result;
    }
    /**
     * Replaces all `placeholder` elements in `array` with an internal placeholder
     * and returns an array of their indexes.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {*} placeholder The placeholder to replace.
     * @returns {Array} Returns the new array of placeholder indexes.
     */


    function replaceHolders(array, placeholder) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];

        if (value === placeholder || value === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result[resIndex++] = index;
        }
      }

      return result;
    }
    /** Used for built-in method references. */


    var funcProto = Function.prototype,
        objectProto = Object.prototype;
    /** Used to detect overreaching core-js shims. */

    var coreJsData = root['__core-js_shared__'];
    /** Used to detect methods masquerading as native. */

    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();
    /** Used to resolve the decompiled source of functions. */


    var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */

    var hasOwnProperty = objectProto.hasOwnProperty;
    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */

    var objectToString = objectProto.toString;
    /** Used to detect if a method is native. */

    var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    /** Built-in value references. */

    var objectCreate = Object.create;
    /* Built-in method references for those with the same name as other `lodash` methods. */

    var nativeMax = Math.max,
        nativeMin = Math.min;
    /* Used to set `toString` methods. */

    var defineProperty = function () {
      var func = getNative(Object, 'defineProperty'),
          name = getNative.name;
      return name && name.length > 2 ? func : undefined;
    }();
    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */


    function baseCreate(proto) {
      return isObject(proto) ? objectCreate(proto) : {};
    }
    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */


    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }

      var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */


    function baseRest(func, start) {
      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
      return function () {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }

        index = -1;
        var otherArgs = Array(start + 1);

        while (++index < start) {
          otherArgs[index] = args[index];
        }

        otherArgs[start] = array;
        return apply(func, this, otherArgs);
      };
    }
    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */


    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }

      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }

      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }

      return result;
    }
    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */


    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }

      var offset = argsIndex;

      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }

      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }

      return result;
    }
    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */


    function copyArray(source, array) {
      var index = -1,
          length = source.length;
      array || (array = Array(length));

      while (++index < length) {
        array[index] = source[index];
      }

      return array;
    }
    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */


    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }

      return wrapper;
    }
    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */


    function createCtor(Ctor) {
      return function () {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;

        switch (args.length) {
          case 0:
            return new Ctor();

          case 1:
            return new Ctor(args[0]);

          case 2:
            return new Ctor(args[0], args[1]);

          case 3:
            return new Ctor(args[0], args[1], args[2]);

          case 4:
            return new Ctor(args[0], args[1], args[2], args[3]);

          case 5:
            return new Ctor(args[0], args[1], args[2], args[3], args[4]);

          case 6:
            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);

          case 7:
            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }

        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args); // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.

        return isObject(result) ? result : thisBinding;
      };
    }
    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */


    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }

        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
        length -= holders.length;

        if (length < arity) {
          return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        }

        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return apply(fn, this, args);
      }

      return wrapper;
    }
    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */


    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
          isFlip = bitmask & FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }

        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }

        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }

        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }

        length -= holdersCount;

        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }

        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;
        length = args.length;

        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }

        if (isAry && ary < length) {
          args.length = ary;
        }

        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }

        return fn.apply(thisBinding, args);
      }

      return wrapper;
    }
    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */


    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = this && this !== root && this instanceof wrapper ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }

        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }

        return apply(fn, isBind ? thisArg : this, args);
      }

      return wrapper;
    }
    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */


    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;
      bitmask |= isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG;
      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

      if (!(bitmask & CURRY_BOUND_FLAG)) {
        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
      }

      var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }
    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     *   512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */


    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;

      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }

      var length = partials ? partials.length : 0;

      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }

      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;
        partials = holders = undefined;
      }

      var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] == null ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
      }

      if (!bitmask || bitmask == BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }

      return setWrapToString(result, func, bitmask);
    }
    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */


    function getHolder(func) {
      var object = func;
      return object.placeholder;
    }
    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */


    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }
    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */


    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }
    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */


    function insertWrapDetails(source, details) {
      var length = details.length,
          lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }
    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */


    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */


    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */


    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }

      return array;
    }
    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */


    var setWrapToString = !defineProperty ? identity : function (wrapper, reference, bitmask) {
      var source = reference + '';
      return defineProperty(wrapper, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
      });
    };
    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to process.
     * @returns {string} Returns the source code.
     */

    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}

        try {
          return func + '';
        } catch (e) {}
      }

      return '';
    }
    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */


    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function (pair) {
        var value = '_.' + pair[0];

        if (bitmask & pair[1] && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }
    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */


    var partialRight = baseRest(function (func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });
    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */

    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8-9 which returns 'object' for typed array and other constructors.
      var tag = isObject(value) ? objectToString.call(value) : '';
      return tag == funcTag || tag == genTag;
    }
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */


    function isObject(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */


    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }
    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */


    function isSymbol(value) {
      return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */


    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }

      value = toNumber(value);

      if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
      }

      return value === value ? value : 0;
    }
    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */


    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;
      return result === result ? remainder ? result - remainder : result : 0;
    }
    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */


    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }

      if (isSymbol(value)) {
        return NAN;
      }

      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
      }

      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }

      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */


    function constant(value) {
      return function () {
        return value;
      };
    }
    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */


    function identity(value) {
      return value;
    } // Assign default placeholders.


    partialRight.placeholder = {};
    module.exports = partialRight;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10));
  /***/
},
/* 501 */

/***/
function (module, exports, __webpack_require__) {
  var baseTimes = __webpack_require__(509),
      isArguments = __webpack_require__(520),
      isArray = __webpack_require__(140),
      isBuffer = __webpack_require__(521),
      isIndex = __webpack_require__(210),
      isTypedArray = __webpack_require__(526);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }

  module.exports = arrayLikeKeys;
  /***/
},
/* 502 */

/***/
function (module, exports) {
  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }

    return result;
  }

  module.exports = arrayMap;
  /***/
},
/* 503 */

/***/
function (module, exports) {
  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  module.exports = asciiToArray;
  /***/
},
/* 504 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(71),
      isObjectLike = __webpack_require__(72);
  /** `Object#toString` result references. */


  var argsTag = '[object Arguments]';
  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */

  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }

  module.exports = baseIsArguments;
  /***/
},
/* 505 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(71),
      isObjectLike = __webpack_require__(72);
  /** `Object#toString` result references. */


  var regexpTag = '[object RegExp]';
  /**
   * The base implementation of `_.isRegExp` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
   */

  function baseIsRegExp(value) {
    return isObjectLike(value) && baseGetTag(value) == regexpTag;
  }

  module.exports = baseIsRegExp;
  /***/
},
/* 506 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(71),
      isLength = __webpack_require__(214),
      isObjectLike = __webpack_require__(72);
  /** `Object#toString` result references. */


  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /** Used to identify `toStringTag` values of typed arrays. */

  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */

  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  module.exports = baseIsTypedArray;
  /***/
},
/* 507 */

/***/
function (module, exports, __webpack_require__) {
  var isPrototype = __webpack_require__(513),
      nativeKeys = __webpack_require__(514);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */

  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }

    var result = [];

    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }

    return result;
  }

  module.exports = baseKeys;
  /***/
},
/* 508 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.slice` without an iteratee call guard.
   *
   * @private
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */
  function baseSlice(array, start, end) {
    var index = -1,
        length = array.length;

    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }

    end = end > length ? length : end;

    if (end < 0) {
      end += length;
    }

    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);

    while (++index < length) {
      result[index] = array[index + start];
    }

    return result;
  }

  module.exports = baseSlice;
  /***/
},
/* 509 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }

  module.exports = baseTimes;
  /***/
},
/* 510 */

/***/
function (module, exports, __webpack_require__) {
  var baseSlice = __webpack_require__(508);
  /**
   * Casts `array` to a slice if it's needed.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {number} start The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the cast slice.
   */


  function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
  }

  module.exports = castSlice;
  /***/
},
/* 511 */

/***/
function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(139);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto.toString;
  /** Built-in value references. */

  var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */

  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }

    return result;
  }

  module.exports = getRawTag;
  /***/
},
/* 512 */

/***/
function (module, exports, __webpack_require__) {
  var eq = __webpack_require__(519),
      isArrayLike = __webpack_require__(213),
      isIndex = __webpack_require__(210),
      isObject = __webpack_require__(215);
  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */


  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }

    var type = typeof index;

    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
      return eq(object[index], value);
    }

    return false;
  }

  module.exports = isIterateeCall;
  /***/
},
/* 513 */

/***/
function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */

  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }

  module.exports = isPrototype;
  /***/
},
/* 514 */

/***/
function (module, exports, __webpack_require__) {
  var overArg = __webpack_require__(516);
  /* Built-in method references for those with the same name as other `lodash` methods. */


  var nativeKeys = overArg(Object.keys, Object);
  module.exports = nativeKeys;
  /***/
},
/* 515 */

/***/
function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto.toString;
  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */

  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  module.exports = objectToString;
  /***/
},
/* 516 */

/***/
function (module, exports) {
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }

  module.exports = overArg;
  /***/
},
/* 517 */

/***/
function (module, exports, __webpack_require__) {
  var asciiToArray = __webpack_require__(503),
      hasUnicode = __webpack_require__(209),
      unicodeToArray = __webpack_require__(518);
  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */


  function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
  }

  module.exports = stringToArray;
  /***/
},
/* 518 */

/***/
function (module, exports) {
  /** Used to compose unicode character classes. */
  var rsAstralRange = "\\ud800-\\udfff",
      rsComboMarksRange = "\\u0300-\\u036f",
      reComboHalfMarksRange = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange = "\\u20d0-\\u20ff",
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsVarRange = "\\ufe0e\\ufe0f";
  /** Used to compose unicode capture groups. */

  var rsAstral = '[' + rsAstralRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsFitz = "\\ud83c[\\udffb-\\udfff]",
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      rsZWJ = "\\u200d";
  /** Used to compose unicode regexes. */

  var reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */

  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  module.exports = unicodeToArray;
  /***/
},
/* 519 */

/***/
function (module, exports) {
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }

  module.exports = eq;
  /***/
},
/* 520 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsArguments = __webpack_require__(504),
      isObjectLike = __webpack_require__(72);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /** Built-in value references. */

  var propertyIsEnumerable = objectProto.propertyIsEnumerable;
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */

  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };
  module.exports = isArguments;
  /***/
},
/* 521 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (module) {
    var root = __webpack_require__(212),
        stubFalse = __webpack_require__(529);
    /** Detect free variable `exports`. */


    var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */

    var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */

    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Built-in value references. */

    var Buffer = moduleExports ? root.Buffer : undefined;
    /* Built-in method references for those with the same name as other `lodash` methods. */

    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */

    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(84)(module));
  /***/
},
/* 522 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(71),
      isObject = __webpack_require__(215);
  /** `Object#toString` result references. */


  var asyncTag = '[object AsyncFunction]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */

  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    } // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.


    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  module.exports = isFunction;
  /***/
},
/* 523 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsRegExp = __webpack_require__(505),
      baseUnary = __webpack_require__(207),
      nodeUtil = __webpack_require__(211);
  /* Node.js helper references. */


  var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
  /**
   * Checks if `value` is classified as a `RegExp` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
   * @example
   *
   * _.isRegExp(/abc/);
   * // => true
   *
   * _.isRegExp('/abc/');
   * // => false
   */

  var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
  module.exports = isRegExp;
  /***/
},
/* 524 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(71),
      isArray = __webpack_require__(140),
      isObjectLike = __webpack_require__(72);
  /** `Object#toString` result references. */


  var stringTag = '[object String]';
  /**
   * Checks if `value` is classified as a `String` primitive or object.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a string, else `false`.
   * @example
   *
   * _.isString('abc');
   * // => true
   *
   * _.isString(1);
   * // => false
   */

  function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
  }

  module.exports = isString;
  /***/
},
/* 525 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(71),
      isObjectLike = __webpack_require__(72);
  /** `Object#toString` result references. */


  var symbolTag = '[object Symbol]';
  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */

  function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
  }

  module.exports = isSymbol;
  /***/
},
/* 526 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsTypedArray = __webpack_require__(506),
      baseUnary = __webpack_require__(207),
      nodeUtil = __webpack_require__(211);
  /* Node.js helper references. */


  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */

  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  module.exports = isTypedArray;
  /***/
},
/* 527 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeKeys = __webpack_require__(501),
      baseKeys = __webpack_require__(507),
      isArrayLike = __webpack_require__(213);
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */


  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }

  module.exports = keys;
  /***/
},
/* 528 */

/***/
function (module, exports, __webpack_require__) {
  var baseToString = __webpack_require__(206),
      castSlice = __webpack_require__(510),
      hasUnicode = __webpack_require__(209),
      isIterateeCall = __webpack_require__(512),
      isRegExp = __webpack_require__(523),
      stringToArray = __webpack_require__(517),
      toString = __webpack_require__(530);
  /** Used as references for the maximum length and index of an array. */


  var MAX_ARRAY_LENGTH = 4294967295;
  /**
   * Splits `string` by `separator`.
   *
   * **Note:** This method is based on
   * [`String#split`](https://mdn.io/String/split).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category String
   * @param {string} [string=''] The string to split.
   * @param {RegExp|string} separator The separator pattern to split by.
   * @param {number} [limit] The length to truncate results to.
   * @returns {Array} Returns the string segments.
   * @example
   *
   * _.split('a-b-c', '-', 2);
   * // => ['a', 'b']
   */

  function split(string, separator, limit) {
    if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
      separator = limit = undefined;
    }

    limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;

    if (!limit) {
      return [];
    }

    string = toString(string);

    if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
      separator = baseToString(separator);

      if (!separator && hasUnicode(string)) {
        return castSlice(stringToArray(string), 0, limit);
      }
    }

    return string.split(separator, limit);
  }

  module.exports = split;
  /***/
},
/* 529 */

/***/
function (module, exports) {
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  module.exports = stubFalse;
  /***/
},
/* 530 */

/***/
function (module, exports, __webpack_require__) {
  var baseToString = __webpack_require__(206);
  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */


  function toString(value) {
    return value == null ? '' : baseToString(value);
  }

  module.exports = toString;
  /***/
},
/* 531 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var Buffer = __webpack_require__(38).Buffer;

  var writeToStream = __webpack_require__(217);

  var EE = __webpack_require__(41).EventEmitter;

  var inherits = __webpack_require__(37);

  function generate(packet) {
    var stream = new Accumulator();
    writeToStream(packet, stream);
    return stream.concat();
  }

  function Accumulator() {
    this._array = new Array(20);
    this._i = 0;
  }

  inherits(Accumulator, EE);

  Accumulator.prototype.write = function (chunk) {
    this._array[this._i++] = chunk;
    return true;
  };

  Accumulator.prototype.concat = function () {
    var length = 0;
    var lengths = new Array(this._array.length);
    var list = this._array;
    var pos = 0;
    var i;
    var result;

    for (i = 0; i < list.length && list[i] !== undefined; i++) {
      if (typeof list[i] !== 'string') lengths[i] = list[i].length;else lengths[i] = Buffer.byteLength(list[i]);
      length += lengths[i];
    }

    result = Buffer.allocUnsafe(length);

    for (i = 0; i < list.length && list[i] !== undefined; i++) {
      if (typeof list[i] !== 'string') {
        list[i].copy(result, pos);
        pos += lengths[i];
      } else {
        result.write(list[i], pos);
        pos += lengths[i];
      }
    }

    return result;
  };

  module.exports = generate;
  /***/
},
/* 532 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.parser = __webpack_require__(535);
  exports.generate = __webpack_require__(531);
  exports.writeToStream = __webpack_require__(217);
  /***/
},
/* 533 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var Buffer = __webpack_require__(38).Buffer;

  var max = 65536;
  var cache = {};

  function generateBuffer(i) {
    var buffer = Buffer.allocUnsafe(2);
    buffer.writeUInt8(i >> 8, 0, true);
    buffer.writeUInt8(i & 0x00FF, 0 + 1, true);
    return buffer;
  }

  function generateCache() {
    for (var i = 0; i < max; i++) {
      cache[i] = generateBuffer(i);
    }
  }

  module.exports = {
    cache: cache,
    generateCache: generateCache,
    generateNumber: generateBuffer
    /***/

  };
},
/* 534 */

/***/
function (module, exports) {
  function Packet() {
    this.cmd = null;
    this.retain = false;
    this.qos = 0;
    this.dup = false;
    this.length = -1;
    this.topic = null;
    this.payload = null;
  }

  module.exports = Packet;
  /***/
},
/* 535 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var bl = __webpack_require__(468);

  var inherits = __webpack_require__(37);

  var EE = __webpack_require__(41).EventEmitter;

  var Packet = __webpack_require__(534);

  var constants = __webpack_require__(216);

  function Parser() {
    if (!(this instanceof Parser)) return new Parser();
    this._states = ['_parseHeader', '_parseLength', '_parsePayload', '_newPacket'];

    this._resetState();
  }

  inherits(Parser, EE);

  Parser.prototype._resetState = function () {
    this.packet = new Packet();
    this.error = null;
    this._list = bl();
    this._stateCounter = 0;
  };

  Parser.prototype.parse = function (buf) {
    if (this.error) this._resetState();

    this._list.append(buf);

    while ((this.packet.length !== -1 || this._list.length > 0) && this[this._states[this._stateCounter]]() && !this.error) {
      this._stateCounter++;
      if (this._stateCounter >= this._states.length) this._stateCounter = 0;
    }

    return this._list.length;
  };

  Parser.prototype._parseHeader = function () {
    // There is at least one byte in the buffer
    var zero = this._list.readUInt8(0);

    this.packet.cmd = constants.types[zero >> constants.CMD_SHIFT];
    this.packet.retain = (zero & constants.RETAIN_MASK) !== 0;
    this.packet.qos = zero >> constants.QOS_SHIFT & constants.QOS_MASK;
    this.packet.dup = (zero & constants.DUP_MASK) !== 0;

    this._list.consume(1);

    return true;
  };

  Parser.prototype._parseLength = function () {
    // There is at least one byte in the list
    var bytes = 0;
    var mul = 1;
    var length = 0;
    var result = true;
    var current;

    while (bytes < 5) {
      current = this._list.readUInt8(bytes++);
      length += mul * (current & constants.LENGTH_MASK);
      mul *= 0x80;
      if ((current & constants.LENGTH_FIN_MASK) === 0) break;

      if (this._list.length <= bytes) {
        result = false;
        break;
      }
    }

    if (result) {
      this.packet.length = length;

      this._list.consume(bytes);
    }

    return result;
  };

  Parser.prototype._parsePayload = function () {
    var result = false; // Do we have a payload? Do we have enough data to complete the payload?
    // PINGs have no payload

    if (this.packet.length === 0 || this._list.length >= this.packet.length) {
      this._pos = 0;

      switch (this.packet.cmd) {
        case 'connect':
          this._parseConnect();

          break;

        case 'connack':
          this._parseConnack();

          break;

        case 'publish':
          this._parsePublish();

          break;

        case 'puback':
        case 'pubrec':
        case 'pubrel':
        case 'pubcomp':
          this._parseMessageId();

          break;

        case 'subscribe':
          this._parseSubscribe();

          break;

        case 'suback':
          this._parseSuback();

          break;

        case 'unsubscribe':
          this._parseUnsubscribe();

          break;

        case 'unsuback':
          this._parseUnsuback();

          break;

        case 'pingreq':
        case 'pingresp':
        case 'disconnect':
          // These are empty, nothing to do
          break;

        default:
          this._emitError(new Error('Not supported'));

      }

      result = true;
    }

    return result;
  };

  Parser.prototype._parseConnect = function () {
    var protocolId; // Protocol ID

    var clientId; // Client ID

    var topic; // Will topic

    var payload; // Will payload

    var password; // Password

    var username; // Username

    var flags = {};
    var packet = this.packet; // Parse protocolId

    protocolId = this._parseString();
    if (protocolId === null) return this._emitError(new Error('Cannot parse protocolId'));

    if (protocolId !== 'MQTT' && protocolId !== 'MQIsdp') {
      return this._emitError(new Error('Invalid protocolId'));
    }

    packet.protocolId = protocolId; // Parse constants version number

    if (this._pos >= this._list.length) return this._emitError(new Error('Packet too short'));
    packet.protocolVersion = this._list.readUInt8(this._pos);

    if (packet.protocolVersion !== 3 && packet.protocolVersion !== 4) {
      return this._emitError(new Error('Invalid protocol version'));
    }

    this._pos++;

    if (this._pos >= this._list.length) {
      return this._emitError(new Error('Packet too short'));
    } // Parse connect flags


    flags.username = this._list.readUInt8(this._pos) & constants.USERNAME_MASK;
    flags.password = this._list.readUInt8(this._pos) & constants.PASSWORD_MASK;
    flags.will = this._list.readUInt8(this._pos) & constants.WILL_FLAG_MASK;

    if (flags.will) {
      packet.will = {};
      packet.will.retain = (this._list.readUInt8(this._pos) & constants.WILL_RETAIN_MASK) !== 0;
      packet.will.qos = (this._list.readUInt8(this._pos) & constants.WILL_QOS_MASK) >> constants.WILL_QOS_SHIFT;
    }

    packet.clean = (this._list.readUInt8(this._pos) & constants.CLEAN_SESSION_MASK) !== 0;
    this._pos++; // Parse keepalive

    packet.keepalive = this._parseNum();
    if (packet.keepalive === -1) return this._emitError(new Error('Packet too short')); // Parse clientId

    clientId = this._parseString();
    if (clientId === null) return this._emitError(new Error('Packet too short'));
    packet.clientId = clientId;

    if (flags.will) {
      // Parse will topic
      topic = this._parseString();
      if (topic === null) return this._emitError(new Error('Cannot parse will topic'));
      packet.will.topic = topic; // Parse will payload

      payload = this._parseBuffer();
      if (payload === null) return this._emitError(new Error('Cannot parse will payload'));
      packet.will.payload = payload;
    } // Parse username


    if (flags.username) {
      username = this._parseString();
      if (username === null) return this._emitError(new Error('Cannot parse username'));
      packet.username = username;
    } // Parse password


    if (flags.password) {
      password = this._parseBuffer();
      if (password === null) return this._emitError(new Error('Cannot parse password'));
      packet.password = password;
    }

    return packet;
  };

  Parser.prototype._parseConnack = function () {
    var packet = this.packet;
    if (this._list.length < 2) return null;
    packet.sessionPresent = !!(this._list.readUInt8(this._pos++) & constants.SESSIONPRESENT_MASK);
    packet.returnCode = this._list.readUInt8(this._pos);
    if (packet.returnCode === -1) return this._emitError(new Error('Cannot parse return code'));
  };

  Parser.prototype._parsePublish = function () {
    var packet = this.packet;
    packet.topic = this._parseString();
    if (packet.topic === null) return this._emitError(new Error('Cannot parse topic')); // Parse messageId

    if (packet.qos > 0) if (!this._parseMessageId()) {
      return;
    }
    packet.payload = this._list.slice(this._pos, packet.length);
  };

  Parser.prototype._parseSubscribe = function () {
    var packet = this.packet;
    var topic;
    var qos;

    if (packet.qos !== 1) {
      return this._emitError(new Error('Wrong subscribe header'));
    }

    packet.subscriptions = [];

    if (!this._parseMessageId()) {
      return;
    }

    while (this._pos < packet.length) {
      // Parse topic
      topic = this._parseString();
      if (topic === null) return this._emitError(new Error('Cannot parse topic'));
      qos = this._list.readUInt8(this._pos++); // Push pair to subscriptions

      packet.subscriptions.push({
        topic: topic,
        qos: qos
      });
    }
  };

  Parser.prototype._parseSuback = function () {
    this.packet.granted = [];

    if (!this._parseMessageId()) {
      return;
    } // Parse granted QoSes


    while (this._pos < this.packet.length) {
      this.packet.granted.push(this._list.readUInt8(this._pos++));
    }
  };

  Parser.prototype._parseUnsubscribe = function () {
    var packet = this.packet;
    packet.unsubscriptions = []; // Parse messageId

    if (!this._parseMessageId()) {
      return;
    }

    while (this._pos < packet.length) {
      var topic; // Parse topic

      topic = this._parseString();
      if (topic === null) return this._emitError(new Error('Cannot parse topic')); // Push topic to unsubscriptions

      packet.unsubscriptions.push(topic);
    }
  };

  Parser.prototype._parseUnsuback = function () {
    if (!this._parseMessageId()) return this._emitError(new Error('Cannot parse messageId'));
  };

  Parser.prototype._parseMessageId = function () {
    var packet = this.packet;
    packet.messageId = this._parseNum();

    if (packet.messageId === null) {
      this._emitError(new Error('Cannot parse messageId'));

      return false;
    }

    return true;
  };

  Parser.prototype._parseString = function (maybeBuffer) {
    var length = this._parseNum();

    var result;
    var end = length + this._pos;
    if (length === -1 || end > this._list.length || end > this.packet.length) return null;
    result = this._list.toString('utf8', this._pos, end);
    this._pos += length;
    return result;
  };

  Parser.prototype._parseBuffer = function () {
    var length = this._parseNum();

    var result;
    var end = length + this._pos;
    if (length === -1 || end > this._list.length || end > this.packet.length) return null;
    result = this._list.slice(this._pos, end);
    this._pos += length;
    return result;
  };

  Parser.prototype._parseNum = function () {
    if (this._list.length - this._pos < 2) return -1;

    var result = this._list.readUInt16BE(this._pos);

    this._pos += 2;
    return result;
  };

  Parser.prototype._newPacket = function () {
    if (this.packet) {
      this._list.consume(this.packet.length);

      this.emit('packet', this.packet);
    }

    this.packet = new Packet();
    return true;
  };

  Parser.prototype._emitError = function (err) {
    this.error = err;
    this.emit('error', err);
  };

  module.exports = Parser;
  /***/
},
/* 536 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (global, process) {
    /**
     * Module dependencies
     */
    var events = __webpack_require__(41);

    var Store = __webpack_require__(221);

    var eos = __webpack_require__(200);

    var mqttPacket = __webpack_require__(532);

    var Writable = __webpack_require__(63).Writable;

    var inherits = __webpack_require__(37);

    var reInterval = __webpack_require__(593);

    var validations = __webpack_require__(538);

    var xtend = __webpack_require__(161);

    var setImmediate = global.setImmediate || function (callback) {
      // works in node v0.8
      process.nextTick(callback);
    };

    var defaultConnectOptions = {
      keepalive: 60,
      reschedulePings: true,
      protocolId: 'MQTT',
      protocolVersion: 4,
      reconnectPeriod: 1000,
      connectTimeout: 30 * 1000,
      clean: true,
      resubscribe: true
    };

    function defaultId() {
      return 'mqttjs_' + Math.random().toString(16).substr(2, 8);
    }

    function sendPacket(client, packet, cb) {
      client.emit('packetsend', packet);
      var result = mqttPacket.writeToStream(packet, client.stream);

      if (!result && cb) {
        client.stream.once('drain', cb);
      } else if (cb) {
        cb();
      }
    }

    function storeAndSend(client, packet, cb) {
      client.outgoingStore.put(packet, function storedPacket(err) {
        if (err) {
          return cb && cb(err);
        }

        sendPacket(client, packet, cb);
      });
    }

    function nop() {}
    /**
     * MqttClient constructor
     *
     * @param {Stream} stream - stream
     * @param {Object} [options] - connection options
     * (see Connection#connect)
     */


    function MqttClient(streamBuilder, options) {
      var k;
      var that = this;

      if (!(this instanceof MqttClient)) {
        return new MqttClient(streamBuilder, options);
      }

      this.options = options || {}; // Defaults

      for (k in defaultConnectOptions) {
        if (typeof this.options[k] === 'undefined') {
          this.options[k] = defaultConnectOptions[k];
        } else {
          this.options[k] = options[k];
        }
      }

      this.options.clientId = typeof this.options.clientId === 'string' ? this.options.clientId : defaultId();
      this.streamBuilder = streamBuilder; // Inflight message storages

      this.outgoingStore = this.options.outgoingStore || new Store();
      this.incomingStore = this.options.incomingStore || new Store(); // Should QoS zero messages be queued when the connection is broken?

      this.queueQoSZero = this.options.queueQoSZero === undefined ? true : this.options.queueQoSZero; // map of subscribed topics to support reconnection

      this._resubscribeTopics = {}; // map of a subscribe messageId and a topic

      this.messageIdToTopic = {}; // Ping timer, setup in _setupPingTimer

      this.pingTimer = null; // Is the client connected?

      this.connected = false; // Are we disconnecting?

      this.disconnecting = false; // Packet queue

      this.queue = []; // connack timer

      this.connackTimer = null; // Reconnect timer

      this.reconnectTimer = null; // MessageIDs starting with 1

      this.nextId = Math.floor(Math.random() * 65535); // Inflight callbacks

      this.outgoing = {}; // Mark connected on connect

      this.on('connect', function () {
        if (this.disconnected) {
          return;
        }

        this.connected = true;
        var outStore = null;
        outStore = this.outgoingStore.createStream(); // Control of stored messages

        outStore.once('readable', function () {
          function storeDeliver() {
            var packet = outStore.read(1);
            var cb;

            if (!packet) {
              return;
            } // Avoid unnecesary stream read operations when disconnected


            if (!that.disconnecting && !that.reconnectTimer && that.options.reconnectPeriod > 0) {
              outStore.read(0);
              cb = that.outgoing[packet.messageId];

              that.outgoing[packet.messageId] = function (err, status) {
                // Ensure that the original callback passed in to publish gets invoked
                if (cb) {
                  cb(err, status);
                }

                storeDeliver();
              };

              that._sendPacket(packet);
            } else if (outStore.destroy) {
              outStore.destroy();
            }
          }

          storeDeliver();
        }).on('error', this.emit.bind(this, 'error'));
      }); // Mark disconnected on stream close

      this.on('close', function () {
        this.connected = false;
        clearTimeout(this.connackTimer);
      }); // Setup ping timer

      this.on('connect', this._setupPingTimer); // Send queued packets

      this.on('connect', function () {
        var queue = this.queue;

        function deliver() {
          var entry = queue.shift();
          var packet = null;

          if (!entry) {
            return;
          }

          packet = entry.packet;

          that._sendPacket(packet, function (err) {
            if (entry.cb) {
              entry.cb(err);
            }

            deliver();
          });
        }

        deliver();
      });
      var firstConnection = true; // resubscribe

      this.on('connect', function () {
        if (!firstConnection && this.options.clean && Object.keys(this._resubscribeTopics).length > 0) {
          if (this.options.resubscribe) {
            this._resubscribeTopics.resubscribe = true;
            this.subscribe(this._resubscribeTopics);
          } else {
            this._resubscribeTopics = {};
          }
        }

        firstConnection = false;
      }); // Clear ping timer

      this.on('close', function () {
        if (that.pingTimer !== null) {
          that.pingTimer.clear();
          that.pingTimer = null;
        }
      }); // Setup reconnect timer on disconnect

      this.on('close', this._setupReconnect);
      events.EventEmitter.call(this);

      this._setupStream();
    }

    inherits(MqttClient, events.EventEmitter);
    /**
     * setup the event handlers in the inner stream.
     *
     * @api private
     */

    MqttClient.prototype._setupStream = function () {
      var connectPacket;
      var that = this;
      var writable = new Writable();
      var parser = mqttPacket.parser(this.options);
      var completeParse = null;
      var packets = [];

      this._clearReconnect();

      this.stream = this.streamBuilder(this);
      parser.on('packet', function (packet) {
        packets.push(packet);
      });

      function nextTickWork() {
        process.nextTick(work);
      }

      function work() {
        var packet = packets.shift();
        var done = completeParse;

        if (packet) {
          that._handlePacket(packet, nextTickWork);
        } else {
          completeParse = null;
          done();
        }
      }

      writable._write = function (buf, enc, done) {
        completeParse = done;
        parser.parse(buf);
        work();
      };

      this.stream.pipe(writable); // Suppress connection errors

      this.stream.on('error', nop); // Echo stream close

      eos(this.stream, this.emit.bind(this, 'close')); // Send a connect packet

      connectPacket = Object.create(this.options);
      connectPacket.cmd = 'connect'; // avoid message queue

      sendPacket(this, connectPacket); // Echo connection errors

      parser.on('error', this.emit.bind(this, 'error')); // many drain listeners are needed for qos 1 callbacks if the connection is intermittent

      this.stream.setMaxListeners(1000);
      clearTimeout(this.connackTimer);
      this.connackTimer = setTimeout(function () {
        that._cleanUp(true);
      }, this.options.connectTimeout);
    };

    MqttClient.prototype._handlePacket = function (packet, done) {
      this.emit('packetreceive', packet);

      switch (packet.cmd) {
        case 'publish':
          this._handlePublish(packet, done);

          break;

        case 'puback':
        case 'pubrec':
        case 'pubcomp':
        case 'suback':
        case 'unsuback':
          this._handleAck(packet);

          done();
          break;

        case 'pubrel':
          this._handlePubrel(packet, done);

          break;

        case 'connack':
          this._handleConnack(packet);

          done();
          break;

        case 'pingresp':
          this._handlePingresp(packet);

          done();
          break;

        default:
          // do nothing
          // maybe we should do an error handling
          // or just log it
          break;
      }
    };

    MqttClient.prototype._checkDisconnecting = function (callback) {
      if (this.disconnecting) {
        if (callback) {
          callback(new Error('client disconnecting'));
        } else {
          this.emit('error', new Error('client disconnecting'));
        }
      }

      return this.disconnecting;
    };
    /**
     * publish - publish <message> to <topic>
     *
     * @param {String} topic - topic to publish to
     * @param {String, Buffer} message - message to publish
     * @param {Object} [opts] - publish options, includes:
     *    {Number} qos - qos level to publish on
     *    {Boolean} retain - whether or not to retain the message
     *    {Boolean} dup - whether or not mark a message as duplicate
     * @param {Function} [callback] - function(err){}
     *    called when publish succeeds or fails
     * @returns {MqttClient} this - for chaining
     * @api public
     *
     * @example client.publish('topic', 'message');
     * @example
     *     client.publish('topic', 'message', {qos: 1, retain: true, dup: true});
     * @example client.publish('topic', 'message', console.log);
     */


    MqttClient.prototype.publish = function (topic, message, opts, callback) {
      var packet; // .publish(topic, payload, cb);

      if (typeof opts === 'function') {
        callback = opts;
        opts = null;
      } // default opts


      var defaultOpts = {
        qos: 0,
        retain: false,
        dup: false
      };
      opts = xtend(defaultOpts, opts);

      if (this._checkDisconnecting(callback)) {
        return this;
      }

      packet = {
        cmd: 'publish',
        topic: topic,
        payload: message,
        qos: opts.qos,
        retain: opts.retain,
        messageId: this._nextId(),
        dup: opts.dup
      };

      switch (opts.qos) {
        case 1:
        case 2:
          // Add to callbacks
          this.outgoing[packet.messageId] = callback || nop;

          this._sendPacket(packet);

          break;

        default:
          this._sendPacket(packet, callback);

          break;
      }

      return this;
    };
    /**
     * subscribe - subscribe to <topic>
     *
     * @param {String, Array, Object} topic - topic(s) to subscribe to, supports objects in the form {'topic': qos}
     * @param {Object} [opts] - optional subscription options, includes:
     *    {Number} qos - subscribe qos level
     * @param {Function} [callback] - function(err, granted){} where:
     *    {Error} err - subscription error (none at the moment!)
     *    {Array} granted - array of {topic: 't', qos: 0}
     * @returns {MqttClient} this - for chaining
     * @api public
     * @example client.subscribe('topic');
     * @example client.subscribe('topic', {qos: 1});
     * @example client.subscribe({'topic': 0, 'topic2': 1}, console.log);
     * @example client.subscribe('topic', console.log);
     */


    MqttClient.prototype.subscribe = function () {
      var packet;
      var args = Array.prototype.slice.call(arguments);
      var subs = [];
      var obj = args.shift();
      var resubscribe = obj.resubscribe;
      var callback = args.pop() || nop;
      var opts = args.pop();
      var invalidTopic;
      var that = this;
      delete obj.resubscribe;

      if (typeof obj === 'string') {
        obj = [obj];
      }

      if (typeof callback !== 'function') {
        opts = callback;
        callback = nop;
      }

      invalidTopic = validations.validateTopics(obj);

      if (invalidTopic !== null) {
        setImmediate(callback, new Error('Invalid topic ' + invalidTopic));
        return this;
      }

      if (this._checkDisconnecting(callback)) {
        return this;
      }

      var defaultOpts = {
        qos: 0
      };
      opts = xtend(defaultOpts, opts);

      if (Array.isArray(obj)) {
        obj.forEach(function (topic) {
          if (that._resubscribeTopics[topic] < opts.qos || !that._resubscribeTopics.hasOwnProperty(topic) || resubscribe) {
            subs.push({
              topic: topic,
              qos: opts.qos
            });
          }
        });
      } else {
        Object.keys(obj).forEach(function (k) {
          if (that._resubscribeTopics[k] < obj[k] || !that._resubscribeTopics.hasOwnProperty(k) || resubscribe) {
            subs.push({
              topic: k,
              qos: obj[k]
            });
          }
        });
      }

      packet = {
        cmd: 'subscribe',
        subscriptions: subs,
        qos: 1,
        retain: false,
        dup: false,
        messageId: this._nextId()
      };

      if (!subs.length) {
        callback(null, []);
        return;
      } // subscriptions to resubscribe to in case of disconnect


      if (this.options.resubscribe) {
        var topics = [];
        subs.forEach(function (sub) {
          if (that.options.reconnectPeriod > 0) {
            that._resubscribeTopics[sub.topic] = sub.qos;
            topics.push(sub.topic);
          }
        });
        that.messageIdToTopic[packet.messageId] = topics;
      }

      this.outgoing[packet.messageId] = function (err, packet) {
        if (!err) {
          var granted = packet.granted;

          for (var i = 0; i < granted.length; i += 1) {
            subs[i].qos = granted[i];
          }
        }

        callback(err, subs);
      };

      this._sendPacket(packet);

      return this;
    };
    /**
     * unsubscribe - unsubscribe from topic(s)
     *
     * @param {String, Array} topic - topics to unsubscribe from
     * @param {Function} [callback] - callback fired on unsuback
     * @returns {MqttClient} this - for chaining
     * @api public
     * @example client.unsubscribe('topic');
     * @example client.unsubscribe('topic', console.log);
     */


    MqttClient.prototype.unsubscribe = function (topic, callback) {
      var packet = {
        cmd: 'unsubscribe',
        qos: 1,
        messageId: this._nextId()
      };
      var that = this;
      callback = callback || nop;

      if (this._checkDisconnecting(callback)) {
        return this;
      }

      if (typeof topic === 'string') {
        packet.unsubscriptions = [topic];
      } else if (typeof topic === 'object' && topic.length) {
        packet.unsubscriptions = topic;
      }

      if (this.options.resubscribe) {
        packet.unsubscriptions.forEach(function (topic) {
          delete that._resubscribeTopics[topic];
        });
      }

      this.outgoing[packet.messageId] = callback;

      this._sendPacket(packet);

      return this;
    };
    /**
     * end - close connection
     *
     * @returns {MqttClient} this - for chaining
     * @param {Boolean} force - do not wait for all in-flight messages to be acked
     * @param {Function} cb - called when the client has been closed
     *
     * @api public
     */


    MqttClient.prototype.end = function (force, cb) {
      var that = this;

      if (typeof force === 'function') {
        cb = force;
        force = false;
      }

      function closeStores() {
        that.disconnected = true;
        that.incomingStore.close(function () {
          that.outgoingStore.close(cb);
        });

        if (that._deferredReconnect) {
          that._deferredReconnect();
        }
      }

      function finish() {
        // defer closesStores of an I/O cycle,
        // just to make sure things are
        // ok for websockets
        that._cleanUp(force, setImmediate.bind(null, closeStores));
      }

      if (this.disconnecting) {
        return this;
      }

      this._clearReconnect();

      this.disconnecting = true;

      if (!force && Object.keys(this.outgoing).length > 0) {
        // wait 10ms, just to be sure we received all of it
        this.once('outgoingEmpty', setTimeout.bind(null, finish, 10));
      } else {
        finish();
      }

      return this;
    };
    /**
     * removeOutgoingMessage - remove a message in outgoing store
     * the outgoing callback will be called withe Error('Message removed') if the message is removed
     *
     * @param {Number} mid - messageId to remove message
     * @returns {MqttClient} this - for chaining
     * @api public
     *
     * @example client.removeOutgoingMessage(client.getLastMessageId());
     */


    MqttClient.prototype.removeOutgoingMessage = function (mid) {
      var cb = this.outgoing[mid];
      delete this.outgoing[mid];
      this.outgoingStore.del({
        messageId: mid
      }, function () {
        cb(new Error('Message removed'));
      });
      return this;
    };
    /**
     * reconnect - connect again using the same options as connect()
     *
     * @param {Object} [opts] - optional reconnect options, includes:
     *    {Store} incomingStore - a store for the incoming packets
     *    {Store} outgoingStore - a store for the outgoing packets
     *    if opts is not given, current stores are used
     * @returns {MqttClient} this - for chaining
     *
     * @api public
     */


    MqttClient.prototype.reconnect = function (opts) {
      var that = this;

      var f = function f() {
        if (opts) {
          that.options.incomingStore = opts.incomingStore;
          that.options.outgoingStore = opts.outgoingStore;
        } else {
          that.options.incomingStore = null;
          that.options.outgoingStore = null;
        }

        that.incomingStore = that.options.incomingStore || new Store();
        that.outgoingStore = that.options.outgoingStore || new Store();
        that.disconnecting = false;
        that.disconnected = false;
        that._deferredReconnect = null;

        that._reconnect();
      };

      if (this.disconnecting && !this.disconnected) {
        this._deferredReconnect = f;
      } else {
        f();
      }

      return this;
    };
    /**
     * _reconnect - implement reconnection
     * @api privateish
     */


    MqttClient.prototype._reconnect = function () {
      this.emit('reconnect');

      this._setupStream();
    };
    /**
     * _setupReconnect - setup reconnect timer
     */


    MqttClient.prototype._setupReconnect = function () {
      var that = this;

      if (!that.disconnecting && !that.reconnectTimer && that.options.reconnectPeriod > 0) {
        if (!this.reconnecting) {
          this.emit('offline');
          this.reconnecting = true;
        }

        that.reconnectTimer = setInterval(function () {
          that._reconnect();
        }, that.options.reconnectPeriod);
      }
    };
    /**
     * _clearReconnect - clear the reconnect timer
     */


    MqttClient.prototype._clearReconnect = function () {
      if (this.reconnectTimer) {
        clearInterval(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    };
    /**
     * _cleanUp - clean up on connection end
     * @api private
     */


    MqttClient.prototype._cleanUp = function (forced, done) {
      if (done) {
        this.stream.on('close', done);
      }

      if (forced) {
        this.stream.destroy();
      } else {
        this._sendPacket({
          cmd: 'disconnect'
        }, setImmediate.bind(null, this.stream.end.bind(this.stream)));
      }

      if (!this.disconnecting) {
        this._clearReconnect();

        this._setupReconnect();
      }

      if (this.pingTimer !== null) {
        this.pingTimer.clear();
        this.pingTimer = null;
      }
    };
    /**
     * _sendPacket - send or queue a packet
     * @param {String} type - packet type (see `protocol`)
     * @param {Object} packet - packet options
     * @param {Function} cb - callback when the packet is sent
     * @api private
     */


    MqttClient.prototype._sendPacket = function (packet, cb) {
      if (!this.connected) {
        if ((packet.qos || 0) === 0 && this.queueQoSZero || packet.cmd !== 'publish') {
          this.queue.push({
            packet: packet,
            cb: cb
          });
        } else if (packet.qos > 0) {
          cb = this.outgoing[packet.messageId];
          this.outgoingStore.put(packet, function (err) {
            if (err) {
              return cb && cb(err);
            }
          });
        } else if (cb) {
          cb(new Error('No connection to broker'));
        }

        return;
      } // When sending a packet, reschedule the ping timer


      this._shiftPingInterval();

      if (packet.cmd !== 'publish') {
        sendPacket(this, packet, cb);
        return;
      }

      switch (packet.qos) {
        case 2:
        case 1:
          storeAndSend(this, packet, cb);
          break;

        /**
         * no need of case here since it will be caught by default
         * and jshint comply that before default it must be a break
         * anyway it will result in -1 evaluation
         */

        case 0:
        /* falls through */

        default:
          sendPacket(this, packet, cb);
          break;
      }
    };
    /**
     * _setupPingTimer - setup the ping timer
     *
     * @api private
     */


    MqttClient.prototype._setupPingTimer = function () {
      var that = this;

      if (!this.pingTimer && this.options.keepalive) {
        this.pingResp = true;
        this.pingTimer = reInterval(function () {
          that._checkPing();
        }, this.options.keepalive * 1000);
      }
    };
    /**
     * _shiftPingInterval - reschedule the ping interval
     *
     * @api private
     */


    MqttClient.prototype._shiftPingInterval = function () {
      if (this.pingTimer && this.options.keepalive && this.options.reschedulePings) {
        this.pingTimer.reschedule(this.options.keepalive * 1000);
      }
    };
    /**
     * _checkPing - check if a pingresp has come back, and ping the server again
     *
     * @api private
     */


    MqttClient.prototype._checkPing = function () {
      if (this.pingResp) {
        this.pingResp = false;

        this._sendPacket({
          cmd: 'pingreq'
        });
      } else {
        // do a forced cleanup since socket will be in bad shape
        this._cleanUp(true);
      }
    };
    /**
     * _handlePingresp - handle a pingresp
     *
     * @api private
     */


    MqttClient.prototype._handlePingresp = function () {
      this.pingResp = true;
    };
    /**
     * _handleConnack
     *
     * @param {Object} packet
     * @api private
     */


    MqttClient.prototype._handleConnack = function (packet) {
      var rc = packet.returnCode;
      var errors = ['', 'Unacceptable protocol version', 'Identifier rejected', 'Server unavailable', 'Bad username or password', 'Not authorized'];
      clearTimeout(this.connackTimer);

      if (rc === 0) {
        this.reconnecting = false;
        this.emit('connect', packet);
      } else if (rc > 0) {
        var err = new Error('Connection refused: ' + errors[rc]);
        err.code = rc;
        this.emit('error', err);
      }
    };
    /**
     * _handlePublish
     *
     * @param {Object} packet
     * @api private
     */

    /*
    those late 2 case should be rewrite to comply with coding style:
    
    case 1:
    case 0:
      // do not wait sending a puback
      // no callback passed
      if (1 === qos) {
        this._sendPacket({
          cmd: 'puback',
          messageId: mid
        });
      }
      // emit the message event for both qos 1 and 0
      this.emit('message', topic, message, packet);
      this.handleMessage(packet, done);
      break;
    default:
      // do nothing but every switch mus have a default
      // log or throw an error about unknown qos
      break;
    
    for now i just suppressed the warnings
    */


    MqttClient.prototype._handlePublish = function (packet, done) {
      var topic = packet.topic.toString();
      var message = packet.payload;
      var qos = packet.qos;
      var mid = packet.messageId;
      var that = this;

      switch (qos) {
        case 2:
          this.incomingStore.put(packet, function () {
            that._sendPacket({
              cmd: 'pubrec',
              messageId: mid
            }, done);
          });
          break;

        case 1:
          // emit the message event
          this.emit('message', topic, message, packet);
          this.handleMessage(packet, function (err) {
            if (err) {
              return done && done(err);
            } // send 'puback' if the above 'handleMessage' method executed
            // successfully.


            that._sendPacket({
              cmd: 'puback',
              messageId: mid
            }, done);
          });
          break;

        case 0:
          // emit the message event
          this.emit('message', topic, message, packet);
          this.handleMessage(packet, done);
          break;

        default:
          // do nothing
          // log or throw an error about unknown qos
          break;
      }
    };
    /**
     * Handle messages with backpressure support, one at a time.
     * Override at will.
     *
     * @param Packet packet the packet
     * @param Function callback call when finished
     * @api public
     */


    MqttClient.prototype.handleMessage = function (packet, callback) {
      callback();
    };
    /**
     * _handleAck
     *
     * @param {Object} packet
     * @api private
     */


    MqttClient.prototype._handleAck = function (packet) {
      /* eslint no-fallthrough: "off" */
      var mid = packet.messageId;
      var type = packet.cmd;
      var response = null;
      var cb = this.outgoing[mid];
      var that = this;

      if (!cb) {
        // Server sent an ack in error, ignore it.
        return;
      } // Process


      switch (type) {
        case 'pubcomp': // same thing as puback for QoS 2

        case 'puback':
          // Callback - we're done
          delete this.outgoing[mid];
          this.outgoingStore.del(packet, cb);
          break;

        case 'pubrec':
          response = {
            cmd: 'pubrel',
            qos: 2,
            messageId: mid
          };

          this._sendPacket(response);

          break;

        case 'suback':
          delete this.outgoing[mid];

          if (packet.granted.length === 1 && (packet.granted[0] & 0x80) !== 0) {
            // suback with Failure status
            var topics = this.messageIdToTopic[mid];

            if (topics) {
              topics.forEach(function (topic) {
                delete that._resubscribeTopics[topic];
              });
            }
          }

          cb(null, packet);
          break;

        case 'unsuback':
          delete this.outgoing[mid];
          cb(null);
          break;

        default:
          that.emit('error', new Error('unrecognized packet type'));
      }

      if (this.disconnecting && Object.keys(this.outgoing).length === 0) {
        this.emit('outgoingEmpty');
      }
    };
    /**
     * _handlePubrel
     *
     * @param {Object} packet
     * @api private
     */


    MqttClient.prototype._handlePubrel = function (packet, callback) {
      var mid = packet.messageId;
      var that = this;
      var comp = {
        cmd: 'pubcomp',
        messageId: mid
      };
      that.incomingStore.get(packet, function (err, pub) {
        if (!err && pub.cmd !== 'pubrel') {
          that.emit('message', pub.topic, pub.payload, pub);
          that.incomingStore.put(packet);
          that.handleMessage(pub, function (err) {
            if (err) {
              return callback && callback(err);
            }

            that._sendPacket(comp, callback);
          });
        } else {
          that._sendPacket(comp, callback);
        }
      });
    };
    /**
     * _nextId
     */


    MqttClient.prototype._nextId = function () {
      var id = this.nextId++; // Ensure 16 bit unsigned int:

      if (id === 65535) {
        this.nextId = 1;
      }

      return id;
    };
    /**
     * getLastMessageId
     */


    MqttClient.prototype.getLastMessageId = function () {
      return this.nextId === 1 ? 65535 : this.nextId - 1;
    };

    module.exports = MqttClient;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(10), __webpack_require__(16));
  /***/
},
/* 537 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    var MqttClient = __webpack_require__(536);

    var Store = __webpack_require__(221);

    var url = __webpack_require__(159);

    var xtend = __webpack_require__(161);

    var protocols = {};

    if (process.title !== 'browser') {
      protocols.mqtt = __webpack_require__(218);
      protocols.tcp = __webpack_require__(218);
      protocols.ssl = __webpack_require__(142);
      protocols.tls = __webpack_require__(142);
      protocols.mqtts = __webpack_require__(142);
    } else {
      protocols.wx = __webpack_require__(220);
      protocols.wxs = __webpack_require__(220);
    }

    protocols.ws = __webpack_require__(219);
    protocols.wss = __webpack_require__(219);
    /**
     * Parse the auth attribute and merge username and password in the options object.
     *
     * @param {Object} [opts] option object
     */

    function parseAuthOptions(opts) {
      var matches;

      if (opts.auth) {
        matches = opts.auth.match(/^(.+):(.+)$/);

        if (matches) {
          opts.username = matches[1];
          opts.password = matches[2];
        } else {
          opts.username = opts.auth;
        }
      }
    }
    /**
     * connect - connect to an MQTT broker.
     *
     * @param {String} [brokerUrl] - url of the broker, optional
     * @param {Object} opts - see MqttClient#constructor
     */


    function connect(brokerUrl, opts) {
      if (typeof brokerUrl === 'object' && !opts) {
        opts = brokerUrl;
        brokerUrl = null;
      }

      opts = opts || {};

      if (brokerUrl) {
        var parsed = url.parse(brokerUrl, true);

        if (parsed.port != null) {
          parsed.port = Number(parsed.port);
        }

        opts = xtend(parsed, opts);

        if (opts.protocol === null) {
          throw new Error('Missing protocol');
        }

        opts.protocol = opts.protocol.replace(/:$/, '');
      } // merge in the auth options if supplied


      parseAuthOptions(opts); // support clientId passed in the query string of the url

      if (opts.query && typeof opts.query.clientId === 'string') {
        opts.clientId = opts.query.clientId;
      }

      if (opts.cert && opts.key) {
        if (opts.protocol) {
          if (['mqtts', 'wss', 'wxs'].indexOf(opts.protocol) === -1) {
            switch (opts.protocol) {
              case 'mqtt':
                opts.protocol = 'mqtts';
                break;

              case 'ws':
                opts.protocol = 'wss';
                break;

              case 'wx':
                opts.protocol = 'wxs';
                break;

              default:
                throw new Error('Unknown protocol for secure connection: "' + opts.protocol + '"!');
            }
          }
        } else {
          // don't know what protocol he want to use, mqtts or wss
          throw new Error('Missing secure protocol key');
        }
      }

      if (!protocols[opts.protocol]) {
        var isSecure = ['mqtts', 'wss'].indexOf(opts.protocol) !== -1;
        opts.protocol = ['mqtt', 'mqtts', 'ws', 'wss', 'wx', 'wxs'].filter(function (key, index) {
          if (isSecure && index % 2 === 0) {
            // Skip insecure protocols when requesting a secure one.
            return false;
          }

          return typeof protocols[key] === 'function';
        })[0];
      }

      if (opts.clean === false && !opts.clientId) {
        throw new Error('Missing clientId for unclean clients');
      }

      function wrapper(client) {
        if (opts.servers) {
          if (!client._reconnectCount || client._reconnectCount === opts.servers.length) {
            client._reconnectCount = 0;
          }

          opts.host = opts.servers[client._reconnectCount].host;
          opts.port = opts.servers[client._reconnectCount].port;
          opts.hostname = opts.host;
          client._reconnectCount++;
        }

        return protocols[opts.protocol](client, opts);
      }

      return new MqttClient(wrapper, opts);
    }

    module.exports = connect;
    module.exports.connect = connect;
    module.exports.MqttClient = MqttClient;
    module.exports.Store = Store;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(16));
  /***/
},
/* 538 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Validate a topic to see if it's valid or not.
   * A topic is valid if it follow below rules:
   * - Rule #1: If any part of the topic is not `+` or `#`, then it must not contain `+` and '#'
   * - Rule #2: Part `#` must be located at the end of the mailbox
   *
   * @param {String} topic - A topic
   * @returns {Boolean} If the topic is valid, returns true. Otherwise, returns false.
   */

  function validateTopic(topic) {
    var parts = topic.split('/');

    for (var i = 0; i < parts.length; i++) {
      if (parts[i] === '+') {
        continue;
      }

      if (parts[i] === '#') {
        // for Rule #2
        return i === parts.length - 1;
      }

      if (parts[i].indexOf('+') !== -1 || parts[i].indexOf('#') !== -1) {
        return false;
      }
    }

    return true;
  }
  /**
   * Validate an array of topics to see if any of them is valid or not
    * @param {Array} topics - Array of topics
   * @returns {String} If the topics is valid, returns null. Otherwise, returns the invalid one
   */


  function validateTopics(topics) {
    if (topics.length === 0) {
      return 'empty_topic_list';
    }

    for (var i = 0; i < topics.length; i++) {
      if (!validateTopic(topics[i])) {
        return topics[i];
      }
    }

    return null;
  }

  module.exports = {
    validateTopics: validateTopics
    /***/

  };
},
/* 539 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (Buffer) {
    /**
    * Base-N/Base-X encoding/decoding functions.
    *
    * Original implementation from base-x:
    * https://github.com/cryptocoinjs/base-x
    *
    * Which is MIT licensed:
    *
    * The MIT License (MIT)
    *
    * Copyright base-x contributors (c) 2016
    *
    * Permission is hereby granted, free of charge, to any person obtaining a copy
    * of this software and associated documentation files (the "Software"), to deal
    * in the Software without restriction, including without limitation the rights
    * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    * copies of the Software, and to permit persons to whom the Software is
    * furnished to do so, subject to the following conditions:
    *
    * The above copyright notice and this permission notice shall be included in
    * all copies or substantial portions of the Software.
    *
    * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
    * DEALINGS IN THE SOFTWARE.
    */
    var api = {};
    module.exports = api; // baseN alphabet indexes

    var _reverseAlphabets = {};
    /**
     * BaseN-encodes a Uint8Array using the given alphabet.
     *
     * @param input the Uint8Array to encode.
     * @param maxline the maximum number of encoded characters per line to use,
     *          defaults to none.
     *
     * @return the baseN-encoded output string.
     */

    api.encode = function (input, alphabet, maxline) {
      if (typeof alphabet !== 'string') {
        throw new TypeError('"alphabet" must be a string.');
      }

      if (maxline !== undefined && typeof maxline !== 'number') {
        throw new TypeError('"maxline" must be a number.');
      }

      var output = '';

      if (!(input instanceof Uint8Array)) {
        // assume forge byte buffer
        output = _encodeWithByteBuffer(input, alphabet);
      } else {
        var i = 0;
        var base = alphabet.length;
        var first = alphabet.charAt(0);
        var digits = [0];

        for (i = 0; i < input.length; ++i) {
          for (var j = 0, carry = input[i]; j < digits.length; ++j) {
            carry += digits[j] << 8;
            digits[j] = carry % base;
            carry = carry / base | 0;
          }

          while (carry > 0) {
            digits.push(carry % base);
            carry = carry / base | 0;
          }
        } // deal with leading zeros


        for (i = 0; input[i] === 0 && i < input.length - 1; ++i) {
          output += first;
        } // convert digits to a string


        for (i = digits.length - 1; i >= 0; --i) {
          output += alphabet[digits[i]];
        }
      }

      if (maxline) {
        var regex = new RegExp('.{1,' + maxline + '}', 'g');
        output = output.match(regex).join('\r\n');
      }

      return output;
    };
    /**
     * Decodes a baseN-encoded (using the given alphabet) string to a
     * Uint8Array.
     *
     * @param input the baseN-encoded input string.
     *
     * @return the Uint8Array.
     */


    api.decode = function (input, alphabet) {
      if (typeof input !== 'string') {
        throw new TypeError('"input" must be a string.');
      }

      if (typeof alphabet !== 'string') {
        throw new TypeError('"alphabet" must be a string.');
      }

      var table = _reverseAlphabets[alphabet];

      if (!table) {
        // compute reverse alphabet
        table = _reverseAlphabets[alphabet] = [];

        for (var i = 0; i < alphabet.length; ++i) {
          table[alphabet.charCodeAt(i)] = i;
        }
      } // remove whitespace characters


      input = input.replace(/\s/g, '');
      var base = alphabet.length;
      var first = alphabet.charAt(0);
      var bytes = [0];

      for (var i = 0; i < input.length; i++) {
        var value = table[input.charCodeAt(i)];

        if (value === undefined) {
          return;
        }

        for (var j = 0, carry = value; j < bytes.length; ++j) {
          carry += bytes[j] * base;
          bytes[j] = carry & 0xff;
          carry >>= 8;
        }

        while (carry > 0) {
          bytes.push(carry & 0xff);
          carry >>= 8;
        }
      } // deal with leading zeros


      for (var k = 0; input[k] === first && k < input.length - 1; ++k) {
        bytes.push(0);
      }

      if (typeof Buffer !== 'undefined') {
        return Buffer.from(bytes.reverse());
      }

      return new Uint8Array(bytes.reverse());
    };

    function _encodeWithByteBuffer(input, alphabet) {
      var i = 0;
      var base = alphabet.length;
      var first = alphabet.charAt(0);
      var digits = [0];

      for (i = 0; i < input.length(); ++i) {
        for (var j = 0, carry = input.at(i); j < digits.length; ++j) {
          carry += digits[j] << 8;
          digits[j] = carry % base;
          carry = carry / base | 0;
        }

        while (carry > 0) {
          digits.push(carry % base);
          carry = carry / base | 0;
        }
      }

      var output = ''; // deal with leading zeros

      for (i = 0; input.at(i) === 0 && i < input.length() - 1; ++i) {
        output += first;
      } // convert digits to a string


      for (i = digits.length - 1; i >= 0; --i) {
        output += alphabet[digits[i]];
      }

      return output;
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 540 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Node.js module for Forge mask generation functions.
   *
   * @author Stefan Siegl
   *
   * Copyright 2012 Stefan Siegl <stesie@brokenpipe.de>
   */
  var forge = __webpack_require__(6);

  __webpack_require__(224);

  module.exports = forge.mgf = forge.mgf || {};
  forge.mgf.mgf1 = forge.mgf1;
  /***/
},
/* 541 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Javascript implementation of PKCS#12.
   *
   * @author Dave Longley
   * @author Stefan Siegl <stesie@brokenpipe.de>
   *
   * Copyright (c) 2010-2014 Digital Bazaar, Inc.
   * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
   *
   * The ASN.1 representation of PKCS#12 is as follows
   * (see ftp://ftp.rsasecurity.com/pub/pkcs/pkcs-12/pkcs-12-tc1.pdf for details)
   *
   * PFX ::= SEQUENCE {
   *   version  INTEGER {v3(3)}(v3,...),
   *   authSafe ContentInfo,
   *   macData  MacData OPTIONAL
   * }
   *
   * MacData ::= SEQUENCE {
   *   mac DigestInfo,
   *   macSalt OCTET STRING,
   *   iterations INTEGER DEFAULT 1
   * }
   * Note: The iterations default is for historical reasons and its use is
   * deprecated. A higher value, like 1024, is recommended.
   *
   * DigestInfo is defined in PKCS#7 as follows:
   *
   * DigestInfo ::= SEQUENCE {
   *   digestAlgorithm DigestAlgorithmIdentifier,
   *   digest Digest
   * }
   *
   * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
   *
   * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
   * for the algorithm, if any. In the case of SHA1 there is none.
   *
   * AlgorithmIdentifer ::= SEQUENCE {
   *    algorithm OBJECT IDENTIFIER,
   *    parameters ANY DEFINED BY algorithm OPTIONAL
   * }
   *
   * Digest ::= OCTET STRING
   *
   *
   * ContentInfo ::= SEQUENCE {
   *   contentType ContentType,
   *   content     [0] EXPLICIT ANY DEFINED BY contentType OPTIONAL
   * }
   *
   * ContentType ::= OBJECT IDENTIFIER
   *
   * AuthenticatedSafe ::= SEQUENCE OF ContentInfo
   * -- Data if unencrypted
   * -- EncryptedData if password-encrypted
   * -- EnvelopedData if public key-encrypted
   *
   *
   * SafeContents ::= SEQUENCE OF SafeBag
   *
   * SafeBag ::= SEQUENCE {
   *   bagId     BAG-TYPE.&id ({PKCS12BagSet})
   *   bagValue  [0] EXPLICIT BAG-TYPE.&Type({PKCS12BagSet}{@bagId}),
   *   bagAttributes SET OF PKCS12Attribute OPTIONAL
   * }
   *
   * PKCS12Attribute ::= SEQUENCE {
   *   attrId ATTRIBUTE.&id ({PKCS12AttrSet}),
   *   attrValues SET OF ATTRIBUTE.&Type ({PKCS12AttrSet}{@attrId})
   * } -- This type is compatible with the X.500 type ’Attribute’
   *
   * PKCS12AttrSet ATTRIBUTE ::= {
   *   friendlyName | -- from PKCS #9
   *   localKeyId, -- from PKCS #9
   *   ... -- Other attributes are allowed
   * }
   *
   * CertBag ::= SEQUENCE {
   *   certId    BAG-TYPE.&id   ({CertTypes}),
   *   certValue [0] EXPLICIT BAG-TYPE.&Type ({CertTypes}{@certId})
   * }
   *
   * x509Certificate BAG-TYPE ::= {OCTET STRING IDENTIFIED BY {certTypes 1}}
   *   -- DER-encoded X.509 certificate stored in OCTET STRING
   *
   * sdsiCertificate BAG-TYPE ::= {IA5String IDENTIFIED BY {certTypes 2}}
   * -- Base64-encoded SDSI certificate stored in IA5String
   *
   * CertTypes BAG-TYPE ::= {
   *   x509Certificate |
   *   sdsiCertificate,
   *   ... -- For future extensions
   * }
   */
  var forge = __webpack_require__(6);

  __webpack_require__(46);

  __webpack_require__(145);

  __webpack_require__(61);

  __webpack_require__(227);

  __webpack_require__(225);

  __webpack_require__(47);

  __webpack_require__(101);

  __webpack_require__(148);

  __webpack_require__(8);

  __webpack_require__(149); // shortcut for asn.1 & PKI API


  var asn1 = forge.asn1;
  var pki = forge.pki; // shortcut for PKCS#12 API

  var p12 = module.exports = forge.pkcs12 = forge.pkcs12 || {};
  var contentInfoValidator = {
    name: 'ContentInfo',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    // a ContentInfo
    constructed: true,
    value: [{
      name: 'ContentInfo.contentType',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OID,
      constructed: false,
      capture: 'contentType'
    }, {
      name: 'ContentInfo.content',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      constructed: true,
      captureAsn1: 'content'
    }]
  };
  var pfxValidator = {
    name: 'PFX',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'PFX.version',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.INTEGER,
      constructed: false,
      capture: 'version'
    }, contentInfoValidator, {
      name: 'PFX.macData',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SEQUENCE,
      constructed: true,
      optional: true,
      captureAsn1: 'mac',
      value: [{
        name: 'PFX.macData.mac',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        // DigestInfo
        constructed: true,
        value: [{
          name: 'PFX.macData.mac.digestAlgorithm',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.SEQUENCE,
          // DigestAlgorithmIdentifier
          constructed: true,
          value: [{
            name: 'PFX.macData.mac.digestAlgorithm.algorithm',
            tagClass: asn1.Class.UNIVERSAL,
            type: asn1.Type.OID,
            constructed: false,
            capture: 'macAlgorithm'
          }, {
            name: 'PFX.macData.mac.digestAlgorithm.parameters',
            tagClass: asn1.Class.UNIVERSAL,
            captureAsn1: 'macAlgorithmParameters'
          }]
        }, {
          name: 'PFX.macData.mac.digest',
          tagClass: asn1.Class.UNIVERSAL,
          type: asn1.Type.OCTETSTRING,
          constructed: false,
          capture: 'macDigest'
        }]
      }, {
        name: 'PFX.macData.macSalt',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.OCTETSTRING,
        constructed: false,
        capture: 'macSalt'
      }, {
        name: 'PFX.macData.iterations',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.INTEGER,
        constructed: false,
        optional: true,
        capture: 'macIterations'
      }]
    }]
  };
  var safeBagValidator = {
    name: 'SafeBag',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'SafeBag.bagId',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OID,
      constructed: false,
      capture: 'bagId'
    }, {
      name: 'SafeBag.bagValue',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      constructed: true,
      captureAsn1: 'bagValue'
    }, {
      name: 'SafeBag.bagAttributes',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SET,
      constructed: true,
      optional: true,
      capture: 'bagAttributes'
    }]
  };
  var attributeValidator = {
    name: 'Attribute',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'Attribute.attrId',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OID,
      constructed: false,
      capture: 'oid'
    }, {
      name: 'Attribute.attrValues',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.SET,
      constructed: true,
      capture: 'values'
    }]
  };
  var certBagValidator = {
    name: 'CertBag',
    tagClass: asn1.Class.UNIVERSAL,
    type: asn1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: 'CertBag.certId',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.OID,
      constructed: false,
      capture: 'certId'
    }, {
      name: 'CertBag.certValue',
      tagClass: asn1.Class.CONTEXT_SPECIFIC,
      constructed: true,

      /* So far we only support X.509 certificates (which are wrapped in
         an OCTET STRING, hence hard code that here). */
      value: [{
        name: 'CertBag.certValue[0]',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Class.OCTETSTRING,
        constructed: false,
        capture: 'cert'
      }]
    }]
  };
  /**
   * Search SafeContents structure for bags with matching attributes.
   *
   * The search can optionally be narrowed by a certain bag type.
   *
   * @param safeContents the SafeContents structure to search in.
   * @param attrName the name of the attribute to compare against.
   * @param attrValue the attribute value to search for.
   * @param [bagType] bag type to narrow search by.
   *
   * @return an array of matching bags.
   */

  function _getBagsByAttribute(safeContents, attrName, attrValue, bagType) {
    var result = [];

    for (var i = 0; i < safeContents.length; i++) {
      for (var j = 0; j < safeContents[i].safeBags.length; j++) {
        var bag = safeContents[i].safeBags[j];

        if (bagType !== undefined && bag.type !== bagType) {
          continue;
        } // only filter by bag type, no attribute specified


        if (attrName === null) {
          result.push(bag);
          continue;
        }

        if (bag.attributes[attrName] !== undefined && bag.attributes[attrName].indexOf(attrValue) >= 0) {
          result.push(bag);
        }
      }
    }

    return result;
  }
  /**
   * Converts a PKCS#12 PFX in ASN.1 notation into a PFX object.
   *
   * @param obj The PKCS#12 PFX in ASN.1 notation.
   * @param strict true to use strict DER decoding, false not to (default: true).
   * @param {String} password Password to decrypt with (optional).
   *
   * @return PKCS#12 PFX object.
   */


  p12.pkcs12FromAsn1 = function (obj, strict, password) {
    // handle args
    if (typeof strict === 'string') {
      password = strict;
      strict = true;
    } else if (strict === undefined) {
      strict = true;
    } // validate PFX and capture data


    var capture = {};
    var errors = [];

    if (!asn1.validate(obj, pfxValidator, capture, errors)) {
      var error = new Error('Cannot read PKCS#12 PFX. ' + 'ASN.1 object is not an PKCS#12 PFX.');
      error.errors = error;
      throw error;
    }

    var pfx = {
      version: capture.version.charCodeAt(0),
      safeContents: [],

      /**
       * Gets bags with matching attributes.
       *
       * @param filter the attributes to filter by:
       *          [localKeyId] the localKeyId to search for.
       *          [localKeyIdHex] the localKeyId in hex to search for.
       *          [friendlyName] the friendly name to search for.
       *          [bagType] bag type to narrow each attribute search by.
       *
       * @return a map of attribute type to an array of matching bags or, if no
       *           attribute was given but a bag type, the map key will be the
       *           bag type.
       */
      getBags: function getBags(filter) {
        var rval = {};
        var localKeyId;

        if ('localKeyId' in filter) {
          localKeyId = filter.localKeyId;
        } else if ('localKeyIdHex' in filter) {
          localKeyId = forge.util.hexToBytes(filter.localKeyIdHex);
        } // filter on bagType only


        if (localKeyId === undefined && !('friendlyName' in filter) && 'bagType' in filter) {
          rval[filter.bagType] = _getBagsByAttribute(pfx.safeContents, null, null, filter.bagType);
        }

        if (localKeyId !== undefined) {
          rval.localKeyId = _getBagsByAttribute(pfx.safeContents, 'localKeyId', localKeyId, filter.bagType);
        }

        if ('friendlyName' in filter) {
          rval.friendlyName = _getBagsByAttribute(pfx.safeContents, 'friendlyName', filter.friendlyName, filter.bagType);
        }

        return rval;
      },

      /**
       * DEPRECATED: use getBags() instead.
       *
       * Get bags with matching friendlyName attribute.
       *
       * @param friendlyName the friendly name to search for.
       * @param [bagType] bag type to narrow search by.
       *
       * @return an array of bags with matching friendlyName attribute.
       */
      getBagsByFriendlyName: function getBagsByFriendlyName(friendlyName, bagType) {
        return _getBagsByAttribute(pfx.safeContents, 'friendlyName', friendlyName, bagType);
      },

      /**
       * DEPRECATED: use getBags() instead.
       *
       * Get bags with matching localKeyId attribute.
       *
       * @param localKeyId the localKeyId to search for.
       * @param [bagType] bag type to narrow search by.
       *
       * @return an array of bags with matching localKeyId attribute.
       */
      getBagsByLocalKeyId: function getBagsByLocalKeyId(localKeyId, bagType) {
        return _getBagsByAttribute(pfx.safeContents, 'localKeyId', localKeyId, bagType);
      }
    };

    if (capture.version.charCodeAt(0) !== 3) {
      var error = new Error('PKCS#12 PFX of version other than 3 not supported.');
      error.version = capture.version.charCodeAt(0);
      throw error;
    }

    if (asn1.derToOid(capture.contentType) !== pki.oids.data) {
      var error = new Error('Only PKCS#12 PFX in password integrity mode supported.');
      error.oid = asn1.derToOid(capture.contentType);
      throw error;
    }

    var data = capture.content.value[0];

    if (data.tagClass !== asn1.Class.UNIVERSAL || data.type !== asn1.Type.OCTETSTRING) {
      throw new Error('PKCS#12 authSafe content data is not an OCTET STRING.');
    }

    data = _decodePkcs7Data(data); // check for MAC

    if (capture.mac) {
      var md = null;
      var macKeyBytes = 0;
      var macAlgorithm = asn1.derToOid(capture.macAlgorithm);

      switch (macAlgorithm) {
        case pki.oids.sha1:
          md = forge.md.sha1.create();
          macKeyBytes = 20;
          break;

        case pki.oids.sha256:
          md = forge.md.sha256.create();
          macKeyBytes = 32;
          break;

        case pki.oids.sha384:
          md = forge.md.sha384.create();
          macKeyBytes = 48;
          break;

        case pki.oids.sha512:
          md = forge.md.sha512.create();
          macKeyBytes = 64;
          break;

        case pki.oids.md5:
          md = forge.md.md5.create();
          macKeyBytes = 16;
          break;
      }

      if (md === null) {
        throw new Error('PKCS#12 uses unsupported MAC algorithm: ' + macAlgorithm);
      } // verify MAC (iterations default to 1)


      var macSalt = new forge.util.ByteBuffer(capture.macSalt);
      var macIterations = 'macIterations' in capture ? parseInt(forge.util.bytesToHex(capture.macIterations), 16) : 1;
      var macKey = p12.generateKey(password, macSalt, 3, macIterations, macKeyBytes, md);
      var mac = forge.hmac.create();
      mac.start(md, macKey);
      mac.update(data.value);
      var macValue = mac.getMac();

      if (macValue.getBytes() !== capture.macDigest) {
        throw new Error('PKCS#12 MAC could not be verified. Invalid password?');
      }
    }

    _decodeAuthenticatedSafe(pfx, data.value, strict, password);

    return pfx;
  };
  /**
   * Decodes PKCS#7 Data. PKCS#7 (RFC 2315) defines "Data" as an OCTET STRING,
   * but it is sometimes an OCTET STRING that is composed/constructed of chunks,
   * each its own OCTET STRING. This is BER-encoding vs. DER-encoding. This
   * function transforms this corner-case into the usual simple,
   * non-composed/constructed OCTET STRING.
   *
   * This function may be moved to ASN.1 at some point to better deal with
   * more BER-encoding issues, should they arise.
   *
   * @param data the ASN.1 Data object to transform.
   */


  function _decodePkcs7Data(data) {
    // handle special case of "chunked" data content: an octet string composed
    // of other octet strings
    if (data.composed || data.constructed) {
      var value = forge.util.createBuffer();

      for (var i = 0; i < data.value.length; ++i) {
        value.putBytes(data.value[i].value);
      }

      data.composed = data.constructed = false;
      data.value = value.getBytes();
    }

    return data;
  }
  /**
   * Decode PKCS#12 AuthenticatedSafe (BER encoded) into PFX object.
   *
   * The AuthenticatedSafe is a BER-encoded SEQUENCE OF ContentInfo.
   *
   * @param pfx The PKCS#12 PFX object to fill.
   * @param {String} authSafe BER-encoded AuthenticatedSafe.
   * @param strict true to use strict DER decoding, false not to.
   * @param {String} password Password to decrypt with (optional).
   */


  function _decodeAuthenticatedSafe(pfx, authSafe, strict, password) {
    authSafe = asn1.fromDer(authSafe, strict);
    /* actually it's BER encoded */

    if (authSafe.tagClass !== asn1.Class.UNIVERSAL || authSafe.type !== asn1.Type.SEQUENCE || authSafe.constructed !== true) {
      throw new Error('PKCS#12 AuthenticatedSafe expected to be a ' + 'SEQUENCE OF ContentInfo');
    }

    for (var i = 0; i < authSafe.value.length; i++) {
      var contentInfo = authSafe.value[i]; // validate contentInfo and capture data

      var capture = {};
      var errors = [];

      if (!asn1.validate(contentInfo, contentInfoValidator, capture, errors)) {
        var error = new Error('Cannot read ContentInfo.');
        error.errors = errors;
        throw error;
      }

      var obj = {
        encrypted: false
      };
      var safeContents = null;
      var data = capture.content.value[0];

      switch (asn1.derToOid(capture.contentType)) {
        case pki.oids.data:
          if (data.tagClass !== asn1.Class.UNIVERSAL || data.type !== asn1.Type.OCTETSTRING) {
            throw new Error('PKCS#12 SafeContents Data is not an OCTET STRING.');
          }

          safeContents = _decodePkcs7Data(data).value;
          break;

        case pki.oids.encryptedData:
          safeContents = _decryptSafeContents(data, password);
          obj.encrypted = true;
          break;

        default:
          var error = new Error('Unsupported PKCS#12 contentType.');
          error.contentType = asn1.derToOid(capture.contentType);
          throw error;
      }

      obj.safeBags = _decodeSafeContents(safeContents, strict, password);
      pfx.safeContents.push(obj);
    }
  }
  /**
   * Decrypt PKCS#7 EncryptedData structure.
   *
   * @param data ASN.1 encoded EncryptedContentInfo object.
   * @param password The user-provided password.
   *
   * @return The decrypted SafeContents (ASN.1 object).
   */


  function _decryptSafeContents(data, password) {
    var capture = {};
    var errors = [];

    if (!asn1.validate(data, forge.pkcs7.asn1.encryptedDataValidator, capture, errors)) {
      var error = new Error('Cannot read EncryptedContentInfo.');
      error.errors = errors;
      throw error;
    }

    var oid = asn1.derToOid(capture.contentType);

    if (oid !== pki.oids.data) {
      var error = new Error('PKCS#12 EncryptedContentInfo ContentType is not Data.');
      error.oid = oid;
      throw error;
    } // get cipher


    oid = asn1.derToOid(capture.encAlgorithm);
    var cipher = pki.pbe.getCipher(oid, capture.encParameter, password); // get encrypted data

    var encryptedContentAsn1 = _decodePkcs7Data(capture.encryptedContentAsn1);

    var encrypted = forge.util.createBuffer(encryptedContentAsn1.value);
    cipher.update(encrypted);

    if (!cipher.finish()) {
      throw new Error('Failed to decrypt PKCS#12 SafeContents.');
    }

    return cipher.output.getBytes();
  }
  /**
   * Decode PKCS#12 SafeContents (BER-encoded) into array of Bag objects.
   *
   * The safeContents is a BER-encoded SEQUENCE OF SafeBag.
   *
   * @param {String} safeContents BER-encoded safeContents.
   * @param strict true to use strict DER decoding, false not to.
   * @param {String} password Password to decrypt with (optional).
   *
   * @return {Array} Array of Bag objects.
   */


  function _decodeSafeContents(safeContents, strict, password) {
    // if strict and no safe contents, return empty safes
    if (!strict && safeContents.length === 0) {
      return [];
    } // actually it's BER-encoded


    safeContents = asn1.fromDer(safeContents, strict);

    if (safeContents.tagClass !== asn1.Class.UNIVERSAL || safeContents.type !== asn1.Type.SEQUENCE || safeContents.constructed !== true) {
      throw new Error('PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag.');
    }

    var res = [];

    for (var i = 0; i < safeContents.value.length; i++) {
      var safeBag = safeContents.value[i]; // validate SafeBag and capture data

      var capture = {};
      var errors = [];

      if (!asn1.validate(safeBag, safeBagValidator, capture, errors)) {
        var error = new Error('Cannot read SafeBag.');
        error.errors = errors;
        throw error;
      }
      /* Create bag object and push to result array. */


      var bag = {
        type: asn1.derToOid(capture.bagId),
        attributes: _decodeBagAttributes(capture.bagAttributes)
      };
      res.push(bag);
      var validator, decoder;
      var bagAsn1 = capture.bagValue.value[0];

      switch (bag.type) {
        case pki.oids.pkcs8ShroudedKeyBag:
          /* bagAsn1 has a EncryptedPrivateKeyInfo, which we need to decrypt.
             Afterwards we can handle it like a keyBag,
             which is a PrivateKeyInfo. */
          bagAsn1 = pki.decryptPrivateKeyInfo(bagAsn1, password);

          if (bagAsn1 === null) {
            throw new Error('Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?');
          }

        /* fall through */

        case pki.oids.keyBag:
          /* A PKCS#12 keyBag is a simple PrivateKeyInfo as understood by our
             PKI module, hence we don't have to do validation/capturing here,
             just pass what we already got. */
          try {
            bag.key = pki.privateKeyFromAsn1(bagAsn1);
          } catch (e) {
            // ignore unknown key type, pass asn1 value
            bag.key = null;
            bag.asn1 = bagAsn1;
          }

          continue;

        /* Nothing more to do. */

        case pki.oids.certBag:
          /* A PKCS#12 certBag can wrap both X.509 and sdsi certificates.
             Therefore put the SafeBag content through another validator to
             capture the fields.  Afterwards check & store the results. */
          validator = certBagValidator;

          decoder = function decoder() {
            if (asn1.derToOid(capture.certId) !== pki.oids.x509Certificate) {
              var error = new Error('Unsupported certificate type, only X.509 supported.');
              error.oid = asn1.derToOid(capture.certId);
              throw error;
            } // true=produce cert hash


            var certAsn1 = asn1.fromDer(capture.cert, strict);

            try {
              bag.cert = pki.certificateFromAsn1(certAsn1, true);
            } catch (e) {
              // ignore unknown cert type, pass asn1 value
              bag.cert = null;
              bag.asn1 = certAsn1;
            }
          };

          break;

        default:
          var error = new Error('Unsupported PKCS#12 SafeBag type.');
          error.oid = bag.type;
          throw error;
      }
      /* Validate SafeBag value (i.e. CertBag, etc.) and capture data if needed. */


      if (validator !== undefined && !asn1.validate(bagAsn1, validator, capture, errors)) {
        var error = new Error('Cannot read PKCS#12 ' + validator.name);
        error.errors = errors;
        throw error;
      }
      /* Call decoder function from above to store the results. */


      decoder();
    }

    return res;
  }
  /**
   * Decode PKCS#12 SET OF PKCS12Attribute into JavaScript object.
   *
   * @param attributes SET OF PKCS12Attribute (ASN.1 object).
   *
   * @return the decoded attributes.
   */


  function _decodeBagAttributes(attributes) {
    var decodedAttrs = {};

    if (attributes !== undefined) {
      for (var i = 0; i < attributes.length; ++i) {
        var capture = {};
        var errors = [];

        if (!asn1.validate(attributes[i], attributeValidator, capture, errors)) {
          var error = new Error('Cannot read PKCS#12 BagAttribute.');
          error.errors = errors;
          throw error;
        }

        var oid = asn1.derToOid(capture.oid);

        if (pki.oids[oid] === undefined) {
          // unsupported attribute type, ignore.
          continue;
        }

        decodedAttrs[pki.oids[oid]] = [];

        for (var j = 0; j < capture.values.length; ++j) {
          decodedAttrs[pki.oids[oid]].push(capture.values[j].value);
        }
      }
    }

    return decodedAttrs;
  }
  /**
   * Wraps a private key and certificate in a PKCS#12 PFX wrapper. If a
   * password is provided then the private key will be encrypted.
   *
   * An entire certificate chain may also be included. To do this, pass
   * an array for the "cert" parameter where the first certificate is
   * the one that is paired with the private key and each subsequent one
   * verifies the previous one. The certificates may be in PEM format or
   * have been already parsed by Forge.
   *
   * @todo implement password-based-encryption for the whole package
   *
   * @param key the private key.
   * @param cert the certificate (may be an array of certificates in order
   *          to specify a certificate chain).
   * @param password the password to use, null for none.
   * @param options:
   *          algorithm the encryption algorithm to use
   *            ('aes128', 'aes192', 'aes256', '3des'), defaults to 'aes128'.
   *          count the iteration count to use.
   *          saltSize the salt size to use.
   *          useMac true to include a MAC, false not to, defaults to true.
   *          localKeyId the local key ID to use, in hex.
   *          friendlyName the friendly name to use.
   *          generateLocalKeyId true to generate a random local key ID,
   *            false not to, defaults to true.
   *
   * @return the PKCS#12 PFX ASN.1 object.
   */


  p12.toPkcs12Asn1 = function (key, cert, password, options) {
    // set default options
    options = options || {};
    options.saltSize = options.saltSize || 8;
    options.count = options.count || 2048;
    options.algorithm = options.algorithm || options.encAlgorithm || 'aes128';

    if (!('useMac' in options)) {
      options.useMac = true;
    }

    if (!('localKeyId' in options)) {
      options.localKeyId = null;
    }

    if (!('generateLocalKeyId' in options)) {
      options.generateLocalKeyId = true;
    }

    var localKeyId = options.localKeyId;
    var bagAttrs;

    if (localKeyId !== null) {
      localKeyId = forge.util.hexToBytes(localKeyId);
    } else if (options.generateLocalKeyId) {
      // use SHA-1 of paired cert, if available
      if (cert) {
        var pairedCert = forge.util.isArray(cert) ? cert[0] : cert;

        if (typeof pairedCert === 'string') {
          pairedCert = pki.certificateFromPem(pairedCert);
        }

        var sha1 = forge.md.sha1.create();
        sha1.update(asn1.toDer(pki.certificateToAsn1(pairedCert)).getBytes());
        localKeyId = sha1.digest().getBytes();
      } else {
        // FIXME: consider using SHA-1 of public key (which can be generated
        // from private key components), see: cert.generateSubjectKeyIdentifier
        // generate random bytes
        localKeyId = forge.random.getBytes(20);
      }
    }

    var attrs = [];

    if (localKeyId !== null) {
      attrs.push( // localKeyID
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// attrId
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(pki.oids.localKeyId).getBytes()), // attrValues
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, localKeyId)])]));
    }

    if ('friendlyName' in options) {
      attrs.push( // friendlyName
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// attrId
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(pki.oids.friendlyName).getBytes()), // attrValues
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.BMPSTRING, false, options.friendlyName)])]));
    }

    if (attrs.length > 0) {
      bagAttrs = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, attrs);
    } // collect contents for AuthenticatedSafe


    var contents = []; // create safe bag(s) for certificate chain

    var chain = [];

    if (cert !== null) {
      if (forge.util.isArray(cert)) {
        chain = cert;
      } else {
        chain = [cert];
      }
    }

    var certSafeBags = [];

    for (var i = 0; i < chain.length; ++i) {
      // convert cert from PEM as necessary
      cert = chain[i];

      if (typeof cert === 'string') {
        cert = pki.certificateFromPem(cert);
      } // SafeBag


      var certBagAttrs = i === 0 ? bagAttrs : undefined;
      var certAsn1 = pki.certificateToAsn1(cert);
      var certSafeBag = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// bagId
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(pki.oids.certBag).getBytes()), // bagValue
      asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [// CertBag
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// certId
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(pki.oids.x509Certificate).getBytes()), // certValue (x509Certificate)
      asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, asn1.toDer(certAsn1).getBytes())])])]), // bagAttributes (OPTIONAL)
      certBagAttrs]);
      certSafeBags.push(certSafeBag);
    }

    if (certSafeBags.length > 0) {
      // SafeContents
      var certSafeContents = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, certSafeBags); // ContentInfo

      var certCI = // PKCS#7 ContentInfo
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// contentType
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, // OID for the content type is 'data'
      asn1.oidToDer(pki.oids.data).getBytes()), // content
      asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, asn1.toDer(certSafeContents).getBytes())])]);
      contents.push(certCI);
    } // create safe contents for private key


    var keyBag = null;

    if (key !== null) {
      // SafeBag
      var pkAsn1 = pki.wrapRsaPrivateKey(pki.privateKeyToAsn1(key));

      if (password === null) {
        // no encryption
        keyBag = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// bagId
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(pki.oids.keyBag).getBytes()), // bagValue
        asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [// PrivateKeyInfo
        pkAsn1]), // bagAttributes (OPTIONAL)
        bagAttrs]);
      } else {
        // encrypted PrivateKeyInfo
        keyBag = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// bagId
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(pki.oids.pkcs8ShroudedKeyBag).getBytes()), // bagValue
        asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [// EncryptedPrivateKeyInfo
        pki.encryptPrivateKeyInfo(pkAsn1, password, options)]), // bagAttributes (OPTIONAL)
        bagAttrs]);
      } // SafeContents


      var keySafeContents = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [keyBag]); // ContentInfo

      var keyCI = // PKCS#7 ContentInfo
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// contentType
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, // OID for the content type is 'data'
      asn1.oidToDer(pki.oids.data).getBytes()), // content
      asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, asn1.toDer(keySafeContents).getBytes())])]);
      contents.push(keyCI);
    } // create AuthenticatedSafe by stringing together the contents


    var safe = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, contents);
    var macData;

    if (options.useMac) {
      // MacData
      var sha1 = forge.md.sha1.create();
      var macSalt = new forge.util.ByteBuffer(forge.random.getBytes(options.saltSize));
      var count = options.count; // 160-bit key

      var key = p12.generateKey(password, macSalt, 3, count, 20);
      var mac = forge.hmac.create();
      mac.start(sha1, key);
      mac.update(asn1.toDer(safe).getBytes());
      var macValue = mac.getMac();
      macData = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// mac DigestInfo
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// digestAlgorithm
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// algorithm = SHA-1
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(pki.oids.sha1).getBytes()), // parameters = Null
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '')]), // digest
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, macValue.getBytes())]), // macSalt OCTET STRING
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, macSalt.getBytes()), // iterations INTEGER (XXX: Only support count < 65536)
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(count).getBytes())]);
    } // PFX


    return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// version (3)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(3).getBytes()), // PKCS#7 ContentInfo
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// contentType
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, // OID for the content type is 'data'
    asn1.oidToDer(pki.oids.data).getBytes()), // content
    asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, asn1.toDer(safe).getBytes())])]), macData]);
  };
  /**
   * Derives a PKCS#12 key.
   *
   * @param password the password to derive the key material from, null or
   *          undefined for none.
   * @param salt the salt, as a ByteBuffer, to use.
   * @param id the PKCS#12 ID byte (1 = key material, 2 = IV, 3 = MAC).
   * @param iter the iteration count.
   * @param n the number of bytes to derive from the password.
   * @param md the message digest to use, defaults to SHA-1.
   *
   * @return a ByteBuffer with the bytes derived from the password.
   */


  p12.generateKey = forge.pbe.generatePkcs12Key;
  /***/
},
/* 542 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Javascript implementation of PKCS#7 v1.5.
   *
   * @author Stefan Siegl
   * @author Dave Longley
   *
   * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
   * Copyright (c) 2012-2015 Digital Bazaar, Inc.
   *
   * Currently this implementation only supports ContentType of EnvelopedData,
   * EncryptedData, or SignedData at the root level. The top level elements may
   * contain only a ContentInfo of ContentType Data, i.e. plain data. Further
   * nesting is not (yet) supported.
   *
   * The Forge validators for PKCS #7's ASN.1 structures are available from
   * a separate file pkcs7asn1.js, since those are referenced from other
   * PKCS standards like PKCS #12.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(79);

  __webpack_require__(46);

  __webpack_require__(144);

  __webpack_require__(61);

  __webpack_require__(80);

  __webpack_require__(227);

  __webpack_require__(47);

  __webpack_require__(8);

  __webpack_require__(149); // shortcut for ASN.1 API


  var asn1 = forge.asn1; // shortcut for PKCS#7 API

  var p7 = module.exports = forge.pkcs7 = forge.pkcs7 || {};
  /**
   * Converts a PKCS#7 message from PEM format.
   *
   * @param pem the PEM-formatted PKCS#7 message.
   *
   * @return the PKCS#7 message.
   */

  p7.messageFromPem = function (pem) {
    var msg = forge.pem.decode(pem)[0];

    if (msg.type !== 'PKCS7') {
      var error = new Error('Could not convert PKCS#7 message from PEM; PEM ' + 'header type is not "PKCS#7".');
      error.headerType = msg.type;
      throw error;
    }

    if (msg.procType && msg.procType.type === 'ENCRYPTED') {
      throw new Error('Could not convert PKCS#7 message from PEM; PEM is encrypted.');
    } // convert DER to ASN.1 object


    var obj = asn1.fromDer(msg.body);
    return p7.messageFromAsn1(obj);
  };
  /**
   * Converts a PKCS#7 message to PEM format.
   *
   * @param msg The PKCS#7 message object
   * @param maxline The maximum characters per line, defaults to 64.
   *
   * @return The PEM-formatted PKCS#7 message.
   */


  p7.messageToPem = function (msg, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var pemObj = {
      type: 'PKCS7',
      body: asn1.toDer(msg.toAsn1()).getBytes()
    };
    return forge.pem.encode(pemObj, {
      maxline: maxline
    });
  };
  /**
   * Converts a PKCS#7 message from an ASN.1 object.
   *
   * @param obj the ASN.1 representation of a ContentInfo.
   *
   * @return the PKCS#7 message.
   */


  p7.messageFromAsn1 = function (obj) {
    // validate root level ContentInfo and capture data
    var capture = {};
    var errors = [];

    if (!asn1.validate(obj, p7.asn1.contentInfoValidator, capture, errors)) {
      var error = new Error('Cannot read PKCS#7 message. ' + 'ASN.1 object is not an PKCS#7 ContentInfo.');
      error.errors = errors;
      throw error;
    }

    var contentType = asn1.derToOid(capture.contentType);
    var msg;

    switch (contentType) {
      case forge.pki.oids.envelopedData:
        msg = p7.createEnvelopedData();
        break;

      case forge.pki.oids.encryptedData:
        msg = p7.createEncryptedData();
        break;

      case forge.pki.oids.signedData:
        msg = p7.createSignedData();
        break;

      default:
        throw new Error('Cannot read PKCS#7 message. ContentType with OID ' + contentType + ' is not (yet) supported.');
    }

    msg.fromAsn1(capture.content.value[0]);
    return msg;
  };

  p7.createSignedData = function () {
    var msg = null;
    msg = {
      type: forge.pki.oids.signedData,
      version: 1,
      certificates: [],
      crls: [],
      // TODO: add json-formatted signer stuff here?
      signers: [],
      // populated during sign()
      digestAlgorithmIdentifiers: [],
      contentInfo: null,
      signerInfos: [],
      fromAsn1: function fromAsn1(obj) {
        // validate SignedData content block and capture data.
        _fromAsn1(msg, obj, p7.asn1.signedDataValidator);

        msg.certificates = [];
        msg.crls = [];
        msg.digestAlgorithmIdentifiers = [];
        msg.contentInfo = null;
        msg.signerInfos = [];

        if (msg.rawCapture.certificates) {
          var certs = msg.rawCapture.certificates.value;

          for (var i = 0; i < certs.length; ++i) {
            msg.certificates.push(forge.pki.certificateFromAsn1(certs[i]));
          }
        } // TODO: parse crls

      },
      toAsn1: function toAsn1() {
        // degenerate case with no content
        if (!msg.contentInfo) {
          msg.sign();
        }

        var certs = [];

        for (var i = 0; i < msg.certificates.length; ++i) {
          certs.push(forge.pki.certificateToAsn1(msg.certificates[i]));
        }

        var crls = []; // TODO: implement CRLs
        // [0] SignedData

        var signedData = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// Version
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(msg.version).getBytes()), // DigestAlgorithmIdentifiers
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, msg.digestAlgorithmIdentifiers), // ContentInfo
        msg.contentInfo])]);

        if (certs.length > 0) {
          // [0] IMPLICIT ExtendedCertificatesAndCertificates OPTIONAL
          signedData.value[0].value.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, certs));
        }

        if (crls.length > 0) {
          // [1] IMPLICIT CertificateRevocationLists OPTIONAL
          signedData.value[0].value.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 1, true, crls));
        } // SignerInfos


        signedData.value[0].value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, msg.signerInfos)); // ContentInfo

        return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// ContentType
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(msg.type).getBytes()), // [0] SignedData
        signedData]);
      },

      /**
       * Add (another) entity to list of signers.
       *
       * Note: If authenticatedAttributes are provided, then, per RFC 2315,
       * they must include at least two attributes: content type and
       * message digest. The message digest attribute value will be
       * auto-calculated during signing and will be ignored if provided.
       *
       * Here's an example of providing these two attributes:
       *
       * forge.pkcs7.createSignedData();
       * p7.addSigner({
       *   issuer: cert.issuer.attributes,
       *   serialNumber: cert.serialNumber,
       *   key: privateKey,
       *   digestAlgorithm: forge.pki.oids.sha1,
       *   authenticatedAttributes: [{
       *     type: forge.pki.oids.contentType,
       *     value: forge.pki.oids.data
       *   }, {
       *     type: forge.pki.oids.messageDigest
       *   }]
       * });
       *
       * TODO: Support [subjectKeyIdentifier] as signer's ID.
       *
       * @param signer the signer information:
       *          key the signer's private key.
       *          [certificate] a certificate containing the public key
       *            associated with the signer's private key; use this option as
       *            an alternative to specifying signer.issuer and
       *            signer.serialNumber.
       *          [issuer] the issuer attributes (eg: cert.issuer.attributes).
       *          [serialNumber] the signer's certificate's serial number in
       *           hexadecimal (eg: cert.serialNumber).
       *          [digestAlgorithm] the message digest OID, as a string, to use
       *            (eg: forge.pki.oids.sha1).
       *          [authenticatedAttributes] an optional array of attributes
       *            to also sign along with the content.
       */
      addSigner: function addSigner(signer) {
        var issuer = signer.issuer;
        var serialNumber = signer.serialNumber;

        if (signer.certificate) {
          var cert = signer.certificate;

          if (typeof cert === 'string') {
            cert = forge.pki.certificateFromPem(cert);
          }

          issuer = cert.issuer.attributes;
          serialNumber = cert.serialNumber;
        }

        var key = signer.key;

        if (!key) {
          throw new Error('Could not add PKCS#7 signer; no private key specified.');
        }

        if (typeof key === 'string') {
          key = forge.pki.privateKeyFromPem(key);
        } // ensure OID known for digest algorithm


        var digestAlgorithm = signer.digestAlgorithm || forge.pki.oids.sha1;

        switch (digestAlgorithm) {
          case forge.pki.oids.sha1:
          case forge.pki.oids.sha256:
          case forge.pki.oids.sha384:
          case forge.pki.oids.sha512:
          case forge.pki.oids.md5:
            break;

          default:
            throw new Error('Could not add PKCS#7 signer; unknown message digest algorithm: ' + digestAlgorithm);
        } // if authenticatedAttributes is present, then the attributes
        // must contain at least PKCS #9 content-type and message-digest


        var authenticatedAttributes = signer.authenticatedAttributes || [];

        if (authenticatedAttributes.length > 0) {
          var contentType = false;
          var messageDigest = false;

          for (var i = 0; i < authenticatedAttributes.length; ++i) {
            var attr = authenticatedAttributes[i];

            if (!contentType && attr.type === forge.pki.oids.contentType) {
              contentType = true;

              if (messageDigest) {
                break;
              }

              continue;
            }

            if (!messageDigest && attr.type === forge.pki.oids.messageDigest) {
              messageDigest = true;

              if (contentType) {
                break;
              }

              continue;
            }
          }

          if (!contentType || !messageDigest) {
            throw new Error('Invalid signer.authenticatedAttributes. If ' + 'signer.authenticatedAttributes is specified, then it must ' + 'contain at least two attributes, PKCS #9 content-type and ' + 'PKCS #9 message-digest.');
          }
        }

        msg.signers.push({
          key: key,
          version: 1,
          issuer: issuer,
          serialNumber: serialNumber,
          digestAlgorithm: digestAlgorithm,
          signatureAlgorithm: forge.pki.oids.rsaEncryption,
          signature: null,
          authenticatedAttributes: authenticatedAttributes,
          unauthenticatedAttributes: []
        });
      },

      /**
       * Signs the content.
       * @param options Options to apply when signing:
       *    [detached] boolean. If signing should be done in detached mode. Defaults to false.
       */
      sign: function sign(options) {
        options = options || {}; // auto-generate content info

        if (typeof msg.content !== 'object' || msg.contentInfo === null) {
          // use Data ContentInfo
          msg.contentInfo = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// ContentType
          asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(forge.pki.oids.data).getBytes())]); // add actual content, if present

          if ('content' in msg) {
            var content;

            if (msg.content instanceof forge.util.ByteBuffer) {
              content = msg.content.bytes();
            } else if (typeof msg.content === 'string') {
              content = forge.util.encodeUtf8(msg.content);
            }

            if (options.detached) {
              msg.detachedContent = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, content);
            } else {
              msg.contentInfo.value.push( // [0] EXPLICIT content
              asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, content)]));
            }
          }
        } // no signers, return early (degenerate case for certificate container)


        if (msg.signers.length === 0) {
          return;
        } // generate digest algorithm identifiers


        var mds = addDigestAlgorithmIds(); // generate signerInfos

        addSignerInfos(mds);
      },
      verify: function verify() {
        throw new Error('PKCS#7 signature verification not yet implemented.');
      },

      /**
       * Add a certificate.
       *
       * @param cert the certificate to add.
       */
      addCertificate: function addCertificate(cert) {
        // convert from PEM
        if (typeof cert === 'string') {
          cert = forge.pki.certificateFromPem(cert);
        }

        msg.certificates.push(cert);
      },

      /**
       * Add a certificate revokation list.
       *
       * @param crl the certificate revokation list to add.
       */
      addCertificateRevokationList: function addCertificateRevokationList(crl) {
        throw new Error('PKCS#7 CRL support not yet implemented.');
      }
    };
    return msg;

    function addDigestAlgorithmIds() {
      var mds = {};

      for (var i = 0; i < msg.signers.length; ++i) {
        var signer = msg.signers[i];
        var oid = signer.digestAlgorithm;

        if (!(oid in mds)) {
          // content digest
          mds[oid] = forge.md[forge.pki.oids[oid]].create();
        }

        if (signer.authenticatedAttributes.length === 0) {
          // no custom attributes to digest; use content message digest
          signer.md = mds[oid];
        } else {
          // custom attributes to be digested; use own message digest
          // TODO: optimize to just copy message digest state if that
          // feature is ever supported with message digests
          signer.md = forge.md[forge.pki.oids[oid]].create();
        }
      } // add unique digest algorithm identifiers


      msg.digestAlgorithmIdentifiers = [];

      for (var oid in mds) {
        msg.digestAlgorithmIdentifiers.push( // AlgorithmIdentifier
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// algorithm
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(oid).getBytes()), // parameters (null)
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '')]));
      }

      return mds;
    }

    function addSignerInfos(mds) {
      var content;

      if (msg.detachedContent) {
        // Signature has been made in detached mode.
        content = msg.detachedContent;
      } else {
        // Note: ContentInfo is a SEQUENCE with 2 values, second value is
        // the content field and is optional for a ContentInfo but required here
        // since signers are present
        // get ContentInfo content
        content = msg.contentInfo.value[1]; // skip [0] EXPLICIT content wrapper

        content = content.value[0];
      }

      if (!content) {
        throw new Error('Could not sign PKCS#7 message; there is no content to sign.');
      } // get ContentInfo content type


      var contentType = asn1.derToOid(msg.contentInfo.value[0].value); // serialize content

      var bytes = asn1.toDer(content); // skip identifier and length per RFC 2315 9.3
      // skip identifier (1 byte)

      bytes.getByte(); // read and discard length bytes

      asn1.getBerValueLength(bytes);
      bytes = bytes.getBytes(); // digest content DER value bytes

      for (var oid in mds) {
        mds[oid].start().update(bytes);
      } // sign content


      var signingTime = new Date();

      for (var i = 0; i < msg.signers.length; ++i) {
        var signer = msg.signers[i];

        if (signer.authenticatedAttributes.length === 0) {
          // if ContentInfo content type is not "Data", then
          // authenticatedAttributes must be present per RFC 2315
          if (contentType !== forge.pki.oids.data) {
            throw new Error('Invalid signer; authenticatedAttributes must be present ' + 'when the ContentInfo content type is not PKCS#7 Data.');
          }
        } else {
          // process authenticated attributes
          // [0] IMPLICIT
          signer.authenticatedAttributesAsn1 = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, []); // per RFC 2315, attributes are to be digested using a SET container
          // not the above [0] IMPLICIT container

          var attrsAsn1 = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, []);

          for (var ai = 0; ai < signer.authenticatedAttributes.length; ++ai) {
            var attr = signer.authenticatedAttributes[ai];

            if (attr.type === forge.pki.oids.messageDigest) {
              // use content message digest as value
              attr.value = mds[signer.digestAlgorithm].digest();
            } else if (attr.type === forge.pki.oids.signingTime) {
              // auto-populate signing time if not already set
              if (!attr.value) {
                attr.value = signingTime;
              }
            } // convert to ASN.1 and push onto Attributes SET (for signing) and
            // onto authenticatedAttributesAsn1 to complete SignedData ASN.1
            // TODO: optimize away duplication


            attrsAsn1.value.push(_attributeToAsn1(attr));
            signer.authenticatedAttributesAsn1.value.push(_attributeToAsn1(attr));
          } // DER-serialize and digest SET OF attributes only


          bytes = asn1.toDer(attrsAsn1).getBytes();
          signer.md.start().update(bytes);
        } // sign digest


        signer.signature = signer.key.sign(signer.md, 'RSASSA-PKCS1-V1_5');
      } // add signer info


      msg.signerInfos = _signersToAsn1(msg.signers);
    }
  };
  /**
   * Creates an empty PKCS#7 message of type EncryptedData.
   *
   * @return the message.
   */


  p7.createEncryptedData = function () {
    var msg = null;
    msg = {
      type: forge.pki.oids.encryptedData,
      version: 0,
      encryptedContent: {
        algorithm: forge.pki.oids['aes256-CBC']
      },

      /**
       * Reads an EncryptedData content block (in ASN.1 format)
       *
       * @param obj The ASN.1 representation of the EncryptedData content block
       */
      fromAsn1: function fromAsn1(obj) {
        // Validate EncryptedData content block and capture data.
        _fromAsn1(msg, obj, p7.asn1.encryptedDataValidator);
      },

      /**
       * Decrypt encrypted content
       *
       * @param key The (symmetric) key as a byte buffer
       */
      decrypt: function decrypt(key) {
        if (key !== undefined) {
          msg.encryptedContent.key = key;
        }

        _decryptContent(msg);
      }
    };
    return msg;
  };
  /**
   * Creates an empty PKCS#7 message of type EnvelopedData.
   *
   * @return the message.
   */


  p7.createEnvelopedData = function () {
    var msg = null;
    msg = {
      type: forge.pki.oids.envelopedData,
      version: 0,
      recipients: [],
      encryptedContent: {
        algorithm: forge.pki.oids['aes256-CBC']
      },

      /**
       * Reads an EnvelopedData content block (in ASN.1 format)
       *
       * @param obj the ASN.1 representation of the EnvelopedData content block.
       */
      fromAsn1: function fromAsn1(obj) {
        // validate EnvelopedData content block and capture data
        var capture = _fromAsn1(msg, obj, p7.asn1.envelopedDataValidator);

        msg.recipients = _recipientsFromAsn1(capture.recipientInfos.value);
      },
      toAsn1: function toAsn1() {
        // ContentInfo
        return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// ContentType
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(msg.type).getBytes()), // [0] EnvelopedData
        asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// Version
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(msg.version).getBytes()), // RecipientInfos
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, _recipientsToAsn1(msg.recipients)), // EncryptedContentInfo
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, _encryptedContentToAsn1(msg.encryptedContent))])])]);
      },

      /**
       * Find recipient by X.509 certificate's issuer.
       *
       * @param cert the certificate with the issuer to look for.
       *
       * @return the recipient object.
       */
      findRecipient: function findRecipient(cert) {
        var sAttr = cert.issuer.attributes;

        for (var i = 0; i < msg.recipients.length; ++i) {
          var r = msg.recipients[i];
          var rAttr = r.issuer;

          if (r.serialNumber !== cert.serialNumber) {
            continue;
          }

          if (rAttr.length !== sAttr.length) {
            continue;
          }

          var match = true;

          for (var j = 0; j < sAttr.length; ++j) {
            if (rAttr[j].type !== sAttr[j].type || rAttr[j].value !== sAttr[j].value) {
              match = false;
              break;
            }
          }

          if (match) {
            return r;
          }
        }

        return null;
      },

      /**
       * Decrypt enveloped content
       *
       * @param recipient The recipient object related to the private key
       * @param privKey The (RSA) private key object
       */
      decrypt: function decrypt(recipient, privKey) {
        if (msg.encryptedContent.key === undefined && recipient !== undefined && privKey !== undefined) {
          switch (recipient.encryptedContent.algorithm) {
            case forge.pki.oids.rsaEncryption:
            case forge.pki.oids.desCBC:
              var key = privKey.decrypt(recipient.encryptedContent.content);
              msg.encryptedContent.key = forge.util.createBuffer(key);
              break;

            default:
              throw new Error('Unsupported asymmetric cipher, ' + 'OID ' + recipient.encryptedContent.algorithm);
          }
        }

        _decryptContent(msg);
      },

      /**
       * Add (another) entity to list of recipients.
       *
       * @param cert The certificate of the entity to add.
       */
      addRecipient: function addRecipient(cert) {
        msg.recipients.push({
          version: 0,
          issuer: cert.issuer.attributes,
          serialNumber: cert.serialNumber,
          encryptedContent: {
            // We simply assume rsaEncryption here, since forge.pki only
            // supports RSA so far.  If the PKI module supports other
            // ciphers one day, we need to modify this one as well.
            algorithm: forge.pki.oids.rsaEncryption,
            key: cert.publicKey
          }
        });
      },

      /**
       * Encrypt enveloped content.
       *
       * This function supports two optional arguments, cipher and key, which
       * can be used to influence symmetric encryption.  Unless cipher is
       * provided, the cipher specified in encryptedContent.algorithm is used
       * (defaults to AES-256-CBC).  If no key is provided, encryptedContent.key
       * is (re-)used.  If that one's not set, a random key will be generated
       * automatically.
       *
       * @param [key] The key to be used for symmetric encryption.
       * @param [cipher] The OID of the symmetric cipher to use.
       */
      encrypt: function encrypt(key, cipher) {
        // Part 1: Symmetric encryption
        if (msg.encryptedContent.content === undefined) {
          cipher = cipher || msg.encryptedContent.algorithm;
          key = key || msg.encryptedContent.key;
          var keyLen, ivLen, ciphFn;

          switch (cipher) {
            case forge.pki.oids['aes128-CBC']:
              keyLen = 16;
              ivLen = 16;
              ciphFn = forge.aes.createEncryptionCipher;
              break;

            case forge.pki.oids['aes192-CBC']:
              keyLen = 24;
              ivLen = 16;
              ciphFn = forge.aes.createEncryptionCipher;
              break;

            case forge.pki.oids['aes256-CBC']:
              keyLen = 32;
              ivLen = 16;
              ciphFn = forge.aes.createEncryptionCipher;
              break;

            case forge.pki.oids['des-EDE3-CBC']:
              keyLen = 24;
              ivLen = 8;
              ciphFn = forge.des.createEncryptionCipher;
              break;

            default:
              throw new Error('Unsupported symmetric cipher, OID ' + cipher);
          }

          if (key === undefined) {
            key = forge.util.createBuffer(forge.random.getBytes(keyLen));
          } else if (key.length() != keyLen) {
            throw new Error('Symmetric key has wrong length; ' + 'got ' + key.length() + ' bytes, expected ' + keyLen + '.');
          } // Keep a copy of the key & IV in the object, so the caller can
          // use it for whatever reason.


          msg.encryptedContent.algorithm = cipher;
          msg.encryptedContent.key = key;
          msg.encryptedContent.parameter = forge.util.createBuffer(forge.random.getBytes(ivLen));
          var ciph = ciphFn(key);
          ciph.start(msg.encryptedContent.parameter.copy());
          ciph.update(msg.content); // The finish function does PKCS#7 padding by default, therefore
          // no action required by us.

          if (!ciph.finish()) {
            throw new Error('Symmetric encryption failed.');
          }

          msg.encryptedContent.content = ciph.output;
        } // Part 2: asymmetric encryption for each recipient


        for (var i = 0; i < msg.recipients.length; ++i) {
          var recipient = msg.recipients[i]; // Nothing to do, encryption already done.

          if (recipient.encryptedContent.content !== undefined) {
            continue;
          }

          switch (recipient.encryptedContent.algorithm) {
            case forge.pki.oids.rsaEncryption:
              recipient.encryptedContent.content = recipient.encryptedContent.key.encrypt(msg.encryptedContent.key.data);
              break;

            default:
              throw new Error('Unsupported asymmetric cipher, OID ' + recipient.encryptedContent.algorithm);
          }
        }
      }
    };
    return msg;
  };
  /**
   * Converts a single recipient from an ASN.1 object.
   *
   * @param obj the ASN.1 RecipientInfo.
   *
   * @return the recipient object.
   */


  function _recipientFromAsn1(obj) {
    // validate EnvelopedData content block and capture data
    var capture = {};
    var errors = [];

    if (!asn1.validate(obj, p7.asn1.recipientInfoValidator, capture, errors)) {
      var error = new Error('Cannot read PKCS#7 RecipientInfo. ' + 'ASN.1 object is not an PKCS#7 RecipientInfo.');
      error.errors = errors;
      throw error;
    }

    return {
      version: capture.version.charCodeAt(0),
      issuer: forge.pki.RDNAttributesAsArray(capture.issuer),
      serialNumber: forge.util.createBuffer(capture.serial).toHex(),
      encryptedContent: {
        algorithm: asn1.derToOid(capture.encAlgorithm),
        parameter: capture.encParameter.value,
        content: capture.encKey
      }
    };
  }
  /**
   * Converts a single recipient object to an ASN.1 object.
   *
   * @param obj the recipient object.
   *
   * @return the ASN.1 RecipientInfo.
   */


  function _recipientToAsn1(obj) {
    return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// Version
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(obj.version).getBytes()), // IssuerAndSerialNumber
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// Name
    forge.pki.distinguishedNameToAsn1({
      attributes: obj.issuer
    }), // Serial
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, forge.util.hexToBytes(obj.serialNumber))]), // KeyEncryptionAlgorithmIdentifier
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// Algorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(obj.encryptedContent.algorithm).getBytes()), // Parameter, force NULL, only RSA supported for now.
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '')]), // EncryptedKey
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, obj.encryptedContent.content)]);
  }
  /**
   * Map a set of RecipientInfo ASN.1 objects to recipient objects.
   *
   * @param infos an array of ASN.1 representations RecipientInfo (i.e. SET OF).
   *
   * @return an array of recipient objects.
   */


  function _recipientsFromAsn1(infos) {
    var ret = [];

    for (var i = 0; i < infos.length; ++i) {
      ret.push(_recipientFromAsn1(infos[i]));
    }

    return ret;
  }
  /**
   * Map an array of recipient objects to ASN.1 RecipientInfo objects.
   *
   * @param recipients an array of recipientInfo objects.
   *
   * @return an array of ASN.1 RecipientInfos.
   */


  function _recipientsToAsn1(recipients) {
    var ret = [];

    for (var i = 0; i < recipients.length; ++i) {
      ret.push(_recipientToAsn1(recipients[i]));
    }

    return ret;
  }
  /**
   * Converts a single signer from an ASN.1 object.
   *
   * @param obj the ASN.1 representation of a SignerInfo.
   *
   * @return the signer object.
   */


  function _signerFromAsn1(obj) {
    // validate EnvelopedData content block and capture data
    var capture = {};
    var errors = [];

    if (!asn1.validate(obj, p7.asn1.signerInfoValidator, capture, errors)) {
      var error = new Error('Cannot read PKCS#7 SignerInfo. ' + 'ASN.1 object is not an PKCS#7 SignerInfo.');
      error.errors = errors;
      throw error;
    }

    var rval = {
      version: capture.version.charCodeAt(0),
      issuer: forge.pki.RDNAttributesAsArray(capture.issuer),
      serialNumber: forge.util.createBuffer(capture.serial).toHex(),
      digestAlgorithm: asn1.derToOid(capture.digestAlgorithm),
      signatureAlgorithm: asn1.derToOid(capture.signatureAlgorithm),
      signature: capture.signature,
      authenticatedAttributes: [],
      unauthenticatedAttributes: []
    }; // TODO: convert attributes

    var authenticatedAttributes = capture.authenticatedAttributes || [];
    var unauthenticatedAttributes = capture.unauthenticatedAttributes || [];
    return rval;
  }
  /**
   * Converts a single signerInfo object to an ASN.1 object.
   *
   * @param obj the signerInfo object.
   *
   * @return the ASN.1 representation of a SignerInfo.
   */


  function _signerToAsn1(obj) {
    // SignerInfo
    var rval = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// version
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(obj.version).getBytes()), // issuerAndSerialNumber
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// name
    forge.pki.distinguishedNameToAsn1({
      attributes: obj.issuer
    }), // serial
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, forge.util.hexToBytes(obj.serialNumber))]), // digestAlgorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// algorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(obj.digestAlgorithm).getBytes()), // parameters (null)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '')])]); // authenticatedAttributes (OPTIONAL)

    if (obj.authenticatedAttributesAsn1) {
      // add ASN.1 previously generated during signing
      rval.value.push(obj.authenticatedAttributesAsn1);
    } // digestEncryptionAlgorithm


    rval.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// algorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(obj.signatureAlgorithm).getBytes()), // parameters (null)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, '')])); // encryptedDigest

    rval.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, obj.signature)); // unauthenticatedAttributes (OPTIONAL)

    if (obj.unauthenticatedAttributes.length > 0) {
      // [1] IMPLICIT
      var attrsAsn1 = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 1, true, []);

      for (var i = 0; i < obj.unauthenticatedAttributes.length; ++i) {
        var attr = obj.unauthenticatedAttributes[i];
        attrsAsn1.values.push(_attributeToAsn1(attr));
      }

      rval.value.push(attrsAsn1);
    }

    return rval;
  }
  /**
   * Map a set of SignerInfo ASN.1 objects to an array of signer objects.
   *
   * @param signerInfoAsn1s an array of ASN.1 SignerInfos (i.e. SET OF).
   *
   * @return an array of signers objects.
   */


  function _signersFromAsn1(signerInfoAsn1s) {
    var ret = [];

    for (var i = 0; i < signerInfoAsn1s.length; ++i) {
      ret.push(_signerFromAsn1(signerInfoAsn1s[i]));
    }

    return ret;
  }
  /**
   * Map an array of signer objects to ASN.1 objects.
   *
   * @param signers an array of signer objects.
   *
   * @return an array of ASN.1 SignerInfos.
   */


  function _signersToAsn1(signers) {
    var ret = [];

    for (var i = 0; i < signers.length; ++i) {
      ret.push(_signerToAsn1(signers[i]));
    }

    return ret;
  }
  /**
   * Convert an attribute object to an ASN.1 Attribute.
   *
   * @param attr the attribute object.
   *
   * @return the ASN.1 Attribute.
   */


  function _attributeToAsn1(attr) {
    var value; // TODO: generalize to support more attributes

    if (attr.type === forge.pki.oids.contentType) {
      value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(attr.value).getBytes());
    } else if (attr.type === forge.pki.oids.messageDigest) {
      value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, attr.value.bytes());
    } else if (attr.type === forge.pki.oids.signingTime) {
      /* Note per RFC 2985: Dates between 1 January 1950 and 31 December 2049
        (inclusive) MUST be encoded as UTCTime. Any dates with year values
        before 1950 or after 2049 MUST be encoded as GeneralizedTime. [Further,]
        UTCTime values MUST be expressed in Greenwich Mean Time (Zulu) and MUST
        include seconds (i.e., times are YYMMDDHHMMSSZ), even where the
        number of seconds is zero.  Midnight (GMT) must be represented as
        "YYMMDD000000Z". */
      // TODO: make these module-level constants
      var jan_1_1950 = new Date('1950-01-01T00:00:00Z');
      var jan_1_2050 = new Date('2050-01-01T00:00:00Z');
      var date = attr.value;

      if (typeof date === 'string') {
        // try to parse date
        var timestamp = Date.parse(date);

        if (!isNaN(timestamp)) {
          date = new Date(timestamp);
        } else if (date.length === 13) {
          // YYMMDDHHMMSSZ (13 chars for UTCTime)
          date = asn1.utcTimeToDate(date);
        } else {
          // assume generalized time
          date = asn1.generalizedTimeToDate(date);
        }
      }

      if (date >= jan_1_1950 && date < jan_1_2050) {
        value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.UTCTIME, false, asn1.dateToUtcTime(date));
      } else {
        value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.GENERALIZEDTIME, false, asn1.dateToGeneralizedTime(date));
      }
    } // TODO: expose as common API call
    // create a RelativeDistinguishedName set
    // each value in the set is an AttributeTypeAndValue first
    // containing the type (an OID) and second the value


    return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// AttributeType
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(attr.type).getBytes()), asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, [// AttributeValue
    value])]);
  }
  /**
   * Map messages encrypted content to ASN.1 objects.
   *
   * @param ec The encryptedContent object of the message.
   *
   * @return ASN.1 representation of the encryptedContent object (SEQUENCE).
   */


  function _encryptedContentToAsn1(ec) {
    return [// ContentType, always Data for the moment
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(forge.pki.oids.data).getBytes()), // ContentEncryptionAlgorithmIdentifier
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [// Algorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(ec.algorithm).getBytes()), // Parameters (IV)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, ec.parameter.getBytes())]), // [0] EncryptedContent
    asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, ec.content.getBytes())])];
  }
  /**
   * Reads the "common part" of an PKCS#7 content block (in ASN.1 format)
   *
   * This function reads the "common part" of the PKCS#7 content blocks
   * EncryptedData and EnvelopedData, i.e. version number and symmetrically
   * encrypted content block.
   *
   * The result of the ASN.1 validate and capture process is returned
   * to allow the caller to extract further data, e.g. the list of recipients
   * in case of a EnvelopedData object.
   *
   * @param msg the PKCS#7 object to read the data to.
   * @param obj the ASN.1 representation of the content block.
   * @param validator the ASN.1 structure validator object to use.
   *
   * @return the value map captured by validator object.
   */


  function _fromAsn1(msg, obj, validator) {
    var capture = {};
    var errors = [];

    if (!asn1.validate(obj, validator, capture, errors)) {
      var error = new Error('Cannot read PKCS#7 message. ' + 'ASN.1 object is not a supported PKCS#7 message.');
      error.errors = error;
      throw error;
    } // Check contentType, so far we only support (raw) Data.


    var contentType = asn1.derToOid(capture.contentType);

    if (contentType !== forge.pki.oids.data) {
      throw new Error('Unsupported PKCS#7 message. ' + 'Only wrapped ContentType Data supported.');
    }

    if (capture.encryptedContent) {
      var content = '';

      if (forge.util.isArray(capture.encryptedContent)) {
        for (var i = 0; i < capture.encryptedContent.length; ++i) {
          if (capture.encryptedContent[i].type !== asn1.Type.OCTETSTRING) {
            throw new Error('Malformed PKCS#7 message, expecting encrypted ' + 'content constructed of only OCTET STRING objects.');
          }

          content += capture.encryptedContent[i].value;
        }
      } else {
        content = capture.encryptedContent;
      }

      msg.encryptedContent = {
        algorithm: asn1.derToOid(capture.encAlgorithm),
        parameter: forge.util.createBuffer(capture.encParameter.value),
        content: forge.util.createBuffer(content)
      };
    }

    if (capture.content) {
      var content = '';

      if (forge.util.isArray(capture.content)) {
        for (var i = 0; i < capture.content.length; ++i) {
          if (capture.content[i].type !== asn1.Type.OCTETSTRING) {
            throw new Error('Malformed PKCS#7 message, expecting ' + 'content constructed of only OCTET STRING objects.');
          }

          content += capture.content[i].value;
        }
      } else {
        content = capture.content;
      }

      msg.content = forge.util.createBuffer(content);
    }

    msg.version = capture.version.charCodeAt(0);
    msg.rawCapture = capture;
    return capture;
  }
  /**
   * Decrypt the symmetrically encrypted content block of the PKCS#7 message.
   *
   * Decryption is skipped in case the PKCS#7 message object already has a
   * (decrypted) content attribute.  The algorithm, key and cipher parameters
   * (probably the iv) are taken from the encryptedContent attribute of the
   * message object.
   *
   * @param The PKCS#7 message object.
   */


  function _decryptContent(msg) {
    if (msg.encryptedContent.key === undefined) {
      throw new Error('Symmetric key not available.');
    }

    if (msg.content === undefined) {
      var ciph;

      switch (msg.encryptedContent.algorithm) {
        case forge.pki.oids['aes128-CBC']:
        case forge.pki.oids['aes192-CBC']:
        case forge.pki.oids['aes256-CBC']:
          ciph = forge.aes.createDecryptionCipher(msg.encryptedContent.key);
          break;

        case forge.pki.oids['desCBC']:
        case forge.pki.oids['des-EDE3-CBC']:
          ciph = forge.des.createDecryptionCipher(msg.encryptedContent.key);
          break;

        default:
          throw new Error('Unsupported symmetric cipher, OID ' + msg.encryptedContent.algorithm);
      }

      ciph.start(msg.encryptedContent.parameter);
      ciph.update(msg.encryptedContent.content);

      if (!ciph.finish()) {
        throw new Error('Symmetric decryption failed.');
      }

      msg.content = ciph.output;
    }
  }
  /***/

},
/* 543 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Javascript implementation of a basic Public Key Infrastructure, including
   * support for RSA public and private keys.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2010-2013 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(46);

  __webpack_require__(61);

  __webpack_require__(225);

  __webpack_require__(80);

  __webpack_require__(146);

  __webpack_require__(541);

  __webpack_require__(147);

  __webpack_require__(101);

  __webpack_require__(8);

  __webpack_require__(149); // shortcut for asn.1 API


  var asn1 = forge.asn1;
  /* Public Key Infrastructure (PKI) implementation. */

  var pki = module.exports = forge.pki = forge.pki || {};
  /**
   * NOTE: THIS METHOD IS DEPRECATED. Use pem.decode() instead.
   *
   * Converts PEM-formatted data to DER.
   *
   * @param pem the PEM-formatted data.
   *
   * @return the DER-formatted data.
   */

  pki.pemToDer = function (pem) {
    var msg = forge.pem.decode(pem)[0];

    if (msg.procType && msg.procType.type === 'ENCRYPTED') {
      throw new Error('Could not convert PEM to DER; PEM is encrypted.');
    }

    return forge.util.createBuffer(msg.body);
  };
  /**
   * Converts an RSA private key from PEM format.
   *
   * @param pem the PEM-formatted private key.
   *
   * @return the private key.
   */


  pki.privateKeyFromPem = function (pem) {
    var msg = forge.pem.decode(pem)[0];

    if (msg.type !== 'PRIVATE KEY' && msg.type !== 'RSA PRIVATE KEY') {
      var error = new Error('Could not convert private key from PEM; PEM ' + 'header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
      error.headerType = msg.type;
      throw error;
    }

    if (msg.procType && msg.procType.type === 'ENCRYPTED') {
      throw new Error('Could not convert private key from PEM; PEM is encrypted.');
    } // convert DER to ASN.1 object


    var obj = asn1.fromDer(msg.body);
    return pki.privateKeyFromAsn1(obj);
  };
  /**
   * Converts an RSA private key to PEM format.
   *
   * @param key the private key.
   * @param maxline the maximum characters per line, defaults to 64.
   *
   * @return the PEM-formatted private key.
   */


  pki.privateKeyToPem = function (key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
      type: 'RSA PRIVATE KEY',
      body: asn1.toDer(pki.privateKeyToAsn1(key)).getBytes()
    };
    return forge.pem.encode(msg, {
      maxline: maxline
    });
  };
  /**
   * Converts a PrivateKeyInfo to PEM format.
   *
   * @param pki the PrivateKeyInfo.
   * @param maxline the maximum characters per line, defaults to 64.
   *
   * @return the PEM-formatted private key.
   */


  pki.privateKeyInfoToPem = function (pki, maxline) {
    // convert to DER, then PEM-encode
    var msg = {
      type: 'PRIVATE KEY',
      body: asn1.toDer(pki).getBytes()
    };
    return forge.pem.encode(msg, {
      maxline: maxline
    });
  };
  /***/

},
/* 544 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * RC2 implementation.
   *
   * @author Stefan Siegl
   *
   * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
   *
   * Information on the RC2 cipher is available from RFC #2268,
   * http://www.ietf.org/rfc/rfc2268.txt
   */
  var forge = __webpack_require__(6);

  __webpack_require__(8);

  var piTable = [0xd9, 0x78, 0xf9, 0xc4, 0x19, 0xdd, 0xb5, 0xed, 0x28, 0xe9, 0xfd, 0x79, 0x4a, 0xa0, 0xd8, 0x9d, 0xc6, 0x7e, 0x37, 0x83, 0x2b, 0x76, 0x53, 0x8e, 0x62, 0x4c, 0x64, 0x88, 0x44, 0x8b, 0xfb, 0xa2, 0x17, 0x9a, 0x59, 0xf5, 0x87, 0xb3, 0x4f, 0x13, 0x61, 0x45, 0x6d, 0x8d, 0x09, 0x81, 0x7d, 0x32, 0xbd, 0x8f, 0x40, 0xeb, 0x86, 0xb7, 0x7b, 0x0b, 0xf0, 0x95, 0x21, 0x22, 0x5c, 0x6b, 0x4e, 0x82, 0x54, 0xd6, 0x65, 0x93, 0xce, 0x60, 0xb2, 0x1c, 0x73, 0x56, 0xc0, 0x14, 0xa7, 0x8c, 0xf1, 0xdc, 0x12, 0x75, 0xca, 0x1f, 0x3b, 0xbe, 0xe4, 0xd1, 0x42, 0x3d, 0xd4, 0x30, 0xa3, 0x3c, 0xb6, 0x26, 0x6f, 0xbf, 0x0e, 0xda, 0x46, 0x69, 0x07, 0x57, 0x27, 0xf2, 0x1d, 0x9b, 0xbc, 0x94, 0x43, 0x03, 0xf8, 0x11, 0xc7, 0xf6, 0x90, 0xef, 0x3e, 0xe7, 0x06, 0xc3, 0xd5, 0x2f, 0xc8, 0x66, 0x1e, 0xd7, 0x08, 0xe8, 0xea, 0xde, 0x80, 0x52, 0xee, 0xf7, 0x84, 0xaa, 0x72, 0xac, 0x35, 0x4d, 0x6a, 0x2a, 0x96, 0x1a, 0xd2, 0x71, 0x5a, 0x15, 0x49, 0x74, 0x4b, 0x9f, 0xd0, 0x5e, 0x04, 0x18, 0xa4, 0xec, 0xc2, 0xe0, 0x41, 0x6e, 0x0f, 0x51, 0xcb, 0xcc, 0x24, 0x91, 0xaf, 0x50, 0xa1, 0xf4, 0x70, 0x39, 0x99, 0x7c, 0x3a, 0x85, 0x23, 0xb8, 0xb4, 0x7a, 0xfc, 0x02, 0x36, 0x5b, 0x25, 0x55, 0x97, 0x31, 0x2d, 0x5d, 0xfa, 0x98, 0xe3, 0x8a, 0x92, 0xae, 0x05, 0xdf, 0x29, 0x10, 0x67, 0x6c, 0xba, 0xc9, 0xd3, 0x00, 0xe6, 0xcf, 0xe1, 0x9e, 0xa8, 0x2c, 0x63, 0x16, 0x01, 0x3f, 0x58, 0xe2, 0x89, 0xa9, 0x0d, 0x38, 0x34, 0x1b, 0xab, 0x33, 0xff, 0xb0, 0xbb, 0x48, 0x0c, 0x5f, 0xb9, 0xb1, 0xcd, 0x2e, 0xc5, 0xf3, 0xdb, 0x47, 0xe5, 0xa5, 0x9c, 0x77, 0x0a, 0xa6, 0x20, 0x68, 0xfe, 0x7f, 0xc1, 0xad];
  var s = [1, 2, 3, 5];
  /**
   * Rotate a word left by given number of bits.
   *
   * Bits that are shifted out on the left are put back in on the right
   * hand side.
   *
   * @param word The word to shift left.
   * @param bits The number of bits to shift by.
   * @return The rotated word.
   */

  var rol = function rol(word, bits) {
    return word << bits & 0xffff | (word & 0xffff) >> 16 - bits;
  };
  /**
   * Rotate a word right by given number of bits.
   *
   * Bits that are shifted out on the right are put back in on the left
   * hand side.
   *
   * @param word The word to shift right.
   * @param bits The number of bits to shift by.
   * @return The rotated word.
   */


  var ror = function ror(word, bits) {
    return (word & 0xffff) >> bits | word << 16 - bits & 0xffff;
  };
  /* RC2 API */


  module.exports = forge.rc2 = forge.rc2 || {};
  /**
   * Perform RC2 key expansion as per RFC #2268, section 2.
   *
   * @param key variable-length user key (between 1 and 128 bytes)
   * @param effKeyBits number of effective key bits (default: 128)
   * @return the expanded RC2 key (ByteBuffer of 128 bytes)
   */

  forge.rc2.expandKey = function (key, effKeyBits) {
    if (typeof key === 'string') {
      key = forge.util.createBuffer(key);
    }

    effKeyBits = effKeyBits || 128;
    /* introduce variables that match the names used in RFC #2268 */

    var L = key;
    var T = key.length();
    var T1 = effKeyBits;
    var T8 = Math.ceil(T1 / 8);
    var TM = 0xff >> (T1 & 0x07);
    var i;

    for (i = T; i < 128; i++) {
      L.putByte(piTable[L.at(i - 1) + L.at(i - T) & 0xff]);
    }

    L.setAt(128 - T8, piTable[L.at(128 - T8) & TM]);

    for (i = 127 - T8; i >= 0; i--) {
      L.setAt(i, piTable[L.at(i + 1) ^ L.at(i + T8)]);
    }

    return L;
  };
  /**
   * Creates a RC2 cipher object.
   *
   * @param key the symmetric key to use (as base for key generation).
   * @param bits the number of effective key bits.
   * @param encrypt false for decryption, true for encryption.
   *
   * @return the cipher.
   */


  var createCipher = function createCipher(key, bits, encrypt) {
    var _finish = false,
        _input = null,
        _output = null,
        _iv = null;
    var mixRound, mashRound;
    var i,
        j,
        K = [];
    /* Expand key and fill into K[] Array */

    key = forge.rc2.expandKey(key, bits);

    for (i = 0; i < 64; i++) {
      K.push(key.getInt16Le());
    }

    if (encrypt) {
      /**
       * Perform one mixing round "in place".
       *
       * @param R Array of four words to perform mixing on.
       */
      mixRound = function mixRound(R) {
        for (i = 0; i < 4; i++) {
          R[i] += K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
          R[i] = rol(R[i], s[i]);
          j++;
        }
      };
      /**
       * Perform one mashing round "in place".
       *
       * @param R Array of four words to perform mashing on.
       */


      mashRound = function mashRound(R) {
        for (i = 0; i < 4; i++) {
          R[i] += K[R[(i + 3) % 4] & 63];
        }
      };
    } else {
      /**
       * Perform one r-mixing round "in place".
       *
       * @param R Array of four words to perform mixing on.
       */
      mixRound = function mixRound(R) {
        for (i = 3; i >= 0; i--) {
          R[i] = ror(R[i], s[i]);
          R[i] -= K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
          j--;
        }
      };
      /**
       * Perform one r-mashing round "in place".
       *
       * @param R Array of four words to perform mashing on.
       */


      mashRound = function mashRound(R) {
        for (i = 3; i >= 0; i--) {
          R[i] -= K[R[(i + 3) % 4] & 63];
        }
      };
    }
    /**
     * Run the specified cipher execution plan.
     *
     * This function takes four words from the input buffer, applies the IV on
     * it (if requested) and runs the provided execution plan.
     *
     * The plan must be put together in form of a array of arrays.  Where the
     * outer one is simply a list of steps to perform and the inner one needs
     * to have two elements: the first one telling how many rounds to perform,
     * the second one telling what to do (i.e. the function to call).
     *
     * @param {Array} plan The plan to execute.
     */


    var runPlan = function runPlan(plan) {
      var R = [];
      /* Get data from input buffer and fill the four words into R */

      for (i = 0; i < 4; i++) {
        var val = _input.getInt16Le();

        if (_iv !== null) {
          if (encrypt) {
            /* We're encrypting, apply the IV first. */
            val ^= _iv.getInt16Le();
          } else {
            /* We're decryption, keep cipher text for next block. */
            _iv.putInt16Le(val);
          }
        }

        R.push(val & 0xffff);
      }
      /* Reset global "j" variable as per spec. */


      j = encrypt ? 0 : 63;
      /* Run execution plan. */

      for (var ptr = 0; ptr < plan.length; ptr++) {
        for (var ctr = 0; ctr < plan[ptr][0]; ctr++) {
          plan[ptr][1](R);
        }
      }
      /* Write back result to output buffer. */


      for (i = 0; i < 4; i++) {
        if (_iv !== null) {
          if (encrypt) {
            /* We're encrypting in CBC-mode, feed back encrypted bytes into
               IV buffer to carry it forward to next block. */
            _iv.putInt16Le(R[i]);
          } else {
            R[i] ^= _iv.getInt16Le();
          }
        }

        _output.putInt16Le(R[i]);
      }
    };
    /* Create cipher object */


    var cipher = null;
    cipher = {
      /**
       * Starts or restarts the encryption or decryption process, whichever
       * was previously configured.
       *
       * To use the cipher in CBC mode, iv may be given either as a string
       * of bytes, or as a byte buffer.  For ECB mode, give null as iv.
       *
       * @param iv the initialization vector to use, null for ECB mode.
       * @param output the output the buffer to write to, null to create one.
       */
      start: function start(iv, output) {
        if (iv) {
          /* CBC mode */
          if (typeof iv === 'string') {
            iv = forge.util.createBuffer(iv);
          }
        }

        _finish = false;
        _input = forge.util.createBuffer();
        _output = output || new forge.util.createBuffer();
        _iv = iv;
        cipher.output = _output;
      },

      /**
       * Updates the next block.
       *
       * @param input the buffer to read from.
       */
      update: function update(input) {
        if (!_finish) {
          // not finishing, so fill the input buffer with more input
          _input.putBuffer(input);
        }

        while (_input.length() >= 8) {
          runPlan([[5, mixRound], [1, mashRound], [6, mixRound], [1, mashRound], [5, mixRound]]);
        }
      },

      /**
       * Finishes encrypting or decrypting.
       *
       * @param pad a padding function to use, null for PKCS#7 padding,
       *           signature(blockSize, buffer, decrypt).
       *
       * @return true if successful, false on error.
       */
      finish: function finish(pad) {
        var rval = true;

        if (encrypt) {
          if (pad) {
            rval = pad(8, _input, !encrypt);
          } else {
            // add PKCS#7 padding to block (each pad byte is the
            // value of the number of pad bytes)
            var padding = _input.length() === 8 ? 8 : 8 - _input.length();

            _input.fillWithByte(padding, padding);
          }
        }

        if (rval) {
          // do final update
          _finish = true;
          cipher.update();
        }

        if (!encrypt) {
          // check for error: input data not a multiple of block size
          rval = _input.length() === 0;

          if (rval) {
            if (pad) {
              rval = pad(8, _output, !encrypt);
            } else {
              // ensure padding byte count is valid
              var len = _output.length();

              var count = _output.at(len - 1);

              if (count > len) {
                rval = false;
              } else {
                // trim off padding bytes
                _output.truncate(count);
              }
            }
          }
        }

        return rval;
      }
    };
    return cipher;
  };
  /**
   * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
   * given symmetric key. The output will be stored in the 'output' member
   * of the returned cipher.
   *
   * The key and iv may be given as a string of bytes or a byte buffer.
   * The cipher is initialized to use 128 effective key bits.
   *
   * @param key the symmetric key to use.
   * @param iv the initialization vector to use.
   * @param output the buffer to write to, null to create one.
   *
   * @return the cipher.
   */


  forge.rc2.startEncrypting = function (key, iv, output) {
    var cipher = forge.rc2.createEncryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
  };
  /**
   * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
   * given symmetric key.
   *
   * The key may be given as a string of bytes or a byte buffer.
   *
   * To start encrypting call start() on the cipher with an iv and optional
   * output buffer.
   *
   * @param key the symmetric key to use.
   *
   * @return the cipher.
   */


  forge.rc2.createEncryptionCipher = function (key, bits) {
    return createCipher(key, bits, true);
  };
  /**
   * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
   * given symmetric key. The output will be stored in the 'output' member
   * of the returned cipher.
   *
   * The key and iv may be given as a string of bytes or a byte buffer.
   * The cipher is initialized to use 128 effective key bits.
   *
   * @param key the symmetric key to use.
   * @param iv the initialization vector to use.
   * @param output the buffer to write to, null to create one.
   *
   * @return the cipher.
   */


  forge.rc2.startDecrypting = function (key, iv, output) {
    var cipher = forge.rc2.createDecryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
  };
  /**
   * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
   * given symmetric key.
   *
   * The key may be given as a string of bytes or a byte buffer.
   *
   * To start decrypting call start() on the cipher with an iv and optional
   * output buffer.
   *
   * @param key the symmetric key to use.
   *
   * @return the cipher.
   */


  forge.rc2.createDecryptionCipher = function (key, bits) {
    return createCipher(key, bits, false);
  };
  /***/

},
/* 545 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Secure Hash Algorithm with a 1024-bit block size implementation.
   *
   * This includes: SHA-512, SHA-384, SHA-512/224, and SHA-512/256. For
   * SHA-256 (block size 512 bits), see sha256.js.
   *
   * See FIPS 180-4 for details.
   *
   * @author Dave Longley
   *
   * Copyright (c) 2014-2015 Digital Bazaar, Inc.
   */
  var forge = __webpack_require__(6);

  __webpack_require__(60);

  __webpack_require__(8);

  var sha512 = module.exports = forge.sha512 = forge.sha512 || {}; // SHA-512

  forge.md.sha512 = forge.md.algorithms.sha512 = sha512; // SHA-384

  var sha384 = forge.sha384 = forge.sha512.sha384 = forge.sha512.sha384 || {};

  sha384.create = function () {
    return sha512.create('SHA-384');
  };

  forge.md.sha384 = forge.md.algorithms.sha384 = sha384; // SHA-512/256

  forge.sha512.sha256 = forge.sha512.sha256 || {
    create: function create() {
      return sha512.create('SHA-512/256');
    }
  };
  forge.md['sha512/256'] = forge.md.algorithms['sha512/256'] = forge.sha512.sha256; // SHA-512/224

  forge.sha512.sha224 = forge.sha512.sha224 || {
    create: function create() {
      return sha512.create('SHA-512/224');
    }
  };
  forge.md['sha512/224'] = forge.md.algorithms['sha512/224'] = forge.sha512.sha224;
  /**
   * Creates a SHA-2 message digest object.
   *
   * @param algorithm the algorithm to use (SHA-512, SHA-384, SHA-512/224,
   *          SHA-512/256).
   *
   * @return a message digest object.
   */

  sha512.create = function (algorithm) {
    // do initialization as necessary
    if (!_initialized) {
      _init();
    }

    if (typeof algorithm === 'undefined') {
      algorithm = 'SHA-512';
    }

    if (!(algorithm in _states)) {
      throw new Error('Invalid SHA-512 algorithm: ' + algorithm);
    } // SHA-512 state contains eight 64-bit integers (each as two 32-bit ints)


    var _state = _states[algorithm];
    var _h = null; // input buffer

    var _input = forge.util.createBuffer(); // used for 64-bit word storage


    var _w = new Array(80);

    for (var wi = 0; wi < 80; ++wi) {
      _w[wi] = new Array(2);
    } // determine digest length by algorithm name (default)


    var digestLength = 64;

    switch (algorithm) {
      case 'SHA-384':
        digestLength = 48;
        break;

      case 'SHA-512/256':
        digestLength = 32;
        break;

      case 'SHA-512/224':
        digestLength = 28;
        break;
    } // message digest object


    var md = {
      // SHA-512 => sha512
      algorithm: algorithm.replace('-', '').toLowerCase(),
      blockLength: 128,
      digestLength: digestLength,
      // 56-bit length of message so far (does not including padding)
      messageLength: 0,
      // true message length
      fullMessageLength: null,
      // size of message length in bytes
      messageLengthSize: 16
    };
    /**
     * Starts the digest.
     *
     * @return this digest object.
     */

    md.start = function () {
      // up to 56-bit message length for convenience
      md.messageLength = 0; // full message length (set md.messageLength128 for backwards-compatibility)

      md.fullMessageLength = md.messageLength128 = [];
      var int32s = md.messageLengthSize / 4;

      for (var i = 0; i < int32s; ++i) {
        md.fullMessageLength.push(0);
      }

      _input = forge.util.createBuffer();
      _h = new Array(_state.length);

      for (var i = 0; i < _state.length; ++i) {
        _h[i] = _state[i].slice(0);
      }

      return md;
    }; // start digest automatically for first time


    md.start();
    /**
     * Updates the digest with the given message input. The given input can
     * treated as raw input (no encoding will be applied) or an encoding of
     * 'utf8' maybe given to encode the input using UTF-8.
     *
     * @param msg the message input to update with.
     * @param encoding the encoding to use (default: 'raw', other: 'utf8').
     *
     * @return this digest object.
     */

    md.update = function (msg, encoding) {
      if (encoding === 'utf8') {
        msg = forge.util.encodeUtf8(msg);
      } // update message length


      var len = msg.length;
      md.messageLength += len;
      len = [len / 0x100000000 >>> 0, len >>> 0];

      for (var i = md.fullMessageLength.length - 1; i >= 0; --i) {
        md.fullMessageLength[i] += len[1];
        len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
        md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
        len[0] = len[1] / 0x100000000 >>> 0;
      } // add bytes to input buffer


      _input.putBytes(msg); // process bytes


      _update(_h, _w, _input); // compact input buffer every 2K or if empty


      if (_input.read > 2048 || _input.length() === 0) {
        _input.compact();
      }

      return md;
    };
    /**
     * Produces the digest.
     *
     * @return a byte buffer containing the digest value.
     */


    md.digest = function () {
      /* Note: Here we copy the remaining bytes in the input buffer and
      add the appropriate SHA-512 padding. Then we do the final update
      on a copy of the state so that if the user wants to get
      intermediate digests they can do so. */

      /* Determine the number of bytes that must be added to the message
      to ensure its length is congruent to 896 mod 1024. In other words,
      the data to be digested must be a multiple of 1024 bits (or 128 bytes).
      This data includes the message, some padding, and the length of the
      message. Since the length of the message will be encoded as 16 bytes (128
      bits), that means that the last segment of the data must have 112 bytes
      (896 bits) of message and padding. Therefore, the length of the message
      plus the padding must be congruent to 896 mod 1024 because
      1024 - 128 = 896.
       In order to fill up the message length it must be filled with
      padding that begins with 1 bit followed by all 0 bits. Padding
      must *always* be present, so if the message length is already
      congruent to 896 mod 1024, then 1024 padding bits must be added. */
      var finalBlock = forge.util.createBuffer();
      finalBlock.putBytes(_input.bytes()); // compute remaining size to be digested (include message length size)

      var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize; // add padding for overflow blockSize - overflow
      // _padding starts with 1 byte with first bit is set (byte value 128), then
      // there may be up to (blockSize - 1) other pad bytes

      var overflow = remaining & md.blockLength - 1;
      finalBlock.putBytes(_padding.substr(0, md.blockLength - overflow)); // serialize message length in bits in big-endian order; since length
      // is stored in bytes we multiply by 8 and add carry from next int

      var next, carry;
      var bits = md.fullMessageLength[0] * 8;

      for (var i = 0; i < md.fullMessageLength.length - 1; ++i) {
        next = md.fullMessageLength[i + 1] * 8;
        carry = next / 0x100000000 >>> 0;
        bits += carry;
        finalBlock.putInt32(bits >>> 0);
        bits = next >>> 0;
      }

      finalBlock.putInt32(bits);
      var h = new Array(_h.length);

      for (var i = 0; i < _h.length; ++i) {
        h[i] = _h[i].slice(0);
      }

      _update(h, _w, finalBlock);

      var rval = forge.util.createBuffer();
      var hlen;

      if (algorithm === 'SHA-512') {
        hlen = h.length;
      } else if (algorithm === 'SHA-384') {
        hlen = h.length - 2;
      } else {
        hlen = h.length - 4;
      }

      for (var i = 0; i < hlen; ++i) {
        rval.putInt32(h[i][0]);

        if (i !== hlen - 1 || algorithm !== 'SHA-512/224') {
          rval.putInt32(h[i][1]);
        }
      }

      return rval;
    };

    return md;
  }; // sha-512 padding bytes not initialized yet


  var _padding = null;
  var _initialized = false; // table of constants

  var _k = null; // initial hash states

  var _states = null;
  /**
   * Initializes the constant tables.
   */

  function _init() {
    // create padding
    _padding = String.fromCharCode(128);
    _padding += forge.util.fillString(String.fromCharCode(0x00), 128); // create K table for SHA-512

    _k = [[0x428a2f98, 0xd728ae22], [0x71374491, 0x23ef65cd], [0xb5c0fbcf, 0xec4d3b2f], [0xe9b5dba5, 0x8189dbbc], [0x3956c25b, 0xf348b538], [0x59f111f1, 0xb605d019], [0x923f82a4, 0xaf194f9b], [0xab1c5ed5, 0xda6d8118], [0xd807aa98, 0xa3030242], [0x12835b01, 0x45706fbe], [0x243185be, 0x4ee4b28c], [0x550c7dc3, 0xd5ffb4e2], [0x72be5d74, 0xf27b896f], [0x80deb1fe, 0x3b1696b1], [0x9bdc06a7, 0x25c71235], [0xc19bf174, 0xcf692694], [0xe49b69c1, 0x9ef14ad2], [0xefbe4786, 0x384f25e3], [0x0fc19dc6, 0x8b8cd5b5], [0x240ca1cc, 0x77ac9c65], [0x2de92c6f, 0x592b0275], [0x4a7484aa, 0x6ea6e483], [0x5cb0a9dc, 0xbd41fbd4], [0x76f988da, 0x831153b5], [0x983e5152, 0xee66dfab], [0xa831c66d, 0x2db43210], [0xb00327c8, 0x98fb213f], [0xbf597fc7, 0xbeef0ee4], [0xc6e00bf3, 0x3da88fc2], [0xd5a79147, 0x930aa725], [0x06ca6351, 0xe003826f], [0x14292967, 0x0a0e6e70], [0x27b70a85, 0x46d22ffc], [0x2e1b2138, 0x5c26c926], [0x4d2c6dfc, 0x5ac42aed], [0x53380d13, 0x9d95b3df], [0x650a7354, 0x8baf63de], [0x766a0abb, 0x3c77b2a8], [0x81c2c92e, 0x47edaee6], [0x92722c85, 0x1482353b], [0xa2bfe8a1, 0x4cf10364], [0xa81a664b, 0xbc423001], [0xc24b8b70, 0xd0f89791], [0xc76c51a3, 0x0654be30], [0xd192e819, 0xd6ef5218], [0xd6990624, 0x5565a910], [0xf40e3585, 0x5771202a], [0x106aa070, 0x32bbd1b8], [0x19a4c116, 0xb8d2d0c8], [0x1e376c08, 0x5141ab53], [0x2748774c, 0xdf8eeb99], [0x34b0bcb5, 0xe19b48a8], [0x391c0cb3, 0xc5c95a63], [0x4ed8aa4a, 0xe3418acb], [0x5b9cca4f, 0x7763e373], [0x682e6ff3, 0xd6b2b8a3], [0x748f82ee, 0x5defb2fc], [0x78a5636f, 0x43172f60], [0x84c87814, 0xa1f0ab72], [0x8cc70208, 0x1a6439ec], [0x90befffa, 0x23631e28], [0xa4506ceb, 0xde82bde9], [0xbef9a3f7, 0xb2c67915], [0xc67178f2, 0xe372532b], [0xca273ece, 0xea26619c], [0xd186b8c7, 0x21c0c207], [0xeada7dd6, 0xcde0eb1e], [0xf57d4f7f, 0xee6ed178], [0x06f067aa, 0x72176fba], [0x0a637dc5, 0xa2c898a6], [0x113f9804, 0xbef90dae], [0x1b710b35, 0x131c471b], [0x28db77f5, 0x23047d84], [0x32caab7b, 0x40c72493], [0x3c9ebe0a, 0x15c9bebc], [0x431d67c4, 0x9c100d4c], [0x4cc5d4be, 0xcb3e42b6], [0x597f299c, 0xfc657e2a], [0x5fcb6fab, 0x3ad6faec], [0x6c44198c, 0x4a475817]]; // initial hash states

    _states = {};
    _states['SHA-512'] = [[0x6a09e667, 0xf3bcc908], [0xbb67ae85, 0x84caa73b], [0x3c6ef372, 0xfe94f82b], [0xa54ff53a, 0x5f1d36f1], [0x510e527f, 0xade682d1], [0x9b05688c, 0x2b3e6c1f], [0x1f83d9ab, 0xfb41bd6b], [0x5be0cd19, 0x137e2179]];
    _states['SHA-384'] = [[0xcbbb9d5d, 0xc1059ed8], [0x629a292a, 0x367cd507], [0x9159015a, 0x3070dd17], [0x152fecd8, 0xf70e5939], [0x67332667, 0xffc00b31], [0x8eb44a87, 0x68581511], [0xdb0c2e0d, 0x64f98fa7], [0x47b5481d, 0xbefa4fa4]];
    _states['SHA-512/256'] = [[0x22312194, 0xFC2BF72C], [0x9F555FA3, 0xC84C64C2], [0x2393B86B, 0x6F53B151], [0x96387719, 0x5940EABD], [0x96283EE2, 0xA88EFFE3], [0xBE5E1E25, 0x53863992], [0x2B0199FC, 0x2C85B8AA], [0x0EB72DDC, 0x81C52CA2]];
    _states['SHA-512/224'] = [[0x8C3D37C8, 0x19544DA2], [0x73E19966, 0x89DCD4D6], [0x1DFAB7AE, 0x32FF9C82], [0x679DD514, 0x582F9FCF], [0x0F6D2B69, 0x7BD44DA8], [0x77E36F73, 0x04C48942], [0x3F9D85A8, 0x6A1D36C8], [0x1112E6AD, 0x91D692A1]]; // now initialized

    _initialized = true;
  }
  /**
   * Updates a SHA-512 state with the given byte buffer.
   *
   * @param s the SHA-512 state to update.
   * @param w the array to use to store words.
   * @param bytes the byte buffer to update with.
   */


  function _update(s, w, bytes) {
    // consume 512 bit (128 byte) chunks
    var t1_hi, t1_lo;
    var t2_hi, t2_lo;
    var s0_hi, s0_lo;
    var s1_hi, s1_lo;
    var ch_hi, ch_lo;
    var maj_hi, maj_lo;
    var a_hi, a_lo;
    var b_hi, b_lo;
    var c_hi, c_lo;
    var d_hi, d_lo;
    var e_hi, e_lo;
    var f_hi, f_lo;
    var g_hi, g_lo;
    var h_hi, h_lo;
    var i, hi, lo, w2, w7, w15, w16;
    var len = bytes.length();

    while (len >= 128) {
      // the w array will be populated with sixteen 64-bit big-endian words
      // and then extended into 64 64-bit words according to SHA-512
      for (i = 0; i < 16; ++i) {
        w[i][0] = bytes.getInt32() >>> 0;
        w[i][1] = bytes.getInt32() >>> 0;
      }

      for (; i < 80; ++i) {
        // for word 2 words ago: ROTR 19(x) ^ ROTR 61(x) ^ SHR 6(x)
        w2 = w[i - 2];
        hi = w2[0];
        lo = w2[1]; // high bits

        t1_hi = ((hi >>> 19 | lo << 13) ^ ( // ROTR 19
        lo >>> 29 | hi << 3) ^ // ROTR 61/(swap + ROTR 29)
        hi >>> 6) >>> 0; // SHR 6
        // low bits

        t1_lo = ((hi << 13 | lo >>> 19) ^ ( // ROTR 19
        lo << 3 | hi >>> 29) ^ ( // ROTR 61/(swap + ROTR 29)
        hi << 26 | lo >>> 6)) >>> 0; // SHR 6
        // for word 15 words ago: ROTR 1(x) ^ ROTR 8(x) ^ SHR 7(x)

        w15 = w[i - 15];
        hi = w15[0];
        lo = w15[1]; // high bits

        t2_hi = ((hi >>> 1 | lo << 31) ^ ( // ROTR 1
        hi >>> 8 | lo << 24) ^ // ROTR 8
        hi >>> 7) >>> 0; // SHR 7
        // low bits

        t2_lo = ((hi << 31 | lo >>> 1) ^ ( // ROTR 1
        hi << 24 | lo >>> 8) ^ ( // ROTR 8
        hi << 25 | lo >>> 7)) >>> 0; // SHR 7
        // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^64 (carry lo overflow)

        w7 = w[i - 7];
        w16 = w[i - 16];
        lo = t1_lo + w7[1] + t2_lo + w16[1];
        w[i][0] = t1_hi + w7[0] + t2_hi + w16[0] + (lo / 0x100000000 >>> 0) >>> 0;
        w[i][1] = lo >>> 0;
      } // initialize hash value for this chunk


      a_hi = s[0][0];
      a_lo = s[0][1];
      b_hi = s[1][0];
      b_lo = s[1][1];
      c_hi = s[2][0];
      c_lo = s[2][1];
      d_hi = s[3][0];
      d_lo = s[3][1];
      e_hi = s[4][0];
      e_lo = s[4][1];
      f_hi = s[5][0];
      f_lo = s[5][1];
      g_hi = s[6][0];
      g_lo = s[6][1];
      h_hi = s[7][0];
      h_lo = s[7][1]; // round function

      for (i = 0; i < 80; ++i) {
        // Sum1(e) = ROTR 14(e) ^ ROTR 18(e) ^ ROTR 41(e)
        s1_hi = ((e_hi >>> 14 | e_lo << 18) ^ ( // ROTR 14
        e_hi >>> 18 | e_lo << 14) ^ ( // ROTR 18
        e_lo >>> 9 | e_hi << 23)) >>> 0; // ROTR 41/(swap + ROTR 9)

        s1_lo = ((e_hi << 18 | e_lo >>> 14) ^ ( // ROTR 14
        e_hi << 14 | e_lo >>> 18) ^ ( // ROTR 18
        e_lo << 23 | e_hi >>> 9)) >>> 0; // ROTR 41/(swap + ROTR 9)
        // Ch(e, f, g) (optimized the same way as SHA-1)

        ch_hi = (g_hi ^ e_hi & (f_hi ^ g_hi)) >>> 0;
        ch_lo = (g_lo ^ e_lo & (f_lo ^ g_lo)) >>> 0; // Sum0(a) = ROTR 28(a) ^ ROTR 34(a) ^ ROTR 39(a)

        s0_hi = ((a_hi >>> 28 | a_lo << 4) ^ ( // ROTR 28
        a_lo >>> 2 | a_hi << 30) ^ ( // ROTR 34/(swap + ROTR 2)
        a_lo >>> 7 | a_hi << 25)) >>> 0; // ROTR 39/(swap + ROTR 7)

        s0_lo = ((a_hi << 4 | a_lo >>> 28) ^ ( // ROTR 28
        a_lo << 30 | a_hi >>> 2) ^ ( // ROTR 34/(swap + ROTR 2)
        a_lo << 25 | a_hi >>> 7)) >>> 0; // ROTR 39/(swap + ROTR 7)
        // Maj(a, b, c) (optimized the same way as SHA-1)

        maj_hi = (a_hi & b_hi | c_hi & (a_hi ^ b_hi)) >>> 0;
        maj_lo = (a_lo & b_lo | c_lo & (a_lo ^ b_lo)) >>> 0; // main algorithm
        // t1 = (h + s1 + ch + _k[i] + _w[i]) modulo 2^64 (carry lo overflow)

        lo = h_lo + s1_lo + ch_lo + _k[i][1] + w[i][1];
        t1_hi = h_hi + s1_hi + ch_hi + _k[i][0] + w[i][0] + (lo / 0x100000000 >>> 0) >>> 0;
        t1_lo = lo >>> 0; // t2 = s0 + maj modulo 2^64 (carry lo overflow)

        lo = s0_lo + maj_lo;
        t2_hi = s0_hi + maj_hi + (lo / 0x100000000 >>> 0) >>> 0;
        t2_lo = lo >>> 0;
        h_hi = g_hi;
        h_lo = g_lo;
        g_hi = f_hi;
        g_lo = f_lo;
        f_hi = e_hi;
        f_lo = e_lo; // e = (d + t1) modulo 2^64 (carry lo overflow)

        lo = d_lo + t1_lo;
        e_hi = d_hi + t1_hi + (lo / 0x100000000 >>> 0) >>> 0;
        e_lo = lo >>> 0;
        d_hi = c_hi;
        d_lo = c_lo;
        c_hi = b_hi;
        c_lo = b_lo;
        b_hi = a_hi;
        b_lo = a_lo; // a = (t1 + t2) modulo 2^64 (carry lo overflow)

        lo = t1_lo + t2_lo;
        a_hi = t1_hi + t2_hi + (lo / 0x100000000 >>> 0) >>> 0;
        a_lo = lo >>> 0;
      } // update hash state (additional modulo 2^64)


      lo = s[0][1] + a_lo;
      s[0][0] = s[0][0] + a_hi + (lo / 0x100000000 >>> 0) >>> 0;
      s[0][1] = lo >>> 0;
      lo = s[1][1] + b_lo;
      s[1][0] = s[1][0] + b_hi + (lo / 0x100000000 >>> 0) >>> 0;
      s[1][1] = lo >>> 0;
      lo = s[2][1] + c_lo;
      s[2][0] = s[2][0] + c_hi + (lo / 0x100000000 >>> 0) >>> 0;
      s[2][1] = lo >>> 0;
      lo = s[3][1] + d_lo;
      s[3][0] = s[3][0] + d_hi + (lo / 0x100000000 >>> 0) >>> 0;
      s[3][1] = lo >>> 0;
      lo = s[4][1] + e_lo;
      s[4][0] = s[4][0] + e_hi + (lo / 0x100000000 >>> 0) >>> 0;
      s[4][1] = lo >>> 0;
      lo = s[5][1] + f_lo;
      s[5][0] = s[5][0] + f_hi + (lo / 0x100000000 >>> 0) >>> 0;
      s[5][1] = lo >>> 0;
      lo = s[6][1] + g_lo;
      s[6][0] = s[6][0] + g_hi + (lo / 0x100000000 >>> 0) >>> 0;
      s[6][1] = lo >>> 0;
      lo = s[7][1] + h_lo;
      s[7][0] = s[7][0] + h_hi + (lo / 0x100000000 >>> 0) >>> 0;
      s[7][1] = lo >>> 0;
      len -= 128;
    }
  }
  /***/

},
/* 546 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/aes-cbc-hmac-sha2.js - AES-CBC-HMAC-SHA2 Composited Encryption
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var helpers = __webpack_require__(30),
        HMAC = __webpack_require__(152),
        sha = __webpack_require__(102),
        forge = __webpack_require__(14),
        DataBuffer = __webpack_require__(82),
        util = __webpack_require__(19);

    function checkIv(iv) {
      if (16 !== iv.length) {
        throw new Error("invalid iv");
      }
    }

    function commonCbcEncryptFN(size) {
      // ### 'fallback' implementation -- uses forge
      var fallback = function fallback(encKey, pdata, iv) {
        try {
          checkIv(iv);
        } catch (err) {
          return Promise.reject(err);
        }

        var promise = Promise.resolve();
        promise = promise.then(function () {
          var cipher = forge.cipher.createCipher("AES-CBC", new DataBuffer(encKey));
          cipher.start({
            iv: new DataBuffer(iv)
          }); // TODO: chunk data

          cipher.update(new DataBuffer(pdata));

          if (!cipher.finish()) {
            return Promise.reject(new Error("encryption failed"));
          }

          var cdata = cipher.output.native();
          return cdata;
        });
        return promise;
      }; // ### WebCryptoAPI implementation
      // TODO: cache CryptoKey sooner


      var webcrypto = function webcrypto(encKey, pdata, iv) {
        try {
          checkIv(iv);
        } catch (err) {
          return Promise.reject(err);
        }

        var promise = Promise.resolve();
        promise = promise.then(function () {
          var alg = {
            name: "AES-CBC"
          };
          return helpers.subtleCrypto.importKey("raw", encKey, alg, true, ["encrypt"]);
        });
        promise = promise.then(function (key) {
          var alg = {
            name: "AES-CBC",
            iv: iv
          };
          return helpers.subtleCrypto.encrypt(alg, key, pdata);
        });
        promise = promise.then(function (cdata) {
          cdata = Buffer.from(cdata);
          return cdata;
        });
        return promise;
      }; // ### NodeJS implementation


      var nodejs = function nodejs(encKey, pdata, iv) {
        try {
          checkIv(iv);
        } catch (err) {
          return Promise.reject(err);
        }

        var promise = Promise.resolve(pdata);
        promise = promise.then(function (pdata) {
          var name = "AES-" + size + "-CBC";
          var cipher = helpers.nodeCrypto.createCipheriv(name, encKey, iv);
          var cdata = Buffer.concat([cipher.update(pdata), cipher.final()]);
          return cdata;
        });
        return promise;
      };

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    }

    function commonCbcDecryptFN(size) {
      // ### 'fallback' implementation -- uses forge
      var fallback = function fallback(encKey, cdata, iv) {
        // validate inputs
        try {
          checkIv(iv);
        } catch (err) {
          return Promise.reject(err);
        }

        var promise = Promise.resolve();
        promise = promise.then(function () {
          var cipher = forge.cipher.createDecipher("AES-CBC", new DataBuffer(encKey));
          cipher.start({
            iv: new DataBuffer(iv)
          }); // TODO: chunk data

          cipher.update(new DataBuffer(cdata));

          if (!cipher.finish()) {
            return Promise.reject(new Error("encryption failed"));
          }

          var pdata = cipher.output.native();
          return pdata;
        });
        return promise;
      }; // ### WebCryptoAPI implementation
      // TODO: cache CryptoKey sooner


      var webcrypto = function webcrypto(encKey, cdata, iv) {
        // validate inputs
        try {
          checkIv(iv);
        } catch (err) {
          return Promise.reject(err);
        }

        var promise = Promise.resolve();
        promise = promise.then(function () {
          var alg = {
            name: "AES-CBC"
          };
          return helpers.subtleCrypto.importKey("raw", encKey, alg, true, ["decrypt"]);
        });
        promise = promise.then(function (key) {
          var alg = {
            name: "AES-CBC",
            iv: iv
          };
          return helpers.subtleCrypto.decrypt(alg, key, cdata);
        });
        promise = promise.then(function (pdata) {
          pdata = Buffer.from(pdata);
          return pdata;
        });
        return promise;
      }; // ### NodeJS implementation


      var nodejs = function nodejs(encKey, cdata, iv) {
        // validate inputs
        try {
          checkIv(iv);
        } catch (err) {
          return Promise.reject(err);
        }

        var promise = Promise.resolve();
        promise = promise.then(function () {
          var name = "AES-" + size + "-CBC";
          var cipher = helpers.nodeCrypto.createDecipheriv(name, encKey, iv);
          var pdata = Buffer.concat([cipher.update(cdata), cipher.final()]);
          return pdata;
        });
        return promise;
      };

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    }

    function checkKey(key, size) {
      if (size << 1 !== key.length << 3) {
        throw new Error("invalid encryption key size");
      }
    }

    function cbcHmacEncryptFN(size) {
      var commonEncrypt = commonCbcEncryptFN(size);
      return function (key, pdata, props) {
        // validate inputs
        try {
          checkKey(key, size);
        } catch (err) {
          return Promise.reject(err);
        }

        var eKey = key.slice(size / 8),
            iKey = key.slice(0, size / 8),
            iv = props.iv || Buffer.alloc(0),
            adata = props.aad || props.adata || Buffer.alloc(0); // STEP 1 -- Encrypt

        var promise = commonEncrypt(eKey, pdata, iv); // STEP 2 -- MAC

        promise = promise.then(function (cdata) {
          var mdata = Buffer.concat([adata, iv, cdata, helpers.int64ToBuffer(adata.length * 8)]);
          var promise;
          promise = HMAC["HS" + size * 2].sign(iKey, mdata, {
            length: size
          });
          promise = promise.then(function (result) {
            // TODO: move slice to hmac.js
            var tag = result.mac.slice(0, size / 8);
            return {
              data: cdata,
              tag: tag
            };
          });
          return promise;
        });
        return promise;
      };
    }

    function cbcHmacDecryptFN(size) {
      var commonDecrypt = commonCbcDecryptFN(size);
      return function (key, cdata, props) {
        // validate inputs
        try {
          checkKey(key, size);
        } catch (err) {
          return Promise.reject(err);
        }

        var eKey = key.slice(size / 8),
            iKey = key.slice(0, size / 8),
            iv = props.iv || Buffer.alloc(0),
            adata = props.aad || props.adata || Buffer.alloc(0),
            tag = props.tag || props.mac || Buffer.alloc(0);
        var promise = Promise.resolve(); // STEP 1 -- MAC

        promise = promise.then(function () {
          var promise; // construct MAC input

          var mdata = Buffer.concat([adata, iv, cdata, helpers.int64ToBuffer(adata.length * 8)]);
          promise = HMAC["HS" + size * 2].verify(iKey, mdata, tag, {
            length: size
          });
          promise = promise.then(function () {
            return cdata;
          }, function () {
            // failure -- invalid tag error
            throw new Error("mac check failed");
          });
          return promise;
        }); // STEP 2 -- Decrypt

        promise = promise.then(function () {
          return commonDecrypt(eKey, cdata, iv);
        });
        return promise;
      };
    }

    var EncryptionLabel = Buffer.from("Encryption", "utf8");
    var IntegrityLabel = Buffer.from("Integrity", "utf8");
    var DotLabel = Buffer.from(".", "utf8");

    function generateCek(masterKey, alg, epu, epv) {
      var masterSize = masterKey.length * 8;
      var cekSize = masterSize / 2;
      var promise = Promise.resolve();
      promise = promise.then(function () {
        var input = Buffer.concat([helpers.int32ToBuffer(1), masterKey, helpers.int32ToBuffer(cekSize), Buffer.from(alg, "utf8"), epu, epv, EncryptionLabel]);
        return input;
      });
      promise = promise.then(function (input) {
        return sha["SHA-" + masterSize].digest(input).then(function (digest) {
          return digest.slice(0, cekSize / 8);
        });
      });
      promise = Promise.resolve(promise);
      return promise;
    }

    function generateCik(masterKey, alg, epu, epv) {
      var masterSize = masterKey.length * 8;
      var cikSize = masterSize;
      var promise = Promise.resolve();
      promise = promise.then(function () {
        var input = Buffer.concat([helpers.int32ToBuffer(1), masterKey, helpers.int32ToBuffer(cikSize), Buffer.from(alg, "utf8"), epu, epv, IntegrityLabel]);
        return input;
      });
      promise = promise.then(function (input) {
        return sha["SHA-" + masterSize].digest(input).then(function (digest) {
          return digest.slice(0, cikSize / 8);
        });
      });
      promise = Promise.resolve(promise);
      return promise;
    }

    function concatKdfCbcHmacEncryptFN(size, alg) {
      var commonEncrypt = commonCbcEncryptFN(size);
      return function (key, pdata, props) {
        var epu = props.epu || helpers.int32ToBuffer(0),
            epv = props.epv || helpers.int32ToBuffer(0),
            iv = props.iv || Buffer.alloc(0),
            adata = props.aad || props.adata || Buffer.alloc(0),
            kdata = props.kdata || Buffer.alloc(0); // Pre Step 1 -- Generate Keys

        var promises = [generateCek(key, alg, epu, epv), generateCik(key, alg, epu, epv)];
        var cek, cik;
        var promise = Promise.all(promises).then(function (keys) {
          cek = keys[0];
          cik = keys[1];
        }); // STEP 1 -- Encrypt

        promise = promise.then(function () {
          return commonEncrypt(cek, pdata, iv);
        }); // STEP 2 -- Mac

        promise = promise.then(function (cdata) {
          var mdata = Buffer.concat([adata, DotLabel, Buffer.from(kdata), DotLabel, Buffer.from(util.base64url.encode(iv), "utf8"), DotLabel, Buffer.from(util.base64url.encode(cdata), "utf8")]);
          return Promise.all([Promise.resolve(cdata), HMAC["HS" + size * 2].sign(cik, mdata, {
            length: size
          })]);
        });
        promise = promise.then(function (result) {
          return {
            data: result[0],
            tag: result[1].mac
          };
        });
        return promise;
      };
    }

    function concatKdfCbcHmacDecryptFN(size, alg) {
      var commonDecrypt = commonCbcDecryptFN(size);
      return function (key, cdata, props) {
        var epu = props.epu || helpers.int32ToBuffer(0),
            epv = props.epv || helpers.int32ToBuffer(0),
            iv = props.iv || Buffer.alloc(0),
            adata = props.aad || props.adata || Buffer.alloc(0),
            kdata = props.kdata || Buffer.alloc(0),
            tag = props.tag || props.mac || Buffer.alloc(0); // Pre Step 1 -- Generate Keys

        var promises = [generateCek(key, alg, epu, epv), generateCik(key, alg, epu, epv)];
        var cek, cik;
        var promise = Promise.all(promises).then(function (keys) {
          cek = keys[0];
          cik = keys[1];
        }); // STEP 1 -- MAC

        promise = promise.then(function () {
          // construct MAC input
          var mdata = Buffer.concat([adata, DotLabel, Buffer.from(kdata), DotLabel, Buffer.from(util.base64url.encode(iv), "utf8"), DotLabel, Buffer.from(util.base64url.encode(cdata), "utf8")]);

          try {
            return HMAC["HS" + size * 2].verify(cik, mdata, tag, {
              loose: false
            });
          } catch (e) {
            throw new Error("mac check failed");
          }
        }); // STEP 2 -- Decrypt

        promise = promise.then(function () {
          return commonDecrypt(cek, cdata, iv);
        });
        return promise;
      };
    } // ### Public API
    // * [name].encrypt
    // * [name].decrypt


    var aesCbcHmacSha2 = {};
    ["A128CBC-HS256", "A192CBC-HS384", "A256CBC-HS512"].forEach(function (alg) {
      var size = parseInt(/A(\d+)CBC-HS(\d+)?/g.exec(alg)[1]);
      aesCbcHmacSha2[alg] = {
        encrypt: cbcHmacEncryptFN(size),
        decrypt: cbcHmacDecryptFN(size)
      };
    });
    ["A128CBC+HS256", "A192CBC+HS384", "A256CBC+HS512"].forEach(function (alg) {
      var size = parseInt(/A(\d+)CBC\+HS(\d+)?/g.exec(alg)[1]);
      aesCbcHmacSha2[alg] = {
        encrypt: concatKdfCbcHmacEncryptFN(size, alg),
        decrypt: concatKdfCbcHmacDecryptFN(size, alg)
      };
    });
    module.exports = aesCbcHmacSha2;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 547 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/aes-gcm.js - AES-GCM Encryption and Key-Wrapping
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var helpers = __webpack_require__(30),
        util = __webpack_require__(19),
        CONSTANTS = __webpack_require__(43),
        GCM = __webpack_require__(554);

    function gcmEncryptFN(size, wrap) {
      function commonChecks(key, iv) {
        if (size !== key.length << 3) {
          throw new Error("invalid key size");
        }

        if (!iv && !wrap) {
          throw new Error("invalid iv");
        }

        if (iv && 12 !== iv.length) {
          throw new Error("invalid iv");
        }
      }

      function prepareResults(results) {
        if (wrap) {
          var iv = util.base64url.encode(results.iv);
          var tag = util.base64url.encode(results.tag);
          results = {
            data: results.data,
            header: {
              iv: iv,
              tag: tag
            }
          };
        }

        return results;
      } // ### 'fallback' implementation -- uses forge


      var fallback = function fallback(key, pdata, props) {
        var iv = props.iv,
            adata = props.aad || props.adata || Buffer.alloc(0),
            cipher,
            cdata; // validate inputs

        try {
          commonChecks(key, iv, adata);
        } catch (err) {
          return Promise.reject(err);
        }

        iv = iv || util.randomBytes(12); // setup cipher

        cipher = GCM.createCipher({
          key: key,
          iv: iv,
          additionalData: adata
        }); // ciphertext is the same length as plaintext

        cdata = Buffer.alloc(pdata.length);
        var promise = new Promise(function (resolve, reject) {
          var amt = CONSTANTS.CHUNK_SIZE,
              clen = 0,
              poff = 0;

          (function doChunk() {
            var plen = Math.min(amt, pdata.length - poff);
            clen += cipher.update(pdata, poff, plen, cdata, clen);
            poff += plen;

            if (pdata.length > poff) {
              setTimeout(doChunk, 0);
              return;
            } // finish it


            clen += cipher.finish(cdata, clen);

            if (clen !== pdata.length) {
              reject(new Error("encryption failed"));
              return;
            } // resolve with output


            var tag = cipher.tag;
            resolve(prepareResults({
              data: cdata,
              iv: iv,
              tag: tag
            }));
          })();
        });
        return promise;
      }; // ### WebCryptoAPI implementation
      // TODO: cache CryptoKey sooner


      var webcrypto = function webcrypto(key, pdata, props) {
        var iv = props.iv,
            adata = props.aad || props.adata || Buffer.alloc(0);

        try {
          commonChecks(key, iv, adata);
        } catch (err) {
          return Promise.reject(err);
        }

        iv = iv || util.randomBytes(12);
        var alg = {
          name: "AES-GCM"
        };
        var promise;
        promise = helpers.subtleCrypto.importKey("raw", key, alg, true, ["encrypt"]);
        promise = promise.then(function (key) {
          alg.iv = iv;
          alg.tagLength = 128;

          if (adata.length) {
            alg.additionalData = adata;
          }

          return helpers.subtleCrypto.encrypt(alg, key, pdata);
        });
        promise = promise.then(function (result) {
          var tagStart = result.byteLength - 16;
          var tag = result.slice(tagStart);
          tag = Buffer.from(tag);
          var cdata = result.slice(0, tagStart);
          cdata = Buffer.from(cdata);
          return prepareResults({
            data: cdata,
            iv: iv,
            tag: tag
          });
        });
        return promise;
      }; // ### NodeJS implementation


      var nodejs = function nodejs(key, pdata, props) {
        var iv = props.iv,
            adata = props.aad || props.adata || Buffer.alloc(0);

        try {
          commonChecks(key, iv, adata);
        } catch (err) {
          return Promise.reject(err);
        }

        iv = iv || util.randomBytes(12);
        var alg = "aes-" + key.length * 8 + "-gcm";
        var cipher;

        try {
          cipher = helpers.nodeCrypto.createCipheriv(alg, key, iv);
        } catch (err) {
          throw new Error("unsupported algorithm: " + alg);
        }

        if ("function" !== typeof cipher.setAAD) {
          throw new Error("unsupported algorithm: " + alg);
        }

        if (adata.length) {
          cipher.setAAD(adata);
        }

        var cdata = Buffer.concat([cipher.update(pdata), cipher.final()]);
        var tag = cipher.getAuthTag();
        return prepareResults({
          data: cdata,
          iv: iv,
          tag: tag
        });
      };

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    }

    function gcmDecryptFN(size) {
      function commonChecks(key, iv, tag) {
        if (size !== key.length << 3) {
          throw new Error("invalid key size");
        }

        if (12 !== iv.length) {
          throw new Error("invalid iv");
        }

        if (16 !== tag.length) {
          throw new Error("invalid tag length");
        }
      } // ### fallback implementation -- uses forge


      var fallback = function fallback(key, cdata, props) {
        var adata = props.aad || props.adata || Buffer.alloc(0),
            iv = props.iv || Buffer.alloc(0),
            tag = props.tag || props.mac || Buffer.alloc(0),
            cipher,
            pdata; // validate inputs

        try {
          commonChecks(key, iv, tag);
        } catch (err) {
          return Promise.reject(err);
        } // setup cipher


        cipher = GCM.createDecipher({
          key: key,
          iv: iv,
          additionalData: adata,
          tag: tag
        }); // plaintext is the same length as ciphertext

        pdata = Buffer.alloc(cdata.length);
        var promise = new Promise(function (resolve, reject) {
          var amt = CONSTANTS.CHUNK_SIZE,
              plen = 0,
              coff = 0;

          (function doChunk() {
            var clen = Math.min(amt, cdata.length - coff);
            plen += cipher.update(cdata, coff, clen, pdata, plen);
            coff += clen;

            if (cdata.length > coff) {
              setTimeout(doChunk, 0);
              return;
            }

            try {
              plen += cipher.finish(pdata, plen);
            } catch (err) {
              reject(new Error("decryption failed"));
              return;
            }

            if (plen !== cdata.length) {
              reject(new Error("decryption failed"));
              return;
            } // resolve with output


            resolve(pdata);
          })();
        });
        return promise;
      }; // ### WebCryptoAPI implementation
      // TODO: cache CryptoKey sooner


      var webcrypto = function webcrypto(key, cdata, props) {
        var adata = props.aad || props.adata || Buffer.alloc(0),
            iv = props.iv || Buffer.alloc(0),
            tag = props.tag || props.mac || Buffer.alloc(0); // validate inputs

        try {
          commonChecks(key, iv, tag);
        } catch (err) {
          return Promise.reject(err);
        }

        var alg = {
          name: "AES-GCM"
        };
        var promise;
        promise = helpers.subtleCrypto.importKey("raw", key, alg, true, ["decrypt"]);
        promise = promise.then(function (key) {
          alg.iv = iv;
          alg.tagLength = 128;

          if (adata.length) {
            alg.additionalData = adata;
          } // concatenate cdata and tag


          cdata = Buffer.concat([cdata, tag], cdata.length + tag.length);
          return helpers.subtleCrypto.decrypt(alg, key, cdata);
        });
        promise = promise.then(function (pdata) {
          pdata = Buffer.from(pdata);
          return pdata;
        });
        return promise;
      };

      var nodejs = function nodejs(key, cdata, props) {
        var adata = props.aad || props.adata || Buffer.alloc(0),
            iv = props.iv || Buffer.alloc(0),
            tag = props.tag || props.mac || Buffer.alloc(0); // validate inputs

        try {
          commonChecks(key, iv, tag);
        } catch (err) {
          return Promise.reject(err);
        }

        var alg = "aes-" + key.length * 8 + "-gcm";
        var cipher;

        try {
          cipher = helpers.nodeCrypto.createDecipheriv(alg, key, iv);
        } catch (err) {
          throw new Error("unsupported algorithm: " + alg);
        }

        if ("function" !== typeof cipher.setAAD) {
          throw new Error("unsupported algorithm: " + alg);
        }

        cipher.setAuthTag(tag);

        if (adata.length) {
          cipher.setAAD(adata);
        }

        try {
          var pdata = Buffer.concat([cipher.update(cdata), cipher.final()]);
          return pdata;
        } catch (err) {
          throw new Error("decryption failed");
        }
      };

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    } // ### Public API
    // * [name].encrypt
    // * [name].decrypt


    var aesGcm = {};
    ["A128GCM", "A192GCM", "A256GCM", "A128GCMKW", "A192GCMKW", "A256GCMKW"].forEach(function (alg) {
      var parts = /A(\d+)GCM(KW)?/g.exec(alg);
      var size = parseInt(parts[1]);
      var wrap = parts[2] === "KW";
      aesGcm[alg] = {
        encrypt: gcmEncryptFN(size, wrap),
        decrypt: gcmDecryptFN(size, wrap)
      };
    });
    module.exports = aesGcm;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 548 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * algorithms/dir.js - Direct key mode
   *
   * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
   */

  function dirEncryptFN(key) {
    // NOTE: pdata unused
    // NOTE: props unused
    return Promise.resolve({
      data: key,
      once: true,
      direct: true
    });
  }

  function dirDecryptFN(key) {
    // NOTE: pdata unused
    // NOTE: props unused
    return Promise.resolve(key);
  } // ### Public API
  // * [name].encrypt
  // * [name].decrypt


  var direct = {
    dir: {
      encrypt: dirEncryptFN,
      decrypt: dirDecryptFN
    }
  };
  module.exports = direct;
  /***/
},
/* 549 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/ecdh.js - Elliptic Curve Diffie-Hellman algorithms
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var clone = __webpack_require__(42),
        merge = __webpack_require__(48),
        omit = __webpack_require__(203),
        pick = __webpack_require__(204),
        util = __webpack_require__(19),
        ecUtil = __webpack_require__(151),
        hkdf = __webpack_require__(232),
        concat = __webpack_require__(231),
        aesKw = __webpack_require__(150),
        helpers = __webpack_require__(30),
        CONSTANTS = __webpack_require__(43);

    function idealHash(curve) {
      switch (curve) {
        case "P-256":
          return "SHA-256";

        case "P-384":
          return "SHA-384";

        case "P-521":
          return "SHA-512";

        default:
          throw new Error("unsupported curve: " + curve);
      }
    } // ### Exported


    var ecdh = module.exports = {}; // ### Derivation algorithms
    // ### "raw" ECDH

    function ecdhDeriveFn() {
      var alg = {
        name: "ECDH"
      };

      var validatePublic = function validatePublic(pk, form) {
        var pubKey = pk && ecUtil.convertToForge(pk, true);

        if (!pubKey || !pubKey.isValid()) {
          return Promise.reject(new Error("invalid EC public key"));
        }

        switch (form) {
          case "jwk":
            pubKey = ecUtil.convertToJWK(pk, true);
            break;

          case "buffer":
            pubKey = ecUtil.convertToBuffer(pk, true);
            break;
        }

        return Promise.resolve(pubKey);
      }; // ### fallback implementation -- uses ecc + forge


      var fallback = function fallback(key, props) {
        props = props || {};
        var keyLen = props.length || 0; // assume {key} is privateKey
        // assume {props.public} is publicKey

        var privKey = ecUtil.convertToForge(key, false);
        var p = validatePublic(props.public, "forge");
        p = p.then(function (pubKey) {
          // {pubKey} is "forge"
          var secret = privKey.computeSecret(pubKey);

          if (keyLen) {
            // truncate to requested key length
            if (secret.length < keyLen) {
              return Promise.reject(new Error("key length too large: " + keyLen));
            }

            secret = secret.slice(0, keyLen);
          }

          return secret;
        });
        return p;
      }; // ### WebCryptoAPI implementation
      // TODO: cache CryptoKey sooner


      var webcrypto = function webcrypto(key, props) {
        key = key || {};
        props = props || {};
        var keyLen = props.length || 0,
            algParams = merge(clone(alg), {
          namedCurve: key.crv
        }); // assume {key} is privateKey

        if (!keyLen) {
          // calculate key length from private key size
          keyLen = key.d.length;
        }

        var privKey = ecUtil.convertToJWK(key, false);
        privKey = helpers.subtleCrypto.importKey("jwk", privKey, algParams, false, ["deriveBits"]); // assume {props.public} is publicKey

        var pubKey = validatePublic(props.public, "jwk");
        pubKey = pubKey.then(function (pubKey) {
          // {pubKey} is "jwk"
          return helpers.subtleCrypto.importKey("jwk", pubKey, algParams, false, []);
        });
        var p = Promise.all([privKey, pubKey]);
        p = p.then(function (keypair) {
          var privKey = keypair[0],
              pubKey = keypair[1];
          var algParams = merge(clone(alg), {
            public: pubKey
          });
          return helpers.subtleCrypto.deriveBits(algParams, privKey, keyLen * 8);
        });
        p = p.then(function (result) {
          result = Buffer.from(result);
          return result;
        });
        return p;
      };

      var nodejs = function nodejs(key, props) {
        if ("function" !== typeof helpers.nodeCrypto.createECDH) {
          throw new Error("unsupported algorithm: ECDH");
        }

        props = props || {};
        var keyLen = props.length || 0;
        var curve;

        switch (key.crv) {
          case "P-256":
            curve = "prime256v1";
            break;

          case "P-384":
            curve = "secp384r1";
            break;

          case "P-521":
            curve = "secp521r1";
            break;

          default:
            return Promise.reject(new Error("invalid curve: " + curve));
        } // assume {key} is privateKey
        // assume {props.public} is publicKey


        var privKey = ecUtil.convertToBuffer(key, false);
        var p = validatePublic(props.public, "buffer");
        p = p.then(function (pubKey) {
          // {pubKey} is "buffer"
          var ecdh = helpers.nodeCrypto.createECDH(curve); // dummy call so computeSecret doesn't fail
          // ecdh.generateKeys();

          ecdh.setPrivateKey(privKey);
          var secret = ecdh.computeSecret(pubKey);

          if (keyLen) {
            if (secret.length < keyLen) {
              return Promise.reject(new Error("key length too large: " + keyLen));
            }

            secret = secret.slice(0, keyLen);
          }

          return secret;
        });
        return p;
      };

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    }

    function ecdhConcatDeriveFn() {
      // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
      //       implemented using other primitives
      var fn = function fn(key, props) {
        props = props || {};
        var hash;

        try {
          hash = props.hash || idealHash(key.crv);

          if (!hash) {
            throw new Error("invalid hash: " + hash);
          }

          hash.toUpperCase();
        } catch (ex) {
          return Promise.reject(ex);
        }

        var params = ["public"]; // derive shared secret
        // NOTE: whitelist items from {props} for ECDH

        var promise = ecdh.ECDH.derive(key, pick(props, params)); // expand

        promise = promise.then(function (shared) {
          // NOTE: blacklist items from {props} for ECDH
          return concat["CONCAT-" + hash].derive(shared, omit(props, params));
        });
        return promise;
      };

      return fn;
    }

    function ecdhHkdfDeriveFn() {
      // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
      //       implemented using other primitives
      var fn = function fn(key, props) {
        props = props || {};
        var hash;

        try {
          hash = props.hash || idealHash(key.crv);

          if (!hash) {
            throw new Error("invalid hash: " + hash);
          }

          hash.toUpperCase();
        } catch (ex) {
          return Promise.reject(ex);
        }

        var params = ["public"]; // derive shared secret
        // NOTE: whitelist items from {props} for ECDH

        var promise = ecdh.ECDH.derive(key, pick(props, params)); // extract-and-expand

        promise = promise.then(function (shared) {
          // NOTE: blacklist items from {props} for ECDH
          return hkdf["HKDF-" + hash].derive(shared, omit(props, params));
        });
        return promise;
      };

      return fn;
    } // ### Wrap/Unwrap algorithms


    function doEcdhesCommonDerive(privKey, pubKey, props) {
      function prependLen(input) {
        return Buffer.concat([helpers.int32ToBuffer(input.length), input]);
      }

      var algId = props.algorithm || "",
          keyLen = CONSTANTS.KEYLENGTH[algId],
          apu = util.asBuffer(props.apu || "", "base64url"),
          apv = util.asBuffer(props.apv || "", "base64url");
      var otherInfo = Buffer.concat([prependLen(Buffer.from(algId, "utf8")), prependLen(apu), prependLen(apv), helpers.int32ToBuffer(keyLen)]);
      var params = {
        public: pubKey,
        length: keyLen / 8,
        hash: "SHA-256",
        otherInfo: otherInfo
      };
      return ecdh["ECDH-CONCAT"].derive(privKey, params);
    }

    function ecdhesDirEncryptFn() {
      // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
      //       implemented using other primitives
      var fn = function fn(key, pdata, props) {
        props = props || {}; // {props.epk} is private

        if (!props.epk || !props.epk.d) {
          return Promise.reject(new Error("missing ephemeral private key"));
        }

        var epk = ecUtil.convertToObj(props.epk, false); // {key} is public

        if (!key || !key.x || !key.y) {
          return Promise.reject(new Error("missing static public key"));
        }

        var spk = ecUtil.convertToObj(key, true); // derive ECDH shared

        var promise = doEcdhesCommonDerive(epk, spk, {
          algorithm: props.enc,
          apu: props.apu,
          apv: props.apv
        });
        promise = promise.then(function (shared) {
          return {
            data: shared,
            once: true,
            direct: true
          };
        });
        return promise;
      };

      return fn;
    }

    function ecdhesDirDecryptFn() {
      // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
      //       implemented using other primitives
      var fn = function fn(key, cdata, props) {
        props = props || {}; // {props.epk} is public

        if (!props.epk || !props.epk.x || !props.epk.y) {
          return Promise.reject(new Error("missing ephemeral public key"));
        }

        var epk = ecUtil.convertToObj(props.epk, true); // {key} is private

        if (!key || !key.d) {
          return Promise.reject(new Error("missing static private key"));
        }

        var spk = ecUtil.convertToObj(key, false); // derive ECDH shared

        var promise = doEcdhesCommonDerive(spk, epk, {
          algorithm: props.enc,
          apu: props.apu,
          apv: props.apv
        });
        promise = promise.then(function (shared) {
          return shared;
        });
        return promise;
      };

      return fn;
    }

    function ecdhesKwEncryptFn(wrap) {
      // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
      //       implemented using other primitives
      var fn = function fn(key, pdata, props) {
        props = props || {}; // {props.epk} is private

        if (!props.epk || !props.epk.d) {
          return Promise.reject(new Error("missing ephemeral private key"));
        }

        var epk = ecUtil.convertToObj(props.epk, false); // {key} is public

        if (!key || !key.x || !key.y) {
          return Promise.reject(new Error("missing static public key"));
        }

        var spk = ecUtil.convertToObj(key, true); // derive ECDH shared

        var promise = doEcdhesCommonDerive(epk, spk, {
          algorithm: props.alg,
          apu: props.apu,
          apv: props.apv
        });
        promise = promise.then(function (shared) {
          // wrap provided key with ECDH shared
          return wrap(shared, pdata);
        });
        return promise;
      };

      return fn;
    }

    function ecdhesKwDecryptFn(unwrap) {
      // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
      //       implemented using other primitives
      var fn = function fn(key, cdata, props) {
        props = props || {}; // {props.epk} is public

        if (!props.epk || !props.epk.x || !props.epk.y) {
          return Promise.reject(new Error("missing ephemeral public key"));
        }

        var epk = ecUtil.convertToObj(props.epk, true); // {key} is private

        if (!key || !key.d) {
          return Promise.reject(new Error("missing static private key"));
        }

        var spk = ecUtil.convertToObj(key, false); // derive ECDH shared

        var promise = doEcdhesCommonDerive(spk, epk, {
          algorithm: props.alg,
          apu: props.apu,
          apv: props.apv
        });
        promise = promise.then(function (shared) {
          // unwrap provided key with ECDH shared
          return unwrap(shared, cdata);
        });
        return promise;
      };

      return fn;
    } // ### Public API
    // * [name].derive


    ["ECDH", "ECDH-HKDF", "ECDH-CONCAT"].forEach(function (name) {
      var kdf = /^ECDH(?:-(\w+))?$/g.exec(name || "")[1];
      var op = ecdh[name] = ecdh[name] || {};

      switch (kdf || "") {
        case "CONCAT":
          op.derive = ecdhConcatDeriveFn();
          break;

        case "HKDF":
          op.derive = ecdhHkdfDeriveFn();
          break;

        case "":
          op.derive = ecdhDeriveFn();
          break;

        default:
          op.derive = null;
      }
    }); // * [name].encrypt
    // * [name].decrypt

    ["ECDH-ES", "ECDH-ES+A128KW", "ECDH-ES+A192KW", "ECDH-ES+A256KW"].forEach(function (name) {
      var kw = /^ECDH-ES(?:\+(.+))?/g.exec(name || "")[1];
      var op = ecdh[name] = ecdh[name] || {};

      if (!kw) {
        op.encrypt = ecdhesDirEncryptFn();
        op.decrypt = ecdhesDirDecryptFn();
      } else {
        kw = aesKw[kw];

        if (kw) {
          op.encrypt = ecdhesKwEncryptFn(kw.encrypt);
          op.decrypt = ecdhesKwDecryptFn(kw.decrypt);
        } else {
          op.ecrypt = op.decrypt = null;
        }
      }
    }); //*/

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 550 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/ecdsa.js - Elliptic Curve Digitial Signature Algorithms
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var ecUtil = __webpack_require__(151),
        helpers = __webpack_require__(30),
        sha = __webpack_require__(102);

    function idealCurve(hash) {
      switch (hash) {
        case "SHA-256":
          return "P-256";

        case "SHA-384":
          return "P-384";

        case "SHA-512":
          return "P-521";

        default:
          throw new Error("unsupported hash: " + hash);
      }
    }

    function ecdsaSignFN(hash) {
      var curve = idealCurve(hash); // ### Fallback implementation -- uses forge

      var fallback = function fallback(key, pdata
      /*, props */
      ) {
        if (curve !== key.crv) {
          return Promise.reject(new Error("invalid curve"));
        }

        var pk = ecUtil.convertToForge(key, false);
        var promise; // generate hash

        promise = sha[hash].digest(pdata); // sign hash

        promise = promise.then(function (result) {
          result = pk.sign(result);
          result = Buffer.concat([result.r, result.s]);
          return {
            data: pdata,
            mac: result
          };
        });
        return promise;
      }; // ### WebCrypto API implementation


      var webcrypto = function webcrypto(key, pdata
      /*, props */
      ) {
        if (curve !== key.crv) {
          return Promise.reject(new Error("invalid curve"));
        }

        var pk = ecUtil.convertToJWK(key, false);
        var promise;
        var alg = {
          name: "ECDSA",
          namedCurve: pk.crv,
          hash: {
            name: hash
          }
        };
        promise = helpers.subtleCrypto.importKey("jwk", pk, alg, true, ["sign"]);
        promise = promise.then(function (key) {
          return helpers.subtleCrypto.sign(alg, key, pdata);
        });
        promise = promise.then(function (result) {
          result = Buffer.from(result);
          return {
            data: pdata,
            mac: result
          };
        });
        return promise;
      };

      var nodejs;
      var nodeHash = hash.toLowerCase().replace("-", "");

      if (helpers.nodeCrypto && helpers.nodeCrypto.getHashes().indexOf(nodeHash) > -1) {
        nodejs = function nodejs(key, pdata) {
          if (curve !== key.crv) {
            return Promise.reject(new Error("invalid curve"));
          }

          var promise;
          promise = Promise.resolve(helpers.nodeCrypto.createSign(nodeHash));
          promise = promise.then(function (sign) {
            sign.update(pdata);
            return sign;
          });
          var size;

          switch (nodeHash.slice(-3)) {
            case "384":
              size = 48;
              break;

            case "512":
              size = 66;
              break;

            default:
              size = 32;
          }

          promise = promise.then(function (sign) {
            return ecUtil.derToConcat(sign.sign(ecUtil.convertToPEM(key, true)), size);
          });
          promise = promise.then(function (result) {
            return {
              data: pdata,
              mac: result
            };
          });
          return promise;
        };
      }

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    }

    function ecdsaVerifyFN(hash) {
      var curve = idealCurve(hash); // ### Fallback implementation -- uses forge

      var fallback = function fallback(key, pdata, mac
      /*, props */
      ) {
        if (curve !== key.crv) {
          return Promise.reject(new Error("invalid curve"));
        }

        var pk = ecUtil.convertToForge(key, true);
        var promise; // generate hash

        promise = sha[hash].digest(pdata); // verify hash

        promise = promise.then(function (result) {
          var len = mac.length / 2;
          var rs = {
            r: mac.slice(0, len),
            s: mac.slice(len)
          };

          if (!pk.verify(result, rs)) {
            return Promise.reject(new Error("verification failed"));
          }

          return {
            data: pdata,
            mac: mac,
            valid: true
          };
        });
        return promise;
      }; // ### WebCrypto API implementation


      var webcrypto = function webcrypto(key, pdata, mac
      /* , props */
      ) {
        if (curve !== key.crv) {
          return Promise.reject(new Error("invalid curve"));
        }

        var pk = ecUtil.convertToJWK(key, true);
        var promise;
        var alg = {
          name: "ECDSA",
          namedCurve: pk.crv,
          hash: {
            name: hash
          }
        };
        promise = helpers.subtleCrypto.importKey("jwk", pk, alg, true, ["verify"]);
        promise = promise.then(function (key) {
          return helpers.subtleCrypto.verify(alg, key, mac, pdata);
        });
        promise = promise.then(function (result) {
          if (!result) {
            return Promise.reject(new Error("verification failed"));
          }

          return {
            data: pdata,
            mac: mac,
            valid: true
          };
        });
        return promise;
      };

      var nodejs;
      var nodeHash = hash.toLowerCase().replace("-", "");

      if (helpers.nodeCrypto && helpers.nodeCrypto.getHashes().indexOf(nodeHash) > -1) {
        nodejs = function nodejs(key, pdata, mac
        /* , props */
        ) {
          if (curve !== key.crv) {
            return Promise.reject(new Error("invalid curve"));
          }

          var size;

          switch (nodeHash.slice(-3)) {
            case "384":
              size = 48;
              break;

            case "512":
              size = 66;
              break;

            default:
              size = 32;
          }

          var promise;
          promise = Promise.resolve(helpers.nodeCrypto.createVerify(nodeHash));
          promise = promise.then(function (verify) {
            verify.update(pdata);
            verify.end();
            return verify.verify(ecUtil.convertToPEM(key, false), ecUtil.concatToDer(mac, size));
          });
          promise = promise.then(function (result) {
            if (!result) {
              throw new Error('verification failed');
            }

            return {
              data: pdata,
              mac: mac,
              valid: true
            };
          });
          return promise;
        };
      }

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    } // ### Public API


    var ecdsa = {}; // * [name].sign
    // * [name].verify

    ["ES256", "ES384", "ES512"].forEach(function (name) {
      var hash = name.replace(/ES(\d+)/g, function (m, size) {
        return "SHA-" + size;
      });
      ecdsa[name] = {
        sign: ecdsaSignFN(hash),
        verify: ecdsaVerifyFN(hash)
      };
    });
    module.exports = ecdsa;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 551 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/pbes2.js - Password-Based Encryption (v2) Algorithms
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var forge = __webpack_require__(14),
        merge = __webpack_require__(48),
        util = __webpack_require__(19),
        helpers = __webpack_require__(30),
        CONSTANTS = __webpack_require__(43),
        KW = __webpack_require__(150);

    var NULL_BUFFER = Buffer.from([0]);
    var DEFAULT_ITERATIONS = 8192;
    var DEFAULT_SALT_LENGTH = 16;

    function fixSalt(hmac, kw, salt) {
      var alg = "PBES2-" + hmac + "+" + kw;
      var output = [Buffer.from(alg, "utf8"), NULL_BUFFER, salt];
      return Buffer.concat(output);
    }

    function pbkdf2Fn(hash) {
      function prepareProps(props) {
        props = props || {};
        var keyLen = props.length || 0;
        var salt = util.asBuffer(props.salt || Buffer.alloc(0), "base64u4l"),
            itrs = props.iterations || 0;

        if (0 >= keyLen) {
          throw new Error("invalid key length");
        }

        if (0 >= itrs) {
          throw new Error("invalid iteration count");
        }

        props.length = keyLen;
        props.salt = salt;
        props.iterations = itrs;
        return props;
      }

      var fallback = function fallback(key, props) {
        try {
          props = prepareProps(props);
        } catch (err) {
          return Promise.reject(err);
        }

        var keyLen = props.length,
            salt = props.salt,
            itrs = props.iterations;
        var promise = new Promise(function (resolve, reject) {
          var md = forge.md[hash.replace("-", "").toLowerCase()].create();

          var cb = function cb(err, dk) {
            if (err) {
              reject(err);
            } else {
              dk = Buffer.from(dk, "binary");
              resolve(dk);
            }
          };

          forge.pkcs5.pbkdf2(key.toString("binary"), salt.toString("binary"), itrs, keyLen, md, cb);
        });
        return promise;
      };

      var webcrypto = function webcrypto(key, props) {
        try {
          props = prepareProps(props);
        } catch (err) {
          return Promise.reject(err);
        }

        var keyLen = props.length,
            salt = props.salt,
            itrs = props.iterations;
        var promise = Promise.resolve(key);
        promise = promise.then(function (keyval) {
          return helpers.subtleCrypto.importKey("raw", keyval, "PBKDF2", false, ["deriveBits"]);
        });
        promise = promise.then(function (key) {
          var mainAlgo = {
            name: "PBKDF2",
            salt: new Uint8Array(salt),
            iterations: itrs,
            hash: hash
          };
          return helpers.subtleCrypto.deriveBits(mainAlgo, key, keyLen * 8);
        });
        promise = promise.then(function (result) {
          return util.asBuffer(result);
        });
        return promise;
      };

      var nodejs = function nodejs(key, props) {
        if (6 > helpers.nodeCrypto.pbkdf2.length) {
          throw new Error("unsupported algorithm: PBKDF2-" + hash);
        }

        try {
          props = prepareProps(props);
        } catch (err) {
          return Promise.reject(err);
        }

        var keyLen = props.length,
            salt = props.salt,
            itrs = props.iterations;
        var md = hash.replace("-", "");
        var promise = new Promise(function (resolve, reject) {
          function cb(err, dk) {
            if (err) {
              reject(err);
            } else {
              resolve(dk);
            }
          }

          helpers.nodeCrypto.pbkdf2(key, salt, itrs, keyLen, md, cb);
        });
        return promise;
      };

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    }

    function pbes2EncryptFN(hmac, kw) {
      var deriveAlg = "PBKDF2-" + hmac.replace("HS", "SHA-");
      var keyLen = CONSTANTS.KEYLENGTH[kw] / 8;
      return function (key, pdata, props) {
        props = props || {};
        var salt = util.asBuffer(props.p2s || Buffer.alloc(0), "base64url"),
            itrs = props.p2c || DEFAULT_ITERATIONS;

        if (0 >= itrs) {
          throw new Error("invalid iteration count");
        }

        if (0 === salt.length) {
          salt = util.randomBytes(DEFAULT_SALT_LENGTH);
        } else if (8 > salt.length) {
          throw new Error("salt too small");
        }

        var header = {
          p2s: util.base64url.encode(salt),
          p2c: itrs
        };
        salt = fixSalt(hmac, kw, salt);
        props = merge(props, {
          salt: salt,
          iterations: itrs,
          length: keyLen
        });
        var promise = Promise.resolve(key); // STEP 1: derive shared key

        promise = promise.then(function (key) {
          return pbes2[deriveAlg].derive(key, props);
        }); // STEP 2: encrypt cek

        promise = promise.then(function (dk) {
          return KW[kw].encrypt(dk, pdata);
        }); // STEP 3: (re-)apply headers

        promise = promise.then(function (results) {
          results.header = merge(results.header || {}, header);
          return results;
        });
        return promise;
      };
    }

    function pbes2DecryptFN(hmac, kw) {
      var deriveAlg = "PBKDF2-" + hmac.replace("HS", "SHA-");
      var keyLen = CONSTANTS.KEYLENGTH[kw] / 8;
      return function (key, cdata, props) {
        props = props || {};
        var salt = util.asBuffer(props.p2s || Buffer.alloc(0), "base64url"),
            itrs = props.p2c || 0;

        if (0 >= itrs) {
          return Promise.reject(new Error("invalid iteration count"));
        }

        if (8 > salt.length) {
          return Promise.reject(new Error("salt too small"));
        }

        salt = fixSalt(hmac, kw, salt);
        props = merge(props, {
          salt: salt,
          iterations: itrs,
          length: keyLen
        });
        var promise = Promise.resolve(key); // STEP 1: derived shared key

        promise = promise.then(function (key) {
          return pbes2[deriveAlg].derive(key, props);
        }); // STEP 2: decrypt cek

        promise = promise.then(function (dk) {
          return KW[kw].decrypt(dk, cdata);
        });
        return promise;
      };
    } // ### Public API


    var pbes2 = {}; // * [name].derive

    ["PBKDF2-SHA-256", "PBKDF2-SHA-384", "PBKDF2-SHA-512"].forEach(function (alg) {
      var hash = alg.replace("PBKDF2-", "");
      pbes2[alg] = {
        derive: pbkdf2Fn(hash)
      };
    }); // [name].encrypt
    // [name].decrypt

    ["PBES2-HS256+A128KW", "PBES2-HS384+A192KW", "PBES2-HS512+A256KW"].forEach(function (alg) {
      var parts = /PBES2-(HS\d+)\+(A\d+KW)/g.exec(alg);
      var hmac = parts[1],
          kw = parts[2];
      pbes2[alg] = {
        encrypt: pbes2EncryptFN(hmac, kw),
        decrypt: pbes2DecryptFN(hmac, kw)
      };
    });
    module.exports = pbes2;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 552 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/rsaes.js - RSA Signatures
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var forge = __webpack_require__(14),
        helpers = __webpack_require__(30),
        DataBuffer = __webpack_require__(82),
        rsaUtil = __webpack_require__(154);

    var nodeSupport = {
      'RSA-OAEP': 'RSA_PKCS1_OAEP_PADDING',
      RSA1_5: 'RSA_PKCS1_PADDING'
    };

    function nodeSupportCheck(name) {
      return helpers.nodeCrypto && helpers.nodeCrypto.constants && Object.keys(nodeSupport).indexOf(name) !== -1;
    } // ### RSAES-PKCS1-v1_5
    // ### RSAES-OAEP


    function rsaesEncryptFn(name) {
      var alg = {
        name: name
      };

      if ("RSA-OAEP-256" === name) {
        alg.name = "RSA-OAEP";
        alg.hash = {
          name: "SHA-256"
        };
      } else if ("RSA-OAEP" === name) {
        alg.hash = {
          name: "SHA-1"
        };
      } else {
        alg.name = "RSAES-PKCS1-v1_5";
      } // ### Fallback Implementation -- uses forge


      var fallback = function fallback(key, pdata) {
        // convert pdata to byte string
        pdata = new DataBuffer(pdata).bytes(); // encrypt it

        var pki = rsaUtil.convertToForge(key, true),
            params = {};

        if ("RSA-OAEP" === alg.name) {
          params.md = alg.hash.name.toLowerCase().replace(/-/g, "");
          params.md = forge.md[params.md].create();
        }

        var cdata = pki.encrypt(pdata, alg.name.toUpperCase(), params); // convert cdata to Buffer

        cdata = new DataBuffer(cdata).native();
        return Promise.resolve({
          data: cdata
        });
      }; // ### WebCryptoAPI Implementation


      var webcrypto;

      if ("RSAES-PKCS1-v1_5" !== alg.name) {
        webcrypto = function webcrypto(key, pdata) {
          key = rsaUtil.convertToJWK(key, true);
          var promise;
          promise = helpers.subtleCrypto.importKey("jwk", key, alg, true, ["encrypt"]);
          promise = promise.then(function (key) {
            return helpers.subtleCrypto.encrypt(alg, key, pdata);
          });
          promise = promise.then(function (result) {
            var cdata = Buffer.from(result);
            return {
              data: cdata
            };
          });
          return promise;
        };
      } else {
        webcrypto = null;
      }

      var nodejs;

      if (nodeSupportCheck(name)) {
        nodejs = function nodejs(key, pdata) {
          key = rsaUtil.convertToPem(key, true);
          var cdata = helpers.nodeCrypto.publicEncrypt({
            key: key,
            padding: helpers.nodeCrypto.constants[nodeSupport[name]]
          }, pdata);
          return {
            data: cdata
          };
        };
      }

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    }

    function rsaesDecryptFn(name) {
      var alg = {
        name: name
      };

      if ("RSA-OAEP-256" === name) {
        alg.name = "RSA-OAEP";
        alg.hash = {
          name: "SHA-256"
        };
      } else if ("RSA-OAEP" === name) {
        alg.hash = {
          name: "SHA-1"
        };
      } else {
        alg.name = "RSAES-PKCS1-v1_5";
      } // ### Fallback Implementation -- uses forge


      var fallback = function fallback(key, cdata) {
        // convert cdata to byte string
        cdata = new DataBuffer(cdata).bytes(); // decrypt it

        var pki = rsaUtil.convertToForge(key, false),
            params = {};

        if ("RSA-OAEP" === alg.name) {
          params.md = alg.hash.name.toLowerCase().replace(/-/g, "");
          params.md = forge.md[params.md].create();
        }

        var pdata = pki.decrypt(cdata, alg.name.toUpperCase(), params); // convert pdata to Buffer

        pdata = new DataBuffer(pdata).native();
        return Promise.resolve(pdata);
      }; // ### WebCryptoAPI Implementation


      var webcrypto;

      if ("RSAES-PKCS1-v1_5" !== alg.name) {
        webcrypto = function webcrypto(key, pdata) {
          key = rsaUtil.convertToJWK(key, false);
          var promise;
          promise = helpers.subtleCrypto.importKey("jwk", key, alg, true, ["decrypt"]);
          promise = promise.then(function (key) {
            return helpers.subtleCrypto.decrypt(alg, key, pdata);
          });
          promise = promise.then(function (result) {
            var pdata = Buffer.from(result);
            return pdata;
          });
          return promise;
        };
      } else {
        webcrypto = null;
      }

      var nodejs;

      if (nodeSupportCheck(name)) {
        // node ^6.12.0 || >= 8.0.0
        nodejs = function nodejs(key, pdata) {
          key = rsaUtil.convertToPem(key, false);
          return helpers.nodeCrypto.privateDecrypt({
            key: key,
            padding: helpers.nodeCrypto.constants[nodeSupport[name]]
          }, pdata);
        };
      } else if (helpers.nodeCrypto && name === 'RSA-OAEP') {
        // node (>= 6.0.0 && < 6.12.0) || ^7.0.0
        nodejs = function nodejs(key, pdata) {
          key = rsaUtil.convertToPem(key, false);
          return helpers.nodeCrypto.privateDecrypt(key, pdata);
        };
      }

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    } // ### Public API
    // * [name].encrypt
    // * [name].decrypt


    var rsaes = {};
    ["RSA-OAEP", "RSA-OAEP-256", "RSA1_5"].forEach(function (name) {
      rsaes[name] = {
        encrypt: rsaesEncryptFn(name),
        decrypt: rsaesDecryptFn(name)
      };
    });
    module.exports = rsaes;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 553 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * algorithms/rsassa.js - RSA Signatures
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var forge = __webpack_require__(14),
        CONSTANTS = __webpack_require__(43),
        helpers = __webpack_require__(30),
        rsaUtil = __webpack_require__(154);

    function nodePSSsupport() {
      return helpers.nodeCrypto && helpers.nodeCrypto.constants && helpers.nodeCrypto.constants.RSA_PSS_SALTLEN_DIGEST;
    } // ### RSASSA-PKCS1-v1_5


    function rsassaV15SignFn(name) {
      var md = name.replace("RS", "SHA").toLowerCase(),
          hash = name.replace("RS", "SHA-");
      var alg = {
        name: "RSASSA-PKCS1-V1_5",
        hash: {
          name: hash
        }
      }; // ### Fallback Implementation -- uses forge

      var fallback = function fallback(key, pdata) {
        // create the digest
        var digest = forge.md[md].create();
        digest.start();
        digest.update(pdata); // sign it

        var pki = rsaUtil.convertToForge(key, false);
        var sig = pki.sign(digest, "RSASSA-PKCS1-V1_5");
        sig = Buffer.from(sig, "binary");
        return Promise.resolve({
          data: pdata,
          mac: sig
        });
      }; // ### WebCryptoAPI Implementation


      var webcrypto = function webcrypto(key, pdata) {
        key = rsaUtil.convertToJWK(key, false);
        var promise;
        promise = helpers.subtleCrypto.importKey("jwk", key, alg, true, ["sign"]);
        promise = promise.then(function (key) {
          return helpers.subtleCrypto.sign(alg, key, pdata);
        });
        promise = promise.then(function (result) {
          var sig = Buffer.from(result);
          return {
            data: pdata,
            mac: sig
          };
        });
        return promise;
      };

      var nodejs;
      var nodeHash = "RSA-" + hash.replace("-", "");

      if (helpers.nodeCrypto && helpers.nodeCrypto.getHashes().indexOf(nodeHash) > -1) {
        nodejs = function nodejs(key, pdata) {
          var sign = helpers.nodeCrypto.createSign(nodeHash);
          sign.update(pdata);
          return {
            data: pdata,
            mac: sign.sign(rsaUtil.convertToPem(key, false))
          };
        };
      }

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    }

    function rsassaV15VerifyFn(name) {
      var md = name.replace("RS", "SHA").toLowerCase(),
          hash = name.replace("RS", "SHA-");
      var alg = {
        name: "RSASSA-PKCS1-V1_5",
        hash: {
          name: hash
        }
      }; // ### Fallback implementation -- uses forge

      var fallback = function fallback(key, pdata, mac) {
        // create the digest
        var digest = forge.md[md].create();
        digest.start();
        digest.update(pdata);
        digest = digest.digest().bytes(); // verify it

        var pki = rsaUtil.convertToForge(key, true);
        var sig = mac.toString("binary");
        var result = pki.verify(digest, sig, "RSASSA-PKCS1-V1_5");

        if (!result) {
          return Promise.reject(new Error("verification failed"));
        }

        return Promise.resolve({
          data: pdata,
          mac: mac,
          valid: true
        });
      }; // ### WebCryptoAPI Implementation


      var webcrypto = function webcrypto(key, pdata, mac) {
        key = rsaUtil.convertToJWK(key, true);
        var promise;
        promise = helpers.subtleCrypto.importKey("jwk", key, alg, true, ["verify"]);
        promise = promise.then(function (key) {
          return helpers.subtleCrypto.verify(alg, key, mac, pdata);
        });
        promise = promise.then(function (result) {
          if (!result) {
            return Promise.reject(new Error("verification failed"));
          }

          return {
            data: pdata,
            mac: mac,
            valid: true
          };
        });
        return promise;
      };

      var nodejs;

      if (helpers.nodeCrypto && helpers.nodeCrypto.getHashes().indexOf(md) > -1) {
        nodejs = function nodejs(key, pdata, mac) {
          var verify = helpers.nodeCrypto.createVerify(md);
          verify.update(pdata);
          verify.end();
          var result = verify.verify(rsaUtil.convertToPem(key, true), mac);

          if (!result) {
            return Promise.reject(new Error("verification failed"));
          }

          return {
            data: pdata,
            mac: mac,
            valid: true
          };
        };
      }

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    } // ### RSA-PSS


    function rsassaPssSignFn(name) {
      var md = name.replace("PS", "SHA").toLowerCase(),
          hash = name.replace("PS", "SHA-");
      var alg = {
        name: "RSA-PSS",
        hash: {
          name: hash
        },
        saltLength: CONSTANTS.HASHLENGTH[hash] / 8
      }; // ### Fallback implementation -- uses forge

      var fallback = function fallback(key, pdata) {
        // create the digest
        var digest = forge.md[md].create();
        digest.start();
        digest.update(pdata); // setup padding

        var pss = forge.pss.create({
          md: forge.md[md].create(),
          mgf: forge.mgf.mgf1.create(forge.md[md].create()),
          saltLength: CONSTANTS.HASHLENGTH[hash] / 8
        }); // sign it

        var pki = rsaUtil.convertToForge(key, false);
        var sig = pki.sign(digest, pss);
        sig = Buffer.from(sig, "binary");
        return Promise.resolve({
          data: pdata,
          mac: sig
        });
      }; // ### WebCryptoAPI Implementation


      var webcrypto = function webcrypto(key, pdata) {
        key = rsaUtil.convertToJWK(key, false);
        var promise;
        promise = helpers.subtleCrypto.importKey("jwk", key, alg, true, ["sign"]);
        promise = promise.then(function (key) {
          return helpers.subtleCrypto.sign(alg, key, pdata);
        });
        promise = promise.then(function (result) {
          var sig = Buffer.from(result);
          return {
            data: pdata,
            mac: sig
          };
        });
        return promise;
      };

      var nodejs;
      var nodeHash = "RSA-" + hash.replace("-", "");

      if (nodePSSsupport()) {
        nodejs = function nodejs(key, pdata) {
          var sign = helpers.nodeCrypto.createSign(nodeHash);
          sign.update(pdata);
          var sig = sign.sign({
            key: rsaUtil.convertToPem(key, false),
            padding: helpers.nodeCrypto.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: helpers.nodeCrypto.constants.RSA_PSS_SALTLEN_DIGEST
          });
          return {
            data: pdata,
            mac: sig
          };
        };
      }

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    }

    function rsassaPssVerifyFn(name) {
      var md = name.replace("PS", "SHA").toLowerCase(),
          hash = name.replace("PS", "SHA-");
      var alg = {
        name: "RSA-PSS",
        hash: {
          name: hash
        },
        saltLength: CONSTANTS.HASHLENGTH[hash] / 8
      }; // ### Fallback implementation -- uses forge

      var fallback = function fallback(key, pdata, mac) {
        // create the digest
        var digest = forge.md[md].create();
        digest.start();
        digest.update(pdata);
        digest = digest.digest().bytes(); // setup padding

        var pss = forge.pss.create({
          md: forge.md[md].create(),
          mgf: forge.mgf.mgf1.create(forge.md[md].create()),
          saltLength: CONSTANTS.HASHLENGTH[hash] / 8
        }); // verify it

        var pki = rsaUtil.convertToForge(key, true);
        var sig = mac.toString("binary");
        var result = pki.verify(digest, sig, pss);

        if (!result) {
          return Promise.reject(new Error("verification failed"));
        }

        return Promise.resolve({
          data: pdata,
          mac: mac,
          valid: true
        });
      }; // ### WebCryptoAPI Implementation


      var webcrypto = function webcrypto(key, pdata, mac) {
        key = rsaUtil.convertToJWK(key, true);
        var promise;
        promise = helpers.subtleCrypto.importKey("jwk", key, alg, true, ["verify"]);
        promise = promise.then(function (key) {
          return helpers.subtleCrypto.verify(alg, key, mac, pdata);
        });
        promise = promise.then(function (result) {
          if (!result) {
            return Promise.reject(new Error("verification failed"));
          }

          return {
            data: pdata,
            mac: mac,
            valid: true
          };
        });
        return promise;
      };

      var nodejs;

      if (nodePSSsupport()) {
        nodejs = function nodejs(key, pdata, mac) {
          var verify = helpers.nodeCrypto.createVerify(md);
          verify.update(pdata);
          verify.end();
          var result = verify.verify({
            key: rsaUtil.convertToPem(key, true),
            padding: helpers.nodeCrypto.constants.RSA_PKCS1_PSS_PADDING
          }, mac);

          if (!result) {
            return Promise.reject(new Error("verification failed"));
          }

          return {
            data: pdata,
            mac: mac,
            valid: true
          };
        };
      }

      return helpers.setupFallback(nodejs, webcrypto, fallback);
    } // ### Public API
    // * [name].sign
    // * [name].verify


    var rsassa = {};
    ["PS256", "PS384", "PS512"].forEach(function (name) {
      rsassa[name] = {
        sign: rsassaPssSignFn(name),
        verify: rsassaPssVerifyFn(name)
      };
    });
    ["RS256", "RS384", "RS512"].forEach(function (name) {
      rsassa[name] = {
        sign: rsassaV15SignFn(name),
        verify: rsassaV15VerifyFn(name)
      };
    });
    module.exports = rsassa;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 554 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * deps/ciphermodes/gcm/index.js - AES-GCM implementation Entry Point
    *
    * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
    */
    var Long = __webpack_require__(141),
        forge = __webpack_require__(14),
        multipliers = __webpack_require__(555),
        helpers = __webpack_require__(233),
        pack = __webpack_require__(103),
        DataBuffer = __webpack_require__(82),
        cipherHelpers = __webpack_require__(556);

    var BLOCK_SIZE = 16; // ### GCM Mode
    // ### Constructor

    function Gcm(options) {
      options = options || {};
      this.name = "GCM";
      this.cipher = options.cipher;
      this.blockSize = this.blockSize || 16;
    } // ### exports


    module.exports = {
      createCipher: function createCipher(options) {
        var alg = new forge.aes.Algorithm("AES-GCM", Gcm);
        alg.initialize({
          key: new DataBuffer(options.key)
        });
        alg.mode.start(options);
        return alg.mode;
      },
      createDecipher: function createDecipher(options) {
        var alg = new forge.aes.Algorithm("AES-GCM", Gcm);
        alg.initialize({
          key: new DataBuffer(options.key)
        });
        alg.mode._decrypt = true;
        alg.mode.start(options);
        return alg.mode;
      }
    }; // ### Public API

    Gcm.prototype.start = function (options) {
      this.tag = null;
      options = options || {};

      if (!("iv" in options)) {
        throw new Error("Gcm needs ParametersWithIV or AEADParameters");
      }

      this.nonce = options.iv;

      if (this.nonce == null || this.nonce.length < 1) {
        throw new Error("IV must be at least 1 byte");
      } // TODO: variable tagLength?


      this.tagLength = 16; // TODO: validate tag

      if ("tag" in options) {
        this.tag = Buffer.from(options.tag);
      }

      var bufLength = !this._decrypt ? this.blockSize : this.blockSize + this.tagLength;
      this.bufBlock = Buffer.alloc(bufLength);
      var multiplier = options.multiplier;

      if (multiplier == null) {
        multiplier = new multipliers["8k"]();
      }

      this.multiplier = multiplier;
      this.H = this.zeroBlock();
      cipherHelpers.encrypt(this.cipher, this.H, 0, this.H, 0); // GcmMultiplier tables don"t change unless the key changes
      // (and are expensive to init)

      this.multiplier.init(this.H);
      this.exp = null;
      this.J0 = this.zeroBlock();

      if (this.nonce.length === 12) {
        this.nonce.copy(this.J0, 0, 0, this.nonce.length);
        this.J0[this.blockSize - 1] = 0x01;
      } else {
        this.gHASH(this.J0, this.nonce, this.nonce.length);
        var X = this.zeroBlock();
        pack.longToBigEndian(new Long(this.nonce.length).multiply(8), X, 8);
        this.gHASHBlock(this.J0, X);
      }

      this.S = this.zeroBlock();
      this.SAt = this.zeroBlock();
      this.SAtPre = this.zeroBlock();
      this.atBlock = this.zeroBlock();
      this.atBlockPos = 0;
      this.atLength = Long.ZERO;
      this.atLengthPre = Long.ZERO;
      this.counter = Buffer.from(this.J0);
      this.bufOff = 0;
      this.totalLength = Long.ZERO;

      if ("additionalData" in options) {
        this.processAADBytes(options.additionalData, 0, options.additionalData.length);
      }
    };

    Gcm.prototype.update = function (inV, inOff, len, out, outOff) {
      var resultLen = 0;

      while (len > 0) {
        var inLen = Math.min(len, this.bufBlock.length - this.bufOff);
        inV.copy(this.bufBlock, this.bufOff, inOff, inOff + inLen);
        len -= inLen;
        inOff += inLen;
        this.bufOff += inLen;

        if (this.bufOff === this.bufBlock.length) {
          this.outputBlock(out, outOff + resultLen);
          resultLen += this.blockSize;
        }
      }

      return resultLen;
    };

    Gcm.prototype.finish = function (out, outOff) {
      var resultLen = 0;

      if (this._decrypt) {
        // append tag
        resultLen += this.update(this.tag, 0, this.tag.length, out, outOff);
      }

      if (this.totalLength.isZero()) {
        this.initCipher();
      }

      var extra = this.bufOff;

      if (this._decrypt) {
        if (extra < this.tagLength) {
          throw new Error("data too short");
        }

        extra -= this.tagLength;
      }

      if (extra > 0) {
        this.gCTRPartial(this.bufBlock, 0, extra, out, outOff + resultLen);
        resultLen += extra;
      }

      this.atLength = this.atLength.add(this.atBlockPos); // Final gHASH

      var X = this.zeroBlock();
      pack.longToBigEndian(this.atLength.multiply(8), X, 0);
      pack.longToBigEndian(this.totalLength.multiply(8), X, 8);
      this.gHASHBlock(this.S, X); // TODO Fix this if tagLength becomes configurable
      // T = MSBt(GCTRk(J0,S))

      var tag = Buffer.alloc(this.blockSize);
      cipherHelpers.encrypt(this.cipher, this.J0, 0, tag, 0);
      this.xor(tag, this.S);

      if (this._decrypt) {
        if (!helpers.arrayEqual(this.tag, tag)) {
          throw new Error("mac check in Gcm failed");
        }
      } else {
        // We place into tag our calculated value for T
        this.tag = Buffer.alloc(this.tagLength);
        tag.copy(this.tag, 0, 0, this.tagLength);
      }

      return resultLen;
    }; // ### "Internal" Helper Functions


    Gcm.prototype.initCipher = function () {
      if (this.atLength.greaterThan(Long.ZERO)) {
        this.SAt.copy(this.SAtPre, 0, 0, this.blockSize);
        this.atLengthPre = this.atLength.add(Long.ZERO);
      } // Finish hash for partial AAD block


      if (this.atBlockPos > 0) {
        this.gHASHPartial(this.SAtPre, this.atBlock, 0, this.atBlockPos);
        this.atLengthPre = this.atLengthPre.add(this.atBlockPos);
      }

      if (this.atLengthPre.greaterThan(Long.ZERO)) {
        this.SAtPre.copy(this.S, 0, 0, this.blockSize);
      }
    };

    Gcm.prototype.outputBlock = function (output, offset) {
      if (this.totalLength.isZero()) {
        this.initCipher();
      }

      this.gCTRBlock(this.bufBlock, output, offset);

      if (!this._decrypt) {
        this.bufOff = 0;
      } else {
        this.bufBlock.copy(this.bufBlock, 0, this.blockSize, this.blockSize + this.tagLength);
        this.bufOff = this.tagLength;
      }
    };

    Gcm.prototype.processAADBytes = function (inV, inOff, len) {
      for (var i = 0; i < len; ++i) {
        this.atBlock[this.atBlockPos] = inV[inOff + i];

        if (++this.atBlockPos === this.blockSize) {
          // Hash each block as it fills
          this.gHASHBlock(this.SAt, this.atBlock);
          this.atBlockPos = 0;
          this.atLength = this.atLength.add(this.blockSize);
        }
      }
    };

    Gcm.prototype.getNextCounterBlock = function () {
      for (var i = 15; i >= 12; --i) {
        var b = this.counter[i] + 1 & 0xff;
        this.counter[i] = b;

        if (b !== 0) {
          break;
        }
      } // encrypt counter


      var outb = Buffer.alloc(this.blockSize);
      cipherHelpers.encrypt(this.cipher, this.counter, 0, outb, 0);
      return outb;
    };

    Gcm.prototype.gCTRBlock = function (block, out, outOff) {
      var tmp = this.getNextCounterBlock();
      this.xor(tmp, block);
      tmp.copy(out, outOff, 0, this.blockSize);
      this.gHASHBlock(this.S, !this._decrypt ? tmp : block);
      this.totalLength = this.totalLength.add(this.blockSize);
    };

    Gcm.prototype.gCTRPartial = function (buf, off, len, out, outOff) {
      var tmp = this.getNextCounterBlock();
      this.xor(tmp, buf, off, len);
      tmp.copy(out, outOff, 0, len);
      this.gHASHPartial(this.S, !this._decrypt ? tmp : buf, 0, len);
      this.totalLength = this.totalLength.add(len);
    };

    Gcm.prototype.gHASHBlock = function (Y, b) {
      this.xor(Y, b);
      this.multiplier.multiplyH(Y);
    };

    Gcm.prototype.gHASHPartial = function (Y, b, off, len) {
      this.xor(Y, b, off, len);
      this.multiplier.multiplyH(Y);
    };

    Gcm.prototype.xor = function (block, val, off, len) {
      switch (arguments.length) {
        case 2:
          for (var i = 15; i >= 0; --i) {
            block[i] ^= val[i];
          }

          break;

        case 4:
          while (len-- > 0) {
            block[len] ^= val[off + len];
          }

          break;

        default:
          throw new TypeError("Expected 2 or 4 arguments.");
      }

      return block;
    };

    Gcm.prototype.zeroBlock = function () {
      var block = Buffer.alloc(BLOCK_SIZE);
      return block;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 555 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * deps/ciphermodes/gcm/multipliers.js - AES-GCM Multipliers
   *
   * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
   */

  var helpers = __webpack_require__(233),
      pack = __webpack_require__(103); // ### 8K Table Multiplier


  function Gcm8KMultiplier() {
    this.H = [];
    this.M = null;
  }

  Gcm8KMultiplier.prototype.init = function (H) {
    var i, j, k;

    if (this.M == null) {
      // sc: I realize this UGLY...
      //M = new int[32][16][4];
      this.M = [];

      for (i = 0; i < 32; ++i) {
        this.M[i] = [];

        for (j = 0; j < 16; ++j) {
          this.M[i][j] = [];

          for (k = 0; k < 4; ++k) {
            this.M[i][j][k] = 0;
          }
        }
      }
    } else if (helpers.arrayEqual(this.H, H)) {
      return;
    }

    this.H = H.slice(); // M[0][0] is ZEROES;
    // M[1][0] is ZEROES;

    helpers.asInts(H, this.M[1][8]);

    for (j = 4; j >= 1; j >>= 1) {
      helpers.multiplyP(this.M[1][j + j], this.M[1][j]);
    }

    helpers.multiplyP(this.M[1][1], this.M[0][8]);

    for (j = 4; j >= 1; j >>= 1) {
      helpers.multiplyP(this.M[0][j + j], this.M[0][j]);
    }

    i = 0;

    for (;;) {
      for (j = 2; j < 16; j += j) {
        for (k = 1; k < j; ++k) {
          helpers.xor(this.M[i][j], this.M[i][k], this.M[i][j + k]);
        }
      }

      if (++i === 32) {
        return;
      }

      if (i > 1) {
        // M[i][0] is ZEROES;
        for (j = 8; j > 0; j >>= 1) {
          helpers.multiplyP8(this.M[i - 2][j], this.M[i][j]);
        }
      }
    }
  };

  Gcm8KMultiplier.prototype.multiplyH = function (x) {
    var z = [];

    for (var i = 15; i >= 0; --i) {
      var m = this.M[i + i][x[i] & 0x0f];
      z[0] ^= m[0];
      z[1] ^= m[1];
      z[2] ^= m[2];
      z[3] ^= m[3];
      m = this.M[i + i + 1][(x[i] & 0xf0) >>> 4];
      z[0] ^= m[0];
      z[1] ^= m[1];
      z[2] ^= m[2];
      z[3] ^= m[3];
    }

    pack.intToBigEndian(z, x, 0);
  };

  module.exports = {
    "8k": Gcm8KMultiplier
  };
  /***/
},
/* 556 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * deps/ciphermodes/helpers.js - Cipher Helper Functions
   *
   * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
   */

  var pack = __webpack_require__(103);

  function doEncrypt(cipher, inb, inOff, outb, outOff) {
    var input = new Array(4),
        output = new Array(4);
    pack.bigEndianToInt(inb, inOff, input);
    cipher.encrypt(input, output);
    pack.intToBigEndian(output, outb, outOff);
  }

  module.exports = {
    encrypt: doEncrypt
  };
  /***/
},
/* 557 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * deps/ecc/curves.js - Elliptic Curve NIST/SECG/X9.62 Parameters
   * Original Copyright (c) 2003-2005  Tom Wu.
   * Modifications Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
   *
   * Ported from Tom Wu, which is ported from BouncyCastle
   * Modified to reuse existing external NPM modules, restricted to the
   * NIST//SECG/X9.62 prime curves only, and formatted to match project
   * coding styles.
   */
  // Named EC curves

  var BigInteger = __webpack_require__(14).jsbn.BigInteger,
      ec = __webpack_require__(235); // ----------------
  // X9ECParameters
  // constructor


  function X9ECParameters(curve, g, n, h) {
    this.curve = curve;
    this.g = g;
    this.n = n;
    this.h = h;
  }

  function x9getCurve() {
    return this.curve;
  }

  function x9getG() {
    return this.g;
  }

  function x9getN() {
    return this.n;
  }

  function x9getH() {
    return this.h;
  }

  X9ECParameters.prototype.getCurve = x9getCurve;
  X9ECParameters.prototype.getG = x9getG;
  X9ECParameters.prototype.getN = x9getN;
  X9ECParameters.prototype.getH = x9getH; // ----------------
  // SECNamedCurves

  function fromHex(s) {
    return new BigInteger(s, 16);
  }

  function secp256r1() {
    // p = 2^224 (2^32 - 1) + 2^192 + 2^96 - 1
    var p = fromHex("FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF");
    var a = fromHex("FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC");
    var b = fromHex("5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B");
    var n = fromHex("FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551");
    var h = BigInteger.ONE;
    var curve = new ec.ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04" + "6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296" + "4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5");
    return new X9ECParameters(curve, G, n, h);
  }

  function secp384r1() {
    // p = 2^384 - 2^128 - 2^96 + 2^32 - 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF");
    var a = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC");
    var b = fromHex("B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF");
    var n = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973");
    var h = BigInteger.ONE;
    var curve = new ec.ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04" + "AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7" + "3617DE4A96262C6F5D9E98BF9292DC29F8F41DBD289A147CE9DA3113B5F0B8C00A60B1CE1D7E819D7A431D7C90EA0E5F");
    return new X9ECParameters(curve, G, n, h);
  }

  function secp521r1() {
    // p = 2^521 - 1
    var p = fromHex("01FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF");
    var a = fromHex("01FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC");
    var b = fromHex("0051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00");
    var n = fromHex("01FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409");
    var h = BigInteger.ONE;
    var curve = new ec.ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04" + "00C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66" + "011839296A789A3BC0045C8A5FB42C7D1BD998F54449579B446817AFBD17273E662C97EE72995EF42640C550B9013FAD0761353C7086A272C24088BE94769FD16650");
    return new X9ECParameters(curve, G, n, h);
  } // ----------------
  // Public API


  var CURVES = module.exports = {
    "secp256r1": secp256r1(),
    "secp384r1": secp384r1(),
    "secp521r1": secp521r1()
  }; // also export NIST names

  CURVES["P-256"] = CURVES.secp256r1;
  CURVES["P-384"] = CURVES.secp384r1;
  CURVES["P-521"] = CURVES.secp521r1;
  /***/
},
/* 558 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * index.js - Main Entry Point
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  if (typeof Promise === "undefined") {
    __webpack_require__(138).polyfill();
  }

  var JWS = __webpack_require__(156);

  module.exports = {
    JWA: __webpack_require__(153),
    JWE: __webpack_require__(155),
    JWK: __webpack_require__(73),
    JWS: JWS,
    util: __webpack_require__(19),
    parse: __webpack_require__(570),
    canYouSee: JWS.createVerify
  };
  /***/
},
/* 559 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * jwe/decrypt.js - Decrypt from a JWE
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var base64url = __webpack_require__(106),
        AlgConfig = __webpack_require__(238),
        JWK = __webpack_require__(73),
        merge = __webpack_require__(48),
        zlib = __webpack_require__(197);

    var DEFAULT_OPTIONS = {
      algorithms: "*"
    };
    /**
     * @class JWE.Decrypter
     * @classdesc Processor of encrypted data.
     *
     * @description
     * **NOTE:** This class cannot be instantiated directly. Instead
     * call {@link JWE.createDecrypt}.
     */

    function JWEDecrypter(ks, globalOpts) {
      var assumedKey, keystore;

      if (JWK.isKey(ks)) {
        assumedKey = ks;
        keystore = assumedKey.keystore;
      } else if (JWK.isKeyStore(ks)) {
        keystore = ks;
      } else {
        throw new TypeError("Keystore must be provided");
      }

      globalOpts = merge(DEFAULT_OPTIONS, globalOpts);
      /**
       * Decrypts the given input.
       *
       * {opts}, if provided, is used to customize this specific decrypt operation.
       * This argument has the same semantics as {JWE.createDecrypt}, and takes
       * precedence over those options.
       *
       * The returned PRomise, when fulfilled, returns an object with the
       * following members:
       *
       * - `header` - The JOSE Header, combined from the relevant "header" and
       *            "protected" fields from the original JWE object.
       * - `protected` - An array containing the names of the protected fields
       * - `key` - The used to decrypt the content
       * - `payload` - The decrypted content (as a Buffer)
       * - `plaintext` - An alias for `payload`
       *
       * @param {Object|String} input The encrypted content
       * @param {Object} [opts] The options for this decryption operation.
       * @returns {Promise} A promise for the decyprted plaintext
       */

      Object.defineProperty(this, "decrypt", {
        value: function value(input, opts) {
          opts = merge({}, globalOpts, opts || {});
          var extraHandlers = opts.handlers || {};
          var handlerKeys = Object.keys(extraHandlers);
          var algSpec = new AlgConfig(opts.algorithms);
          /* eslint camelcase: [0] */

          if (typeof input === "string") {
            input = input.split(".");
            input = {
              protected: input[0],
              recipients: [{
                encrypted_key: input[1]
              }],
              iv: input[2],
              ciphertext: input[3],
              tag: input[4]
            };
          } else if (!input || typeof input !== "object") {
            throw new Error("invalid input");
          }

          if ("encrypted_key" in input) {
            input.recipients = [{
              encrypted_key: input.encrypted_key
            }];
          }

          var promise; // ensure recipients exists

          var rcptList = input.recipients || [{}];
          promise = Promise.resolve(rcptList); //combine fields

          var fields, protect;
          promise = promise.then(function (rcptList) {
            if (input.protected) {
              protect = base64url.decode(input.protected).toString("utf8");
              protect = JSON.parse(protect); // verify "crit" field first

              var crit = protect.crit;

              if (crit) {
                if (!Array.isArray(crit)) {
                  return Promise.reject(new Error("Invalid 'crit' header"));
                }

                for (var idx = 0; crit.length > idx; idx++) {
                  if (-1 === handlerKeys.indexOf(crit[idx])) {
                    return Promise.reject(new Error("Critical extension is not supported: " + crit[idx]));
                  }
                }
              }

              fields = protect;
              protect = Object.keys(protect);
            } else {
              fields = {};
              protect = [];
            }

            fields = merge(input.unprotected || {}, fields);
            rcptList = rcptList.map(function (r) {
              var promise = Promise.resolve();
              var header = r.header || {};
              header = merge(header, fields);
              r.header = header;
              r.protected = protect; // check on allowed algorithms

              if (!algSpec.match(header.alg)) {
                promise = promise.then(function () {
                  return Promise.reject(new Error("Algorithm not allowed: " + header.alg));
                });
              }

              if (!algSpec.match(header.enc)) {
                promise = promise.then(function () {
                  return Promise.reject(new Error("Algorithm not allowed: " + header.enc));
                });
              }

              if (header.epk) {
                promise = promise.then(function () {
                  return JWK.asKey(header.epk);
                });
                promise = promise.then(function (epk) {
                  header.epk = epk.toObject(false);
                });
              }

              return promise.then(function () {
                return r;
              });
            });
            return Promise.all(rcptList);
          }); // decrypt with first key found

          var algKey, encKey, kdata;
          promise = promise.then(function (rcptList) {
            var jwe = {};
            return new Promise(function (resolve, reject) {
              var processKey = function processKey() {
                var rcpt = rcptList.shift();

                if (!rcpt) {
                  reject(new Error("no key found"));
                  return;
                }

                var algPromise = Promise.resolve(rcpt);
                algPromise = algPromise.then(function (rcpt) {
                  // try to unwrap encrypted key
                  var prekey = kdata = rcpt.encrypted_key || "";
                  prekey = base64url.decode(prekey);
                  algKey = assumedKey || keystore.get({
                    use: "enc",
                    alg: rcpt.header.alg,
                    kid: rcpt.header.kid
                  });

                  if (algKey) {
                    return algKey.unwrap(rcpt.header.alg, prekey, rcpt.header);
                  } else {
                    return Promise.reject();
                  }
                });
                algPromise = algPromise.then(function (key) {
                  encKey = {
                    "kty": "oct",
                    "k": base64url.encode(key)
                  };
                  encKey = JWK.asKey(encKey);
                  jwe.key = algKey;
                  jwe.header = rcpt.header;
                  jwe.protected = rcpt.protected;
                  resolve(jwe);
                });
                algPromise.catch(processKey);
              };

              processKey();
            });
          }); // assign decipher inputs

          promise = promise.then(function (jwe) {
            jwe.iv = input.iv;
            jwe.tag = input.tag;
            jwe.ciphertext = input.ciphertext;
            return jwe;
          }); // process any prepare-decrypt handlers

          promise = promise.then(function (jwe) {
            var processing = [];
            handlerKeys.forEach(function (h) {
              h = extraHandlers[h];
              var p;

              if ("function" === typeof h) {
                p = h(jwe);
              } else if ("object" === typeof h && "function" === typeof h.prepare) {
                p = h.prepare(jwe);
              }

              if (p) {
                processing.push(Promise.resolve(p));
              }
            });
            return Promise.all(processing).then(function () {
              // don't actually care about individual handler results
              // assume {jwe} is updated
              return jwe;
            });
          }); // prepare decrypt inputs

          promise = promise.then(function (jwe) {
            if (!Buffer.isBuffer(jwe.ciphertext)) {
              jwe.ciphertext = base64url.decode(jwe.ciphertext);
            }

            return jwe;
          }); // decrypt it!

          promise = promise.then(function (jwe) {
            var adata = input.protected;

            if ("aad" in input && null != input.aad) {
              adata += "." + input.aad;
            }

            var params = {
              iv: jwe.iv,
              adata: adata,
              tag: jwe.tag,
              kdata: kdata,
              epu: jwe.epu,
              epv: jwe.epv
            };
            var cdata = jwe.ciphertext;
            delete jwe.iv;
            delete jwe.tag;
            delete jwe.ciphertext;
            return encKey.then(function (enkKey) {
              return enkKey.decrypt(jwe.header.enc, cdata, params).then(function (pdata) {
                jwe.payload = jwe.plaintext = pdata;
                return jwe;
              });
            });
          }); // (OPTIONAL) decompress plaintext

          promise = promise.then(function (jwe) {
            if ("DEF" === jwe.header.zip) {
              return new Promise(function (resolve, reject) {
                zlib.inflateRaw(Buffer.from(jwe.plaintext), function (err, data) {
                  if (err) {
                    reject(err);
                  } else {
                    jwe.payload = jwe.plaintext = data;
                    resolve(jwe);
                  }
                });
              });
            }

            return jwe;
          }); // process any post-decrypt handlers

          promise = promise.then(function (jwe) {
            var processing = [];
            handlerKeys.forEach(function (h) {
              h = extraHandlers[h];
              var p;

              if ("object" === typeof h && "function" === typeof h.complete) {
                p = h.complete(jwe);
              }

              if (p) {
                processing.push(Promise.resolve(p));
              }
            });
            return Promise.all(processing).then(function () {
              // don't actually care about individual handler results
              // assume {jwe} is updated
              return jwe;
            });
          });
          return promise;
        }
      });
    }
    /**
     * @description
     * Creates a new Decrypter for the given Key or KeyStore.
     *
     * {opts}, when provided, is used to customize decryption processes. The
     * following options are currently supported:
     *
     * - `handlers` - An object where each name is a JOSE header member name and
     *   the value can be a boolean, function, or an object.
     *
     * Handlers are intended to support 'crit' extensions. When a boolean value,
     * the member is expected to be processed once decryption is fully complete.
     * When a function, it is called just before the ciphertext is decrypted
     * (processed as if it were a `prepare` handler, as decribed below). When an
     * object, it can contain any of the following members:
     *
     * - `recipient` - A function called after a valid key is determined; it takes
     *   an object describing the recipient, and returns a Promise that is
     *   fulfilled once the handler's processing is complete.
     * - `prepare` - A function called just prior to decrypting the ciphertext;
     *   it takes an object describing the decryption result (but containing
     *   `ciphertext` and `tag' instead of `payload` and `plaintext`), and
     *   returns a Promise that is fulfilled once the handler's processing is
     *   complete.
     * - `complete` - A function called once decryption is complete, just prior
     *   to fulfilling the Promise returned by `decrypt()`; it takes the object
     *   that will be returned by `decrypt()`'s fulfilled Promise, and returns
     *   a Promise that is fulfilled once the handler's processing is complete.
     *
     * Note that normal processing of `decrypt()` does not continue until all
     * relevant handlers have completed. Any changes handlers make to the
     * provided objects affects `decrypt()`'s processing.
     *
     * @param {JWK.Key|JWK.KeyStore} ks The Key or KeyStore to use for decryption.
     * @param {Object} [opts] The options for this Decrypter.
     * @returns {JWE.Decrypter} The new Decrypter.
     */


    function createDecrypt(ks, opts) {
      var dec = new JWEDecrypter(ks, opts);
      return dec;
    }

    module.exports = {
      decrypter: JWEDecrypter,
      createDecrypt: createDecrypt
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 560 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * jwe/defaults.js - Defaults for JWEs
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  /**
   * @description
   * The default options for {@link JWE.createEncrypt}.
   *
   * @property {Boolean|String} zip Determines the compression algorithm to
   *           apply to the plaintext (if any) before it is encrypted. This can
   *           also be `true` (which is equivalent to `"DEF"`) or **`false`**
   *           (the default, which is equivalent to no compression).
   * @property {String} format Determines the serialization format of the
   *           output.  Expected to be `"general"` for general JSON
   *           Serialization, `"flattened"` for flattened JSON Serialization,
   *           or `"compact"` for Compact Serialization (default is
   *           **`"general"`**).
   * @property {Boolean} compact Determines if the output is the Compact
   *           serialization (`true`) or the JSON serialization (**`false`**,
   *           the default).
   * @property {String} contentAlg The algorithm used to encrypt the plaintext
   *           (default is **`"A128CBC-HS256"`**).
   * @property {String|String[]} protect The names of the headers to integrity
   *           protect.  The value `""` means that none of the header parameters
   *           are integrity protected, while `"*"` (the default) means that all
   *           header parameters are integrity protected.
   */

  var JWEDefaults = {
    zip: false,
    format: "general",
    contentAlg: "A128CBC-HS256",
    protect: "*"
  };
  module.exports = JWEDefaults;
  /***/
},
/* 561 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * jwe/encrypt.js - Encrypt to a JWE
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var assign = __webpack_require__(202),
        clone = __webpack_require__(42),
        util = __webpack_require__(19),
        generateCEK = __webpack_require__(236).generateCEK,
        JWK = __webpack_require__(73),
        slice = __webpack_require__(236).slice,
        zlib = __webpack_require__(197),
        CONSTANTS = __webpack_require__(43);

    var DEFAULTS = __webpack_require__(560);
    /**
     * @class JWE.Encrypter
     * @classdesc
     * Generator of encrypted data.
     *
     * @description
     * **NOTE:** This class cannot be instantiated directly. Instead call {@link
     * JWE.createEncrypt}.
     */


    function JWEEncrypter(cfg, fields, recipients) {
      var finalized = false,
          format = cfg.format || "general",
          protectAll = !!cfg.protectAll,
          content = Buffer.alloc(0);
      /**
       * @member {String} JWE.Encrypter#zip
       * @readonly
       * @description
       * Indicates the compression algorithm applied to the plaintext
       * before it is encrypted.  The possible values are:
       *
       * + **`"DEF"`**: Compress the plaintext using the DEFLATE algorithm.
       * + **`""`**: Do not compress the plaintext.
       */

      Object.defineProperty(this, "zip", {
        get: function get() {
          return fields.zip || "";
        },
        enumerable: true
      });
      /**
       * @member {Boolean} JWE.Encrypter#compact
       * @readonly
       * @description
       * Indicates whether the output of this encryption generator is
       * using the Compact serialization (`true`) or the JSON
       * serialization (`false`).
       */

      Object.defineProperty(this, "compact", {
        get: function get() {
          return "compact" === format;
        },
        enumerable: true
      });
      /**
       * @member {String} JWE.Encrypter#format
       * @readonly
       * @description
       * Indicates the format the output of this encryption generator takes.
       */

      Object.defineProperty(this, "format", {
        get: function get() {
          return format;
        },
        enumerable: true
      });
      /**
       * @member {String[]} JWE.Encrypter#protected
       * @readonly
       * @description
       * The header parameter names that are protected. Protected header fields
       * are first serialized to UTF-8 then encoded as util.base64url, then used as
       * the additional authenticated data in the encryption operation.
       */

      Object.defineProperty(this, "protected", {
        get: function get() {
          return clone(cfg.protect);
        },
        enumerable: true
      });
      /**
       * @member {Object} JWE.Encrypter#header
       * @readonly
       * @description
       * The global header parameters, both protected and unprotected. Call
       * {@link JWE.Encrypter#protected} to determine which parameters will
       * be protected.
       */

      Object.defineProperty(this, "header", {
        get: function get() {
          return clone(fields);
        },
        enumerable: true
      });
      /**
       * @method JWE.Encrypter#update
       * @description
       * Updates the plaintext data for the encryption generator. The plaintext
       * is appended to the end of any other plaintext already applied.
       *
       * If {data} is a Buffer, {encoding} is ignored. Otherwise, {data} is
       * converted to a Buffer internally to {encoding}.
       *
       * @param {Buffer|String} [data] The plaintext to apply.
       * @param {String} [encoding] The encoding of the plaintext.
       * @returns {JWE.Encrypter} This encryption generator.
       * @throws {Error} If ciphertext has already been generated.
       */

      Object.defineProperty(this, "update", {
        value: function value(data, encoding) {
          if (finalized) {
            throw new Error("already final");
          }

          if (data != null) {
            data = util.asBuffer(data, encoding);

            if (content.length) {
              content = Buffer.concat([content, data], content.length + data.length);
            } else {
              content = data;
            }
          }

          return this;
        }
      });
      /**
       * @method JWE.Encrypter#final
       * @description
       * Finishes the encryption operation.
       *
       * The returned Promise, when fulfilled, is the JSON Web Encryption (JWE)
       * object, either in the Compact (if {@link JWE.Encrypter#compact} is
       * `true`) or the JSON serialization.
       *
       * @param {Buffer|String} [data] The final plaintext data to apply.
       * @param {String} [encoding] The encoding of the final plaintext data
       *        (if any).
       * @returns {Promise} A promise for the encryption operation.
       * @throws {Error} If ciphertext has already been generated.
       */

      Object.defineProperty(this, "final", {
        value: function value(data, encoding) {
          if (finalized) {
            return Promise.reject(new Error("already final"));
          } // last-minute data


          this.update(data, encoding); // mark as done...ish

          finalized = true;
          var promise = Promise.resolve({}); // determine CEK and IV

          var encAlg = fields.enc;
          var encKey;
          promise = promise.then(function (jwe) {
            if (cfg.cek) {
              encKey = JWK.asKey(cfg.cek);
            }

            return jwe;
          }); // process recipients

          promise = promise.then(function (jwe) {
            var procR = function procR(r, one) {
              var props = {};
              props = assign(props, fields);
              props = assign(props, r.header);
              var algKey = r.key,
                  algAlg = props.alg; // generate Ephemeral EC Key

              var tks, rpromise;

              if ((props.alg || "").indexOf("ECDH-ES") === 0) {
                tks = algKey.keystore.temp();

                if (r.epk) {
                  rpromise = Promise.resolve(r.epk).then(function (epk) {
                    r.header.epk = epk.toJSON(false, ["kid"]);
                    props.epk = epk.toObject(true, ["kid"]);
                  });
                } else {
                  rpromise = tks.generate("EC", algKey.get("crv")).then(function (epk) {
                    r.header.epk = epk.toJSON(false, ["kid"]);
                    props.epk = epk.toObject(true, ["kid"]);
                  });
                }
              } else {
                rpromise = Promise.resolve();
              } // encrypt the CEK


              rpromise = rpromise.then(function () {
                var cek, p; // special case 'alg=dir'

                if ("dir" === algAlg && one) {
                  encKey = Promise.resolve(algKey);
                  p = encKey.then(function (jwk) {
                    // fixup encAlg
                    if (!encAlg) {
                      props.enc = fields.enc = encAlg = jwk.algorithms(JWK.MODE_ENCRYPT)[0];
                    }

                    return {
                      once: true,
                      direct: true
                    };
                  });
                } else {
                  if (!encKey) {
                    if (!encAlg) {
                      props.enc = fields.enc = encAlg = cfg.contentAlg;
                    }

                    encKey = generateCEK(encAlg);
                  }

                  p = encKey.then(function (jwk) {
                    cek = jwk.get("k", true); // algKey may or may not be a promise

                    return algKey;
                  });
                  p = p.then(function (algKey) {
                    return algKey.wrap(algAlg, cek, props);
                  });
                }

                return p;
              });
              rpromise = rpromise.then(function (wrapped) {
                if (wrapped.once && !one) {
                  return Promise.reject(new Error("cannot use 'alg':'" + algAlg + "' with multiple recipients"));
                }

                var rjwe = {},
                    cek;

                if (wrapped.data) {
                  cek = wrapped.data;
                  cek = util.base64url.encode(cek);
                }

                if (wrapped.direct && cek) {
                  // replace content key
                  encKey = JWK.asKey({
                    kty: "oct",
                    k: cek
                  });
                } else if (cek) {
                  /* eslint camelcase: [0] */
                  rjwe.encrypted_key = cek;
                }

                if (r.header && Object.keys(r.header).length) {
                  rjwe.header = clone(r.header || {});
                }

                if (wrapped.header) {
                  rjwe.header = assign(rjwe.header || {}, wrapped.header);
                }

                return rjwe;
              });
              return rpromise;
            };

            var p = Promise.all(recipients);
            p = p.then(function (rcpts) {
              var single = 1 === rcpts.length;
              rcpts = rcpts.map(function (r) {
                return procR(r, single);
              });
              return Promise.all(rcpts);
            });
            p = p.then(function (rcpts) {
              jwe.recipients = rcpts.filter(function (r) {
                return !!r;
              });
              return jwe;
            });
            return p;
          }); // normalize headers

          var props = {};
          promise = promise.then(function (jwe) {
            var protect, lenProtect, unprotect, lenUnprotect;
            unprotect = clone(fields);

            if (protectAll && jwe.recipients.length === 1 || "compact" === format) {
              // merge single recipient into fields
              protect = {};
              protect = assign({}, unprotect, jwe.recipients[0].header);
              lenProtect = Object.keys(protect).length;
              unprotect = undefined;
              lenUnprotect = 0;
              delete jwe.recipients[0].header;

              if (Object.keys(jwe.recipients[0]).length === 0) {
                jwe.recipients.splice(0, 1);
              }
            } else {
              protect = {};
              lenProtect = 0;
              lenUnprotect = Object.keys(unprotect).length;
              cfg.protect.forEach(function (f) {
                // remove protected header values from body unprotected header
                if (!(f in unprotect)) {
                  return;
                }

                protect[f] = unprotect[f];
                lenProtect++;
                delete unprotect[f];
                lenUnprotect--;
              });
              jwe.recipients = (jwe.recipients || []).map(function (rcpt) {
                rcpt = rcpt || {};
                var header = rcpt.header;

                if (header) {
                  Object.keys(header).forEach(function (f) {
                    if (f in protect) {
                      delete header[f];
                    }
                  });

                  if (!Object.keys(header).length) {
                    delete rcpt.header;
                  }
                }

                return rcpt;
              });
            }

            if (!jwe.recipients || jwe.recipients.length === 0) {
              delete jwe.recipients;
            } // "serialize" (and setup merged props)


            if (unprotect && lenUnprotect > 0) {
              props = assign(props, unprotect);
              jwe.unprotected = unprotect;
            }

            if (protect && lenProtect > 0) {
              props = assign(props, protect);
              protect = JSON.stringify(protect);
              jwe.protected = util.base64url.encode(protect, "utf8");
            }

            return jwe;
          }); // (OPTIONAL) compress plaintext

          promise = promise.then(function (jwe) {
            var pdata = content;

            if (!props.zip) {
              jwe.plaintext = pdata;
              return jwe;
            } else if (props.zip === "DEF") {
              return new Promise(function (resolve, reject) {
                zlib.deflateRaw(Buffer.from(pdata, "binary"), function (err, data) {
                  if (err) {
                    reject(err);
                  } else {
                    jwe.plaintext = data;
                    resolve(jwe);
                  }
                });
              });
            }

            return Promise.reject(new Error("unsupported 'zip' mode"));
          }); // encrypt plaintext

          promise = promise.then(function (jwe) {
            props.adata = jwe.protected;

            if ("aad" in cfg && cfg.aad != null) {
              props.adata += "." + cfg.aad;
              props.adata = Buffer.from(props.adata, "utf8");
            } // calculate IV


            var iv = cfg.iv || util.randomBytes(CONSTANTS.NONCELENGTH[encAlg] / 8);

            if ("string" === typeof iv) {
              iv = util.base64url.decode(iv);
            }

            props.iv = iv;

            if ("recipients" in jwe && jwe.recipients.length === 1) {
              props.kdata = jwe.recipients[0].encrypted_key;
            }

            if ("epu" in cfg && cfg.epu != null) {
              props.epu = cfg.epu;
            }

            if ("epv" in cfg && cfg.epv != null) {
              props.epv = cfg.epv;
            }

            var pdata = jwe.plaintext;
            delete jwe.plaintext;
            return encKey.then(function (encKey) {
              var p = encKey.encrypt(encAlg, pdata, props);
              p = p.then(function (result) {
                jwe.iv = util.base64url.encode(iv, "binary");

                if ("aad" in cfg && cfg.aad != null) {
                  jwe.aad = cfg.aad;
                }

                jwe.ciphertext = util.base64url.encode(result.data, "binary");
                jwe.tag = util.base64url.encode(result.tag, "binary");
                return jwe;
              });
              return p;
            });
          }); // (OPTIONAL) compact/flattened results

          switch (format) {
            case "compact":
              promise = promise.then(function (jwe) {
                var compact = new Array(5);
                compact[0] = jwe.protected;

                if (jwe.recipients && jwe.recipients[0]) {
                  compact[1] = jwe.recipients[0].encrypted_key;
                }

                compact[2] = jwe.iv;
                compact[3] = jwe.ciphertext;
                compact[4] = jwe.tag;
                compact = compact.join(".");
                return compact;
              });
              break;

            case "flattened":
              promise = promise.then(function (jwe) {
                var flattened = {},
                    rcpt = jwe.recipients && jwe.recipients[0];

                if (jwe.protected) {
                  flattened.protected = jwe.protected;
                }

                if (jwe.unprotected) {
                  flattened.unprotected = jwe.unprotected;
                }

                ["header", "encrypted_key"].forEach(function (f) {
                  if (!rcpt) {
                    return;
                  }

                  if (!(f in rcpt)) {
                    return;
                  }

                  if (!rcpt[f]) {
                    return;
                  }

                  if ("object" === typeof rcpt[f] && !Object.keys(rcpt[f]).length) {
                    return;
                  }

                  flattened[f] = rcpt[f];
                });

                if (jwe.aad) {
                  flattened.aad = jwe.aad;
                }

                flattened.iv = jwe.iv;
                flattened.ciphertext = jwe.ciphertext;
                flattened.tag = jwe.tag;
                return flattened;
              });
              break;

            case "general":
              promise = promise.then(function (jwe) {
                var recipients = jwe.recipients || [];
                recipients = recipients.map(function (rcpt) {
                  if (!Object.keys(rcpt).length) {
                    return undefined;
                  }

                  return rcpt;
                });
                recipients = recipients.filter(function (rcpt) {
                  return !!rcpt;
                });

                if (recipients.length) {
                  jwe.recipients = recipients;
                } else {
                  delete jwe.recipients;
                }

                return jwe;
              });
          }

          return promise;
        }
      });
    }

    function createEncrypt(opts, rcpts) {
      // fixup recipients
      var options = opts,
          rcptStart = 1,
          rcptList = rcpts;

      if (arguments.length === 0) {
        throw new Error("at least one recipient must be provided");
      }

      if (arguments.length === 1) {
        // assume opts is the recipient list
        rcptList = opts;
        rcptStart = 0;
        options = {};
      } else if (JWK.isKey(opts) || opts && "kty" in opts || opts && "key" in opts && (JWK.isKey(opts.key) || "kty" in opts.key)) {
        rcptList = opts;
        rcptStart = 0;
        options = {};
      } else {
        options = clone(opts);
      }

      if (!Array.isArray(rcptList)) {
        rcptList = slice(arguments, rcptStart);
      } // fixup options


      options = assign(clone(DEFAULTS), options); // setup header fields

      var fields = clone(options.fields || {});

      if (options.zip) {
        fields.zip = typeof options.zip === "boolean" ? options.zip ? "DEF" : false : options.zip;
      }

      options.format = (options.compact ? "compact" : options.format) || "general";

      switch (options.format) {
        case "compact":
          if ("aad" in opts) {
            throw new Error("additional authenticated data cannot be used for compact serialization");
          }

        /* eslint no-fallthrough: [0] */

        case "flattened":
          if (rcptList.length > 1) {
            throw new Error("too many recipients for compact serialization");
          }

          break;
      } // note protected fields (globally)
      // protected fields are global only


      var protectAll = false;

      if ("compact" === options.format || "*" === options.protect) {
        protectAll = true;
        options.protect = Object.keys(fields).concat("enc");
      } else if (typeof options.protect === "string") {
        options.protect = [options.protect];
      } else if (Array.isArray(options.protect)) {
        options.protect = options.protect.concat();
      } else if (!options.protect) {
        options.protect = [];
      } else {
        throw new Error("protect must be a list of fields");
      }

      if (protectAll && 1 < rcptList.length) {
        throw new Error("too many recipients to protect all header parameters");
      }

      rcptList = rcptList.map(function (r, idx) {
        var p; // resolve a key

        if (r && "kty" in r) {
          p = JWK.asKey(r);
          p = p.then(function (k) {
            return {
              key: k
            };
          });
        } else if (r) {
          p = JWK.asKey(r.key);
          p = p.then(function (k) {
            return {
              header: r.header,
              reference: r.reference,
              key: k
            };
          });
        } else {
          p = Promise.reject(new Error("missing key for recipient " + idx));
        } // convert ephemeral key (if present)


        if (r.epk) {
          p = p.then(function (recipient) {
            return JWK.asKey(r.epk).then(function (epk) {
              recipient.epk = epk;
              return recipient;
            });
          });
        } // resolve the complete recipient


        p = p.then(function (recipient) {
          var key = recipient.key; // prepare the recipient header

          var header = recipient.header || {};
          recipient.header = header;
          var props = {};
          props = assign(props, fields);
          props = assign(props, recipient.header); // ensure key protection algorithm is set

          if (!props.alg) {
            props.alg = key.algorithms(JWK.MODE_WRAP)[0];
            header.alg = props.alg;
          }

          if (!props.alg) {
            return Promise.reject(new Error("key not valid for encrypting to recipient " + idx));
          }

          header.alg = props.alg; // determine the key reference

          var ref = recipient.reference;
          delete recipient.reference;

          if (undefined === ref) {
            // header already contains the key reference
            ref = ["kid", "jku", "x5c", "x5t", "x5u"].some(function (k) {
              return k in header;
            });
            ref = !ref ? "kid" : null;
          } else if ("boolean" === typeof ref) {
            // explicit (positive | negative) request for key reference
            ref = ref ? "kid" : null;
          }

          var jwk;

          if (ref) {
            jwk = key.toJSON();

            if ("jwk" === ref) {
              if ("oct" === key.kty) {
                return Promise.reject(new Error("cannot embed key"));
              }

              header.jwk = jwk;
            } else if (ref in jwk) {
              header[ref] = jwk[ref];
            }
          } // freeze recipient


          recipient = Object.freeze(recipient);
          return recipient;
        });
        return p;
      }); // create and configure encryption

      var cfg = {
        aad: "aad" in options ? util.base64url.encode(options.aad || "") : null,
        contentAlg: options.contentAlg,
        format: options.format,
        protect: options.protect,
        cek: options.cek,
        iv: options.iv,
        protectAll: protectAll
      };
      var enc = new JWEEncrypter(cfg, fields, rcptList);
      return enc;
    }

    module.exports = {
      encrypter: JWEEncrypter,
      createEncrypt: createEncrypt
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 562 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * jwk/rsa.js - RSA Key Representation
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var ecutil = __webpack_require__(151),
        forge = __webpack_require__(14),
        depsecc = __webpack_require__(234);

    var JWK = {
      BaseKey: __webpack_require__(104),
      helpers: __webpack_require__(81)
    };
    var SIG_ALGS = ["ES256", "ES384", "ES512"];
    var WRAP_ALGS = ["ECDH-ES", "ECDH-ES+A128KW", "ECDH-ES+A192KW", "ECDH-ES+A256KW"];
    var EC_OID = ecutil.EC_OID;

    function oidToCurveName(oid) {
      switch (oid) {
        case "1.2.840.10045.3.1.7":
          return "P-256";

        case "1.3.132.0.34":
          return "P-384";

        case "1.3.132.0.35":
          return "P-521";

        default:
          return null;
      }
    }

    var JWKEcCfg = {
      publicKey: function publicKey(props) {
        var fields = JWK.helpers.COMMON_PROPS.concat([{
          name: "crv",
          type: "string"
        }, {
          name: "x",
          type: "binary"
        }, {
          name: "y",
          type: "binary"
        }]);
        var pk = JWK.helpers.unpackProps(props, fields);

        if (pk && pk.crv && pk.x && pk.y) {
          pk.length = ecutil.curveSize(pk.crv);
        } else {
          delete pk.crv;
          delete pk.x;
          delete pk.y;
        }

        return pk;
      },
      privateKey: function privateKey(props) {
        var fields = JWK.helpers.COMMON_PROPS.concat([{
          name: "crv",
          type: "string"
        }, {
          name: "x",
          type: "binary"
        }, {
          name: "y",
          type: "binary"
        }, {
          name: "d",
          type: "binary"
        }]);
        var pk = JWK.helpers.unpackProps(props, fields);

        if (pk && pk.crv && pk.x && pk.y && pk.d) {
          pk.length = ecutil.curveSize(pk.crv);
        } else {
          pk = undefined;
        }

        return pk;
      },
      thumbprint: function thumbprint(json) {
        if (json.public) {
          json = json.public;
        }

        var fields = {
          crv: json.crv,
          kty: "EC",
          x: json.x,
          y: json.y
        };
        return fields;
      },
      algorithms: function algorithms(keys, mode) {
        var len = keys.public && keys.public.length || keys.private && keys.private.length || 0; // NOTE: 521 is the actual, but 512 is the expected

        if (len === 521) {
          len = 512;
        }

        switch (mode) {
          case "encrypt":
          case "decrypt":
            return [];

          case "wrap":
            return keys.public && WRAP_ALGS || [];

          case "unwrap":
            return keys.private && WRAP_ALGS || [];

          case "sign":
            if (!keys.private) {
              return [];
            }

            return SIG_ALGS.filter(function (a) {
              return a === "ES" + len;
            });

          case "verify":
            if (!keys.public) {
              return [];
            }

            return SIG_ALGS.filter(function (a) {
              return a === "ES" + len;
            });
        }
      },
      encryptKey: function encryptKey(alg, keys) {
        return keys.public;
      },
      decryptKey: function decryptKey(alg, keys) {
        return keys.private;
      },
      wrapKey: function wrapKey(alg, keys) {
        return keys.public;
      },
      unwrapKey: function unwrapKey(alg, keys) {
        return keys.private;
      },
      signKey: function signKey(alg, keys) {
        return keys.private;
      },
      verifyKey: function verifyKey(alg, keys) {
        return keys.public;
      }
    };
    JWKEcCfg.convertToPEM = ecutil.convertToPEM; // Inspired by digitalbaazar/node-forge/js/rsa.js

    var validators = {
      oid: EC_OID,
      privateKey: {
        // ECPrivateKey
        name: "ECPrivateKey",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.SEQUENCE,
        constructed: true,
        value: [{
          // EC version
          name: "ECPrivateKey.version",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false
        }, {
          // private value (d)
          name: "ECPrivateKey.private",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.OCTETSTRING,
          constructed: false,
          capture: "d"
        }, {
          // EC parameters
          tagClass: forge.asn1.Class.CONTEXT_SPECIFIC,
          name: "ECPrivateKey.parameters",
          constructed: true,
          value: [{
            // namedCurve (crv)
            name: "ECPrivateKey.namedCurve",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.OID,
            constructed: false,
            capture: "crv"
          }]
        }, {
          // publicKey
          name: "ECPrivateKey.publicKey",
          tagClass: forge.asn1.Class.CONTEXT_SPECIFIC,
          constructed: true,
          value: [{
            name: "ECPrivateKey.point",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.BITSTRING,
            constructed: false,
            capture: "point"
          }]
        }]
      },
      embeddedPrivateKey: {
        // ECPrivateKey
        name: "ECPrivateKey",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.SEQUENCE,
        constructed: true,
        value: [{
          // EC version
          name: "ECPrivateKey.version",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false
        }, {
          // private value (d)
          name: "ECPrivateKey.private",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.OCTETSTRING,
          constructed: false,
          capture: "d"
        }, {
          // publicKey
          name: "ECPrivateKey.publicKey",
          tagClass: forge.asn1.Class.CONTEXT_SPECIFIC,
          constructed: true,
          value: [{
            name: "ECPrivateKey.point",
            tagClass: forge.asn1.Class.UNIVERSAL,
            type: forge.asn1.Type.BITSTRING,
            constructed: false,
            capture: "point"
          }]
        }]
      }
    };
    var JWKEcFactory = {
      kty: "EC",
      validators: validators,
      prepare: function prepare(props) {
        // TODO: validate key properties
        var cfg = JWKEcCfg;
        var p = Promise.resolve(props);
        p = p.then(function (json) {
          return JWK.helpers.thumbprint(cfg, json);
        });
        p = p.then(function (hash) {
          var prints = {};
          prints[JWK.helpers.INTERNALS.THUMBPRINT_HASH] = hash;
          props[JWK.helpers.INTERNALS.THUMBPRINT_KEY] = prints;
          return cfg;
        });
        return p;
      },
      generate: function generate(size) {
        var keypair = depsecc.generateKeyPair(size);
        var result = {
          "crv": size,
          "x": keypair.public.x,
          "y": keypair.public.y,
          "d": keypair.private.d
        };
        return Promise.resolve(result);
      },
      import: function _import(input) {
        if (validators.oid !== input.keyOid) {
          return null;
        } // coerce key params to OID


        var crv;

        if (input.keyParams && forge.asn1.Type.OID === input.keyParams.type) {
          crv = forge.asn1.derToOid(input.keyParams.value);
          crv = oidToCurveName(crv);
        } else if (input.crv) {
          crv = forge.asn1.derToOid(input.crv);
          crv = oidToCurveName(crv);
        }

        if (!crv) {
          return null;
        }

        if (!input.parsed) {
          var capture = {},
              errors = [];

          if ("private" === input.type) {
            // coerce capture.value to DER *iff* private
            if ("string" === typeof input.keyValue) {
              input.keyValue = forge.asn1.fromDer(input.keyValue);
            } else if (Array.isArray(input.keyValue)) {
              input.keyValue = input.keyValue[0];
            }

            if (!forge.asn1.validate(input.keyValue, validators.embeddedPrivateKey, capture, errors)) {
              return null;
            }
          } else {
            capture.point = input.keyValue;
          }

          input = capture;
        } // convert factors to Buffers


        var output = {
          kty: "EC",
          crv: crv
        };

        if (input.d) {
          output.d = Buffer.from(input.d, "binary");
        }

        if (input.point) {
          var pt = Buffer.from(input.point, "binary"); // only support uncompressed

          if (4 !== pt.readUInt16BE(0)) {
            return null;
          }

          pt = pt.slice(2);
          var len = pt.length / 2;
          output.x = pt.slice(0, len);
          output.y = pt.slice(len);
        }

        return output;
      }
    }; // public API

    module.exports = Object.freeze({
      config: JWKEcCfg,
      factory: JWKEcFactory
    }); // registration

    (function (REGISTRY) {
      REGISTRY.register(JWKEcFactory);
    })(__webpack_require__(105).registry);
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 563 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * jwk/octkey.js - Symmetric Octet Key Representation
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var util = __webpack_require__(19);

    var JWK = {
      BaseKey: __webpack_require__(104),
      helpers: __webpack_require__(81)
    };
    var SIG_ALGS = ["HS256", "HS384", "HS512"];
    var ENC_ALGS = ["A128GCM", "A192GCM", "A256GCM", "A128CBC-HS256", "A192CBC-HS384", "A256CBC-HS512", "A128CBC+HS256", "A192CBC+HS384", "A256CBC+HS512"];
    var WRAP_ALGS = ["A128KW", "A192KW", "A256KW", "A128GCMKW", "A192GCMKW", "A256GCMKW", "PBES2-HS256+A128KW", "PBES2-HS384+A192KW", "PBES2-HS512+A256KW", "dir"];

    function adjustDecryptProps(alg, props) {
      if ("iv" in props) {
        props.iv = Buffer.isBuffer(props.iv) ? props.iv : util.base64url.decode(props.iv || "");
      }

      if ("adata" in props) {
        props.adata = Buffer.isBuffer(props.adata) ? props.adata : Buffer.from(props.adata || "", "utf8");
      }

      if ("mac" in props) {
        props.mac = Buffer.isBuffer(props.mac) ? props.mac : util.base64url.decode(props.mac || "");
      }

      if ("tag" in props) {
        props.tag = Buffer.isBuffer(props.tag) ? props.tag : util.base64url.decode(props.tag || "");
      }

      return props;
    }

    function adjustEncryptProps(alg, props) {
      if ("iv" in props) {
        props.iv = Buffer.isBuffer(props.iv) ? props.iv : util.base64url.decode(props.iv || "");
      }

      if ("adata" in props) {
        props.adata = Buffer.isBuffer(props.adata) ? props.adata : Buffer.from(props.adata || "", "utf8");
      }

      return props;
    }

    var JWKOctetCfg = {
      publicKey: function publicKey(props) {
        var fields = JWK.helpers.COMMON_PROPS.concat([]);
        var pk;
        pk = JWK.helpers.unpackProps(props, fields);
        return pk;
      },
      privateKey: function privateKey(props) {
        var fields = JWK.helpers.COMMON_PROPS.concat([{
          name: "k",
          type: "binary"
        }]);
        var pk;
        pk = JWK.helpers.unpackProps(props, fields);

        if (pk && pk.k) {
          pk.length = pk.k.length * 8;
        } else {
          pk = undefined;
        }

        return pk;
      },
      thumbprint: function thumbprint(json) {
        if (json.private) {
          json = json.private;
        }

        var fields;
        fields = {
          k: json.k || "",
          kty: "oct"
        };
        return fields;
      },
      algorithms: function algorithms(keys, mode) {
        var len = keys.private && keys.private.k.length * 8;
        var mins = [256, 384, 512];

        if (!len) {
          return [];
        }

        switch (mode) {
          case "encrypt":
          case "decrypt":
            return ENC_ALGS.filter(function (a) {
              return a === "A" + len / 2 + "CBC-HS" + len || a === "A" + len / 2 + "CBC+HS" + len || a === "A" + len + "GCM";
            });

          case "sign":
          case "verify":
            // TODO: allow for HS{less-than-keysize}
            return SIG_ALGS.filter(function (a) {
              var result = false;
              mins.forEach(function (m) {
                if (m > len) {
                  return;
                }

                result = result | a === "HS" + m;
              });
              return result;
            });

          case "wrap":
          case "unwrap":
            return WRAP_ALGS.filter(function (a) {
              return a === "A" + len + "KW" || a === "A" + len + "GCMKW" || a.indexOf("PBES2-") === 0 || a === "dir";
            });
        }

        return [];
      },
      encryptKey: function encryptKey(alg, keys) {
        return keys.private && keys.private.k;
      },
      encryptProps: adjustEncryptProps,
      decryptKey: function decryptKey(alg, keys) {
        return keys.private && keys.private.k;
      },
      decryptProps: adjustDecryptProps,
      wrapKey: function wrapKey(alg, keys) {
        return keys.private && keys.private.k;
      },
      wrapProps: adjustEncryptProps,
      unwrapKey: function unwrapKey(alg, keys) {
        return keys.private && keys.private.k;
      },
      unwrapProps: adjustDecryptProps,
      signKey: function signKey(alg, keys) {
        return keys.private && keys.private.k;
      },
      verifyKey: function verifyKey(alg, keys) {
        return keys.private && keys.private.k;
      }
    }; // Factory

    var JWKOctetFactory = {
      kty: "oct",
      prepare: function prepare(props) {
        // TODO: validate key properties
        var cfg = JWKOctetCfg;
        var p = Promise.resolve(props);
        p = p.then(function (json) {
          return JWK.helpers.thumbprint(cfg, json);
        });
        p = p.then(function (hash) {
          var prints = {};
          prints[JWK.helpers.INTERNALS.THUMBPRINT_HASH] = hash;
          props[JWK.helpers.INTERNALS.THUMBPRINT_KEY] = prints;
          return cfg;
        });
        return p;
      },
      generate: function generate(size) {
        // TODO: validate key sizes
        var key = util.randomBytes(size / 8);
        return Promise.resolve({
          k: key
        });
      }
    }; // public API

    module.exports = Object.freeze({
      config: JWKOctetCfg,
      factory: JWKOctetFactory
    }); // registration

    (function (REGISTRY) {
      REGISTRY.register(JWKOctetFactory);
    })(__webpack_require__(105).registry);
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 564 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * jwk/rsa.js - RSA Key Representation
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var forge = __webpack_require__(14),
        rsau = __webpack_require__(154),
        nodeCrypto = __webpack_require__(30).nodeCrypto;

    var JWK = {
      BaseKey: __webpack_require__(104),
      helpers: __webpack_require__(81)
    };
    var SIG_ALGS = ["RS256", "RS384", "RS512", "PS256", "PS384", "PS512"];
    var WRAP_ALGS = ["RSA-OAEP", "RSA-OAEP-256", "RSA1_5"];
    var JWKRsaCfg = {
      publicKey: function publicKey(props) {
        var fields = JWK.helpers.COMMON_PROPS.concat([{
          name: "n",
          type: "binary"
        }, {
          name: "e",
          type: "binary"
        }]);
        var pk;
        pk = JWK.helpers.unpackProps(props, fields);

        if (pk && pk.n && pk.e) {
          pk.length = pk.n.length * 8;
        } else {
          delete pk.e;
          delete pk.n;
        }

        return pk;
      },
      privateKey: function privateKey(props) {
        var fields = JWK.helpers.COMMON_PROPS.concat([{
          name: "n",
          type: "binary"
        }, {
          name: "e",
          type: "binary"
        }, {
          name: "d",
          type: "binary"
        }, {
          name: "p",
          type: "binary"
        }, {
          name: "q",
          type: "binary"
        }, {
          name: "dp",
          type: "binary"
        }, {
          name: "dq",
          type: "binary"
        }, {
          name: "qi",
          type: "binary"
        }]);
        var pk;
        pk = JWK.helpers.unpackProps(props, fields);

        if (pk && pk.d && pk.n && pk.e && pk.p && pk.q && pk.dp && pk.dq && pk.qi) {
          pk.length = pk.d.length * 8;
        } else {
          pk = undefined;
        }

        return pk;
      },
      thumbprint: function thumbprint(json) {
        if (json.public) {
          json = json.public;
        }

        var fields = {
          e: json.e,
          kty: "RSA",
          n: json.n
        };
        return fields;
      },
      algorithms: function algorithms(keys, mode) {
        switch (mode) {
          case "encrypt":
          case "decrypt":
            return [];

          case "wrap":
            return keys.public && WRAP_ALGS.slice() || [];

          case "unwrap":
            return keys.private && WRAP_ALGS.slice() || [];

          case "sign":
            return keys.private && SIG_ALGS.slice() || [];

          case "verify":
            return keys.public && SIG_ALGS.slice() || [];
        }

        return [];
      },
      wrapKey: function wrapKey(alg, keys) {
        return keys.public;
      },
      unwrapKey: function unwrapKey(alg, keys) {
        return keys.private;
      },
      signKey: function signKey(alg, keys) {
        return keys.private;
      },
      verifyKey: function verifyKey(alg, keys) {
        return keys.public;
      },
      convertToPEM: function convertToPEM(key, isPrivate) {
        var k = rsau.convertToForge(key, !isPrivate);

        if (!isPrivate) {
          return forge.pki.publicKeyToPem(k);
        }

        return forge.pki.privateKeyToPem(k);
      }
    };

    function convertBNtoBuffer(bn) {
      bn = bn.toString(16);

      if (bn.length % 2) {
        bn = "0" + bn;
      }

      return Buffer.from(bn, "hex");
    } // Adapted from digitalbaazar/node-forge/js/rsa.js


    var validators = {
      oid: "1.2.840.113549.1.1.1",
      privateKey: {
        name: "RSAPrivateKey",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.SEQUENCE,
        constructed: true,
        value: [{
          // Version (INTEGER)
          name: "RSAPrivateKey.version",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "version"
        }, {
          // modulus (n)
          name: "RSAPrivateKey.modulus",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "n"
        }, {
          // publicExponent (e)
          name: "RSAPrivateKey.publicExponent",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "e"
        }, {
          // privateExponent (d)
          name: "RSAPrivateKey.privateExponent",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "d"
        }, {
          // prime1 (p)
          name: "RSAPrivateKey.prime1",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "p"
        }, {
          // prime2 (q)
          name: "RSAPrivateKey.prime2",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "q"
        }, {
          // exponent1 (d mod (p-1))
          name: "RSAPrivateKey.exponent1",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "dp"
        }, {
          // exponent2 (d mod (q-1))
          name: "RSAPrivateKey.exponent2",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "dq"
        }, {
          // coefficient ((inverse of q) mod p)
          name: "RSAPrivateKey.coefficient",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "qi"
        }]
      },
      publicKey: {
        // RSAPublicKey
        name: "RSAPublicKey",
        tagClass: forge.asn1.Class.UNIVERSAL,
        type: forge.asn1.Type.SEQUENCE,
        constructed: true,
        value: [{
          // modulus (n)
          name: "RSAPublicKey.modulus",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "n"
        }, {
          // publicExponent (e)
          name: "RSAPublicKey.exponent",
          tagClass: forge.asn1.Class.UNIVERSAL,
          type: forge.asn1.Type.INTEGER,
          constructed: false,
          capture: "e"
        }]
      }
    }; // Factory

    var JWKRsaFactory = {
      kty: "RSA",
      validators: validators,
      prepare: function prepare(props) {
        // TODO: validate key properties
        var cfg = JWKRsaCfg;
        var p = Promise.resolve(props);
        p = p.then(function (json) {
          return JWK.helpers.thumbprint(cfg, json);
        });
        p = p.then(function (hash) {
          var prints = {};
          prints[JWK.helpers.INTERNALS.THUMBPRINT_HASH] = hash;
          props[JWK.helpers.INTERNALS.THUMBPRINT_KEY] = prints;
          return cfg;
        });
        return p;
      },
      generate: function generate(size) {
        // TODO: validate key sizes
        var promise;

        if (nodeCrypto) {
          promise = new Promise(function (resolve, reject) {
            forge.pki.rsa.generateKeyPair({
              bits: size,
              e: 0x010001
            }, function (err, key) {
              if (err) return reject(err);
              resolve(key.privateKey);
            });
          });
        } else {
          var key = forge.pki.rsa.generateKeyPair({
            bits: size,
            e: 0x010001
          });
          promise = Promise.resolve(key.privateKey);
        }

        return promise.then(function (key) {
          // convert to JSON-ish
          var result = {};
          ["e", "n", "d", "p", "q", {
            incoming: "dP",
            outgoing: "dp"
          }, {
            incoming: "dQ",
            outgoing: "dq"
          }, {
            incoming: "qInv",
            outgoing: "qi"
          }].forEach(function (f) {
            var incoming, outgoing;

            if ("string" === typeof f) {
              incoming = outgoing = f;
            } else {
              incoming = f.incoming;
              outgoing = f.outgoing;
            }

            if (incoming in key) {
              result[outgoing] = convertBNtoBuffer(key[incoming]);
            }
          });
          return result;
        });
      },
      import: function _import(input) {
        if (validators.oid !== input.keyOid) {
          return null;
        }

        if (!input.parsed) {
          // coerce capture.keyValue to DER
          if ("string" === typeof input.keyValue) {
            input.keyValue = forge.asn1.fromDer(input.keyValue);
          } else if (Array.isArray(input.keyValue)) {
            input.keyValue = input.keyValue[0];
          } // capture key factors


          var validator = "private" === input.type ? validators.privateKey : validators.publicKey;
          var capture = {},
              errors = [];

          if (!forge.asn1.validate(input.keyValue, validator, capture, errors)) {
            return null;
          }

          input = capture;
        } // convert factors to Buffers


        var output = {
          kty: "RSA"
        };
        ["n", "e", "d", "p", "q", "dp", "dq", "qi"].forEach(function (f) {
          if (!(f in input)) {
            return;
          }

          var b = Buffer.from(input[f], "binary"); // remove leading zero padding if any

          if (0 === b[0]) {
            b = b.slice(1);
          }

          output[f] = b;
        });
        return output;
      }
    }; // public API

    module.exports = Object.freeze({
      config: JWKRsaCfg,
      factory: JWKRsaFactory
    }); // registration

    (function (REGISTRY) {
      REGISTRY.register(JWKRsaFactory);
    })(__webpack_require__(105).registry);
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 565 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * jws/defaults.js - Defaults for JWSs
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  /**
   * @description
   * The default options for {@link JWS.createSign}.
   *
   * @property {Boolean} compact Determines if the output is the Compact
   *           serialization (`true`) or the JSON serialization (**`false`**,
   *           the default).
   * @property {String|String[]} protect The names of the headers to integrity
   *           protect.  The value `""` means that none of header parameters
   *           are integrity protected, while `"*"` (the default) means that all
   *           headers parameter sare integrity protected.
   */

  var JWSDefaults = {
    compact: false,
    protect: "*"
  };
  module.exports = JWSDefaults;
  /***/
},
/* 566 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * jws/helpers.js - JWS Internal Helper Functions
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  module.exports = {
    slice: function slice(input, start) {
      return Array.prototype.slice.call(input, start || 0);
    }
  };
  /***/
},
/* 567 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * jws/sign.js - Sign to JWS
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var clone = __webpack_require__(42),
        merge = __webpack_require__(48),
        uniq = __webpack_require__(205),
        util = __webpack_require__(19),
        JWK = __webpack_require__(73),
        slice = __webpack_require__(566).slice;

    var DEFAULTS = __webpack_require__(565);
    /**
     * @class JWS.Signer
     * @classdesc Generator of signed content.
     *
     * @description
     * **NOTE:** this class cannot be instantiated directly. Instead call {@link
     * JWS.createSign}.
     */


    var JWSSigner = function JWSSigner(cfg, signatories) {
      var finalized = false,
          format = cfg.format || "general",
          content = Buffer.alloc(0);
      /**
      * @member {Boolean} JWS.Signer#compact
      * @description
      * Indicates whether the outuput of this signature generator is using
      * the Compact serialization (`true`) or the JSON serialization
      * (`false`).
      */

      Object.defineProperty(this, "compact", {
        get: function get() {
          return "compact" === format;
        },
        enumerable: true
      });
      Object.defineProperty(this, "format", {
        get: function get() {
          return format;
        },
        enumerable: true
      });
      /**
      * @method JWS.Signer#update
      * @description
      * Updates the signing content for this signature content. The content
      * is appended to the end of any other content already applied.
      *
      * If {data} is a Buffer, {encoding} is ignored. Otherwise, {data} is
      * converted to a Buffer internally to {encoding}.
      *
      * @param {Buffer|String} data The data to sign.
      * @param {String} [encoding="binary"] The encoding of {data}.
      * @returns {JWS.Signer} This signature generator.
      * @throws {Error} If a signature has already been generated.
      */

      Object.defineProperty(this, "update", {
        value: function value(data, encoding) {
          if (finalized) {
            throw new Error("already final");
          }

          if (data != null) {
            data = util.asBuffer(data, encoding);

            if (content.length) {
              content = Buffer.concat([content, data], content.length + data.length);
            } else {
              content = data;
            }
          }

          return this;
        }
      });
      /**
      * @method JWS.Signer#final
      * @description
      * Finishes the signature operation.
      *
      * The returned Promise, when fulfilled, is the JSON Web Signature (JWS)
      * object, either in the Compact (if {@link JWS.Signer#format} is
      * `"compact"`), the flattened JSON (if {@link JWS.Signer#format} is
      * "flattened"), or the general JSON serialization.
      *
      * @param {Buffer|String} [data] The final content to apply.
      * @param {String} [encoding="binary"] The encoding of the final content
      *        (if any).
      * @returns {Promise} The promise for the signatures
      * @throws {Error} If a signature has already been generated.
      */

      Object.defineProperty(this, "final", {
        value: function value(data, encoding) {
          if (finalized) {
            return Promise.reject(new Error("already final"));
          } // last-minute data


          this.update(data, encoding); // mark as done...ish

          finalized = true;
          var promise; // map signatory promises to just signatories

          promise = Promise.all(signatories);
          promise = promise.then(function (sigs) {
            // prepare content
            content = util.base64url.encode(content);
            sigs = sigs.map(function (s) {
              // prepare protected
              var protect = {},
                  lenProtect = 0,
                  unprotect = clone(s.header),
                  lenUnprotect = Object.keys(unprotect).length;
              s.protected.forEach(function (h) {
                if (!(h in unprotect)) {
                  return;
                }

                protect[h] = unprotect[h];
                lenProtect++;
                delete unprotect[h];
                lenUnprotect--;
              });

              if (lenProtect > 0) {
                protect = JSON.stringify(protect);
                protect = util.base64url.encode(protect);
              } else {
                protect = "";
              } // signit!


              var data = Buffer.from(protect + "." + content, "ascii");
              s = s.key.sign(s.header.alg, data, s.header);
              s = s.then(function (result) {
                var sig = {};

                if (0 < lenProtect) {
                  sig.protected = protect;
                }

                if (0 < lenUnprotect) {
                  sig.header = unprotect;
                }

                sig.signature = util.base64url.encode(result.mac);
                return sig;
              });
              return s;
            });
            sigs = [Promise.resolve(content)].concat(sigs);
            return Promise.all(sigs);
          });
          promise = promise.then(function (results) {
            var content = results[0];
            return {
              payload: content,
              signatures: results.slice(1)
            };
          });

          switch (format) {
            case "compact":
              promise = promise.then(function (jws) {
                var compact = [jws.signatures[0].protected, jws.payload, jws.signatures[0].signature];
                compact = compact.join(".");
                return compact;
              });
              break;

            case "flattened":
              promise = promise.then(function (jws) {
                var flattened = {};
                flattened.payload = jws.payload;
                var sig = jws.signatures[0];

                if (sig.protected) {
                  flattened.protected = sig.protected;
                }

                if (sig.header) {
                  flattened.header = sig.header;
                }

                flattened.signature = sig.signature;
                return flattened;
              });
              break;
          }

          return promise;
        }
      });
    };
    /**
     * @description
     * Creates a new JWS.Signer with the given options and signatories.
     *
     * @param {Object} [opts] The signing options
     * @param {Boolean} [opts.compact] Use compact serialization?
     * @param {String} [opts.format] The serialization format to use ("compact",
     *                 "flattened", "general")
     * @param {Object} [opts.fields] Additional header fields
     * @param {JWK.Key[]|Object[]} [signs] Signatories, either as an array of
     *        JWK.Key instances; or an array of objects, each with the following
     *        properties
     * @param {JWK.Key} signs.key Key used to sign content
     * @param {Object} [signs.header] Per-signatory header fields
     * @param {String} [signs.reference] Reference field to identify the key
     * @param {String[]|String} [signs.protect] List of fields to integrity
     *        protect ("*" to protect all fields)
     * @returns {JWS.Signer} The signature generator.
     * @throws {Error} If Compact serialization is requested but there are
     *         multiple signatories
     */


    function createSign(opts, signs) {
      // fixup signatories
      var options = opts,
          signStart = 1,
          signList = signs;

      if (arguments.length === 0) {
        throw new Error("at least one signatory must be provided");
      }

      if (arguments.length === 1) {
        signList = opts;
        signStart = 0;
        options = {};
      } else if (JWK.isKey(opts) || opts && "kty" in opts || opts && "key" in opts && (JWK.isKey(opts.key) || "kty" in opts.key)) {
        signList = opts;
        signStart = 0;
        options = {};
      } else {
        options = clone(opts);
      }

      if (!Array.isArray(signList)) {
        signList = slice(arguments, signStart);
      } // fixup options


      options = merge(clone(DEFAULTS), options); // setup header fields

      var allFields = options.fields || {}; // setup serialization format

      var format = options.format;

      if (!format) {
        format = options.compact ? "compact" : "general";
      }

      if (("compact" === format || "flattened" === format) && 1 < signList.length) {
        throw new Error("too many signatories for compact or flattened JSON serialization");
      } // note protected fields (globally)
      // protected fields are per signature


      var protectAll = "*" === options.protect;

      if (options.compact) {
        protectAll = true;
      }

      signList = signList.map(function (s, idx) {
        var p; // resolve a key

        if (s && "kty" in s) {
          p = JWK.asKey(s);
          p = p.then(function (k) {
            return {
              key: k
            };
          });
        } else if (s) {
          p = JWK.asKey(s.key);
          p = p.then(function (k) {
            return {
              header: s.header,
              reference: s.reference,
              protect: s.protect,
              key: k
            };
          });
        } else {
          p = Promise.reject(new Error("missing key for signatory " + idx));
        } // resolve the complete signatory


        p = p.then(function (signatory) {
          var key = signatory.key; // make sure there is a header

          var header = signatory.header || {};
          header = merge(merge({}, allFields), header);
          signatory.header = header; // ensure an algorithm

          if (!header.alg) {
            header.alg = key.algorithms(JWK.MODE_SIGN)[0] || "";
          } // determine the key reference


          var ref = signatory.reference;
          delete signatory.reference;

          if (undefined === ref) {
            // header already contains the key reference
            ref = ["kid", "jku", "x5c", "x5t", "x5u"].some(function (k) {
              return k in header;
            });
            ref = !ref ? "kid" : null;
          } else if ("boolean" === typeof ref) {
            // explicit (positive | negative) request for key reference
            ref = ref ? "kid" : null;
          }

          var jwk;

          if (ref) {
            jwk = key.toJSON();

            if ("jwk" === ref) {
              if ("oct" === key.kty) {
                return Promise.reject(new Error("cannot embed key"));
              }

              header.jwk = jwk;
            } else if (ref in jwk) {
              header[ref] = jwk[ref];
            }
          } // determine protected fields


          var protect = signatory.protect;

          if (protectAll || "*" === protect) {
            protect = Object.keys(header);
          } else if ("string" === protect) {
            protect = [protect];
          } else if (Array.isArray(protect)) {
            protect = protect.concat();
          } else if (!protect) {
            protect = [];
          } else {
            return Promise.reject(new Error("protect must be a list of fields"));
          }

          protect = uniq(protect);
          signatory.protected = protect; // freeze signatory

          signatory = Object.freeze(signatory);
          return signatory;
        });
        return p;
      });
      var cfg = {
        format: format
      };
      return new JWSSigner(cfg, signList);
    }

    module.exports = {
      signer: JWSSigner,
      createSign: createSign
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 568 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * jws/verify.js - Verifies from a JWS
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var clone = __webpack_require__(42),
        merge = __webpack_require__(48),
        base64url = __webpack_require__(106),
        AlgConfig = __webpack_require__(238),
        JWK = __webpack_require__(73);

    var DEFAULT_OPTIONS = {
      algorithms: "*",
      allowEmbeddedKey: false
    };
    /**
     * @class JWS.Verifier
     * @classdesc Parser of signed content.
     *
     * @description
     * **NOTE:** this class cannot be instantiated directly. Instead call {@link
     * JWS.createVerify}.
     */

    var JWSVerifier = function JWSVerifier(ks, globalOpts) {
      var assumedKey, keystore;

      if (JWK.isKey(ks)) {
        assumedKey = ks;
        keystore = assumedKey.keystore;
      } else if (JWK.isKeyStore(ks)) {
        keystore = ks;
      } else {
        keystore = JWK.createKeyStore();
      }

      globalOpts = merge(DEFAULT_OPTIONS, globalOpts);
      Object.defineProperty(this, "defaultKey", {
        value: assumedKey || undefined,
        enumerable: true
      });
      Object.defineProperty(this, "keystore", {
        value: keystore,
        enumerable: true
      });
      Object.defineProperty(this, "verify", {
        value: function value(input, opts) {
          opts = merge({}, globalOpts, opts || {});
          var extraHandlers = opts.handlers || {};
          var handlerKeys = Object.keys(extraHandlers);
          var algSpec = new AlgConfig(opts.algorithms);

          if ("string" === typeof input) {
            input = input.split(".");
            input = {
              payload: input[1],
              signatures: [{
                protected: input[0],
                signature: input[2]
              }]
            };
          } else if (!input || "object" !== typeof input) {
            throw new Error("invalid input");
          } // fixup "flattened JSON" to look like "general JSON"


          if (input.signature) {
            input.signatures = [{
              protected: input.protected || undefined,
              header: input.header || undefined,
              signature: input.signature
            }];
          } // ensure signatories exists


          var sigList = input.signatures || [{}]; // combine fields and decode signature per signatory

          sigList = sigList.map(function (s) {
            var header = clone(s.header || {});
            var protect = s.protected ? JSON.parse(base64url.decode(s.protected, "utf8")) : {};
            header = merge(header, protect);
            var signature = base64url.decode(s.signature); // process allowed algorithims

            if (!algSpec.match(header.alg)) {
              return Promise.reject(new Error("Algorithm not allowed: " + header.alg));
            } // process "crit" first


            var crit = protect.crit;

            if (crit) {
              if (!Array.isArray(crit)) {
                return Promise.reject(new Error("Invalid 'crit' header"));
              }

              for (var idx = 0; crit.length > idx; idx++) {
                if (-1 === handlerKeys.indexOf(crit[idx])) {
                  return Promise.reject(new Error("Critical extension is not supported: " + crit[idx]));
                }
              }
            }

            protect = Object.keys(protect);
            return Promise.resolve({
              protected: protect,
              aad: s.protected || "",
              header: header,
              signature: signature
            });
          });
          var promise = Promise.all(sigList);
          promise = promise.then(function (sigList) {
            return new Promise(function (resolve, reject) {
              var processSig = function processSig() {
                var sig = sigList.shift();

                if (!sig) {
                  reject(new Error("no key found"));
                  return;
                }

                sig = merge({}, sig, {
                  payload: input.payload
                });
                var p = Promise.resolve(sig); // find the key

                p = p.then(function (sig) {
                  var algKey; // TODO: resolve jku, x5c, x5u

                  if (opts.allowEmbeddedKey && sig.header.jwk) {
                    algKey = JWK.asKey(sig.header.jwk);
                  } else if (opts.allowEmbeddedKey && sig.header.x5c) {
                    algKey = sig.header.x5c[0];
                    algKey = Buffer.from(algKey, "base64"); // TODO: callback to validate chain

                    algKey = JWK.asKey(algKey, "pkix");
                  } else {
                    algKey = Promise.resolve(assumedKey || keystore.get({
                      use: "sig",
                      alg: sig.header.alg,
                      kid: sig.header.kid
                    }));
                  }

                  return algKey.then(function (k) {
                    if (!k) {
                      return Promise.reject(new Error("key does not match"));
                    }

                    sig.key = k;
                    return sig;
                  });
                }); // process any prepare-verify handlers

                p = p.then(function (sig) {
                  var processing = [];
                  handlerKeys.forEach(function (h) {
                    h = extraHandlers[h];
                    var p;

                    if ("function" === typeof h) {
                      p = h(sig);
                    } else if ("object" === typeof h && "function" === typeof h.prepare) {
                      p = h.prepare(sig);
                    }

                    if (p) {
                      processing.push(Promise.resolve(p));
                    }
                  });
                  return Promise.all(processing).then(function () {
                    // don't actually care about individual handler results
                    // assume {sig} is updated
                    return sig;
                  });
                }); // prepare verify inputs

                p = p.then(function (sig) {
                  var aad = sig.aad || "",
                      payload = sig.payload || "";
                  var content = Buffer.alloc(1 + aad.length + payload.length),
                      pos = 0;
                  content.write(aad, pos, "ascii");
                  pos += aad.length;
                  content.write(".", pos, "ascii");
                  pos++;

                  if (Buffer.isBuffer(payload)) {
                    payload.copy(content, pos);
                  } else {
                    content.write(payload, pos, "binary");
                  }

                  sig.content = content;
                  return sig;
                });
                p = p.then(function (sig) {
                  return sig.key.verify(sig.header.alg, sig.content, sig.signature);
                });
                p = p.then(function (result) {
                  var payload = sig.payload;
                  payload = base64url.decode(payload);
                  return {
                    protected: sig.protected,
                    header: sig.header,
                    payload: payload,
                    signature: result.mac,
                    key: sig.key
                  };
                }); // process any post-verify handlers

                p = p.then(function (jws) {
                  var processing = [];
                  handlerKeys.forEach(function (h) {
                    h = extraHandlers[h];
                    var p;

                    if ("object" === typeof h && "function" === typeof h.complete) {
                      p = h.complete(jws);
                    }

                    if (p) {
                      processing.push(Promise.resolve(p));
                    }
                  });
                  return Promise.all(processing).then(function () {
                    // don't actually care about individual handler results
                    // assume {jws} is updated
                    return jws;
                  });
                });
                p.then(resolve, processSig);
              };

              processSig();
            });
          });
          return promise;
        }
      });
    };
    /**
     * @description
     * Creates a new JWS.Verifier with the given Key or KeyStore.
     *
     * @param {JWK.Key|JWK.KeyStore} ks The Key or KeyStore to use for verification.
     * @returns {JWS.Verifier} The new Verifier.
     */


    function createVerify(ks, opts) {
      var vfy = new JWSVerifier(ks, opts);
      return vfy;
    }

    module.exports = {
      verifier: JWSVerifier,
      createVerify: createVerify
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 569 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * parse/compact.js - JOSE Compact Serialization Parser
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  var jose = {
    JWE: __webpack_require__(155),
    JWS: __webpack_require__(156),
    util: __webpack_require__(19)
  };

  function parseCompact(input) {
    var parts = input.split(".");
    var type, op;

    if (3 === parts.length) {
      // JWS
      type = "JWS";

      op = function op(ks, opts) {
        return jose.JWS.createVerify(ks).verify(input, opts);
      };
    } else if (5 === parts.length) {
      // JWE
      type = "JWE";

      op = function op(ks, opts) {
        return jose.JWE.createDecrypt(ks).decrypt(input, opts);
      };
    } else {
      throw new TypeError("invalid jose serialization");
    } // parse header


    var header;
    header = jose.util.base64url.decode(parts[0], "utf8");
    header = JSON.parse(header);
    return {
      type: type,
      format: "compact",
      input: input,
      header: header,
      perform: op
    };
  }

  module.exports = parseCompact;
  /***/
},
/* 570 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (Buffer) {
    /*!
    * parse/index.js - JOSE Parser Entry Point
    *
    * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
    */
    var compact = __webpack_require__(569),
        json = __webpack_require__(571);

    var parse = module.exports = function (input) {
      if (Buffer.isBuffer(input)) {
        // assume buffer holds a Compact Serialization string
        return compact(input.toString("ascii"));
      } else if ("string" === typeof input) {
        return compact(input);
      } else if (input) {
        return json(input);
      } else {
        throw new TypeError("invalid input");
      }
    };

    parse.compact = compact;
    parse.json = json;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(1).Buffer);
  /***/
},
/* 571 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * parse/compact.js - JOSE JSON Serialization Parser
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  var merge = __webpack_require__(48);

  var jose = {
    JWE: __webpack_require__(155),
    JWS: __webpack_require__(156),
    util: __webpack_require__(19)
  };

  function parseJSON(input) {
    var type, op, headers;

    if ("signatures" in input || "signature" in input) {
      // JWS
      type = "JWS";

      op = function op(ks, opts) {
        return jose.JWS.createVerify(ks).verify(input, opts);
      }; // headers can be (signatures[].protected, signatures[].header, signature.protected, signature.header)


      headers = input.signatures || [{
        protected: input.protected,
        header: input.header,
        signature: input.signature
      }];
      headers = headers.map(function (sig) {
        var all = {};

        if (sig.header) {
          all = merge(all, sig.header);
        }

        var prot;

        if (sig.protected) {
          prot = sig.protected;
          prot = jose.util.base64url.decode(prot, "utf8");
          prot = JSON.parse(prot);
          all = merge(all, prot);
        }

        return all;
      });
    } else if ("ciphertext" in input) {
      // JWE
      type = "JWE";

      op = function op(ks, opts) {
        return jose.JWE.createDecrypt(ks).decrypt(input, opts);
      }; // headers can be (protected, unprotected, recipients[].header)


      var root = {};

      if (input.protected) {
        root.protected = input.protected;
        root.protected = jose.util.base64url.decode(root.protected, "utf8");
        root.protected = JSON.parse(root.protected);
      }

      if (input.unprotected) {
        root.unprotected = input.unprotected;
      }

      headers = input.recipients || [{}];
      headers = headers.map(function (rcpt) {
        var all = {};

        if (rcpt.header) {
          all = merge(all, rcpt.header);
        }

        if (root.unprotected) {
          all = merge(all, root.unprotected);
        }

        if (root.protected) {
          all = merge(all, root.protected);
        }

        return all;
      });
    }

    return {
      type: type,
      format: "json",
      input: input,
      all: headers,
      perform: op
    };
  }

  module.exports = parseJSON;
  /***/
},
/* 572 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*!
   * util/utf8.js - Implementation of UTF-8 Encoder/Decoder
   *
   * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
   */

  var utf8 = exports;

  utf8.encode = function (input) {
    var output = encodeURIComponent(input || "");
    output = output.replace(/%([0-9a-fA-F]{2})/g, function (m, code) {
      code = parseInt(code, 16);
      return String.fromCharCode(code);
    });
    return output;
  };

  utf8.decode = function (input) {
    var output = (input || "").replace(/[\u0080-\u00ff]/g, function (m) {
      var code = (0x100 | m.charCodeAt(0)).toString(16).substring(1);
      return "%" + code;
    });
    output = decodeURIComponent(output);
    return output;
  };
  /***/

},
/* 573 */

/***/
function (module, exports, __webpack_require__) {
  var wrappy = __webpack_require__(605);

  module.exports = wrappy(once);
  module.exports.strict = wrappy(onceStrict);
  once.proto = once(function () {
    Object.defineProperty(Function.prototype, 'once', {
      value: function value() {
        return once(this);
      },
      configurable: true
    });
    Object.defineProperty(Function.prototype, 'onceStrict', {
      value: function value() {
        return onceStrict(this);
      },
      configurable: true
    });
  });

  function once(fn) {
    var f = function f() {
      if (f.called) return f.value;
      f.called = true;
      return f.value = fn.apply(this, arguments);
    };

    f.called = false;
    return f;
  }

  function onceStrict(fn) {
    var f = function f() {
      if (f.called) throw new Error(f.onceError);
      f.called = true;
      return f.value = fn.apply(this, arguments);
    };

    var name = fn.name || 'Function wrapped with `once`';
    f.onceError = name + " shouldn't be called more than once";
    f.called = false;
    return f;
  }
  /***/

},
/* 574 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // (C) 1995-2013 Jean-loup Gailly and Mark Adler
  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
  //
  // This software is provided 'as-is', without any express or implied
  // warranty. In no event will the authors be held liable for any damages
  // arising from the use of this software.
  //
  // Permission is granted to anyone to use this software for any purpose,
  // including commercial applications, and to alter it and redistribute it
  // freely, subject to the following restrictions:
  //
  // 1. The origin of this software must not be misrepresented; you must not
  //   claim that you wrote the original software. If you use this software
  //   in a product, an acknowledgment in the product documentation would be
  //   appreciated but is not required.
  // 2. Altered source versions must be plainly marked as such, and must not be
  //   misrepresented as being the original software.
  // 3. This notice may not be removed or altered from any source distribution.

  module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,

    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,

    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,

    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,

    /* The deflate compression method */
    Z_DEFLATED: 8 //Z_NULL:                 null // Use -1 or null inline, depending on var type

  };
  /***/
},
/* 575 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // (C) 1995-2013 Jean-loup Gailly and Mark Adler
  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
  //
  // This software is provided 'as-is', without any express or implied
  // warranty. In no event will the authors be held liable for any damages
  // arising from the use of this software.
  //
  // Permission is granted to anyone to use this software for any purpose,
  // including commercial applications, and to alter it and redistribute it
  // freely, subject to the following restrictions:
  //
  // 1. The origin of this software must not be misrepresented; you must not
  //   claim that you wrote the original software. If you use this software
  //   in a product, an acknowledgment in the product documentation would be
  //   appreciated but is not required.
  // 2. Altered source versions must be plainly marked as such, and must not be
  //   misrepresented as being the original software.
  // 3. This notice may not be removed or altered from any source distribution.

  var utils = __webpack_require__(107);

  var trees = __webpack_require__(580);

  var adler32 = __webpack_require__(239);

  var crc32 = __webpack_require__(240);

  var msg = __webpack_require__(579);
  /* Public constants ==========================================================*/

  /* ===========================================================================*/

  /* Allowed flush values; see deflate() and inflate() below for details */


  var Z_NO_FLUSH = 0;
  var Z_PARTIAL_FLUSH = 1; //var Z_SYNC_FLUSH    = 2;

  var Z_FULL_FLUSH = 3;
  var Z_FINISH = 4;
  var Z_BLOCK = 5; //var Z_TREES         = 6;

  /* Return codes for the compression/decompression functions. Negative values
   * are errors, positive values are used for special but normal events.
   */

  var Z_OK = 0;
  var Z_STREAM_END = 1; //var Z_NEED_DICT     = 2;
  //var Z_ERRNO         = -1;

  var Z_STREAM_ERROR = -2;
  var Z_DATA_ERROR = -3; //var Z_MEM_ERROR     = -4;

  var Z_BUF_ERROR = -5; //var Z_VERSION_ERROR = -6;

  /* compression levels */
  //var Z_NO_COMPRESSION      = 0;
  //var Z_BEST_SPEED          = 1;
  //var Z_BEST_COMPRESSION    = 9;

  var Z_DEFAULT_COMPRESSION = -1;
  var Z_FILTERED = 1;
  var Z_HUFFMAN_ONLY = 2;
  var Z_RLE = 3;
  var Z_FIXED = 4;
  var Z_DEFAULT_STRATEGY = 0;
  /* Possible values of the data_type field (though see inflate()) */
  //var Z_BINARY              = 0;
  //var Z_TEXT                = 1;
  //var Z_ASCII               = 1; // = Z_TEXT

  var Z_UNKNOWN = 2;
  /* The deflate compression method */

  var Z_DEFLATED = 8;
  /*============================================================================*/

  var MAX_MEM_LEVEL = 9;
  /* Maximum value for memLevel in deflateInit2 */

  var MAX_WBITS = 15;
  /* 32K LZ77 window */

  var DEF_MEM_LEVEL = 8;
  var LENGTH_CODES = 29;
  /* number of length codes, not counting the special END_BLOCK code */

  var LITERALS = 256;
  /* number of literal bytes 0..255 */

  var L_CODES = LITERALS + 1 + LENGTH_CODES;
  /* number of Literal or Length codes, including the END_BLOCK code */

  var D_CODES = 30;
  /* number of distance codes */

  var BL_CODES = 19;
  /* number of codes used to transfer the bit lengths */

  var HEAP_SIZE = 2 * L_CODES + 1;
  /* maximum heap size */

  var MAX_BITS = 15;
  /* All codes must not exceed MAX_BITS bits */

  var MIN_MATCH = 3;
  var MAX_MATCH = 258;
  var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
  var PRESET_DICT = 0x20;
  var INIT_STATE = 42;
  var EXTRA_STATE = 69;
  var NAME_STATE = 73;
  var COMMENT_STATE = 91;
  var HCRC_STATE = 103;
  var BUSY_STATE = 113;
  var FINISH_STATE = 666;
  var BS_NEED_MORE = 1;
  /* block not completed, need more input or more output */

  var BS_BLOCK_DONE = 2;
  /* block flush performed */

  var BS_FINISH_STARTED = 3;
  /* finish started, need only more output at next deflate */

  var BS_FINISH_DONE = 4;
  /* finish done, accept no more input or output */

  var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

  function err(strm, errorCode) {
    strm.msg = msg[errorCode];
    return errorCode;
  }

  function rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
  }

  function zero(buf) {
    var len = buf.length;

    while (--len >= 0) {
      buf[len] = 0;
    }
  }
  /* =========================================================================
   * Flush as much pending output as possible. All deflate() output goes
   * through this function so some applications may wish to modify it
   * to avoid allocating a large strm->output buffer and copying into it.
   * (See also read_buf()).
   */


  function flush_pending(strm) {
    var s = strm.state; //_tr_flush_bits(s);

    var len = s.pending;

    if (len > strm.avail_out) {
      len = strm.avail_out;
    }

    if (len === 0) {
      return;
    }

    utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;

    if (s.pending === 0) {
      s.pending_out = 0;
    }
  }

  function flush_block_only(s, last) {
    trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);

    s.block_start = s.strstart;
    flush_pending(s.strm);
  }

  function put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
  }
  /* =========================================================================
   * Put a short in the pending buffer. The 16-bit value is put in MSB order.
   * IN assertion: the stream state is correct and there is enough room in
   * pending_buf.
   */


  function putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
  }
  /* ===========================================================================
   * Read a new buffer from the current input stream, update the adler32
   * and total number of bytes read.  All deflate() input goes through
   * this function so some applications may wish to modify it to avoid
   * allocating a large strm->input buffer and copying from it.
   * (See also flush_pending()).
   */


  function read_buf(strm, buf, start, size) {
    var len = strm.avail_in;

    if (len > size) {
      len = size;
    }

    if (len === 0) {
      return 0;
    }

    strm.avail_in -= len; // zmemcpy(buf, strm->next_in, len);

    utils.arraySet(buf, strm.input, strm.next_in, len, start);

    if (strm.state.wrap === 1) {
      strm.adler = adler32(strm.adler, buf, len, start);
    } else if (strm.state.wrap === 2) {
      strm.adler = crc32(strm.adler, buf, len, start);
    }

    strm.next_in += len;
    strm.total_in += len;
    return len;
  }
  /* ===========================================================================
   * Set match_start to the longest match starting at the given string and
   * return its length. Matches shorter or equal to prev_length are discarded,
   * in which case the result is equal to prev_length and match_start is
   * garbage.
   * IN assertions: cur_match is the head of the hash chain for the current
   *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
   * OUT assertion: the match length is not greater than s->lookahead.
   */


  function longest_match(s, cur_match) {
    var chain_length = s.max_chain_length;
    /* max hash chain length */

    var scan = s.strstart;
    /* current string */

    var match;
    /* matched string */

    var len;
    /* length of current match */

    var best_len = s.prev_length;
    /* best match length so far */

    var nice_match = s.nice_match;
    /* stop if match long enough */

    var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0
    /*NIL*/
    ;
    var _win = s.window; // shortcut

    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
     * we prevent matches with the string of window index 0.
     */

    var strend = s.strstart + MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
     * It is easy to get rid of this optimization if necessary.
     */
    // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

    /* Do not waste too much time if we already have a good match: */

    if (s.prev_length >= s.good_match) {
      chain_length >>= 2;
    }
    /* Do not look for matches beyond the end of the input. This is necessary
     * to make deflate deterministic.
     */


    if (nice_match > s.lookahead) {
      nice_match = s.lookahead;
    } // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");


    do {
      // Assert(cur_match < s->strstart, "no future");
      match = cur_match;
      /* Skip to next match if the match length cannot increase
       * or if the match length is less than 2.  Note that the checks below
       * for insufficient lookahead only occur occasionally for performance
       * reasons.  Therefore uninitialized memory will be accessed, and
       * conditional jumps will be made that depend on those values.
       * However the length of the match is limited to the lookahead, so
       * the output of deflate is not affected by the uninitialized values.
       */

      if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) {
        continue;
      }
      /* The check at best_len-1 can be removed because it will be made
       * again later. (This heuristic is not always a win.)
       * It is not necessary to compare scan[2] and match[2] since they
       * are always equal when the other bytes match, given that
       * the hash keys are equal and that HASH_BITS >= 8.
       */


      scan += 2;
      match++; // Assert(*scan == *match, "match[2]?");

      /* We check for insufficient lookahead only every 8th comparison;
       * the 256th check will be made at strstart+258.
       */

      do {
        /*jshint noempty:false*/
      } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");


      len = MAX_MATCH - (strend - scan);
      scan = strend - MAX_MATCH;

      if (len > best_len) {
        s.match_start = cur_match;
        best_len = len;

        if (len >= nice_match) {
          break;
        }

        scan_end1 = _win[scan + best_len - 1];
        scan_end = _win[scan + best_len];
      }
    } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

    if (best_len <= s.lookahead) {
      return best_len;
    }

    return s.lookahead;
  }
  /* ===========================================================================
   * Fill the window when the lookahead becomes insufficient.
   * Updates strstart and lookahead.
   *
   * IN assertion: lookahead < MIN_LOOKAHEAD
   * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
   *    At least one byte has been read, or avail_in == 0; reads are
   *    performed for at least two bytes (required for the zip translate_eol
   *    option -- not supported here).
   */


  function fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str; //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

    do {
      more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed

      /* Deal with !@#$% 64K limit: */
      //if (sizeof(int) <= 2) {
      //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
      //        more = wsize;
      //
      //  } else if (more == (unsigned)(-1)) {
      //        /* Very unlikely, but possible on 16 bit machine if
      //         * strstart == 0 && lookahead == 1 (input done a byte at time)
      //         */
      //        more--;
      //    }
      //}

      /* If the window is almost full and there is insufficient lookahead,
       * move the upper half to the lower one to make room in the upper half.
       */

      if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
        utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
        s.match_start -= _w_size;
        s.strstart -= _w_size;
        /* we now have strstart >= MAX_DIST */

        s.block_start -= _w_size;
        /* Slide the hash table (could be avoided with 32 bit values
         at the expense of memory usage). We slide even when level == 0
         to keep the hash table consistent if we switch back to level > 0
         later. (Using level 0 permanently is not an optimal usage of
         zlib, so we don't care about this pathological case.)
         */

        n = s.hash_size;
        p = n;

        do {
          m = s.head[--p];
          s.head[p] = m >= _w_size ? m - _w_size : 0;
        } while (--n);

        n = _w_size;
        p = n;

        do {
          m = s.prev[--p];
          s.prev[p] = m >= _w_size ? m - _w_size : 0;
          /* If n is not on any hash chain, prev[n] is garbage but
           * its value will never be used.
           */
        } while (--n);

        more += _w_size;
      }

      if (s.strm.avail_in === 0) {
        break;
      }
      /* If there was no sliding:
       *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
       *    more == window_size - lookahead - strstart
       * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
       * => more >= window_size - 2*WSIZE + 2
       * In the BIG_MEM or MMAP case (not yet supported),
       *   window_size == input_size + MIN_LOOKAHEAD  &&
       *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
       * Otherwise, window_size == 2*WSIZE so more >= 2.
       * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
       */
      //Assert(more >= 2, "more < 2");


      n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
      s.lookahead += n;
      /* Initialize the hash value now that we have some input: */

      if (s.lookahead + s.insert >= MIN_MATCH) {
        str = s.strstart - s.insert;
        s.ins_h = s.window[str];
        /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */

        s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask; //#if MIN_MATCH != 3
        //        Call update_hash() MIN_MATCH-3 more times
        //#endif

        while (s.insert) {
          /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
          s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
          s.prev[str & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = str;
          str++;
          s.insert--;

          if (s.lookahead + s.insert < MIN_MATCH) {
            break;
          }
        }
      }
      /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
       * but this is not important since only literal bytes will be emitted.
       */

    } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
    /* If the WIN_INIT bytes after the end of the current data have never been
     * written, then zero those bytes in order to avoid memory check reports of
     * the use of uninitialized (or uninitialised as Julian writes) bytes by
     * the longest match routines.  Update the high water mark for the next
     * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
     * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
     */
    //  if (s.high_water < s.window_size) {
    //    var curr = s.strstart + s.lookahead;
    //    var init = 0;
    //
    //    if (s.high_water < curr) {
    //      /* Previous high water mark below current data -- zero WIN_INIT
    //       * bytes or up to end of window, whichever is less.
    //       */
    //      init = s.window_size - curr;
    //      if (init > WIN_INIT)
    //        init = WIN_INIT;
    //      zmemzero(s->window + curr, (unsigned)init);
    //      s->high_water = curr + init;
    //    }
    //    else if (s->high_water < (ulg)curr + WIN_INIT) {
    //      /* High water mark at or above current data, but below current data
    //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
    //       * to end of window, whichever is less.
    //       */
    //      init = (ulg)curr + WIN_INIT - s->high_water;
    //      if (init > s->window_size - s->high_water)
    //        init = s->window_size - s->high_water;
    //      zmemzero(s->window + s->high_water, (unsigned)init);
    //      s->high_water += init;
    //    }
    //  }
    //
    //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
    //    "not enough room for search");

  }
  /* ===========================================================================
   * Copy without compression as much as possible from the input stream, return
   * the current block state.
   * This function does not insert new strings in the dictionary since
   * uncompressible data is probably not useful. This function is used
   * only for the level=0 compression option.
   * NOTE: this function should be optimized to avoid extra copying from
   * window to pending_buf.
   */


  function deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
     * to pending_buf_size, and each stored block has a 5 byte header:
     */
    var max_block_size = 0xffff;

    if (max_block_size > s.pending_buf_size - 5) {
      max_block_size = s.pending_buf_size - 5;
    }
    /* Copy as much as possible from input to output: */


    for (;;) {
      /* Fill the window as much as possible: */
      if (s.lookahead <= 1) {
        //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
        //  s->block_start >= (long)s->w_size, "slide too late");
        //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
        //        s.block_start >= s.w_size)) {
        //        throw  new Error("slide too late");
        //      }
        fill_window(s);

        if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }

        if (s.lookahead === 0) {
          break;
        }
        /* flush the current block */

      } //Assert(s->block_start >= 0L, "block gone");
      //    if (s.block_start < 0) throw new Error("block gone");


      s.strstart += s.lookahead;
      s.lookahead = 0;
      /* Emit a stored block if pending_buf will be full: */

      var max_start = s.block_start + max_block_size;

      if (s.strstart === 0 || s.strstart >= max_start) {
        /* strstart == 0 is possible when wraparound on 16-bit machine */
        s.lookahead = s.strstart - max_start;
        s.strstart = max_start;
        /*** FLUSH_BLOCK(s, 0); ***/

        flush_block_only(s, false);

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/

      }
      /* Flush if we may have to slide, otherwise block_start may become
       * negative and the data will be gone:
       */


      if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/

      }
    }

    s.insert = 0;

    if (flush === Z_FINISH) {
      /*** FLUSH_BLOCK(s, 1); ***/
      flush_block_only(s, true);

      if (s.strm.avail_out === 0) {
        return BS_FINISH_STARTED;
      }
      /***/


      return BS_FINISH_DONE;
    }

    if (s.strstart > s.block_start) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);

      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/

    }

    return BS_NEED_MORE;
  }
  /* ===========================================================================
   * Compress as much as possible from the input stream, return the current
   * block state.
   * This function does not perform lazy evaluation of matches and inserts
   * new strings in the dictionary only for unmatched strings or for short
   * matches. It is used only for the fast compression options.
   */


  function deflate_fast(s, flush) {
    var hash_head;
    /* head of the hash chain */

    var bflush;
    /* set if current block must be flushed */

    for (;;) {
      /* Make sure that we always have enough lookahead, except
       * at the end of the input file. We need MAX_MATCH bytes
       * for the next match, plus MIN_MATCH bytes to insert the
       * string following the next match.
       */
      if (s.lookahead < MIN_LOOKAHEAD) {
        fill_window(s);

        if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }

        if (s.lookahead === 0) {
          break;
          /* flush the current block */
        }
      }
      /* Insert the string window[strstart .. strstart+2] in the
       * dictionary, and set hash_head to the head of the hash chain:
       */


      hash_head = 0
      /*NIL*/
      ;

      if (s.lookahead >= MIN_MATCH) {
        /*** INSERT_STRING(s, s.strstart, hash_head); ***/
        s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
        hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = s.strstart;
        /***/
      }
      /* Find the longest match, discarding those <= prev_length.
       * At this point we have always match_length < MIN_MATCH
       */


      if (hash_head !== 0
      /*NIL*/
      && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
        /* To simplify the code, we prevent matches with the string
         * of window index 0 (in particular we have to avoid a match
         * of the string with itself at the start of the input file).
         */
        s.match_length = longest_match(s, hash_head);
        /* longest_match() sets match_start */
      }

      if (s.match_length >= MIN_MATCH) {
        // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

        /*** _tr_tally_dist(s, s.strstart - s.match_start,
                       s.match_length - MIN_MATCH, bflush); ***/
        bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
        s.lookahead -= s.match_length;
        /* Insert new strings in the hash table only if the match length
         * is not too large. This saves time but degrades compression.
         */

        if (s.match_length <= s.max_lazy_match
        /*max_insert_length*/
        && s.lookahead >= MIN_MATCH) {
          s.match_length--;
          /* string at strstart already in table */

          do {
            s.strstart++;
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/

            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
            /***/

            /* strstart never exceeds WSIZE-MAX_MATCH, so there are
             * always MIN_MATCH bytes ahead.
             */
          } while (--s.match_length !== 0);

          s.strstart++;
        } else {
          s.strstart += s.match_length;
          s.match_length = 0;
          s.ins_h = s.window[s.strstart];
          /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */

          s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask; //#if MIN_MATCH != 3
          //                Call UPDATE_HASH() MIN_MATCH-3 more times
          //#endif

          /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
           * matter since it will be recomputed at next deflate call.
           */
        }
      } else {
        /* No match, output a literal byte */
        //Tracevv((stderr,"%c", s.window[s.strstart]));

        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
        bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
      }

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/

      }
    }

    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;

    if (flush === Z_FINISH) {
      /*** FLUSH_BLOCK(s, 1); ***/
      flush_block_only(s, true);

      if (s.strm.avail_out === 0) {
        return BS_FINISH_STARTED;
      }
      /***/


      return BS_FINISH_DONE;
    }

    if (s.last_lit) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);

      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/

    }

    return BS_BLOCK_DONE;
  }
  /* ===========================================================================
   * Same as above, but achieves better compression. We use a lazy
   * evaluation for matches: a match is finally adopted only if there is
   * no better match at the next window position.
   */


  function deflate_slow(s, flush) {
    var hash_head;
    /* head of hash chain */

    var bflush;
    /* set if current block must be flushed */

    var max_insert;
    /* Process the input block. */

    for (;;) {
      /* Make sure that we always have enough lookahead, except
       * at the end of the input file. We need MAX_MATCH bytes
       * for the next match, plus MIN_MATCH bytes to insert the
       * string following the next match.
       */
      if (s.lookahead < MIN_LOOKAHEAD) {
        fill_window(s);

        if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }

        if (s.lookahead === 0) {
          break;
        }
        /* flush the current block */

      }
      /* Insert the string window[strstart .. strstart+2] in the
       * dictionary, and set hash_head to the head of the hash chain:
       */


      hash_head = 0
      /*NIL*/
      ;

      if (s.lookahead >= MIN_MATCH) {
        /*** INSERT_STRING(s, s.strstart, hash_head); ***/
        s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
        hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = s.strstart;
        /***/
      }
      /* Find the longest match, discarding those <= prev_length.
       */


      s.prev_length = s.match_length;
      s.prev_match = s.match_start;
      s.match_length = MIN_MATCH - 1;

      if (hash_head !== 0
      /*NIL*/
      && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
      /*MAX_DIST(s)*/
      ) {
          /* To simplify the code, we prevent matches with the string
           * of window index 0 (in particular we have to avoid a match
           * of the string with itself at the start of the input file).
           */
          s.match_length = longest_match(s, hash_head);
          /* longest_match() sets match_start */

          if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096
          /*TOO_FAR*/
          )) {
            /* If prev_match is also MIN_MATCH, match_start is garbage
             * but we will ignore the current match anyway.
             */
            s.match_length = MIN_MATCH - 1;
          }
        }
      /* If there was a match at the previous step and the current
       * match is not better, output the previous match:
       */


      if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
        max_insert = s.strstart + s.lookahead - MIN_MATCH;
        /* Do not insert strings in hash table beyond this. */
        //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

        /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                       s.prev_length - MIN_MATCH, bflush);***/

        bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
        /* Insert in hash table all strings up to the end of the match.
         * strstart-1 and strstart are already inserted. If there is not
         * enough lookahead, the last two strings are not inserted in
         * the hash table.
         */

        s.lookahead -= s.prev_length - 1;
        s.prev_length -= 2;

        do {
          if (++s.strstart <= max_insert) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
            /***/
          }
        } while (--s.prev_length !== 0);

        s.match_available = 0;
        s.match_length = MIN_MATCH - 1;
        s.strstart++;

        if (bflush) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }
      } else if (s.match_available) {
        /* If there was no match at the previous position, output a
         * single literal. If there was a match but the current match
         * is longer, truncate the previous match to a single literal.
         */
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));

        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
        bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

        if (bflush) {
          /*** FLUSH_BLOCK_ONLY(s, 0) ***/
          flush_block_only(s, false);
          /***/
        }

        s.strstart++;
        s.lookahead--;

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
      } else {
        /* There is no previous match to compare with, wait for
         * the next step to decide.
         */
        s.match_available = 1;
        s.strstart++;
        s.lookahead--;
      }
    } //Assert (flush != Z_NO_FLUSH, "no flush?");


    if (s.match_available) {
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));

      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
      s.match_available = 0;
    }

    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;

    if (flush === Z_FINISH) {
      /*** FLUSH_BLOCK(s, 1); ***/
      flush_block_only(s, true);

      if (s.strm.avail_out === 0) {
        return BS_FINISH_STARTED;
      }
      /***/


      return BS_FINISH_DONE;
    }

    if (s.last_lit) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);

      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/

    }

    return BS_BLOCK_DONE;
  }
  /* ===========================================================================
   * For Z_RLE, simply look for runs of bytes, generate matches only of distance
   * one.  Do not maintain a hash table.  (It will be regenerated if this run of
   * deflate switches away from Z_RLE.)
   */


  function deflate_rle(s, flush) {
    var bflush;
    /* set if current block must be flushed */

    var prev;
    /* byte at distance one to match */

    var scan, strend;
    /* scan goes up to strend for length of run */

    var _win = s.window;

    for (;;) {
      /* Make sure that we always have enough lookahead, except
       * at the end of the input file. We need MAX_MATCH bytes
       * for the longest run, plus one for the unrolled loop.
       */
      if (s.lookahead <= MAX_MATCH) {
        fill_window(s);

        if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }

        if (s.lookahead === 0) {
          break;
        }
        /* flush the current block */

      }
      /* See how many times the previous byte repeats */


      s.match_length = 0;

      if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
        scan = s.strstart - 1;
        prev = _win[scan];

        if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
          strend = s.strstart + MAX_MATCH;

          do {
            /*jshint noempty:false*/
          } while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);

          s.match_length = MAX_MATCH - (strend - scan);

          if (s.match_length > s.lookahead) {
            s.match_length = s.lookahead;
          }
        } //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");

      }
      /* Emit match if have run of MIN_MATCH or longer, else emit literal */


      if (s.match_length >= MIN_MATCH) {
        //check_match(s, s.strstart, s.strstart - 1, s.match_length);

        /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
        bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
        s.lookahead -= s.match_length;
        s.strstart += s.match_length;
        s.match_length = 0;
      } else {
        /* No match, output a literal byte */
        //Tracevv((stderr,"%c", s->window[s->strstart]));

        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
        bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
      }

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/

      }
    }

    s.insert = 0;

    if (flush === Z_FINISH) {
      /*** FLUSH_BLOCK(s, 1); ***/
      flush_block_only(s, true);

      if (s.strm.avail_out === 0) {
        return BS_FINISH_STARTED;
      }
      /***/


      return BS_FINISH_DONE;
    }

    if (s.last_lit) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);

      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/

    }

    return BS_BLOCK_DONE;
  }
  /* ===========================================================================
   * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
   * (It will be regenerated if this run of deflate switches away from Huffman.)
   */


  function deflate_huff(s, flush) {
    var bflush;
    /* set if current block must be flushed */

    for (;;) {
      /* Make sure that we have a literal to write. */
      if (s.lookahead === 0) {
        fill_window(s);

        if (s.lookahead === 0) {
          if (flush === Z_NO_FLUSH) {
            return BS_NEED_MORE;
          }

          break;
          /* flush the current block */
        }
      }
      /* Output a literal byte */


      s.match_length = 0; //Tracevv((stderr,"%c", s->window[s->strstart]));

      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/

      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
      s.lookahead--;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/

      }
    }

    s.insert = 0;

    if (flush === Z_FINISH) {
      /*** FLUSH_BLOCK(s, 1); ***/
      flush_block_only(s, true);

      if (s.strm.avail_out === 0) {
        return BS_FINISH_STARTED;
      }
      /***/


      return BS_FINISH_DONE;
    }

    if (s.last_lit) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);

      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/

    }

    return BS_BLOCK_DONE;
  }
  /* Values for max_lazy_match, good_match and max_chain_length, depending on
   * the desired pack level (0..9). The values given below have been tuned to
   * exclude worst case performance for pathological files. Better values may be
   * found for specific files.
   */


  function Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
  }

  var configuration_table;
  configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),
  /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),
  /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),
  /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),
  /* 3 */
  new Config(4, 4, 16, 16, deflate_slow),
  /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),
  /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),
  /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),
  /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),
  /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)
  /* 9 max compression */
  ];
  /* ===========================================================================
   * Initialize the "longest match" routines for a new zlib stream
   */

  function lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/

    zero(s.head); // Fill with NIL (= 0);

    /* Set the default configuration parameters:
     */

    s.max_lazy_match = configuration_table[s.level].max_lazy;
    s.good_match = configuration_table[s.level].good_length;
    s.nice_match = configuration_table[s.level].nice_length;
    s.max_chain_length = configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
  }

  function DeflateState() {
    this.strm = null;
    /* pointer back to this zlib stream */

    this.status = 0;
    /* as the name implies */

    this.pending_buf = null;
    /* output still pending */

    this.pending_buf_size = 0;
    /* size of pending_buf */

    this.pending_out = 0;
    /* next pending byte to output to the stream */

    this.pending = 0;
    /* nb of bytes in the pending buffer */

    this.wrap = 0;
    /* bit 0 true for zlib, bit 1 true for gzip */

    this.gzhead = null;
    /* gzip header information to write */

    this.gzindex = 0;
    /* where in extra, name, or comment */

    this.method = Z_DEFLATED;
    /* can only be DEFLATED */

    this.last_flush = -1;
    /* value of flush param for previous deflate call */

    this.w_size = 0;
    /* LZ77 window size (32K by default) */

    this.w_bits = 0;
    /* log2(w_size)  (8..16) */

    this.w_mask = 0;
    /* w_size - 1 */

    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
     * and move to the first half later to keep a dictionary of at least wSize
     * bytes. With this organization, matches are limited to a distance of
     * wSize-MAX_MATCH bytes, but this ensures that IO is always
     * performed with a length multiple of the block size.
     */

    this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
     * is directly used as sliding window.
     */

    this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
     * array to 64K, this link is maintained only for the last 32K strings.
     * An index in this array is thus a window index modulo 32K.
     */

    this.head = null;
    /* Heads of the hash chains or NIL. */

    this.ins_h = 0;
    /* hash index of string to be inserted */

    this.hash_size = 0;
    /* number of elements in hash table */

    this.hash_bits = 0;
    /* log2(hash_size) */

    this.hash_mask = 0;
    /* hash_size-1 */

    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
     * step. It must be such that after MIN_MATCH steps, the oldest
     * byte no longer takes part in the hash key, that is:
     *   hash_shift * MIN_MATCH >= hash_bits
     */

    this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
     * negative when the window is moved backwards.
     */

    this.match_length = 0;
    /* length of best match */

    this.prev_match = 0;
    /* previous match */

    this.match_available = 0;
    /* set if previous match exists */

    this.strstart = 0;
    /* start of string to insert */

    this.match_start = 0;
    /* start of matching string */

    this.lookahead = 0;
    /* number of valid bytes ahead in window */

    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
     * are discarded. This is used in the lazy match evaluation.
     */

    this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
     * length.  A higher limit improves compression ratio but degrades the
     * speed.
     */

    this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
     * smaller than this value. This mechanism is used only for compression
     * levels >= 4.
     */
    // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;

    /* Insert new strings in the hash table only if the match length is not
     * greater than this length. This saves time but degrades compression.
     * max_insert_length is used only for compression levels <= 3.
     */

    this.level = 0;
    /* compression level (1..9) */

    this.strategy = 0;
    /* favor or force Huffman coding*/

    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */

    this.nice_match = 0;
    /* Stop searching when current match exceeds this */

    /* used by trees.c: */

    /* Didn't use ct_data typedef below to suppress compiler warning */
    // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective

    this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
    this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
    this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
    zero(this.dyn_ltree);
    zero(this.dyn_dtree);
    zero(this.bl_tree);
    this.l_desc = null;
    /* desc. for literal tree */

    this.d_desc = null;
    /* desc. for distance tree */

    this.bl_desc = null;
    /* desc. for bit length tree */
    //ush bl_count[MAX_BITS+1];

    this.bl_count = new utils.Buf16(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */
    //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */

    this.heap = new utils.Buf16(2 * L_CODES + 1);
    /* heap used to build the Huffman trees */

    zero(this.heap);
    this.heap_len = 0;
    /* number of elements in the heap */

    this.heap_max = 0;
    /* element of largest frequency */

    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
     * The same heap array is used to build all trees.
     */

    this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];

    zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
     */

    this.l_buf = 0;
    /* buffer index for literals or lengths */

    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
     * limiting lit_bufsize to 64K:
     *   - frequencies can be kept in 16 bit counters
     *   - if compression is not successful for the first block, all input
     *     data is still in the window so we can still emit a stored block even
     *     when input comes from standard input.  (This can also be done for
     *     all blocks if lit_bufsize is not greater than 32K.)
     *   - if compression is not successful for a file smaller than 64K, we can
     *     even emit a stored file instead of a stored block (saving 5 bytes).
     *     This is applicable only for zip (not gzip or zlib).
     *   - creating new Huffman trees less frequently may not provide fast
     *     adaptation to changes in the input data statistics. (Take for
     *     example a binary file with poorly compressible code followed by
     *     a highly compressible string table.) Smaller buffer sizes give
     *     fast adaptation but have of course the overhead of transmitting
     *     trees more frequently.
     *   - I can't count above 4
     */

    this.last_lit = 0;
    /* running index in l_buf */

    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
     * the same number of elements. To use different lengths, an extra flag
     * array would be necessary.
     */

    this.opt_len = 0;
    /* bit length of current block with optimal trees */

    this.static_len = 0;
    /* bit length of current block with static trees */

    this.matches = 0;
    /* number of string matches in current block */

    this.insert = 0;
    /* bytes at end of window left to insert */

    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
     * significant bits).
     */

    this.bi_valid = 0;
    /* Number of valid bits in bi_buf.  All bits above the last valid bit
     * are always zero.
     */
    // Used for window memory init. We safely ignore it for JS. That makes
    // sense only for pointers and memory check tools.
    //this.high_water = 0;

    /* High water mark offset in window for initialized bytes -- bytes above
     * this are set to zero in order to avoid memory check warnings when
     * longest match routines access bytes past the input.  This is then
     * updated to the new high water mark.
     */
  }

  function deflateResetKeep(strm) {
    var s;

    if (!strm || !strm.state) {
      return err(strm, Z_STREAM_ERROR);
    }

    strm.total_in = strm.total_out = 0;
    strm.data_type = Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;

    if (s.wrap < 0) {
      s.wrap = -s.wrap;
      /* was made negative by deflate(..., Z_FINISH); */
    }

    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
    : 1; // adler32(0, Z_NULL, 0)

    s.last_flush = Z_NO_FLUSH;

    trees._tr_init(s);

    return Z_OK;
  }

  function deflateReset(strm) {
    var ret = deflateResetKeep(strm);

    if (ret === Z_OK) {
      lm_init(strm.state);
    }

    return ret;
  }

  function deflateSetHeader(strm, head) {
    if (!strm || !strm.state) {
      return Z_STREAM_ERROR;
    }

    if (strm.state.wrap !== 2) {
      return Z_STREAM_ERROR;
    }

    strm.state.gzhead = head;
    return Z_OK;
  }

  function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) {
      // === Z_NULL
      return Z_STREAM_ERROR;
    }

    var wrap = 1;

    if (level === Z_DEFAULT_COMPRESSION) {
      level = 6;
    }

    if (windowBits < 0) {
      /* suppress zlib wrapper */
      wrap = 0;
      windowBits = -windowBits;
    } else if (windowBits > 15) {
      wrap = 2;
      /* write gzip wrapper instead */

      windowBits -= 16;
    }

    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) {
      return err(strm, Z_STREAM_ERROR);
    }

    if (windowBits === 8) {
      windowBits = 9;
    }
    /* until 256-byte window bug fixed */


    var s = new DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
    s.window = new utils.Buf8(s.w_size * 2);
    s.head = new utils.Buf16(s.hash_size);
    s.prev = new utils.Buf16(s.w_size); // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */

    s.lit_bufsize = 1 << memLevel + 6;
    /* 16K elements by default */

    s.pending_buf_size = s.lit_bufsize * 4; //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;

    s.pending_buf = new utils.Buf8(s.pending_buf_size); // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);

    s.d_buf = 1 * s.lit_bufsize; //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;

    s.l_buf = (1 + 2) * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return deflateReset(strm);
  }

  function deflateInit(strm, level) {
    return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
  }

  function deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only

    if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
      return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
    }

    s = strm.state;

    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) {
      return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
    }

    s.strm = strm;
    /* just in case */

    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */

    if (s.status === INIT_STATE) {
      if (s.wrap === 2) {
        // GZIP header
        strm.adler = 0; //crc32(0L, Z_NULL, 0);

        put_byte(s, 31);
        put_byte(s, 139);
        put_byte(s, 8);

        if (!s.gzhead) {
          // s->gzhead == Z_NULL
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
          put_byte(s, OS_CODE);
          s.status = BUSY_STATE;
        } else {
          put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
          put_byte(s, s.gzhead.time & 0xff);
          put_byte(s, s.gzhead.time >> 8 & 0xff);
          put_byte(s, s.gzhead.time >> 16 & 0xff);
          put_byte(s, s.gzhead.time >> 24 & 0xff);
          put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
          put_byte(s, s.gzhead.os & 0xff);

          if (s.gzhead.extra && s.gzhead.extra.length) {
            put_byte(s, s.gzhead.extra.length & 0xff);
            put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
          }

          if (s.gzhead.hcrc) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
          }

          s.gzindex = 0;
          s.status = EXTRA_STATE;
        }
      } else // DEFLATE header
        {
          var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
          var level_flags = -1;

          if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
            level_flags = 0;
          } else if (s.level < 6) {
            level_flags = 1;
          } else if (s.level === 6) {
            level_flags = 2;
          } else {
            level_flags = 3;
          }

          header |= level_flags << 6;

          if (s.strstart !== 0) {
            header |= PRESET_DICT;
          }

          header += 31 - header % 31;
          s.status = BUSY_STATE;
          putShortMSB(s, header);
          /* Save the adler32 of the preset dictionary: */

          if (s.strstart !== 0) {
            putShortMSB(s, strm.adler >>> 16);
            putShortMSB(s, strm.adler & 0xffff);
          }

          strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    } //#ifdef GZIP


    if (s.status === EXTRA_STATE) {
      if (s.gzhead.extra
      /* != Z_NULL*/
      ) {
          beg = s.pending;
          /* start of bytes to update crc */

          while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
            if (s.pending === s.pending_buf_size) {
              if (s.gzhead.hcrc && s.pending > beg) {
                strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
              }

              flush_pending(strm);
              beg = s.pending;

              if (s.pending === s.pending_buf_size) {
                break;
              }
            }

            put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
            s.gzindex++;
          }

          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }

          if (s.gzindex === s.gzhead.extra.length) {
            s.gzindex = 0;
            s.status = NAME_STATE;
          }
        } else {
        s.status = NAME_STATE;
      }
    }

    if (s.status === NAME_STATE) {
      if (s.gzhead.name
      /* != Z_NULL*/
      ) {
          beg = s.pending;
          /* start of bytes to update crc */
          //int val;

          do {
            if (s.pending === s.pending_buf_size) {
              if (s.gzhead.hcrc && s.pending > beg) {
                strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
              }

              flush_pending(strm);
              beg = s.pending;

              if (s.pending === s.pending_buf_size) {
                val = 1;
                break;
              }
            } // JS specific: little magic to add zero terminator to end of string


            if (s.gzindex < s.gzhead.name.length) {
              val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
            } else {
              val = 0;
            }

            put_byte(s, val);
          } while (val !== 0);

          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }

          if (val === 0) {
            s.gzindex = 0;
            s.status = COMMENT_STATE;
          }
        } else {
        s.status = COMMENT_STATE;
      }
    }

    if (s.status === COMMENT_STATE) {
      if (s.gzhead.comment
      /* != Z_NULL*/
      ) {
          beg = s.pending;
          /* start of bytes to update crc */
          //int val;

          do {
            if (s.pending === s.pending_buf_size) {
              if (s.gzhead.hcrc && s.pending > beg) {
                strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
              }

              flush_pending(strm);
              beg = s.pending;

              if (s.pending === s.pending_buf_size) {
                val = 1;
                break;
              }
            } // JS specific: little magic to add zero terminator to end of string


            if (s.gzindex < s.gzhead.comment.length) {
              val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
            } else {
              val = 0;
            }

            put_byte(s, val);
          } while (val !== 0);

          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }

          if (val === 0) {
            s.status = HCRC_STATE;
          }
        } else {
        s.status = HCRC_STATE;
      }
    }

    if (s.status === HCRC_STATE) {
      if (s.gzhead.hcrc) {
        if (s.pending + 2 > s.pending_buf_size) {
          flush_pending(strm);
        }

        if (s.pending + 2 <= s.pending_buf_size) {
          put_byte(s, strm.adler & 0xff);
          put_byte(s, strm.adler >> 8 & 0xff);
          strm.adler = 0; //crc32(0L, Z_NULL, 0);

          s.status = BUSY_STATE;
        }
      } else {
        s.status = BUSY_STATE;
      }
    } //#endif

    /* Flush as much pending output as possible */


    if (s.pending !== 0) {
      flush_pending(strm);

      if (strm.avail_out === 0) {
        /* Since avail_out is 0, deflate will be called again with
         * more output space, but possibly with both pending and
         * avail_in equal to zero. There won't be anything to do,
         * but this is not an error situation so make sure we
         * return OK instead of BUF_ERROR at next call of deflate:
         */
        s.last_flush = -1;
        return Z_OK;
      }
      /* Make sure there is something to do and avoid duplicate consecutive
       * flushes. For repeated and useless calls with Z_FINISH, we keep
       * returning Z_STREAM_END instead of Z_BUF_ERROR.
       */

    } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
      return err(strm, Z_BUF_ERROR);
    }
    /* User must not provide more input after the first FINISH: */


    if (s.status === FINISH_STATE && strm.avail_in !== 0) {
      return err(strm, Z_BUF_ERROR);
    }
    /* Start a new block or continue the current one.
     */


    if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
      var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);

      if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
        s.status = FINISH_STATE;
      }

      if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
        if (strm.avail_out === 0) {
          s.last_flush = -1;
          /* avoid BUF_ERROR next call, see above */
        }

        return Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
         * of deflate should use the same flush parameter to make sure
         * that the flush is complete. So we don't have to output an
         * empty block here, this will be done at next call. This also
         * ensures that for a very small output buffer, we emit at most
         * one empty block.
         */
      }

      if (bstate === BS_BLOCK_DONE) {
        if (flush === Z_PARTIAL_FLUSH) {
          trees._tr_align(s);
        } else if (flush !== Z_BLOCK) {
          /* FULL_FLUSH or SYNC_FLUSH */
          trees._tr_stored_block(s, 0, 0, false);
          /* For a full flush, this empty block will be recognized
           * as a special marker by inflate_sync().
           */


          if (flush === Z_FULL_FLUSH) {
            /*** CLEAR_HASH(s); ***/

            /* forget history */
            zero(s.head); // Fill with NIL (= 0);

            if (s.lookahead === 0) {
              s.strstart = 0;
              s.block_start = 0;
              s.insert = 0;
            }
          }
        }

        flush_pending(strm);

        if (strm.avail_out === 0) {
          s.last_flush = -1;
          /* avoid BUF_ERROR at next call, see above */

          return Z_OK;
        }
      }
    } //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}


    if (flush !== Z_FINISH) {
      return Z_OK;
    }

    if (s.wrap <= 0) {
      return Z_STREAM_END;
    }
    /* Write the trailer */


    if (s.wrap === 2) {
      put_byte(s, strm.adler & 0xff);
      put_byte(s, strm.adler >> 8 & 0xff);
      put_byte(s, strm.adler >> 16 & 0xff);
      put_byte(s, strm.adler >> 24 & 0xff);
      put_byte(s, strm.total_in & 0xff);
      put_byte(s, strm.total_in >> 8 & 0xff);
      put_byte(s, strm.total_in >> 16 & 0xff);
      put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
      putShortMSB(s, strm.adler >>> 16);
      putShortMSB(s, strm.adler & 0xffff);
    }

    flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
     * to flush the rest.
     */

    if (s.wrap > 0) {
      s.wrap = -s.wrap;
    }
    /* write the trailer only once! */


    return s.pending !== 0 ? Z_OK : Z_STREAM_END;
  }

  function deflateEnd(strm) {
    var status;

    if (!strm
    /*== Z_NULL*/
    || !strm.state
    /*== Z_NULL*/
    ) {
        return Z_STREAM_ERROR;
      }

    status = strm.state.status;

    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) {
      return err(strm, Z_STREAM_ERROR);
    }

    strm.state = null;
    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
  }
  /* =========================================================================
   * Initializes the compression dictionary from the given byte
   * sequence without producing any compressed output.
   */


  function deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;

    if (!strm
    /*== Z_NULL*/
    || !strm.state
    /*== Z_NULL*/
    ) {
        return Z_STREAM_ERROR;
      }

    s = strm.state;
    wrap = s.wrap;

    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) {
      return Z_STREAM_ERROR;
    }
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */


    if (wrap === 1) {
      /* adler32(strm->adler, dictionary, dictLength); */
      strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
    }

    s.wrap = 0;
    /* avoid computing Adler-32 in read_buf */

    /* if dictionary would fill window, just replace the history */

    if (dictLength >= s.w_size) {
      if (wrap === 0) {
        /* already empty otherwise */

        /*** CLEAR_HASH(s); ***/
        zero(s.head); // Fill with NIL (= 0);

        s.strstart = 0;
        s.block_start = 0;
        s.insert = 0;
      }
      /* use the tail */
      // dictionary = dictionary.slice(dictLength - s.w_size);


      tmpDict = new utils.Buf8(s.w_size);
      utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
      dictionary = tmpDict;
      dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */


    avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    fill_window(s);

    while (s.lookahead >= MIN_MATCH) {
      str = s.strstart;
      n = s.lookahead - (MIN_MATCH - 1);

      do {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
      } while (--n);

      s.strstart = str;
      s.lookahead = MIN_MATCH - 1;
      fill_window(s);
    }

    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return Z_OK;
  }

  exports.deflateInit = deflateInit;
  exports.deflateInit2 = deflateInit2;
  exports.deflateReset = deflateReset;
  exports.deflateResetKeep = deflateResetKeep;
  exports.deflateSetHeader = deflateSetHeader;
  exports.deflate = deflate;
  exports.deflateEnd = deflateEnd;
  exports.deflateSetDictionary = deflateSetDictionary;
  exports.deflateInfo = 'pako deflate (from Nodeca project)';
  /* Not implemented
  exports.deflateBound = deflateBound;
  exports.deflateCopy = deflateCopy;
  exports.deflateParams = deflateParams;
  exports.deflatePending = deflatePending;
  exports.deflatePrime = deflatePrime;
  exports.deflateTune = deflateTune;
  */

  /***/
},
/* 576 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // (C) 1995-2013 Jean-loup Gailly and Mark Adler
  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
  //
  // This software is provided 'as-is', without any express or implied
  // warranty. In no event will the authors be held liable for any damages
  // arising from the use of this software.
  //
  // Permission is granted to anyone to use this software for any purpose,
  // including commercial applications, and to alter it and redistribute it
  // freely, subject to the following restrictions:
  //
  // 1. The origin of this software must not be misrepresented; you must not
  //   claim that you wrote the original software. If you use this software
  //   in a product, an acknowledgment in the product documentation would be
  //   appreciated but is not required.
  // 2. Altered source versions must be plainly marked as such, and must not be
  //   misrepresented as being the original software.
  // 3. This notice may not be removed or altered from any source distribution.
  // See state defs from inflate.js

  var BAD = 30;
  /* got a data error -- remain here until reset */

  var TYPE = 12;
  /* i: waiting for type bits, including last-flag bit */

  /*
     Decode literal, length, and distance codes and write out the resulting
     literal and match bytes until either not enough input or output is
     available, an end-of-block is encountered, or a data error is encountered.
     When large enough input and output buffers are supplied to inflate(), for
     example, a 16K input buffer and a 64K output buffer, more than 95% of the
     inflate execution time is spent in this routine.
  
     Entry assumptions:
  
          state.mode === LEN
          strm.avail_in >= 6
          strm.avail_out >= 258
          start >= strm.avail_out
          state.bits < 8
  
     On return, state.mode is one of:
  
          LEN -- ran out of enough output space or enough available input
          TYPE -- reached end of block code, inflate() to interpret next block
          BAD -- error in block data
  
     Notes:
  
      - The maximum input bits used by a length/distance pair is 15 bits for the
        length code, 5 bits for the length extra, 15 bits for the distance code,
        and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
        Therefore if strm.avail_in >= 6, then there is enough input to avoid
        checking for available input while decoding.
  
      - The maximum bytes that a single length/distance pair can output is 258
        bytes, which is the maximum length that can be coded.  inflate_fast()
        requires strm.avail_out >= 258 for each loop to avoid checking for
        output space.
   */

  module.exports = function inflate_fast(strm, start) {
    var state;

    var _in;
    /* local strm.input */


    var last;
    /* have enough input while in < last */

    var _out;
    /* local strm.output */


    var beg;
    /* inflate()'s initial strm.output */

    var end;
    /* while out < end, enough space available */
    //#ifdef INFLATE_STRICT

    var dmax;
    /* maximum distance from zlib header */
    //#endif

    var wsize;
    /* window size or zero if not using window */

    var whave;
    /* valid bytes in the window */

    var wnext;
    /* window write index */
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools

    var s_window;
    /* allocated sliding window, if wsize != 0 */

    var hold;
    /* local strm.hold */

    var bits;
    /* local strm.bits */

    var lcode;
    /* local strm.lencode */

    var dcode;
    /* local strm.distcode */

    var lmask;
    /* mask for first level of length codes */

    var dmask;
    /* mask for first level of distance codes */

    var here;
    /* retrieved table entry */

    var op;
    /* code bits, operation, extra bits, or */

    /*  window position, window bytes to copy */

    var len;
    /* match length, unused bytes */

    var dist;
    /* match distance */

    var from;
    /* where to copy match from */

    var from_source;
    var input, output; // JS specific, because we have no pointers

    /* copy state to local variables */

    state = strm.state; //here = state.here;

    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257); //#ifdef INFLATE_STRICT

    dmax = state.dmax; //#endif

    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
       input data or output space */

    top: do {
      if (bits < 15) {
        hold += input[_in++] << bits;
        bits += 8;
        hold += input[_in++] << bits;
        bits += 8;
      }

      here = lcode[hold & lmask];

      dolen: for (;;) {
        // Goto emulation
        op = here >>> 24
        /*here.bits*/
        ;
        hold >>>= op;
        bits -= op;
        op = here >>> 16 & 0xff
        /*here.op*/
        ;

        if (op === 0) {
          /* literal */
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          output[_out++] = here & 0xffff
          /*here.val*/
          ;
        } else if (op & 16) {
          /* length base */
          len = here & 0xffff
          /*here.val*/
          ;
          op &= 15;
          /* number of extra bits */

          if (op) {
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
            }

            len += hold & (1 << op) - 1;
            hold >>>= op;
            bits -= op;
          } //Tracevv((stderr, "inflate:         length %u\n", len));


          if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
          }

          here = dcode[hold & dmask];

          dodist: for (;;) {
            // goto emulation
            op = here >>> 24
            /*here.bits*/
            ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff
            /*here.op*/
            ;

            if (op & 16) {
              /* distance base */
              dist = here & 0xffff
              /*here.val*/
              ;
              op &= 15;
              /* number of extra bits */

              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;

                if (bits < op) {
                  hold += input[_in++] << bits;
                  bits += 8;
                }
              }

              dist += hold & (1 << op) - 1; //#ifdef INFLATE_STRICT

              if (dist > dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = BAD;
                break top;
              } //#endif


              hold >>>= op;
              bits -= op; //Tracevv((stderr, "inflate:         distance %u\n", dist));

              op = _out - beg;
              /* max distance in output */

              if (dist > op) {
                /* see if copy from window */
                op = dist - op;
                /* distance back in window */

                if (op > whave) {
                  if (state.sane) {
                    strm.msg = 'invalid distance too far back';
                    state.mode = BAD;
                    break top;
                  } // (!) This block is disabled in zlib defaults,
                  // don't enable it for binary compatibility
                  //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                  //                if (len <= op - whave) {
                  //                  do {
                  //                    output[_out++] = 0;
                  //                  } while (--len);
                  //                  continue top;
                  //                }
                  //                len -= op - whave;
                  //                do {
                  //                  output[_out++] = 0;
                  //                } while (--op > whave);
                  //                if (op === 0) {
                  //                  from = _out - dist;
                  //                  do {
                  //                    output[_out++] = output[from++];
                  //                  } while (--len);
                  //                  continue top;
                  //                }
                  //#endif

                }

                from = 0; // window index

                from_source = s_window;

                if (wnext === 0) {
                  /* very common case */
                  from += wsize - op;

                  if (op < len) {
                    /* some from window */
                    len -= op;

                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);

                    from = _out - dist;
                    /* rest from output */

                    from_source = output;
                  }
                } else if (wnext < op) {
                  /* wrap around window */
                  from += wsize + wnext - op;
                  op -= wnext;

                  if (op < len) {
                    /* some from end of window */
                    len -= op;

                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);

                    from = 0;

                    if (wnext < len) {
                      /* some from start of window */
                      op = wnext;
                      len -= op;

                      do {
                        output[_out++] = s_window[from++];
                      } while (--op);

                      from = _out - dist;
                      /* rest from output */

                      from_source = output;
                    }
                  }
                } else {
                  /* contiguous in window */
                  from += wnext - op;

                  if (op < len) {
                    /* some from window */
                    len -= op;

                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);

                    from = _out - dist;
                    /* rest from output */

                    from_source = output;
                  }
                }

                while (len > 2) {
                  output[_out++] = from_source[from++];
                  output[_out++] = from_source[from++];
                  output[_out++] = from_source[from++];
                  len -= 3;
                }

                if (len) {
                  output[_out++] = from_source[from++];

                  if (len > 1) {
                    output[_out++] = from_source[from++];
                  }
                }
              } else {
                from = _out - dist;
                /* copy direct from output */

                do {
                  /* minimum length is three */
                  output[_out++] = output[from++];
                  output[_out++] = output[from++];
                  output[_out++] = output[from++];
                  len -= 3;
                } while (len > 2);

                if (len) {
                  output[_out++] = output[from++];

                  if (len > 1) {
                    output[_out++] = output[from++];
                  }
                }
              }
            } else if ((op & 64) === 0) {
              /* 2nd level distance code */
              here = dcode[(here & 0xffff) + (
              /*here.val*/
              hold & (1 << op) - 1)];
              continue dodist;
            } else {
              strm.msg = 'invalid distance code';
              state.mode = BAD;
              break top;
            }

            break; // need to emulate goto via "continue"
          }
        } else if ((op & 64) === 0) {
          /* 2nd level length code */
          here = lcode[(here & 0xffff) + (
          /*here.val*/
          hold & (1 << op) - 1)];
          continue dolen;
        } else if (op & 32) {
          /* end-of-block */
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.mode = TYPE;
          break top;
        } else {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break top;
        }

        break; // need to emulate goto via "continue"
      }
    } while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */


    len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */

    strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
  };
  /***/

},
/* 577 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // (C) 1995-2013 Jean-loup Gailly and Mark Adler
  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
  //
  // This software is provided 'as-is', without any express or implied
  // warranty. In no event will the authors be held liable for any damages
  // arising from the use of this software.
  //
  // Permission is granted to anyone to use this software for any purpose,
  // including commercial applications, and to alter it and redistribute it
  // freely, subject to the following restrictions:
  //
  // 1. The origin of this software must not be misrepresented; you must not
  //   claim that you wrote the original software. If you use this software
  //   in a product, an acknowledgment in the product documentation would be
  //   appreciated but is not required.
  // 2. Altered source versions must be plainly marked as such, and must not be
  //   misrepresented as being the original software.
  // 3. This notice may not be removed or altered from any source distribution.

  var utils = __webpack_require__(107);

  var adler32 = __webpack_require__(239);

  var crc32 = __webpack_require__(240);

  var inflate_fast = __webpack_require__(576);

  var inflate_table = __webpack_require__(578);

  var CODES = 0;
  var LENS = 1;
  var DISTS = 2;
  /* Public constants ==========================================================*/

  /* ===========================================================================*/

  /* Allowed flush values; see deflate() and inflate() below for details */
  //var Z_NO_FLUSH      = 0;
  //var Z_PARTIAL_FLUSH = 1;
  //var Z_SYNC_FLUSH    = 2;
  //var Z_FULL_FLUSH    = 3;

  var Z_FINISH = 4;
  var Z_BLOCK = 5;
  var Z_TREES = 6;
  /* Return codes for the compression/decompression functions. Negative values
   * are errors, positive values are used for special but normal events.
   */

  var Z_OK = 0;
  var Z_STREAM_END = 1;
  var Z_NEED_DICT = 2; //var Z_ERRNO         = -1;

  var Z_STREAM_ERROR = -2;
  var Z_DATA_ERROR = -3;
  var Z_MEM_ERROR = -4;
  var Z_BUF_ERROR = -5; //var Z_VERSION_ERROR = -6;

  /* The deflate compression method */

  var Z_DEFLATED = 8;
  /* STATES ====================================================================*/

  /* ===========================================================================*/

  var HEAD = 1;
  /* i: waiting for magic header */

  var FLAGS = 2;
  /* i: waiting for method and flags (gzip) */

  var TIME = 3;
  /* i: waiting for modification time (gzip) */

  var OS = 4;
  /* i: waiting for extra flags and operating system (gzip) */

  var EXLEN = 5;
  /* i: waiting for extra length (gzip) */

  var EXTRA = 6;
  /* i: waiting for extra bytes (gzip) */

  var NAME = 7;
  /* i: waiting for end of file name (gzip) */

  var COMMENT = 8;
  /* i: waiting for end of comment (gzip) */

  var HCRC = 9;
  /* i: waiting for header crc (gzip) */

  var DICTID = 10;
  /* i: waiting for dictionary check value */

  var DICT = 11;
  /* waiting for inflateSetDictionary() call */

  var TYPE = 12;
  /* i: waiting for type bits, including last-flag bit */

  var TYPEDO = 13;
  /* i: same, but skip check to exit inflate on new block */

  var STORED = 14;
  /* i: waiting for stored size (length and complement) */

  var COPY_ = 15;
  /* i/o: same as COPY below, but only first time in */

  var COPY = 16;
  /* i/o: waiting for input or output to copy stored block */

  var TABLE = 17;
  /* i: waiting for dynamic block table lengths */

  var LENLENS = 18;
  /* i: waiting for code length code lengths */

  var CODELENS = 19;
  /* i: waiting for length/lit and distance code lengths */

  var LEN_ = 20;
  /* i: same as LEN below, but only first time in */

  var LEN = 21;
  /* i: waiting for length/lit/eob code */

  var LENEXT = 22;
  /* i: waiting for length extra bits */

  var DIST = 23;
  /* i: waiting for distance code */

  var DISTEXT = 24;
  /* i: waiting for distance extra bits */

  var MATCH = 25;
  /* o: waiting for output space to copy string */

  var LIT = 26;
  /* o: waiting for output space to write literal */

  var CHECK = 27;
  /* i: waiting for 32-bit check value */

  var LENGTH = 28;
  /* i: waiting for 32-bit length (gzip) */

  var DONE = 29;
  /* finished check, done -- remain here until reset */

  var BAD = 30;
  /* got a data error -- remain here until reset */

  var MEM = 31;
  /* got an inflate() memory error -- remain here until reset */

  var SYNC = 32;
  /* looking for synchronization bytes to restart inflate() */

  /* ===========================================================================*/

  var ENOUGH_LENS = 852;
  var ENOUGH_DISTS = 592; //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

  var MAX_WBITS = 15;
  /* 32K LZ77 window */

  var DEF_WBITS = MAX_WBITS;

  function zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
  }

  function InflateState() {
    this.mode = 0;
    /* current inflate mode */

    this.last = false;
    /* true if processing last block */

    this.wrap = 0;
    /* bit 0 true for zlib, bit 1 true for gzip */

    this.havedict = false;
    /* true if dictionary provided */

    this.flags = 0;
    /* gzip header method and flags (0 if zlib) */

    this.dmax = 0;
    /* zlib header max distance (INFLATE_STRICT) */

    this.check = 0;
    /* protected copy of check value */

    this.total = 0;
    /* protected copy of output count */
    // TODO: may be {}

    this.head = null;
    /* where to save gzip header information */

    /* sliding window */

    this.wbits = 0;
    /* log base 2 of requested window size */

    this.wsize = 0;
    /* window size or zero if not using window */

    this.whave = 0;
    /* valid bytes in the window */

    this.wnext = 0;
    /* window write index */

    this.window = null;
    /* allocated sliding window, if needed */

    /* bit accumulator */

    this.hold = 0;
    /* input bit accumulator */

    this.bits = 0;
    /* number of bits in "in" */

    /* for string and stored block copying */

    this.length = 0;
    /* literal or length of data to copy */

    this.offset = 0;
    /* distance back to copy string from */

    /* for table and code decoding */

    this.extra = 0;
    /* extra bits needed */

    /* fixed and dynamic code tables */

    this.lencode = null;
    /* starting table for length/literal codes */

    this.distcode = null;
    /* starting table for distance codes */

    this.lenbits = 0;
    /* index bits for lencode */

    this.distbits = 0;
    /* index bits for distcode */

    /* dynamic table building */

    this.ncode = 0;
    /* number of code length code lengths */

    this.nlen = 0;
    /* number of length code lengths */

    this.ndist = 0;
    /* number of distance code lengths */

    this.have = 0;
    /* number of code lengths in lens[] */

    this.next = null;
    /* next available space in codes[] */

    this.lens = new utils.Buf16(320);
    /* temporary storage for code lengths */

    this.work = new utils.Buf16(288);
    /* work area for code table building */

    /*
     because we don't have pointers in js, we use lencode and distcode directly
     as buffers so we don't need codes
    */
    //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */

    this.lendyn = null;
    /* dynamic table for length/literal codes (JS specific) */

    this.distdyn = null;
    /* dynamic table for distance codes (JS specific) */

    this.sane = 0;
    /* if false, allow invalid distance too far */

    this.back = 0;
    /* bits back of last unprocessed length/lit */

    this.was = 0;
    /* initial length of match */
  }

  function inflateResetKeep(strm) {
    var state;

    if (!strm || !strm.state) {
      return Z_STREAM_ERROR;
    }

    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = '';
    /*Z_NULL*/

    if (state.wrap) {
      /* to support ill-conceived Java test suite */
      strm.adler = state.wrap & 1;
    }

    state.mode = HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null
    /*Z_NULL*/
    ;
    state.hold = 0;
    state.bits = 0; //state.lencode = state.distcode = state.next = state.codes;

    state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
    state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1; //Tracev((stderr, "inflate: reset\n"));

    return Z_OK;
  }

  function inflateReset(strm) {
    var state;

    if (!strm || !strm.state) {
      return Z_STREAM_ERROR;
    }

    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return inflateResetKeep(strm);
  }

  function inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */

    if (!strm || !strm.state) {
      return Z_STREAM_ERROR;
    }

    state = strm.state;
    /* extract wrap request from windowBits parameter */

    if (windowBits < 0) {
      wrap = 0;
      windowBits = -windowBits;
    } else {
      wrap = (windowBits >> 4) + 1;

      if (windowBits < 48) {
        windowBits &= 15;
      }
    }
    /* set number of window bits, free window if different */


    if (windowBits && (windowBits < 8 || windowBits > 15)) {
      return Z_STREAM_ERROR;
    }

    if (state.window !== null && state.wbits !== windowBits) {
      state.window = null;
    }
    /* update state and reset the rest of it */


    state.wrap = wrap;
    state.wbits = windowBits;
    return inflateReset(strm);
  }

  function inflateInit2(strm, windowBits) {
    var ret;
    var state;

    if (!strm) {
      return Z_STREAM_ERROR;
    } //strm.msg = Z_NULL;                 /* in case we return an error */


    state = new InflateState(); //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));

    strm.state = state;
    state.window = null
    /*Z_NULL*/
    ;
    ret = inflateReset2(strm, windowBits);

    if (ret !== Z_OK) {
      strm.state = null
      /*Z_NULL*/
      ;
    }

    return ret;
  }

  function inflateInit(strm) {
    return inflateInit2(strm, DEF_WBITS);
  }
  /*
   Return state with length and distance decoding tables and index sizes set to
   fixed code decoding.  Normally this returns fixed tables from inffixed.h.
   If BUILDFIXED is defined, then instead this routine builds the tables the
   first time it's called, and returns those tables the first time and
   thereafter.  This reduces the size of the code by about 2K bytes, in
   exchange for a little execution time.  However, BUILDFIXED should not be
   used for threaded applications, since the rewriting of the tables and virgin
   may not be thread-safe.
   */


  var virgin = true;
  var lenfix, distfix; // We have no pointers in JS, so keep tables separate

  function fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */
    if (virgin) {
      var sym;
      lenfix = new utils.Buf32(512);
      distfix = new utils.Buf32(32);
      /* literal/length table */

      sym = 0;

      while (sym < 144) {
        state.lens[sym++] = 8;
      }

      while (sym < 256) {
        state.lens[sym++] = 9;
      }

      while (sym < 280) {
        state.lens[sym++] = 7;
      }

      while (sym < 288) {
        state.lens[sym++] = 8;
      }

      inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
        bits: 9
      });
      /* distance table */

      sym = 0;

      while (sym < 32) {
        state.lens[sym++] = 5;
      }

      inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
        bits: 5
      });
      /* do this just once */

      virgin = false;
    }

    state.lencode = lenfix;
    state.lenbits = 9;
    state.distcode = distfix;
    state.distbits = 5;
  }
  /*
   Update the window with the last wsize (normally 32K) bytes written before
   returning.  If window does not exist yet, create it.  This is only called
   when a window is already in use, or when output has been written during this
   inflate call, but the end of the deflate stream has not been reached yet.
   It is also called to create a window for dictionary data when a dictionary
   is loaded.
  
   Providing output buffers larger than 32K to inflate() should provide a speed
   advantage, since only the last 32K of output is copied to the sliding window
   upon return from inflate(), and since all distances after the first 32K of
   output will fall in the output data, making match copies simpler and faster.
   The advantage may be dependent on the size of the processor's data caches.
   */


  function updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */

    if (state.window === null) {
      state.wsize = 1 << state.wbits;
      state.wnext = 0;
      state.whave = 0;
      state.window = new utils.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */


    if (copy >= state.wsize) {
      utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
      state.wnext = 0;
      state.whave = state.wsize;
    } else {
      dist = state.wsize - state.wnext;

      if (dist > copy) {
        dist = copy;
      } //zmemcpy(state->window + state->wnext, end - copy, dist);


      utils.arraySet(state.window, src, end - copy, dist, state.wnext);
      copy -= dist;

      if (copy) {
        //zmemcpy(state->window, end - copy, copy);
        utils.arraySet(state.window, src, end - copy, copy, 0);
        state.wnext = copy;
        state.whave = state.wsize;
      } else {
        state.wnext += dist;

        if (state.wnext === state.wsize) {
          state.wnext = 0;
        }

        if (state.whave < state.wsize) {
          state.whave += dist;
        }
      }
    }

    return 0;
  }

  function inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers

    var next;
    /* next input INDEX */

    var put;
    /* next output INDEX */

    var have, left;
    /* available input and output */

    var hold;
    /* bit buffer */

    var bits;
    /* bits in bit buffer */

    var _in, _out;
    /* save starting available input and output */


    var copy;
    /* number of stored or match bytes to copy */

    var from;
    /* where to copy match bytes from */

    var from_source;
    var here = 0;
    /* current decoding table entry */

    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */

    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)

    var len;
    /* length to copy for repeats, bits to drop */

    var ret;
    /* return code */

    var hbuf = new utils.Buf8(4);
    /* buffer for gzip header crc calculation */

    var opts;
    var n; // temporary var for NEED_BITS

    var order =
    /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) {
      return Z_STREAM_ERROR;
    }

    state = strm.state;

    if (state.mode === TYPE) {
      state.mode = TYPEDO;
    }
    /* skip check */
    //--- LOAD() ---


    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits; //---

    _in = have;
    _out = left;
    ret = Z_OK;

    inf_leave: // goto emulation
    for (;;) {
      switch (state.mode) {
        case HEAD:
          if (state.wrap === 0) {
            state.mode = TYPEDO;
            break;
          } //=== NEEDBITS(16);


          while (bits < 16) {
            if (have === 0) {
              break inf_leave;
            }

            have--;
            hold += input[next++] << bits;
            bits += 8;
          } //===//


          if (state.wrap & 2 && hold === 0x8b1f) {
            /* gzip header */
            state.check = 0
            /*crc32(0L, Z_NULL, 0)*/
            ; //=== CRC2(state.check, hold);

            hbuf[0] = hold & 0xff;
            hbuf[1] = hold >>> 8 & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0); //===//
            //=== INITBITS();

            hold = 0;
            bits = 0; //===//

            state.mode = FLAGS;
            break;
          }

          state.flags = 0;
          /* expect zlib header */

          if (state.head) {
            state.head.done = false;
          }

          if (!(state.wrap & 1) ||
          /* check if zlib header allowed */
          (((hold & 0xff) <<
          /*BITS(8)*/
          8) + (hold >> 8)) % 31) {
            strm.msg = 'incorrect header check';
            state.mode = BAD;
            break;
          }

          if ((hold & 0x0f) !==
          /*BITS(4)*/
          Z_DEFLATED) {
            strm.msg = 'unknown compression method';
            state.mode = BAD;
            break;
          } //--- DROPBITS(4) ---//


          hold >>>= 4;
          bits -= 4; //---//

          len = (hold & 0x0f) +
          /*BITS(4)*/
          8;

          if (state.wbits === 0) {
            state.wbits = len;
          } else if (len > state.wbits) {
            strm.msg = 'invalid window size';
            state.mode = BAD;
            break;
          }

          state.dmax = 1 << len; //Tracev((stderr, "inflate:   zlib header ok\n"));

          strm.adler = state.check = 1
          /*adler32(0L, Z_NULL, 0)*/
          ;
          state.mode = hold & 0x200 ? DICTID : TYPE; //=== INITBITS();

          hold = 0;
          bits = 0; //===//

          break;

        case FLAGS:
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) {
              break inf_leave;
            }

            have--;
            hold += input[next++] << bits;
            bits += 8;
          } //===//


          state.flags = hold;

          if ((state.flags & 0xff) !== Z_DEFLATED) {
            strm.msg = 'unknown compression method';
            state.mode = BAD;
            break;
          }

          if (state.flags & 0xe000) {
            strm.msg = 'unknown header flags set';
            state.mode = BAD;
            break;
          }

          if (state.head) {
            state.head.text = hold >> 8 & 1;
          }

          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = hold >>> 8 & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0); //===//
          } //=== INITBITS();


          hold = 0;
          bits = 0; //===//

          state.mode = TIME;

        /* falls through */

        case TIME:
          //=== NEEDBITS(32); */
          while (bits < 32) {
            if (have === 0) {
              break inf_leave;
            }

            have--;
            hold += input[next++] << bits;
            bits += 8;
          } //===//


          if (state.head) {
            state.head.time = hold;
          }

          if (state.flags & 0x0200) {
            //=== CRC4(state.check, hold)
            hbuf[0] = hold & 0xff;
            hbuf[1] = hold >>> 8 & 0xff;
            hbuf[2] = hold >>> 16 & 0xff;
            hbuf[3] = hold >>> 24 & 0xff;
            state.check = crc32(state.check, hbuf, 4, 0); //===
          } //=== INITBITS();


          hold = 0;
          bits = 0; //===//

          state.mode = OS;

        /* falls through */

        case OS:
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) {
              break inf_leave;
            }

            have--;
            hold += input[next++] << bits;
            bits += 8;
          } //===//


          if (state.head) {
            state.head.xflags = hold & 0xff;
            state.head.os = hold >> 8;
          }

          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = hold >>> 8 & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0); //===//
          } //=== INITBITS();


          hold = 0;
          bits = 0; //===//

          state.mode = EXLEN;

        /* falls through */

        case EXLEN:
          if (state.flags & 0x0400) {
            //=== NEEDBITS(16); */
            while (bits < 16) {
              if (have === 0) {
                break inf_leave;
              }

              have--;
              hold += input[next++] << bits;
              bits += 8;
            } //===//


            state.length = hold;

            if (state.head) {
              state.head.extra_len = hold;
            }

            if (state.flags & 0x0200) {
              //=== CRC2(state.check, hold);
              hbuf[0] = hold & 0xff;
              hbuf[1] = hold >>> 8 & 0xff;
              state.check = crc32(state.check, hbuf, 2, 0); //===//
            } //=== INITBITS();


            hold = 0;
            bits = 0; //===//
          } else if (state.head) {
            state.head.extra = null
            /*Z_NULL*/
            ;
          }

          state.mode = EXTRA;

        /* falls through */

        case EXTRA:
          if (state.flags & 0x0400) {
            copy = state.length;

            if (copy > have) {
              copy = have;
            }

            if (copy) {
              if (state.head) {
                len = state.head.extra_len - state.length;

                if (!state.head.extra) {
                  // Use untyped array for more convenient processing later
                  state.head.extra = new Array(state.head.extra_len);
                }

                utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len); //zmemcpy(state.head.extra + len, next,
                //        len + copy > state.head.extra_max ?
                //        state.head.extra_max - len : copy);
              }

              if (state.flags & 0x0200) {
                state.check = crc32(state.check, input, copy, next);
              }

              have -= copy;
              next += copy;
              state.length -= copy;
            }

            if (state.length) {
              break inf_leave;
            }
          }

          state.length = 0;
          state.mode = NAME;

        /* falls through */

        case NAME:
          if (state.flags & 0x0800) {
            if (have === 0) {
              break inf_leave;
            }

            copy = 0;

            do {
              // TODO: 2 or 1 bytes?
              len = input[next + copy++];
              /* use constant limit because in js we should not preallocate memory */

              if (state.head && len && state.length < 65536
              /*state.head.name_max*/
              ) {
                state.head.name += String.fromCharCode(len);
              }
            } while (len && copy < have);

            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }

            have -= copy;
            next += copy;

            if (len) {
              break inf_leave;
            }
          } else if (state.head) {
            state.head.name = null;
          }

          state.length = 0;
          state.mode = COMMENT;

        /* falls through */

        case COMMENT:
          if (state.flags & 0x1000) {
            if (have === 0) {
              break inf_leave;
            }

            copy = 0;

            do {
              len = input[next + copy++];
              /* use constant limit because in js we should not preallocate memory */

              if (state.head && len && state.length < 65536
              /*state.head.comm_max*/
              ) {
                state.head.comment += String.fromCharCode(len);
              }
            } while (len && copy < have);

            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }

            have -= copy;
            next += copy;

            if (len) {
              break inf_leave;
            }
          } else if (state.head) {
            state.head.comment = null;
          }

          state.mode = HCRC;

        /* falls through */

        case HCRC:
          if (state.flags & 0x0200) {
            //=== NEEDBITS(16); */
            while (bits < 16) {
              if (have === 0) {
                break inf_leave;
              }

              have--;
              hold += input[next++] << bits;
              bits += 8;
            } //===//


            if (hold !== (state.check & 0xffff)) {
              strm.msg = 'header crc mismatch';
              state.mode = BAD;
              break;
            } //=== INITBITS();


            hold = 0;
            bits = 0; //===//
          }

          if (state.head) {
            state.head.hcrc = state.flags >> 9 & 1;
            state.head.done = true;
          }

          strm.adler = state.check = 0;
          state.mode = TYPE;
          break;

        case DICTID:
          //=== NEEDBITS(32); */
          while (bits < 32) {
            if (have === 0) {
              break inf_leave;
            }

            have--;
            hold += input[next++] << bits;
            bits += 8;
          } //===//


          strm.adler = state.check = zswap32(hold); //=== INITBITS();

          hold = 0;
          bits = 0; //===//

          state.mode = DICT;

        /* falls through */

        case DICT:
          if (state.havedict === 0) {
            //--- RESTORE() ---
            strm.next_out = put;
            strm.avail_out = left;
            strm.next_in = next;
            strm.avail_in = have;
            state.hold = hold;
            state.bits = bits; //---

            return Z_NEED_DICT;
          }

          strm.adler = state.check = 1
          /*adler32(0L, Z_NULL, 0)*/
          ;
          state.mode = TYPE;

        /* falls through */

        case TYPE:
          if (flush === Z_BLOCK || flush === Z_TREES) {
            break inf_leave;
          }

        /* falls through */

        case TYPEDO:
          if (state.last) {
            //--- BYTEBITS() ---//
            hold >>>= bits & 7;
            bits -= bits & 7; //---//

            state.mode = CHECK;
            break;
          } //=== NEEDBITS(3); */


          while (bits < 3) {
            if (have === 0) {
              break inf_leave;
            }

            have--;
            hold += input[next++] << bits;
            bits += 8;
          } //===//


          state.last = hold & 0x01
          /*BITS(1)*/
          ; //--- DROPBITS(1) ---//

          hold >>>= 1;
          bits -= 1; //---//

          switch (hold & 0x03) {
            /*BITS(2)*/
            case 0:
              /* stored block */
              //Tracev((stderr, "inflate:     stored block%s\n",
              //        state.last ? " (last)" : ""));
              state.mode = STORED;
              break;

            case 1:
              /* fixed block */
              fixedtables(state); //Tracev((stderr, "inflate:     fixed codes block%s\n",
              //        state.last ? " (last)" : ""));

              state.mode = LEN_;
              /* decode codes */

              if (flush === Z_TREES) {
                //--- DROPBITS(2) ---//
                hold >>>= 2;
                bits -= 2; //---//

                break inf_leave;
              }

              break;

            case 2:
              /* dynamic block */
              //Tracev((stderr, "inflate:     dynamic codes block%s\n",
              //        state.last ? " (last)" : ""));
              state.mode = TABLE;
              break;

            case 3:
              strm.msg = 'invalid block type';
              state.mode = BAD;
          } //--- DROPBITS(2) ---//


          hold >>>= 2;
          bits -= 2; //---//

          break;

        case STORED:
          //--- BYTEBITS() ---// /* go to byte boundary */
          hold >>>= bits & 7;
          bits -= bits & 7; //---//
          //=== NEEDBITS(32); */

          while (bits < 32) {
            if (have === 0) {
              break inf_leave;
            }

            have--;
            hold += input[next++] << bits;
            bits += 8;
          } //===//


          if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
            strm.msg = 'invalid stored block lengths';
            state.mode = BAD;
            break;
          }

          state.length = hold & 0xffff; //Tracev((stderr, "inflate:       stored length %u\n",
          //        state.length));
          //=== INITBITS();

          hold = 0;
          bits = 0; //===//

          state.mode = COPY_;

          if (flush === Z_TREES) {
            break inf_leave;
          }

        /* falls through */

        case COPY_:
          state.mode = COPY;

        /* falls through */

        case COPY:
          copy = state.length;

          if (copy) {
            if (copy > have) {
              copy = have;
            }

            if (copy > left) {
              copy = left;
            }

            if (copy === 0) {
              break inf_leave;
            } //--- zmemcpy(put, next, copy); ---


            utils.arraySet(output, input, next, copy, put); //---//

            have -= copy;
            next += copy;
            left -= copy;
            put += copy;
            state.length -= copy;
            break;
          } //Tracev((stderr, "inflate:       stored end\n"));


          state.mode = TYPE;
          break;

        case TABLE:
          //=== NEEDBITS(14); */
          while (bits < 14) {
            if (have === 0) {
              break inf_leave;
            }

            have--;
            hold += input[next++] << bits;
            bits += 8;
          } //===//


          state.nlen = (hold & 0x1f) +
          /*BITS(5)*/
          257; //--- DROPBITS(5) ---//

          hold >>>= 5;
          bits -= 5; //---//

          state.ndist = (hold & 0x1f) +
          /*BITS(5)*/
          1; //--- DROPBITS(5) ---//

          hold >>>= 5;
          bits -= 5; //---//

          state.ncode = (hold & 0x0f) +
          /*BITS(4)*/
          4; //--- DROPBITS(4) ---//

          hold >>>= 4;
          bits -= 4; //---//
          //#ifndef PKZIP_BUG_WORKAROUND

          if (state.nlen > 286 || state.ndist > 30) {
            strm.msg = 'too many length or distance symbols';
            state.mode = BAD;
            break;
          } //#endif
          //Tracev((stderr, "inflate:       table sizes ok\n"));


          state.have = 0;
          state.mode = LENLENS;

        /* falls through */

        case LENLENS:
          while (state.have < state.ncode) {
            //=== NEEDBITS(3);
            while (bits < 3) {
              if (have === 0) {
                break inf_leave;
              }

              have--;
              hold += input[next++] << bits;
              bits += 8;
            } //===//


            state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
            //--- DROPBITS(3) ---//

            hold >>>= 3;
            bits -= 3; //---//
          }

          while (state.have < 19) {
            state.lens[order[state.have++]] = 0;
          } // We have separate tables & no pointers. 2 commented lines below not needed.
          //state.next = state.codes;
          //state.lencode = state.next;
          // Switch to use dynamic table


          state.lencode = state.lendyn;
          state.lenbits = 7;
          opts = {
            bits: state.lenbits
          };
          ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
          state.lenbits = opts.bits;

          if (ret) {
            strm.msg = 'invalid code lengths set';
            state.mode = BAD;
            break;
          } //Tracev((stderr, "inflate:       code lengths ok\n"));


          state.have = 0;
          state.mode = CODELENS;

        /* falls through */

        case CODELENS:
          while (state.have < state.nlen + state.ndist) {
            for (;;) {
              here = state.lencode[hold & (1 << state.lenbits) - 1];
              /*BITS(state.lenbits)*/

              here_bits = here >>> 24;
              here_op = here >>> 16 & 0xff;
              here_val = here & 0xffff;

              if (here_bits <= bits) {
                break;
              } //--- PULLBYTE() ---//


              if (have === 0) {
                break inf_leave;
              }

              have--;
              hold += input[next++] << bits;
              bits += 8; //---//
            }

            if (here_val < 16) {
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits; //---//

              state.lens[state.have++] = here_val;
            } else {
              if (here_val === 16) {
                //=== NEEDBITS(here.bits + 2);
                n = here_bits + 2;

                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                } //===//
                //--- DROPBITS(here.bits) ---//


                hold >>>= here_bits;
                bits -= here_bits; //---//

                if (state.have === 0) {
                  strm.msg = 'invalid bit length repeat';
                  state.mode = BAD;
                  break;
                }

                len = state.lens[state.have - 1];
                copy = 3 + (hold & 0x03); //BITS(2);
                //--- DROPBITS(2) ---//

                hold >>>= 2;
                bits -= 2; //---//
              } else if (here_val === 17) {
                //=== NEEDBITS(here.bits + 3);
                n = here_bits + 3;

                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                } //===//
                //--- DROPBITS(here.bits) ---//


                hold >>>= here_bits;
                bits -= here_bits; //---//

                len = 0;
                copy = 3 + (hold & 0x07); //BITS(3);
                //--- DROPBITS(3) ---//

                hold >>>= 3;
                bits -= 3; //---//
              } else {
                //=== NEEDBITS(here.bits + 7);
                n = here_bits + 7;

                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                } //===//
                //--- DROPBITS(here.bits) ---//


                hold >>>= here_bits;
                bits -= here_bits; //---//

                len = 0;
                copy = 11 + (hold & 0x7f); //BITS(7);
                //--- DROPBITS(7) ---//

                hold >>>= 7;
                bits -= 7; //---//
              }

              if (state.have + copy > state.nlen + state.ndist) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }

              while (copy--) {
                state.lens[state.have++] = len;
              }
            }
          }
          /* handle error breaks in while */


          if (state.mode === BAD) {
            break;
          }
          /* check for end-of-block code (better have one) */


          if (state.lens[256] === 0) {
            strm.msg = 'invalid code -- missing end-of-block';
            state.mode = BAD;
            break;
          }
          /* build code tables -- note: do not change the lenbits or distbits
             values here (9 and 6) without reading the comments in inftrees.h
             concerning the ENOUGH constants, which depend on those values */


          state.lenbits = 9;
          opts = {
            bits: state.lenbits
          };
          ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts); // We have separate tables & no pointers. 2 commented lines below not needed.
          // state.next_index = opts.table_index;

          state.lenbits = opts.bits; // state.lencode = state.next;

          if (ret) {
            strm.msg = 'invalid literal/lengths set';
            state.mode = BAD;
            break;
          }

          state.distbits = 6; //state.distcode.copy(state.codes);
          // Switch to use dynamic table

          state.distcode = state.distdyn;
          opts = {
            bits: state.distbits
          };
          ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts); // We have separate tables & no pointers. 2 commented lines below not needed.
          // state.next_index = opts.table_index;

          state.distbits = opts.bits; // state.distcode = state.next;

          if (ret) {
            strm.msg = 'invalid distances set';
            state.mode = BAD;
            break;
          } //Tracev((stderr, 'inflate:       codes ok\n'));


          state.mode = LEN_;

          if (flush === Z_TREES) {
            break inf_leave;
          }

        /* falls through */

        case LEN_:
          state.mode = LEN;

        /* falls through */

        case LEN:
          if (have >= 6 && left >= 258) {
            //--- RESTORE() ---
            strm.next_out = put;
            strm.avail_out = left;
            strm.next_in = next;
            strm.avail_in = have;
            state.hold = hold;
            state.bits = bits; //---

            inflate_fast(strm, _out); //--- LOAD() ---

            put = strm.next_out;
            output = strm.output;
            left = strm.avail_out;
            next = strm.next_in;
            input = strm.input;
            have = strm.avail_in;
            hold = state.hold;
            bits = state.bits; //---

            if (state.mode === TYPE) {
              state.back = -1;
            }

            break;
          }

          state.back = 0;

          for (;;) {
            here = state.lencode[hold & (1 << state.lenbits) - 1];
            /*BITS(state.lenbits)*/

            here_bits = here >>> 24;
            here_op = here >>> 16 & 0xff;
            here_val = here & 0xffff;

            if (here_bits <= bits) {
              break;
            } //--- PULLBYTE() ---//


            if (have === 0) {
              break inf_leave;
            }

            have--;
            hold += input[next++] << bits;
            bits += 8; //---//
          }

          if (here_op && (here_op & 0xf0) === 0) {
            last_bits = here_bits;
            last_op = here_op;
            last_val = here_val;

            for (;;) {
              here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >>
              /*BITS(last.bits + last.op)*/
              last_bits)];
              here_bits = here >>> 24;
              here_op = here >>> 16 & 0xff;
              here_val = here & 0xffff;

              if (last_bits + here_bits <= bits) {
                break;
              } //--- PULLBYTE() ---//


              if (have === 0) {
                break inf_leave;
              }

              have--;
              hold += input[next++] << bits;
              bits += 8; //---//
            } //--- DROPBITS(last.bits) ---//


            hold >>>= last_bits;
            bits -= last_bits; //---//

            state.back += last_bits;
          } //--- DROPBITS(here.bits) ---//


          hold >>>= here_bits;
          bits -= here_bits; //---//

          state.back += here_bits;
          state.length = here_val;

          if (here_op === 0) {
            //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            state.mode = LIT;
            break;
          }

          if (here_op & 32) {
            //Tracevv((stderr, "inflate:         end of block\n"));
            state.back = -1;
            state.mode = TYPE;
            break;
          }

          if (here_op & 64) {
            strm.msg = 'invalid literal/length code';
            state.mode = BAD;
            break;
          }

          state.extra = here_op & 15;
          state.mode = LENEXT;

        /* falls through */

        case LENEXT:
          if (state.extra) {
            //=== NEEDBITS(state.extra);
            n = state.extra;

            while (bits < n) {
              if (have === 0) {
                break inf_leave;
              }

              have--;
              hold += input[next++] << bits;
              bits += 8;
            } //===//


            state.length += hold & (1 << state.extra) - 1
            /*BITS(state.extra)*/
            ; //--- DROPBITS(state.extra) ---//

            hold >>>= state.extra;
            bits -= state.extra; //---//

            state.back += state.extra;
          } //Tracevv((stderr, "inflate:         length %u\n", state.length));


          state.was = state.length;
          state.mode = DIST;

        /* falls through */

        case DIST:
          for (;;) {
            here = state.distcode[hold & (1 << state.distbits) - 1];
            /*BITS(state.distbits)*/

            here_bits = here >>> 24;
            here_op = here >>> 16 & 0xff;
            here_val = here & 0xffff;

            if (here_bits <= bits) {
              break;
            } //--- PULLBYTE() ---//


            if (have === 0) {
              break inf_leave;
            }

            have--;
            hold += input[next++] << bits;
            bits += 8; //---//
          }

          if ((here_op & 0xf0) === 0) {
            last_bits = here_bits;
            last_op = here_op;
            last_val = here_val;

            for (;;) {
              here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >>
              /*BITS(last.bits + last.op)*/
              last_bits)];
              here_bits = here >>> 24;
              here_op = here >>> 16 & 0xff;
              here_val = here & 0xffff;

              if (last_bits + here_bits <= bits) {
                break;
              } //--- PULLBYTE() ---//


              if (have === 0) {
                break inf_leave;
              }

              have--;
              hold += input[next++] << bits;
              bits += 8; //---//
            } //--- DROPBITS(last.bits) ---//


            hold >>>= last_bits;
            bits -= last_bits; //---//

            state.back += last_bits;
          } //--- DROPBITS(here.bits) ---//


          hold >>>= here_bits;
          bits -= here_bits; //---//

          state.back += here_bits;

          if (here_op & 64) {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break;
          }

          state.offset = here_val;
          state.extra = here_op & 15;
          state.mode = DISTEXT;

        /* falls through */

        case DISTEXT:
          if (state.extra) {
            //=== NEEDBITS(state.extra);
            n = state.extra;

            while (bits < n) {
              if (have === 0) {
                break inf_leave;
              }

              have--;
              hold += input[next++] << bits;
              bits += 8;
            } //===//


            state.offset += hold & (1 << state.extra) - 1
            /*BITS(state.extra)*/
            ; //--- DROPBITS(state.extra) ---//

            hold >>>= state.extra;
            bits -= state.extra; //---//

            state.back += state.extra;
          } //#ifdef INFLATE_STRICT


          if (state.offset > state.dmax) {
            strm.msg = 'invalid distance too far back';
            state.mode = BAD;
            break;
          } //#endif
          //Tracevv((stderr, "inflate:         distance %u\n", state.offset));


          state.mode = MATCH;

        /* falls through */

        case MATCH:
          if (left === 0) {
            break inf_leave;
          }

          copy = _out - left;

          if (state.offset > copy) {
            /* copy from window */
            copy = state.offset - copy;

            if (copy > state.whave) {
              if (state.sane) {
                strm.msg = 'invalid distance too far back';
                state.mode = BAD;
                break;
              } // (!) This block is disabled in zlib defaults,
              // don't enable it for binary compatibility
              //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
              //          Trace((stderr, "inflate.c too far\n"));
              //          copy -= state.whave;
              //          if (copy > state.length) { copy = state.length; }
              //          if (copy > left) { copy = left; }
              //          left -= copy;
              //          state.length -= copy;
              //          do {
              //            output[put++] = 0;
              //          } while (--copy);
              //          if (state.length === 0) { state.mode = LEN; }
              //          break;
              //#endif

            }

            if (copy > state.wnext) {
              copy -= state.wnext;
              from = state.wsize - copy;
            } else {
              from = state.wnext - copy;
            }

            if (copy > state.length) {
              copy = state.length;
            }

            from_source = state.window;
          } else {
            /* copy from output */
            from_source = output;
            from = put - state.offset;
            copy = state.length;
          }

          if (copy > left) {
            copy = left;
          }

          left -= copy;
          state.length -= copy;

          do {
            output[put++] = from_source[from++];
          } while (--copy);

          if (state.length === 0) {
            state.mode = LEN;
          }

          break;

        case LIT:
          if (left === 0) {
            break inf_leave;
          }

          output[put++] = state.length;
          left--;
          state.mode = LEN;
          break;

        case CHECK:
          if (state.wrap) {
            //=== NEEDBITS(32);
            while (bits < 32) {
              if (have === 0) {
                break inf_leave;
              }

              have--; // Use '|' instead of '+' to make sure that result is signed

              hold |= input[next++] << bits;
              bits += 8;
            } //===//


            _out -= left;
            strm.total_out += _out;
            state.total += _out;

            if (_out) {
              strm.adler = state.check =
              /*UPDATE(state.check, put - _out, _out);*/
              state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
            }

            _out = left; // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too

            if ((state.flags ? hold : zswap32(hold)) !== state.check) {
              strm.msg = 'incorrect data check';
              state.mode = BAD;
              break;
            } //=== INITBITS();


            hold = 0;
            bits = 0; //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
          }

          state.mode = LENGTH;

        /* falls through */

        case LENGTH:
          if (state.wrap && state.flags) {
            //=== NEEDBITS(32);
            while (bits < 32) {
              if (have === 0) {
                break inf_leave;
              }

              have--;
              hold += input[next++] << bits;
              bits += 8;
            } //===//


            if (hold !== (state.total & 0xffffffff)) {
              strm.msg = 'incorrect length check';
              state.mode = BAD;
              break;
            } //=== INITBITS();


            hold = 0;
            bits = 0; //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
          }

          state.mode = DONE;

        /* falls through */

        case DONE:
          ret = Z_STREAM_END;
          break inf_leave;

        case BAD:
          ret = Z_DATA_ERROR;
          break inf_leave;

        case MEM:
          return Z_MEM_ERROR;

        case SYNC:
        /* falls through */

        default:
          return Z_STREAM_ERROR;
      }
    } // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

    /*
       Return from inflate(), updating the total counts and the check value.
       If there was no progress during the inflate() call, return a buffer
       error.  Call updatewindow() to create and/or update the window state.
       Note: a memory error from inflate() is non-recoverable.
     */
    //--- RESTORE() ---


    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits; //---

    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
      if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
        state.mode = MEM;
        return Z_MEM_ERROR;
      }
    }

    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;

    if (state.wrap && _out) {
      strm.adler = state.check =
      /*UPDATE(state.check, strm.next_out - _out, _out);*/
      state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
    }

    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);

    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) {
      ret = Z_BUF_ERROR;
    }

    return ret;
  }

  function inflateEnd(strm) {
    if (!strm || !strm.state
    /*|| strm->zfree == (free_func)0*/
    ) {
        return Z_STREAM_ERROR;
      }

    var state = strm.state;

    if (state.window) {
      state.window = null;
    }

    strm.state = null;
    return Z_OK;
  }

  function inflateGetHeader(strm, head) {
    var state;
    /* check state */

    if (!strm || !strm.state) {
      return Z_STREAM_ERROR;
    }

    state = strm.state;

    if ((state.wrap & 2) === 0) {
      return Z_STREAM_ERROR;
    }
    /* save header structure */


    state.head = head;
    head.done = false;
    return Z_OK;
  }

  function inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */

    if (!strm
    /* == Z_NULL */
    || !strm.state
    /* == Z_NULL */
    ) {
        return Z_STREAM_ERROR;
      }

    state = strm.state;

    if (state.wrap !== 0 && state.mode !== DICT) {
      return Z_STREAM_ERROR;
    }
    /* check for correct dictionary identifier */


    if (state.mode === DICT) {
      dictid = 1;
      /* adler32(0, null, 0)*/

      /* dictid = adler32(dictid, dictionary, dictLength); */

      dictid = adler32(dictid, dictionary, dictLength, 0);

      if (dictid !== state.check) {
        return Z_DATA_ERROR;
      }
    }
    /* copy dictionary to window using updatewindow(), which will amend the
     existing dictionary if appropriate */


    ret = updatewindow(strm, dictionary, dictLength, dictLength);

    if (ret) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }

    state.havedict = 1; // Tracev((stderr, "inflate:   dictionary set\n"));

    return Z_OK;
  }

  exports.inflateReset = inflateReset;
  exports.inflateReset2 = inflateReset2;
  exports.inflateResetKeep = inflateResetKeep;
  exports.inflateInit = inflateInit;
  exports.inflateInit2 = inflateInit2;
  exports.inflate = inflate;
  exports.inflateEnd = inflateEnd;
  exports.inflateGetHeader = inflateGetHeader;
  exports.inflateSetDictionary = inflateSetDictionary;
  exports.inflateInfo = 'pako inflate (from Nodeca project)';
  /* Not implemented
  exports.inflateCopy = inflateCopy;
  exports.inflateGetDictionary = inflateGetDictionary;
  exports.inflateMark = inflateMark;
  exports.inflatePrime = inflatePrime;
  exports.inflateSync = inflateSync;
  exports.inflateSyncPoint = inflateSyncPoint;
  exports.inflateUndermine = inflateUndermine;
  */

  /***/
},
/* 578 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // (C) 1995-2013 Jean-loup Gailly and Mark Adler
  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
  //
  // This software is provided 'as-is', without any express or implied
  // warranty. In no event will the authors be held liable for any damages
  // arising from the use of this software.
  //
  // Permission is granted to anyone to use this software for any purpose,
  // including commercial applications, and to alter it and redistribute it
  // freely, subject to the following restrictions:
  //
  // 1. The origin of this software must not be misrepresented; you must not
  //   claim that you wrote the original software. If you use this software
  //   in a product, an acknowledgment in the product documentation would be
  //   appreciated but is not required.
  // 2. Altered source versions must be plainly marked as such, and must not be
  //   misrepresented as being the original software.
  // 3. This notice may not be removed or altered from any source distribution.

  var utils = __webpack_require__(107);

  var MAXBITS = 15;
  var ENOUGH_LENS = 852;
  var ENOUGH_DISTS = 592; //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

  var CODES = 0;
  var LENS = 1;
  var DISTS = 2;
  var lbase = [
  /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0];
  var lext = [
  /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78];
  var dbase = [
  /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0];
  var dext = [
  /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];

  module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits; //here = opts.here; /* table entry for duplication */

    var len = 0;
    /* a code's length in bits */

    var sym = 0;
    /* index of code symbols */

    var min = 0,
        max = 0;
    /* minimum and maximum code lengths */

    var root = 0;
    /* number of index bits for root table */

    var curr = 0;
    /* number of index bits for current table */

    var drop = 0;
    /* code bits to drop for sub-table */

    var left = 0;
    /* number of prefix codes available */

    var used = 0;
    /* code entries in table used */

    var huff = 0;
    /* Huffman code */

    var incr;
    /* for incrementing code, index */

    var fill;
    /* index for replicating entries */

    var low;
    /* low bits for current root entry */

    var mask;
    /* mask for low root bits */

    var next;
    /* next available space in table */

    var base = null;
    /* base value table to use */

    var base_index = 0; //  var shoextra;    /* extra bits table to use */

    var end;
    /* use base and extra for symbol > end */

    var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */

    var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */

    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
     Process a set of code lengths to create a canonical Huffman code.  The
     code lengths are lens[0..codes-1].  Each length corresponds to the
     symbols 0..codes-1.  The Huffman code is generated by first sorting the
     symbols by length from short to long, and retaining the symbol order
     for codes with equal lengths.  Then the code starts with all zero bits
     for the first code of the shortest length, and the codes are integer
     increments for the same length, and zeros are appended as the length
     increases.  For the deflate format, these bits are stored backwards
     from their more natural integer increment ordering, and so when the
     decoding tables are built in the large loop below, the integer codes
     are incremented backwards.
      This routine assumes, but does not check, that all of the entries in
     lens[] are in the range 0..MAXBITS.  The caller must assure this.
     1..MAXBITS is interpreted as that code length.  zero means that that
     symbol does not occur in this code.
      The codes are sorted by computing a count of codes for each length,
     creating from that a table of starting indices for each length in the
     sorted table, and then entering the symbols in order in the sorted
     table.  The sorted table is work[], with that space being provided by
     the caller.
      The length counts are used for other purposes as well, i.e. finding
     the minimum and maximum length codes, determining if there are any
     codes at all, checking for a valid set of lengths, and looking ahead
     at length counts to determine sub-table sizes when building the
     decoding tables.
     */

    /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */

    for (len = 0; len <= MAXBITS; len++) {
      count[len] = 0;
    }

    for (sym = 0; sym < codes; sym++) {
      count[lens[lens_index + sym]]++;
    }
    /* bound code lengths, force root to be within code lengths */


    root = bits;

    for (max = MAXBITS; max >= 1; max--) {
      if (count[max] !== 0) {
        break;
      }
    }

    if (root > max) {
      root = max;
    }

    if (max === 0) {
      /* no symbols to code at all */
      //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
      //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
      //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
      table[table_index++] = 1 << 24 | 64 << 16 | 0; //table.op[opts.table_index] = 64;
      //table.bits[opts.table_index] = 1;
      //table.val[opts.table_index++] = 0;

      table[table_index++] = 1 << 24 | 64 << 16 | 0;
      opts.bits = 1;
      return 0;
      /* no symbols, but wait for decoding to report error */
    }

    for (min = 1; min < max; min++) {
      if (count[min] !== 0) {
        break;
      }
    }

    if (root < min) {
      root = min;
    }
    /* check for an over-subscribed or incomplete set of lengths */


    left = 1;

    for (len = 1; len <= MAXBITS; len++) {
      left <<= 1;
      left -= count[len];

      if (left < 0) {
        return -1;
      }
      /* over-subscribed */

    }

    if (left > 0 && (type === CODES || max !== 1)) {
      return -1;
      /* incomplete set */
    }
    /* generate offsets into symbol table for each length for sorting */


    offs[1] = 0;

    for (len = 1; len < MAXBITS; len++) {
      offs[len + 1] = offs[len] + count[len];
    }
    /* sort symbols by length, by symbol order within each length */


    for (sym = 0; sym < codes; sym++) {
      if (lens[lens_index + sym] !== 0) {
        work[offs[lens[lens_index + sym]]++] = sym;
      }
    }
    /*
     Create and fill in decoding tables.  In this loop, the table being
     filled is at next and has curr index bits.  The code being used is huff
     with length len.  That code is converted to an index by dropping drop
     bits off of the bottom.  For codes where len is less than drop + curr,
     those top drop + curr - len bits are incremented through all values to
     fill the table with replicated entries.
      root is the number of index bits for the root table.  When len exceeds
     root, sub-tables are created pointed to by the root entry with an index
     of the low root bits of huff.  This is saved in low to check for when a
     new sub-table should be started.  drop is zero when the root table is
     being filled, and drop is root when sub-tables are being filled.
      When a new sub-table is needed, it is necessary to look ahead in the
     code lengths to determine what size sub-table is needed.  The length
     counts are used for this, and so count[] is decremented as codes are
     entered in the tables.
      used keeps track of how many table entries have been allocated from the
     provided *table space.  It is checked for LENS and DIST tables against
     the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
     the initial root table size constants.  See the comments in inftrees.h
     for more information.
      sym increments through all symbols, and the loop terminates when
     all codes of length max, i.e. all codes, have been processed.  This
     routine permits incomplete codes, so another loop after this one fills
     in the rest of the decoding tables with invalid code markers.
     */

    /* set up for code type */
    // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8


    if (type === CODES) {
      base = extra = work;
      /* dummy value--not used */

      end = 19;
    } else if (type === LENS) {
      base = lbase;
      base_index -= 257;
      extra = lext;
      extra_index -= 257;
      end = 256;
    } else {
      /* DISTS */
      base = dbase;
      extra = dext;
      end = -1;
    }
    /* initialize opts for loop */


    huff = 0;
    /* starting code */

    sym = 0;
    /* starting code symbol */

    len = min;
    /* starting code length */

    next = table_index;
    /* current table to fill in */

    curr = root;
    /* current table index bits */

    drop = 0;
    /* current bits to drop from code for index */

    low = -1;
    /* trigger new sub-table when len > root */

    used = 1 << root;
    /* use root table entries */

    mask = used - 1;
    /* mask for comparing low */

    /* check available table space */

    if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
      return 1;
    }
    /* process all codes and make table entries */


    for (;;) {
      /* create table entry */
      here_bits = len - drop;

      if (work[sym] < end) {
        here_op = 0;
        here_val = work[sym];
      } else if (work[sym] > end) {
        here_op = extra[extra_index + work[sym]];
        here_val = base[base_index + work[sym]];
      } else {
        here_op = 32 + 64;
        /* end of block */

        here_val = 0;
      }
      /* replicate for those indices with low len bits equal to huff */


      incr = 1 << len - drop;
      fill = 1 << curr;
      min = fill;
      /* save offset to next table */

      do {
        fill -= incr;
        table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
      } while (fill !== 0);
      /* backwards increment the len-bit code huff */


      incr = 1 << len - 1;

      while (huff & incr) {
        incr >>= 1;
      }

      if (incr !== 0) {
        huff &= incr - 1;
        huff += incr;
      } else {
        huff = 0;
      }
      /* go to next symbol, update count, len */


      sym++;

      if (--count[len] === 0) {
        if (len === max) {
          break;
        }

        len = lens[lens_index + work[sym]];
      }
      /* create new sub-table if needed */


      if (len > root && (huff & mask) !== low) {
        /* if first time, transition to sub-tables */
        if (drop === 0) {
          drop = root;
        }
        /* increment past last table */


        next += min;
        /* here min is 1 << curr */

        /* determine length of next table */

        curr = len - drop;
        left = 1 << curr;

        while (curr + drop < max) {
          left -= count[curr + drop];

          if (left <= 0) {
            break;
          }

          curr++;
          left <<= 1;
        }
        /* check for enough space */


        used += 1 << curr;

        if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
          return 1;
        }
        /* point entry in root table to sub-table */


        low = huff & mask;
        /*table.op[low] = curr;
        table.bits[low] = root;
        table.val[low] = next - opts.table_index;*/

        table[low] = root << 24 | curr << 16 | next - table_index | 0;
      }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
     at most one remaining entry, since if the code is incomplete, the
     maximum code length that was allowed to get this far is one bit) */


    if (huff !== 0) {
      //table.op[next + huff] = 64;            /* invalid code marker */
      //table.bits[next + huff] = len - drop;
      //table.val[next + huff] = 0;
      table[next + huff] = len - drop << 24 | 64 << 16 | 0;
    }
    /* set return parameters */
    //opts.table_index += used;


    opts.bits = root;
    return 0;
  };
  /***/

},
/* 579 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // (C) 1995-2013 Jean-loup Gailly and Mark Adler
  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
  //
  // This software is provided 'as-is', without any express or implied
  // warranty. In no event will the authors be held liable for any damages
  // arising from the use of this software.
  //
  // Permission is granted to anyone to use this software for any purpose,
  // including commercial applications, and to alter it and redistribute it
  // freely, subject to the following restrictions:
  //
  // 1. The origin of this software must not be misrepresented; you must not
  //   claim that you wrote the original software. If you use this software
  //   in a product, an acknowledgment in the product documentation would be
  //   appreciated but is not required.
  // 2. Altered source versions must be plainly marked as such, and must not be
  //   misrepresented as being the original software.
  // 3. This notice may not be removed or altered from any source distribution.

  module.exports = {
    2: 'need dictionary',

    /* Z_NEED_DICT       2  */
    1: 'stream end',

    /* Z_STREAM_END      1  */
    0: '',

    /* Z_OK              0  */
    '-1': 'file error',

    /* Z_ERRNO         (-1) */
    '-2': 'stream error',

    /* Z_STREAM_ERROR  (-2) */
    '-3': 'data error',

    /* Z_DATA_ERROR    (-3) */
    '-4': 'insufficient memory',

    /* Z_MEM_ERROR     (-4) */
    '-5': 'buffer error',

    /* Z_BUF_ERROR     (-5) */
    '-6': 'incompatible version'
    /* Z_VERSION_ERROR (-6) */

  };
  /***/
},
/* 580 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // (C) 1995-2013 Jean-loup Gailly and Mark Adler
  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
  //
  // This software is provided 'as-is', without any express or implied
  // warranty. In no event will the authors be held liable for any damages
  // arising from the use of this software.
  //
  // Permission is granted to anyone to use this software for any purpose,
  // including commercial applications, and to alter it and redistribute it
  // freely, subject to the following restrictions:
  //
  // 1. The origin of this software must not be misrepresented; you must not
  //   claim that you wrote the original software. If you use this software
  //   in a product, an acknowledgment in the product documentation would be
  //   appreciated but is not required.
  // 2. Altered source versions must be plainly marked as such, and must not be
  //   misrepresented as being the original software.
  // 3. This notice may not be removed or altered from any source distribution.

  var utils = __webpack_require__(107);
  /* Public constants ==========================================================*/

  /* ===========================================================================*/
  //var Z_FILTERED          = 1;
  //var Z_HUFFMAN_ONLY      = 2;
  //var Z_RLE               = 3;


  var Z_FIXED = 4; //var Z_DEFAULT_STRATEGY  = 0;

  /* Possible values of the data_type field (though see inflate()) */

  var Z_BINARY = 0;
  var Z_TEXT = 1; //var Z_ASCII             = 1; // = Z_TEXT

  var Z_UNKNOWN = 2;
  /*============================================================================*/

  function zero(buf) {
    var len = buf.length;

    while (--len >= 0) {
      buf[len] = 0;
    }
  } // From zutil.h


  var STORED_BLOCK = 0;
  var STATIC_TREES = 1;
  var DYN_TREES = 2;
  /* The three kinds of block type */

  var MIN_MATCH = 3;
  var MAX_MATCH = 258;
  /* The minimum and maximum match lengths */
  // From deflate.h

  /* ===========================================================================
   * Internal compression state.
   */

  var LENGTH_CODES = 29;
  /* number of length codes, not counting the special END_BLOCK code */

  var LITERALS = 256;
  /* number of literal bytes 0..255 */

  var L_CODES = LITERALS + 1 + LENGTH_CODES;
  /* number of Literal or Length codes, including the END_BLOCK code */

  var D_CODES = 30;
  /* number of distance codes */

  var BL_CODES = 19;
  /* number of codes used to transfer the bit lengths */

  var HEAP_SIZE = 2 * L_CODES + 1;
  /* maximum heap size */

  var MAX_BITS = 15;
  /* All codes must not exceed MAX_BITS bits */

  var Buf_size = 16;
  /* size of bit buffer in bi_buf */

  /* ===========================================================================
   * Constants
   */

  var MAX_BL_BITS = 7;
  /* Bit length codes must not exceed MAX_BL_BITS bits */

  var END_BLOCK = 256;
  /* end of block literal code */

  var REP_3_6 = 16;
  /* repeat previous bit length 3-6 times (2 bits of repeat count) */

  var REPZ_3_10 = 17;
  /* repeat a zero length 3-10 times  (3 bits of repeat count) */

  var REPZ_11_138 = 18;
  /* repeat a zero length 11-138 times  (7 bits of repeat count) */

  /* eslint-disable comma-spacing,array-bracket-spacing */

  var extra_lbits =
  /* extra bits for each length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0];
  var extra_dbits =
  /* extra bits for each distance code */
  [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];
  var extra_blbits =
  /* extra bits for each bit length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
  var bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
  /* eslint-enable comma-spacing,array-bracket-spacing */

  /* The lengths of the bit length codes are sent in order of decreasing
   * probability, to avoid transmitting the lengths for unused bit length codes.
   */

  /* ===========================================================================
   * Local data. These are initialized only once.
   */
  // We pre-fill arrays with 0 to avoid uninitialized gaps

  var DIST_CODE_LEN = 512;
  /* see definition of array dist_code below */
  // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1

  var static_ltree = new Array((L_CODES + 2) * 2);
  zero(static_ltree);
  /* The static literal tree. Since the bit lengths are imposed, there is no
   * need for the L_CODES extra codes used during heap construction. However
   * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
   * below).
   */

  var static_dtree = new Array(D_CODES * 2);
  zero(static_dtree);
  /* The static distance tree. (Actually a trivial tree since all codes use
   * 5 bits.)
   */

  var _dist_code = new Array(DIST_CODE_LEN);

  zero(_dist_code);
  /* Distance codes. The first 256 values correspond to the distances
   * 3 .. 258, the last 256 values correspond to the top 8 bits of
   * the 15 bit distances.
   */

  var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);

  zero(_length_code);
  /* length code for each normalized match length (0 == MIN_MATCH) */

  var base_length = new Array(LENGTH_CODES);
  zero(base_length);
  /* First normalized length for each code (0 = MIN_MATCH) */

  var base_dist = new Array(D_CODES);
  zero(base_dist);
  /* First normalized distance for each code (0 = distance of 1) */

  function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree;
    /* static tree or NULL */

    this.extra_bits = extra_bits;
    /* extra bits for each code or NULL */

    this.extra_base = extra_base;
    /* base index for extra_bits */

    this.elems = elems;
    /* max number of elements in the tree */

    this.max_length = max_length;
    /* max bit length for the codes */
    // show if `static_tree` has data or dummy - needed for monomorphic objects

    this.has_stree = static_tree && static_tree.length;
  }

  var static_l_desc;
  var static_d_desc;
  var static_bl_desc;

  function TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree;
    /* the dynamic tree */

    this.max_code = 0;
    /* largest code with non zero frequency */

    this.stat_desc = stat_desc;
    /* the corresponding static tree */
  }

  function d_code(dist) {
    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
  }
  /* ===========================================================================
   * Output a short LSB first on the stream.
   * IN assertion: there is enough room in pendingBuf.
   */


  function put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
  }
  /* ===========================================================================
   * Send a value on a given number of bits.
   * IN assertion: length <= 16 and value fits in length bits.
   */


  function send_bits(s, value, length) {
    if (s.bi_valid > Buf_size - length) {
      s.bi_buf |= value << s.bi_valid & 0xffff;
      put_short(s, s.bi_buf);
      s.bi_buf = value >> Buf_size - s.bi_valid;
      s.bi_valid += length - Buf_size;
    } else {
      s.bi_buf |= value << s.bi_valid & 0xffff;
      s.bi_valid += length;
    }
  }

  function send_code(s, c, tree) {
    send_bits(s, tree[c * 2]
    /*.Code*/
    , tree[c * 2 + 1]
    /*.Len*/
    );
  }
  /* ===========================================================================
   * Reverse the first len bits of a code, using straightforward code (a faster
   * method would use a table)
   * IN assertion: 1 <= len <= 15
   */


  function bi_reverse(code, len) {
    var res = 0;

    do {
      res |= code & 1;
      code >>>= 1;
      res <<= 1;
    } while (--len > 0);

    return res >>> 1;
  }
  /* ===========================================================================
   * Flush the bit buffer, keeping at most 7 bits in it.
   */


  function bi_flush(s) {
    if (s.bi_valid === 16) {
      put_short(s, s.bi_buf);
      s.bi_buf = 0;
      s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
      s.pending_buf[s.pending++] = s.bi_buf & 0xff;
      s.bi_buf >>= 8;
      s.bi_valid -= 8;
    }
  }
  /* ===========================================================================
   * Compute the optimal bit lengths for a tree and update the total bit length
   * for the current block.
   * IN assertion: the fields freq and dad are set, heap[heap_max] and
   *    above are the tree nodes sorted by increasing frequency.
   * OUT assertions: the field len is set to the optimal bit length, the
   *     array bl_count contains the frequencies for each bit length.
   *     The length opt_len is updated; static_len is also updated if stree is
   *     not null.
   */


  function gen_bitlen(s, desc) //    deflate_state *s;
  //    tree_desc *desc;    /* the tree descriptor */
  {
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h;
    /* heap index */

    var n, m;
    /* iterate over the tree elements */

    var bits;
    /* bit length */

    var xbits;
    /* extra bits */

    var f;
    /* frequency */

    var overflow = 0;
    /* number of elements with bit length too large */

    for (bits = 0; bits <= MAX_BITS; bits++) {
      s.bl_count[bits] = 0;
    }
    /* In a first pass, compute the optimal bit lengths (which may
     * overflow in the case of the bit length tree).
     */


    tree[s.heap[s.heap_max] * 2 + 1]
    /*.Len*/
    = 0;
    /* root of the heap */

    for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
      n = s.heap[h];
      bits = tree[tree[n * 2 + 1]
      /*.Dad*/
      * 2 + 1]
      /*.Len*/
      + 1;

      if (bits > max_length) {
        bits = max_length;
        overflow++;
      }

      tree[n * 2 + 1]
      /*.Len*/
      = bits;
      /* We overwrite tree[n].Dad which is no longer needed */

      if (n > max_code) {
        continue;
      }
      /* not a leaf node */


      s.bl_count[bits]++;
      xbits = 0;

      if (n >= base) {
        xbits = extra[n - base];
      }

      f = tree[n * 2]
      /*.Freq*/
      ;
      s.opt_len += f * (bits + xbits);

      if (has_stree) {
        s.static_len += f * (stree[n * 2 + 1]
        /*.Len*/
        + xbits);
      }
    }

    if (overflow === 0) {
      return;
    } // Trace((stderr,"\nbit length overflow\n"));

    /* This happens for example on obj2 and pic of the Calgary corpus */

    /* Find the first bit length which could increase: */


    do {
      bits = max_length - 1;

      while (s.bl_count[bits] === 0) {
        bits--;
      }

      s.bl_count[bits]--;
      /* move one leaf down the tree */

      s.bl_count[bits + 1] += 2;
      /* move one overflow item as its brother */

      s.bl_count[max_length]--;
      /* The brother of the overflow item also moves one step up,
       * but this does not affect bl_count[max_length]
       */

      overflow -= 2;
    } while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
     * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
     * lengths instead of fixing only the wrong ones. This idea is taken
     * from 'ar' written by Haruhiko Okumura.)
     */


    for (bits = max_length; bits !== 0; bits--) {
      n = s.bl_count[bits];

      while (n !== 0) {
        m = s.heap[--h];

        if (m > max_code) {
          continue;
        }

        if (tree[m * 2 + 1]
        /*.Len*/
        !== bits) {
          // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
          s.opt_len += (bits - tree[m * 2 + 1]
          /*.Len*/
          ) * tree[m * 2]
          /*.Freq*/
          ;
          tree[m * 2 + 1]
          /*.Len*/
          = bits;
        }

        n--;
      }
    }
  }
  /* ===========================================================================
   * Generate the codes for a given tree and bit counts (which need not be
   * optimal).
   * IN assertion: the array bl_count contains the bit length statistics for
   * the given tree and the field len is set for all tree elements.
   * OUT assertion: the field code is set for all tree elements of non
   *     zero code length.
   */


  function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
  //    int max_code;              /* largest code with non zero frequency */
  //    ushf *bl_count;            /* number of codes at each bit length */
  {
    var next_code = new Array(MAX_BITS + 1);
    /* next code value for each bit length */

    var code = 0;
    /* running code value */

    var bits;
    /* bit index */

    var n;
    /* code index */

    /* The distribution counts are first used to generate the code values
     * without bit reversal.
     */

    for (bits = 1; bits <= MAX_BITS; bits++) {
      next_code[bits] = code = code + bl_count[bits - 1] << 1;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
     * must be all ones.
     */
    //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));


    for (n = 0; n <= max_code; n++) {
      var len = tree[n * 2 + 1]
      /*.Len*/
      ;

      if (len === 0) {
        continue;
      }
      /* Now reverse the bits */


      tree[n * 2]
      /*.Code*/
      = bi_reverse(next_code[len]++, len); //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
      //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
  }
  /* ===========================================================================
   * Initialize the various 'constant' tables.
   */


  function tr_static_init() {
    var n;
    /* iterates over tree elements */

    var bits;
    /* bit counter */

    var length;
    /* length value */

    var code;
    /* code value */

    var dist;
    /* distance index */

    var bl_count = new Array(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */
    // do check in _tr_init()
    //if (static_init_done) return;

    /* For some embedded targets, global variables are not initialized: */

    /*#ifdef NO_INIT_GLOBAL_POINTERS
      static_l_desc.static_tree = static_ltree;
      static_l_desc.extra_bits = extra_lbits;
      static_d_desc.static_tree = static_dtree;
      static_d_desc.extra_bits = extra_dbits;
      static_bl_desc.extra_bits = extra_blbits;
    #endif*/

    /* Initialize the mapping length (0..255) -> length code (0..28) */

    length = 0;

    for (code = 0; code < LENGTH_CODES - 1; code++) {
      base_length[code] = length;

      for (n = 0; n < 1 << extra_lbits[code]; n++) {
        _length_code[length++] = code;
      }
    } //Assert (length == 256, "tr_static_init: length != 256");

    /* Note that the length 255 (match length 258) can be represented
     * in two different ways: code 284 + 5 bits or code 285, so we
     * overwrite length_code[255] to use the best encoding:
     */


    _length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */

    dist = 0;

    for (code = 0; code < 16; code++) {
      base_dist[code] = dist;

      for (n = 0; n < 1 << extra_dbits[code]; n++) {
        _dist_code[dist++] = code;
      }
    } //Assert (dist == 256, "tr_static_init: dist != 256");


    dist >>= 7;
    /* from now on, all distances are divided by 128 */

    for (; code < D_CODES; code++) {
      base_dist[code] = dist << 7;

      for (n = 0; n < 1 << extra_dbits[code] - 7; n++) {
        _dist_code[256 + dist++] = code;
      }
    } //Assert (dist == 256, "tr_static_init: 256+dist != 512");

    /* Construct the codes of the static literal tree */


    for (bits = 0; bits <= MAX_BITS; bits++) {
      bl_count[bits] = 0;
    }

    n = 0;

    while (n <= 143) {
      static_ltree[n * 2 + 1]
      /*.Len*/
      = 8;
      n++;
      bl_count[8]++;
    }

    while (n <= 255) {
      static_ltree[n * 2 + 1]
      /*.Len*/
      = 9;
      n++;
      bl_count[9]++;
    }

    while (n <= 279) {
      static_ltree[n * 2 + 1]
      /*.Len*/
      = 7;
      n++;
      bl_count[7]++;
    }

    while (n <= 287) {
      static_ltree[n * 2 + 1]
      /*.Len*/
      = 8;
      n++;
      bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
     * tree construction to get a canonical Huffman tree (longest code
     * all ones)
     */


    gen_codes(static_ltree, L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */

    for (n = 0; n < D_CODES; n++) {
      static_dtree[n * 2 + 1]
      /*.Len*/
      = 5;
      static_dtree[n * 2]
      /*.Code*/
      = bi_reverse(n, 5);
    } // Now data ready and we can init static trees


    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS); //static_init_done = true;
  }
  /* ===========================================================================
   * Initialize a new block.
   */


  function init_block(s) {
    var n;
    /* iterates over tree elements */

    /* Initialize the trees. */

    for (n = 0; n < L_CODES; n++) {
      s.dyn_ltree[n * 2]
      /*.Freq*/
      = 0;
    }

    for (n = 0; n < D_CODES; n++) {
      s.dyn_dtree[n * 2]
      /*.Freq*/
      = 0;
    }

    for (n = 0; n < BL_CODES; n++) {
      s.bl_tree[n * 2]
      /*.Freq*/
      = 0;
    }

    s.dyn_ltree[END_BLOCK * 2]
    /*.Freq*/
    = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
  }
  /* ===========================================================================
   * Flush the bit buffer and align the output on a byte boundary
   */


  function bi_windup(s) {
    if (s.bi_valid > 8) {
      put_short(s, s.bi_buf);
    } else if (s.bi_valid > 0) {
      //put_byte(s, (Byte)s->bi_buf);
      s.pending_buf[s.pending++] = s.bi_buf;
    }

    s.bi_buf = 0;
    s.bi_valid = 0;
  }
  /* ===========================================================================
   * Copy a stored block, storing first the length and its
   * one's complement if requested.
   */


  function copy_block(s, buf, len, header) //DeflateState *s;
  //charf    *buf;    /* the input data */
  //unsigned len;     /* its length */
  //int      header;  /* true if block header must be written */
  {
    bi_windup(s);
    /* align on byte boundary */

    if (header) {
      put_short(s, len);
      put_short(s, ~len);
    } //  while (len--) {
    //    put_byte(s, *buf++);
    //  }


    utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
  }
  /* ===========================================================================
   * Compares to subtrees, using the tree depth as tie breaker when
   * the subtrees have equal frequency. This minimizes the worst case length.
   */


  function smaller(tree, n, m, depth) {
    var _n2 = n * 2;

    var _m2 = m * 2;

    return tree[_n2]
    /*.Freq*/
    < tree[_m2]
    /*.Freq*/
    || tree[_n2]
    /*.Freq*/
    === tree[_m2]
    /*.Freq*/
    && depth[n] <= depth[m];
  }
  /* ===========================================================================
   * Restore the heap property by moving down the tree starting at node k,
   * exchanging a node with the smallest of its two sons if necessary, stopping
   * when the heap property is re-established (each father smaller than its
   * two sons).
   */


  function pqdownheap(s, tree, k) //    deflate_state *s;
  //    ct_data *tree;  /* the tree to restore */
  //    int k;               /* node to move down */
  {
    var v = s.heap[k];
    var j = k << 1;
    /* left son of k */

    while (j <= s.heap_len) {
      /* Set j to the smallest of the two sons: */
      if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
        j++;
      }
      /* Exit if v is smaller than both sons */


      if (smaller(tree, v, s.heap[j], s.depth)) {
        break;
      }
      /* Exchange v with the smallest son */


      s.heap[k] = s.heap[j];
      k = j;
      /* And continue down the tree, setting j to the left son of k */

      j <<= 1;
    }

    s.heap[k] = v;
  } // inlined manually
  // var SMALLEST = 1;

  /* ===========================================================================
   * Send the block data compressed using the given Huffman trees
   */


  function compress_block(s, ltree, dtree) //    deflate_state *s;
  //    const ct_data *ltree; /* literal tree */
  //    const ct_data *dtree; /* distance tree */
  {
    var dist;
    /* distance of matched string */

    var lc;
    /* match length or unmatched char (if dist == 0) */

    var lx = 0;
    /* running index in l_buf */

    var code;
    /* the code to send */

    var extra;
    /* number of extra bits to send */

    if (s.last_lit !== 0) {
      do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;

        if (dist === 0) {
          send_code(s, lc, ltree);
          /* send a literal byte */
          //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
        } else {
          /* Here, lc is the match length - MIN_MATCH */
          code = _length_code[lc];
          send_code(s, code + LITERALS + 1, ltree);
          /* send the length code */

          extra = extra_lbits[code];

          if (extra !== 0) {
            lc -= base_length[code];
            send_bits(s, lc, extra);
            /* send the extra length bits */
          }

          dist--;
          /* dist is now the match distance - 1 */

          code = d_code(dist); //Assert (code < D_CODES, "bad d_code");

          send_code(s, code, dtree);
          /* send the distance code */

          extra = extra_dbits[code];

          if (extra !== 0) {
            dist -= base_dist[code];
            send_bits(s, dist, extra);
            /* send the extra distance bits */
          }
        }
        /* literal or match pair ? */

        /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
        //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
        //       "pendingBuf overflow");

      } while (lx < s.last_lit);
    }

    send_code(s, END_BLOCK, ltree);
  }
  /* ===========================================================================
   * Construct one Huffman tree and assigns the code bit strings and lengths.
   * Update the total bit length for the current block.
   * IN assertion: the field freq is set for all tree elements.
   * OUT assertions: the fields len and code are set to the optimal bit length
   *     and corresponding code. The length opt_len is updated; static_len is
   *     also updated if stree is not null. The field max_code is set.
   */


  function build_tree(s, desc) //    deflate_state *s;
  //    tree_desc *desc; /* the tree descriptor */
  {
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m;
    /* iterate over heap elements */

    var max_code = -1;
    /* largest code with non zero frequency */

    var node;
    /* new node being created */

    /* Construct the initial heap, with least frequent element in
     * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
     * heap[0] is not used.
     */

    s.heap_len = 0;
    s.heap_max = HEAP_SIZE;

    for (n = 0; n < elems; n++) {
      if (tree[n * 2]
      /*.Freq*/
      !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
      } else {
        tree[n * 2 + 1]
        /*.Len*/
        = 0;
      }
    }
    /* The pkzip format requires that at least one distance code exists,
     * and that at least one bit should be sent even if there is only one
     * possible code. So to avoid special checks later on we force at least
     * two codes of non zero frequency.
     */


    while (s.heap_len < 2) {
      node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
      tree[node * 2]
      /*.Freq*/
      = 1;
      s.depth[node] = 0;
      s.opt_len--;

      if (has_stree) {
        s.static_len -= stree[node * 2 + 1]
        /*.Len*/
        ;
      }
      /* node is 0 or 1 so it does not have extra bits */

    }

    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
     * establish sub-heaps of increasing lengths:
     */

    for (n = s.heap_len >> 1
    /*int /2*/
    ; n >= 1; n--) {
      pqdownheap(s, tree, n);
    }
    /* Construct the Huffman tree by repeatedly combining the least two
     * frequent nodes.
     */


    node = elems;
    /* next internal node of the tree */

    do {
      //pqremove(s, tree, n);  /* n = node of least frequency */

      /*** pqremove ***/
      n = s.heap[1
      /*SMALLEST*/
      ];
      s.heap[1
      /*SMALLEST*/
      ] = s.heap[s.heap_len--];
      pqdownheap(s, tree, 1
      /*SMALLEST*/
      );
      /***/

      m = s.heap[1
      /*SMALLEST*/
      ];
      /* m = node of next least frequency */

      s.heap[--s.heap_max] = n;
      /* keep the nodes sorted by frequency */

      s.heap[--s.heap_max] = m;
      /* Create a new node father of n and m */

      tree[node * 2]
      /*.Freq*/
      = tree[n * 2]
      /*.Freq*/
      + tree[m * 2]
      /*.Freq*/
      ;
      s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
      tree[n * 2 + 1]
      /*.Dad*/
      = tree[m * 2 + 1]
      /*.Dad*/
      = node;
      /* and insert the new node in the heap */

      s.heap[1
      /*SMALLEST*/
      ] = node++;
      pqdownheap(s, tree, 1
      /*SMALLEST*/
      );
    } while (s.heap_len >= 2);

    s.heap[--s.heap_max] = s.heap[1
    /*SMALLEST*/
    ];
    /* At this point, the fields freq and dad are set. We can now
     * generate the bit lengths.
     */

    gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */

    gen_codes(tree, max_code, s.bl_count);
  }
  /* ===========================================================================
   * Scan a literal or distance tree to determine the frequencies of the codes
   * in the bit length tree.
   */


  function scan_tree(s, tree, max_code) //    deflate_state *s;
  //    ct_data *tree;   /* the tree to be scanned */
  //    int max_code;    /* and its largest code of non zero frequency */
  {
    var n;
    /* iterates over all tree elements */

    var prevlen = -1;
    /* last emitted length */

    var curlen;
    /* length of current code */

    var nextlen = tree[0 * 2 + 1]
    /*.Len*/
    ;
    /* length of next code */

    var count = 0;
    /* repeat count of the current code */

    var max_count = 7;
    /* max repeat count */

    var min_count = 4;
    /* min repeat count */

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;
    }

    tree[(max_code + 1) * 2 + 1]
    /*.Len*/
    = 0xffff;
    /* guard */

    for (n = 0; n <= max_code; n++) {
      curlen = nextlen;
      nextlen = tree[(n + 1) * 2 + 1]
      /*.Len*/
      ;

      if (++count < max_count && curlen === nextlen) {
        continue;
      } else if (count < min_count) {
        s.bl_tree[curlen * 2]
        /*.Freq*/
        += count;
      } else if (curlen !== 0) {
        if (curlen !== prevlen) {
          s.bl_tree[curlen * 2] /*.Freq*/++;
        }

        s.bl_tree[REP_3_6 * 2] /*.Freq*/++;
      } else if (count <= 10) {
        s.bl_tree[REPZ_3_10 * 2] /*.Freq*/++;
      } else {
        s.bl_tree[REPZ_11_138 * 2] /*.Freq*/++;
      }

      count = 0;
      prevlen = curlen;

      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      } else if (curlen === nextlen) {
        max_count = 6;
        min_count = 3;
      } else {
        max_count = 7;
        min_count = 4;
      }
    }
  }
  /* ===========================================================================
   * Send a literal or distance tree in compressed form, using the codes in
   * bl_tree.
   */


  function send_tree(s, tree, max_code) //    deflate_state *s;
  //    ct_data *tree; /* the tree to be scanned */
  //    int max_code;       /* and its largest code of non zero frequency */
  {
    var n;
    /* iterates over all tree elements */

    var prevlen = -1;
    /* last emitted length */

    var curlen;
    /* length of current code */

    var nextlen = tree[0 * 2 + 1]
    /*.Len*/
    ;
    /* length of next code */

    var count = 0;
    /* repeat count of the current code */

    var max_count = 7;
    /* max repeat count */

    var min_count = 4;
    /* min repeat count */

    /* tree[max_code+1].Len = -1; */

    /* guard already set */

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;
    }

    for (n = 0; n <= max_code; n++) {
      curlen = nextlen;
      nextlen = tree[(n + 1) * 2 + 1]
      /*.Len*/
      ;

      if (++count < max_count && curlen === nextlen) {
        continue;
      } else if (count < min_count) {
        do {
          send_code(s, curlen, s.bl_tree);
        } while (--count !== 0);
      } else if (curlen !== 0) {
        if (curlen !== prevlen) {
          send_code(s, curlen, s.bl_tree);
          count--;
        } //Assert(count >= 3 && count <= 6, " 3_6?");


        send_code(s, REP_3_6, s.bl_tree);
        send_bits(s, count - 3, 2);
      } else if (count <= 10) {
        send_code(s, REPZ_3_10, s.bl_tree);
        send_bits(s, count - 3, 3);
      } else {
        send_code(s, REPZ_11_138, s.bl_tree);
        send_bits(s, count - 11, 7);
      }

      count = 0;
      prevlen = curlen;

      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      } else if (curlen === nextlen) {
        max_count = 6;
        min_count = 3;
      } else {
        max_count = 7;
        min_count = 4;
      }
    }
  }
  /* ===========================================================================
   * Construct the Huffman tree for the bit lengths and return the index in
   * bl_order of the last bit length code to send.
   */


  function build_bl_tree(s) {
    var max_blindex;
    /* index of last bit length code of non zero freq */

    /* Determine the bit length frequencies for literal and distance trees */

    scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */

    build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
     * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
     */

    /* Determine the number of bit length codes to send. The pkzip format
     * requires that at least 4 bit length codes be sent. (appnote.txt says
     * 3 but the actual value used is 4.)
     */

    for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
      if (s.bl_tree[bl_order[max_blindex] * 2 + 1]
      /*.Len*/
      !== 0) {
        break;
      }
    }
    /* Update opt_len to include the bit length tree and counts */


    s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));

    return max_blindex;
  }
  /* ===========================================================================
   * Send the header for a block using dynamic Huffman trees: the counts, the
   * lengths of the bit length codes, the literal tree and the distance tree.
   * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
   */


  function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
  //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
  {
    var rank;
    /* index in bl_order */
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));

    send_bits(s, lcodes - 257, 5);
    /* not +255 as stated in appnote.txt */

    send_bits(s, dcodes - 1, 5);
    send_bits(s, blcodes - 4, 4);
    /* not -3 as stated in appnote.txt */

    for (rank = 0; rank < blcodes; rank++) {
      //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
      send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]
      /*.Len*/
      , 3);
    } //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));


    send_tree(s, s.dyn_ltree, lcodes - 1);
    /* literal tree */
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

    send_tree(s, s.dyn_dtree, dcodes - 1);
    /* distance tree */
    //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
  }
  /* ===========================================================================
   * Check if the data type is TEXT or BINARY, using the following algorithm:
   * - TEXT if the two conditions below are satisfied:
   *    a) There are no non-portable control characters belonging to the
   *       "black list" (0..6, 14..25, 28..31).
   *    b) There is at least one printable character belonging to the
   *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
   * - BINARY otherwise.
   * - The following partially-portable control characters form a
   *   "gray list" that is ignored in this detection algorithm:
   *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
   * IN assertion: the fields Freq of dyn_ltree are set.
   */


  function detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
     * set bits 0..6, 14..25, and 28..31
     * 0xf3ffc07f = binary 11110011111111111100000001111111
     */
    var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */

    for (n = 0; n <= 31; n++, black_mask >>>= 1) {
      if (black_mask & 1 && s.dyn_ltree[n * 2]
      /*.Freq*/
      !== 0) {
        return Z_BINARY;
      }
    }
    /* Check for textual ("white-listed") bytes. */


    if (s.dyn_ltree[9 * 2]
    /*.Freq*/
    !== 0 || s.dyn_ltree[10 * 2]
    /*.Freq*/
    !== 0 || s.dyn_ltree[13 * 2]
    /*.Freq*/
    !== 0) {
      return Z_TEXT;
    }

    for (n = 32; n < LITERALS; n++) {
      if (s.dyn_ltree[n * 2]
      /*.Freq*/
      !== 0) {
        return Z_TEXT;
      }
    }
    /* There are no "black-listed" or "white-listed" bytes:
     * this stream either is empty or has tolerated ("gray-listed") bytes only.
     */


    return Z_BINARY;
  }

  var static_init_done = false;
  /* ===========================================================================
   * Initialize the tree data structures for a new zlib stream.
   */

  function _tr_init(s) {
    if (!static_init_done) {
      tr_static_init();
      static_init_done = true;
    }

    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */

    init_block(s);
  }
  /* ===========================================================================
   * Send a stored block
   */


  function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
  //charf *buf;       /* input block */
  //ulg stored_len;   /* length of input block */
  //int last;         /* one if this is the last block for a file */
  {
    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
    /* send block type */

    copy_block(s, buf, stored_len, true);
    /* with header */
  }
  /* ===========================================================================
   * Send one empty static block to give enough lookahead for inflate.
   * This takes 10 bits, of which 7 may remain in the bit buffer.
   */


  function _tr_align(s) {
    send_bits(s, STATIC_TREES << 1, 3);
    send_code(s, END_BLOCK, static_ltree);
    bi_flush(s);
  }
  /* ===========================================================================
   * Determine the best encoding for the current block: dynamic trees, static
   * trees or store, and output the encoded block to the zip file.
   */


  function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
  //charf *buf;       /* input block, or NULL if too old */
  //ulg stored_len;   /* length of input block */
  //int last;         /* one if this is the last block for a file */
  {
    var opt_lenb, static_lenb;
    /* opt_len and static_len in bytes */

    var max_blindex = 0;
    /* index of last bit length code of non zero freq */

    /* Build the Huffman trees unless a stored block is forced */

    if (s.level > 0) {
      /* Check if the file is binary or text */
      if (s.strm.data_type === Z_UNKNOWN) {
        s.strm.data_type = detect_data_type(s);
      }
      /* Construct the literal and distance trees */


      build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
      //        s->static_len));

      build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
      //        s->static_len));

      /* At this point, opt_len and static_len are the total bit lengths of
       * the compressed block data, excluding the tree representations.
       */

      /* Build the bit length tree for the above two trees, and get the index
       * in bl_order of the last bit length code to send.
       */

      max_blindex = build_bl_tree(s);
      /* Determine the best encoding. Compute the block lengths in bytes. */

      opt_lenb = s.opt_len + 3 + 7 >>> 3;
      static_lenb = s.static_len + 3 + 7 >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
      //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
      //        s->last_lit));

      if (static_lenb <= opt_lenb) {
        opt_lenb = static_lenb;
      }
    } else {
      // Assert(buf != (char*)0, "lost buf");
      opt_lenb = static_lenb = stored_len + 5;
      /* force a stored block */
    }

    if (stored_len + 4 <= opt_lenb && buf !== -1) {
      /* 4: two words for the lengths */

      /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
       * Otherwise we can't have processed more than WSIZE input bytes since
       * the last block flush, because compression would have been
       * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
       * transform a block into a stored block.
       */
      _tr_stored_block(s, buf, stored_len, last);
    } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
      send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
      compress_block(s, static_ltree, static_dtree);
    } else {
      send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
      send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
      compress_block(s, s.dyn_ltree, s.dyn_dtree);
    } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");

    /* The above check is made mod 2^32, for files larger than 512 MB
     * and uLong implemented on 32 bits.
     */


    init_block(s);

    if (last) {
      bi_windup(s);
    } // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
    //       s->compressed_len-7*last));

  }
  /* ===========================================================================
   * Save the match info and tally the frequency counts. Return true if
   * the current block must be flushed.
   */


  function _tr_tally(s, dist, lc) //    deflate_state *s;
  //    unsigned dist;  /* distance of matched string */
  //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
  {
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;

    if (dist === 0) {
      /* lc is the unmatched char */
      s.dyn_ltree[lc * 2] /*.Freq*/++;
    } else {
      s.matches++;
      /* Here, lc is the match length - MIN_MATCH */

      dist--;
      /* dist = match distance - 1 */
      //Assert((ush)dist < (ush)MAX_DIST(s) &&
      //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
      //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

      s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /*.Freq*/++;
      s.dyn_dtree[d_code(dist) * 2] /*.Freq*/++;
    } // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif


    return s.last_lit === s.lit_bufsize - 1;
    /* We avoid equality with lit_bufsize because of wraparound at 64K
     * on 16 bit machines and because stored blocks are restricted to
     * 64K-1 bytes.
     */
  }

  exports._tr_init = _tr_init;
  exports._tr_stored_block = _tr_stored_block;
  exports._tr_flush_block = _tr_flush_block;
  exports._tr_tally = _tr_tally;
  exports._tr_align = _tr_align;
  /***/
},
/* 581 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // (C) 1995-2013 Jean-loup Gailly and Mark Adler
  // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
  //
  // This software is provided 'as-is', without any express or implied
  // warranty. In no event will the authors be held liable for any damages
  // arising from the use of this software.
  //
  // Permission is granted to anyone to use this software for any purpose,
  // including commercial applications, and to alter it and redistribute it
  // freely, subject to the following restrictions:
  //
  // 1. The origin of this software must not be misrepresented; you must not
  //   claim that you wrote the original software. If you use this software
  //   in a product, an acknowledgment in the product documentation would be
  //   appreciated but is not required.
  // 2. Altered source versions must be plainly marked as such, and must not be
  //   misrepresented as being the original software.
  // 3. This notice may not be removed or altered from any source distribution.

  function ZStream() {
    /* next input byte */
    this.input = null; // JS specific, because we have no pointers

    this.next_in = 0;
    /* number of bytes available at input */

    this.avail_in = 0;
    /* total number of input bytes read so far */

    this.total_in = 0;
    /* next output byte should be put there */

    this.output = null; // JS specific, because we have no pointers

    this.next_out = 0;
    /* remaining free space at output */

    this.avail_out = 0;
    /* total number of bytes output so far */

    this.total_out = 0;
    /* last error message, NULL if no error */

    this.msg = ''
    /*Z_NULL*/
    ;
    /* not visible by applications */

    this.state = null;
    /* best guess about the data type: binary or text */

    this.data_type = 2
    /*Z_UNKNOWN*/
    ;
    /* adler32 value of the uncompressed data */

    this.adler = 0;
  }

  module.exports = ZStream;
  /***/
},
/* 582 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    // resolves . and .. elements in a path array with directory names there
    // must be no slashes, empty elements, or device names (c:\) in the array
    // (so also no leading and trailing slashes - it does not distinguish
    // relative and absolute paths)
    function normalizeArray(parts, allowAboveRoot) {
      // if the path tries to go above the root, `up` ends up > 0
      var up = 0;

      for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];

        if (last === '.') {
          parts.splice(i, 1);
        } else if (last === '..') {
          parts.splice(i, 1);
          up++;
        } else if (up) {
          parts.splice(i, 1);
          up--;
        }
      } // if the path is allowed to go above the root, restore leading ..s


      if (allowAboveRoot) {
        for (; up--; up) {
          parts.unshift('..');
        }
      }

      return parts;
    } // Split a filename into [root, dir, basename, ext], unix version
    // 'root' is just a slash, or nothing.


    var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;

    var splitPath = function splitPath(filename) {
      return splitPathRe.exec(filename).slice(1);
    }; // path.resolve([from ...], to)
    // posix version


    exports.resolve = function () {
      var resolvedPath = '',
          resolvedAbsolute = false;

      for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? arguments[i] : process.cwd(); // Skip empty and invalid entries

        if (typeof path !== 'string') {
          throw new TypeError('Arguments to path.resolve must be strings');
        } else if (!path) {
          continue;
        }

        resolvedPath = path + '/' + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
      } // At this point the path should be resolved to a full absolute path, but
      // handle relative paths to be safe (might happen when process.cwd() fails)
      // Normalize the path


      resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function (p) {
        return !!p;
      }), !resolvedAbsolute).join('/');
      return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
    }; // path.normalize(path)
    // posix version


    exports.normalize = function (path) {
      var isAbsolute = exports.isAbsolute(path),
          trailingSlash = substr(path, -1) === '/'; // Normalize the path

      path = normalizeArray(filter(path.split('/'), function (p) {
        return !!p;
      }), !isAbsolute).join('/');

      if (!path && !isAbsolute) {
        path = '.';
      }

      if (path && trailingSlash) {
        path += '/';
      }

      return (isAbsolute ? '/' : '') + path;
    }; // posix version


    exports.isAbsolute = function (path) {
      return path.charAt(0) === '/';
    }; // posix version


    exports.join = function () {
      var paths = Array.prototype.slice.call(arguments, 0);
      return exports.normalize(filter(paths, function (p, index) {
        if (typeof p !== 'string') {
          throw new TypeError('Arguments to path.join must be strings');
        }

        return p;
      }).join('/'));
    }; // path.relative(from, to)
    // posix version


    exports.relative = function (from, to) {
      from = exports.resolve(from).substr(1);
      to = exports.resolve(to).substr(1);

      function trim(arr) {
        var start = 0;

        for (; start < arr.length; start++) {
          if (arr[start] !== '') break;
        }

        var end = arr.length - 1;

        for (; end >= 0; end--) {
          if (arr[end] !== '') break;
        }

        if (start > end) return [];
        return arr.slice(start, end - start + 1);
      }

      var fromParts = trim(from.split('/'));
      var toParts = trim(to.split('/'));
      var length = Math.min(fromParts.length, toParts.length);
      var samePartsLength = length;

      for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
          samePartsLength = i;
          break;
        }
      }

      var outputParts = [];

      for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
      }

      outputParts = outputParts.concat(toParts.slice(samePartsLength));
      return outputParts.join('/');
    };

    exports.sep = '/';
    exports.delimiter = ':';

    exports.dirname = function (path) {
      var result = splitPath(path),
          root = result[0],
          dir = result[1];

      if (!root && !dir) {
        // No dirname whatsoever
        return '.';
      }

      if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
      }

      return root + dir;
    };

    exports.basename = function (path, ext) {
      var f = splitPath(path)[2]; // TODO: make this comparison case-insensitive on windows?

      if (ext && f.substr(-1 * ext.length) === ext) {
        f = f.substr(0, f.length - ext.length);
      }

      return f;
    };

    exports.extname = function (path) {
      return splitPath(path)[3];
    };

    function filter(xs, f) {
      if (xs.filter) return xs.filter(f);
      var res = [];

      for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
      }

      return res;
    } // String.prototype.substr - negative index don't work in IE8


    var substr = 'ab'.substr(-1) === 'b' ? function (str, start, len) {
      return str.substr(start, len);
    } : function (str, start, len) {
      if (start < 0) start = str.length + start;
      return str.substr(start, len);
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(16));
  /***/
},
/* 583 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (module, global) {
    var __WEBPACK_AMD_DEFINE_RESULT__;
    /*! https://mths.be/punycode v1.4.1 by @mathias */


    ;

    (function (root) {
      /** Detect free variables */
      var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
      var freeModule = typeof module == 'object' && module && !module.nodeType && module;
      var freeGlobal = typeof global == 'object' && global;

      if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
        root = freeGlobal;
      }
      /**
       * The `punycode` object.
       * @name punycode
       * @type Object
       */


      var punycode,

      /** Highest positive signed 32-bit float value */
      maxInt = 2147483647,
          // aka. 0x7FFFFFFF or 2^31-1

      /** Bootstring parameters */
      base = 36,
          tMin = 1,
          tMax = 26,
          skew = 38,
          damp = 700,
          initialBias = 72,
          initialN = 128,
          // 0x80
      delimiter = '-',
          // '\x2D'

      /** Regular expressions */
      regexPunycode = /^xn--/,
          regexNonASCII = /[^\x20-\x7E]/,
          // unprintable ASCII chars + non-ASCII chars
      regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
          // RFC 3490 separators

      /** Error messages */
      errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
      },

      /** Convenience shortcuts */
      baseMinusTMin = base - tMin,
          floor = Math.floor,
          stringFromCharCode = String.fromCharCode,

      /** Temporary variable */
      key;
      /*--------------------------------------------------------------------------*/

      /**
       * A generic error utility function.
       * @private
       * @param {String} type The error type.
       * @returns {Error} Throws a `RangeError` with the applicable error message.
       */

      function error(type) {
        throw new RangeError(errors[type]);
      }
      /**
       * A generic `Array#map` utility function.
       * @private
       * @param {Array} array The array to iterate over.
       * @param {Function} callback The function that gets called for every array
       * item.
       * @returns {Array} A new array of values returned by the callback function.
       */


      function map(array, fn) {
        var length = array.length;
        var result = [];

        while (length--) {
          result[length] = fn(array[length]);
        }

        return result;
      }
      /**
       * A simple `Array#map`-like wrapper to work with domain name strings or email
       * addresses.
       * @private
       * @param {String} domain The domain name or email address.
       * @param {Function} callback The function that gets called for every
       * character.
       * @returns {Array} A new string of characters returned by the callback
       * function.
       */


      function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';

        if (parts.length > 1) {
          // In email addresses, only the domain name should be punycoded. Leave
          // the local part (i.e. everything up to `@`) intact.
          result = parts[0] + '@';
          string = parts[1];
        } // Avoid `split(regex)` for IE8 compatibility. See #17.


        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
      }
      /**
       * Creates an array containing the numeric code points of each Unicode
       * character in the string. While JavaScript uses UCS-2 internally,
       * this function will convert a pair of surrogate halves (each of which
       * UCS-2 exposes as separate characters) into a single code point,
       * matching UTF-16.
       * @see `punycode.ucs2.encode`
       * @see <https://mathiasbynens.be/notes/javascript-encoding>
       * @memberOf punycode.ucs2
       * @name decode
       * @param {String} string The Unicode input string (UCS-2).
       * @returns {Array} The new array of code points.
       */


      function ucs2decode(string) {
        var output = [],
            counter = 0,
            length = string.length,
            value,
            extra;

        while (counter < length) {
          value = string.charCodeAt(counter++);

          if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // high surrogate, and there is a next character
            extra = string.charCodeAt(counter++);

            if ((extra & 0xFC00) == 0xDC00) {
              // low surrogate
              output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            } else {
              // unmatched surrogate; only append this code unit, in case the next
              // code unit is the high surrogate of a surrogate pair
              output.push(value);
              counter--;
            }
          } else {
            output.push(value);
          }
        }

        return output;
      }
      /**
       * Creates a string based on an array of numeric code points.
       * @see `punycode.ucs2.decode`
       * @memberOf punycode.ucs2
       * @name encode
       * @param {Array} codePoints The array of numeric code points.
       * @returns {String} The new Unicode string (UCS-2).
       */


      function ucs2encode(array) {
        return map(array, function (value) {
          var output = '';

          if (value > 0xFFFF) {
            value -= 0x10000;
            output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
            value = 0xDC00 | value & 0x3FF;
          }

          output += stringFromCharCode(value);
          return output;
        }).join('');
      }
      /**
       * Converts a basic code point into a digit/integer.
       * @see `digitToBasic()`
       * @private
       * @param {Number} codePoint The basic numeric code point value.
       * @returns {Number} The numeric value of a basic code point (for use in
       * representing integers) in the range `0` to `base - 1`, or `base` if
       * the code point does not represent a value.
       */


      function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) {
          return codePoint - 22;
        }

        if (codePoint - 65 < 26) {
          return codePoint - 65;
        }

        if (codePoint - 97 < 26) {
          return codePoint - 97;
        }

        return base;
      }
      /**
       * Converts a digit/integer into a basic code point.
       * @see `basicToDigit()`
       * @private
       * @param {Number} digit The numeric value of a basic code point.
       * @returns {Number} The basic code point whose value (when used for
       * representing integers) is `digit`, which needs to be in the range
       * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
       * used; else, the lowercase form is used. The behavior is undefined
       * if `flag` is non-zero and `digit` has no uppercase form.
       */


      function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
      }
      /**
       * Bias adaptation function as per section 3.4 of RFC 3492.
       * https://tools.ietf.org/html/rfc3492#section-3.4
       * @private
       */


      function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);

        for (;
        /* no initialization */
        delta > baseMinusTMin * tMax >> 1; k += base) {
          delta = floor(delta / baseMinusTMin);
        }

        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
      }
      /**
       * Converts a Punycode string of ASCII-only symbols to a string of Unicode
       * symbols.
       * @memberOf punycode
       * @param {String} input The Punycode string of ASCII-only symbols.
       * @returns {String} The resulting string of Unicode symbols.
       */


      function decode(input) {
        // Don't use UCS-2
        var output = [],
            inputLength = input.length,
            out,
            i = 0,
            n = initialN,
            bias = initialBias,
            basic,
            j,
            index,
            oldi,
            w,
            k,
            digit,
            t,

        /** Cached calculation results */
        baseMinusT; // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.

        basic = input.lastIndexOf(delimiter);

        if (basic < 0) {
          basic = 0;
        }

        for (j = 0; j < basic; ++j) {
          // if it's not a basic code point
          if (input.charCodeAt(j) >= 0x80) {
            error('not-basic');
          }

          output.push(input.charCodeAt(j));
        } // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.


        for (index = basic > 0 ? basic + 1 : 0; index < inputLength;)
        /* no final expression */
        {
          // `index` is the index of the next character to be consumed.
          // Decode a generalized variable-length integer into `delta`,
          // which gets added to `i`. The overflow checking is easier
          // if we increase `i` as we go, then subtract off its starting
          // value at the end to obtain `delta`.
          for (oldi = i, w = 1, k = base;;
          /* no condition */
          k += base) {
            if (index >= inputLength) {
              error('invalid-input');
            }

            digit = basicToDigit(input.charCodeAt(index++));

            if (digit >= base || digit > floor((maxInt - i) / w)) {
              error('overflow');
            }

            i += digit * w;
            t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

            if (digit < t) {
              break;
            }

            baseMinusT = base - t;

            if (w > floor(maxInt / baseMinusT)) {
              error('overflow');
            }

            w *= baseMinusT;
          }

          out = output.length + 1;
          bias = adapt(i - oldi, out, oldi == 0); // `i` was supposed to wrap around from `out` to `0`,
          // incrementing `n` each time, so we'll fix that now:

          if (floor(i / out) > maxInt - n) {
            error('overflow');
          }

          n += floor(i / out);
          i %= out; // Insert `n` at position `i` of the output

          output.splice(i++, 0, n);
        }

        return ucs2encode(output);
      }
      /**
       * Converts a string of Unicode symbols (e.g. a domain name label) to a
       * Punycode string of ASCII-only symbols.
       * @memberOf punycode
       * @param {String} input The string of Unicode symbols.
       * @returns {String} The resulting Punycode string of ASCII-only symbols.
       */


      function encode(input) {
        var n,
            delta,
            handledCPCount,
            basicLength,
            bias,
            j,
            m,
            q,
            k,
            t,
            currentValue,
            output = [],

        /** `inputLength` will hold the number of code points in `input`. */
        inputLength,

        /** Cached calculation results */
        handledCPCountPlusOne,
            baseMinusT,
            qMinusT; // Convert the input in UCS-2 to Unicode

        input = ucs2decode(input); // Cache the length

        inputLength = input.length; // Initialize the state

        n = initialN;
        delta = 0;
        bias = initialBias; // Handle the basic code points

        for (j = 0; j < inputLength; ++j) {
          currentValue = input[j];

          if (currentValue < 0x80) {
            output.push(stringFromCharCode(currentValue));
          }
        }

        handledCPCount = basicLength = output.length; // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter

        if (basicLength) {
          output.push(delimiter);
        } // Main encoding loop:


        while (handledCPCount < inputLength) {
          // All non-basic code points < n have been handled already. Find the next
          // larger one:
          for (m = maxInt, j = 0; j < inputLength; ++j) {
            currentValue = input[j];

            if (currentValue >= n && currentValue < m) {
              m = currentValue;
            }
          } // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
          // but guard against overflow


          handledCPCountPlusOne = handledCPCount + 1;

          if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
            error('overflow');
          }

          delta += (m - n) * handledCPCountPlusOne;
          n = m;

          for (j = 0; j < inputLength; ++j) {
            currentValue = input[j];

            if (currentValue < n && ++delta > maxInt) {
              error('overflow');
            }

            if (currentValue == n) {
              // Represent delta as a generalized variable-length integer
              for (q = delta, k = base;;
              /* no condition */
              k += base) {
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

                if (q < t) {
                  break;
                }

                qMinusT = q - t;
                baseMinusT = base - t;
                output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                q = floor(qMinusT / baseMinusT);
              }

              output.push(stringFromCharCode(digitToBasic(q, 0)));
              bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
              delta = 0;
              ++handledCPCount;
            }
          }

          ++delta;
          ++n;
        }

        return output.join('');
      }
      /**
       * Converts a Punycode string representing a domain name or an email address
       * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
       * it doesn't matter if you call it on a string that has already been
       * converted to Unicode.
       * @memberOf punycode
       * @param {String} input The Punycoded domain name or email address to
       * convert to Unicode.
       * @returns {String} The Unicode representation of the given Punycode
       * string.
       */


      function toUnicode(input) {
        return mapDomain(input, function (string) {
          return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
      }
      /**
       * Converts a Unicode string representing a domain name or an email address to
       * Punycode. Only the non-ASCII parts of the domain name will be converted,
       * i.e. it doesn't matter if you call it with a domain that's already in
       * ASCII.
       * @memberOf punycode
       * @param {String} input The domain name or email address to convert, as a
       * Unicode string.
       * @returns {String} The Punycode representation of the given domain name or
       * email address.
       */


      function toASCII(input) {
        return mapDomain(input, function (string) {
          return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
      }
      /*--------------------------------------------------------------------------*/

      /** Define the public API */


      punycode = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        'version': '1.4.1',

        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        'ucs2': {
          'decode': ucs2decode,
          'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
      };
      /** Expose `punycode` */
      // Some AMD build optimizers, like r.js, check for specific condition patterns
      // like the following:

      if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return punycode;
        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else if (freeExports && freeModule) {
        if (module.exports == freeExports) {
          // in Node.js, io.js, or RingoJS v0.8.0+
          freeModule.exports = punycode;
        } else {
          // in Narwhal or RingoJS v0.7.0-
          for (key in punycode) {
            punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
          }
        }
      } else {
        // in Rhino or a web browser
        root.punycode = punycode;
      }
    })(this);
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(84)(module), __webpack_require__(10));
  /***/
},
/* 584 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  // If obj.hasOwnProperty has been overridden, then calling
  // obj.hasOwnProperty(prop) will break.
  // See: https://github.com/joyent/node/issues/1707

  function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  module.exports = function (qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};

    if (typeof qs !== 'string' || qs.length === 0) {
      return obj;
    }

    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;

    if (options && typeof options.maxKeys === 'number') {
      maxKeys = options.maxKeys;
    }

    var len = qs.length; // maxKeys <= 0 means that we should not limit keys count

    if (maxKeys > 0 && len > maxKeys) {
      len = maxKeys;
    }

    for (var i = 0; i < len; ++i) {
      var x = qs[i].replace(regexp, '%20'),
          idx = x.indexOf(eq),
          kstr,
          vstr,
          k,
          v;

      if (idx >= 0) {
        kstr = x.substr(0, idx);
        vstr = x.substr(idx + 1);
      } else {
        kstr = x;
        vstr = '';
      }

      k = decodeURIComponent(kstr);
      v = decodeURIComponent(vstr);

      if (!hasOwnProperty(obj, k)) {
        obj[k] = v;
      } else if (isArray(obj[k])) {
        obj[k].push(v);
      } else {
        obj[k] = [obj[k], v];
      }
    }

    return obj;
  };

  var isArray = Array.isArray || function (xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
  };
  /***/

},
/* 585 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.

  var stringifyPrimitive = function stringifyPrimitive(v) {
    switch (typeof v) {
      case 'string':
        return v;

      case 'boolean':
        return v ? 'true' : 'false';

      case 'number':
        return isFinite(v) ? v : '';

      default:
        return '';
    }
  };

  module.exports = function (obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';

    if (obj === null) {
      obj = undefined;
    }

    if (typeof obj === 'object') {
      return map(objectKeys(obj), function (k) {
        var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;

        if (isArray(obj[k])) {
          return map(obj[k], function (v) {
            return ks + encodeURIComponent(stringifyPrimitive(v));
          }).join(sep);
        } else {
          return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
        }
      }).join(sep);
    }

    if (!name) return '';
    return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
  };

  var isArray = Array.isArray || function (xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
  };

  function map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];

    for (var i = 0; i < xs.length; i++) {
      res.push(f(xs[i], i));
    }

    return res;
  }

  var objectKeys = Object.keys || function (obj) {
    var res = [];

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    }

    return res;
  };
  /***/

},
/* 586 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.decode = exports.parse = __webpack_require__(584);
  exports.encode = exports.stringify = __webpack_require__(585);
  /***/
},
/* 587 */

/***/
function (module, exports, __webpack_require__) {
  module.exports =
  /******/
  function (modules) {
    // webpackBootstrap

    /******/
    // The module cache

    /******/
    var installedModules = {};
    /******/

    /******/
    // The require function

    /******/

    function __webpack_require__(moduleId) {
      /******/

      /******/
      // Check if module is in cache

      /******/
      if (installedModules[moduleId]) {
        /******/
        return installedModules[moduleId].exports;
        /******/
      }
      /******/
      // Create a new module (and put it into the cache)

      /******/


      var module = installedModules[moduleId] = {
        /******/
        i: moduleId,

        /******/
        l: false,

        /******/
        exports: {}
        /******/

      };
      /******/

      /******/
      // Execute the module function

      /******/

      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/

      /******/
      // Flag the module as loaded

      /******/

      module.l = true;
      /******/

      /******/
      // Return the exports of the module

      /******/

      return module.exports;
      /******/
    }
    /******/

    /******/

    /******/
    // expose the modules object (__webpack_modules__)

    /******/


    __webpack_require__.m = modules;
    /******/

    /******/
    // expose the module cache

    /******/

    __webpack_require__.c = installedModules;
    /******/

    /******/
    // define getter function for harmony exports

    /******/

    __webpack_require__.d = function (exports, name, getter) {
      /******/
      if (!__webpack_require__.o(exports, name)) {
        /******/
        Object.defineProperty(exports, name, {
          /******/
          configurable: false,

          /******/
          enumerable: true,

          /******/
          get: getter
          /******/

        });
        /******/
      }
      /******/

    };
    /******/

    /******/
    // getDefaultExport function for compatibility with non-harmony modules

    /******/


    __webpack_require__.n = function (module) {
      /******/
      var getter = module && module.__esModule ?
      /******/
      function getDefault() {
        return module['default'];
      } :
      /******/
      function getModuleExports() {
        return module;
      };
      /******/

      __webpack_require__.d(getter, 'a', getter);
      /******/


      return getter;
      /******/
    };
    /******/

    /******/
    // Object.prototype.hasOwnProperty.call

    /******/


    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/

    /******/
    // __webpack_public_path__

    /******/


    __webpack_require__.p = "";
    /******/

    /******/
    // Load entry module and return exports

    /******/

    return __webpack_require__(__webpack_require__.s = 3);
    /******/
  }(
  /************************************************************************/

  /******/
  [
  /* 0 */

  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var UAParser = __webpack_require__(6);

    var UA = exports.UA = new UAParser();
    var browser = exports.browser = UA.getBrowser();
    var cpu = exports.cpu = UA.getCPU();
    var device = exports.device = UA.getDevice();
    var engine = exports.engine = UA.getEngine();
    var os = exports.os = UA.getOS();
    var ua = exports.ua = UA.getUA();

    var setUA = exports.setUA = function setUA(uaStr) {
      return UA.setUA(uaStr);
    };

    var mockUserAgent = exports.mockUserAgent = function mockUserAgent(userAgent) {
      window.navigator.__defineGetter__("userAgent", function () {
        return userAgent;
      });
    };
    /***/

  },
  /* 1 */

  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.isYandex = exports.isEdge = exports.getUA = exports.engineVersion = exports.engineName = exports.mobileModel = exports.mobileVendor = exports.browserName = exports.browserVersion = exports.fullBrowserVersion = exports.osName = exports.osVersion = exports.isIE = exports.isOpera = exports.isSafari = exports.isFirefox = exports.isChrome = exports.isIOS = exports.isWinPhone = exports.isAndroid = exports.isBrowser = exports.isTablet = exports.isMobileOnly = exports.isMobile = exports.isChromium = exports.isMobileSafari = exports.isWearable = exports.isConsole = exports.isSmartTV = undefined;

    var _getUaData = __webpack_require__(0);

    var _types = __webpack_require__(2);

    var CHROME = _types.BROWSER_TYPES.CHROME,
        CHROMIUM = _types.BROWSER_TYPES.CHROMIUM,
        IE = _types.BROWSER_TYPES.IE,
        INTERNET_EXPLORER = _types.BROWSER_TYPES.INTERNET_EXPLORER,
        OPERA = _types.BROWSER_TYPES.OPERA,
        FIREFOX = _types.BROWSER_TYPES.FIREFOX,
        SAFARI = _types.BROWSER_TYPES.SAFARI,
        MOBILE_SAFARI = _types.BROWSER_TYPES.MOBILE_SAFARI,
        EDGE = _types.BROWSER_TYPES.EDGE,
        YANDEX = _types.BROWSER_TYPES.YANDEX;
    var MOBILE = _types.DEVICE_TYPES.MOBILE,
        TABLET = _types.DEVICE_TYPES.TABLET,
        SMART_TV = _types.DEVICE_TYPES.SMART_TV,
        BROWSER = _types.DEVICE_TYPES.BROWSER,
        WEARABLE = _types.DEVICE_TYPES.WEARABLE,
        CONSOLE = _types.DEVICE_TYPES.CONSOLE;
    var ANDROID = _types.OS_TYPES.ANDROID,
        WINDOWS_PHONE = _types.OS_TYPES.WINDOWS_PHONE,
        IOS = _types.OS_TYPES.IOS;

    var isMobileType = function isMobileType() {
      return _getUaData.device.type === MOBILE;
    };

    var isTabletType = function isTabletType() {
      return _getUaData.device.type === TABLET;
    };

    var isMobileAndTabletType = function isMobileAndTabletType() {
      switch (_getUaData.device.type) {
        case MOBILE:
        case TABLET:
          return true;

        default:
          return false;
      }
    };

    var isSmartTVType = function isSmartTVType() {
      return _getUaData.device.type === SMART_TV;
    };

    var isBrowserType = function isBrowserType() {
      return _getUaData.device.type === BROWSER;
    };

    var isWearableType = function isWearableType() {
      return _getUaData.device.type === WEARABLE;
    };

    var isConsoleType = function isConsoleType() {
      return _getUaData.device.type === CONSOLE;
    };

    var isAndroidType = function isAndroidType() {
      return _getUaData.os.name === ANDROID;
    };

    var isWinPhoneType = function isWinPhoneType() {
      return _getUaData.os.name === WINDOWS_PHONE;
    };

    var isIOSType = function isIOSType() {
      return _getUaData.os.name === IOS;
    };

    var isChromeType = function isChromeType() {
      return _getUaData.browser.name === CHROME;
    };

    var isFirefoxType = function isFirefoxType() {
      return _getUaData.browser.name === FIREFOX;
    };

    var isChromiumType = function isChromiumType() {
      return _getUaData.browser.name === CHROMIUM;
    };

    var isEdgeType = function isEdgeType() {
      return _getUaData.browser.name === EDGE;
    };

    var isYandexType = function isYandexType() {
      return _getUaData.browser.name === YANDEX;
    };

    var isSafariType = function isSafariType() {
      return _getUaData.browser.name === SAFARI || _getUaData.browser.name === MOBILE_SAFARI;
    };

    var isMobileSafariType = function isMobileSafariType() {
      return _getUaData.browser.name === MOBILE_SAFARI;
    };

    var isOperaType = function isOperaType() {
      return _getUaData.browser.name === OPERA;
    };

    var isIEType = function isIEType() {
      return _getUaData.browser.name === INTERNET_EXPLORER || _getUaData.browser.name === IE;
    };

    var getBrowserFullVersion = function getBrowserFullVersion() {
      return _getUaData.browser.major;
    };

    var getBrowserVersion = function getBrowserVersion() {
      return _getUaData.browser.version;
    };

    var getOsVersion = function getOsVersion() {
      return _getUaData.os.version ? _getUaData.os.version : "none";
    };

    var getOsName = function getOsName() {
      return _getUaData.os.name ? _getUaData.os.name : "none";
    };

    var getBrowserName = function getBrowserName() {
      return _getUaData.browser.name;
    };

    var getMobileVendor = function getMobileVendor() {
      return _getUaData.device.vendor ? _getUaData.device.vendor : "none";
    };

    var getMobileModel = function getMobileModel() {
      return _getUaData.device.model ? _getUaData.device.model : "none";
    };

    var getEngineName = function getEngineName() {
      return _getUaData.engine.name;
    };

    var getEngineVersion = function getEngineVersion() {
      return _getUaData.engine.version;
    };

    var getUseragent = function getUseragent() {
      return _getUaData.ua;
    };

    var isSmartTV = exports.isSmartTV = isSmartTVType();
    var isConsole = exports.isConsole = isConsoleType();
    var isWearable = exports.isWearable = isWearableType();
    var isMobileSafari = exports.isMobileSafari = isMobileSafariType();
    var isChromium = exports.isChromium = isChromiumType();
    var isMobile = exports.isMobile = isMobileAndTabletType();
    var isMobileOnly = exports.isMobileOnly = isMobileType();
    var isTablet = exports.isTablet = isTabletType();
    var isBrowser = exports.isBrowser = isBrowserType();
    var isAndroid = exports.isAndroid = isAndroidType();
    var isWinPhone = exports.isWinPhone = isWinPhoneType();
    var isIOS = exports.isIOS = isIOSType();
    var isChrome = exports.isChrome = isChromeType();
    var isFirefox = exports.isFirefox = isFirefoxType();
    var isSafari = exports.isSafari = isSafariType();
    var isOpera = exports.isOpera = isOperaType();
    var isIE = exports.isIE = isIEType();
    var osVersion = exports.osVersion = getOsVersion();
    var osName = exports.osName = getOsName();
    var fullBrowserVersion = exports.fullBrowserVersion = getBrowserFullVersion();
    var browserVersion = exports.browserVersion = getBrowserVersion();
    var browserName = exports.browserName = getBrowserName();
    var mobileVendor = exports.mobileVendor = getMobileVendor();
    var mobileModel = exports.mobileModel = getMobileModel();
    var engineName = exports.engineName = getEngineName();
    var engineVersion = exports.engineVersion = getEngineVersion();
    var getUA = exports.getUA = getUseragent();
    var isEdge = exports.isEdge = isEdgeType();
    var isYandex = exports.isYandex = isYandexType();
    /***/
  },
  /* 2 */

  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.wearPayload = exports.consolePayload = exports.stvPayload = exports.mobilePayload = exports.broPayload = exports.getCurrentBrowser = exports.checkType = exports.OS_TYPES = exports.BROWSER_TYPES = exports.DEVICE_TYPES = undefined;

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var _getUaData = __webpack_require__(0);

    var DEVICE_TYPES = exports.DEVICE_TYPES = {
      MOBILE: 'mobile',
      TABLET: 'tablet',
      SMART_TV: 'smarttv',
      CONSOLE: 'console',
      WEARABLE: 'wearable',
      BROWSER: undefined
    };
    var BROWSER_TYPES = exports.BROWSER_TYPES = {
      CHROME: 'Chrome',
      FIREFOX: "Firefox",
      OPERA: "Opera",
      YANDEX: "Yandex",
      SAFARI: "Safari",
      INTERNET_EXPLORER: "Internet Explorer",
      EDGE: "Edge",
      CHROMIUM: "Chromium",
      IE: 'IE',
      MOBILE_SAFARI: "Mobile Safari"
    };
    var OS_TYPES = exports.OS_TYPES = {
      IOS: 'iOS',
      ANDROID: "Android",
      WINDOWS_PHONE: "Windows Phone"
    };
    var initialData = {
      isMobile: false,
      isTablet: false,
      isBrowser: false,
      isSmartTV: false,
      isConsole: false,
      isWearable: false
    };

    var checkType = exports.checkType = function checkType(type) {
      switch (type) {
        case DEVICE_TYPES.MOBILE:
          return {
            isMobile: true
          };

        case DEVICE_TYPES.TABLET:
          return {
            isTablet: true
          };

        case DEVICE_TYPES.SMART_TV:
          return {
            isSmartTV: true
          };

        case DEVICE_TYPES.CONSOLE:
          return {
            isConsole: true
          };

        case DEVICE_TYPES.WEARABLE:
          return {
            isWearable: true
          };

        case DEVICE_TYPES.BROWSER:
          return {
            isBrowser: true
          };

        default:
          return initialData;
      }
    };

    var getCurrentBrowser = exports.getCurrentBrowser = function getCurrentBrowser(name) {
      switch (name) {
        case BROWSER_TYPES.CHROME:
        case BROWSER_TYPES.FIREFOX:
        case BROWSER_TYPES.OPERA:
        case BROWSER_TYPES.YANDEX:
        case BROWSER_TYPES.SAFARI:
        case BROWSER_TYPES.IE:
        case BROWSER_TYPES.EDGE:
        case BROWSER_TYPES.CHROMIUM:
          return true;

        default:
          return false;
      }
    };

    var broPayload = exports.broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
      return {
        isBrowser: isBrowser,
        browserMajorVersion: browser.major,
        browserFullVersion: browser.version,
        browserName: browser.name,
        engineName: engine.name || false,
        engineVersion: engine.version,
        osName: os.name,
        osVersion: os.version,
        userAgent: ua
      };
    };

    var mobilePayload = exports.mobilePayload = function mobilePayload(type, device, os, ua) {
      return _extends({}, type, {
        vendor: device.vendor || "none",
        model: device.model || "none",
        os: os.name || "none",
        osVersion: os.version || "none",
        ua: ua || "none"
      });
    };

    var stvPayload = exports.stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
      return {
        isSmartTV: isSmartTV,
        engineName: engine.name || false,
        engineVersion: engine.version,
        osName: os.name,
        osVersion: os.version,
        userAgent: ua
      };
    };

    var consolePayload = exports.consolePayload = function consolePayload(isConsole, engine, os, ua) {
      return {
        isConsole: isConsole,
        engineName: engine.name || false,
        engineVersion: engine.version,
        osName: os.name,
        osVersion: os.version,
        userAgent: ua
      };
    };

    var wearPayload = exports.wearPayload = function wearPayload(isWearable, engine, os, ua) {
      return {
        isWearable: isWearable,
        engineName: engine.name || false,
        engineVersion: engine.version,
        osName: os.name,
        osVersion: os.version,
        userAgent: ua
      };
    };
    /***/

  },
  /* 3 */

  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.deviceDetect = undefined;

    var _views = __webpack_require__(4);

    Object.keys(_views).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _views[key];
        }
      });
    });

    var _selectors = __webpack_require__(1);

    Object.keys(_selectors).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _selectors[key];
        }
      });
    });

    var _detect = __webpack_require__(8);

    var _detect2 = _interopRequireDefault(_detect);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    exports.deviceDetect = _detect2.default;
    /***/
  },
  /* 4 */

  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.CustomView = exports.WearableView = exports.ConsoleView = exports.SmartTVView = exports.MobileOnlyView = exports.WinPhoneView = exports.TabletView = exports.MobileView = exports.IOSView = exports.IEView = exports.BrowserView = exports.AndroidView = undefined;

    var _react = __webpack_require__(5);

    var _react2 = _interopRequireDefault(_react);

    var _selectors = __webpack_require__(1);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var AndroidView = exports.AndroidView = function AndroidView(_ref) {
      var renderWithFragment = _ref.renderWithFragment,
          children = _ref.children,
          viewClassName = _ref.viewClassName,
          style = _ref.style;
      return _selectors.isAndroid ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var BrowserView = exports.BrowserView = function BrowserView(_ref2) {
      var renderWithFragment = _ref2.renderWithFragment,
          children = _ref2.children,
          viewClassName = _ref2.viewClassName,
          style = _ref2.style;
      return _selectors.isBrowser ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var IEView = exports.IEView = function IEView(_ref3) {
      var renderWithFragment = _ref3.renderWithFragment,
          children = _ref3.children,
          viewClassName = _ref3.viewClassName,
          style = _ref3.style;
      return _selectors.isIE ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var IOSView = exports.IOSView = function IOSView(_ref4) {
      var renderWithFragment = _ref4.renderWithFragment,
          children = _ref4.children,
          viewClassName = _ref4.viewClassName,
          style = _ref4.style;
      return _selectors.isIOS ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var MobileView = exports.MobileView = function MobileView(_ref5) {
      var renderWithFragment = _ref5.renderWithFragment,
          children = _ref5.children,
          viewClassName = _ref5.viewClassName,
          style = _ref5.style;
      return _selectors.isMobile ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var TabletView = exports.TabletView = function TabletView(_ref6) {
      var renderWithFragment = _ref6.renderWithFragment,
          children = _ref6.children,
          viewClassName = _ref6.viewClassName,
          style = _ref6.style;
      return _selectors.isTablet ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var WinPhoneView = exports.WinPhoneView = function WinPhoneView(_ref7) {
      var renderWithFragment = _ref7.renderWithFragment,
          children = _ref7.children,
          viewClassName = _ref7.viewClassName,
          style = _ref7.style;
      return _selectors.isWinPhone ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var MobileOnlyView = exports.MobileOnlyView = function MobileOnlyView(_ref8) {
      var renderWithFragment = _ref8.renderWithFragment,
          children = _ref8.children,
          viewClassName = _ref8.viewClassName,
          style = _ref8.style;
      return _selectors.isMobileOnly ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var SmartTVView = exports.SmartTVView = function SmartTVView(_ref9) {
      var renderWithFragment = _ref9.renderWithFragment,
          children = _ref9.children,
          viewClassName = _ref9.viewClassName,
          style = _ref9.style;
      return _selectors.isSmartTV ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var ConsoleView = exports.ConsoleView = function ConsoleView(_ref10) {
      var renderWithFragment = _ref10.renderWithFragment,
          children = _ref10.children,
          viewClassName = _ref10.viewClassName,
          style = _ref10.style;
      return _selectors.isConsole ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var WearableView = exports.WearableView = function WearableView(_ref11) {
      var renderWithFragment = _ref11.renderWithFragment,
          children = _ref11.children,
          viewClassName = _ref11.viewClassName,
          style = _ref11.style;
      return _selectors.isWearable ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };

    var CustomView = exports.CustomView = function CustomView(_ref12) {
      var renderWithFragment = _ref12.renderWithFragment,
          children = _ref12.children,
          viewClassName = _ref12.viewClassName,
          style = _ref12.style,
          condition = _ref12.condition;
      return condition ? renderWithFragment ? _react2.default.createElement(_react.Fragment, null, children) : _react2.default.createElement('div', {
        className: viewClassName,
        style: style
      }, children) : null;
    };
    /***/

  },
  /* 5 */

  /***/
  function (module, exports) {
    module.exports = __webpack_require__(250);
    /***/
  },
  /* 6 */

  /***/
  function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_RESULT__;
    /*!
    * UAParser.js v0.7.18
    * Lightweight JavaScript-based User-Agent string parser
    * https://github.com/faisalman/ua-parser-js
    *
    * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
    * Dual licensed under GPLv2 or MIT
    */


    (function (window, undefined) {
      "use strict";

      var LIBVERSION = "0.7.18",
          EMPTY = "",
          UNKNOWN = "?",
          FUNC_TYPE = "function",
          UNDEF_TYPE = "undefined",
          OBJ_TYPE = "object",
          STR_TYPE = "string",
          MAJOR = "major",
          MODEL = "model",
          NAME = "name",
          TYPE = "type",
          VENDOR = "vendor",
          VERSION = "version",
          ARCHITECTURE = "architecture",
          CONSOLE = "console",
          MOBILE = "mobile",
          TABLET = "tablet",
          SMARTTV = "smarttv",
          WEARABLE = "wearable",
          EMBEDDED = "embedded";
      var util = {
        extend: function extend(regexes, extensions) {
          var margedRegexes = {};

          for (var i in regexes) {
            if (extensions[i] && extensions[i].length % 2 === 0) {
              margedRegexes[i] = extensions[i].concat(regexes[i]);
            } else {
              margedRegexes[i] = regexes[i];
            }
          }

          return margedRegexes;
        },
        has: function has(str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize: function lowerize(str) {
          return str.toLowerCase();
        },
        major: function major(version) {
          return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, "").split(".")[0] : undefined;
        },
        trim: function trim(str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        }
      };
      var mapper = {
        rgx: function rgx(ua, arrays) {
          var i = 0,
              j,
              k,
              p,
              q,
              matches,
              match;

          while (i < arrays.length && !matches) {
            var regex = arrays[i],
                props = arrays[i + 1];
            j = k = 0;

            while (j < regex.length && !matches) {
              matches = regex[j++].exec(ua);

              if (!!matches) {
                for (p = 0; p < props.length; p++) {
                  match = matches[++k];
                  q = props[p];

                  if (typeof q === OBJ_TYPE && q.length > 0) {
                    if (q.length == 2) {
                      if (typeof q[1] == FUNC_TYPE) {
                        this[q[0]] = q[1].call(this, match);
                      } else {
                        this[q[0]] = q[1];
                      }
                    } else if (q.length == 3) {
                      if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                      } else {
                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                      }
                    } else if (q.length == 4) {
                      this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    }
                  } else {
                    this[q] = match ? match : undefined;
                  }
                }
              }
            }

            i += 2;
          }
        },
        str: function str(_str, map) {
          for (var i in map) {
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
              for (var j = 0; j < map[i].length; j++) {
                if (util.has(map[i][j], _str)) {
                  return i === UNKNOWN ? undefined : i;
                }
              }
            } else if (util.has(map[i], _str)) {
              return i === UNKNOWN ? undefined : i;
            }
          }

          return _str;
        }
      };
      var maps = {
        browser: {
          oldsafari: {
            version: {
              "1.0": "/8",
              1.2: "/1",
              1.3: "/3",
              "2.0": "/412",
              "2.0.2": "/416",
              "2.0.3": "/417",
              "2.0.4": "/419",
              "?": "/"
            }
          }
        },
        device: {
          amazon: {
            model: {
              "Fire Phone": ["SD", "KF"]
            }
          },
          sprint: {
            model: {
              "Evo Shift 4G": "7373KT"
            },
            vendor: {
              HTC: "APA",
              Sprint: "Sprint"
            }
          }
        },
        os: {
          windows: {
            version: {
              ME: "4.90",
              "NT 3.11": "NT3.51",
              "NT 4.0": "NT4.0",
              2000: "NT 5.0",
              XP: ["NT 5.1", "NT 5.2"],
              Vista: "NT 6.0",
              7: "NT 6.1",
              8: "NT 6.2",
              8.1: "NT 6.3",
              10: ["NT 6.4", "NT 10.0"],
              RT: "ARM"
            }
          }
        }
      };
      var regexes = {
        browser: [[/(opera\smini)\/([\w\.-]+)/i, /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, /(opera).+version\/([\w\.]+)/i, /(opera)[\/\s]+([\w\.]+)/i], [NAME, VERSION], [/(opios)[\/\s]+([\w\.]+)/i], [[NAME, "Opera Mini"], VERSION], [/\s(opr)\/([\w\.]+)/i], [[NAME, "Opera"], VERSION], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i, /(?:ms|\()(ie)\s([\w\.]+)/i, /(rekonq)\/([\w\.]*)/i, /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i], [NAME, VERSION], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i], [[NAME, "IE"], VERSION], [/(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i], [[NAME, "Edge"], VERSION], [/(yabrowser)\/([\w\.]+)/i], [[NAME, "Yandex"], VERSION], [/(puffin)\/([\w\.]+)/i], [[NAME, "Puffin"], VERSION], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i], [[NAME, "UCBrowser"], VERSION], [/(comodo_dragon)\/([\w\.]+)/i], [[NAME, /_/g, " "], VERSION], [/(micromessenger)\/([\w\.]+)/i], [[NAME, "WeChat"], VERSION], [/(qqbrowserlite)\/([\w\.]+)/i], [NAME, VERSION], [/(QQ)\/([\d\.]+)/i], [NAME, VERSION], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i], [NAME, VERSION], [/(BIDUBrowser)[\/\s]?([\w\.]+)/i], [NAME, VERSION], [/(2345Explorer)[\/\s]?([\w\.]+)/i], [NAME, VERSION], [/(MetaSr)[\/\s]?([\w\.]+)/i], [NAME], [/(LBBROWSER)/i], [NAME], [/xiaomi\/miuibrowser\/([\w\.]+)/i], [VERSION, [NAME, "MIUI Browser"]], [/;fbav\/([\w\.]+);/i], [VERSION, [NAME, "Facebook"]], [/headlesschrome(?:\/([\w\.]+)|\s)/i], [VERSION, [NAME, "Chrome Headless"]], [/\swv\).+(chrome)\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 WebView"], VERSION], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[NAME, /(.+(?:g|us))(.+)/, "$1 $2"], VERSION], [/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i], [VERSION, [NAME, "Android Browser"]], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i], [NAME, VERSION], [/(dolfin)\/([\w\.]+)/i], [[NAME, "Dolphin"], VERSION], [/((?:android.+)crmo|crios)\/([\w\.]+)/i], [[NAME, "Chrome"], VERSION], [/(coast)\/([\w\.]+)/i], [[NAME, "Opera Coast"], VERSION], [/fxios\/([\w\.-]+)/i], [VERSION, [NAME, "Firefox"]], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i], [VERSION, [NAME, "Mobile Safari"]], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i], [VERSION, NAME], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [[NAME, "GSA"], VERSION], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [/(konqueror)\/([\w\.]+)/i, /(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [/(navigator|netscape)\/([\w\.-]+)/i], [[NAME, "Netscape"], VERSION], [/(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, /(links)\s\(([\w\.]+)/i, /(gobrowser)\/?([\w\.]*)/i, /(ice\s?browser)\/v?([\w\._]+)/i, /(mosaic)[\/\s]([\w\.]+)/i], [NAME, VERSION]],
        cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [[ARCHITECTURE, "amd64"]], [/(ia32(?=;))/i], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [[ARCHITECTURE, "ia32"]], [/windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [[ARCHITECTURE, /ower/, "", util.lowerize]], [/(sun4\w)[;\)]/i], [[ARCHITECTURE, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i], [[ARCHITECTURE, util.lowerize]]],
        device: [[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i], [MODEL, VENDOR, [TYPE, TABLET]], [/applecoremedia\/[\w\.]+ \((ipad)/], [MODEL, [VENDOR, "Apple"], [TYPE, TABLET]], [/(apple\s{0,1}tv)/i], [[MODEL, "Apple TV"], [VENDOR, "Apple"]], [/(archos)\s(gamepad2?)/i, /(hp).+(touchpad)/i, /(hp).+(tablet)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(kf[A-z]+)\sbuild\/.+silk\//i], [MODEL, [VENDOR, "Amazon"], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, "Amazon"], [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);.+(apple)/i], [MODEL, VENDOR, [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);/i], [MODEL, [VENDOR, "Apple"], [TYPE, MOBILE]], [/(blackberry)[\s-]?(\w+)/i, /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/\(bb10;\s(\w+)/i], [MODEL, [VENDOR, "BlackBerry"], [TYPE, MOBILE]], [/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i], [MODEL, [VENDOR, "Asus"], [TYPE, TABLET]], [/(sony)\s(tablet\s[ps])\sbuild\//i, /(sony)?(?:sgp.+)\sbuild\//i], [[VENDOR, "Sony"], [MODEL, "Xperia Tablet"], [TYPE, TABLET]], [/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i], [MODEL, [VENDOR, "Sony"], [TYPE, MOBILE]], [/\s(ouya)\s/i, /(nintendo)\s([wids3u]+)/i], [VENDOR, MODEL, [TYPE, CONSOLE]], [/android.+;\s(shield)\sbuild/i], [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]], [/(playstation\s[34portablevi]+)/i], [MODEL, [VENDOR, "Sony"], [TYPE, CONSOLE]], [/(sprint\s(\w+))/i], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, /(zte)-(\w*)/i, /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i], [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]], [/(nexus\s9)/i], [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i], [MODEL, [VENDOR, "Huawei"], [TYPE, MOBILE]], [/(microsoft);\s(lumia[\s\w]+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i], [MODEL, [VENDOR, "Microsoft"], [TYPE, CONSOLE]], [/(kin\.[onetw]{3})/i], [[MODEL, /\./g, " "], [VENDOR, "Microsoft"], [TYPE, MOBILE]], [/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [MODEL, [VENDOR, "Motorola"], [TYPE, MOBILE]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [MODEL, [VENDOR, "Motorola"], [TYPE, TABLET]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, "SmartTV"], [VENDOR, "Samsung"], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i], [MODEL, [VENDOR, "Sharp"], [TYPE, SMARTTV]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[VENDOR, "Samsung"], MODEL, [TYPE, TABLET]], [/smart-tv.+(samsung)/i], [VENDOR, [TYPE, SMARTTV], MODEL], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[VENDOR, "Samsung"], MODEL, [TYPE, MOBILE]], [/sie-(\w*)/i], [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]*)/i], [[VENDOR, "Nokia"], MODEL, [TYPE, MOBILE]], [/android\s3\.[\s\w;-]{10}(a\d{3})/i], [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]], [/android.+([vl]k\-?\d{3})\s+build/i], [MODEL, [VENDOR, "LG"], [TYPE, TABLET]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i], [[VENDOR, "LG"], MODEL, [TYPE, TABLET]], [/(lg) netcast\.tv/i], [VENDOR, MODEL, [TYPE, SMARTTV]], [/(nexus\s[45])/i, /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [MODEL, [VENDOR, "LG"], [TYPE, MOBILE]], [/android.+(ideatab[a-z0-9\-\s]+)/i], [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]], [/linux;.+((jolla));/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/((pebble))app\/[\d\.]+\s/i], [VENDOR, MODEL, [TYPE, WEARABLE]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/crkey/i], [[MODEL, "Chromecast"], [VENDOR, "Google"]], [/android.+;\s(glass)\s\d/i], [MODEL, [VENDOR, "Google"], [TYPE, WEARABLE]], [/android.+;\s(pixel c)\s/i], [MODEL, [VENDOR, "Google"], [TYPE, TABLET]], [/android.+;\s(pixel xl|pixel)\s/i], [MODEL, [VENDOR, "Google"], [TYPE, MOBILE]], [/android.+;\s(\w+)\s+build\/hm\1/i, /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i], [[MODEL, /_/g, " "], [VENDOR, "Xiaomi"], [TYPE, MOBILE]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i], [[MODEL, /_/g, " "], [VENDOR, "Xiaomi"], [TYPE, TABLET]], [/android.+;\s(m[1-5]\snote)\sbuild/i], [MODEL, [VENDOR, "Meizu"], [TYPE, TABLET]], [/android.+a000(1)\s+build/i, /android.+oneplus\s(a\d{4})\s+build/i], [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i], [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i], [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i], [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i], [[VENDOR, "Barnes & Noble"], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i], [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]], [/android.+;\s(k88)\sbuild/i], [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i], [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]], [/android.+[;\/]\s*(zur\d{3})\s+build/i], [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i], [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i], [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i], [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i], [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]], [/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i], [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]], [/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i], [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i], [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*TU_(1491)\s+build/i], [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]], [/android.+(KS(.+))\s+build/i], [MODEL, [VENDOR, "Amazon"], [TYPE, TABLET]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i], [VENDOR, MODEL, [TYPE, TABLET]], [/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i], [[TYPE, util.lowerize], VENDOR, MODEL], [/(android[\w\.\s\-]{0,9});.+build/i], [MODEL, [VENDOR, "Generic"]]],
        engine: [[/windows.+\sedge\/([\w\.]+)/i], [VERSION, [NAME, "EdgeHTML"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [NAME, VERSION], [/rv\:([\w\.]{1,9}).+(gecko)/i], [VERSION, NAME]],
        os: [[/microsoft\s(windows)\s(vista|xp)/i], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, "Windows"], [VERSION, mapper.str, maps.os.windows.version]], [/\((bb)(10);/i], [[NAME, "BlackBerry"], VERSION], [/(blackberry)\w*\/?([\w\.]*)/i, /(tizen)[\/\s]([\w\.]+)/i, /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i, /linux;.+(sailfish);/i], [NAME, VERSION], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i], [[NAME, "Symbian"], VERSION], [/\((series40);/i], [NAME], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[NAME, "Firefox OS"], VERSION], [/(nintendo|playstation)\s([wids34portablevu]+)/i, /(mint)[\/\s\(]?(\w*)/i, /(mageia|vectorlinux)[;\s]/i, /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i, /(hurd|linux)\s?([\w\.]*)/i, /(gnu)\s?([\w\.]*)/i], [NAME, VERSION], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[NAME, "Chromium OS"], VERSION], [/(sunos)\s?([\w\.\d]*)/i], [[NAME, "Solaris"], VERSION], [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i], [NAME, VERSION], [/(haiku)\s(\w+)/i], [NAME, VERSION], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i], [[VERSION, /_/g, "."], [NAME, "iOS"]], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i], [[NAME, "Mac OS"], [VERSION, /_/g, "."]], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i, /(unix)\s?([\w\.]*)/i], [NAME, VERSION]]
      };

      var UAParser = function UAParser(uastring, extensions) {
        if (typeof uastring === "object") {
          extensions = uastring;
          uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
          return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
          var browser = {
            name: undefined,
            version: undefined
          };
          mapper.rgx.call(browser, ua, rgxmap.browser);
          browser.major = util.major(browser.version);
          return browser;
        };

        this.getCPU = function () {
          var cpu = {
            architecture: undefined
          };
          mapper.rgx.call(cpu, ua, rgxmap.cpu);
          return cpu;
        };

        this.getDevice = function () {
          var device = {
            vendor: undefined,
            model: undefined,
            type: undefined
          };
          mapper.rgx.call(device, ua, rgxmap.device);
          return device;
        };

        this.getEngine = function () {
          var engine = {
            name: undefined,
            version: undefined
          };
          mapper.rgx.call(engine, ua, rgxmap.engine);
          return engine;
        };

        this.getOS = function () {
          var os = {
            name: undefined,
            version: undefined
          };
          mapper.rgx.call(os, ua, rgxmap.os);
          return os;
        };

        this.getResult = function () {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        };

        this.getUA = function () {
          return ua;
        };

        this.setUA = function (uastring) {
          ua = uastring;
          return this;
        };

        return this;
      };

      UAParser.VERSION = LIBVERSION;
      UAParser.BROWSER = {
        NAME: NAME,
        MAJOR: MAJOR,
        VERSION: VERSION
      };
      UAParser.CPU = {
        ARCHITECTURE: ARCHITECTURE
      };
      UAParser.DEVICE = {
        MODEL: MODEL,
        VENDOR: VENDOR,
        TYPE: TYPE,
        CONSOLE: CONSOLE,
        MOBILE: MOBILE,
        SMARTTV: SMARTTV,
        TABLET: TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
      };
      UAParser.ENGINE = {
        NAME: NAME,
        VERSION: VERSION
      };
      UAParser.OS = {
        NAME: NAME,
        VERSION: VERSION
      };

      if (typeof exports !== UNDEF_TYPE) {
        if (typeof module !== UNDEF_TYPE && module.exports) {
          exports = module.exports = UAParser;
        }

        exports.UAParser = UAParser;
      } else {
        if ("function" === FUNC_TYPE && __webpack_require__(7)) {
          !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return UAParser;
          }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
          window.UAParser = UAParser;
        }
      }

      var $ = window && (window.jQuery || window.Zepto);

      if (typeof $ !== UNDEF_TYPE) {
        var parser = new UAParser();
        $.ua = parser.getResult();

        $.ua.get = function () {
          return parser.getUA();
        };

        $.ua.set = function (uastring) {
          parser.setUA(uastring);
          var result = parser.getResult();

          for (var prop in result) {
            $.ua[prop] = result[prop];
          }
        };
      }
    })(typeof window === "object" ? window : this);
    /***/

  },
  /* 7 */

  /***/
  function (module, exports) {
    /* WEBPACK VAR INJECTION */
    (function (__webpack_amd_options__) {
      /* globals __webpack_amd_options__ */
      module.exports = __webpack_amd_options__;
      /* WEBPACK VAR INJECTION */
    }).call(exports, {});
    /***/
  },
  /* 8 */

  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _getUaData = __webpack_require__(0);

    var _types = __webpack_require__(2);

    var create = _interopRequireWildcard(_types);

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};

        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }

        newObj.default = obj;
        return newObj;
      }
    }

    var type = create.checkType(_getUaData.device.type);

    exports.default = function () {
      var isBrowser = type.isBrowser,
          isMobile = type.isMobile,
          isTablet = type.isTablet,
          isSmartTV = type.isSmartTV,
          isConsole = type.isConsole,
          isWearable = type.isWearable;

      if (isBrowser) {
        return create.broPayload(isBrowser, _getUaData.browser, _getUaData.engine, _getUaData.os, _getUaData.ua);
      }

      if (isSmartTV) {
        return create.stvPayload(isSmartTV, _getUaData.engine, _getUaData.os, _getUaData.ua);
      }

      if (isConsole) {
        return create.consolePayload(isConsole, _getUaData.engine, _getUaData.os, _getUaData.ua);
      }

      if (isMobile) {
        return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
      }

      if (isTablet) {
        return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
      }

      if (isWearable) {
        return create.wearPayload(isWearable, _getUaData.engine, _getUaData.os, _getUaData.ua);
      }
    };
    /***/

  }]);
  /***/

},
/* 588 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  // a passthrough stream.
  // basically just the most minimal sort of Transform stream.
  // Every written chunk gets output as-is.

  module.exports = PassThrough;

  var Transform = __webpack_require__(243);
  /*<replacement>*/


  var util = __webpack_require__(78);

  util.inherits = __webpack_require__(37);
  /*</replacement>*/

  util.inherits(PassThrough, Transform);

  function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
  }

  PassThrough.prototype._transform = function (chunk, encoding, cb) {
    cb(null, chunk);
  };
  /***/

},
/* 589 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var Buffer = __webpack_require__(38).Buffer;

  var util = __webpack_require__(610);

  function copyBuffer(src, target, offset) {
    src.copy(target, offset);
  }

  module.exports = function () {
    function BufferList() {
      _classCallCheck(this, BufferList);

      this.head = null;
      this.tail = null;
      this.length = 0;
    }

    BufferList.prototype.push = function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    };

    BufferList.prototype.unshift = function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    };

    BufferList.prototype.shift = function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    };

    BufferList.prototype.clear = function clear() {
      this.head = this.tail = null;
      this.length = 0;
    };

    BufferList.prototype.join = function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;

      while (p = p.next) {
        ret += s + p.data;
      }

      return ret;
    };

    BufferList.prototype.concat = function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      if (this.length === 1) return this.head.data;
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;

      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }

      return ret;
    };

    return BufferList;
  }();

  if (util && util.inspect && util.inspect.custom) {
    module.exports.prototype[util.inspect.custom] = function () {
      var obj = util.inspect({
        length: this.length
      });
      return this.constructor.name + ' ' + obj;
    };
  }
  /***/

},
/* 590 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(63).PassThrough;
  /***/
},
/* 591 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(63).Transform;
  /***/
},
/* 592 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(158);
  /***/
},
/* 593 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function ReInterval(callback, interval, args) {
    var self = this;
    this._callback = callback;
    this._args = args;
    this._interval = setInterval(callback, interval, this._args);

    this.reschedule = function (interval) {
      // if no interval entered, use the interval passed in on creation
      if (!interval) interval = self._interval;
      if (self._interval) clearInterval(self._interval);
      self._interval = setInterval(self._callback, interval, self._args);
    };

    this.clear = function () {
      if (self._interval) {
        clearInterval(self._interval);
        self._interval = undefined;
      }
    };

    this.destroy = function () {
      if (self._interval) {
        clearInterval(self._interval);
      }

      self._callback = undefined;
      self._interval = undefined;
      self._args = undefined;
    };
  }

  function reInterval() {
    if (typeof arguments[0] !== 'function') throw new Error('callback needed');
    if (typeof arguments[1] !== 'number') throw new Error('interval needed');
    var args;

    if (arguments.length > 0) {
      args = new Array(arguments.length - 2);

      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i + 2];
      }
    }

    return new ReInterval(arguments[0], arguments[1], args);
  }

  module.exports = reInterval;
  /***/
},
/* 594 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global, process) {
    (function (global, undefined) {
      "use strict";

      if (global.setImmediate) {
        return;
      }

      var nextHandle = 1; // Spec says greater than zero

      var tasksByHandle = {};
      var currentlyRunningATask = false;
      var doc = global.document;
      var registerImmediate;

      function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
          callback = new Function("" + callback);
        } // Copy function arguments


        var args = new Array(arguments.length - 1);

        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
        } // Store and register the task


        var task = {
          callback: callback,
          args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
      }

      function clearImmediate(handle) {
        delete tasksByHandle[handle];
      }

      function run(task) {
        var callback = task.callback;
        var args = task.args;

        switch (args.length) {
          case 0:
            callback();
            break;

          case 1:
            callback(args[0]);
            break;

          case 2:
            callback(args[0], args[1]);
            break;

          case 3:
            callback(args[0], args[1], args[2]);
            break;

          default:
            callback.apply(undefined, args);
            break;
        }
      }

      function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
          // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
          // "too much recursion" error.
          setTimeout(runIfPresent, 0, handle);
        } else {
          var task = tasksByHandle[handle];

          if (task) {
            currentlyRunningATask = true;

            try {
              run(task);
            } finally {
              clearImmediate(handle);
              currentlyRunningATask = false;
            }
          }
        }
      }

      function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
          process.nextTick(function () {
            runIfPresent(handle);
          });
        };
      }

      function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
          var postMessageIsAsynchronous = true;
          var oldOnMessage = global.onmessage;

          global.onmessage = function () {
            postMessageIsAsynchronous = false;
          };

          global.postMessage("", "*");
          global.onmessage = oldOnMessage;
          return postMessageIsAsynchronous;
        }
      }

      function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var messagePrefix = "setImmediate$" + Math.random() + "$";

        var onGlobalMessage = function onGlobalMessage(event) {
          if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
            runIfPresent(+event.data.slice(messagePrefix.length));
          }
        };

        if (global.addEventListener) {
          global.addEventListener("message", onGlobalMessage, false);
        } else {
          global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
          global.postMessage(messagePrefix + handle, "*");
        };
      }

      function installMessageChannelImplementation() {
        var channel = new MessageChannel();

        channel.port1.onmessage = function (event) {
          var handle = event.data;
          runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
          channel.port2.postMessage(handle);
        };
      }

      function installReadyStateChangeImplementation() {
        var html = doc.documentElement;

        registerImmediate = function registerImmediate(handle) {
          // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
          // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
          var script = doc.createElement("script");

          script.onreadystatechange = function () {
            runIfPresent(handle);
            script.onreadystatechange = null;
            html.removeChild(script);
            script = null;
          };

          html.appendChild(script);
        };
      }

      function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
          setTimeout(runIfPresent, 0, handle);
        };
      } // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.


      var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
      attachTo = attachTo && attachTo.setTimeout ? attachTo : global; // Don't get fooled by e.g. browserify environments.

      if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
      } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
      } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
      } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
      } else {
        // For older browsers
        installSetTimeoutImplementation();
      }

      attachTo.setImmediate = setImmediate;
      attachTo.clearImmediate = clearImmediate;
    })(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(10), __webpack_require__(16));
  /***/
},
/* 595 */

/***/
function (module, exports, __webpack_require__) {
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  module.exports = Stream;

  var EE = __webpack_require__(41).EventEmitter;

  var inherits = __webpack_require__(37);

  inherits(Stream, EE);
  Stream.Readable = __webpack_require__(63);
  Stream.Writable = __webpack_require__(592);
  Stream.Duplex = __webpack_require__(241);
  Stream.Transform = __webpack_require__(591);
  Stream.PassThrough = __webpack_require__(590); // Backwards-compat with node 0.4.x

  Stream.Stream = Stream; // old-style streams.  Note that the pipe method (the only relevant
  // part of this class) is overridden in the Readable class.

  function Stream() {
    EE.call(this);
  }

  Stream.prototype.pipe = function (dest, options) {
    var source = this;

    function ondata(chunk) {
      if (dest.writable) {
        if (false === dest.write(chunk) && source.pause) {
          source.pause();
        }
      }
    }

    source.on('data', ondata);

    function ondrain() {
      if (source.readable && source.resume) {
        source.resume();
      }
    }

    dest.on('drain', ondrain); // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.

    if (!dest._isStdio && (!options || options.end !== false)) {
      source.on('end', onend);
      source.on('close', onclose);
    }

    var didOnEnd = false;

    function onend() {
      if (didOnEnd) return;
      didOnEnd = true;
      dest.end();
    }

    function onclose() {
      if (didOnEnd) return;
      didOnEnd = true;
      if (typeof dest.destroy === 'function') dest.destroy();
    } // don't leave dangling pipes when there are errors.


    function onerror(er) {
      cleanup();

      if (EE.listenerCount(this, 'error') === 0) {
        throw er; // Unhandled stream error in pipe.
      }
    }

    source.on('error', onerror);
    dest.on('error', onerror); // remove all the event listeners that were added.

    function cleanup() {
      source.removeListener('data', ondata);
      dest.removeListener('drain', ondrain);
      source.removeListener('end', onend);
      source.removeListener('close', onclose);
      source.removeListener('error', onerror);
      dest.removeListener('error', onerror);
      source.removeListener('end', cleanup);
      source.removeListener('close', cleanup);
      dest.removeListener('close', cleanup);
    }

    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source); // Allow for unix-like usage: A.pipe(B).pipe(C)

    return dest;
  };
  /***/

},
/* 596 */

/***/
function (module, exports) {
  module.exports = shift;

  function shift(stream) {
    var rs = stream._readableState;
    if (!rs) return null;
    return rs.objectMode ? stream.read() : stream.read(getStateLength(rs));
  }

  function getStateLength(state) {
    if (state.buffer.length) {
      // Since node 6.3.0 state.buffer is a BufferList not an array
      if (state.buffer.head) {
        return state.buffer.head.data.length;
      }

      return state.buffer[0].length;
    }

    return state.length;
  }
  /***/

},
/* 597 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = {
    isString: function isString(arg) {
      return typeof arg === 'string';
    },
    isObject: function isObject(arg) {
      return typeof arg === 'object' && arg !== null;
    },
    isNull: function isNull(arg) {
      return arg === null;
    },
    isNullOrUndefined: function isNullOrUndefined(arg) {
      return arg == null;
    }
  };
  /***/
},
/* 598 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
     * Module exports.
     */
    module.exports = deprecate;
    /**
     * Mark that a method should not be used.
     * Returns a modified function which warns once by default.
     *
     * If `localStorage.noDeprecation = true` is set, then it is a no-op.
     *
     * If `localStorage.throwDeprecation = true` is set, then deprecated functions
     * will throw an Error when invoked.
     *
     * If `localStorage.traceDeprecation = true` is set, then deprecated functions
     * will invoke `console.trace()` instead of `console.error()`.
     *
     * @param {Function} fn - the function to deprecate
     * @param {String} msg - the string to print to the console when `fn` is invoked
     * @returns {Function} a new "deprecated" version of `fn`
     * @api public
     */

    function deprecate(fn, msg) {
      if (config('noDeprecation')) {
        return fn;
      }

      var warned = false;

      function deprecated() {
        if (!warned) {
          if (config('throwDeprecation')) {
            throw new Error(msg);
          } else if (config('traceDeprecation')) {
            console.trace(msg);
          } else {
            console.warn(msg);
          }

          warned = true;
        }

        return fn.apply(this, arguments);
      }

      return deprecated;
    }
    /**
     * Checks `localStorage` for boolean values for the given `name`.
     *
     * @param {String} name
     * @returns {Boolean}
     * @api private
     */


    function config(name) {
      // accessing global.localStorage can trigger a DOMException in sandboxed iframes
      try {
        if (!global.localStorage) return false;
      } catch (_) {
        return false;
      }

      var val = global.localStorage[name];
      if (null == val) return false;
      return String(val).toLowerCase() === 'true';
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(10));
  /***/
},
/* 599 */

/***/
function (module, exports) {
  if (typeof Object.create === 'function') {
    // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;

      var TempCtor = function TempCtor() {};

      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }
  /***/

},
/* 600 */

/***/
function (module, exports) {
  module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
  };
  /***/

},
/* 601 */

/***/
function (module, exports, __webpack_require__) {
  var v1 = __webpack_require__(602);

  var v4 = __webpack_require__(603);

  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  module.exports = uuid;
  /***/
},
/* 602 */

/***/
function (module, exports, __webpack_require__) {
  var rng = __webpack_require__(249);

  var bytesToUuid = __webpack_require__(248); // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html


  var _nodeId;

  var _clockseq; // Previous uuid creation time


  var _lastMSecs = 0;
  var _lastNSecs = 0; // See https://github.com/broofa/node-uuid for API details

  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189

    if (node == null || clockseq == null) {
      var seedBytes = rng();

      if (node == null) {
        // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
      }

      if (clockseq == null) {
        // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
      }
    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock

    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

    if (dt < 0 && options.clockseq === undefined) {
      clockseq = clockseq + 1 & 0x3fff;
    } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval


    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
      nsecs = 0;
    } // Per 4.2.1.2 Throw error if too many uuids are requested


    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }

    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

    msecs += 12219292800000; // `time_low`

    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff; // `time_mid`

    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff; // `time_high_and_version`

    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

    b[i++] = clockseq & 0xff; // `node`

    for (var n = 0; n < 6; ++n) {
      b[i + n] = node[n];
    }

    return buf ? buf : bytesToUuid(b);
  }

  module.exports = v1;
  /***/
},
/* 603 */

/***/
function (module, exports, __webpack_require__) {
  var rng = __webpack_require__(249);

  var bytesToUuid = __webpack_require__(248);

  function v4(options, buf, offset) {
    var i = buf && offset || 0;

    if (typeof options == 'string') {
      buf = options === 'binary' ? new Array(16) : null;
      options = null;
    }

    options = options || {};
    var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

    if (buf) {
      for (var ii = 0; ii < 16; ++ii) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || bytesToUuid(rnds);
  }

  module.exports = v4;
  /***/
},
/* 604 */

/***/
function (module, exports) {
  var ws = null;

  if (typeof WebSocket !== 'undefined') {
    ws = WebSocket;
  } else if (typeof MozWebSocket !== 'undefined') {
    ws = MozWebSocket;
  } else if (typeof window !== 'undefined') {
    ws = window.WebSocket || window.MozWebSocket;
  }

  module.exports = ws;
  /***/
},
/* 605 */

/***/
function (module, exports) {
  // Returns a wrapper function that returns a wrapped callback
  // The wrapper function should do some stuff, and return a
  // presumably different callback function.
  // This makes sure that own properties are retained, so that
  // decorations and such are not lost along the way.
  module.exports = wrappy;

  function wrappy(fn, cb) {
    if (fn && cb) return wrappy(fn)(cb);
    if (typeof fn !== 'function') throw new TypeError('need wrapper function');
    Object.keys(fn).forEach(function (k) {
      wrapper[k] = fn[k];
    });
    return wrapper;

    function wrapper() {
      var args = new Array(arguments.length);

      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }

      var ret = fn.apply(this, args);
      var cb = args[args.length - 1];

      if (typeof ret === 'function' && ret !== cb) {
        Object.keys(cb).forEach(function (k) {
          ret[k] = cb[k];
        });
      }

      return ret;
    }
  }
  /***/

},
/* 606 */

/***/
function (module, exports) {
  /* (ignored) */

  /***/
},
/* 607 */

/***/
function (module, exports) {
  /* (ignored) */

  /***/
},
/* 608 */

/***/
function (module, exports) {
  /* (ignored) */

  /***/
},
/* 609 */

/***/
function (module, exports) {
  /* (ignored) */

  /***/
},
/* 610 */

/***/
function (module, exports) {
  /* (ignored) */

  /***/
},
/* 611 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(253);

  module.exports = __webpack_require__(252);
  /***/
}]);